
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3714"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3714"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iTneE", function(module, exports) {

$parcel$export(module.exports, "create", () => cd);
var ld = Object.defineProperty;
var G = (t, e)=>()=>(t && (e = t(t = 0)), e);
var Mt = (t, e)=>{
    for(var r in e)ld(t, r, {
        get: e[r],
        enumerable: !0
    });
};
var fd, ud, D, L, Nr = G(()=>{
    fd = globalThis, ud = globalThis, D = globalThis, L = D.document;
});
var Ee, Zo, Bt, Dr = G(()=>{
    Nr();
    Ee = (t)=>(typeof Node == "object" ? t instanceof D.Node : t && typeof t == "object" && typeof t.nodeType == "number" && typeof t.nodeName == "string") || !1, Zo = (t)=>(typeof HTMLElement == "object" ? t instanceof D.HTMLElement : t && typeof t == "object" && t !== null && t.nodeType === 1 && typeof t.nodeName == "string") || !1, Bt = (t)=>typeof D < "u" && (D.Node && t instanceof D.Node || D.Window && t instanceof D.Window || t === D || t === document);
});
var g, b, ct, y, Pn, Cc, x, kc, N, Ot, K, ts, At, Fr, St = G(()=>{
    Dr();
    g = (t)=>t === null ? !1 : typeof t == "object" && t.constructor === Object, b = (t)=>typeof t == "string", ct = (t)=>typeof t == "number", y = (t)=>typeof t == "function", Pn = (t)=>t === !0 || t === !1, Cc = (t)=>t === null, x = (t)=>Array.isArray(t), kc = (t)=>t instanceof Date, N = (t)=>t === null ? !1 : typeof t == "object", Ot = (t)=>t !== void 0, K = (t)=>t === void 0, ts = {
        boolean: Pn,
        array: x,
        object: g,
        string: b,
        date: kc,
        number: ct,
        null: Cc,
        function: y,
        objectLike: N,
        node: Ee,
        htmlElement: Zo,
        defined: Ot
    }, At = (t)=>(...e)=>e.some((r)=>ts[r](t)), Fr = (t)=>(...e)=>!e.some((r)=>ts[r](t));
});
var pd, dd, es, hd, Nn, rs, md, gd, ns, yd, bd, Sd, xd, _d, wd, vd, Dn, $r, qe = G(()=>{
    ae();
    St();
    pd = (t, e)=>e.every((r)=>t.includes(r)), dd = (t, e)=>{
        let r = 0;
        for(let n = 0; n < t.length; n++)t[n] === e && r++;
        return r;
    }, es = (t, e)=>{
        if (b(e) && (e = parseInt(e)), ct(e)) {
            if (e < 0 || e >= t.length || isNaN(e)) throw new Error("Invalid index");
            t.splice(e, 1);
        } else throw new Error("Invalid index");
        return t;
    }, hd = (t, e, r)=>{
        [t[e], t[r]] = [
            t[r],
            t[e]
        ];
    }, Nn = (...t)=>[].concat(...t), rs = (t, e = [])=>t.reduce((r, n)=>U(r, z(n, {
                exclude: e
            }), e), {}), md = (t, e)=>{
        let r = t.indexOf(e);
        return r !== -1 ? t.slice(0, r) : t;
    }, gd = (t, e)=>{
        if (!x(t)) return;
        let r = t.indexOf(e);
        return r !== -1 ? t.slice(r + 1) : t;
    }, ns = (t, e)=>{
        let r = t.indexOf(e);
        if (r > -1) {
            let n = [
                ...t
            ];
            return n.splice(r, 1), n;
        }
        return t;
    }, yd = (t, e)=>t.filter((r)=>r !== e), bd = (t, e)=>{
        let r = [];
        for(let n = 0; n < t.length; n++)r.push(t[n]), n < t.length - 1 && r.push(e);
        return r;
    }, Sd = (t, e, r)=>{
        let n = [
            ...t
        ], o = n.indexOf(e), s = n.indexOf(r);
        if (o !== -1 && s !== -1) {
            let i = n.splice(o, 1)[0], a = s < o ? s : s + 1;
            n.splice(a, 0, i);
        }
        return n;
    }, xd = (t, e)=>{
        if (t.length !== e.length) return !1;
        for(let r = 0; r < t.length; r++)if (t[r] !== e[r]) return !1;
        return !0;
    }, _d = (t, e)=>t.filter((r)=>!e.includes(r)), wd = (t, e)=>{
        let r = new Set(e);
        return t.filter((n)=>!r.has(n));
    }, vd = (t, e)=>{
        if (!t) return 0;
        let r = 0;
        for(let n = 0; n < e.length; n++)t.includes(e[n]) && r++;
        return r;
    }, Dn = (t)=>x(t) ? [
            ...new Set(t)
        ] : t, $r = (t, e)=>{
        for(let r in e)Object.defineProperty(t, r, {
            value: e[r],
            enumerable: !1,
            configurable: !0,
            writable: !0
        });
    };
});
function kd(t, e, r = {}) {
    let { bracketsLength: n = 2 } = r, o = n === 3 ? "{{{" : "{{";
    if (!t.includes(o)) return t;
    let s = Cd[n], i = e || this.state || {}, a = this;
    return t.replace(s, (c, f, l, u)=>{
        let p = l.trim();
        if (u) {
            let d = a?.context?.functions?.[u];
            if (d) try {
                let h = os(i, p);
                return String(d.call(a, h ?? p) ?? "");
            } catch  {
                return "";
            }
            return "";
        }
        if (f) {
            let d = (f.match(/\.\.\//g) || []).length, h = i;
            for(let S = 0; S < d; S++){
                if (!h || !h.parent) return "";
                h = h.parent;
            }
            if (p === "parent") return String(h.value ?? "");
            let m = os(h, p);
            return String(m ?? "");
        } else {
            let d = os(i, p);
            return String(d ?? "");
        }
    });
}
var ss, Ed, Cd, os, ce, Od, Ad, Td, Rd, Id, Pd, Nd, Dd, Lr = G(()=>{
    ss = (t, e)=>{
        for (let r of e)if (t.includes(r)) return !0;
        return !1;
    }, Ed = (t, e)=>{
        let r = new RegExp(`[${e.join("\\")}]`, "g");
        return t.replace(r, "");
    }, Cd = {
        2: /{{\s*((?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}/g,
        3: /{{{(\s*(?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}}/g
    }, os = (t, e)=>e.split(".").reduce((r, n)=>r?.[n], t);
    ce = (t)=>`${t.charAt(0).toLowerCase()}${t.slice(1)}`, Od = (t, e)=>{
        let r = t.split(`
`), n = -1, o = -1, s = -1, i = -1, a = new RegExp(`\\b${e}\\b\\s*:\\s*`), c = 0, f = !1;
        for(let l = 0; l < r.length; l++)if (a.test(r[l]) && !f) {
            if (f = !0, n = l + 1, s = r[l].indexOf(e) + 1, r[l].includes("{}")) {
                o = n, i = r[l].indexOf("{}") + 3;
                break;
            }
            let u = r[l].slice(s + e.length);
            if (u.includes("{") || u.includes("[")) c = 1;
            else {
                o = l + 1, i = r[l].length + 1;
                break;
            }
        } else if (f && (c += (r[l].match(/{/g) || []).length, c += (r[l].match(/\[/g) || []).length, c -= (r[l].match(/}/g) || []).length, c -= (r[l].match(/]/g) || []).length, c === 0)) {
            o = l + 1, i = r[l].lastIndexOf("}") !== -1 ? r[l].lastIndexOf("}") + 2 : r[l].length + 1;
            break;
        }
        return {
            startColumn: s,
            endColumn: i,
            startLineNumber: n,
            endLineNumber: o
        };
    }, Ad = /\\([0-7]{1,3})/g, Td = (t)=>t.replace(Ad, (e, r)=>String.fromCharCode(parseInt(r, 8))), Rd = (t)=>t.replace(/\n/g, "/////n").replace(/`/g, "/////tilde").replace(/\$/g, "/////dlrsgn"), Id = (t)=>t.replace(/\/\/\/\/\/n/g, `
`).replace(/\/\/\/\/\/tilde/g, "`").replace(/\/\/\/\/\/dlrsgn/g, "$"), Pd = /[^a-zA-Z0-9\s]/g, Nd = (t)=>t.replace(Pd, (e)=>"%" + e.charCodeAt(0).toString(16).toUpperCase()), Dd = (t)=>t.replace(/%[0-9A-Fa-f]{2}/g, (e)=>String.fromCharCode(parseInt(e.slice(1), 16)));
});
var He, is, Fd, Tt, We, Fn, as, cs, Ge = G(()=>{
    He = new Set([
        "attr",
        "style",
        "text",
        "html",
        "content",
        "data",
        "classlist",
        "state",
        "scope",
        "root",
        "deps",
        "extend",
        "extends",
        "$router",
        "routes",
        "children",
        "childExtend",
        "childExtends",
        "childExtendRecursive",
        "childExtendsRecursive",
        "props",
        "if",
        "define",
        "__name",
        "__ref",
        "__hash",
        "__text",
        "key",
        "tag",
        "query",
        "parent",
        "node",
        "variables",
        "on",
        "fetch",
        "component",
        "context"
    ]), is = new Set([
        "attr",
        "style",
        "text",
        "html",
        "content",
        "data",
        "class",
        "state",
        "scope",
        "children",
        "props",
        "if",
        "key",
        "tag",
        "query",
        "on",
        "context"
    ]), Fd = [
        "ref",
        "parent",
        "__element",
        "__depends",
        "__ref",
        "__children",
        "root"
    ], Tt = new Set([
        "update",
        "parse",
        "clean",
        "create",
        "destroy",
        "add",
        "toggle",
        "remove",
        "apply",
        "set",
        "reset",
        "replace",
        "quietReplace",
        "quietUpdate",
        "applyReplace",
        "applyFunction",
        "keys",
        "values",
        "ref",
        "rootUpdate",
        "parentUpdate",
        "parent",
        "__element",
        "__depends",
        "__ref",
        "__children",
        "root",
        "setByPath",
        "setPathCollection",
        "removeByPath",
        "removePathCollection",
        "getByPath"
    ]), We = new Set([
        "update",
        "__element"
    ]), Fn = new Set([
        "set",
        "reset",
        "update",
        "remove",
        "updateContent",
        "removeContent",
        "lookup",
        "lookdown",
        "lookdownAll",
        "getRef",
        "getPath",
        "setNodeStyles",
        "spotByPath",
        "keys",
        "parse",
        "setProps",
        "parseDeep",
        "variables",
        "if",
        "log",
        "verbose",
        "warn",
        "error",
        "call",
        "nextElement",
        "previousElement",
        "getRootState",
        "getRoot",
        "getRootData",
        "getRootContext",
        "getContext",
        "getQuery",
        "getDB",
        "getChildren"
    ]), as = new Set([
        "node",
        "context",
        "extends",
        "__element",
        "__ref",
        ...Fn,
        ...Tt,
        ...We
    ]), cs = new Set([
        "init",
        "beforeClassAssign",
        "render",
        "renderRouter",
        "attachNode",
        "stateInit",
        "stateCreated",
        "beforeStateUpdate",
        "stateUpdate",
        "beforeUpdate",
        "done",
        "create",
        "complete",
        "frame",
        "update",
        "fetchError",
        "fetchComplete"
    ]);
});
var Oc, Ce, O, $d, Y, U, Ld, z, ls, Md, fs, Bd, Ud, $n, le, us, Vd, jd, Ac, zd, qd, fe, Mr, it, Tc, Hd, ps, ds, Rc, hs, ms, gs, ys, bs, Wd, Gd, ae = G(()=>{
    Nr();
    St();
    qe();
    Lr();
    Dr();
    Ge();
    Oc = "production", Ce = (t)=>t.charCodeAt(0) === 95 && t.charCodeAt(1) === 95, O = (t, e, r, n)=>{
        if (y(t)) {
            if (!e) return;
            let o = t.call(e, e, r || e.state, n || e.context);
            if (o && typeof o.then == "function") {
                let s;
                return o.then((i)=>{
                    s = i;
                }), s;
            }
            return o;
        }
        return t;
    }, $d = (t, e, r)=>{
        for(let n in e)t[n] = O(e[n], r);
    }, Y = (t, e, r = [])=>{
        let n = r instanceof Set;
        for(let o in e)Object.prototype.hasOwnProperty.call(e, o) && (Ce(o) || (n ? r.has(o) : r.includes(o)) || t[o] === void 0 && (t[o] = e[o]));
        return t;
    }, U = (t, e, r = as)=>{
        let n = r instanceof Set;
        for(let o in e){
            if (!Object.prototype.hasOwnProperty.call(e, o) || Ce(o) || (n ? r.has(o) : r.includes(o))) continue;
            let s = t[o], i = e[o];
            N(s) && N(i) ? U(s, i, r) : s === void 0 && (t[o] = i);
        }
        return t;
    }, Ld = (t, e = [])=>{
        let r = e instanceof Set, n = {};
        for(let o in t)Object.prototype.hasOwnProperty.call(t, o) && (Ce(o) || (r ? e.has(o) : e.includes(o)) || (n[o] = t[o]));
        return n;
    }, z = (t, e = {})=>{
        let { exclude: r = [], cleanUndefined: n = !1, cleanNull: o = !1, window: s, visited: i = new WeakMap, handleExtends: a = !1 } = e, c = s || D || globalThis;
        if (!N(t) || Bt(t)) return t;
        if (i.has(t)) return i.get(t);
        let l = x(t) ? [] : {};
        i.set(t, l);
        let u = r instanceof Set ? r : r.length > 3 ? new Set(r) : null;
        for(let p in t){
            if (!Object.prototype.hasOwnProperty.call(t, p) || Ce(p) || p === "__proto__" || (u ? u.has(p) : r.includes(p))) continue;
            let d = t[p];
            if (!(n && d === void 0) && !(o && d === null)) {
                if (Bt(d)) {
                    l[p] = d;
                    continue;
                }
                if (a && p === "extends" && x(d)) {
                    l[p] = rs(d, r);
                    continue;
                }
                if (y(d) && e.window) {
                    l[p] = c.eval("(" + d.toString() + ")");
                    continue;
                }
                N(d) ? l[p] = z(d, {
                    ...e,
                    visited: i
                }) : l[p] = d;
            }
        }
        return l;
    }, ls = (t, e = {})=>{
        (t.node || t.__ref || t.parent || t.__element || t.parse) && ((t.__element || t.parent?.__element).warn("Trying to clone element or state at", t), t = t.parse?.());
        for(let r in t){
            let n = t[r];
            if (y(n)) e[r] = n.toString();
            else if (g(n)) e[r] = {}, ls(n, e[r]);
            else if (x(n)) {
                let o = e[r] = [];
                for(let s = 0; s < n.length; s++){
                    let i = n[s];
                    g(i) ? (o[s] = {}, ls(i, o[s])) : y(i) ? o[s] = i.toString() : o[s] = i;
                }
            } else e[r] = n;
        }
        return e;
    }, Md = new Set([
        "&",
        "*",
        "-",
        ":",
        "%",
        "{",
        "}",
        ">",
        "<",
        "@",
        ".",
        "/",
        "!",
        " "
    ]), fs = (t = {}, e = 0)=>{
        if (t === null || typeof t != "object") return String(t);
        let r = !1;
        for(let s in t){
            r = !0;
            break;
        }
        if (!r) return "{}";
        let n = "  ".repeat(e), o = `{
`;
        for(let s in t){
            if (!Object.prototype.hasOwnProperty.call(t, s)) continue;
            let i = t[s], a = !1;
            for(let f = 0; f < s.length; f++)if (Md.has(s[f])) {
                a = !0;
                break;
            }
            let c = a ? `'${s}'` : s;
            if (o += `${n}  ${c}: `, x(i)) {
                o += `[
`;
                for (let f of i)N(f) && f !== null ? o += `${n}    ${fs(f, e + 2)},
` : b(f) ? o += `${n}    '${f}',
` : o += `${n}    ${f},
`;
                o += `${n}  ]`;
            } else N(i) ? o += fs(i, e + 1) : b(i) ? o += ss(i, [
                `
`,
                "'"
            ]) ? `\`${i}\`` : `'${i}'` : o += i;
            o += `,
`;
        }
        return o += `${n}}`, o;
    }, Bd = [
        /^\(\s*\{[^}]*\}\s*\)\s*=>/,
        /^(\([^)]*\)|[^=]*)\s*=>/,
        /^function[\s(]/,
        /^async\s+/,
        /^\(\s*function/,
        /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/
    ], Ud = /^["[{]/, $n = (t)=>{
        if (!t) return !1;
        let e = t.trim().replace(/\n\s*/g, " ").trim();
        if (e === "" || e === "{}" || e === "[]" || !Bd.some((s)=>s.test(e))) return !1;
        let n = e.charCodeAt(0), o = e.includes("=>");
        return !(n === 123 && !o || n === 91 || Ud.test(e) && !o);
    }, le = (t, e = {})=>{
        for(let r in t){
            if (!Object.prototype.hasOwnProperty.call(t, r)) continue;
            let n = t[r];
            if (b(n)) {
                if ($n(n)) try {
                    e[r] = D.eval(`(${n})`);
                } catch (o) {
                    o && (e[r] = n);
                }
                else e[r] = n;
            } else if (x(n)) {
                let o = e[r] = [];
                for(let s = 0; s < n.length; s++){
                    let i = n[s];
                    if (b(i)) {
                        if ($n(i)) try {
                            o.push(D.eval(`(${i})`));
                        } catch (a) {
                            a && o.push(i);
                        }
                        else o.push(i);
                    } else g(i) ? o.push(le(i)) : o.push(i);
                }
            } else g(n) ? e[r] = le(n, e[r]) : e[r] = n;
        }
        return e;
    }, us = (t)=>{
        if (!t || typeof t != "object") return t;
        let e = {}, r = [];
        for (let n of Object.keys(t)){
            let o = t[n];
            b(o) && $n(o) ? r.push([
                n,
                o
            ]) : e[n] = o;
        }
        for (let [n, o] of r)try {
            let s = Object.keys(e).map((i)=>`var ${i} = __gs__[${JSON.stringify(i)}];`).join(`
`);
            e[n] = D.eval(`(function(__gs__) { ${s}
 return (${o}); })`)(e);
        } catch  {
            try {
                e[n] = D.eval(`(${o})`);
            } catch  {
                e[n] = o;
            }
        }
        return e;
    }, Vd = (t, e = {
        verbose: !0
    })=>{
        try {
            return t ? D.eval("(" + t + ")") : {};
        } catch (r) {
            e.verbose && console.warn(r);
        }
    }, jd = (t, ...e)=>Object.prototype.hasOwnProperty.call(t, ...e), Ac = (t)=>{
        for(let e in t)return !1;
        return !0;
    }, zd = (t)=>g(t) && Ac(t), qd = ()=>Object.create(null), fe = (t, e, r = {})=>{
        let n = r.exclude || [], o = r.preventUnderscore;
        for(let s in e)n.includes(s) || !o && Ce(s) || e[s] !== void 0 && (t[s] = e[s]);
        return t;
    }, Mr = (t, e, r = [])=>{
        let n = r instanceof Set;
        for(let o in e)Ce(o) || (n ? r.has(o) : r.includes(o)) || (t[o] = e[o]);
        return t;
    }, it = (t, e, r = {}, n = new WeakMap)=>{
        if (!N(t) || !N(e) || Bt(t) || Bt(e)) return e;
        if (n.has(t)) return n.get(t);
        n.set(t, t);
        let o = r.exclude, s = o ? o instanceof Set ? o : new Set(o) : null, i = !r.preventForce;
        for(let a in e){
            if (!Object.prototype.hasOwnProperty.call(e, a) || s && s.has(a) || i && Ce(a)) continue;
            let c = t[a], f = e[a];
            Bt(f) ? t[a] = f : N(c) && N(f) ? t[a] = it(c, f, r, n) : f !== void 0 && (t[a] = f);
        }
        return t;
    }, Tc = (t, e, r = new Set)=>{
        if (typeof t != "object" || typeof e != "object" || t === null || e === null) return t === e;
        if (r.has(t) || r.has(e)) return !0;
        r.add(t), r.add(e);
        let n = Object.keys(t), o = Object.keys(e);
        if (n.length !== o.length) return !1;
        for(let s = 0; s < n.length; s++){
            let i = n[s];
            if (!Object.prototype.hasOwnProperty.call(e, i) || !Tc(t[i], e[i], r)) return !1;
        }
        return !0;
    }, Hd = new Set([
        "node",
        "__ref"
    ]), ps = (t, e, r = Hd)=>{
        if (t === e) return !0;
        if (!N(t) || !N(e) || Bt(t) || Bt(e)) return t === e;
        let n = r instanceof Set ? r : new Set(r), o = new WeakSet;
        function s(i, a) {
            if (o.has(a)) return !0;
            o.add(a);
            for(let c in a){
                if (!Object.prototype.hasOwnProperty.call(a, c) || n.has(c)) continue;
                if (!Object.prototype.hasOwnProperty.call(i, c)) return !1;
                let f = a[c], l = i[c];
                if (Bt(f) || Bt(l)) {
                    if (f !== l) return !1;
                } else if (N(f) && N(l)) {
                    if (!s(l, f)) return !1;
                } else if (f !== l) return !1;
            }
            return !0;
        }
        return s(t, e);
    }, ds = (t, e)=>{
        if (e == null) return t;
        if (At(e)("string", "number")) delete t[e];
        else if (x(e)) for(let r = 0; r < e.length; r++)delete t[e[r]];
        else throw new Error("Invalid input: props must be a string or an array of strings");
        return t;
    }, Rc = (t)=>{
        if (t === null || typeof t != "object") return t;
        let e = Object.create(null);
        for(let r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = Rc(t[r]));
        return e;
    }, hs = (t, e)=>{
        if (t.length === 0) return e;
        let r = {}, n = r;
        for(let o = 0; o < t.length; o++)o === t.length - 1 && e ? n[t[o]] = e : (n[t[o]] = {}, n = n[t[o]]);
        return r;
    }, ms = (t, e)=>{
        if (!Array.isArray(e)) throw new Error("Path must be an array.");
        let r = t;
        for(let o = 0; o < e.length - 1; o++){
            if (r[e[o]] === void 0) return;
            r = r[e[o]];
        }
        let n = e[e.length - 1];
        r && Object.prototype.hasOwnProperty.call(r, n) && delete r[n];
    }, gs = (t, e, r)=>{
        if (!Array.isArray(e)) throw new Error("Path must be an array.");
        let n = t;
        for(let o = 0; o < e.length - 1; o++)(!n[e[o]] || typeof n[e[o]] != "object") && (n[e[o]] = {}), n = n[e[o]];
        return n[e[e.length - 1]] = r, t;
    }, ys = (t, e)=>{
        if (!Array.isArray(e)) throw new Error("Path must be an array.");
        let r = t;
        for(let n = 0; n < e.length; n++){
            if (r == null) return;
            r = r[e[n]];
        }
        return r;
    }, bs = (t)=>{
        let r = [], n = 0;
        for(let o = 0; o < t.length; o++)if (r.length < 2) r.push(t[o]);
        else if (t[o] === r[o % 2] ? n++ : (r = [
            t[o - 1],
            t[o]
        ], n = 1), n >= 20) return (Oc === "test" || Oc === "development") && console.warn("Warning: Potential infinite loop detected due to repeated sequence:", r), !0;
    }, Wd = (t)=>{
        let e = new WeakSet;
        function r(n) {
            if (n && typeof n == "object") {
                if (e.has(n)) return !0;
                e.add(n);
                for(let o in n)if (Object.prototype.hasOwnProperty.call(n, o) && r(n[o])) return console.log(n, "cycle at " + o), !0;
            }
            return !1;
        }
        return r(t);
    }, Gd = (t, e)=>{
        let r = e instanceof Set ? e : new Set(e), n = {};
        for(let o in t)Object.prototype.hasOwnProperty.call(t, o) && !r.has(o) && (n[o] = t[o]);
        return n;
    };
});
var Ss, xs, _s, Ln = G(()=>{
    ae();
    Ss = function() {
        let t = 0;
        function e() {
            return t++, t;
        }
        return e;
    }(), xs = Ss, _s = (t, e, r)=>(O(r, t) || r || t.key || Ss()).toString();
});
var Qt, Kd, Ke, Ic, Yd, Xd, Qd, Jt, Jd, Br, ws = G(()=>{
    Qt = "production", Kd = Qt, Ke = (t = Qt)=>t === "production", Ic = (t = Qt)=>t === "testing" || t === "test", Yd = Ic, Xd = (t = Qt)=>t === "staging", Qd = (t = Qt)=>t === "local", Jt = (t = Qt)=>t === "development" || t === "dev" || t === "local", Jd = (t, e = Qt)=>e[t], Br = (t = Qt)=>!Ke(t);
});
function Zd(t, e, r) {
    let n;
    return function() {
        let o = this, s = arguments, i = function() {
            n = null, r || t.apply(o, s);
        }, a = r && !n;
        clearTimeout(n), n = setTimeout(i, e), a && t.apply(o, s);
    };
}
function oh(t, e = window) {
    let r = function() {
        return t.apply(e, arguments);
    };
    for(let n in t)Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
    return r;
}
var th, eh, rh, nh, Ye, Xe, Mn, Bn = G(()=>{
    th = (t, e, r = 300)=>{
        let n;
        return (...o)=>{
            clearTimeout(n), n = setTimeout(()=>{
                e.apply(t, o);
            }, r);
        };
    }, eh = (t)=>{
        let e = {};
        return (...r)=>{
            let n = r[0];
            if (n in e) return e[n];
            {
                let o = t(n);
                return e[n] = o, o;
            }
        };
    }, rh = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/, nh = (t)=>rh.test(t), Ye = (t)=>{
        let e = t?.plugins;
        if (!e || !e.length) return !1;
        for (let r of e)if (r.resolveHandler) return !0;
        return !1;
    }, Xe = (t, e)=>{
        if (typeof t == "function") return t;
        let r = e?.context?.plugins;
        if (!r) return t;
        for (let n of r)if (n.resolveHandler) {
            let o = n.resolveHandler(t, e);
            if (typeof o == "function") return o;
        }
        return t;
    }, Mn = (t, e, ...r)=>{
        let n = e?.context?.plugins;
        if (n) for (let o of n)typeof o[t] == "function" && o[t](e, ...r);
    };
});
var Ur, Pc = G(()=>{
    St();
    Ur = (t, e)=>{
        let { __ref: r } = t;
        y(t.if) && !t.if(t, t.state, t.context) ? delete r.__if : r.__if = !0;
    };
});
var sh, ih, Nc = G(()=>{
    sh = (t, ...e)=>{
        t && e.map((r)=>console.log(r));
    }, ih = (t, e, ...r)=>{
        t && (console.group(e), r.map((n)=>console.log(n)), console.groupEnd(e));
    };
});
function uh(t) {
    if (!window.localStorage) return;
    let e = window.localStorage.getItem(t);
    if (e !== null) try {
        return JSON.parse(e);
    } catch  {
        return;
    }
}
function ph(t, e) {
    if (!window.localStorage || e === void 0 || e === null) return;
    let r = typeof e == "object" ? JSON.stringify(e) : e;
    window.localStorage.setItem(t, r);
}
var ah, ch, lh, fh, Dc = G(()=>{
    St();
    Nr();
    ah = typeof navigator > "u" ? !1 : /Mobi/.test(navigator.userAgent), ch = (t, e, r = 365)=>{
        if (K(L) || K(L.cookie)) return;
        let n = new Date;
        n.setTime(n.getTime() + r * 86400000);
        let o = `expires=${n.toUTCString()}`;
        L.cookie = `${t}=${e};${o};path=/`;
    }, lh = (t)=>{
        if (K(L) || K(L.cookie)) return;
        let e = `${t}=`, n = decodeURIComponent(L.cookie).split(";");
        for(let o = 0; o < n.length; o++){
            let s = n[o];
            for(; s.charAt(0) === " ";)s = s.substring(1);
            if (s.indexOf(e) === 0) return s.substring(e.length, s.length);
        }
        return "";
    }, fh = (t)=>{
        K(L) || K(L.cookie) || (L.cookie = t + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
    };
});
var Un, Qe, ke, vs = G(()=>{
    Un = {
        root: [
            "body",
            "html"
        ],
        head: [
            "title",
            "base",
            "meta",
            "style",
            "noscript",
            "script"
        ],
        body: new Set([
            "string",
            "style",
            "fragment",
            "a",
            "abbr",
            "acronym",
            "address",
            "applet",
            "area",
            "article",
            "aside",
            "audio",
            "b",
            "basefont",
            "bdi",
            "bdo",
            "big",
            "blockquote",
            "br",
            "button",
            "canvas",
            "caption",
            "center",
            "cite",
            "code",
            "search",
            "col",
            "colgroup",
            "data",
            "datalist",
            "dd",
            "del",
            "details",
            "dfn",
            "dialog",
            "dir",
            "div",
            "dl",
            "dt",
            "em",
            "embed",
            "fieldset",
            "figcaption",
            "figure",
            "font",
            "footer",
            "form",
            "frame",
            "frameset",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "head",
            "header",
            "hr",
            "i",
            "iframe",
            "img",
            "input",
            "ins",
            "kbd",
            "label",
            "legend",
            "li",
            "link",
            "main",
            "map",
            "mark",
            "meter",
            "nav",
            "noframes",
            "noscript",
            "object",
            "ol",
            "optgroup",
            "option",
            "output",
            "p",
            "param",
            "picture",
            "pre",
            "progress",
            "hgroup",
            "q",
            "rp",
            "rt",
            "ruby",
            "s",
            "samp",
            "script",
            "section",
            "select",
            "small",
            "source",
            "span",
            "strike",
            "strong",
            "sub",
            "summary",
            "sup",
            "table",
            "tbody",
            "td",
            "template",
            "hgroup",
            "textarea",
            "tfoot",
            "th",
            "thead",
            "time",
            "tr",
            "track",
            "tt",
            "u",
            "ul",
            "var",
            "video",
            "wbr",
            "svg",
            "path",
            "circle",
            "ellipse",
            "line",
            "polygon",
            "polyline",
            "rect",
            "g",
            "defs",
            "symbol",
            "use",
            "text",
            "tspan",
            "image",
            "clipPath",
            "mask",
            "pattern",
            "marker",
            "linearGradient",
            "radialGradient",
            "stop",
            "filter",
            "feGaussianBlur",
            "feOffset",
            "feMerge",
            "feMergeNode",
            "feBlend",
            "feColorMatrix",
            "feFlood",
            "feComposite",
            "foreignObject"
        ])
    }, Qe = new Set([
        "svg",
        "path",
        "circle",
        "ellipse",
        "line",
        "polygon",
        "polyline",
        "rect",
        "g",
        "defs",
        "symbol",
        "use",
        "text",
        "tspan",
        "image",
        "clipPath",
        "mask",
        "pattern",
        "marker",
        "linearGradient",
        "radialGradient",
        "stop",
        "filter",
        "feGaussianBlur",
        "feOffset",
        "feMerge",
        "feMergeNode",
        "feBlend",
        "feColorMatrix",
        "feFlood",
        "feComposite",
        "foreignObject"
    ]), ke = (t)=>Un.body.has(t);
});
var Es, Fc, Vn, Os, Rt, As, $c, Ts, dh, Rs, Lc, Mc, Is, Bc, jn, hh, ue, Uc, Cs, Ps, mh, ks, gh, yh, Vc, jc, zc, qc, Hc, Wc, Ns, zn = G(()=>{
    qe();
    Ds();
    ae();
    St();
    Es = "production", Fc = (t)=>t.sourcemap !== !1 && Es !== "production", Vn = (t)=>{
        if (t.includes("+")) return t.split("+").filter(It);
        if (t.includes("_")) {
            let [e] = t.split("_");
            return [
                e
            ];
        }
        if (t.includes(".") && !It(t.split(".")[1])) {
            let [e] = t.split(".");
            return [
                e
            ];
        }
        return [
            t
        ];
    }, Os = (t, e, r)=>{
        let n = [], o = Vn(r);
        o && (n = [
            ...o
        ]);
        let s = t.extends;
        return s && (n = x(s) ? [
            ...n,
            ...s
        ] : [
            ...n,
            s
        ]), n;
    }, Rt = (t, e)=>{
        let { __ref: r } = e, { __extends: n } = r;
        if (!t) return n;
        let o = e.props?.variant, s = e.context;
        if (o && s?.components && !Array.isArray(t) && typeof t == "string") {
            let i = `${t}.${o}`;
            s.components[i] && (t = i);
        }
        return n.includes(t) || (n = Array.isArray(t) ? [
            ...n,
            ...t
        ] : [
            ...n,
            t
        ], r.__extends = n), n;
    }, As = (t, e)=>{
        if (!t) return e;
        let { extends: r } = e, n = x(r) ? r : [
            r
        ], o = x(t) ? t : [
            t
        ];
        return {
            ...e,
            extends: Nn(o, n)
        };
    }, $c = ()=>Math.random().toString(36).substring(2), Ts = {}, dh = {}, Rs = (t)=>Ts[t.__hash], Lc = (t, e)=>{
        let r = $c();
        return b(t) || (t.__hash = r), r !== "__proto__" && r !== "constructor" && r !== "prototype" && (Ts[r] = e), e;
    }, Mc = (t, e)=>t.__hash ? e.concat(Rs(t)) : Lc(t, e), Is = (t, e, r, n = new Set, o, s)=>{
        for (let i of t)x(i) ? Is(i, e, r, n, o, s) : jn(i, e, r, n, o, void 0, s);
        return e;
    }, Bc = (t, e, r, n = new Set, o, s, i)=>{
        let a = t.extends || t.extend, c = {
            ...t
        };
        delete c.extends, delete c.extend;
        let f = !1;
        for(let l in c){
            f = !0;
            break;
        }
        return f && (e.push(c), o && o.push(s)), a && jn(a, e, r, n, o, s, i), e;
    }, jn = (t, e, r, n = new Set, o, s, i)=>{
        if (!t || n.has(t)) return e;
        if (x(t)) return Is(t, e, r, n, o, i);
        let a = s;
        return b(t) ? (a = t, t = Ps(t, r)) : i && g(t) && i.has(t) && (a = i.get(t)), n.add(t), t?.extends || t?.extend ? Bc(t, e, r, n, o, a, i) : t && (e.push(t), o && o.push(a)), e;
    }, hh = new Set([
        "parent",
        "node",
        "__ref",
        "__proto__",
        "extend",
        "childExtend",
        "childExtendRecursive"
    ]), ue = (t, e, r, n, o)=>{
        e = z(e);
        for(let s in e){
            if (hh.has(s)) continue;
            let i = t[s], a = e[s];
            if (a !== void 0 && Object.prototype.hasOwnProperty.call(e, s) && s !== "__proto__" && s !== "constructor" && s !== "prototype") {
                if (i === void 0) t[s] = a, r && n ? g(a) && !x(a) ? (r[s] = r[s] || {}, Uc(r[s], a, n)) : r[s] = n : r && o?.[s] && (r[s] = o[s]);
                else if (g(i) && g(a)) {
                    let c = r ? r[s] = r[s] || {} : void 0, f = o?.[s];
                    It(s) ? t[s] = ue(i, a, c, n, f) : ue(i, a, c, n, f);
                }
                if (s === "extends" || s === "childExtends" || s === "childExtendsRecursive") {
                    if (x(i) && x(a)) t[s] = i.concat(a);
                    else if (x(i) && g(a)) {
                        let c = ue({}, i);
                        t[s] = ue(c, a);
                    }
                }
            }
        }
        return t;
    }, Uc = (t, e, r, n)=>{
        if (n || (n = new WeakSet), !n.has(e)) {
            n.add(e);
            for(let o in e){
                if (!Object.prototype.hasOwnProperty.call(e, o) || o === "__proto__" || o === "constructor" || o === "prototype") continue;
                let s = e[o];
                g(s) && !x(s) ? (t[o] = t[o] || {}, Uc(t[o], s, r, n)) : t[o] = r;
            }
        }
    }, Cs = (t, e, r)=>t.reduce((n, o, s)=>{
            let i = z(o), a = r ? r[s] : void 0;
            return ue(n, i, e, a);
        }, {}), Ps = (t, e, r = {}, n)=>{
        let o = e?.components || r.components, s = e?.pages || r.pages;
        if (b(t)) {
            let i = o && (o[t + "." + n] || o[t] || o["smbls." + t]), a = s && t.charCodeAt(0) === 47 && s[t];
            if (i) return i;
            if (a) return a;
            r.verbose && (Es === "test" || Es === "development") && console.warn("Extend is string but component was not found:", t);
            return;
        }
        return t;
    }, mh = (t, e)=>[].concat(t.slice(0, 1)).concat(e.slice(0, 1)).concat(t.slice(1)).concat(e.slice(1)), ks = (t, e, r, n)=>{
        if (!t) return [];
        if (t.__hash) return Rs(t) || [];
        let s = jn(t, [], e, new Set, r, void 0, n);
        return r ? s : Mc(t, s);
    }, gh = (t, e)=>{
        if (!t) return e;
        let r = x(t) ? t : [
            t
        ];
        return Nn(r, e);
    }, yh = (t)=>{
        let e = [];
        function r(n) {
            for(let o in n)Object.prototype.hasOwnProperty.call(n, o) && (It(o) && e.push(o), o === "extends" && (typeof n[o] == "string" ? e.push(n[o]) : Array.isArray(n[o]) && (e = e.concat(n[o]))), typeof n[o] == "object" && n[o] !== null && r(n[o]));
        }
        return r(t), e;
    }, Vc = (t, e, r = {})=>{
        let { __ref: n } = t, o = t.context || e.context, s = t.props?.variant;
        if (t.extend && !t.extends && (t.extends = t.extend), delete t.extend, !t.extends && t.props?.extends && (t.extends = t.props.extends), t.extends) {
            if (Array.isArray(t.extends) && t.extends.length > 0) {
                let [i, ...a] = t.extends;
                if (typeof i == "string" && s && o?.components) {
                    let c = `${i}.${s}`;
                    o.components[c] ? Rt([
                        c,
                        ...a
                    ], t) : Rt(t.extends, t);
                } else Rt(t.extends, t);
            } else if (typeof t.extends == "string" && s && o?.components) {
                let i = `${t.extends}.${s}`;
                o.components[i] ? Rt(i, t) : Rt(t.extends, t);
            } else Rt(t.extends, t);
        }
        return jc(t, e, r), zc(t, e, r), qc(t, e, r), t.component && Rt(O(t.component, t), t), o.defaultExtends && Rt(o.defaultExtends, t), Dn(n.__extends);
    }, jc = (t, e, r = {})=>{
        let { props: n, __ref: o } = t;
        return r.ignoreChildExtends || n?.ignoreChildExtends || e.props?.childProps?.extends && Rt(e.props?.childProps.extends, t), o.__extends;
    }, zc = (t, e, r = {})=>{
        let { props: n, __ref: o } = t, s = r.ignoreChildExtends || n?.ignoreChildExtends, i = e.childExtends || e.childExtend;
        return !s && i && Rt(i, t), o.__extends;
    }, qc = (t, e, r = {})=>{
        let { props: n, __ref: o } = t, s = e.childExtendsRecursive || e.childExtendRecursive, i = r.ignoreChildExtendsRecursive || n?.ignoreChildExtendsRecursive, a = t.key === "__text";
        return s && !a && !i && Rt(s, t), o.__extends;
    }, Hc = (t, e, r = {})=>{
        let { props: n, __ref: o } = t, s = t.context || e.context, i = t.variant || n?.variant, a = Fc(r), c = a ? [
            ...o.__extends
        ] : null, f = Dn(o.__extends.map((l, u)=>Ps(l, s, r, u === 0 && i)));
        if (a) {
            let l = new WeakMap;
            for(let d = 0; d < f.length; d++){
                let h = f[d], m = c[d];
                h && g(h) && b(m) && l.set(h, m);
            }
            let u = [], p = ks(f, s, u, l);
            o.__extendsStack = p, o.__extendsNames = u;
        } else {
            let l = ks(f, s);
            o.__extendsStack = l;
        }
        return o.__extendsStack;
    }, Wc = (t, e, r = {})=>{
        let { __ref: n } = t, { __extendsStack: o } = n;
        if (Fc(r)) {
            let s = {}, i = n.__extendsNames || [], a = Cs(o, s, i), c = {};
            ue(t, a, c, void 0, s), n.__sourcemap = c;
        } else {
            let s = Cs(o);
            ue(t, s);
        }
        return t;
    }, Ns = (t, e, r = {})=>(Vc(t, e, r), Hc(t, e, r), Wc(t, e, r), t);
});
function bh(t) {
    return Object.keys(t).filter((e)=>/^[A-Z]/.test(e));
}
function Sh(t) {
    return Object.keys(t).filter((e)=>/^\d+$/.test(e));
}
function Fs(t, e, r) {
    let { context: n } = e || {}, [o] = Vn(r), s = r || o;
    return n?.components?.[s] || n?.pages?.[s];
}
var It, Ds = G(()=>{
    zn();
    St();
    It = (t)=>{
        if (!b(t) || !t.length) return !1;
        let e = t.charCodeAt(0);
        return e >= 65 && e <= 90;
    };
});
function Gc(t, e) {
    let { props: r, on: n } = e, o = ce(t.split("on")[1]), s = n[o], i = r[t];
    y(s) ? n[o] = (...a)=>{
        if (s(...a) !== !1 && y(i)) return i(...a);
    } : n[o] = i;
}
var Kc = G(()=>{
    Lr();
    St();
});
function Qc(t, e = {}) {
    let r = e.cachedKeys || [];
    for(let n in t){
        let o = t[n];
        if (n.length > 2 && n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && n[2] === n[2].toUpperCase() && (y(o) || o != null && Ye(this.context))) {
            let h = ce(n.slice(2));
            t.on && (t.on[h] = o), delete t[n];
            continue;
        }
        if (n === "childProps") {
            t.props[n] = o, delete t[n], r.push(n);
            continue;
        }
        let a = this.define?.[n], c = this.context?.define?.[n], f = g(a) || y(a), l = g(c) || y(c);
        if (f || l) continue;
        let u = n.charAt(0);
        if (Xc.has(u)) {
            t.props[n] = o, delete t[n], r.push(n);
            continue;
        }
        let p = Ms.test(n) || Yc.test(n) || _h(o), d = He.has(n);
        !p && !d && (t.props[n] = o, delete t[n], r.push(n));
    }
    return t;
}
function Vr(t = this, e) {
    let r = e.cachedKeys || [];
    for(let n in t.props){
        let o = t.props[n], s = n.length > 2 && n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110, i = y(o) || o != null && Ye(this.context);
        if (s && i) {
            Gc(n, t), delete t.props[n];
            continue;
        }
        if (r.includes(n) || n === "childProps") continue;
        let a = n.charAt(0);
        if (Xc.has(a)) continue;
        let c = this.define?.[n], f = this.context?.define?.[n], l = g(c) || y(c), u = g(f) || y(f), p = Ms.test(n) || Yc.test(n), d = He.has(n);
        (p || d || l || u) && (t[n] === void 0 || o === null) && (t[n] = o, t.props && delete t.props[n]);
    }
    return t;
}
function qn(t = this) {
    let e = [];
    return Qc.call(this, t, {
        cachedKeys: e
    }), Vr.call(this, t, {
        cachedKeys: e
    }), t;
}
function Us(t = {}) {
    return t.on || (t.on = {}), t.props || (t.props = {}), qn.call(this, t);
}
function Jc(t, e) {
    this.__element.update({
        props: t
    }, e);
}
function js(t) {
    let e = {
        update: Jc.bind(t.props),
        __element: t
    };
    Object.setPrototypeOf(t.props, e);
}
var Ms, Yc, Xc, xh, _h, Bs, $s, wh, Vs, zs, qs, Zc, Ls, Hn, Hs, Ws = G(()=>{
    Ge();
    Kc();
    ae();
    St();
    Lr();
    Bn();
    Ms = /^[A-Z]/, Yc = /^\d+$/, Xc = new Set([
        ":",
        "@",
        "[",
        "*",
        "+",
        "~",
        "&",
        ">",
        "$",
        "-",
        ".",
        "!"
    ]), xh = new Set([
        "extend",
        "props",
        "text",
        "tag",
        "on",
        "if",
        "childExtend",
        "children",
        "childrenAs",
        "state",
        "html",
        "attr",
        "define",
        "content"
    ]), _h = (t)=>{
        if (!t || typeof t != "object" || Array.isArray(t)) return !1;
        for(let e in t)if (xh.has(e) || Ms.test(e)) return !0;
        return !1;
    }, Bs = (t, e, r)=>{
        let { props: n, __ref: o } = t;
        if (o.__propsStack = [], n) o.__initialProps = n;
        else return {};
        return N(n) ? {
            ...n
        } : (o.__propsStack.push(n), {});
    };
    $s = (t)=>At(t)("string", "number") ? {
            inheritedString: t
        } : t, wh = (t, e)=>!t || !e.length ? !1 : e.includes(t), Vs = (t, e)=>{
        let { __ref: r } = t, n = r.__propsStack || [], o = e.props;
        if (!o) return n;
        let s = o[t.key], i = o.childProps || e.childProps, a = t.props?.ignoreChildProps;
        if (i && !a) {
            let c = $s(i);
            n.unshift(c);
        }
        if (s) {
            let c = $s(s);
            n.unshift(c);
        }
        return n;
    };
    zs = (t)=>{
        let e = new Set;
        return t.filter((r)=>!r || We.has(r) || e.has(r) ? !1 : (e.add(r), !0));
    }, qs = (t, e, r)=>(e.props = t.reduce((n, o)=>{
            if (We.has(o)) return n;
            for(; y(o);)o = O(o, e);
            return U(n, z(o, {
                exclude: We
            }));
        }, {}), js(e), e.props), Zc = (t, e)=>{
        let { props: r, __ref: n } = t, o = n.__propsStack || [];
        if (e?.props && (o = [
            ...Vs(t, e)
        ]), g(r) ? o.push(r) : r === "inherit" && e?.props ? o.push(e.props) : r && o.push(r), x(n.__extendsStack)) for(let s = 0; s < n.__extendsStack.length; s++){
            let i = n.__extendsStack[s];
            i.props && i.props !== r && o.push(i.props);
        }
        return n.__propsStack = zs(o), n.__propsStack;
    }, Ls = (t, e)=>{
        let { __ref: r } = t, n = Zc(t, e);
        n.length ? qs(n, t) : (r.__propsStack = [], t.props = {});
    }, Hn = function(t, e, r) {
        let { __ref: n } = t;
        if (n.__if) Ls(t, e);
        else try {
            Ls(t, e);
        } catch (o) {
            t.context?.designSystem?.verbose && console.warn("initProps error at", n.path?.join("."), o), t.props = {}, n.__propsStack = [];
        }
        return js(t), t;
    }, Hs = (t, e, r)=>{
        let { __ref: n } = e, s = [
            ...n.__propsStack || []
        ], i = Vs(e, r);
        return i.length && (s = [
            ...i,
            ...s
        ]), t && (s = [
            t,
            ...s
        ]), n.__propsStack = zs(s), n.__propsStack.length && qs(n.__propsStack, e), e;
    };
});
var tl, el, rl, nl, ol, Gs, sl, il, al, Ks, cl = G(()=>{
    zn();
    Ln();
    Dr();
    Ws();
    vs();
    St();
    tl = "production", el = (t, e, r)=>{
        let n = e.childExtends && e.childExtends.tag, o = e.props.childProps && e.props.childProps.tag, s = Un.body.has(r) && r;
        return {
            text: t,
            tag: n || o || s || "string"
        };
    }, rl = (t, e, r)=>{
        if (t === void 0) return (tl === "test" || tl === "development") && console.warn(r, "element is undefined in", e?.__ref?.path), {};
        if (t !== null) return t === !0 ? {} : At(t)("string", "number") ? el(t, e, r) : y(t) ? {
            props: t
        } : t;
    }, nl = (t, e)=>{
        let r = {};
        return r.origin = t, r.parent = e, r;
    }, ol = (t, e, r, n, o)=>{
        if (!e) return o;
        if (Ee(e)) {
            let s = {
                key: ":root",
                node: e
            };
            return o[`${r}_parent`] = s, s;
        }
        return e;
    }, Gs = (t, e)=>{
        let { __ref: r } = t, { __ref: n } = e, o = e && e.key === ":root";
        r?.root || (r.root = o ? t : n?.root);
    }, sl = (t, e, r)=>{
        let { __ref: n } = e;
        return n || (n = e.ref = {}), n.path || (n.path = []), n.path.concat(r);
    }, il = (t, e, r, n, o)=>(n.context && !o.context && !t.context && (o.context = n.context), n.context || e.context || o.context || t.context), al = (t, e, r)=>{
        let n = nl(t, e);
        return t.__ref = n, n.__defineCache || (n.__defineCache = {}), n.__exec || (n.__exec = {}), n.__execProps || (n.__execProps = {}), n.__class || (n.__class = {}), n.__classNames || (n.__classNames = {}), n.__attr || (n.__attr = {}), n.__changes || (n.__changes = []), n.__children || (n.__children = []), n.__extends = Os(t, e, r), n.path = sl(t, e, r), n;
    }, Ks = (t, e, r, n, o)=>{
        let i = t?.__hash ? {
            extends: [
                t
            ]
        } : rl(t, e, r);
        if (!i) return;
        let a = ol(i, e, r, n, o), c = _s(i, a, r);
        al(i, a, c);
        let f = Bs(i, a, c), l = il(i, a, c, n, o), u = i.on || {};
        return {
            ...i,
            key: c,
            props: f,
            parent: a,
            context: l,
            on: u
        };
    };
});
var Ys, Je, Ze, tr, er, Xs, rr, Wn, Qs, Js, Zs, ll = G(()=>{
    qe();
    Ge();
    ae();
    St();
    Ys = (t)=>{
        let { state: e, props: r, __ref: n } = t, o = r?.state || e;
        return At(o)("string", "number") ? (n.__state = o, {
            value: o
        }) : o === !0 ? (n.__state = t.key, {}) : o ? (n.__hasRootState = !0, o) : !1;
    }, Je = (t, e)=>{
        if (!t.includes("~/")) return;
        if (t.split("~/").length > 1) return e.root;
    }, Ze = (t, e)=>{
        if (!t.includes("../")) return;
        let n = t.split("../").length - 1;
        for(let o = 0; o < n; o++){
            if (!e.parent) return null;
            e = e.parent;
        }
        return e;
    }, tr = (t, e, r = {})=>{
        let n = b(t) ? t.split("/") : [
            t
        ], o = n.length - 1;
        for(let s = 0; s < o; s++){
            let i = n[s], a = n[s + 1];
            if (i === "__proto__" || a === "__proto__") return;
            let c = e[i];
            c || (c = e[i] = {}), c[a] || (c[a] = {}), t = a, e = c;
        }
        return r.returnParent ? e : e[t];
    }, er = (t, e, r = {})=>{
        let o = t.__ref.__state;
        if (!rr(t)) return;
        let s = Je(o, e.state), i = e.state;
        if (s) i = s, o = o.replaceAll("~/", "");
        else {
            let a = Ze(o, e.state);
            a && (i = a, o = o.replaceAll("../", ""));
        }
        if (i) return tr(o, i, r);
    }, Xs = (t, e)=>{
        let r = t.__ref, n = er(t, e);
        if (n === void 0) return t.state;
        if (At(n)("object", "array")) return z(n);
        if (At(n)("string", "number", "boolean")) return r.__stateType = typeof n, {
            value: n
        };
        console.warn(r.__state, "is not present. Replacing with", {});
    }, rr = (t)=>{
        let { __ref: e } = t, r = e?.__state;
        return !!(r && At(r)("number", "string", "boolean"));
    }, Wn = function(t) {
        return N(t) ? !!(t.update && t.parse && t.clean && t.create && t.parent && t.destroy && t.rootUpdate && t.parentUpdate && t.keys && t.values && t.toggle && t.replace && t.quietUpdate && t.quietReplace && t.add && t.apply && t.applyReplace && t.setByPath && t.setPathCollection && t.removeByPath && t.removePathCollection && t.getByPath && t.applyFunction && t.__element && t.__children) : !1;
    }, Qs = (t, e)=>{
        if (!t) return e || {};
        let r = t.split("/"), n = {}, o = n, s = r.length - 1;
        for(let i = 0; i <= s; i++)o[r[i]] = i === s ? e || {} : {}, o = o[r[i]];
        return n;
    }, Js = (t, e)=>{
        let { __element: r } = e, n = r?.state;
        if (!n) return;
        let o = z(n, Tt), s = {
            [t.key]: o
        }, i = g(n.__depends) ? {
            ...n.__depends,
            ...s
        } : s;
        return Array.isArray(n) ? $r(n, {
            ...Object.getPrototypeOf(n),
            __depends: i
        }) : Object.setPrototypeOf(n, {
            ...Object.getPrototypeOf(n),
            __depends: i
        }), o;
    }, Zs = (t, e, r = {})=>{
        let { overwrite: n } = r;
        if (!n) return;
        let o = n === "shallow";
        if (n === "merge") {
            U(t, e, Tt);
            return;
        }
        (o ? Mr : it)(t, e, Tt);
    };
});
var Gn, fl = G(()=>{
    Gn = (t, e)=>{
        let { __ref: r } = t, n = t.context || e.context || r.root?.context;
        n && !n.globalScope && (n.globalScope = {});
        let o = e.scope || r.root?.scope, s = n?.globalScope;
        if (!t.scope) o ? t.scope = o : s ? t.scope = Object.create(s) : t.scope = {};
        else if (typeof t.scope == "object" && t.scope !== null && Object.getPrototypeOf(t.scope) === Object.prototype) {
            let i = o || s;
            i && Object.setPrototypeOf(t.scope, i);
        }
    };
});
var ul, jr, W, ti, vt, ei = G(()=>{
    St();
    Bn();
    ul = (t, e)=>{
        let r = e.on?.[t];
        if (r) return r;
        let n = e.props;
        if (!n) return;
        let o = "on" + t.charAt(0).toUpperCase() + t.slice(1);
        return n[o];
    }, jr = (t, e, r, n, o)=>{
        if (t = Xe(t, e), !!y(t)) try {
            let s = t.call(e, e, r || e.state, n || e.context, o);
            return s && typeof s.then == "function" && s.catch((i)=>{
                e.error = i, console.error("[DOMQL] Async event error:", i);
            }), s;
        } catch (s) {
            if (e.error = s, console.error("[DOMQL] Event handler error:", s), e.context?.strictMode) throw s;
        }
    }, W = (t, e, r)=>{
        if (!e) throw new Error("Element is required");
        Mn(t, e, r);
        let n = ul(t, e);
        if (n) {
            let { state: o, context: s } = e;
            return jr(n, e, o, s, r);
        }
    }, ti = (t, e, r, n, o, s)=>{
        if (t = Xe(t, r), !!y(t)) try {
            let i = t.call(r, e, r, n || r.state, o || r.context, s);
            return i && typeof i.then == "function" && i.catch((a)=>{
                r.error = a, console.error("[DOMQL] Async event update error:", a);
            }), i;
        } catch (i) {
            if (r.error = i, console.error("[DOMQL] Event update error:", i), r.context?.strictMode) throw i;
        }
    }, vt = (t, e, r, n)=>{
        Mn(t, r, e, n);
        let o = ul(t, r);
        if (o) {
            let { state: s, context: i } = r;
            return ti(o, e, r, s, i, n);
        }
    };
});
var vh, ut, ri = G(()=>{
    vh = {}, ut = {};
});
var dl = {};
Mt(dl, {
    setup: ()=>Eh,
    supabaseAdapter: ()=>pl
});
var Eh, ni, Ch, pl;

var hl = G(()=>{
    "use strict";
    Eh = async ({ url: t, key: e, projectId: r, createClient: n, ...o })=>{
        let s = t || r && `https://${r}.supabase.co`;
        if (!s || !e) throw new Error("@symbo.ls/fetch supabase: url (or projectId) and key are required");
        n || (n = (await Promise.resolve((parcelRequire("dNnfS")))).createClient);
        let i = n(s, e, o);
        return !i || !i.auth ? null : pl(i);
    }, ni = (t, e)=>{
        if (!e) return t;
        for(let r in e){
            let n = e[r];
            if (n === null) t = t.is(r, null);
            else if (Array.isArray(n)) t = t.in(r, n);
            else if (typeof n == "object") for(let o in n)o === "gt" ? t = t.gt(r, n[o]) : o === "gte" ? t = t.gte(r, n[o]) : o === "lt" ? t = t.lt(r, n[o]) : o === "lte" ? t = t.lte(r, n[o]) : o === "neq" ? t = t.neq(r, n[o]) : o === "like" ? t = t.like(r, n[o]) : o === "ilike" ? t = t.ilike(r, n[o]) : o === "in" ? t = t.in(r, n[o]) : o === "is" ? t = t.is(r, n[o]) : o === "contains" ? t = t.contains(r, n[o]) : o === "containedBy" ? t = t.containedBy(r, n[o]) : o === "textSearch" && (t = t.textSearch(r, n[o]));
            else t = t.eq(r, n);
        }
        return t;
    }, Ch = (t, { limit: e, offset: r, order: n, single: o } = {})=>{
        if (n) {
            if (Array.isArray(n)) for (let s of n){
                let i = typeof s == "string" ? s : s.by;
                t = t.order(i, {
                    ascending: s.asc !== !1
                });
            }
            else {
                let s = typeof n == "string" ? n : n.by;
                t = t.order(s, {
                    ascending: n.asc !== !1
                });
            }
        }
        return e && (t = t.limit(e)), r && (t = t.range(r, r + (e || 20) - 1)), o && (t = t.single()), t;
    }, pl = (t)=>({
            name: "supabase",
            client: t,
            getSession: async ()=>{
                let { data: e } = await t.auth.getSession();
                return e?.session || null;
            },
            getUser: async ()=>{
                let { data: e } = await t.auth.getUser();
                return e?.user || null;
            },
            signIn: (e)=>e.provider ? t.auth.signInWithOAuth({
                    provider: e.provider
                }) : e.token ? t.auth.signInWithIdToken(e) : t.auth.signInWithPassword(e),
            signUp: (e)=>t.auth.signUp(e),
            signOut: ()=>t.auth.signOut(),
            onAuthStateChange: (e)=>{
                let { data: { subscription: r } } = t.auth.onAuthStateChange((n, o)=>e(n, o));
                return ()=>r.unsubscribe();
            },
            select: async ({ from: e, select: r, params: n, ...o })=>{
                let s = t.from(e).select(r || "*");
                return s = ni(s, n), s = Ch(s, o), s;
            },
            rpc: ({ from: e, params: r })=>t.rpc(e, r),
            insert: ({ from: e, data: r, select: n })=>t.from(e).insert(r).select(n || "*"),
            update: ({ from: e, data: r, params: n, select: o })=>{
                let s = t.from(e).update(r);
                return s = ni(s, n), s.select(o || "*");
            },
            upsert: ({ from: e, data: r, select: n })=>t.from(e).upsert(r).select(n || "*"),
            delete: ({ from: e, params: r })=>{
                let n = t.from(e).delete();
                return n = ni(n, r), n;
            },
            subscribe: ({ from: e, params: r, on: n }, o)=>{
                let s = n || "*", i = t.channel(`db-${e}-${Date.now()}`).on("postgres_changes", {
                    event: s,
                    schema: "public",
                    table: e,
                    ...r?.id ? {
                        filter: `id=eq.${r.id}`
                    } : {}
                }, (a)=>o(a.new, a.old, a)).subscribe();
                return ()=>t.removeChannel(i);
            },
            upload: ({ bucket: e, path: r, file: n, options: o })=>t.storage.from(e).upload(r, n, o),
            download: ({ bucket: e, path: r })=>t.storage.from(e).download(r),
            getPublicUrl: ({ bucket: e, path: r })=>t.storage.from(e).getPublicUrl(r)
        });
});
var gl = {};
Mt(gl, {
    restAdapter: ()=>ml,
    setup: ()=>Oh
});
var kh, pe, Oh, ml, yl = G(()=>{
    "use strict";
    kh = (t, e, r)=>{
        let n = e && !e.startsWith("/") ? "/" : "", o = new URL(`${t}${n}${e}`);
        if (r) for(let s in r){
            let i = r[s];
            i != null && o.searchParams.set(s, typeof i == "object" ? JSON.stringify(i) : i);
        }
        return o.toString();
    }, pe = async (t, e)=>{
        let r = await globalThis.fetch(t, e), n = r.headers.get("content-type"), o = n && n.includes("json") ? await r.json() : await r.text();
        return {
            data: o,
            error: r.ok ? null : o?.message || o?.error || r.statusText,
            status: r.status
        };
    }, Oh = async ({ url: t, headers: e, auth: r, fetchOptions: n })=>{
        if (!t) throw new Error("@symbo.ls/fetch rest: url is required");
        return ml(t, e, r, n);
    }, ml = (t, e = {}, r, n = {})=>{
        let o = r?.token || null, s = (l)=>{
            let u = {
                ...e,
                ...l
            };
            return o && (u.Authorization = `Bearer ${o}`), u;
        }, i = (l)=>({
                ...s(l),
                "Content-Type": "application/json"
            }), a = (l)=>({
                ...n,
                ...l
            }), c = (l, u)=>{
            let p = u || t;
            if (l && (l.startsWith("http://") || l.startsWith("https://"))) return l;
            let d = l && !l.startsWith("/") ? "/" : "";
            return `${p}${d}${l || ""}`;
        };
        return {
            name: "rest",
            setToken: (l)=>{
                o = l;
            },
            getSession: async ()=>{
                if (!r?.sessionUrl) return o ? {
                    token: o
                } : null;
                let l = await pe(c(r.sessionUrl, r.baseUrl), a({
                    headers: s()
                }));
                return l.error ? null : l.data;
            },
            signIn: async (l)=>{
                if (!r?.signInUrl) throw new Error("rest: auth.signInUrl not configured");
                let u = await pe(c(r.signInUrl, r.baseUrl), a({
                    method: "POST",
                    headers: i(),
                    body: JSON.stringify(l)
                }));
                return u.data?.token && (o = u.data.token), u;
            },
            signOut: async ()=>(r?.signOutUrl && await pe(c(r.signOutUrl, r.baseUrl), a({
                    method: "POST",
                    headers: s()
                })), o = null, {
                    error: null
                }),
            select: ({ from: l, params: u, select: p, limit: d, offset: h, order: m, single: S, headers: _, baseUrl: w })=>{
                let E = {
                    ...u
                };
                return p && (E.select = p), d && (E.limit = d), h && (E.offset = h), S && (E.single = !0), m && (typeof m == "string" ? E.order = m : Array.isArray(m) ? E.order = m.map((R)=>`${R.by}:${R.asc === !1 ? "desc" : "asc"}`).join(",") : m.by && (E.order = `${m.by}:${m.asc === !1 ? "desc" : "asc"}`)), pe(kh(w || t, l || "", E), a({
                    headers: s(_)
                }));
            },
            rpc: ({ from: l, params: u, headers: p, baseUrl: d })=>pe(c(`rpc/${l}`, d), a({
                    method: "POST",
                    headers: i(p),
                    body: JSON.stringify(u)
                })),
            insert: ({ from: l, data: u, headers: p, baseUrl: d })=>pe(c(l, d), a({
                    method: "POST",
                    headers: i(p),
                    body: JSON.stringify(u)
                })),
            update: ({ from: l, data: u, params: p, method: d, headers: h, baseUrl: m })=>{
                let S = p?.id || u?.id, _ = S ? `${l}/${S}` : l;
                return pe(c(_, m), a({
                    method: d || "PATCH",
                    headers: i(h),
                    body: JSON.stringify(u)
                }));
            },
            delete: ({ from: l, params: u, headers: p, baseUrl: d })=>{
                let h = u?.id, m = h ? `${l}/${h}` : l;
                return pe(c(m, d), a({
                    method: "DELETE",
                    headers: s(p)
                }));
            }
        };
    };
});
var Sl = {};
Mt(Sl, {
    localAdapter: ()=>bl,
    setup: ()=>Th
});
var oi, Ah, Th, bl, xl = G(()=>{
    "use strict";
    oi = (t, e)=>{
        if (!e) return !0;
        for(let r in e){
            let n = e[r];
            if (n === null) {
                if (t[r] !== null && t[r] !== void 0) return !1;
            } else if (Array.isArray(n)) {
                if (!n.includes(t[r])) return !1;
            } else if (typeof n == "object") {
                for(let o in n)if (o === "gt" && !(t[r] > n[o]) || o === "gte" && !(t[r] >= n[o]) || o === "lt" && !(t[r] < n[o]) || o === "lte" && !(t[r] <= n[o]) || o === "neq" && t[r] === n[o] || o === "like" && !String(t[r]).includes(n[o])) return !1;
            } else if (t[r] !== n) return !1;
        }
        return !0;
    }, Ah = (t, { order: e, limit: r, offset: n, single: o })=>{
        let s = [
            ...t
        ];
        if (e) {
            let i = typeof e == "string" ? e : e.by, a = e.asc !== !1;
            s.sort((c, f)=>c[i] < f[i] ? a ? -1 : 1 : c[i] > f[i] ? a ? 1 : -1 : 0);
        }
        return n && (s = s.slice(n)), r && (s = s.slice(0, r)), o ? {
            data: s[0] || null,
            error: null
        } : {
            data: s,
            error: null
        };
    }, Th = async ({ data: t, ...e })=>bl(t, e), bl = (t = {}, e = {})=>{
        let r = {}, n = {}, o = e.persist !== !1 && typeof localStorage < "u", s = e.prefix || "smbls_db_", i = (l)=>{
            if (!r[l]) {
                if (o) try {
                    let u = localStorage.getItem(s + l);
                    r[l] = u ? JSON.parse(u) : t[l] || [];
                } catch  {
                    r[l] = t[l] || [];
                }
                else r[l] = t[l] || [];
            }
            return r[l];
        }, a = (l)=>{
            if (o) try {
                localStorage.setItem(s + l, JSON.stringify(r[l]));
            } catch  {}
        }, c = (l, u, p, d)=>{
            let h = n[l];
            if (h) for (let m of h)m(p, d, {
                event: u,
                table: l
            });
        }, f = Date.now();
        return {
            name: "local",
            store: r,
            select: async ({ from: l, params: u, ...p })=>{
                let h = i(l).filter((m)=>oi(m, u));
                return Ah(h, p);
            },
            insert: async ({ from: l, data: u })=>{
                let p = i(l), h = (Array.isArray(u) ? u : [
                    u
                ]).map((m)=>{
                    let S = {
                        id: m.id || ++f,
                        ...m
                    };
                    return p.push(S), S;
                });
                a(l);
                for (let m of h)c(l, "INSERT", m, null);
                return {
                    data: Array.isArray(u) ? h : h[0],
                    error: null
                };
            },
            update: async ({ from: l, data: u, params: p })=>{
                let d = i(l), h = [];
                for(let m = 0; m < d.length; m++)if (oi(d[m], p)) {
                    let S = {
                        ...d[m]
                    };
                    Object.assign(d[m], u), h.push(d[m]), c(l, "UPDATE", d[m], S);
                }
                return a(l), {
                    data: h,
                    error: null
                };
            },
            delete: async ({ from: l, params: u })=>{
                let p = i(l), d = [];
                for(let h = p.length - 1; h >= 0; h--)oi(p[h], u) && (d.push(p[h]), p.splice(h, 1), c(l, "DELETE", null, d[d.length - 1]));
                return a(l), {
                    data: d,
                    error: null
                };
            },
            subscribe: ({ from: l, on: u }, p)=>{
                n[l] || (n[l] = []);
                let d = (h, m, S)=>{
                    u && u !== "*" && u !== S.event || p(h, m, S);
                };
                return n[l].push(d), ()=>{
                    let h = n[l].indexOf(d);
                    h > -1 && n[l].splice(h, 1);
                };
            }
        };
    };
});
var Yr = {};
Mt(Yr, {
    createAdapter: ()=>Ph,
    default: ()=>jh,
    executeFetch: ()=>Kr,
    fetchPlugin: ()=>fi,
    initAdapterAuth: ()=>Xn,
    parseDuration: ()=>zr,
    queryClient: ()=>Vh,
    registerAdapter: ()=>Ih,
    resolveDb: ()=>Cl
});
var Rh, El, Ih, Ph, Cl, zr, xt, kl, Kn, Nh, Gr, qr, Hr, si, ci, Yn, Dh, _l, ii, Ol, Al, nr, wl, Fh, vl, $h, Tl, Rl, Xn, li, Pt, Wr, Oe, qt, de, Lh, Mh, Bh, ai, Uh, Kr, Vh, fi, jh;

var Ae = G(()=>{
    "use strict";
    v();
    Rh = [
        "select",
        "rpc",
        "insert",
        "update",
        "delete",
        "subscribe"
    ], El = {
        supabase: ()=>Promise.resolve().then(function() {
                return Promise.resolve((parcelRequire("dNnfS")));
            }).then((res)=>(hl(), dl)),
        rest: ()=>Promise.resolve().then(()=>(yl(), gl)),
        local: ()=>Promise.resolve().then(()=>(xl(), Sl))
    }, Ih = (t, e)=>{
        El[t] = e;
    }, Ph = (t)=>{
        let e = {};
        for (let r of Rh)t[r] && (e[r] = t[r]);
        return e.name = t.name || "custom", e;
    }, Cl = async (t)=>{
        if (!t) return null;
        if (typeof t.select == "function") return t;
        let { adapter: e, ...r } = t, n = typeof e == "string" ? e : typeof t == "string" ? t : null;
        if (!n) return null;
        let o = El[n];
        if (!o) throw new Error(`Unknown db adapter: "${n}". Use registerAdapter() for adapters with optional deps.`);
        return (await o()).setup(r);
    }, zr = (t)=>{
        if (!t) return 0;
        if (typeof t == "number") return t;
        let e = t.match(/^(\d+)(ms|s|m|h)$/);
        if (!e) return 0;
        let r = parseInt(e[1]), n = e[2];
        return n === "ms" ? r : n === "s" ? r * 1e3 : n === "m" ? r * 6e4 : n === "h" ? r * 36e5 : 0;
    }, xt = new Map, kl = new Map, Kn = new Map, Nh = (t)=>{
        if (t.cache?.key) return t.cache.key;
        let e = $h(t.params);
        return `${t.from}:${t.method}:${JSON.stringify(e || "")}`;
    }, Gr = (t)=>xt.get(t) || null, qr = (t, e, r)=>{
        let n = xt.get(t), o = {
            data: e,
            error: r,
            time: Date.now(),
            stale: !1
        };
        xt.set(t, o);
        let s = kl.get(t);
        if (s) for (let i of s)y(i) && i(o);
        return o;
    }, Hr = (t)=>{
        if (t) {
            let e = xt.get(t);
            e && (e.stale = !0);
            return;
        }
        for (let [, e] of xt)e.stale = !0;
    }, si = (t)=>{
        if (t) {
            xt.delete(t);
            return;
        }
        xt.clear();
    }, ci = (t)=>!t && t !== !1 ? {
            staleTime: 6e4,
            gcTime: 3e5
        } : t === !1 ? null : t === !0 ? {
            staleTime: 6e4,
            gcTime: 3e5
        } : typeof t == "number" ? {
            staleTime: t,
            gcTime: Math.max(t * 5, 3e5)
        } : b(t) ? {
            staleTime: zr(t),
            gcTime: 3e5
        } : {
            staleTime: zr(t.stale || t.staleTime) || 6e4,
            gcTime: zr(t.gc || t.gcTime || t.expire) || 3e5,
            key: t.key
        }, Yn = null, Dh = ()=>{
        Yn || (Yn = setInterval(()=>{
            let t = Date.now();
            for (let [e, r] of xt){
                let n = kl.get(e);
                !(n && n.size > 0) && t - r.time > (r.gcTime || 3e5) && xt.delete(e);
            }
        }, 3e4), Yn.unref && Yn.unref());
    };
    Dh();
    _l = 3, ii = (t)=>Math.min(1e3 * 2 ** t, 3e4), Ol = (t)=>{
        let e = t.retry;
        return e === !1 ? {
            count: 0
        } : e === !0 || e === void 0 ? {
            count: _l,
            delay: ii
        } : typeof e == "number" ? {
            count: e,
            delay: ii
        } : {
            count: e.count ?? _l,
            delay: y(e.delay) ? e.delay : typeof e.delay == "number" ? ()=>e.delay : ii
        };
    }, Al = async (t, e)=>{
        let { count: r, delay: n } = e, o;
        for(let s = 0; s <= r; s++)try {
            let i = await t();
            if (i?.error) {
                if (o = i.error, s < r) {
                    let a = y(n) ? n(s, o) : n;
                    await new Promise((c)=>setTimeout(c, a));
                    continue;
                }
                return i;
            }
            return i;
        } catch (i) {
            if (o = i, s < r) {
                let a = y(n) ? n(s, i) : n;
                await new Promise((c)=>setTimeout(c, a));
                continue;
            }
            throw i;
        }
        return {
            data: null,
            error: o
        };
    }, nr = {
        focus: new Set,
        online: new Set
    }, wl = !1, Fh = ()=>{
        if (wl || typeof window > "u") return;
        wl = !0;
        let t = ()=>{
            for (let r of nr.focus)r();
        }, e = ()=>{
            for (let r of nr.online)r();
        };
        window.addEventListener("visibilitychange", ()=>{
            document.visibilityState === "visible" && t();
        }), window.addEventListener("focus", t), window.addEventListener("online", e);
    }, vl = (t, e)=>{
        let r = e.__ref;
        if (t === !0) return {
            from: r.__state || e.key,
            method: "select",
            query: !0,
            on: "create"
        };
        if (b(t)) return {
            from: t,
            method: "select",
            query: !0,
            on: "create"
        };
        if (g(t)) {
            let n = {
                ...t
            };
            return n.from = n.from || r.__state || e.key, n.method = n.method || "select", n.on = n.on || "create", n.query === void 0 && (n.query = !0), n;
        }
        return null;
    }, $h = (t)=>(!t || y(t), t), Tl = (t, e)=>{
        let r = t?.state?.root || e?.state?.root;
        if (r?.lang) return r.lang;
    }, Rl = (t, e, r)=>{
        let n;
        if (!t) n = void 0;
        else if (y(t)) n = t(e, e.state);
        else {
            n = {};
            for(let o in t){
                let s = t[o];
                n[o] = y(s) ? s(e, e.state) : s;
            }
        }
        return n;
    }, Xn = async (t, e)=>{
        if (!t || t.__authInitialized || (t.__authInitialized = !0, !t.getSession)) return;
        let r = (n, o)=>{
            let s = e.state?.root;
            s?.update && s.update({
                auth: {
                    user: n,
                    session: o,
                    loading: !1
                }
            });
        };
        try {
            let n = await t.getSession();
            r(n?.user || null, n);
        } catch  {}
        t.onAuthStateChange && t.onAuthStateChange((n, o)=>{
            r(o?.user || null, o);
        });
    }, li = async (t, e)=>{
        if (y(t.select)) return t.auth !== !1 && await Xn(t, e), t;
        if (t.__resolved) return t.auth !== !1 && await Xn(t.__resolved, e), t.__resolved;
        if (t.__resolving) return t.__resolving;
        t.__resolving = Cl(t);
        let r = await t.__resolving;
        return delete t.__resolving, r ? (t.__resolved = r, e.fetch = r, t.auth !== !1 && await Xn(r, e), r) : null;
    }, Pt = (t, e, ...r)=>{
        let n = y(t[e]) ? t[e] : t.props && y(t.props[e]) ? t.props[e] : null;
        n && n.call(t, ...r, t, t.state, t.context);
    }, Wr = (t)=>{
        let e = {}, r = t.node;
        if (!r) return e;
        if (r.tagName === "FORM") {
            let o = new FormData(r);
            for (let [s, i] of o.entries())e[s] = i;
            return e;
        }
        let n = r.querySelectorAll("input, textarea, select");
        for(let o = 0; o < n.length; o++){
            let s = n[o], i = s.name || s.getAttribute("name");
            i && (s.type === "checkbox" ? e[i] = s.checked : s.type === "file" ? e[i] = s.files : e[i] = s.value);
        }
        return e;
    }, Oe = (t, e, r, n = {})=>{
        let o = r ? {
            [r]: e
        } : e;
        t.state?.update && t.state.update(o, {
            preventFetch: !0,
            ...n
        });
    }, qt = (t, e)=>{
        let r = t.__ref;
        r.__fetchStatus = e, r.__fetching = e.isFetching, r.__fetchError = e.error;
    }, de = async (t, e, r, n = {})=>{
        let o = r?.fetch;
        if (!o || t.enabled === !1 || y(t.enabled) && !t.enabled(e, e.state)) return;
        let s = await li(o, r);
        if (!s) return;
        let i = e.__ref, { from: a, method: c, query: f, params: l, cache: u, transform: p, single: d, auth: h, fields: m, as: S, limit: _, offset: w, order: E, headers: R, baseUrl: T, page: A, cursor: k, getNextPageParam: $, getPreviousPageParam: P, infinite: F, placeholderData: j, initialData: Z, select: tt, keepPreviousData: pt } = t, _t;
        if (f && y(e.getQuery)) {
            let Q = e.getQuery(s.name || "paths");
            Q && (_t = Q.select || Q.length && Q.join(",") || void 0);
        }
        let Lt = Rl(l, e, r), Pr = ci(u), Yo = Ol(t), st = Pr ? u?.key || `${a}:${c}:${JSON.stringify(Lt || "")}${F ? ":infinite" : ""}${A ? ":p" + JSON.stringify(A) : ""}` : null;
        if (!i.__fetchInitialized && st && (i.__fetchInitialized = !0, Z !== void 0)) {
            let Q = y(Z) ? Z() : Z;
            qr(st, Q, null);
        }
        if ((c === "select" || c === "rpc") && st && Pr) {
            let Q = Gr(st);
            if (Q && !Q.error) {
                let H = Date.now() - Q.time, ft = Q.stale || H > (Pr.staleTime || 0), B = Q.data;
                if (tt && (B = tt(B, e, e.state)), p && (B = p(B, e, e.state)), Oe(e, B, S), !ft) {
                    qt(e, {
                        isFetching: !1,
                        isLoading: !1,
                        isStale: !1,
                        isSuccess: !0,
                        error: null,
                        status: "success",
                        fetchStatus: "idle"
                    });
                    return;
                }
            } else if (j !== void 0) {
                let H = y(j) ? j(e, e.state) : j;
                H !== void 0 && Oe(e, H, S);
            }
        }
        if (st && Kn.has(st) && !n.force) {
            let Q = Kn.get(st);
            try {
                let H = await Q;
                if (H?.data !== void 0) {
                    let ft = H.data;
                    tt && (ft = tt(ft, e, e.state)), p && (ft = p(ft, e, e.state)), Oe(e, ft, S), Pt(e, "onFetchComplete", ft);
                }
            } catch  {}
            return;
        }
        let Xo = !Gr(st)?.data;
        qt(e, {
            isFetching: !0,
            isLoading: Xo,
            isStale: !1,
            isSuccess: !1,
            error: null,
            status: "pending",
            fetchStatus: "fetching"
        }), Pt(e, "onFetchStart");
        let Ec = Al(async ()=>{
            if (h !== !1 && s.getSession) {
                let B = await s.getSession();
                if (h === !0 && !B) {
                    let wt = {
                        message: "Not authenticated"
                    };
                    return qt(e, {
                        isFetching: !1,
                        isLoading: !1,
                        isStale: !1,
                        isSuccess: !1,
                        error: wt,
                        status: "error",
                        fetchStatus: "idle"
                    }), Pt(e, "onFetchError", wt), {
                        data: null,
                        error: wt
                    };
                }
            }
            let Q = s[c];
            if (!y(Q)) return {
                data: null,
                error: {
                    message: `Method "${c}" not found on adapter`
                }
            };
            let H = {
                from: a,
                select: _t,
                params: Lt,
                single: d,
                limit: _,
                offset: w,
                order: E,
                headers: R,
                baseUrl: T
            }, ft = Tl(e, r);
            if (ft && (H.headers = {
                ...H.headers,
                "Accept-Language": ft
            }), A !== void 0) {
                if (g(A)) A.offset !== void 0 && (H.offset = A.offset), A.limit !== void 0 && (H.limit = A.limit), A.cursor !== void 0 && (H.params = {
                    ...H.params,
                    cursor: A.cursor
                });
                else if (typeof A == "number") {
                    let B = t.pageSize || _ || 20;
                    H.offset = (A - 1) * B, H.limit = B;
                }
            }
            if (k !== void 0 && (H.params = {
                ...H.params,
                cursor: k
            }), c === "insert" || c === "update" || c === "upsert") {
                let B;
                if (m === !0 || t.on === "submit") B = Wr(e);
                else if (x(m)) {
                    let wt = Wr(e);
                    B = {};
                    for (let Jo of m)B[Jo] = wt[Jo];
                } else e.state?.parse ? B = e.state.parse() : g(e.state) && (B = {
                    ...e.state
                });
                p && (B = p(B, e, e.state)), H.data = B;
            }
            if (c === "rpc") {
                let B = Lt;
                if (t.on === "submit") {
                    let wt = Wr(e);
                    B = t.transformParams ? t.transformParams(wt, e, e.state) : wt;
                }
                H.params = B;
            }
            if (c === "subscribe") {
                let B = s.subscribe({
                    from: a,
                    params: Lt,
                    on: t.subscribeOn
                }, (wt, Jo, t_)=>{
                    Oe(e, wt, S), Pt(e, "onFetchComplete", wt);
                });
                return i.__unsubscribe = B, {
                    data: null,
                    error: null,
                    subscribed: !0
                };
            }
            return Q(H);
        }, Yo);
        st && Kn.set(st, Ec);
        try {
            let Q = await Ec;
            if (Q?.subscribed) return;
            let { data: H, error: ft } = Q || {};
            if (ft) {
                st && qr(st, null, ft), qt(e, {
                    isFetching: !1,
                    isLoading: !1,
                    isStale: !1,
                    isSuccess: !1,
                    error: ft,
                    status: "error",
                    fetchStatus: "idle"
                }), Pt(e, "onFetchError", ft);
                return;
            }
            if (H !== void 0) {
                if ((c === "select" || c === "rpc") && st) {
                    let wt = qr(st, H, null);
                    wt.gcTime = Pr?.gcTime || 3e5;
                }
                let B = H;
                F && x(H) && (i.__pages || (i.__pages = []), n.direction === "previous" ? i.__pages.unshift(H) : i.__pages.push(H), B = i.__pages.flat(), $ && (i.__nextPageParam = $(H, i.__pages), i.__hasNextPage = i.__nextPageParam != null), P && (i.__prevPageParam = P(H, i.__pages), i.__hasPreviousPage = i.__prevPageParam != null)), tt && (B = tt(B, e, e.state)), p && (B = p(B, e, e.state)), (!pt || B !== void 0) && Oe(e, B, S), qt(e, {
                    isFetching: !1,
                    isLoading: !1,
                    isStale: !1,
                    isSuccess: !0,
                    error: null,
                    status: "success",
                    fetchStatus: "idle"
                }), Pt(e, "onFetchComplete", B);
            }
        } catch (Q) {
            qt(e, {
                isFetching: !1,
                isLoading: !1,
                isStale: !1,
                isSuccess: !1,
                error: Q,
                status: "error",
                fetchStatus: "idle"
            }), Pt(e, "onFetchError", Q);
        } finally{
            st && Kn.delete(st);
        }
    }, Lh = (t, e, r)=>{
        let n = t.on, o = e.__ref;
        o.__fetchListeners || (o.__fetchListeners = []);
        let s = t.__runner || de;
        if (n === "submit") {
            let i = (c)=>{
                c.preventDefault(), s(t, e, r);
            }, a = e.node;
            a && (a.addEventListener("submit", i), o.__fetchListeners.push(()=>a.removeEventListener("submit", i)));
        } else if (n === "click") {
            let i = ()=>s(t, e, r), a = e.node;
            a && (a.addEventListener("click", i), o.__fetchListeners.push(()=>a.removeEventListener("click", i)));
        } else n === "stateChange" && (o.__fetchOnStateChange = ()=>s(t, e, r));
    }, Mh = (t, e, r)=>{
        let n = e.__ref;
        n.__fetchCleanups || (n.__fetchCleanups = []), Fh();
        let o = t.refetchInterval;
        if (o) {
            let s = typeof o == "number" ? o : zr(o);
            if (s > 0) {
                let i = setInterval(()=>{
                    (t.refetchIntervalInBackground || typeof document > "u" || document.visibilityState === "visible") && de(t, e, r, {
                        force: !0
                    });
                }, s);
                n.__fetchCleanups.push(()=>clearInterval(i));
            }
        }
        if (t.refetchOnWindowFocus !== !1) {
            let s = ()=>{
                let i = Nh(t), a = Gr(i), c = ci(t.cache);
                (!a || a.stale || Date.now() - a.time > (c?.staleTime || 0)) && de(t, e, r, {
                    force: !0
                });
            };
            nr.focus.add(s), n.__fetchCleanups.push(()=>nr.focus.delete(s));
        }
        if (t.refetchOnReconnect !== !1) {
            let s = ()=>de(t, e, r, {
                    force: !0
                });
            nr.online.add(s), n.__fetchCleanups.push(()=>nr.online.delete(s));
        }
    }, Bh = (t, e, r)=>{
        if (!e.optimistic) return null;
        let n = t.__ref, o = e.as, s = t.state?.parse ? t.state.parse() : g(t.state) ? {
            ...t.state
        } : t.state;
        n.__optimisticSnapshot = s;
        let i = y(e.optimistic) ? e.optimistic(r, s, t) : e.optimistic;
        return i !== void 0 && Oe(t, i, o), s;
    }, ai = (t, e)=>{
        let r = t.__ref, n = r.__optimisticSnapshot;
        n !== void 0 && (Oe(t, n, e.as), delete r.__optimisticSnapshot);
    }, Uh = async (t, e, r)=>{
        let n = r?.fetch;
        if (!n) return;
        let o = await li(n, r);
        if (!o) return;
        let s = e.__ref, { method: i, from: a, fields: c, transform: f, as: l, on: u, auth: p, headers: d, baseUrl: h, invalidates: m, optimistic: S, onMutate: _, onSuccess: w, onError: E, onSettled: R } = t, T;
        if (c === !0 || u === "submit") T = Wr(e);
        else if (x(c)) {
            let k = Wr(e);
            T = {};
            for (let $ of c)T[$] = k[$];
        } else e.state?.parse ? T = e.state.parse() : g(e.state) && (T = {
            ...e.state
        });
        f && (T = f(T, e, e.state)), y(_) && _(T, e, e.state);
        let A = S ? Bh(e, t, T) : null;
        s.__fetching = !0, qt(e, {
            isFetching: !0,
            isLoading: !1,
            isStale: !1,
            isSuccess: !1,
            error: null,
            status: "pending",
            fetchStatus: "fetching"
        }), Pt(e, "onFetchStart");
        try {
            if (p !== !1 && o.getSession) {
                let pt = await o.getSession();
                if (p === !0 && !pt) {
                    A !== void 0 && ai(e, t), Pt(e, "onFetchError", {
                        message: "Not authenticated"
                    });
                    return;
                }
            }
            let k = o[i];
            if (!y(k)) return;
            let $ = {
                from: a,
                data: T,
                headers: d,
                baseUrl: h
            };
            t.params && ($.params = Rl(t.params, e, r));
            let P = Tl(e, r);
            P && ($.headers = {
                ...$.headers,
                "Accept-Language": P
            });
            let F = Ol(t), j = await Al(()=>k($), F), { data: Z, error: tt } = j || {};
            if (tt) {
                A !== void 0 && ai(e, t), qt(e, {
                    isFetching: !1,
                    isLoading: !1,
                    isStale: !1,
                    isSuccess: !1,
                    error: tt,
                    status: "error",
                    fetchStatus: "idle"
                }), Pt(e, "onFetchError", tt), y(E) && E(tt, T, e), y(R) && R(null, tt, T, e);
                return;
            }
            if (delete s.__optimisticSnapshot, Z !== void 0) {
                let pt = l ? {
                    [l]: Z
                } : Z;
                e.state?.update && e.state.update(pt, {
                    preventFetch: !0
                });
            }
            if (qt(e, {
                isFetching: !1,
                isLoading: !1,
                isStale: !1,
                isSuccess: !0,
                error: null,
                status: "success",
                fetchStatus: "idle"
            }), Pt(e, "onFetchComplete", Z), y(w) && w(Z, T, e), y(R) && R(Z, null, T, e), m) {
                let pt = x(m) ? m : [
                    m
                ];
                for (let _t of pt)if (_t === !0 || _t === "*") for (let [Lt] of xt)Lt.startsWith(a + ":") && Hr(Lt);
                else Hr(_t);
            }
        } catch (k) {
            A !== void 0 && ai(e, t), qt(e, {
                isFetching: !1,
                isLoading: !1,
                isStale: !1,
                isSuccess: !1,
                error: k,
                status: "error",
                fetchStatus: "idle"
            }), Pt(e, "onFetchError", k), y(E) && E(k, T, e), y(R) && R(null, k, T, e);
        } finally{
            s.__fetching = !1;
        }
    }, Kr = (t, e, r, n)=>{
        if (!t || !n?.fetch) return;
        let s = O(t, e);
        if (!s) return;
        let i = x(s) ? s.map((c)=>vl(O(c, e), e)).filter(Boolean) : [
            vl(s, e)
        ].filter(Boolean);
        for (let c of i){
            let f = c.method === "insert" || c.method === "update" || c.method === "upsert" || c.method === "delete", l = f ? Uh : de;
            c.on === "create" ? l(c, e, n) : Promise.resolve().then(()=>{
                Lh({
                    ...c,
                    __runner: l
                }, e, n);
            }), !f && c.on === "create" && (c.refetchInterval || c.refetchOnWindowFocus !== !1 || c.refetchOnReconnect !== !1) && Mh(c, e, n);
        }
        let a = e.__ref;
        a.refetch = (c)=>{
            for (let f of i)de(f, e, n, {
                force: !0,
                ...c
            });
        }, a.fetchNextPage = ()=>{
            let c = i[0];
            if (!c || !c.infinite) return;
            let f = a.__nextPageParam;
            if (f == null) return;
            let l = {
                ...c,
                cursor: f
            };
            de(l, e, n, {
                direction: "next",
                force: !0
            });
        }, a.fetchPreviousPage = ()=>{
            let c = i[0];
            if (!c || !c.infinite) return;
            let f = a.__prevPageParam;
            if (f == null) return;
            let l = {
                ...c,
                cursor: f
            };
            de(l, e, n, {
                direction: "previous",
                force: !0
            });
        };
    }, Vh = {
        invalidateQueries: (t)=>{
            if (!t) {
                Hr();
                return;
            }
            if (b(t)) for (let [e] of xt)(e.startsWith(t) || e.includes(t)) && Hr(e);
            else if (x(t)) {
                let e = t.join(":");
                for (let [r] of xt)r.includes(e) && Hr(r);
            }
        },
        removeQueries: (t)=>{
            if (!t) {
                si();
                return;
            }
            if (b(t)) for (let [e] of xt)(e.startsWith(t) || e.includes(t)) && si(e);
        },
        getQueryData: (t)=>Gr(t)?.data ?? void 0,
        setQueryData: (t, e)=>{
            let r = Gr(t), n = y(e) ? e(r?.data) : e;
            qr(t, n, null);
        },
        prefetchQuery: async (t, e)=>{
            let r = e?.fetch;
            if (!r) return;
            let n = await li(r, e);
            if (!n) return;
            let o = t.cache?.key || `${t.from}:${t.method || "select"}:${JSON.stringify(t.params || "")}`, s = n[t.method || "select"];
            if (!y(s)) return;
            let i = await s({
                from: t.from,
                params: t.params,
                limit: t.limit,
                offset: t.offset,
                order: t.order,
                single: t.single
            });
            if (i?.data !== void 0 && !i?.error) {
                let a = qr(o, i.data, null);
                a.gcTime = ci(t.cache)?.gcTime || 3e5;
            }
            return i;
        },
        getCache: ()=>xt,
        clear: ()=>si()
    }, fi = {
        name: "fetch",
        create (t) {
            let e = t.fetch || t.props?.fetch;
            e && Kr(e, t, t.state, t.context);
        }
    }, jh = Kr;
});
function pi(t) {
    let e = this, { __ref: r } = e, n = [].concat(t), o = r.root[n[0]];
    if (!n || !n.length) return console.log(n, "on", e.key, "is undefined");
    for(; o.key === n[0] && (n.shift(), !!n.length);)if (o = o[n[0]], !o) return;
    return o;
}
function di(t) {
    let e = this, { parent: r } = e;
    if (y(t)) return r.state && t(r, r.state, r.context) ? r : r.parent ? r.lookup(t) : void 0;
    if (e[t]) return e[t];
    for(; r.param !== t;){
        if (r[t]) return r[t];
        if (r = r.parent, !r) return;
    }
    return r;
}
function hi(t) {
    let e = this, { __ref: r } = e, n = r?.__children;
    if (n) for(let o = 0; o < n.length; o++){
        let s = n[o], i = e[s];
        if (s === t) return i;
        if (y(t)) {
            let c = t(i, i.state, i.context);
            if (i.state && c) return i;
        }
        let a = i?.lookdown?.(t);
        if (a) return a;
    }
}
function mi(t, e = []) {
    let r = this, { __ref: n } = r, o = n?.__children;
    if (o) {
        for(let s = 0; s < o.length; s++){
            let i = o[s], a = r[i];
            if (i === t) e.push(a);
            else if (y(t)) {
                let c = t(a, a.state, a.context);
                a.state && c && e.push(a);
            }
            a?.lookdownAll?.(t, e);
        }
        return e.length ? e : void 0;
    }
}
function Qn(t = {}) {
    let e = this;
    if (e.node?.style) {
        for(let r in t){
            let n = t[r], o = e[r];
            g(n) && o ? Qn.call(o, n) : e.node.style[r] = n;
        }
        return e;
    }
}
function gi(t) {
    let e = this;
    if (W("beforeRemove", e, t) === !1) return e;
    y(e.node.remove) ? e.node.remove() : Ke() || (console.warn("This item cant be removed"), e.log()), delete e.parent[e.key], e.parent.__ref && (e.parent.__ref.__children = ns(e.parent.__ref.__children, e.key)), W("remove", e, t);
}
function zh(t) {
    return this[t];
}
function yi(t, e) {
    let r = this;
    if (!(!t || !r.props)) return r.update({
        props: t
    }, e), r;
}
function bi(t) {
    return t ? this.__ref && this.__ref[t] : this.__ref;
}
function qh() {
    return this.getRef("__children").map((e)=>this[e]);
}
function Si() {
    return this.getRef().path;
}
function xi(t) {
    let e = null, r = (n)=>n.__element && n.root?.isRootState;
    if (!this) e = window.platformState || window.smblsApp?.state;
    else if (r(this)) e = this.root;
    else if (this.__ref && this.__ref.path) {
        let n = this.state && r(this.state), o = y(this.state) && this.parent.state && r(this.parent.state);
        (n || o) && (e = this.state.root || this.parent.state.root);
    }
    return e || (e = window.platformState || window.smblsApp?.state), t ? e?.[t] : e;
}
function _i(t) {
    let e = this.getRootState()?.__element;
    return e && Object.keys(e).length > 0 && t ? e[t] : e;
}
function wi(t) {
    return this.getRoot("data") && Object.keys(this.getRoot("data")).length > 0 && t ? this.getRoot("data")[t] : this.getRoot("data");
}
function vi(t) {
    let e = this.getRoot()?.context;
    return t ? e[t] : e;
}
function Ei(t) {
    let e = this.context;
    return t ? e[t] : e;
}
function Jn() {
    let t = this, e = [];
    for(let r in t)!Object.prototype.hasOwnProperty.call(t, r) || He.has(r) && !is.has(r) || e.push(r);
    return e;
}
function Zn(t = []) {
    let e = this, r = {}, n = Jn.call(e), o = n.includes("children"), s = t.length ? new Set(t) : null;
    for(let i = 0; i < n.length; i++){
        let a = n[i];
        if (s && s.has(a) || !Object.prototype.hasOwnProperty.call(e, a) || o && a === "content") continue;
        let c = e[a];
        if (a === "state") {
            if (e.__ref && !e.__ref.__hasRootState) continue;
            let f = y(c && c.parse) ? c.parse() : c;
            r[a] = y(f) ? f : JSON.parse(JSON.stringify(f || {}));
        } else if (a === "scope") {
            if (e.__ref && !e.__ref.__hasRootScope) continue;
            r[a] = JSON.parse(JSON.stringify(c || {}));
        } else if (a === "props") {
            let { __element: f, update: l, ...u } = e[a];
            r[a] = u;
        } else Ot(c) && Object.prototype.hasOwnProperty.call(e, a) && (r[a] = c);
    }
    return r;
}
function Xr(t = [], e = new WeakSet) {
    let r = this;
    if (e.has(r)) return;
    e.add(r);
    let n = Zn.call(r, t), o = t.length ? new Set(t) : null;
    for(let s in n){
        if (o && o.has(s) || !Object.prototype.hasOwnProperty.call(r, s)) continue;
        let i = n[s];
        Array.isArray(i) ? n[s] = i.map((a)=>N(a) ? Xr.call(a, t, e) : a) : N(i) && (n[s] = Xr.call(i, t, e));
    }
    return n;
}
function to(...t) {
    if (he !== "test" && he !== "development") return;
    let e = this, { __ref: r } = e;
    return console.groupCollapsed(e.key), t.length ? t.forEach((n)=>console.log(`%c${n}:
`, "font-weight: bold", e[n])) : (console.log(r.path), e.keys().forEach((o)=>console.log(`%c${o}:`, "font-weight: bold", e[o]))), console.log(e), console.groupEnd(e.key), e;
}
function Ci(...t) {
    (he === "test" || he === "development") && console.log(...t);
}
function ki(...t) {
    (he === "test" || he === "development") && console.warn(...t);
}
function Qr(...t) {
    if (he === "test" || he === "development") {
        if (t[t.length - 1]?.debugger) debugger;
        throw t[t.length - 1]?.verbose && to.call(this), new Error(...t);
    }
}
function Oi() {
    let t = this, { key: e, parent: r } = t, { __children: n } = r.__ref, o = n.indexOf(e), s = n[o + 1];
    return r[s];
}
function Ai(t) {
    let e = t || this, { key: r, parent: n } = e, { __children: o } = n.__ref;
    if (!o) return;
    let s = o.indexOf(r);
    return n[o[s - 1]];
}
function Ti(t = {}) {
    let e = this;
    e.data || (e.data = {}), e.data.varCaches || (e.data.varCaches = {});
    let r = e.data.varCaches, n = {}, o;
    for(let s in t)t[s] !== r[s] && (o = !0, n[s] = t[s]);
    return {
        changed: (s)=>{
            if (!o) return;
            let i = s(n, z(r));
            for(let a in n)r[a] = n[a];
            return i;
        },
        timeout: (s, i)=>{
            if (!o) return;
            let a = setTimeout(()=>{
                s(n), clearTimeout(a);
            }, i);
        }
    };
}
function Ri(t, ...e) {
    let r = this.context, n = r.utils?.[t] || r.functions?.[t] || r.methods?.[t] || r.snippets?.[t];
    if (n) try {
        let o = n.call(this, ...e);
        return o && typeof o.then == "function" && o.catch((s)=>{
            Qr.call(this, s);
        }), o;
    } catch (o) {
        if (Qr.call(this, o), r?.strictMode) throw o;
    }
}
async function Ii() {
    let t = this, e = t.context?.fetch;
    if (!e) return null;
    if (typeof e.select == "function") {
        if (!e.__authInitialized && e.getSession) {
            let { initAdapterAuth: o } = await Promise.resolve().then(()=>(Ae(), Yr));
            await o(e, t.context);
        }
        return e;
    }
    if (e.__resolved) {
        if (!e.__resolved.__authInitialized && e.__resolved.getSession) {
            let { initAdapterAuth: o } = await Promise.resolve().then(()=>(Ae(), Yr));
            await o(e.__resolved, t.context);
        }
        return e.__resolved;
    }
    if (e.__resolving) return e.__resolving;
    let r = Promise.resolve().then(()=>(Ae(), Yr)).then(({ resolveDb: o })=>o(e));
    e.__resolving = r;
    let n = await r;
    if (e.__resolved = n, t.context.fetch = n, delete e.__resolving, n.getSession) {
        let { initAdapterAuth: o } = await Promise.resolve().then(()=>(Ae(), Yr));
        await o(n, t.context);
    }
    return n;
}
function Pi(t) {
    let e = this, r = t || ut.useStateQuery || e.context?.useStateQuery;
    if (!r) return null;
    let n = {};
    if (ui(e, n), r === !0) return n;
    let o = Zh[r];
    return o ? o(n) : n;
}
function Ht(t, e) {
    return !!(Fn.has(t) || e?.context?.methods?.[t]);
}
var he, Hh, ui, Wh, Il, Gh, Kh, Yh, Xh, Qh, Jh, Zh, Ni = G(()=>{
    ei();
    Ge();
    St();
    ae();
    ws();
    qe();
    ri();
    he = "production";
    Hh = (t, e, r, n)=>Object.defineProperty(t, e, {
            get: r,
            set: n
        });
    ui = (t, e)=>{
        let r = t.__ref;
        if (!r) return;
        let n = r.__state;
        n && typeof n == "string" && Wh(e, n);
        let o = r.__children;
        if (o) for(let a = 0; a < o.length; a++){
            let c = t[o[a]];
            c && c.__ref && ui(c, e);
        }
        let s = r.contentElementKey || "content", i = t[s];
        i && i.__ref && ui(i, e);
    }, Wh = (t, e)=>{
        let n = e.replaceAll("../", "").replaceAll("~/", "").split("/"), o = t;
        for(let s = 0; s < n.length; s++){
            let i = n[s];
            s === n.length - 1 ? o[i] || (o[i] = !0) : (o[i] === !0 && (o[i] = {}), o[i] || (o[i] = {}), o = o[i]);
        }
    }, Il = (t, e = 0)=>{
        let r = "  ".repeat(e), n = Object.entries(t);
        return n.length ? n.map(([s, i])=>i === !0 ? `${r}${s}` : `${r}${s} {
${Il(i, e + 1)}
${r}}`).join(`
`) : "";
    }, Gh = (t)=>`{
${Il(t, 1)}
}`, Kh = (t)=>{
        let e = {
            fields: {},
            include: []
        }, r = (n, o)=>{
            let s = [];
            for(let i in n)if (n[i] === !0) s.push(i);
            else {
                let a = o ? `${o}.${i}` : i;
                e.include.push(a), r(n[i], a);
            }
            s.length && (e.fields[o || "_root"] = s);
        };
        return r(t, ""), e;
    }, Yh = (t)=>{
        let e = (s)=>{
            let i = [], a = [];
            for(let c in s)if (s[c] === !0) i.push(c);
            else {
                let f = e(s[c]), l = [];
                f.select && l.push(`$select=${f.select}`), f.expand && l.push(`$expand=${f.expand}`), a.push(l.length ? `${c}(${l.join(";")})` : c);
            }
            return {
                select: i.length ? i.join(",") : "",
                expand: a.length ? a.join(",") : ""
            };
        }, { select: r, expand: n } = e(t), o = [];
        return r && o.push(`$select=${r}`), n && o.push(`$expand=${n}`), o.join("&");
    }, Xh = (t, e)=>{
        let r = [], n = [], o = new Set, s = (l, u, p)=>{
            o.add(u), p && n.push(`LEFT JOIN ${u} ON ${u}.${p}_id = ${p}.id`);
            for(let d in l)l[d] === !0 ? r.push(`${u}.${d}`) : s(l[d], d, u);
        }, i = Object.keys(t);
        i.length === 1 && t[i[0]] !== !0 ? s(t[i[0]], i[0], null) : s(t, "_root", null);
        let a = [
            ...o
        ][0] || "_root", c = r.length ? r.join(", ") : "*", f = n.length ? `
` + n.join(`
`) : "";
        return `SELECT ${c}
FROM ${a}${f}`;
    }, Qh = (t)=>{
        let e = [], r = (n, o)=>{
            for(let s in n){
                let i = o ? `${o}/${s}` : s;
                n[s] === !0 ? e.push(i) : r(n[s], i);
            }
        };
        return r(t, ""), e;
    }, Jh = (t)=>{
        let e = (n)=>{
            let o = [];
            for(let s in n)n[s] === !0 ? o.push(s) : o.push(`${s}(${e(n[s])})`);
            return o.join(", ");
        }, r = Object.keys(t);
        return r.length === 1 && t[r[0]] !== !0 ? {
            from: r[0],
            select: e(t[r[0]])
        } : {
            from: null,
            select: e(t)
        };
    }, Zh = {
        graphql: Gh,
        "json-api": Kh,
        odata: Yh,
        sql: Xh,
        supabase: Jh,
        paths: Qh
    };
});
var tm, Di, Pl = G(()=>{
    Ln();
    tm = {
        snapshotId: xs
    }, Di = (t, e)=>{
        let r = t.__ref, { currentSnapshot: n, calleeElement: o } = e;
        if (!o || o === t) {
            let a = tm.snapshotId();
            return r.__currentSnapshot = a, [
                a,
                t
            ];
        }
        let i = o.__ref.__currentSnapshot;
        return n < i ? [
            i,
            o,
            !0
        ] : [
            i,
            o
        ];
    };
});
var v = G(()=>{
    Ln();
    ws();
    St();
    ae();
    Bn();
    qe();
    Dr();
    Pc();
    Nc();
    Lr();
    Nr();
    Dc();
    vs();
    Ds();
    Ws();
    zn();
    cl();
    ll();
    Ge();
    fl();
    Ni();
    ri();
    Pl();
    ei();
});
v();
v();
var Kw = [
    "alert",
    "alertdialog",
    "application",
    "article",
    "banner",
    "button",
    "cell",
    "checkbox",
    "columnheader",
    "combobox",
    "complementary",
    "contentinfo",
    "definition",
    "dialog",
    "directory",
    "document",
    "feed",
    "figure",
    "form",
    "grid",
    "gridcell",
    "group",
    "heading",
    "img",
    "link",
    "list",
    "listbox",
    "listitem",
    "log",
    "main",
    "marquee",
    "math",
    "menu",
    "menubar",
    "menuitem",
    "menuitemcheckbox",
    "menuitemradio",
    "navigation",
    "none",
    "note",
    "option",
    "presentation",
    "progressbar",
    "radio",
    "radiogroup",
    "region",
    "row",
    "rowgroup",
    "rowheader",
    "scrollbar",
    "search",
    "searchbox",
    "separator",
    "slider",
    "spinbutton",
    "status",
    "switch",
    "tab",
    "table",
    "tablist",
    "tabpanel",
    "term",
    "textbox",
    "timer",
    "toolbar",
    "tooltip",
    "tree",
    "treegrid",
    "treeitem"
], Fi = {
    default: [
        "accesskey",
        "autofocus",
        "class",
        "contenteditable",
        "contextmenu",
        "dir",
        "draggable",
        "hidden",
        "id",
        "lang",
        "part",
        "placeholder",
        "slot",
        "spellcheck",
        "style",
        "tabindex",
        "title",
        "translate",
        "inert",
        "radiogroup",
        "role",
        "about",
        "datatype",
        "inlist",
        "prefix",
        "property",
        "resource",
        "typeof",
        "vocab",
        "autocapitalize",
        "autocorrect",
        "autosave",
        "color",
        "itemprop",
        "itemscope",
        "itemtype",
        "itemid",
        "itemref",
        "results",
        "security",
        "unselectable",
        "is"
    ],
    a: [
        "accesskey",
        "charset",
        "coords",
        "download",
        "href",
        "hreflang",
        "name",
        "rel",
        "rev",
        "shape",
        "target",
        "type"
    ],
    aria: [
        "aria-activedescendant",
        "aria-atomic",
        "aria-autocomplete",
        "aria-checked",
        "aria-colcount",
        "aria-colindex",
        "aria-colspan",
        "aria-controls",
        "aria-current",
        "aria-describedby",
        "aria-details",
        "aria-dropeffect",
        "aria-errormessage",
        "aria-expanded",
        "aria-flowto",
        "aria-grabbed",
        "aria-haspopup",
        "aria-hidden",
        "aria-invalid",
        "aria-keyshortcuts",
        "aria-label",
        "aria-labelledby",
        "aria-level",
        "aria-live",
        "aria-modal",
        "aria-multiline",
        "aria-multiselectable",
        "aria-orientation",
        "aria-owns",
        "aria-placeholder",
        "aria-posinset",
        "aria-pressed",
        "aria-readonly",
        "aria-relevant",
        "aria-required",
        "aria-roledescription",
        "aria-rowcount",
        "aria-rowindex",
        "aria-rowspan",
        "aria-selected",
        "aria-setsize",
        "aria-sort",
        "aria-valuemax",
        "aria-valuemin",
        "aria-valuenow",
        "aria-valuetext"
    ],
    anchor: [
        "download",
        "href",
        "hreflang",
        "media",
        "ping",
        "rel",
        "target",
        "type",
        "referrerpolicy"
    ],
    audio: [
        "autoplay",
        "controls",
        "crossorigin",
        "loop",
        "muted",
        "preload",
        "src"
    ],
    area: [
        "alt",
        "coords",
        "download",
        "href",
        "hreflang",
        "media",
        "referrerpolicy",
        "rel",
        "shape",
        "target",
        "ping"
    ],
    base: [
        "href",
        "target"
    ],
    blockquote: [
        "cite"
    ],
    button: [
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "name",
        "type",
        "value"
    ],
    canvas: [
        "height",
        "width"
    ],
    col: [
        "span",
        "width"
    ],
    colgroup: [
        "span"
    ],
    data: [
        "value"
    ],
    details: [
        "open"
    ],
    del: [
        "cite",
        "datetime"
    ],
    dialog: [
        "open"
    ],
    embed: [
        "height",
        "src",
        "type",
        "width"
    ],
    fieldset: [
        "disabled",
        "form",
        "name"
    ],
    form: [
        "acceptcharset",
        "action",
        "autocomplete",
        "enctype",
        "method",
        "name",
        "novalidate",
        "target",
        "rel"
    ],
    html: [
        "manifest"
    ],
    iframe: [
        "allow",
        "allowfullscreen",
        "allowtransparency",
        "frameborder",
        "height",
        "loading",
        "marginheight",
        "marginwidth",
        "mozallowfullscreen",
        "name",
        "referrerpolicy",
        "sandbox",
        "scrolling",
        "seamless",
        "src",
        "srcdoc",
        "webkitallowfullscreen",
        "width"
    ],
    img: [
        "alt",
        "crossorigin",
        "decoding",
        "height",
        "ismap",
        "loading",
        "referrerpolicy",
        "sizes",
        "src",
        "srcset",
        "usemap",
        "width"
    ],
    ins: [
        "cite",
        "datetime"
    ],
    input: [
        "accept",
        "alt",
        "autocomplete",
        "capture",
        "checked",
        "crossorigin",
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "height",
        "indeterminate",
        "list",
        "max",
        "maxlength",
        "min",
        "minlength",
        "multiple",
        "name",
        "pattern",
        "placeholder",
        "readonly",
        "required",
        "size",
        "src",
        "step",
        "type",
        "value",
        "width"
    ],
    keygen: [
        "challenge",
        "disabled",
        "form",
        "keytype",
        "keyparams",
        "name"
    ],
    label: [
        "form",
        "for"
    ],
    li: [
        "value"
    ],
    link: [
        "as",
        "crossorigin",
        "href",
        "hreflang",
        "integrity",
        "media",
        "imagesrcset",
        "imagesizes",
        "referrerpolicy",
        "rel",
        "sizes",
        "type",
        "charset"
    ],
    map: [
        "name"
    ],
    menu: [
        "type"
    ],
    media: [
        "autoplay",
        "controls",
        "currenttime",
        "defaultmuted",
        "defaultplaybackrate",
        "loop",
        "mediagroup",
        "muted",
        "playsinline",
        "preload",
        "src",
        "volume"
    ],
    meta: [
        "charset",
        "content",
        "http-equiv",
        "name",
        "media"
    ],
    meter: [
        "form",
        "high",
        "low",
        "max",
        "min",
        "optimum",
        "value"
    ],
    quote: [
        "cite"
    ],
    object: [
        "classid",
        "data",
        "form",
        "height",
        "name",
        "type",
        "usemap",
        "width",
        "wmode"
    ],
    ol: [
        "reversed",
        "start",
        "type"
    ],
    optgroup: [
        "disabled",
        "label"
    ],
    option: [
        "disabled",
        "label",
        "selected",
        "value"
    ],
    output: [
        "form",
        "for",
        "name"
    ],
    param: [
        "name",
        "value"
    ],
    progress: [
        "max",
        "value"
    ],
    slot: [
        "name"
    ],
    script: [
        "async",
        "charset",
        "crossorigin",
        "defer",
        "integrity",
        "nomodule",
        "nonce",
        "referrerpolicy",
        "src",
        "type"
    ],
    select: [
        "autocomplete",
        "disabled",
        "form",
        "multiple",
        "name",
        "required",
        "size",
        "value",
        "onchange"
    ],
    source: [
        "height",
        "media",
        "sizes",
        "src",
        "srcset",
        "type",
        "width"
    ],
    style: [
        "media",
        "nonce",
        "scoped",
        "type"
    ],
    table: [
        "align",
        "bgcolor",
        "border",
        "cellpadding",
        "cellspacing",
        "frame",
        "rules",
        "summary",
        "width"
    ],
    textarea: [
        "autocomplete",
        "cols",
        "dirname",
        "disabled",
        "form",
        "maxlength",
        "minlength",
        "name",
        "placeholder",
        "readonly",
        "required",
        "rows",
        "value",
        "wrap"
    ],
    td: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr",
        "height",
        "width",
        "valign"
    ],
    th: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr"
    ],
    time: [
        "datetime"
    ],
    track: [
        "default",
        "kind",
        "label",
        "src",
        "srclang"
    ],
    video: [
        "autoplay",
        "controls",
        "crossorigin",
        "disablepictureinpicture",
        "disableremoteplayback",
        "height",
        "loop",
        "muted",
        "playsinline",
        "poster",
        "preload",
        "src",
        "width"
    ],
    svg: [
        "className",
        "class",
        "color",
        "height",
        "id",
        "lang",
        "max",
        "media",
        "method",
        "min",
        "name",
        "style",
        "target",
        "type",
        "width",
        "role",
        "tabindex",
        "crossorigin",
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "allowReorder",
        "alphabetic",
        "amplitude",
        "arabic-form",
        "ascent",
        "attributeName",
        "attributeType",
        "autoReverse",
        "azimuth",
        "baseFrequency",
        "baseline-shift",
        "baseProfile",
        "bbox",
        "begin",
        "bias",
        "by",
        "calcMode",
        "cap-height",
        "clip",
        "clip-path",
        "clipPathUnits",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "contentScriptType",
        "contentStyleType",
        "cursor",
        "cx",
        "cy",
        "d",
        "decelerate",
        "descent",
        "diffuseConstant",
        "direction",
        "display",
        "divisor",
        "dominant-baseline",
        "dur",
        "dx",
        "dy",
        "edgeMode",
        "elevation",
        "enable-background",
        "end",
        "exponent",
        "externalResourcesRequired",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterRes",
        "filterUnits",
        "flood-color",
        "flood-opacity",
        "focusable",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "format",
        "from",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "glyphRef",
        "gradientTransform",
        "gradientUnits",
        "hanging",
        "href",
        "horiz-adv-x",
        "horiz-origin-x",
        "ideographic",
        "image-rendering",
        "in2",
        "in",
        "intercept",
        "k1",
        "k2",
        "k3",
        "k4",
        "k",
        "kernelMatrix",
        "kernelUnitLength",
        "kerning",
        "keyPoints",
        "keySplines",
        "keyTimes",
        "lengthAdjust",
        "letter-spacing",
        "lighting-color",
        "limitingConeAngle",
        "local",
        "marker-end",
        "markerHeight",
        "marker-mid",
        "marker-start",
        "markerUnits",
        "markerWidth",
        "mask",
        "maskContentUnits",
        "maskUnits",
        "mathematical",
        "mode",
        "numOctaves",
        "offset",
        "opacity",
        "operator",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "path",
        "pathLength",
        "patternContentUnits",
        "patternTransform",
        "patternUnits",
        "pointer-events",
        "points",
        "pointsAtX",
        "pointsAtY",
        "pointsAtZ",
        "preserveAlpha",
        "preserveAspectRatio",
        "primitiveUnits",
        "r",
        "radius",
        "refX",
        "refY",
        "rendering-intent",
        "repeatCount",
        "repeatDur",
        "requiredExtensions",
        "requiredFeatures",
        "restart",
        "result",
        "rotate",
        "rx",
        "ry",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "spacing",
        "specularConstant",
        "specularExponent",
        "speed",
        "spreadMethod",
        "startOffset",
        "stdDeviation",
        "stemh",
        "stemv",
        "stitchTiles",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "string",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "surfaceScale",
        "systemLanguage",
        "tableValues",
        "targetX",
        "targetY",
        "text-anchor",
        "text-decoration",
        "textLength",
        "text-rendering",
        "to",
        "transform",
        "u1",
        "u2",
        "underline-position",
        "underline-thickness",
        "unicode",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "values",
        "vector-effect",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "v-hanging",
        "v-ideographic",
        "viewBox",
        "viewTarget",
        "visibility",
        "v-mathematical",
        "widths",
        "word-spacing",
        "writing-mode",
        "x1",
        "x2",
        "x",
        "xChannelSelector",
        "x-height",
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:href",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type",
        "xml:base",
        "xml:lang",
        "xmlns",
        "xmlns:xlink",
        "xml:space",
        "y1",
        "y2",
        "y",
        "yChannelSelector",
        "z",
        "zoomAndPan"
    ]
}, em = [
    "oncopy",
    "oncut",
    "onpaste",
    "oncompositionend",
    "oncompositionstart",
    "oncompositionupdate",
    "onfocus",
    "onfocusin",
    "onfocusout",
    "onblur",
    "onchange",
    "onbeforeinput",
    "oninput",
    "onreset",
    "onsubmit",
    "oninvalid",
    "onformdata",
    "onload",
    "onerror",
    "ontoggle",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onabort",
    "oncanplay",
    "oncanplaythrough",
    "oncuechange",
    "ondurationchange",
    "onemptied",
    "onencrypted",
    "onended",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onpause",
    "onplay",
    "onplaying",
    "onprogress",
    "onratechange",
    "onseeked",
    "onseeking",
    "onstalled",
    "onsuspend",
    "ontimeupdate",
    "onvolumechange",
    "onwaiting",
    "onauxclick",
    "onclick",
    "oncontextmenu",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragexit",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onselect",
    "onselectionchange",
    "onselectstart",
    "ontouchcancel",
    "ontouchend",
    "ontouchmove",
    "ontouchstart",
    "ongotpointercapture",
    "onpointercancel",
    "onpointerdown",
    "onpointerenter",
    "onpointerleave",
    "onpointermove",
    "onpointerout",
    "onpointerover",
    "onpointerup",
    "onlostpointercapture",
    "onscroll",
    "onresize",
    "onwheel",
    "onanimationstart",
    "onanimationend",
    "onanimationiteration",
    "ontransitionstart",
    "ontransitionrun",
    "ontransitionend",
    "ontransitioncancel",
    "onoutrostart",
    "onoutroend",
    "onintrostart",
    "onintroend",
    "onmessage",
    "onmessageerror",
    "onvisibilitychange",
    "oncancel",
    "onclose",
    "onfullscreenchange",
    "onfullscreenerror"
], Dl = (t, e)=>{
    if (Object.prototype.hasOwnProperty.call(Fi, t)) {
        let r = Fi[t];
        return r.includes(e) || r.includes("default");
    } else return Fi.default.includes(e);
}, rm = (t)=>{
    if (!b(t)) return !1;
    let e = t.toLowerCase();
    return em.includes(e);
}, Fl = (t, e, r)=>{
    let n = {};
    for(let o in e)if (Object.prototype.hasOwnProperty.call(e, o)) {
        if (r && o in r) continue;
        let s = Dl(t, o), i = rm(o);
        Ot(e[o]) && (s || i) && (n[o] = e[o]);
    }
    return n;
}, Yw = (t, e)=>{
    let r = {};
    if (t.attr) for(let n in t.attr)r[n] = t.attr[n](e, e.state, e.context);
    return r;
}, Wt = (t, e)=>{
    let r = t.call("exec", e, t);
    if (r) return b(r) && r.includes("{{") && (r = t.call("replaceLiteralsWithObjectFields", r)), r;
}, Nl = {
    src: (t)=>Wt(t, t.props.src),
    href: (t)=>Wt(t, t.props.href),
    action: (t)=>Wt(t, t.props.action),
    poster: (t)=>Wt(t, t.props.poster),
    data: (t)=>Wt(t, t.props.data)
}, Xw = (t)=>{
    let e = t.tag || "div", { props: r } = t, n = {};
    for(let o in Nl)if (r[o] !== void 0 && Dl(e, o)) {
        let s = Nl[o](t);
        s !== void 0 && (n[o] = s);
    }
    return n;
};
v();
v();
var nm = !1;
function om(t) {
    if (t.sheet) return t.sheet;
    for(var e = 0; e < document.styleSheets.length; e++)if (document.styleSheets[e].ownerNode === t) return document.styleSheets[e];
}
function sm(t) {
    var e = document.createElement("style");
    return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var $l = function() {
    function t(r) {
        var n = this;
        this._insertTag = function(o) {
            var s;
            n.tags.length === 0 ? n.insertionPoint ? s = n.insertionPoint.nextSibling : n.prepend ? s = n.container.firstChild : s = n.before : s = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, s), n.tags.push(o);
        }, this.isSpeedy = r.speedy === void 0 ? !nm : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
    }
    var e = t.prototype;
    return e.hydrate = function(n) {
        n.forEach(this._insertTag);
    }, e.insert = function(n) {
        this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(sm(this));
        var o = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var s = om(o);
            try {
                s.insertRule(n, s.cssRules.length);
            } catch  {}
        } else o.appendChild(document.createTextNode(n));
        this.ctr++;
    }, e.flush = function() {
        this.tags.forEach(function(n) {
            var o;
            return (o = n.parentNode) == null ? void 0 : o.removeChild(n);
        }), this.tags = [], this.ctr = 0;
    }, t;
}();
var lt = "-ms-", Jr = "-moz-", q = "-webkit-", eo = "comm", or = "rule", sr = "decl";
var Ll = "@import";
var ro = "@keyframes";
var Ml = "@layer";
var Bl = Math.abs, Te = String.fromCharCode, Ul = Object.assign;
function Vl(t, e) {
    return et(t, 0) ^ 45 ? (((e << 2 ^ et(t, 0)) << 2 ^ et(t, 1)) << 2 ^ et(t, 2)) << 2 ^ et(t, 3) : 0;
}
function no(t) {
    return t.trim();
}
function $i(t, e) {
    return (t = e.exec(t)) ? t[0] : t;
}
function M(t, e, r) {
    return t.replace(e, r);
}
function Zr(t, e) {
    return t.indexOf(e);
}
function et(t, e) {
    return t.charCodeAt(e) | 0;
}
function me(t, e, r) {
    return t.slice(e, r);
}
function dt(t) {
    return t.length;
}
function ir(t) {
    return t.length;
}
function ar(t, e) {
    return e.push(t), t;
}
function Li(t, e) {
    return t.map(e).join("");
}
var oo = 1, cr = 1, jl = 0, ht = 0, rt = 0, fr = "";
function tn(t, e, r, n, o, s, i) {
    return {
        value: t,
        root: e,
        parent: r,
        type: n,
        props: o,
        children: s,
        line: oo,
        column: cr,
        length: i,
        return: ""
    };
}
function ur(t, e) {
    return Ul(tn("", null, null, "", null, null, 0), t, {
        length: -t.length
    }, e);
}
function zl() {
    return rt;
}
function ql() {
    return rt = ht > 0 ? et(fr, --ht) : 0, cr--, rt === 10 && (cr = 1, oo--), rt;
}
function mt() {
    return rt = ht < jl ? et(fr, ht++) : 0, cr++, rt === 10 && (cr = 1, oo++), rt;
}
function Nt() {
    return et(fr, ht);
}
function en() {
    return ht;
}
function pr(t, e) {
    return me(fr, t, e);
}
function lr(t) {
    switch(t){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function so(t) {
    return oo = cr = 1, jl = dt(fr = t), ht = 0, [];
}
function io(t) {
    return fr = "", t;
}
function dr(t) {
    return no(pr(ht - 1, Mi(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function Hl(t) {
    for(; (rt = Nt()) && rt < 33;)mt();
    return lr(t) > 2 || lr(rt) > 3 ? "" : " ";
}
function Wl(t, e) {
    for(; --e && mt() && !(rt < 48 || rt > 102 || rt > 57 && rt < 65 || rt > 70 && rt < 97););
    return pr(t, en() + (e < 6 && Nt() == 32 && mt() == 32));
}
function Mi(t) {
    for(; mt();)switch(rt){
        case t:
            return ht;
        case 34:
        case 39:
            t !== 34 && t !== 39 && Mi(rt);
            break;
        case 40:
            t === 41 && Mi(t);
            break;
        case 92:
            mt();
            break;
    }
    return ht;
}
function Gl(t, e) {
    for(; mt() && t + rt !== 57;)if (t + rt === 84 && Nt() === 47) break;
    return "/*" + pr(e, ht - 1) + "*" + Te(t === 47 ? t : mt());
}
function Kl(t) {
    for(; !lr(Nt());)mt();
    return pr(t, ht);
}
function Ql(t) {
    return io(ao("", null, null, null, [
        ""
    ], t = so(t), 0, [
        0
    ], t));
}
function ao(t, e, r, n, o, s, i, a, c) {
    for(var f = 0, l = 0, u = i, p = 0, d = 0, h = 0, m = 1, S = 1, _ = 1, w = 0, E = "", R = o, T = s, A = n, k = E; S;)switch(h = w, w = mt()){
        case 40:
            if (h != 108 && et(k, u - 1) == 58) {
                Zr(k += M(dr(w), "&", "&\f"), "&\f") != -1 && (_ = -1);
                break;
            }
        case 34:
        case 39:
        case 91:
            k += dr(w);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            k += Hl(h);
            break;
        case 92:
            k += Wl(en() - 1, 7);
            continue;
        case 47:
            switch(Nt()){
                case 42:
                case 47:
                    ar(im(Gl(mt(), en()), e, r), c);
                    break;
                default:
                    k += "/";
            }
            break;
        case 123 * m:
            a[f++] = dt(k) * _;
        case 125 * m:
        case 59:
        case 0:
            switch(w){
                case 0:
                case 125:
                    S = 0;
                case 59 + l:
                    _ == -1 && (k = M(k, /\f/g, "")), d > 0 && dt(k) - u && ar(d > 32 ? Xl(k + ";", n, r, u - 1) : Xl(M(k, " ", "") + ";", n, r, u - 2), c);
                    break;
                case 59:
                    k += ";";
                default:
                    if (ar(A = Yl(k, e, r, f, l, o, a, E, R = [], T = [], u), s), w === 123) {
                        if (l === 0) ao(k, e, A, A, R, s, u, a, T);
                        else switch(p === 99 && et(k, 3) === 110 ? 100 : p){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                ao(t, A, A, n && ar(Yl(t, A, A, 0, 0, o, a, E, o, R = [], u), T), o, T, u, a, n ? R : T);
                                break;
                            default:
                                ao(k, A, A, A, [
                                    ""
                                ], T, 0, a, T);
                        }
                    }
            }
            f = l = d = 0, m = _ = 1, E = k = "", u = i;
            break;
        case 58:
            u = 1 + dt(k), d = h;
        default:
            if (m < 1) {
                if (w == 123) --m;
                else if (w == 125 && m++ == 0 && ql() == 125) continue;
            }
            switch(k += Te(w), w * m){
                case 38:
                    _ = l > 0 ? 1 : (k += "\f", -1);
                    break;
                case 44:
                    a[f++] = (dt(k) - 1) * _, _ = 1;
                    break;
                case 64:
                    Nt() === 45 && (k += dr(mt())), p = Nt(), l = u = dt(E = k += Kl(en())), w++;
                    break;
                case 45:
                    h === 45 && dt(k) == 2 && (m = 0);
            }
    }
    return s;
}
function Yl(t, e, r, n, o, s, i, a, c, f, l) {
    for(var u = o - 1, p = o === 0 ? s : [
        ""
    ], d = ir(p), h = 0, m = 0, S = 0; h < n; ++h)for(var _ = 0, w = me(t, u + 1, u = Bl(m = i[h])), E = t; _ < d; ++_)(E = no(m > 0 ? p[_] + " " + w : M(w, /&\f/g, p[_]))) && (c[S++] = E);
    return tn(t, e, r, o === 0 ? or : a, c, f, l);
}
function im(t, e, r) {
    return tn(t, e, r, eo, Te(zl()), me(t, 2, -2), 0);
}
function Xl(t, e, r, n) {
    return tn(t, e, r, sr, me(t, 0, n), me(t, n + 1, -1), n);
}
function Re(t, e) {
    for(var r = "", n = ir(t), o = 0; o < n; o++)r += e(t[o], o, t, e) || "";
    return r;
}
function Jl(t, e, r, n) {
    switch(t.type){
        case Ml:
            if (t.children.length) break;
        case Ll:
        case sr:
            return t.return = t.return || t.value;
        case eo:
            return "";
        case ro:
            return t.return = t.value + "{" + Re(t.children, n) + "}";
        case or:
            t.value = t.props.join(",");
    }
    return dt(r = Re(t.children, n)) ? t.return = t.value + "{" + r + "}" : "";
}
function Zl(t) {
    var e = ir(t);
    return function(r, n, o, s) {
        for(var i = "", a = 0; a < e; a++)i += t[a](r, n, o, s) || "";
        return i;
    };
}
function tf(t) {
    return function(e) {
        e.root || (e = e.return) && t(e);
    };
}
function ef(t) {
    var e = Object.create(null);
    return function(r) {
        return e[r] === void 0 && (e[r] = t(r)), e[r];
    };
}
var am = function(e, r, n) {
    for(var o = 0, s = 0; o = s, s = Nt(), o === 38 && s === 12 && (r[n] = 1), !lr(s);)mt();
    return pr(e, ht);
}, cm = function(e, r) {
    var n = -1, o = 44;
    do switch(lr(o)){
        case 0:
            o === 38 && Nt() === 12 && (r[n] = 1), e[n] += am(ht - 1, r, n);
            break;
        case 2:
            e[n] += dr(o);
            break;
        case 4:
            if (o === 44) {
                e[++n] = Nt() === 58 ? "&\f" : "", r[n] = e[n].length;
                break;
            }
        default:
            e[n] += Te(o);
    }
    while (o = mt());
    return e;
}, lm = function(e, r) {
    return io(cm(so(e), r));
}, rf = new WeakMap, fm = function(e) {
    if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
        for(var r = e.value, n = e.parent, o = e.column === n.column && e.line === n.line; n.type !== "rule";)if (n = n.parent, !n) return;
        if (!(e.props.length === 1 && r.charCodeAt(0) !== 58 && !rf.get(n)) && !o) {
            rf.set(e, !0);
            for(var s = [], i = lm(r, s), a = n.props, c = 0, f = 0; c < i.length; c++)for(var l = 0; l < a.length; l++, f++)e.props[f] = s[c] ? i[c].replace(/&\f/g, a[l]) : a[l] + " " + i[c];
        }
    }
}, um = function(e) {
    if (e.type === "decl") {
        var r = e.value;
        r.charCodeAt(0) === 108 && r.charCodeAt(2) === 98 && (e.return = "", e.value = "");
    }
};
function nf(t, e) {
    switch(Vl(t, e)){
        case 5103:
            return q + "print-" + t + t;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return q + t + t;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return q + t + Jr + t + lt + t + t;
        case 6828:
        case 4268:
            return q + t + lt + t + t;
        case 6165:
            return q + t + lt + "flex-" + t + t;
        case 5187:
            return q + t + M(t, /(\w+).+(:[^]+)/, q + "box-$1$2" + lt + "flex-$1$2") + t;
        case 5443:
            return q + t + lt + "flex-item-" + M(t, /flex-|-self/, "") + t;
        case 4675:
            return q + t + lt + "flex-line-pack" + M(t, /align-content|flex-|-self/, "") + t;
        case 5548:
            return q + t + lt + M(t, "shrink", "negative") + t;
        case 5292:
            return q + t + lt + M(t, "basis", "preferred-size") + t;
        case 6060:
            return q + "box-" + M(t, "-grow", "") + q + t + lt + M(t, "grow", "positive") + t;
        case 4554:
            return q + M(t, /([^-])(transform)/g, "$1" + q + "$2") + t;
        case 6187:
            return M(M(M(t, /(zoom-|grab)/, q + "$1"), /(image-set)/, q + "$1"), t, "") + t;
        case 5495:
        case 3959:
            return M(t, /(image-set\([^]*)/, q + "$1$`$1");
        case 4968:
            return M(M(t, /(.+:)(flex-)?(.*)/, q + "box-pack:$3" + lt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + q + t + t;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return M(t, /(.+)-inline(.+)/, q + "$1$2") + t;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (dt(t) - 1 - e > 6) switch(et(t, e + 1)){
                case 109:
                    if (et(t, e + 4) !== 45) break;
                case 102:
                    return M(t, /(.+:)(.+)-([^]+)/, "$1" + q + "$2-$3$1" + Jr + (et(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
                case 115:
                    return ~Zr(t, "stretch") ? nf(M(t, "stretch", "fill-available"), e) + t : t;
            }
            break;
        case 4949:
            if (et(t, e + 1) !== 115) break;
        case 6444:
            switch(et(t, dt(t) - 3 - (~Zr(t, "!important") && 10))){
                case 107:
                    return M(t, ":", ":" + q) + t;
                case 101:
                    return M(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + q + (et(t, 14) === 45 ? "inline-" : "") + "box$3$1" + q + "$2$3$1" + lt + "$2box$3") + t;
            }
            break;
        case 5936:
            switch(et(t, e + 11)){
                case 114:
                    return q + t + lt + M(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
                case 108:
                    return q + t + lt + M(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
                case 45:
                    return q + t + lt + M(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
            }
            return q + t + lt + t + t;
    }
    return t;
}
var pm = function(e, r, n, o) {
    if (e.length > -1 && !e.return) switch(e.type){
        case sr:
            e.return = nf(e.value, e.length);
            break;
        case ro:
            return Re([
                ur(e, {
                    value: M(e.value, "@", "@" + q)
                })
            ], o);
        case or:
            if (e.length) return Li(e.props, function(s) {
                switch($i(s, /(::plac\w+|:read-\w+)/)){
                    case ":read-only":
                    case ":read-write":
                        return Re([
                            ur(e, {
                                props: [
                                    M(s, /:(read-\w+)/, ":" + Jr + "$1")
                                ]
                            })
                        ], o);
                    case "::placeholder":
                        return Re([
                            ur(e, {
                                props: [
                                    M(s, /:(plac\w+)/, ":" + q + "input-$1")
                                ]
                            }),
                            ur(e, {
                                props: [
                                    M(s, /:(plac\w+)/, ":" + Jr + "$1")
                                ]
                            }),
                            ur(e, {
                                props: [
                                    M(s, /:(plac\w+)/, lt + "input-$1")
                                ]
                            })
                        ], o);
                }
                return "";
            });
    }
}, dm = [
    pm
], of = function(e) {
    var r = e.key;
    if (r === "css") {
        var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
        Array.prototype.forEach.call(n, function(m) {
            var S = m.getAttribute("data-emotion");
            S.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
        });
    }
    var o = e.stylisPlugins || dm, s = {}, i, a = [];
    i = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + r + ' "]'), function(m) {
        for(var S = m.getAttribute("data-emotion").split(" "), _ = 1; _ < S.length; _++)s[S[_]] = !0;
        a.push(m);
    });
    var c, f = [
        fm,
        um
    ];
    var l, u = [
        Jl,
        tf(function(m) {
            l.insert(m);
        })
    ], p = Zl(f.concat(o, u)), d = function(S) {
        return Re(Ql(S), p);
    };
    c = function(S, _, w, E) {
        l = w, d(S ? S + "{" + _.styles + "}" : _.styles), E && (h.inserted[_.name] = !0);
    };
    var h = {
        key: r,
        sheet: new $l({
            key: r,
            container: i,
            nonce: e.nonce,
            speedy: e.speedy,
            prepend: e.prepend,
            insertionPoint: e.insertionPoint
        }),
        nonce: e.nonce,
        inserted: s,
        registered: {},
        insert: c
    };
    return h.sheet.hydrate(a), h;
};
function sf(t) {
    for(var e = 0, r, n = 0, o = t.length; o >= 4; ++n, o -= 4)r = t.charCodeAt(n) & 255 | (t.charCodeAt(++n) & 255) << 8 | (t.charCodeAt(++n) & 255) << 16 | (t.charCodeAt(++n) & 255) << 24, r = (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= r >>> 24, e = (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
    switch(o){
        case 3:
            e ^= (t.charCodeAt(n + 2) & 255) << 16;
        case 2:
            e ^= (t.charCodeAt(n + 1) & 255) << 8;
        case 1:
            e ^= t.charCodeAt(n) & 255, e = (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
    }
    return e ^= e >>> 13, e = (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var af = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var hm = !1, mm = /[A-Z]|^ms/g, gm = /_EMO_([^_]+?)_([^]*?)_EMO_/g, uf = function(e) {
    return e.charCodeAt(1) === 45;
}, cf = function(e) {
    return e != null && typeof e != "boolean";
}, Bi = ef(function(t) {
    return uf(t) ? t : t.replace(mm, "-$&").toLowerCase();
}), lf = function(e, r) {
    switch(e){
        case "animation":
        case "animationName":
            if (typeof r == "string") return r.replace(gm, function(n, o, s) {
                return Gt = {
                    name: o,
                    styles: s,
                    next: Gt
                }, o;
            });
    }
    return af[e] !== 1 && !uf(e) && typeof r == "number" && r !== 0 ? r + "px" : r;
}, ym = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function rn(t, e, r) {
    if (r == null) return "";
    var n = r;
    if (n.__emotion_styles !== void 0) return n;
    switch(typeof r){
        case "boolean":
            return "";
        case "object":
            var o = r;
            if (o.anim === 1) return Gt = {
                name: o.name,
                styles: o.styles,
                next: Gt
            }, o.name;
            var s = r;
            if (s.styles !== void 0) {
                var i = s.next;
                if (i !== void 0) for(; i !== void 0;)Gt = {
                    name: i.name,
                    styles: i.styles,
                    next: Gt
                }, i = i.next;
                var a = s.styles + ";";
                return a;
            }
            return bm(t, e, r);
        case "function":
            if (t !== void 0) {
                var c = Gt, f = r(t);
                return Gt = c, rn(t, e, f);
            }
            break;
    }
    var l = r;
    if (e == null) return l;
    var u = e[l];
    return u !== void 0 ? u : l;
}
function bm(t, e, r) {
    var n = "";
    if (Array.isArray(r)) for(var o = 0; o < r.length; o++)n += rn(t, e, r[o]) + ";";
    else for(var s in r){
        var i = r[s];
        if (typeof i != "object") {
            var a = i;
            e != null && e[a] !== void 0 ? n += s + "{" + e[a] + "}" : cf(a) && (n += Bi(s) + ":" + lf(s, a) + ";");
        } else {
            if (s === "NO_COMPONENT_SELECTOR" && hm) throw new Error(ym);
            if (Array.isArray(i) && typeof i[0] == "string" && (e == null || e[i[0]] === void 0)) for(var c = 0; c < i.length; c++)cf(i[c]) && (n += Bi(s) + ":" + lf(s, i[c]) + ";");
            else {
                var f = rn(t, e, i);
                switch(s){
                    case "animation":
                    case "animationName":
                        n += Bi(s) + ":" + f + ";";
                        break;
                    default:
                        n += s + "{" + f + "}";
                }
            }
        }
    }
    return n;
}
var ff = /label:\s*([^\s;{]+)\s*(;|$)/g, Gt;
function co(t, e, r) {
    if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0) return t[0];
    var n = !0, o = "";
    Gt = void 0;
    var s = t[0];
    if (s == null || s.raw === void 0) n = !1, o += rn(r, e, s);
    else {
        var i = s;
        o += i[0];
    }
    for(var a = 1; a < t.length; a++)if (o += rn(r, e, t[a]), n) {
        var c = s;
        o += c[a];
    }
    ff.lastIndex = 0;
    for(var f = "", l; (l = ff.exec(o)) !== null;)f += "-" + l[1];
    var u = sf(o) + f;
    return {
        name: u,
        styles: o,
        next: Gt
    };
}
var Sm = !0;
function Ui(t, e, r) {
    var n = "";
    return r.split(" ").forEach(function(o) {
        t[o] !== void 0 ? e.push(t[o] + ";") : o && (n += o + " ");
    }), n;
}
var xm = function(e, r, n) {
    var o = e.key + "-" + r.name;
    (n === !1 || Sm === !1) && e.registered[o] === void 0 && (e.registered[o] = r.styles);
}, pf = function(e, r, n) {
    xm(e, r, n);
    var o = e.key + "-" + r.name;
    if (e.inserted[r.name] === void 0) {
        var s = r;
        do e.insert(r === s ? "." + o : "", s, e.sheet, !0), s = s.next;
        while (s !== void 0);
    }
};
function df(t, e) {
    if (t.inserted[e.name] === void 0) return t.insert("", e, t.sheet, !0);
}
function hf(t, e, r) {
    var n = [], o = Ui(t, n, r);
    return n.length < 2 ? r : o + e(n);
}
var Vi = function(e) {
    var r = of(e);
    r.sheet.speedy = function(a) {
        this.isSpeedy = a;
    }, r.compat = !0;
    var n = function() {
        for(var c = arguments.length, f = new Array(c), l = 0; l < c; l++)f[l] = arguments[l];
        var u = co(f, r.registered, void 0);
        return pf(r, u, !1), r.key + "-" + u.name;
    }, o = function() {
        for(var c = arguments.length, f = new Array(c), l = 0; l < c; l++)f[l] = arguments[l];
        var u = co(f, r.registered), p = "animation-" + u.name;
        return df(r, {
            name: u.name,
            styles: "@keyframes " + p + "{" + u.styles + "}"
        }), p;
    }, s = function() {
        for(var c = arguments.length, f = new Array(c), l = 0; l < c; l++)f[l] = arguments[l];
        var u = co(f, r.registered);
        df(r, u);
    }, i = function() {
        for(var c = arguments.length, f = new Array(c), l = 0; l < c; l++)f[l] = arguments[l];
        return hf(r.registered, n, _m(f));
    };
    return {
        css: n,
        cx: i,
        injectGlobal: s,
        keyframes: o,
        hydrate: function(c) {
            c.forEach(function(f) {
                r.inserted[f] = !0;
            });
        },
        flush: function() {
            r.registered = {}, r.inserted = {}, r.sheet.flush();
        },
        sheet: r.sheet,
        cache: r,
        getRegisteredStyles: Ui.bind(null, r.registered),
        merge: hf.bind(null, r.registered, n)
    };
}, _m = function t(e) {
    for(var r = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (o != null) {
            var s = void 0;
            switch(typeof o){
                case "boolean":
                    break;
                case "object":
                    if (Array.isArray(o)) s = t(o);
                    else {
                        s = "";
                        for(var i in o)o[i] && i && (s && (s += " "), s += i);
                    }
                    break;
                default:
                    s = o;
            }
            s && (r && (r += " "), r += s);
        }
    }
    return r;
};
v();
v();
var wm = /\s+/g, Iv = (t)=>{
    let { key: e } = t;
    t.classlist === !0 ? t.classlist = e : !t.classlist && typeof e == "string" && e.charCodeAt(0) === 95 && e.charCodeAt(1) !== 95 && (t.classlist = e.slice(1));
}, vm = (t, e)=>{
    let r = "";
    for(let n in t){
        let o = t[n];
        typeof o == "boolean" && o ? r += ` ${n}` : typeof o == "string" ? r += ` ${o}` : typeof o == "function" && (r += ` ${O(o, e)}`);
    }
    return r;
}, Em = (t, e)=>{
    if (!t) return;
    let { key: r } = e;
    return t === !0 && (t = e.classlist = {
        key: r
    }), b(t) && (t = e.classlist = {
        default: t
    }), g(t) && (t = vm(t, e)), t.replace(wm, " ").trim();
}, ji = (t, e, r)=>{
    let n = Em(t, e);
    if (r && typeof r.setAttribute == "function") r.setAttribute("class", n);
    else if (r) try {
        r.className = n;
    } catch  {}
    return n;
};
function Pv(t, e, r) {
    ji(t, e, r);
}
var Cm = (t = "smbls", e)=>{
    let r = t.replaceAll(/\./g, "-");
    return Vi({
        key: r,
        container: e
    });
}, Et = Cm(), km = (t)=>(e, r, n)=>{
        let o = O(e, r);
        if (e) {
            let { __ref: s } = r;
            s.__class.style = o;
        }
        mf(t)(r.classlist, r, r.state, !0);
    }, mf = (t)=>(e, r, n, o)=>{
        if (r.style && !o) return;
        let { __ref: s } = r, { __class: i, __classNames: a } = s;
        if (N(e)) {
            r.props.class && (a.classProps = r.props.class), r.attr?.class && (a.class = r.attr.class);
            for(let c in i){
                let f = i[c];
                if (!f) {
                    delete a[c];
                    continue;
                }
                let l;
                b(f) || ct(f) ? l = f : Pn(f) ? l = r.key : l = t.css(f), a[c] = l;
            }
            for(let c in a)c === "classProps" || c === "class" || i[c] === void 0 && delete a[c];
            r.node && ji(a, r, r.node);
        }
    }, gf = (t, e)=>(t || (t = Vi(e || {
        key: "smbls"
    })), {
        style: km(t),
        classlist: mf(t)
    });
var Sr = {};
Mt(Sr, {
    CSS_NATIVE_COLOR_REGEX: ()=>Zt,
    CSS_UNITS: ()=>on,
    applyMediaSequenceVars: ()=>br,
    applySequenceGlobalVars: ()=>oa,
    applySequenceVars: ()=>$e,
    changeLightness: ()=>Pm,
    colorStringToRgbaArray: ()=>ge,
    convertSvgToSymbol: ()=>sa,
    findHeadingLetter: ()=>If,
    findHeadings: ()=>na,
    generateSequence: ()=>Kt,
    generateSequencePosition: ()=>Vg,
    generateSprite: ()=>go,
    generateSubSequence: ()=>ea,
    getColorShade: ()=>_f,
    getDefaultOrFirstKey: ()=>an,
    getFnPrefixAndValue: ()=>Fe,
    getFontFace: ()=>Fm,
    getFontFaceEach: ()=>cn,
    getFontFaceEachString: ()=>Cf,
    getFontFaceString: ()=>qi,
    getFontFormat: ()=>vf,
    getRgbTone: ()=>sn,
    getSequenceValue: ()=>ra,
    getSequenceValueBySymbols: ()=>Rf,
    getSequenceValuePropertyPair: ()=>be,
    getSubratio: ()=>ta,
    getSubratioDifference: ()=>Zi,
    hexToRgb: ()=>Am,
    hexToRgbArray: ()=>yf,
    hexToRgba: ()=>Rm,
    hslToRgb: ()=>xf,
    isCSSVar: ()=>nt,
    isGoogleFontsUrl: ()=>fo,
    isResolvedColor: ()=>ye,
    isScalingUnit: ()=>nn,
    mixTwoColors: ()=>Om,
    mixTwoRgb: ()=>Im,
    mixTwoRgba: ()=>wf,
    numToLetterMap: ()=>De,
    opacify: ()=>lo,
    parseColorToken: ()=>hr,
    resolveFileUrl: ()=>Ie,
    returnSubThemeOrDefault: ()=>Dm,
    rgbArrayToHex: ()=>bf,
    rgbToHSL: ()=>Sf,
    rgbToHex: ()=>Tm,
    setCustomFont: ()=>zi,
    setCustomFontMedia: ()=>gr,
    setFontImport: ()=>uo,
    setInCustomFontMedia: ()=>Ef,
    setScalingVar: ()=>Ji,
    setSubScalingVar: ()=>Tf,
    setVariables: ()=>jg,
    splitTopLevelCommas: ()=>mr
});
var nn = (t)=>t === "em" || t === "rem" || t === "vw" || t === "vh" || t === "vmax" || t === "vmin", on = [
    "px",
    "cm",
    "mm",
    "in",
    "pt",
    "pc",
    "em",
    "rem",
    "ex",
    "cap",
    "ch",
    "ic",
    "lh",
    "rlh",
    "%",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax",
    "deg",
    "rad",
    "grad",
    "turn",
    "s",
    "ms",
    "dpi",
    "dpcm",
    "dppx",
    "fr",
    "auto"
];
v();
var ge = (t)=>{
    if (t === "") return [
        0,
        0,
        0,
        0
    ];
    if (t.toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    if (t[0] === "#") return t.length < 7 && (t = "#" + t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + (t.length > 4 ? t[4] + t[4] : "")), [
        parseInt(t.substr(1, 2), 16),
        parseInt(t.substr(3, 2), 16),
        parseInt(t.substr(5, 2), 16),
        t.length > 7 ? parseInt(t.substr(7, 2), 16) / 255 : 1
    ];
    if (t.indexOf("rgb") === -1 && L && D) {
        let e = L.body.appendChild(L.createElement("fictum")), r = "rgb(1, 2, 3)";
        if (e.style.color = r, e.style.color !== r) {
            L.body.removeChild(e);
            return;
        }
        if (e.style.color = t, e.style.color === r || e.style.color === "") return L.body.removeChild(e), [
            0,
            0,
            0,
            0
        ];
        t = D.getComputedStyle(e).color, L.body.removeChild(e);
    }
    return t.indexOf("rgb") === 0 ? (t.indexOf("rgba") === -1 && (t = `${t}, 1`), t.match(/[\.\d]+/g).map((e)=>+e)) : [
        0,
        0,
        0,
        0
    ];
}, Om = (t, e, r = .5)=>(t = ge(t), e = ge(e), wf(t, e, r)), Am = (t, e = 1)=>{
    let [r, n, o] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return `rgb(${r},${n},${o})`;
}, yf = (t, e = 1)=>{
    let [r, n, o] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return [
        r,
        n,
        o
    ];
}, Tm = (t, e, r)=>"#" + (16777216 | t << 16 | e << 8 | r).toString(16).slice(1), bf = ([t, e, r])=>(16777216 + (t << 16) + (e << 8) + r).toString(16).slice(1), Rm = (t, e = 1)=>{
    let [r, n, o] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return `rgba(${r},${n},${o},${e})`;
}, Im = (t, e, r = .5)=>{
    let n = [];
    for(let o = 0; o < 3; o++)n[o] = ~~(t[o] + (e[o] - t[o]) * r);
    return `rgb(${n})`;
}, Pm = (t, e)=>{
    let [r, n, o] = e, s = Math.max(0, Math.min(100, o + parseFloat(t)));
    return [
        r,
        n,
        s
    ];
}, Sf = (t, e, r)=>{
    let n = Math.max(t, e, r), o = n - Math.min(t, e, r), s = 1 - Math.abs(n + n - o - 1), i = o && (n == t ? (e - r) / o : n == e ? 2 + (r - t) / o : 4 + (t - e) / o);
    return [
        60 * (i < 0 ? i + 6 : i),
        s ? o / s : 0,
        (n + n - o) / 2
    ];
}, xf = (t, e, r, n = e * Math.min(r, 1 - r), o = (s, i = (s + t / 30) % 12)=>r - n * Math.max(Math.min(i - 3, 9 - i, 1), -1))=>[
        o(0),
        o(8),
        o(4)
    ], _f = (t, e)=>{
    let r = parseInt(t, 16), n = (r >> 16) + e;
    n > 255 ? n = 255 : n < 0 && (n = 0);
    let o = (r >> 8 & 255) + e;
    o > 255 ? o = 255 : o < 0 && (o = 0);
    let s = (r & 255) + e;
    return s > 255 ? s = 255 : s < 0 && (s = 0), ((s | o << 8 | n << 16) + 16777216).toString(16).slice(1);
}, wf = (t, e, r = .5)=>{
    let n = [];
    for(let o = 0; o < 4; o++){
        let s = o === 3 ? (i)=>i : Math.round;
        n[o] = s(t[o] + (e[o] - t[o]) * r);
    }
    return `rgba(${n})`;
}, lo = (t, e)=>{
    let r = ge(t);
    if (!r) {
        Br() && console.warn(t + " color is not rgba");
        return;
    }
    return r[3] = e, `rgba(${r})`;
}, nt = (t)=>t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45, Zt = /(?:rgba?\(|hsla?\(|#[0-9a-fA-F]{3,8}\b)/, Nm = /^([a-zA-Z]\w*)(?:\.(\d+))?(?:([+-]\d+|=\d+))?$/, hr = (t)=>{
    if (!b(t)) return null;
    if (Zt.test(t)) return {
        passthrough: t
    };
    if (nt(t)) return {
        cssVar: t
    };
    let e = t.match(Nm);
    if (!e) return null;
    let [, r, n, o] = e, s = n !== void 0 ? `0.${n}` : void 0, i = o && o[0] === "=" ? o.slice(1) : o;
    return {
        name: r,
        alpha: s,
        tone: i
    };
}, ye = (t)=>b(t) && (t.includes("rgb") || t.includes("var(") || t.includes("#")), mr = (t)=>{
    let e = [], r = "", n = 0;
    for (let o of t){
        if (o === "(" ? n += 1 : o === ")" && n > 0 && (n -= 1), o === "," && n === 0) {
            e.push(r), r = "";
            continue;
        }
        r += o;
    }
    return (r.length || !e.length) && e.push(r), e;
}, sn = (t, e)=>{
    b(t) && t.includes("rgb") && (t = ge(t).join(", ")), b(t) && (t = t.split(",").map((o)=>parseFloat(o.trim()))), ct(e) && (e += "");
    let r = bf(t), n = e.slice(0, 1);
    if (n === "-" || n === "+") {
        let o = _f(r, parseFloat(e));
        return yf(o).join(", ");
    } else {
        let [o, s, i] = t, a = Sf(o, s, i), [c, f, l] = a;
        return xf(c, f, parseFloat(e) / 100 * 255);
    }
};
var Dm = (t, e)=>{
    if (t) return t.themes && t.themes[e] ? t.themes[e] : t[e] ? [
        t,
        t[e]
    ] : t;
};
var Ie = (t, e)=>{
    if (!t || !e) return null;
    try {
        return new URL(t), null;
    } catch  {}
    let r = e[t];
    return r ? r.content && r.content.src : null;
}, an = (t, e)=>{
    if (t[e]) return t[e].value;
    if (t.default) return t[t.default].value;
    let r = Object.keys(t)[0];
    return r && t[r] && t[r].value;
}, vf = (t)=>{
    let e = t.split(/[#?]/)[0].split(".").pop().trim();
    return [
        "woff2",
        "woff",
        "ttf",
        "otf",
        "eot"
    ].includes(e) ? e : null;
}, fo = (t)=>t && (t.includes("fonts.googleapis.com") || t.includes("fonts.gstatic.com")), uo = (t)=>`@import url('${t}');`, Ef = (t)=>`@font-face { ${t} }`, zi = (t, e, r, n = {})=>{
    let o = vf(e), s = o ? ` format('${o}')` : "";
    return `
  font-family: '${t}';
  font-style: normal;${r ? `
  font-weight: ${r};` : ""}${n.fontStretch ? `
  font-stretch: ${n.fontStretch};` : ""}${n.fontDisplay ? `
  font-display: ${n.fontDisplay};` : ""}
  src: url('${e}')${s};`;
}, gr = (t, e, r, n)=>`@font-face {${zi(t, e, r, n)}
}`, cn = (t, e, r)=>Object.keys(e).map((o)=>{
        let { url: s, fontWeight: i } = e[o], a = Ie(s, r) || s;
        return zi(t, a, i);
    }), Fm = (t)=>Object.keys(t).map((r)=>cn(r, t[r].value)), Cf = (t, e, r)=>{
    if (e && e.isVariable) {
        let s = Ie(e.url, r) || e.url;
        return fo(s) ? uo(s) : gr(t, s, e.fontWeight, {
            fontStretch: e.fontStretch,
            fontDisplay: e.fontDisplay || "swap"
        });
    }
    if (e[0]) return cn(t, e, r).map(Ef);
    let o = Ie(e.url, r) || e.url;
    return gr(t, o);
}, qi = (t, e)=>Object.keys(t).map((n)=>Cf(n, t[n].value, e));
v();
v();
async function $m(t) {
    if (document.fullscreenElement) await document.exitFullscreen();
    else try {
        await (this.node || document).requestFullscreen();
    } catch (e) {
        console.warn(`Error attempting to enable fullscreen mode: ${e.message} (${e.name})`);
    }
}
v();
var kf = (t, e)=>(x(e) ? e : Object.values(e)).reduce((r, n)=>Math.abs(n - t) < Math.abs(r - t) ? n : r), Lm = (t, e)=>(t = parseFloat(t), g(e) && (e = Object.values(e)), kf(t, e));
var Mm = (t)=>{
    if (!t) return "";
    let e = new Date(t), r = new Intl.DateTimeFormat("en", {
        year: "numeric"
    }).format(e), n = new Intl.DateTimeFormat("en", {
        month: "short"
    }).format(e);
    return `${new Intl.DateTimeFormat("en", {
        day: "2-digit"
    }).format(e)} ${n}, ${r}`;
};
var Bm = function(e) {
    let r = [
        0,
        1
    ];
    for(let n = 2; n <= e; n++)r[n] = r[n - 1] + r[n - 2];
    return r[e];
};
var Um = (t, e = !1, r = document, n = "text/javascript")=>new Promise((o, s)=>{
        try {
            let i = r.createElement("script");
            i.type = n, i.async = e, i.src = t, i.addEventListener("load", (a)=>{
                o({
                    status: !0
                });
            }), i.addEventListener("error", (a)=>{
                s(new Error({
                    status: !1,
                    message: `Failed to load the script ${t}`
                }));
            }), r.body.appendChild(i);
        } catch (i) {
            s(i);
        }
    }), Vm = (t, e = document, r = "text/javascript")=>new Promise((n, o)=>{
        let s = e.createElement("script");
        s.type = r, s.src = t;
        let i = e.createElement("div");
        i.style.cssText = "position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;", e.body.appendChild(i), s.onload = ()=>{
            console.log(`Successfully loaded: ${t}`), e.body.removeChild(i), n();
        }, s.onerror = ()=>{
            e.body.removeChild(i), o(new Error(`Failed to load: ${t}`));
        }, e.body.appendChild(s);
    }), jm = (t, e = document, r, n = "text/javascript")=>{
    let o = new window.XMLHttpRequest;
    if (o.open("GET", t, !1), o.send(), o.status === 200) {
        let s = e.createElement("script");
        s.type = n, s.text = o.responseText, e.body.appendChild(s), typeof r == "function" && r();
    } else throw new Error(`Failed to load the script ${t}`);
}, zm = (t, e = !1, r = document, n = "text/javascript")=>new Promise((o, s)=>{
        try {
            let i = r.createElement("link");
            i.rel = "stylesheet", i.href = t, i.addEventListener("load", (a)=>{
                o({
                    status: !0
                });
            }), r.head.appendChild(i);
        } catch (i) {
            s(i);
        }
    }), qm = (t, e = !1, r = document, n = "text/javascript", o = "smbls-script")=>{
    try {
        let s = r.createElement("script");
        s.type = n, s.async = e, s.id = o, s.innerHTML = t, r.body.appendChild(s);
    } catch (s) {
        console.warn(s);
    }
};
function po(t, e = {}) {
    let { window: r = globalThis } = e, { document: n = r.document } = e;
    return new Promise((o, s)=>{
        let i = n.querySelector(`script[src="${t}"]`);
        if (i) return o(i);
        let a = n.createElement("script");
        a.src = t, a.async = e.async === !0, a.type = e.type || "text/javascript", e.id && (a.id = e.id), e.integrity && (a.integrity = e.integrity), e.crossOrigin && (a.crossOrigin = e.crossOrigin), a.onload = ()=>{
            a.onerror = a.onload = null, o(a);
        }, a.onerror = ()=>{
            a.onerror = a.onload = null, s(new Error(`Failed to load script: ${t}`));
        }, n.head.appendChild(a);
    });
}
async function Hm(t, e = {}) {
    let { window: r = globalThis } = e, { document: n = r.document } = e;
    return new Promise((o, s)=>{
        let i = n.querySelector(`link[href="${t}"]`);
        if (i) return o(i);
        let a = n.createElement("link");
        a.href = t, a.rel = e.rel || "stylesheet", a.type = "text/css", a.media = e.media || "all", e.id && (a.id = e.id), e.integrity && (a.integrity = e.integrity), e.crossOrigin && (a.crossOrigin = e.crossOrigin), a.onload = ()=>{
            a.onerror = a.onload = null, o(a);
        }, a.onerror = ()=>{
            a.onerror = a.onload = null, s(new Error(`Failed to load stylesheet: ${t}`));
        }, n.head.appendChild(a);
    });
}
var Wm = (t)=>[
        "jpeg",
        "gif",
        "jpg",
        "png",
        "tiff",
        "woff"
    ].includes(t);
function Gm(t) {
    return /^[0-9.]+$/.test(t) && t !== "";
}
var te = {
    skypack: {
        url: "https://cdn.skypack.dev",
        formatUrl: (t, e)=>`${te.skypack.url}/${t}${e !== "latest" ? `@${e}` : ""}`
    },
    esmsh: {
        url: "https://esm.sh",
        formatUrl: (t, e)=>`${te.esmsh.url}/${t}${e !== "latest" ? `@${e}` : ""}`
    },
    unpkg: {
        url: "https://unpkg.com",
        formatUrl: (t, e)=>`${te.unpkg.url}/${t}${e !== "latest" ? `@${e}` : ""}?module`
    },
    jsdelivr: {
        url: "https://cdn.jsdelivr.net/npm",
        formatUrl: (t, e)=>`${te.jsdelivr.url}/${t}${e !== "latest" ? `@${e}` : ""}/+esm`
    },
    symbols: {
        url: "https://pkg.symbo.ls",
        formatUrl: (t, e)=>t.split("/").length > 2 || !Gm(e) ? `${te.symbols.url}/${t}` : `${te.symbols.url}/${t}/${e}.js`
    }
}, yr = {
    "esm.sh": "esmsh",
    unpkg: "unpkg",
    skypack: "skypack",
    jsdelivr: "jsdelivr",
    "pkg.symbo.ls": "symbols"
}, ho = (t = {})=>{
    let { packageManager: e } = t;
    return yr[e] || null;
}, ee = (t, e = "latest", r = "esmsh")=>(te[r] || te.esmsh).formatUrl(t, e), Km = (t, e = "skypack")=>{
    let r = t.dependencies || {}, n = Object.keys(r);
    if (!n.length) return "";
    let o = {};
    for (let s of n){
        let i = r[s] || "latest";
        o[s] = ee(s, i, e);
    }
    return `<script type="importmap">{
    "imports": ${JSON.stringify(o, null, 2)}
  }<\/script>`;
};
v();
var gt = (t)=>{
    if (t == null) return "";
    let e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
    };
    return t.toString().replace(/[&<>"']/g, (r)=>e[r]);
}, Hi = (t)=>Object.entries(t || {}).filter(([e, r])=>r !== void 0).map(([e, r])=>`${e}="${gt(r)}"`).join(" "), Ym = (t, e)=>{
    if (!e) {
        let n = (()=>{
            let o = t?.favicon || t?.favicons;
            return o ? typeof o == "string" ? `<link rel="icon" href="${gt(o)}">` : Array.isArray(o) ? o.map((s)=>typeof s == "string" ? `<link rel="icon" href="${gt(s)}">` : `<link ${Hi({
                    rel: "icon",
                    ...s
                })}>`).join(`
`) : `<link ${Hi({
                rel: "icon",
                ...o
            })}>` : '<link rel="icon" href="/favicon.ico">';
        })();
        return [
            '<meta charset="UTF-8">',
            `<title>${gt(t.title || "Test")}</title>`,
            '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no">',
            '<meta name="robots" content="noindex">',
            '<meta name="apple-mobile-web-app-capable" content="yes">',
            n
        ].join(`
`);
    }
    return Object.entries(t).reduce((n, [o, s])=>{
        if (!s && s !== 0 && s !== !1) return n;
        if (o === "title") return n.push(`<title>${gt(s)}</title>`), n;
        if (o === "canonical") return n.push(`<link rel="canonical" href="${gt(s)}">`), n;
        if (o === "manifest") return n.push(`<link rel="manifest" href="${gt(s)}">`), n;
        if (o === "favicon" || o === "favicons" || o === "icon" || o === "icons") return (Array.isArray(s) ? s : [
            s
        ]).forEach((l)=>{
            if (typeof l == "string") n.push(`<link rel="icon" href="${gt(l)}">`);
            else if (typeof l == "object") {
                let u = Hi(l);
                /rel=/.test(u) ? n.push(`<link ${u}>`) : n.push(`<link rel="icon" ${u}>`);
            }
        }), n;
        if (o === "alternate") return (Array.isArray(s) ? s : [
            s
        ]).forEach((l)=>{
            if (typeof l == "object") {
                let u = Object.entries(l).filter(([p, d])=>d !== void 0).map(([p, d])=>`${p}="${gt(d)}"`).join(" ");
                n.push(`<link rel="alternate" ${u}>`);
            }
        }), n;
        let i = (f, l, u = "name")=>{
            if (typeof l == "string" || typeof l == "number" || typeof l == "boolean") n.push(`<meta ${u}="${gt(f)}" content="${gt(l)}">`);
            else if (Array.isArray(l)) l.forEach((p)=>{
                if (typeof p == "string" || typeof p == "number" || typeof p == "boolean") n.push(`<meta ${u}="${gt(f)}" content="${gt(p)}">`);
                else if (typeof p == "object") {
                    let d = Object.entries(p).filter(([h, m])=>m !== void 0).map(([h, m])=>`${h}="${gt(m)}"`).join(" ");
                    n.push(`<meta ${d}>`);
                }
            });
            else if (typeof l == "object") {
                let p = Object.entries(l).filter(([d, h])=>h !== void 0).map(([d, h])=>`${d}="${gt(h)}"`).join(" ");
                n.push(`<meta ${p}>`);
            }
        };
        if (o.startsWith("http-equiv:")) {
            let f = o.replace("http-equiv:", "");
            return i(f, s, "http-equiv"), n;
        }
        if (o.startsWith("itemprop:")) {
            let f = o.replace("itemprop:", "");
            return i(f, s, "itemprop"), n;
        }
        let c = [
            "og:",
            "twitter:",
            "fb:",
            "article:",
            "profile:",
            "book:",
            "business:",
            "music:",
            "product:",
            "video:",
            "DC:",
            "DCTERMS:"
        ].find((f)=>o.startsWith(f));
        if (c) {
            let f = o.replace(c, "");
            return i(`${c.replace(":", "")}:${f}`, s, c === "twitter:" || c === "DC:" || c === "DCTERMS:" ? "name" : "property"), n;
        }
        if (o.startsWith("apple:") || o.startsWith("msapplication:")) {
            let f = o.startsWith("apple:") ? "apple-" : "msapplication-", l = o.replace(/^apple:|^msapplication:/, "");
            return i(`${f}${l}`, s, "name"), n;
        }
        return i(o, s), n;
    }, [
        '<meta charset="UTF-8">',
        '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no">'
    ]).join(`
`);
}, Xm = (t)=>typeof t == "string" && t.length > 0 && !t.startsWith("/") && !t.startsWith("http");
function Qm(t, e) {
    if (!e || typeof e != "object") return t;
    let r = (o)=>{
        if (!Xm(o)) return o;
        let s = e[o];
        return s?.src ? s.src : o;
    }, n = {
        ...t
    };
    for (let [o, s] of Object.entries(n))typeof s == "string" ? n[o] = r(s) : Array.isArray(s) && (n[o] = s.map((i)=>typeof i == "string" ? r(i) : i));
    return n;
}
function mo(t, e) {
    if (!t || !e) return;
    let r = e.split("."), n = t;
    for (let o of r){
        if (n == null || typeof n != "object") return;
        n = n[o];
    }
    return n;
}
function Jm(t, e, r) {
    let o = (e.config || e.settings || {}).polyglot || e.polyglot, s = r?.lang || o?.defaultLang || "en", a = (o?.translations || {})[s] || {}, c = r?.state || {}, f = {
        ...t
    };
    for (let [l, u] of Object.entries(f))typeof u != "string" || !u.includes("{{") || (f[l] = u.replace(/\{\{\s*([^|{}]+?)\s*(?:\|\s*(\w+)\s*)?\}\}/g, (p, d, h)=>{
        let m = d.trim();
        if (h === "polyglot") return a[m] ?? mo(a, m) ?? p;
        if (h === "getLocalStateLang") return mo(c, m + s) ?? p;
        let S = mo(c, m);
        return S !== void 0 ? S : a[m] ?? mo(a, m) ?? p;
    }));
    return f;
}
function Of(t) {
    let e = {
        ...t
    };
    for (let [r, n] of Object.entries(e))if (typeof n == "function") {
        let o = n.toString(), s = o.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (s) {
            e[r] = `{{ ${s[1]} | getLocalStateLang }}`;
            continue;
        }
        let i = o.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (i) {
            e[r] = `{{ ${i[1]} | polyglot }}`;
            continue;
        }
        let a = o.match(/s\.(\w+(?:\.\w+)+)/);
        if (a) {
            e[r] = `{{ ${a[1]} }}`;
            continue;
        }
        delete e[r];
    } else if (typeof n == "string") {
        let o = n.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (o) {
            e[r] = `{{ ${o[1]} | getLocalStateLang }}`;
            continue;
        }
        let s = n.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (s) {
            e[r] = `{{ ${s[1]} | polyglot }}`;
            continue;
        }
        if (n.includes("=>") && n.includes("s.")) {
            let i = n.match(/s\.(\w+(?:\.\w+)+)/);
            if (i) {
                e[r] = `{{ ${i[1]} }}`;
                continue;
            }
        }
    }
    return e;
}
function Zm(t, e, r) {
    let n = t.pages?.[e], o = g(n?.state) && n?.state, s = n?.metadata || n?.helmet || o || {}, i = Of(s), a = new Set(Object.keys(i)), c = t.app?.metadata || {}, f = Of(c), l = {};
    t.integrations?.seo ? l = {
        ...t.integrations.seo,
        ...f,
        ...i
    } : Object.keys(f).length ? l = {
        ...f,
        ...i
    } : l = {
        ...i
    }, l.title || (l.title = t.name + " / symbo.ls"), l = Jm(l, t, r), l.title && (a.has("title") || !l["og:title"]) && (a.has("og:title") || (l["og:title"] = l.title)), l.description && (a.has("description") || !l["og:description"]) && (a.has("og:description") || (l["og:description"] = l.description)), l.title && !l["twitter:title"] && (l["twitter:title"] = l.title), l.description && !l["twitter:description"] && (l["twitter:description"] = l.description);
    let u = r?.actualPathname || e;
    if (l["og:url"] || l.url) {
        let d = (l["og:url"] || l.url || "").replace(/\/$/, "");
        if (d && u && u !== "/") {
            let h = u.startsWith("/") ? u : "/" + u;
            l["og:url"] = d + h;
        }
    }
    l = Qm(l, t.files);
    let p = t.name || t.app?.metadata?.title || t.app?.name || "";
    for (let [d, h] of Object.entries(l))if (typeof h == "string" && h.includes("{{")) {
        let m = h.replace(/\{\{[^}]*\}\}/g, "").trim();
        m ? l[d] = m : d === "title" ? l[d] = p : delete l[d];
    }
    return l;
}
var tg = async (t)=>{
    try {
        await navigator.clipboard.writeText(t);
    } catch (e) {
        console.warn("Failed to copy text: ", e);
    }
}, eg = async (t)=>{
    try {
        let e = new Blob([
            t
        ], {
            type: "text/javascript"
        }), r = new window.ClipboardItem({
            "text/plain": e
        });
        await navigator.clipboard.write([
            r
        ]), console.log("JavaScript code copied to clipboard as text/javascript");
    } catch (e) {
        console.error("Failed to copy JavaScript code: ", e);
    }
}, rg = (t)=>t.replace(/[^a-zA-Z0-9_]/g, ""), Wi = (t)=>t.replace(/(?:^\w|[A-Z]|\b\w)/g, function(e, r) {
        return r === 0 ? e.toLowerCase() : e.toUpperCase();
    }).replaceAll(/\s+/g, ""), ng = (t)=>t && t.replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.substr(1).toLowerCase()), Gi = (t)=>t.replace(/[^a-zA-Z0-9]/g, " ").trim().toLowerCase().replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, ""), og = (t = "")=>{
    if (typeof t != "string") return;
    let e = t.replace(/([A-Z])/g, " $1");
    return e.charAt(0).toUpperCase() + e.slice(1);
}, ln = (t)=>{
    if (x(t)) return t;
    if (b(t)) return t.split(" ");
    if (g(t)) return Object.values(t);
    if (ct(t)) return [
        t
    ];
};
v();
var Yi = {};
Mt(Yi, {
    CLASS: ()=>Ng,
    animation: ()=>kg,
    breakpoints: ()=>vg,
    cases: ()=>Cg,
    color: ()=>hg,
    devices: ()=>Eg,
    document: ()=>wg,
    font: ()=>ag,
    font_face: ()=>fg,
    font_family: ()=>cg,
    font_family_types: ()=>lg,
    gradient: ()=>mg,
    grid: ()=>Ig,
    icons: ()=>bg,
    media: ()=>ug,
    reset: ()=>Dg,
    semantic_icons: ()=>Sg,
    sequence: ()=>Pe,
    shadow: ()=>yg,
    spacing: ()=>dg,
    svg: ()=>Og,
    svg_data: ()=>Ag,
    templates: ()=>Tg,
    theme: ()=>gg,
    timing: ()=>_g,
    typography: ()=>Ki,
    unit: ()=>sg
});
var Pe = {
    "minor-second": 1.067,
    "major-second": 1.125,
    "minor-third": 1.2,
    "major-third": 1.25,
    "perfect-fourth": 1.333,
    "augmented-fourth": 1.414,
    "perfect-fifth": 1.5,
    "minor-sixth": 1.6,
    phi: 1.618,
    "major-sixth": 1.667,
    "square-root-3": 1.732,
    "minor-seventh": 1.778,
    "major-seventh": 1.875,
    octave: 2,
    "square-root-5": 2.23,
    "major-tenth": 2.5,
    "major-eleventh": 2.667,
    "major-twelfth": 3,
    pi: 3.14,
    "double-octave": 4
};
var sg = {
    default: "em"
};
var ig = {
    browserDefault: 16,
    base: 16,
    type: "font-size",
    ratio: Pe["minor-third"],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: !0,
    mediaRegenerate: !1,
    unit: "em",
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
}, Ki = ig;
var ag = {};
var cg = {}, lg = {
    "sans-serif": "Helvetica, Arial, sans-serif, --system-default",
    serif: "Times New Roman, Georgia, serif, --system-default",
    monospace: "Courier New, monospace, --system-default"
}, fg = {};
var ug = {
    tv: "(min-width: 2780px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};
var pg = {
    base: Ki.base,
    type: "spacing",
    ratio: Pe.phi,
    range: [
        -5,
        15
    ],
    subSequence: !0,
    mediaRegenerate: !1,
    unit: "em",
    sequence: {},
    scales: {},
    vars: {}
}, dg = pg;
var hg = {}, mg = {};
var gg = {};
var yg = {};
var bg = {}, Sg = {};
var xg = {
    default: 150,
    base: 150,
    type: "timing",
    ratio: Pe["perfect-fourth"],
    range: [
        -3,
        12
    ],
    mediaRegenerate: !1,
    unit: "ms",
    sequence: {},
    scales: {},
    vars: {}
}, _g = xg;
var wg = {};
var vg = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
}, Eg = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};
var Cg = {};
var kg = {};
var Og = {}, Ag = {};
var Tg = {};
var Rg = {}, Ig = Rg;
var Pg = {}, Ng = Pg;
var Dg = {};
var Fg = {}, $g = {}, fn = Yi, un = {}, Lg = (t)=>t.replace(/_([a-z])/g, (e, r)=>r.toUpperCase()), Mg = (t)=>t.replace(/([A-Z])/g, "_$1").toUpperCase();
for(let t in fn){
    let e = t.toLowerCase();
    un[e] = fn[t];
    let r = Lg(e);
    r !== e && (un[r] = fn[t]), e !== t && (un[t] = fn[t]);
    let n = Mg(t);
    n !== t && (un[n] = fn[t]);
}
var Xi = {
    verbose: !1,
    useVariable: !0,
    useReset: !0,
    globalTheme: "auto",
    CSS_VARS: Fg,
    CSS_MEDIA_VARS: $g,
    ...un
}, Bg = z(Xi), Ne = {
    active: "0",
    0: Xi
}, eE = (t)=>(Ot(t) && (Ne.active = t), Ne[t || Ne.active]), C = (t)=>Ne[t || Ne.active] || Xi, Af = (t)=>{
    if (g(t)) return Ne.active = "1", Ne[1] = U(t, z(Bg)), t;
};
var De = {
    "-6": "U",
    "-5": "V",
    "-4": "W",
    "-3": "X",
    "-2": "Y",
    "-1": "Z",
    0: "A",
    1: "B",
    2: "C",
    3: "D",
    4: "E",
    5: "F",
    6: "G",
    7: "H",
    8: "I",
    9: "J",
    10: "K",
    11: "L",
    12: "M",
    13: "N",
    14: "O",
    15: "P",
    16: "Q",
    17: "R",
    18: "S",
    19: "T"
}, Qi = (t, e)=>{
    let { key: r, variable: n, value: o, scaling: s, index: i, scalingVariable: a } = t;
    e.sequence[r] = {
        key: r,
        decimal: ~~(o * 100) / 100,
        val: ~~o,
        scaling: s,
        index: i,
        scalingVariable: a,
        variable: n
    }, e.scales[r] = s, e.vars[n] = s + e.unit;
}, Fe = (t)=>{
    if (!t.includes("(")) return t;
    let e = t.split("(")[0], r = t.slice(t.indexOf("(") + 1, t.lastIndexOf(")"));
    return [
        e,
        r
    ];
}, Ji = (t, e)=>{
    let { base: r, type: n, unit: o } = e, s = (nn(o) ? 1 : r) + o;
    if (t === 0) return s;
    let i = "--" + (n && n.replace(".", "-")), a = `${i}-ratio`;
    if (t > 0) {
        let c = De[t - 1];
        return `calc(var(${i}-${c}) * var(${a}))`;
    }
    if (t < 0) {
        let c = De[t + 1];
        return `calc(var(${i}-${c}) / var(${a}))`;
    }
}, Tf = (t, e, r, n)=>{
    let { type: o } = n, i = t === 2 && e.length === 2 ? t + 1 : t, c = `${"--" + (o && o.replace(".", "-"))}-sub-ratio-`;
    return `calc(var(${r}) * var(${c + i}))`;
}, Zi = (t, e)=>{
    let n = (t * e - t) / 1.618, o = t * e - n, s = t + n, i = (o + s) / 2;
    return [
        o,
        i,
        s
    ];
}, ta = (t, e)=>Zi(t, e).map((r)=>r / t), ea = (t, e)=>{
    let { key: r, base: n, value: o, ratio: s, variable: i, index: a } = t, f = ~~(o * s) - ~~o, l, [u, p, d] = Zi(o, s);
    f > 16 ? l = [
        u,
        p,
        d
    ] : l = [
        u,
        d
    ], l.forEach((h, m)=>{
        let S = ~~(h / n * 1e3) / 1e3, _ = i + (m + 1), w = a + (m + 1) / 10, E = Tf(m + 1, l, i, e), R = {
            key: r + (m + 1),
            variable: _,
            value: h,
            scaling: S,
            scalingVariable: E,
            index: w
        };
        Qi(R, e);
    });
}, Ug = (t, e, r)=>e * Math.pow(r, t), Kt = (t)=>{
    let { type: e, base: r, ratio: n, range: o, subSequence: s } = t, i = Math.abs(o[0]) + Math.abs(o[1]), a = "--" + (e && e.replace(".", "-")) + "-";
    for(let c = 0; c <= i; c++){
        let f = o[1] - c, l = De[f], u = Ug(f, r, n), p = ~~(u / r * 100) / 100, d = a + l, h = Ji(f, t), m = {
            key: l,
            variable: d,
            value: u,
            base: r,
            scaling: p,
            scalingVariable: h,
            ratio: n,
            index: f
        };
        Qi(m, t), s && ea(m, t);
    }
    return t;
}, Vg = (t, e = 0)=>{
    let { type: r, base: n, ratio: o, subSequence: s } = t, i = b(e) ? e : De[e], a = b(e) ? Object.entries(De).find(([, m])=>m === e)?.[0] : e;
    if (!i) return console.warn(`Position ${e} is out of range in numToLetterMap`), null;
    let c = {
        sequence: {},
        scales: {},
        vars: {},
        ...t
    }, f = n * Math.pow(o, a), l = ~~(f / n * 100) / 100, p = "--" + (r && r.replace(".", "-")) + "-" + i, d = Ji(a, t), h = {
        key: i,
        variable: p,
        value: f,
        base: n,
        scaling: l,
        scalingVariable: d,
        ratio: o,
        index: a
    };
    return Qi(h, c), s && ea(h, c), c;
}, ra = (t = "A", e)=>{
    let r = C(), { unit: n } = r;
    if (b(t) && nt(t)) return `var(${t})`;
    let { sequence: o, unit: s = n.default, useVariable: i } = e, a = /^-?[a-zA-Z]/i, c = a.test(t);
    if (on.some((w)=>t.includes(w)) || !c || [
        "none",
        "auto",
        "max-content",
        "min-content",
        "fit-content",
        "inherit",
        "initial",
        "unset",
        "revert",
        "revert-layer"
    ].includes(t)) return t;
    let u = `--${Gi(e.type.replace(".", "-"))}-`, p = t.toUpperCase(), d = p.slice(0, 1) === "-" ? "-" : "", h = d ? p.slice(1) : p, m = "";
    h.includes("_") && (m = "_" + h.split("_")[1].toLowerCase(), h = h.split("_")[0]);
    let S = (w)=>a.test(w) ? `var(${u}${w}${m})` : w;
    if (h.includes("+")) {
        let [w, E] = h.split("+"), R = `${S(w)} + ${S(E)}`;
        return d ? `calc((${R}) * -1)` : `calc(${R})`;
    } else if (h.includes("*")) {
        let [w, E] = h.split("*"), R = `${S(w)} * ${S(E)}`;
        return d ? `calc((${R}) * -1)` : `calc(${R})`;
    } else if (h.includes("-")) {
        let [w, E] = h.split("-"), R = `${S(w)} - ${S(E)}`;
        return d ? `calc((${R}) * -1)` : `calc(${R})`;
    }
    if (!o[h] && h.length === 2 && (r.verbose && console.warn(h, "- value is not found because `subSequence` is set to false"), h = h.slice(0, 1)), i || r.useVariable) {
        let w = `var(${u}${h}${m})`;
        return d ? `calc(${w} * -1)` : w;
    }
    let _ = o ? o[h] : null;
    return _ ? s === "ms" || s === "s" ? d + _.val + s : d + _.scaling + s : console.warn("can't find", o, h);
}, Rf = (t, e)=>{
    let r = [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((n)=>t.includes(n + " "));
    return r.length ? r.map((n)=>t.split(n + " ").map((i)=>i.trim()).map((i)=>ra(i, e)).join(" " + n + " ")).join("") : t;
}, be = (t, e, r, n)=>{
    if (typeof t != "string") return C().verbose && console.warn(e, t, "is not a string"), {
        [e]: t
    };
    if (t === "-" || t === "") return {};
    if (!n && t.includes("(")) {
        let s = Fe(t);
        n = s[0], t = s[1];
    }
    return [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((s)=>t.includes(s + " ")).length ? t = Rf(t, r) : t = ra(t, r), {
        [e]: n ? `${n}(${t})` : t
    };
}, If = (t, e)=>De[t - e], na = (t)=>{
    let { h1Matches: e, sequence: r } = t;
    return new Array(6).fill(null).map((n, o)=>{
        let s = If(e, o);
        return r[s];
    });
};
v();
var jg = (t, e)=>{
    let r = C(), { CSS_VARS: n } = r;
    N(t.value) || (n[t.var] = t.value);
}, oa = (t, e, r)=>{
    let n = C(), { unit: o } = n, s = e.unit || o.default, { base: i, ratio: a, type: c } = e, f = "--" + (c && c.replace(".", "-"));
    t[`${f}-base`] = i, t[`${f}-unit`] = s;
    let l = `${f}-ratio`;
    t[l] = a;
    let [u, p, d] = ta(i, a);
    t[`${f}-sub-ratio-1`] = `calc(var(${f}-ratio) * ${u / a})`, t[`${f}-sub-ratio-2`] = `calc(var(${f}-ratio) * ${p / a})`, t[`${f}-sub-ratio-3`] = `calc(var(${f}-ratio) * ${d / a})`;
}, $e = (t, e = {})=>{
    let r = C(), { unit: n, timing: o, CSS_VARS: s } = r, i = t.unit || n.default, { mediaRegenerate: a, sequence: c, scales: f } = t;
    a || oa(s, t, e);
    for(let l in c){
        let u = c[l], p = (t.type === o.type ? c[l].val : f[l]) + i;
        if (!a) {
            s[u.variable + "_default"] = p, s[u.variable] = u.scalingVariable;
            continue;
        }
        e.useDefault === !1 ? s[u.variable] = p : (s[u.variable + "_default"] = p, s[u.variable] = `var(${u.variable + "_default"})`);
    }
}, br = (t, e, r = {})=>{
    let n = C(), { unit: o, media: s, CSS_VARS: i } = n, a = e.slice(1), c = t.unit || o.default, { mediaRegenerate: f } = t, { sequence: l, scales: u } = t[e], p = s[a];
    if (!p && n.verbose && console.warn("Can't find media query ", p), !f) {
        let d = i[`@media ${p}`];
        d || (d = i[`@media ${p}`] = {}), oa(d, t[e], r);
        return;
    }
    for(let d in l){
        let h = l[d], m = (nn(c) ? u[d] : l[d].val) + c;
        !p && n.verbose && console.warn("Can't find query ", p);
        let S = i[`@media ${p}`];
        S || (S = i[`@media ${p}`] = {}), S[h.variable] = `var(${h.variable + "_" + a})`, i[h.variable + "_" + a] = m;
    }
};
v();
var zg = Br(), go = (t)=>{
    let e = C(), r = "";
    for(let n in t)e.__svg_cache[n] || (e.__svg_cache[n] = !0, r += t[n]);
    return r;
}, qg = (t)=>{
    let e = t.default || t;
    if (!b(e)) {
        zg && console.warn("parseRootAttributes:", e, "is not a string");
        return;
    }
    let r = e.match(/<svg\s+(.*?)>/);
    return !r || !r[1] ? {} : r[1].match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm).reduce((s, i)=>{
        let [a, c] = i.split("=");
        return s[a] = c.replace(/['"]/g, ""), s;
    }, {});
}, Hg = (t, e)=>{
    let r = /id="([^"]*)"/, n = /url\(#([^)]*)\)/g, o = t.match(/id="([^"]*)"/g), s = t;
    return x(o) && o.forEach(()=>{
        let i = Math.floor(Math.random() * 1e5);
        s = t.replace(r, `id="${e}-${i}"`).replace(n, `url(#${e}-${i})`);
    }), s;
}, sa = (t, e)=>{
    let r = qg(e), { width: n, height: o } = r, s = r.viewBox || `0 0 ${n || 24} ${o || 24}`, c = Hg(e, t).replace("<svg", `<symbol id="${t}" xmlns="http://www.w3.org/2000/svg" viewBox="${s}"`);
    return c = c.replace(/width="[^"]*"/, ""), c = c.replace(/height="[^"]*"/, ""), c = c.replace("</svg", "</symbol"), c;
};
var xo = {};
Mt(xo, {
    appendSVGSprite: ()=>_a,
    appendSvgIconsSprite: ()=>va,
    applyDocument: ()=>Sa,
    applyHeadings: ()=>$f,
    applyReset: ()=>Ea,
    applySpacingSequence: ()=>ma,
    applyTimingSequence: ()=>ba,
    applyTypographySequence: ()=>pa,
    checkIfBoxSize: ()=>ha,
    getColor: ()=>J,
    getFontFamily: ()=>ua,
    getFontSizeByKey: ()=>da,
    getMediaColor: ()=>Ct,
    getMediaTheme: ()=>Yt,
    getShadow: ()=>ya,
    getSpacingBasedOnRatio: ()=>Le,
    getSpacingByKey: ()=>at,
    getTheme: ()=>aa,
    getTimingByKey: ()=>Ut,
    getTimingFunction: ()=>Dt,
    runThroughMedia: ()=>Ff,
    setColor: ()=>xr,
    setFont: ()=>fa,
    setFontFamily: ()=>bo,
    setGradient: ()=>_r,
    setMediaTheme: ()=>la,
    setSVG: ()=>So,
    setShadow: ()=>wr,
    setSvgIcon: ()=>wa,
    setTheme: ()=>ca,
    splitSpacedValue: ()=>ga
});
v();
var J = (t, e, r)=>{
    let n = r || C();
    if (!b(t)) {
        n.verbose && console.warn(t, "- type for color is not valid");
        return;
    }
    if (nt(t)) return `var(${t})`;
    e && t[e] && (t = t[e]);
    let o, s, i;
    if (x(t)) [o, s, i] = t;
    else {
        let u = hr(t);
        if (!u) return t;
        if (u.passthrough) return u.passthrough;
        if (u.cssVar) return `var(${u.cssVar})`;
        o = u.name, s = u.alpha, i = u.tone;
    }
    let { color: a, gradient: c } = n, f = a[o] || c[o];
    if (!f) return n.verbose && console.warn("Can't find color ", o), t;
    e && (f[e] ? f = f[e] : n.verbose && console.warn(t, " - does not have ", e));
    let l = f.rgb;
    return l ? (i && !f[i] && (l = sn(l, i), f[i] = {
        rgb: l,
        var: `${f.var}-${i}`
    }), f[i] && (l = f[i].rgb), s ? `rgba(${l}, ${s})` : i ? `rgba(${l}, 1)` : n.useVariable ? `var(${f.var})` : `rgb(${l})`) : n.useVariable ? `var(${f.var})` : f.value;
}, Ct = (t, e, r)=>{
    let n = r || C();
    if (e || (e = n.globalTheme === "auto" ? null : n.globalTheme), !b(t)) {
        n.verbose && console.warn(t, "- type for color is not valid");
        return;
    }
    if (nt(t)) return `var(${t})`;
    let o;
    if (x(t)) o = t[0];
    else {
        let f = hr(t);
        if (!f) return t;
        if (f.passthrough) return f.passthrough;
        if (f.cssVar) return `var(${f.cssVar})`;
        o = f.name;
    }
    let { color: s, gradient: i } = n, a = s[o] || i[o], c = g(a);
    if (c && a.value) return J(t, `@${e}`, r);
    if (c) {
        if (e) return J(t, `@${e}`, r);
        {
            let f = {};
            for(let l in a){
                let u = n.media[l.slice(1)], p = "@media " + (u === "print" ? `${u}` : `screen and ${u}`);
                f[p] = J(t, l, r);
            }
            return f;
        }
    } else return n.verbose && console.warn("Can't find color", t), t;
}, xr = (t, e, r)=>{
    let n = C();
    if (b(t) && nt(t)) {
        let d = t.slice(2);
        if (t = J(d), !(t.includes("rgb") || t.includes("var") || t.includes("#"))) {
            let h = d.split(" "), m = n.color[h[0]];
            if (m && m.value) {
                let S = m.rgb, _ = h[1] !== void 0 ? h[1] : "1", w = h[2];
                w && (S = sn(S, w)), t = `rgba(${S}, ${_})`;
            } else {
                let S = h[2], _ = h[1] !== void 0 ? h[1] : "1";
                if (S) try {
                    let w = ge(h[0]);
                    w && w.length >= 3 ? t = `rgba(${sn(w.slice(0, 3).join(", "), S)}, ${_})` : t = h[0];
                } catch  {
                    t = h[0];
                }
                else t = h[0];
            }
        }
    }
    if (x(t)) return {
        "@light": xr(t[0], e, "light"),
        "@dark": xr(t[1], e, "dark")
    };
    if (g(t)) {
        let d = {};
        for(let h in t)d[h] = xr(t[h], e, h.slice(0, 1) === "@" ? h.slice(1) : h);
        return d;
    }
    let o = `--color-${e}` + (r ? `-${r}` : ""), s = ge(t.value || t), [i, a, c, f = 1] = s, l = parseFloat(f.toFixed(2)), u = `${i}, ${a}, ${c}`, p = `rgba(${u}, ${l})`;
    return n.useVariable && (n.CSS_VARS[o] = p), {
        var: o,
        rgb: u,
        alpha: l,
        value: p
    };
}, _r = (t, e, r)=>{
    let n = C();
    if (b(t) && nt(t) && (t = J(t.slice(2))), x(t)) return {
        "@light": _r(t[0], e, "light"),
        "@dark": _r(t[0], e, "dark")
    };
    if (g(t)) {
        let s = {};
        for(let i in t)s[i] = _r(t[i], e, i.slice(0, 1) === "@" ? i.slice(1) : i);
        return s;
    }
    let o = `--gradient-${e}` + (r ? `-${r}` : "");
    return n.useVariable && (n.CSS_VARS[o] = t.value || t), {
        var: o,
        value: t.value || t
    };
};
v();
var yo = (t)=>{
    let e = {}, { state: r, media: n, helpers: o, ...s } = t;
    return Object.keys(s).map((a)=>{
        let f = [
            "color",
            "Color",
            "background",
            "border"
        ].some((l)=>a.includes(l));
        return e[a] = f ? J(t[a]) : t[a];
    }), e;
}, pn = (t)=>(t.value || (t.value = yo(t)), t.value), aa = (t, e)=>{
    let r = C();
    if (r.useVariable) return Yt(t, e);
    let n = r.theme;
    if (b(t)) {
        let [o, s] = t.split(" "), i = n[o];
        if (i) {
            if (!s && !e) return pn(i);
            t = [
                o,
                s || e
            ];
        }
    }
    if (N(t) && t[1]) {
        let o = t[0], s = t[1], { helpers: i, media: a, state: c } = n[o];
        if (a && a[s]) return pn(a[s]);
        if (i && i[s]) return pn(i[s]);
        if (c && c[s]) return pn(c[s]);
    } else if (g(t)) return yo(t);
}, Wg = (t, e, r)=>{
    if (g(e)) t.variants.inverse.value = yo(e);
    else if (e === !0) {
        let { color: n, background: o } = r;
        t.variants.inverse = {
            value: {
                color: o,
                background: n
            }
        };
    }
}, Gg = (t, e, r, n)=>{
    let o = aa(r);
    n[`&:${e}`] = o, g(r) && !r.value && (r.value = o);
}, Kg = (t, e)=>{
    let { state: r } = t;
    return r ? (Object.keys(r).map((o)=>{
        let s = r[o];
        return Gg(t, o, s, e), t;
    }), t) : void 0;
}, Yg = (t, e, r, n)=>{
    let o = aa(r);
    n[`@media (prefers-color-scheme: ${e})`] = o, g(r) && !r.value && (r.value = o);
}, Xg = (t, e)=>{
    let { media: r } = t;
    return r ? (Object.keys(r).map((o)=>{
        let s = r[o];
        return (o === "dark" || o === "light") && Yg(t, o, s, e), o === "inverse" && Wg(t, s, e), t;
    }), t) : void 0;
}, Qg = (t, e)=>{
    let r = C(), { helpers: n } = t;
    return n ? (Object.keys(n).map((s)=>{
        let i = n[s];
        return b(i) ? n[s] = r.theme[i] : pn(n[s]), t;
    }), t) : void 0;
}, ca = (t, e)=>{
    if (C().useVariable) return la(t, e);
    let { state: n, media: o, helpers: s } = t, i = yo(t, e), a = `--theme-${e}`;
    return Kg(t, i), Xg(t, i), Qg(t, i), {
        var: a,
        value: i,
        state: n,
        media: o,
        helpers: s
    };
};
var ia = (t, e, r)=>{
    let { CSS_VARS: n } = r;
    r.CSS_MEDIA_VARS || (r.CSS_MEDIA_VARS = {});
    let o = r.CSS_MEDIA_VARS, s = r.globalTheme !== void 0 ? r.globalTheme : "auto", i = {}, a = new Set;
    for(let c in t)if (t[c]) for (let f of Object.keys(t[c]))a.add(f);
    for (let c of a){
        let f = c.slice(0, 1), l = Object.values(t).some((u)=>N(u?.[c]));
        if (f === "." && l) {
            let u = c.slice(1), p = {};
            for(let d in t)N(t[d]?.[c]) && (p[d] = t[d][c]);
            i[c] = ia(p, `${e}-${u}`, r);
        } else if (f === ":" && l) {
            let u = c.replace(/^:+/, ""), p = {};
            for(let d in t)N(t[d]?.[c]) && (p[d] = t[d][c]);
            i[c] = ia(p, `${e}-${u}`, r);
        } else if (f !== "@" && f !== "." && f !== ":") {
            let u = `--theme-${e}-${c}`;
            if (s === "auto") for(let p in t){
                let d = t[p]?.[c];
                if (d === void 0) continue;
                let h = J(d, `@${p}`);
                if (h === void 0) continue;
                let m = `[data-theme="${p}"]`;
                if (o[m] || (o[m] = {}), o[m][u] = h, p === "dark" || p === "light") {
                    let S = `@media (prefers-color-scheme: ${p})`;
                    o[S] || (o[S] = {}), o[S][u] = h;
                }
            }
            else {
                let p = String(s).replace(/^'|'$/g, ""), d = t[p]?.[c];
                if (d !== void 0) {
                    let h = J(d, `@${p}`);
                    h !== void 0 && (n[u] = h);
                }
            }
            i[c] = `var(${u})`, i[`.${c}`] = {
                [c]: i[c]
            };
        }
    }
    return (i.background || i.color || i.backgroundColor) && (i[".inversed"] = {
        color: i.background || i.backgroundColor,
        background: i.color
    }), i;
}, la = (t, e, r, n)=>{
    let o = C(), { CSS_VARS: s } = o, i = {
        value: t
    }, a = !r && !n;
    if (N(t)) {
        if (a && o.useVariable) {
            let c = {};
            for(let f in t)f.startsWith("@") && N(t[f]) && (c[f.slice(1)] = t[f]);
            if (Object.keys(c).length) {
                let f = ia(c, e, o);
                Object.assign(i, f);
            }
        }
        for(let c in t){
            let f = c.slice(0, 1), l = t[c];
            if (f === "@" || f === ":" || f === ".") {
                let u = f === "@" && c;
                i[c] = la(l, e, c, n || u);
            } else if (!a) {
                let u = J(l, n), p = [
                    ...new Set([
                        n,
                        r
                    ].filter((m)=>m).map((m)=>m.slice(1)))
                ], d = p.length ? "-" + p.join("-") : "", h = `--theme-${e}${d}-${c}`;
                o.useVariable ? (o.useThemeSuffixedVars && (s[h] = u), i[c] = `var(${h})`) : i[c] = u, i[`.${c}`] = {
                    [c]: i[c]
                };
            }
        }
        !i[".inversed"] && (i.background || i.color || i.backgroundColor) && (i[".inversed"] = {
            color: i.background || i.backgroundColor,
            background: i.color
        });
    }
    if (b(t) && nt(t)) {
        let f = o.theme[t.slice(2)];
        return Yt(f, n);
    }
    return i;
}, Nf = (t)=>{
    let e = C(), r = {};
    for(let n in t){
        let o = n.slice(0, 1);
        if (N(t[n])) {
            if (o === "@") continue;
            o === ":" && (r[`&${n}`] = Nf(t[n]));
        } else r[n] = t[n];
    }
    return r;
}, Df = (t, e)=>{
    let r = e.shift();
    return t[r] ? Df(t[r], e) : t;
}, Pf = (t, e)=>x(e) ? Df(t, e) : b(e) && t[e] ? t[e] : t;
var Yt = (t, e)=>{
    let r = C();
    if (b(t) && nt(t) && (t = Yt(t.slice(2))), !t || !b(t)) {
        r.verbose && console.warn(`${t} - Theme is not a string`);
        return;
    }
    let [n, ...o] = x(t) ? t : t.split(" "), s = r.theme[n];
    return s && o.length ? s = Pf(s, o) : s && e && (s = Pf(s, e)), Nf(s);
};
v();
var fa = (t, e)=>{
    let r = C(), n = `--font-${e}`;
    if (!t || x(t) && !t[0]) return;
    let o;
    if (t.isVariable) {
        let s = Ie(t.url, r.files) || t.url;
        fo(s) ? o = uo(s) : o = gr(e, s, t.fontWeight, {
            fontStretch: t.fontStretch,
            fontDisplay: t.fontDisplay || "swap"
        });
    } else if (t[0]) o = cn(e, t, r.files);
    else {
        let s = Ie(t.url, r.files) || t.url;
        o = gr(e, s);
    }
    return {
        var: n,
        value: t,
        fontFace: o
    };
}, ua = (t, e)=>{
    let r = C(), { font_family: n } = r;
    return an(e || n, t);
}, bo = (t, e)=>{
    let r = C(), { font_family: n, font_family_types: o } = r, { value: s, type: i } = t;
    t.isDefault && (n.default = e), g(s) && (s = ln(s));
    let a = `--font-family-${e}`, c = `${s.join(", ")}, ${o[i]}`;
    return {
        var: a,
        value: c,
        arr: s,
        type: i
    };
};
v();
var Ff = (t)=>{
    let e = C(), { typography: r, media: n } = e;
    for(let o in t){
        let s = o.slice(0, 1) === "@", i = t[o];
        if (!s) continue;
        let { mediaRegenerate: a } = t, c = o.slice(1), { type: f, base: l, ratio: u, range: p, subSequence: d, h1Matches: h, unit: m } = t;
        Y(i, {
            type: f,
            base: l,
            ratio: u,
            range: p,
            subSequence: d,
            h1Matches: h,
            unit: m
        });
        let S = n[c], _ = "@media " + (S === "print" ? `${S}` : `screen and ${S}`);
        if (r.templates[_] = {
            fontSize: i.base / r.browserDefault + m
        }, !a) {
            br(t, o);
            continue;
        }
        Y(i, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        }), Kt(i), br(t, o);
    }
}, $f = (t)=>{
    let e = C();
    if (t.h1Matches) {
        let r = t.unit, n = na(t), { templates: o } = t;
        for(let s in n){
            let i = `h${parseInt(s) + 1}`, a = o[i];
            o[i] = {
                fontSize: e.useVariable ? `var(${n[s]?.variable})` : `${n[s]?.scaling}${r}`,
                margin: a ? a.margin : 0,
                lineHeight: a ? a.lineHeight : t.lineHeight,
                letterSpacing: a ? a.letterSpacing : t.letterSpacing,
                fontWeight: a ? a.fontWeight : 900 - s * 100
            };
        }
    }
}, pa = ()=>{
    let t = C(), { typography: e } = t;
    Kt(e), $f(e), $e(e), Ff(e);
}, da = (t)=>{
    let e = C(), { typography: r } = e;
    return be(t, "fontSize", r);
};
v();
var Jg = (t)=>{
    for(let e in t){
        let r = t[e];
        if (!(e.slice(0, 1) === "@")) continue;
        let { type: o, base: s, ratio: i, range: a, subSequence: c, h1Matches: f, unit: l } = t;
        Y(r, {
            type: o,
            base: s,
            ratio: i,
            range: a,
            subSequence: c,
            h1Matches: f,
            unit: l,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        }), Kt(r), br(t, e);
    }
}, ha = (t)=>{
    let e = t.toLowerCase(), r = e.includes("width") || e.includes("height"), n = e.includes("border") || e.includes("outline");
    return r && !n;
}, ma = ()=>{
    let t = C(), { spacing: e } = t;
    Kt(e), $e(e), Jg(e);
}, Zg = (t)=>{
    let e = C(), { spacing: r } = e;
    return !t || !t.sequence ? r : Object.keys(t.sequence).length > 0 ? t : Kt(t);
}, at = (t, e = "padding", r, n)=>{
    let o = Zg(r);
    if (b(t) && !n && t.includes("(")) {
        let i = Fe(t);
        n = i[0], t = i[1];
    }
    let s = n ? [
        t
    ] : ln(t);
    if (x(s)) {
        if (s.length > 1) {
            let i = "";
            e === "borderWidth" && (e = "border", i = "Width");
            let a = {
                2: [
                    "Block",
                    "Inline"
                ],
                3: [
                    "BlockStart",
                    "Inline",
                    "BlockEnd"
                ],
                4: [
                    "BlockStart",
                    "InlineEnd",
                    "BlockEnd",
                    "InlineStart"
                ]
            }, c = (f, l)=>be(s[l], e + f + i, o, n);
            return a[s.length].map((f, l)=>c(f, l));
        }
        return be(t, e, o, n);
    }
}, Le = (t, e, r, n)=>{
    let o = C(), { spacing: s } = o, i = r || t[e];
    if (!n && b(i) && i.includes("(")) {
        let a = Fe(i);
        n = a[0], i = a[1];
    }
    if (t.spacingRatio) {
        let a = applyCustomSequence(t);
        return at(i, e, a, n);
    }
    return at(i, e, s, n);
}, ga = (t)=>{
    let e = (r)=>{
        let n = [
            "+",
            "-",
            "*",
            "/"
        ].includes(r), o = on.some((i)=>t.includes(i));
        return n || o ? r : r.length < 3 && /[A-Z]/.test(r) ? r + "_default" : r;
    };
    return t.split(",").map((r)=>r.trim()).map(e).join(",").split(" ").map(e).join(" ");
};
v();
var wr = (t, e, r, n)=>{
    let o = C();
    if (x(t)) return {
        "@light": wr(t[0], e, "light"),
        "@dark": wr(t[1], e, "dark")
    };
    if (g(t)) {
        let i = {};
        for(let a in t)i[a] = wr(t[a], e, a.startsWith("@") ? a.slice(1) : a);
        return i;
    }
    b(t) && !Zt.test(t) && (t = mr(t).map((i)=>(i = i.trim(), i.split(/\s+/).map((a)=>{
            if (a = a.trim(), !a) return "";
            if (a.startsWith("--")) return `var(${a})`;
            let c = J(a);
            if (ye(c)) return c;
            if (/^\d/.test(a) || a === "0" || a.includes("px") || a.slice(-2) === "em" || a === "inset" || a === "none") return a;
            let f = at(a, "shadow");
            return f && f.shadow ? f.shadow : a;
        }).join(" "))).join(", "));
    let s = `--shadow-${e}` + (r ? `-${r}` : "");
    return o.useVariable && (o.CSS_VARS[s] = t), {
        var: s,
        value: t
    };
}, ya = (t, e)=>{
    let r = C();
    if (e || (e = r.globalTheme), !b(t)) {
        r.verbose && console.warn(t, "- type for color is not valid");
        return;
    }
    if (nt(t)) return `var(${t})`;
    let [n] = x(t) ? t : t.split(" "), s = r.shadow[n], i = g(s);
    if (!s) return r.verbose && console.warn("Can't find color ", n), t;
    if (e) {
        if (s[e]) return s[e].value;
        r.verbose && console.warn(t, " - does not have ", e);
    }
    if (i && s.value) return s.value;
    if (i) {
        let a = {};
        for(let c in s){
            let f = r.media[c.slice(1)], l = "@media " + (f === "print" ? `${f}` : `screen and ${f}`);
            a[l] = s.value;
        }
        return a;
    }
    return r.verbose && console.warn("Can't find color", t), t;
};
var ba = ()=>{
    let t = C(), { timing: e } = t;
    Kt(e), $e(e);
}, Dt = (t)=>{
    let e = C(), { timing: r } = e;
    return r[t] || r[Wi(t)] || t;
}, Ut = (t, e = "timing")=>{
    let r = C(), { timing: n } = r;
    return be(t, e, n);
};
v();
var Sa = ()=>{
    let t = C(), { document: e, font_family: r, theme: n, typography: o } = t;
    return Y(e, {
        theme: n.document,
        fontFamily: an(r),
        fontSize: o.base,
        lineHeight: o.lineHeight
    });
};
v();
var xa = {
    document: L
}, So = (t, e)=>{
    let r = C();
    if (!t) {
        r.verbose && console.warn("setSVG: val is not defined", e);
        return;
    }
    return r.useSvgSprite ? sa(e, t) : t;
}, _a = (t, e = xa)=>{
    let r = C(), n = Object.keys(t).length ? {} : r.svg;
    for(let o in t)n[o] = r.svg[o];
    Mf(n, e);
}, wa = (t, e)=>{
    let r = C();
    return r.useIconSprite && !r.semantic_icons?.[e] ? So(t, e) : t;
}, va = (t, e = xa)=>{
    let r = C(), n = Object.keys(t).length ? {} : r.icons;
    for(let o in t)n[o] = r.icons[o];
    Mf(n, e);
}, Lf = (t = {
    isRoot: !0
})=>{
    if (!L || !L.createElementNS) return;
    let e = L.createElementNS("http://www.w3.org/2000/svg", "svg");
    return t.isRoot && (e.setAttribute("aria-hidden", "true"), e.setAttribute("width", "0"), e.setAttribute("height", "0"), e.setAttribute("style", "position:absolute"), e.setAttribute("id", "svgSprite")), e;
}, Mf = (t, e = xa)=>{
    let r = C(), n = e.document || L;
    if (!n || !n.documentElement) return r.verbose && console.warn("To append SVG sprites it should be run in browser environment"), go(t);
    let o = n.querySelector("#svgSprite"), s = go(t);
    if (o) {
        let i = Lf({
            isRoot: !1
        });
        i.innerHTML = s, o.append(...i.children);
    } else {
        let i = Lf();
        i && i.nodeType && (i.innerHTML = s, n.body.prepend(i));
    }
};
v();
var Ea = (t = {})=>{
    let e = C(), { reset: r, typography: n, document: o } = e;
    if (r) {
        if (r[":root"]) {
            let c = r, f = n.templates;
            c.body = {
                ...e.useDocumentTheme ? Yt("document") : {},
                ...f.body
            }, c.h1 = f.h1, c.h2 = f.h2, c.h3 = f.h3, c.h4 = f.h4, c.h5 = f.h5, c.h6 = f.h6;
        }
        let { body: s, ...i } = n.templates, a = e.useDocumentTheme ? Yt("document") : {};
        return r.html && it(r.html, a), U(Y(r, t), {
            html: {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
                margin: "0",
                WebkitFontSmoothing: "subpixel-antialiased",
                scrollBehavior: "smooth",
                ...a,
                fontSize: n.browserDefault + "px",
                fontFamily: o.fontFamily,
                lineHeight: o.lineHeight
            },
            body: {
                boxSizing: "border-box",
                height: "100%",
                margin: 0,
                fontFamily: o.fontFamily,
                fontSize: n.base / n.browserDefault + e.unit.default,
                ...i,
                ...s
            },
            a: {
                color: "currentColor"
            },
            fieldset: {
                border: 0,
                padding: 0,
                margin: 0
            },
            "select, input": {
                fontFamily: o.fontFamily
            }
        });
    }
};
v();
var ty = new Set([
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset",
    "initial"
]), ey = new Set([
    "to",
    "top",
    "bottom",
    "left",
    "right",
    "center",
    "at",
    "circle",
    "ellipse",
    "closest-side",
    "farthest-side",
    "closest-corner",
    "farthest-corner"
]), ry = (t)=>ty.has(t), Se = (t)=>{
    let e = t + "";
    if (Zt.test(e)) return e;
    let r = e.trim();
    return r === "none" || r === "0" || r === "initial" || r === "inherit" || r === "unset" ? e : e.split(/\s+/).map((o)=>{
        if (o = o.trim(), !o) return "";
        if (nt(o)) return `var(${o})`;
        if (ry(o) || /^\d/.test(o) || o === "0") return o;
        let s = J(o);
        if (ye(s)) return s;
        let i = at(o, "border");
        return i && i.border ? i.border : o;
    }).join(" ");
}, Bf = (t)=>Zt.test(t) ? t : t.split(/\s+/).map((e)=>{
        if (e = e.trim(), !e) return "";
        if (nt(e)) return `var(${e})`;
        if (/^\d/.test(e) || e.includes("px") || e === "0") return e;
        let r = J(e);
        return ye(r) ? r : e;
    }).join(" "), Uf = (t, e)=>ya(t, e), Ca = (t, e)=>Zt.test(t) ? t : mr(t).map((r)=>(r = r.trim(), r ? r.split(/\s+/).map((n)=>{
            if (n = n.trim(), !n) return "";
            if (nt(n)) return `var(${n})`;
            if (n === "inset" || n === "none") return n;
            let o = J(n);
            if (ye(o)) {
                let i = Ct(n, e);
                return g(i) ? Object.values(i).filter((a)=>a.includes(": " + e))[0] : i;
            }
            if (/^\d/.test(n) || n === "0" || n.includes("px") || n.slice(-2) === "em") return n;
            let s = at(n, "shadow");
            return s && s.shadow ? s.shadow : n;
        }).join(" ") : "")).join(", "), ka = (t, e)=>{
    let r = t.indexOf("(");
    if (r === -1) return t;
    let n = t.slice(0, r + 1), o = t.slice(r + 1, t.lastIndexOf(")")), s = ")", a = mr(o).map((c)=>(c = c.trim(), c.split(/\s+/).map((l)=>{
            if (!l || /^\d/.test(l) || l === "0" || ey.has(l) || l === "transparent" || Zt.test(l)) return l;
            let u = J(l);
            return ye(u) ? u : l;
        }).join(" ")));
    return n + a.join(", ") + s;
}, Vf = (t, e)=>{
    let r = C();
    return t.split(", ").map((n)=>nt(n) ? `var(${n})` : n.includes("url") ? n : n.includes("gradient") ? ka(n, e) : r.gradient[t] ? {
            backgroundImage: Ct(t, e || r.globalTheme)
        } : n.includes("/") || n.startsWith("http") || n.includes(".") && !hr(n) ? `url(${n})` : n).join(" ");
}, jf = (t)=>b(t) && t.split(" ").map((e)=>at(e, "gap").gap).join(" "), ny = (t)=>{
    let e = t.split(" ");
    return e.length ? e.map((r)=>nt(r) ? `var(${r})` : r.length < 3 || r.includes("ms") ? Ut(r).timing || r : Dt(r) ? Dt(r) : r).join(" ") : t;
}, vr = (t, e, r)=>{
    if (b(t)) return t.split(",").map((n)=>Ut(n).timing || n).join(",");
}, _o = (t)=>{
    let e = t.split(",");
    if (e.length) return e.map(ny).join(",");
};
function ot(t, e, r = {}, n = {}) {
    let o = O.call(this, e || r[t]);
    if (o == null) return;
    let s;
    if (b(o)) {
        if (o.includes("(")) {
            let c = Fe(o);
            s = c[0], o = c[1];
        }
        let i = r.scaleBoxSize, a = ha(t);
        !i && a && !n.ratio && (o = ga(o));
    }
    return n.ratio ? Le(r, t, o, s) : at(o, t, void 0, s);
}
var V = (t, e = null, r)=>ot(t, e, r, {
        ratio: !0
    }), Oa = (t, e, r)=>{
    if (b(t)) return {
        borderRadius: t.split(" ").map((n, o)=>Le(e, r, n)[r]).join(" ")
    };
};
v();
var oy = (t, e)=>y(t) ? t() : t, Ft = (t, e)=>t, zf = {
    color: xr,
    gradient: _r,
    font: fa,
    font_family: bo,
    fontfamily: bo,
    theme: ca,
    icons: wa,
    semantic_icons: Ft,
    semanticicons: Ft,
    svg: So,
    svg_data: Ft,
    typography: Ft,
    cases: oy,
    shadow: wr,
    spacing: Ft,
    media: Ft,
    grid: Ft,
    class: Ft,
    timing: Ft,
    reset: Ft,
    unit: Ft,
    animation: Ft
}, sy = (t, e, r)=>{
    let n = C(), o = t.toLowerCase(), s = n[o] || n[t];
    if (zf[o]) try {
        let i = zf[o](e, r);
        return s[r] = i, s;
    } catch (i) {
        n.verbose && console.warn("Error setting", o, "value", e, r, i);
    }
    n.verbose && console.warn("Can not find", o, "method in scratch");
}, iy = (t, e)=>{
    let r = C(), n = t.toLowerCase();
    return Object.keys(e).forEach((s)=>{
        try {
            return sy(n, e[s], s);
        } catch (i) {
            r.verbose && console.warn("Error setting", n, "value", e[s], s, i);
        }
    }), r[n] || r[t];
};
var ay = {}, dn = (t, e = ay)=>{
    let r = C(), { version: n, verbose: o, useVariable: s, useReset: i, useSvgSprite: a, useFontImport: c, useIconSprite: f, globalTheme: l, useDocumentTheme: u, useDefaultConfig: p, semanticIcons: d, SEMANTIC_ICONS: h, semantic_icons: m, files: S, ..._ } = t;
    e.newConfig && (r = Af(e.newConfig)), S !== void 0 && (r.files = S), o !== void 0 && (r.verbose = o), s !== void 0 && (r.useVariable = s), i !== void 0 && (r.useReset = i), c !== void 0 && (r.useFontImport = c), a !== void 0 && (r.useSvgSprite = a), f !== void 0 && (r.useIconSprite = f), u !== void 0 && (r.useDocumentTheme = u), l !== void 0 && (r.globalTheme = l), t.useThemeSuffixedVars !== void 0 && (r.useThemeSuffixedVars = t.useThemeSuffixedVars), p !== void 0 && (r.useDefaultConfig = p);
    let w = d || h || m;
    w !== void 0 && (r.semantic_icons = w, r.semanticIcons = r.semantic_icons, r.SEMANTIC_ICONS = r.semantic_icons), r.verbose && console.log(r), r.__svg_cache || (r.__svg_cache = {});
    let E = Object.keys(_), R = new Set(E);
    if (E.forEach((T)=>{
        let A = T.toLowerCase();
        A !== T && R.has(A) && U(_[A], _[T]);
    }), E.map((T)=>{
        let A = T.toLowerCase();
        if (!(A !== T && R.has(A))) return iy(T, _[T]);
    }), _.typography || _.TYPOGRAPHY) try {
        pa();
    } catch (T) {
        r.verbose && console.warn("Error applying typography sequence", T);
    }
    if (_.spacing || _.SPACING) try {
        ma();
    } catch (T) {
        r.verbose && console.warn("Error applying spacing sequence", T);
    }
    if (_.timing || _.TIMING) try {
        ba();
    } catch (T) {
        r.verbose && console.warn("Error applying timing sequence", T);
    }
    return Sa(), Ea(), r;
};
var cy = [
    "ease",
    "linear",
    "ease-in",
    "ease-out",
    "ease-in-out",
    "step-start",
    "step-end"
], ly = [
    "none",
    "forwards",
    "backwards",
    "both"
], fy = [
    "normal",
    "reverse",
    "alternate",
    "alternate-reverse"
], uy = [
    "running",
    "paused"
], py = (t)=>/^[\d.]+m?s$/.test(t), Aa = (t, e)=>{
    let { emotion: r } = e.context, { keyframes: n } = r || Et;
    if (g(t)) return {
        animationName: n(t)
    };
    let { ANIMATION: o } = e.context && e.context.designSystem, s = o[t];
    return n(s);
}, dy = (t, e)=>{
    let { ANIMATION: r } = e.context && e.context.designSystem || {}, n = t.split(/\s+/), o = null, s = [], i = null, a = null, c = null, f = null, l = null;
    for (let u of n)r && r[u] ? o = u : py(u) ? s.push(u) : cy.includes(u) || u.startsWith("cubic-bezier") || u.startsWith("steps(") ? i = u : u === "infinite" || /^\d+$/.test(u) ? a = u === "infinite" ? u : Number(u) : fy.includes(u) ? c = u : ly.includes(u) ? f = u : uy.includes(u) ? l = u : o || (o = u);
    return {
        name: o,
        durations: s,
        timingFunction: i,
        iterationCount: a,
        direction: c,
        fillMode: f,
        playState: l
    };
}, qf = {
    animation: (t, e)=>{
        if (b(t) && t.includes(" ")) {
            let r = dy(t, e);
            return {
                animationName: Aa(r.name || t, e),
                animationDuration: r.durations[0] || Ut(e.props.animationDuration || "A").timing,
                animationDelay: r.durations[1] || Ut(e.props.animationDelay || "0s").timing,
                animationTimingFunction: r.timingFunction || Dt(e.props.animationTimingFunction || "ease"),
                animationFillMode: r.fillMode || e.props.animationFillMode || "both",
                animationIterationCount: r.iterationCount != null ? r.iterationCount : e.props.animationIterationCount || 1,
                animationPlayState: r.playState || e.props.animationPlayState,
                animationDirection: r.direction || e.props.animationDirection
            };
        }
        return {
            animationName: Aa(t, e),
            animationDuration: Ut(e.props.animationDuration || "A").timing,
            animationDelay: Ut(e.props.animationDelay || "0s").timing,
            animationTimingFunction: Dt(e.props.animationTimingFunction || "ease"),
            animationFillMode: e.props.animationFillMode || "both",
            animationIterationCount: e.props.animationIterationCount || 1,
            animationPlayState: e.props.animationPlayState,
            animationDirection: e.props.animationDirection
        };
    },
    animationName: (t, e)=>({
            animationName: Aa(t, e)
        }),
    animationDuration: (t)=>({
            animationDuration: Ut(t).timing
        }),
    animationDelay: (t)=>({
            animationDelay: Ut(t).timing
        }),
    animationTimingFunction: (t)=>({
            animationTimingFunction: Dt(t)
        }),
    animationIterationCount: (t)=>({
            animationIterationCount: t
        }),
    animationFillMode: (t)=>({
            animationFillMode: t
        }),
    animationPlayState: (t)=>({
            animationPlayState: t
        }),
    animationDirection: (t)=>({
            animationDirection: t
        })
};
v();
var Hf = {
    show: (t, e, r, n)=>n.utils.exec(t, e, r) === !1 && {
            display: "none !important"
        },
    hide: (t, e, r, n)=>!!n.utils.exec(t, e, r) && {
            display: "none !important"
        },
    height: (t, { props: e })=>V("height", t, e),
    width: (t, { props: e })=>V("width", t, e),
    boxSizing: (t)=>K(t) ? {
            boxSizing: "border-box"
        } : {
            boxSizing: t
        },
    boxSize: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("height", e),
            ...ot("width", r || e)
        };
    },
    inlineSize: (t, { props: e })=>V("inlineSize", t, e),
    blockSize: (t, { props: e })=>V("blockSize", t, e),
    minWidth: (t, { props: e })=>V("minWidth", t, e),
    maxWidth: (t, { props: e })=>V("maxWidth", t, e),
    widthRange: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("minWidth", e),
            ...ot("maxWidth", r || e)
        };
    },
    minHeight: (t, { props: e })=>V("minHeight", t, e),
    maxHeight: (t, { props: e })=>V("maxHeight", t, e),
    heightRange: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("minHeight", e),
            ...ot("maxHeight", r || e)
        };
    },
    size: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...V("inlineSize", e),
            ...V("blockSize", r || e)
        };
    },
    minBlockSize: (t, { props: e })=>V("minBlockSize", t, e),
    minInlineSize: (t, { props: e })=>V("minInlineSize", t, e),
    maxBlockSize: (t, { props: e })=>V("maxBlockSize", t, e),
    maxInlineSize: (t, { props: e })=>V("maxInlineSize", t, e),
    minSize: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("minInlineSize", e),
            ...ot("minBlockSize", r || e)
        };
    },
    maxSize: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("maxInlineSize", e),
            ...ot("maxBlockSize", r || e)
        };
    },
    borderWidth: (t, { props: e })=>V("borderWidth", t, e),
    padding: (t, { props: e })=>V("padding", t, e),
    scrollPadding: (t, { props: e })=>V("scrollPadding", t, e),
    paddingInline: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("paddingInlineStart", e),
            ...ot("paddingInlineEnd", r || e)
        };
    },
    paddingBlock: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("paddingBlockStart", e),
            ...ot("paddingBlockEnd", r || e)
        };
    },
    paddingTop: (t, { props: e })=>V("paddingBlockStart", t, e),
    paddingBottom: (t, { props: e })=>V("paddingBlockEnd", t, e),
    paddingLeft: (t, { props: e })=>V("paddingInlineStart", t, e),
    paddingRight: (t, { props: e })=>V("paddingInlineEnd", t, e),
    paddingBlockStart: (t, { props: e })=>V("paddingBlockStart", t, e),
    paddingBlockEnd: (t, { props: e })=>V("paddingBlockEnd", t, e),
    paddingInlineStart: (t, { props: e })=>V("paddingInlineStart", t, e),
    paddingInlineEnd: (t, { props: e })=>V("paddingInlineEnd", t, e),
    margin: (t, { props: e })=>V("margin", t, e),
    marginInline: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            ...ot("marginInlineStart", e),
            ...ot("marginInlineEnd", r || e)
        };
    },
    marginBlock: (t, { props: e })=>{
        if (!b(e.marginBlock)) return;
        let [r, n] = e.marginBlock.split(" ");
        return {
            ...ot("marginBlockStart", r),
            ...ot("marginBlockEnd", n || r)
        };
    },
    marginInlineStart: (t, { props: e })=>V("marginInlineStart", t, e),
    marginInlineEnd: (t, { props: e })=>V("marginInlineEnd", t, e),
    marginBlockStart: (t, { props: e })=>V("marginBlockStart", t, e),
    marginBlockEnd: (t, { props: e })=>V("marginBlockEnd", t, e),
    gap: (t)=>({
            gap: jf(t)
        }),
    columnGap: (t, { props: e })=>Le(e, "columnGap", t),
    rowGap: (t, { props: e })=>Le(e, "rowGap", t),
    flexWrap: (t, { props: e })=>({
            display: "flex",
            flexFlow: (t || "row").split(" ")[0] + " " + e.flexWrap
        }),
    flexFlow: (t, { props: e })=>{
        let { reverse: r } = e;
        if (!b(t)) return;
        let [n, o] = (t || "row").split(" ");
        return (t.startsWith("x") || t === "row") && (n = "row"), (t.startsWith("y") || t === "column") && (n = "column"), {
            display: "flex",
            flexFlow: (n || "") + (!n.includes("-reverse") && r ? "-reverse" : "") + " " + (o || "")
        };
    },
    flexAlign: (t)=>{
        if (!b(t)) return;
        let [e, r] = t.split(" ");
        return {
            display: "flex",
            alignItems: e,
            justifyContent: r
        };
    },
    round: (t, { props: e })=>Oa(t || e.borderRadius, e, "round"),
    borderRadius: (t, { props: e })=>Oa(t || e.round, e, "borderRadius")
};
var Wf = {
    fontSize: (t)=>da(t) || t,
    fontFamily: (t)=>({
            fontFamily: ua(t) || t
        }),
    fontWeight: (t)=>({
            fontWeight: t,
            fontVariationSettings: '"wght" ' + t
        })
};
var Ta = {
    overflow: (t)=>({
            overflow: t,
            scrollBehavior: "smooth"
        }),
    cursor: (t, e, r, n)=>{
        if (!t) return;
        let o = n.files && n.files[t];
        return o && o.content && (t = `url(${o.content.src})`), {
            cursor: t
        };
    }
};
var Gf = {
    inset: (t, e)=>{
        if (e.call("isNumber", t)) return {
            inset: t
        };
        if (e.call("isString", t)) return {
            inset: t.split(" ").map((r)=>at(r, "k").k).join(" ")
        };
    },
    left: (t)=>at(t, "left"),
    top: (t)=>at(t, "top"),
    right: (t)=>at(t, "right"),
    bottom: (t)=>at(t, "bottom"),
    verticalInset: (t)=>{
        if (typeof t != "string") return;
        let e = t.split(" ").map((r)=>at(r, "k").k);
        return {
            top: e[0],
            bottom: e[1] || e[0]
        };
    },
    horizontalInset: (t)=>{
        if (typeof t != "string") return;
        let e = t.split(" ").map((r)=>at(r, "k").k);
        return {
            left: e[0],
            right: e[1] || e[0]
        };
    }
};
v();
var Vt = ({ context: t, state: e })=>{
    let r = e?.root?.globalTheme || t.designSystem?.globalTheme;
    return r === "auto" ? null : r;
}, Kf = {
    theme: (t, e)=>{
        let { props: r } = e;
        if (t) return r.themeModifier ? Yt(t, `@${r.themeModifier}`) : Yt(t);
    },
    color: (t, e)=>{
        let r = Vt(e);
        if (t) return {
            color: Ct(t, r)
        };
    },
    background: (t, e)=>{
        let r = Vt(e);
        if (t) return b(t) && t.includes("gradient") ? {
            background: ka(t, r)
        } : {
            background: Ct(t, r)
        };
    },
    backgroundColor: (t, e)=>{
        let r = Vt(e);
        if (t) return {
            backgroundColor: Ct(t, r)
        };
    },
    backgroundImage: (t, e, r, n)=>{
        let o = Vt(e);
        if (!t) return;
        let s = n.files && n.files[t];
        return s && s.content && (t = s.content.src), {
            backgroundImage: Vf(t, o)
        };
    },
    textStroke: (t)=>({
            WebkitTextStroke: Bf(t)
        }),
    outline: (t)=>({
            outline: Se(t)
        }),
    outlineOffset: (t, { props: e })=>V("outlineOffset", t, e),
    border: (t)=>({
            border: Se(t)
        }),
    borderColor: (t, e)=>{
        let r = Vt(e);
        if (t) return {
            borderColor: Ct(t, r)
        };
    },
    borderTopColor: (t, e)=>{
        let r = Vt(e);
        if (t) return {
            borderTopColor: Ct(t, r)
        };
    },
    borderBottomColor: (t, e)=>{
        let r = Vt(e);
        if (t) return {
            borderBottomColor: Ct(t, r)
        };
    },
    borderLeftColor: (t, e)=>{
        let r = Vt(e);
        if (t) return {
            borderLeftColor: Ct(t, r)
        };
    },
    borderRightColor: (t, e)=>{
        let r = Vt(e);
        if (t) return {
            borderRightColor: Ct(t, r)
        };
    },
    borderLeft: (t)=>({
            borderLeft: Se(t)
        }),
    borderTop: (t)=>({
            borderTop: Se(t)
        }),
    borderRight: (t)=>({
            borderRight: Se(t)
        }),
    borderBottom: (t)=>({
            borderBottom: Se(t)
        }),
    shadow: (t, e)=>{
        let r = Vt(e);
        if (t) return {
            boxShadow: Uf(t, r)
        };
    },
    boxShadow: (t, e)=>{
        if (!b(t)) return;
        let [r, n] = t.split("!importan"), o = Vt(e), s = n ? " !important" : "";
        return {
            boxShadow: Ca(r.trim(), o) + s
        };
    },
    textShadow: (t, { context: e })=>({
            textShadow: Ca(t, e.designSystem.globalTheme)
        }),
    columnRule: (t)=>({
            columnRule: Se(t)
        })
};
var Yf = {
    transition: (t)=>({
            transition: _o(t)
        }),
    transitionDuration: (t)=>({
            transitionDuration: vr(t)
        }),
    transitionDelay: (t)=>({
            transitionDelay: vr(t)
        }),
    transitionTimingFunction: (t)=>({
            transitionTimingFunction: Dt(t)
        }),
    transitionProperty: (t)=>({
            transitionProperty: t,
            willChange: t
        })
};
v();
var Xf = {
    flow: (t, e)=>{
        let { props: r } = e, { reverse: n } = r;
        if (!b(t)) return;
        let [o, s] = (t || "row").split(" ");
        return (t.startsWith("x") || t === "row") && (o = "row"), (t.startsWith("y") || t === "column") && (o = "column"), {
            display: "flex",
            flexFlow: (o || "") + (!o.includes("-reverse") && n ? "-reverse" : "") + " " + (s || "")
        };
    },
    wrap: (t, { props: e })=>({
            display: "flex",
            flexWrap: t
        }),
    align: (t, { props: e })=>{
        let [r, n] = t.split(" ");
        return {
            display: "flex",
            alignItems: r,
            justifyContent: n
        };
    }
};
var Qf = {
    area: (t)=>({
            gridArea: t
        }),
    template: (t)=>({
            gridTemplate: t
        }),
    templateAreas: (t)=>({
            gridTemplateAreas: t
        }),
    column: (t)=>({
            gridColumn: t
        }),
    columns: (t)=>({
            gridTemplateColumns: t
        }),
    templateColumns: (t)=>({
            gridTemplateColumns: t
        }),
    autoColumns: (t)=>({
            gridAutoColumns: t
        }),
    columnStart: (t)=>({
            gridColumnStart: t
        }),
    row: (t)=>({
            gridRow: t
        }),
    rows: (t)=>({
            gridTemplateRows: t
        }),
    templateRows: (t)=>({
            gridTemplateRows: t
        }),
    autoRows: (t)=>({
            gridAutoRows: t
        }),
    rowStart: (t)=>({
            gridRowStart: t
        }),
    autoFlow: (t)=>({
            gridAutoFlow: t
        })
};
var hn = {
    ...qf,
    ...Hf,
    ...Wf,
    ...Ta,
    ...Ta,
    ...Gf,
    ...Kf,
    ...Yf,
    ...Xf,
    ...Qf
};
var Jf = new Set([
    "accentColor",
    "alignContent",
    "alignItems",
    "alignSelf",
    "alignmentBaseline",
    "all",
    "animation",
    "animationDelay",
    "animationDirection",
    "animationDuration",
    "animationFillMode",
    "animationIterationCount",
    "animationName",
    "animationPlayState",
    "animationTimingFunction",
    "appearance",
    "aspectRatio",
    "backdropFilter",
    "backfaceVisibility",
    "background",
    "backgroundAttachment",
    "backgroundBlendMode",
    "backgroundClip",
    "backgroundColor",
    "backgroundImage",
    "backgroundOrigin",
    "backgroundPosition",
    "backgroundPositionX",
    "backgroundPositionY",
    "backgroundRepeat",
    "backgroundRepeatX",
    "backgroundRepeatY",
    "backgroundSize",
    "baselineShift",
    "blockSize",
    "border",
    "borderBlock",
    "borderBlockColor",
    "borderBlockEnd",
    "borderBlockEndColor",
    "borderBlockEndStyle",
    "borderBlockEndWidth",
    "borderBlockStart",
    "borderBlockStartColor",
    "borderBlockStartStyle",
    "borderBlockStartWidth",
    "borderBlockStyle",
    "borderBlockWidth",
    "borderBottom",
    "borderBottomColor",
    "borderBottomLeftRadius",
    "borderBottomRightRadius",
    "borderBottomStyle",
    "borderBottomWidth",
    "borderCollapse",
    "borderColor",
    "borderImage",
    "borderImageOutset",
    "borderImageRepeat",
    "borderImageSlice",
    "borderImageSource",
    "borderImageWidth",
    "borderLeft",
    "borderLeftColor",
    "borderLeftStyle",
    "borderLeftWidth",
    "borderRadius",
    "borderRight",
    "borderRightColor",
    "borderRightStyle",
    "borderRightWidth",
    "borderSpacing",
    "borderStyle",
    "borderTop",
    "borderTopColor",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderTopStyle",
    "borderTopWidth",
    "borderWidth",
    "bottom",
    "boxDecorationBreak",
    "boxShadow",
    "boxSizing",
    "breakAfter",
    "breakBefore",
    "breakInside",
    "captionSide",
    "caretColor",
    "clear",
    "clip",
    "clipPath",
    "color",
    "colorAdjust",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorRendering",
    "columnCount",
    "columnFill",
    "columnGap",
    "columnRule",
    "columnRuleColor",
    "columnRuleStyle",
    "columnRuleWidth",
    "columnSpan",
    "columnWidth",
    "columns",
    "contain",
    "content",
    "counterIncrement",
    "counterReset",
    "cursor",
    "direction",
    "display",
    "emptyCells",
    "filter",
    "flex",
    "flexBasis",
    "flexDirection",
    "flexFlow",
    "flexGrow",
    "flexShrink",
    "flexWrap",
    "float",
    "font",
    "fontFamily",
    "fontFeatureSettings",
    "fontKerning",
    "fontLanguageOverride",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontVariantAlternates",
    "fontVariantCaps",
    "fontVariantEastAsian",
    "fontVariantNumeric",
    "fontVariantPosition",
    "fontWeight",
    "fontVariationSettings",
    "fontSynthesis",
    "forcedColorAdjust",
    "gap",
    "grid",
    "gridArea",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridColumn",
    "gridColumnEnd",
    "gridColumnGap",
    "gridColumnStart",
    "gridGap",
    "gridRow",
    "gridRowEnd",
    "gridRowGap",
    "gridRowStart",
    "gridTemplate",
    "gridTemplateAreas",
    "gridTemplateColumns",
    "gridTemplateRows",
    "height",
    "hyphens",
    "imageOrientation",
    "imageRendering",
    "imeMode",
    "inset",
    "insetBlock",
    "insetBlockEnd",
    "insetBlockStart",
    "insetInline",
    "insetInlineEnd",
    "insetInlineStart",
    "initialLetter",
    "isolation",
    "justifyContent",
    "justifyItems",
    "justifySelf",
    "left",
    "letterSpacing",
    "lineBreak",
    "lineClamp",
    "lineHeight",
    "listStyle",
    "listStyleImage",
    "listStylePosition",
    "listStyleType",
    "margin",
    "marginBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBlock",
    "marginBlockEnd",
    "marginBlockStart",
    "marginInline",
    "marginInlineEnd",
    "marginInlineStart",
    "mask",
    "maskBorder",
    "maskBorderImage",
    "maskBorderOutset",
    "maskBorderRepeat",
    "maskBorderSlice",
    "maskBorderSource",
    "maskBorderWidth",
    "maskClip",
    "maskComposite",
    "maskImage",
    "maskOrigin",
    "maskPosition",
    "maskRepeat",
    "maskSize",
    "maskType",
    "maxBlockSize",
    "maxHeight",
    "maxInlineSize",
    "maxWidth",
    "minBlockSize",
    "minHeight",
    "minInlineSize",
    "minWidth",
    "mixBlendMode",
    "objectFit",
    "objectPosition",
    "objectViewBox",
    "offset",
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "opacity",
    "order",
    "orientation",
    "outline",
    "outlineColor",
    "outlineOffset",
    "outlineStyle",
    "outlineWidth",
    "overflow",
    "overflowAnchor",
    "overflowClip",
    "overflowScrolling",
    "overflowWrap",
    "overflowX",
    "overflowY",
    "padding",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "pageBreakAfter",
    "pageBreakBefore",
    "pageBreakInside",
    "paintOrder",
    "perspective",
    "perspectiveOrigin",
    "placeContent",
    "placeItems",
    "placeSelf",
    "pointerEvents",
    "position",
    "resize",
    "right",
    "rotate",
    "rowGap",
    "scrollBehavior",
    "scrollPadding",
    "scrollSnapAlign",
    "scrollSnapType",
    "scrollbarColor",
    "scrollbarWidth",
    "shapeImageThreshold",
    "shapeMargin",
    "shapeOutside",
    "tabSize",
    "tableLayout",
    "textAlign",
    "textAlignLast",
    "textDecoration",
    "textDecorationColor",
    "textDecorationLine",
    "textDecorationSkipInk",
    "textDecorationStyle",
    "textDecorationThickness",
    "textIndent",
    "textOverflow",
    "textShadow",
    "textTransform",
    "textUnderlineOffset",
    "top",
    "transform",
    "transformOrigin",
    "transformStyle",
    "transition",
    "transitionDelay",
    "transitionDuration",
    "transitionProperty",
    "transitionTimingFunction",
    "translate",
    "translateX",
    "translateY",
    "translateZ",
    "unicodeBidi",
    "userSelect",
    "verticalAlign",
    "visibility",
    "whiteSpace",
    "widows",
    "width",
    "willChange",
    "wordBreak",
    "wordSpacing",
    "wordWrap",
    "writingMode",
    "zIndex"
]);
var hy = (t, e, r)=>{
    let { context: n } = r;
    if (!n.designSystem?.media) return;
    let o = n.designSystem.media[t.slice(1)], s = Xt(e, r);
    return {
        [o ? "@media " + (o === "print" ? o : `screen and ${o}`) : t]: s
    };
}, Zf = (t, e, r)=>({
        [t]: Xt(e, r)
    }), mn = (t, e, r)=>({
        [`&${t}`]: Xt(e, r)
    }), my = (t, e, r)=>{
    let { cases: n } = r.context?.designSystem || {}, o = t.slice(1);
    if (!n?.[o] && !r.props[o]) return Xt(e, r);
}, gy = (t, e, r)=>({
        [t]: e
    }), yy = (t, e, r)=>{
    let n = t.slice(1);
    if (r.props[n] === !0 || r.state[n] || r[n]) return Xt(e, r);
}, by = (t, e, r)=>{
    let n = t.slice(1);
    if (!(r.props[n] === !0 || r.state[n] || r[n])) return Xt(e, r);
}, tu = (t, e)=>Xt(t, e), eu = {
    "@": hy,
    ":": mn,
    "[": mn,
    "*": mn,
    "+": mn,
    "~": mn,
    "&": Zf,
    ">": Zf,
    $: my,
    "-": gy,
    ".": yy,
    "!": by
};
var Ra = Ke(), Sy = (t, e, r)=>{
    let n = {}, o = {}, s = (i, a)=>{
        if (r.unpack) {
            n = {
                ...n,
                ...a
            };
            return;
        }
        n[i] = a;
    };
    for(let i in t){
        let a = t[i];
        if (i === "class" && e.call("isString", t.class)) {
            let c = a.split(" ");
            if (c.length) {
                let f = e.context.designSystem.class, l = c.reduce((u, p)=>Y(u, f[p]), {});
                n.designSystemClass = l;
            }
        } else if (i === "true") {
            let c = O(a, e);
            Y(n, tu(c, e));
        } else if (e.classlist[i]) {
            let c = e.classlist[i], f = y(c) ? c(e, e.state, e.context) : c;
            f && s(i, f), !Ra && g(n[i]) && (n[i].label = i);
        } else if (hn[i]) {
            let c = O(a, e);
            x(c) && (c = c.reduce((l, u)=>Y(l, u), {}));
            let f = hn[i](c, e, e.state, e.context);
            x(f) && (f = f.reduce((l, u)=>Y(l, u), {})), f && s(i, f), !Ra && g(n[i]) && (n[i].label = i);
        } else if (Jf.has(i)) {
            let c = O(a, e);
            s(i, {
                [i]: c
            }), !Ra && g(n[i]) && (n[i].label = i);
        } else o[i] = a;
    }
    return [
        n,
        o
    ];
}, xy = (t, e)=>{
    let r = {};
    for(let n in t){
        let o = eu[n.slice(0, 1)];
        if (o) {
            let s = o(n, t[n], e);
            if (s) for(let i in s)Object.prototype.hasOwnProperty.call(s, i) && (r[i] && typeof r[i] == "object" && typeof s[i] == "object" ? it(r[i], s[i]) : r[i] = s[i]);
        }
    }
    return r;
}, Xt = (t, e, r = {
    unpack: !0
})=>{
    let [n, o] = Sy(t, e, r), s = xy(o, e), i = !1;
    for(let a in s){
        i = !0;
        break;
    }
    if (i) {
        if (r.unpack) return fe(n, s);
        n._selectors = s;
    }
    return n;
}, Fk = (t, e)=>{
    let r = {};
    if (t.class) for(let n in t.class)r[n] = t.class[n](e);
    return r;
};
v();
var { css: _y } = Et, Bk = (t, e)=>y(e) ? e(t) : _y(t);
var ru = {
    transparent: "rgba(0, 0, 0, 0)",
    black: "black",
    white: "white",
    title: [
        "--gray 1 -168",
        "--gray 1 +168"
    ],
    caption: [
        "--gray 1 -68",
        "--gray 1 +68"
    ],
    paragraph: [
        "--gray 1 -42",
        "--gray 1 +42"
    ],
    disabled: [
        "--gray 1 -26",
        "--gray 1 +26"
    ],
    line: [
        "--gray 1 -16",
        "--gray 1 +16"
    ]
}, nu = {};
var wy = {
    primary: {
        "@dark": {
            color: "white",
            background: "blue"
        },
        "@light": {
            color: "white",
            background: "gradient-blue"
        }
    },
    secondary: {
        "@dark": {
            color: "white",
            background: "gray"
        },
        "@light": {
            color: "white",
            background: "gray"
        }
    },
    tertiary: {
        "@dark": {
            color: "white",
            background: "gray.92+8"
        },
        "@light": {
            background: "gray.1"
        }
    },
    quaternary: {
        "@light": {
            color: "white",
            background: "gradient-light"
        },
        "@dark": {
            color: "white",
            background: "gradient-dark-active"
        }
    },
    quinary: {
        "@dark": {
            color: "gray=90",
            background: "gradient-light"
        },
        "@light": {
            color: "gray3",
            background: "gradient-dark"
        }
    }
}, vy = {
    alert: {
        "@dark": {
            color: "white",
            background: "red"
        }
    },
    warning: {
        "@dark": {
            color: "black",
            background: "yellow"
        }
    },
    success: {
        "@dark": {
            color: "black",
            background: "green"
        }
    }
}, Ey = {
    field: {
        "@light": {
            color: "black",
            background: "gray.975+144",
            borderColor: "gray.975+144",
            "::placeholder": {
                color: "gray-68"
            }
        },
        "@dark": {
            color: "white",
            background: "gray.975-52",
            borderColor: "gray.975-52",
            "::placeholder": {
                color: "gray+68"
            }
        }
    },
    label: {
        "@dark": {
            color: "white",
            background: "gray.92+8"
        },
        "@light": {
            background: "gray.1"
        }
    },
    dialog: {
        "@dark": {
            color: "white",
            background: "gray.92"
        },
        "@light": {
            color: "currentColor",
            background: "gray.1"
        }
    }
}, ou = {
    document: {
        "@light": {
            color: "black",
            background: "white"
        },
        "@dark": {
            color: "white",
            background: "black"
        }
    },
    ...wy,
    ...vy,
    ...Ey,
    none: {
        color: "none",
        background: "none"
    },
    transparent: {
        color: "currentColor",
        background: "transparent"
    }
};
var su = {
    base: 16,
    ratio: 1.25,
    subSequence: !0,
    templates: {}
};
var iu = {
    ratio: 1.618,
    subSequence: !0
};
var au = {}, cu = {
    system: {
        value: [
            '"Helvetica Neue"',
            "Helvetica",
            "Arial"
        ],
        type: "sans-serif"
    }
};
var lu = {
    tv: "(min-width: 2780px)",
    screenL: "(max-width: 1920px)",
    "screenL<": "(min-width: 1920px)",
    screenM: "(max-width: 1680px)",
    "screenM<": "(min-width: 1680px)",
    screenS: "(max-width: 1440px)",
    "screenS<": "(min-width: 1440px)",
    tabletL: "(max-width: 1366px)",
    "tabletL<": "(min-width: 1366px)",
    tabletM: "(max-width: 1280px)",
    "tabletM<": "(min-width: 1280px)",
    tabletS: "(max-width: 1024px)",
    "tabletS<": "(min-width: 1024px)",
    mobileL: "(max-width: 768px)",
    "mobileL<": "(min-width: 768px)",
    mobileM: "(max-width: 560px)",
    "mobileM<": "(min-width: 560px)",
    mobileS: "(max-width: 480px)",
    "mobileS<": "(min-width: 480px)",
    mobileXS: "(max-width: 375px)",
    "mobileXS<": "(min-width: 375px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};
var fu = {
    base: 150,
    ratio: 1.333,
    unit: "ms",
    subSequence: !0
};
var Ia = {
    version: "0.0.1",
    color: ru,
    gradient: nu,
    theme: ou,
    typography: su,
    spacing: iu,
    font: au,
    font_family: cu,
    timing: fu,
    media: lu,
    reset: {
        html: {},
        body: {}
    },
    animation: {
        fadeIn: {
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            }
        }
    },
    devices: {},
    cases: {},
    class: {},
    svg: {},
    grid: {},
    shape: {}
};
var Be = {};
Mt(Be, {
    A: ()=>LS,
    Avatar: ()=>JS,
    B: ()=>cb,
    Block: ()=>Cy,
    Box: ()=>Na,
    Br: ()=>db,
    Button: ()=>US,
    ButtonSet: ()=>qS,
    Caption: ()=>Zy,
    Checkbox: ()=>wb,
    CheckboxHgroup: ()=>vb,
    CircleButton: ()=>jS,
    Clickable: ()=>Ly,
    Data: ()=>fb,
    Dialog: ()=>WS,
    DialogFooter: ()=>KS,
    DialogHeader: ()=>GS,
    DropdownList: ()=>tx,
    DropdownParent: ()=>ex,
    DropdownParentFocus: ()=>rx,
    DropdownSiblingFocus: ()=>nx,
    FileIcon: ()=>Pb,
    Flex: ()=>Oy,
    Focusable: ()=>My,
    FocusableComponent: ()=>By,
    Footnote: ()=>ab,
    Form: ()=>Ny,
    Grid: ()=>Ty,
    Gutter: ()=>Iy,
    H1: ()=>Wy,
    H2: ()=>Gy,
    H3: ()=>Ky,
    H4: ()=>Yy,
    H5: ()=>Xy,
    H6: ()=>Qy,
    Headline: ()=>sb,
    Hgroup: ()=>yb,
    HgroupButton: ()=>Sb,
    HgroupRows: ()=>bb,
    Hoverable: ()=>$y,
    Hr: ()=>pb,
    I: ()=>lb,
    Icon: ()=>Rb,
    IconButton: ()=>HS,
    IconText: ()=>Ib,
    Iframe: ()=>Dy,
    Img: ()=>Py,
    Inline: ()=>ky,
    InlineFlex: ()=>Ay,
    InlineGrid: ()=>Ry,
    Input: ()=>xb,
    Italic: ()=>nb,
    KangorooButton: ()=>zS,
    Li: ()=>hb,
    Link: ()=>Ku,
    Notification: ()=>ox,
    NumberInput: ()=>_b,
    Ol: ()=>gb,
    P: ()=>Jy,
    Picture: ()=>jy,
    Radio: ()=>Eb,
    RadioHgroup: ()=>Cb,
    Range: ()=>ZS,
    RouteLink: ()=>MS,
    RouterLink: ()=>Yu,
    SHAPES: ()=>Uy,
    Select: ()=>BS,
    SquareButton: ()=>VS,
    Strong: ()=>tb,
    Subhead: ()=>ib,
    Svg: ()=>zy,
    Text: ()=>Hy,
    Textarea: ()=>Ab,
    TextareaWithButton: ()=>Tb,
    Theme: ()=>Vy,
    Title: ()=>ob,
    Toggle: ()=>kb,
    ToggleHgroup: ()=>Ob,
    Tooltip: ()=>YS,
    TooltipHidden: ()=>XS,
    TooltipParent: ()=>QS,
    U: ()=>eb,
    Ul: ()=>mb,
    Underline: ()=>rb,
    Video: ()=>qy,
    depth: ()=>Pa,
    getSystemGlobalTheme: ()=>vo
});
var Cy = {
    display: "block"
}, ky = {
    display: "inline"
}, Oy = {
    display: "flex"
}, Ay = {
    display: "inline-flex"
}, Ty = {
    display: "grid"
}, Ry = {
    display: "inline-grid"
}, Iy = {
    boxSize: "C1"
};
var Py = {
    tag: "img",
    attr: {
        src: (t)=>{
            let { props: e, context: r } = t, n = (e.preSrc || "") + Wt(t, e.src), o;
            try {
                o = new URL(n);
            } catch  {}
            if (o) return n;
            let s = n && n.startsWith("/files/") ? n.slice(7) : n, i = r.files && (r.files[n] || r.files[s]);
            if (i) return i.content && i.content.src;
        },
        title: ({ props: t })=>t.title || t.alt
    }
};
var Ny = {
    tag: "form"
};
var Dy = {
    tag: "iframe",
    position: "relative",
    minWidth: "H",
    minHeight: "H"
};
var Fy = {
    appearance: "none",
    border: "none",
    cursor: "pointer",
    fontFamily: "inherit"
}, $y = {
    transition: "C defaultBezier",
    transitionProperty: "opacity, transform",
    opacity: .85,
    ":hover": {
        opacity: .9,
        transform: "scale(1.015)"
    },
    ":active": {
        opacity: 1,
        transform: "scale(1.015)"
    },
    ".active": {
        opacity: 1,
        transform: "scale(1.015)",
        ":hover": {
            opacity: 1
        }
    }
}, Ly = {
    extends: "Hoverable",
    ":active": {
        opacity: 1,
        transform: "scale(1.015)"
    },
    ".active": {
        opacity: 1
    }
}, My = {
    border: "none",
    outline: "solid 0 blue.3",
    ":focus-visible": {
        opacity: 1,
        outline: "solid X blue.3"
    },
    attr: {
        tabIndex: ({ props: t })=>t.tabIndex
    }
}, By = {
    extends: "Focusable",
    tag: "button",
    fontSize: "A",
    type: "button",
    border: "none",
    textDecoration: "none",
    lineHeight: "1",
    whiteSpace: "nowrap",
    fontFamily: "inherit",
    style: Fy
};
var uu = {
    transition: (t)=>({
            transition: _o(t)
        }),
    transitionDuration: (t)=>({
            transitionDuration: vr(t)
        }),
    transitionDelay: (t)=>({
            transitionDelay: vr(t)
        }),
    transitionTimingFunction: (t)=>({
            transitionTimingFunction: Dt(t)
        }),
    transitionProperty: (t)=>({
            transitionProperty: t,
            willChange: t
        })
};
var $t = C(), Pa = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${$t.UNIT.default} 4${$t.UNIT.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${$t.UNIT.default} 6${$t.UNIT.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${$t.UNIT.default} 10${$t.UNIT.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${$t.UNIT.default} 16${$t.UNIT.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${$t.UNIT.default} 26${$t.UNIT.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${$t.UNIT.default} 42${$t.UNIT.default}`
    }
}, Er = ({ props: t })=>J(t.shapeDirectionColor) || J(t.borderColor) || J(t.backgroundColor) || J(t.background), wo = ({ props: t, deps: e })=>{
    let r = uu.transition(t.transition, {
        props: t,
        deps: e
    });
    return r && r.transition;
}, Uy = {
    rectangle: {},
    circle: {
        borderRadius: "100%"
    },
    bubble: {},
    tv: {
        borderRadius: "1.15em/2.5em"
    },
    tooltip: ({ props: t, deps: e })=>({
            position: t.position || "relative",
            "&:before": {
                content: '""',
                display: "block",
                width: "0px",
                height: "0px",
                border: ".35em solid",
                borderColor: Er({
                    props: t,
                    deps: e
                }),
                transition: wo({
                    props: t,
                    deps: e
                }),
                transitionProperty: "border-color",
                position: "absolute",
                borderRadius: ".15em"
            }
        }),
    tooltipDirection: {
        top: {
            "&:before": {
                top: "0",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                right: "0",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                bottom: "0",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                left: "0",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        }
    },
    tag: ({ props: t, deps: e })=>({
            position: "relative",
            "&:before": {
                content: '""',
                display: "block",
                background: Er({
                    props: t,
                    deps: e
                }),
                transition: wo({
                    props: t,
                    deps: e
                }),
                transitionProperty: "background",
                borderRadius: ".25em",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%"
            }
        }),
    tagDirection: {
        top: {
            "&:before": {
                bottom: "100%",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                left: "100%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                top: "100%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                right: "100%",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        }
    },
    hexagon: ({ props: t, deps: e })=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                borderRadius: ".25em",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%",
                background: Er({
                    props: t,
                    deps: e
                }),
                transition: wo({
                    props: t,
                    deps: e
                }),
                transitionProperty: "background"
            },
            "&:before": {
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            },
            "&:after": {
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }),
    chevron: ({ props: t, deps: e })=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                transition: wo({
                    props: t,
                    deps: e
                }),
                transitionProperty: "background"
            },
            "&:before": {
                background: `linear-gradient(225deg, ${Er({
                    props: t,
                    deps: e
                })} 25%, transparent 25%), linear-gradient(315deg, ${Er({
                    props: t,
                    deps: e
                })} 25%, transparent 25%)`
            },
            "&:after": {
                background: Er({
                    props: t,
                    deps: e
                }),
                borderRadius: ".25em"
            }
        }),
    chevronDirection: {
        left: {
            "&:before": {
                height: "100%",
                left: "100%",
                transform: "translate3d(-1%, -50%, 1px) scale(-1, 1)"
            },
            "&:after": {
                height: "73%",
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                height: "100%",
                left: "0",
                transform: "translate3d(-99%, -50%, 1px)"
            },
            "&:after": {
                height: "73%",
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }
    }
};
v();
var vo = ({ context: t, state: e })=>{
    let r = e && e.root, n = r && r.globalTheme || t.designSystem && t.designSystem.globalTheme;
    return n === "auto" ? null : n;
}, Vy = {
    deps: {
        depth: Pa
    },
    classlist: {
        depth: ({ props: t, deps: e })=>!K(t.depth) && e.depth[t.depth]
    }
};
var jy = {
    deps: {
        getSystemGlobalTheme: vo
    },
    tag: "picture",
    childExtends: {
        deps: {
            getSystemGlobalTheme: vo
        },
        tag: "source",
        attr: {
            media: (t)=>{
                let { props: e, key: r, context: n, deps: o } = t, { media: s } = n.designSystem, i = o.getSystemGlobalTheme(t), a = (e.media || r).slice(1);
                return a === i ? "(min-width: 0px)" : a === "dark" || a === "light" ? "(max-width: 0px)" : s[a];
            }
        }
    },
    Img: {
        width: "inherit",
        ignoreChildExtends: !0,
        height: "inherit",
        src: (t, e)=>t.parent.props?.src || t.parent.src || e.src
    }
};
var zy = {
    tag: "svg",
    attr: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    html: (t)=>{
        let { props: e, context: r } = t;
        if (e.semantic_symbols) return;
        if (e.html) return t.call("exec", e.html, t);
        let { designSystem: n, utils: o } = r, s = n && n.svg, i = e.spriteId || r.designSystem && r.designSystem.useSvgSprite, a = t.call("exec", e.src, t);
        if (!i && a) return a;
        let c = (p)=>`<use xlink:href="#${p}" />`, f = e.spriteId;
        if (f) return c(f);
        let l = Symbol.for(a), u = s[l];
        return u && s[u] || (u = s[l] = Math.random(), a && o.init({
            svg: {
                [u]: a
            }
        }, {
            document: r.document,
            emotion: r.emotion
        })), c(u);
    }
};
var qy = {
    tag: "video",
    controls: !0,
    childExtends: {
        tag: "source"
    }
};
var Hy = {}, Wy = {
    tag: "h1"
}, Gy = {
    tag: "h2"
}, Ky = {
    tag: "h3"
}, Yy = {
    tag: "h4"
}, Xy = {
    tag: "h5"
}, Qy = {
    tag: "h6"
}, Jy = {
    tag: "p"
}, Zy = {
    tag: "caption"
}, tb = {
    tag: "strong",
    fontWeight: "700"
}, eb = {
    tag: "u"
}, rb = {
    tag: "u"
}, nb = {
    tag: "i"
}, ob = {}, sb = {
    tag: "h6",
    fontSize: "B",
    fontWeight: 500
}, ib = {
    tag: "span",
    fontSize: "Z1"
}, ab = {
    tag: "span",
    fontSize: "Z"
}, cb = {
    tag: "b"
}, lb = {
    tag: "i"
}, fb = {
    tag: "data"
};
var ub = (t)=>{
    if (!t.context) return;
    let { props: e, __ref: r } = t, n = Xt(e, t, {
        unpack: !1
    });
    r.__class = n;
}, Na = {
    extends: [
        "Shape",
        "Theme"
    ],
    boxSizing: "border-box",
    onBeforeClassAssign: ub
}, pb = {
    tag: "hr",
    margin: "C1 0"
}, db = {
    tag: "br"
}, hb = {
    tag: "li"
}, mb = {
    tag: "ul",
    childExtends: {
        extends: "Li"
    }
}, gb = {
    tag: "ol",
    childExtends: {
        extends: "Li"
    }
};
var yb = {
    display: "flex",
    tag: "hgroup",
    flow: "y",
    gap: "Y2",
    H: {
        color: "title",
        tag: "h3",
        lineHeight: "1em",
        margin: "0"
    },
    P: {
        margin: "0",
        color: "paragraph"
    }
}, bb = {
    extends: "Hgroup",
    H: {
        display: "flex",
        color: "title",
        align: "center space-between"
    },
    P: {
        color: "paragraph",
        align: "center space-between"
    }
}, Sb = {
    extends: "HgroupRows",
    H: {
        justifyContent: "space-between",
        Span: {},
        Button: {
            background: "transparent",
            color: "currentColor",
            padding: "0",
            Icon: {
                name: "x",
                fontSize: "C"
            }
        }
    },
    P: {}
};
var xb = {
    extends: [
        "Focusable"
    ],
    tag: "input",
    border: "none",
    type: "input",
    theme: "field",
    fontSize: "A",
    round: "C",
    lineHeight: "1",
    padding: "Z2 B",
    attr: {
        pattern: ({ props: t })=>t.pattern,
        minLength: ({ props: t })=>t.minlength,
        maxLength: ({ props: t })=>t.maxlength,
        name: ({ props: t })=>t.name,
        autocomplete: ({ props: t })=>t.autocomplete,
        placeholder: ({ props: t })=>t.placeholder,
        value: (t)=>{
            if (!t.props || !t.props.value) return;
            let e = t.call("exec", t.props.value, t);
            return t.call("isString", e) && e.includes("{{") ? t.call("replaceLiteralsWithObjectFields", e) : e;
        },
        checked: (t)=>t.call("exec", t.props.checked, t),
        disabled: ({ props: t })=>t.disabled || null,
        readonly: ({ props: t })=>t.readonly,
        required: ({ props: t })=>t.required,
        type: ({ props: t })=>t.type
    }
};
var _b = {
    extends: [
        "Flex",
        "Input"
    ],
    type: "number",
    boxSize: "C+X",
    align: "center center",
    textAlign: "center",
    round: "Y1",
    theme: "transparent",
    border: "solid gray3",
    borderWidth: "1px",
    placeholder: "0",
    fontWeight: "400",
    "::-webkit-inner-spin-button": {
        appearance: "none"
    },
    attr: {
        step: ({ props: t })=>t.step,
        min: ({ props: t })=>t.min,
        max: ({ props: t })=>t.max
    }
};
var wb = {
    extends: "Focusable",
    tag: "label",
    boxSize: "fit-content fit-content",
    cursor: "pointer",
    round: "Y",
    Input: {
        type: "checkbox",
        display: "none",
        ":checked + div": {
            theme: "primary"
        },
        ":checked + div > svg": {
            transform: "none",
            opacity: "1"
        },
        attr: {
            checked: (t)=>t.call("exec", t.parent.props.checked)
        }
    },
    Flex: {
        align: "center center",
        fontSize: "B1",
        padding: "V",
        theme: "field",
        round: "X2",
        transition: "background A defaultBezier",
        Icon: {
            icon: "check",
            opacity: "0",
            transform: "scale(0.9) rotate(-15deg)",
            transition: "opacity B defaultBezier"
        }
    }
}, vb = {
    display: "flex",
    tag: "label",
    boxSize: "fit-content",
    align: "flex-start flex-start",
    gap: "A",
    Checkbox: {
        tag: "div"
    },
    HgroupRows: {
        gap: "Z1",
        margin: "Y - - -"
    }
};
var Eb = {
    extends: "Checkbox",
    Input: {
        type: "radio",
        ":checked + div:after": {
            opacity: "1"
        }
    },
    Flex: {
        round: "100%",
        padding: "Y",
        ":after": {
            content: '""',
            display: "block",
            boxSize: "X+W1",
            round: "100%",
            background: "white",
            opacity: "0",
            transition: "opacity .15s ease-in-out"
        },
        Icon: null
    }
}, Cb = {
    extends: "CheckboxHgroup",
    Checkbox: null,
    Radio: {}
};
var kb = {
    extends: "Checkbox",
    Input: {
        ":checked + div": {
            background: "green2+8",
            justifyContent: "flex-end"
        }
    },
    Flex: {
        boxSize: "A1 B1",
        padding: "- W_default",
        round: "D",
        align: "center flex-start",
        theme: "field",
        border: "none",
        transition: "opacity .15s ease",
        ":after": {
            content: '""',
            boxSize: "A A",
            round: "100%",
            background: "white",
            boxShadow: "gray.2 1px 1px Z"
        },
        Icon: null
    }
}, Ob = {
    extends: "CheckboxHgroup",
    Checkbox: null,
    Toggle: {}
};
var Ab = {
    tag: "textarea",
    extends: [
        "Input",
        "Flex"
    ],
    variant: "outlined",
    fontfamily: "Avenir",
    round: "Z1",
    placeholder: "Leave us a message...",
    padding: "A",
    theme: "field",
    border: "none",
    maxWidth: "G1_default",
    minHeight: "E_default",
    width: "100%",
    height: "E1_default",
    fontFamily: "inherit",
    style: {
        resize: "none"
    },
    ".simple": {
        theme: "field",
        round: "Z2",
        lineHeight: 1.4
    },
    ".outlined": {
        theme: "field",
        borderWidth: "1px",
        borderStyle: "solid",
        lineHeight: 1.4,
        placeholder: "Leave us a message...",
        resize: "none"
    },
    html: (t, e)=>t.props.value
}, Tb = {
    display: "flex",
    gap: "Y2",
    Textarea: {
        height: "C2+W",
        minWidth: "H",
        padding: "A",
        fontSize: "Z1",
        round: "Z2",
        minHeight: "fit-content"
    },
    SquareButton: {
        background: "blue",
        Icon: {
            name: "send"
        }
    }
};
var Rb = {
    extends: "Svg",
    width: "A",
    height: "A",
    display: "inline-block",
    style: {
        fill: "currentColor",
        "*": {
            fill: "currentColor"
        }
    },
    props: (t, e, r)=>{
        let { props: n, parent: o } = t, { icons: s, useIconSprite: i, verbose: a } = r && r.designSystem, { toCamelCase: c } = r && r.utils, f = (A)=>{
            let { props: k } = A, $ = k[".isActive"];
            if ($) return A.call("exec", $.name || $.icon);
        }, l = (A, k, $)=>{
            let { semanticIcons: P } = $ && $.designSystem, { toCamelCase: F } = $ && $.utils, j = u(A, k), tt = F(j).split(/([a-z])([A-Z])/g), pt = tt[1] ? tt[0] : j.split(".")[0].split(" ")[0], _t = P && P[pt];
            if (_t) {
                let Lt = j.includes(".") ? "sfsymbols." + j.split(".").slice(1).join(".") : "sfsymbols";
                return j = _t[Lt] || _t[j.split(".")[0].split(" ")[0]], {
                    tag: "span",
                    semantic_symbols: !0,
                    width: "A",
                    height: "A",
                    lineHeight: "1em",
                    ":after": {
                        fontSize: "Z",
                        fontWeight: "300",
                        content: `"${j}"`,
                        textAlign: "center",
                        display: "inline-block",
                        style: {
                            color: "currentColor",
                            fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                        }
                    }
                };
            }
        }, u = (A, k)=>{
            let { key: $, props: P } = A, F = A.call("exec", P.name || P.icon || $, A);
            return A.call("isString", F) && F.includes("{{") && (F = A.call("replaceLiteralsWithObjectFields", F)), A.call("isString", F) ? F : $;
        }, p = u(t, e), d = c(p), h = d.split(/([a-z])([A-Z])/g), m = l(t, e, r);
        if (m) return m;
        let S;
        n.isActive && (S = f(t));
        let _ = o.props, w = _[".isActive"];
        o && _ && _.isActive && w && w.icon && (S = t.call("exec", w.icon || w.Icon.name || w.Icon.icon, t)), t.call("isString", S) && S.includes("{{") && (S = t.call("replaceLiteralsWithObjectFields", S));
        let E;
        s[S] && (E = S), s[d] ? E = d : s[h[0] + h[1]] ? E = h[0] + h[1] : s[h[0]] ? E = h[0] : a && t.warn("Can't find icon:", p, E);
        let R = s[E], T = o && o.props && o.props.src || n.src;
        return {
            spriteId: i && E,
            src: R || T || s.noIcon
        };
    },
    attr: {
        viewBox: "0 0 24 24"
    }
}, Ib = {
    display: "flex",
    align: "center center",
    lineHeight: 1,
    ".reversed": {
        flow: "row-reverse"
    },
    ".vertical": {
        flow: "column"
    },
    Icon: {
        if: (t)=>{
            let { parent: e, props: r } = t;
            return t.call("exec", e.props.icon || r.name || r.sfSymbols || e.props.sfSymbols, t);
        },
        icon: (t)=>t.call("exec", t.parent.props.icon, t.parent)
    },
    text: ({ props: t })=>t.text
}, Pb = {
    display: "flex",
    theme: "tertiary",
    boxSize: "C1",
    align: "center center",
    round: "Z",
    Icon: {
        fontSize: "B",
        margin: "auto",
        icon: "file"
    }
};
var Xa = {};
Mt(Xa, {
    default: ()=>$S,
    getActiveRoute: ()=>Ya,
    lastLevel: ()=>No,
    lastPathname: ()=>Po,
    matchRoute: ()=>Wa,
    parseQuery: ()=>Ga,
    parseRoutePattern: ()=>Ha,
    router: ()=>ne,
    runGuards: ()=>Ka
});
v();
v();
v();
v();
v();
var Nb = (t, e)=>{
    let r = e.on?.[t];
    if (r) return r;
    let n = e.props;
    if (!n) return;
    let o = "on" + t.charAt(0).toUpperCase() + t.slice(1);
    return n[o];
}, Db = (t, e, r, n)=>{
    let o = Xe(Nb(t, e), e);
    if (y(o)) {
        let { __ref: s } = e;
        s.__eventListeners || (s.__eventListeners = {}), s.__eventListeners[t] && r.removeEventListener(t, s.__eventListeners[t]);
        let i = (a)=>{
            let { state: c, context: f } = e;
            try {
                let l = o.call(e, a, e, c, f, n);
                l && typeof l.then == "function" && l.catch((u)=>{
                    e.error = u, console.error("[DOMQL] Async DOM event error:", u);
                });
            } catch (l) {
                if (e.error = l, console.error("[DOMQL] DOM event error:", l), f?.strictMode) throw l;
            }
        };
        s.__eventListeners[t] = i, r.addEventListener(t, i);
    }
}, pu = (t, e)=>{
    let { node: r, on: n } = t;
    for(let o in n)cs.has(o) || Db(o, t, r, e);
};
var du = {
    en: {
        DocumentNotDefined: {
            title: "Document is undefined",
            description: "To tweak with DOM, you should use browser."
        },
        OverwriteToBuiltin: {
            title: "Overwriting to builtin method",
            description: "Overwriting a builtin method in the window define is not possible, please choose different name"
        },
        BrowserNotDefined: {
            title: "Can't recognize environment",
            description: "Environment should be browser application, that can run Javascript"
        },
        SetQuickPreferancesIsNotObject: {
            title: "Quick preferances object is required",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        InvalidParams: {
            title: "Params are invalid",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        CantCreateWithoutNode: {
            title: "You must provide node",
            description: "Can't create DOM element without setting node or text"
        },
        HTMLInvalidTag: {
            title: "Element tag name (or DOM nodeName) is invalid",
            description: "To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/"
        },
        HTMLInvalidAttr: {
            title: "Attibutes object is invalid",
            description: "Please pass a valid plain object to apply as an attributes for a DOM node"
        },
        HTMLInvalidData: {
            title: "Data object is invalid",
            description: "Please pass a valid plain object to apply as an dataset for a DOM node"
        },
        HTMLInvalidStyles: {
            title: "Styles object is invalid",
            description: "Please pass a valid plain object to apply as an style for a DOM node"
        },
        HTMLInvalidText: {
            title: "Text string is invalid",
            description: "Please pass a valid string to apply text to DOM node"
        },
        ElementOnStateIsNotDefined: {
            title: "Element on state is not defined",
            description: "Please check the element object"
        }
    }
}, yt = (t, e, r)=>{
    let o;
    t && typeof t == "string" && (o = du.en[t]);
    let s = o ? `

${o.description}` : "", i = r ? `

${r}` : "";
    return new Error(`"${t}", "${e}"${s}${i}`);
};
v();
var hu = (t)=>ke(t || "div") || yt("HTMLInvalidTag");
var Fb = (t)=>{
    if (!t || !t.__ref) throw new Error("Element reference is invalid");
    let { __ref: e } = t;
    if (!e.root) throw new Error("Root reference is invalid");
    if (!e.root.data) throw new Error("Data are undefined");
    let { frameListeners: r } = e.root.data;
    r && !r.has(t) && r.add(t);
}, $b = (t)=>{
    for (let e of t){
        if (!e.__ref.__frameHandler) {
            let r = e.on?.frame || e.onFrame || e.props?.onFrame;
            if (r) e.__ref.__frameHandler = r;
            else {
                t.delete(e);
                continue;
            }
        }
        if (!e.node?.parentNode) t.delete(e), delete e.__ref.__frameHandler;
        else try {
            e.__ref.__frameHandler(e, e.state, e.context);
        } catch (r) {
            console.warn(r), t.delete(e), delete e.__ref.__frameHandler;
        }
    }
}, mu = (t)=>{
    let e = typeof window < "u" && window.requestAnimationFrame;
    if (Da || !e) return;
    Da = !0;
    function r() {
        if (t.size === 0) {
            Da = !1;
            return;
        }
        $b(t), e(r);
    }
    e(r);
}, gu = (t)=>{
    if (!t) throw new Error("Element is invalid");
    let { on: e, props: r, __ref: n } = t;
    if (!n.root || !n.root.data) return;
    let { frameListeners: o } = n.root.data;
    o && (e?.frame || t.onFrame || r?.onFrame) && (Fb(t), mu(o));
}, Da = !1, yu = ()=>{
    let t = new Set;
    return mu(t), t;
};
v();
var bu = (t)=>{
    let { props: e, on: r } = t;
    for(let n in e){
        if (n.charCodeAt(0) !== 111 || n.charCodeAt(1) !== 110) continue;
        let o = ce(n.slice(2)), s = r[o], i = e[n];
        y(s) ? r[o] = (...a)=>{
            if (s(...a) !== !1 && y(i)) return i(...a);
        } : r[o] = i;
    }
}, Su = (t)=>{
    let { on: e } = t, r = Ye(t.context);
    for(let n in t){
        if (n.charCodeAt(0) !== 111 || n.charCodeAt(1) !== 110 || !Object.prototype.hasOwnProperty.call(t, n)) continue;
        let o = t[n];
        if (!y(o) && !(r && o != null)) continue;
        let s = ce(n.slice(2)), i = e[s];
        y(i) ? e[s] = (...a)=>{
            if (i(...a) !== !1 && y(o)) return o(...a);
        } : e[s] = o;
    }
};
v();
var Fa = "http://www.w3.org/2000/svg", Lb = (t)=>{
    let { tag: e, context: r } = t, n = r.document || L;
    return e ? e === "string" ? n.createTextNode(t.text) : e === "fragment" ? n.createDocumentFragment() : Qe.has(e) && (e === "svg" || t.parent?.node?.namespaceURI === Fa) ? n.createElementNS(Fa, e) : n.createElement(e) : n.createElement("div");
}, $a = (t)=>{
    let { tag: e, key: r, props: n } = t;
    if (e = O(e, t), e === !0 && (e = r), g(n) && b(n.tag) && ke(n.tag)) return n.tag;
    if (b(e)) {
        if (ke(e)) return e;
    } else {
        let o = r.toLowerCase();
        if (o.includes(".") && (o = o.split(".")[0]), o.includes("_") && (o = o.split("_")[0]), ke(o)) return o;
    }
    return "div";
}, xu = (t)=>{
    let { context: e } = t, r = e.window || window, n = t.tag = $a(t);
    if (!hu(n)) return yt("HTMLInvalidTag", t.tag, t);
    r.nodeCaches || (r.nodeCaches = {});
    let s = Qe.has(n) && (n === "svg" || t.parent?.node?.namespaceURI === Fa) ? "svg:" + n : n, i = r.nodeCaches[s];
    i || (i = r.nodeCaches[s] = Lb(t));
    let a = i.cloneNode(!0);
    return n === "string" && (a.nodeValue = t.text), a;
};
var Mb = (t, e)=>{
    try {
        return e.appendChild(t), t;
    } catch  {
        console.error("Does not support to append", e, t);
    }
}, Bb = (t, e, r)=>{
    if (!t) throw new Error("Node is required");
    let n = r || e?.parentNode;
    e?.nextSibling ? n?.insertBefore(t, e.nextSibling) : e?.insertAdjacentElement ? e.insertAdjacentElement("afterend", t) : n?.insertBefore(t, e);
}, Ub = (t, e, r)=>{
    if (!t) throw new Error("Node is required");
    (r || e.parentNode)?.insertBefore(t, e);
}, La = (t, e, r, n)=>{
    if (!t) throw new Error("Element is required");
    if (!e) throw new Error("Parent is required");
    return e[r || t.key] = t, t.tag !== "shadow" && (n && n.position ? (n.position === "before" ? Ub : Bb)(t.node, n.node || e.node) : Mb(t.node, e.node, t)), t;
};
v();
var Eo = (t, e = {})=>{
    let { __ref: r } = t;
    for(let n in t){
        if (e[n]) continue;
        let o = t[n];
        if (y(o) && !Ht(n, t)) {
            r.__exec[n] = o;
            try {
                let s = o(t, t.state, t.context);
                s && typeof s.then == "function" ? s.then((i)=>{
                    t[n] = i;
                }).catch((i)=>{
                    console.warn("[DOMQL] Async exec error in", n, ":", i?.message || i);
                }) : t[n] = s;
            } catch (s) {
                console.warn("[DOMQL] Exec error in", n, ":", s?.message || s);
            }
        }
    }
}, _u = (t, e = {})=>{
    let { __ref: r } = t, n = {};
    for(let o in r.__exec){
        let s = t[o];
        if (r.__defineCache[o]) continue;
        let a = r.__exec[o](t, t.state, t.context);
        if (a && typeof a.then == "function") {
            a.then((f)=>{
                t[o] = f;
            });
            continue;
        }
        let c = b(a) || ct(a);
        if (s?.node && c) fe(s, {
            text: a
        });
        else if (a !== s) {
            if (It(o)) {
                let { extends: f, ...l } = Fs(a, t, o);
                fe(s, l);
            } else n[o] = s, t[o] = a;
        }
    }
    return n;
}, Co = (t)=>{
    let { __ref: e } = t, { props: r } = t;
    for(let n in r){
        let o = n.charCodeAt(0), s = n.charCodeAt(1), i = o === 105 && s === 115 || o === 104 && s === 97 && n.charCodeAt(2) === 115 || o === 117 && s === 115 && n.charCodeAt(2) === 101, a = e.__execProps[n];
        if (y(a)) {
            let c = O(a, t);
            c && typeof c.then == "function" ? c.then((f)=>{
                r[n] = f;
            }) : r[n] = c;
        } else if (i && y(r[n])) {
            e.__execProps[n] = r[n];
            let c = O(r[n], t);
            c && typeof c.then == "function" ? c.then((f)=>{
                r[n] = f;
            }) : r[n] = c;
        }
    }
}, ko = (t)=>{
    let { define: e, context: r, __ref: n } = t, o = g(e), s = r && g(r.define);
    if (!o && !s) return t;
    let i = o && s ? {
        ...e,
        ...r.define
    } : o ? e : r.define;
    for(let a in i){
        let c = t[a];
        if (y(c) && !Ht(a, t)) {
            n.__exec[a] = c;
            let l = O(c, t);
            l && typeof l.then == "function" ? l.then((u)=>{
                c = t[a] = u && u.parse ? u.parse() : u, u && (n.__defineCache[a] = c);
            }) : (c = t[a] = l && l.parse ? l.parse() : l, l && (n.__defineCache[a] = c));
        }
        let f = i[a](c, t, t.state, t.context);
        f && typeof f.then == "function" ? f.then((l)=>{
            l && (t[a] = l);
        }) : f && (t[a] = f);
    }
    return t;
}, wu = (t)=>{
    let { context: e, define: r, __ref: n } = t, o = g(r), s = g(e?.define);
    if (!o && !s) return;
    let i = o && s ? {
        ...r,
        ...e.define
    } : o ? r : e.define;
    for(let a in i){
        let c = n.__exec[a];
        if (c) {
            let u = c(t, t.state, t.context);
            u && typeof u.then == "function" ? u.then((p)=>{
                n.__defineCache[a] = p;
            }) : n.__defineCache[a] = u;
        }
        let f = O(n.__defineCache[a], t);
        if (f && typeof f.then == "function") {
            f.then((u)=>{});
            continue;
        }
        let l = typeof i[a] == "function" ? i[a](f, t, t.state, t.context) : void 0;
        l && typeof l.then == "function" ? l.then((u)=>{
            t[a] = u;
        }) : l && (t[a] = l);
    }
};
v();
function vu(t, e, r) {
    let { __ref: n, props: o } = e, { __attr: s } = n;
    if (Fr(t)("object") && yt("HTMLInvalidAttr", t), t) {
        let i = O(t, e);
        o.attr && U(i, o.attr);
        for(let a in i){
            let c = O(i[a], e);
            b(c) && c.includes("{{") && e.call && (c = e.call("replaceLiteralsWithObjectFields", c, e.state)), c !== s[a] && (c !== !1 && c !== void 0 && c !== null && r.setAttribute ? r.setAttribute(a, c) : r.removeAttribute && r.removeAttribute(a), s[a] = c);
        }
    }
}
v();
var Eu = (t)=>{
    let { key: e } = t;
    t.classlist === !0 ? t.classlist = e : !t.classlist && typeof e == "string" && e.charAt(0) === "_" && e.charAt(1) !== "_" && (t.classlist = e.slice(1));
}, Vb = (t, e)=>{
    let r = "";
    for(let n in t){
        let o = t[n];
        typeof o == "boolean" && o ? r += ` ${n}` : typeof o == "string" ? r += ` ${o}` : typeof o == "function" && (r += ` ${O(o, e)}`);
    }
    return r;
}, Cu = (t, e)=>{
    if (!t) return;
    let { key: r } = e;
    return t === !0 && (t = e.classlist = {
        key: r
    }), b(t) && (t = e.classlist = {
        default: t
    }), g(t) && (t = Vb(t, e)), t.replace(/\s+/g, " ").trim();
};
v();
function jb(t, e, r) {
    if (t && (e.props.data && U(t, e.props.data), t.showOnNode)) {
        g(t) || yt("HTMLInvalidData", t);
        for(let n in t)n !== "showOnNode" && (r.dataset[n] = O(t[n], e));
    }
}
var ku = jb;
v();
function zb(t, e, r) {
    let n = O(t ?? e?.props?.html, e), { __ref: o } = e;
    n !== o.__html && (r.nodeName === "SVG" ? r.textContent = n : r.innerHTML = n, o.__html = n);
}
var Ou = zb;
v();
function qb(t, e, r) {
    if (t) {
        if (g(t)) {
            let { __ref: n } = e;
            n.__style || (n.__style = {});
            let o = n.__style;
            for(let s in t){
                let i = O(t[s], e);
                i !== o[s] && (o[s] = i, r.style[s] = i);
            }
        } else yt("HTMLInvalidStyles", t);
    }
}
var Au = qb;
v();
function Hb(t, e, r) {
    let n = O(e.props.text || t, e);
    if (y(n) && (n = O(n, e)), b(n) && n.includes("{{") && (n = e.call("replaceLiteralsWithObjectFields", n, e.state)), e.tag === "string") r.nodeValue = n;
    else if (t != null) {
        if (Qe.has(e.tag)) {
            r && (r.textContent = n);
            return;
        }
        if (e.__text) {
            if (e.__text.text === n) return;
            e.__text.text = n, e.__text.node && (e.__text.node.nodeValue = n);
        } else jt({
            tag: "string",
            text: n
        }, e, "__text");
    }
}
var Tu = Hb;
v();
function Wb(t, e, r) {
    let n = O(t, e);
    if (g(n)) for(let o in n)Tt.has(o) || Object.prototype.hasOwnProperty.call(n, o);
    return e;
}
var Ru = Wb;
v();
function Gb(t, e, r) {
    if (g(t)) for(let n in t){
        let o = t[n];
        y(o) ? e.scope[n] = o.bind(e) : e.scope[n] = o;
    }
}
var Iu = Gb;
var re = {
    attr: vu,
    style: Au,
    text: Tu,
    html: Ou,
    data: ku,
    classlist: Cu,
    state: Ru,
    scope: Iu,
    fetch: {},
    deps: (t, e)=>t || e.parent.deps,
    extends: {},
    children: {},
    content: {},
    childExtend: {},
    childExtends: {},
    childExtendRecursive: {},
    childExtendsRecursive: {},
    props: {},
    if: {},
    define: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    variables: {},
    on: {},
    component: {},
    context: {}
};
v();
var Oo = (t, e, r)=>{
    let { node: n, context: o, __ref: s } = e, i = O(e[t], e), { onlyUpdate: a } = r, c = re[t], l = o?.registry?.[t] || c, u = e.define?.[t], p = o?.define?.[t];
    if (!s.__if) return;
    let d = a ? a === t || e.lookup(a) : !0;
    if (l && !p && d) {
        y(l) && l(i, e, n, r);
        return;
    }
    return {
        hasDefine: u,
        hasContextDefine: p
    };
};
v();
var Ma = (t, e)=>{
    if (t === e) return !0;
    if (!t || !e) return !1;
    let r = typeof t, n = typeof e;
    if (r === "function" && n === "function") return !0;
    if (r !== n) return !1;
    if (x(t) && x(e)) {
        if (t.length !== e.length) return !1;
        for(let o = 0; o < t.length; o++)if (!Ma(t[o], e[o])) return !1;
        return !0;
    }
    if (g(t) && g(e)) {
        let o = Object.keys(t), s = Object.keys(e);
        if (o.length !== s.length) return !1;
        for(let i = 0; i < o.length; i++){
            let a = o[i];
            if (!Ma(t[a], e[a])) return !1;
        }
        return !0;
    }
    return t === e;
}, Pu = new Set([
    ".",
    "/",
    "./"
]), Kb = (t, e)=>{
    if (!b(t) || !e) return;
    if (Pu.has(t)) return e.parse ? e.parse() : e;
    let r = Je(t, e);
    if (r) {
        let o = t.replaceAll("~/", "");
        return tr(o, r);
    }
    let n = Ze(t, e);
    if (n) {
        let o = t.replaceAll("../", "");
        return tr(o, n);
    }
    return tr(t, e);
};
function Yb(t, e, r) {
    let { children: n, __ref: o, state: s } = e, { childrenAs: i } = e.props || {}, a = O(t, e, s), c = O(n, e, s);
    n = a || c;
    let f;
    if (n) {
        if (Wn(n) && (i = i || "state", n = n.parse()), b(n) || ct(n)) {
            let p = Kb(n, s);
            p !== void 0 ? (f = Pu.has(n) ? "" : n, n = Wn(p) ? p.parse() : p) : n = {
                text: n
            };
        }
        if (g(n)) {
            if (n.$$typeof) return e.call("renderReact", n, e);
            n = Object.keys(n).map((p)=>{
                let d = n[p];
                return It(p) ? As(p, d) : d;
            });
        }
    }
    if (!n || Fr(n)("array", "object")) return;
    if (x(n) && n.some((p)=>p?.$$typeof)) {
        let p = [], d = [];
        for(let h = 0; h < n.length; h++)n[h]?.$$typeof ? d.push(n[h]) : p.push(n[h]);
        d.length && e.call("renderReact", d, e), n = p;
    }
    let l;
    o.__childrenCache ? Ma(n, o.__childrenCache) ? o.__noChildrenDifference = !0 : (l = z(n), o.__childrenCache = l, delete o.__noChildrenDifference) : (l = z(n), o.__childrenCache = l), (g(n) || x(n)) && (n = l || z(n));
    let u = {
        tag: "fragment"
    };
    for(let p in n){
        let d = Object.prototype.hasOwnProperty.call(n, p) && n[p];
        if (Ot(d) && d !== null && d !== !1) {
            if (f !== void 0 && i !== "props") {
                let h = f ? `${f}/${p}` : p;
                u[p] = {
                    state: h
                };
            } else u[p] = N(d) ? i ? {
                [i]: d
            } : d : i ? {
                [i]: i === "state" ? {
                    value: d
                } : {
                    text: d
                }
            } : {
                text: d
            };
        }
    }
    return u;
}
var Ao = Yb;
var Nu = "production", Du = (t, e)=>{
    let { node: r, tag: n, __ref: o } = t;
    if (!o.__if) return t;
    let s;
    r || (s = !0, n === "shadow" ? r = t.node = t.parent.node.attachShadow({
        mode: "open"
    }) : r = t.node = xu(t), W("attachNode", t, e)), (Nu === "test" || Nu === "development" || e.alowRefReference) && (r.ref = t, y(r.setAttribute) && r.setAttribute("key", t.key)), Co(t), ko(t), Eo(t), bu(t), Su(t), pu(t, {
        isNewNode: s,
        ...e
    });
    for(let a in t){
        let c = t[a];
        if (!Object.prototype.hasOwnProperty.call(t, a) || c === void 0 || Ht(a, t) || g(re[a]) || a.length > 2 && a.charCodeAt(0) === 111 && a.charCodeAt(1) === 110 && a.charCodeAt(2) >= 65 && a.charCodeAt(2) <= 90) continue;
        let f = Oo(a, t, e);
        if (f) {
            let { hasDefine: l, hasContextDefine: u } = f;
            if (t[a] && !l && !u) {
                let p = ()=>{
                    jt(c, t, a, e);
                };
                t.props && t.props.lazyLoad || e.lazyLoad ? window.requestAnimationFrame(()=>{
                    p(), e.preventUpdateListener || W("lazyLoad", t, e);
                }) : p();
            }
        }
    }
    let i = t.children ? Ao(t.children, t, e) : t.children || t.content;
    return i && gn(i, t, e), t;
};
v();
var Ba = {
    key: ":root",
    node: L ? L.body : yt("DocumentNotDefined", L)
}, Ua = Ba;
v();
v();
v();
v();
var Fu = {
    overwrite: !0,
    preventHoistElementUpdate: !1,
    updateByState: !0,
    isHoisted: !0
}, $u = function(t, e = Fu) {
    let r = this, n = r.__element;
    if (e.onEach && e.onEach(n, r, n.context, e), e.updateByState || Y(e, Fu), r.__element || yt("ElementOnStateIsNotDefined"), e.preventInheritAtCurrentState === !0) e.preventInheritAtCurrentState = r;
    else if (e.preventInheritAtCurrentState) return;
    return !e.preventBeforeStateUpdateListener && vt("beforeStateUpdate", t, n, e) === !1 ? n : (Zs(r, t, e), Xb(r, t, e) || (Qb(r, t, e), Jb(r, t, e), e.preventStateUpdateListener || vt("stateUpdate", t, n, e)), r);
}, Xb = (t, e, r)=>{
    let n = t.__element, { parent: o, __ref: s } = n, i = s?.__state, a = s?.__stateType;
    if (!i) return;
    let c = rr(n), f = er(n, o, {
        returnParent: !0
    });
    if (!(c && f && !r.stopStatePropagation)) return;
    let u = a === "string" || a === "number" || a === "boolean", p = u ? t.value : t.parse(), d = u ? t.value : e, h = Je(i, o.state), m = Ze(i, o.state), S = i.replaceAll("~/", "").replaceAll("../", ""), _ = Qs(S, d), w = h || m || o.state;
    r.replace && it(w, _ || p), w.update(_, {
        ...r,
        isHoisted: !0,
        preventUpdate: r.preventHoistElementUpdate,
        overwrite: !r.replace
    });
    let E = r.preventUpdate !== !0 || !r.preventHoistElementUpdate;
    return !r.preventStateUpdateListener && E && vt("stateUpdate", e, n, r), !0;
}, Qb = (t, e, r)=>{
    if (t.__depends) for(let n in t.__depends)t.__depends[n].clean().update(t.parse(), r);
}, Jb = (t, e, r)=>{
    let n = t.__element;
    r.preventUpdate !== !0 ? n.update({}, {
        ...r,
        updateByState: !0
    }) : r.preventUpdate === "recursive" && n.update({}, {
        ...r,
        isHoisted: !1,
        updateByState: !0,
        preventUpdate: !0
    });
};
var Zb = function() {
    let t = this;
    if (g(t)) {
        let e = {};
        for(let r in t)Tt.has(r) || (e[r] = t[r]);
        return e;
    } else if (x(t)) return t.filter((e)=>!Tt.has(e));
}, tS = function(t = {}) {
    let e = this;
    for(let r in e)!Tt.has(r) && Object.prototype.hasOwnProperty.call(e, r) && delete e[r];
    return t.preventStateUpdate || e.update(e, {
        replace: !0,
        ...t
    }), e;
}, eS = function(t = {}) {
    let e = this, r = e.__element, n = r.__ref.__state;
    if (b(n)) return r.parent.state.remove(n, {
        isHoisted: !0,
        ...t
    }), r.state;
    if (delete r.state, r.state = e.parent, e.parent && delete e.parent.__children[r.key], e.__children) for(let o in e.__children){
        let s = e.__children[o];
        s.state && (x(s.state) ? Object.defineProperty(s.state, "parent", {
            value: e.parent,
            enumerable: !1,
            configurable: !0,
            writable: !0
        }) : Object.setPrototypeOf(s, {
            parent: e.parent
        }));
    }
    return r.state.update({}, {
        isHoisted: !0,
        ...t
    }), r.state;
}, rS = function(t, e = {}) {
    let r = this;
    if (!(!r || !r.parent)) return r.parent.update(t, {
        isHoisted: !0,
        ...e
    });
}, nS = function(t, e = {}) {
    let r = this;
    return r ? r.__element.__ref.root.state.update(t, {
        isHoisted: !1,
        ...e
    }) : void 0;
}, oS = function(t, e = {}) {
    let r = this;
    if (x(r)) r.push(t), r.update(r.parse(), {
        overwrite: !0,
        ...e
    });
    else if (g(r)) {
        let n = Object.keys(r).length;
        r.update({
            [n]: t
        }, e);
    }
}, sS = function(t, e = {}) {
    let r = this;
    r.update({
        [t]: !r[t]
    }, e);
}, iS = function(t, e = {}) {
    let r = this;
    return x(r) ? es(r, t) : g(r) && ds(r, t), e.applyReset ? r.set(r.parse(), {
        replace: !0,
        ...e
    }) : r.update({}, e);
}, aS = function(t, e = {}) {
    let r = this, n = z(t);
    return r.clean({
        preventStateUpdate: !0,
        ...e
    }).update(n, {
        replace: !0,
        ...e
    });
}, Lu = function(t, e, r = {}) {
    let n = this, o = z(e);
    r.preventReplace || gs(n, t, e);
    let s = hs(t, o);
    return r.preventStateUpdate ? s : n.update(s, r);
}, cS = function(t, e = {}) {
    let r = this, n = t.reduce((o, s)=>{
        if (s[0] === "update") {
            let i = Lu.call(r, s[1], s[2], {
                preventStateUpdate: !0
            });
            return it(o, i);
        } else s[0] === "delete" && Va.call(r, s[1], {
            ...e,
            preventUpdate: !0
        });
        return o;
    }, {});
    return r.update(n, e);
}, Va = function(t, e = {}) {
    let r = this;
    return ms(r, t), e.preventUpdate ? t : r.update({}, e);
}, lS = function(t, e = {}) {
    let r = this;
    for(let n = 0; n < t.length; n++)Va(t[n], {
        preventUpdate: !0
    });
    return r.update({}, e);
}, fS = function(t, e = {}) {
    return ys(this, t);
}, uS = function(t = {}) {
    let e = this, r = z(e.parse());
    return e.set(r, {
        replace: !0,
        ...t
    });
}, pS = function(t, e = {}) {
    let r = this;
    if (y(t)) {
        let n = t(r);
        return r.update(n, {
            replace: !0,
            ...e
        });
    }
}, dS = function(t, e = {}) {
    let r = this;
    if (y(t)) {
        let n = t(r);
        return r.replace(n, e);
    }
}, hS = function(t, e = {}) {
    let r = this;
    if (y(t)) return t(r), r.update(r.parse(), {
        replace: !0,
        ...e
    });
}, mS = function(t, e = {}) {
    return this.update(t, {
        preventUpdate: !0,
        ...e
    });
}, gS = function(t, e = {}) {
    let r = this;
    for(let n in t)r[n] = t[n];
    return r.update(t, e);
}, yS = function(t, e = {}) {
    return this.replace(t, {
        preventUpdate: !0,
        ...e
    });
}, bS = function(t, e = {}) {
    return Object.keys(this);
}, SS = function(t, e = {}) {
    return Object.values(this);
}, Mu = (t)=>{
    let e = t.state, r = t.__ref, n = {
        clean: tS.bind(e),
        parse: Zb.bind(e),
        destroy: eS.bind(e),
        update: $u.bind(e),
        rootUpdate: nS.bind(e),
        parentUpdate: rS.bind(e),
        create: Me.bind(e),
        add: oS.bind(e),
        toggle: sS.bind(e),
        remove: iS.bind(e),
        apply: pS.bind(e),
        applyReplace: dS.bind(e),
        applyFunction: hS.bind(e),
        set: aS.bind(e),
        quietUpdate: mS.bind(e),
        replace: gS.bind(e),
        quietReplace: yS.bind(e),
        reset: uS.bind(e),
        parent: t.parent?.state || e,
        setByPath: Lu.bind(e),
        setPathCollection: cS.bind(e),
        removeByPath: Va.bind(e),
        removePathCollection: lS.bind(e),
        getByPath: fS.bind(e),
        keys: bS.bind(e),
        values: SS.bind(e),
        __element: t,
        __children: {},
        root: r?.root ? r.root.state : e
    };
    x(e) ? $r(e, n) : Object.setPrototypeOf(e, n), e.parent && e.parent.__children && (e.parent.__children[t.key] = e);
};
var Me = function(t, e, r) {
    return t.state = xS(t, e, r), t.state;
}, xS = function(t, e, r) {
    let n = Ys(t);
    if (n === !1) return e.state || {};
    if (t.state = n, W("stateInit", t, r) === !1) return t.state;
    if (rr(t)) {
        let i = Xs(t, e);
        t.state = K(i) ? {} : i;
    }
    let s = Js(t, t.state || e.state || {});
    return s && (t.state = s), Mu(t), W("stateCreated", t), t.state;
};
v();
v();
var Bu = [];
var To = {
    stackChanges: !1,
    cleanExec: !0,
    preventRecursive: !1,
    currentSnapshot: !1,
    calleeElement: !1,
    exclude: Bu
}, yn = function(t = {}, e) {
    let r = g(e) ? {
        ...To,
        ...e
    } : {
        ...To
    }, n = this, o = n.__ref;
    o || (o = n.__ref = {});
    let [s, i, a] = Di(n, r);
    if (a) return;
    r.preventListeners || vt("startUpdate", t, n, r);
    let { parent: c, node: f, key: l } = n, { exclude: u, preventInheritAtCurrentState: p } = r;
    if (p && p.__element === n || (u || Y(r, To), (b(t) || ct(t)) && (t = {
        text: t
    }), t = Us.call(n, t), vS(n, r) === !1) || wS(n, c, r)) return;
    if (o.__if && !r.preventPropsUpdate) {
        let P = c.props && (c.props[l] || c.props.childProps), F = o.__propsStack.some(y), j = t.props || P || F;
        j && Hs(j, n, c);
    }
    if (!r.preventBeforeUpdateListener && !r.preventListeners && (n.on?.beforeUpdate || n.props?.onBeforeUpdate)) {
        let F = {
            ...t,
            ...n
        };
        if (Object.setPrototypeOf(F, Object.getPrototypeOf(n)), vt("beforeUpdate", t, F, r) === !1) return n;
    }
    if (it(n, t), Co(n), _u(n, {
        ignore: To
    }), wu(n), !r.isForced && !r.preventListeners && W("beforeClassAssign", n, r), !o.__if) return !1;
    if (!f) return;
    let { preventUpdate: m, preventDefineUpdate: S, preventContentUpdate: _, preventStateUpdate: w, preventRecursive: E, preventUpdateListener: R, preventUpdateAfter: T, preventUpdateAfterCount: A } = r;
    if (T) {
        if (ct(A) && T <= A) return;
        r.preventUpdateAfterCount === void 0 ? r.preventUpdateAfterCount = 1 : r.preventUpdateAfterCount++;
    }
    let k = x(m) ? new Set(m) : null, $ = x(S) ? new Set(S) : null;
    for(let P in n){
        let F = n[P];
        if (!Object.prototype.hasOwnProperty.call(n, P)) continue;
        let j = k && k.has(P), Z = $ && $.has(P), tt = y(F) && P.length > 2 && P.charCodeAt(0) === 111 && P.charCodeAt(1) === 110 && P.charCodeAt(2) >= 65 && P.charCodeAt(2) <= 90;
        if (K(F) || j || Z || S === !0 || S === P || w && P === "state" || Ht(P, n) || tt || g(re[P])) continue;
        w === "once" && (r.preventStateUpdate = !1);
        let pt = Oo(P, n, r);
        if (pt) {
            let { hasDefine: _t, hasContextDefine: Lt } = pt;
            if (!(g(F) && !_t && !Lt && !E)) continue;
            let Yo = n.props.lazyLoad || r.lazyLoad;
            r.onEachUpdate && r.onEachUpdate(P, n, n.state, n.context);
            let st = t[P];
            if (st === void 0 && !r.isForced) {
                if (r.onlyUpdate) {
                    if (P !== r.onlyUpdate) continue;
                } else if (!r.updateByState) continue;
            }
            let Xo = r.onlyUpdate && P === r.onlyUpdate ? {
                ...r,
                onlyUpdate: void 0,
                currentSnapshot: s,
                calleeElement: i
            } : {
                ...r,
                currentSnapshot: s,
                calleeElement: i
            }, Qo = ()=>yn.call(F, st, Xo);
            Yo ? D.requestAnimationFrame(()=>{
                Qo(), !r.preventUpdateListener && !r.preventListeners && W("lazyLoad", n, r);
            }) : Qo();
        }
    }
    if (!_) {
        let P = o.contentElementKey || "content", F = n[P], j = r.updateByState ? t.children || (o.__exec?.children ? n.children : void 0) : t.children || n.children;
        if (j) {
            let Z = Ao(j, n, e);
            if (Z && !o.__noChildrenDifference) gn(Z, n, r);
            else if (F?.__ref && y(F.update)) {
                let tt = n.props?.lazyLoad || r.lazyLoad, pt = ()=>yn.call(F, t[P], {
                        ...r,
                        currentSnapshot: s,
                        calleeElement: i
                    });
                tt ? D.requestAnimationFrame(()=>{
                    pt(), !r.preventUpdateListener && !r.preventListeners && W("lazyLoad", n, r);
                }) : pt();
            }
        } else if (F?.__ref && y(F.update)) {
            let Z = n.props?.lazyLoad || r.lazyLoad, tt = ()=>yn.call(F, t[P], {
                    ...r,
                    currentSnapshot: s,
                    calleeElement: i
                });
            Z ? D.requestAnimationFrame(()=>{
                tt(), !r.preventUpdateListener && !r.preventListeners && W("lazyLoad", n, r);
            }) : tt();
        } else {
            let Z = n.children || t.content;
            Z && !r.updateByState && gn(Z, n, r);
        }
    }
    !R && !r.preventListeners && W("update", n, r), !r.preventFetch && o.__fetchOnStateChange && o.__fetchOnStateChange();
}, _S = (t, e)=>{
    let { __children: r } = e.__ref || {};
    if (!r) return !1;
    let n = r.indexOf(t.key), o;
    for(let i = n - 1; i >= 0; i--){
        let a = e[r[i]];
        if (a?.node?.parentNode) {
            o = a.node;
            break;
        }
    }
    if (o) return {
        position: "after",
        node: o
    };
    let s;
    for(let i = n + 1; i < r.length; i++){
        let a = e[r[i]];
        if (a?.node?.parentNode) {
            s = a.node;
            break;
        }
    }
    return s ? {
        position: "before",
        node: s
    } : !1;
}, wS = (t, e, r)=>{
    if (!y(t.if) && !y(t.props?.if) || !e) return;
    let n = t.__ref, o = (t.if || t.props?.if)(t, t.state, t.context, r), s = n.__if !== !0;
    if (o) {
        if (n.__if = !0, s) {
            delete t.__hash, delete t.__text, delete t.extends, n.__hasRootState || delete t.state, n.__state ? t.state = n.__state : n.__hasRootState || delete t.state, t.node && (t.node.remove(), delete t.node);
            let i = n.contentElementKey;
            t.children ? t.removeContent() : t[i]?.parseDeep && (t[i] = t[i].parseDeep());
            let a = _S(t, e);
            delete t.__ref, delete t.parent;
            let c = jt(t, e, t.key, ut.create, a);
            return r.preventUpdate !== !0 && t.on && y(t.on.update) && jr(t.on.update, c, c.state), c;
        }
    } else t.node && !o && (t.node.remove(), delete n.__if);
}, vS = (t, e)=>{
    let { __ref: r } = t, n = r.__state, { parent: o } = t, { preventUpdateTriggerStateUpdate: s } = e;
    if (s) return;
    if (!n && !r.__hasRootState) {
        t.state = o?.state || {};
        return;
    }
    let i = er(t, t.parent);
    if (!i || e.preventInheritedStateUpdate) return;
    if (!e.preventBeforeStateUpdateListener && !e.preventListeners && vt("beforeStateUpdate", i, t, e) === !1) return t;
    let a = ES(t, o, e);
    !e.preventStateUpdateListener && !e.preventListeners && vt("stateUpdate", a.parse(), t, e);
}, ES = (t, e, r)=>{
    let n = t.state.__children, o = Me(t, e);
    t.state = o;
    for(let s in n)o[s] && (o.__children[s] = n[s]), Object.getPrototypeOf(n[s]).parent = o;
    return o;
};
Ni();
var ja = (t, e, r = {})=>{
    let n = {
        set: qa,
        reset: Uu,
        update: yn,
        variables: Ti,
        remove: gi,
        updateContent: Vu,
        removeContent: za,
        setProps: yi,
        lookup: di,
        lookdown: hi,
        lookdownAll: mi,
        getRef: bi,
        getDB: Ii,
        getPath: Si,
        getQuery: Pi,
        getRootState: xi,
        getRoot: _i,
        getRootData: wi,
        getRootContext: vi,
        getContext: Ei,
        setNodeStyles: Qn,
        spotByPath: pi,
        parse: Zn,
        parseDeep: Xr,
        keys: Jn,
        nextElement: Oi,
        previousElement: Ai,
        log: Ci,
        verbose: to,
        warn: ki,
        error: Qr,
        call: Ri
    };
    t.context.methods && (r.strict ? Y : fe)(n, t.context.methods), Object.setPrototypeOf(t, n);
};
var CS = new Set([
    "class",
    "style"
]), kS = (t)=>{
    let { tag: e, props: r, context: n } = t;
    if (!e || !r) return;
    let o = Fl(e, r, n?.cssPropsRegistry), s = {};
    for(let a in o)CS.has(a) || (s[a] = o[a]);
    let i = !1;
    for(let a in s){
        i = !0;
        break;
    }
    i && (t.attr ? typeof t.attr == "object" && (t.attr = {
        ...s,
        ...t.attr
    }) : t.attr = s);
}, Ro = "production", jt = (t, e, r, n = ut.create || {}, o)=>{
    OS(n);
    let s = Ks(t, e, r, n, Ba);
    if (!s) return;
    let { key: i, parent: a, __ref: c } = s;
    return Gs(s, a), Ns(s, a, n), n.onlyResolveExtends ? IS(s, a, i, n) : (qn.call(s, s), W("start", s, n), AS(s, a, n), ja(s, a, n), Gn(s, a), Me(s, a), Ur(s, a), Hn(s, a, n), Vr.call(s, s, {
        cachedKeys: []
    }), s.tag || (s.tag = $a(s)), kS(s), Ur(s, a), s.node && c.__if ? La(s, a, i, o) : (W("init", s, n) === !1 || (W("beforeClassAssign", s, n), Eu(s), RS(s, a, n, o), zu(s, a), W("complete", s, n)), s));
}, OS = (t)=>{
    t && !ut.create && (ut.create = t, ut.create.context = t.context);
}, AS = (t, e, r)=>{
    let n = !1;
    for(let o in r){
        n = !0;
        break;
    }
    n && (ut.defaultOptions = r, r.ignoreChildExtends && delete r.ignoreChildExtends);
}, zu = (t, e)=>{
    e.__ref && e.__ref.__children && (e.__ref.__children.includes(t.key) || e.__ref.__children.push(t.key));
}, TS = 1, ju = new WeakMap, RS = (t, e, r, n)=>{
    ju.has(t) && (Ro === "test" || Ro === "development") && console.warn("Cyclic rendering detected:", t.__ref.path), ju.set(t, !0);
    let { __ref: o, key: s } = t, i = ()=>{
        let a = bs(o.path);
        o.__uniqId || a || (Du(t, r), o.__uniqId = TS++);
    };
    if (Ro === "test" || Ro === "development" || t.context?.strictMode) i();
    else try {
        i();
    } catch (a) {
        t.error = a;
        let c = o.path;
        c.includes("ComponentsGrid") && c.splice(0, c.indexOf("ComponentsGrid") + 2), c.includes("demoComponent") && c.splice(0, c.indexOf("demoComponent") + 1);
        let f = t.lookup((l)=>l.state.key)?.state?.key;
        t.warn("Error happened in:", f ? f + " " : "" + c.join(".")), t.verbose(), console.error("[DOMQL] Render error:", a), t.on?.error && t.on.error(a, t, t.state, t.context, r);
    }
    if (!o.__if) return e[s || t.key] = t, t;
    La(t, e, s, n), gu(t, r), W("render", t, r), W("renderRouter", t, r), W("done", t, r), W("create", t, r);
}, IS = (t, e, r, n)=>{
    let { __ref: o } = t;
    if (ja(t, e, n), Gn(t, e), Me(t, e), Ur(t, e), Hn(t, e, n), Vr.call(t, t, {
        cachedKeys: []
    }), t.node && o.__if && (e[r || t.key] = t), t.props || (t.props = {}), zu(t, e), t.tag !== "string" && t.tag !== "fragment") {
        ko(t), Eo(t);
        for(let s in t){
            if (K(t[s]) || Ht(s, t) || g(re[s])) continue;
            let i = t.define?.[s], a = t.context?.define?.[s], c = n.define?.[s];
            if (!(!o.__skipCreate && re[s] && !c) && t[s] && !i && !c && !a) try {
                jt(O(t[s], t), t, s, n);
            } catch (f) {
                console.warn("[DOMQL] onlyResolveExtends child error in", s, ":", f?.message || f);
            }
        }
    }
    return e[r || t.key] = t, delete t.update, delete t.__element, t.props && (delete t.props.update, delete t.props.__element), t;
}, Io = jt;
var Cr = (t, e = {})=>{
    let { __ref: r } = t, n = e.contentElementKey;
    return (!r.contentElementKey || n !== r.contentElementKey) && (r.contentElementKey = n || "content"), r.contentElementKey;
};
function Uu(t) {
    let e = this;
    jt(e, e.parent, void 0, {
        ignoreChildExtends: !0,
        ...ut.defaultOptions,
        ...ut.create,
        ...t
    });
}
var qu = (t, e, r)=>{
    let n = Cr(e, r);
    e[n]?.node && za(e, r);
    let o = jt(t, e, n || "content", {
        ignoreChildExtends: !0,
        ...ut.defaultOptions,
        ...ut.create,
        ...r
    });
    return n !== "content" && (r.contentElementKey = "content"), o;
}, Vu = function(t, e) {
    let r = this, n = Cr(r, e);
    r[n] && r[n].update && r[n].update(t, e);
};
function gn(t, e, r) {
    let n = O(t, e);
    n && e && qa.call(e, n, r);
}
var za = function(t, e = {}) {
    let r = t || this, n = Cr(r, e);
    e.contentElementKey !== "content" && (e.contentElementKey = "content");
    let o = r[n];
    if (o) {
        if (o.tag === "fragment" && o.__ref?.__children) {
            let s = o.__ref.__children;
            for(let i = 0; i < s.length; i++){
                let a = o[s[i]];
                a.node && a.node.parentNode && a.node.parentNode.removeChild(a.node), y(a.remove) && a.remove();
            }
        } else o.node && o.node.parentNode && o.node.parentNode.removeChild(o.node), y(o.remove) && o.remove();
        delete r[n];
    }
}, qa = function(t, e = {}, r) {
    let n = r || this, { __ref: o } = n;
    if (o.__settingContent) return n;
    o.__settingContent = !0;
    try {
        return PS(t, e, n);
    } finally{
        o.__settingContent = !1;
    }
}, PS = function(t, e, r) {
    let { __ref: n } = r, o = Cr(r, e), s = r[o], i = s && s.__ref, a = r.props && r.props.lazyLoad, c = r.children;
    if (e.preventContentUpdate === !0 && !c) return;
    let f = !n.__noChildrenDifference, l = f && i && Object.keys(t).length === Object.keys(s).length && ps(t, s);
    if (s?.update && !f && !l) {
        if (!e.preventBeforeUpdateListener && !e.preventListeners && vt("beforeUpdate", t, r, e) === !1) return r;
        s.update(t), !e.preventUpdateListener && !e.preventListeners && W("update", r, e);
        return;
    }
    if (!t || typeof t != "object") return r;
    let { childExtends: u, props: p, tag: d } = t;
    if (p || (p = t.props = {}), d === "fragment") {
        let h = r.childExtends || r.childExtend;
        !u && h && (t.childExtends = h, p.ignoreChildExtends = !0);
        let m = r.childProps || r.props?.childProps;
        !p?.childProps && m && (p.childProps = m), p.ignoreChildProps = !0;
    }
    a ? window.requestAnimationFrame(()=>{
        qu(t, r, e), e.preventUpdateListener || W("lazyLoad", r, e);
    }) : qu(t, r, e);
};
var Wu = /^:(.+)/, Gu = /^\*$/, Hu = new Map, Ha = (t)=>{
    let e = Hu.get(t);
    if (e) return e;
    let r = t.replace(/^\//, "").split("/"), n = [], o = !1;
    for(let i = 0; i < r.length; i++){
        let a = r[i].match(Wu);
        a ? n.push({
            index: i,
            name: a[1]
        }) : Gu.test(r[i]) && (o = !0);
    }
    let s = {
        segments: r,
        params: n,
        hasWildcard: o,
        pattern: t
    };
    return Hu.set(t, s), s;
}, Wa = (t, e, r = 0)=>{
    let o = t.replace(/^\//, "").split("/").filter(Boolean).slice(r), s = "/" + (o[0] || ""), i = null, a = -1, c = {};
    for(let f in e){
        if (f === "/*") continue;
        let l = Ha(f), u = NS(o, l);
        u > a && (a = u, i = f, c = DS(o, l));
    }
    return !i && e["/*"] && (i = "/*"), {
        key: i,
        content: i ? e[i] : null,
        params: c,
        routePath: s
    };
}, NS = (t, e)=>{
    let { segments: r, hasWildcard: n } = e;
    if (!n && r.length !== t.length && r.length !== 1 && r.length > t.length) return -1;
    let o = 0, s = Math.min(r.length, t.length);
    for(let i = 0; i < s; i++)if (r[i] === t[i]) o += 3;
    else if (Wu.test(r[i])) o += 1;
    else if (Gu.test(r[i])) o += .5;
    else return -1;
    return o;
}, DS = (t, e)=>{
    let r = {};
    for (let { index: n, name: o } of e.params)t[n] && (r[o] = decodeURIComponent(t[n]));
    return r;
}, Ga = (t)=>{
    if (!t || t === "?") return {};
    let e = {};
    return new URLSearchParams(t).forEach((n, o)=>{
        e[o] !== void 0 ? (Array.isArray(e[o]) || (e[o] = [
            e[o]
        ]), e[o].push(n)) : e[o] = n;
    }), e;
}, Ka = async (t, e)=>{
    if (!t || !t.length) return !0;
    for (let r of t){
        let n = await r(e);
        if (n === !1) return !1;
        if (typeof n == "string") return n;
    }
    return !0;
}, Ya = (t = 0, e = D.location.pathname)=>{
    let n = e.split("/")[t + 1];
    if (n) return `/${n}`;
}, Po, No = 0, FS = {
    level: No,
    pushState: !0,
    initialRender: !1,
    scrollToTop: !0,
    scrollToNode: !1,
    scrollNode: L && L.documentElement,
    scrollBody: !1,
    useFragment: !1,
    updateState: !0,
    scrollToOffset: 0,
    contentElementKey: "content",
    scrollToOptions: {
        behavior: "smooth"
    },
    useParamsMatching: !1
}, ne = (t, e, r = {}, n = {})=>{
    let o = e || void 0, s = o.context.window || D, i = o.context.document || L, a = {
        ...FS,
        ...o.context.routerOptions,
        ...n
    };
    No = a.lastLevel;
    let c = o.__ref;
    (a.contentElementKey !== "content" && a.contentElementKey !== c.contentElementKey || !c.contentElementKey) && (c.contentElementKey = a.contentElementKey || "content");
    let f = Cr(o, a), l = s.location.origin !== "null" ? s.location.origin : "http://localhost", u = new s.URL(l + t), { pathname: p, search: d, hash: h } = u, m = Ga(d), S = o.node, _ = h && h !== s.location.hash.slice(1), w = p !== Po;
    Po = p;
    let E, R, T;
    if (a.useParamsMatching) {
        let k = Wa(p, o.routes, a.level);
        E = k.routePath, R = k.content, T = k.params;
    } else E = Ya(a.level, p), R = o.routes[E || "/"] || o.routes["/*"], T = {};
    let A = a.scrollToNode ? S : a.scrollNode;
    if (!R || o.state.root.debugging) {
        o.state.root.debugging = !1, a.onNotFound && a.onNotFound({
            pathname: p,
            route: E,
            element: o
        });
        return;
    }
    if (a.guards && a.guards.length) {
        let k = {
            pathname: p,
            route: E,
            params: T,
            query: m,
            hash: h,
            element: o,
            state: r
        }, $ = Ka(a.guards, k);
        if ($ === !1) return;
        if (typeof $ == "string") return ne($, e, r, {
            ...n,
            guards: []
        });
    }
    if (a.pushState && s.history.pushState(r, null, p + (d || "") + (h || "")), w || !_) {
        let k = {
            route: E,
            hash: h,
            debugging: !1
        };
        Object.keys(T).length && (k.params = T), Object.keys(m).length && (k.query = m), a.updateState && o.state.update(k, {
            preventContentUpdate: !0
        }), f && a.removeOldElement && o[f].remove();
        let $ = o.__ref?.origin?.content, P = {};
        if ($) for(let F in $){
            let j = $[F];
            F === "__ref" || F === "props" || F === "node" || F === "parent" || F === "key" || (typeof j == "string" || typeof j == "number" || typeof j == "boolean" || typeof j == "object" && j !== null && !j.node && !j.__ref) && (P[F] = j);
        }
        o.set({
            ...P,
            tag: a.useFragment && "fragment",
            extends: R
        }, {
            contentElementKey: f
        });
    }
    if (a.scrollToTop && A?.scrollTo && A.scrollTo({
        ...a.scrollToOptions || {},
        top: 0,
        left: 0
    }), a.scrollToNode && R[f]?.node?.scrollTo && R[f].node.scrollTo({
        ...a.scrollToOptions || {},
        top: 0,
        left: 0
    }), h) {
        let k = i.getElementById(h);
        if (k && A?.scrollTo) {
            let $ = k.getBoundingClientRect().top + S.scrollTop - (a.scrollToOffset || 0);
            A.scrollTo({
                ...a.scrollToOptions || {},
                top: $,
                left: 0
            });
        }
    }
    W("routeChanged", o, a);
}, $S = ne;
var Ku = {
    extends: "Focusable",
    tag: "a",
    aria: {},
    fontWeight: "bold",
    textDecoration: "none",
    color: "currentColor",
    draggable: !1,
    attr: {
        href: (t)=>{
            let e = t.props;
            return Wt(t, e.href) || Wt(t, t.call("exec", e, t).href);
        },
        "aria-label": ({ props: t })=>t.aria ? t.aria.label : t.text
    }
}, LS = {
    extends: "Link"
}, Yu = {
    onClick: (t, e, r)=>{
        let { props: n, context: o } = e, { href: s, scrollToTop: i, stopPropagation: a } = n, c = e.call("exec", s, e);
        if (e.call("isString", c) && c.includes("{{") && (c = e.call("replaceLiteralsWithObjectFields", c)), a && t.stopPropagation(), !c) return;
        let { utils: f, snippets: l, functions: u, routerOptions: p } = o, d = e.__ref.root, h = c.startsWith("http://") || c.startsWith("https://") || c.startsWith("mailto:") || c.startsWith("tel:") || c.startsWith("sketch:") || c.startsWith("whatsapp:") || c.startsWith("sms:") || c.startsWith("skype:") || c.startsWith("viber:") || c.startsWith("callto:") || c.startsWith("facetime:") || c.startsWith("facetime-audio:") || c.startsWith("geo:") || c.startsWith("maps:");
        if (c && !h) {
            t.preventDefault();
            try {
                let m = d;
                if (p && p.customRouterElement) {
                    let S = Array.isArray(p.customRouterElement) ? p.customRouterElement : p.customRouterElement.split("."), _ = d;
                    for (let w of S){
                        if (!_ || !_[w]) {
                            _ = null;
                            break;
                        }
                        _ = _[w];
                    }
                    _ && (m = _, d.routes && (m.routes = d.routes));
                }
                (u.router || l.router || f.router || ne)(c, m, {}, {
                    scrollToOptions: {
                        behaviour: "instant"
                    },
                    scrollToTop: e.call("isDefined", i) ? i : !0,
                    ...p,
                    ...n.routerOptions
                });
            } catch (m) {
                console.warn(m);
            }
        }
    }
}, MS = {
    extends: [
        Ku,
        Yu
    ]
};
var BS = {
    extends: "Focusable",
    tag: "select",
    fontSize: "A",
    border: "none",
    boxSizing: "border-box",
    theme: "field",
    cursor: "pointer",
    childProps: {
        tag: "option",
        attr: {
            value: ({ props: t })=>t.value,
            selected: ({ props: t })=>t.selected,
            disabled: ({ props: t })=>t.disabled
        }
    },
    attr: {
        name: ({ props: t })=>t.name,
        disabled: ({ props: t })=>t.disabled,
        value: (t)=>{
            if (!t.props || !t.props.value) return;
            let e = t.call("exec", t.props.value, t);
            return t.call("isString", e) && e.includes("{{") ? t.call("replaceLiteralsWithObjectFields", e) : e;
        }
    }
};
var US = {
    extends: [
        "IconText",
        "FocusableComponent"
    ],
    tag: "button",
    fontSize: "A",
    type: "button",
    borderStyle: "none",
    display: "inline-flex",
    align: "center center",
    textDecoration: "none",
    lineHeight: "1",
    whiteSpace: "nowrap",
    padding: "Z B2",
    fontWeight: "500",
    fontFamily: "inherit",
    round: "C2",
    disabled: (t)=>t.call("exec", t.props.disabled)
}, VS = {
    extends: "Button",
    fontSize: "A",
    width: "A",
    padding: "Z",
    aspectRatio: "1 / 1",
    icon: "smile",
    boxSize: "fit-content fit-content",
    justifyContent: "center",
    round: "Z",
    boxSizing: "content-box"
}, jS = {
    extends: "SquareButton",
    round: "C"
}, zS = {
    extends: "Button",
    childExtends: "IconText"
}, qS = {
    tag: "nav",
    display: "flex",
    childExtends: "SquareButton"
}, HS = {
    extends: [
        "SquareButton",
        "ClickableItem"
    ],
    round: "Z"
};
var WS = {
    display: "flex",
    tag: "dialog",
    flow: "column",
    border: "0",
    theme: "dialog",
    round: "Z2"
}, GS = {
    extends: "Hgroup",
    minWidth: "100%",
    gap: "A",
    Title: {
        align: "center space-between",
        Text: {
            text: "Title"
        },
        SquareButton: {
            icon: "x",
            theme: "transparent"
        }
    },
    Paragraph: {
        color: "caption"
    }
}, KS = {
    display: "flex",
    align: "center flex-end",
    gap: "X2",
    margin: "auto - -",
    padding: "Y2 X2",
    childExtends: {
        extends: "Button",
        textTransform: "uppercase",
        background: "transparent",
        "@dark": {
            theme: "primary @dark .color-only"
        },
        "@light": {
            theme: "primary @light .color-only"
        },
        "&": {
            padding: "Z A"
        },
        ":hover": {
            theme: "tertiary"
        },
        ":active": {
            background: "white.1"
        }
    },
    Cancel: {
        text: "cancel"
    },
    Ok: {
        text: "ok"
    }
};
v();
var YS = {
    display: "flex",
    theme: "dialog",
    background: "black",
    flow: "column",
    shape: "tooltip",
    shapeDirection: "left",
    padding: "Z1 A",
    round: "Y2",
    width: "fit-content",
    minWidth: "D2",
    maxWidth: "F2",
    gap: "X",
    textAlign: "center",
    attr: {
        tooltip: !0
    },
    Title: {
        if: ({ parent: t, props: e })=>Ot(t.props.title) || e.text,
        width: "fit-content",
        fontWeight: 500,
        color: "gray12",
        text: ({ parent: t })=>t.props.title
    },
    P: {
        if: (t, e)=>t.call("isDefined", t.call("exec", t.parent.props.description, t)) || t.props.text,
        width: "fit-content",
        fontSize: "Z2",
        margin: "0",
        color: "gray6",
        fontWeight: "400",
        text: (t, e)=>t.call("exec", t.parent.props.description, t)
    }
}, XS = {
    extends: "Tooltip",
    position: "absolute",
    pointerEvents: "none",
    opacity: "0",
    visibility: "hidden",
    transition: "C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform",
    props: ({ props: t })=>({
            ...!t.shapeDirection || t.shapeDirection === "top" ? {
                top: "112%",
                left: "50%",
                transform: "translate3d(-50%,10%,0)",
                ".isActive": {
                    transform: "translate3d(-50%,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : t.shapeDirection === "right" ? {
                transform: "translate3d(10%,-50%,0)",
                left: "112%",
                top: "50%",
                ".isActive": {
                    transform: "translate3d(0%,-50%,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : ({ props: e })=>e.shapeDirection === "bottom" ? {
                    transform: "translate3d(-50%,-10%,0)",
                    bottom: "112%",
                    left: "50%",
                    ".isActive": {
                        transform: "translate3d(-50%,0,0)",
                        opacity: 1,
                        visibility: "visible"
                    }
                } : e.shapeDirection === "left" ? {
                    transform: "translate3d(10%,-50%,0)",
                    right: "112%",
                    top: "50%",
                    ".isActive": {
                        transform: "translate3d(0%,-50%,0)",
                        opacity: 1,
                        visibility: "visible"
                    }
                } : {}
        })
}, QS = {
    position: "relative",
    zIndex: 999,
    props: (t)=>{
        let { Tooltip: e, TooltipHidden: r } = t, n = e || r;
        return n ? {
            ":hover, &:focus-visible": {
                zIndex: 1e3,
                "& [tooltip]": n && n.props && n.props[".isActive"] || {
                    transform: "translate3d(-50%, 0, 0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        } : void 0;
    }
};
var JS = {
    extends: "Img",
    display: "block",
    avatarType: "adventurer-neutral",
    borderRadius: "100%",
    boxSize: "C+X C+X",
    src: (t)=>`https://api.dicebear.com/7.x/${t.props.avatarType || "initials"}/svg?seed=${t.props.key || t.key || "no-avatar"}`
};
var ZS = {
    tag: "input",
    appearance: "none",
    width: "100%",
    height: "2px",
    outline: "none",
    flex: 1,
    onInput: (t, e, r)=>{
        let n = e.props;
        e.call("isFunction", n.onInput) ? n.onInput(t, e, r) : r.update({
            value: parseFloat(e.node.value)
        });
    },
    onChange: (t, e, r)=>{
        let n = e.props;
        e.call("isFunction", n.onChange) ? n.onChange(t, e, r) : r.update({
            value: parseFloat(e.node.value)
        });
    },
    "::-webkit-slider-thumb": {
        boxSizing: "content-box",
        width: "8px",
        height: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "100%",
        opacity: ".8",
        appearance: "none"
    },
    "::-webkit-slider-runnable-track": {},
    "@dark": {
        background: "white.2",
        "::-webkit-slider-thumb": {
            background: "#232526",
            borderColor: lo("#454646", .75)
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: lo("#fff", .35)
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "#3C6AC0"
            }
        }
    },
    "@light": {
        background: "gray9",
        "::-webkit-slider-thumb": {
            background: "white",
            borderColor: "gray9"
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: "gray7"
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "blue"
            }
        }
    },
    deps: {
        returnPropertyValue: (t, e, r)=>{
            let n = t.props && t.call("exec", t.props[e], t);
            return (t.call("isFunction", n) ? n(t, t.state) : n !== void 0 ? n : r !== void 0 ? r : 0) + "";
        }
    },
    attr: {
        type: "range",
        value: (t, e)=>t.call("exec", e.value || t.props.value || t.props.defaultValue, t),
        min: (t, e)=>t.deps.returnPropertyValue(t, "min", 0),
        max: (t, e)=>t.deps.returnPropertyValue(t, "max", 100),
        step: (t, e)=>t.deps.returnPropertyValue(t, "step", 1)
    }
};
var tx = {
    display: "flex",
    attr: {
        dropdown: !0
    },
    padding: "0 Y",
    maxHeight: "G",
    flow: "column",
    theme: "quaternary",
    overflow: "hidden auto",
    style: {
        listStyleType: "none"
    },
    transition: "B defaultBezier",
    transitionProperty: "transform, opacity, visibility",
    children: ({ props: t })=>t.options || [],
    childrenAs: "props",
    ".hidden": {
        transform: "translate3d(0,10%,0)",
        opacity: 0,
        visibility: "hidden"
    },
    childExtends: {
        extends: "Button",
        state: {},
        isActive: ({ key: t, state: e })=>e.active === t,
        position: "relative",
        round: "0",
        align: "center flex-end",
        flow: "row-reverse",
        padding: "Z2 C Z2 Y2",
        margin: "0",
        gap: "Y2",
        theme: "quaternary .child",
        ":hover": {
            style: {
                svg: {
                    opacity: "0.5"
                }
            }
        },
        Icon: {
            isActive: ({ key: t, state: e })=>e.active === t,
            name: "checkmark",
            opacity: "0.1",
            ".active": {
                opacity: "1"
            }
        },
        ":not(:first-child)": {
            "@dark": {
                border: "solid gray4.65"
            },
            "@light": {
                border: "solid gray11"
            },
            borderWidth: "1px 0 0"
        }
    }
}, ex = {
    position: "relative",
    zIndex: 999,
    style: {
        "&:hover": {
            zIndex: 1e3,
            "& [dropdown]": {
                transform: "translate3d(0,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        }
    }
}, rx = {
    position: "relative",
    tabindex: "0",
    style: {
        "&:focus-within": {
            zIndex: 1e3,
            "& [dropdown]": {
                transform: "translate3d(0,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        }
    },
    Input_trigger: {
        type: "checkbox",
        opacity: "0",
        visibility: "hidden",
        position: "absolute",
        inset: "0",
        onUpdate: (t)=>t.node.blur()
    },
    Dropdown: {
        onClick: ()=>{
            document.activeElement?.blur();
        }
    }
}, nx = {
    props: {
        position: "relative",
        tabindex: "0",
        style: {
            "&:focus-within": {
                zIndex: 1e3,
                "& ~ [dropdown]": {
                    transform: "translate3d(0,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        }
    },
    Input_trigger: {
        type: "checkbox",
        opacity: "0",
        visibility: "hidden",
        position: "absolute",
        inset: "0",
        onUpdate: (t)=>t.node.blur()
    }
};
var ox = {
    display: "flex",
    theme: "alert",
    padding: "Z1 B Z A",
    round: "A A A Y2",
    gap: "X2",
    cursor: "pointer",
    align: "flex-start center",
    IconText: {
        Icon: {
            name: "info outline"
        },
        Text: {
            ":empty": {
                hide: !0
            }
        }
    },
    Hgroup: {
        extends: [
            "Flex",
            "Hgroup"
        ],
        flow: "y",
        align: "flex-start",
        gap: "X2",
        H: {
            tag: "h6",
            margin: "0",
            fontWeight: "600",
            lineHeight: "1em",
            text: "Notification",
            ":empty": {
                hide: !0
            }
        },
        P: {
            fontSize: "Z",
            margin: "0",
            text: "is not always a distraction",
            ":empty": {
                hide: !0
            }
        }
    }
};
v();
var bn = {};
Mt(bn, {
    CDN_PROVIDERS: ()=>te,
    DOMQL_EVENTS: ()=>cs,
    DOMQ_PROPERTIES: ()=>He,
    ENV: ()=>Kd,
    ERRORS_REGISTRY: ()=>du,
    HTML_TAGS: ()=>Un,
    METHODS: ()=>Fn,
    METHODS_EXL: ()=>as,
    NODE_ENV: ()=>Qt,
    OPTIONS: ()=>ut,
    PACKAGE_MANAGER_TO_CDN: ()=>yr,
    PARSED_DOMQ_PROPERTIES: ()=>is,
    PROPS_METHODS: ()=>We,
    STATE_METHODS: ()=>Tt,
    STATE_PROPERTIES: ()=>Fd,
    SVG_TAGS: ()=>Qe,
    TYPES: ()=>ts,
    addCaching: ()=>al,
    addContext: ()=>il,
    addExtend: ()=>gh,
    addExtends: ()=>Rt,
    addItemAfterEveryElement: ()=>bd,
    addProtoToArray: ()=>$r,
    addRef: ()=>nl,
    applyCSS: ()=>Ju,
    applyDependentState: ()=>Js,
    applyEvent: ()=>jr,
    applyEventUpdate: ()=>ti,
    applyExtends: ()=>Ns,
    applyProps: ()=>Ls,
    arrayContainsOtherArray: ()=>pd,
    arraysEqual: ()=>xd,
    arrayzeValue: ()=>ln,
    cache: ()=>vh,
    call: ()=>Ri,
    captureSnapshot: ()=>Di,
    checkForStateTypes: ()=>Ys,
    checkIfInherits: ()=>rr,
    checkIfStringIsInArray: ()=>vd,
    clone: ()=>Ld,
    cloneAndMergeArrayExtend: ()=>Cs,
    cloneFunction: ()=>oh,
    concatAddExtends: ()=>As,
    copyJavaScriptToClipboard: ()=>eg,
    copyStringToClipboard: ()=>tg,
    createBasedOnType: ()=>rl,
    createElement: ()=>Ks,
    createElementExtends: ()=>Vc,
    createExtends: ()=>Os,
    createExtendsFromKeys: ()=>Vn,
    createExtendsStack: ()=>Hc,
    createIfConditionFlag: ()=>Ur,
    createInheritedState: ()=>Xs,
    createKey: ()=>_s,
    createNestedObject: ()=>hs,
    createNestedObjectByKeyPath: ()=>Qs,
    createObjectWithoutPrototype: ()=>Rc,
    createParent: ()=>ol,
    createPath: ()=>sl,
    createProps: ()=>Bs,
    createPropsStack: ()=>Zc,
    createRoot: ()=>Gs,
    createScope: ()=>Gn,
    createSnapshotId: ()=>xs,
    customDecodeURIComponent: ()=>Dd,
    customEncodeURIComponent: ()=>Nd,
    cutArrayAfterValue: ()=>gd,
    cutArrayBeforeValue: ()=>md,
    debounce: ()=>Zd,
    debounceOnContext: ()=>th,
    decodeNewlines: ()=>Id,
    deepClone: ()=>z,
    deepContains: ()=>ps,
    deepDestringifyFunctions: ()=>le,
    deepExtend: ()=>Bc,
    deepMerge: ()=>U,
    deepMergeExtends: ()=>ue,
    deepStringifyFunctions: ()=>ls,
    defineSetter: ()=>Hh,
    destringifyGlobalScope: ()=>us,
    detectInfiniteLoop: ()=>bs,
    document: ()=>L,
    encodeNewlines: ()=>Rd,
    error: ()=>Qr,
    excludeKeysFromObject: ()=>Gd,
    exec: ()=>O,
    extendCachedRegistry: ()=>dh,
    extendStackRegistry: ()=>Ts,
    extractArrayExtend: ()=>Is,
    fibonacciNumberByIndex: ()=>Bm,
    filterArrays: ()=>_d,
    filterArraysFast: ()=>wd,
    finalizeExtends: ()=>Wc,
    findClosestNumber: ()=>kf,
    findClosestNumberInFactory: ()=>Lm,
    findInheritedState: ()=>er,
    findKeyPosition: ()=>Od,
    flattenExtend: ()=>jn,
    formatDate: ()=>Mm,
    generateHash: ()=>$c,
    generateKey: ()=>Ss,
    generateMetaTags: ()=>Ym,
    get: ()=>zh,
    getActiveRoute: ()=>Ya,
    getCDNUrl: ()=>ee,
    getCapitalCaseKeys: ()=>bh,
    getCdnProviderFromConfig: ()=>ho,
    getChildStateInKey: ()=>tr,
    getChildren: ()=>qh,
    getContext: ()=>Ei,
    getCookie: ()=>lh,
    getDB: ()=>Ii,
    getExtendsInElement: ()=>yh,
    getExtendsStack: ()=>ks,
    getExtendsStackRegistry: ()=>Mc,
    getFrequencyInArray: ()=>dd,
    getHashedExtend: ()=>Rs,
    getImportMapScript: ()=>Km,
    getInObjectByPath: ()=>ys,
    getLocalStorage: ()=>uh,
    getNev: ()=>Jd,
    getPageMetadata: ()=>Zm,
    getParentStateInKey: ()=>Ze,
    getPath: ()=>Si,
    getQuery: ()=>Pi,
    getRef: ()=>bi,
    getRoot: ()=>_i,
    getRootContext: ()=>vi,
    getRootData: ()=>wi,
    getRootState: ()=>xi,
    getRootStateInKey: ()=>Je,
    getSpreadChildren: ()=>Sh,
    global: ()=>fd,
    hasFunction: ()=>$n,
    hasHandlerPlugin: ()=>Ye,
    hasOwnProperty: ()=>jd,
    inheritChildExtends: ()=>zc,
    inheritChildPropsExtends: ()=>jc,
    inheritParentProps: ()=>Vs,
    inheritRecursiveChildExtends: ()=>qc,
    init: ()=>Ue,
    initProps: ()=>Hn,
    is: ()=>At,
    isArray: ()=>x,
    isBoolean: ()=>Pn,
    isContextComponent: ()=>Fs,
    isCyclic: ()=>Wd,
    isDOMNode: ()=>Bt,
    isDate: ()=>kc,
    isDefined: ()=>Ot,
    isDevelopment: ()=>Jt,
    isEmpty: ()=>Ac,
    isEmptyObject: ()=>zd,
    isEqualDeep: ()=>Tc,
    isFunction: ()=>y,
    isHtmlElement: ()=>Zo,
    isLocal: ()=>Qd,
    isMethod: ()=>Ht,
    isMobile: ()=>ah,
    isNode: ()=>Ee,
    isNot: ()=>Fr,
    isNotProduction: ()=>Br,
    isNull: ()=>Cc,
    isNumber: ()=>ct,
    isObject: ()=>g,
    isObjectLike: ()=>N,
    isPhoto: ()=>Wm,
    isProduction: ()=>Ke,
    isStaging: ()=>Xd,
    isState: ()=>Wn,
    isString: ()=>b,
    isStringFunction: ()=>nh,
    isTest: ()=>Ic,
    isTesting: ()=>Yd,
    isUndefined: ()=>K,
    isValidHtmlTag: ()=>ke,
    joinArrays: ()=>Nn,
    jointStacks: ()=>mh,
    keys: ()=>Jn,
    lastLevel: ()=>No,
    lastPathname: ()=>Po,
    loadCssFile: ()=>zm,
    loadJavascript: ()=>qm,
    loadJavascriptFile: ()=>Um,
    loadJavascriptFileEmbedSync: ()=>jm,
    loadJavascriptFileSync: ()=>Vm,
    loadRemoteCSS: ()=>Hm,
    loadRemoteScript: ()=>po,
    log: ()=>Ci,
    logGroupIf: ()=>ih,
    logIf: ()=>sh,
    lookdown: ()=>hi,
    lookdownAll: ()=>mi,
    lookup: ()=>di,
    lowercaseFirstLetter: ()=>ce,
    makeObjectWithoutPrototype: ()=>qd,
    map: ()=>$d,
    mapStringsWithContextComponents: ()=>Ps,
    matchRoute: ()=>Wa,
    matchesComponentNaming: ()=>It,
    memoize: ()=>eh,
    merge: ()=>Y,
    nextElement: ()=>Oi,
    objectToString: ()=>fs,
    objectizeStringProperty: ()=>$s,
    overwrite: ()=>fe,
    overwriteDeep: ()=>it,
    overwriteShallow: ()=>Mr,
    overwriteState: ()=>Zs,
    parse: ()=>Zn,
    parseDeep: ()=>Xr,
    parseQuery: ()=>Ga,
    parseRoutePattern: ()=>Ha,
    pickupElementFromProps: ()=>Vr,
    pickupPropsFromElement: ()=>Qc,
    previousElement: ()=>Ai,
    propExists: ()=>wh,
    propertizeElement: ()=>qn,
    propertizeUpdate: ()=>Us,
    reinit: ()=>Qu,
    remove: ()=>gi,
    removeChars: ()=>rg,
    removeCookie: ()=>fh,
    removeDuplicateProps: ()=>zs,
    removeDuplicatesInArray: ()=>Dn,
    removeFromArray: ()=>es,
    removeFromObject: ()=>ds,
    removeNestedKeyByPath: ()=>ms,
    removeValueFromArray: ()=>ns,
    removeValueFromArrayAll: ()=>yd,
    reorderArrayByValues: ()=>Sd,
    replaceLiteralsWithObjectFields: ()=>kd,
    replaceOctalEscapeSequences: ()=>Td,
    report: ()=>yt,
    resolveHandler: ()=>Xe,
    returnValueAsText: ()=>el,
    router: ()=>ne,
    runGuards: ()=>Ka,
    runPluginHook: ()=>Mn,
    scratchSystem: ()=>xo,
    scratchUtils: ()=>Sr,
    self: ()=>ud,
    set: ()=>dn,
    setCookie: ()=>ch,
    setHashedExtend: ()=>Lc,
    setInObjectByPath: ()=>gs,
    setLocalStorage: ()=>ph,
    setNodeStyles: ()=>Qn,
    setProps: ()=>yi,
    setPropsPrototype: ()=>js,
    spotByPath: ()=>pi,
    stringIncludesAny: ()=>ss,
    stringToObject: ()=>Vd,
    swapItemsInArray: ()=>hd,
    syncProps: ()=>qs,
    toCamelCase: ()=>Wi,
    toDashCase: ()=>Gi,
    toDescriptionCase: ()=>og,
    toTitleCase: ()=>ng,
    toggleFullscreen: ()=>$m,
    triggerEventOn: ()=>W,
    triggerEventOnUpdate: ()=>vt,
    trimStringFromSymbols: ()=>Ed,
    unstackArrayOfObjects: ()=>rs,
    update: ()=>Jc,
    updateProps: ()=>Hs,
    variables: ()=>Ti,
    verbose: ()=>to,
    warn: ()=>ki,
    window: ()=>D
});
v();
v();
var sx = C(), Xu = (t = sx, e)=>{
    let r = g(e.localFile) ? e.localFile : {}, n = z(r.designSystem || {});
    return U(t, n);
}, ix = {
    emotion: Et,
    useVariable: !0,
    useReset: !0,
    useFontImport: !0,
    useIconSprite: !0,
    useDocumentTheme: !0,
    useSvgSprite: !0
}, Ue = (t, e = ix)=>{
    let r = e.emotion || Et, n = Xu(t || {}, e), o = dn({
        verbose: e.verbose,
        useReset: e.useReset,
        useFontImport: e.useFontImport,
        useVariable: e.useVariable,
        useSvgSprite: e.useSvgSprite,
        useDocumentTheme: e.useDocumentTheme,
        useIconSprite: e.useIconSprite,
        useDefaultConfig: e.useDefaultConfig,
        globalTheme: e.globalTheme,
        files: e.files,
        ...n
    }, {
        newConfig: e.newConfig
    }), s = qi(o.font, o.files), i = o.useReset, a = o.useVariable, c = o.useFontImport, f = o.useSvgSprite, l = t.svg, u = o.useIconSprite, p = t.icons;
    if (c && r.injectGlobal(s), a && (r.injectGlobal({
        ":root": o.CSS_VARS
    }), o.CSS_MEDIA_VARS)) {
        let h = {};
        for(let m in o.CSS_MEDIA_VARS)m.startsWith("@media") ? h[m] = {
            ":root:not([data-theme])": o.CSS_MEDIA_VARS[m]
        } : h[m] = o.CSS_MEDIA_VARS[m];
        r.injectGlobal(h);
    }
    i && r.injectGlobal(o.reset);
    let d = o.animation;
    if (d) {
        let h = {};
        for(let m in d)h[`@keyframes ${m}`] = d[m];
        r.injectGlobal(h);
    }
    return (l || f) && _a(o.svg, {
        document: e.document
    }), (p || u) && va(o.icons, {
        document: e.document
    }), o;
}, Do = {
    emotion: Et
}, Qu = (t, e = Do)=>{
    let r = e.emotion || Et, n = Xu(t || {}, e), o = dn({
        verbose: !1,
        ...n
    });
    if (!e.preventInject) {
        if (r.injectGlobal({
            ":root": o.CSS_VARS
        }), o.CSS_MEDIA_VARS) {
            let s = {};
            for(let i in o.CSS_MEDIA_VARS)i.startsWith("@media") ? s[i] = {
                ":root:not([data-theme])": o.CSS_MEDIA_VARS[i]
            } : s[i] = o.CSS_MEDIA_VARS[i];
            r.injectGlobal(s);
        }
        r.injectGlobal(o.reset);
    }
    return o;
}, Ju = (t, e = Do)=>{
    (e.emotion || Et).injectGlobal(t);
}, AT = (t, e = Do)=>{
    let r = e.emotion || Et;
    if (r.injectGlobal({
        ":root": t.CSS_VARS
    }), t.CSS_MEDIA_VARS) {
        let n = {};
        for(let o in t.CSS_MEDIA_VARS)o.startsWith("@media") ? n[o] = {
            ":root:not([data-theme])": t.CSS_MEDIA_VARS[o]
        } : n[o] = t.CSS_MEDIA_VARS[o];
        r.injectGlobal(n);
    }
};
var TT = (t, e = Do)=>{};
v();
var Qa = {
    initRouter: !0,
    injectRouterInLinkComponent: !0,
    popState: !0
}, tp = (t, e)=>{
    if (!e) return t;
    let r = Array.isArray(e) ? e : e.split("."), n = t;
    for (let o of r){
        if (!n || !n[o]) return null;
        n = n[o];
    }
    return n;
}, ep = (t, e)=>{
    if (e.router === !1) return;
    e.router === !0 ? e.router = Qa : e.router = Y(e.router || {}, Qa);
    let r = e.router, n = async (s, i)=>{
        if (!D.location) return;
        let { pathname: a, search: c, hash: f } = D.location, l = a + c + f, u = s;
        if (r.customRouterElement) {
            let p = tp(s, r.customRouterElement);
            p && (u = p, s.routes && (u.routes = s.routes));
        }
        u.routes && await ne(l, u, {}, {
            initialRender: !0
        });
    }, o = t.on && !K(t.on.renderRouter) || !K(t.onRenderRouter);
    return r && r.initRouter && !o && (t.on ? t.on.renderRouter = n : t.on = {
        renderRouter: n
    }), ax(e, r), r;
}, Zu, rp = (t, e)=>{
    if (Zu) return;
    Zu = !0;
    let r = e.router || Qa;
    if (!r.popState) return;
    let n = e.utils && e.utils.router ? e.utils.router : ne;
    D.onpopstate = async (o)=>{
        let { pathname: s, search: i, hash: a } = D.location, c = s + i + a, f = t;
        if (r.customRouterElement) {
            let l = tp(t, r.customRouterElement);
            l && (f = l, t.routes && (f.routes = t.routes));
        }
        await f.call("router", c, f, {}, {
            pushState: !1,
            scrollToTop: !1,
            level: 0,
            event: o
        });
    };
}, ax = (t, e)=>{
    let { components: r } = t;
    if (e && e.injectRouterInLinkComponent) return U(r.Link || r["smbls.Link"], r.RouterLink || r["smbls.RouterLink"]);
};
v();
var Ja = D && D.location ? D.location.host.includes("dev.") : Jt(), np = Ja ? "http://localhost:8080/get" : "https://api.symbols.app/get", cx = {
    endpoint: np
}, op = async (t, e = cx)=>{
    let r = e.endpoint || np, n = e.serviceRoute ? x(e.serviceRoute) ? e.serviceRoute.map((s)=>s.toLowerCase() + "=true").join("&") : e.serviceRoute : "", o;
    try {
        return o = await globalThis.fetch(r + "/?" + n, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-AppKey": t,
                "X-Metadata": e.metadata
            }
        }), await o.json();
    } catch (s) {
        if (y(e.onError)) return e.onError(s);
        console.error(s);
    }
}, lx = async (t, e)=>{
    let { editor: r } = e;
    if (r && r.remote) {
        let n = await op(t, r), o = Ja || e.isDevelopment ? le(n) : le(n.releases[0]);
        r.serviceRoute ? x(r.serviceRoute) ? r.serviceRoute.forEach((s)=>{
            it(e[s], o[s.toLowerCase()]);
        }) : it(e[r.serviceRoute], o) : [
            "state",
            "designSystem",
            "components",
            "snippets",
            "pages",
            "utils",
            "files",
            "packages",
            "functions",
            "globalScope"
        ].forEach((s)=>{
            it(e[s], o[s.toLowerCase()]);
        });
    }
    return e;
}, fx = async (t, e, r)=>{
    let { editor: n } = e;
    if (n && n.remote) {
        let o = await op(t, n), s = Ja || e.isDevelopment ? le(o) : le(o.releases[0]);
        r(s);
    }
}, sp = async (t, e)=>{
    if (t && e.editor) try {
        e.editor.async || await lx(t, e);
    } catch (r) {
        console.error(r);
    }
}, ip = (t, e, r, n)=>{
    if (e && r.editor) try {
        r.editor.async && fx(e, r, n || ((o)=>{
            let s = o.designSystem;
            g(s) && r.utils.init(s), g(o.state) && t.state.set(o.state);
        }));
    } catch (o) {
        console.error(o);
    }
};
v();
var ux = {
    title: {
        tag: "title"
    },
    description: {
        tag: "meta",
        attr: "name",
        key: "description"
    },
    keywords: {
        tag: "meta",
        attr: "name",
        key: "keywords"
    },
    robots: {
        tag: "meta",
        attr: "name",
        key: "robots"
    },
    author: {
        tag: "meta",
        attr: "name",
        key: "author"
    },
    canonical: {
        tag: "link",
        attr: "rel",
        key: "canonical",
        valueAttr: "href"
    },
    image: {
        tag: "meta",
        attr: "property",
        key: "og:image"
    },
    url: {
        tag: "meta",
        attr: "property",
        key: "og:url"
    },
    siteName: {
        tag: "meta",
        attr: "property",
        key: "og:site_name"
    },
    type: {
        tag: "meta",
        attr: "property",
        key: "og:type"
    },
    locale: {
        tag: "meta",
        attr: "property",
        key: "og:locale"
    },
    "og:title": {
        tag: "meta",
        attr: "property",
        key: "og:title"
    },
    "og:description": {
        tag: "meta",
        attr: "property",
        key: "og:description"
    },
    "og:image": {
        tag: "meta",
        attr: "property",
        key: "og:image"
    },
    "og:url": {
        tag: "meta",
        attr: "property",
        key: "og:url"
    },
    "og:type": {
        tag: "meta",
        attr: "property",
        key: "og:type"
    },
    "og:site_name": {
        tag: "meta",
        attr: "property",
        key: "og:site_name"
    },
    "og:locale": {
        tag: "meta",
        attr: "property",
        key: "og:locale"
    },
    "twitter:card": {
        tag: "meta",
        attr: "name",
        key: "twitter:card"
    },
    "twitter:title": {
        tag: "meta",
        attr: "name",
        key: "twitter:title"
    },
    "twitter:description": {
        tag: "meta",
        attr: "name",
        key: "twitter:description"
    },
    "twitter:image": {
        tag: "meta",
        attr: "name",
        key: "twitter:image"
    },
    "twitter:site": {
        tag: "meta",
        attr: "name",
        key: "twitter:site"
    },
    "theme-color": {
        tag: "meta",
        attr: "name",
        key: "theme-color"
    }
}, px = (t)=>{
    if (t.tag === "link") return `link[${t.attr}="${t.key}"]`;
    if (t.tag && !t.attr && !t.key) return t.tag;
    if (t.tag && t.attr && t.key) return `${t.tag}[${t.attr}="${t.key}"]`;
}, Fo = (t, e, r)=>{
    if (!t) return {};
    let n = y(t) ? O(t, e, r) : {
        ...t
    };
    if (!g(n)) return {};
    for(let o in n){
        let s = n[o];
        y(s) && (s = O(s, e, r)), b(s) && s.includes("{{") && e?.call && (s = e.call("replaceLiteralsWithObjectFields", s, r)), n[o] = s;
    }
    return n;
};
var dx = (t, e)=>{
    let r = e.createElement(t.tag);
    return t.attr && r.setAttribute(t.attr, t.key), (e.head || e.querySelector("head")).appendChild(r), r;
}, $o = (t, e)=>{
    if (!(!g(t) || !e)) for(let r in t){
        let n = t[r];
        if (n == null) continue;
        let o = ux[r];
        if (!o) continue;
        let s = px(o), i = e.querySelector(s) || dx(o, e);
        i && (r === "title" ? i.textContent = n : o.valueAttr ? i.setAttribute(o.valueAttr, n) : i.setAttribute("content", n));
    }
};
var ap = {
    name: "helmet",
    create (t) {
        let e = t.metadata || t.props?.metadata;
        if (!e) return;
        let r = t.context?.document || typeof document < "u" && document;
        if (!r) return;
        let n = Fo(e, t, t.state);
        $o(n, r);
    },
    update (t) {
        let e = t.metadata || t.props?.metadata;
        if (!e) return;
        let r = t.context?.document || typeof document < "u" && document;
        if (!r) return;
        let n = Fo(e, t, t.state);
        $o(n, r);
    }
};
Ae();
var cp = (t, e, r, n)=>{
    t && Kr(t, e, r, n);
}, lp = (t, e, r)=>{
    if (!t) return;
    let n = e.context?.document || typeof document < "u" && document;
    if (!n) return;
    let o = Fo(t, e, r);
    $o(o, n);
}, fp = async (t, e)=>{
    if (!t) return;
    let r = {
        tag: "fragment",
        ...t
    }, n = async ()=>{
        await e.set(r, {
            preventDefineUpdate: "$router"
        });
    };
    return e.props && e.props.lazyLoad ? window.requestAnimationFrame(n) : await n(), r;
}, Sn = {
    routes: (t)=>t,
    metadata: lp,
    fetch: cp,
    $router: fp
}, hx = (t = {})=>{
    let e = {
        routes: (r)=>r
    };
    return t.metadata !== !1 && (e.metadata = lp), t.fetch !== !1 && (e.fetch = cp), t.router !== !1 && (e.$router = fp), e;
};
var up = {
    useReset: !0,
    useVariable: !0,
    useIconSprite: !0,
    useSvgSprite: !0,
    useDocumentTheme: !0,
    useDefaultIcons: !0,
    useFontImport: !0,
    useDefaultConfig: !0
}, Za = {
    initRouter: !0,
    popState: !0,
    injectRouterInLinkComponent: !0
}, tc = {
    ...up,
    router: Za
}, mx = {
    state: {},
    pages: {},
    components: {},
    router: Za,
    define: Sn
}, xe = mx;
var gx = (t, e, r, n)=>{
    let o = (Io.default || Io)(t, e, r, n);
    return o.on?.complete && o.on.complete(t, t.state, t.context, n), o.props?.onComplete && o.props?.onComplete(t, t.state, t.context, n), o.on?.initInspect && o.on.initInspect(t, t.state, t.context, n), o.on?.initSync && o.on.initSync(t, t.state, t.context, n), o;
}, Ve = {
    TREE: Ua,
    create: gx
};
v();
v();
var zt = Object.create(null);
zt.open = "0";
zt.close = "1";
zt.ping = "2";
zt.pong = "3";
zt.message = "4";
zt.upgrade = "5";
zt.noop = "6";
var xn = Object.create(null);
Object.keys(zt).forEach((t)=>{
    xn[zt[t]] = t;
});
var _n = {
    type: "error",
    data: "parser error"
};
var hp = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", mp = typeof ArrayBuffer == "function", gp = (t)=>typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(t) : t && t.buffer instanceof ArrayBuffer, wn = ({ type: t, data: e }, r, n)=>hp && e instanceof Blob ? r ? n(e) : pp(e, n) : mp && (e instanceof ArrayBuffer || gp(e)) ? r ? n(e) : pp(new Blob([
        e
    ]), n) : n(zt[t] + (e || "")), pp = (t, e)=>{
    let r = new FileReader;
    return r.onload = function() {
        let n = r.result.split(",")[1];
        e("b" + (n || ""));
    }, r.readAsDataURL(t);
};
function dp(t) {
    return t instanceof Uint8Array ? t : t instanceof ArrayBuffer ? new Uint8Array(t) : new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
}
var ec;
function yp(t, e) {
    if (hp && t.data instanceof Blob) return t.data.arrayBuffer().then(dp).then(e);
    if (mp && (t.data instanceof ArrayBuffer || gp(t.data))) return e(dp(t.data));
    wn(t, !1, (r)=>{
        ec || (ec = new TextEncoder), e(ec.encode(r));
    });
}
var bp = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", vn = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for(let t = 0; t < bp.length; t++)vn[bp.charCodeAt(t)] = t;
var Sp = (t)=>{
    let e = t.length * .75, r = t.length, n, o = 0, s, i, a, c;
    t[t.length - 1] === "=" && (e--, t[t.length - 2] === "=" && e--);
    let f = new ArrayBuffer(e), l = new Uint8Array(f);
    for(n = 0; n < r; n += 4)s = vn[t.charCodeAt(n)], i = vn[t.charCodeAt(n + 1)], a = vn[t.charCodeAt(n + 2)], c = vn[t.charCodeAt(n + 3)], l[o++] = s << 2 | i >> 4, l[o++] = (i & 15) << 4 | a >> 2, l[o++] = (a & 3) << 6 | c & 63;
    return f;
};
var yx = typeof ArrayBuffer == "function", En = (t, e)=>{
    if (typeof t != "string") return {
        type: "message",
        data: xp(t, e)
    };
    let r = t.charAt(0);
    return r === "b" ? {
        type: "message",
        data: bx(t.substring(1), e)
    } : xn[r] ? t.length > 1 ? {
        type: xn[r],
        data: t.substring(1)
    } : {
        type: xn[r]
    } : _n;
}, bx = (t, e)=>{
    if (yx) {
        let r = Sp(t);
        return xp(r, e);
    } else return {
        base64: !0,
        data: t
    };
}, xp = (t, e)=>e === "blob" ? t instanceof Blob ? t : new Blob([
        t
    ]) : t instanceof ArrayBuffer ? t : t.buffer;
var _p = "", wp = (t, e)=>{
    let r = t.length, n = new Array(r), o = 0;
    t.forEach((s, i)=>{
        wn(s, !1, (a)=>{
            n[i] = a, ++o === r && e(n.join(_p));
        });
    });
}, vp = (t, e)=>{
    let r = t.split(_p), n = [];
    for(let o = 0; o < r.length; o++){
        let s = En(r[o], e);
        if (n.push(s), s.type === "error") break;
    }
    return n;
};
function Ep() {
    return new TransformStream({
        transform (t, e) {
            yp(t, (r)=>{
                let n = r.length, o;
                if (n < 126) o = new Uint8Array(1), new DataView(o.buffer).setUint8(0, n);
                else if (n < 65536) {
                    o = new Uint8Array(3);
                    let s = new DataView(o.buffer);
                    s.setUint8(0, 126), s.setUint16(1, n);
                } else {
                    o = new Uint8Array(9);
                    let s = new DataView(o.buffer);
                    s.setUint8(0, 127), s.setBigUint64(1, BigInt(n));
                }
                t.data && typeof t.data != "string" && (o[0] |= 128), e.enqueue(o), e.enqueue(r);
            });
        }
    });
}
var rc;
function Lo(t) {
    return t.reduce((e, r)=>e + r.length, 0);
}
function Mo(t, e) {
    if (t[0].length === e) return t.shift();
    let r = new Uint8Array(e), n = 0;
    for(let o = 0; o < e; o++)r[o] = t[0][n++], n === t[0].length && (t.shift(), n = 0);
    return t.length && n < t[0].length && (t[0] = t[0].slice(n)), r;
}
function Cp(t, e) {
    rc || (rc = new TextDecoder);
    let r = [], n = 0, o = -1, s = !1;
    return new TransformStream({
        transform (i, a) {
            for(r.push(i);;){
                if (n === 0) {
                    if (Lo(r) < 1) break;
                    let c = Mo(r, 1);
                    s = (c[0] & 128) === 128, o = c[0] & 127, o < 126 ? n = 3 : o === 126 ? n = 1 : n = 2;
                } else if (n === 1) {
                    if (Lo(r) < 2) break;
                    let c = Mo(r, 2);
                    o = new DataView(c.buffer, c.byteOffset, c.length).getUint16(0), n = 3;
                } else if (n === 2) {
                    if (Lo(r) < 8) break;
                    let c = Mo(r, 8), f = new DataView(c.buffer, c.byteOffset, c.length), l = f.getUint32(0);
                    if (l > Math.pow(2, 21) - 1) {
                        a.enqueue(_n);
                        break;
                    }
                    o = l * Math.pow(2, 32) + f.getUint32(4), n = 3;
                } else {
                    if (Lo(r) < o) break;
                    let c = Mo(r, o);
                    a.enqueue(En(s ? c : rc.decode(c), e)), n = 0;
                }
                if (o === 0 || o > t) {
                    a.enqueue(_n);
                    break;
                }
            }
        }
    });
}
var nc = 4;
function X(t) {
    if (t) return Sx(t);
}
function Sx(t) {
    for(var e in X.prototype)t[e] = X.prototype[e];
    return t;
}
X.prototype.on = X.prototype.addEventListener = function(t, e) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
};
X.prototype.once = function(t, e) {
    function r() {
        this.off(t, r), e.apply(this, arguments);
    }
    return r.fn = e, this.on(t, r), this;
};
X.prototype.off = X.prototype.removeListener = X.prototype.removeAllListeners = X.prototype.removeEventListener = function(t, e) {
    if (this._callbacks = this._callbacks || {}, arguments.length == 0) return this._callbacks = {}, this;
    var r = this._callbacks["$" + t];
    if (!r) return this;
    if (arguments.length == 1) return delete this._callbacks["$" + t], this;
    for(var n, o = 0; o < r.length; o++)if (n = r[o], n === e || n.fn === e) {
        r.splice(o, 1);
        break;
    }
    return r.length === 0 && delete this._callbacks["$" + t], this;
};
X.prototype.emit = function(t) {
    this._callbacks = this._callbacks || {};
    for(var e = new Array(arguments.length - 1), r = this._callbacks["$" + t], n = 1; n < arguments.length; n++)e[n - 1] = arguments[n];
    if (r) {
        r = r.slice(0);
        for(var n = 0, o = r.length; n < o; ++n)r[n].apply(this, e);
    }
    return this;
};
X.prototype.emitReserved = X.prototype.emit;
X.prototype.listeners = function(t) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
};
X.prototype.hasListeners = function(t) {
    return !!this.listeners(t).length;
};
var oe = typeof Promise == "function" && typeof Promise.resolve == "function" ? (e)=>Promise.resolve().then(e) : (e, r)=>r(e, 0), bt = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), kp = "arraybuffer";
function Bo(t, ...e) {
    return e.reduce((r, n)=>(t.hasOwnProperty(n) && (r[n] = t[n]), r), {});
}
var xx = bt.setTimeout, _x = bt.clearTimeout;
function se(t, e) {
    e.useNativeTimers ? (t.setTimeoutFn = xx.bind(bt), t.clearTimeoutFn = _x.bind(bt)) : (t.setTimeoutFn = bt.setTimeout.bind(bt), t.clearTimeoutFn = bt.clearTimeout.bind(bt));
}
var wx = 1.33;
function Op(t) {
    return typeof t == "string" ? vx(t) : Math.ceil((t.byteLength || t.size) * wx);
}
function vx(t) {
    let e = 0, r = 0;
    for(let n = 0, o = t.length; n < o; n++)e = t.charCodeAt(n), e < 128 ? r += 1 : e < 2048 ? r += 2 : e < 55296 || e >= 57344 ? r += 3 : (n++, r += 4);
    return r;
}
function Uo() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function Ap(t) {
    let e = "";
    for(let r in t)t.hasOwnProperty(r) && (e.length && (e += "&"), e += encodeURIComponent(r) + "=" + encodeURIComponent(t[r]));
    return e;
}
function Tp(t) {
    let e = {}, r = t.split("&");
    for(let n = 0, o = r.length; n < o; n++){
        let s = r[n].split("=");
        e[decodeURIComponent(s[0])] = decodeURIComponent(s[1]);
    }
    return e;
}
var Vo = class extends Error {
    constructor(e, r, n){
        super(e), this.description = r, this.context = n, this.type = "TransportError";
    }
}, ie = class extends X {
    constructor(e){
        super(), this.writable = !1, se(this, e), this.opts = e, this.query = e.query, this.socket = e.socket, this.supportsBinary = !e.forceBase64;
    }
    onError(e, r, n) {
        return super.emitReserved("error", new Vo(e, r, n)), this;
    }
    open() {
        return this.readyState = "opening", this.doOpen(), this;
    }
    close() {
        return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
    }
    send(e) {
        this.readyState === "open" && this.write(e);
    }
    onOpen() {
        this.readyState = "open", this.writable = !0, super.emitReserved("open");
    }
    onData(e) {
        let r = En(e, this.socket.binaryType);
        this.onPacket(r);
    }
    onPacket(e) {
        super.emitReserved("packet", e);
    }
    onClose(e) {
        this.readyState = "closed", super.emitReserved("close", e);
    }
    pause(e) {}
    createUri(e, r = {}) {
        return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(r);
    }
    _hostname() {
        let e = this.opts.hostname;
        return e.indexOf(":") === -1 ? e : "[" + e + "]";
    }
    _port() {
        return this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
    }
    _query(e) {
        let r = Ap(e);
        return r.length ? "?" + r : "";
    }
};
var Cn = class extends ie {
    constructor(){
        super(...arguments), this._polling = !1;
    }
    get name() {
        return "polling";
    }
    doOpen() {
        this._poll();
    }
    pause(e) {
        this.readyState = "pausing";
        let r = ()=>{
            this.readyState = "paused", e();
        };
        if (this._polling || !this.writable) {
            let n = 0;
            this._polling && (n++, this.once("pollComplete", function() {
                --n || r();
            })), this.writable || (n++, this.once("drain", function() {
                --n || r();
            }));
        } else r();
    }
    _poll() {
        this._polling = !0, this.doPoll(), this.emitReserved("poll");
    }
    onData(e) {
        let r = (n)=>{
            if (this.readyState === "opening" && n.type === "open" && this.onOpen(), n.type === "close") return this.onClose({
                description: "transport closed by the server"
            }), !1;
            this.onPacket(n);
        };
        vp(e, this.socket.binaryType).forEach(r), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
    }
    doClose() {
        let e = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        this.readyState === "open" ? e() : this.once("open", e);
    }
    write(e) {
        this.writable = !1, wp(e, (r)=>{
            this.doWrite(r, ()=>{
                this.writable = !0, this.emitReserved("drain");
            });
        });
    }
    uri() {
        let e = this.opts.secure ? "https" : "http", r = this.query || {};
        return this.opts.timestampRequests !== !1 && (r[this.opts.timestampParam] = Uo()), !this.supportsBinary && !r.sid && (r.b64 = 1), this.createUri(e, r);
    }
};
var Rp = !1;
try {
    Rp = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest;
} catch  {}
var Ip = Rp;
function Ex() {}
var oc = class extends Cn {
    constructor(e){
        if (super(e), typeof location < "u") {
            let r = location.protocol === "https:", n = location.port;
            n || (n = r ? "443" : "80"), this.xd = typeof location < "u" && e.hostname !== location.hostname || n !== e.port;
        }
    }
    doWrite(e, r) {
        let n = this.request({
            method: "POST",
            data: e
        });
        n.on("success", r), n.on("error", (o, s)=>{
            this.onError("xhr post error", o, s);
        });
    }
    doPoll() {
        let e = this.request();
        e.on("data", this.onData.bind(this)), e.on("error", (r, n)=>{
            this.onError("xhr poll error", r, n);
        }), this.pollXhr = e;
    }
}, _e = class t extends X {
    constructor(e, r, n){
        super(), this.createRequest = e, se(this, n), this._opts = n, this._method = n.method || "GET", this._uri = r, this._data = n.data !== void 0 ? n.data : null, this._create();
    }
    _create() {
        var e;
        let r = Bo(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        r.xdomain = !!this._opts.xd;
        let n = this._xhr = this.createRequest(r);
        try {
            n.open(this._method, this._uri, !0);
            try {
                if (this._opts.extraHeaders) {
                    n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
                    for(let o in this._opts.extraHeaders)this._opts.extraHeaders.hasOwnProperty(o) && n.setRequestHeader(o, this._opts.extraHeaders[o]);
                }
            } catch  {}
            if (this._method === "POST") try {
                n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch  {}
            try {
                n.setRequestHeader("Accept", "*/*");
            } catch  {}
            (e = this._opts.cookieJar) === null || e === void 0 || e.addCookies(n), "withCredentials" in n && (n.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (n.timeout = this._opts.requestTimeout), n.onreadystatechange = ()=>{
                var o;
                n.readyState === 3 && ((o = this._opts.cookieJar) === null || o === void 0 || o.parseCookies(n.getResponseHeader("set-cookie"))), n.readyState === 4 && (n.status === 200 || n.status === 1223 ? this._onLoad() : this.setTimeoutFn(()=>{
                    this._onError(typeof n.status == "number" ? n.status : 0);
                }, 0));
            }, n.send(this._data);
        } catch (o) {
            this.setTimeoutFn(()=>{
                this._onError(o);
            }, 0);
            return;
        }
        typeof document < "u" && (this._index = t.requestsCount++, t.requests[this._index] = this);
    }
    _onError(e) {
        this.emitReserved("error", e, this._xhr), this._cleanup(!0);
    }
    _cleanup(e) {
        if (!(typeof this._xhr > "u" || this._xhr === null)) {
            if (this._xhr.onreadystatechange = Ex, e) try {
                this._xhr.abort();
            } catch  {}
            typeof document < "u" && delete t.requests[this._index], this._xhr = null;
        }
    }
    _onLoad() {
        let e = this._xhr.responseText;
        e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this._cleanup());
    }
    abort() {
        this._cleanup();
    }
};
_e.requestsCount = 0;
_e.requests = {};
if (typeof document < "u") {
    if (typeof attachEvent == "function") attachEvent("onunload", Pp);
    else if (typeof addEventListener == "function") {
        let t = "onpagehide" in bt ? "pagehide" : "unload";
        addEventListener(t, Pp, !1);
    }
}
function Pp() {
    for(let t in _e.requests)_e.requests.hasOwnProperty(t) && _e.requests[t].abort();
}
var Cx = function() {
    let t = Np({
        xdomain: !1
    });
    return t && t.responseType !== null;
}(), we = class extends oc {
    constructor(e){
        super(e);
        let r = e && e.forceBase64;
        this.supportsBinary = Cx && !r;
    }
    request(e = {}) {
        return Object.assign(e, {
            xd: this.xd
        }, this.opts), new _e(Np, this.uri(), e);
    }
};
function Np(t) {
    let e = t.xdomain;
    try {
        if (typeof XMLHttpRequest < "u" && (!e || Ip)) return new XMLHttpRequest;
    } catch  {}
    if (!e) try {
        return new bt[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch  {}
}
var Dp = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", ic = class extends ie {
    get name() {
        return "websocket";
    }
    doOpen() {
        let e = this.uri(), r = this.opts.protocols, n = Dp ? {} : Bo(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
        try {
            this.ws = this.createSocket(e, r, n);
        } catch (o) {
            return this.emitReserved("error", o);
        }
        this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
    }
    addEventListeners() {
        this.ws.onopen = ()=>{
            this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
        }, this.ws.onclose = (e)=>this.onClose({
                description: "websocket connection closed",
                context: e
            }), this.ws.onmessage = (e)=>this.onData(e.data), this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(e) {
        this.writable = !1;
        for(let r = 0; r < e.length; r++){
            let n = e[r], o = r === e.length - 1;
            wn(n, this.supportsBinary, (s)=>{
                try {
                    this.doWrite(n, s);
                } catch  {}
                o && oe(()=>{
                    this.writable = !0, this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        typeof this.ws < "u" && (this.ws.onerror = ()=>{}, this.ws.close(), this.ws = null);
    }
    uri() {
        let e = this.opts.secure ? "wss" : "ws", r = this.query || {};
        return this.opts.timestampRequests && (r[this.opts.timestampParam] = Uo()), this.supportsBinary || (r.b64 = 1), this.createUri(e, r);
    }
}, sc = bt.WebSocket || bt.MozWebSocket, ve = class extends ic {
    createSocket(e, r, n) {
        return Dp ? new sc(e, r, n) : r ? new sc(e, r) : new sc(e);
    }
    doWrite(e, r) {
        this.ws.send(r);
    }
};
var kr = class extends ie {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (e) {
            return this.emitReserved("error", e);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((e)=>{
            this.onError("webtransport error", e);
        }), this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((e)=>{
                let r = Cp(Number.MAX_SAFE_INTEGER, this.socket.binaryType), n = e.readable.pipeThrough(r).getReader(), o = Ep();
                o.readable.pipeTo(e.writable), this._writer = o.writable.getWriter();
                let s = ()=>{
                    n.read().then(({ done: a, value: c })=>{
                        a || (this.onPacket(c), s());
                    }).catch((a)=>{});
                };
                s();
                let i = {
                    type: "open"
                };
                this.query.sid && (i.data = `{"sid":"${this.query.sid}"}`), this._writer.write(i).then(()=>this.onOpen());
            });
        });
    }
    write(e) {
        this.writable = !1;
        for(let r = 0; r < e.length; r++){
            let n = e[r], o = r === e.length - 1;
            this._writer.write(n).then(()=>{
                o && oe(()=>{
                    this.writable = !0, this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var e;
        (e = this._transport) === null || e === void 0 || e.close();
    }
};
var ac = {
    websocket: ve,
    webtransport: kr,
    polling: we
};
var kx = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, Ox = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function Or(t) {
    if (t.length > 8e3) throw "URI too long";
    let e = t, r = t.indexOf("["), n = t.indexOf("]");
    r != -1 && n != -1 && (t = t.substring(0, r) + t.substring(r, n).replace(/:/g, ";") + t.substring(n, t.length));
    let o = kx.exec(t || ""), s = {}, i = 14;
    for(; i--;)s[Ox[i]] = o[i] || "";
    return r != -1 && n != -1 && (s.source = e, s.host = s.host.substring(1, s.host.length - 1).replace(/;/g, ":"), s.authority = s.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), s.ipv6uri = !0), s.pathNames = Ax(s, s.path), s.queryKey = Tx(s, s.query), s;
}
function Ax(t, e) {
    let r = /\/{2,9}/g, n = e.replace(r, "/").split("/");
    return (e.slice(0, 1) == "/" || e.length === 0) && n.splice(0, 1), e.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function Tx(t, e) {
    let r = {};
    return e.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(n, o, s) {
        o && (r[o] = s);
    }), r;
}
var cc = typeof addEventListener == "function" && typeof removeEventListener == "function", jo = [];
cc && addEventListener("offline", ()=>{
    jo.forEach((t)=>t());
}, !1);
var je = class t extends X {
    constructor(e, r){
        if (super(), this.binaryType = kp, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, e && typeof e == "object" && (r = e, e = null), e) {
            let n = Or(e);
            r.hostname = n.host, r.secure = n.protocol === "https" || n.protocol === "wss", r.port = n.port, n.query && (r.query = n.query);
        } else r.host && (r.hostname = Or(r.host).host);
        se(this, r), this.secure = r.secure != null ? r.secure : typeof location < "u" && location.protocol === "https:", r.hostname && !r.port && (r.port = this.secure ? "443" : "80"), this.hostname = r.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = r.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, r.transports.forEach((n)=>{
            let o = n.prototype.name;
            this.transports.push(o), this._transportsByName[o] = n;
        }), this.opts = Object.assign({
            path: "/engine.io",
            agent: !1,
            withCredentials: !1,
            upgrade: !0,
            timestampParam: "t",
            rememberUpgrade: !1,
            addTrailingSlash: !0,
            rejectUnauthorized: !0,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: !1
        }, r), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = Tp(this.opts.query)), cc && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = ()=>{
            this.transport && (this.transport.removeAllListeners(), this.transport.close());
        }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = ()=>{
            this._onClose("transport close", {
                description: "network connection lost"
            });
        }, jo.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
    }
    createTransport(e) {
        let r = Object.assign({}, this.opts.query);
        r.EIO = nc, r.transport = e, this.id && (r.sid = this.id);
        let n = Object.assign({}, this.opts, {
            query: r,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[e]);
        return new this._transportsByName[e](n);
    }
    _open() {
        if (this.transports.length === 0) {
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        let e = this.opts.rememberUpgrade && t.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        let r = this.createTransport(e);
        r.open(), this.setTransport(r);
    }
    setTransport(e) {
        this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (r)=>this._onClose("transport close", r));
    }
    onOpen() {
        this.readyState = "open", t.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
    }
    _onPacket(e) {
        if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") switch(this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type){
            case "open":
                this.onHandshake(JSON.parse(e.data));
                break;
            case "ping":
                this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
                break;
            case "error":
                let r = new Error("server error");
                r.code = e.data, this._onError(r);
                break;
            case "message":
                this.emitReserved("data", e.data), this.emitReserved("message", e.data);
                break;
        }
    }
    onHandshake(e) {
        this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this._pingInterval = e.pingInterval, this._pingTimeout = e.pingTimeout, this._maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
    }
    _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        let e = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + e, this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, e), this.opts.autoUnref && this._pingTimeoutTimer.unref();
    }
    _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
    }
    flush() {
        if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            let e = this._getWritablePackets();
            this.transport.send(e), this._prevBufferLen = e.length, this.emitReserved("flush");
        }
    }
    _getWritablePackets() {
        if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1)) return this.writeBuffer;
        let r = 1;
        for(let n = 0; n < this.writeBuffer.length; n++){
            let o = this.writeBuffer[n].data;
            if (o && (r += Op(o)), n > 0 && r > this._maxPayload) return this.writeBuffer.slice(0, n);
            r += 2;
        }
        return this.writeBuffer;
    }
    _hasPingExpired() {
        if (!this._pingTimeoutTime) return !0;
        let e = Date.now() > this._pingTimeoutTime;
        return e && (this._pingTimeoutTime = 0, oe(()=>{
            this._onClose("ping timeout");
        }, this.setTimeoutFn)), e;
    }
    write(e, r, n) {
        return this._sendPacket("message", e, r, n), this;
    }
    send(e, r, n) {
        return this._sendPacket("message", e, r, n), this;
    }
    _sendPacket(e, r, n, o) {
        if (typeof r == "function" && (o = r, r = void 0), typeof n == "function" && (o = n, n = null), this.readyState === "closing" || this.readyState === "closed") return;
        n = n || {}, n.compress = n.compress !== !1;
        let s = {
            type: e,
            data: r,
            options: n
        };
        this.emitReserved("packetCreate", s), this.writeBuffer.push(s), o && this.once("flush", o), this.flush();
    }
    close() {
        let e = ()=>{
            this._onClose("forced close"), this.transport.close();
        }, r = ()=>{
            this.off("upgrade", r), this.off("upgradeError", r), e();
        }, n = ()=>{
            this.once("upgrade", r), this.once("upgradeError", r);
        };
        return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", ()=>{
            this.upgrading ? n() : e();
        }) : this.upgrading ? n() : e()), this;
    }
    _onError(e) {
        if (t.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") return this.transports.shift(), this._open();
        this.emitReserved("error", e), this._onClose("transport error", e);
    }
    _onClose(e, r) {
        if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
            if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), cc && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
                let n = jo.indexOf(this._offlineEventListener);
                n !== -1 && jo.splice(n, 1);
            }
            this.readyState = "closed", this.id = null, this.emitReserved("close", e, r), this.writeBuffer = [], this._prevBufferLen = 0;
        }
    }
};
je.protocol = nc;
var zo = class extends je {
    constructor(){
        super(...arguments), this._upgrades = [];
    }
    onOpen() {
        if (super.onOpen(), this.readyState === "open" && this.opts.upgrade) for(let e = 0; e < this._upgrades.length; e++)this._probe(this._upgrades[e]);
    }
    _probe(e) {
        let r = this.createTransport(e), n = !1;
        je.priorWebsocketSuccess = !1;
        let o = ()=>{
            n || (r.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]), r.once("packet", (u)=>{
                if (!n) {
                    if (u.type === "pong" && u.data === "probe") {
                        if (this.upgrading = !0, this.emitReserved("upgrading", r), !r) return;
                        je.priorWebsocketSuccess = r.name === "websocket", this.transport.pause(()=>{
                            n || this.readyState !== "closed" && (l(), this.setTransport(r), r.send([
                                {
                                    type: "upgrade"
                                }
                            ]), this.emitReserved("upgrade", r), r = null, this.upgrading = !1, this.flush());
                        });
                    } else {
                        let p = new Error("probe error");
                        p.transport = r.name, this.emitReserved("upgradeError", p);
                    }
                }
            }));
        };
        function s() {
            n || (n = !0, l(), r.close(), r = null);
        }
        let i = (u)=>{
            let p = new Error("probe error: " + u);
            p.transport = r.name, s(), this.emitReserved("upgradeError", p);
        };
        function a() {
            i("transport closed");
        }
        function c() {
            i("socket closed");
        }
        function f(u) {
            r && u.name !== r.name && s();
        }
        let l = ()=>{
            r.removeListener("open", o), r.removeListener("error", i), r.removeListener("close", a), this.off("close", c), this.off("upgrading", f);
        };
        r.once("open", o), r.once("error", i), r.once("close", a), this.once("close", c), this.once("upgrading", f), this._upgrades.indexOf("webtransport") !== -1 && e !== "webtransport" ? this.setTimeoutFn(()=>{
            n || r.open();
        }, 200) : r.open();
    }
    onHandshake(e) {
        this._upgrades = this._filterUpgrades(e.upgrades), super.onHandshake(e);
    }
    _filterUpgrades(e) {
        let r = [];
        for(let n = 0; n < e.length; n++)~this.transports.indexOf(e[n]) && r.push(e[n]);
        return r;
    }
}, Ar = class extends zo {
    constructor(e, r = {}){
        let n = typeof e == "object" ? e : r;
        (!n.transports || n.transports && typeof n.transports[0] == "string") && (n.transports = (n.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((o)=>ac[o]).filter((o)=>!!o)), super(e, n);
    }
};
var iI = Ar.protocol;
function Fp(t, e = "", r) {
    let n = t;
    r = r || typeof location < "u" && location, t == null && (t = r.protocol + "//" + r.host), typeof t == "string" && (t.charAt(0) === "/" && (t.charAt(1) === "/" ? t = r.protocol + t : t = r.host + t), /^(https?|wss?):\/\//.test(t) || (typeof r < "u" ? t = r.protocol + "//" + t : t = "https://" + t), n = Or(t)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
    let s = n.host.indexOf(":") !== -1 ? "[" + n.host + "]" : n.host;
    return n.id = n.protocol + "://" + s + ":" + n.port + e, n.href = n.protocol + "://" + s + (r && r.port === n.port ? "" : ":" + n.port), n;
}
var hc = {};
Mt(hc, {
    Decoder: ()=>pc,
    Encoder: ()=>uc,
    PacketType: ()=>I,
    isPacketValid: ()=>Bx,
    protocol: ()=>Up
});
var Ix = typeof ArrayBuffer == "function", Px = (t)=>typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(t) : t.buffer instanceof ArrayBuffer, $p = Object.prototype.toString, Nx = typeof Blob == "function" || typeof Blob < "u" && $p.call(Blob) === "[object BlobConstructor]", Dx = typeof File == "function" || typeof File < "u" && $p.call(File) === "[object FileConstructor]";
function On(t) {
    return Ix && (t instanceof ArrayBuffer || Px(t)) || Nx && t instanceof Blob || Dx && t instanceof File;
}
function kn(t, e) {
    if (!t || typeof t != "object") return !1;
    if (Array.isArray(t)) {
        for(let r = 0, n = t.length; r < n; r++)if (kn(t[r])) return !0;
        return !1;
    }
    if (On(t)) return !0;
    if (t.toJSON && typeof t.toJSON == "function" && arguments.length === 1) return kn(t.toJSON(), !0);
    for(let r in t)if (Object.prototype.hasOwnProperty.call(t, r) && kn(t[r])) return !0;
    return !1;
}
function Lp(t) {
    let e = [], r = t.data, n = t;
    return n.data = lc(r, e), n.attachments = e.length, {
        packet: n,
        buffers: e
    };
}
function lc(t, e) {
    if (!t) return t;
    if (On(t)) {
        let r = {
            _placeholder: !0,
            num: e.length
        };
        return e.push(t), r;
    } else if (Array.isArray(t)) {
        let r = new Array(t.length);
        for(let n = 0; n < t.length; n++)r[n] = lc(t[n], e);
        return r;
    } else if (typeof t == "object" && !(t instanceof Date)) {
        let r = {};
        for(let n in t)Object.prototype.hasOwnProperty.call(t, n) && (r[n] = lc(t[n], e));
        return r;
    }
    return t;
}
function Mp(t, e) {
    return t.data = fc(t.data, e), delete t.attachments, t;
}
function fc(t, e) {
    if (!t) return t;
    if (t && t._placeholder === !0) {
        if (typeof t.num == "number" && t.num >= 0 && t.num < e.length) return e[t.num];
        throw new Error("illegal attachments");
    } else if (Array.isArray(t)) for(let r = 0; r < t.length; r++)t[r] = fc(t[r], e);
    else if (typeof t == "object") for(let r in t)Object.prototype.hasOwnProperty.call(t, r) && (t[r] = fc(t[r], e));
    return t;
}
var Bp = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
], Up = 5, I;
(function(t) {
    t[t.CONNECT = 0] = "CONNECT", t[t.DISCONNECT = 1] = "DISCONNECT", t[t.EVENT = 2] = "EVENT", t[t.ACK = 3] = "ACK", t[t.CONNECT_ERROR = 4] = "CONNECT_ERROR", t[t.BINARY_EVENT = 5] = "BINARY_EVENT", t[t.BINARY_ACK = 6] = "BINARY_ACK";
})(I || (I = {}));
var uc = class {
    constructor(e){
        this.replacer = e;
    }
    encode(e) {
        return (e.type === I.EVENT || e.type === I.ACK) && kn(e) ? this.encodeAsBinary({
            type: e.type === I.EVENT ? I.BINARY_EVENT : I.BINARY_ACK,
            nsp: e.nsp,
            data: e.data,
            id: e.id
        }) : [
            this.encodeAsString(e)
        ];
    }
    encodeAsString(e) {
        let r = "" + e.type;
        return (e.type === I.BINARY_EVENT || e.type === I.BINARY_ACK) && (r += e.attachments + "-"), e.nsp && e.nsp !== "/" && (r += e.nsp + ","), e.id != null && (r += e.id), e.data != null && (r += JSON.stringify(e.data, this.replacer)), r;
    }
    encodeAsBinary(e) {
        let r = Lp(e), n = this.encodeAsString(r.packet), o = r.buffers;
        return o.unshift(n), o;
    }
}, pc = class t extends X {
    constructor(e){
        super(), this.reviver = e;
    }
    add(e) {
        let r;
        if (typeof e == "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            r = this.decodeString(e);
            let n = r.type === I.BINARY_EVENT;
            n || r.type === I.BINARY_ACK ? (r.type = n ? I.EVENT : I.ACK, this.reconstructor = new dc(r), r.attachments === 0 && super.emitReserved("decoded", r)) : super.emitReserved("decoded", r);
        } else if (On(e) || e.base64) {
            if (this.reconstructor) r = this.reconstructor.takeBinaryData(e), r && (this.reconstructor = null, super.emitReserved("decoded", r));
            else throw new Error("got binary data when not reconstructing a packet");
        } else throw new Error("Unknown type: " + e);
    }
    decodeString(e) {
        let r = 0, n = {
            type: Number(e.charAt(0))
        };
        if (I[n.type] === void 0) throw new Error("unknown packet type " + n.type);
        if (n.type === I.BINARY_EVENT || n.type === I.BINARY_ACK) {
            let s = r + 1;
            for(; e.charAt(++r) !== "-" && r != e.length;);
            let i = e.substring(s, r);
            if (i != Number(i) || e.charAt(r) !== "-") throw new Error("Illegal attachments");
            n.attachments = Number(i);
        }
        if (e.charAt(r + 1) === "/") {
            let s = r + 1;
            for(; ++r && !(e.charAt(r) === "," || r === e.length););
            n.nsp = e.substring(s, r);
        } else n.nsp = "/";
        let o = e.charAt(r + 1);
        if (o !== "" && Number(o) == o) {
            let s = r + 1;
            for(; ++r;){
                let i = e.charAt(r);
                if (i == null || Number(i) != i) {
                    --r;
                    break;
                }
                if (r === e.length) break;
            }
            n.id = Number(e.substring(s, r + 1));
        }
        if (e.charAt(++r)) {
            let s = this.tryParse(e.substr(r));
            if (t.isPayloadValid(n.type, s)) n.data = s;
            else throw new Error("invalid payload");
        }
        return n;
    }
    tryParse(e) {
        try {
            return JSON.parse(e, this.reviver);
        } catch  {
            return !1;
        }
    }
    static isPayloadValid(e, r) {
        switch(e){
            case I.CONNECT:
                return qo(r);
            case I.DISCONNECT:
                return r === void 0;
            case I.CONNECT_ERROR:
                return typeof r == "string" || qo(r);
            case I.EVENT:
            case I.BINARY_EVENT:
                return Array.isArray(r) && (typeof r[0] == "number" || typeof r[0] == "string" && Bp.indexOf(r[0]) === -1);
            case I.ACK:
            case I.BINARY_ACK:
                return Array.isArray(r);
        }
    }
    destroy() {
        this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
    }
}, dc = class {
    constructor(e){
        this.packet = e, this.buffers = [], this.reconPack = e;
    }
    takeBinaryData(e) {
        if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
            let r = Mp(this.reconPack, this.buffers);
            return this.finishedReconstruction(), r;
        }
        return null;
    }
    finishedReconstruction() {
        this.reconPack = null, this.buffers = [];
    }
};
function Fx(t) {
    return typeof t == "string";
}
var $x = Number.isInteger || function(t) {
    return typeof t == "number" && isFinite(t) && Math.floor(t) === t;
};
function Lx(t) {
    return t === void 0 || $x(t);
}
function qo(t) {
    return Object.prototype.toString.call(t) === "[object Object]";
}
function Mx(t, e) {
    switch(t){
        case I.CONNECT:
            return e === void 0 || qo(e);
        case I.DISCONNECT:
            return e === void 0;
        case I.EVENT:
            return Array.isArray(e) && (typeof e[0] == "number" || typeof e[0] == "string" && Bp.indexOf(e[0]) === -1);
        case I.ACK:
            return Array.isArray(e);
        case I.CONNECT_ERROR:
            return typeof e == "string" || qo(e);
        default:
            return !1;
    }
}
function Bx(t) {
    return Fx(t.nsp) && Lx(t.id) && Mx(t.type, t.data);
}
function kt(t, e, r) {
    return t.on(e, r), function() {
        t.off(e, r);
    };
}
var Ux = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    newListener: 1,
    removeListener: 1
}), Tr = class extends X {
    constructor(e, r, n){
        super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = r, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
    }
    get disconnected() {
        return !this.connected;
    }
    subEvents() {
        if (this.subs) return;
        let e = this.io;
        this.subs = [
            kt(e, "open", this.onopen.bind(this)),
            kt(e, "packet", this.onpacket.bind(this)),
            kt(e, "error", this.onerror.bind(this)),
            kt(e, "close", this.onclose.bind(this))
        ];
    }
    get active() {
        return !!this.subs;
    }
    connect() {
        return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
    }
    open() {
        return this.connect();
    }
    send(...e) {
        return e.unshift("message"), this.emit.apply(this, e), this;
    }
    emit(e, ...r) {
        var n, o, s;
        if (Ux.hasOwnProperty(e)) throw new Error('"' + e.toString() + '" is a reserved event name');
        if (r.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) return this._addToQueue(r), this;
        let i = {
            type: I.EVENT,
            data: r
        };
        if (i.options = {}, i.options.compress = this.flags.compress !== !1, typeof r[r.length - 1] == "function") {
            let l = this.ids++, u = r.pop();
            this._registerAckCallback(l, u), i.id = l;
        }
        let a = (o = (n = this.io.engine) === null || n === void 0 ? void 0 : n.transport) === null || o === void 0 ? void 0 : o.writable, c = this.connected && !(!((s = this.io.engine) === null || s === void 0) && s._hasPingExpired());
        return this.flags.volatile && !a || (c ? (this.notifyOutgoingListeners(i), this.packet(i)) : this.sendBuffer.push(i)), this.flags = {}, this;
    }
    _registerAckCallback(e, r) {
        var n;
        let o = (n = this.flags.timeout) !== null && n !== void 0 ? n : this._opts.ackTimeout;
        if (o === void 0) {
            this.acks[e] = r;
            return;
        }
        let s = this.io.setTimeoutFn(()=>{
            delete this.acks[e];
            for(let a = 0; a < this.sendBuffer.length; a++)this.sendBuffer[a].id === e && this.sendBuffer.splice(a, 1);
            r.call(this, new Error("operation has timed out"));
        }, o), i = (...a)=>{
            this.io.clearTimeoutFn(s), r.apply(this, a);
        };
        i.withError = !0, this.acks[e] = i;
    }
    emitWithAck(e, ...r) {
        return new Promise((n, o)=>{
            let s = (i, a)=>i ? o(i) : n(a);
            s.withError = !0, r.push(s), this.emit(e, ...r);
        });
    }
    _addToQueue(e) {
        let r;
        typeof e[e.length - 1] == "function" && (r = e.pop());
        let n = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: !1,
            args: e,
            flags: Object.assign({
                fromQueue: !0
            }, this.flags)
        };
        e.push((o, ...s)=>(this._queue[0], o !== null ? n.tryCount > this._opts.retries && (this._queue.shift(), r && r(o)) : (this._queue.shift(), r && r(null, ...s)), n.pending = !1, this._drainQueue())), this._queue.push(n), this._drainQueue();
    }
    _drainQueue(e = !1) {
        if (!this.connected || this._queue.length === 0) return;
        let r = this._queue[0];
        r.pending && !e || (r.pending = !0, r.tryCount++, this.flags = r.flags, this.emit.apply(this, r.args));
    }
    packet(e) {
        e.nsp = this.nsp, this.io._packet(e);
    }
    onopen() {
        typeof this.auth == "function" ? this.auth((e)=>{
            this._sendConnectPacket(e);
        }) : this._sendConnectPacket(this.auth);
    }
    _sendConnectPacket(e) {
        this.packet({
            type: I.CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, e) : e
        });
    }
    onerror(e) {
        this.connected || this.emitReserved("connect_error", e);
    }
    onclose(e, r) {
        this.connected = !1, delete this.id, this.emitReserved("disconnect", e, r), this._clearAcks();
    }
    _clearAcks() {
        Object.keys(this.acks).forEach((e)=>{
            if (!this.sendBuffer.some((n)=>String(n.id) === e)) {
                let n = this.acks[e];
                delete this.acks[e], n.withError && n.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    onpacket(e) {
        if (e.nsp === this.nsp) switch(e.type){
            case I.CONNECT:
                e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case I.EVENT:
            case I.BINARY_EVENT:
                this.onevent(e);
                break;
            case I.ACK:
            case I.BINARY_ACK:
                this.onack(e);
                break;
            case I.DISCONNECT:
                this.ondisconnect();
                break;
            case I.CONNECT_ERROR:
                this.destroy();
                let n = new Error(e.data.message);
                n.data = e.data.data, this.emitReserved("connect_error", n);
                break;
        }
    }
    onevent(e) {
        let r = e.data || [];
        e.id != null && r.push(this.ack(e.id)), this.connected ? this.emitEvent(r) : this.receiveBuffer.push(Object.freeze(r));
    }
    emitEvent(e) {
        if (this._anyListeners && this._anyListeners.length) {
            let r = this._anyListeners.slice();
            for (let n of r)n.apply(this, e);
        }
        super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
    }
    ack(e) {
        let r = this, n = !1;
        return function(...o) {
            n || (n = !0, r.packet({
                type: I.ACK,
                id: e,
                data: o
            }));
        };
    }
    onack(e) {
        let r = this.acks[e.id];
        typeof r == "function" && (delete this.acks[e.id], r.withError && e.data.unshift(null), r.apply(this, e.data));
    }
    onconnect(e, r) {
        this.id = e, this.recovered = r && this._pid === r, this._pid = r, this.connected = !0, this.emitBuffered(), this._drainQueue(!0), this.emitReserved("connect");
    }
    emitBuffered() {
        this.receiveBuffer.forEach((e)=>this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e)=>{
            this.notifyOutgoingListeners(e), this.packet(e);
        }), this.sendBuffer = [];
    }
    ondisconnect() {
        this.destroy(), this.onclose("io server disconnect");
    }
    destroy() {
        this.subs && (this.subs.forEach((e)=>e()), this.subs = void 0), this.io._destroy(this);
    }
    disconnect() {
        return this.connected && this.packet({
            type: I.DISCONNECT
        }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
    }
    close() {
        return this.disconnect();
    }
    compress(e) {
        return this.flags.compress = e, this;
    }
    get volatile() {
        return this.flags.volatile = !0, this;
    }
    timeout(e) {
        return this.flags.timeout = e, this;
    }
    onAny(e) {
        return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
    }
    prependAny(e) {
        return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
    }
    offAny(e) {
        if (!this._anyListeners) return this;
        if (e) {
            let r = this._anyListeners;
            for(let n = 0; n < r.length; n++)if (e === r[n]) return r.splice(n, 1), this;
        } else this._anyListeners = [];
        return this;
    }
    listenersAny() {
        return this._anyListeners || [];
    }
    onAnyOutgoing(e) {
        return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
    }
    prependAnyOutgoing(e) {
        return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
    }
    offAnyOutgoing(e) {
        if (!this._anyOutgoingListeners) return this;
        if (e) {
            let r = this._anyOutgoingListeners;
            for(let n = 0; n < r.length; n++)if (e === r[n]) return r.splice(n, 1), this;
        } else this._anyOutgoingListeners = [];
        return this;
    }
    listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    notifyOutgoingListeners(e) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            let r = this._anyOutgoingListeners.slice();
            for (let n of r)n.apply(this, e.data);
        }
    }
};
function ze(t) {
    t = t || {}, this.ms = t.min || 100, this.max = t.max || 1e4, this.factor = t.factor || 2, this.jitter = t.jitter > 0 && t.jitter <= 1 ? t.jitter : 0, this.attempts = 0;
}
ze.prototype.duration = function() {
    var t = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var e = Math.random(), r = Math.floor(e * this.jitter * t);
        t = (Math.floor(e * 10) & 1) == 0 ? t - r : t + r;
    }
    return Math.min(t, this.max) | 0;
};
ze.prototype.reset = function() {
    this.attempts = 0;
};
ze.prototype.setMin = function(t) {
    this.ms = t;
};
ze.prototype.setMax = function(t) {
    this.max = t;
};
ze.prototype.setJitter = function(t) {
    this.jitter = t;
};
var Rr = class extends X {
    constructor(e, r){
        var n;
        super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (r = e, e = void 0), r = r || {}, r.path = r.path || "/socket.io", this.opts = r, se(this, r), this.reconnection(r.reconnection !== !1), this.reconnectionAttempts(r.reconnectionAttempts || 1 / 0), this.reconnectionDelay(r.reconnectionDelay || 1e3), this.reconnectionDelayMax(r.reconnectionDelayMax || 5e3), this.randomizationFactor((n = r.randomizationFactor) !== null && n !== void 0 ? n : .5), this.backoff = new ze({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        }), this.timeout(r.timeout == null ? 2e4 : r.timeout), this._readyState = "closed", this.uri = e;
        let o = r.parser || hc;
        this.encoder = new o.Encoder, this.decoder = new o.Decoder, this._autoConnect = r.autoConnect !== !1, this._autoConnect && this.open();
    }
    reconnection(e) {
        return arguments.length ? (this._reconnection = !!e, e || (this.skipReconnect = !0), this) : this._reconnection;
    }
    reconnectionAttempts(e) {
        return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
    }
    reconnectionDelay(e) {
        var r;
        return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (r = this.backoff) === null || r === void 0 || r.setMin(e), this);
    }
    randomizationFactor(e) {
        var r;
        return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (r = this.backoff) === null || r === void 0 || r.setJitter(e), this);
    }
    reconnectionDelayMax(e) {
        var r;
        return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (r = this.backoff) === null || r === void 0 || r.setMax(e), this);
    }
    timeout(e) {
        return arguments.length ? (this._timeout = e, this) : this._timeout;
    }
    maybeReconnectOnOpen() {
        !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
    }
    open(e) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new Ar(this.uri, this.opts);
        let r = this.engine, n = this;
        this._readyState = "opening", this.skipReconnect = !1;
        let o = kt(r, "open", function() {
            n.onopen(), e && e();
        }), s = (a)=>{
            this.cleanup(), this._readyState = "closed", this.emitReserved("error", a), e ? e(a) : this.maybeReconnectOnOpen();
        }, i = kt(r, "error", s);
        if (this._timeout !== !1) {
            let a = this._timeout, c = this.setTimeoutFn(()=>{
                o(), s(new Error("timeout")), r.close();
            }, a);
            this.opts.autoUnref && c.unref(), this.subs.push(()=>{
                this.clearTimeoutFn(c);
            });
        }
        return this.subs.push(o), this.subs.push(i), this;
    }
    connect(e) {
        return this.open(e);
    }
    onopen() {
        this.cleanup(), this._readyState = "open", this.emitReserved("open");
        let e = this.engine;
        this.subs.push(kt(e, "ping", this.onping.bind(this)), kt(e, "data", this.ondata.bind(this)), kt(e, "error", this.onerror.bind(this)), kt(e, "close", this.onclose.bind(this)), kt(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    onping() {
        this.emitReserved("ping");
    }
    ondata(e) {
        try {
            this.decoder.add(e);
        } catch (r) {
            this.onclose("parse error", r);
        }
    }
    ondecoded(e) {
        oe(()=>{
            this.emitReserved("packet", e);
        }, this.setTimeoutFn);
    }
    onerror(e) {
        this.emitReserved("error", e);
    }
    socket(e, r) {
        let n = this.nsps[e];
        return n ? this._autoConnect && !n.active && n.connect() : (n = new Tr(this, e, r), this.nsps[e] = n), n;
    }
    _destroy(e) {
        let r = Object.keys(this.nsps);
        for (let n of r)if (this.nsps[n].active) return;
        this._close();
    }
    _packet(e) {
        let r = this.encoder.encode(e);
        for(let n = 0; n < r.length; n++)this.engine.write(r[n], e.options);
    }
    cleanup() {
        this.subs.forEach((e)=>e()), this.subs.length = 0, this.decoder.destroy();
    }
    _close() {
        this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
    }
    disconnect() {
        return this._close();
    }
    onclose(e, r) {
        var n;
        this.cleanup(), (n = this.engine) === null || n === void 0 || n.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, r), this._reconnection && !this.skipReconnect && this.reconnect();
    }
    reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        let e = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
        else {
            let r = this.backoff.duration();
            this._reconnecting = !0;
            let n = this.setTimeoutFn(()=>{
                e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((o)=>{
                    o ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", o)) : e.onreconnect();
                }));
            }, r);
            this.opts.autoUnref && n.unref(), this.subs.push(()=>{
                this.clearTimeoutFn(n);
            });
        }
    }
    onreconnect() {
        let e = this.backoff.attempts;
        this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
    }
};
var An = {};
function Tn(t, e) {
    typeof t == "object" && (e = t, t = void 0), e = e || {};
    let r = Fp(t, e.path || "/socket.io"), n = r.source, o = r.id, s = r.path, i = An[o] && s in An[o].nsps, a = e.forceNew || e["force new connection"] || e.multiplex === !1 || i, c;
    return a ? c = new Rr(n, e) : (An[o] || (An[o] = new Rr(n, e)), c = An[o]), r.query && !e.query && (e.query = r.queryKey), c.socket(r.path, e);
}
Object.assign(Tn, {
    Manager: Rr,
    Socket: Tr,
    io: Tn,
    connect: Tn
});
v();
var Vx = {
    success: "green",
    error: "red",
    warning: "yellow"
}, Vp = (t, e, r)=>{
    if (t.symbols) {
        if (!r.connected) {
            r.notifications.connected = {
                title: "Connected",
                message: "to the Symbols live server"
            }, r.update({
                connected: !0
            });
            let n = setTimeout(()=>{
                delete r.notifications.connected, e.notifications.content.connected.setProps({
                    animation: "fadeOutDown"
                }), r.update({
                    connected: !0
                }), clearTimeout(n);
            }, 3e3);
        }
    } else if (r.connected) {
        r.notifications.connected = {
            title: "Disconnected",
            type: "error"
        }, r.update({
            connected: !1
        });
        let n = setTimeout(()=>{
            delete r.notifications.connected, e.notifications.content.connected && e.notifications.content.connected.setProps({
                animation: "fadeOutDown"
            }), r.update({
                connected: !0
            }), clearTimeout(n);
        }, 3e3);
    }
}, Rn = {
    state: {
        notifications: []
    },
    Notifications: {
        position: "fixed",
        left: "A2",
        bottom: "Z2",
        zIndex: "999",
        childExtends: "Notification",
        childProps: ({ state: t })=>({
                animationDuration: "C",
                background: Vx[t.type || "success"],
                icon: null,
                Flex: {
                    Title: {
                        text: "{{ title }}"
                    },
                    P: {
                        text: "{{ title }}"
                    }
                },
                onRender: (e, r, n)=>{
                    r.setProps({
                        animation: "fadeInUp"
                    });
                },
                onClick: (e, r, n)=>{
                    delete n.notifications[r.key], r.setProps({
                        animation: "fadeOutDown"
                    }), n.onClose && n.onClose(e, r, n);
                }
            }),
        IconText: null,
        childrenAs: "state",
        children: ({ state: t })=>t.notifications
    }
};
var jp = false, jx = (t, e)=>{
    !t || !Array.isArray(e) || e.reduce((r, n, o, s)=>{
        if (r && n in r) {
            if (o !== s.length - 1) return r[n];
            delete r[n];
        }
    }, t);
}, zx = (t, e, r, n = !1)=>{
    !t || !Array.isArray(e) || e.reduce((o, s, i, a)=>{
        if (o) {
            if (i !== a.length - 1) return !o[s] && n && (o[s] = {}), o[s];
            o[s] = r;
        }
    }, t);
}, qx = (t, e)=>{
    let r = new Set;
    if (!Array.isArray(e)) return r;
    for (let [n, o, s] of e)if (!(!Array.isArray(o) || !o.length)) switch(r.add(o[0]), n){
        case "delete":
            jx(t, o);
            break;
        case "update":
        case "set":
            zx(t, o, s, !0);
            break;
        default:
            break;
    }
    return r;
}, Hx = async ()=>{
    try {
        let t = jp ? "http://localhost:8080" : "https://api.symbols.app", e = await D.fetch(`${t}/service-token`, {
            method: "GET"
        }), r;
        try {
            let n = await e.clone().json();
            if (n && typeof n.token == "string") return n.token.trim();
            r = await e.text();
        } catch  {
            r = await e.text();
        }
        return (r || "").replace(/\s+/gu, "") || void 0;
    } catch (t) {
        console.error("[sync] Failed to fetch service-token", t);
    }
}, Wx = (t, e, r)=>(n = {})=>{
        let { data: o } = n, { schema: s } = n;
        o && (o = t.call("deepDestringifyFunctions", o, Array.isArray(o) ? [] : {}), Object.entries(o).forEach(([i, a])=>{
            r[i] && typeof r[i] == "object" ? i === "designSystem" ? Ue(a) : Mr(r[i], a) : r[i] = a;
        }), s && (r.schema = s));
    }, Gx = (t, e, r)=>(n = {})=>{
        let { changes: o } = n;
        if (!o || !Array.isArray(o) || !o.length) return;
        o = t.call("deepDestringifyFunctions", o, Array.isArray(o) ? [] : {});
        let s = qx(r, o);
        if (s.has("state")) {
            let i = r.state?.route;
            i ? t.call("router", i.replace("/state", "") || "/", t.__ref.root, {}, {
                scrollToTop: !1
            }) : e.update(r.state);
        }
        if ([
            "pages",
            "components",
            "snippets",
            "functions"
        ].some((i)=>s.has(i))) {
            let { pathname: i, search: a, hash: c } = r.window.location;
            t.call("router", i + a + c, t.__ref.root, {}, {
                scrollToTop: !1
            });
        }
        s.has("designSystem") && Ue(r.designSystem);
    }, Kx = async (t, e, r)=>{
    let n = await Hx();
    if (!n) return console.warn("[sync] No service token \u2013 live collaboration disabled"), null;
    let o = r.key;
    if (!o) return console.warn("[sync] ctx.key missing \u2013 cannot establish collaborative connection"), null;
    let i = Tn(jp ? "http://localhost:8080" : "https://api.symbols.app", {
        path: "/collab-socket",
        transports: [
            "websocket"
        ],
        auth: {
            token: n,
            projectKey: o,
            branch: "main",
            live: !0,
            clientType: "platform"
        },
        reconnectionAttempts: 1 / 0,
        reconnectionDelayMax: 4e3
    });
    return i.on("connect", ()=>{
        r.editor?.verbose && console.info("[sync] Connected to collab socket");
    }), i.on("snapshot", Wx(t, e, r)), i.on("ops", Gx(t, e, r)), i.on("clients", (a)=>{
        r.editor?.verbose && Vp(a, t, e);
    }), i.on("disconnect", (a)=>{
        r.editor?.verbose && console.info("[sync] Disconnected from collab socket", a);
    }), i;
}, Ho = {
    onInitSync: Kx
};
var zp = (t, e)=>N(t.extends) ? t.extends : [], qp = (t, e)=>{
    let { editor: r } = e;
    if (!r) return;
    (K(r.liveSync) ? Jt() : r.liveSync) && (x(t.extends) ? t.extends.push(Ho) : t.extends ? t.extends = [
        t.extends,
        Ho
    ] : t.extends = [
        Ho
    ]);
};
var Hp = (t, e)=>{
    let { editor: r } = e;
    if (!r) return;
    (K(r.verbose) ? Jt() || e.verbose : r.verbose) && (x(t.extends) ? t.extends.push(Rn) : t.extends ? t.extends = [
        t.extends,
        Rn
    ] : t.extends = [
        Rn
    ]);
};
v();
v();
var Yx = [
    "useReset",
    "useVariable",
    "useFontImport",
    "useIconSprite",
    "useSvgSprite",
    "useDocumentTheme",
    "useDefaultIcons",
    "useDefaultConfig",
    "verbose",
    "globalTheme"
], Wp = (t, e = {})=>{
    let r = e.parent || e.document || document, n = e.initOptions || {}, o = n.emotion;
    n.emotion || (n.emotion = Et);
    let s = e.registry || gf(n.emotion, e), i = e.designSystem ? U(z(Ia), e.designSystem) : z(Ia), a = {};
    for (let f of Yx)e[f] !== void 0 && (a[f] = e[f]);
    return [
        Ue(i, {
            key: t,
            emotion: o,
            document: r,
            files: e.files,
            ...tc,
            ...a,
            ...n
        }),
        o,
        s
    ];
};
var Yp = (t)=>{
    let e = typeof window < "u" ? window : globalThis || {};
    e.document || (e.document = {
        body: {}
    });
    let r = typeof document < "u" ? document : e.document;
    return t.document = t.document || r, t.window = t.window || e, t.window;
}, Gp = (t = "smbls")=>{
    let e = {};
    for(let r in Be)Object.prototype.hasOwnProperty.call(Be, r) && (It(r) ? e[`smbls.${r}`] = Be[r] : e[r] = Be[r]);
    return e;
}, Xp = (t)=>t.components ? {
        ...Gp(),
        ...t.components
    } : Gp(), Qp = (t)=>({
        ...bn,
        ...Xa,
        ...Sr,
        ...t.utils,
        ...t.snippets,
        ...t.functions
    }), Jp = (t)=>({
        ...t.methods || {},
        require: t.utils.require,
        requireOnDemand: t.utils.requireOnDemand,
        router: t.utils.router
    }), Kp = {}, Zp = async ({ dependencies: t, dependenciesOnDemand: e, document: r, preventCaching: n = !1, cdnProvider: o, packageManager: s, symbolsConfig: i })=>{
    if (o || (o = yr[s] || ho(i) || "esmsh"), !t) return null;
    let a = !1;
    for(let c in t){
        a = !0;
        break;
    }
    if (!a) return null;
    for(let c in t){
        let f = t[c];
        if (e && e[c]) continue;
        let l = Jt() && n ? `?${Math.random()}` : "", u = ee(c, f, o) + l;
        try {
            if (Kp[c]) return;
            Kp[c] = !0, await po(u, {
                document: r,
                type: "module"
            });
        } catch (p) {
            if (console.error(`Failed to load ${c} from ${o}:`, p), o !== "symbols") try {
                let d = ee(c, f, "symbols") + l;
                await po(d, {
                    document: r
                }), console.log(`Successfully loaded ${c} from fallback (symbols.ls)`);
            } catch (d) {
                console.error(`Failed to load ${c} from fallback:`, d);
            }
        }
    }
    return t;
}, td = async (t, e)=>{
    let r = e.window || window, n = e.cdnProvider || ho(e.symbolsConfig) || "esmsh", o = async (i)=>async (a, c)=>{
            let l = (i.window || window).packages[a];
            return typeof l == "function" ? l() : l;
        }, s = async (i)=>async (a, c = n)=>{
            let { dependenciesOnDemand: f } = i, l = i.document || document, u = i.window || window;
            if (!u.packages[a]) {
                let p = Jt() ? `?${Math.random()}` : "";
                if (f && f[a]) {
                    let d = f[a], h = ee(a, d, c) + p;
                    try {
                        await i.utils.loadRemoteScript(h, {
                            window: u,
                            document: l
                        });
                    } catch (m) {
                        if (console.error(`Failed to load ${a} from ${c}:`, m), c !== "symbols") {
                            let S = ee(a, d, "symbols") + p;
                            await i.utils.loadRemoteScript(S, {
                                window: u,
                                document: l
                            });
                        }
                    }
                } else {
                    let d = ee(a, "latest", c) + p;
                    try {
                        await i.utils.loadRemoteScript(d, {
                            window: u,
                            document: l
                        });
                    } catch (h) {
                        if (console.error(`Failed to load ${a} from ${c}:`, h), c !== "symbols") {
                            let m = ee(a, "latest", "symbols") + p;
                            await i.utils.loadRemoteScript(m, {
                                window: u,
                                document: l
                            });
                        }
                    }
                    u.packages[a] = "loadedOnDeman";
                }
            }
            return await u.require(a, c);
        };
    r.packages ? r.packages = Y(r.packages, t) : r.packages = t, r.require || (e.utils.require = await o(e), r.require = e.utils.require), r.requireOnDemand || (e.utils.requireOnDemand = await s(e), r.requireOnDemand = e.utils.requireOnDemand);
}, ed = (t, e)=>{
    let [r, n, o] = Wp(t, e);
    return [
        r,
        n,
        o
    ];
}, rd = (t, e)=>{
    let r = {};
    return e.state && U(r, e.state), t && t.state && U(r, t.state), r.isRootState = !0, z(r);
}, nd = (t, e)=>{
    g(t.routes) && g(e.pages) && Y(t.routes, e.pages);
    let r = t.routes || e.pages || {};
    for(let n in r){
        if (n.charCodeAt(0) === 47) continue;
        let o = n === "index" ? "" : n;
        r["/" + o] = r[n], delete r[n];
    }
    return r;
}, od = (t)=>{
    let e = t.sharedLibraries;
    for(let r = 0; r < e.length; r++){
        let n = e[r];
        t.type === "template" ? (overwriteShallow(t.designSystem, n.designSystem), U(t, n, [
            "designSystem"
        ], 1)) : U(t, n, [], 1);
    }
};
v();
var id = "smbls_lang", Xx = "smbls_t_", Qx = "smbls_tv_", Ir = {
    get (t) {
        try {
            return window?.localStorage.getItem(t);
        } catch  {
            return null;
        }
    },
    set (t, e) {
        try {
            window?.localStorage.setItem(t, e);
        } catch  {}
    },
    remove (t) {
        try {
            window?.localStorage.removeItem(t);
        } catch  {}
    }
}, In = {};
function Go() {
    let t = this?.context, e = t?.polyglot;
    return (this?.state?.root || t?.state?.root)?.lang || e?.defaultLang || "en";
}
function mc() {
    let t = this?.context?.polyglot;
    return t ? t.languages ? t.languages : t.translations ? Object.keys(t.translations) : [] : [];
}
var Wo = (t, e)=>{
    if (!t || !e) return;
    if (t[e] !== void 0) return t[e];
    if (e.indexOf(".") === -1) return;
    let r = e.split("."), n = t;
    for(let o = 0; o < r.length; o++){
        if (n == null) return;
        n = n[r[o]];
    }
    return n;
}, sd = (t, e, r)=>{
    let n = e.lastIndexOf(".");
    if (n === -1) return t[e + "_" + r];
    let o = Wo(t, e.substring(0, n));
    if (o != null) return o[e.substring(n + 1) + "_" + r];
};
function gc(t, e) {
    if (!t) return "";
    let r = this?.context, n = r?.polyglot, o = e || this.call("getActiveLang"), s = this?.state;
    if (s) {
        let f = sd(s, t, o);
        if (f !== void 0) return f;
    }
    if (n?.translations) {
        let f = n.translations[o];
        if (f) {
            let l = Wo(f, t);
            if (l !== void 0) return l;
        }
    }
    let a = (s?.root || r?.state?.root)?.translations;
    if (a) {
        let f = a[o];
        if (f) {
            let l = Wo(f, t);
            if (l !== void 0) return l;
        }
    }
    let c = n?.defaultLang || "en";
    if (s) {
        let f = sd(s, t, c);
        if (f !== void 0) return f;
    }
    if (n?.translations) {
        let f = n.translations[c];
        if (f) {
            let l = Wo(f, t);
            if (l !== void 0) return l;
        }
    }
    return t;
}
async function yc(t) {
    let e = this?.context, r = e?.polyglot, n = this?.state?.root || e?.state?.root;
    if (!r || !n) return;
    let o = r.storagePrefix || Xx, s = r.storageVersionPrefix || (r.storagePrefix ? r.storagePrefix.replace(/_$/, "v_") : Qx);
    if (r.translations && r.translations[t] && !r.fetch || !r.fetch || r._fetchFailed?.[t]) return;
    if (!n.translations?.[t]) {
        let c = Ir.get(o + t);
        if (c) try {
            let f = JSON.parse(c), l = {
                translations: {
                    ...n.translations || {}
                }
            };
            l.translations[t] = f, n.update && n.update(l);
        } catch  {}
    }
    let i = (r.storagePrefix || "smbls") + ":" + t;
    if (In[i]) return In[i];
    let a = this;
    return In[i] = (async ()=>{
        try {
            let c = r.fetch, f = parseInt(Ir.get(s + t), 10) || 0, l, u, p;
            if (y(c)) {
                let h = await c(t, f, a);
                if (!h || h.changed === !1) return;
                l = h.translations || h.data || h, u = h.version || 0, p = !0;
            } else if (g(c)) {
                let h = a.getDB || (()=>e.fetch), m = y(h) ? await h.call(a) : e.fetch;
                if (!m) return;
                let S = c.rpc || c.from || "get_translations_if_changed", _ = {
                    p_lang: t,
                    p_cached_version: f,
                    ...c.params || {}
                }, w = await m.rpc({
                    from: S,
                    params: _
                });
                if (w.error) throw r._fetchFailed || (r._fetchFailed = {}), r._fetchFailed[t] = !0, w.error;
                let E = w.data;
                if (!E || !E.changed) return;
                l = E.translations || {}, u = E.version || 0, p = !0;
            } else return;
            if (!p || !l) return;
            Ir.set(o + t, JSON.stringify(l)), u && Ir.set(s + t, String(u));
            let d = {
                translations: {
                    ...n.translations || {}
                }
            };
            d.translations[t] = l, n.update && n.update(d);
        } catch (c) {
            if (r.verbose !== !1) {
                let f = c?.message || c?.details || (typeof c == "object" ? JSON.stringify(c) : String(c));
                console.warn("[polyglot] Failed to load translations for", t, "-", f);
            }
        } finally{
            delete In[i];
        }
    })(), In[i];
}
async function bc(t) {
    let e = this?.context, r = e?.polyglot, n = this?.state?.root || e?.state?.root;
    if (!n || this.call("getActiveLang") === t) return;
    let o = r?.storageLangKey || id;
    Ir.set(o, t), r?.fetch && await this.call("loadTranslations", t), n.update && n.update({
        lang: t
    });
}
async function Sc(t, e, r) {
    let n = this?.context, o = n?.polyglot, s = this?.state?.root || n?.state?.root;
    if (s?.translations?.[e] && (s.translations[e][t] = r), o?.translations?.[e] && (o.translations[e][t] = r), o?.fetch && g(o.fetch)) {
        let i = this.getDB || (()=>n.fetch), a = y(i) ? await i.call(this) : n.fetch;
        if (!a) return;
        let c = o.fetch.table || "translations", f = await a.upsert({
            from: c,
            data: {
                key: t,
                lang: e,
                text: r
            }
        });
        if (f?.error) throw f.error;
        return f.data;
    }
}
async function ad() {
    let t = this?.context, e = t?.polyglot;
    if (!e) return;
    let r = this?.state?.root || t?.state?.root;
    if (!r) return;
    let n = e.storageLangKey || id, s = Ir.get(n) || e.defaultLang || r.lang || "en";
    r.update && r.lang !== s && r.update({
        lang: s
    }), e.fetch && !(e.translations && e.translations[s]) && await this.call("loadTranslations", s);
}
function xc(t) {
    try {
        let e = this?.context?.polyglot, n = (this?.state?.root || this?.context?.state?.root)?.lang || e?.defaultLang || "en", o = this?.state;
        if (!o) return "";
        let s = t.lastIndexOf(".");
        if (s === -1) return o[t + n] ?? "";
        let i = t.substring(0, s).split("."), a = o;
        for(let c = 0; c < i.length; c++){
            if (a == null) return "";
            a = a[i[c]];
        }
        return a == null ? "" : a[t.substring(s + 1) + n] ?? "";
    } catch  {
        return "";
    }
}
var _c = {
    name: "polyglot",
    render (t) {
        t.parent && t.parent.parent || t.__polyglotInitialized || (t.__polyglotInitialized = !0, ad.call(t));
    }
};
var Ko = {
    polyglot: gc,
    getLocalStateLang: xc,
    getActiveLang: Go,
    getLang: Go,
    setLang: bc,
    getLanguages: mc,
    loadTranslations: yc,
    upsertTranslation: Sc
};
Ae();
var Jx = async (t, e = {})=>{
    let r = e.key = e.key || (b(t) ? t : "smblsapp");
    e.define = e.define || Sn, e.cssPropsRegistry = hn, e.window = Yp(e), e.sharedLibraries && e.sharedLibraries.length && od(e);
    let [n, o, s] = ed(r, e);
    e.designSystem = n, e.registry = s, e.emotion = o;
    let i = rd(t, e);
    e.state = i, e.pages = nd(t, e), e.components = Xp(e), e.utils = Qp(e), yr[e.packageManager] && (e.dependencies = await Zp(e)), e.methods = Jp(e), e.routerOptions = ep(t, e), e.defaultExtends = [
        Na
    ], e.snippets = e.snippets || {}, e.functions = e.functions || {}, e.plugins = e.plugins || [], e.globalScope && g(e.globalScope) && (e.globalScope = us(e.globalScope));
    let a = (c)=>e.plugins.some((f)=>f.name === c);
    if (e.polyglot && !a("polyglot")) {
        e.plugins.push(_c);
        for(let c in Ko)c in e.functions || (e.functions[c] = Ko[c]);
    }
    return a("helmet") || e.plugins.push(ap), e.fetch && !a("fetch") && e.plugins.push(fi), e;
}, wc = async (t, e)=>{
    g(e) || (e = {}), Ee(t) ? (t = {}, e.parent = t) : b(t) ? (t = {}, e.key = t) : g(t) || (t = {}), await Jx(t, e), t.extends = zp(t, e), t.routes = e.pages, t.state = e.state, t.context = e, t.data = t.data || {}, t.data.frameListeners = yu(e), await td({
        functions: e.functions,
        utils: e.utils,
        snippets: e.snippets,
        ...e.files
    }, e), qp(t, e), Hp(t, e);
    let r = e.document;
    if (!r || !r.createElement) return t;
    let n = e.window || (typeof window < "u" ? window : null);
    if (n?.__BRENDER__ && r.querySelector("[data-br]")) return Zx(t, e, r, n);
    let s = e.parent || r.body;
    return await (Ve.default && Ve.default.create || Ve.create)(t, s, e.key, {
        verbose: e.verbose,
        ...e.domqlOptions
    });
}, Zx = async (t, e, r, n)=>{
    let o = e.parent || r.body, s = Ve.default && Ve.default.create || Ve.create, i = [];
    for (let c of o.childNodes){
        if (c.nodeType === 1) {
            let f = c.tagName.toLowerCase();
            if (f === "style" || f === "script" || f === "link") continue;
        }
        i.push(c);
    }
    i.forEach((c)=>c.remove());
    let a = await s(t, o, e.key, {
        verbose: e.verbose,
        ...e.domqlOptions,
        onlyResolveExtends: !1
    });
    return delete n.__BRENDER__, a;
};
var vc = (t, e)=>U(t, g(e) ? e : {}), cd = (t, e = xe, r)=>{
    let n = {
        ...xe,
        ...vc(e, r)
    }, o = wc(t, n).then((s)=>{
        rp(s, n), n.on && n.on.create && n.on.create(o, o.state, o.context, n);
    });
    return o;
}, $P = (t, e = xe, r)=>{
    let n = cd(t, e, r), o = {
        ...xe,
        ...vc(e, r)
    }, s = o.key;
    return ip(n, s, {
        utils: bn,
        ...o
    }), n;
}, LP = async (t, e = xe, r)=>{
    let n = {
        ...xe,
        ...vc(e, r)
    }, o = e.key;
    await sp(o, n);
    let s = await wc(t, n);
    return n.on && n.on.create && await n.on.create(s, s.state, s.context, n), s;
}, MP = (t = {}, e = xe, r)=>cd({
        deps: {
            isUndefined: K
        },
        ...t
    }, U({
        domqlOptions: {
            onlyResolveExtends: !0
        }
    }, e), r);
 // @preserve-env

});
parcelRegister("dNnfS", function(module, exports) {

$parcel$export(module.exports, "SupabaseClient", () => $5e33485c08cd650a$export$1bfe63e045eb2ffa);
$parcel$export(module.exports, "createClient", () => $5e33485c08cd650a$export$5d730b7aed1a3eb0);
$parcel$export(module.exports, "FunctionRegion", () => (parcelRequire("1oqCS")).FunctionRegion);
$parcel$export(module.exports, "FunctionsError", () => (parcelRequire("1oqCS")).FunctionsError);
$parcel$export(module.exports, "FunctionsFetchError", () => (parcelRequire("1oqCS")).FunctionsFetchError);
$parcel$export(module.exports, "FunctionsHttpError", () => (parcelRequire("1oqCS")).FunctionsHttpError);
$parcel$export(module.exports, "FunctionsRelayError", () => (parcelRequire("1oqCS")).FunctionsRelayError);
$parcel$export(module.exports, "PostgrestError", () => (parcelRequire("4yorG")).PostgrestError);

var $1oqCS = parcelRequire("1oqCS");
var $9A7Ck = parcelRequire("9A7Ck");

var $4yorG = parcelRequire("4yorG");
parcelRequire("izHZ4");
var $eWiay = parcelRequire("eWiay");
var $izHZ4 = parcelRequire("izHZ4");

var $9Yl9w = parcelRequire("9Yl9w");
parcelRequire("lpqci");
var $aALRH = parcelRequire("aALRH");
var $lpqci = parcelRequire("lpqci");
//#region src/lib/version.ts
const $5e33485c08cd650a$var$version = "2.99.3";
//#endregion
//#region src/lib/constants.ts
let $5e33485c08cd650a$var$JS_ENV = "";
if (typeof Deno !== "undefined") $5e33485c08cd650a$var$JS_ENV = "deno";
else if (typeof document !== "undefined") $5e33485c08cd650a$var$JS_ENV = "web";
else if (typeof navigator !== "undefined" && navigator.product === "ReactNative") $5e33485c08cd650a$var$JS_ENV = "react-native";
else $5e33485c08cd650a$var$JS_ENV = "node";
const $5e33485c08cd650a$var$DEFAULT_HEADERS = {
    "X-Client-Info": `supabase-js-${$5e33485c08cd650a$var$JS_ENV}/${$5e33485c08cd650a$var$version}`
};
const $5e33485c08cd650a$var$DEFAULT_GLOBAL_OPTIONS = {
    headers: $5e33485c08cd650a$var$DEFAULT_HEADERS
};
const $5e33485c08cd650a$var$DEFAULT_DB_OPTIONS = {
    schema: "public"
};
const $5e33485c08cd650a$var$DEFAULT_AUTH_OPTIONS = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit"
};
const $5e33485c08cd650a$var$DEFAULT_REALTIME_OPTIONS = {};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $5e33485c08cd650a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5e33485c08cd650a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $5e33485c08cd650a$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $5e33485c08cd650a$var$toPrimitive(t, r) {
    if ("object" != $5e33485c08cd650a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5e33485c08cd650a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $5e33485c08cd650a$var$toPropertyKey(t) {
    var i = $5e33485c08cd650a$var$toPrimitive(t, "string");
    return "symbol" == $5e33485c08cd650a$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $5e33485c08cd650a$var$_defineProperty(e, r, t) {
    return (r = $5e33485c08cd650a$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $5e33485c08cd650a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e33485c08cd650a$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e33485c08cd650a$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $5e33485c08cd650a$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e33485c08cd650a$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/fetch.ts
const $5e33485c08cd650a$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $5e33485c08cd650a$var$resolveHeadersConstructor = ()=>{
    return Headers;
};
const $5e33485c08cd650a$var$fetchWithAuth = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch$1 = $5e33485c08cd650a$var$resolveFetch(customFetch);
    const HeadersConstructor = $5e33485c08cd650a$var$resolveHeadersConstructor();
    return async (input, init)=>{
        var _await$getAccessToken;
        const accessToken = (_await$getAccessToken = await getAccessToken()) !== null && _await$getAccessToken !== void 0 ? _await$getAccessToken : supabaseKey;
        let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
        if (!headers.has("apikey")) headers.set("apikey", supabaseKey);
        if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${accessToken}`);
        return fetch$1(input, $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, init), {}, {
            headers: headers
        }));
    };
};
//#endregion
//#region src/lib/helpers.ts
function $5e33485c08cd650a$var$ensureTrailingSlash(url) {
    return url.endsWith("/") ? url : url + "/";
}
function $5e33485c08cd650a$var$applySettingDefaults(options, defaults) {
    var _DEFAULT_GLOBAL_OPTIO, _globalOptions$header;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS$1, auth: DEFAULT_AUTH_OPTIONS$1, realtime: DEFAULT_REALTIME_OPTIONS$1, global: DEFAULT_GLOBAL_OPTIONS$1 } = defaults;
    const result = {
        db: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_DB_OPTIONS$1), dbOptions),
        auth: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_AUTH_OPTIONS$1), authOptions),
        realtime: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_REALTIME_OPTIONS$1), realtimeOptions),
        storage: {},
        global: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_GLOBAL_OPTIONS$1), globalOptions), {}, {
            headers: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, (_DEFAULT_GLOBAL_OPTIO = DEFAULT_GLOBAL_OPTIONS$1 === null || DEFAULT_GLOBAL_OPTIONS$1 === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS$1.headers) !== null && _DEFAULT_GLOBAL_OPTIO !== void 0 ? _DEFAULT_GLOBAL_OPTIO : {}), (_globalOptions$header = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _globalOptions$header !== void 0 ? _globalOptions$header : {})
        }),
        accessToken: async ()=>""
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else delete result.accessToken;
    return result;
}
/**
* Validates a Supabase client URL
*
* @param {string} supabaseUrl - The Supabase client URL string.
* @returns {URL} - The validated base URL.
* @throws {Error}
*/ function $5e33485c08cd650a$var$validateSupabaseUrl(supabaseUrl) {
    const trimmedUrl = supabaseUrl === null || supabaseUrl === void 0 ? void 0 : supabaseUrl.trim();
    if (!trimmedUrl) throw new Error("supabaseUrl is required.");
    if (!trimmedUrl.match(/^https?:\/\//i)) throw new Error("Invalid supabaseUrl: Must be a valid HTTP or HTTPS URL.");
    try {
        return new URL($5e33485c08cd650a$var$ensureTrailingSlash(trimmedUrl));
    } catch (_unused) {
        throw Error("Invalid supabaseUrl: Provided URL is malformed.");
    }
}
//#endregion
//#region src/lib/SupabaseAuthClient.ts
var $5e33485c08cd650a$var$SupabaseAuthClient = class extends (0, $aALRH.default) {
    constructor(options){
        super(options);
    }
};
//#endregion
//#region src/SupabaseClient.ts
/**
* Supabase Client.
*
* An isomorphic Javascript client for interacting with Postgres.
*/ var $5e33485c08cd650a$export$1bfe63e045eb2ffa = class {
    /**
	* Create a new client for use in the browser.
	*
	* @category Initializing
	*
	* @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
	* @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
	* @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
	* @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
	* @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
	* @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
	* @param options.realtime Options passed along to realtime-js constructor.
	* @param options.storage Options passed along to the storage-js constructor.
	* @param options.global.fetch A custom fetch implementation.
	* @param options.global.headers Any additional headers to send with each network request.
	*
	* @example Creating a client
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Create a single supabase client for interacting with your database
	* const supabase = createClient('https://xyzcompany.supabase.co', 'publishable-or-anon-key')
	* ```
	*
	* @example With a custom domain
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Use a custom domain as the supabase URL
	* const supabase = createClient('https://my-custom-domain.com', 'publishable-or-anon-key')
	* ```
	*
	* @example With additional parameters
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const options = {
	*   db: {
	*     schema: 'public',
	*   },
	*   auth: {
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: true
	*   },
	*   global: {
	*     headers: { 'x-my-custom-header': 'my-app-name' },
	*   },
	* }
	* const supabase = createClient("https://xyzcompany.supabase.co", "publishable-or-anon-key", options)
	* ```
	*
	* @exampleDescription With custom schemas
	* By default the API server points to the `public` schema. You can enable other database schemas within the Dashboard.
	* Go to [Settings > API > Exposed schemas](/dashboard/project/_/settings/api) and add the schema which you want to expose to the API.
	*
	* Note: each client connection can only access a single schema, so the code above can access the `other_schema` schema but cannot access the `public` schema.
	*
	* @example With custom schemas
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'publishable-or-anon-key', {
	*   // Provide a custom schema. Defaults to "public".
	*   db: { schema: 'other_schema' }
	* })
	* ```
	*
	* @exampleDescription Custom fetch implementation
	* `supabase-js` uses the [`cross-fetch`](https://www.npmjs.com/package/cross-fetch) library to make HTTP requests,
	* but an alternative `fetch` implementation can be provided as an option.
	* This is most useful in environments where `cross-fetch` is not compatible (for instance Cloudflare Workers).
	*
	* @example Custom fetch implementation
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'publishable-or-anon-key', {
	*   global: { fetch: fetch.bind(globalThis) }
	* })
	* ```
	*
	* @exampleDescription React Native options with AsyncStorage
	* For React Native we recommend using `AsyncStorage` as the storage implementation for Supabase Auth.
	*
	* @example React Native options with AsyncStorage
	* ```js
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from "@react-native-async-storage/async-storage";
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "publishable-or-anon-key", {
	*   auth: {
	*     storage: AsyncStorage,
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @exampleDescription React Native options with Expo SecureStore
	* If you wish to encrypt the user's session information, you can use `aes-js` and store the encryption key in Expo SecureStore.
	* The `aes-js` library, a reputable JavaScript-only implementation of the AES encryption algorithm in CTR mode.
	* A new 256-bit encryption key is generated using the `react-native-get-random-values` library.
	* This key is stored inside Expo's SecureStore, while the value is encrypted and placed inside AsyncStorage.
	*
	* Please make sure that:
	* - You keep the `expo-secure-store`, `aes-js` and `react-native-get-random-values` libraries up-to-date.
	* - Choose the correct [`SecureStoreOptions`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestoreoptions) for your app's needs.
	*   E.g. [`SecureStore.WHEN_UNLOCKED`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestorewhen_unlocked) regulates when the data can be accessed.
	* - Carefully consider optimizations or other modifications to the above example, as those can lead to introducing subtle security vulnerabilities.
	*
	* @example React Native options with Expo SecureStore
	* ```ts
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from '@react-native-async-storage/async-storage';
	* import * as SecureStore from 'expo-secure-store';
	* import * as aesjs from 'aes-js';
	* import 'react-native-get-random-values';
	*
	* // As Expo's SecureStore does not support values larger than 2048
	* // bytes, an AES-256 key is generated and stored in SecureStore, while
	* // it is used to encrypt/decrypt values stored in AsyncStorage.
	* class LargeSecureStore {
	*   private async _encrypt(key: string, value: string) {
	*     const encryptionKey = crypto.getRandomValues(new Uint8Array(256 / 8));
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(encryptionKey, new aesjs.Counter(1));
	*     const encryptedBytes = cipher.encrypt(aesjs.utils.utf8.toBytes(value));
	*
	*     await SecureStore.setItemAsync(key, aesjs.utils.hex.fromBytes(encryptionKey));
	*
	*     return aesjs.utils.hex.fromBytes(encryptedBytes);
	*   }
	*
	*   private async _decrypt(key: string, value: string) {
	*     const encryptionKeyHex = await SecureStore.getItemAsync(key);
	*     if (!encryptionKeyHex) {
	*       return encryptionKeyHex;
	*     }
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(aesjs.utils.hex.toBytes(encryptionKeyHex), new aesjs.Counter(1));
	*     const decryptedBytes = cipher.decrypt(aesjs.utils.hex.toBytes(value));
	*
	*     return aesjs.utils.utf8.fromBytes(decryptedBytes);
	*   }
	*
	*   async getItem(key: string) {
	*     const encrypted = await AsyncStorage.getItem(key);
	*     if (!encrypted) { return encrypted; }
	*
	*     return await this._decrypt(key, encrypted);
	*   }
	*
	*   async removeItem(key: string) {
	*     await AsyncStorage.removeItem(key);
	*     await SecureStore.deleteItemAsync(key);
	*   }
	*
	*   async setItem(key: string, value: string) {
	*     const encrypted = await this._encrypt(key, value);
	*
	*     await AsyncStorage.setItem(key, encrypted);
	*   }
	* }
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "publishable-or-anon-key", {
	*   auth: {
	*     storage: new LargeSecureStore(),
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @example With a database query
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'public-anon-key')
	*
	* const { data } = await supabase.from('profiles').select('*')
	* ```
	*/ constructor(supabaseUrl, supabaseKey, options){
        var _settings$auth$storag, _settings$global$head;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        const baseUrl = $5e33485c08cd650a$var$validateSupabaseUrl(supabaseUrl);
        if (!supabaseKey) throw new Error("supabaseKey is required.");
        this.realtimeUrl = new URL("realtime/v1", baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace("http", "ws");
        this.authUrl = new URL("auth/v1", baseUrl);
        this.storageUrl = new URL("storage/v1", baseUrl);
        this.functionsUrl = new URL("functions/v1", baseUrl);
        const defaultStorageKey = `sb-${baseUrl.hostname.split(".")[0]}-auth-token`;
        const DEFAULTS = {
            db: $5e33485c08cd650a$var$DEFAULT_DB_OPTIONS,
            realtime: $5e33485c08cd650a$var$DEFAULT_REALTIME_OPTIONS,
            auth: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, $5e33485c08cd650a$var$DEFAULT_AUTH_OPTIONS), {}, {
                storageKey: defaultStorageKey
            }),
            global: $5e33485c08cd650a$var$DEFAULT_GLOBAL_OPTIONS
        };
        const settings = $5e33485c08cd650a$var$applySettingDefaults(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_settings$auth$storag = settings.auth.storageKey) !== null && _settings$auth$storag !== void 0 ? _settings$auth$storag : "";
        this.headers = (_settings$global$head = settings.global.headers) !== null && _settings$global$head !== void 0 ? _settings$global$head : {};
        if (!settings.accessToken) {
            var _settings$auth;
            this.auth = this._initSupabaseAuthClient((_settings$auth = settings.auth) !== null && _settings$auth !== void 0 ? _settings$auth : {}, this.headers, settings.global.fetch);
        } else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = $5e33485c08cd650a$var$fetchWithAuth(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient($5e33485c08cd650a$var$_objectSpread2({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        if (this.accessToken) Promise.resolve(this.accessToken()).then((token)=>this.realtime.setAuth(token)).catch((e)=>console.warn("Failed to set initial Realtime auth token:", e));
        this.rest = new (0, $4yorG.PostgrestClient)(new URL("rest/v1", baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch,
            timeout: settings.db.timeout,
            urlLengthLimit: settings.db.urlLengthLimit
        });
        this.storage = new (0, $9Yl9w.StorageClient)(this.storageUrl.href, this.headers, this.fetch, options === null || options === void 0 ? void 0 : options.storage);
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
	* Supabase Functions allows you to deploy and invoke edge functions.
	*/ get functions() {
        return new (0, $9A7Ck.FunctionsClient)(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*/ from(relation) {
        return this.rest.from(relation);
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*/ schema(schema) {
        return this.rest.schema(schema);
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*/ rpc(fn, args = {}, options = {
        head: false,
        get: false,
        count: void 0
    }) {
        return this.rest.rpc(fn, args, options);
    }
    /**
	* Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
	*
	* @param {string} name - The name of the Realtime channel.
	* @param {Object} opts - The options to pass to the Realtime channel.
	*
	*/ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
	* Returns all Realtime channels.
	*/ getChannels() {
        return this.realtime.getChannels();
    }
    /**
	* Unsubscribes and removes Realtime channel from Realtime client.
	*
	* @param {RealtimeChannel} channel - The name of the Realtime channel.
	*
	*/ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
	* Unsubscribes and removes all Realtime channels from Realtime client.
	*/ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    async _getAccessToken() {
        var _this = this;
        var _data$session$access_, _data$session;
        if (_this.accessToken) return await _this.accessToken();
        const { data: data } = await _this.auth.getSession();
        return (_data$session$access_ = (_data$session = data.session) === null || _data$session === void 0 ? void 0 : _data$session.access_token) !== null && _data$session$access_ !== void 0 ? _data$session$access_ : _this.supabaseKey;
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, userStorage: userStorage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug, throwOnError: throwOnError }, headers, fetch$1) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new $5e33485c08cd650a$var$SupabaseAuthClient({
            url: this.authUrl.href,
            headers: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            userStorage: userStorage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            throwOnError: throwOnError,
            fetch: fetch$1,
            hasCustomAuthorizationHeader: Object.keys(this.headers).some((key)=>key.toLowerCase() === "authorization")
        });
    }
    _initRealtimeClient(options) {
        return new (0, $eWiay.default)(this.realtimeUrl.href, $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, options), {}, {
            params: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, {
                apikey: this.supabaseKey
            }), options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        return this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, "CLIENT", session === null || session === void 0 ? void 0 : session.access_token);
        });
    }
    _handleTokenChanged(event, source, token) {
        if ((event === "TOKEN_REFRESHED" || event === "SIGNED_IN") && this.changedAccessToken !== token) {
            this.changedAccessToken = token;
            this.realtime.setAuth(token);
        } else if (event === "SIGNED_OUT") {
            this.realtime.setAuth();
            if (source == "STORAGE") this.auth.signOut();
            this.changedAccessToken = void 0;
        }
    }
};
//#endregion
//#region src/index.ts
/**
* Creates a new Supabase Client.
*
* @example
* ```ts
* import { createClient } from '@supabase/supabase-js'
*
* const supabase = createClient('https://xyzcompany.supabase.co', 'public-anon-key')
* const { data, error } = await supabase.from('profiles').select('*')
* ```
*/ const $5e33485c08cd650a$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new $5e33485c08cd650a$export$1bfe63e045eb2ffa(supabaseUrl, supabaseKey, options);
};
function $5e33485c08cd650a$var$shouldShowDeprecationWarning() {
    if (typeof window !== "undefined") return false;
    const _process = globalThis["process"];
    if (!_process) return false;
    const processVersion = _process["version"];
    if (processVersion === void 0 || processVersion === null) return false;
    const versionMatch = processVersion.match(/^v(\d+)\./);
    if (!versionMatch) return false;
    return parseInt(versionMatch[1], 10) <= 18;
}
if ($5e33485c08cd650a$var$shouldShowDeprecationWarning()) console.warn("\u26A0\uFE0F  Node.js 18 and below are deprecated and will no longer be supported in future versions of @supabase/supabase-js. Please upgrade to Node.js 20 or later. For more information, visit: https://github.com/orgs/supabase/discussions/37217");
$parcel$exportWildcard(module.exports, $izHZ4);
$parcel$exportWildcard(module.exports, $lpqci);

});
parcelRegister("1oqCS", function(module, exports) {

$parcel$export(module.exports, "FunctionsError", () => $103cafb5d5f4c571$export$738689d52335bb3c);
$parcel$export(module.exports, "FunctionsFetchError", () => $103cafb5d5f4c571$export$14f2b6540d498ce);
$parcel$export(module.exports, "FunctionsRelayError", () => $103cafb5d5f4c571$export$d08a45df86040161);
$parcel$export(module.exports, "FunctionsHttpError", () => $103cafb5d5f4c571$export$761f8c0e0fa4624f);
$parcel$export(module.exports, "FunctionRegion", () => $103cafb5d5f4c571$export$9b19f1a5abf91e06);
/**
 * Base error for Supabase Edge Function invocations.
 *
 * @example
 * ```ts
 * import { FunctionsError } from '@supabase/functions-js'
 *
 * throw new FunctionsError('Unexpected error invoking function', 'FunctionsError', {
 *   requestId: 'abc123',
 * })
 * ```
 */ class $103cafb5d5f4c571$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $103cafb5d5f4c571$export$14f2b6540d498ce extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $103cafb5d5f4c571$export$d08a45df86040161 extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $103cafb5d5f4c571$export$761f8c0e0fa4624f extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $103cafb5d5f4c571$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($103cafb5d5f4c571$export$9b19f1a5abf91e06 || ($103cafb5d5f4c571$export$9b19f1a5abf91e06 = {}));

});

parcelRegister("9A7Ck", function(module, exports) {

$parcel$export(module.exports, "FunctionsClient", () => $6f9d627d4ebb0255$export$1d0b400bf8a0fa55);

var $7WQrb = parcelRequire("7WQrb");

var $ffULL = parcelRequire("ffULL");

var $1oqCS = parcelRequire("1oqCS");
class $6f9d627d4ebb0255$export$1d0b400bf8a0fa55 {
    /**
     * Creates a new Functions client bound to an Edge Functions URL.
     *
     * @example
     * ```ts
     * import { FunctionsClient, FunctionRegion } from '@supabase/functions-js'
     *
     * const functions = new FunctionsClient('https://xyzcompany.supabase.co/functions/v1', {
     *   headers: { apikey: 'public-anon-key' },
     *   region: FunctionRegion.UsEast1,
     * })
     * ```
     */ constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $1oqCS.FunctionRegion).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $ffULL.resolveFetch)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     * @example
     * ```ts
     * functions.setAuth(session.access_token)
     * ```
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     * @example
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     */ invoke(functionName_1) {
        return (0, $7WQrb.__awaiter)(this, arguments, void 0, function*(functionName, options = {}) {
            var _a;
            let timeoutId;
            let timeoutController;
            try {
                const { headers: headers, method: method, body: functionArgs, signal: signal, timeout: timeout } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                // Add region as query parameter using URL API
                const url = new URL(`${this.url}/${functionName}`);
                if (region && region !== 'any') {
                    _headers['x-region'] = region;
                    url.searchParams.set('forceFunctionRegion', region);
                }
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                } else if (functionArgs && typeof functionArgs !== 'string' && !(typeof Blob !== 'undefined' && functionArgs instanceof Blob) && !(functionArgs instanceof ArrayBuffer) && !(typeof FormData !== 'undefined' && functionArgs instanceof FormData)) body = JSON.stringify(functionArgs);
                else body = functionArgs;
                // Handle timeout by creating an AbortController
                let effectiveSignal = signal;
                if (timeout) {
                    timeoutController = new AbortController();
                    timeoutId = setTimeout(()=>timeoutController.abort(), timeout);
                    // If user provided their own signal, we need to respect both
                    if (signal) {
                        effectiveSignal = timeoutController.signal;
                        // If the user's signal is aborted, abort our timeout controller too
                        signal.addEventListener('abort', ()=>timeoutController.abort());
                    } else effectiveSignal = timeoutController.signal;
                }
                const response = yield this.fetch(url.toString(), {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body,
                    signal: effectiveSignal
                }).catch((fetchError)=>{
                    throw new (0, $1oqCS.FunctionsFetchError)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $1oqCS.FunctionsRelayError)(response);
                if (!response.ok) throw new (0, $1oqCS.FunctionsHttpError)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream' || responseType === 'application/pdf') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null,
                    response: response
                };
            } catch (error) {
                return {
                    data: null,
                    error: error,
                    response: error instanceof (0, $1oqCS.FunctionsHttpError) || error instanceof (0, $1oqCS.FunctionsRelayError) ? error.context : undefined
                };
            } finally{
                // Clear the timeout if it was set
                if (timeoutId) clearTimeout(timeoutId);
            }
        });
    }
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("ffULL", function(module, exports) {

$parcel$export(module.exports, "resolveFetch", () => $b1b44af3c77a62f9$export$98d92b1aa79f8cc7);
const $b1b44af3c77a62f9$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};

});


parcelRegister("4yorG", function(module, exports) {

$parcel$export(module.exports, "PostgrestError", () => $cfc0ca97c19fecec$export$445b7e3a323f992f);
$parcel$export(module.exports, "PostgrestClient", () => $cfc0ca97c19fecec$export$796f32e2ee984aaa);
//#region src/PostgrestError.ts
/**
* Error format
*
* {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
*/ var $cfc0ca97c19fecec$export$445b7e3a323f992f = class extends Error {
    /**
	* @example
	* ```ts
	* import PostgrestError from '@supabase/postgrest-js'
	*
	* throw new PostgrestError({
	*   message: 'Row level security prevented the request',
	*   details: 'RLS denied the insert',
	*   hint: 'Check your policies',
	*   code: 'PGRST301',
	* })
	* ```
	*/ constructor(context){
        super(context.message);
        this.name = "PostgrestError";
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
};
//#endregion
//#region src/PostgrestBuilder.ts
var $cfc0ca97c19fecec$export$3106e21688a06353 = class {
    /**
	* Creates a builder configured for a specific PostgREST request.
	*
	* @example
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const builder = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: new Headers({ apikey: 'public-anon-key' }) }
	* )
	* ```
	*
	* @category Database
	*
	* @example Example 1
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const builder = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: new Headers({ apikey: 'public-anon-key' }) }
	* )
	* ```
	*/ constructor(builder){
        var _builder$shouldThrowO, _builder$isMaybeSingl, _builder$urlLengthLim;
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = new Headers(builder.headers);
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = (_builder$shouldThrowO = builder.shouldThrowOnError) !== null && _builder$shouldThrowO !== void 0 ? _builder$shouldThrowO : false;
        this.signal = builder.signal;
        this.isMaybeSingle = (_builder$isMaybeSingl = builder.isMaybeSingle) !== null && _builder$isMaybeSingl !== void 0 ? _builder$isMaybeSingl : false;
        this.urlLengthLimit = (_builder$urlLengthLim = builder.urlLengthLimit) !== null && _builder$urlLengthLim !== void 0 ? _builder$urlLengthLim : 8e3;
        if (builder.fetch) this.fetch = builder.fetch;
        else this.fetch = fetch;
    }
    /**
	* If there's an error with the query, throwOnError will reject the promise by
	* throwing the error instead of returning it as part of a successful response.
	*
	* {@link https://github.com/supabase/supabase-js/issues/92}
	*
	* @category Database
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	*
	* @category Database
	*/ setHeader(name, value) {
        this.headers = new Headers(this.headers);
        this.headers.set(name, value);
        return this;
    }
    /**  *
	* @category Database
	*/ then(onfulfilled, onrejected) {
        var _this = this;
        if (this.schema === void 0) ;
        else if ([
            "GET",
            "HEAD"
        ].includes(this.method)) this.headers.set("Accept-Profile", this.schema);
        else this.headers.set("Content-Profile", this.schema);
        if (this.method !== "GET" && this.method !== "HEAD") this.headers.set("Content-Type", "application/json");
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res$1)=>{
            let error = null;
            let data = null;
            let count = null;
            let status = res$1.status;
            let statusText = res$1.statusText;
            if (res$1.ok) {
                var _this$headers$get2, _res$headers$get;
                if (_this.method !== "HEAD") {
                    var _this$headers$get;
                    const body = await res$1.text();
                    if (body === "") ;
                    else if (_this.headers.get("Accept") === "text/csv") data = body;
                    else if (_this.headers.get("Accept") && ((_this$headers$get = _this.headers.get("Accept")) === null || _this$headers$get === void 0 ? void 0 : _this$headers$get.includes("application/vnd.pgrst.plan+text"))) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_this$headers$get2 = _this.headers.get("Prefer")) === null || _this$headers$get2 === void 0 ? void 0 : _this$headers$get2.match(/count=(exact|planned|estimated)/);
                const contentRange = (_res$headers$get = res$1.headers.get("content-range")) === null || _res$headers$get === void 0 ? void 0 : _res$headers$get.split("/");
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                if (_this.isMaybeSingle && _this.method === "GET" && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            code: "PGRST116",
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: "JSON object requested, multiple (or no) rows returned"
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = "Not Acceptable";
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                var _error$details;
                const body = await res$1.text();
                try {
                    error = JSON.parse(body);
                    if (Array.isArray(error) && res$1.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = "OK";
                    }
                } catch (_unused) {
                    if (res$1.status === 404 && body === "") {
                        status = 204;
                        statusText = "No Content";
                    } else error = {
                        message: body
                    };
                }
                if (error && _this.isMaybeSingle && (error === null || error === void 0 || (_error$details = error.details) === null || _error$details === void 0 ? void 0 : _error$details.includes("0 rows"))) {
                    error = null;
                    status = 200;
                    statusText = "OK";
                }
                if (error && _this.shouldThrowOnError) throw new $cfc0ca97c19fecec$export$445b7e3a323f992f(error);
            }
            return {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _fetchError$name2;
            let errorDetails = "";
            let hint = "";
            let code = "";
            const cause = fetchError === null || fetchError === void 0 ? void 0 : fetchError.cause;
            if (cause) {
                var _cause$message, _cause$code, _fetchError$name, _cause$name;
                const causeMessage = (_cause$message = cause === null || cause === void 0 ? void 0 : cause.message) !== null && _cause$message !== void 0 ? _cause$message : "";
                const causeCode = (_cause$code = cause === null || cause === void 0 ? void 0 : cause.code) !== null && _cause$code !== void 0 ? _cause$code : "";
                errorDetails = `${(_fetchError$name = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name !== void 0 ? _fetchError$name : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`;
                errorDetails += `\n\nCaused by: ${(_cause$name = cause === null || cause === void 0 ? void 0 : cause.name) !== null && _cause$name !== void 0 ? _cause$name : "Error"}: ${causeMessage}`;
                if (causeCode) errorDetails += ` (${causeCode})`;
                if (cause === null || cause === void 0 ? void 0 : cause.stack) errorDetails += `\n${cause.stack}`;
            } else {
                var _fetchError$stack;
                errorDetails = (_fetchError$stack = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _fetchError$stack !== void 0 ? _fetchError$stack : "";
            }
            const urlLength = this.url.toString().length;
            if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR") {
                code = "";
                hint = "Request was aborted (timeout or manual cancellation)";
                if (urlLength > this.urlLengthLimit) hint += `. Note: Your request URL is ${urlLength} characters, which may exceed server limits. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [many IDs])), consider using an RPC function to pass values server-side.`;
            } else if ((cause === null || cause === void 0 ? void 0 : cause.name) === "HeadersOverflowError" || (cause === null || cause === void 0 ? void 0 : cause.code) === "UND_ERR_HEADERS_OVERFLOW") {
                code = "";
                hint = "HTTP headers exceeded server limits (typically 16KB)";
                if (urlLength > this.urlLengthLimit) hint += `. Your request URL is ${urlLength} characters. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [200+ IDs])), consider using an RPC function instead.`;
            }
            return {
                error: {
                    message: `${(_fetchError$name2 = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name2 !== void 0 ? _fetchError$name2 : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: errorDetails,
                    hint: hint,
                    code: code
                },
                data: null,
                count: null,
                status: 0,
                statusText: ""
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	*/ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
	* Override the type of the returned `data` field in the response.
	*
	* @typeParam NewResult - The new type to cast the response data to
	* @typeParam Options - Optional type configuration (defaults to { merge: true })
	* @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
	* @example
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	* @returns A PostgrestBuilder instance with the new type
	*
	* @category Database
	*
	* @example Complete Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<MyType>, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of successful response
	* ```ts
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Complete Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<MyType, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of object response
	* ```ts
	* let x: typeof data // MyType | null
	* ```
	*
	* @example Partial Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<{ status: "A" | "B" }>>()
	* ```
	*
	* @exampleResponse Partial Override type of successful response
	* ```ts
	* let x: typeof data // Array<CountryRowProperties & { status: "A" | "B" }>
	* ```
	*
	* @example Partial Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<{ status: "A" | "B" }>()
	* ```
	*
	* @exampleResponse Partial Override type of object response
	* ```ts
	* let x: typeof data // CountryRowProperties & { status: "A" | "B" } | null
	* ```
	*
	* @example Example 5
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	*/ overrideTypes() {
        return this;
    }
};
//#endregion
//#region src/PostgrestTransformBuilder.ts
var $cfc0ca97c19fecec$export$7b4361bb87e3030c = class extends $cfc0ca97c19fecec$export$3106e21688a06353 {
    /**
	* Perform a SELECT on the query result.
	*
	* By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
	* return modified rows. By calling this method, modified rows are returned in
	* `data`.
	*
	* @param columns - The columns to retrieve, separated by commas
	*
	* @category Database
	*
	* @example With `upsert()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .upsert({ id: 1, name: 'Han Solo' })
	*   .select()
	* ```
	*
	* @exampleSql With `upsert()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Han');
	* ```
	*
	* @exampleResponse With `upsert()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Han Solo"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*/ select(columns) {
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        this.headers.append("Prefer", "return=representation");
        return this;
    }
    /**
	* Order the query result by `column`.
	*
	* You can call this method multiple times to order by multiple columns.
	*
	* You can order referenced tables, but it only affects the ordering of the
	* parent table if you use `!inner` in the query.
	*
	* @param column - The column to order by
	* @param options - Named parameters
	* @param options.ascending - If `true`, the result will be in ascending order
	* @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
	* `null`s appear last.
	* @param options.referencedTable - Set this to order a referenced table by
	* its columns
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('id, name')
	*   .order('id', { ascending: false })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On a referenced table
	* Ordering with `referencedTable` doesn't affect the ordering of the
	* parent table.
	*
	* @example On a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('orchestral_sections')
	*     .select(`
	*       name,
	*       instruments (
	*         name
	*       )
	*     `)
	*     .order('name', { referencedTable: 'instruments', ascending: false })
	*
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         },
	*         {
	*           "name": "harp"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": []
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Order parent table by a referenced table
	* Ordering with `referenced_table(col)` affects the ordering of the
	* parent table.
	*
	* @example Order parent table by a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('instruments')
	*     .select(`
	*       name,
	*       section:orchestral_sections (
	*         name
	*       )
	*     `)
	*     .order('section(name)', { ascending: true })
	*
	* ```
	*
	* @exampleSql Order parent table by a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Order parent table by a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "violin",
	*       "orchestral_sections": {"name": "strings"}
	*     },
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : "order";
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ""}${column}.${ascending ? "asc" : "desc"}${nullsFirst === void 0 ? "" : nullsFirst ? ".nullsfirst" : ".nullslast"}`);
        return this;
    }
    /**
	* Limit the query result by `count`.
	*
	* @param count - The maximum number of rows to return
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	*   .limit(1, { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
	* Limit the query result by starting at an offset `from` and ending at the offset `to`.
	* Only records within this range are returned.
	* This respects the query order and if there is no order clause the range could behave unexpectedly.
	* The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
	* and fourth rows of the query.
	*
	* @param from - The starting index from which to limit the result
	* @param to - The last index to which to limit the result
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .range(0, 1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     },
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === "undefined" ? "offset" : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
	* Set the AbortSignal for the fetch request.
	*
	* @param signal - The AbortSignal to use for the fetch request
	*
	* @category Database
	*
	* @remarks
	* You can use this to set a timeout for the request.
	*
	* @exampleDescription Aborting requests in-flight
	* You can use an [`AbortController`](https://developer.mozilla.org/en-US/docs/Web/API/AbortController) to abort requests.
	* Note that `status` and `statusText` don't mean anything for aborted requests as the request wasn't fulfilled.
	*
	* @example Aborting requests in-flight
	* ```ts
	* const ac = new AbortController()
	*
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(ac.signal)
	*
	* // Abort the request after 100 ms
	* setTimeout(() => ac.abort(), 100)
	* ```
	*
	* @exampleResponse Aborting requests in-flight
	* ```json
	*   {
	*     "error": {
	*       "message": "AbortError: The user aborted a request.",
	*       "details": "",
	*       "hint": "The request was aborted locally via the provided AbortSignal.",
	*       "code": ""
	*     },
	*     "status": 0,
	*     "statusText": ""
	*   }
	*
	* ```
	*
	* @example Set a timeout
	* ```ts
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(AbortSignal.timeout(1000 /* ms *\/))
	* ```
	*
	* @exampleResponse Set a timeout
	* ```json
	*   {
	*     "error": {
	*       "message": "FetchError: The user aborted a request.",
	*       "details": "",
	*       "hint": "",
	*       "code": ""
	*     },
	*     "status": 400,
	*     "statusText": "Bad Request"
	*   }
	*
	* ```
	*/ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be one row (e.g. using `.limit(1)`), otherwise this
	* returns an error.
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	*   .single()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": {
	*     "name": "Luke"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ single() {
        this.headers.set("Accept", "application/vnd.pgrst.object+json");
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
	* this returns an error.
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Katniss')
	*   .maybeSingle()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ maybeSingle() {
        if (this.method === "GET") this.headers.set("Accept", "application/json");
        else this.headers.set("Accept", "application/vnd.pgrst.object+json");
        this.isMaybeSingle = true;
        return this;
    }
    /**
	* Return `data` as a string in CSV format.
	*
	* @category Database
	*
	* @exampleDescription Return data as CSV
	* By default, the data is returned in JSON format, but can also be returned as Comma Separated Values.
	*
	* @example Return data as CSV
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .csv()
	* ```
	*
	* @exampleSql Return data as CSV
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Return data as CSV
	* ```json
	* {
	*   "data": "id,name\n1,Luke\n2,Leia\n3,Han",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ csv() {
        this.headers.set("Accept", "text/csv");
        return this;
    }
    /**
	* Return `data` as an object in [GeoJSON](https://geojson.org) format.
	*
	* @category Database
	*/ geojson() {
        this.headers.set("Accept", "application/geo+json");
        return this;
    }
    /**
	* Return `data` as the EXPLAIN plan for the query.
	*
	* You need to enable the
	* [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
	* setting before using this method.
	*
	* @param options - Named parameters
	*
	* @param options.analyze - If `true`, the query will be executed and the
	* actual run time will be returned
	*
	* @param options.verbose - If `true`, the query identifier will be returned
	* and `data` will include the output columns of the query
	*
	* @param options.settings - If `true`, include information on configuration
	* parameters that affect query planning
	*
	* @param options.buffers - If `true`, include information on buffer usage
	*
	* @param options.wal - If `true`, include information on WAL record generation
	*
	* @param options.format - The format of the output, can be `"text"` (default)
	* or `"json"`
	*
	* @category Database
	*
	* @exampleDescription Get the execution plan
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain()
	* ```
	*
	* @exampleSql Get the execution plan
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40)
	*         ->  Seq Scan on characters  (cost=0.00..22.00 rows=1200 width=40)
	* ```
	*
	* @exampleDescription Get the execution plan with analyze and verbose
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan with analyze and verbose
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain({analyze:true,verbose:true})
	* ```
	*
	* @exampleSql Get the execution plan with analyze and verbose
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan with analyze and verbose
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112) (actual time=0.041..0.041 rows=1 loops=1)
	*   Output: NULL::bigint, count(ROW(characters.id, characters.name)), COALESCE(json_agg(ROW(characters.id, characters.name)), '[]'::json), NULLIF(current_setting('response.headers'::text, true), ''::text), NULLIF(current_setting('response.status'::text, true), ''::text)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40) (actual time=0.005..0.006 rows=3 loops=1)
	*         Output: characters.id, characters.name
	*         ->  Seq Scan on public.characters  (cost=0.00..22.00 rows=1200 width=40) (actual time=0.004..0.005 rows=3 loops=1)
	*               Output: characters.id, characters.name
	* Query Identifier: -4730654291623321173
	* Planning Time: 0.407 ms
	* Execution Time: 0.119 ms
	* ```
	*/ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = "text" } = {}) {
        var _this$headers$get;
        const options = [
            analyze ? "analyze" : null,
            verbose ? "verbose" : null,
            settings ? "settings" : null,
            buffers ? "buffers" : null,
            wal ? "wal" : null
        ].filter(Boolean).join("|");
        const forMediatype = (_this$headers$get = this.headers.get("Accept")) !== null && _this$headers$get !== void 0 ? _this$headers$get : "application/json";
        this.headers.set("Accept", `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`);
        if (format === "json") return this;
        else return this;
    }
    /**
	* Rollback the query.
	*
	* `data` will still be returned, but the query is not committed.
	*
	* @category Database
	*/ rollback() {
        this.headers.append("Prefer", "tx=rollback");
        return this;
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	*
	* @remarks
	* - Deprecated: use overrideTypes method instead
	*
	* @example Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .returns<Array<MyType>>()
	* ```
	*
	* @exampleResponse Override type of successful response
	* ```js
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .returns<MyType>()
	* ```
	*
	* @exampleResponse Override type of object response
	* ```js
	* let x: typeof data // MyType | null
	* ```
	*/ returns() {
        return this;
    }
    /**
	* Set the maximum number of rows that can be affected by the query.
	* Only available in PostgREST v13+ and only works with PATCH and DELETE methods.
	*
	* @param value - The maximum number of rows that can be affected
	*
	* @category Database
	*/ maxAffected(value) {
        this.headers.append("Prefer", "handling=strict");
        this.headers.append("Prefer", `max-affected=${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestFilterBuilder.ts
const $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp = /* @__PURE__ */ new RegExp("[,()]");
var $cfc0ca97c19fecec$export$3158317c13bdc93a = class extends $cfc0ca97c19fecec$export$7b4361bb87e3030c {
    /**
	* Match only rows where `column` is equal to `value`.
	*
	* To check if the value of `column` is NULL, you should use `.is()` instead.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is not equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .neq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is greater than `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* When using [reserved words](https://www.postgresql.org/docs/current/sql-keywords-appendix.html) for column names you need
	* to add double quotes e.g. `.gt('"order"', 2)`
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .gt('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is greater than or equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .gte('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is less than `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .lt('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is less than or equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .lte('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` matches `pattern` case-sensitively.
	*
	* @param column - The column to filter on
	* @param pattern - The pattern to match with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .like('name', '%Lu%')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches all of `patterns` case-sensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches any of `patterns` case-sensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches `pattern` case-insensitively.
	*
	* @param column - The column to filter on
	* @param pattern - The pattern to match with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .ilike('name', '%lu%')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches all of `patterns` case-insensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches any of `patterns` case-insensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	*/ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches the PostgreSQL regex `pattern`
	* case-sensitively (using the `~` operator).
	*
	* @param column - The column to filter on
	* @param pattern - The PostgreSQL regular expression pattern to match with
	*/ regexMatch(column, pattern) {
        this.url.searchParams.append(column, `match.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches the PostgreSQL regex `pattern`
	* case-insensitively (using the `~*` operator).
	*
	* @param column - The column to filter on
	* @param pattern - The PostgreSQL regular expression pattern to match with
	*/ regexIMatch(column, pattern) {
        this.url.searchParams.append(column, `imatch.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` IS `value`.
	*
	* For non-boolean columns, this is only relevant for checking if the value of
	* `column` is NULL by setting `value` to `null`.
	*
	* For boolean columns, you can also set `value` to `true` or `false` and it
	* will behave the same way as `.eq()`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	*
	* @exampleDescription Checking for nullness, true or false
	* Using the `eq()` filter doesn't work when filtering for `null`.
	*
	* Instead, you need to use `is()`.
	*
	* @example Checking for nullness, true or false
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .is('name', null)
	* ```
	*
	* @exampleSql Checking for nullness, true or false
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse Checking for nullness, true or false
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "null"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` IS DISTINCT FROM `value`.
	*
	* Unlike `.neq()`, this treats `NULL` as a comparable value. Two `NULL` values
	* are considered equal (not distinct), and comparing `NULL` with any non-NULL
	* value returns true (distinct).
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*/ isDistinct(column, value) {
        this.url.searchParams.append(column, `isdistinct.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .in('name', ['Leia', 'Han'])
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
	* Match only rows where `column` is NOT included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*/ notIn(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `not.in.(${cleanedValues})`);
        return this;
    }
    /**
	* Only relevant for jsonb, array, and range columns. Match only rows where
	* `column` contains every element appearing in `value`.
	*
	* @param column - The jsonb, array, or range column to filter on
	* @param value - The jsonb, array, or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('issues')
	*   .select()
	*   .contains('tags', ['is:open', 'priority:low'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   issues (
	*     id int8 primary key,
	*     title text,
	*     tags text[]
	*   );
	*
	* insert into
	*   issues (id, title, tags)
	* values
	*   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
	*   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "title": "Cache invalidation is not working"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .contains('during', '[2000-01-01 13:00, 2000-01-01 13:30)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On `jsonb` columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select('name')
	*   .contains('address', { postcode: 90210 })
	* ```
	*
	* @exampleSql On `jsonb` columns
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
	*   (2, 'Jane', '{}');
	* ```
	*
	* @exampleResponse On `jsonb` columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Michael"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ contains(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cs.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
	* Only relevant for jsonb, array, and range columns. Match only rows where
	* every element appearing in `column` is contained by `value`.
	*
	* @param column - The jsonb, array, or range column to filter on
	* @param value - The jsonb, array, or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('classes')
	*   .select('name')
	*   .containedBy('days', ['monday', 'tuesday', 'wednesday', 'friday'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   classes (
	*     id int8 primary key,
	*     name text,
	*     days text[]
	*   );
	*
	* insert into
	*   classes (id, name, days)
	* values
	*   (1, 'Chemistry', array['monday', 'friday']),
	*   (2, 'History', array['monday', 'wednesday', 'thursday']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Chemistry"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .containedBy('during', '[2000-01-01 00:00, 2000-01-01 23:59)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On `jsonb` columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select('name')
	*   .containedBy('address', {})
	* ```
	*
	* @exampleSql On `jsonb` columns
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
	*   (2, 'Jane', '{}');
	* ```
	*
	* @exampleResponse On `jsonb` columns
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Jane"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ containedBy(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cd.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is greater than any element in `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeGt('during', '[2000-01-02 08:00, 2000-01-02 09:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 2,
	*         "room_name": "Topaz",
	*         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is either contained in `range` or greater than any element in
	* `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeGte('during', '[2000-01-02 08:30, 2000-01-02 09:30)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 2,
	*         "room_name": "Topaz",
	*         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is less than any element in `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeLt('during', '[2000-01-01 15:00, 2000-01-01 16:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is either contained in `range` or less than any element in
	* `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeLte('during', '[2000-01-01 14:00, 2000-01-01 16:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "room_name": "Emerald",
	*         "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where `column` is
	* mutually exclusive to `range` and there can be no element between the two
	* ranges.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeAdjacent('during', '[2000-01-01 12:00, 2000-01-01 13:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
	* Only relevant for array and range columns. Match only rows where
	* `column` and `value` have an element in common.
	*
	* @param column - The array or range column to filter on
	* @param value - The array or range value to filter with
	*
	* @category Database
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('issues')
	*   .select('title')
	*   .overlaps('tags', ['is:closed', 'severity:high'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   issues (
	*     id int8 primary key,
	*     title text,
	*     tags text[]
	*   );
	*
	* insert into
	*   issues (id, title, tags)
	* values
	*   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
	*   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "title": "Cache invalidation is not working"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .overlaps('during', '[2000-01-01 12:45, 2000-01-01 13:15)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ overlaps(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `ov.${value}`);
        else this.url.searchParams.append(column, `ov.{${value.join(",")}}`);
        return this;
    }
    /**
	* Only relevant for text and tsvector columns. Match only rows where
	* `column` matches the query string in `query`.
	*
	* @param column - The text or tsvector column to filter on
	* @param query - The query text to match with
	* @param options - Named parameters
	* @param options.config - The text search configuration to use
	* @param options.type - Change how the `query` text is interpreted
	*
	* @category Database
	*
	* @remarks
	* - For more information, see [Postgres full text search](/docs/guides/database/full-text-search).
	*
	* @example Text search
	* ```ts
	* const result = await supabase
	*   .from("texts")
	*   .select("content")
	*   .textSearch("content", `'eggs' & 'ham'`, {
	*     config: "english",
	*   });
	* ```
	*
	* @exampleSql Text search
	* ```sql
	* create table texts (
	*   id      bigint
	*           primary key
	*           generated always as identity,
	*   content text
	* );
	*
	* insert into texts (content) values
	*     ('Four score and seven years ago'),
	*     ('The road goes ever on and on'),
	*     ('Green eggs and ham')
	* ;
	* ```
	*
	* @exampleResponse Text search
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "Green eggs and ham"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Basic normalization
	* Uses PostgreSQL's `plainto_tsquery` function.
	*
	* @example Basic normalization
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat' & 'cat'`, {
	*     type: 'plain',
	*     config: 'english'
	*   })
	* ```
	*
	* @exampleDescription Full normalization
	* Uses PostgreSQL's `phraseto_tsquery` function.
	*
	* @example Full normalization
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat' & 'cat'`, {
	*     type: 'phrase',
	*     config: 'english'
	*   })
	* ```
	*
	* @exampleDescription Websearch
	* Uses PostgreSQL's `websearch_to_tsquery` function.
	* This function will never raise syntax errors, which makes it possible to use raw user-supplied input for search, and can be used
	* with advanced operators.
	*
	* - `unquoted text`: text not inside quote marks will be converted to terms separated by & operators, as if processed by plainto_tsquery.
	* - `"quoted text"`: text inside quote marks will be converted to terms separated by `<->` operators, as if processed by phraseto_tsquery.
	* - `OR`: the word “or” will be converted to the | operator.
	* - `-`: a dash will be converted to the ! operator.
	*
	* @example Websearch
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat or cat'`, {
	*     type: 'websearch',
	*     config: 'english'
	*   })
	* ```
	*/ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = "";
        if (type === "plain") typePart = "pl";
        else if (type === "phrase") typePart = "ph";
        else if (type === "websearch") typePart = "w";
        const configPart = config === void 0 ? "" : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
	* Match only rows where each column in `query` keys is equal to its
	* associated value. Shorthand for multiple `.eq()`s.
	*
	* @param query - The object to filter with, with column names as keys mapped
	* to their filter values
	*
	* @category Database
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .match({ id: 2, name: 'Leia' })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ match(query) {
        Object.entries(query).filter(([_, value])=>value !== void 0).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
	* Match only rows which doesn't satisfy the filter.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to be negated to filter with, following
	* PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	*
	* @remarks
	* not() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .not('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .not('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .not('name', 'is', null)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "name": "null"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
	* Match only rows which satisfy at least one of the filters.
	*
	* Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure it's properly sanitized.
	*
	* It's currently not possible to do an `.or()` filter across multiple tables.
	*
	* @param filters - The filters to use, following PostgREST syntax
	* @param options - Named parameters
	* @param options.referencedTable - Set this to filter on referenced tables
	* instead of the parent table
	* @param options.foreignTable - Deprecated, use `referencedTable` instead
	*
	* @category Database
	*
	* @remarks
	* or() expects you to use the raw PostgREST syntax for the filter names and values.
	*
	* ```ts
	* .or('id.in.(5,6,7), arraycol.cs.{"a","b"}')  // Use `()` for `in` filter, `{}` for array values and `cs` for `contains()`.
	* .or('id.in.(5,6,7), arraycol.cd.{"a","b"}')  // Use `cd` for `containedBy()`
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.eq.2,name.eq.Han')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     },
	*     {
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` with `and`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.gt.3,and(id.eq.1,name.eq.Luke)')
	* ```
	*
	* @exampleSql Use `or` with `and`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Use `or` with `and`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` on referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .or('section_id.eq.1,name.eq.guzheng', { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql Use `or` on referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Use `or` on referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : "or";
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
	* Match only rows which satisfy the filter. This is an escape hatch - you
	* should use the specific filter methods wherever possible.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to filter with, following PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	*
	* @remarks
	* filter() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .filter('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .filter('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .filter('name', 'in', '("Han","Yoda")')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .filter('instruments.name', 'eq', 'flute')
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*    instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestQueryBuilder.ts
var $cfc0ca97c19fecec$export$a81993b50ca081ad = class {
    /**
	* Creates a query builder scoped to a Postgres table or view.
	*
	* @example
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const query = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: { apikey: 'public-anon-key' } }
	* )
	* ```
	*
	* @category Database
	*
	* @example Example 1
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const query = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: { apikey: 'public-anon-key' } }
	* )
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, urlLengthLimit: urlLengthLimit = 8e3 }){
        this.url = url;
        this.headers = new Headers(headers);
        this.schema = schema;
        this.fetch = fetch$1;
        this.urlLengthLimit = urlLengthLimit;
    }
    /**
	* Clone URL and headers to prevent shared state between operations.
	*/ cloneRequestState() {
        return {
            url: new URL(this.url.toString()),
            headers: new Headers(this.headers)
        };
    }
    /**
	* Perform a SELECT query on the table or view.
	*
	* @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
	*
	* @param options - Named parameters
	*
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	*
	* @param options.count - Count algorithm to use to count rows in the table or view.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @remarks
	* When using `count` with `.range()` or `.limit()`, the returned `count` is the total number of rows
	* that match your filters, not the number of rows in the current page. Use this to build pagination UI.
	
	* - By default, Supabase projects return a maximum of 1,000 rows. This setting can be changed in your project's [API settings](/dashboard/project/_/settings/api). It's recommended that you keep it low to limit the payload size of accidental or malicious requests. You can use `range()` queries to paginate through your data.
	* - `select()` can be combined with [Filters](/docs/reference/javascript/using-filters)
	* - `select()` can be combined with [Modifiers](/docs/reference/javascript/using-modifiers)
	* - `apikey` is a reserved keyword if you're using the [Supabase Platform](/docs/guides/platform) and [should be avoided as a column name](https://github.com/supabase/supabase/issues/5465). *
	* @category Database
	*
	* @example Getting your data
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	* ```
	*
	* @exampleSql Getting your data
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Harry'),
	*   (2, 'Frodo'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Getting your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Harry"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Frodo"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Selecting specific columns
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	* ```
	*
	* @exampleSql Selecting specific columns
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Frodo'),
	*   (2, 'Harry'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Selecting specific columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Frodo"
	*     },
	*     {
	*       "name": "Harry"
	*     },
	*     {
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables
	* If your database has foreign key relationships, you can query related tables too.
	*
	* @example Query referenced tables
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables with spaces in their names
	* If your table name contains spaces, you must use double quotes in the `select` statement to reference the table.
	*
	* @example Query referenced tables with spaces in their names
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral sections')
	*   .select(`
	*     name,
	*     "musical instruments" (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables with spaces in their names
	* ```sql
	* create table
	*   "orchestral sections" (id int8 primary key, name text);
	* create table
	*   "musical instruments" (
	*     id int8 primary key,
	*     section_id int8 not null references "orchestral sections",
	*     name text
	*   );
	*
	* insert into
	*   "orchestral sections" (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   "musical instruments" (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables with spaces in their names
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "musical instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "musical instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables through a join table
	* If you're in a situation where your tables are **NOT** directly
	* related, but instead are joined by a _join table_, you can still use
	* the `select()` method to query the related data. The join table needs
	* to have the foreign keys as part of its composite primary key.
	*
	* @example Query referenced tables through a join table
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     name,
	*     teams (
	*       name
	*     )
	*   `)
	*   
	* ```
	*
	* @exampleSql Query referenced tables through a join table
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*     -- both foreign keys must be part of a composite primary key
	*     primary key (user_id, team_id)
	*   );
	*
	* insert into
	*   users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* ```
	*
	* @exampleResponse Query referenced tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Kiran",
	*         "teams": [
	*           {
	*             "name": "Green"
	*           },
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       },
	*       {
	*         "name": "Evan",
	*         "teams": [
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Query the same referenced table multiple times
	* If you need to query the same referenced table twice, use the name of the
	* joined column to identify which join to use. You can also give each
	* column an alias.
	*
	* @example Query the same referenced table multiple times
	* ```ts
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:sender_id(name),
	*     to:receiver_id(name)
	*   `)
	*
	* // To infer types, use the name of the table (in this case `users`) and
	* // the name of the foreign key constraint.
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:users!messages_sender_id_fkey(name),
	*     to:users!messages_receiver_id_fkey(name)
	*   `)
	* ```
	*
	* @exampleSql Query the same referenced table multiple times
	* ```sql
	*  create table
	*  users (id int8 primary key, name text);
	*
	*  create table
	*    messages (
	*      sender_id int8 not null references users,
	*      receiver_id int8 not null references users,
	*      content text
	*    );
	*
	*  insert into
	*    users (id, name)
	*  values
	*    (1, 'Kiran'),
	*    (2, 'Evan');
	*
	*  insert into
	*    messages (sender_id, receiver_id, content)
	*  values
	*    (1, 2, '👋');
	*  ```
	* ```
	*
	* @exampleResponse Query the same referenced table multiple times
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "👋",
	*       "from": {
	*         "name": "Kiran"
	*       },
	*       "to": {
	*         "name": "Evan"
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query nested foreign tables through a join table
	* You can use the result of a joined table to gather data in
	* another foreign table. With multiple references to the same foreign
	* table you must specify the column on which to conduct the join.
	*
	* @example Query nested foreign tables through a join table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('games')
	*     .select(`
	*       game_id:id,
	*       away_team:teams!games_away_team_fkey (
	*         users (
	*           id,
	*           name
	*         )
	*       )
	*     `)
	*   
	* ```
	*
	* @exampleSql Query nested foreign tables through a join table
	* ```sql
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*
	*     primary key (user_id, team_id)
	*   );
	* create table
	*   games (
	*     id int8 primary key,
	*     home_team int8 not null references teams,
	*     away_team int8 not null references teams,
	*     name text
	*   );
	*
	* insert into users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* insert into
	*   games (id, home_team, away_team, name)
	* values
	*   (1, 1, 2, 'Green vs Blue'),
	*   (2, 2, 1, 'Blue vs Green');
	* ```
	*
	* @exampleResponse Query nested foreign tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "game_id": 1,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             },
	*             {
	*               "id": 2,
	*               "name": "Evan"
	*             }
	*           ]
	*         }
	*       },
	*       {
	*         "game_id": 2,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             }
	*           ]
	*         }
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Filtering through referenced tables
	* If the filter on a referenced table's column is not satisfied, the referenced
	* table returns `[]` or `null` but the parent table is not filtered out.
	* If you want to filter out the parent table rows, use the `!inner` hint
	*
	* @example Filtering through referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections(*)')
	*   .eq('orchestral_sections.name', 'percussion')
	* ```
	*
	* @exampleSql Filtering through referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Filtering through referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": null
	*     },
	*     {
	*       "name": "violin",
	*       "orchestral_sections": null
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with count
	* You can get the number of rows in a related table by using the
	* **count** property.
	*
	* @example Querying referenced table with count
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`*, instruments(count)`)
	* ```
	*
	* @exampleSql Querying referenced table with count
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table characters (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('strings') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('violin', (select id from section)),
	* ('viola', (select id from section)),
	* ('cello', (select id from section)),
	* ('double bass', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with count
	* ```json
	* [
	*   {
	*     "id": "693694e7-d993-4360-a6d7-6294e325d9b6",
	*     "name": "strings",
	*     "instruments": [
	*       {
	*         "count": 4
	*       }
	*     ]
	*   }
	* ]
	* ```
	*
	* @exampleDescription Querying with count option
	* You can get the number of rows by using the
	* [count](/docs/reference/javascript/select#parameters) option.
	*
	* @example Querying with count option
	* ```ts
	* const { count, error } = await supabase
	*   .from('characters')
	*   .select('*', { count: 'exact', head: true })
	* ```
	*
	* @exampleSql Querying with count option
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Querying with count option
	* ```json
	* {
	*   "count": 3,
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying JSON data
	* You can select and filter data inside of
	* [JSON](/docs/guides/database/json) columns. Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* querying JSON data.
	*
	* @example Querying JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     id, name,
	*     address->city
	*   `)
	* ```
	*
	* @exampleSql Querying JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Frodo', '{"city":"Hobbiton"}');
	* ```
	*
	* @exampleResponse Querying JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Frodo",
	*       "city": "Hobbiton"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with inner join
	* If you don't want to return the referenced table contents, you can leave the parenthesis empty.
	* Like `.select('name, orchestral_sections!inner()')`.
	*
	* @example Querying referenced table with inner join
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections!inner(name)')
	*   .eq('orchestral_sections.name', 'woodwinds')
	*   .limit(1)
	* ```
	*
	* @exampleSql Querying referenced table with inner join
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table instruments (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('woodwinds') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('flute', (select id from section)),
	* ('clarinet', (select id from section)),
	* ('bassoon', (select id from section)),
	* ('piccolo', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with inner join
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Switching schemas per query
	* In addition to setting the schema during initialization, you can also switch schemas on a per-query basis.
	* Make sure you've set up your [database privileges and API settings](/docs/guides/api/using-custom-schemas).
	*
	* @example Switching schemas per query
	* ```ts
	* const { data, error } = await supabase
	*   .schema('myschema')
	*   .from('mytable')
	*   .select()
	* ```
	*
	* @exampleSql Switching schemas per query
	* ```sql
	* create schema myschema;
	*
	* create table myschema.mytable (
	*   id uuid primary key default gen_random_uuid(),
	*   data text
	* );
	*
	* insert into myschema.mytable (data) values ('mydata');
	* ```
	*
	* @exampleResponse Switching schemas per query
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": "4162e008-27b0-4c0f-82dc-ccaeee9a624d",
	*       "data": "mydata"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ select(columns, options) {
        const { head: head = false, count: count } = options !== null && options !== void 0 ? options : {};
        const method = head ? "HEAD" : "GET";
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        const { url: url, headers: headers } = this.cloneRequestState();
        url.searchParams.set("select", cleanedColumns);
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform an INSERT into the table or view.
	*
	* By default, inserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to insert. Pass an object to insert a single row
	* or an array to insert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count inserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. Only applies for bulk
	* inserts.
	*
	* @category Database
	*
	* @example Create a record
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	* ```
	*
	* @exampleSql Create a record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record
	* ```json
	* {
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @example Create a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	*   .select()
	* ```
	*
	* @exampleSql Create a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @exampleDescription Bulk create
	* A bulk create operation is handled in a single transaction.
	* If any of the inserts fail, none of the rows are inserted.
	*
	* @example Bulk create
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert([
	*     { id: 1, name: 'Mordor' },
	*     { id: 1, name: 'The Shire' },
	*   ])
	* ```
	*
	* @exampleSql Bulk create
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Bulk create
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (id)=(1) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"countries_pkey\""
	*   },
	*   "status": 409,
	*   "statusText": "Conflict"
	* }
	* ```
	*/ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", `missing=default`);
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform an UPSERT on the table or view. Depending on the column(s) passed
	* to `onConflict`, `.upsert()` allows you to perform the equivalent of
	* `.insert()` if a row with the corresponding `onConflict` columns doesn't
	* exist, or if it does exist, perform an alternative action depending on
	* `ignoreDuplicates`.
	*
	* By default, upserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to upsert with. Pass an object to upsert a
	* single row or an array to upsert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
	* duplicate rows are determined. Two rows are duplicates if all the
	* `onConflict` columns are equal.
	*
	* @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
	* `false`, duplicate rows are merged with existing rows.
	*
	* @param options.count - Count algorithm to use to count upserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. This only applies when
	* inserting new rows, not when merging with existing rows under
	* `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
	*
	* @example Upsert a single row using a unique key
	* ```ts
	* // Upserting a single row, overwriting based on the 'username' unique column
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ username: 'supabot' }, { onConflict: 'username' })
	*
	* // Example response:
	* // {
	* //   data: [
	* //     { id: 4, message: 'bar', username: 'supabot' }
	* //   ],
	* //   error: null
	* // }
	* ```
	*
	* @example Upsert with conflict resolution and exact row counting
	* ```ts
	* // Upserting and returning exact count
	* const { data, error, count } = await supabase
	*   .from('users')
	*   .upsert(
	*     {
	*       id: 3,
	*       message: 'foo',
	*       username: 'supabot'
	*     },
	*     {
	*       onConflict: 'username',
	*       count: 'exact'
	*     }
	*   )
	*
	* // Example response:
	* // {
	* //   data: [
	* //     {
	* //       id: 42,
	* //       handle: "saoirse",
	* //       display_name: "Saoirse"
	* //     }
	* //   ],
	* //   count: 1,
	* //   error: null
	* // }
	* ```
	*
	* @category Database
	*
	* @remarks
	* - Primary keys must be included in `values` to use upsert.
	*
	* @example Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert({ id: 1, name: 'piano' })
	*   .select()
	* ```
	*
	* @exampleSql Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @example Bulk Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert([
	*     { id: 1, name: 'piano' },
	*     { id: 2, name: 'harp' },
	*   ])
	*   .select()
	* ```
	*
	* @exampleSql Bulk Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Bulk Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     },
	*     {
	*       "id": 2,
	*       "name": "harp"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @exampleDescription Upserting into tables with constraints
	* In the following query, `upsert()` implicitly uses the `id`
	* (primary key) column to determine conflicts. If there is no existing
	* row with the same `id`, `upsert()` inserts a new row, which
	* will fail in this case as there is already a row with `handle` `"saoirse"`.
	* Using the `onConflict` option, you can instruct `upsert()` to use
	* another column with a unique constraint to determine conflicts.
	*
	* @example Upserting into tables with constraints
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ id: 42, handle: 'saoirse', display_name: 'Saoirse' })
	*   .select()
	* ```
	*
	* @exampleSql Upserting into tables with constraints
	* ```sql
	* create table
	*   users (
	*     id int8 generated by default as identity primary key,
	*     handle text not null unique,
	*     display_name text
	*   );
	*
	* insert into
	*   users (id, handle, display_name)
	* values
	*   (1, 'saoirse', null);
	* ```
	*
	* @exampleResponse Upserting into tables with constraints
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (handle)=(saoirse) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"users_handle_key\""
	*   },
	*   "status": 409,
	*   "statusText": "Conflict"
	* }
	* ```
	*/ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch2;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        headers.append("Prefer", `resolution=${ignoreDuplicates ? "ignore" : "merge"}-duplicates`);
        if (onConflict !== void 0) url.searchParams.set("on_conflict", onConflict);
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", "missing=default");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch2 = this.fetch) !== null && _this$fetch2 !== void 0 ? _this$fetch2 : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform an UPDATE on the table or view.
	*
	* By default, updated rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param values - The values to update with
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count updated rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `update()` should always be combined with [Filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to update.
	*
	* @example Updating your data
	* ```ts
	* const { error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Updating your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Updating your data
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*
	* @example Update a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Update a record and return it
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Update a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Updating JSON data
	* Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* working with JSON data. Currently, it is only possible to update the entire JSON document.
	*
	* @example Updating JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .update({
	*     address: {
	*       street: 'Melrose Place',
	*       postcode: 90210
	*     }
	*   })
	*   .eq('address->postcode', 90210)
	*   .select()
	* ```
	*
	* @exampleSql Updating JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210 }');
	* ```
	*
	* @exampleResponse Updating JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Michael",
	*       "address": {
	*         "street": "Melrose Place",
	*         "postcode": 90210
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ update(values, { count: count } = {}) {
        var _this$fetch3;
        const method = "PATCH";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch3 = this.fetch) !== null && _this$fetch3 !== void 0 ? _this$fetch3 : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform a DELETE on the table or view.
	*
	* By default, deleted rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count deleted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `delete()` should always be combined with [filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to delete.
	* - If you use `delete()` with filters and you have
	*   [RLS](/docs/learn/auth-deep-dive/auth-row-level-security) enabled, only
	*   rows visible through `SELECT` policies are deleted. Note that by default
	*   no rows are visible, so you need at least one `SELECT`/`ALL` policy that
	*   makes the rows visible.
	* - When using `delete().in()`, specify an array of values to target multiple rows with a single query. This is particularly useful for batch deleting entries that share common criteria, such as deleting users by their IDs. Ensure that the array you provide accurately represents all records you intend to delete to avoid unintended data removal.
	*
	* @example Delete a single record
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Delete a single record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a single record
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*
	* @example Delete a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Delete a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Delete multiple records
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .in('id', [1, 2, 3])
	* ```
	*
	* @exampleSql Delete multiple records
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'), (2, 'The Shire'), (3, 'Mordor');
	* ```
	*
	* @exampleResponse Delete multiple records
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*/ delete({ count: count } = {}) {
        var _this$fetch4;
        const method = "DELETE";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: (_this$fetch4 = this.fetch) !== null && _this$fetch4 !== void 0 ? _this$fetch4 : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $cfc0ca97c19fecec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cfc0ca97c19fecec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $cfc0ca97c19fecec$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $cfc0ca97c19fecec$var$toPrimitive(t, r) {
    if ("object" != $cfc0ca97c19fecec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cfc0ca97c19fecec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $cfc0ca97c19fecec$var$toPropertyKey(t) {
    var i = $cfc0ca97c19fecec$var$toPrimitive(t, "string");
    return "symbol" == $cfc0ca97c19fecec$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $cfc0ca97c19fecec$var$_defineProperty(e, r, t) {
    return (r = $cfc0ca97c19fecec$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $cfc0ca97c19fecec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cfc0ca97c19fecec$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cfc0ca97c19fecec$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $cfc0ca97c19fecec$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cfc0ca97c19fecec$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/PostgrestClient.ts
/**
* PostgREST client.
*
* @typeParam Database - Types for the schema from the [type
* generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
*
* @typeParam SchemaName - Postgres schema to switch to. Must be a string
* literal, the same one passed to the constructor. If the schema is not
* `"public"`, this must be supplied manually.
*/ var $cfc0ca97c19fecec$export$796f32e2ee984aaa = class PostgrestClient {
    /**
	* Creates a PostgREST client.
	*
	* @param url - URL of the PostgREST endpoint
	* @param options - Named parameters
	* @param options.headers - Custom headers
	* @param options.schema - Postgres schema to switch to
	* @param options.fetch - Custom fetch
	* @param options.timeout - Optional timeout in milliseconds for all requests. When set, requests will automatically abort after this duration to prevent indefinite hangs.
	* @param options.urlLengthLimit - Maximum URL length in characters before warnings/errors are triggered. Defaults to 8000.
	* @example
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'public-anon-key' },
	*   schema: 'public',
	*   timeout: 30000, // 30 second timeout
	* })
	* ```
	*
	* @category Database
	*
	* @remarks
	* - A `timeout` option (in milliseconds) can be set to automatically abort requests that take too long.
	* - A `urlLengthLimit` option (default: 8000) can be set to control when URL length warnings are included in error messages for aborted requests.
	*
	* @example Example 1
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'public-anon-key' },
	*   schema: 'public',
	* })
	* ```
	*
	* @example With timeout
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'public-anon-key' },
	*   schema: 'public',
	*   timeout: 30000, // 30 second timeout
	* })
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, timeout: timeout, urlLengthLimit: urlLengthLimit = 8e3 } = {}){
        this.url = url;
        this.headers = new Headers(headers);
        this.schemaName = schema;
        this.urlLengthLimit = urlLengthLimit;
        const originalFetch = fetch$1 !== null && fetch$1 !== void 0 ? fetch$1 : globalThis.fetch;
        if (timeout !== void 0 && timeout > 0) this.fetch = (input, init)=>{
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), timeout);
            const existingSignal = init === null || init === void 0 ? void 0 : init.signal;
            if (existingSignal) {
                if (existingSignal.aborted) {
                    clearTimeout(timeoutId);
                    return originalFetch(input, init);
                }
                const abortHandler = ()=>{
                    clearTimeout(timeoutId);
                    controller.abort();
                };
                existingSignal.addEventListener("abort", abortHandler, {
                    once: true
                });
                return originalFetch(input, $cfc0ca97c19fecec$var$_objectSpread2($cfc0ca97c19fecec$var$_objectSpread2({}, init), {}, {
                    signal: controller.signal
                })).finally(()=>{
                    clearTimeout(timeoutId);
                    existingSignal.removeEventListener("abort", abortHandler);
                });
            }
            return originalFetch(input, $cfc0ca97c19fecec$var$_objectSpread2($cfc0ca97c19fecec$var$_objectSpread2({}, init), {}, {
                signal: controller.signal
            })).finally(()=>clearTimeout(timeoutId));
        };
        else this.fetch = originalFetch;
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*
	* @category Database
	*/ from(relation) {
        if (!relation || typeof relation !== "string" || relation.trim() === "") throw new Error("Invalid relation name: relation must be a non-empty string.");
        return new $cfc0ca97c19fecec$export$a81993b50ca081ad(new URL(`${this.url}/${relation}`), {
            headers: new Headers(this.headers),
            schema: this.schemaName,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*
	* @category Database
	*/ schema(schema) {
        return new PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @example
	* ```ts
	* // For cross-schema functions where type inference fails, use overrideTypes:
	* const { data } = await supabase
	*   .schema('schema_b')
	*   .rpc('function_a', {})
	*   .overrideTypes<{ id: string; user_id: string }[]>()
	* ```
	*
	* @category Database
	*
	* @example Call a Postgres function without arguments
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world')
	* ```
	*
	* @exampleSql Call a Postgres function without arguments
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function without arguments
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a Postgres function with arguments
	* ```ts
	* const { data, error } = await supabase.rpc('echo', { say: '👋' })
	* ```
	*
	* @exampleSql Call a Postgres function with arguments
	* ```sql
	* create function echo(say text) returns text as $$
	*   select say;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with arguments
	* ```json
	*   {
	*     "data": "👋",
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*
	* @exampleDescription Bulk processing
	* You can process large payloads by passing in an array as an argument.
	*
	* @example Bulk processing
	* ```ts
	* const { data, error } = await supabase.rpc('add_one_each', { arr: [1, 2, 3] })
	* ```
	*
	* @exampleSql Bulk processing
	* ```sql
	* create function add_one_each(arr int[]) returns int[] as $$
	*   select array_agg(n + 1) from unnest(arr) as n;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Bulk processing
	* ```json
	* {
	*   "data": [
	*     2,
	*     3,
	*     4
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Call a Postgres function with filters
	* Postgres functions that return tables can also be combined with [Filters](/docs/reference/javascript/using-filters) and [Modifiers](/docs/reference/javascript/using-modifiers).
	*
	* @example Call a Postgres function with filters
	* ```ts
	* const { data, error } = await supabase
	*   .rpc('list_stored_countries')
	*   .eq('id', 1)
	*   .single()
	* ```
	*
	* @exampleSql Call a Postgres function with filters
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'),
	*   (2, 'The Shire');
	*
	* create function list_stored_countries() returns setof countries as $$
	*   select * from countries;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with filters
	* ```json
	* {
	*   "data": {
	*     "id": 1,
	*     "name": "Rohan"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a read-only Postgres function
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world', undefined, { get: true })
	* ```
	*
	* @exampleSql Call a read-only Postgres function
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a read-only Postgres function
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        var _this$fetch;
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        const _isObject = (v)=>v !== null && typeof v === "object" && (!Array.isArray(v) || v.some(_isObject));
        const _hasObjectArg = head && Object.values(args).some(_isObject);
        if (_hasObjectArg) {
            method = "POST";
            body = args;
        } else if (head || get) {
            method = head ? "HEAD" : "GET";
            Object.entries(args).filter(([_, value])=>value !== void 0).map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(",")}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = "POST";
            body = args;
        }
        const headers = new Headers(this.headers);
        if (_hasObjectArg) headers.set("Prefer", count ? `count=${count},return=minimal` : "return=minimal");
        else if (count) headers.set("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit
        });
    }
};
//#endregion
//#region src/index.ts
var $cfc0ca97c19fecec$export$2e2bcd8739ae039 = {
    PostgrestClient: $cfc0ca97c19fecec$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $cfc0ca97c19fecec$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $cfc0ca97c19fecec$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $cfc0ca97c19fecec$export$7b4361bb87e3030c,
    PostgrestBuilder: $cfc0ca97c19fecec$export$3106e21688a06353,
    PostgrestError: $cfc0ca97c19fecec$export$445b7e3a323f992f
};

});

parcelRegister("izHZ4", function(module, exports) {

$parcel$export(module.exports, "RealtimePresence", () => (parcelRequire("6zp63")).default);
$parcel$export(module.exports, "RealtimeChannel", () => (parcelRequire("IhlL5")).default);
$parcel$export(module.exports, "RealtimeClient", () => (parcelRequire("eWiay")).default);
$parcel$export(module.exports, "REALTIME_LISTEN_TYPES", () => (parcelRequire("IhlL5")).REALTIME_LISTEN_TYPES);
$parcel$export(module.exports, "REALTIME_POSTGRES_CHANGES_LISTEN_EVENT", () => (parcelRequire("IhlL5")).REALTIME_POSTGRES_CHANGES_LISTEN_EVENT);
$parcel$export(module.exports, "REALTIME_PRESENCE_LISTEN_EVENTS", () => (parcelRequire("6zp63")).REALTIME_PRESENCE_LISTEN_EVENTS);
$parcel$export(module.exports, "REALTIME_SUBSCRIBE_STATES", () => (parcelRequire("IhlL5")).REALTIME_SUBSCRIBE_STATES);
$parcel$export(module.exports, "REALTIME_CHANNEL_STATES", () => (parcelRequire("IhlL5")).REALTIME_CHANNEL_STATES);
$parcel$export(module.exports, "WebSocketFactory", () => (parcelRequire("hnThW")).default);

var $eWiay = parcelRequire("eWiay");

var $IhlL5 = parcelRequire("IhlL5");

var $6zp63 = parcelRequire("6zp63");

var $hnThW = parcelRequire("hnThW");

});
parcelRegister("eWiay", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae049384a7d1c7c8$export$2e2bcd8739ae039);

var $hnThW = parcelRequire("hnThW");

var $5gqEk = parcelRequire("5gqEk");

var $8VIf2 = parcelRequire("8VIf2");

var $6TKMA = parcelRequire("6TKMA");

var $5po7o = parcelRequire("5po7o");

var $IhlL5 = parcelRequire("IhlL5");
const $ae049384a7d1c7c8$var$noop = ()=>{};
// Connection-related constants
const $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS = {
    HEARTBEAT_INTERVAL: 25000,
    RECONNECT_DELAY: 10,
    HEARTBEAT_TIMEOUT_FALLBACK: 100
};
const $ae049384a7d1c7c8$var$RECONNECT_INTERVALS = [
    1000,
    2000,
    5000,
    10000
];
const $ae049384a7d1c7c8$var$DEFAULT_RECONNECT_FALLBACK = 10000;
const $ae049384a7d1c7c8$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;
class $ae049384a7d1c7c8$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers Deprecated: headers cannot be set on websocket connections and this option will be removed in the future.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.heartbeatCallback The optional function to handle heartbeat status and latency.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.logLevel Sets the log level for Realtime
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     * @param options.vsn The protocol version to use when connecting. Supported versions are "1.0.0" and "2.0.0". Defaults to "2.0.0".
     * @example
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'public-anon-key' },
     * })
     * client.connect()
     * ```
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this._manuallySetToken = false;
        this.channels = new Array();
        this.endPoint = '';
        this.httpEndpoint = '';
        /** @deprecated headers cannot be set on websocket connections */ this.headers = {};
        this.params = {};
        this.timeout = (0, $5gqEk.DEFAULT_TIMEOUT);
        this.transport = null;
        this.heartbeatIntervalMs = $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.heartbeatCallback = $ae049384a7d1c7c8$var$noop;
        this.ref = 0;
        this.reconnectTimer = null;
        this.vsn = (0, $5gqEk.DEFAULT_VSN);
        this.logger = $ae049384a7d1c7c8$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $8VIf2.default)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        this._connectionState = 'disconnected';
        this._wasManualDisconnect = false;
        this._authPromise = null;
        this._heartbeatSentAt = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            if (customFetch) return (...args)=>customFetch(...args);
            return (...args)=>fetch(...args);
        };
        // Validate required parameters
        if (!((_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey)) throw new Error('API key is required to connect to Realtime');
        this.apiKey = options.params.apikey;
        // Initialize endpoint URLs
        this.endPoint = `${endPoint}/${(0, $5gqEk.TRANSPORTS).websocket}`;
        this.httpEndpoint = (0, $5po7o.httpEndpointURL)(endPoint);
        this._initializeOptions(options);
        this._setupReconnectionTimer();
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        // Skip if already connecting, disconnecting, or connected
        if (this.isConnecting() || this.isDisconnecting() || this.conn !== null && this.isConnected()) return;
        this._setConnectionState('connecting');
        // Trigger auth if needed and not already in progress
        // This ensures auth is called for standalone RealtimeClient usage
        // while avoiding race conditions with SupabaseClient's immediate setAuth call
        if (this.accessToken && !this._authPromise) this._setAuthSafely('connect');
        // Establish WebSocket connection
        if (this.transport) // Use custom transport if provided
        this.conn = new this.transport(this.endpointURL());
        else // Try to use native WebSocket
        try {
            this.conn = (0, $hnThW.default).createWebSocket(this.endpointURL());
        } catch (error) {
            this._setConnectionState('disconnected');
            const errorMessage = error.message;
            // Provide helpful error message based on environment
            if (errorMessage.includes('Node.js')) throw new Error(`${errorMessage}\n\n` + 'To use Realtime in Node.js, you need to provide a WebSocket implementation:\n\n' + 'Option 1: Use Node.js 22+ which has native WebSocket support\n' + 'Option 2: Install and provide the "ws" package:\n\n' + '  npm install ws\n\n' + '  import ws from "ws"\n' + '  const client = new RealtimeClient(url, {\n' + '    ...options,\n' + '    transport: ws\n' + '  })');
            throw new Error(`WebSocket not available: ${errorMessage}`);
        }
        this._setupConnectionHandlers();
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: this.vsn
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.isDisconnecting()) return;
        this._setConnectionState('disconnecting', true);
        if (this.conn) {
            // Setup fallback timer to prevent hanging in disconnecting state
            const fallbackTimer = setTimeout(()=>{
                this._setConnectionState('disconnected');
            }, 100);
            this.conn.onclose = ()=>{
                clearTimeout(fallbackTimer);
                this._setConnectionState('disconnected');
            };
            // Close the WebSocket connection if close method exists
            if (typeof this.conn.close === 'function') {
                if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
                else this.conn.close();
            }
            this._teardownConnection();
        } else this._setConnectionState('disconnected');
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.channels = [];
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $5gqEk.SOCKET_STATES).connecting:
                return (0, $5gqEk.CONNECTION_STATE).Connecting;
            case (0, $5gqEk.SOCKET_STATES).open:
                return (0, $5gqEk.CONNECTION_STATE).Open;
            case (0, $5gqEk.SOCKET_STATES).closing:
                return (0, $5gqEk.CONNECTION_STATE).Closing;
            default:
                return (0, $5gqEk.CONNECTION_STATE).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $5gqEk.CONNECTION_STATE).Open;
    }
    /**
     * Returns `true` if the connection is currently connecting.
     */ isConnecting() {
        return this._connectionState === 'connecting';
    }
    /**
     * Returns `true` if the connection is currently disconnecting.
     */ isDisconnecting() {
        return this._connectionState === 'disconnecting';
    }
    /**
     * Creates (or reuses) a {@link RealtimeChannel} for the provided topic.
     *
     * Topics are automatically prefixed with `realtime:` to match the Realtime service.
     * If a channel with the same topic already exists it will be returned instead of creating
     * a duplicate connection.
     */ channel(topic, params = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c)=>c.topic === realtimeTopic);
        if (!exists) {
            const chan = new (0, $IhlL5.default)(`realtime:${topic}`, params, this);
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * When a token is explicitly provided, it will be preserved across channel operations
     * (including removeChannel and resubscribe). The `accessToken` callback will not be
     * invoked until `setAuth()` is called without arguments.
     *
     * @param token A JWT string to override the token set on the client.
     *
     * @example
     * // Use a manual token (preserved across resubscribes, ignores accessToken callback)
     * client.realtime.setAuth('my-custom-jwt')
     *
     * // Switch back to using the accessToken callback
     * client.realtime.setAuth()
     */ async setAuth(token = null) {
        this._authPromise = this._performAuth(token);
        try {
            await this._authPromise;
        } finally{
            this._authPromise = null;
        }
    }
    /**
     * Returns true if the current access token was explicitly set via setAuth(token),
     * false if it was obtained via the accessToken callback.
     * @internal
     */ _isManualToken() {
        return this._manuallySetToken;
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) {
            try {
                this.heartbeatCallback('disconnected');
            } catch (e) {
                this.log('error', 'error in heartbeat callback', e);
            }
            return;
        }
        // Handle heartbeat timeout and force reconnection if needed
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this._heartbeatSentAt = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            try {
                this.heartbeatCallback('timeout');
            } catch (e) {
                this.log('error', 'error in heartbeat callback', e);
            }
            // Force reconnection after heartbeat timeout
            this._wasManualDisconnect = false;
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $5gqEk.WS_CLOSE_NORMAL), 'heartbeat timeout');
            setTimeout(()=>{
                var _a;
                if (!this.isConnected()) (_a = this.reconnectTimer) === null || _a === void 0 || _a.scheduleTimeout();
            }, $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS.HEARTBEAT_TIMEOUT_FALLBACK);
            return;
        }
        // Send heartbeat message to server
        this._heartbeatSentAt = Date.now();
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        try {
            this.heartbeatCallback('sent');
        } catch (e) {
            this.log('error', 'error in heartbeat callback', e);
        }
        this._setAuthSafely('heartbeat');
    }
    /**
     * Sets a callback that receives lifecycle events for internal heartbeat messages.
     * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
     */ onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c.topic !== channel.topic);
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            // Handle heartbeat responses
            if (msg.topic === 'phoenix' && msg.event === 'phx_reply' && msg.ref && msg.ref === this.pendingHeartbeatRef) {
                const latency = this._heartbeatSentAt ? Date.now() - this._heartbeatSentAt : undefined;
                try {
                    this.heartbeatCallback(msg.payload.status === 'ok' ? 'ok' : 'error', latency);
                } catch (e) {
                    this.log('error', 'error in heartbeat callback', e);
                }
                this._heartbeatSentAt = null;
                this.pendingHeartbeatRef = null;
            }
            // Log incoming message
            const { topic: topic, event: event, payload: payload, ref: ref } = msg;
            const refString = ref ? `(${ref})` : '';
            const status = payload.status || '';
            this.log('receive', `${status} ${topic} ${event} ${refString}`.trim(), payload);
            // Route message to appropriate channels
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this._triggerStateCallbacks('message', msg);
        });
    }
    /**
     * Clear specific timer
     * @internal
     */ _clearTimer(timer) {
        var _a;
        if (timer === 'heartbeat' && this.heartbeatTimer) {
            clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = undefined;
        } else if (timer === 'reconnect') (_a = this.reconnectTimer) === null || _a === void 0 || _a.reset();
    }
    /**
     * Clear all timers
     * @internal
     */ _clearAllTimers() {
        this._clearTimer('heartbeat');
        this._clearTimer('reconnect');
    }
    /**
     * Setup connection handlers for WebSocket events
     * @internal
     */ _setupConnectionHandlers() {
        if (!this.conn) return;
        // Set binary type if supported (browsers and most WebSocket implementations)
        if ('binaryType' in this.conn) this.conn.binaryType = 'arraybuffer';
        this.conn.onopen = ()=>this._onConnOpen();
        this.conn.onerror = (error)=>this._onConnError(error);
        this.conn.onmessage = (event)=>this._onConnMessage(event);
        this.conn.onclose = (event)=>this._onConnClose(event);
        if (this.conn.readyState === (0, $5gqEk.SOCKET_STATES).open) this._onConnOpen();
    }
    /**
     * Teardown connection and cleanup resources
     * @internal
     */ _teardownConnection() {
        if (this.conn) {
            if (this.conn.readyState === (0, $5gqEk.SOCKET_STATES).open || this.conn.readyState === (0, $5gqEk.SOCKET_STATES).connecting) try {
                this.conn.close();
            } catch (e) {
                this.log('error', 'Error closing connection', e);
            }
            this.conn.onopen = null;
            this.conn.onerror = null;
            this.conn.onmessage = null;
            this.conn.onclose = null;
            this.conn = null;
        }
        this._clearAllTimers();
        this._terminateWorker();
        this.channels.forEach((channel)=>channel.teardown());
    }
    /** @internal */ _onConnOpen() {
        this._setConnectionState('connected');
        this.log('transport', `connected to ${this.endpointURL()}`);
        // Wait for any pending auth operations before flushing send buffer
        // This ensures channel join messages include the correct access token
        const authPromise = this._authPromise || (this.accessToken && !this.accessTokenValue ? this.setAuth() : Promise.resolve());
        authPromise.then(()=>{
            // When subscribe() is called before the accessToken callback has
            // resolved (common on React Native / Expo where token storage is
            // async), the phx_join payload captured at subscribe()-time will
            // have no access_token.  By this point auth has settled and
            // this.accessTokenValue holds the real JWT.
            //
            // The stale join messages sitting in sendBuffer captured the old
            // (token-less) payload in a closure, so we cannot simply flush
            // them.  Instead we:
            //   1. Patch each channel's joinPush payload with the real token
            //   2. Drop the stale buffered messages
            //   3. Re-send the join for any channel still in "joining" state
            //
            // On browsers this is a harmless no-op: accessTokenValue was
            // already set synchronously before subscribe() ran, so the join
            // payload already had the correct token.
            if (this.accessTokenValue) {
                this.channels.forEach((channel)=>{
                    channel.updateJoinPayload({
                        access_token: this.accessTokenValue
                    });
                });
                this.sendBuffer = [];
                this.channels.forEach((channel)=>{
                    if (channel._isJoining()) {
                        channel.joinPush.sent = false;
                        channel.joinPush.send();
                    }
                });
            }
            this.flushSendBuffer();
        }).catch((e)=>{
            this.log('error', 'error waiting for auth on connect', e);
            // Proceed anyway to avoid hanging connections
            this.flushSendBuffer();
        });
        this._clearTimer('reconnect');
        if (!this.worker) this._startHeartbeat();
        else if (!this.workerRef) this._startWorkerHeartbeat();
        this._triggerStateCallbacks('open');
    }
    /** @internal */ _startHeartbeat() {
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    /** @internal */ _startWorkerHeartbeat() {
        if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
        else this.log('worker', `starting default worker`);
        const objectUrl = this._workerObjectUrl(this.workerUrl);
        this.workerRef = new Worker(objectUrl);
        this.workerRef.onerror = (error)=>{
            this.log('worker', 'worker error', error.message);
            this._terminateWorker();
        };
        this.workerRef.onmessage = (event)=>{
            if (event.data.event === 'keepAlive') this.sendHeartbeat();
        };
        this.workerRef.postMessage({
            event: 'start',
            interval: this.heartbeatIntervalMs
        });
    }
    /**
     * Terminate the Web Worker and clear the reference
     * @internal
     */ _terminateWorker() {
        if (this.workerRef) {
            this.log('worker', 'terminating worker');
            this.workerRef.terminate();
            this.workerRef = undefined;
        }
    }
    /** @internal */ _onConnClose(event) {
        var _a;
        this._setConnectionState('disconnected');
        this.log('transport', 'close', event);
        this._triggerChanError();
        this._clearTimer('heartbeat');
        // Only schedule reconnection if it wasn't a manual disconnect
        if (!this._wasManualDisconnect) (_a = this.reconnectTimer) === null || _a === void 0 || _a.scheduleTimeout();
        this._triggerStateCallbacks('close', event);
    }
    /** @internal */ _onConnError(error) {
        this._setConnectionState('disconnected');
        this.log('transport', `${error}`);
        this._triggerChanError();
        this._triggerStateCallbacks('error', error);
        try {
            this.heartbeatCallback('error');
        } catch (e) {
            this.log('error', 'error in heartbeat callback', e);
        }
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $5gqEk.CHANNEL_EVENTS).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $ae049384a7d1c7c8$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
    /**
     * Set connection state with proper state management
     * @internal
     */ _setConnectionState(state, manual = false) {
        this._connectionState = state;
        if (state === 'connecting') this._wasManualDisconnect = false;
        else if (state === 'disconnecting') this._wasManualDisconnect = manual;
    }
    /**
     * Perform the actual auth operation
     * @internal
     */ async _performAuth(token = null) {
        let tokenToSend;
        let isManualToken = false;
        if (token) {
            tokenToSend = token;
            // Track if this is a manually-provided token
            isManualToken = true;
        } else if (this.accessToken) // Call the accessToken callback to get fresh token
        try {
            tokenToSend = await this.accessToken();
        } catch (e) {
            this.log('error', 'Error fetching access token from callback', e);
            // Fall back to cached value if callback fails
            tokenToSend = this.accessTokenValue;
        }
        else tokenToSend = this.accessTokenValue;
        // Track whether this token was manually set or fetched via callback
        if (isManualToken) this._manuallySetToken = true;
        else if (this.accessToken) // If we used the callback, clear the manual flag
        this._manuallySetToken = false;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                const payload = {
                    access_token: tokenToSend,
                    version: (0, $5gqEk.DEFAULT_VERSION)
                };
                tokenToSend && channel.updateJoinPayload(payload);
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, $5gqEk.CHANNEL_EVENTS).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Wait for any in-flight auth operations to complete
     * @internal
     */ async _waitForAuthIfNeeded() {
        if (this._authPromise) await this._authPromise;
    }
    /**
     * Safely call setAuth with standardized error handling
     * @internal
     */ _setAuthSafely(context = 'general') {
        // Only refresh auth if using callback-based tokens
        if (!this._isManualToken()) this.setAuth().catch((e)=>{
            this.log('error', `Error setting auth in ${context}`, e);
        });
    }
    /**
     * Trigger state change callbacks with proper error handling
     * @internal
     */ _triggerStateCallbacks(event, data) {
        try {
            this.stateChangeCallbacks[event].forEach((callback)=>{
                try {
                    callback(data);
                } catch (e) {
                    this.log('error', `error in ${event} callback`, e);
                }
            });
        } catch (e) {
            this.log('error', `error triggering ${event} callbacks`, e);
        }
    }
    /**
     * Setup reconnection timer with proper configuration
     * @internal
     */ _setupReconnectionTimer() {
        this.reconnectTimer = new (0, $6TKMA.default)(async ()=>{
            setTimeout(async ()=>{
                await this._waitForAuthIfNeeded();
                if (!this.isConnected()) this.connect();
            }, $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS.RECONNECT_DELAY);
        }, this.reconnectAfterMs);
    }
    /**
     * Initialize client options with defaults
     * @internal
     */ _initializeOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        // Set defaults
        this.transport = (_a = options === null || options === void 0 ? void 0 : options.transport) !== null && _a !== void 0 ? _a : null;
        this.timeout = (_b = options === null || options === void 0 ? void 0 : options.timeout) !== null && _b !== void 0 ? _b : (0, $5gqEk.DEFAULT_TIMEOUT);
        this.heartbeatIntervalMs = (_c = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _c !== void 0 ? _c : $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        this.worker = (_d = options === null || options === void 0 ? void 0 : options.worker) !== null && _d !== void 0 ? _d : false;
        this.accessToken = (_e = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _e !== void 0 ? _e : null;
        this.heartbeatCallback = (_f = options === null || options === void 0 ? void 0 : options.heartbeatCallback) !== null && _f !== void 0 ? _f : $ae049384a7d1c7c8$var$noop;
        this.vsn = (_g = options === null || options === void 0 ? void 0 : options.vsn) !== null && _g !== void 0 ? _g : (0, $5gqEk.DEFAULT_VSN);
        // Handle special cases
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            this.params = Object.assign(Object.assign({}, this.params), {
                log_level: this.logLevel
            });
        }
        // Set up functions with defaults
        this.reconnectAfterMs = (_h = options === null || options === void 0 ? void 0 : options.reconnectAfterMs) !== null && _h !== void 0 ? _h : (tries)=>{
            return $ae049384a7d1c7c8$var$RECONNECT_INTERVALS[tries - 1] || $ae049384a7d1c7c8$var$DEFAULT_RECONNECT_FALLBACK;
        };
        switch(this.vsn){
            case 0, $5gqEk.VSN_1_0_0:
                this.encode = (_j = options === null || options === void 0 ? void 0 : options.encode) !== null && _j !== void 0 ? _j : (payload, callback)=>{
                    return callback(JSON.stringify(payload));
                };
                this.decode = (_k = options === null || options === void 0 ? void 0 : options.decode) !== null && _k !== void 0 ? _k : (payload, callback)=>{
                    return callback(JSON.parse(payload));
                };
                break;
            case 0, $5gqEk.VSN_2_0_0:
                this.encode = (_l = options === null || options === void 0 ? void 0 : options.encode) !== null && _l !== void 0 ? _l : this.serializer.encode.bind(this.serializer);
                this.decode = (_m = options === null || options === void 0 ? void 0 : options.decode) !== null && _m !== void 0 ? _m : this.serializer.decode.bind(this.serializer);
                break;
            default:
                throw new Error(`Unsupported serializer version: ${this.vsn}`);
        }
        // Handle worker setup
        if (this.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
    }
}

});
parcelRegister("hnThW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca7f78c8d4f60723$export$2e2bcd8739ae039);
/**
 * Utilities for creating WebSocket instances across runtimes.
 */ class $ca7f78c8d4f60723$export$67be75336dea7fb5 {
    /**
     * Static-only utility – prevent instantiation.
     */ constructor(){}
    static detectEnvironment() {
        var _a;
        if (typeof WebSocket !== 'undefined') return {
            type: 'native',
            constructor: WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocket !== 'undefined') return {
            type: 'native',
            constructor: globalThis.WebSocket
        };
        if (typeof $parcel$global !== 'undefined' && typeof $parcel$global.WebSocket !== 'undefined') return {
            type: 'native',
            constructor: $parcel$global.WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocketPair !== 'undefined' && typeof globalThis.WebSocket === 'undefined') return {
            type: 'cloudflare',
            error: 'Cloudflare Workers detected. WebSocket clients are not supported in Cloudflare Workers.',
            workaround: 'Use Cloudflare Workers WebSocket API for server-side WebSocket handling, or deploy to a different runtime.'
        };
        if (typeof globalThis !== 'undefined' && globalThis.EdgeRuntime || typeof navigator !== 'undefined' && ((_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('Vercel-Edge'))) return {
            type: 'unsupported',
            error: 'Edge runtime detected (Vercel Edge/Netlify Edge). WebSockets are not supported in edge functions.',
            workaround: 'Use serverless functions or a different deployment target for WebSocket functionality.'
        };
        // Use dynamic property access to avoid Next.js Edge Runtime static analysis warnings
        const _process = globalThis['process'];
        if (_process) {
            const processVersions = _process['versions'];
            if (processVersions && processVersions['node']) {
                // Remove 'v' prefix if present and parse the major version
                const versionString = processVersions['node'];
                const nodeVersion = parseInt(versionString.replace(/^v/, '').split('.')[0]);
                // Node.js 22+ should have native WebSocket
                if (nodeVersion >= 22) {
                    // Check if native WebSocket is available (should be in Node.js 22+)
                    if (typeof globalThis.WebSocket !== 'undefined') return {
                        type: 'native',
                        constructor: globalThis.WebSocket
                    };
                    // If not available, user needs to provide it
                    return {
                        type: 'unsupported',
                        error: `Node.js ${nodeVersion} detected but native WebSocket not found.`,
                        workaround: 'Provide a WebSocket implementation via the transport option.'
                    };
                }
                // Node.js < 22 doesn't have native WebSocket
                return {
                    type: 'unsupported',
                    error: `Node.js ${nodeVersion} detected without native WebSocket support.`,
                    workaround: 'For Node.js < 22, install "ws" package and provide it via the transport option:\nimport ws from "ws"\nnew RealtimeClient(url, { transport: ws })'
                };
            }
        }
        return {
            type: 'unsupported',
            error: 'Unknown JavaScript runtime without WebSocket support.',
            workaround: "Ensure you're running in a supported environment (browser, Node.js, Deno) or provide a custom WebSocket implementation."
        };
    }
    /**
     * Returns the best available WebSocket constructor for the current runtime.
     *
     * @example
     * ```ts
     * const WS = WebSocketFactory.getWebSocketConstructor()
     * const socket = new WS('wss://realtime.supabase.co/socket')
     * ```
     */ static getWebSocketConstructor() {
        const env = this.detectEnvironment();
        if (env.constructor) return env.constructor;
        let errorMessage = env.error || 'WebSocket not supported in this environment.';
        if (env.workaround) errorMessage += `\n\nSuggested solution: ${env.workaround}`;
        throw new Error(errorMessage);
    }
    /**
     * Creates a WebSocket using the detected constructor.
     *
     * @example
     * ```ts
     * const socket = WebSocketFactory.createWebSocket('wss://realtime.supabase.co/socket')
     * ```
     */ static createWebSocket(url, protocols) {
        const WS = this.getWebSocketConstructor();
        return new WS(url, protocols);
    }
    /**
     * Detects whether the runtime can establish WebSocket connections.
     *
     * @example
     * ```ts
     * if (!WebSocketFactory.isWebSocketSupported()) {
     *   console.warn('Falling back to long polling')
     * }
     * ```
     */ static isWebSocketSupported() {
        try {
            const env = this.detectEnvironment();
            return env.type === 'native' || env.type === 'ws';
        } catch (_a) {
            return false;
        }
    }
}
var $ca7f78c8d4f60723$export$2e2bcd8739ae039 = $ca7f78c8d4f60723$export$67be75336dea7fb5;

});

parcelRegister("5gqEk", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VERSION", () => $3d531e63e1ea7f53$export$363ebe89e6e7aeef);
$parcel$export(module.exports, "VSN_1_0_0", () => $3d531e63e1ea7f53$export$b8f6d7e635d6c56b);
$parcel$export(module.exports, "VSN_2_0_0", () => $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a);
$parcel$export(module.exports, "DEFAULT_VSN", () => $3d531e63e1ea7f53$export$90c89f9664aa9117);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $3d531e63e1ea7f53$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "WS_CLOSE_NORMAL", () => $3d531e63e1ea7f53$export$5e80cf62e56a877b);
$parcel$export(module.exports, "MAX_PUSH_BUFFER_SIZE", () => $3d531e63e1ea7f53$export$f227fe8351a81f4a);
$parcel$export(module.exports, "SOCKET_STATES", () => $3d531e63e1ea7f53$export$a6d0320a1563d49e);
$parcel$export(module.exports, "CHANNEL_STATES", () => $3d531e63e1ea7f53$export$b83816118db74fe7);
$parcel$export(module.exports, "CHANNEL_EVENTS", () => $3d531e63e1ea7f53$export$8db7548e65d6ea55);
$parcel$export(module.exports, "TRANSPORTS", () => $3d531e63e1ea7f53$export$b2688bfb999f5751);
$parcel$export(module.exports, "CONNECTION_STATE", () => $3d531e63e1ea7f53$export$deda39003d27273);

var $6BQLu = parcelRequire("6BQLu");
const $3d531e63e1ea7f53$export$363ebe89e6e7aeef = `realtime-js/${(0, $6BQLu.version)}`;
const $3d531e63e1ea7f53$export$b8f6d7e635d6c56b = '1.0.0';
const $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a = '2.0.0';
const $3d531e63e1ea7f53$export$90c89f9664aa9117 = $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a;
const $3d531e63e1ea7f53$export$a4ad2735b021c132 = (0, $6BQLu.version);
const $3d531e63e1ea7f53$export$7bd623b29ec8e1eb = 10000;
const $3d531e63e1ea7f53$export$5e80cf62e56a877b = 1000;
const $3d531e63e1ea7f53$export$f227fe8351a81f4a = 100;
var $3d531e63e1ea7f53$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($3d531e63e1ea7f53$export$a6d0320a1563d49e || ($3d531e63e1ea7f53$export$a6d0320a1563d49e = {}));
var $3d531e63e1ea7f53$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($3d531e63e1ea7f53$export$b83816118db74fe7 || ($3d531e63e1ea7f53$export$b83816118db74fe7 = {}));
var $3d531e63e1ea7f53$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($3d531e63e1ea7f53$export$8db7548e65d6ea55 || ($3d531e63e1ea7f53$export$8db7548e65d6ea55 = {}));
var $3d531e63e1ea7f53$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($3d531e63e1ea7f53$export$b2688bfb999f5751 || ($3d531e63e1ea7f53$export$b2688bfb999f5751 = {}));
var $3d531e63e1ea7f53$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($3d531e63e1ea7f53$export$deda39003d27273 || ($3d531e63e1ea7f53$export$deda39003d27273 = {}));

});
parcelRegister("6BQLu", function(module, exports) {

$parcel$export(module.exports, "version", () => $4cff20d240de2de4$export$83d89fbfd8236492);
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $4cff20d240de2de4$export$83d89fbfd8236492 = '2.99.3';

});


parcelRegister("8VIf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6805f7080ae1d67f$export$2e2bcd8739ae039);
class $6805f7080ae1d67f$export$2e2bcd8739ae039 {
    constructor(allowedMetadataKeys){
        this.HEADER_LENGTH = 1;
        this.USER_BROADCAST_PUSH_META_LENGTH = 6;
        this.KINDS = {
            userBroadcastPush: 3,
            userBroadcast: 4
        };
        this.BINARY_ENCODING = 0;
        this.JSON_ENCODING = 1;
        this.BROADCAST_EVENT = 'broadcast';
        this.allowedMetadataKeys = [];
        this.allowedMetadataKeys = allowedMetadataKeys !== null && allowedMetadataKeys !== void 0 ? allowedMetadataKeys : [];
    }
    encode(msg, callback) {
        if (msg.event === this.BROADCAST_EVENT && !(msg.payload instanceof ArrayBuffer) && typeof msg.payload.event === 'string') return callback(this._binaryEncodeUserBroadcastPush(msg));
        let payload = [
            msg.join_ref,
            msg.ref,
            msg.topic,
            msg.event,
            msg.payload
        ];
        return callback(JSON.stringify(payload));
    }
    _binaryEncodeUserBroadcastPush(message) {
        var _a;
        if (this._isArrayBuffer((_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload)) return this._encodeBinaryUserBroadcastPush(message);
        else return this._encodeJsonUserBroadcastPush(message);
    }
    _encodeBinaryUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : new ArrayBuffer(0);
        return this._encodeUserBroadcastPush(message, this.BINARY_ENCODING, userPayload);
    }
    _encodeJsonUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : {};
        const encoder = new TextEncoder();
        const encodedUserPayload = encoder.encode(JSON.stringify(userPayload)).buffer;
        return this._encodeUserBroadcastPush(message, this.JSON_ENCODING, encodedUserPayload);
    }
    _encodeUserBroadcastPush(message, encodingType, encodedPayload) {
        var _a, _b;
        const topic = message.topic;
        const ref = (_a = message.ref) !== null && _a !== void 0 ? _a : '';
        const joinRef = (_b = message.join_ref) !== null && _b !== void 0 ? _b : '';
        const userEvent = message.payload.event;
        // Filter metadata based on allowed keys
        const rest = this.allowedMetadataKeys ? this._pick(message.payload, this.allowedMetadataKeys) : {};
        const metadata = Object.keys(rest).length === 0 ? '' : JSON.stringify(rest);
        // Validate lengths don't exceed uint8 max value (255)
        if (joinRef.length > 255) throw new Error(`joinRef length ${joinRef.length} exceeds maximum of 255`);
        if (ref.length > 255) throw new Error(`ref length ${ref.length} exceeds maximum of 255`);
        if (topic.length > 255) throw new Error(`topic length ${topic.length} exceeds maximum of 255`);
        if (userEvent.length > 255) throw new Error(`userEvent length ${userEvent.length} exceeds maximum of 255`);
        if (metadata.length > 255) throw new Error(`metadata length ${metadata.length} exceeds maximum of 255`);
        const metaLength = this.USER_BROADCAST_PUSH_META_LENGTH + joinRef.length + ref.length + topic.length + userEvent.length + metadata.length;
        const header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.userBroadcastPush); // kind
        view.setUint8(offset++, joinRef.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, userEvent.length);
        view.setUint8(offset++, metadata.length);
        view.setUint8(offset++, encodingType);
        Array.from(joinRef, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(userEvent, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(metadata, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + encodedPayload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(encodedPayload), header.byteLength);
        return combined.buffer;
    }
    decode(rawPayload, callback) {
        if (this._isArrayBuffer(rawPayload)) {
            let result = this._binaryDecode(rawPayload);
            return callback(result);
        }
        if (typeof rawPayload === 'string') {
            const jsonPayload = JSON.parse(rawPayload);
            const [join_ref, ref, topic, event, payload] = jsonPayload;
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const kind = view.getUint8(0);
        const decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.userBroadcast:
                return this._decodeUserBroadcast(buffer, view, decoder);
        }
    }
    _decodeUserBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const userEventSize = view.getUint8(2);
        const metadataSize = view.getUint8(3);
        const payloadEncoding = view.getUint8(4);
        let offset = this.HEADER_LENGTH + 4;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const userEvent = decoder.decode(buffer.slice(offset, offset + userEventSize));
        offset = offset + userEventSize;
        const metadata = decoder.decode(buffer.slice(offset, offset + metadataSize));
        offset = offset + metadataSize;
        const payload = buffer.slice(offset, buffer.byteLength);
        const parsedPayload = payloadEncoding === this.JSON_ENCODING ? JSON.parse(decoder.decode(payload)) : payload;
        const data = {
            type: this.BROADCAST_EVENT,
            event: userEvent,
            payload: parsedPayload
        };
        // Metadata is optional and always JSON encoded
        if (metadataSize > 0) data['meta'] = JSON.parse(metadata);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: this.BROADCAST_EVENT,
            payload: data
        };
    }
    _isArrayBuffer(buffer) {
        var _a;
        return buffer instanceof ArrayBuffer || ((_a = buffer === null || buffer === void 0 ? void 0 : buffer.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'ArrayBuffer';
    }
    _pick(obj, keys) {
        if (!obj || typeof obj !== 'object') return {};
        return Object.fromEntries(Object.entries(obj).filter(([key])=>keys.includes(key)));
    }
}

});

parcelRegister("6TKMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $505c2b2d07197e20$export$2e2bcd8739ae039);
/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $505c2b2d07197e20$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
        this.timer = undefined;
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}

});

parcelRegister("5po7o", function(module, exports) {

$parcel$export(module.exports, "convertChangeData", () => $3f01feefa94fd48b$export$20ce708a1f594c5e);
$parcel$export(module.exports, "httpEndpointURL", () => $3f01feefa94fd48b$export$976fda7151b30cae);
/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $3f01feefa94fd48b$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($3f01feefa94fd48b$export$4d213a7d364021dc || ($3f01feefa94fd48b$export$4d213a7d364021dc = {}));
const $3f01feefa94fd48b$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    if (!record) return {};
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $3f01feefa94fd48b$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $3f01feefa94fd48b$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $3f01feefa94fd48b$export$3df02a362b86a91(colType, value);
    return $3f01feefa94fd48b$var$noop(value);
};
const $3f01feefa94fd48b$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $3f01feefa94fd48b$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $3f01feefa94fd48b$export$4d213a7d364021dc.bool:
            return $3f01feefa94fd48b$export$3c2e6d1b7583eee6(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int2:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.numeric:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.oid:
            return $3f01feefa94fd48b$export$a0a81dc3380ce7d3(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.json:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.jsonb:
            return $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamp:
            return $3f01feefa94fd48b$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $3f01feefa94fd48b$export$4d213a7d364021dc.abstime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.date:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.daterange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.money:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.reltime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.text:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.time:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamptz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timetz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tsrange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tstzrange:
            return $3f01feefa94fd48b$var$noop(value);
        default:
            // Return the value for remaining types
            return $3f01feefa94fd48b$var$noop(value);
    }
};
const $3f01feefa94fd48b$var$noop = (value)=>{
    return value;
};
const $3f01feefa94fd48b$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $3f01feefa94fd48b$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
    return value;
};
const $3f01feefa94fd48b$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$3f01feefa94fd48b$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $3f01feefa94fd48b$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $3f01feefa94fd48b$export$976fda7151b30cae = (socketUrl)=>{
    const wsUrl = new URL(socketUrl);
    wsUrl.protocol = wsUrl.protocol.replace(/^ws/i, 'http');
    wsUrl.pathname = wsUrl.pathname.replace(/\/+$/, '') // remove all trailing slashes
    .replace(/\/socket\/websocket$/i, '') // remove the socket/websocket path
    .replace(/\/socket$/i, '') // remove the socket path
    .replace(/\/websocket$/i, ''); // remove the websocket path
    if (wsUrl.pathname === '' || wsUrl.pathname === '/') wsUrl.pathname = '/api/broadcast';
    else wsUrl.pathname = wsUrl.pathname + '/api/broadcast';
    return wsUrl.href;
};

});

parcelRegister("IhlL5", function(module, exports) {

$parcel$export(module.exports, "REALTIME_POSTGRES_CHANGES_LISTEN_EVENT", () => $0851918337283a61$export$bc171c571098b6c4);
$parcel$export(module.exports, "REALTIME_LISTEN_TYPES", () => $0851918337283a61$export$9e3fe8e487ef792e);
$parcel$export(module.exports, "REALTIME_SUBSCRIBE_STATES", () => $0851918337283a61$export$a6885b926af646a2);
$parcel$export(module.exports, "REALTIME_CHANNEL_STATES", () => $0851918337283a61$export$154db638d9c0559e);
$parcel$export(module.exports, "default", () => $0851918337283a61$export$2e2bcd8739ae039);

var $5gqEk = parcelRequire("5gqEk");

var $dkOb9 = parcelRequire("dkOb9");

var $6TKMA = parcelRequire("6TKMA");

var $6zp63 = parcelRequire("6zp63");

var $5po7o = parcelRequire("5po7o");
var $0851918337283a61$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($0851918337283a61$export$bc171c571098b6c4 || ($0851918337283a61$export$bc171c571098b6c4 = {}));
var $0851918337283a61$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($0851918337283a61$export$9e3fe8e487ef792e || ($0851918337283a61$export$9e3fe8e487ef792e = {}));
var $0851918337283a61$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($0851918337283a61$export$a6885b926af646a2 || ($0851918337283a61$export$a6885b926af646a2 = {}));
const $0851918337283a61$export$154db638d9c0559e = (0, $5gqEk.CHANNEL_STATES);
class $0851918337283a61$export$2e2bcd8739ae039 {
    /**
     * Creates a channel that can broadcast messages, sync presence, and listen to Postgres changes.
     *
     * The topic determines which realtime stream you are subscribing to. Config options let you
     * enable acknowledgement for broadcasts, presence tracking, or private channels.
     *
     * @example
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'public-anon-key' },
     * })
     * const channel = new RealtimeChannel('realtime:public:messages', { config: {} }, client)
     * ```
     */ constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        var _a, _b;
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $5gqEk.CHANNEL_STATES).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $dkOb9.default)(this, (0, $5gqEk.CHANNEL_EVENTS).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $6TKMA.default)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $5gqEk.CHANNEL_STATES).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $5gqEk.CHANNEL_STATES).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $5gqEk.CHANNEL_STATES).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $5gqEk.CHANNEL_STATES).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('error', (reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $5gqEk.CHANNEL_STATES).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $5gqEk.CHANNEL_EVENTS).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $6zp63.default)(this);
        this.broadcastEndpointURL = (0, $5po7o.httpEndpointURL)(this.socket.endPoint);
        this.private = this.params.config.private || false;
        if (!this.private && ((_b = (_a = this.params.config) === null || _a === void 0 ? void 0 : _a.broadcast) === null || _b === void 0 ? void 0 : _b.replay)) throw `tried to use replay on public channel '${this.topic}'. It must be a private channel.`;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b, _c;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.state == (0, $5gqEk.CHANNEL_STATES).closed) {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            const postgres_changes = (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [];
            const presence_enabled = !!this.bindings[$0851918337283a61$export$9e3fe8e487ef792e.PRESENCE] && this.bindings[$0851918337283a61$export$9e3fe8e487ef792e.PRESENCE].length > 0 || ((_c = this.params.config.presence) === null || _c === void 0 ? void 0 : _c.enabled) === true;
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: Object.assign(Object.assign({}, presence), {
                    enabled: presence_enabled
                }),
                postgres_changes: postgres_changes,
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($0851918337283a61$export$a6885b926af646a2.CLOSED));
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes: postgres_changes })=>{
                var _a;
                // Only refresh auth if using callback-based tokens
                if (!this.socket._isManualToken()) this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.schema, schema) && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.table, table) && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.filter, filter)) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            this.state = (0, $5gqEk.CHANNEL_STATES).errored;
                            callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                this.state = (0, $5gqEk.CHANNEL_STATES).errored;
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    /**
     * Returns the current presence state for this channel.
     *
     * The shape is a map keyed by presence key (for example a user id) where each entry contains the
     * tracked metadata for that user.
     */ presenceState() {
        return this.presence.state;
    }
    /**
     * Sends the supplied payload to the presence tracker so other subscribers can see that this
     * client is online. Use `untrack` to stop broadcasting presence for the same key.
     */ async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    /**
     * Removes the current presence state for this client.
     */ async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        if (this.state === (0, $5gqEk.CHANNEL_STATES).joined && type === $0851918337283a61$export$9e3fe8e487ef792e.PRESENCE) {
            this.socket.log('channel', `resubscribe to ${this.topic} due to change in presence callbacks on joined channel`);
            this.unsubscribe().then(async ()=>await this.subscribe());
        }
        return this._on(type, filter, callback);
    }
    /**
     * Sends a broadcast message explicitly via REST API.
     *
     * This method always uses the REST API endpoint regardless of WebSocket connection state.
     * Useful when you want to guarantee REST delivery or when gradually migrating from implicit REST fallback.
     *
     * @param event The name of the broadcast event
     * @param payload Payload to be sent (required)
     * @param opts Options including timeout
     * @returns Promise resolving to object with success status, and error details if failed
     */ async httpSend(event, payload, opts = {}) {
        var _a;
        if (payload === undefined || payload === null) return Promise.reject('Payload is required for httpSend()');
        const headers = {
            apikey: this.socket.apiKey ? this.socket.apiKey : '',
            'Content-Type': 'application/json'
        };
        if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                messages: [
                    {
                        topic: this.subTopic,
                        event: event,
                        payload: payload,
                        private: this.private
                    }
                ]
            })
        };
        const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
        if (response.status === 202) return {
            success: true
        };
        let errorMessage = response.statusText;
        try {
            const errorBody = await response.json();
            errorMessage = errorBody.error || errorBody.message || errorMessage;
        } catch (_b) {}
        return Promise.reject(new Error(errorMessage));
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            console.warn("Realtime send() is automatically falling back to REST API. This behavior will be deprecated in the future. Please use httpSend() explicitly for REST delivery.");
            const { event: event, payload: endpoint_payload } = args;
            const headers = {
                apikey: this.socket.apiKey ? this.socket.apiKey : '',
                'Content-Type': 'application/json'
            };
            if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    /**
     * Updates the payload that will be sent the next time the channel joins (reconnects).
     * Useful for rotating access tokens or updating config without re-creating the channel.
     */ updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $5gqEk.CHANNEL_STATES).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $5gqEk.CHANNEL_EVENTS).close, 'leave', this._joinRef());
        };
        this.joinPush.destroy();
        let leavePush = null;
        return new Promise((resolve)=>{
            leavePush = new (0, $dkOb9.default)(this, (0, $5gqEk.CHANNEL_EVENTS).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        }).finally(()=>{
            leavePush === null || leavePush === void 0 || leavePush.destroy();
        });
    }
    /**
     * Teardown the channel.
     *
     * Destroys and stops related timers.
     */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.pushBuffer = [];
        this.rejoinTimer.reset();
        this.joinPush.destroy();
        this.state = (0, $5gqEk.CHANNEL_STATES).closed;
        this.bindings = {};
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $dkOb9.default)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else this._addToPushBuffer(pushEvent);
        return pushEvent;
    }
    /** @internal */ _addToPushBuffer(pushEvent) {
        pushEvent.startTimeout();
        this.pushBuffer.push(pushEvent);
        // Enforce buffer size limit
        if (this.pushBuffer.length > (0, $5gqEk.MAX_PUSH_BUFFER_SIZE)) {
            const removedPush = this.pushBuffer.shift();
            if (removedPush) {
                removedPush.destroy();
                this.socket.log('channel', `discarded push due to buffer overflow: ${removedPush.event}`, removedPush.payload);
            }
        }
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $5gqEk.CHANNEL_EVENTS);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        if (this.bindings[typeLower]) this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $0851918337283a61$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /**
     * Compares two optional filter values for equality.
     * Treats undefined, null, and empty string as equivalent empty values.
     * @internal
     */ static isFilterValueEqual(serverValue, clientValue) {
        const normalizedServer = serverValue !== null && serverValue !== void 0 ? serverValue : undefined;
        const normalizedClient = clientValue !== null && clientValue !== void 0 ? clientValue : undefined;
        return normalizedServer === normalizedClient;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $5gqEk.CHANNEL_EVENTS).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $5gqEk.CHANNEL_EVENTS).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $5gqEk.CHANNEL_STATES).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $5po7o.convertChangeData(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $5po7o.convertChangeData(payload.columns, payload.old_record);
        return records;
    }
}

});
parcelRegister("dkOb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b541112b15eb31d$export$2e2bcd8739ae039);

var $5gqEk = parcelRequire("5gqEk");
class $9b541112b15eb31d$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $5gqEk.DEFAULT_TIMEOUT)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}

});

parcelRegister("6zp63", function(module, exports) {

$parcel$export(module.exports, "REALTIME_PRESENCE_LISTEN_EVENTS", () => $4c897aa496ab948f$export$f1ce049df2794fb4);
$parcel$export(module.exports, "default", () => $4c897aa496ab948f$export$2e2bcd8739ae039);
/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $4c897aa496ab948f$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($4c897aa496ab948f$export$f1ce049df2794fb4 || ($4c897aa496ab948f$export$f1ce049df2794fb4 = {}));
class $4c897aa496ab948f$export$2e2bcd8739ae039 {
    /**
     * Creates a Presence helper that keeps the local presence state in sync with the server.
     *
     * @param channel - The realtime channel to bind to.
     * @param opts - Optional custom event names, e.g. `{ events: { state: 'state', diff: 'diff' } }`.
     *
     * @example
     * ```ts
     * const presence = new RealtimePresence(channel)
     *
     * channel.on('presence', ({ event, key }) => {
     *   console.log(`Presence ${event} on ${key}`)
     * })
     * ```
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.enabled = false;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}

});




parcelRegister("9Yl9w", function(module, exports) {

$parcel$export(module.exports, "StorageClient", () => $d3773c76b69f8b27$export$6c85f5032e75eff9);

var $b8Rhd = parcelRequire("b8Rhd");

var $6ZWSX = parcelRequire("6ZWSX");
var $d3773c76b69f8b27$require$Buffer = $6ZWSX.Buffer;
//#region src/lib/common/errors.ts
/**
* Base error class for all Storage errors
* Supports both 'storage' and 'vectors' namespaces
*/ var $d3773c76b69f8b27$export$697502632950e9d3 = class extends Error {
    constructor(message, namespace = "storage", status, statusCode){
        super(message);
        this.__isStorageError = true;
        this.namespace = namespace;
        this.name = namespace === "vectors" ? "StorageVectorsError" : "StorageError";
        this.status = status;
        this.statusCode = statusCode;
    }
};
/**
* Type guard to check if an error is a StorageError
* @param error - The error to check
* @returns True if the error is a StorageError
*/ function $d3773c76b69f8b27$export$5a322e77e5eb0561(error) {
    return typeof error === "object" && error !== null && "__isStorageError" in error;
}
/**
* API error returned from Storage service
* Includes HTTP status code and service-specific error code
*/ var $d3773c76b69f8b27$export$ca9ecfd959b3871c = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message, status, statusCode, namespace = "storage"){
        super(message, namespace, status, statusCode);
        this.name = namespace === "vectors" ? "StorageVectorsApiError" : "StorageApiError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            statusCode: this.statusCode
        };
    }
};
/**
* Unknown error that doesn't match expected error patterns
* Wraps the original error for debugging
*/ var $d3773c76b69f8b27$export$29127ca2e1a271d = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message, originalError, namespace = "storage"){
        super(message, namespace);
        this.name = namespace === "vectors" ? "StorageVectorsUnknownError" : "StorageUnknownError";
        this.originalError = originalError;
    }
};
/**
* @deprecated Use StorageError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$92ae90d5da46e8c0 = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message){
        super(message, "vectors");
    }
};
/**
* Type guard to check if an error is a StorageVectorsError
* @param error - The error to check
* @returns True if the error is a StorageVectorsError
*/ function $d3773c76b69f8b27$export$95bc534aa9e6b2f1(error) {
    return $d3773c76b69f8b27$export$5a322e77e5eb0561(error) && error["namespace"] === "vectors";
}
/**
* @deprecated Use StorageApiError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$22e4871ee01e8e3f = class extends $d3773c76b69f8b27$export$ca9ecfd959b3871c {
    constructor(message, status, statusCode){
        super(message, status, statusCode, "vectors");
    }
};
/**
* @deprecated Use StorageUnknownError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$26d7e1f64f113285 = class extends $d3773c76b69f8b27$export$29127ca2e1a271d {
    constructor(message, originalError){
        super(message, originalError, "vectors");
    }
};
/**
* Error codes specific to S3 Vectors API
* Maps AWS service errors to application-friendly error codes
*/ let $d3773c76b69f8b27$export$2f60cecd2e35a5da = /* @__PURE__ */ function(StorageVectorsErrorCode$1) {
    /** Internal server fault (HTTP 500) */ StorageVectorsErrorCode$1["InternalError"] = "InternalError";
    /** Resource already exists / conflict (HTTP 409) */ StorageVectorsErrorCode$1["S3VectorConflictException"] = "S3VectorConflictException";
    /** Resource not found (HTTP 404) */ StorageVectorsErrorCode$1["S3VectorNotFoundException"] = "S3VectorNotFoundException";
    /** Delete bucket while not empty (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorBucketNotEmpty"] = "S3VectorBucketNotEmpty";
    /** Exceeds bucket quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxBucketsExceeded"] = "S3VectorMaxBucketsExceeded";
    /** Exceeds index quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxIndexesExceeded"] = "S3VectorMaxIndexesExceeded";
    return StorageVectorsErrorCode$1;
}({});
//#endregion
//#region src/lib/common/helpers.ts
/**
* Resolves the fetch implementation to use
* Uses custom fetch if provided, otherwise uses native fetch
*
* @param customFetch - Optional custom fetch implementation
* @returns Resolved fetch function
*/ const $d3773c76b69f8b27$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
/**
* Determine if input is a plain object
* An object is plain if it's created by either {}, new Object(), or Object.create(null)
*
* @param value - Value to check
* @returns True if value is a plain object
* @source https://github.com/sindresorhus/is-plain-obj
*/ const $d3773c76b69f8b27$var$isPlainObject = (value)=>{
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};
/**
* Recursively converts object keys from snake_case to camelCase
* Used for normalizing API responses
*
* @param item - Object to convert
* @returns Converted object with camelCase keys
*/ const $d3773c76b69f8b27$var$recursiveToCamel = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$d3773c76b69f8b27$var$recursiveToCamel(el));
    else if (typeof item === "function" || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ""));
        result[newKey] = $d3773c76b69f8b27$var$recursiveToCamel(value);
    });
    return result;
};
/**
* Validates if a given bucket name is valid according to Supabase Storage API rules
* Mirrors backend validation from: storage/src/storage/limits.ts:isValidBucketName()
*
* Rules:
* - Length: 1-100 characters
* - Allowed characters: alphanumeric (a-z, A-Z, 0-9), underscore (_), and safe special characters
* - Safe special characters: ! - . * ' ( ) space & $ @ = ; : + , ?
* - Forbidden: path separators (/, \), path traversal (..), leading/trailing whitespace
*
* AWS S3 Reference: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
*
* @param bucketName - The bucket name to validate
* @returns true if valid, false otherwise
*/ const $d3773c76b69f8b27$var$isValidBucketName = (bucketName)=>{
    if (!bucketName || typeof bucketName !== "string") return false;
    if (bucketName.length === 0 || bucketName.length > 100) return false;
    if (bucketName.trim() !== bucketName) return false;
    if (bucketName.includes("/") || bucketName.includes("\\")) return false;
    return /^[\w!.\*'() &$@=;:+,?-]+$/.test(bucketName);
};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $d3773c76b69f8b27$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d3773c76b69f8b27$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $d3773c76b69f8b27$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $d3773c76b69f8b27$var$toPrimitive(t, r) {
    if ("object" != $d3773c76b69f8b27$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d3773c76b69f8b27$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $d3773c76b69f8b27$var$toPropertyKey(t) {
    var i = $d3773c76b69f8b27$var$toPrimitive(t, "string");
    return "symbol" == $d3773c76b69f8b27$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $d3773c76b69f8b27$var$_defineProperty(e, r, t) {
    return (r = $d3773c76b69f8b27$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $d3773c76b69f8b27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3773c76b69f8b27$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3773c76b69f8b27$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $d3773c76b69f8b27$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3773c76b69f8b27$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/common/fetch.ts
/**
* Extracts error message from various error response formats
* @param err - Error object from API
* @returns Human-readable error message
*/ const $d3773c76b69f8b27$var$_getErrorMessage = (err)=>{
    var _err$error;
    return err.msg || err.message || err.error_description || (typeof err.error === "string" ? err.error : (_err$error = err.error) === null || _err$error === void 0 ? void 0 : _err$error.message) || JSON.stringify(err);
};
/**
* Handles fetch errors and converts them to Storage error types
* @param error - The error caught from fetch
* @param reject - Promise rejection function
* @param options - Fetch options that may affect error handling
* @param namespace - Error namespace ('storage' or 'vectors')
*/ const $d3773c76b69f8b27$var$handleError = async (error, reject, options, namespace)=>{
    if (error !== null && typeof error === "object" && typeof error.json === "function") {
        const responseError = error;
        let status = parseInt(responseError.status, 10);
        if (!Number.isFinite(status)) status = 500;
        responseError.json().then((err)=>{
            const statusCode = (err === null || err === void 0 ? void 0 : err.statusCode) || (err === null || err === void 0 ? void 0 : err.code) || status + "";
            reject(new $d3773c76b69f8b27$export$ca9ecfd959b3871c($d3773c76b69f8b27$var$_getErrorMessage(err), status, statusCode, namespace));
        }).catch(()=>{
            const statusCode = status + "";
            reject(new $d3773c76b69f8b27$export$ca9ecfd959b3871c(responseError.statusText || `HTTP ${status} error`, status, statusCode, namespace));
        });
    } else reject(new $d3773c76b69f8b27$export$29127ca2e1a271d($d3773c76b69f8b27$var$_getErrorMessage(error), error, namespace));
};
/**
* Builds request parameters for fetch calls
* @param method - HTTP method
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters like AbortSignal
* @param body - Request body (will be JSON stringified if plain object)
* @returns Complete fetch request parameters
*/ const $d3773c76b69f8b27$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET" || method === "HEAD" || !body) return $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, params), parameters);
    if ($d3773c76b69f8b27$var$isPlainObject(body)) {
        params.headers = $d3773c76b69f8b27$var$_objectSpread2({
            "Content-Type": "application/json"
        }, options === null || options === void 0 ? void 0 : options.headers);
        params.body = JSON.stringify(body);
    } else params.body = body;
    if (options === null || options === void 0 ? void 0 : options.duplex) params.duplex = options.duplex;
    return $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, params), parameters);
};
/**
* Internal request handler that wraps fetch with error handling
* @param fetcher - Fetch function to use
* @param method - HTTP method
* @param url - Request URL
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters
* @param body - Request body
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Promise with parsed response or error
*/ async function $d3773c76b69f8b27$var$_handleRequest(fetcher, method, url, options, parameters, body, namespace) {
    return new Promise((resolve, reject)=>{
        fetcher(url, $d3773c76b69f8b27$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
            if (!result.ok) throw result;
            if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
            if (namespace === "vectors") {
                const contentType = result.headers.get("content-type");
                if (result.headers.get("content-length") === "0" || result.status === 204) return {};
                if (!contentType || !contentType.includes("application/json")) return {};
            }
            return result.json();
        }).then((data)=>resolve(data)).catch((error)=>$d3773c76b69f8b27$var$handleError(error, reject, options, namespace));
    });
}
/**
* Creates a fetch API with the specified namespace
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Object with HTTP method functions
*/ function $d3773c76b69f8b27$var$createFetchApi(namespace = "storage") {
    return {
        get: async (fetcher, url, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "GET", url, options, parameters, void 0, namespace);
        },
        post: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "POST", url, options, parameters, body, namespace);
        },
        put: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "PUT", url, options, parameters, body, namespace);
        },
        head: async (fetcher, url, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "HEAD", url, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
                noResolveJson: true
            }), parameters, void 0, namespace);
        },
        remove: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "DELETE", url, options, parameters, body, namespace);
        }
    };
}
const $d3773c76b69f8b27$var$defaultApi = $d3773c76b69f8b27$var$createFetchApi("storage");
const { get: $d3773c76b69f8b27$var$get, post: $d3773c76b69f8b27$var$post, put: $d3773c76b69f8b27$var$put, head: $d3773c76b69f8b27$var$head, remove: $d3773c76b69f8b27$var$remove } = $d3773c76b69f8b27$var$defaultApi;
const $d3773c76b69f8b27$var$vectorsApi = $d3773c76b69f8b27$var$createFetchApi("vectors");
//#endregion
//#region src/lib/common/BaseApiClient.ts
/**
* @ignore
* Base API client class for all Storage API classes
* Provides common infrastructure for error handling and configuration
*
* @typeParam TError - The error type (StorageError or subclass)
*/ var $d3773c76b69f8b27$var$BaseApiClient = class {
    /**
	* Creates a new BaseApiClient instance
	* @param url - Base URL for API requests
	* @param headers - Default headers for API requests
	* @param fetch - Optional custom fetch implementation
	* @param namespace - Error namespace ('storage' or 'vectors')
	*/ constructor(url, headers = {}, fetch$1, namespace = "storage"){
        this.shouldThrowOnError = false;
        this.url = url;
        this.headers = headers;
        this.fetch = $d3773c76b69f8b27$var$resolveFetch(fetch$1);
        this.namespace = namespace;
    }
    /**
	* Enable throwing errors instead of returning them.
	* When enabled, errors are thrown instead of returned in { data, error } format.
	*
	* @returns this - For method chaining
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	* Creates a shallow copy of headers to avoid mutating shared state.
	*
	* @param name - Header name
	* @param value - Header value
	* @returns this - For method chaining
	*/ setHeader(name, value) {
        this.headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, this.headers), {}, {
            [name]: value
        });
        return this;
    }
    /**
	* Handles API operation with standardized error handling
	* Eliminates repetitive try-catch blocks across all API methods
	*
	* This wrapper:
	* 1. Executes the operation
	* 2. Returns { data, error: null } on success
	* 3. Returns { data: null, error } on failure (if shouldThrowOnError is false)
	* 4. Throws error on failure (if shouldThrowOnError is true)
	*
	* @typeParam T - The expected data type from the operation
	* @param operation - Async function that performs the API call
	* @returns Promise with { data, error } tuple
	*
	* @example
	* ```typescript
	* async listBuckets() {
	*   return this.handleOperation(async () => {
	*     return await get(this.fetch, `${this.url}/bucket`, {
	*       headers: this.headers,
	*     })
	*   })
	* }
	* ```
	*/ async handleOperation(operation) {
        var _this = this;
        try {
            return {
                data: await operation(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StreamDownloadBuilder.ts
var $d3773c76b69f8b27$var$StreamDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
    }
    then(onfulfilled, onrejected) {
        return this.execute().then(onfulfilled, onrejected);
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: (await _this.downloadFn()).body,
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/BlobDownloadBuilder.ts
let $d3773c76b69f8b27$var$_Symbol$toStringTag;
$d3773c76b69f8b27$var$_Symbol$toStringTag = Symbol.toStringTag;
var $d3773c76b69f8b27$var$BlobDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
        this[$d3773c76b69f8b27$var$_Symbol$toStringTag] = "BlobDownloadBuilder";
        this.promise = null;
    }
    asStream() {
        return new $d3773c76b69f8b27$var$StreamDownloadBuilder(this.downloadFn, this.shouldThrowOnError);
    }
    then(onfulfilled, onrejected) {
        return this.getPromise().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.getPromise().catch(onrejected);
    }
    finally(onfinally) {
        return this.getPromise().finally(onfinally);
    }
    getPromise() {
        if (!this.promise) this.promise = this.execute();
        return this.promise;
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: await (await _this.downloadFn()).blob(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StorageFileApi.ts
const $d3773c76b69f8b27$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: "name",
        order: "asc"
    }
};
const $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: "3600",
    contentType: "text/plain;charset=UTF-8",
    upsert: false
};
var $d3773c76b69f8b27$var$StorageFileApi = class extends $d3773c76b69f8b27$var$BaseApiClient {
    constructor(url, headers = {}, bucketId, fetch$1){
        super(url, headers, fetch$1, "storage");
        this.bucketId = bucketId;
    }
    /**
	* Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
	*
	* @param method HTTP method.
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	*/ async uploadOrUpdate(method, path, fileBody, fileOptions) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            let body;
            const options = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, _this.headers), method === "POST" && {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                if (metadata) body.append("metadata", _this.encodeMetadata(metadata));
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
                if (metadata && !body.has("metadata")) body.append("metadata", _this.encodeMetadata(metadata));
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (metadata) headers["x-metadata"] = _this.toBase64(_this.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, headers), fileOptions.headers);
            const cleanPath = _this._removeEmptyFolders(path);
            const _path = _this._getFinalPath(cleanPath);
            const data = await (method == "PUT" ? $d3773c76b69f8b27$var$put : $d3773c76b69f8b27$var$post)(_this.fetch, `${_this.url}/object/${_path}`, body, $d3773c76b69f8b27$var$_objectSpread2({
                headers: headers
            }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                duplex: options.duplex
            } : {}));
            return {
                path: cleanPath,
                id: data.Id,
                fullPath: data.Key
            };
        });
    }
    /**
	* Uploads a file to an existing bucket.
	*
	* @category File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, upsert, and metadata.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Upload file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600',
	*     upsert: false
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Upload file using `ArrayBuffer` from base64 file data
	* ```js
	* import { decode } from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*/ async upload(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("POST", path, fileBody, fileOptions);
    }
    /**
	* Upload a file with a token generated from `createSignedUploadUrl`.
	*
	* @category File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param token The token generated from `createSignedUploadUrl`
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions HTTP headers (cacheControl, contentType, etc.).
	* **Note:** The `upsert` option has no effect here. To enable upsert behavior,
	* pass `{ upsert: true }` when calling `createSignedUploadUrl()` instead.
	* @returns Promise with response containing file path and fullPath or error
	*
	* @example Upload to a signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .uploadToSignedUrl('folder/cat.jpg', 'token-from-createSignedUploadUrl', file)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "folder/cat.jpg",
	*     "fullPath": "avatars/folder/cat.jpg"
	*   },
	*   "error": null
	* }
	* ```
	*/ async uploadToSignedUrl(path, token, fileBody, fileOptions) {
        var _this3 = this;
        const cleanPath = _this3._removeEmptyFolders(path);
        const _path = _this3._getFinalPath(cleanPath);
        const url = new URL(_this3.url + `/object/upload/sign/${_path}`);
        url.searchParams.set("token", token);
        return _this3.handleOperation(async ()=>{
            let body;
            const options = $d3773c76b69f8b27$var$_objectSpread2({
                upsert: $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS.upsert
            }, fileOptions);
            const headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, _this3.headers), {
                "x-upsert": String(options.upsert)
            });
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                body.append("cacheControl", options.cacheControl);
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
            }
            return {
                path: cleanPath,
                fullPath: (await $d3773c76b69f8b27$var$put(_this3.fetch, url.toString(), body, {
                    headers: headers
                })).Key
            };
        });
    }
    /**
	* Creates a signed upload URL.
	* Signed upload URLs can be used to upload files to the bucket without further authentication.
	* They are valid for 2 hours.
	*
	* @category File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param options.upsert If set to true, allows the file to be overwritten if it already exists.
	* @returns Promise with response containing signed upload URL, token, and path or error
	*
	* @example Create Signed Upload URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUploadUrl('folder/cat.jpg')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/upload/sign/avatars/folder/cat.jpg?token=<TOKEN>",
	*     "path": "folder/cat.jpg",
	*     "token": "<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*/ async createSignedUploadUrl(path, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            let _path = _this4._getFinalPath(path);
            const headers = $d3773c76b69f8b27$var$_objectSpread2({}, _this4.headers);
            if (options === null || options === void 0 ? void 0 : options.upsert) headers["x-upsert"] = "true";
            const data = await $d3773c76b69f8b27$var$post(_this4.fetch, `${_this4.url}/object/upload/sign/${_path}`, {}, {
                headers: headers
            });
            const url = new URL(_this4.url + data.url);
            const token = url.searchParams.get("token");
            if (!token) throw new $d3773c76b69f8b27$export$697502632950e9d3("No token returned by API");
            return {
                signedUrl: url.toString(),
                path: path,
                token: token
            };
        });
    }
    /**
	* Replaces an existing file at the specified path with a new one.
	*
	* @category File Buckets
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, upsert, and metadata.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Update file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600',
	*     upsert: true
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Update file using `ArrayBuffer` from base64 file data
	* ```js
	* import {decode} from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*/ async update(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("PUT", path, fileBody, fileOptions);
    }
    /**
	* Moves an existing file to a new path in the same bucket.
	*
	* @category File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
	* @param options The destination options.
	* @returns Promise with response containing success message or error
	*
	* @example Move file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .move('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully moved"
	*   },
	*   "error": null
	* }
	* ```
	*/ async move(fromPath, toPath, options) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this6.fetch, `${_this6.url}/object/move`, {
                bucketId: _this6.bucketId,
                sourceKey: fromPath,
                destinationKey: toPath,
                destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
            }, {
                headers: _this6.headers
            });
        });
    }
    /**
	* Copies an existing file to a new path in the same bucket.
	*
	* @category File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
	* @param options The destination options.
	* @returns Promise with response containing copied file path or error
	*
	* @example Copy file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .copy('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "avatars/private/avatar2.png"
	*   },
	*   "error": null
	* }
	* ```
	*/ async copy(fromPath, toPath, options) {
        var _this7 = this;
        return _this7.handleOperation(async ()=>{
            return {
                path: (await $d3773c76b69f8b27$var$post(_this7.fetch, `${_this7.url}/object/copy`, {
                    bucketId: _this7.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: _this7.headers
                })).Key
            };
        });
    }
    /**
	* Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @returns Promise with response containing signed URL or error
	*
	* @example Create Signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Create a signed URL for an asset with transformations
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Create a signed URL which triggers the download of the asset
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     download: true,
	*   })
	* ```
	*/ async createSignedUrl(path, expiresIn, options) {
        var _this8 = this;
        return _this8.handleOperation(async ()=>{
            let _path = _this8._getFinalPath(path);
            const hasTransform = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0;
            let data = await $d3773c76b69f8b27$var$post(_this8.fetch, `${_this8.url}/object/sign/${_path}`, $d3773c76b69f8b27$var$_objectSpread2({
                expiresIn: expiresIn
            }, hasTransform ? {
                transform: options.transform
            } : {}), {
                headers: _this8.headers
            });
            const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? "" : options.download}` : "";
            const returnedPath = hasTransform && data.signedURL.includes("/object/sign/") ? data.signedURL.replace("/object/sign/", "/render/image/sign/") : data.signedURL;
            return {
                signedUrl: encodeURI(`${_this8.url}${returnedPath}${downloadQueryParam}`)
            };
        });
    }
    /**
	* Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category File Buckets
	* @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
	* @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @returns Promise with response containing array of objects with signedUrl, path, and error or error
	*
	* @example Create Signed URLs
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrls(['folder/avatar1.png', 'folder/avatar2.png'], 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "error": null,
	*       "path": "folder/avatar1.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar1.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*     },
	*     {
	*       "error": null,
	*       "path": "folder/avatar2.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar2.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar2.png?token=<TOKEN>"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*/ async createSignedUrls(paths, expiresIn, options) {
        var _this9 = this;
        return _this9.handleOperation(async ()=>{
            const data = await $d3773c76b69f8b27$var$post(_this9.fetch, `${_this9.url}/object/sign/${_this9.bucketId}`, {
                expiresIn: expiresIn,
                paths: paths
            }, {
                headers: _this9.headers
            });
            const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? "" : options.download}` : "";
            return data.map((datum)=>$d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, datum), {}, {
                    signedUrl: datum.signedURL ? encodeURI(`${_this9.url}${datum.signedURL}${downloadQueryParam}`) : null
                }));
        });
    }
    /**
	* Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
	*
	* @category File Buckets
	* @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
	* @param options.transform Transform the asset before serving it to the client.
	* @param parameters Additional fetch parameters like signal for cancellation. Supports standard fetch options including cache control.
	* @returns BlobDownloadBuilder instance for downloading the file
	*
	* @example Download file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": <BLOB>,
	*   "error": null
	* }
	* ```
	*
	* @example Download file with transformations
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*       quality: 80
	*     }
	*   })
	* ```
	*
	* @example Download with cache control (useful in Edge Functions)
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { cache: 'no-store' })
	* ```
	*
	* @example Download with abort signal
	* ```js
	* const controller = new AbortController()
	* setTimeout(() => controller.abort(), 5000)
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { signal: controller.signal })
	* ```
	*/ download(path, options, parameters) {
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) !== "undefined" ? "render/image/authenticated" : "object";
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        const queryString = transformationQuery ? `?${transformationQuery}` : "";
        const _path = this._getFinalPath(path);
        const downloadFn = ()=>$d3773c76b69f8b27$var$get(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                headers: this.headers,
                noResolveJson: true
            }, parameters);
        return new $d3773c76b69f8b27$var$BlobDownloadBuilder(downloadFn, this.shouldThrowOnError);
    }
    /**
	* Retrieves the details of an existing file.
	*
	* Returns detailed file metadata including size, content type, and timestamps.
	* Note: The API returns `last_modified` field, not `updated_at`.
	*
	* @category File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing file metadata or error
	*
	* @example Get file info
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .info('folder/avatar1.png')
	*
	* if (data) {
	*   console.log('Last modified:', data.lastModified)
	*   console.log('Size:', data.size)
	* }
	* ```
	*/ async info(path) {
        var _this10 = this;
        const _path = _this10._getFinalPath(path);
        return _this10.handleOperation(async ()=>{
            return $d3773c76b69f8b27$var$recursiveToCamel(await $d3773c76b69f8b27$var$get(_this10.fetch, `${_this10.url}/object/info/${_path}`, {
                headers: _this10.headers
            }));
        });
    }
    /**
	* Checks the existence of a file.
	*
	* @category File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing boolean indicating file existence or error
	*
	* @example Check file existence
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .exists('folder/avatar1.png')
	* ```
	*/ async exists(path) {
        var _this11 = this;
        const _path = _this11._getFinalPath(path);
        try {
            await $d3773c76b69f8b27$var$head(_this11.fetch, `${_this11.url}/object/${_path}`, {
                headers: _this11.headers
            });
            return {
                data: true,
                error: null
            };
        } catch (error) {
            if (_this11.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) {
                var _error$originalError;
                const status = error instanceof $d3773c76b69f8b27$export$ca9ecfd959b3871c ? error.status : error instanceof $d3773c76b69f8b27$export$29127ca2e1a271d ? (_error$originalError = error.originalError) === null || _error$originalError === void 0 ? void 0 : _error$originalError.status : void 0;
                if (status !== void 0 && [
                    400,
                    404
                ].includes(status)) return {
                    data: false,
                    error: error
                };
            }
            throw error;
        }
    }
    /**
	* A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
	* This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
	*
	* @category File Buckets
	* @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
	* @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @returns Object with public URL
	*
	* @example Returns the URL for an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "publicUrl": "https://example.supabase.co/storage/v1/object/public/public-bucket/folder/avatar1.png"
	*   }
	* }
	* ```
	*
	* @example Returns the URL for an asset in a public bucket with transformations
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Returns the URL which triggers the download of an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     download: true,
	*   })
	* ```
	*/ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? "" : options.download}` : "";
        if (downloadQueryParam !== "") _queryString.push(downloadQueryParam);
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) !== "undefined" ? "render/image" : "object";
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== "") _queryString.push(transformationQuery);
        let queryString = _queryString.join("&");
        if (queryString !== "") queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
	* Deletes files within the same bucket
	*
	* Returns an array of FileObject entries for the deleted files. Note that deprecated
	* fields like `bucket_id` may or may not be present in the response - do not rely on them.
	*
	* @category File Buckets
	* @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
	* @returns Promise with response containing array of deleted file objects or error
	*
	* @example Delete file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .remove(['folder/avatar1.png'])
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [],
	*   "error": null
	* }
	* ```
	*/ async remove(paths) {
        var _this12 = this;
        return _this12.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this12.fetch, `${_this12.url}/object/${_this12.bucketId}`, {
                prefixes: paths
            }, {
                headers: _this12.headers
            });
        });
    }
    /**
	* Get file metadata
	* @param id the file id to retrieve metadata
	*/ /**
	* Update file metadata
	* @param id the file id to update metadata
	* @param meta the new file metadata
	*/ /**
	* Lists all the files and folders within a path of the bucket.
	*
	* **Important:** For folder entries, fields like `id`, `updated_at`, `created_at`,
	* `last_accessed_at`, and `metadata` will be `null`. Only files have these fields populated.
	* Additionally, deprecated fields like `bucket_id`, `owner`, and `buckets` are NOT returned
	* by this method.
	*
	* @category File Buckets
	* @param path The folder path.
	* @param options Search options including limit (defaults to 100), offset, sortBy, and search
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing array of files/folders or error
	*
	* @example List files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*   })
	*
	* // Handle files vs folders
	* data?.forEach(item => {
	*   if (item.id !== null) {
	*     // It's a file
	*     console.log('File:', item.name, 'Size:', item.metadata?.size)
	*   } else {
	*     // It's a folder
	*     console.log('Folder:', item.name)
	*   }
	* })
	* ```
	*
	* Response (file entry):
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "avatar1.png",
	*       "id": "e668cf7f-821b-4a2f-9dce-7dfa5dd1cfd2",
	*       "updated_at": "2024-05-22T23:06:05.580Z",
	*       "created_at": "2024-05-22T23:04:34.443Z",
	*       "last_accessed_at": "2024-05-22T23:04:34.443Z",
	*       "metadata": {
	*         "eTag": "\"c5e8c553235d9af30ef4f6e280790b92\"",
	*         "size": 32175,
	*         "mimetype": "image/png",
	*         "cacheControl": "max-age=3600",
	*         "lastModified": "2024-05-22T23:06:05.574Z",
	*         "contentLength": 32175,
	*         "httpStatusCode": 200
	*       }
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @example Search files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*     search: 'jon'
	*   })
	* ```
	*/ async list(path, options, parameters) {
        var _this13 = this;
        return _this13.handleOperation(async ()=>{
            const body = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_SEARCH_OPTIONS), options), {}, {
                prefix: path || ""
            });
            return await $d3773c76b69f8b27$var$post(_this13.fetch, `${_this13.url}/object/list/${_this13.bucketId}`, body, {
                headers: _this13.headers
            }, parameters);
        });
    }
    /**
	* Lists all the files and folders within a bucket using the V2 API with pagination support.
	*
	* **Important:** Folder entries in the `folders` array only contain `name` and optionally `key` —
	* they have no `id`, timestamps, or `metadata` fields. Full file metadata is only available
	* on entries in the `objects` array.
	*
	* @experimental this method signature might change in the future
	*
	* @category File Buckets
	* @param options Search options including prefix, cursor for pagination, limit, with_delimiter
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing folders/objects arrays with pagination info or error
	*
	* @example List files with pagination
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .listV2({
	*     prefix: 'folder/',
	*     limit: 100,
	*   })
	*
	* // Handle pagination
	* if (data?.hasNext) {
	*   const nextPage = await supabase
	*     .storage
	*     .from('avatars')
	*     .listV2({
	*       prefix: 'folder/',
	*       cursor: data.nextCursor,
	*     })
	* }
	*
	* // Handle files vs folders
	* data?.objects.forEach(file => {
	*   if (file.id !== null) {
	*     console.log('File:', file.name, 'Size:', file.metadata?.size)
	*   }
	* })
	* data?.folders.forEach(folder => {
	*   console.log('Folder:', folder.name)
	* })
	* ```
	*/ async listV2(options, parameters) {
        var _this14 = this;
        return _this14.handleOperation(async ()=>{
            const body = $d3773c76b69f8b27$var$_objectSpread2({}, options);
            return await $d3773c76b69f8b27$var$post(_this14.fetch, `${_this14.url}/object/list-v2/${_this14.bucketId}`, body, {
                headers: _this14.headers
            }, parameters);
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $d3773c76b69f8b27$require$Buffer !== "undefined") return $d3773c76b69f8b27$require$Buffer.from(data).toString("base64");
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path.replace(/^\/+/, "")}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join("&");
    }
};
//#endregion
//#region src/lib/version.ts
const $d3773c76b69f8b27$var$version = "2.99.3";
//#endregion
//#region src/lib/constants.ts
const $d3773c76b69f8b27$var$DEFAULT_HEADERS = {
    "X-Client-Info": `storage-js/${$d3773c76b69f8b27$var$version}`
};
//#endregion
//#region src/packages/StorageBucketApi.ts
var $d3773c76b69f8b27$var$StorageBucketApi = class extends $d3773c76b69f8b27$var$BaseApiClient {
    constructor(url, headers = {}, fetch$1, opts){
        const baseUrl = new URL(url);
        if (opts === null || opts === void 0 ? void 0 : opts.useNewHostname) {
            if (/supabase\.(co|in|red)$/.test(baseUrl.hostname) && !baseUrl.hostname.includes("storage.supabase.")) baseUrl.hostname = baseUrl.hostname.replace("supabase.", "storage.supabase.");
        }
        const finalUrl = baseUrl.href.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* Retrieves the details of all Storage buckets within an existing project.
	*
	* @category File Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('id', 'name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of buckets or error
	*
	* @example List buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets()
	* ```
	*
	* @example List buckets with options
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc',
	*     search: 'prod'
	*   })
	* ```
	*/ async listBuckets(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            const queryString = _this.listBucketOptionsToQueryString(options);
            return await $d3773c76b69f8b27$var$get(_this.fetch, `${_this.url}/bucket${queryString}`, {
                headers: _this.headers
            });
        });
    }
    /**
	* Retrieves the details of an existing Storage bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to retrieve.
	* @returns Promise with response containing bucket details or error
	*
	* @example Get bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .getBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "id": "avatars",
	*     "name": "avatars",
	*     "owner": "",
	*     "public": false,
	*     "file_size_limit": 1024,
	*     "allowed_mime_types": [
	*       "image/png"
	*     ],
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*/ async getBucket(id) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$get(_this2.fetch, `${_this2.url}/bucket/${id}`, {
                headers: _this2.headers
            });
        });
    }
    /**
	* Creates a new Storage bucket
	*
	* @category File Buckets
	* @param id A unique identifier for the bucket you are creating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @param options.type (private-beta) specifies the bucket type. see `BucketType` for more details.
	*   - default bucket type is `STANDARD`
	* @returns Promise with response containing newly created bucket name or error
	*
	* @example Create bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .createBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "avatars"
	*   },
	*   "error": null
	* }
	* ```
	*/ async createBucket(id, options = {
        public: false
    }) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this3.fetch, `${_this3.url}/bucket`, {
                id: id,
                name: id,
                type: options.type,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this3.headers
            });
        });
    }
    /**
	* Updates a Storage bucket
	*
	* @category File Buckets
	* @param id A unique identifier for the bucket you are updating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @returns Promise with response containing success message or error
	*
	* @example Update bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .updateBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully updated"
	*   },
	*   "error": null
	* }
	* ```
	*/ async updateBucket(id, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$put(_this4.fetch, `${_this4.url}/bucket/${id}`, {
                id: id,
                name: id,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this4.headers
            });
        });
    }
    /**
	* Removes all objects inside a single bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to empty.
	* @returns Promise with success message or error
	*
	* @example Empty bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .emptyBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully emptied"
	*   },
	*   "error": null
	* }
	* ```
	*/ async emptyBucket(id) {
        var _this5 = this;
        return _this5.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this5.fetch, `${_this5.url}/bucket/${id}/empty`, {}, {
                headers: _this5.headers
            });
        });
    }
    /**
	* Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
	* You must first `empty()` the bucket.
	*
	* @category File Buckets
	* @param id The unique identifier of the bucket you would like to delete.
	* @returns Promise with success message or error
	*
	* @example Delete bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .deleteBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*/ async deleteBucket(id) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this6.fetch, `${_this6.url}/bucket/${id}`, {}, {
                headers: _this6.headers
            });
        });
    }
    listBucketOptionsToQueryString(options) {
        const params = {};
        if (options) {
            if ("limit" in options) params.limit = String(options.limit);
            if ("offset" in options) params.offset = String(options.offset);
            if (options.search) params.search = options.search;
            if (options.sortColumn) params.sortColumn = options.sortColumn;
            if (options.sortOrder) params.sortOrder = options.sortOrder;
        }
        return Object.keys(params).length > 0 ? "?" + new URLSearchParams(params).toString() : "";
    }
};
//#endregion
//#region src/packages/StorageAnalyticsClient.ts
/**
* Client class for managing Analytics Buckets using Iceberg tables
* Provides methods for creating, listing, and deleting analytics buckets
*/ var $d3773c76b69f8b27$export$6be1752cbca4e2bf = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /**
	* @alpha
	*
	* Creates a new StorageAnalyticsClient instance
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param url - The base URL for the storage API
	* @param headers - HTTP headers to include in requests
	* @param fetch - Optional custom fetch implementation
	*
	* @example
	* ```typescript
	* const client = new StorageAnalyticsClient(url, headers)
	* ```
	*/ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* @alpha
	*
	* Creates a new analytics bucket using Iceberg tables
	* Analytics buckets are optimized for analytical queries and data processing
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param name A unique name for the bucket you are creating
	* @returns Promise with response containing newly created analytics bucket or error
	*
	* @example Create analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "analytics-data",
	*     "type": "ANALYTICS",
	*     "format": "iceberg",
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*/ async createBucket(name) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this.fetch, `${_this.url}/bucket`, {
                name: name
            }, {
                headers: _this.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Retrieves the details of all Analytics Storage buckets within an existing project
	* Only returns buckets of type 'ANALYTICS'
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of analytics buckets or error
	*
	* @example List analytics buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc'
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "analytics-data",
	*       "type": "ANALYTICS",
	*       "format": "iceberg",
	*       "created_at": "2024-05-22T22:26:05.100Z",
	*       "updated_at": "2024-05-22T22:26:05.100Z"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*/ async listBuckets(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            const queryParams = new URLSearchParams();
            if ((options === null || options === void 0 ? void 0 : options.limit) !== void 0) queryParams.set("limit", options.limit.toString());
            if ((options === null || options === void 0 ? void 0 : options.offset) !== void 0) queryParams.set("offset", options.offset.toString());
            if (options === null || options === void 0 ? void 0 : options.sortColumn) queryParams.set("sortColumn", options.sortColumn);
            if (options === null || options === void 0 ? void 0 : options.sortOrder) queryParams.set("sortOrder", options.sortOrder);
            if (options === null || options === void 0 ? void 0 : options.search) queryParams.set("search", options.search);
            const queryString = queryParams.toString();
            const url = queryString ? `${_this2.url}/bucket?${queryString}` : `${_this2.url}/bucket`;
            return await $d3773c76b69f8b27$var$get(_this2.fetch, url, {
                headers: _this2.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Deletes an existing analytics bucket
	* A bucket can't be deleted with existing objects inside it
	* You must first empty the bucket before deletion
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param bucketName The unique identifier of the bucket you would like to delete
	* @returns Promise with response containing success message or error
	*
	* @example Delete analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .deleteBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*/ async deleteBucket(bucketName) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this3.fetch, `${_this3.url}/bucket/${bucketName}`, {}, {
                headers: _this3.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Get an Iceberg REST Catalog client configured for a specific analytics bucket
	* Use this to perform advanced table and namespace operations within the bucket
	* The returned client provides full access to the Apache Iceberg REST Catalog API
	* with the Supabase `{ data, error }` pattern for consistent error handling on all operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @param bucketName - The name of the analytics bucket (warehouse) to connect to
	* @returns The wrapped Iceberg catalog client
	* @throws {StorageError} If the bucket name is invalid
	*
	* @example Get catalog and create table
	* ```js
	* // First, create an analytics bucket
	* const { data: bucket, error: bucketError } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	*
	* // Get the Iceberg catalog for that bucket
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Create a namespace
	* const { error: nsError } = await catalog.createNamespace({ namespace: ['default'] })
	*
	* // Create a table with schema
	* const { data: tableMetadata, error: tableError } = await catalog.createTable(
	*   { namespace: ['default'] },
	*   {
	*     name: 'events',
	*     schema: {
	*       type: 'struct',
	*       fields: [
	*         { id: 1, name: 'id', type: 'long', required: true },
	*         { id: 2, name: 'timestamp', type: 'timestamp', required: true },
	*         { id: 3, name: 'user_id', type: 'string', required: false }
	*       ],
	*       'schema-id': 0,
	*       'identifier-field-ids': [1]
	*     },
	*     'partition-spec': {
	*       'spec-id': 0,
	*       fields: []
	*     },
	*     'write-order': {
	*       'order-id': 0,
	*       fields: []
	*     },
	*     properties: {
	*       'write.format.default': 'parquet'
	*     }
	*   }
	* )
	* ```
	*
	* @example List tables in namespace
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all tables in the default namespace
	* const { data: tables, error: listError } = await catalog.listTables({ namespace: ['default'] })
	* if (listError) {
	*   if (listError.isNotFound()) {
	*     console.log('Namespace not found')
	*   }
	*   return
	* }
	* console.log(tables) // [{ namespace: ['default'], name: 'events' }]
	* ```
	*
	* @example Working with namespaces
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all namespaces
	* const { data: namespaces } = await catalog.listNamespaces()
	*
	* // Create namespace with properties
	* await catalog.createNamespace(
	*   { namespace: ['production'] },
	*   { properties: { owner: 'data-team', env: 'prod' } }
	* )
	* ```
	*
	* @example Cleanup operations
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Drop table with purge option (removes all data)
	* const { error: dropError } = await catalog.dropTable(
	*   { namespace: ['default'], name: 'events' },
	*   { purge: true }
	* )
	*
	* if (dropError?.isNotFound()) {
	*   console.log('Table does not exist')
	* }
	*
	* // Drop namespace (must be empty)
	* await catalog.dropNamespace({ namespace: ['default'] })
	* ```
	*
	* @remarks
	* This method provides a bridge between Supabase's bucket management and the standard
	* Apache Iceberg REST Catalog API. The bucket name maps to the Iceberg warehouse parameter.
	* All authentication and configuration is handled automatically using your Supabase credentials.
	*
	* **Error Handling**: Invalid bucket names throw immediately. All catalog
	* operations return `{ data, error }` where errors are `IcebergError` instances from iceberg-js.
	* Use helper methods like `error.isNotFound()` or check `error.status` for specific error handling.
	* Use `.throwOnError()` on the analytics client if you prefer exceptions for catalog operations.
	*
	* **Cleanup Operations**: When using `dropTable`, the `purge: true` option permanently
	* deletes all table data. Without it, the table is marked as deleted but data remains.
	*
	* **Library Dependency**: The returned catalog wraps `IcebergRestCatalog` from iceberg-js.
	* For complete API documentation and advanced usage, refer to the
	* [iceberg-js documentation](https://supabase.github.io/iceberg-js/).
	*/ from(bucketName) {
        var _this4 = this;
        if (!$d3773c76b69f8b27$var$isValidBucketName(bucketName)) throw new $d3773c76b69f8b27$export$697502632950e9d3("Invalid bucket name: File, folder, and bucket names must follow AWS object key naming guidelines and should avoid the use of any other characters.");
        const catalog = new (0, $b8Rhd.IcebergRestCatalog)({
            baseUrl: this.url,
            catalogName: bucketName,
            auth: {
                type: "custom",
                getHeaders: async ()=>_this4.headers
            },
            fetch: this.fetch
        });
        const shouldThrowOnError = this.shouldThrowOnError;
        return new Proxy(catalog, {
            get (target, prop) {
                const value = target[prop];
                if (typeof value !== "function") return value;
                return async (...args)=>{
                    try {
                        return {
                            data: await value.apply(target, args),
                            error: null
                        };
                    } catch (error) {
                        if (shouldThrowOnError) throw error;
                        return {
                            data: null,
                            error: error
                        };
                    }
                };
            }
        });
    }
};
//#endregion
//#region src/packages/VectorIndexApi.ts
/**
* @hidden
* Base implementation for vector index operations.
* Use {@link VectorBucketScope} via `supabase.storage.vectors.from('bucket')` instead.
*/ var $d3773c76b69f8b27$export$50097ff1e36420b1 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorIndexApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector index within a bucket */ async createIndex(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateIndex`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector index */ async getIndex(vectorBucketName, indexName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector indexes within a bucket with optional filtering and pagination */ async listIndexes(options) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListIndexes`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector index and all its data */ async deleteIndex(vectorBucketName, indexName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorDataApi.ts
/**
* @hidden
* Base implementation for vector data operations.
* Use {@link VectorIndexScope} via `supabase.storage.vectors.from('bucket').index('idx')` instead.
*/ var $d3773c76b69f8b27$export$5f2a4b6b8397c039 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorDataApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Inserts or updates vectors in batch (1-500 per request) */ async putVectors(options) {
        var _this = this;
        if (options.vectors.length < 1 || options.vectors.length > 500) throw new Error("Vector batch size must be between 1 and 500 items");
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/PutVectors`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves vectors by their keys in batch */ async getVectors(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectors`, options, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vectors in an index with pagination */ async listVectors(options) {
        var _this3 = this;
        if (options.segmentCount !== void 0) {
            if (options.segmentCount < 1 || options.segmentCount > 16) throw new Error("segmentCount must be between 1 and 16");
            if (options.segmentIndex !== void 0) {
                if (options.segmentIndex < 0 || options.segmentIndex >= options.segmentCount) throw new Error(`segmentIndex must be between 0 and ${options.segmentCount - 1}`);
            }
        }
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectors`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Queries for similar vectors using approximate nearest neighbor search */ async queryVectors(options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/QueryVectors`, options, {
                headers: _this4.headers
            });
        });
    }
    /** Deletes vectors by their keys in batch (1-500 per request) */ async deleteVectors(options) {
        var _this5 = this;
        if (options.keys.length < 1 || options.keys.length > 500) throw new Error("Keys batch size must be between 1 and 500 items");
        return _this5.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this5.fetch, `${_this5.url}/DeleteVectors`, options, {
                headers: _this5.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorBucketApi.ts
/**
* @hidden
* Base implementation for vector bucket operations.
* Use {@link StorageVectorsClient} via `supabase.storage.vectors` instead.
*/ var $d3773c76b69f8b27$export$e8b640c07a633e69 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorBucketApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector bucket */ async createBucket(vectorBucketName) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector bucket */ async getBucket(vectorBucketName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector buckets with optional filtering and pagination */ async listBuckets(options = {}) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectorBuckets`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector bucket (must be empty first) */ async deleteBucket(vectorBucketName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/StorageVectorsClient.ts
/**
*
* @alpha
*
* Main client for interacting with S3 Vectors API
* Provides access to bucket, index, and vector data operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*
* **Usage Patterns:**
*
* ```typescript
* const { data, error } = await supabase
*  .storage
*  .vectors
*  .createBucket('embeddings-prod')
*
* // Access index operations via buckets
* const bucket = supabase.storage.vectors.from('embeddings-prod')
* await bucket.createIndex({
*   indexName: 'documents',
*   dataType: 'float32',
*   dimension: 1536,
*   distanceMetric: 'cosine'
* })
*
* // Access vector operations via index
* const index = bucket.index('documents')
* await index.putVectors({
*   vectors: [
*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
*   ]
* })
*
* // Query similar vectors
* const { data } = await index.queryVectors({
*   queryVector: { float32: [...] },
*   topK: 5,
*   returnDistance: true
* })
* ```
*/ var $d3773c76b69f8b27$export$f8cb34cab8a13f87 = class extends $d3773c76b69f8b27$export$e8b640c07a633e69 {
    /**
	* @alpha
	*
	* Creates a StorageVectorsClient that can manage buckets, indexes, and vectors.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param url - Base URL of the Storage Vectors REST API.
	* @param options.headers - Optional headers (for example `Authorization`) applied to every request.
	* @param options.fetch - Optional custom `fetch` implementation for non-browser runtimes.
	*
	* @example
	* ```typescript
	* const client = new StorageVectorsClient(url, options)
	* ```
	*/ constructor(url, options = {}){
        super(url, options.headers || {}, options.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific vector bucket
	* Returns a scoped client for index and vector operations within the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Bucket-scoped client with index and vector operations
	*
	* @example
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ from(vectorBucketName) {
        return new $d3773c76b69f8b27$export$5a6e64e51df41f53(this.url, this.headers, vectorBucketName, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector bucket
	* Vector buckets are containers for vector indexes and their data
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Unique name for the vector bucket
	* @returns Promise with empty response on success or error
	*
	* @example
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .createBucket('embeddings-prod')
	* ```
	*/ async createBucket(vectorBucketName) {
        var _superprop_getCreateBucket = ()=>super.createBucket, _this = this;
        return _superprop_getCreateBucket().call(_this, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific vector bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Promise with bucket metadata or error
	*
	* @example
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .getBucket('embeddings-prod')
	*
	* console.log('Bucket created:', data?.vectorBucket.creationTime)
	* ```
	*/ async getBucket(vectorBucketName) {
        var _superprop_getGetBucket = ()=>super.getBucket, _this2 = this;
        return _superprop_getGetBucket().call(_this2, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Lists all vector buckets with optional filtering and pagination
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Optional filters (prefix, maxResults, nextToken)
	* @returns Promise with list of buckets or error
	*
	* @example
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .listBuckets({ prefix: 'embeddings-' })
	*
	* data?.vectorBuckets.forEach(bucket => {
	*   console.log(bucket.vectorBucketName)
	* })
	* ```
	*/ async listBuckets(options = {}) {
        var _superprop_getListBuckets = ()=>super.listBuckets, _this3 = this;
        return _superprop_getListBuckets().call(_this3, options);
    }
    /**
	*
	* @alpha
	*
	* Deletes a vector bucket (bucket must be empty)
	* All indexes must be deleted before deleting the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param vectorBucketName - Name of the vector bucket to delete
	* @returns Promise with empty response on success or error
	*
	* @example
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .deleteBucket('embeddings-old')
	* ```
	*/ async deleteBucket(vectorBucketName) {
        var _superprop_getDeleteBucket = ()=>super.deleteBucket, _this4 = this;
        return _superprop_getDeleteBucket().call(_this4, vectorBucketName);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector bucket
* Provides index management and access to vector operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $d3773c76b69f8b27$export$5a6e64e51df41f53 = class extends $d3773c76b69f8b27$export$50097ff1e36420b1 {
    /**
	* @alpha
	*
	* Creates a helper that automatically scopes all index operations to the provided bucket.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @example
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ constructor(url, headers, vectorBucketName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Index configuration (vectorBucketName is automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.createIndex({
	*   indexName: 'documents-openai',
	*   dataType: 'float32',
	*   dimension: 1536,
	*   distanceMetric: 'cosine',
	*   metadataConfiguration: {
	*     nonFilterableMetadataKeys: ['raw_text']
	*   }
	* })
	* ```
	*/ async createIndex(options) {
        var _superprop_getCreateIndex = ()=>super.createIndex, _this5 = this;
        return _superprop_getCreateIndex().call(_this5, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this5.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists indexes in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Listing options (vectorBucketName is automatically set)
	* @returns Promise with response containing indexes array and pagination token or error
	*
	* @example
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.listIndexes({ prefix: 'documents-' })
	* ```
	*/ async listIndexes(options = {}) {
        var _superprop_getListIndexes = ()=>super.listIndexes, _this6 = this;
        return _superprop_getListIndexes().call(_this6, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this6.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index to retrieve
	* @returns Promise with index metadata or error
	*
	* @example
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.getIndex('documents-openai')
	* console.log('Dimension:', data?.index.dimension)
	* ```
	*/ async getIndex(indexName) {
        var _superprop_getGetIndex = ()=>super.getIndex, _this7 = this;
        return _superprop_getGetIndex().call(_this7, _this7.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Deletes an index from this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index to delete
	* @returns Promise with empty response on success or error
	*
	* @example
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.deleteIndex('old-index')
	* ```
	*/ async deleteIndex(indexName) {
        var _superprop_getDeleteIndex = ()=>super.deleteIndex, _this8 = this;
        return _superprop_getDeleteIndex().call(_this8, _this8.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific index within this bucket
	* Returns a scoped client for vector data operations
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param indexName - Name of the index
	* @returns Index-scoped client with vector data operations
	*
	* @example
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	*
	* // Insert vectors
	* await index.putVectors({
	*   vectors: [
	*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
	*   ]
	* })
	*
	* // Query similar vectors
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [...] },
	*   topK: 5
	* })
	* ```
	*/ index(indexName) {
        return new $d3773c76b69f8b27$export$bb92e54e27a7dace(this.url, this.headers, this.vectorBucketName, indexName, this.fetch);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector index
* Provides vector data operations (put, get, list, query, delete)
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $d3773c76b69f8b27$export$bb92e54e27a7dace = class extends $d3773c76b69f8b27$export$5f2a4b6b8397c039 {
    /**
	*
	* @alpha
	*
	* Creates a helper that automatically scopes all vector operations to the provided bucket/index names.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @example
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* ```
	*/ constructor(url, headers, vectorBucketName, indexName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
        this.indexName = indexName;
    }
    /**
	*
	* @alpha
	*
	* Inserts or updates vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Vector insertion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.putVectors({
	*   vectors: [
	*     {
	*       key: 'doc-1',
	*       data: { float32: [0.1, 0.2, ...] },
	*       metadata: { title: 'Introduction', page: 1 }
	*     }
	*   ]
	* })
	* ```
	*/ async putVectors(options) {
        var _superprop_getPutVectors = ()=>super.putVectors, _this9 = this;
        return _superprop_getPutVectors().call(_this9, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this9.vectorBucketName,
            indexName: _this9.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Vector retrieval options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array or error
	*
	* @example
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.getVectors({
	*   keys: ['doc-1', 'doc-2'],
	*   returnMetadata: true
	* })
	* ```
	*/ async getVectors(options) {
        var _superprop_getGetVectors = ()=>super.getVectors, _this10 = this;
        return _superprop_getGetVectors().call(_this10, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this10.vectorBucketName,
            indexName: _this10.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists vectors in this index with pagination
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Listing options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array and pagination token or error
	*
	* @example
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.listVectors({
	*   maxResults: 500,
	*   returnMetadata: true
	* })
	* ```
	*/ async listVectors(options = {}) {
        var _superprop_getListVectors = ()=>super.listVectors, _this11 = this;
        return _superprop_getListVectors().call(_this11, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this11.vectorBucketName,
            indexName: _this11.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Queries for similar vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Query options (bucket and index names automatically set)
	* @returns Promise with response containing matches array of similar vectors ordered by distance or error
	*
	* @example
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [0.1, 0.2, ...] },
	*   topK: 5,
	*   filter: { category: 'technical' },
	*   returnDistance: true,
	*   returnMetadata: true
	* })
	* ```
	*/ async queryVectors(options) {
        var _superprop_getQueryVectors = ()=>super.queryVectors, _this12 = this;
        return _superprop_getQueryVectors().call(_this12, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this12.vectorBucketName,
            indexName: _this12.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Deletes vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @param options - Deletion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.deleteVectors({
	*   keys: ['doc-1', 'doc-2', 'doc-3']
	* })
	* ```
	*/ async deleteVectors(options) {
        var _superprop_getDeleteVectors = ()=>super.deleteVectors, _this13 = this;
        return _superprop_getDeleteVectors().call(_this13, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this13.vectorBucketName,
            indexName: _this13.indexName
        }));
    }
};
//#endregion
//#region src/StorageClient.ts
var $d3773c76b69f8b27$export$6c85f5032e75eff9 = class extends $d3773c76b69f8b27$var$StorageBucketApi {
    /**
	* Creates a client for Storage buckets, files, analytics, and vectors.
	*
	* @category File Buckets
	* @example
	* ```ts
	* import { StorageClient } from '@supabase/storage-js'
	*
	* const storage = new StorageClient('https://xyzcompany.supabase.co/storage/v1', {
	*   apikey: 'public-anon-key',
	* })
	* const avatars = storage.from('avatars')
	* ```
	*/ constructor(url, headers = {}, fetch$1, opts){
        super(url, headers, fetch$1, opts);
    }
    /**
	* Perform file operation in a bucket.
	*
	* @category File Buckets
	* @param id The bucket id to operate on.
	*
	* @example
	* ```typescript
	* const avatars = supabase.storage.from('avatars')
	* ```
	*/ from(id) {
        return new $d3773c76b69f8b27$var$StorageFileApi(this.url, this.headers, id, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access vector storage operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Vector Buckets
	* @returns A StorageVectorsClient instance configured with the current storage settings.
	*/ get vectors() {
        return new $d3773c76b69f8b27$export$f8cb34cab8a13f87(this.url + "/vector", {
            headers: this.headers,
            fetch: this.fetch
        });
    }
    /**
	*
	* @alpha
	*
	* Access analytics storage operations using Iceberg tables.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Analytics Buckets
	* @returns A StorageAnalyticsClient instance configured with the current storage settings.
	*/ get analytics() {
        return new $d3773c76b69f8b27$export$6be1752cbca4e2bf(this.url + "/iceberg", this.headers, this.fetch);
    }
};

});
parcelRegister("b8Rhd", function(module, exports) {

$parcel$export(module.exports, "IcebergRestCatalog", () => $9d579afbf8f344f3$export$1ccb0cb30480e317);
// src/errors/IcebergError.ts
var $9d579afbf8f344f3$export$5625de1fddd06f76 = class extends Error {
    constructor(message, opts){
        super(message);
        this.name = "IcebergError";
        this.status = opts.status;
        this.icebergType = opts.icebergType;
        this.icebergCode = opts.icebergCode;
        this.details = opts.details;
        this.isCommitStateUnknown = opts.icebergType === "CommitStateUnknownException" || [
            500,
            502,
            504
        ].includes(opts.status) && opts.icebergType?.includes("CommitState") === true;
    }
    /**
   * Returns true if the error is a 404 Not Found error.
   */ isNotFound() {
        return this.status === 404;
    }
    /**
   * Returns true if the error is a 409 Conflict error.
   */ isConflict() {
        return this.status === 409;
    }
    /**
   * Returns true if the error is a 419 Authentication Timeout error.
   */ isAuthenticationTimeout() {
        return this.status === 419;
    }
};
// src/utils/url.ts
function $9d579afbf8f344f3$var$buildUrl(baseUrl, path, query) {
    const url = new URL(path, baseUrl);
    if (query) {
        for (const [key, value] of Object.entries(query))if (value !== void 0) url.searchParams.set(key, value);
    }
    return url.toString();
}
// src/http/createFetchClient.ts
async function $9d579afbf8f344f3$var$buildAuthHeaders(auth) {
    if (!auth || auth.type === "none") return {};
    if (auth.type === "bearer") return {
        Authorization: `Bearer ${auth.token}`
    };
    if (auth.type === "header") return {
        [auth.name]: auth.value
    };
    if (auth.type === "custom") return await auth.getHeaders();
    return {};
}
function $9d579afbf8f344f3$var$createFetchClient(options) {
    const fetchFn = options.fetchImpl ?? globalThis.fetch;
    return {
        async request ({ method: method, path: path, query: query, body: body, headers: headers }) {
            const url = $9d579afbf8f344f3$var$buildUrl(options.baseUrl, path, query);
            const authHeaders = await $9d579afbf8f344f3$var$buildAuthHeaders(options.auth);
            const res = await fetchFn(url, {
                method: method,
                headers: {
                    ...body ? {
                        "Content-Type": "application/json"
                    } : {},
                    ...authHeaders,
                    ...headers
                },
                body: body ? JSON.stringify(body) : void 0
            });
            const text = await res.text();
            const isJson = (res.headers.get("content-type") || "").includes("application/json");
            const data = isJson && text ? JSON.parse(text) : text;
            if (!res.ok) {
                const errBody = isJson ? data : void 0;
                const errorDetail = errBody?.error;
                throw new $9d579afbf8f344f3$export$5625de1fddd06f76(errorDetail?.message ?? `Request failed with status ${res.status}`, {
                    status: res.status,
                    icebergType: errorDetail?.type,
                    icebergCode: errorDetail?.code,
                    details: errBody
                });
            }
            return {
                status: res.status,
                headers: res.headers,
                data: data
            };
        }
    };
}
// src/catalog/namespaces.ts
function $9d579afbf8f344f3$var$namespaceToPath(namespace) {
    return namespace.join("");
}
var $9d579afbf8f344f3$var$NamespaceOperations = class {
    constructor(client, prefix = ""){
        this.client = client;
        this.prefix = prefix;
    }
    async listNamespaces(parent) {
        const query = parent ? {
            parent: $9d579afbf8f344f3$var$namespaceToPath(parent.namespace)
        } : void 0;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces`,
            query: query
        });
        return response.data.namespaces.map((ns)=>({
                namespace: ns
            }));
    }
    async createNamespace(id, metadata) {
        const request = {
            namespace: id.namespace,
            properties: metadata?.properties
        };
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces`,
            body: request
        });
        return response.data;
    }
    async dropNamespace(id) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
        });
    }
    async loadNamespaceMetadata(id) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
        });
        return {
            properties: response.data.properties
        };
    }
    async namespaceExists(id) {
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
            });
            return true;
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createNamespaceIfNotExists(id, metadata) {
        try {
            return await this.createNamespace(id, metadata);
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 409) return;
            throw error;
        }
    }
};
// src/catalog/tables.ts
function $9d579afbf8f344f3$var$namespaceToPath2(namespace) {
    return namespace.join("");
}
var $9d579afbf8f344f3$var$TableOperations = class {
    constructor(client, prefix = "", accessDelegation){
        this.client = client;
        this.prefix = prefix;
        this.accessDelegation = accessDelegation;
    }
    async listTables(namespace) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(namespace.namespace)}/tables`
        });
        return response.data.identifiers;
    }
    async createTable(namespace, request) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(namespace.namespace)}/tables`,
            body: request,
            headers: headers
        });
        return response.data.metadata;
    }
    async updateTable(id, request) {
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            body: request
        });
        return {
            "metadata-location": response.data["metadata-location"],
            metadata: response.data.metadata
        };
    }
    async dropTable(id, options) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            query: {
                purgeRequested: String(options?.purge ?? false)
            }
        });
    }
    async loadTable(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            headers: headers
        });
        return response.data.metadata;
    }
    async tableExists(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
                headers: headers
            });
            return true;
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createTableIfNotExists(namespace, request) {
        try {
            return await this.createTable(namespace, request);
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 409) return await this.loadTable({
                namespace: namespace.namespace,
                name: request.name
            });
            throw error;
        }
    }
};
// src/catalog/IcebergRestCatalog.ts
var $9d579afbf8f344f3$export$1ccb0cb30480e317 = class {
    /**
   * Creates a new Iceberg REST Catalog client.
   *
   * @param options - Configuration options for the catalog client
   */ constructor(options){
        let prefix = "v1";
        if (options.catalogName) prefix += `/${options.catalogName}`;
        const baseUrl = options.baseUrl.endsWith("/") ? options.baseUrl : `${options.baseUrl}/`;
        this.client = $9d579afbf8f344f3$var$createFetchClient({
            baseUrl: baseUrl,
            auth: options.auth,
            fetchImpl: options.fetch
        });
        this.accessDelegation = options.accessDelegation?.join(",");
        this.namespaceOps = new $9d579afbf8f344f3$var$NamespaceOperations(this.client, prefix);
        this.tableOps = new $9d579afbf8f344f3$var$TableOperations(this.client, prefix, this.accessDelegation);
    }
    /**
   * Lists all namespaces in the catalog.
   *
   * @param parent - Optional parent namespace to list children under
   * @returns Array of namespace identifiers
   *
   * @example
   * ```typescript
   * // List all top-level namespaces
   * const namespaces = await catalog.listNamespaces();
   *
   * // List namespaces under a parent
   * const children = await catalog.listNamespaces({ namespace: ['analytics'] });
   * ```
   */ async listNamespaces(parent) {
        return this.namespaceOps.listNamespaces(parent);
    }
    /**
   * Creates a new namespace in the catalog.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespace(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * console.log(response.namespace); // ['analytics']
   * console.log(response.properties); // { owner: 'data-team', ... }
   * ```
   */ async createNamespace(id, metadata) {
        return this.namespaceOps.createNamespace(id, metadata);
    }
    /**
   * Drops a namespace from the catalog.
   *
   * The namespace must be empty (contain no tables) before it can be dropped.
   *
   * @param id - Namespace identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropNamespace({ namespace: ['analytics'] });
   * ```
   */ async dropNamespace(id) {
        await this.namespaceOps.dropNamespace(id);
    }
    /**
   * Loads metadata for a namespace.
   *
   * @param id - Namespace identifier to load
   * @returns Namespace metadata including properties
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadNamespaceMetadata({ namespace: ['analytics'] });
   * console.log(metadata.properties);
   * ```
   */ async loadNamespaceMetadata(id) {
        return this.namespaceOps.loadNamespaceMetadata(id);
    }
    /**
   * Lists all tables in a namespace.
   *
   * @param namespace - Namespace identifier to list tables from
   * @returns Array of table identifiers
   *
   * @example
   * ```typescript
   * const tables = await catalog.listTables({ namespace: ['analytics'] });
   * console.log(tables); // [{ namespace: ['analytics'], name: 'events' }, ...]
   * ```
   */ async listTables(namespace) {
        return this.tableOps.listTables(namespace);
    }
    /**
   * Creates a new table in the catalog.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTable(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     },
   *     'partition-spec': {
   *       'spec-id': 0,
   *       fields: [
   *         { source_id: 2, field_id: 1000, name: 'ts_day', transform: 'day' }
   *       ]
   *     }
   *   }
   * );
   * ```
   */ async createTable(namespace, request) {
        return this.tableOps.createTable(namespace, request);
    }
    /**
   * Updates an existing table's metadata.
   *
   * Can update the schema, partition spec, or properties of a table.
   *
   * @param id - Table identifier to update
   * @param request - Update request with fields to modify
   * @returns Response containing the metadata location and updated table metadata
   *
   * @example
   * ```typescript
   * const response = await catalog.updateTable(
   *   { namespace: ['analytics'], name: 'events' },
   *   {
   *     properties: { 'read.split.target-size': '134217728' }
   *   }
   * );
   * console.log(response['metadata-location']); // s3://...
   * console.log(response.metadata); // TableMetadata object
   * ```
   */ async updateTable(id, request) {
        return this.tableOps.updateTable(id, request);
    }
    /**
   * Drops a table from the catalog.
   *
   * @param id - Table identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropTable({ namespace: ['analytics'], name: 'events' });
   * ```
   */ async dropTable(id, options) {
        await this.tableOps.dropTable(id, options);
    }
    /**
   * Loads metadata for a table.
   *
   * @param id - Table identifier to load
   * @returns Table metadata including schema, partition spec, location, etc.
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadTable({ namespace: ['analytics'], name: 'events' });
   * console.log(metadata.schema);
   * console.log(metadata.location);
   * ```
   */ async loadTable(id) {
        return this.tableOps.loadTable(id);
    }
    /**
   * Checks if a namespace exists in the catalog.
   *
   * @param id - Namespace identifier to check
   * @returns True if the namespace exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.namespaceExists({ namespace: ['analytics'] });
   * console.log(exists); // true or false
   * ```
   */ async namespaceExists(id) {
        return this.namespaceOps.namespaceExists(id);
    }
    /**
   * Checks if a table exists in the catalog.
   *
   * @param id - Table identifier to check
   * @returns True if the table exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.tableExists({ namespace: ['analytics'], name: 'events' });
   * console.log(exists); // true or false
   * ```
   */ async tableExists(id) {
        return this.tableOps.tableExists(id);
    }
    /**
   * Creates a namespace if it does not exist.
   *
   * If the namespace already exists, returns void. If created, returns the response.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties, or void if it already exists
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespaceIfNotExists(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * if (response) {
   *   console.log('Created:', response.namespace);
   * } else {
   *   console.log('Already exists');
   * }
   * ```
   */ async createNamespaceIfNotExists(id, metadata) {
        return this.namespaceOps.createNamespaceIfNotExists(id, metadata);
    }
    /**
   * Creates a table if it does not exist.
   *
   * If the table already exists, returns its metadata instead.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created or existing table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTableIfNotExists(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     }
   *   }
   * );
   * ```
   */ async createTableIfNotExists(namespace, request) {
        return this.tableOps.createTableIfNotExists(namespace, request);
    }
};
// src/catalog/types.ts
var $9d579afbf8f344f3$var$DECIMAL_REGEX = /^decimal\s*\(\s*(\d+)\s*,\s*(\d+)\s*\)$/;
var $9d579afbf8f344f3$var$FIXED_REGEX = /^fixed\s*\[\s*(\d+)\s*\]$/;
function $9d579afbf8f344f3$export$31eb975fa3e9c1f6(type) {
    const match = type.match($9d579afbf8f344f3$var$DECIMAL_REGEX);
    if (!match) return null;
    return {
        precision: parseInt(match[1], 10),
        scale: parseInt(match[2], 10)
    };
}
function $9d579afbf8f344f3$export$43d56cf6240a0c0e(type) {
    const match = type.match($9d579afbf8f344f3$var$FIXED_REGEX);
    if (!match) return null;
    return {
        length: parseInt(match[1], 10)
    };
}
function $9d579afbf8f344f3$export$ec8cf417183662a1(type) {
    return $9d579afbf8f344f3$var$DECIMAL_REGEX.test(type);
}
function $9d579afbf8f344f3$export$9fafc1fb79bd852e(type) {
    return $9d579afbf8f344f3$var$FIXED_REGEX.test(type);
}
function $9d579afbf8f344f3$export$84255940fed2ec86(a, b) {
    const decimalA = $9d579afbf8f344f3$export$31eb975fa3e9c1f6(a);
    const decimalB = $9d579afbf8f344f3$export$31eb975fa3e9c1f6(b);
    if (decimalA && decimalB) return decimalA.precision === decimalB.precision && decimalA.scale === decimalB.scale;
    const fixedA = $9d579afbf8f344f3$export$43d56cf6240a0c0e(a);
    const fixedB = $9d579afbf8f344f3$export$43d56cf6240a0c0e(b);
    if (fixedA && fixedB) return fixedA.length === fixedB.length;
    return a === b;
}
function $9d579afbf8f344f3$export$d26e6db8c278e564(metadata) {
    return metadata.schemas.find((s)=>s["schema-id"] === metadata["current-schema-id"]);
}
 //# sourceMappingURL=index.mjs.map

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("lpqci", function(module, exports) {

$parcel$export(module.exports, "GoTrueAdminApi", () => (parcelRequire("f8esb")).default);
$parcel$export(module.exports, "GoTrueClient", () => (parcelRequire("b083j")).default);
$parcel$export(module.exports, "AuthAdminApi", () => (parcelRequire("fCilG")).default);
$parcel$export(module.exports, "AuthClient", () => (parcelRequire("aALRH")).default);
$parcel$export(module.exports, "navigatorLock", () => (parcelRequire("gn0EB")).navigatorLock);
$parcel$export(module.exports, "NavigatorLockAcquireTimeoutError", () => (parcelRequire("gn0EB")).NavigatorLockAcquireTimeoutError);
$parcel$export(module.exports, "lockInternals", () => (parcelRequire("gn0EB")).internals);
$parcel$export(module.exports, "processLock", () => (parcelRequire("gn0EB")).processLock);

var $f8esb = parcelRequire("f8esb");

var $b083j = parcelRequire("b083j");

var $fCilG = parcelRequire("fCilG");

var $aALRH = parcelRequire("aALRH");

var $39QCi = parcelRequire("39QCi");

var $fTIQY = parcelRequire("fTIQY");

var $gn0EB = parcelRequire("gn0EB");
$parcel$exportWildcard(module.exports, $39QCi);
$parcel$exportWildcard(module.exports, $fTIQY);

});
parcelRegister("f8esb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b042d08e69f8c3c9$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $doWUR = parcelRequire("doWUR");

var $98hXt = parcelRequire("98hXt");

var $39QCi = parcelRequire("39QCi");

var $fTIQY = parcelRequire("fTIQY");
class $b042d08e69f8c3c9$export$2e2bcd8739ae039 {
    /**
     * Creates an admin API client that can be used to manage users and OAuth clients.
     *
     * @example
     * ```ts
     * import { GoTrueAdminApi } from '@supabase/auth-js'
     *
     * const admin = new GoTrueAdminApi({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { Authorization: `Bearer ${process.env.SUPABASE_SERVICE_ROLE_KEY}` },
     * })
     * ```
     */ constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $98hXt.resolveFetch)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
        this.oauth = {
            listClients: this._listOAuthClients.bind(this),
            createClient: this._createOAuthClient.bind(this),
            getClient: this._getOAuthClient.bind(this),
            updateClient: this._updateOAuthClient.bind(this),
            deleteClient: this._deleteOAuthClient.bind(this),
            regenerateClientSecret: this._regenerateOAuthClientSecret.bind(this)
        };
        this.customProviders = {
            listProviders: this._listCustomProviders.bind(this),
            createProvider: this._createCustomProvider.bind(this),
            getProvider: this._getCustomProvider.bind(this),
            updateProvider: this._updateCustomProvider.bind(this),
            deleteProvider: this._deleteCustomProvider.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = (0, $39QCi.SIGN_OUT_SCOPES)[0]) {
        if ((0, $39QCi.SIGN_OUT_SCOPES).indexOf(scope) < 0) throw new Error(`@supabase/auth-js: Parameter scope must be one of ${(0, $39QCi.SIGN_OUT_SCOPES).join(', ')}`);
        try {
            await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = (0, $7WQrb.__rest)(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $doWUR._generateLinkResponse),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $doWUR._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        (0, $98hXt.validateUUID)(uid);
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data. Changes are applied directly without confirmation flows.
     *
     * @param uid The user's unique identifier
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @remarks
     * **Important:** This is a server-side operation and does **not** trigger client-side
     * `onAuthStateChange` listeners. The admin API has no connection to client state.
     *
     * To sync changes to the client after calling this method:
     * 1. On the client, call `supabase.auth.refreshSession()` to fetch the updated user data
     * 2. This will trigger the `TOKEN_REFRESHED` event and notify all listeners
     *
     * @example
     * ```typescript
     * // Server-side (Edge Function)
     * const { data, error } = await supabase.auth.admin.updateUserById(
     *   userId,
     *   { user_metadata: { preferences: { theme: 'dark' } } }
     * )
     *
     * // Client-side (to sync the changes)
     * const { data, error } = await supabase.auth.refreshSession()
     * // onAuthStateChange listeners will now be notified with updated user
     * ```
     *
     * @see {@link GoTrueClient.refreshSession} for syncing admin changes to the client
     * @see {@link GoTrueClient.updateUser} for client-side user updates (triggers listeners automatically)
     */ async updateUserById(uid, attributes) {
        (0, $98hXt.validateUUID)(uid);
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        (0, $98hXt.validateUUID)(id);
        try {
            return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        (0, $98hXt.validateUUID)(params.userId);
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        (0, $98hXt.validateUUID)(params.userId);
        (0, $98hXt.validateUUID)(params.id);
        try {
            const data = await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all OAuth clients with optional pagination.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listOAuthClients(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $doWUR._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const clients = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, clients), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    clients: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createOAuthClient(params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getOAuthClient(clientId) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateOAuthClient(clientId, params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/oauth/clients/${clientId}`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteOAuthClient(clientId) {
        try {
            await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Regenerates the secret for an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _regenerateOAuthClientSecret(clientId) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients/${clientId}/regenerate_secret`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all custom providers with optional type filter.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listCustomProviders(params) {
        try {
            const query = {};
            if (params === null || params === void 0 ? void 0 : params.type) query.type = params.type;
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers`, {
                headers: this.headers,
                query: query,
                xform: (data)=>{
                    var _a;
                    return {
                        data: {
                            providers: (_a = data === null || data === void 0 ? void 0 : data.providers) !== null && _a !== void 0 ? _a : []
                        },
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    providers: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new custom OIDC/OAuth provider.
     *
     * For OIDC providers, the server fetches and validates the OpenID Connect discovery document
     * from the issuer's well-known endpoint (or the provided `discovery_url`) at creation time.
     * This may return a validation error (`error_code: "validation_failed"`) if the discovery
     * document is unreachable, not valid JSON, missing required fields, or if the issuer
     * in the document does not match the expected issuer.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createCustomProvider(params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/custom-providers`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific custom provider by identifier.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getCustomProvider(identifier) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing custom provider.
     *
     * When `issuer` or `discovery_url` is changed on an OIDC provider, the server re-fetches and
     * validates the discovery document before persisting. This may return a validation error
     * (`error_code: "validation_failed"`) if the discovery document is unreachable, invalid, or
     * the issuer does not match.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateCustomProvider(identifier, params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/custom-providers/${identifier}`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes a custom provider.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteCustomProvider(identifier) {
        try {
            await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}

});
parcelRegister("doWUR", function(module, exports) {

$parcel$export(module.exports, "_request", () => $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd);
$parcel$export(module.exports, "_sessionResponse", () => $9c1b37c8edd4ca2b$export$273fe4673a018c2e);
$parcel$export(module.exports, "_sessionResponsePassword", () => $9c1b37c8edd4ca2b$export$db83aade1c2922c7);
$parcel$export(module.exports, "_userResponse", () => $9c1b37c8edd4ca2b$export$e20f488897843593);
$parcel$export(module.exports, "_ssoResponse", () => $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b);
$parcel$export(module.exports, "_generateLinkResponse", () => $9c1b37c8edd4ca2b$export$f5eaa950605b2146);
$parcel$export(module.exports, "_noResolveJsonResponse", () => $9c1b37c8edd4ca2b$export$7aed01df6e045e31);

var $7WQrb = parcelRequire("7WQrb");

var $44TzP = parcelRequire("44TzP");

var $98hXt = parcelRequire("98hXt");

var $fTIQY = parcelRequire("fTIQY");
const $9c1b37c8edd4ca2b$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $98hXt.looksLikeFetchResponse)(error)) throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), 0);
    if ($9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $fTIQY.AuthUnknownError)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $98hXt.parseResponseAPIVersion)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $44TzP.API_VERSIONS)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $fTIQY.AuthWeakPasswordError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $fTIQY.AuthWeakPasswordError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $fTIQY.AuthSessionMissingError)();
    throw new (0, $fTIQY.AuthApiError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $9c1b37c8edd4ca2b$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $44TzP.API_VERSION_HEADER_NAME]) headers[0, $44TzP.API_VERSION_HEADER_NAME] = (0, $44TzP.API_VERSIONS)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $9c1b37c8edd4ca2b$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(e);
    }
}
function $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($9c1b37c8edd4ca2b$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $98hXt.expiresAt)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$db83aade1c2922c7(data) {
    const response = $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $9c1b37c8edd4ca2b$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = (0, $7WQrb.__rest)(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $9c1b37c8edd4ca2b$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}

});
parcelRegister("44TzP", function(module, exports) {

$parcel$export(module.exports, "AUTO_REFRESH_TICK_DURATION_MS", () => $2f82a590c21cea7a$export$a4558fee79d6c8ae);
$parcel$export(module.exports, "AUTO_REFRESH_TICK_THRESHOLD", () => $2f82a590c21cea7a$export$f20a97df8f5fe223);
$parcel$export(module.exports, "EXPIRY_MARGIN_MS", () => $2f82a590c21cea7a$export$a36ad0026e55ac00);
$parcel$export(module.exports, "GOTRUE_URL", () => $2f82a590c21cea7a$export$7fedf552187f0c3d);
$parcel$export(module.exports, "STORAGE_KEY", () => $2f82a590c21cea7a$export$86880b4b2e1a2384);
$parcel$export(module.exports, "DEFAULT_HEADERS", () => $2f82a590c21cea7a$export$88a84136db6a4b64);
$parcel$export(module.exports, "API_VERSION_HEADER_NAME", () => $2f82a590c21cea7a$export$e4f5507f88977535);
$parcel$export(module.exports, "API_VERSIONS", () => $2f82a590c21cea7a$export$1f9a66038489bdeb);
$parcel$export(module.exports, "BASE64URL_REGEX", () => $2f82a590c21cea7a$export$7a68c9e70b9d3911);
$parcel$export(module.exports, "JWKS_TTL", () => $2f82a590c21cea7a$export$5bd768495200f133);

var $iIHZ2 = parcelRequire("iIHZ2");
const $2f82a590c21cea7a$export$a4558fee79d6c8ae = 30000;
const $2f82a590c21cea7a$export$f20a97df8f5fe223 = 3;
const $2f82a590c21cea7a$export$a36ad0026e55ac00 = $2f82a590c21cea7a$export$f20a97df8f5fe223 * $2f82a590c21cea7a$export$a4558fee79d6c8ae;
const $2f82a590c21cea7a$export$7fedf552187f0c3d = 'http://localhost:9999';
const $2f82a590c21cea7a$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $2f82a590c21cea7a$export$2f9161bad044dacb = '';
const $2f82a590c21cea7a$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $iIHZ2.version)}`
};
const $2f82a590c21cea7a$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $2f82a590c21cea7a$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $2f82a590c21cea7a$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $2f82a590c21cea7a$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $2f82a590c21cea7a$export$5bd768495200f133 = 600000; // 10 minutes

});
parcelRegister("iIHZ2", function(module, exports) {

$parcel$export(module.exports, "version", () => $da0e74438356dc28$export$83d89fbfd8236492);
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $da0e74438356dc28$export$83d89fbfd8236492 = '2.99.3';

});


parcelRegister("98hXt", function(module, exports) {

$parcel$export(module.exports, "expiresAt", () => $6a62ca85cf697dd5$export$e02d0a488392f690);
$parcel$export(module.exports, "generateCallbackId", () => $6a62ca85cf697dd5$export$16db4ce6a8dfc285);
$parcel$export(module.exports, "isBrowser", () => $6a62ca85cf697dd5$export$4e09c449d6c407f7);
$parcel$export(module.exports, "supportsLocalStorage", () => $6a62ca85cf697dd5$export$9ec034ee80211814);
$parcel$export(module.exports, "parseParametersFromURL", () => $6a62ca85cf697dd5$export$7a29392fb778224c);
$parcel$export(module.exports, "resolveFetch", () => $6a62ca85cf697dd5$export$98d92b1aa79f8cc7);
$parcel$export(module.exports, "looksLikeFetchResponse", () => $6a62ca85cf697dd5$export$e8ad6599be1036a7);
$parcel$export(module.exports, "setItemAsync", () => $6a62ca85cf697dd5$export$e82c36d29078a87f);
$parcel$export(module.exports, "getItemAsync", () => $6a62ca85cf697dd5$export$ba6fcb7c333d32c0);
$parcel$export(module.exports, "removeItemAsync", () => $6a62ca85cf697dd5$export$d35c645d585317ec);
$parcel$export(module.exports, "Deferred", () => $6a62ca85cf697dd5$export$85f6557964517f1a);
$parcel$export(module.exports, "decodeJWT", () => $6a62ca85cf697dd5$export$9a62e6c0a30e00bc);
$parcel$export(module.exports, "sleep", () => $6a62ca85cf697dd5$export$e772c8ff12451969);
$parcel$export(module.exports, "retryable", () => $6a62ca85cf697dd5$export$9e1b8e833f44ff21);
$parcel$export(module.exports, "getCodeChallengeAndMethod", () => $6a62ca85cf697dd5$export$81b177cadfcf873c);
$parcel$export(module.exports, "parseResponseAPIVersion", () => $6a62ca85cf697dd5$export$5f69ecf1c14d56fd);
$parcel$export(module.exports, "validateExp", () => $6a62ca85cf697dd5$export$a5850868adeb9253);
$parcel$export(module.exports, "getAlgorithm", () => $6a62ca85cf697dd5$export$fa59f625ab60cb91);
$parcel$export(module.exports, "validateUUID", () => $6a62ca85cf697dd5$export$a4c72ae47296db0c);
$parcel$export(module.exports, "userNotAvailableProxy", () => $6a62ca85cf697dd5$export$52c7f0d8a78626b);
$parcel$export(module.exports, "insecureUserWarningProxy", () => $6a62ca85cf697dd5$export$28f3a5de6111309a);
$parcel$export(module.exports, "deepClone", () => $6a62ca85cf697dd5$export$b7d58db314e0ac27);

var $44TzP = parcelRequire("44TzP");

var $fTIQY = parcelRequire("fTIQY");

var $iSR6L = parcelRequire("iSR6L");
function $6a62ca85cf697dd5$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $6a62ca85cf697dd5$export$16db4ce6a8dfc285() {
    return Symbol('auth-callback');
}
const $6a62ca85cf697dd5$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $6a62ca85cf697dd5$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $6a62ca85cf697dd5$export$9ec034ee80211814 = ()=>{
    if (!$6a62ca85cf697dd5$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($6a62ca85cf697dd5$var$localStorageWriteTests.tested) return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = false;
    }
    return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
};
function $6a62ca85cf697dd5$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
const $6a62ca85cf697dd5$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $6a62ca85cf697dd5$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $6a62ca85cf697dd5$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $6a62ca85cf697dd5$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $6a62ca85cf697dd5$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $6a62ca85cf697dd5$export$85f6557964517f1a {
    constructor(){
        this.promise = new $6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor = Promise;
function $6a62ca85cf697dd5$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $fTIQY.AuthInvalidJwtError)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $44TzP.BASE64URL_REGEX).test(parts[i])) throw new (0, $fTIQY.AuthInvalidJwtError)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $iSR6L.stringFromBase64URL)(parts[0])),
        payload: JSON.parse((0, $iSR6L.stringFromBase64URL)(parts[1])),
        signature: (0, $iSR6L.base64UrlToUint8Array)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $6a62ca85cf697dd5$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $6a62ca85cf697dd5$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $6a62ca85cf697dd5$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $6a62ca85cf697dd5$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $6a62ca85cf697dd5$var$dec2hex).join('');
}
async function $6a62ca85cf697dd5$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $6a62ca85cf697dd5$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $6a62ca85cf697dd5$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $6a62ca85cf697dd5$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $6a62ca85cf697dd5$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $6a62ca85cf697dd5$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $6a62ca85cf697dd5$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $6a62ca85cf697dd5$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $6a62ca85cf697dd5$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $44TzP.API_VERSION_HEADER_NAME));
    if (!apiVersion) return null;
    if (!apiVersion.match($6a62ca85cf697dd5$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}
function $6a62ca85cf697dd5$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $6a62ca85cf697dd5$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}
const $6a62ca85cf697dd5$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function $6a62ca85cf697dd5$export$a4c72ae47296db0c(str) {
    if (!$6a62ca85cf697dd5$var$UUID_REGEX.test(str)) throw new Error('@supabase/auth-js: Expected parameter to be UUID but is not');
}
function $6a62ca85cf697dd5$export$52c7f0d8a78626b() {
    const proxyTarget = {};
    return new Proxy(proxyTarget, {
        get: (target, prop)=>{
            if (prop === '__isUserNotAvailableProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms.
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)') // Node.js util.inspect
                return undefined;
            }
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${prop}" property of the session object is not supported. Please use getUser() instead.`);
        },
        set: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        },
        deleteProperty: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        }
    });
}
function $6a62ca85cf697dd5$export$28f3a5de6111309a(user, suppressWarningRef) {
    return new Proxy(user, {
        get: (target, prop, receiver)=>{
            // Allow internal checks without warning
            if (prop === '__isInsecureUserWarningProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)' || sProp === 'Symbol(nodejs.util.inspect.custom)') // Return the actual value for these symbols to allow proper inspection
                return Reflect.get(target, prop, receiver);
            }
            // Emit warning on first property access
            if (!suppressWarningRef.value && typeof prop === 'string') {
                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                suppressWarningRef.value = true;
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}
function $6a62ca85cf697dd5$export$b7d58db314e0ac27(obj) {
    return JSON.parse(JSON.stringify(obj));
}

});
parcelRegister("fTIQY", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $b92ec9013174409a$export$145273558d58e0ac);
$parcel$export(module.exports, "isAuthError", () => $b92ec9013174409a$export$cde1786a482f9a1c);
$parcel$export(module.exports, "AuthApiError", () => $b92ec9013174409a$export$45fde0b55b14f37b);
$parcel$export(module.exports, "isAuthApiError", () => $b92ec9013174409a$export$4fe744aeb810d543);
$parcel$export(module.exports, "AuthUnknownError", () => $b92ec9013174409a$export$f7559805d4a50078);
$parcel$export(module.exports, "CustomAuthError", () => $b92ec9013174409a$export$823c745ae0673c5e);
$parcel$export(module.exports, "AuthSessionMissingError", () => $b92ec9013174409a$export$403b3fc0d3ad5f0c);
$parcel$export(module.exports, "isAuthSessionMissingError", () => $b92ec9013174409a$export$3e849aa4db565c1d);
$parcel$export(module.exports, "AuthInvalidTokenResponseError", () => $b92ec9013174409a$export$7e277b620449c1b4);
$parcel$export(module.exports, "AuthInvalidCredentialsError", () => $b92ec9013174409a$export$9ef583f0381b4cc);
$parcel$export(module.exports, "AuthImplicitGrantRedirectError", () => $b92ec9013174409a$export$bf5df8e043856ef5);
$parcel$export(module.exports, "isAuthImplicitGrantRedirectError", () => $b92ec9013174409a$export$45edea3999507afd);
$parcel$export(module.exports, "AuthPKCEGrantCodeExchangeError", () => $b92ec9013174409a$export$39583657eb2a7027);
$parcel$export(module.exports, "AuthPKCECodeVerifierMissingError", () => $b92ec9013174409a$export$11e8e15400b7b336);
$parcel$export(module.exports, "isAuthPKCECodeVerifierMissingError", () => $b92ec9013174409a$export$398e1f2bb2c7a92);
$parcel$export(module.exports, "AuthRetryableFetchError", () => $b92ec9013174409a$export$2423b763f68be1b4);
$parcel$export(module.exports, "isAuthRetryableFetchError", () => $b92ec9013174409a$export$a77af358da5fb874);
$parcel$export(module.exports, "AuthWeakPasswordError", () => $b92ec9013174409a$export$b034076aa04913a6);
$parcel$export(module.exports, "isAuthWeakPasswordError", () => $b92ec9013174409a$export$dac36143fd8a46ef);
$parcel$export(module.exports, "AuthInvalidJwtError", () => $b92ec9013174409a$export$d04cb18528f2043e);
/**
 * Base error thrown by Supabase Auth helpers.
 *
 * @example
 * ```ts
 * import { AuthError } from '@supabase/auth-js'
 *
 * throw new AuthError('Unexpected auth error', 500, 'unexpected')
 * ```
 */ class $b92ec9013174409a$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $b92ec9013174409a$export$45fde0b55b14f37b extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$4fe744aeb810d543(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $b92ec9013174409a$export$f7559805d4a50078 extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $b92ec9013174409a$export$823c745ae0673c5e extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $b92ec9013174409a$export$403b3fc0d3ad5f0c extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $b92ec9013174409a$export$3e849aa4db565c1d(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $b92ec9013174409a$export$7e277b620449c1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $b92ec9013174409a$export$9ef583f0381b4cc extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $b92ec9013174409a$export$bf5df8e043856ef5 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $b92ec9013174409a$export$45edea3999507afd(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $b92ec9013174409a$export$39583657eb2a7027 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $b92ec9013174409a$export$11e8e15400b7b336 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super("PKCE code verifier not found in storage. This can happen if the auth flow was initiated in a different browser or device, or if the storage was cleared. For SSR frameworks (Next.js, SvelteKit, etc.), use @supabase/ssr on both the server and client to store the code verifier in cookies.", 'AuthPKCECodeVerifierMissingError', 400, 'pkce_code_verifier_not_found');
    }
}
function $b92ec9013174409a$export$398e1f2bb2c7a92(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthPKCECodeVerifierMissingError';
}
class $b92ec9013174409a$export$2423b763f68be1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $b92ec9013174409a$export$a77af358da5fb874(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $b92ec9013174409a$export$b034076aa04913a6 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $b92ec9013174409a$export$dac36143fd8a46ef(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $b92ec9013174409a$export$d04cb18528f2043e extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}

});

parcelRegister("iSR6L", function(module, exports) {

$parcel$export(module.exports, "stringFromBase64URL", () => $dbf67752838ebc66$export$bd5d476f823ea024);
$parcel$export(module.exports, "base64UrlToUint8Array", () => $dbf67752838ebc66$export$9cae2cd6076b8fb6);
$parcel$export(module.exports, "stringToUint8Array", () => $dbf67752838ebc66$export$a098e7b533f96db3);
$parcel$export(module.exports, "bytesToBase64URL", () => $dbf67752838ebc66$export$3f156efe462a835e);
/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $dbf67752838ebc66$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $dbf67752838ebc66$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $dbf67752838ebc66$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $dbf67752838ebc66$var$IGNORE_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $dbf67752838ebc66$var$TO_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $dbf67752838ebc66$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $dbf67752838ebc66$export$403e86c86002a137(charCode, state, emit) {
    const bits = $dbf67752838ebc66$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $dbf67752838ebc66$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>{
        $dbf67752838ebc66$export$744f452403189a3e(byte, state, emitter);
    });
    $dbf67752838ebc66$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $dbf67752838ebc66$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $dbf67752838ebc66$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $dbf67752838ebc66$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit);
    }
}
function $dbf67752838ebc66$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $dbf67752838ebc66$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$a098e7b533f96db3(str) {
    const result = [];
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$3f156efe462a835e(bytes) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onChar = (char)=>{
        result.push(char);
    };
    bytes.forEach((byte)=>$dbf67752838ebc66$export$744f452403189a3e(byte, state, onChar));
    // always call with `null` after processing all bytes
    $dbf67752838ebc66$export$744f452403189a3e(null, state, onChar);
    return result.join('');
}

});



parcelRegister("39QCi", function(module, exports) {

$parcel$export(module.exports, "SIGN_OUT_SCOPES", () => $24cb06f66874b0a4$export$9a0f1d0c97ce73ca);
const $24cb06f66874b0a4$var$WeakPasswordReasons = [
    'length',
    'characters',
    'pwned'
];
const $24cb06f66874b0a4$var$AMRMethods = [
    'password',
    'otp',
    'oauth',
    'totp',
    'mfa/totp',
    'mfa/phone',
    'mfa/webauthn',
    'anonymous',
    'sso/saml',
    'magiclink',
    'web3',
    'oauth_provider/authorization_code'
];
const $24cb06f66874b0a4$var$FactorTypes = [
    'totp',
    'phone',
    'webauthn'
];
const $24cb06f66874b0a4$var$FactorVerificationStatuses = [
    'verified',
    'unverified'
];
const $24cb06f66874b0a4$var$MFATOTPChannels = [
    'sms',
    'whatsapp'
];
const $24cb06f66874b0a4$export$9a0f1d0c97ce73ca = [
    'global',
    'local',
    'others'
];

});


parcelRegister("b083j", function(module, exports) {

$parcel$export(module.exports, "default", () => $8025f0dcbc879582$export$2e2bcd8739ae039);

var $f8esb = parcelRequire("f8esb");

var $44TzP = parcelRequire("44TzP");

var $fTIQY = parcelRequire("fTIQY");

var $doWUR = parcelRequire("doWUR");

var $98hXt = parcelRequire("98hXt");

var $a7BAw = parcelRequire("a7BAw");

var $gn0EB = parcelRequire("gn0EB");

var $8WDEC = parcelRequire("8WDEC");

var $iIHZ2 = parcelRequire("iIHZ2");

var $iSR6L = parcelRequire("iSR6L");

var $baxuF = parcelRequire("baxuF");

var $2GmzD = parcelRequire("2GmzD");
(0, $8WDEC.polyfillGlobalThis)(); // Make "globalThis" available
const $8025f0dcbc879582$var$DEFAULT_OPTIONS = {
    url: (0, $44TzP.GOTRUE_URL),
    storageKey: (0, $44TzP.STORAGE_KEY),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $44TzP.DEFAULT_HEADERS),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false,
    throwOnError: false,
    lockAcquireTimeout: 5000,
    skipAutoInitialize: false
};
async function $8025f0dcbc879582$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
/**
 * Caches JWKS values for all clients created in the same environment. This is
 * especially useful for shared-memory execution environments such as Vercel's
 * Fluid Compute, AWS Lambda or Supabase's Edge Functions. Regardless of how
 * many clients are created, if they share the same storage key they will use
 * the same JWKS cache, significantly speeding up getClaims() with asymmetric
 * JWTs.
 */ const $8025f0dcbc879582$var$GLOBAL_JWKS = {};
class $8025f0dcbc879582$var$GoTrueClient {
    /**
     * The JWKS used for verifying asymmetric JWTs
     */ get jwks() {
        var _a, _b;
        return (_b = (_a = $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.jwks) !== null && _b !== void 0 ? _b : {
            keys: []
        };
    }
    set jwks(value) {
        $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]), {
            jwks: value
        });
    }
    get jwks_cached_at() {
        var _a, _b;
        return (_b = (_a = $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.cachedAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER;
    }
    set jwks_cached_at(value) {
        $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]), {
            cachedAt: value
        });
    }
    /**
     * Create a new client for use in the browser.
     *
     * @example
     * ```ts
     * import { GoTrueClient } from '@supabase/auth-js'
     *
     * const auth = new GoTrueClient({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { apikey: 'public-anon-key' },
     *   storageKey: 'supabase-auth',
     * })
     * ```
     */ constructor(options){
        var _a, _b, _c;
        /**
         * @experimental
         */ this.userStorage = null;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.autoRefreshTickTimeout = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the auth state is known and it's safe to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        const settings = Object.assign(Object.assign({}, $8025f0dcbc879582$var$DEFAULT_OPTIONS), options);
        this.storageKey = settings.storageKey;
        this.instanceID = (_a = $8025f0dcbc879582$var$GoTrueClient.nextInstanceID[this.storageKey]) !== null && _a !== void 0 ? _a : 0;
        $8025f0dcbc879582$var$GoTrueClient.nextInstanceID[this.storageKey] = this.instanceID + 1;
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        if (this.instanceID > 0 && (0, $98hXt.isBrowser)()) {
            const message = `${this._logPrefix()} Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.`;
            console.warn(message);
            if (this.logDebugMessages) console.trace(message);
        }
        this.persistSession = settings.persistSession;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $f8esb.default)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $98hXt.resolveFetch)(settings.fetch);
        this.lock = settings.lock || $8025f0dcbc879582$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        this.throwOnError = settings.throwOnError;
        this.lockAcquireTimeout = settings.lockAcquireTimeout;
        if (settings.lock) this.lock = settings.lock;
        else if (this.persistSession && (0, $98hXt.isBrowser)() && ((_b = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _b === void 0 ? void 0 : _b.locks)) this.lock = (0, $gn0EB.navigatorLock);
        else this.lock = $8025f0dcbc879582$var$lockNoOp;
        if (!this.jwks) {
            this.jwks = {
                keys: []
            };
            this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        }
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this),
            webauthn: new (0, $2GmzD.WebAuthnApi)(this)
        };
        this.oauth = {
            getAuthorizationDetails: this._getAuthorizationDetails.bind(this),
            approveAuthorization: this._approveAuthorization.bind(this),
            denyAuthorization: this._denyAuthorization.bind(this),
            listGrants: this._listOAuthGrants.bind(this),
            revokeGrant: this._revokeOAuthGrant.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $98hXt.supportsLocalStorage)()) this.storage = globalThis.localStorage;
            else {
                this.memoryStorage = {};
                this.storage = (0, $a7BAw.memoryLocalStorageAdapter)(this.memoryStorage);
            }
            if (settings.userStorage) this.userStorage = settings.userStorage;
        } else {
            this.memoryStorage = {};
            this.storage = (0, $a7BAw.memoryLocalStorageAdapter)(this.memoryStorage);
        }
        if ((0, $98hXt.isBrowser)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_c = this.broadcastChannel) === null || _c === void 0 || _c.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                try {
                    await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
                } catch (error) {
                    this._debug('#broadcastChannel', 'error', error);
                }
            });
        }
        // Only auto-initialize if not explicitly disabled. Skipped in SSR contexts
        // where initialization timing must be controlled. All public methods have
        // lazy initialization, so the client remains fully functional.
        if (!settings.skipAutoInitialize) this.initialize().catch((error)=>{
            this._debug('#initialize()', 'error', error);
        });
    }
    /**
     * Returns whether error throwing mode is enabled for this client.
     */ isThrowOnErrorEnabled() {
        return this.throwOnError;
    }
    /**
     * Centralizes return handling with optional error throwing. When `throwOnError` is enabled
     * and the provided result contains a non-nullish error, the error is thrown instead of
     * being returned. This ensures consistent behavior across all public API methods.
     */ _returnResult(result) {
        if (this.throwOnError && result && result.error) throw result.error;
        return result;
    }
    _logPrefix() {
        return 'GoTrueClient@' + `${this.storageKey}:${this.instanceID} (${0, $iIHZ2.version}) ${new Date().toISOString()}`;
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(this._logPrefix(), ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            let params = {};
            let callbackUrlType = 'none';
            if ((0, $98hXt.isBrowser)()) {
                params = (0, $98hXt.parseParametersFromURL)(window.location.href);
                if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
                else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            }
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $98hXt.isBrowser)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $fTIQY.isAuthImplicitGrantRedirectError)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // Don't remove existing session on URL login failure.
                    // A failed attempt (e.g. reused magic link) shouldn't invalidate a valid session.
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                error: error
            });
            return this._returnResult({
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error during initialization', error)
            });
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $doWUR._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error || !data) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     *
     * @category Auth
     *
     * @remarks
     * - By default, the user needs to verify their email address before logging in. To turn this off, disable **Confirm email** in [your project](/dashboard/project/_/auth/providers).
     * - **Confirm email** determines if users need to confirm their email address after signing up.
     *   - If **Confirm email** is enabled, a `user` is returned but `session` is null.
     *   - If **Confirm email** is disabled, both a `user` and a `session` are returned.
     * - When the user confirms their email address, they are redirected to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) by default. You can modify your `SITE_URL` or add additional redirect URLs in [your project](/dashboard/project/_/auth/url-configuration).
     * - If signUp() is called for an existing confirmed user:
     *   - When both **Confirm email** and **Confirm phone** (even when phone provider is disabled) are enabled in [your project](/dashboard/project/_/auth/providers), an obfuscated/fake user object is returned.
     *   - When either **Confirm email** or **Confirm phone** (even when phone provider is disabled) is disabled, the error message, `User already registered` is returned.
     * - To fetch the currently logged-in user, refer to [`getUser()`](/docs/reference/javascript/auth-getuser).
     *
     * @example Sign up with an email and password
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign up with an email and password
     * ```json
     * // Some fields may be null if "confirm email" is enabled.
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign up with a phone number and password (SMS)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'sms'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign up with a phone number and password (whatsapp)
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign up with a phone number and password (whatsapp)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'whatsapp'
     *   }
     * })
     * ```
     *
     * @example Sign up with additional user metadata
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       data: {
     *         first_name: 'John',
     *         age: 27,
     *       }
     *     }
     *   }
     * )
     * ```
     *
     * @exampleDescription Sign up with a redirect URL
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign up with a redirect URL
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       emailRedirectTo: 'https://example.com/welcome'
     *     }
     *   }
     * )
     * ```
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
            } else throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) {
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponsePassword)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponsePassword)
                });
            } else throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    /**
     * Signs in a user by verifying a message signed by the user's private key.
     * Supports Ethereum (via Sign-In-With-Ethereum) & Solana (Sign-In-With-Solana) standards,
     * both of which derive from the EIP-4361 standard
     * With slight variation on Solana's side.
     * @reference https://eips.ethereum.org/EIPS/eip-4361
     */ async signInWithWeb3(credentials) {
        const { chain: chain } = credentials;
        switch(chain){
            case 'ethereum':
                return await this.signInWithEthereum(credentials);
            case 'solana':
                return await this.signInWithSolana(credentials);
            default:
                throw new Error(`@supabase/auth-js: Unsupported chain "${chain}"`);
        }
    }
    async signInWithEthereum(credentials) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        // TODO: flatten type
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $98hXt.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('ethereum' in windowAny && typeof windowAny.ethereum === 'object' && 'request' in windowAny.ethereum && typeof windowAny.ethereum.request === 'function') resolvedWallet = windowAny.ethereum;
                else throw new Error(`@supabase/auth-js: No compatible Ethereum wallet interface on the window object (window.ethereum) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'ethereum', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            const accounts = await resolvedWallet.request({
                method: 'eth_requestAccounts'
            }).then((accs)=>accs).catch(()=>{
                throw new Error(`@supabase/auth-js: Wallet method eth_requestAccounts is missing or invalid`);
            });
            if (!accounts || accounts.length === 0) throw new Error(`@supabase/auth-js: No accounts available. Please ensure the wallet is connected.`);
            const address = (0, $baxuF.getAddress)(accounts[0]);
            let chainId = (_b = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _b === void 0 ? void 0 : _b.chainId;
            if (!chainId) {
                const chainIdHex = await resolvedWallet.request({
                    method: 'eth_chainId'
                });
                chainId = (0, $baxuF.fromHex)(chainIdHex);
            }
            const siweMessage = {
                domain: url.host,
                address: address,
                statement: statement,
                uri: url.href,
                version: '1',
                chainId: chainId,
                nonce: (_c = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _c === void 0 ? void 0 : _c.nonce,
                issuedAt: (_e = (_d = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _d === void 0 ? void 0 : _d.issuedAt) !== null && _e !== void 0 ? _e : new Date(),
                expirationTime: (_f = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _f === void 0 ? void 0 : _f.expirationTime,
                notBefore: (_g = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _g === void 0 ? void 0 : _g.notBefore,
                requestId: (_h = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _h === void 0 ? void 0 : _h.requestId,
                resources: (_j = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _j === void 0 ? void 0 : _j.resources
            };
            message = (0, $baxuF.createSiweMessage)(siweMessage);
            // Sign message
            signature = await resolvedWallet.request({
                method: 'personal_sign',
                params: [
                    (0, $baxuF.toHex)(message),
                    address
                ]
            });
        }
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'ethereum',
                    message: message,
                    signature: signature
                }, ((_k = credentials.options) === null || _k === void 0 ? void 0 : _k.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken
                    }
                } : null),
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async signInWithSolana(credentials) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $98hXt.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('solana' in windowAny && typeof windowAny.solana === 'object' && ('signIn' in windowAny.solana && typeof windowAny.solana.signIn === 'function' || 'signMessage' in windowAny.solana && typeof windowAny.solana.signMessage === 'function')) resolvedWallet = windowAny.solana;
                else throw new Error(`@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            if ('signIn' in resolvedWallet && resolvedWallet.signIn) {
                const output = await resolvedWallet.signIn(Object.assign(Object.assign(Object.assign({
                    issuedAt: new Date().toISOString()
                }, options === null || options === void 0 ? void 0 : options.signInWithSolana), {
                    // non-overridable properties
                    version: '1',
                    domain: url.host,
                    uri: url.href
                }), statement ? {
                    statement: statement
                } : null));
                let outputToProcess;
                if (Array.isArray(output) && output[0] && typeof output[0] === 'object') outputToProcess = output[0];
                else if (output && typeof output === 'object' && 'signedMessage' in output && 'signature' in output) outputToProcess = output;
                else throw new Error('@supabase/auth-js: Wallet method signIn() returned unrecognized value');
                if ('signedMessage' in outputToProcess && 'signature' in outputToProcess && (typeof outputToProcess.signedMessage === 'string' || outputToProcess.signedMessage instanceof Uint8Array) && outputToProcess.signature instanceof Uint8Array) {
                    message = typeof outputToProcess.signedMessage === 'string' ? outputToProcess.signedMessage : new TextDecoder().decode(outputToProcess.signedMessage);
                    signature = outputToProcess.signature;
                } else throw new Error('@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields');
            } else {
                if (!('signMessage' in resolvedWallet) || typeof resolvedWallet.signMessage !== 'function' || !('publicKey' in resolvedWallet) || typeof resolvedWallet !== 'object' || !resolvedWallet.publicKey || !('toBase58' in resolvedWallet.publicKey) || typeof resolvedWallet.publicKey.toBase58 !== 'function') throw new Error('@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API');
                message = [
                    `${url.host} wants you to sign in with your Solana account:`,
                    resolvedWallet.publicKey.toBase58(),
                    ...statement ? [
                        '',
                        statement,
                        ''
                    ] : [
                        ''
                    ],
                    'Version: 1',
                    `URI: ${url.href}`,
                    `Issued At: ${(_c = (_b = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _b === void 0 ? void 0 : _b.issuedAt) !== null && _c !== void 0 ? _c : new Date().toISOString()}`,
                    ...((_d = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _d === void 0 ? void 0 : _d.notBefore) ? [
                        `Not Before: ${options.signInWithSolana.notBefore}`
                    ] : [],
                    ...((_e = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _e === void 0 ? void 0 : _e.expirationTime) ? [
                        `Expiration Time: ${options.signInWithSolana.expirationTime}`
                    ] : [],
                    ...((_f = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _f === void 0 ? void 0 : _f.chainId) ? [
                        `Chain ID: ${options.signInWithSolana.chainId}`
                    ] : [],
                    ...((_g = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _g === void 0 ? void 0 : _g.nonce) ? [
                        `Nonce: ${options.signInWithSolana.nonce}`
                    ] : [],
                    ...((_h = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _h === void 0 ? void 0 : _h.requestId) ? [
                        `Request ID: ${options.signInWithSolana.requestId}`
                    ] : [],
                    ...((_k = (_j = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _j === void 0 ? void 0 : _j.resources) === null || _k === void 0 ? void 0 : _k.length) ? [
                        'Resources',
                        ...options.signInWithSolana.resources.map((resource)=>`- ${resource}`)
                    ] : []
                ].join('\n');
                const maybeSignature = await resolvedWallet.signMessage(new TextEncoder().encode(message), 'utf8');
                if (!maybeSignature || !(maybeSignature instanceof Uint8Array)) throw new Error('@supabase/auth-js: Wallet signMessage() API returned an recognized value');
                signature = maybeSignature;
            }
        }
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'solana',
                    message: message,
                    signature: (0, $iSR6L.bytesToBase64URL)(signature)
                }, ((_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken
                    }
                } : null),
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $98hXt.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            if (!codeVerifier && this.flowType === 'pkce') throw new (0, $fTIQY.AuthPKCECodeVerifierMissingError)();
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $doWUR._sessionResponse)
            });
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        redirectType: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $doWUR._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: data,
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number.');
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data) {
                const tokenVerificationError = new Error('An error occurred on token verification.');
                throw tokenVerificationError;
            }
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c, _d, _e;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const result = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $doWUR._ssoResponse)
            });
            // Automatically redirect in browser unless skipBrowserRedirect is true
            if (((_d = result.data) === null || _d === void 0 ? void 0 : _d.url) && (0, $98hXt.isBrowser)() && !((_e = params.options) === null || _e === void 0 ? void 0 : _e.skipBrowserRedirect)) window.location.assign(result.data.url);
            return this._returnResult(result);
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $fTIQY.AuthSessionMissingError)();
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $44TzP.EXPIRY_MARGIN_MS) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.userStorage) {
                    const maybeUser = await (0, $98hXt.getItemAsync)(this.userStorage, this.storageKey + '-user');
                    if (maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) currentSession.user = maybeUser.user;
                    else currentSession.user = (0, $98hXt.userNotAvailableProxy)();
                }
                // Wrap the user object with a warning proxy on the server
                // This warns when properties of the user are accessed, not when session.user itself is accessed
                if (this.storage.isServer && currentSession.user && !currentSession.user.__isUserNotAvailableProxy) {
                    const suppressWarningRef = {
                        value: this.suppressGetSessionWarning
                    };
                    currentSession.user = (0, $98hXt.insecureUserWarningProxy)(currentSession.user, suppressWarningRef);
                    // Update the client-level suppression flag when the proxy suppresses the warning
                    if (suppressWarningRef.value) this.suppressGetSessionWarning = true;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return this._returnResult({
                data: {
                    session: null
                },
                error: error
            });
            return this._returnResult({
                data: {
                    session: session
                },
                error: null
            });
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._getUser();
        });
        if (result.data.user) this.suppressGetSessionWarning = true;
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $doWUR._userResponse)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                };
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $doWUR._userResponse)
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) {
                if ((0, $fTIQY.isAuthSessionMissingError)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return this._returnResult({
                    data: {
                        user: null
                    },
                    error: error
                });
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $fTIQY.AuthSessionMissingError)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $doWUR._userResponse)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return this._returnResult({
                    data: {
                        user: session.user
                    },
                    error: null
                });
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $fTIQY.AuthSessionMissingError)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $98hXt.decodeJWT)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { data: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $fTIQY.AuthSessionMissingError)();
                const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!session) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                });
                return this._returnResult({
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $98hXt.isBrowser)()) throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $fTIQY.AuthImplicitGrantRedirectError)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $fTIQY.AuthPKCEGrantCodeExchangeError)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $fTIQY.AuthPKCEGrantCodeExchangeError)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return this._returnResult({
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     *
     * If `detectSessionInUrl` is a function, it will be called with the URL and params to determine
     * if the URL should be processed as a Supabase auth callback. This allows users to exclude
     * URLs from other OAuth providers (e.g., Facebook Login) that also return access_token in the fragment.
     */ _isImplicitGrantCallback(params) {
        if (typeof this.detectSessionInUrl === 'function') return this.detectSessionInUrl(new URL(window.location.href), params);
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $98hXt.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError && !(0, $fTIQY.isAuthSessionMissingError)(sessionError)) return this._returnResult({
                error: sessionError
            });
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $fTIQY.isAuthApiError)(error) && (error.status === 404 || error.status === 401 || error.status === 403) || (0, $fTIQY.isAuthSessionMissingError)(error))) return this._returnResult({
                        error: error
                    });
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return this._returnResult({
                error: null
            });
        });
    }
    onAuthStateChange(callback) {
        const id = (0, $98hXt.generateCallbackId)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return this._returnResult({
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async linkIdentity(credentials) {
        if ('token' in credentials) return this.linkIdentityIdToken(credentials);
        return this.linkIdentityOAuth(credentials);
    }
    async linkIdentityOAuth(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $98hXt.isBrowser)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            });
            throw error;
        }
    }
    async linkIdentityIdToken(credentials) {
        return await this._useSession(async (result)=>{
            var _a;
            try {
                const { error: sessionError, data: { session: session } } = result;
                if (sessionError) throw sessionError;
                const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
                const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                    headers: this.headers,
                    jwt: (_a = session === null || session === void 0 ? void 0 : session.access_token) !== null && _a !== void 0 ? _a : undefined,
                    body: {
                        provider: provider,
                        id_token: token,
                        access_token: access_token,
                        nonce: nonce,
                        link_identity: true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
                const { data: data, error: error } = res;
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                else if (!data || !data.session || !data.user) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: new (0, $fTIQY.AuthInvalidTokenResponseError)()
                });
                if (data.session) {
                    await this._saveSession(data.session);
                    await this._notifyAllSubscribers('USER_UPDATED', data.session);
                }
                return this._returnResult({
                    data: data,
                    error: error
                });
            } catch (error) {
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $98hXt.retryable)(async (attempt)=>{
                if (attempt > 0) await (0, $98hXt.sleep)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $doWUR._sessionResponse)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $fTIQY.isAuthRetryableFetchError)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $98hXt.isBrowser)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a, _b;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey);
            if (currentSession && this.userStorage) {
                let maybeUser = await (0, $98hXt.getItemAsync)(this.userStorage, this.storageKey + '-user');
                if (!this.storage.isServer && Object.is(this.storage, this.userStorage) && !maybeUser) {
                    // storage and userStorage are the same storage medium, for example
                    // window.localStorage if userStorage does not have the user from
                    // storage stored, store it first thereby migrating the user object
                    // from storage -> userStorage
                    maybeUser = {
                        user: currentSession.user
                    };
                    await (0, $98hXt.setItemAsync)(this.userStorage, this.storageKey + '-user', maybeUser);
                }
                currentSession.user = (_a = maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) !== null && _a !== void 0 ? _a : (0, $98hXt.userNotAvailableProxy)();
            } else if (currentSession && !currentSession.user) // user storage is not set, let's check if it was previously enabled so
            // we bring back the storage as it should be
            {
                if (!currentSession.user) {
                    // test if userStorage was previously enabled and the storage medium was the same, to move the user back under the same key
                    const separateUser = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey + '-user');
                    if (separateUser && (separateUser === null || separateUser === void 0 ? void 0 : separateUser.user)) {
                        currentSession.user = separateUser.user;
                        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-user');
                        await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, currentSession);
                    } else currentSession.user = (0, $98hXt.userNotAvailableProxy)();
                }
            }
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_b = currentSession.expires_at) !== null && _b !== void 0 ? _b : Infinity) * 1000 - Date.now() < (0, $44TzP.EXPIRY_MARGIN_MS);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $44TzP.EXPIRY_MARGIN_MS)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $fTIQY.isAuthRetryableFetchError)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else if (currentSession.user && currentSession.user.__isUserNotAvailableProxy === true) // If we have a proxy user, try to get the real user data
            try {
                const { data: data, error: userError } = await this._getUser(currentSession.access_token);
                if (!userError && (data === null || data === void 0 ? void 0 : data.user)) {
                    currentSession.user = data.user;
                    await this._saveSession(currentSession);
                    await this._notifyAllSubscribers('SIGNED_IN', currentSession);
                } else this._debug(debugName, 'could not get user data, skipping SIGNED_IN notification');
            } catch (getUserError) {
                console.error('Error getting user data:', getUserError);
                this._debug(debugName, 'error getting user data, skipping SIGNED_IN notification', getUserError);
            }
            else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $fTIQY.AuthSessionMissingError)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $98hXt.Deferred)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $fTIQY.AuthSessionMissingError)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                data: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $fTIQY.isAuthError)(error)) {
                const result = {
                    data: null,
                    error: error
                };
                if (!(0, $fTIQY.isAuthRetryableFetchError)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        // Create a shallow copy to work with, to avoid mutating the original session object if it's used elsewhere
        const sessionToProcess = Object.assign({}, session);
        const userIsProxy = sessionToProcess.user && sessionToProcess.user.__isUserNotAvailableProxy === true;
        if (this.userStorage) {
            if (!userIsProxy && sessionToProcess.user) // If it's a real user object, save it to userStorage.
            await (0, $98hXt.setItemAsync)(this.userStorage, this.storageKey + '-user', {
                user: sessionToProcess.user
            });
            else userIsProxy;
            // Prepare the main session data for primary storage: remove the user property before cloning
            // This is important because the original session.user might be the proxy
            const mainSessionData = Object.assign({}, sessionToProcess);
            delete mainSessionData.user; // Remove user (real or proxy) before cloning for main storage
            const clonedMainSessionData = (0, $98hXt.deepClone)(mainSessionData);
            await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, clonedMainSessionData);
        } else {
            // No userStorage is configured.
            // In this case, session.user should ideally not be a proxy.
            // If it were, structuredClone would fail. This implies an issue elsewhere if user is a proxy here
            const clonedSession = (0, $98hXt.deepClone)(sessionToProcess); // sessionToProcess still has its original user property
            await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, clonedSession);
        }
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        this.suppressGetSessionWarning = false;
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey);
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-code-verifier');
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-user');
        if (this.userStorage) await (0, $98hXt.removeItemAsync)(this.userStorage, this.storageKey + '-user');
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $98hXt.isBrowser)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        const timeout = setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
        this.autoRefreshTickTimeout = timeout;
        if (timeout && typeof timeout === 'object' && typeof timeout.unref === 'function') timeout.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(timeout);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
        const timeout = this.autoRefreshTickTimeout;
        this.autoRefreshTickTimeout = null;
        if (timeout) clearTimeout(timeout);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS)}ms, refresh threshold is ${(0, $44TzP.AUTO_REFRESH_TICK_THRESHOLD)} ticks`);
                            if (expiresInTicks <= (0, $44TzP.AUTO_REFRESH_TICK_THRESHOLD)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $gn0EB.LockAcquireTimeoutError)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $98hXt.isBrowser)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>{
                try {
                    await this._onVisibilityChanged(false);
                } catch (error) {
                    this._debug('#visibilityChangedCallback', 'error', error);
                }
            };
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : params.factorType === 'totp' ? {
                    issuer: params.issuer
                } : {});
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                if (params.factorType === 'totp' && data.type === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _verify(params) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const body = Object.assign({
                        challenge_id: params.challengeId
                    }, 'webauthn' in params ? {
                        webauthn: Object.assign(Object.assign({}, params.webauthn), {
                            credential_response: params.webauthn.type === 'create' ? (0, $2GmzD.serializeCredentialCreationResponse)(params.webauthn.credential_response) : (0, $2GmzD.serializeCredentialRequestResponse)(params.webauthn.credential_response)
                        })
                    } : {
                        code: params.code
                    });
                    const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: body,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return this._returnResult({
                        data: null,
                        error: error
                    });
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return this._returnResult({
                        data: data,
                        error: error
                    });
                });
            } catch (error) {
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    async _challenge(params) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: params,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (response.error) return response;
                    const { data: data } = response;
                    if (data.type !== 'webauthn') return {
                        data: data,
                        error: null
                    };
                    switch(data.webauthn.type){
                        case 'create':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $2GmzD.deserializeCredentialCreationOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                        case 'request':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $2GmzD.deserializeCredentialRequestOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                    }
                });
            } catch (error) {
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return this._returnResult({
            data: null,
            error: challengeError
        });
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        var _a;
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const data = {
            all: [],
            phone: [],
            totp: [],
            webauthn: []
        };
        // loop over the factors ONCE
        for (const factor of (_a = user === null || user === void 0 ? void 0 : user.factors) !== null && _a !== void 0 ? _a : []){
            data.all.push(factor);
            if (factor.status === 'verified') data[factor.factor_type].push(factor);
        }
        return {
            data: data,
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel(jwt) {
        var _a, _b, _c, _d;
        if (jwt) try {
            const { payload: payload } = (0, $98hXt.decodeJWT)(jwt);
            let currentLevel = null;
            if (payload.aal) currentLevel = payload.aal;
            let nextLevel = currentLevel;
            const { data: { user: user }, error: userError } = await this.getUser(jwt);
            if (userError) return this._returnResult({
                data: null,
                error: userError
            });
            const verifiedFactors = (_b = (_a = user === null || user === void 0 ? void 0 : user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
            if (verifiedFactors.length > 0) nextLevel = 'aal2';
            const currentAuthenticationMethods = payload.amr || [];
            return {
                data: {
                    currentLevel: currentLevel,
                    nextLevel: nextLevel,
                    currentAuthenticationMethods: currentAuthenticationMethods
                },
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
        const { data: { session: session }, error: sessionError } = await this.getSession();
        if (sessionError) return this._returnResult({
            data: null,
            error: sessionError
        });
        if (!session) return {
            data: {
                currentLevel: null,
                nextLevel: null,
                currentAuthenticationMethods: []
            },
            error: null
        };
        const { payload: payload } = (0, $98hXt.decodeJWT)(session.access_token);
        let currentLevel = null;
        if (payload.aal) currentLevel = payload.aal;
        let nextLevel = currentLevel;
        const verifiedFactors = (_d = (_c = session.user.factors) === null || _c === void 0 ? void 0 : _c.filter((factor)=>factor.status === 'verified')) !== null && _d !== void 0 ? _d : [];
        if (verifiedFactors.length > 0) nextLevel = 'aal2';
        const currentAuthenticationMethods = payload.amr || [];
        return {
            data: {
                currentLevel: currentLevel,
                nextLevel: nextLevel,
                currentAuthenticationMethods: currentAuthenticationMethods
            },
            error: null
        };
    }
    /**
     * Retrieves details about an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * Returns authorization details including client info, scopes, and user information.
     * If the response includes only a redirect_url field, it means consent was already given - the caller
     * should handle the redirect manually if needed.
     */ async _getAuthorizationDetails(authorizationId) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/oauth/authorizations/${authorizationId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Approves an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _approveAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'approve'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $98hXt.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Denies an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _denyAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'deny'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $98hXt.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Lists all OAuth grants that the authenticated user has authorized.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _listOAuthGrants() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Revokes a user's OAuth grant for a specific client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _revokeOAuthGrant(options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    query: {
                        client_id: options.clientId
                    },
                    noResolveJson: true
                });
                return {
                    data: {},
                    error: null
                };
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        const now = Date.now();
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $44TzP.JWKS_TTL) > now) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) return null;
        this.jwks = data;
        this.jwks_cached_at = now;
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) return null;
        return jwk;
    }
    /**
     * Extracts the JWT claims present in the access token by first verifying the
     * JWT against the server's JSON Web Key Set endpoint
     * `/.well-known/jwks.json` which is often cached, resulting in significantly
     * faster responses. Prefer this method over {@link #getUser} which always
     * sends a request to the Auth server for each JWT.
     *
     * If the project is not using an asymmetric JWT signing key (like ECC or
     * RSA) it always sends a request to the Auth server (similar to {@link
     * #getUser}) to verify the JWT.
     *
     * @param jwt An optional specific JWT you wish to verify, not the one you
     *            can obtain from {@link #getSession}.
     * @param options Various additional options that allow you to customize the
     *                behavior of this method.
     */ async getClaims(jwt, options = {}) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return this._returnResult({
                    data: null,
                    error: error
                });
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $98hXt.decodeJWT)(token);
            if (!(options === null || options === void 0 ? void 0 : options.allowExpired)) // Reject expired JWTs should only happen if jwt argument was passed
            (0, $98hXt.validateExp)(payload.exp);
            const signingKey = !header.alg || header.alg.startsWith('HS') || !header.kid || !('crypto' in globalThis && 'subtle' in globalThis.crypto) ? null : await this.fetchJwk(header.kid, (options === null || options === void 0 ? void 0 : options.keys) ? {
                keys: options.keys
            } : options === null || options === void 0 ? void 0 : options.jwks);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!signingKey) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $98hXt.getAlgorithm)(header.alg);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $iSR6L.stringToUint8Array)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $fTIQY.AuthInvalidJwtError)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
}
$8025f0dcbc879582$var$GoTrueClient.nextInstanceID = {};
var $8025f0dcbc879582$export$2e2bcd8739ae039 = $8025f0dcbc879582$var$GoTrueClient;

});
parcelRegister("a7BAw", function(module, exports) {

$parcel$export(module.exports, "memoryLocalStorageAdapter", () => $75e7b709645121aa$export$d791f66d7e5710cf);
/**
 * Returns a localStorage-like object that stores the key-value pairs in
 * memory.
 */ function $75e7b709645121aa$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}

});

parcelRegister("gn0EB", function(module, exports) {

$parcel$export(module.exports, "internals", () => $031357f45f79c67e$export$e368aba7747330f2);
$parcel$export(module.exports, "LockAcquireTimeoutError", () => $031357f45f79c67e$export$23e9464cc010dff9);
$parcel$export(module.exports, "NavigatorLockAcquireTimeoutError", () => $031357f45f79c67e$export$4aa56776043a4631);
$parcel$export(module.exports, "navigatorLock", () => $031357f45f79c67e$export$f4ff21938fb7af3c);
$parcel$export(module.exports, "processLock", () => $031357f45f79c67e$export$b21ec9b2268372c7);

var $98hXt = parcelRequire("98hXt");
const $031357f45f79c67e$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $98hXt.supportsLocalStorage)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $031357f45f79c67e$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $031357f45f79c67e$export$4aa56776043a4631 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
class $031357f45f79c67e$export$4b982ee840d3d915 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
async function $031357f45f79c67e$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    let acquireTimeoutTimer;
    if (acquireTimeout > 0) acquireTimeoutTimer = setTimeout(()=>{
        abortController.abort();
        if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    await Promise.resolve();
    try {
        return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                // Lock acquired — cancel the acquire-timeout timer so it cannot fire
                // while fn() is running. Without this, a delayed timeout abort would
                // set signal.aborted = true even though we already hold the lock,
                // causing a subsequent steal to be misclassified as "our timeout
                // fired" and triggering a spurious steal-back cascade.
                clearTimeout(acquireTimeoutTimer);
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $031357f45f79c67e$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                clearTimeout(acquireTimeoutTimer);
                return await fn();
            }
        });
    } catch (e) {
        // Always clear the acquire timeout once the request settles, so it cannot
        // fire later and incorrectly abort/log after a rejection.
        if (acquireTimeout > 0) clearTimeout(acquireTimeoutTimer);
        if ((e === null || e === void 0 ? void 0 : e.name) === 'AbortError' && acquireTimeout > 0) {
            if (abortController.signal.aborted) {
                // OUR timeout fired — the lock is genuinely orphaned. Steal it.
                //
                // The lock acquisition was aborted because the timeout fired while the
                // request was still pending. This typically means another lock holder is
                // not releasing the lock, possibly due to React Strict Mode's
                // double-mount/unmount behavior or a component unmounting mid-operation,
                // leaving an orphaned lock.
                //
                // Recovery: use { steal: true } to forcefully acquire the lock. Per the
                // Web Locks API spec, this releases any currently held lock with the same
                // name and grants the request immediately, preempting any queued requests.
                // The previous holder's callback continues running to completion but no
                // longer holds the lock for exclusion purposes.
                //
                // See: https://github.com/supabase/supabase/issues/42505
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire timeout, recovering by stealing lock', name);
                console.warn(`@supabase/gotrue-js: Lock "${name}" was not released within ${acquireTimeout}ms. ` + 'This may indicate an orphaned lock from a component unmount (e.g., React Strict Mode). ' + 'Forcefully acquiring the lock to recover.');
                return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, {
                        mode: 'exclusive',
                        steal: true
                    }, async (lock)=>{
                        if (lock) {
                            if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: recovered (stolen)', name, lock.name);
                            try {
                                return await fn();
                            } finally{
                                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released (stolen)', name, lock.name);
                            }
                        } else {
                            // This should not happen with steal: true, but handle gracefully.
                            console.warn('@supabase/gotrue-js: Navigator LockManager returned null lock even with steal: true');
                            return await fn();
                        }
                    }));
            } else {
                // We HELD the lock but another request stole it from us.
                // Per the Web Locks spec, our fn() callback is still running as an
                // orphaned background task — do NOT steal back. Stealing back would
                // cause a cascade (A steals B, B steals A, ...) and run fn() a second
                // time concurrently, corrupting auth state.
                // Convert to a typed error so callers (e.g. _autoRefreshTokenTick)
                // can handle/filter it without it leaking to Sentry as a raw AbortError.
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: lock was stolen by another request', name);
                throw new $031357f45f79c67e$export$4aa56776043a4631(`Lock "${name}" was released because another request stole it`);
            }
        }
        throw e;
    }
}
const $031357f45f79c67e$var$PROCESS_LOCKS = {};
async function $031357f45f79c67e$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $031357f45f79c67e$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    // Wrap previousOperation to handle errors without using .catch()
    // This avoids Firefox content script security errors
    const previousOperationHandled = (async ()=>{
        try {
            await previousOperation;
            return null;
        } catch (e) {
            // ignore error of previous operation that we're waiting to finish
            return null;
        }
    })();
    const currentOperation = (async ()=>{
        let timeoutId = null;
        try {
            // Wait for either previous operation or timeout
            const timeoutPromise = acquireTimeout >= 0 ? new Promise((_, reject)=>{
                timeoutId = setTimeout(()=>{
                    console.warn(`@supabase/gotrue-js: Lock "${name}" acquisition timed out after ${acquireTimeout}ms. ` + 'This may be caused by another operation holding the lock. ' + 'Consider increasing lockAcquireTimeout or checking for stuck operations.');
                    reject(new $031357f45f79c67e$export$4b982ee840d3d915(`Acquiring process lock with name "${name}" timed out`));
                }, acquireTimeout);
            }) : null;
            await Promise.race([
                previousOperationHandled,
                timeoutPromise
            ].filter((x)=>x));
            // If we reach here, previousOperationHandled won the race
            // Clear the timeout to prevent false warnings
            if (timeoutId !== null) clearTimeout(timeoutId);
        } catch (e) {
            // Clear the timeout on error path as well
            if (timeoutId !== null) clearTimeout(timeoutId);
            // Re-throw timeout errors, ignore others
            if (e && e.isAcquireTimeout) throw e;
        // Fall through to run fn() - previous operation finished with error
        }
        // Previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    })();
    $031357f45f79c67e$var$PROCESS_LOCKS[name] = (async ()=>{
        try {
            return await currentOperation;
        } catch (e) {
            if (e && e.isAcquireTimeout) {
                // if the current operation timed out, it doesn't mean that the previous
                // operation finished, so we need continue waiting for it to finish
                try {
                    await previousOperation;
                } catch (prevError) {
                // Ignore previous operation errors
                }
                return null;
            }
            throw e;
        }
    })();
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}

});

parcelRegister("8WDEC", function(module, exports) {

$parcel$export(module.exports, "polyfillGlobalThis", () => $68327ffe4e2befb5$export$ad067ce270531206);
/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $68327ffe4e2befb5$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}

});

parcelRegister("baxuF", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $821a9c05c0953df2$export$88411125f012957a);
$parcel$export(module.exports, "fromHex", () => $821a9c05c0953df2$export$1a8ceedbd5845648);
$parcel$export(module.exports, "toHex", () => $821a9c05c0953df2$export$7ea66e3774a60b67);
$parcel$export(module.exports, "createSiweMessage", () => $821a9c05c0953df2$export$7ee2e5fde403d4c8);
// types and functions copied over from viem so this library doesn't depend on it
function $821a9c05c0953df2$export$88411125f012957a(address) {
    if (!/^0x[a-fA-F0-9]{40}$/.test(address)) throw new Error(`@supabase/auth-js: Address "${address}" is invalid.`);
    return address.toLowerCase();
}
function $821a9c05c0953df2$export$1a8ceedbd5845648(hex) {
    return parseInt(hex, 16);
}
function $821a9c05c0953df2$export$7ea66e3774a60b67(value) {
    const bytes = new TextEncoder().encode(value);
    const hex = Array.from(bytes, (byte)=>byte.toString(16).padStart(2, '0')).join('');
    return '0x' + hex;
}
function $821a9c05c0953df2$export$7ee2e5fde403d4c8(parameters) {
    var _a;
    const { chainId: chainId, domain: domain, expirationTime: expirationTime, issuedAt: issuedAt = new Date(), nonce: nonce, notBefore: notBefore, requestId: requestId, resources: resources, scheme: scheme, uri: uri, version: version } = parameters;
    if (!Number.isInteger(chainId)) throw new Error(`@supabase/auth-js: Invalid SIWE message field "chainId". Chain ID must be a EIP-155 chain ID. Provided value: ${chainId}`);
    if (!domain) throw new Error(`@supabase/auth-js: Invalid SIWE message field "domain". Domain must be provided.`);
    if (nonce && nonce.length < 8) throw new Error(`@supabase/auth-js: Invalid SIWE message field "nonce". Nonce must be at least 8 characters. Provided value: ${nonce}`);
    if (!uri) throw new Error(`@supabase/auth-js: Invalid SIWE message field "uri". URI must be provided.`);
    if (version !== '1') throw new Error(`@supabase/auth-js: Invalid SIWE message field "version". Version must be '1'. Provided value: ${version}`);
    if ((_a = parameters.statement) === null || _a === void 0 ? void 0 : _a.includes('\n')) throw new Error(`@supabase/auth-js: Invalid SIWE message field "statement". Statement must not include '\\n'. Provided value: ${parameters.statement}`);
    // Construct message
    const address = $821a9c05c0953df2$export$88411125f012957a(parameters.address);
    const origin = scheme ? `${scheme}://${domain}` : domain;
    const statement = parameters.statement ? `${parameters.statement}\n` : '';
    const prefix = `${origin} wants you to sign in with your Ethereum account:\n${address}\n\n${statement}`;
    let suffix = `URI: ${uri}\nVersion: ${version}\nChain ID: ${chainId}${nonce ? `\nNonce: ${nonce}` : ''}\nIssued At: ${issuedAt.toISOString()}`;
    if (expirationTime) suffix += `\nExpiration Time: ${expirationTime.toISOString()}`;
    if (notBefore) suffix += `\nNot Before: ${notBefore.toISOString()}`;
    if (requestId) suffix += `\nRequest ID: ${requestId}`;
    if (resources) {
        let content = '\nResources:';
        for (const resource of resources){
            if (!resource || typeof resource !== 'string') throw new Error(`@supabase/auth-js: Invalid SIWE message field "resources". Every resource must be a valid string. Provided value: ${resource}`);
            content += `\n- ${resource}`;
        }
        suffix += content;
    }
    return `${prefix}\n${suffix}`;
}

});

parcelRegister("2GmzD", function(module, exports) {

$parcel$export(module.exports, "deserializeCredentialCreationOptions", () => $1f4103b2c99735be$export$d02e6c69c68605f0);
$parcel$export(module.exports, "deserializeCredentialRequestOptions", () => $1f4103b2c99735be$export$943ff00a541d1017);
$parcel$export(module.exports, "serializeCredentialCreationResponse", () => $1f4103b2c99735be$export$4b534f6222f6d585);
$parcel$export(module.exports, "serializeCredentialRequestResponse", () => $1f4103b2c99735be$export$b3350da6d3acaa5a);
$parcel$export(module.exports, "isValidDomain", () => $1f4103b2c99735be$export$59e759560deddc3c);
$parcel$export(module.exports, "WebAuthnApi", () => $1f4103b2c99735be$export$23264e48ebb7dee0);

var $7WQrb = parcelRequire("7WQrb");

var $iSR6L = parcelRequire("iSR6L");

var $fTIQY = parcelRequire("fTIQY");

var $98hXt = parcelRequire("98hXt");

var $3SAvc = parcelRequire("3SAvc");
class $1f4103b2c99735be$export$442ada5d34ca6e87 {
    /**
     * Create an abort signal for a new WebAuthn operation.
     * Automatically cancels any existing operation.
     *
     * @returns {AbortSignal} Signal to pass to navigator.credentials.create() or .get()
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal MDN - AbortSignal}
     */ createNewAbortSignal() {
        // Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
        if (this.controller) {
            const abortError = new Error('Cancelling existing WebAuthn API call for new one');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    /**
     * Manually cancel the current WebAuthn operation.
     * Useful for cleaning up when user cancels or navigates away.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort MDN - AbortController.abort}
     */ cancelCeremony() {
        if (this.controller) {
            const abortError = new Error('Manually cancelling existing WebAuthn API call');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const $1f4103b2c99735be$export$4109de07ec7c8bef = new $1f4103b2c99735be$export$442ada5d34ca6e87();
function $1f4103b2c99735be$export$d02e6c69c68605f0(options) {
    if (!options) throw new Error('Credential creation options are required');
    // Check if the native parseCreationOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseCreationOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseCreationOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseCreationOptionsFromJSON(/** we assert the options here as typescript still doesn't know about future webauthn types */ options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, user: userOpts, excludeCredentials: excludeCredentials } = options, restOptions = (0, $7WQrb.__rest)(options, [
        "challenge",
        "user",
        "excludeCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $iSR6L.base64UrlToUint8Array)(challengeStr).buffer;
    // Convert user.id from base64url to ArrayBuffer
    const user = Object.assign(Object.assign({}, userOpts), {
        id: (0, $iSR6L.base64UrlToUint8Array)(userOpts.id).buffer
    });
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge,
        user: user
    });
    // Only add excludeCredentials if it exists
    if (excludeCredentials && excludeCredentials.length > 0) {
        result.excludeCredentials = new Array(excludeCredentials.length);
        for(let i = 0; i < excludeCredentials.length; i++){
            const cred = excludeCredentials[i];
            result.excludeCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $iSR6L.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $1f4103b2c99735be$export$943ff00a541d1017(options) {
    if (!options) throw new Error('Credential request options are required');
    // Check if the native parseRequestOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseRequestOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseRequestOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseRequestOptionsFromJSON(options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, allowCredentials: allowCredentials } = options, restOptions = (0, $7WQrb.__rest)(options, [
        "challenge",
        "allowCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $iSR6L.base64UrlToUint8Array)(challengeStr).buffer;
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge
    });
    // Only add allowCredentials if it exists
    if (allowCredentials && allowCredentials.length > 0) {
        result.allowCredentials = new Array(allowCredentials.length);
        for(let i = 0; i < allowCredentials.length; i++){
            const cred = allowCredentials[i];
            result.allowCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $iSR6L.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $1f4103b2c99735be$export$4b534f6222f6d585(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    const credentialWithAttachment = credential;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            attestationObject: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(credential.response.attestationObject)),
            clientDataJSON: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(credential.response.clientDataJSON))
        },
        type: 'public-key',
        clientExtensionResults: credential.getClientExtensionResults(),
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $1f4103b2c99735be$export$b3350da6d3acaa5a(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    // Fallback to manual conversion for browsers that don't support toJSON
    // Access authenticatorAttachment via type assertion to handle TypeScript version differences
    // @simplewebauthn/types includes this property but base TypeScript 4.7.4 doesn't
    const credentialWithAttachment = credential;
    const clientExtensionResults = credential.getClientExtensionResults();
    const assertionResponse = credential.response;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            authenticatorData: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.authenticatorData)),
            clientDataJSON: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.clientDataJSON)),
            signature: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.signature)),
            userHandle: assertionResponse.userHandle ? (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.userHandle)) : undefined
        },
        type: 'public-key',
        clientExtensionResults: clientExtensionResults,
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $1f4103b2c99735be$export$59e759560deddc3c(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}
/**
 * Determine if the browser is capable of WebAuthn.
 * Checks for necessary Web APIs: PublicKeyCredential and Credential Management.
 *
 * @returns {boolean} True if browser supports WebAuthn
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential#browser_compatibility MDN - PublicKeyCredential Browser Compatibility}
 */ function $1f4103b2c99735be$var$browserSupportsWebAuthn() {
    var _a, _b;
    return !!((0, $98hXt.isBrowser)() && 'PublicKeyCredential' in window && window.PublicKeyCredential && 'credentials' in navigator && typeof ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _a === void 0 ? void 0 : _a.create) === 'function' && typeof ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _b === void 0 ? void 0 : _b.get) === 'function');
}
async function $1f4103b2c99735be$export$e4658562cd85d5e4(options) {
    try {
        const response = await navigator.credentials.create(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $3SAvc.identifyRegistrationError)({
                error: err,
                options: options
            })
        };
    }
}
async function $1f4103b2c99735be$export$298c59008c641b3e(options) {
    try {
        const response = await navigator.credentials.get(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $3SAvc.identifyAuthenticationError)({
                error: err,
                options: options
            })
        };
    }
}
const $1f4103b2c99735be$export$315ccaead2259c48 = {
    hints: [
        'security-key'
    ],
    authenticatorSelection: {
        authenticatorAttachment: 'cross-platform',
        requireResidentKey: false,
        /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
        residentKey: 'discouraged'
    },
    attestation: 'direct'
};
const $1f4103b2c99735be$export$26eadd1e9f10eb21 = {
    /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
    hints: [
        'security-key'
    ],
    attestation: 'direct'
};
function $1f4103b2c99735be$var$deepMerge(...sources) {
    const isObject = (val)=>val !== null && typeof val === 'object' && !Array.isArray(val);
    const isArrayBufferLike = (val)=>val instanceof ArrayBuffer || ArrayBuffer.isView(val);
    const result = {};
    for (const source of sources){
        if (!source) continue;
        for(const key in source){
            const value = source[key];
            if (value === undefined) continue;
            if (Array.isArray(value)) // preserve array reference, including unions like AuthenticatorTransport[]
            result[key] = value;
            else if (isArrayBufferLike(value)) result[key] = value;
            else if (isObject(value)) {
                const existing = result[key];
                if (isObject(existing)) result[key] = $1f4103b2c99735be$var$deepMerge(existing, value);
                else result[key] = $1f4103b2c99735be$var$deepMerge(value);
            } else result[key] = value;
        }
    }
    return result;
}
function $1f4103b2c99735be$export$3be75f4dca600793(baseOptions, overrides) {
    return $1f4103b2c99735be$var$deepMerge($1f4103b2c99735be$export$315ccaead2259c48, baseOptions, overrides || {});
}
function $1f4103b2c99735be$export$dd12a9ca29190b76(baseOptions, overrides) {
    return $1f4103b2c99735be$var$deepMerge($1f4103b2c99735be$export$26eadd1e9f10eb21, baseOptions, overrides || {});
}
class $1f4103b2c99735be$export$23264e48ebb7dee0 {
    constructor(client){
        this.client = client;
        // Bind all methods so they can be destructured
        this.enroll = this._enroll.bind(this);
        this.challenge = this._challenge.bind(this);
        this.verify = this._verify.bind(this);
        this.authenticate = this._authenticate.bind(this);
        this.register = this._register.bind(this);
    }
    /**
     * Enroll a new WebAuthn factor.
     * Creates an unverified WebAuthn factor that must be verified with a credential.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Omit<MFAEnrollWebauthnParams, 'factorType'>} params - Enrollment parameters (friendlyName required)
     * @returns {Promise<AuthMFAEnrollWebauthnResponse>} Enrolled factor details or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registering a New Credential}
     */ async _enroll(params) {
        return this.client.mfa.enroll(Object.assign(Object.assign({}, params), {
            factorType: 'webauthn'
        }));
    }
    /**
     * Challenge for WebAuthn credential creation or authentication.
     * Combines server challenge with browser credential operations.
     * Handles both registration (create) and authentication (request) flows.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {MFAChallengeWebauthnParams & { friendlyName?: string; signal?: AbortSignal }} params - Challenge parameters including factorId
     * @param {Object} overrides - Allows you to override the parameters passed to navigator.credentials
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides.create - Override options for credential creation
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides.request - Override options for credential request
     * @returns {Promise<RequestResult>} Challenge response with credential or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-credential-creation W3C WebAuthn Spec - Credential Creation}
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying Assertion}
     */ async _challenge({ factorId: factorId, webauthn: webauthn, friendlyName: friendlyName, signal: signal }, overrides) {
        var _a;
        try {
            // Get challenge from server using the client's MFA methods
            const { data: challengeResponse, error: challengeError } = await this.client.mfa.challenge({
                factorId: factorId,
                webauthn: webauthn
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const abortSignal = signal !== null && signal !== void 0 ? signal : $1f4103b2c99735be$export$4109de07ec7c8bef.createNewAbortSignal();
            /** webauthn will fail if either of the name/displayname are blank */ if (challengeResponse.webauthn.type === 'create') {
                const { user: user } = challengeResponse.webauthn.credential_options.publicKey;
                if (!user.name) {
                    // Preserve original format: use friendlyName if provided, otherwise fetch fallback
                    // This maintains backward compatibility with the ${user.id}:${name} format
                    const nameToUse = friendlyName;
                    if (!nameToUse) {
                        // Only fetch user data if friendlyName is not provided (bug fix for null friendlyName)
                        const currentUser = await this.client.getUser();
                        const userData = currentUser.data.user;
                        const fallbackName = ((_a = userData === null || userData === void 0 ? void 0 : userData.user_metadata) === null || _a === void 0 ? void 0 : _a.name) || (userData === null || userData === void 0 ? void 0 : userData.email) || (userData === null || userData === void 0 ? void 0 : userData.id) || 'User';
                        user.name = `${user.id}:${fallbackName}`;
                    } else user.name = `${user.id}:${nameToUse}`;
                }
                if (!user.displayName) user.displayName = user.name;
            }
            switch(challengeResponse.webauthn.type){
                case 'create':
                    {
                        const options = $1f4103b2c99735be$export$3be75f4dca600793(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.create);
                        const { data: data, error: error } = await $1f4103b2c99735be$export$e4658562cd85d5e4({
                            publicKey: options,
                            signal: abortSignal
                        });
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
                case 'request':
                    {
                        const options = $1f4103b2c99735be$export$dd12a9ca29190b76(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.request);
                        const { data: data, error: error } = await $1f4103b2c99735be$export$298c59008c641b3e(Object.assign(Object.assign({}, challengeResponse.webauthn.credential_options), {
                            publicKey: options,
                            signal: abortSignal
                        }));
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
            }
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in challenge', error)
            };
        }
    }
    /**
     * Verify a WebAuthn credential with the server.
     * Completes the WebAuthn ceremony by sending the credential to the server for verification.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Verification parameters
     * @param {string} params.challengeId - ID of the challenge being verified
     * @param {string} params.factorId - ID of the WebAuthn factor
     * @param {MFAVerifyWebauthnParams<T>['webauthn']} params.webauthn - WebAuthn credential response
     * @returns {Promise<AuthMFAVerifyResponse>} Verification result with session or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying an Authentication Assertion}
     * */ async _verify({ challengeId: challengeId, factorId: factorId, webauthn: webauthn }) {
        return this.client.mfa.verify({
            factorId: factorId,
            challengeId: challengeId,
            webauthn: webauthn
        });
    }
    /**
     * Complete WebAuthn authentication flow.
     * Performs challenge and verification in a single operation for existing credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Authentication parameters
     * @param {string} params.factorId - ID of the WebAuthn factor to authenticate with
     * @param {Object} params.webauthn - WebAuthn configuration
     * @param {string} params.webauthn.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.webauthn.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.webauthn.signal - Optional abort signal
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides - Override options for navigator.credentials.get
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Authentication result
     * @see {@link https://w3c.github.io/webauthn/#sctn-authentication W3C WebAuthn Spec - Authentication Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialRequestOptions MDN - PublicKeyCredentialRequestOptions}
     */ async _authenticate({ factorId: factorId, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $fTIQY.AuthError)('rpId is required for WebAuthn authentication')
        };
        try {
            if (!$1f4103b2c99735be$var$browserSupportsWebAuthn()) return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Get challenge and credential
            const { data: challengeResponse, error: challengeError } = await this.challenge({
                factorId: factorId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                request: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const { webauthn: webauthn } = challengeResponse;
            // Verify credential
            return this._verify({
                factorId: factorId,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    type: webauthn.type,
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    credential_response: webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in authenticate', error)
            };
        }
    }
    /**
     * Complete WebAuthn registration flow.
     * Performs enrollment, challenge, and verification in a single operation for new credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Registration parameters
     * @param {string} params.friendlyName - User-friendly name for the credential
     * @param {string} params.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.signal - Optional abort signal
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides - Override options for navigator.credentials.create
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Registration result
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registration Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialCreationOptions MDN - PublicKeyCredentialCreationOptions}
     */ async _register({ friendlyName: friendlyName, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $fTIQY.AuthError)('rpId is required for WebAuthn registration')
        };
        try {
            if (!$1f4103b2c99735be$var$browserSupportsWebAuthn()) return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Enroll factor
            const { data: factor, error: enrollError } = await this._enroll({
                friendlyName: friendlyName
            });
            if (!factor) {
                await this.client.mfa.listFactors().then((factors)=>{
                    var _a;
                    return (_a = factors.data) === null || _a === void 0 ? void 0 : _a.all.find((v)=>v.factor_type === 'webauthn' && v.friendly_name === friendlyName && v.status !== 'unverified');
                }).then((factor)=>factor ? this.client.mfa.unenroll({
                        factorId: factor === null || factor === void 0 ? void 0 : factor.id
                    }) : void 0);
                return {
                    data: null,
                    error: enrollError
                };
            }
            // Get challenge and create credential
            const { data: challengeResponse, error: challengeError } = await this._challenge({
                factorId: factor.id,
                friendlyName: factor.friendly_name,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                create: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            return this._verify({
                factorId: factor.id,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    type: challengeResponse.webauthn.type,
                    credential_response: challengeResponse.webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in register', error)
            };
        }
    }
}

});
parcelRegister("3SAvc", function(module, exports) {

$parcel$export(module.exports, "WebAuthnUnknownError", () => $2d32bad54faaeecf$export$2799e3b911935b0d);
$parcel$export(module.exports, "identifyRegistrationError", () => $2d32bad54faaeecf$export$1c18a773f8a28a92);
$parcel$export(module.exports, "identifyAuthenticationError", () => $2d32bad54faaeecf$export$9b62fd498befe529);
/* eslint-disable @typescript-eslint/ban-ts-comment */ 
var $2GmzD = parcelRequire("2GmzD");
class $2d32bad54faaeecf$export$90f0c14a652de832 extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        var _a;
        // @ts-ignore: help Rollup understand that `cause` is okay to set
        super(message, {
            cause: cause
        });
        this.__isWebAuthnError = true;
        this.name = (_a = name !== null && name !== void 0 ? name : cause instanceof Error ? cause.name : undefined) !== null && _a !== void 0 ? _a : 'Unknown Error';
        this.code = code;
    }
}
class $2d32bad54faaeecf$export$2799e3b911935b0d extends $2d32bad54faaeecf$export$90f0c14a652de832 {
    constructor(message, originalError){
        super({
            code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
            cause: originalError,
            message: message
        });
        this.name = 'WebAuthnUnknownError';
        this.originalError = originalError;
    }
}
function $2d32bad54faaeecf$export$8596540875e19045(error) {
    return typeof error === 'object' && error !== null && '__isWebAuthnError' in error;
}
function $2d32bad54faaeecf$export$1c18a773f8a28a92({ error: error, options: options }) {
    var _a, _b, _c;
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Registration ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'ConstraintError') {
        if (((_a = publicKey.authenticatorSelection) === null || _a === void 0 ? void 0 : _a.requireResidentKey) === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Discoverable credentials were required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT',
            cause: error
        });
        else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === 'conditional' && ((_b = publicKey.authenticatorSelection) === null || _b === void 0 ? void 0 : _b.userVerification) === 'required') // https://w3c.github.io/webauthn/#sctn-createCredential (Step 22.4)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User verification was required during automatic registration but it could not be performed',
            code: 'ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE',
            cause: error
        });
        else if (((_c = publicKey.authenticatorSelection) === null || _c === void 0 ? void 0 : _c.userVerification) === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User verification was required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT',
            cause: error
        });
    } else if (error.name === 'InvalidStateError') // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was previously registered',
        code: 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED',
        cause: error
    });
    else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'NotSupportedError') {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === 'public-key');
        if (validPubKeyCredParams.length === 0) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 10)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: 'ERROR_MALFORMED_PUBKEYCREDPARAMS',
            cause: error
        });
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'No available authenticator supported any of the specified pubKeyCredParams algorithms',
            code: 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG',
            cause: error
        });
    } else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $2GmzD.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'TypeError') {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User ID was not between 1 and 64 characters',
            code: 'ERROR_INVALID_USER_ID_LENGTH',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new credential',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}
function $2d32bad54faaeecf$export$9b62fd498befe529({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Authentication ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $2GmzD.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new assertion signature',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}

});



parcelRegister("fCilG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e8a3473c3df521$export$2e2bcd8739ae039);

var $f8esb = parcelRequire("f8esb");
const $b5e8a3473c3df521$var$AuthAdminApi = (0, $f8esb.default);
var $b5e8a3473c3df521$export$2e2bcd8739ae039 = $b5e8a3473c3df521$var$AuthAdminApi;

});

parcelRegister("aALRH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b62653534e595bb$export$2e2bcd8739ae039);

var $b083j = parcelRequire("b083j");
const $7b62653534e595bb$var$AuthClient = (0, $b083j.default);
var $7b62653534e595bb$export$2e2bcd8739ae039 = $7b62653534e595bb$var$AuthClient;

});





var $iTneE = parcelRequire("iTneE");
var $85274e1cff99deb2$export$2e2bcd8739ae039 = {};


var $583e5c65243bf299$export$2e2bcd8739ae039 = {
    // Theme
    darkMode: false,
    lang: 'en',
    activeLangMenu: false,
    // Location
    locationShared: false,
    userLat: null,
    userLng: null,
    showClinicsMap: true,
    // Appointment Modal
    selectedAppointment: null,
    showAppointmentModal: false,
    // Navigation
    activeTab: 'appointments',
    activeAiTool: 'assistant',
    activePatientSection: 'overview',
    // Booking
    activeBookingStep: 1,
    selectedClinic: null,
    selectedClinicId: null,
    selectedService: null,
    selectedDate: null,
    selectedTime: null,
    clinicFilter: '',
    // Patient
    selectedTooth: null,
    // Chart
    selectedSurface: null,
    chartMode: 'odontogram',
    toothData: {},
    // Perio
    currentExamId: 'exam-2024-03',
    selectedExamIds: [
        'exam-2024-03',
        'exam-2023-09'
    ],
    entryMode: 'probing',
    perioData: {},
    // Treatment Plan
    activePlanId: 'plan-a',
    showAlternative: false,
    treatmentPhases: [],
    // Clinical Notes
    selectedNoteDate: null,
    editingNoteId: null,
    templateType: null,
    clinicalNotes: [],
    // Scheduling
    viewMode: 'week',
    currentDate: '2026-03-18',
    selectedOperatory: 'all',
    selectedProvider: 'all',
    // Billing
    billingTab: 'claims',
    selectedClaimId: null,
    // Prescriptions
    activeRxTab: 'active',
    editingRxId: null,
    showInteractions: false,
    // Lab Cases
    labViewMode: 'pipeline',
    selectedCaseId: null,
    // Referrals
    referralDirection: 'all',
    selectedReferralId: null,
    // Reports
    reportType: 'production',
    reportDateRange: 'this-month',
    reportProviderId: 'all',
    // Medical History
    medHistorySection: 'timeline',
    medHistoryPatientId: 'P-1042',
    // Enterprise
    enterprisePanel: 'rbac',
    // Integrations
    integrationCategory: 'all',
    selectedIntegration: null,
    // AI Modal
    showAiModal: false,
    aiModalThread: [],
    aiModalLoading: false,
    // AI
    messages: [
        {
            role: 'assistant',
            content: "\u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10DD\u10D1\u10D0! I am your dental clinical assistant. I can help with treatment planning, clinical notes, drug interactions, and patient communication. How can I help?"
        },
        {
            role: 'user',
            content: 'Patient has periapical lesion on tooth #14 with chronic pain. What treatment options should I consider?'
        },
        {
            role: 'assistant',
            content: "For a periapical lesion on tooth #14 with chronic pain, consider:\n\n1. **Root Canal Treatment (RCT)** \u2014 First-line treatment. Clean, shape, and obturate the canal system. Success rate ~85-95%.\n\n2. **Apicoectomy** \u2014 If RCT fails or retreatment is not feasible. Surgical removal of the apex + retrograde filling.\n\n3. **Extraction + Implant** \u2014 If tooth is non-restorable (extensive decay, fracture, poor prognosis).\n\n**Recommended diagnostics:** Periapical radiograph, vitality test (cold/EPT), probing depths.\n\n**Drug consideration:** Prescribe Amoxicillin 500mg TID for 7 days if acute infection present. Check penicillin allergy first."
        }
    ],
    isTyping: false,
    // Waitlist
    waitlistEmail: '',
    // Clinics - fetched from Supabase
    clinics: [],
    clinicsLoaded: false,
    clinicsVisible: 24,
    // Services
    services: [
        {
            name: 'Implant',
            price: "\u20BE300+",
            emoji: "\uD83E\uDDB7"
        },
        {
            name: 'Whitening',
            price: "\u20BE120",
            emoji: "\u2728"
        },
        {
            name: 'Checkup',
            price: "\u20BE30",
            emoji: "\uD83D\uDD0D"
        },
        {
            name: 'Orthodontics',
            price: "\u20BE1,200",
            emoji: "\uD83E\uDDBF"
        },
        {
            name: 'Surgery',
            price: "\u20BE400",
            emoji: "\uD83C\uDFE5"
        }
    ],
    dates: [
        {
            label: 'Mon 19',
            value: '2026-03-19'
        },
        {
            label: 'Tue 20',
            value: '2026-03-20'
        },
        {
            label: 'Wed 21',
            value: '2026-03-21'
        },
        {
            label: 'Thu 22',
            value: '2026-03-22'
        },
        {
            label: 'Fri 23',
            value: '2026-03-23'
        },
        {
            label: 'Sat 24',
            value: '2026-03-24'
        },
        {
            label: 'Sun 25',
            value: '2026-03-25'
        }
    ],
    times: [
        {
            label: '09:00',
            period: 'Morning'
        },
        {
            label: '10:00',
            period: 'Morning'
        },
        {
            label: '11:00',
            period: 'Morning'
        },
        {
            label: '14:00',
            period: 'Afternoon'
        },
        {
            label: '15:00',
            period: 'Afternoon'
        },
        {
            label: '17:00',
            period: 'Evening'
        }
    ],
    // Dashboard data
    appointments: [
        {
            patient: 'Giorgi Beridze',
            time: '09:00',
            service: 'Checkup',
            doctor: 'Dr. Lomidze',
            status: 'Confirmed'
        },
        {
            patient: 'Nino Kapanadze',
            time: '10:30',
            service: 'Whitening',
            doctor: 'Dr. Kvaratskhelia',
            status: 'Pending'
        },
        {
            patient: 'Davit Gelashvili',
            time: '11:00',
            service: 'Implant Phase 2',
            doctor: 'Dr. Lomidze',
            status: 'Confirmed'
        },
        {
            patient: 'Mariam Tsiklauri',
            time: '14:00',
            service: 'Orthodontics',
            doctor: 'Dr. Beridze',
            status: 'Confirmed'
        },
        {
            patient: 'Ana Javakhishvili',
            time: '15:30',
            service: 'Root Canal',
            doctor: 'Dr. Lomidze',
            status: 'Pending'
        },
        {
            patient: 'Luka Mchedlishvili',
            time: '17:00',
            service: 'Extraction',
            doctor: 'Dr. Kvaratskhelia',
            status: 'Cancelled'
        }
    ],
    patients: [
        {
            name: 'Giorgi Beridze',
            age: 34,
            lastVisit: 'Mar 10',
            nextAppt: 'Mar 19',
            totalVisits: 12,
            phone: '+995 555 11 22 33'
        },
        {
            name: 'Nino Kapanadze',
            age: 28,
            lastVisit: 'Feb 28',
            nextAppt: 'Mar 20',
            totalVisits: 8,
            phone: '+995 599 44 55 66'
        },
        {
            name: 'Davit Gelashvili',
            age: 45,
            lastVisit: 'Mar 5',
            nextAppt: 'Mar 22',
            totalVisits: 23,
            phone: '+995 577 77 88 99'
        },
        {
            name: 'Mariam Tsiklauri',
            age: 31,
            lastVisit: 'Mar 12',
            nextAppt: 'Mar 25',
            totalVisits: 6,
            phone: '+995 555 22 33 44'
        },
        {
            name: 'Ana Javakhishvili',
            age: 52,
            lastVisit: 'Mar 8',
            nextAppt: 'Mar 21',
            totalVisits: 18,
            phone: '+995 599 88 77 66'
        },
        {
            name: 'Luka Mchedlishvili',
            age: 23,
            lastVisit: 'Mar 1',
            nextAppt: 'Apr 5',
            totalVisits: 3,
            phone: '+995 577 33 22 11'
        },
        {
            name: 'Tamara Lomidze',
            age: 67,
            lastVisit: 'Feb 15',
            nextAppt: 'Mar 28',
            totalVisits: 31,
            phone: '+995 322 55 44 33'
        },
        {
            name: 'Irakli Diasamidze',
            age: 41,
            lastVisit: 'Mar 14',
            nextAppt: 'Mar 30',
            totalVisits: 15,
            phone: '+995 555 99 88 77'
        }
    ],
    // Treatment plans
    treatmentPlans: [
        {
            tooth: 14,
            procedure: 'Root Canal Treatment',
            status: 'In Progress',
            price: "\u20BE149",
            doctor: 'Dr. Lomidze'
        },
        {
            tooth: 36,
            procedure: 'Ceramic Crown',
            status: 'Planned',
            price: "\u20BE600",
            doctor: 'Dr. Lomidze'
        },
        {
            tooth: 21,
            procedure: 'Composite Filling',
            status: 'Completed',
            price: "\u20BE80",
            doctor: 'Dr. Kvaratskhelia'
        },
        {
            tooth: 46,
            procedure: 'Implant Placement',
            status: 'Planned',
            price: "\u20BE1,200",
            doctor: 'Dr. Beridze'
        }
    ],
    // Invoices
    invoices: [
        {
            number: 'INV-001',
            patient: 'Giorgi Beridze',
            service: 'Checkup + X-ray',
            amount: "\u20BE80",
            status: 'Paid'
        },
        {
            number: 'INV-002',
            patient: 'Nino Kapanadze',
            service: 'Whitening',
            amount: "\u20BE120",
            status: 'Pending'
        },
        {
            number: 'INV-003',
            patient: 'Davit Gelashvili',
            service: 'Implant Phase 1',
            amount: "\u20BE300+",
            status: 'Paid'
        },
        {
            number: 'INV-004',
            patient: 'Ana Javakhishvili',
            service: 'Root Canal',
            amount: "\u20BE149",
            status: 'Overdue'
        }
    ]
};


var $ffee29e35474451f$export$2e2bcd8739ae039 = {
    '@supabase/supabase-js': '^2.99.2'
};


var $b940b823876787d8$exports = {};
var $1361c0857020ec79$exports = {};

$parcel$export($1361c0857020ec79$exports, "NavSidebar", () => $1361c0857020ec79$export$9a8d5ad2243b1a3);
const $1361c0857020ec79$export$9a8d5ad2243b1a3 = {
    flow: 'y',
    width: 'F2',
    background: 'inkMid',
    borderRight: '1px solid inkBorder',
    padding: 'A 0 0 0',
    height: '100vh',
    position: 'sticky',
    top: '0',
    overflow: 'auto',
    '@mobileL': {
        display: 'none'
    },
    LogoArea: {
        padding: '0 A Z A',
        marginBottom: 'Z',
        borderBottom: '1px solid inkBorder',
        LogoLink: {
            extends: 'Link',
            href: '/dashboard',
            textDecoration: 'none',
            flow: 'x',
            align: 'center flex-start',
            gap: 'W',
            LogoIcon: {
                extends: 'Icon',
                icon: 'fourStar',
                width: 'A',
                height: 'A',
                color: 'inkText'
            },
            LogoText: {
                text: 'MCAI',
                fontSize: 'A',
                fontWeight: '700',
                color: 'inkText',
                letterSpacing: '-0.02em'
            }
        }
    },
    MainNav: {
        flow: 'y',
        gap: 'X',
        padding: 'Z Z',
        NavDashboard: {
            extends: 'SidebarNavItem',
            state: {
                route: '/dashboard',
                label: '{{ navDashboard | polyglot }}',
                iconName: 'home'
            }
        },
        NavPatients: {
            extends: 'SidebarNavItem',
            state: {
                route: '/patients',
                label: '{{ navPatients | polyglot }}',
                iconName: 'users'
            }
        }
    },
    ClinicalSection: {
        flow: 'y',
        gap: 'X',
        padding: 'Z Z',
        SectionLabel1: {
            text: '{{ sectionClinical | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            letterSpacing: 'X',
            padding: 'Y Z',
            textTransform: 'uppercase'
        },
        NavScheduling: {
            extends: 'SidebarNavItem',
            state: {
                route: '/scheduling',
                label: '{{ navScheduling | polyglot }}',
                iconName: 'calendar'
            }
        },
        NavMySchedule: {
            extends: 'SidebarNavItem',
            state: {
                route: '/my-schedule',
                label: 'My Schedule',
                iconName: 'user'
            }
        },
        NavRadiology: {
            extends: 'SidebarNavItem',
            state: {
                route: '/radiology',
                label: '{{ navRadiology | polyglot }}',
                iconName: 'aperture'
            }
        },
        NavDocuments: {
            extends: 'SidebarNavItem',
            state: {
                route: '/documents',
                label: '{{ navDocuments | polyglot }}',
                iconName: 'fileText'
            }
        }
    },
    TemplatesSection: {
        flow: 'y',
        gap: 'X',
        padding: 'Z Z',
        borderTop: '1px solid inkBorder',
        SectionLabelTpl: {
            text: 'Templates',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            letterSpacing: 'X',
            padding: 'Y Z',
            textTransform: 'uppercase'
        },
        NavTemplates: {
            extends: 'SidebarNavItem',
            state: {
                route: '/templates',
                label: 'Record Templates',
                iconName: 'copy'
            }
        },
        NavFormBuilder: {
            extends: 'SidebarNavItem',
            state: {
                route: '/templates/forms',
                label: 'Form Builder',
                iconName: 'edit'
            }
        },
        NavConsentTpl: {
            extends: 'SidebarNavItem',
            state: {
                route: '/templates/consent',
                label: 'Consent Templates',
                iconName: 'checkSquare'
            }
        }
    },
    OpsSection: {
        flow: 'y',
        gap: 'X',
        padding: 'Z Z',
        SectionLabel2: {
            text: '{{ sectionOperations | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            letterSpacing: 'X',
            padding: 'Y Z',
            textTransform: 'uppercase'
        },
        NavFinances: {
            extends: 'SidebarNavItem',
            state: {
                route: '/finances',
                label: '{{ navFinances | polyglot }}',
                iconName: 'dollarSign'
            }
        },
        NavBilling: {
            extends: 'SidebarNavItem',
            state: {
                route: '/billing',
                label: '{{ navBilling | polyglot }}',
                iconName: 'creditCard'
            }
        },
        NavInventory: {
            extends: 'SidebarNavItem',
            state: {
                route: '/inventory',
                label: '{{ navInventory | polyglot }}',
                iconName: 'package'
            }
        },
        NavRx: {
            extends: 'SidebarNavItem',
            state: {
                route: '/prescriptions',
                label: '{{ navPrescriptions | polyglot }}',
                iconName: 'rx'
            }
        },
        NavLab: {
            extends: 'SidebarNavItem',
            state: {
                route: '/lab-cases',
                label: '{{ navLabCases | polyglot }}',
                iconName: 'flask'
            }
        },
        NavReferrals: {
            extends: 'SidebarNavItem',
            state: {
                route: '/referrals',
                label: '{{ navReferrals | polyglot }}',
                iconName: 'send'
            }
        },
        NavStaff: {
            extends: 'SidebarNavItem',
            state: {
                route: '/staff',
                label: 'Staff',
                iconName: 'users'
            }
        }
    },
    CommSection: {
        flow: 'y',
        gap: 'X',
        padding: 'Z Z',
        SectionLabel3: {
            text: '{{ sectionComm | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            letterSpacing: 'X',
            padding: 'Y Z',
            textTransform: 'uppercase'
        },
        NavChat: {
            extends: 'SidebarNavItem',
            state: {
                route: '/chat',
                label: '{{ navChat | polyglot }}',
                iconName: 'messageSquare'
            }
        }
    },
    AnalyticsSection: {
        flow: 'y',
        gap: 'X',
        padding: 'Z Z',
        SectionLabel4: {
            text: '{{ sectionAnalytics | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            letterSpacing: 'X',
            padding: 'Y Z',
            textTransform: 'uppercase'
        },
        NavReports: {
            extends: 'SidebarNavItem',
            state: {
                route: '/reports',
                label: '{{ navReports | polyglot }}',
                iconName: 'barChart'
            }
        }
    },
    AiSection: {
        flow: 'y',
        gap: 'X',
        padding: 'Z Z',
        borderTop: '1px solid inkBorder',
        SectionLabel5: {
            text: '{{ sectionAiTools | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            letterSpacing: 'X',
            padding: 'Y Z',
            textTransform: 'uppercase'
        },
        NavAi: {
            extends: 'SidebarNavItem',
            state: {
                route: '/ai',
                label: '{{ aiAssistant | polyglot }}',
                iconName: 'sparkle'
            }
        }
    },
    AdminSection: {
        flow: 'y',
        gap: 'X',
        padding: 'Z Z',
        borderTop: '1px solid inkBorder',
        SectionLabel6: {
            text: '{{ sectionAdmin | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'gold',
            letterSpacing: 'X',
            padding: 'Y Z',
            textTransform: 'uppercase'
        },
        NavIntegrations: {
            extends: 'SidebarNavItem',
            state: {
                route: '/integrations',
                label: '{{ navIntegrations | polyglot }}',
                iconName: 'link'
            }
        },
        NavEnterprise: {
            extends: 'SidebarNavItem',
            state: {
                route: '/enterprise',
                label: '{{ navEnterprise | polyglot }}',
                iconName: 'shield'
            }
        }
    },
    BottomBar: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Z A',
        borderTop: '1px solid inkBorder',
        marginTop: 'auto',
        flexShrink: '0',
        VersionText: {
            text: 'v2.0',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        ThemeToggle: {}
    }
};


var $3e7d9d0c898609d2$exports = {};

$parcel$export($3e7d9d0c898609d2$exports, "SidebarNavItem", () => $3e7d9d0c898609d2$export$1e8e95432f1f72fa);
const $3e7d9d0c898609d2$export$1e8e95432f1f72fa = {
    extends: 'Link',
    href: (el, s)=>s.route || '/dashboard',
    textDecoration: 'none',
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'Z A',
    round: 'Y',
    cursor: 'pointer',
    width: '100%',
    color: 'inkMuted',
    transition: 'all 0.15s ease',
    ':hover': {
        color: 'inkText',
        background: 'inkSurface'
    },
    isActive: (el, s)=>{
        var path = window.location.pathname;
        return path === s.route;
    },
    '.isActive': {
        color: 'inkText',
        background: 'inkSurface'
    },
    NavIcon: {
        extends: 'Icon',
        icon: (el, s)=>s.iconName,
        width: 'A',
        height: 'A'
    },
    NavLabel: {
        text: (el, s)=>s.label,
        fontSize: 'Z',
        fontWeight: '500'
    }
};


var $9636b0bca02a11fc$exports = {};

$parcel$export($9636b0bca02a11fc$exports, "TopBar", () => $9636b0bca02a11fc$export$c4e96258f3b6511);
const $9636b0bca02a11fc$export$c4e96258f3b6511 = {
    flow: 'x',
    align: 'center space-between',
    padding: 'A B',
    borderBottom: '1px solid inkBorder',
    background: 'ink',
    PageTitle: {
        tag: 'h1',
        text: (el, s)=>{
            var path = window.location.pathname;
            if (path === '/ai') return '{{ aiAssistant | polyglot }}';
            if (path === '/patient') return '{{ navPatients | polyglot }}';
            if (path === '/chart') return '{{ navChart | polyglot }}';
            if (path === '/perio') return '{{ navPerio | polyglot }}';
            if (path === '/treatment-plan') return '{{ navTreatmentPlans | polyglot }}';
            if (path === '/clinical-notes') return '{{ navNotes | polyglot }}';
            if (path === '/scheduling') return '{{ navScheduling | polyglot }}';
            if (path === '/billing') return '{{ navBilling | polyglot }}';
            if (path === '/prescriptions') return '{{ navPrescriptions | polyglot }}';
            if (path === '/lab-cases') return '{{ navLabCases | polyglot }}';
            if (path === '/referrals') return '{{ navReferrals | polyglot }}';
            if (path === '/reports') return '{{ navReports | polyglot }}';
            if (path === '/medical-history') return '{{ navMedHistory | polyglot }}';
            if (path === '/enterprise') return '{{ navEnterprise | polyglot }}';
            if (path === '/integrations') return '{{ navIntegrations | polyglot }}';
            return '{{ navDashboard | polyglot }}';
        },
        fontSize: 'B',
        fontWeight: '700',
        color: 'inkText'
    },
    TopBarRight: {
        flow: 'x',
        gap: 'Z',
        align: 'center center',
        SearchBox: {
            tag: 'input',
            type: 'text',
            placeholder: '{{ searchByName | polyglot }}',
            padding: 'Z A',
            round: 'C',
            background: 'inkSurface',
            color: 'inkText',
            border: '1px solid inkBorder',
            fontSize: 'Z',
            width: 'G',
            outline: 'none',
            transition: 'border 0.2s ease',
            ':focus': {
                border: '1px solid inkSubtle'
            }
        },
        LangSwitcher: {
            position: 'relative',
            LangBtn: {
                tag: 'button',
                flow: 'x',
                align: 'center center',
                gap: 'W',
                padding: 'X Z',
                round: 'Z',
                cursor: 'pointer',
                background: 'transparent',
                border: 'none',
                ':hover': {
                    background: 'inkSurface'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root.update({
                        activeLangMenu: !s.root.activeLangMenu
                    });
                },
                LangFlag: {
                    fontSize: 'A',
                    text: (el, s)=>{
                        var flags = {
                            en: '\uD83C\uDDEC\uD83C\uDDE7',
                            ka: '\uD83C\uDDEC\uD83C\uDDEA',
                            ru: '\uD83C\uDDF7\uD83C\uDDFA',
                            uk: '\uD83C\uDDFA\uD83C\uDDE6',
                            tr: '\uD83C\uDDF9\uD83C\uDDF7',
                            zh: '\uD83C\uDDE8\uD83C\uDDF3',
                            hi: '\uD83C\uDDEE\uD83C\uDDF3',
                            msa: '\uD83C\uDDF8\uD83C\uDDE6'
                        };
                        return flags[s.root.lang] || flags.en;
                    }
                },
                LangCode: {
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'inkSubtle',
                    text: (el, s)=>(s.root.lang || 'en').toUpperCase()
                }
            },
            LangDropdown: {
                flow: 'y',
                show: (el, s)=>s.root.activeLangMenu,
                position: 'absolute',
                top: '100%',
                right: '0',
                marginTop: 'Y',
                background: 'inkMid',
                border: '1px solid inkBorder',
                round: 'Z',
                padding: 'Y 0',
                minWidth: 'F',
                zIndex: '100',
                boxShadow: '0 A B inkBorder',
                LangEn: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'en',
                        flag: '\uD83C\uDDEC\uD83C\uDDE7',
                        name: 'English'
                    }
                },
                LangKa: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'ka',
                        flag: '\uD83C\uDDEC\uD83C\uDDEA',
                        name: '\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8'
                    }
                },
                LangRu: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'ru',
                        flag: '\uD83C\uDDF7\uD83C\uDDFA',
                        name: '\u0420\u0443\u0441\u0441\u043A\u0438\u0439'
                    }
                },
                LangUk: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'uk',
                        flag: '\uD83C\uDDFA\uD83C\uDDE6',
                        name: '\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430'
                    }
                },
                LangTr: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'tr',
                        flag: '\uD83C\uDDF9\uD83C\uDDF7',
                        name: 'T\u00FCrk\u00E7e'
                    }
                },
                LangZh: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'zh',
                        flag: '\uD83C\uDDE8\uD83C\uDDF3',
                        name: '\u4E2D\u6587'
                    }
                },
                LangHi: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'hi',
                        flag: '\uD83C\uDDEE\uD83C\uDDF3',
                        name: '\u0939\u093F\u0928\u094D\u0926\u0940'
                    }
                },
                LangMsa: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'msa',
                        flag: '\uD83C\uDDF8\uD83C\uDDE6',
                        name: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629'
                    }
                }
            }
        },
        BellIcon: {
            extends: 'Icon',
            icon: 'bell',
            width: 'A',
            height: 'A',
            color: 'inkMuted',
            cursor: 'pointer'
        },
        UserAvatar: {
            text: 'DL',
            width: 'B1',
            height: 'B1',
            round: 'D',
            background: 'inkText',
            color: 'white',
            fontWeight: '700',
            fontSize: 'Z',
            flow: 'x',
            align: 'center center'
        }
    }
};


var $8091e96233427455$exports = {};

$parcel$export($8091e96233427455$exports, "LangOption", () => $8091e96233427455$export$10f03b20191bd926);
const $8091e96233427455$export$10f03b20191bd926 = {
    tag: 'button',
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'Y A',
    width: '100%',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z',
    ':hover': {
        background: 'inkSurface'
    },
    onClick: (e, el, s)=>{
        s.root.update({
            lang: s.langCode,
            activeLangMenu: false
        });
        try {
            localStorage.setItem('dental_lang', s.langCode);
        } catch (e) {}
    },
    FlagEl: {
        text: (el, s)=>s.flag,
        fontSize: 'A'
    },
    NameEl: {
        text: (el, s)=>s.name,
        fontSize: 'Z',
        color: 'inkText',
        fontWeight: '500'
    }
};


var $032a0868926608de$exports = {};

$parcel$export($032a0868926608de$exports, "AppointmentModal", () => $032a0868926608de$export$56a5fe69e12bdd43);
const $032a0868926608de$export$56a5fe69e12bdd43 = {
    show: (el, s)=>s.root.showAppointmentModal,
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '1000',
    Backdrop: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        background: 'black.5',
        cursor: 'pointer',
        onClick: (e, el, s)=>s.root.update({
                showAppointmentModal: false
            })
    },
    ModalPanel: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        attr: {
            style: 'transform: translate(-50%, -50%)'
        },
        width: '90%',
        maxWidth: 'H',
        background: 'inkMid',
        round: 'B',
        boxShadow: '0 B D black.2',
        flow: 'y',
        overflow: 'hidden',
        ModalHeader: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A B',
            borderBottom: '1px solid inkBorder',
            HeaderTitle: {
                text: '{{ appointmentDetails | polyglot }}',
                fontSize: 'A',
                fontWeight: '700',
                color: 'inkText'
            },
            CloseBtn: {
                tag: 'button',
                text: '\u2715',
                background: 'transparent',
                border: 'none',
                fontSize: 'A',
                color: 'inkMuted',
                cursor: 'pointer',
                padding: 'Y',
                round: 'Y',
                ':hover': {
                    background: 'inkSurface'
                },
                onClick: (e, el, s)=>s.root.update({
                        showAppointmentModal: false
                    })
            }
        },
        ModalBody: {
            flow: 'y',
            gap: 'A',
            padding: 'B',
            ApptTime: {
                flow: 'x',
                gap: 'Z',
                align: 'center flex-start',
                TimeIcon: {
                    extends: 'Icon',
                    icon: 'clock',
                    width: 'A',
                    height: 'A',
                    color: 'teal'
                },
                TimeValue: {
                    text: (el, s)=>(s.root.selectedAppointment || {}).time || '',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'teal'
                }
            },
            ApptPatient: {
                flow: 'x',
                gap: 'Z',
                align: 'center flex-start',
                PatientIcon: {
                    extends: 'Icon',
                    icon: 'users',
                    width: 'A',
                    height: 'A',
                    color: 'inkMuted'
                },
                PatientInfo: {
                    flow: 'y',
                    gap: 'W',
                    PatientLabel: {
                        text: '{{ patient | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    },
                    PatientName: {
                        extends: 'Link',
                        href: '/patient',
                        text: (el, s)=>(s.root.selectedAppointment || {}).patient || '',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'teal',
                        textDecoration: 'none',
                        ':hover': {
                            textDecoration: 'underline'
                        }
                    }
                }
            },
            ApptService: {
                flow: 'x',
                gap: 'Z',
                align: 'center flex-start',
                ServiceIcon: {
                    extends: 'Icon',
                    icon: 'tooth',
                    width: 'A',
                    height: 'A',
                    color: 'inkMuted'
                },
                ServiceInfo: {
                    flow: 'y',
                    gap: 'W',
                    ServiceLabel: {
                        text: '{{ service | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    },
                    ServiceValue: {
                        text: (el, s)=>(s.root.selectedAppointment || {}).service || '',
                        fontSize: 'A',
                        fontWeight: '500',
                        color: 'inkText'
                    }
                }
            },
            ApptDoctor: {
                flow: 'x',
                gap: 'Z',
                align: 'center flex-start',
                DoctorIcon: {
                    extends: 'Icon',
                    icon: 'stethoscope',
                    width: 'A',
                    height: 'A',
                    color: 'inkMuted'
                },
                DoctorInfo: {
                    flow: 'y',
                    gap: 'W',
                    DoctorLabel: {
                        text: '{{ doctor | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    },
                    DoctorValue: {
                        text: (el, s)=>(s.root.selectedAppointment || {}).doctor || '',
                        fontSize: 'A',
                        fontWeight: '500',
                        color: 'inkText'
                    }
                }
            },
            ApptStatus: {
                flow: 'x',
                gap: 'Z',
                align: 'center flex-start',
                StatusIcon: {
                    extends: 'Icon',
                    icon: 'check',
                    width: 'A',
                    height: 'A',
                    color: 'inkMuted'
                },
                StatusInfo: {
                    flow: 'y',
                    gap: 'W',
                    StatusLabel: {
                        text: '{{ status2 | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    },
                    StatusBadgeWrap: {
                        extends: 'StatusBadge',
                        state: (el, s)=>({
                                status: (s.root.selectedAppointment || {}).status || 'Pending'
                            })
                    }
                }
            }
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z',
            padding: 'A B',
            borderTop: '1px solid inkBorder',
            align: 'center flex-end',
            OpenPatientBtn: {
                extends: 'Link',
                href: '/patient',
                text: '{{ openPatientRecord | polyglot }}',
                background: 'teal',
                color: 'ink',
                fontWeight: '600',
                padding: 'Z A',
                round: 'A',
                fontSize: 'Z',
                textDecoration: 'none',
                cursor: 'pointer'
            },
            CancelApptBtn: {
                extends: 'Button',
                text: '{{ cancel | polyglot }}',
                background: 'inkSurface',
                color: 'inkText',
                fontWeight: '600',
                padding: 'Z A',
                round: 'A',
                fontSize: 'Z',
                cursor: 'pointer',
                border: '1px solid inkBorder',
                onClick: (e, el, s)=>s.root.update({
                        showAppointmentModal: false
                    })
            }
        }
    }
};


var $ec3f9d7c7c1f789a$exports = {};

$parcel$export($ec3f9d7c7c1f789a$exports, "StatCard", () => $ec3f9d7c7c1f789a$export$b5cddb1a6bf990a0);
const $ec3f9d7c7c1f789a$export$b5cddb1a6bf990a0 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    flex: '1',
    minWidth: 'E',
    StatLabel: {
        text: (el, s)=>s.label,
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: 'X'
    },
    StatNumber: {
        text: (el, s)=>s.value,
        fontSize: 'D',
        fontWeight: '800',
        color: 'inkText'
    },
    StatDelta: {
        if: (el, s)=>!!s.delta,
        text: (el, s)=>s.delta || '',
        fontSize: 'Y',
        fontWeight: '600',
        padding: 'X Y',
        round: 'Y',
        background: (el, s)=>s.delta && s.delta.startsWith('+') ? 'green.15' : 'red.15',
        color: (el, s)=>s.delta && s.delta.startsWith('+') ? 'green' : 'red'
    }
};


var $18de0e4585488af7$exports = {};

$parcel$export($18de0e4585488af7$exports, "StatusBadge", () => $18de0e4585488af7$export$5720c1871db44880);
const $18de0e4585488af7$export$5720c1871db44880 = {
    tag: 'span',
    text: (el, s)=>s.status || s.text,
    fontSize: 'Z',
    fontWeight: '600',
    padding: 'Y Z',
    round: 'B',
    whiteSpace: 'nowrap',
    background: (el, s)=>{
        const st = s.status || s.text;
        if (st === 'Confirmed') return 'green.15';
        if (st === 'Pending') return 'amber.15';
        if (st === 'Completed' || st === 'Paid') return 'inkSurface';
        if (st === 'Cancelled' || st === 'Overdue') return 'red.15';
        return 'inkSurface';
    },
    color: (el, s)=>{
        const st = s.status || s.text;
        if (st === 'Confirmed') return 'green';
        if (st === 'Pending') return 'amber';
        if (st === 'Completed' || st === 'Paid') return 'inkMuted';
        if (st === 'Cancelled' || st === 'Overdue') return 'red';
        return 'inkMuted';
    }
};


var $960e970dc63774b5$exports = {};

$parcel$export($960e970dc63774b5$exports, "PatientCard", () => $960e970dc63774b5$export$304dcc153ad6a9d9);
const $960e970dc63774b5$export$304dcc153ad6a9d9 = {
    extends: 'Link',
    href: '/patient',
    textDecoration: 'none',
    color: 'inherit',
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid transparent',
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.2s ease',
    ':hover': {
        border: '1px solid inkBorder',
        boxShadow: '0 4px 16px rgba(0,0,0,0.04)'
    },
    AvatarCircle: {
        text: (el, s)=>s.name ? s.name.charAt(0) : '?',
        width: 'C',
        height: 'C',
        round: 'D',
        background: '#0D1117',
        color: '#FFFFFF',
        fontWeight: '700',
        fontSize: 'A',
        flow: 'x',
        align: 'center center',
        flexShrink: '0'
    },
    PatientInfo: {
        flow: 'y',
        gap: 'W',
        flex: '1',
        PatientName: {
            text: (el, s)=>s.name,
            fontSize: 'A',
            fontWeight: '600',
            color: 'inkText'
        },
        PatientMeta: {
            text: (el, s)=>'Last visit: ' + s.lastVisit + " \xb7 Next: " + s.nextAppt,
            fontSize: 'Z',
            color: 'inkMuted'
        }
    },
    VisitCount: {
        text: (el, s)=>s.totalVisits + ' visits',
        fontSize: 'Z',
        color: 'inkSubtle',
        fontWeight: '500',
        flexShrink: '0'
    }
};


var $b755e2fd8d543f30$exports = {};

$parcel$export($b755e2fd8d543f30$exports, "AiInsightCard", () => $b755e2fd8d543f30$export$961757e8b45fe16);
const $b755e2fd8d543f30$export$961757e8b45fe16 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid purple.3',
    CardHeader: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        SparkleIcon: {
            extends: 'Icon',
            icon: 'sparkle',
            width: 'Z',
            height: 'Z',
            color: 'purple'
        },
        InsightLabel: {
            text: '{{ aiInsight | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'purple'
        }
    },
    InsightText: {
        text: (el, s)=>s.insight || '',
        fontSize: 'Z',
        color: 'inkText',
        lineHeight: '1.5'
    },
    ConfidenceRow: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        ConfLabel: {
            text: '{{ confidence | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        ConfValue: {
            text: (el, s)=>(s.confidence || '95') + '%',
            fontSize: 'Y',
            color: 'teal',
            fontWeight: '600'
        }
    }
};


var $14e5064f35397f79$exports = {};

$parcel$export($14e5064f35397f79$exports, "AiChatBubble", () => $14e5064f35397f79$export$5c145f33b09beab2);
const $14e5064f35397f79$export$5c145f33b09beab2 = {
    flow: 'y',
    gap: 'Y',
    padding: 'A',
    round: 'Z',
    maxWidth: '85%',
    background: (el, s)=>s.role === 'assistant' ? 'inkSurface' : 'inkMid',
    borderLeft: (el, s)=>s.role === 'assistant' ? '2px solid purple' : 'none',
    border: (el, s)=>s.role === 'user' ? '1px solid inkBorder' : 'none',
    alignSelf: (el, s)=>s.role === 'user' ? 'flex-end' : 'flex-start',
    RoleLabel: {
        text: (el, s)=>s.role === 'assistant' ? '\u2726 AI Assistant' : 'You',
        fontSize: 'Y',
        fontWeight: '600',
        color: (el, s)=>s.role === 'assistant' ? 'purple' : 'inkMuted'
    },
    MessageText: {
        text: (el, s)=>s.content,
        fontSize: 'Z',
        color: (el, s)=>s.role === 'assistant' ? 'inkText' : 'inkSubtle',
        lineHeight: '1.6',
        whiteSpace: 'pre-wrap'
    }
};


var $142b97f260d45453$exports = {};

$parcel$export($142b97f260d45453$exports, "AiSuggestionChip", () => $142b97f260d45453$export$e6054ef362292e9d);
const $142b97f260d45453$export$e6054ef362292e9d = {
    tag: 'button',
    text: (el, s)=>s.label,
    fontSize: 'Y',
    fontWeight: '500',
    padding: 'Y Z',
    round: 'B',
    background: 'purple.1',
    border: '1px solid purple.3',
    color: 'purple',
    cursor: 'pointer'
};


var $19f071aa89dd3a6b$exports = {};

$parcel$export($19f071aa89dd3a6b$exports, "FormField", () => $19f071aa89dd3a6b$export$56e87bf42978147a);
const $19f071aa89dd3a6b$export$56e87bf42978147a = {
    flow: 'y',
    gap: 'Y',
    width: '100%',
    FieldLabel: {
        tag: 'label',
        text: (el, s)=>s.label,
        fontSize: 'Y',
        fontWeight: '600',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: 'X'
    },
    FieldInput: {
        extends: 'Input',
        tag: 'input',
        type: (el, s)=>s.type || 'text',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>s.value || '',
        padding: 'Z A',
        round: 'Y',
        background: 'inkSurface',
        color: 'inkText',
        border: '1px solid inkBorder',
        fontSize: 'Z',
        width: '100%'
    }
};


var $6adc95ecda5c309e$exports = {};

$parcel$export($6adc95ecda5c309e$exports, "ClinicCard", () => $6adc95ecda5c309e$export$e746b352d37ddeb3);
const $6adc95ecda5c309e$export$e746b352d37ddeb3 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    cursor: 'pointer',
    width: '100%',
    isSelected: (el, s)=>s.root.selectedClinicId === s.id,
    '.isSelected': {
        borderColor: 'teal',
        background: 'teal.08'
    },
    onClick: (e, el, s)=>s.root.update({
            selectedClinic: s.name,
            selectedClinicId: s.id
        }),
    show: (el, s)=>{
        const q = s.root.clinicFilter;
        if (!q) return true;
        const lower = q.toLowerCase();
        return s.name.toLowerCase().includes(lower) || s.district.toLowerCase().includes(lower);
    },
    CardTop: {
        flow: 'x',
        align: 'center space-between',
        ClinicName: {
            text: (el, s)=>s.name,
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        },
        RatingRow: {
            flow: 'x',
            gap: 'X',
            align: 'center center',
            RatingStar: {
                extends: 'Icon',
                icon: 'star',
                width: 'Z',
                height: 'Z',
                color: 'amber'
            },
            RatingNum: {
                text: (el, s)=>String(s.rating),
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkText'
            },
            ReviewNum: {
                text: (el, s)=>'(' + s.reviews + ')',
                fontSize: 'Y',
                color: 'inkMuted'
            }
        }
    },
    CardMid: {
        flow: 'x',
        gap: 'Y',
        DistrictText: {
            text: (el, s)=>s.district,
            fontSize: 'Y',
            color: 'teal',
            fontWeight: '500'
        },
        SepDot: {
            text: '{{ u00b72 | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        AddressText: {
            text: (el, s)=>s.address,
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    ClinicRating: {
        flow: 'x',
        gap: 'W',
        align: 'center flex-start',
        RatingStarIcon: {
            extends: 'Icon',
            icon: 'star',
            width: 'Y',
            height: 'Y',
            color: 'teal'
        },
        RatingAvg: {
            text: (el, s)=>String(s.clinicRating || s.rating || '0'),
            fontSize: 'Y',
            fontWeight: '600',
            color: 'teal'
        },
        RatingLabel: {
            text: '{{ clinicAvgRating | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    CardServices: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        children: (el, s)=>(s.services || []).map((sv)=>({
                    label: sv
                })),
        childrenAs: 'state',
        childProps: {
            text: (el, s)=>s.label,
            fontSize: 'Y',
            padding: 'X Y',
            round: 'Y',
            background: 'inkSurface',
            color: 'inkSubtle'
        }
    }
};


var $b1cc20cced7368fe$exports = {};

$parcel$export($b1cc20cced7368fe$exports, "AppointmentRow", () => $b1cc20cced7368fe$export$214f562778454096);
const $b1cc20cced7368fe$export$214f562778454096 = {
    display: 'grid',
    gridTemplateColumns: '70px 1fr 1fr 1fr 100px',
    align: 'center flex-start',
    padding: 'Z A',
    borderBottom: '1px solid inkBorder',
    cursor: 'pointer',
    transition: 'background 0.15s ease',
    ':hover': {
        background: 'inkSurface'
    },
    ':last-child': {
        borderBottom: 'none'
    },
    '@mobileL': {
        display: 'flex',
        flow: 'y',
        gap: 'Y'
    },
    onClick: (e, el, s)=>{
        s.root.update({
            selectedAppointment: {
                patient: s.patient,
                time: s.time,
                service: s.service,
                doctor: s.doctor,
                status: s.status
            },
            showAppointmentModal: true
        });
    },
    TimeCell: {
        text: (el, s)=>s.time,
        fontSize: 'Z',
        color: 'inkMuted',
        fontWeight: '500'
    },
    PatientCell: {
        extends: 'Link',
        href: '/patient',
        text: (el, s)=>s.patient,
        fontSize: 'Z',
        color: 'teal',
        fontWeight: '600',
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'underline'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
        }
    },
    ServiceCell: {
        text: (el, s)=>s.service,
        fontSize: 'Z',
        color: 'inkMuted'
    },
    DoctorCell: {
        text: (el, s)=>s.doctor,
        fontSize: 'Z',
        color: 'inkMuted'
    },
    StatusWrap: {
        textAlign: 'right',
        StatusCell: {
            extends: 'StatusBadge'
        }
    }
};


var $741f1041f5324f0c$exports = {};

$parcel$export($741f1041f5324f0c$exports, "TreatmentPlanRow", () => $741f1041f5324f0c$export$22d564ca90cf4aa8);
const $741f1041f5324f0c$export$22d564ca90cf4aa8 = {
    flow: 'x',
    align: 'center space-between',
    padding: 'Z A',
    borderBottom: '1px solid inkBorder',
    gap: 'A',
    ToothBadge: {
        text: (el, s)=>'#' + s.tooth,
        fontSize: 'Z',
        fontWeight: '700',
        color: 'teal',
        width: 'B',
        textAlign: 'center'
    },
    ProcedureName: {
        text: (el, s)=>s.procedure,
        fontSize: 'Z',
        color: 'inkText',
        fontWeight: '500',
        flex: '1'
    },
    PlanStatus: {
        extends: 'StatusBadge'
    },
    PlanPrice: {
        text: (el, s)=>s.price,
        fontSize: 'Z',
        color: 'teal',
        fontWeight: '600',
        width: 'C',
        textAlign: 'right'
    },
    PlanDoctor: {
        text: (el, s)=>s.doctor,
        fontSize: 'Y',
        color: 'inkMuted',
        width: 'E'
    }
};


var $e09c7e6cacc12172$exports = {};

$parcel$export($e09c7e6cacc12172$exports, "ServiceOption", () => $e09c7e6cacc12172$export$d7b1b04770da359f);
const $e09c7e6cacc12172$export$d7b1b04770da359f = {
    flow: 'x',
    align: 'center space-between',
    padding: 'A',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    cursor: 'pointer',
    width: '100%',
    isSelected: (el, s)=>s.root.selectedService === s.name,
    '.isSelected': {
        borderColor: 'teal',
        background: 'teal.08'
    },
    onClick: (e, el, s)=>s.root.update({
            selectedService: s.name
        }),
    ServiceLeft: {
        flow: 'x',
        align: 'center center',
        gap: 'Z',
        ServiceEmoji: {
            text: (el, s)=>s.emoji,
            fontSize: 'A'
        },
        ServiceName: {
            text: (el, s)=>s.name,
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        }
    },
    ServicePrice: {
        text: (el, s)=>s.price,
        fontSize: 'Z',
        color: 'teal',
        fontWeight: '700'
    }
};


var $8aba4b6de89427c7$exports = {};

$parcel$export($8aba4b6de89427c7$exports, "DateOption", () => $8aba4b6de89427c7$export$7eb204090cf5da5b);
const $8aba4b6de89427c7$export$7eb204090cf5da5b = {
    flow: 'y',
    align: 'center center',
    padding: 'Y Z',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    cursor: 'pointer',
    flex: '1',
    minWidth: '0',
    transition: 'all 0.15s ease',
    isSelected: (el, s)=>s.root.selectedDate === s.value,
    '.isSelected': {
        background: '#0D1117',
        color: '#FFFFFF',
        borderColor: '#0D1117'
    },
    ':hover': {
        borderColor: '#0D1117'
    },
    onClick: (e, el, s)=>s.root.update({
            selectedDate: s.value
        }),
    DateLabel: {
        text: (el, s)=>s.label,
        fontSize: 'Y',
        fontWeight: '600',
        textAlign: 'center',
        whiteSpace: 'nowrap'
    }
};


var $c6bcb1da226598d7$exports = {};

$parcel$export($c6bcb1da226598d7$exports, "TimeOption", () => $c6bcb1da226598d7$export$c5253b3da33c2f05);
const $c6bcb1da226598d7$export$c5253b3da33c2f05 = {
    flow: 'y',
    align: 'center center',
    padding: 'Y Z',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    cursor: 'pointer',
    gap: 'W',
    transition: 'all 0.15s ease',
    isSelected: (el, s)=>s.root.selectedTime === s.label,
    '.isSelected': {
        background: '#0D1117',
        color: '#FFFFFF',
        borderColor: '#0D1117'
    },
    ':hover': {
        borderColor: '#0D1117'
    },
    onClick: (e, el, s)=>s.root.update({
            selectedTime: s.label
        }),
    TimeLabel: {
        text: (el, s)=>s.label,
        fontSize: 'Z',
        fontWeight: '600'
    },
    TimePeriod: {
        text: (el, s)=>s.period,
        fontSize: 'Y',
        color: 'inkMuted'
    }
};


var $1b7b9ca0dc4e4c87$exports = {};

$parcel$export($1b7b9ca0dc4e4c87$exports, "NavBar", () => $1b7b9ca0dc4e4c87$export$ef8da11641c635de);
const $1b7b9ca0dc4e4c87$export$ef8da11641c635de = {
    tag: 'nav',
    flow: 'x',
    align: 'center space-between',
    padding: 'A B',
    background: 'transparent',
    position: 'sticky',
    top: '0',
    zIndex: '100',
    width: '100%',
    LogoLink: {
        extends: 'Link',
        href: '/',
        textDecoration: 'none',
        flow: 'x',
        align: 'center center',
        gap: 'W',
        LogoIcon: {
            extends: 'Icon',
            icon: 'fourStar',
            width: 'A',
            height: 'A',
            color: 'inkText'
        },
        LogoText: {
            text: 'MCAI',
            fontSize: 'A',
            fontWeight: '700',
            color: 'inkText'
        }
    },
    NavLinks: {
        flow: 'x',
        gap: 'B',
        align: 'center center',
        position: 'absolute',
        left: '50%',
        attr: {
            style: 'transform: translateX(-50%)'
        },
        '@mobileL': {
            display: 'none'
        },
        FeaturesLink: {
            extends: 'Link',
            text: '{{ features | polyglot }}',
            href: '/business#features',
            color: 'inkSubtle',
            fontSize: 'Z',
            textDecoration: 'none',
            fontWeight: '500'
        },
        PricingLink: {
            extends: 'Link',
            text: '{{ pricing | polyglot }}',
            href: '/business#pricing',
            color: 'inkSubtle',
            fontSize: 'Z',
            textDecoration: 'none',
            fontWeight: '500'
        },
        ClinicsLink: {
            extends: 'Link',
            text: '{{ clinicsNav | polyglot }}',
            href: '/clinics',
            color: 'inkSubtle',
            fontSize: 'Z',
            textDecoration: 'none',
            fontWeight: '500'
        },
        AiLink: {
            extends: 'Link',
            text: '{{ aiAssistant | polyglot }}',
            href: '/business#ai',
            color: 'inkSubtle',
            fontSize: 'Z',
            textDecoration: 'none',
            fontWeight: '500'
        },
        ForBusinessLink: {
            extends: 'Link',
            text: '{{ forBusiness | polyglot }}',
            href: '/business',
            color: 'inkSubtle',
            fontSize: 'Z',
            textDecoration: 'none',
            fontWeight: '500'
        }
    },
    NavRight: {
        flow: 'x',
        gap: 'Z',
        align: 'center center',
        LangMenu: {
            position: 'relative',
            flow: 'x',
            align: 'center center',
            LangBtn: {
                tag: 'button',
                flow: 'x',
                align: 'center center',
                gap: 'W',
                padding: 'X Z',
                round: 'Z',
                cursor: 'pointer',
                background: 'transparent',
                border: 'none',
                ':hover': {
                    background: 'inkSurface'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root.update({
                        activeLangMenu: !s.root.activeLangMenu
                    });
                },
                LangFlag: {
                    fontSize: 'A',
                    text: (el, s)=>{
                        var flags = {
                            en: '\uD83C\uDDEC\uD83C\uDDE7',
                            ka: '\uD83C\uDDEC\uD83C\uDDEA',
                            ru: '\uD83C\uDDF7\uD83C\uDDFA',
                            uk: '\uD83C\uDDFA\uD83C\uDDE6',
                            tr: '\uD83C\uDDF9\uD83C\uDDF7',
                            zh: '\uD83C\uDDE8\uD83C\uDDF3',
                            hi: '\uD83C\uDDEE\uD83C\uDDF3',
                            msa: '\uD83C\uDDF8\uD83C\uDDE6'
                        };
                        return flags[s.root.lang] || flags.en;
                    }
                },
                LangCode: {
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'inkSubtle',
                    '@mobileL': {
                        display: 'none'
                    },
                    text: (el, s)=>{
                        var codes = {
                            en: 'EN',
                            ka: 'GE',
                            ru: 'RU',
                            uk: 'UA',
                            tr: 'TR',
                            zh: 'ZH',
                            hi: 'HI',
                            msa: 'AR'
                        };
                        return codes[s.root.lang] || 'EN';
                    }
                }
            },
            LangDropdown: {
                flow: 'y',
                position: 'absolute',
                top: '100%',
                right: '0',
                marginTop: 'Y',
                background: 'inkMid',
                round: 'Z',
                border: '1px solid inkBorder',
                boxShadow: '0 A B inkBorder',
                padding: 'Y 0',
                minWidth: 'F',
                zIndex: '300',
                show: (el, s)=>s.root.activeLangMenu,
                LangEn: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'en',
                        flag: '\uD83C\uDDEC\uD83C\uDDE7',
                        name: 'English'
                    }
                },
                LangKa: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'ka',
                        flag: '\uD83C\uDDEC\uD83C\uDDEA',
                        name: '\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8'
                    }
                },
                LangRu: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'ru',
                        flag: '\uD83C\uDDF7\uD83C\uDDFA',
                        name: '\u0420\u0443\u0441\u0441\u043A\u0438\u0439'
                    }
                },
                LangUk: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'uk',
                        flag: '\uD83C\uDDFA\uD83C\uDDE6',
                        name: '\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430'
                    }
                },
                LangTr: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'tr',
                        flag: '\uD83C\uDDF9\uD83C\uDDF7',
                        name: 'T\u00FCrk\u00E7e'
                    }
                },
                LangZh: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'zh',
                        flag: '\uD83C\uDDE8\uD83C\uDDF3',
                        name: '\u4E2D\u6587'
                    }
                },
                LangHi: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'hi',
                        flag: '\uD83C\uDDEE\uD83C\uDDF3',
                        name: '\u0939\u093F\u0928\u094D\u0926\u0940'
                    }
                },
                LangMsa: {
                    extends: 'LangOption',
                    state: {
                        langCode: 'msa',
                        flag: '\uD83C\uDDF8\uD83C\uDDE6',
                        name: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629'
                    }
                }
            }
        },
        CtaLink: {
            extends: 'Link',
            text: '{{ getStarted | polyglot }}',
            href: '/booking',
            background: 'inkText',
            color: 'white',
            fontWeight: '600',
            padding: 'Y A',
            round: 'Z',
            fontSize: 'Z',
            textDecoration: 'none'
        }
    }
};


var $d39763d811cd1e53$exports = {};

$parcel$export($d39763d811cd1e53$exports, "PricingCard", () => $d39763d811cd1e53$export$668dae926a178a9f);
const $d39763d811cd1e53$export$668dae926a178a9f = {
    flow: 'y',
    gap: 'A',
    padding: 'C',
    round: 'A',
    flex: '1',
    minWidth: 'F',
    background: (el, s)=>s.highlighted ? 'teal' : 'inkMid',
    border: (el, s)=>s.highlighted ? '2px solid teal' : '1px solid inkBorder',
    boxShadow: (el, s)=>s.highlighted ? '0 20px 60px rgba(0,201,167,0.2)' : 'none',
    transition: 'all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)',
    ':hover': {
        transform: 'translateY(-4px)',
        boxShadow: (el, s)=>s.highlighted ? '0 24px 70px rgba(0,201,167,0.3)' : '0 12px 40px rgba(0,0,0,0.12)'
    },
    TierName: {
        tag: 'h3',
        text: (el, s)=>s.tier,
        fontSize: 'Z',
        fontWeight: '600',
        color: (el, s)=>s.highlighted ? 'ink' : 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: '0.05em'
    },
    PriceRow: {
        flow: 'x',
        align: 'flex-end center',
        gap: 'Y',
        marginTop: 'Z',
        Amount: {
            text: (el, s)=>s.amount,
            fontSize: 'E',
            fontWeight: '800',
            color: (el, s)=>s.highlighted ? 'ink' : 'inkText',
            letterSpacing: '-0.03em'
        },
        Period: {
            text: (el, s)=>s.period,
            fontSize: 'Z',
            color: (el, s)=>s.highlighted ? 'ink' : 'inkMuted',
            marginBottom: 'Y'
        }
    },
    Description: {
        text: (el, s)=>s.description,
        fontSize: 'Z',
        color: (el, s)=>s.highlighted ? 'ink' : 'inkMuted',
        lineHeight: '1.7',
        marginTop: 'Z'
    },
    PricingCta: {
        extends: 'Button',
        text: '{{ choosePlan | polyglot }}',
        marginTop: 'A',
        padding: 'Z1 A',
        round: 'Z1',
        fontWeight: '600',
        fontSize: 'Z',
        cursor: 'pointer',
        border: 'none',
        textAlign: 'center',
        width: '100%',
        background: (el, s)=>s.highlighted ? 'ink' : 'teal',
        color: (el, s)=>s.highlighted ? 'teal' : 'ink',
        transition: 'all 0.2s ease',
        ':hover': {
            opacity: '0.9'
        }
    }
};


var $ef2aa5000ca42c4b$exports = {};

$parcel$export($ef2aa5000ca42c4b$exports, "FeatureCard", () => $ef2aa5000ca42c4b$export$9bb2c5592f957d1c);
const $ef2aa5000ca42c4b$export$9bb2c5592f957d1c = {
    flow: 'y',
    gap: 'A',
    padding: 'C',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    transition: 'all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)',
    ':hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 12px 40px rgba(0,0,0,0.12)'
    },
    CardIcon: {
        extends: 'Icon',
        icon: (el, s)=>s.icon,
        width: 'B',
        height: 'B',
        color: '#1D1D1F'
    },
    CardTitle: {
        tag: 'h3',
        text: (el, s)=>s.title,
        fontSize: 'A',
        fontWeight: '700',
        color: 'inkText',
        letterSpacing: '-0.01em'
    },
    CardDetail: {
        text: (el, s)=>s.detail,
        fontSize: 'Z',
        color: 'inkMuted',
        lineHeight: '1.7'
    }
};


var $d94fc369bc06faad$exports = {};

$parcel$export($d94fc369bc06faad$exports, "TestimonialCard", () => $d94fc369bc06faad$export$a34a40ba0fc7f13f);
const $d94fc369bc06faad$export$a34a40ba0fc7f13f = {
    flow: 'y',
    gap: 'A',
    padding: 'C',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    flex: '1',
    minWidth: 'E',
    transition: 'all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)',
    ':hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 12px 40px rgba(0,0,0,0.12)'
    },
    QuoteIcon: {
        text: '{{ u201c | polyglot }}',
        fontSize: 'E',
        fontWeight: '800',
        color: 'teal',
        lineHeight: '0.8',
        marginBottom: '-Z'
    },
    QuoteText: {
        text: (el, s)=>s.quote,
        fontSize: 'A',
        color: 'inkSubtle',
        lineHeight: '1.7',
        fontStyle: 'italic'
    },
    StarRow: {
        flow: 'x',
        gap: 'X',
        StarIcon1: {
            extends: 'Icon',
            icon: 'star',
            width: 'Z',
            height: 'Z',
            color: 'amber'
        },
        StarIcon2: {
            extends: 'Icon',
            icon: 'star',
            width: 'Z',
            height: 'Z',
            color: 'amber'
        },
        StarIcon3: {
            extends: 'Icon',
            icon: 'star',
            width: 'Z',
            height: 'Z',
            color: 'amber'
        },
        StarIcon4: {
            extends: 'Icon',
            icon: 'star',
            width: 'Z',
            height: 'Z',
            color: 'amber'
        },
        StarIcon5: {
            extends: 'Icon',
            icon: 'star',
            width: 'Z',
            height: 'Z',
            color: 'amber'
        }
    },
    ClinicInfo: {
        flow: 'y',
        gap: 'X',
        marginTop: 'Z',
        ClinicName: {
            text: (el, s)=>s.clinic,
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        ClinicLocation: {
            text: (el, s)=>s.location,
            fontSize: 'Y',
            color: 'inkMuted'
        }
    }
};


var $0facdb3adfab73f3$exports = {};

$parcel$export($0facdb3adfab73f3$exports, "StepIndicator", () => $0facdb3adfab73f3$export$a765b9dee96eca0e);
const $0facdb3adfab73f3$export$a765b9dee96eca0e = {
    flow: 'x',
    gap: 'Y',
    align: 'center center',
    width: '100%',
    padding: 'A 0',
    StepDot1: {
        flow: 'y',
        align: 'center center',
        flex: '1',
        gap: 'X',
        StepBar: {
            height: 'X',
            width: '100%',
            round: 'X',
            background: (el, s)=>s.root.activeBookingStep >= 1 ? 'teal' : 'inkBorder'
        },
        StepLabel: {
            text: '{{ selectClinic | polyglot }}',
            fontSize: 'Y',
            color: (el, s)=>s.root.activeBookingStep >= 1 ? 'teal' : 'inkMuted'
        }
    },
    StepDot2: {
        flow: 'y',
        align: 'center center',
        flex: '1',
        gap: 'X',
        StepBar: {
            height: 'X',
            width: '100%',
            round: 'X',
            background: (el, s)=>s.root.activeBookingStep >= 2 ? 'teal' : 'inkBorder'
        },
        StepLabel: {
            text: '{{ selectService | polyglot }}',
            fontSize: 'Y',
            color: (el, s)=>s.root.activeBookingStep >= 2 ? 'teal' : 'inkMuted'
        }
    },
    StepDot3: {
        flow: 'y',
        align: 'center center',
        flex: '1',
        gap: 'X',
        StepBar: {
            height: 'X',
            width: '100%',
            round: 'X',
            background: (el, s)=>s.root.activeBookingStep >= 3 ? 'teal' : 'inkBorder'
        },
        StepLabel: {
            text: '{{ preCheck | polyglot }}',
            fontSize: 'Y',
            color: (el, s)=>s.root.activeBookingStep >= 3 ? 'teal' : 'inkMuted'
        }
    },
    StepDot4: {
        flow: 'y',
        align: 'center center',
        flex: '1',
        gap: 'X',
        StepBar: {
            height: 'X',
            width: '100%',
            round: 'X',
            background: (el, s)=>s.root.activeBookingStep >= 4 ? 'teal' : 'inkBorder'
        },
        StepLabel: {
            text: '{{ selectDate | polyglot }}',
            fontSize: 'Y',
            color: (el, s)=>s.root.activeBookingStep >= 4 ? 'teal' : 'inkMuted'
        }
    },
    StepDot5: {
        flow: 'y',
        align: 'center center',
        flex: '1',
        gap: 'X',
        StepBar: {
            height: 'X',
            width: '100%',
            round: 'X',
            background: (el, s)=>s.root.activeBookingStep >= 5 ? 'teal' : 'inkBorder'
        },
        StepLabel: {
            text: '{{ selectTime | polyglot }}',
            fontSize: 'Y',
            color: (el, s)=>s.root.activeBookingStep >= 5 ? 'teal' : 'inkMuted'
        }
    },
    StepDot6: {
        flow: 'y',
        align: 'center center',
        flex: '1',
        gap: 'X',
        StepBar: {
            height: 'X',
            width: '100%',
            round: 'X',
            background: (el, s)=>s.root.activeBookingStep >= 6 ? 'teal' : 'inkBorder'
        },
        StepLabel: {
            text: '{{ confirm | polyglot }}',
            fontSize: 'Y',
            color: (el, s)=>s.root.activeBookingStep >= 6 ? 'teal' : 'inkMuted'
        }
    }
};


var $5d673512a9117fe3$exports = {};

$parcel$export($5d673512a9117fe3$exports, "PainPointCard", () => $5d673512a9117fe3$export$f73ca08b83a68e39);
const $5d673512a9117fe3$export$f73ca08b83a68e39 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    flex: '1',
    minWidth: 'E',
    PainEmoji: {
        text: (el, s)=>s.emoji,
        fontSize: 'C'
    },
    PainTitle: {
        tag: 'h3',
        text: (el, s)=>s.title,
        fontSize: 'A',
        fontWeight: '600',
        color: 'inkText'
    },
    PainDetail: {
        text: (el, s)=>s.detail,
        fontSize: 'Z',
        color: 'inkSubtle',
        lineHeight: '1.6'
    }
};


var $b2bcaff2106d22a4$exports = {};

$parcel$export($b2bcaff2106d22a4$exports, "ClinicListCard", () => $b2bcaff2106d22a4$export$1b1403c571072fb);
const $b2bcaff2106d22a4$export$1b1403c571072fb = {
    extends: 'Link',
    href: (el, s)=>'/clinic?id=' + s.id,
    textDecoration: 'none',
    color: 'inherit',
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid transparent',
    cursor: 'pointer',
    transition: 'all 0.25s ease',
    ':hover': {
        border: '1px solid inkBorder',
        boxShadow: '0 8px 24px rgba(0,0,0,0.06)'
    },
    show: (el, s)=>{
        const q = s.root.clinicFilter;
        if (!q) return true;
        const lower = q.toLowerCase();
        return s.name.toLowerCase().includes(lower) || s.district.toLowerCase().includes(lower) || (s.services || []).some((sv)=>sv.toLowerCase().includes(lower));
    },
    CardHeader: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'Z',
        HeaderLeft: {
            flow: 'x',
            align: 'flex-start flex-start',
            gap: 'Z',
            flex: '1',
            minWidth: '0',
            ClinicLogo: {
                tag: 'img',
                width: 'C',
                height: 'C',
                round: 'Z',
                flexShrink: '0',
                attr: {
                    src: (el, s)=>s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.name) + '&background=0D1117&color=00C9A7&size=96&bold=true&format=svg'
                }
            },
            NameGroup: {
                flow: 'y',
                gap: 'W',
                minWidth: '0',
                ClinicName: {
                    text: (el, s)=>s.name,
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'inkText',
                    lineHeight: '1.3'
                },
                ClinicLoc: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center flex-start',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    LocDistrict: {
                        text: (el, s)=>s.district,
                        fontSize: 'Z',
                        color: 'inkText',
                        fontWeight: '500',
                        flexShrink: '0'
                    },
                    LocDot: {
                        text: "\xb7",
                        fontSize: 'Z',
                        color: 'inkMuted',
                        flexShrink: '0'
                    },
                    LocAddress: {
                        text: (el, s)=>s.address,
                        fontSize: 'Z',
                        color: 'inkMuted',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        minWidth: '0'
                    }
                }
            }
        },
        RatingBadge: {
            flow: 'x',
            gap: 'W',
            align: 'center center',
            padding: 'W Y',
            round: 'Y',
            background: 'teal.1',
            flexShrink: '0',
            RatingStar: {
                extends: 'Icon',
                icon: 'star',
                width: 'Z',
                height: 'Z',
                color: 'teal'
            },
            RatingVal: {
                text: (el, s)=>String(s.rating),
                fontSize: 'Z',
                fontWeight: '600',
                color: 'teal'
            }
        }
    },
    DiscountBadge: {
        show: (el, s)=>{
            const discounts = s.root.clinicDiscounts;
            return discounts && discounts[s.id];
        },
        flow: 'x',
        gap: 'W',
        align: 'center center',
        padding: 'W Y',
        round: 'Y',
        background: 'teal.15',
        marginTop: 'Y',
        width: 'fit-content',
        BadgeIcon: {
            extends: 'Icon',
            icon: 'tag',
            width: 'Y',
            height: 'Y',
            color: 'teal'
        },
        BadgeText: {
            text: '{{ specialOffer | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'teal'
        }
    },
    CardMeta: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        align: 'center flex-start',
        marginTop: 'Y',
        color: 'inkMuted',
        fontSize: 'Z',
        MetaReviews: {
            text: (el, s)=>s.reviews + ' reviews'
        },
        MetaDot1: {
            text: "\xb7"
        },
        MetaHours: {
            text: (el, s)=>s.hours
        },
        MetaDot2: {
            text: "\xb7",
            show: (el, s)=>!s.root.hidePrices
        },
        MetaPrice: {
            text: (el, s)=>s.priceRange,
            show: (el, s)=>!s.root.hidePrices
        }
    },
    CardServices: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        marginTop: 'Y',
        children: (el, s)=>(s.services || []).map((sv)=>({
                    label: sv
                })),
        childrenAs: 'state',
        childProps: {
            text: (el, s)=>s.label,
            fontSize: 'Z',
            padding: 'X Z',
            round: 'C',
            background: 'inkSurface',
            color: 'inkSubtle',
            fontWeight: '500'
        }
    }
};


var $b11e431348e0cc21$exports = {};

$parcel$export($b11e431348e0cc21$exports, "ThemeToggle", () => $b11e431348e0cc21$export$173e0a822059eddc);
const $b11e431348e0cc21$var$LIGHT_VARS = ':root{--color-ink:#FAFAFA;--color-inkMid:#FFFFFF;--color-inkSurface:#F0F0F5;--color-inkBorder:#D2D2D7;--color-inkMuted:#6E6E73;--color-inkSubtle:#3A3A3C;--color-inkText:#1D1D1F;--theme-document-background:#FAFAFA;--theme-document-color:#1D1D1F}';
const $b11e431348e0cc21$var$applyTheme = (isDark)=>{
    let st = document.getElementById('__dm');
    if (!st) {
        st = document.createElement('style');
        st.id = '__dm';
        document.head.appendChild(st);
    }
    st.textContent = isDark ? '' : $b11e431348e0cc21$var$LIGHT_VARS;
    localStorage.setItem('__dental_theme', isDark ? 'dark' : 'light');
};
const $b11e431348e0cc21$export$173e0a822059eddc = {
    tag: 'button',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 'Y',
    round: 'Y',
    color: 'inkMuted',
    display: 'flex',
    align: 'center center',
    ':hover': {
        background: 'inkSurface',
        color: 'inkText'
    },
    show: (()=>{
        let inited = false;
        return (el, s)=>{
            if (!inited) {
                inited = true;
                const saved = localStorage.getItem('__dental_theme');
                if (saved === 'light') Promise.resolve().then(()=>{
                    s.root.update({
                        darkMode: false
                    });
                    $b11e431348e0cc21$var$applyTheme(false);
                });
            }
            return true;
        };
    })(),
    onClick: (e, el, s)=>{
        const isDark = !s.root.darkMode;
        s.root.update({
            darkMode: isDark
        });
        $b11e431348e0cc21$var$applyTheme(isDark);
    },
    ThemeIcon: {
        extends: 'Icon',
        icon: (el, s)=>s.root.darkMode ? 'sun' : 'moon',
        width: 'A',
        height: 'A'
    }
};


var $e791da1e519e3866$exports = {};

$parcel$export($e791da1e519e3866$exports, "MobileTabBar", () => $e791da1e519e3866$export$8373dbaf5dc36b72);
$parcel$export($e791da1e519e3866$exports, "MobileTabItem", () => $e791da1e519e3866$export$7419237cb724da15);
const $e791da1e519e3866$export$8373dbaf5dc36b72 = {
    display: 'none',
    '@mobileL': {
        display: 'flex',
        flow: 'x'
    },
    align: 'center space-around',
    padding: 'Y 0',
    background: 'inkMid',
    borderTop: '1px solid inkBorder',
    position: 'sticky',
    bottom: '0',
    zIndex: '100',
    width: '100%',
    MobileTabHome: {
        extends: 'MobileTabItem',
        state: {
            tabKey: 'appointments',
            iconName: 'calendar'
        }
    },
    MobileTabPatients: {
        extends: 'MobileTabItem',
        state: {
            tabKey: 'patients',
            iconName: 'users'
        }
    },
    MobileTabCalendar: {
        extends: 'MobileTabItem',
        state: {
            tabKey: 'calendar',
            iconName: 'clock'
        }
    },
    MobileTabFinance: {
        extends: 'MobileTabItem',
        state: {
            tabKey: 'finance',
            iconName: 'dollarSign'
        }
    },
    MobileTabAi: {
        extends: 'MobileTabItem',
        state: {
            tabKey: 'ai',
            iconName: 'sparkle'
        }
    }
};
const $e791da1e519e3866$export$7419237cb724da15 = {
    tag: 'button',
    flow: 'y',
    align: 'center center',
    gap: 'X',
    padding: 'Y Z',
    cursor: 'pointer',
    flex: '1',
    color: 'inkMuted',
    background: 'none',
    border: 'none',
    isActive: (el, s)=>{
        const path = window.location.pathname;
        if (path === '/ai' && s.tabKey === 'ai') return true;
        if (path === '/patient' && s.tabKey === 'patients') return true;
        return s.root.activeTab === s.tabKey;
    },
    '.isActive': {
        color: 'inkText'
    },
    onClick: (e, el, s)=>{
        if (s.tabKey === 'ai') {
            window.location.href = '/ai';
            return;
        }
        s.root.update({
            activeTab: s.tabKey
        });
    },
    TabIcon: {
        extends: 'Icon',
        icon: (el, s)=>s.iconName,
        width: 'A',
        height: 'A'
    }
};


var $fb3cc24df2f6a035$exports = {};

$parcel$export($fb3cc24df2f6a035$exports, "askGemini", () => $fb3cc24df2f6a035$export$62406c3f3822876c);
$parcel$export($fb3cc24df2f6a035$exports, "AiModal", () => $fb3cc24df2f6a035$export$6d029938fac14260);
const $fb3cc24df2f6a035$var$GEMINI_URL = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc';
const $fb3cc24df2f6a035$var$SYSTEM_PROMPT = `You are an AI dental assistant for a dental clinic directory in Georgia (Tbilisi). Help users find the best dental clinics, services, and answer dental health questions.

IMPORTANT: When recommending clinics, you MUST include a JSON block at the end of your response with the clinic IDs you recommend. Format:
<!--CLINICS:["clinic-id-1","clinic-id-2"]-->

Only use IDs from this list. Be helpful, concise. Respond in the same language the user writes in (Georgian or English).`;
const $fb3cc24df2f6a035$export$62406c3f3822876c = async (thread, clinics)=>{
    const clinicContext = clinics.map((c)=>`ID: ${c.id} | ${c.name} (${c.district}) - Rating: ${c.rating}, Services: ${c.services.join(', ')}, Hours: ${c.hours}, Price: ${c.priceRange}`).join('\n');
    const contents = thread.map((m)=>({
            role: m.role === 'assistant' ? 'model' : 'user',
            parts: [
                {
                    text: m.content
                }
            ]
        }));
    const res = await fetch($fb3cc24df2f6a035$var$GEMINI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            systemInstruction: {
                parts: [
                    {
                        text: $fb3cc24df2f6a035$var$SYSTEM_PROMPT + '\n\nAvailable clinics:\n' + clinicContext
                    }
                ]
            },
            contents: contents,
            generationConfig: {
                temperature: 0.3,
                maxOutputTokens: 1024
            }
        })
    });
    const data = await res.json();
    return data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response received.';
};
const $fb3cc24df2f6a035$var$parseClinicIds = (text)=>{
    const match = text.match(/<!--CLINICS:\[([^\]]*)\]-->/);
    if (!match) return [];
    try {
        return JSON.parse('[' + match[1] + ']');
    } catch  {
        return [];
    }
};
const $fb3cc24df2f6a035$var$cleanResponse = (text)=>(text || '').replace(/<!--CLINICS:\[[^\]]*\]-->/, '').trim();
const $fb3cc24df2f6a035$var$formatHtml = (text)=>{
    if (!text) return '';
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>');
};
const $fb3cc24df2f6a035$export$6d029938fac14260 = {
    show: (el, s)=>s.root.showAiModal,
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '1000',
    Backdrop: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        cursor: 'pointer',
        onClick: (e, el, s)=>s.root.update({
                showAiModal: false
            })
    },
    ModalPanel: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        attr: {
            style: 'transform: translate(-50%, -50%)'
        },
        width: '90%',
        maxWidth: '640px',
        maxHeight: '80vh',
        background: '#FFFFFF',
        round: 'B',
        boxShadow: '0 24px 80px rgba(0,0,0,0.2)',
        flow: 'y',
        overflow: 'hidden',
        ModalHeader: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A B',
            borderBottom: '1px solid #E5E5EA',
            flexShrink: '0',
            HeaderLeft: {
                flow: 'x',
                align: 'center center',
                gap: 'Y',
                SparkleIcon: {
                    extends: 'Icon',
                    icon: 'sparkle',
                    width: 'A',
                    height: 'A',
                    color: 'teal'
                },
                HeaderTitle: {
                    text: '{{ aiAssistant | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: '#1D1D1F'
                }
            },
            CloseBtn: {
                tag: 'button',
                text: '{{ u2715 | polyglot }}',
                background: 'transparent',
                border: 'none',
                fontSize: 'A',
                color: '#6E6E73',
                cursor: 'pointer',
                padding: 'Y',
                round: 'Y',
                ':hover': {
                    background: '#F0F0F5'
                },
                onClick: (e, el, s)=>s.root.update({
                        showAiModal: false
                    })
            }
        },
        ThreadBody: {
            flow: 'y',
            gap: 'Z',
            padding: 'A B',
            overflow: 'auto',
            flex: '1',
            children: (el, s)=>{
                const thread = s.root.aiModalThread || [];
                const clinics = s.root.clinics || [];
                return thread.map((m)=>{
                    const entry = {
                        role: m.role,
                        content: m.content
                    };
                    if (m.role === 'assistant') {
                        const ids = $fb3cc24df2f6a035$var$parseClinicIds(m.content);
                        if (ids.length) entry.recommendedClinics = ids.map((id)=>clinics.find((c)=>c.id === id)).filter(Boolean);
                        entry.cleanContent = $fb3cc24df2f6a035$var$cleanResponse(m.content);
                    }
                    return entry;
                });
            },
            childrenAs: 'state',
            childExtends: {
                flow: 'y',
                gap: 'Z',
                alignSelf: (el, s)=>s.role === 'user' ? 'flex-end' : 'flex-start',
                maxWidth: '90%',
                MessageBubble: {
                    padding: 'Z A',
                    round: 'A',
                    background: (el, s)=>s.role === 'user' ? '#0D1117' : '#F0F0F5',
                    MessageText: {
                        html: (el, s)=>$fb3cc24df2f6a035$var$formatHtml(s.role === 'user' ? s.content : s.cleanContent || s.content),
                        fontSize: 'Z',
                        color: (el, s)=>s.role === 'user' ? '#FFFFFF' : '#1D1D1F',
                        lineHeight: '1.6'
                    }
                },
                ClinicCards: {
                    show: (el, s)=>s.recommendedClinics && s.recommendedClinics.length > 0,
                    flow: 'y',
                    gap: 'Y',
                    width: '100%',
                    children: (el, s)=>s.recommendedClinics || [],
                    childrenAs: 'state',
                    childExtends: {
                        extends: 'Link',
                        href: (el, s)=>'/clinic?id=' + s.id,
                        textDecoration: 'none',
                        color: 'inherit',
                        flow: 'x',
                        gap: 'Z',
                        align: 'center flex-start',
                        padding: 'Z A',
                        round: 'Z',
                        background: '#FFFFFF',
                        border: '1px solid #E5E5EA',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        ':hover': {
                            border: '1px solid #00C9A7',
                            boxShadow: '0 4px 12px rgba(0,201,167,0.1)'
                        },
                        CardLogo: {
                            tag: 'img',
                            width: 'B1',
                            height: 'B1',
                            round: 'Y',
                            flexShrink: '0',
                            attr: {
                                src: (el, s)=>s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.name) + '&background=0D1117&color=00C9A7&size=96&bold=true&format=svg'
                            }
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'W',
                            flex: '1',
                            minWidth: '0',
                            CardName: {
                                text: (el, s)=>s.name,
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: '#1D1D1F'
                            },
                            CardMeta: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                CardDistrict: {
                                    text: (el, s)=>s.district,
                                    fontSize: 'Y',
                                    color: '#6E6E73'
                                },
                                CardDot: {
                                    text: '{{ u00b7 | polyglot }}',
                                    fontSize: 'Y',
                                    color: '#6E6E73'
                                },
                                CardPrice: {
                                    text: (el, s)=>s.priceRange,
                                    fontSize: 'Y',
                                    color: '#6E6E73'
                                }
                            }
                        },
                        CardRating: {
                            flow: 'x',
                            gap: 'W',
                            align: 'center center',
                            flexShrink: '0',
                            RatingStar: {
                                extends: 'Icon',
                                icon: 'star',
                                width: 'Z',
                                height: 'Z',
                                color: 'teal'
                            },
                            RatingVal: {
                                text: (el, s)=>String(s.rating),
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'teal'
                            }
                        }
                    }
                }
            },
            LoadingIndicator: {
                show: (el, s)=>s.root.aiModalLoading,
                flow: 'x',
                align: 'flex-start center',
                gap: 'Y',
                padding: 'Z A',
                round: 'A',
                background: '#F0F0F5',
                alignSelf: 'flex-start',
                LoadingDots: {
                    text: '{{ thinking | polyglot }}',
                    fontSize: 'Z',
                    color: 'teal',
                    fontWeight: '500'
                }
            }
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z',
            padding: 'A B',
            borderTop: '1px solid #E5E5EA',
            align: 'center center',
            flexShrink: '0',
            FollowUpInput: {
                tag: 'input',
                type: 'text',
                placeholder: '{{ followUpPlaceholder | polyglot }}',
                flex: '1',
                padding: 'Z A',
                round: 'A',
                background: '#F0F0F5',
                border: '1px solid #E5E5EA',
                fontSize: 'Z',
                color: '#1D1D1F',
                outline: 'none',
                ':focus': {
                    borderColor: '#00C9A7'
                },
                on: {
                    keydown: (e, el, s)=>{
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            el.parent.FollowUpBtn.node.click();
                        }
                    }
                }
            },
            FollowUpBtn: {
                tag: 'button',
                background: '#0D1117',
                color: '#FFFFFF',
                border: 'none',
                padding: 'Z A',
                round: 'A',
                fontSize: 'Z',
                fontWeight: '600',
                cursor: 'pointer',
                ':hover': {
                    opacity: '0.9'
                },
                align: 'center center',
                SendIcon: {
                    extends: 'Icon',
                    icon: 'send',
                    width: 'Z',
                    height: 'Z',
                    color: '#FFFFFF'
                },
                onClick: async (e, el, s)=>{
                    const input = el.lookup('FollowUpInput');
                    const msg = input.node.value;
                    if (!msg.trim() || s.root.aiModalLoading) return;
                    input.node.value = '';
                    const thread = [
                        ...s.root.aiModalThread || [],
                        {
                            role: 'user',
                            content: msg
                        }
                    ];
                    s.root.update({
                        aiModalThread: thread,
                        aiModalLoading: true
                    });
                    try {
                        const reply = await $fb3cc24df2f6a035$export$62406c3f3822876c(thread, s.root.clinics || []);
                        s.root.update({
                            aiModalThread: [
                                ...thread,
                                {
                                    role: 'assistant',
                                    content: reply
                                }
                            ],
                            aiModalLoading: false
                        });
                    } catch (err) {
                        s.root.update({
                            aiModalThread: [
                                ...thread,
                                {
                                    role: 'assistant',
                                    content: 'Error: ' + err.message
                                }
                            ],
                            aiModalLoading: false
                        });
                    }
                }
            }
        }
    }
};


var $403c48608a3af55e$exports = {};

$parcel$export($403c48608a3af55e$exports, "SoapNote", () => $403c48608a3af55e$export$d09148132c03a08b);
const $403c48608a3af55e$export$d09148132c03a08b = {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    state: {
        subjectiveOpen: true,
        objectiveOpen: true,
        assessmentOpen: true,
        planOpen: true,
        painScale: 5,
        subjective: '',
        objective: '',
        assessment: '',
        plan: '',
        prescriptions: ''
    },
    SubjectiveSection: {
        flow: 'y',
        gap: 'Z',
        Header: {
            flow: 'x',
            align: 'center flex-start',
            gap: 'Z',
            cursor: 'pointer',
            padding: 'Z',
            borderBottom: '1px solid inkBorder',
            onClick: (el, s)=>s.update({
                    subjectiveOpen: !s.subjectiveOpen
                }),
            Arrow: {
                text: (el, s)=>s.subjectiveOpen ? "\u25BE" : "\u25B8",
                fontSize: 'Z',
                color: 'inkSubtle'
            },
            Label: {
                text: '{{ subjective | polyglot }}',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkSubtle',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            }
        },
        Body: {
            show: (el, s)=>s.subjectiveOpen,
            flow: 'y',
            gap: 'Z',
            padding: 'Z',
            ChiefComplaintLabel: {
                text: '{{ chiefComplaint | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600'
            },
            ChiefComplaint: {
                tag: 'textarea',
                placeholder: 'Describe chief complaint...',
                rows: '3',
                width: '100%',
                padding: 'Z',
                round: 'Y',
                border: '1px solid inkBorder',
                background: 'ink',
                color: 'inkText',
                fontSize: 'Z',
                resize: 'vertical',
                onInput: (ev, el, s)=>s.update({
                        subjective: el.node.value
                    })
            },
            PainScaleWrap: {
                flow: 'x',
                align: 'center flex-start',
                gap: 'Z',
                PainLabel: {
                    text: '{{ painScale | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted',
                    fontWeight: '600'
                },
                PainValue: {
                    text: (el, s)=>`${s.painScale}/10`,
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: 'teal'
                },
                PainInput: {
                    tag: 'input',
                    attr: {
                        type: 'range',
                        min: '1',
                        max: '10'
                    },
                    value: (el, s)=>s.painScale,
                    onInput: (ev, el, s)=>s.update({
                            painScale: parseInt(el.node.value)
                        })
                }
            }
        }
    },
    ObjectiveSection: {
        flow: 'y',
        gap: 'Z',
        Header: {
            flow: 'x',
            align: 'center flex-start',
            gap: 'Z',
            cursor: 'pointer',
            padding: 'Z',
            borderBottom: '1px solid inkBorder',
            onClick: (el, s)=>s.update({
                    objectiveOpen: !s.objectiveOpen
                }),
            Arrow: {
                text: (el, s)=>s.objectiveOpen ? "\u25BE" : "\u25B8",
                fontSize: 'Z',
                color: 'inkSubtle'
            },
            Label: {
                text: '{{ objective | polyglot }}',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkSubtle',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            }
        },
        Body: {
            show: (el, s)=>s.objectiveOpen,
            flow: 'y',
            gap: 'Z',
            padding: 'Z',
            FindingsLabel: {
                text: '{{ clinicalFindings | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600'
            },
            Findings: {
                tag: 'textarea',
                placeholder: 'Document clinical findings...',
                rows: '3',
                width: '100%',
                padding: 'Z',
                round: 'Y',
                border: '1px solid inkBorder',
                background: 'ink',
                color: 'inkText',
                fontSize: 'Z',
                resize: 'vertical',
                onInput: (ev, el, s)=>s.update({
                        objective: el.node.value
                    })
            }
        }
    },
    AssessmentSection: {
        flow: 'y',
        gap: 'Z',
        Header: {
            flow: 'x',
            align: 'center flex-start',
            gap: 'Z',
            cursor: 'pointer',
            padding: 'Z',
            borderBottom: '1px solid inkBorder',
            onClick: (el, s)=>s.update({
                    assessmentOpen: !s.assessmentOpen
                }),
            Arrow: {
                text: (el, s)=>s.assessmentOpen ? "\u25BE" : "\u25B8",
                fontSize: 'Z',
                color: 'inkSubtle'
            },
            Label: {
                text: '{{ assessment | polyglot }}',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkSubtle',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            }
        },
        Body: {
            show: (el, s)=>s.assessmentOpen,
            flow: 'y',
            gap: 'Z',
            padding: 'Z',
            DiagnosisLabel: {
                text: '{{ diagnosis | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600'
            },
            Diagnosis: {
                tag: 'input',
                attr: {
                    type: 'text'
                },
                placeholder: 'Enter diagnosis...',
                width: '100%',
                padding: 'Z',
                round: 'Y',
                border: '1px solid inkBorder',
                background: 'ink',
                color: 'inkText',
                fontSize: 'Z',
                onInput: (ev, el, s)=>s.update({
                        assessment: el.node.value
                    })
            }
        }
    },
    PlanSection: {
        flow: 'y',
        gap: 'Z',
        Header: {
            flow: 'x',
            align: 'center flex-start',
            gap: 'Z',
            cursor: 'pointer',
            padding: 'Z',
            borderBottom: '1px solid inkBorder',
            onClick: (el, s)=>s.update({
                    planOpen: !s.planOpen
                }),
            Arrow: {
                text: (el, s)=>s.planOpen ? "\u25BE" : "\u25B8",
                fontSize: 'Z',
                color: 'inkSubtle'
            },
            Label: {
                text: '{{ plan | polyglot }}',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkSubtle',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            }
        },
        Body: {
            show: (el, s)=>s.planOpen,
            flow: 'y',
            gap: 'Z',
            padding: 'Z',
            TreatmentLabel: {
                text: '{{ treatmentPlan | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600'
            },
            Treatment: {
                tag: 'textarea',
                placeholder: 'Describe treatment plan...',
                rows: '3',
                width: '100%',
                padding: 'Z',
                round: 'Y',
                border: '1px solid inkBorder',
                background: 'ink',
                color: 'inkText',
                fontSize: 'Z',
                resize: 'vertical',
                onInput: (ev, el, s)=>s.update({
                        plan: el.node.value
                    })
            },
            PrescriptionsLabel: {
                text: '{{ prescriptions | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600'
            },
            Prescriptions: {
                tag: 'textarea',
                placeholder: 'List prescriptions...',
                rows: '2',
                width: '100%',
                padding: 'Z',
                round: 'Y',
                border: '1px solid inkBorder',
                background: 'ink',
                color: 'inkText',
                fontSize: 'Z',
                resize: 'vertical',
                onInput: (ev, el, s)=>s.update({
                        prescriptions: el.node.value
                    })
            }
        }
    }
};


var $f918ed4841c6aab1$exports = {};

$parcel$export($f918ed4841c6aab1$exports, "NoteTemplate", () => $f918ed4841c6aab1$export$3dd9f1930b58f69b);
$parcel$export($f918ed4841c6aab1$exports, "NoteTemplatePill", () => $f918ed4841c6aab1$export$d5fd9d65a44ade0d);
const $f918ed4841c6aab1$export$3dd9f1930b58f69b = {
    flow: 'x',
    gap: 'Z',
    flexWrap: 'wrap',
    padding: 'Z',
    children: [
        {
            templateName: 'Extraction'
        },
        {
            templateName: 'Root Canal'
        },
        {
            templateName: 'Crown Prep'
        },
        {
            templateName: 'Perio Maintenance'
        },
        {
            templateName: 'Exam'
        },
        {
            templateName: 'Emergency'
        }
    ],
    childrenAs: 'state',
    childExtends: 'NoteTemplatePill'
};
const $f918ed4841c6aab1$export$d5fd9d65a44ade0d = {
    tag: 'span',
    text: (el, s)=>s.templateName,
    padding: 'Y A',
    round: 'C',
    fontSize: 'Z',
    fontWeight: '600',
    background: 'teal.1',
    color: 'teal',
    cursor: 'pointer',
    transition: 'background 0.15s',
    ':hover': {
        background: 'teal.2'
    },
    onClick: (el, s)=>{
        const root = s.root || s;
        root.update({
            templateType: s.templateName
        });
    }
};


var $e44a7f8d70078042$exports = {};

$parcel$export($e44a7f8d70078042$exports, "ClinicalNoteCard", () => $e44a7f8d70078042$export$90a8222b603371db);
const $e44a7f8d70078042$export$90a8222b603371db = {
    flow: 'y',
    gap: 'Y',
    padding: 'A',
    round: 'Y',
    background: (el, s)=>s.index !== undefined && s.index % 2 === 1 ? 'inkMid' : 'ink',
    state: {
        aiMode: false
    },
    TopRow: {
        flow: 'x',
        align: 'center flex-start',
        gap: 'Z',
        justifyContent: 'space-between',
        LeftInfo: {
            flow: 'x',
            gap: 'Z',
            align: 'center flex-start',
            NoteDate: {
                text: (el, s)=>s.date || '',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '500'
            },
            Provider: {
                text: (el, s)=>s.provider || '',
                fontSize: 'Y',
                color: 'inkMuted'
            }
        },
        AiToggle: {
            tag: 'button',
            text: 'AI',
            fontSize: 'X',
            fontWeight: '800',
            padding: 'X Y',
            round: 'X',
            border: 'none',
            cursor: 'pointer',
            background: (el, s)=>s.aiMode ? 'violet' : 'violet.15',
            color: (el, s)=>s.aiMode ? 'white' : 'violet',
            transition: 'background 0.15s, color 0.15s',
            ':hover': {
                opacity: '0.85'
            },
            onClick: (el, s)=>s.update({
                    aiMode: !s.aiMode
                })
        }
    },
    SpecialtyBadge: {
        tag: 'span',
        show: (el, s)=>!!s.specialty,
        text: (el, s)=>s.specialty || '',
        fontSize: 'X',
        fontWeight: '700',
        padding: 'X Y',
        round: 'C',
        textTransform: 'capitalize',
        alignSelf: 'flex-start',
        background: (el, s)=>{
            var sp = s.specialty;
            if (sp === 'orthodontics') return 'purple.15';
            if (sp === 'endodontics') return 'red.15';
            if (sp === 'periodontics') return 'green.15';
            if (sp === 'surgery') return 'amber.15';
            if (sp === 'general') return 'blue.15';
            if (sp === 'prosthetics') return 'pink.15';
            return 'inkSurface';
        },
        color: (el, s)=>{
            var sp = s.specialty;
            if (sp === 'orthodontics') return 'purple';
            if (sp === 'endodontics') return 'red';
            if (sp === 'periodontics') return 'green';
            if (sp === 'surgery') return 'amber';
            if (sp === 'general') return 'blue';
            if (sp === 'prosthetics') return 'pink';
            return 'inkMuted';
        }
    },
    ProcedureTag: {
        tag: 'span',
        text: (el, s)=>{
            if (s.aiMode && s.procedure) {
                var result = el.call('normalizeTerms', s.procedure);
                return result ? result.normalized : s.procedure;
            }
            return s.procedure || '';
        },
        fontSize: 'Y',
        fontWeight: '600',
        padding: 'X Y',
        round: 'Y',
        background: (el, s)=>s.aiMode ? 'violet.15' : 'teal.15',
        color: (el, s)=>s.aiMode ? 'violet' : 'teal',
        alignSelf: 'flex-start'
    },
    SoapSummary: {
        tag: 'div',
        fontSize: 'Z',
        color: 'inkText',
        lineHeight: '1.4',
        html: (el, s)=>{
            var t = s.summary || '';
            if (!s.aiMode) {
                var plain = t.length > 120 ? t.slice(0, 120) + '...' : t;
                return plain;
            }
            var result = el.call('normalizeTerms', t);
            if (!result || !result.changes || !result.changes.length) return t.length > 120 ? t.slice(0, 120) + '...' : t;
            var output = result.normalized;
            var changes = result.changes.slice().sort(function(a, b) {
                return b.position - a.position;
            });
            for(var i = 0; i < changes.length; i++){
                var c = changes[i];
                var before = output.slice(0, c.position);
                var term = output.slice(c.position, c.position + c.normalized.length);
                var after = output.slice(c.position + c.normalized.length);
                output = before + '<span style="background:rgba(139,92,246,0.15);padding:1px 3px;border-radius:3px;cursor:help" title="' + c.original + '">' + term + '</span>' + after;
            }
            return output;
        }
    },
    ExpandLink: {
        tag: 'span',
        text: '{{ expand | polyglot }}',
        fontSize: 'Y',
        color: 'teal',
        fontWeight: '600',
        cursor: 'pointer',
        alignSelf: 'flex-start',
        ':hover': {
            textDecoration: 'underline'
        }
    }
};


var $78912a1ebc9679bc$exports = {};

$parcel$export($78912a1ebc9679bc$exports, "ClaimCard", () => $78912a1ebc9679bc$export$391e5a8ac3c44aca);
$parcel$export($78912a1ebc9679bc$exports, "ClaimCDTCode", () => $78912a1ebc9679bc$export$6646f5b879d7e6c7);
const $78912a1ebc9679bc$export$391e5a8ac3c44aca = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    HeaderRow: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        ClaimNumber: {
            text: (el, s)=>s.claimNumber || '',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        ClaimStatus: {
            tag: 'span',
            text: (el, s)=>s.claimStatus || '',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const st = s.claimStatus;
                if (st === 'Submitted') return 'blue.15';
                if (st === 'Accepted') return 'teal.15';
                if (st === 'Paid') return 'green.15';
                if (st === 'Denied') return 'red.15';
                if (st === 'Appealed') return 'amber.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const st = s.claimStatus;
                if (st === 'Submitted') return 'blue';
                if (st === 'Accepted') return 'teal';
                if (st === 'Paid') return 'green';
                if (st === 'Denied') return 'red';
                if (st === 'Appealed') return 'amber';
                return 'inkMuted';
            }
        }
    },
    PatientName: {
        text: (el, s)=>s.patientName || '',
        fontSize: 'Z',
        color: 'inkText',
        fontWeight: '600'
    },
    ProviderName: {
        text: (el, s)=>s.providerName || '',
        fontSize: 'Y',
        color: 'inkMuted'
    },
    DateOfService: {
        text: (el, s)=>s.dateOfService ? `DOS: ${s.dateOfService}` : '',
        fontSize: 'Y',
        color: 'inkMuted'
    },
    CDTCodes: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        children: (el, s)=>(s.cdtCodes || []).map((code)=>({
                    text: code
                })),
        childrenAs: 'state',
        childExtends: 'ClaimCDTCode'
    },
    Divider: {
        height: '1px',
        background: 'inkBorder'
    },
    FinancialsRow: {
        flow: 'y',
        gap: 'Y',
        TotalCharged: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ totalCharged | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.totalCharged || '',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkText'
            }
        },
        InsurancePayment: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ insurancePayment | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.insurancePayment || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'green'
            }
        },
        PatientResponsibility: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ patientResponsibility | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.patientResponsibility || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        }
    }
};
const $78912a1ebc9679bc$export$6646f5b879d7e6c7 = {
    tag: 'span',
    text: (el, s)=>s.text || '',
    fontSize: 'Y',
    fontWeight: '600',
    padding: 'X Y',
    round: 'Y',
    background: 'inkSurface',
    color: 'inkMuted'
};


var $43bf22cb6cdbd180$exports = {};

$parcel$export($43bf22cb6cdbd180$exports, "EligibilityCard", () => $43bf22cb6cdbd180$export$ff0ff844cfe47ec8);
const $43bf22cb6cdbd180$export$ff0ff844cfe47ec8 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: (el, s)=>s.expired ? '2px solid red' : '2px solid green',
    state: {
        expired: false
    },
    HeaderRow: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        InsuranceName: {
            text: (el, s)=>s.insuranceName || '',
            fontSize: 'A',
            fontWeight: '700',
            color: 'inkText'
        },
        ActiveBadge: {
            tag: 'span',
            text: (el, s)=>s.expired ? 'Expired' : 'Active',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>s.expired ? 'red.15' : 'green.15',
            color: (el, s)=>s.expired ? 'red' : 'green'
        }
    },
    PolicyRow: {
        flow: 'x',
        gap: 'A',
        PolicyNumber: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ policyNumber | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.policyNumber || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        PlanType: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ planType | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.planType || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        }
    },
    Divider: {
        height: '1px',
        background: 'inkBorder'
    },
    BenefitsRow: {
        flow: 'x',
        gap: 'A',
        AnnualMax: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ annualMax | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.annualMax || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        AnnualUsed: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ used | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.annualUsed || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        Remaining: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ remaining | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.remaining || '',
                fontSize: 'B',
                fontWeight: '700',
                color: 'teal'
            }
        }
    },
    DeductibleMet: {
        tag: 'span',
        text: (el, s)=>s.deductibleMet ? 'Deductible Met' : 'Deductible Not Met',
        fontSize: 'Y',
        fontWeight: '600',
        padding: 'X Z',
        round: 'B',
        alignSelf: 'flex-start',
        background: (el, s)=>s.deductibleMet ? 'green.15' : 'amber.15',
        color: (el, s)=>s.deductibleMet ? 'green' : 'amber'
    },
    Divider2: {
        height: '1px',
        background: 'inkBorder'
    },
    CoverageTitle: {
        text: '{{ coverageByCategory | polyglot }}',
        fontSize: 'Y',
        fontWeight: '700',
        color: 'inkSubtle',
        textTransform: 'uppercase',
        letterSpacing: 'X'
    },
    CoverageGrid: {
        flow: 'y',
        gap: 'Y',
        Preventive: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ preventive | polyglot }}',
                fontSize: 'Z',
                color: 'inkText'
            },
            Value: {
                text: '100%',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'green'
            }
        },
        Basic: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ basic | polyglot }}',
                fontSize: 'Z',
                color: 'inkText'
            },
            Value: {
                text: '80%',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'teal'
            }
        },
        Major: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ major | polyglot }}',
                fontSize: 'Z',
                color: 'inkText'
            },
            Value: {
                text: '50%',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'amber'
            }
        },
        Ortho: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ ortho | polyglot }}',
                fontSize: 'Z',
                color: 'inkText'
            },
            Value: {
                text: '50%',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'amber'
            }
        }
    },
    VerifiedDate: {
        text: (el, s)=>s.verifiedDate ? `Verified: ${s.verifiedDate}` : '',
        fontSize: 'Y',
        color: 'inkMuted',
        fontStyle: 'italic'
    }
};


var $b3dba13d61cef323$exports = {};

$parcel$export($b3dba13d61cef323$exports, "AgingBucket", () => $b3dba13d61cef323$export$6c4602856f96c374);
const $b3dba13d61cef323$export$6c4602856f96c374 = {
    flow: 'x',
    gap: 'A',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    CurrentBucket: {
        flex: '1',
        flow: 'y',
        gap: 'Y',
        align: 'center center',
        padding: 'A',
        Label: {
            text: '{{ current | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        Amount: {
            text: (el, s)=>s.currentAmount || '$0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'green'
        },
        Count: {
            text: (el, s)=>s.currentCount ? `${s.currentCount} accounts` : '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    ThirtyBucket: {
        flex: '1',
        flow: 'y',
        gap: 'Y',
        align: 'center center',
        padding: 'A',
        Label: {
            text: '{{ thirtyDay | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        Amount: {
            text: (el, s)=>s.thirtyAmount || '$0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'amber'
        },
        Count: {
            text: (el, s)=>s.thirtyCount ? `${s.thirtyCount} accounts` : '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    SixtyBucket: {
        flex: '1',
        flow: 'y',
        gap: 'Y',
        align: 'center center',
        padding: 'A',
        Label: {
            text: '{{ sixtyDay | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        Amount: {
            text: (el, s)=>s.sixtyAmount || '$0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'amber'
        },
        Count: {
            text: (el, s)=>s.sixtyCount ? `${s.sixtyCount} accounts` : '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    NinetyPlusBucket: {
        flex: '1',
        flow: 'y',
        gap: 'Y',
        align: 'center center',
        padding: 'A',
        Label: {
            text: '{{ ninetyPlus | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        Amount: {
            text: (el, s)=>s.ninetyAmount || '$0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'red'
        },
        Count: {
            text: (el, s)=>s.ninetyCount ? `${s.ninetyCount} accounts` : '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    }
};


var $7784c6f1fd59027d$exports = {};

$parcel$export($7784c6f1fd59027d$exports, "PaymentPlanCard", () => $7784c6f1fd59027d$export$6fd1eefbe04d9579);
const $7784c6f1fd59027d$export$6fd1eefbe04d9579 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    TotalBalance: {
        flow: 'y',
        gap: 'X',
        Label: {
            text: '{{ totalBalance | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        Value: {
            text: (el, s)=>s.totalBalance || '',
            fontSize: 'C',
            fontWeight: '800',
            color: 'inkText'
        }
    },
    DetailsRow: {
        flow: 'x',
        gap: 'A',
        flexWrap: 'wrap',
        MonthlyPayment: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ monthlyPayment | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.monthlyPayment || '',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkText'
            }
        },
        PaymentsRemaining: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ paymentsRemaining | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.paymentsRemaining != null ? String(s.paymentsRemaining) : '',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkText'
            }
        },
        NextPaymentDate: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ nextPayment | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.nextPaymentDate || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        }
    },
    AutoPayStatus: {
        flow: 'x',
        align: 'center flex-start',
        gap: 'Y',
        Dot: {
            width: 'Y',
            height: 'Y',
            round: '100',
            background: (el, s)=>s.autoPay ? 'green' : 'amber'
        },
        Label: {
            text: (el, s)=>s.autoPay ? 'AutoPay On' : 'AutoPay Off',
            fontSize: 'Y',
            fontWeight: '600',
            color: (el, s)=>s.autoPay ? 'green' : 'amber'
        }
    },
    ProgressWrap: {
        flow: 'y',
        gap: 'Y',
        ProgressLabel: {
            text: '{{ paymentProgress | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        ProgressBar: {
            width: '100%',
            height: 'Y',
            round: 'Y',
            background: 'inkBorder',
            overflow: 'hidden',
            Fill: {
                height: '100%',
                round: 'Y',
                background: 'teal',
                width: (el, s)=>{
                    const pct = s.progressPercent || 0;
                    return `${pct}%`;
                },
                transition: 'width 0.3s'
            }
        },
        ProgressPercent: {
            text: (el, s)=>s.progressPercent != null ? `${s.progressPercent}% complete` : '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    }
};


var $f04008839a986e0c$exports = {};

$parcel$export($f04008839a986e0c$exports, "LedgerRow", () => $f04008839a986e0c$export$53af4e9987d1078a);
const $f04008839a986e0c$export$53af4e9987d1078a = {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'Z A',
    borderBottom: '1px solid inkBorder',
    LedgerDate: {
        text: (el, s)=>s.date || '',
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '500',
        minWidth: 'D'
    },
    Description: {
        text: (el, s)=>s.description || '',
        fontSize: 'Z',
        color: 'inkText',
        flex: '2',
        fontWeight: '500'
    },
    Provider: {
        text: (el, s)=>s.provider || '',
        fontSize: 'Y',
        color: 'inkMuted',
        flex: '1'
    },
    CDTCode: {
        text: (el, s)=>s.cdtCode || '',
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '600',
        minWidth: 'C'
    },
    Charge: {
        text: (el, s)=>s.charge || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'red',
        minWidth: 'C',
        textAlign: 'right'
    },
    Payment: {
        text: (el, s)=>s.payment || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'green',
        minWidth: 'C',
        textAlign: 'right'
    },
    Adjustment: {
        text: (el, s)=>s.adjustment || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'amber',
        minWidth: 'C',
        textAlign: 'right'
    },
    Balance: {
        text: (el, s)=>s.balance || '',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'inkText',
        minWidth: 'C',
        textAlign: 'right'
    },
    InsurancePortion: {
        text: (el, s)=>s.insurancePortion || '',
        fontSize: 'Y',
        color: 'inkMuted',
        minWidth: 'C',
        textAlign: 'right'
    }
};


var $67883e541bbbc832$exports = {};

$parcel$export($67883e541bbbc832$exports, "WeekCalendar", () => $67883e541bbbc832$export$d2585b584d52ef7d);
const $67883e541bbbc832$export$d2585b584d52ef7d = {
    flow: 'y',
    overflow: 'auto',
    background: 'inkMid',
    round: 'Z',
    border: '1px solid inkBorder',
    DayHeaders: {
        flow: 'x',
        position: 'sticky',
        top: '0',
        zIndex: '10',
        background: 'inkMid',
        borderBottom: '1px solid inkBorder',
        TimeCorner: {
            minWidth: 'D',
            padding: 'Z',
            text: '',
            background: 'inkMid'
        },
        Mon: {
            flex: '1',
            text: '{{ mon | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkSubtle',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            padding: 'Z',
            textAlign: 'center',
            borderLeft: '1px solid inkBorder'
        },
        Tue: {
            flex: '1',
            text: '{{ tue | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkSubtle',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            padding: 'Z',
            textAlign: 'center',
            borderLeft: '1px solid inkBorder'
        },
        Wed: {
            flex: '1',
            text: '{{ wed | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkSubtle',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            padding: 'Z',
            textAlign: 'center',
            borderLeft: '1px solid inkBorder'
        },
        Thu: {
            flex: '1',
            text: '{{ thu | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkSubtle',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            padding: 'Z',
            textAlign: 'center',
            borderLeft: '1px solid inkBorder'
        },
        Fri: {
            flex: '1',
            text: '{{ fri | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkSubtle',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            padding: 'Z',
            textAlign: 'center',
            borderLeft: '1px solid inkBorder'
        },
        Sat: {
            flex: '1',
            text: '{{ sat | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkSubtle',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            padding: 'Z',
            textAlign: 'center',
            borderLeft: '1px solid inkBorder'
        },
        Sun: {
            flex: '1',
            text: '{{ sun | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'inkSubtle',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            padding: 'Z',
            textAlign: 'center',
            borderLeft: '1px solid inkBorder'
        }
    },
    TimeGrid: {
        flow: 'y',
        Slot0800: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '08:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot0900: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '09:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1000: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '10:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1100: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '11:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1200: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '12:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1300: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '13:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1400: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '14:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1500: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '15:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1600: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '16:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1700: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '17:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1800: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '18:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot1900: {
            flow: 'x',
            borderBottom: '1px solid inkBorder',
            TimeLabel: {
                minWidth: 'D',
                text: '19:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        },
        Slot2000: {
            flow: 'x',
            TimeLabel: {
                minWidth: 'D',
                text: '20:00',
                fontSize: 'Y',
                color: 'inkMuted',
                padding: 'Z',
                textAlign: 'right'
            },
            Cells: {
                flex: '1',
                minHeight: 'B',
                flow: 'x'
            }
        }
    }
};


var $4d80c719a303ed6b$exports = {};

$parcel$export($4d80c719a303ed6b$exports, "AppointmentBlock", () => $4d80c719a303ed6b$export$8edc068b3cbba07f);
const $4d80c719a303ed6b$export$8edc068b3cbba07f = {
    flow: 'y',
    gap: 'X',
    padding: 'Z',
    round: 'Y',
    background: 'inkMid',
    cursor: 'pointer',
    borderLeft: (el, s)=>{
        const st = s.status;
        if (st === 'Confirmed') return '4px solid green';
        if (st === 'Unconfirmed') return '4px solid amber';
        if (st === 'InChair') return '4px solid teal';
        if (st === 'CheckedOut') return '4px solid inkMuted';
        if (st === 'NoShow') return '4px solid red';
        if (st === 'Cancelled') return '4px solid inkBorder';
        return '4px solid inkBorder';
    },
    transition: 'background 0.15s',
    ':hover': {
        background: 'inkSurface'
    },
    PatientName: {
        text: (el, s)=>s.patient || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText'
    },
    ProcedureSummary: {
        text: (el, s)=>s.procedure || '',
        fontSize: 'Z',
        color: 'inkMuted'
    },
    TimeInfo: {
        flow: 'x',
        gap: 'Y',
        Time: {
            text: (el, s)=>s.time || '',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        Duration: {
            text: (el, s)=>s.duration ? `${s.duration} min` : '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    ProviderInfo: {
        text: (el, s)=>s.provider || '',
        fontSize: 'Y',
        color: 'inkMuted',
        fontStyle: 'italic'
    }
};


var $fadd47535bac1056$exports = {};

$parcel$export($fadd47535bac1056$exports, "OperatoryHeader", () => $fadd47535bac1056$export$b90bac9cbfbc4521);
const $fadd47535bac1056$export$b90bac9cbfbc4521 = {
    flow: 'y',
    gap: 'Y',
    padding: 'A',
    align: 'center center',
    background: 'inkMid',
    borderBottom: '1px solid inkBorder',
    OperatoryName: {
        text: (el, s)=>s.operatoryName || 'Chair 1',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'inkText'
    },
    AssignedProvider: {
        text: (el, s)=>s.assignedProvider || '',
        fontSize: 'Y',
        color: 'inkMuted'
    },
    UtilizationWrap: {
        flow: 'x',
        align: 'center center',
        gap: 'Y',
        width: '100%',
        UtilizationBar: {
            flex: '1',
            height: 'X',
            round: 'X',
            background: 'inkBorder',
            overflow: 'hidden',
            Fill: {
                height: '100%',
                round: 'X',
                background: 'teal',
                width: (el, s)=>{
                    const pct = s.utilizationPercent || 0;
                    return `${pct}%`;
                },
                transition: 'width 0.3s'
            }
        },
        UtilizationLabel: {
            text: (el, s)=>s.utilizationPercent != null ? `${s.utilizationPercent}%` : '',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'teal',
            minWidth: 'B'
        }
    }
};


var $18eda60775471865$exports = {};

$parcel$export($18eda60775471865$exports, "ProductionGoalMeter", () => $18eda60775471865$export$b8f7d6dbae3b0a69);
const $18eda60775471865$export$b8f7d6dbae3b0a69 = {
    flow: 'x',
    align: 'center flex-start',
    gap: 'A',
    padding: 'A',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    LabelsWrap: {
        flow: 'y',
        gap: 'X',
        minWidth: 'D',
        GoalAmount: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ goal | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.goalAmount || '',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkText'
            }
        },
        CurrentProduction: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ current2 | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.currentProduction || '',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'teal'
            }
        }
    },
    BarWrap: {
        flex: '1',
        flow: 'y',
        gap: 'Y',
        ProgressBar: {
            width: '100%',
            height: 'Z',
            round: 'Y',
            background: 'inkBorder',
            overflow: 'hidden',
            Fill: {
                height: '100%',
                round: 'Y',
                transition: 'width 0.3s',
                width: (el, s)=>{
                    const goal = parseFloat(String(s.goalAmount || '0').replace(/[$,]/g, ''));
                    const current = parseFloat(String(s.currentProduction || '0').replace(/[$,]/g, ''));
                    const pct = goal > 0 ? Math.min(100, Math.round(current / goal * 100)) : 0;
                    return `${pct}%`;
                },
                background: (el, s)=>{
                    const goal = parseFloat(String(s.goalAmount || '0').replace(/[$,]/g, ''));
                    const current = parseFloat(String(s.currentProduction || '0').replace(/[$,]/g, ''));
                    const pct = goal > 0 ? current / goal * 100 : 0;
                    if (pct >= 80) return 'teal';
                    if (pct >= 50) return 'amber';
                    return 'red';
                }
            }
        },
        ScheduledProduction: {
            text: (el, s)=>s.scheduledProduction ? `Scheduled: ${s.scheduledProduction}` : '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    }
};


var $9267baef54d8d235$exports = {};

$parcel$export($9267baef54d8d235$exports, "PrescriptionCard", () => $9267baef54d8d235$export$11dcbba25faf3db4);
const $9267baef54d8d235$export$11dcbba25faf3db4 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    minWidth: 'G3',
    HeaderRow: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        MedicationName: {
            text: (el, s)=>s.drugName || '',
            fontSize: 'A',
            fontWeight: '700',
            color: 'inkText'
        },
        StatusBadge: {
            tag: 'span',
            text: (el, s)=>s.status || '',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const st = s.status;
                if (st === 'Active') return 'green.15';
                if (st === 'Expired') return 'red.15';
                if (st === 'RefillDue') return 'amber.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const st = s.status;
                if (st === 'Active') return 'green';
                if (st === 'Expired') return 'red';
                if (st === 'RefillDue') return 'amber';
                return 'inkMuted';
            }
        }
    },
    DosageForm: {
        text: (el, s)=>[
                s.dosage,
                s.form
            ].filter(Boolean).join(' - '),
        fontSize: 'Z',
        color: 'inkText'
    },
    Frequency: {
        text: (el, s)=>s.frequency ? `Frequency: ${s.frequency}` : '',
        fontSize: 'Z',
        color: 'inkMuted'
    },
    Indication: {
        if: (el, s)=>!!s.indication,
        text: (el, s)=>`Indication: ${s.indication}`,
        fontSize: 'Z',
        color: 'inkMuted',
        fontStyle: 'italic'
    },
    DetailsRow: {
        flow: 'x',
        gap: 'A',
        flexWrap: 'wrap',
        Duration: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: (el, s)=>'Duration',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.duration || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        Refills: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ refills | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.refillsRemaining != null ? String(s.refillsRemaining) : '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        }
    },
    Divider: {
        height: '1px',
        background: 'inkBorder'
    },
    PatientName: {
        text: (el, s)=>s.patientName ? `Patient: ${s.patientName}` : '',
        fontSize: 'Y',
        color: 'inkMuted'
    },
    Prescriber: {
        text: (el, s)=>s.prescribedBy ? `Prescriber: ${s.prescribedBy}` : '',
        fontSize: 'Y',
        color: 'inkMuted'
    },
    DateWritten: {
        text: (el, s)=>s.prescribedDate ? `Written: ${s.prescribedDate}` : '',
        fontSize: 'Y',
        color: 'inkMuted'
    },
    PharmacyName: {
        text: (el, s)=>s.pharmacy ? `Pharmacy: ${s.pharmacy}` : '',
        fontSize: 'Y',
        color: 'inkMuted'
    }
};


var $caf35111e5293e4f$exports = {};

$parcel$export($caf35111e5293e4f$exports, "DrugInteractionAlert", () => $caf35111e5293e4f$export$2fc4fc4249d2b5c0);
const $caf35111e5293e4f$export$2fc4fc4249d2b5c0 = {
    flow: 'x',
    gap: 'Z',
    padding: 'A',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    borderLeft: '4px solid red',
    AlertIcon: {
        extends: 'Icon',
        icon: 'alertTriangle',
        fontSize: 'B',
        color: 'red',
        flexShrink: '0'
    },
    Content: {
        flow: 'y',
        gap: 'Y',
        flex: '1',
        InteractionPair: {
            text: (el, s)=>s.interactionPair || '',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        SeverityBadge: {
            tag: 'span',
            text: (el, s)=>s.severity || '',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            alignSelf: 'flex-start',
            background: (el, s)=>{
                const sv = s.severity;
                if (sv === 'Major') return 'red.15';
                if (sv === 'Moderate') return 'amber.15';
                if (sv === 'Minor') return 'inkSurface';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const sv = s.severity;
                if (sv === 'Major') return 'red';
                if (sv === 'Moderate') return 'amber';
                if (sv === 'Minor') return 'inkMuted';
                return 'inkMuted';
            }
        },
        Description: {
            text: (el, s)=>s.description || '',
            fontSize: 'Z',
            color: 'inkMuted',
            lineHeight: '1.4'
        },
        Recommendation: {
            text: (el, s)=>s.recommendation || '',
            fontSize: 'Z',
            color: 'inkText',
            fontWeight: '500',
            fontStyle: 'italic'
        }
    }
};


var $60f8e0a81eb161fd$exports = {};

$parcel$export($60f8e0a81eb161fd$exports, "RxTemplateSelector", () => $60f8e0a81eb161fd$export$e545c04d4b43f126);
$parcel$export($60f8e0a81eb161fd$exports, "RxTemplatePill", () => $60f8e0a81eb161fd$export$e3ef055f33362c44);
const $60f8e0a81eb161fd$export$e545c04d4b43f126 = {
    flow: 'x',
    gap: 'Z',
    flexWrap: 'wrap',
    padding: 'Z',
    children: [
        {
            templateName: 'Post-Extraction Pack'
        },
        {
            templateName: 'Post-RCT'
        },
        {
            templateName: 'Dry Socket'
        },
        {
            templateName: 'Perio Maintenance'
        }
    ],
    childrenAs: 'state',
    childExtends: 'RxTemplatePill'
};
const $60f8e0a81eb161fd$export$e3ef055f33362c44 = {
    tag: 'span',
    text: (el, s)=>s.templateName,
    padding: 'Y A',
    round: 'C',
    fontSize: 'Z',
    fontWeight: '600',
    background: 'teal.1',
    color: 'teal',
    cursor: 'pointer',
    transition: 'background 0.15s',
    ':hover': {
        background: 'teal.2'
    },
    onClick: (el, s)=>{
        const root = s.root || s;
        root.update({
            rxTemplate: s.templateName
        });
    }
};


var $11b41673cc060e9f$exports = {};

$parcel$export($11b41673cc060e9f$exports, "ToothSVG", () => $11b41673cc060e9f$export$d760b013da4dfa06);
var $11b41673cc060e9f$var$getSurfaceBg = function(surface) {
    return function(el, s) {
        var td = s.root.toothData && s.root.toothData[s.num];
        var toothType = td && td.type;
        if (toothType === 'missing') return 'toothMissing';
        if (toothType === 'implant') return 'toothImplant';
        if (toothType === 'bridge') return 'toothBridge';
        if (toothType === 'braces') return 'toothBraces';
        var st = td && td.surfaces && td.surfaces[surface];
        if (st === 'caries') return 'toothCaries';
        if (st === 'restored') return 'toothRestored';
        if (st === 'crown') return 'toothCrown';
        return 'toothHealthy';
    };
};
var $11b41673cc060e9f$var$getBuccalBg = function(el, s) {
    var td = s.root.toothData && s.root.toothData[s.num];
    var toothType = td && td.type;
    if (toothType === 'missing') return 'toothMissing';
    if (toothType === 'implant') return 'toothImplant';
    if (toothType === 'bridge') return 'toothBridge';
    if (toothType === 'braces') return 'toothBraces';
    if (toothType === 'veneer') return 'toothVeneer';
    var st = td && td.surfaces && td.surfaces.buccal;
    if (st === 'caries') return 'toothCaries';
    if (st === 'restored') return 'toothRestored';
    if (st === 'crown') return 'toothCrown';
    return 'toothHealthy';
};
const $11b41673cc060e9f$export$d760b013da4dfa06 = {
    position: 'relative',
    width: 'C',
    height: 'C',
    cursor: 'pointer',
    border: (el, s)=>{
        var td = s.root.toothData && s.root.toothData[s.num];
        var toothType = td && td.type;
        if (s.root.selectedTooth === s.num) return '2px solid toothSelected';
        if (toothType === 'bridge') return '2px dashed blue';
        return '2px solid inkBorder';
    },
    round: 'Y',
    background: (el, s)=>{
        var td = s.root.toothData && s.root.toothData[s.num];
        var toothType = td && td.type;
        if (toothType === 'missing') return 'toothMissing';
        if (toothType === 'implant') return 'toothImplant';
        return 'inkMid';
    },
    opacity: (el, s)=>{
        var td = s.root.toothData && s.root.toothData[s.num];
        var toothType = td && td.type;
        if (toothType === 'missing') return '0.5';
        return '1';
    },
    overflow: 'hidden',
    Buccal: {
        position: 'absolute',
        top: '0',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'Z2',
        height: 'Z',
        round: 'X',
        cursor: 'pointer',
        background: $11b41673cc060e9f$var$getBuccalBg,
        border: (el, s)=>{
            var td = s.root.toothData && s.root.toothData[s.num];
            var toothType = td && td.type;
            if (toothType === 'veneer') return '2px solid purple';
            return '1px solid inkBorder';
        },
        onClick: (el, s)=>{
            s.root.update({
                selectedTooth: s.num,
                selectedSurface: 'buccal'
            });
        }
    },
    Lingual: {
        position: 'absolute',
        bottom: '0',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'Z2',
        height: 'Z',
        round: 'X',
        cursor: 'pointer',
        background: $11b41673cc060e9f$var$getSurfaceBg('lingual'),
        border: '1px solid inkBorder',
        onClick: (el, s)=>{
            s.root.update({
                selectedTooth: s.num,
                selectedSurface: 'lingual'
            });
        }
    },
    Mesial: {
        position: 'absolute',
        left: '0',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 'Z',
        height: 'Z2',
        round: 'X',
        cursor: 'pointer',
        background: $11b41673cc060e9f$var$getSurfaceBg('mesial'),
        border: '1px solid inkBorder',
        onClick: (el, s)=>{
            s.root.update({
                selectedTooth: s.num,
                selectedSurface: 'mesial'
            });
        }
    },
    Occlusal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'Z2',
        height: 'Z2',
        round: 'X',
        cursor: 'pointer',
        background: $11b41673cc060e9f$var$getSurfaceBg('occlusal'),
        border: '1px solid inkBorder',
        onClick: (el, s)=>{
            s.root.update({
                selectedTooth: s.num,
                selectedSurface: 'occlusal'
            });
        }
    },
    Distal: {
        position: 'absolute',
        right: '0',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 'Z',
        height: 'Z2',
        round: 'X',
        cursor: 'pointer',
        background: $11b41673cc060e9f$var$getSurfaceBg('distal'),
        border: '1px solid inkBorder',
        onClick: (el, s)=>{
            s.root.update({
                selectedTooth: s.num,
                selectedSurface: 'distal'
            });
        }
    },
    MissingMarker: {
        if: (el, s)=>{
            var td = s.root.toothData && s.root.toothData[s.num];
            return td && td.type === 'missing';
        },
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '10',
        tag: 'span',
        text: 'X',
        fontSize: 'A',
        fontWeight: '800',
        color: 'red',
        pointerEvents: 'none'
    },
    BracesOverlay: {
        if: (el, s)=>{
            var td = s.root.toothData && s.root.toothData[s.num];
            return td && td.type === 'braces';
        },
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '10',
        width: 'Z2',
        height: '3px',
        background: 'inkSubtle',
        round: 'X',
        pointerEvents: 'none',
        BracketLeft: {
            position: 'absolute',
            left: '0',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '4px',
            height: 'Y',
            background: 'inkSubtle',
            round: 'X'
        },
        BracketRight: {
            position: 'absolute',
            right: '0',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '4px',
            height: 'Y',
            background: 'inkSubtle',
            round: 'X'
        }
    },
    ToothStatusBadge: {
        if: (el, s)=>{
            var td = s.root.toothData && s.root.toothData[s.num];
            var tp = td && td.type;
            return tp === 'implant' || tp === 'braces' || tp === 'bridge' || tp === 'veneer';
        },
        position: 'absolute',
        top: '-2px',
        right: '-2px',
        zIndex: '20',
        width: 'Y2',
        height: 'Y2',
        round: 'C',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        background: (el, s)=>{
            var td = s.root.toothData && s.root.toothData[s.num];
            var tp = td && td.type;
            if (tp === 'implant') return 'purple';
            if (tp === 'braces') return 'green';
            if (tp === 'bridge') return 'blue';
            if (tp === 'veneer') return 'purple';
            return 'inkMuted';
        },
        BadgeIcon: {
            extends: 'Icon',
            icon: (el, s)=>{
                var td = s.root.toothData && s.root.toothData[s.num];
                var tp = td && td.type;
                if (tp === 'implant') return 'pin';
                if (tp === 'braces') return 'link';
                if (tp === 'bridge') return 'minus';
                if (tp === 'veneer') return 'layers';
                return 'circle';
            },
            fontSize: 'W2',
            color: 'white'
        }
    }
};


var $88ef4cc8fece9e19$exports = {};

$parcel$export($88ef4cc8fece9e19$exports, "OdontogramGrid", () => $88ef4cc8fece9e19$export$1637c2dfdae82704);
const $88ef4cc8fece9e19$export$1637c2dfdae82704 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    background: 'inkMid',
    round: 'Z',
    border: '1px solid inkBorder',
    overflow: 'auto',
    UpperArch: {
        flow: 'x',
        gap: 'X',
        align: 'flex-end center',
        justifyContent: 'center',
        UpperRight: {
            flow: 'x',
            gap: 'X',
            T18: {
                extends: 'ToothSVG',
                state: {
                    num: 18
                }
            },
            T17: {
                extends: 'ToothSVG',
                state: {
                    num: 17
                }
            },
            T16: {
                extends: 'ToothSVG',
                state: {
                    num: 16
                }
            },
            T15: {
                extends: 'ToothSVG',
                state: {
                    num: 15
                }
            },
            T14: {
                extends: 'ToothSVG',
                state: {
                    num: 14
                }
            },
            T13: {
                extends: 'ToothSVG',
                state: {
                    num: 13
                }
            },
            T12: {
                extends: 'ToothSVG',
                state: {
                    num: 12
                }
            },
            T11: {
                extends: 'ToothSVG',
                state: {
                    num: 11
                }
            }
        },
        Divider: {
            width: '2px',
            height: 'D',
            background: 'inkBorder',
            margin: '0 Y'
        },
        UpperLeft: {
            flow: 'x',
            gap: 'X',
            T21: {
                extends: 'ToothSVG',
                state: {
                    num: 21
                }
            },
            T22: {
                extends: 'ToothSVG',
                state: {
                    num: 22
                }
            },
            T23: {
                extends: 'ToothSVG',
                state: {
                    num: 23
                }
            },
            T24: {
                extends: 'ToothSVG',
                state: {
                    num: 24
                }
            },
            T25: {
                extends: 'ToothSVG',
                state: {
                    num: 25
                }
            },
            T26: {
                extends: 'ToothSVG',
                state: {
                    num: 26
                }
            },
            T27: {
                extends: 'ToothSVG',
                state: {
                    num: 27
                }
            },
            T28: {
                extends: 'ToothSVG',
                state: {
                    num: 28
                }
            }
        }
    },
    UpperNumbers: {
        flow: 'x',
        gap: 'X',
        justifyContent: 'center',
        UpperRightNums: {
            flow: 'x',
            gap: 'X',
            N18: {
                tag: 'span',
                text: '18',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N17: {
                tag: 'span',
                text: '17',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N16: {
                tag: 'span',
                text: '16',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N15: {
                tag: 'span',
                text: '15',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N14: {
                tag: 'span',
                text: '14',
                fontSize: 'Y',
                color: 'teal',
                fontWeight: '600',
                textAlign: 'center',
                width: 'C'
            },
            N13: {
                tag: 'span',
                text: '13',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N12: {
                tag: 'span',
                text: '12',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N11: {
                tag: 'span',
                text: '11',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            }
        },
        NumDivider: {
            width: '2px',
            margin: '0 Y'
        },
        UpperLeftNums: {
            flow: 'x',
            gap: 'X',
            N21: {
                tag: 'span',
                text: '21',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N22: {
                tag: 'span',
                text: '22',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N23: {
                tag: 'span',
                text: '23',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N24: {
                tag: 'span',
                text: '24',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N25: {
                tag: 'span',
                text: '25',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N26: {
                tag: 'span',
                text: '26',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N27: {
                tag: 'span',
                text: '27',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N28: {
                tag: 'span',
                text: '28',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            }
        }
    },
    CenterLine: {
        width: '100%',
        height: '2px',
        background: 'inkBorder',
        margin: 'Y 0'
    },
    LowerNumbers: {
        flow: 'x',
        gap: 'X',
        justifyContent: 'center',
        LowerRightNums: {
            flow: 'x',
            gap: 'X',
            N48: {
                tag: 'span',
                text: '48',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N47: {
                tag: 'span',
                text: '47',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N46: {
                tag: 'span',
                text: '46',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N45: {
                tag: 'span',
                text: '45',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N44: {
                tag: 'span',
                text: '44',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N43: {
                tag: 'span',
                text: '43',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N42: {
                tag: 'span',
                text: '42',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N41: {
                tag: 'span',
                text: '41',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            }
        },
        NumDivider: {
            width: '2px',
            margin: '0 Y'
        },
        LowerLeftNums: {
            flow: 'x',
            gap: 'X',
            N31: {
                tag: 'span',
                text: '31',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N32: {
                tag: 'span',
                text: '32',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N33: {
                tag: 'span',
                text: '33',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N34: {
                tag: 'span',
                text: '34',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N35: {
                tag: 'span',
                text: '35',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N36: {
                tag: 'span',
                text: '36',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N37: {
                tag: 'span',
                text: '37',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            },
            N38: {
                tag: 'span',
                text: '38',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                width: 'C'
            }
        }
    },
    LowerArch: {
        flow: 'x',
        gap: 'X',
        align: 'flex-start center',
        justifyContent: 'center',
        LowerRight: {
            flow: 'x',
            gap: 'X',
            T48: {
                extends: 'ToothSVG',
                state: {
                    num: 48
                }
            },
            T47: {
                extends: 'ToothSVG',
                state: {
                    num: 47
                }
            },
            T46: {
                extends: 'ToothSVG',
                state: {
                    num: 46
                }
            },
            T45: {
                extends: 'ToothSVG',
                state: {
                    num: 45
                }
            },
            T44: {
                extends: 'ToothSVG',
                state: {
                    num: 44
                }
            },
            T43: {
                extends: 'ToothSVG',
                state: {
                    num: 43
                }
            },
            T42: {
                extends: 'ToothSVG',
                state: {
                    num: 42
                }
            },
            T41: {
                extends: 'ToothSVG',
                state: {
                    num: 41
                }
            }
        },
        Divider: {
            width: '2px',
            height: 'D',
            background: 'inkBorder',
            margin: '0 Y'
        },
        LowerLeft: {
            flow: 'x',
            gap: 'X',
            T31: {
                extends: 'ToothSVG',
                state: {
                    num: 31
                }
            },
            T32: {
                extends: 'ToothSVG',
                state: {
                    num: 32
                }
            },
            T33: {
                extends: 'ToothSVG',
                state: {
                    num: 33
                }
            },
            T34: {
                extends: 'ToothSVG',
                state: {
                    num: 34
                }
            },
            T35: {
                extends: 'ToothSVG',
                state: {
                    num: 35
                }
            },
            T36: {
                extends: 'ToothSVG',
                state: {
                    num: 36
                }
            },
            T37: {
                extends: 'ToothSVG',
                state: {
                    num: 37
                }
            },
            T38: {
                extends: 'ToothSVG',
                state: {
                    num: 38
                }
            }
        }
    }
};


var $60fc3d52c5182c70$exports = {};

$parcel$export($60fc3d52c5182c70$exports, "ToothDetailPanel", () => $60fc3d52c5182c70$export$66e3e761565027e4);
const $60fc3d52c5182c70$export$66e3e761565027e4 = {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    background: 'inkSurface',
    round: 'Z',
    border: '1px solid inkBorder',
    width: 'G',
    maxHeight: '80vh',
    overflow: 'auto',
    show: (el, s)=>s.root.selectedTooth !== null && s.root.selectedTooth !== undefined,
    PanelHeader: {
        flow: 'x',
        align: 'center space-between',
        ToothInfo: {
            flow: 'x',
            gap: 'Z',
            align: 'center flex-start',
            ToothNumber: {
                text: (el, s)=>'#' + (s.root.selectedTooth || ''),
                fontSize: 'D',
                fontWeight: '800',
                color: 'teal'
            },
            ToothName: {
                text: (el, s)=>{
                    var names = {
                        11: 'Central Incisor',
                        12: 'Lateral Incisor',
                        13: 'Canine',
                        14: 'First Premolar',
                        15: 'Second Premolar',
                        16: 'First Molar',
                        17: 'Second Molar',
                        18: 'Third Molar',
                        21: 'Central Incisor',
                        22: 'Lateral Incisor',
                        23: 'Canine',
                        24: 'First Premolar',
                        25: 'Second Premolar',
                        26: 'First Molar',
                        27: 'Second Molar',
                        28: 'Third Molar',
                        31: 'Central Incisor',
                        32: 'Lateral Incisor',
                        33: 'Canine',
                        34: 'First Premolar',
                        35: 'Second Premolar',
                        36: 'First Molar',
                        37: 'Second Molar',
                        38: 'Third Molar',
                        41: 'Central Incisor',
                        42: 'Lateral Incisor',
                        43: 'Canine',
                        44: 'First Premolar',
                        45: 'Second Premolar',
                        46: 'First Molar',
                        47: 'Second Molar',
                        48: 'Third Molar'
                    };
                    return names[s.root.selectedTooth] || 'Tooth';
                },
                fontSize: 'Z',
                color: 'inkMuted',
                fontWeight: '500'
            }
        },
        CloseButton: {
            extends: 'Icon',
            icon: 'x',
            fontSize: 'A',
            color: 'inkMuted',
            cursor: 'pointer',
            onClick: (el, s)=>{
                s.root.update({
                    selectedTooth: null,
                    selectedSurface: null
                });
            }
        }
    },
    StatusSection: {
        flow: 'y',
        gap: 'Y',
        StatusLabel: {
            text: '{{ status | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        StatusDropdown: {
            tag: 'select',
            padding: 'Y Z',
            round: 'Y',
            border: '1px solid inkBorder',
            background: 'inkMid',
            color: 'inkText',
            fontSize: 'Z',
            width: '100%',
            cursor: 'pointer',
            value: (el, s)=>{
                var td = s.root.toothData && s.root.toothData[s.root.selectedTooth];
                return td && td.status ? td.status : 'healthy';
            },
            onChange: (el, s)=>{
                var val = el.node.value;
                var toothData = Object.assign({}, s.root.toothData || {});
                var num = s.root.selectedTooth;
                toothData[num] = Object.assign({}, toothData[num] || {}, {
                    status: val
                });
                s.root.update({
                    toothData: toothData
                });
            },
            OptionHealthy: {
                tag: 'option',
                value: 'healthy',
                text: '{{ healthy | polyglot }}'
            },
            OptionCaries: {
                tag: 'option',
                value: 'caries',
                text: '{{ caries | polyglot }}'
            },
            OptionRestored: {
                tag: 'option',
                value: 'restored',
                text: '{{ restored | polyglot }}'
            },
            OptionMissing: {
                tag: 'option',
                value: 'missing',
                text: '{{ missing | polyglot }}'
            },
            OptionImplant: {
                tag: 'option',
                value: 'implant',
                text: '{{ implant | polyglot }}'
            },
            OptionCrown: {
                tag: 'option',
                value: 'crown',
                text: '{{ crownStatus | polyglot }}'
            },
            OptionBridge: {
                tag: 'option',
                value: 'bridge',
                text: '{{ bridge | polyglot }}'
            },
            OptionVeneer: {
                tag: 'option',
                value: 'veneer',
                text: '{{ veneer | polyglot }}'
            }
        }
    },
    SurfaceSection: {
        flow: 'y',
        gap: 'Y',
        SurfaceLabel: {
            text: '{{ surfaces | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        SurfaceList: {
            flow: 'y',
            gap: 'X',
            childExtends: {
                flow: 'x',
                align: 'center space-between',
                padding: 'X Z',
                round: 'X',
                background: 'inkMid',
                border: '1px solid inkBorder'
            },
            $collection: (el, s)=>{
                var td = s.root.toothData && s.root.toothData[s.root.selectedTooth];
                var surfaces = td && td.surfaces ? td.surfaces : {};
                var names = [
                    'buccal',
                    'lingual',
                    'mesial',
                    'occlusal',
                    'distal'
                ];
                return names.map(function(name) {
                    return {
                        SurfaceName: {
                            text: name.charAt(0).toUpperCase() + name.slice(1),
                            fontSize: 'Y',
                            color: 'inkText',
                            fontWeight: '500'
                        },
                        SurfaceStatus: {
                            text: (surfaces[name] || 'healthy').charAt(0).toUpperCase() + (surfaces[name] || 'healthy').slice(1),
                            fontSize: 'Y',
                            color: surfaces[name] === 'caries' ? 'red' : surfaces[name] === 'restored' ? 'blue' : 'green',
                            fontWeight: '600'
                        }
                    };
                });
            }
        }
    },
    HistorySection: {
        flow: 'y',
        gap: 'Y',
        HistoryLabel: {
            text: '{{ procedureHistory | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        HistoryList: {
            flow: 'y',
            gap: 'X',
            childExtends: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Y Z',
                borderBottom: '1px solid inkBorder'
            },
            $collection: (el, s)=>{
                return [
                    {
                        ProcName: {
                            text: '{{ compositeFilling | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkText',
                            fontWeight: '500'
                        },
                        ProcDate: {
                            text: '2025-11-15',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    {
                        ProcName: {
                            text: '{{ xray | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkText',
                            fontWeight: '500'
                        },
                        ProcDate: {
                            text: '2025-08-20',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    {
                        ProcName: {
                            text: '{{ cleaning | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkText',
                            fontWeight: '500'
                        },
                        ProcDate: {
                            text: '2025-06-10',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                ];
            }
        }
    },
    ProcedureTimeline: {
        flow: 'y',
        gap: 'Y',
        TimelineHeader: {
            flow: 'x',
            align: 'center space-between',
            TimelineLabel: {
                text: '{{ procedureTimeline | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            },
            EntryCount: {
                text: (el, s)=>{
                    var history = s.root.toothHistory && s.root.toothHistory[s.root.selectedTooth];
                    var count = history ? history.length : 0;
                    return count + ' entries';
                },
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '500'
            }
        },
        TimelineList: {
            flow: 'y',
            gap: '0',
            position: 'relative',
            TimelineLine: {
                position: 'absolute',
                left: '8px',
                top: '0',
                bottom: '0',
                width: '2px',
                background: 'inkBorder',
                show: (el, s)=>{
                    var history = s.root.toothHistory && s.root.toothHistory[s.root.selectedTooth];
                    return history && history.length > 0;
                }
            },
            TimelineEntries: {
                flow: 'y',
                gap: 'X',
                childExtends: {
                    flow: 'x',
                    gap: 'Z',
                    padding: 'Z',
                    paddingLeft: '0',
                    round: 'Y',
                    align: 'flex-start flex-start',
                    position: 'relative',
                    TimelineDot: {
                        width: 'Y2',
                        height: 'Y2',
                        minWidth: 'Y2',
                        round: 'C',
                        background: 'teal',
                        marginTop: 'X2',
                        zIndex: '1',
                        border: '2px solid inkSurface'
                    },
                    TimelineContent: {
                        flow: 'y',
                        gap: 'X',
                        flex: '1',
                        padding: 'X Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        ContentTop: {
                            flow: 'x',
                            align: 'center space-between',
                            gap: 'Y',
                            ProcedureName: {
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            VerifiedBadge: {
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Y',
                                round: 'B'
                            }
                        },
                        ProcedureMeta: {
                            flow: 'x',
                            gap: 'Y',
                            flexWrap: 'wrap',
                            DoctorName: {
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            ClinicName: {
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        ProcedureDate: {
                            fontSize: 'Y',
                            color: 'teal',
                            fontWeight: '500'
                        },
                        ProcedureNotes: {
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    }
                },
                $collection: (el, s)=>{
                    var history = s.root.toothHistory && s.root.toothHistory[s.root.selectedTooth];
                    if (!history || !history.length) return [
                        {
                            TimelineDot: {
                                background: 'inkMuted',
                                border: '2px solid inkSurface'
                            },
                            TimelineContent: {
                                ContentTop: {
                                    ProcedureName: {
                                        text: '{{ noHistory | polyglot }}'
                                    },
                                    VerifiedBadge: {
                                        display: 'none'
                                    }
                                },
                                ProcedureMeta: {
                                    display: 'none'
                                },
                                ProcedureDate: {
                                    display: 'none'
                                },
                                ProcedureNotes: {
                                    display: 'none'
                                }
                            }
                        }
                    ];
                    return history.map(function(entry) {
                        var isVerified = entry.verified !== false;
                        return {
                            TimelineDot: {
                                background: isVerified ? 'teal' : 'orange'
                            },
                            TimelineContent: {
                                ContentTop: {
                                    ProcedureName: {
                                        text: entry.procedure
                                    },
                                    VerifiedBadge: isVerified ? {
                                        text: '{{ verified | polyglot }}',
                                        background: 'teal.15',
                                        color: 'teal'
                                    } : {
                                        text: '{{ patientReported | polyglot }}',
                                        background: 'orange.15',
                                        color: 'orange'
                                    }
                                },
                                ProcedureMeta: {
                                    DoctorName: {
                                        text: entry.doctor || ''
                                    },
                                    ClinicName: {
                                        text: entry.clinic ? '- ' + entry.clinic : ''
                                    }
                                },
                                ProcedureDate: {
                                    text: entry.date
                                },
                                ProcedureNotes: entry.notes ? {
                                    text: entry.notes
                                } : {
                                    display: 'none'
                                }
                            }
                        };
                    });
                }
            }
        }
    },
    AddHistoryButton: {
        flow: 'x',
        gap: 'Y',
        align: 'center center',
        padding: 'Z A',
        round: 'Y',
        background: 'teal',
        color: 'white',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: 'Z',
        marginTop: 'Z',
        show: (el, s)=>!s.root.showHistoryForm,
        ButtonIcon: {
            extends: 'Icon',
            icon: 'plus',
            fontSize: 'Z'
        },
        ButtonText: {
            text: '{{ addHistory | polyglot }}'
        },
        onClick: (el, s)=>{
            s.root.update({
                showHistoryForm: true
            });
        }
    },
    HistoryFormContainer: {
        show: (el, s)=>s.root.showHistoryForm,
        marginTop: 'Z',
        PatientHistoryForm: {}
    },
    AddProcedureButton: {
        flow: 'x',
        gap: 'Y',
        align: 'center center',
        padding: 'Z A',
        round: 'Y',
        background: 'teal',
        color: 'white',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: 'Z',
        marginTop: 'Z',
        show: (el, s)=>!s.root.showHistoryForm,
        ButtonIcon: {
            extends: 'Icon',
            icon: 'plus',
            fontSize: 'Z'
        },
        ButtonText: {
            text: '{{ addProcedure | polyglot }}'
        }
    }
};


var $57275b097b61842e$exports = {};

$parcel$export($57275b097b61842e$exports, "ProcedureButton", () => $57275b097b61842e$export$f295db063afd1820);
const $57275b097b61842e$export$f295db063afd1820 = {
    flow: 'x',
    gap: 'Y',
    align: 'center flex-start',
    padding: 'Y Z',
    round: 'Y',
    background: 'teal',
    color: 'ink',
    cursor: 'pointer',
    transition: 'opacity 0.15s ease',
    ':hover': {
        opacity: '0.85'
    },
    childrenAs: 'state',
    ProcName: {
        text: (el, s)=>s.name || 'Procedure',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'ink'
    },
    ProcCode: {
        text: (el, s)=>s.code || 'D0000',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'ink',
        opacity: '0.7',
        fontFamily: 'monospace'
    },
    onClick: (el, s)=>{
        var tooth = s.root.selectedTooth;
        if (!tooth) return;
        var toothData = Object.assign({}, s.root.toothData || {});
        var td = Object.assign({}, toothData[tooth] || {});
        var procedures = (td.procedures || []).slice();
        procedures.push({
            name: s.name,
            code: s.code,
            date: new Date().toISOString().split('T')[0]
        });
        td.procedures = procedures;
        toothData[tooth] = td;
        s.root.update({
            toothData: toothData
        });
    }
};


var $354620d77410b75a$exports = {};

$parcel$export($354620d77410b75a$exports, "PerioGrid", () => $354620d77410b75a$export$f77674496215c16b);
const $354620d77410b75a$export$f77674496215c16b = {
    flow: 'y',
    gap: '0',
    background: 'inkMid',
    round: 'Z',
    border: '1px solid inkBorder',
    overflow: 'auto',
    GridHeader: {
        flow: 'x',
        gap: '0',
        borderBottom: '2px solid inkBorder',
        position: 'sticky',
        top: '0',
        background: 'inkMid',
        zIndex: '1',
        LabelCell: {
            width: 'E',
            minWidth: 'E',
            padding: 'Y Z',
            fontWeight: '700',
            fontSize: 'Y',
            color: 'inkMuted',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            borderRight: '1px solid inkBorder',
            text: '{{ metric | polyglot }}'
        },
        ToothColumns: {
            flow: 'x',
            gap: '0',
            childExtends: {
                width: 'B',
                minWidth: 'B',
                padding: 'Y X',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: 'Y',
                color: 'inkText',
                borderRight: '1px solid inkBorder'
            },
            $collection: (el, s)=>{
                var teeth = [
                    18,
                    17,
                    16,
                    15,
                    14,
                    13,
                    12,
                    11,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28
                ];
                return teeth.map(function(t) {
                    return {
                        text: String(t)
                    };
                });
            }
        }
    },
    PDRow: {
        flow: 'x',
        gap: '0',
        borderBottom: '1px solid inkBorder',
        RowLabel: {
            width: 'E',
            minWidth: 'E',
            padding: 'Y Z',
            fontWeight: '600',
            fontSize: 'Y',
            color: 'inkText',
            borderRight: '1px solid inkBorder',
            text: '{{ pdMm | polyglot }}'
        },
        Cells: {
            flow: 'x',
            gap: '0',
            childExtends: {
                width: 'B',
                minWidth: 'B',
                padding: 'Y X',
                textAlign: 'center',
                fontSize: 'Y',
                fontWeight: '600',
                borderRight: '1px solid inkBorder'
            },
            $collection: (el, s)=>{
                var teeth = [
                    18,
                    17,
                    16,
                    15,
                    14,
                    13,
                    12,
                    11,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28
                ];
                return teeth.map(function(t) {
                    var pd = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].pd;
                    var val = pd || 2;
                    return {
                        text: String(val),
                        color: val >= 6 ? 'perioCritical' : val >= 4 ? 'perioWarning' : 'perioHealthy',
                        background: val >= 6 ? 'perioCritical.10' : val >= 4 ? 'perioWarning.10' : 'perioHealthy.10'
                    };
                });
            }
        }
    },
    GMRow: {
        flow: 'x',
        gap: '0',
        borderBottom: '1px solid inkBorder',
        RowLabel: {
            width: 'E',
            minWidth: 'E',
            padding: 'Y Z',
            fontWeight: '600',
            fontSize: 'Y',
            color: 'inkText',
            borderRight: '1px solid inkBorder',
            text: '{{ gmMm | polyglot }}'
        },
        Cells: {
            flow: 'x',
            gap: '0',
            childExtends: {
                width: 'B',
                minWidth: 'B',
                padding: 'Y X',
                textAlign: 'center',
                fontSize: 'Y',
                fontWeight: '600',
                borderRight: '1px solid inkBorder',
                color: 'inkText'
            },
            $collection: (el, s)=>{
                var teeth = [
                    18,
                    17,
                    16,
                    15,
                    14,
                    13,
                    12,
                    11,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28
                ];
                return teeth.map(function(t) {
                    var gm = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].gm;
                    return {
                        text: String(gm || 0)
                    };
                });
            }
        }
    },
    CALRow: {
        flow: 'x',
        gap: '0',
        borderBottom: '1px solid inkBorder',
        RowLabel: {
            width: 'E',
            minWidth: 'E',
            padding: 'Y Z',
            fontWeight: '600',
            fontSize: 'Y',
            color: 'inkText',
            borderRight: '1px solid inkBorder',
            text: '{{ calMm | polyglot }}'
        },
        Cells: {
            flow: 'x',
            gap: '0',
            childExtends: {
                width: 'B',
                minWidth: 'B',
                padding: 'Y X',
                textAlign: 'center',
                fontSize: 'Y',
                fontWeight: '600',
                borderRight: '1px solid inkBorder'
            },
            $collection: (el, s)=>{
                var teeth = [
                    18,
                    17,
                    16,
                    15,
                    14,
                    13,
                    12,
                    11,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28
                ];
                return teeth.map(function(t) {
                    var cal = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].cal;
                    var val = cal || 2;
                    return {
                        text: String(val),
                        color: val >= 6 ? 'perioCritical' : val >= 4 ? 'perioWarning' : 'perioHealthy',
                        background: val >= 6 ? 'perioCritical.10' : val >= 4 ? 'perioWarning.10' : 'perioHealthy.10'
                    };
                });
            }
        }
    },
    BOPRow: {
        flow: 'x',
        gap: '0',
        borderBottom: '1px solid inkBorder',
        RowLabel: {
            width: 'E',
            minWidth: 'E',
            padding: 'Y Z',
            fontWeight: '600',
            fontSize: 'Y',
            color: 'inkText',
            borderRight: '1px solid inkBorder',
            text: 'BOP'
        },
        Cells: {
            flow: 'x',
            gap: '0',
            childExtends: {
                width: 'B',
                minWidth: 'B',
                padding: 'Y X',
                textAlign: 'center',
                fontSize: 'Y',
                fontWeight: '600',
                borderRight: '1px solid inkBorder'
            },
            $collection: (el, s)=>{
                var teeth = [
                    18,
                    17,
                    16,
                    15,
                    14,
                    13,
                    12,
                    11,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28
                ];
                return teeth.map(function(t) {
                    var bop = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].bop;
                    return {
                        text: bop ? '+' : '-',
                        color: bop ? 'perioBleeding' : 'perioHealthy'
                    };
                });
            }
        }
    },
    SuppRow: {
        flow: 'x',
        gap: '0',
        borderBottom: '1px solid inkBorder',
        RowLabel: {
            width: 'E',
            minWidth: 'E',
            padding: 'Y Z',
            fontWeight: '600',
            fontSize: 'Y',
            color: 'inkText',
            borderRight: '1px solid inkBorder',
            text: '{{ suppuration | polyglot }}'
        },
        Cells: {
            flow: 'x',
            gap: '0',
            childExtends: {
                width: 'B',
                minWidth: 'B',
                padding: 'Y X',
                textAlign: 'center',
                fontSize: 'Y',
                fontWeight: '600',
                borderRight: '1px solid inkBorder'
            },
            $collection: (el, s)=>{
                var teeth = [
                    18,
                    17,
                    16,
                    15,
                    14,
                    13,
                    12,
                    11,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28
                ];
                return teeth.map(function(t) {
                    var supp = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].suppuration;
                    return {
                        text: supp ? '+' : '-',
                        color: supp ? 'red' : 'inkMuted'
                    };
                });
            }
        }
    },
    FurcRow: {
        flow: 'x',
        gap: '0',
        borderBottom: '1px solid inkBorder',
        RowLabel: {
            width: 'E',
            minWidth: 'E',
            padding: 'Y Z',
            fontWeight: '600',
            fontSize: 'Y',
            color: 'inkText',
            borderRight: '1px solid inkBorder',
            text: '{{ furcation | polyglot }}'
        },
        Cells: {
            flow: 'x',
            gap: '0',
            childExtends: {
                width: 'B',
                minWidth: 'B',
                padding: 'Y X',
                textAlign: 'center',
                fontSize: 'Y',
                fontWeight: '600',
                borderRight: '1px solid inkBorder',
                color: 'inkText'
            },
            $collection: (el, s)=>{
                var teeth = [
                    18,
                    17,
                    16,
                    15,
                    14,
                    13,
                    12,
                    11,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28
                ];
                return teeth.map(function(t) {
                    var furc = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].furcation;
                    return {
                        text: String(furc || 0)
                    };
                });
            }
        }
    },
    MobRow: {
        flow: 'x',
        gap: '0',
        RowLabel: {
            width: 'E',
            minWidth: 'E',
            padding: 'Y Z',
            fontWeight: '600',
            fontSize: 'Y',
            color: 'inkText',
            borderRight: '1px solid inkBorder',
            text: '{{ mobility | polyglot }}'
        },
        Cells: {
            flow: 'x',
            gap: '0',
            childExtends: {
                width: 'B',
                minWidth: 'B',
                padding: 'Y X',
                textAlign: 'center',
                fontSize: 'Y',
                fontWeight: '600',
                borderRight: '1px solid inkBorder',
                color: 'inkText'
            },
            $collection: (el, s)=>{
                var teeth = [
                    18,
                    17,
                    16,
                    15,
                    14,
                    13,
                    12,
                    11,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28
                ];
                return teeth.map(function(t) {
                    var mob = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].mobility;
                    return {
                        text: String(mob || 0)
                    };
                });
            }
        }
    }
};


var $4debbafc7bdaa8be$exports = {};

$parcel$export($4debbafc7bdaa8be$exports, "PerioExamSelector", () => $4debbafc7bdaa8be$export$b07533753c0b05a2);
const $4debbafc7bdaa8be$export$b07533753c0b05a2 = {
    flow: 'x',
    gap: 'Z',
    padding: 'Z A',
    background: 'inkMid',
    round: 'Z',
    border: '1px solid inkBorder',
    overflow: 'auto',
    align: 'center flex-start',
    SelectorLabel: {
        text: '{{ exams2 | polyglot }}',
        fontSize: 'Y',
        fontWeight: '600',
        color: 'inkMuted',
        textTransform: 'uppercase',
        letterSpacing: 'X',
        whiteSpace: 'nowrap'
    },
    ExamList: {
        flow: 'x',
        gap: 'Y',
        childExtends: {
            tag: 'button',
            padding: 'Y Z',
            round: 'Y',
            border: '1px solid inkBorder',
            cursor: 'pointer',
            fontSize: 'Y',
            whiteSpace: 'nowrap',
            transition: 'all 0.15s ease'
        },
        $collection: (el, s)=>{
            var exams = s.root.perioExams || [
                {
                    id: 1,
                    date: '2026-03-18',
                    label: 'Mar 18, 2026'
                },
                {
                    id: 2,
                    date: '2025-09-15',
                    label: 'Sep 15, 2025'
                },
                {
                    id: 3,
                    date: '2025-03-10',
                    label: 'Mar 10, 2025'
                }
            ];
            var currentId = s.root.currentExamId || exams[0] && exams[0].id;
            return exams.map(function(exam) {
                var isCurrent = exam.id === currentId;
                return {
                    text: exam.label,
                    fontWeight: isCurrent ? '700' : '400',
                    color: isCurrent ? 'inkText' : 'inkMuted',
                    background: isCurrent ? 'inkSurface' : 'inkMid',
                    borderColor: isCurrent ? 'teal' : 'inkBorder',
                    onClick: function() {
                        s.root.update({
                            currentExamId: exam.id
                        });
                    }
                };
            });
        }
    }
};


var $bc96e42e6114e68d$exports = {};

$parcel$export($bc96e42e6114e68d$exports, "PerioIndexCards", () => $bc96e42e6114e68d$export$c6aa8cf8b08d6d65);
const $bc96e42e6114e68d$export$c6aa8cf8b08d6d65 = {
    flow: 'x',
    gap: 'Z',
    flexWrap: 'wrap',
    BleedingCard: {
        flow: 'y',
        gap: 'Z',
        padding: 'B',
        round: 'Z',
        background: 'inkMid',
        border: '1px solid inkBorder',
        flex: '1',
        minWidth: 'E',
        CardLabel: {
            text: '{{ bleedingIndex | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        CardValue: {
            text: (el, s)=>{
                var val = s.root.perioIndices && s.root.perioIndices.bleeding;
                return (val !== undefined ? val : 18) + '%';
            },
            fontSize: 'D',
            fontWeight: '800',
            color: (el, s)=>{
                var val = s.root.perioIndices && s.root.perioIndices.bleeding;
                val = val !== undefined ? val : 18;
                return val > 30 ? 'perioCritical' : val > 15 ? 'perioWarning' : 'perioHealthy';
            }
        },
        CardBar: {
            width: '100%',
            height: 'X',
            round: 'X',
            background: 'inkSurface',
            CardFill: {
                width: (el, s)=>{
                    var val = s.root.perioIndices && s.root.perioIndices.bleeding;
                    return (val !== undefined ? val : 18) + '%';
                },
                height: '100%',
                round: 'X',
                background: (el, s)=>{
                    var val = s.root.perioIndices && s.root.perioIndices.bleeding;
                    val = val !== undefined ? val : 18;
                    return val > 30 ? 'perioCritical' : val > 15 ? 'perioWarning' : 'perioHealthy';
                }
            }
        }
    },
    PlaqueCard: {
        flow: 'y',
        gap: 'Z',
        padding: 'B',
        round: 'Z',
        background: 'inkMid',
        border: '1px solid inkBorder',
        flex: '1',
        minWidth: 'E',
        CardLabel: {
            text: '{{ plaqueIndex | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        CardValue: {
            text: (el, s)=>{
                var val = s.root.perioIndices && s.root.perioIndices.plaque;
                return (val !== undefined ? val : 24) + '%';
            },
            fontSize: 'D',
            fontWeight: '800',
            color: (el, s)=>{
                var val = s.root.perioIndices && s.root.perioIndices.plaque;
                val = val !== undefined ? val : 24;
                return val > 30 ? 'perioCritical' : val > 15 ? 'perioWarning' : 'perioHealthy';
            }
        },
        CardBar: {
            width: '100%',
            height: 'X',
            round: 'X',
            background: 'inkSurface',
            CardFill: {
                width: (el, s)=>{
                    var val = s.root.perioIndices && s.root.perioIndices.plaque;
                    return (val !== undefined ? val : 24) + '%';
                },
                height: '100%',
                round: 'X',
                background: (el, s)=>{
                    var val = s.root.perioIndices && s.root.perioIndices.plaque;
                    val = val !== undefined ? val : 24;
                    return val > 30 ? 'perioCritical' : val > 15 ? 'perioWarning' : 'perioHealthy';
                }
            }
        }
    },
    Sites4Card: {
        flow: 'y',
        gap: 'Z',
        padding: 'B',
        round: 'Z',
        background: 'inkMid',
        border: '1px solid inkBorder',
        flex: '1',
        minWidth: 'E',
        CardLabel: {
            text: '{{ sitesAbove4 | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        CardValue: {
            text: (el, s)=>{
                var val = s.root.perioIndices && s.root.perioIndices.sites4;
                return String(val !== undefined ? val : 12);
            },
            fontSize: 'D',
            fontWeight: '800',
            color: 'perioWarning'
        },
        CardSub: {
            text: (el, s)=>{
                var val = s.root.perioIndices && s.root.perioIndices.sites4;
                var total = s.root.perioIndices && s.root.perioIndices.totalSites;
                val = val !== undefined ? val : 12;
                total = total !== undefined ? total : 192;
                return Math.round(val / total * 100) + '% of sites';
            },
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    Sites6Card: {
        flow: 'y',
        gap: 'Z',
        padding: 'B',
        round: 'Z',
        background: 'inkMid',
        border: '1px solid inkBorder',
        flex: '1',
        minWidth: 'E',
        CardLabel: {
            text: '{{ sitesAbove6 | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        CardValue: {
            text: (el, s)=>{
                var val = s.root.perioIndices && s.root.perioIndices.sites6;
                return String(val !== undefined ? val : 3);
            },
            fontSize: 'D',
            fontWeight: '800',
            color: 'perioCritical'
        },
        CardSub: {
            text: (el, s)=>{
                var val = s.root.perioIndices && s.root.perioIndices.sites6;
                var total = s.root.perioIndices && s.root.perioIndices.totalSites;
                val = val !== undefined ? val : 3;
                total = total !== undefined ? total : 192;
                return Math.round(val / total * 100) + '% of sites';
            },
            fontSize: 'Y',
            color: 'inkMuted'
        }
    }
};


var $70283f9df385c538$exports = {};

$parcel$export($70283f9df385c538$exports, "TreatmentPhase", () => $70283f9df385c538$export$3e034218ef084d55);
const $70283f9df385c538$export$3e034218ef084d55 = {
    flow: 'y',
    round: 'A',
    overflow: 'hidden',
    border: (el, s)=>s.status === 'active' ? '1px solid teal' : '1px solid inkBorder',
    PhaseHeader: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Z A',
        cursor: 'pointer',
        background: (el, s)=>s.status === 'active' ? 'teal.08' : 'ink',
        onClick: (e, el, s)=>s.update({
                collapsed: !s.collapsed
            }),
        HeaderLeft: {
            flow: 'y',
            gap: 'X',
            PhaseTitle: {
                tag: 'h4',
                text: (el, s)=>s.title || 'Phase',
                fontSize: 'Z',
                fontWeight: '700',
                color: (el, s)=>s.status === 'active' ? 'teal' : 'inkText'
            },
            PhaseMeta: {
                text: (el, s)=>{
                    var rows = s.rows || [];
                    return rows.length + " procedures \xb7 " + (s.provider || 'Multiple providers');
                },
                fontSize: 'Y',
                color: 'inkMuted'
            }
        },
        HeaderRight: {
            flow: 'x',
            gap: 'Z',
            align: 'center center',
            StatusBadge: {
                tag: 'span',
                text: (el, s)=>s.status || 'pending',
                fontSize: 'Y',
                fontWeight: '600',
                padding: 'X Z',
                round: 'B',
                background: (el, s)=>s.status === 'active' ? 'teal.15' : 'inkMid',
                color: (el, s)=>s.status === 'active' ? 'teal' : 'inkMuted',
                whiteSpace: 'nowrap'
            },
            Chevron: {
                tag: 'span',
                text: (el, s)=>s.collapsed ? "\u25B8" : "\u25BE",
                fontSize: 'Z',
                color: 'inkMuted',
                marginLeft: 'Y'
            }
        }
    },
    ProcedureList: {
        flow: 'y',
        gap: '0',
        show: (el, s)=>!s.parent.collapsed,
        background: 'inkMid',
        borderTop: '1px solid inkBorder',
        childExtends: 'TreatmentRow',
        $collection: (el, s)=>{
            var rows = s.parent.rows || [];
            return rows.map(function(row) {
                return {
                    state: {
                        tooth: row.tooth,
                        procedure: row.description,
                        code: row.code,
                        provider: row.provider,
                        fee: row.fee,
                        status: row.status
                    }
                };
            });
        }
    },
    PhaseSummary: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Y A',
        background: 'inkSurface',
        show: (el, s)=>!s.parent.collapsed,
        borderTop: '1px solid inkBorder',
        SummaryLabel: {
            text: '{{ phaseTotal | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted'
        },
        SummaryRight: {
            flow: 'x',
            gap: 'A',
            align: 'center flex-end',
            SummaryAmount: {
                show: (el, s)=>!s.root.chairSideMode,
                text: (el, s)=>{
                    var rows = s.parent.rows || [];
                    var total = 0;
                    rows.forEach(function(r) {
                        total += parseFloat(String(r.fee || 0)) || 0;
                    });
                    return "\u20BE" + total.toLocaleString();
                },
                fontSize: 'Z',
                fontWeight: '700',
                color: 'teal'
            },
            SummaryCount: {
                text: (el, s)=>{
                    var rows = s.parent.rows || [];
                    return rows.length + ' procedures';
                },
                fontSize: 'Y',
                color: 'inkMuted'
            }
        }
    }
};


var $950698d4d1413b23$exports = {};

$parcel$export($950698d4d1413b23$exports, "TreatmentRow", () => $950698d4d1413b23$export$6e73094ad4e3447c);
const $950698d4d1413b23$export$6e73094ad4e3447c = {
    flow: 'x',
    gap: 'Z',
    align: 'center flex-start',
    padding: 'Z A',
    borderBottom: '1px solid inkBorder',
    ':last-child': {
        borderBottom: 'none'
    },
    ToothBadge: {
        text: (el, s)=>'#' + (s.tooth || ''),
        fontSize: (el, s)=>s.root.chairSideMode ? 'Z' : 'Y',
        fontWeight: '700',
        color: 'teal',
        background: 'teal.10',
        width: (el, s)=>s.root.chairSideMode ? 'C' : 'B',
        height: (el, s)=>s.root.chairSideMode ? 'C' : 'B',
        round: 'E',
        textAlign: 'center',
        lineHeight: (el, s)=>s.root.chairSideMode ? 'C' : 'B',
        flow: 'x',
        align: 'center center'
    },
    ProcedureName: {
        text: (el, s)=>s.procedure || '',
        fontSize: (el, s)=>s.root.chairSideMode ? 'A' : 'Z',
        color: 'inkText',
        fontWeight: (el, s)=>s.root.chairSideMode ? '700' : '500',
        flex: '1',
        minWidth: 'D'
    },
    CDTCode: {
        text: (el, s)=>s.code || '',
        fontSize: 'Y',
        color: 'inkMuted',
        fontFamily: 'monospace',
        fontWeight: '500',
        width: 'D'
    },
    ProviderName: {
        text: (el, s)=>s.provider || '',
        fontSize: 'Y',
        color: 'inkMuted',
        width: 'E'
    },
    FeeAmount: {
        show: (el, s)=>!s.root.chairSideMode,
        text: (el, s)=>s.fee || '',
        fontSize: 'Z',
        color: 'teal',
        fontWeight: '600',
        width: 'C',
        textAlign: 'right'
    },
    InsuranceEstimate: {
        show: (el, s)=>!s.root.chairSideMode,
        text: (el, s)=>s.insurance || '',
        fontSize: 'Y',
        color: 'inkSubtle',
        width: 'C',
        textAlign: 'right'
    },
    PatientPortion: {
        show: (el, s)=>!s.root.chairSideMode,
        text: (el, s)=>s.patientPortion || '',
        fontSize: 'Z',
        color: 'inkText',
        fontWeight: '700',
        width: 'C',
        textAlign: 'right'
    },
    RowStatus: {
        extends: 'StatusBadge'
    }
};


var $d0ea885a4e40b154$exports = {};

$parcel$export($d0ea885a4e40b154$exports, "LabCaseCard", () => $d0ea885a4e40b154$export$3dbda108e5e8ead6);
const $d0ea885a4e40b154$export$3dbda108e5e8ead6 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    HeaderRow: {
        flow: 'x',
        align: 'center space-between',
        CaseNumber: {
            text: (el, s)=>s.caseId || 'LC-0001',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        CaseStatus: {
            tag: 'span',
            text: (el, s)=>s.status || 'Impression Sent',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const st = s.status || '';
                if (st === 'Impression Sent') return 'blue.15';
                if (st === 'In Fabrication') return 'amber.15';
                if (st === 'Quality Check') return 'teal.15';
                if (st === 'Try-in Scheduled') return 'purple.15';
                if (st === 'Ready for Pickup') return 'green.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const st = s.status || '';
                if (st === 'Impression Sent') return 'blue';
                if (st === 'In Fabrication') return 'amber';
                if (st === 'Quality Check') return 'teal';
                if (st === 'Try-in Scheduled') return 'purple';
                if (st === 'Ready for Pickup') return 'green';
                return 'inkMuted';
            }
        }
    },
    PatientName: {
        text: (el, s)=>s.patientName || 'Patient Name',
        fontSize: 'A',
        fontWeight: '600',
        color: 'inkText'
    },
    ProcedureType: {
        text: (el, s)=>s.type || 'Crown - PFM',
        fontSize: 'Z',
        color: 'inkMuted'
    },
    LabVendor: {
        text: (el, s)=>'Lab: ' + (s.labVendor || 'Premier Dental Lab'),
        fontSize: 'Z',
        color: 'inkMuted'
    },
    DatesRow: {
        flow: 'x',
        gap: 'Z',
        flexWrap: 'wrap',
        DateSent: {
            text: (el, s)=>'Sent: ' + (s.dateSubmitted || '--'),
            fontSize: 'Y',
            color: 'inkSubtle'
        },
        EstimatedReturn: {
            text: (el, s)=>'Est: ' + (s.dateExpected || '--'),
            fontSize: 'Y',
            color: 'inkSubtle'
        },
        ActualReturn: {
            if: (el, s)=>!!s.actualReturn,
            text: (el, s)=>'Actual: ' + (s.actualReturn || ''),
            fontSize: 'Y',
            color: 'green'
        }
    },
    Notes: {
        if: (el, s)=>!!s.notes,
        text: (el, s)=>s.notes,
        fontSize: 'Y',
        color: 'inkSubtle',
        fontStyle: 'italic'
    }
};


var $a7129e33134b01bf$exports = {};

$parcel$export($a7129e33134b01bf$exports, "LabPipelineColumn", () => $a7129e33134b01bf$export$2669f43c7e0e4b5f);
$parcel$export($a7129e33134b01bf$exports, "LabPipeline", () => $a7129e33134b01bf$export$81222c8f2cb3db9a);
const $a7129e33134b01bf$export$2669f43c7e0e4b5f = {
    flow: 'y',
    gap: 'Z',
    flex: '1',
    minWidth: 'G3',
    height: '100%',
    background: 'inkSurface',
    round: 'A',
    padding: 'Z',
    overflow: 'auto',
    ColumnHeader: {
        flow: 'x',
        order: -1,
        align: 'center space-between',
        padding: 'Y Z',
        marginBottom: 'Y',
        Title: {
            text: (el, s)=>s.title || 'Column',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        Count: {
            tag: 'span',
            text: (el, s)=>s.count || '0',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Y',
            round: 'B',
            background: 'inkMid',
            color: 'inkMuted'
        }
    },
    Cards: {
        flow: 'y',
        gap: 'Y',
        childExtends: 'LabCaseCard'
    }
};
const $a7129e33134b01bf$export$81222c8f2cb3db9a = {
    flow: 'x',
    align: 'stretch start',
    gap: 'Z',
    width: '100%',
    overflow: 'auto',
    Submitted: {
        extends: 'LabPipelineColumn',
        state: {
            title: 'Impression Sent',
            count: '3'
        }
    },
    Fabrication: {
        extends: 'LabPipelineColumn',
        state: {
            title: 'In Fabrication',
            count: '2'
        }
    },
    Quality: {
        extends: 'LabPipelineColumn',
        state: {
            title: 'Quality Check',
            count: '1'
        }
    },
    TryIn: {
        extends: 'LabPipelineColumn',
        state: {
            title: 'Try-in Scheduled',
            count: '1'
        }
    },
    Ready: {
        extends: 'LabPipelineColumn',
        state: {
            title: 'Ready for Pickup',
            count: '1'
        }
    }
};


var $26c70c0245bc7136$exports = {};

$parcel$export($26c70c0245bc7136$exports, "ReferralCard", () => $26c70c0245bc7136$export$d7e041cd5d39ec21);
const $26c70c0245bc7136$export$d7e041cd5d39ec21 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        DirectionBadge: {
            tag: 'span',
            text: (el, s)=>s.direction || 'Inbound',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>s.direction === 'Outbound' ? 'teal.15' : 'blue.15',
            color: (el, s)=>s.direction === 'Outbound' ? 'teal' : 'blue'
        },
        StatusBadge: {
            tag: 'span',
            text: (el, s)=>s.referralStatus || 'Sent',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const st = s.referralStatus || 'Sent';
                if (st === 'Sent') return 'blue.15';
                if (st === 'Scheduled') return 'amber.15';
                if (st === 'Completed') return 'green.15';
                if (st === 'LetterSent') return 'teal.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const st = s.referralStatus || 'Sent';
                if (st === 'Sent') return 'blue';
                if (st === 'Scheduled') return 'amber';
                if (st === 'Completed') return 'green';
                if (st === 'LetterSent') return 'teal';
                return 'inkMuted';
            }
        }
    },
    PatientName: {
        text: (el, s)=>s.patientName || 'Patient Name',
        fontSize: 'A',
        fontWeight: '600',
        color: 'inkText'
    },
    ReferringDoctor: {
        text: (el, s)=>s.referringDoctor || 'Unknown',
        fontSize: 'Z',
        color: 'inkMuted'
    },
    Specialty: {
        text: (el, s)=>s.specialty || 'Oral Surgery',
        fontSize: 'Z',
        color: 'teal',
        fontWeight: '500'
    },
    Reason: {
        text: (el, s)=>s.reason || 'Impacted wisdom teeth',
        fontSize: 'Z',
        color: 'inkSubtle'
    },
    DateSent: {
        text: (el, s)=>'Sent: ' + (s.dateSent || '--'),
        fontSize: 'Y',
        color: 'inkSubtle'
    },
    GenerateLetterBtn: {
        extends: 'Button',
        text: '{{ generateLetter | polyglot }}',
        fontSize: 'Y',
        padding: 'Y Z',
        round: 'Z',
        background: 'teal',
        color: 'white',
        fontWeight: '600',
        cursor: 'pointer',
        alignSelf: 'flex-start'
    }
};


var $d0d345c73715026a$exports = {};

$parcel$export($d0d345c73715026a$exports, "ReportCard", () => $d0d345c73715026a$export$7bf364c5d17ecc34);
const $d0d345c73715026a$export$7bf364c5d17ecc34 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    flex: '1',
    minWidth: 'E',
    Title: {
        text: (el, s)=>s.title || 'Metric',
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: 'X'
    },
    Value: {
        text: (el, s)=>s.value || '0',
        fontSize: 'D',
        fontWeight: '800',
        color: 'teal'
    },
    ComparisonRow: {
        if: (el, s)=>!!s.comparisonValue,
        flow: 'x',
        align: 'center flex-start',
        gap: 'X',
        Arrow: {
            text: (el, s)=>s.deltaPositive ? '\u25B2' : '\u25BC',
            fontSize: 'Y',
            color: (el, s)=>s.deltaPositive ? 'green' : 'red'
        },
        ComparisonValue: {
            text: (el, s)=>s.comparisonValue || '',
            fontSize: 'Z',
            fontWeight: '600',
            color: (el, s)=>s.deltaPositive ? 'green' : 'red'
        }
    },
    SparklineTrend: {
        flow: 'x',
        align: 'flex-end center',
        gap: '2px',
        height: 'B',
        marginTop: 'Y',
        Dot1: {
            width: '6px',
            height: (el, s)=>s.spark1 || '40%',
            background: 'teal',
            round: 'C'
        },
        Dot2: {
            width: '6px',
            height: (el, s)=>s.spark2 || '55%',
            background: 'teal',
            round: 'C'
        },
        Dot3: {
            width: '6px',
            height: (el, s)=>s.spark3 || '45%',
            background: 'teal',
            round: 'C'
        },
        Dot4: {
            width: '6px',
            height: (el, s)=>s.spark4 || '70%',
            background: 'teal',
            round: 'C'
        },
        Dot5: {
            width: '6px',
            height: (el, s)=>s.spark5 || '60%',
            background: 'teal',
            round: 'C'
        },
        Dot6: {
            width: '6px',
            height: (el, s)=>s.spark6 || '80%',
            background: 'teal',
            round: 'C'
        },
        Dot7: {
            width: '6px',
            height: (el, s)=>s.spark7 || '90%',
            background: 'teal',
            round: 'C'
        }
    },
    TimePeriod: {
        text: (el, s)=>s.timePeriod || 'Last 7 days',
        fontSize: 'Y',
        color: 'inkMuted',
        marginTop: 'Y'
    }
};


var $d7115285f384c954$exports = {};

$parcel$export($d7115285f384c954$exports, "ProductionReport", () => $d7115285f384c954$export$2e38bcb57e63600a);
const $d7115285f384c954$export$2e38bcb57e63600a = {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'Z A',
    borderBottom: '1px solid inkBorder',
    flexWrap: 'wrap',
    ProviderName: {
        text: (el, s)=>s.providerName || 'Dr. Smith',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText',
        minWidth: 'E'
    },
    ProcedureCount: {
        text: (el, s)=>(s.procedureCount || '0') + ' procedures',
        fontSize: 'Z',
        color: 'inkMuted',
        minWidth: 'D'
    },
    GrossProduction: {
        text: (el, s)=>s.grossProduction || '$0',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText',
        minWidth: 'D'
    },
    NetProduction: {
        text: (el, s)=>s.netProduction || '$0',
        fontSize: 'Z',
        color: 'teal',
        fontWeight: '600',
        minWidth: 'D'
    },
    CollectionRate: {
        text: (el, s)=>(s.collectionRate || '0') + '%',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'green',
        minWidth: 'C'
    },
    BreakdownBar: {
        flow: 'x',
        flex: '1',
        height: 'Y',
        round: 'B',
        overflow: 'hidden',
        minWidth: 'E',
        Preventive: {
            height: '100%',
            background: 'teal',
            width: (el, s)=>(s.preventive || '20') + '%'
        },
        Restorative: {
            height: '100%',
            background: 'purple',
            width: (el, s)=>(s.restorative || '25') + '%'
        },
        Endo: {
            height: '100%',
            background: 'amber',
            width: (el, s)=>(s.endo || '15') + '%'
        },
        Perio: {
            height: '100%',
            background: 'blue',
            width: (el, s)=>(s.perio || '15') + '%'
        },
        Prosth: {
            height: '100%',
            background: 'gold',
            width: (el, s)=>(s.prosth || '15') + '%'
        },
        Surgery: {
            height: '100%',
            background: 'green',
            width: (el, s)=>(s.surgery || '10') + '%'
        }
    }
};


var $51e3af5a0cb05d74$exports = {};

$parcel$export($51e3af5a0cb05d74$exports, "RecallEffectivenessChart", () => $51e3af5a0cb05d74$export$68d9cf520c683ad7);
const $51e3af5a0cb05d74$export$68d9cf520c683ad7 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    StatsRow: {
        flow: 'x',
        gap: 'A',
        flexWrap: 'wrap',
        TotalDue: {
            flow: 'y',
            gap: 'W',
            Label: {
                text: '{{ totalDue | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Val: {
                text: (el, s)=>s.totalDue || '0',
                fontSize: 'A',
                fontWeight: '700',
                color: 'inkText'
            }
        },
        Scheduled: {
            flow: 'y',
            gap: 'W',
            Label: {
                text: '{{ scheduled2 | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Val: {
                text: (el, s)=>s.scheduled || '0',
                fontSize: 'A',
                fontWeight: '700',
                color: 'teal'
            }
        },
        Completed: {
            flow: 'y',
            gap: 'W',
            Label: {
                text: '{{ completed2 | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Val: {
                text: (el, s)=>s.completed || '0',
                fontSize: 'A',
                fontWeight: '700',
                color: 'green'
            }
        },
        OverdueCount: {
            flow: 'y',
            gap: 'W',
            Label: {
                text: '{{ overdue2 | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Val: {
                text: (el, s)=>s.overdueCount || '0',
                fontSize: 'A',
                fontWeight: '700',
                color: 'red'
            }
        },
        ReactivationRate: {
            flow: 'y',
            gap: 'W',
            Label: {
                text: '{{ reactivation | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Val: {
                text: (el, s)=>(s.reactivationRate || '0') + '%',
                fontSize: 'A',
                fontWeight: '700',
                color: 'teal'
            }
        }
    },
    ChartLabel: {
        text: '6-Month Trend',
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '600',
        marginTop: 'Y'
    },
    BarChart: {
        flow: 'x',
        align: 'flex-end center',
        gap: 'Y',
        height: 'F',
        padding: 'Y 0',
        Bar1: {
            flex: '1',
            background: 'teal',
            round: 'Y Y 0 0',
            height: (el, s)=>(s.month1 || '40') + '%',
            transition: 'height 0.3s ease'
        },
        Bar2: {
            flex: '1',
            background: 'teal',
            round: 'Y Y 0 0',
            height: (el, s)=>(s.month2 || '55') + '%',
            transition: 'height 0.3s ease'
        },
        Bar3: {
            flex: '1',
            background: 'teal',
            round: 'Y Y 0 0',
            height: (el, s)=>(s.month3 || '65') + '%',
            transition: 'height 0.3s ease'
        },
        Bar4: {
            flex: '1',
            background: 'teal',
            round: 'Y Y 0 0',
            height: (el, s)=>(s.month4 || '50') + '%',
            transition: 'height 0.3s ease'
        },
        Bar5: {
            flex: '1',
            background: 'teal',
            round: 'Y Y 0 0',
            height: (el, s)=>(s.month5 || '75') + '%',
            transition: 'height 0.3s ease'
        },
        Bar6: {
            flex: '1',
            background: 'teal',
            round: 'Y Y 0 0',
            height: (el, s)=>(s.month6 || '85') + '%',
            transition: 'height 0.3s ease'
        }
    }
};


var $1cec1237daf50111$exports = {};

$parcel$export($1cec1237daf50111$exports, "RbacBadge", () => $1cec1237daf50111$export$c5148eafb8582c7d);
const $1cec1237daf50111$export$c5148eafb8582c7d = {
    tag: 'span',
    text: (el, s)=>s.role || 'Admin',
    fontSize: 'Y',
    fontWeight: '600',
    padding: 'X Z',
    round: 'C',
    background: (el, s)=>{
        const r = s.role || 'Admin';
        if (r === 'Admin') return 'gold.15';
        if (r === 'Doctor') return 'teal.15';
        if (r === 'Hygienist') return 'purple';
        if (r === 'Receptionist') return 'blue.15';
        if (r === 'LabTech') return 'amber.15';
        if (r === 'Patient') return 'inkSurface';
        return 'inkSurface';
    },
    color: (el, s)=>{
        const r = s.role || 'Admin';
        if (r === 'Admin') return 'inkText';
        if (r === 'Doctor') return 'ink';
        if (r === 'Hygienist') return 'white';
        if (r === 'Receptionist') return 'ink';
        if (r === 'LabTech') return 'ink';
        if (r === 'Patient') return 'inkMuted';
        return 'inkMuted';
    }
};


var $2f8e33763a765e93$exports = {};

$parcel$export($2f8e33763a765e93$exports, "AuditLogRow", () => $2f8e33763a765e93$export$8729af4522518d9);
const $2f8e33763a765e93$export$8729af4522518d9 = {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'Z A',
    background: 'inkMid',
    borderBottom: '1px solid inkBorder',
    flexWrap: 'wrap',
    Timestamp: {
        text: (el, s)=>s.timestamp || '--',
        fontSize: 'Y',
        color: 'inkSubtle',
        minWidth: 'E',
        fontFamily: 'monospace'
    },
    UserInfo: {
        flow: 'x',
        align: 'center flex-start',
        gap: 'Y',
        minWidth: 'E',
        UserName: {
            text: (el, s)=>s.userName || 'User',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        },
        Badge: {
            extends: 'RbacBadge'
        }
    },
    ActionType: {
        text: (el, s)=>s.actionType || 'READ',
        fontSize: 'Z',
        fontWeight: '600',
        minWidth: 'C',
        color: (el, s)=>{
            const a = s.actionType || 'READ';
            if (a === 'READ') return 'inkSubtle';
            if (a === 'WRITE') return 'teal';
            if (a === 'EXPORT') return 'blue';
            if (a === 'DELETE') return 'red';
            return 'inkMuted';
        }
    },
    ResourceTarget: {
        text: (el, s)=>s.resourceTarget || '--',
        fontSize: 'Z',
        color: 'inkMuted',
        flex: '1'
    },
    IpAddress: {
        text: (el, s)=>s.ipAddress || '--',
        fontSize: 'Y',
        color: 'inkSubtle',
        fontFamily: 'monospace',
        flexShrink: '0'
    }
};


var $30924b58f89821b8$exports = {};

$parcel$export($30924b58f89821b8$exports, "ComplianceMeter", () => $30924b58f89821b8$export$6cdbd5f08621bb41);
const $30924b58f89821b8$export$6cdbd5f08621bb41 = {
    flow: 'y',
    gap: 'Y',
    padding: 'A',
    round: 'A',
    background: 'inkSurface',
    border: '1px solid inkBorder',
    Label: {
        text: (el, s)=>s.label || 'Compliance',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText'
    },
    BarTrack: {
        width: '100%',
        height: 'Y',
        round: 'B',
        background: 'inkMid',
        overflow: 'hidden',
        BarFill: {
            height: '100%',
            round: 'B',
            width: (el, s)=>(s.percentage || 0) + '%',
            transition: 'width 0.4s ease',
            background: (el, s)=>{
                const p = s.percentage || 0;
                if (p > 80) return 'teal';
                if (p >= 50) return 'amber';
                return 'red';
            }
        }
    },
    BottomRow: {
        flow: 'x',
        align: 'center space-between',
        Percentage: {
            text: (el, s)=>(s.percentage || 0) + '%',
            fontSize: 'Z',
            fontWeight: '700',
            color: (el, s)=>{
                const p = s.percentage || 0;
                if (p > 80) return 'teal';
                if (p >= 50) return 'amber';
                return 'red';
            }
        },
        ItemsCount: {
            text: (el, s)=>(s.itemsCount || '0') + ' items',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    }
};


var $9938164d635e4121$exports = {};

$parcel$export($9938164d635e4121$exports, "TenantCard", () => $9938164d635e4121$export$4e1325d0d7b9556e);
const $9938164d635e4121$export$4e1325d0d7b9556e = {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    OrgInitial: {
        text: (el, s)=>s.orgInitial || 'D',
        width: 'C',
        height: 'C',
        round: 'D',
        background: 'teal',
        color: 'white',
        fontWeight: '700',
        fontSize: 'A',
        flow: 'x',
        align: 'center center',
        flexShrink: '0'
    },
    Info: {
        flow: 'y',
        gap: 'W',
        flex: '1',
        OrgName: {
            text: (el, s)=>s.orgName || 'Dental Org',
            fontSize: 'A',
            fontWeight: '600',
            color: 'inkText'
        },
        ClinicCount: {
            text: (el, s)=>(s.clinicCount || '0') + ' clinics',
            fontSize: 'Z',
            color: 'inkMuted'
        }
    },
    RightSection: {
        flow: 'y',
        align: 'flex-end center',
        gap: 'Y',
        PlanBadge: {
            tag: 'span',
            text: (el, s)=>s.plan || 'Enterprise',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: 'gold.15',
            color: 'gold'
        },
        StatusDot: {
            width: '10px',
            height: '10px',
            round: 'D',
            background: (el, s)=>s.active !== false ? 'green' : 'red'
        }
    }
};


var $e00105f4cbc5a90f$exports = {};

$parcel$export($e00105f4cbc5a90f$exports, "IntegrationCard", () => $e00105f4cbc5a90f$export$ad4bbebd033175bb);
const $e00105f4cbc5a90f$export$ad4bbebd033175bb = {
    flow: 'x',
    align: 'flex-start flex-start',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    cursor: 'pointer',
    transition: 'border 150ms ease',
    ':hover': {
        border: '1px solid inkSubtle'
    },
    on: {
        click: (e, el, s)=>{
            s.root.update({
                integrationModal: {
                    open: true,
                    name: s.name,
                    category: s.category,
                    status: s.status,
                    logoUrl: s.logoUrl,
                    protocol: s.protocol
                }
            });
        }
    },
    LogoImg: {
        tag: 'img',
        src: (el, s)=>{
            if (s.logoUrl) return s.logoUrl;
            const name = s.name || 'I';
            return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=f0f0f0&color=333&size=96&bold=true&format=svg`;
        },
        attr: {
            onerror: "this.src='https://ui-avatars.com/api/?name='+encodeURIComponent(this.closest('[key]')?.querySelector('[key=Name]')?.textContent||'?')+'&background=f0f0f0&color=333&size=96&bold=true&format=svg'"
        },
        width: 'A1',
        height: 'A1',
        round: 'Y',
        marginTop: 'X',
        flexShrink: '0',
        objectFit: 'contain',
        background: 'inkSurface'
    },
    InfoSection: {
        flow: 'y',
        gap: 'W',
        flex: '1',
        Name: {
            text: (el, s)=>s.name || 'Integration',
            fontSize: 'A',
            fontWeight: '600',
            color: 'inkText',
            lineHeight: '1',
            margin: '- - X2 -'
        },
        CategoryTag: {
            tag: 'span',
            text: (el, s)=>s.category || 'EHR',
            fontSize: 'Y',
            padding: 'X Y',
            round: 'B',
            background: 'inkSurface',
            color: 'inkMuted',
            alignSelf: 'flex-start'
        }
    },
    RightSection: {
        flow: 'y',
        align: 'flex-end center',
        gap: 'Y',
        ConnectionStatus: {
            flow: 'x',
            align: 'center center',
            gap: 'X',
            Dot: {
                width: '8px',
                height: '8px',
                round: 'D',
                background: (el, s)=>{
                    const st = s.status || 'available';
                    if (st === 'connected') return 'green';
                    if (st === 'disconnected') return 'red';
                    if (st === 'syncing') return 'blue';
                    return 'inkMuted';
                }
            },
            Label: {
                text: (el, s)=>{
                    const st = s.status || 'available';
                    if (st === 'connected') return 'Connected';
                    if (st === 'disconnected') return 'Disconnected';
                    if (st === 'syncing') return 'Syncing';
                    return 'Not Installed';
                },
                fontSize: 'Y',
                color: (el, s)=>{
                    const st = s.status || 'available';
                    if (st === 'connected') return 'green';
                    if (st === 'disconnected') return 'red';
                    return 'inkMuted';
                }
            }
        },
        ConfigButton: {
            extends: 'Button',
            text: (el, s)=>s.status === 'connected' ? 'Configure' : 'Install',
            fontSize: 'Y',
            padding: 'X Z',
            round: 'Y',
            background: (el, s)=>s.status === 'connected' ? 'inkSurface' : 'inkText',
            color: (el, s)=>s.status === 'connected' ? 'inkText' : 'inkMid',
            fontWeight: '500',
            cursor: 'pointer',
            border: '1px solid inkBorder'
        }
    }
};


var $172ff3cc87e49b82$exports = {};

$parcel$export($172ff3cc87e49b82$exports, "ApiKeyRow", () => $172ff3cc87e49b82$export$9fa3436849979243);
$parcel$export($172ff3cc87e49b82$exports, "PermissionTag", () => $172ff3cc87e49b82$export$5781689938f9156a);
const $172ff3cc87e49b82$export$9fa3436849979243 = {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'Z A',
    borderBottom: '1px solid inkBorder',
    flexWrap: 'wrap',
    KeyName: {
        text: (el, s)=>s.keyName || 'API Key',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText',
        minWidth: 'D'
    },
    KeyPrefix: {
        text: (el, s)=>s.keyPrefix || 'sk_****...',
        fontSize: 'Z',
        color: 'inkSubtle',
        fontFamily: 'monospace',
        minWidth: 'D'
    },
    Permissions: {
        flow: 'x',
        gap: 'X',
        flex: '1',
        flexWrap: 'wrap',
        childExtends: 'PermissionTag'
    },
    LastUsed: {
        text: (el, s)=>s.lastUsed || '--',
        fontSize: 'Y',
        color: 'inkSubtle',
        minWidth: 'D'
    },
    RevokeButton: {
        extends: 'Button',
        text: '{{ revoke | polyglot }}',
        fontSize: 'Y',
        padding: 'X Z',
        round: 'Z',
        background: 'red.15',
        color: 'red',
        fontWeight: '600',
        cursor: 'pointer',
        border: 'none',
        flexShrink: '0'
    }
};
const $172ff3cc87e49b82$export$5781689938f9156a = {
    tag: 'span',
    text: (el, s)=>s.label || 'read',
    fontSize: 'Y',
    padding: 'X Y',
    round: 'B',
    background: 'inkSurface',
    color: 'inkMuted',
    fontWeight: '500'
};


var $4f093a273ed50522$exports = {};

$parcel$export($4f093a273ed50522$exports, "PortalFormCard", () => $4f093a273ed50522$export$4da4f4b279a55405);
const $4f093a273ed50522$export$4da4f4b279a55405 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        FormTitle: {
            text: (el, s)=>s.formTitle || 'Form',
            fontSize: 'A',
            fontWeight: '600',
            color: 'inkText'
        },
        FormStatus: {
            tag: 'span',
            text: (el, s)=>s.formStatus || 'Pending',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const st = s.formStatus || 'Pending';
                if (st === 'Pending') return 'amber.15';
                if (st === 'Completed') return 'green.15';
                if (st === 'Expired') return 'red.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const st = s.formStatus || 'Pending';
                if (st === 'Pending') return 'amber';
                if (st === 'Completed') return 'green';
                if (st === 'Expired') return 'red';
                return 'inkMuted';
            }
        }
    },
    DueDate: {
        text: (el, s)=>'Due: ' + (s.dueDate || '--'),
        fontSize: 'Z',
        color: 'inkMuted'
    },
    ActionButton: {
        extends: 'Button',
        text: (el, s)=>s.actionLabel || 'Complete Form',
        fontSize: 'Z',
        padding: 'Y Z',
        round: 'Z',
        background: 'teal',
        color: 'white',
        fontWeight: '600',
        cursor: 'pointer',
        alignSelf: 'flex-start',
        marginTop: 'Y'
    }
};


var $c5713fe43a4c045d$exports = {};

$parcel$export($c5713fe43a4c045d$exports, "PatientMessage", () => $c5713fe43a4c045d$export$afc7b15c518654bb);
$parcel$export($c5713fe43a4c045d$exports, "ClinicMessage", () => $c5713fe43a4c045d$export$eee43e9eb7cb0a8b);
$parcel$export($c5713fe43a4c045d$exports, "SecureMessageThread", () => $c5713fe43a4c045d$export$7531090fb2ec223f);
const $c5713fe43a4c045d$export$afc7b15c518654bb = {
    flow: 'y',
    alignSelf: 'flex-end',
    maxWidth: '75%',
    gap: 'W',
    Bubble: {
        padding: 'Z A',
        round: 'A',
        background: 'inkMid',
        color: 'inkText',
        fontSize: 'Z',
        text: (el, s)=>s.text || ''
    },
    Timestamp: {
        text: (el, s)=>s.timestamp || '',
        fontSize: 'Y',
        color: 'inkMuted',
        alignSelf: 'flex-end'
    }
};
const $c5713fe43a4c045d$export$eee43e9eb7cb0a8b = {
    flow: 'y',
    alignSelf: 'flex-start',
    maxWidth: '75%',
    gap: 'W',
    Bubble: {
        padding: 'Z A',
        round: 'A',
        background: 'inkSurface',
        borderLeft: '3px solid teal',
        color: 'inkText',
        fontSize: 'Z',
        text: (el, s)=>s.text || ''
    },
    Timestamp: {
        text: (el, s)=>s.timestamp || '',
        fontSize: 'Y',
        color: 'inkMuted',
        alignSelf: 'flex-start'
    }
};
const $c5713fe43a4c045d$export$7531090fb2ec223f = {
    flow: 'y',
    gap: '0',
    height: '100%',
    background: 'inkSurface',
    round: 'A',
    overflow: 'hidden',
    border: '1px solid inkBorder',
    Header: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Z A',
        borderBottom: '1px solid inkBorder',
        background: 'inkMid',
        ThreadTitle: {
            text: (el, s)=>s.threadTitle || 'Secure Message',
            fontSize: 'A',
            fontWeight: '600',
            color: 'inkText'
        },
        PatientLabel: {
            text: (el, s)=>s.patientName || 'Patient',
            fontSize: 'Z',
            color: 'inkMuted'
        }
    },
    MessageList: {
        flow: 'y',
        gap: 'Z',
        padding: 'A',
        flex: '1',
        overflow: 'auto',
        childrenAs: 'state'
    },
    InputArea: {
        flow: 'x',
        gap: 'Y',
        padding: 'Z A',
        borderTop: '1px solid inkBorder',
        background: 'inkMid',
        align: 'center flex-start',
        MessageInput: {
            extends: 'Input',
            placeholder: 'Type a secure message...',
            flex: '1',
            padding: 'Y Z',
            round: 'Z',
            background: 'inkSurface',
            border: '1px solid inkBorder',
            color: 'inkText',
            fontSize: 'Z'
        },
        SendButton: {
            extends: 'Button',
            text: '{{ send | polyglot }}',
            padding: 'Y Z',
            round: 'Z',
            background: 'teal',
            color: 'white',
            fontWeight: '600',
            fontSize: 'Z',
            cursor: 'pointer',
            flexShrink: '0'
        }
    }
};


var $7ed557d2698990e7$exports = {};

$parcel$export($7ed557d2698990e7$exports, "PlanProcedureRow", () => $7ed557d2698990e7$export$be3c61575cb964a1);
$parcel$export($7ed557d2698990e7$exports, "PlanColumn", () => $7ed557d2698990e7$export$d2c139d27be1fb7b);
$parcel$export($7ed557d2698990e7$exports, "AlternativePlanTab", () => $7ed557d2698990e7$export$44f0c1cbcb2d69f6);
const $7ed557d2698990e7$export$be3c61575cb964a1 = {
    flow: 'x',
    align: 'center space-between',
    padding: 'Y Z',
    borderBottom: '1px solid inkBorder',
    ':last-child': {
        borderBottom: 'none'
    },
    ProcName: {
        text: (el, s)=>s.procedure || 'Procedure',
        fontSize: 'Z',
        color: 'inkText',
        flex: '1'
    },
    Cost: {
        show: (el, s)=>!s.root.chairSideMode,
        text: (el, s)=>s.cost || '$0',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'teal'
    },
    Notes: {
        if: (el, s)=>!!s.notes,
        text: (el, s)=>s.notes || '',
        fontSize: 'Y',
        color: 'inkMuted',
        marginLeft: 'Y'
    }
};
const $7ed557d2698990e7$export$d2c139d27be1fb7b = {
    flow: 'y',
    flex: '1',
    gap: 'Y',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    PlanLabel: {
        text: (el, s)=>s.planLabel || 'Plan',
        fontSize: 'A',
        fontWeight: '700',
        color: 'inkText',
        paddingBottom: 'Y',
        borderBottom: '2px solid teal'
    },
    TotalCost: {
        show: (el, s)=>!s.root.chairSideMode,
        text: (el, s)=>'Total: ' + (s.totalCost || '$0'),
        fontSize: 'Z',
        fontWeight: '700',
        color: 'teal'
    },
    Procedures: {
        flow: 'y',
        childExtends: 'PlanProcedureRow'
    }
};
const $7ed557d2698990e7$export$44f0c1cbcb2d69f6 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    Header: {
        text: '{{ treatmentPlanComparison | polyglot }}',
        fontSize: 'B',
        fontWeight: '700',
        color: 'inkText',
        marginBottom: 'Y'
    },
    Plans: {
        flow: 'x',
        gap: 'Z',
        '@mobileL': {
            flow: 'y'
        },
        PlanA: {
            extends: 'PlanColumn',
            state: {
                planLabel: 'Plan A (Recommended)'
            }
        },
        PlanB: {
            extends: 'PlanColumn',
            state: {
                planLabel: 'Plan B (Alternative)'
            }
        }
    },
    DifferenceNote: {
        text: (el, s)=>s.differenceNote || 'Highlighted differences show cost and procedure variations between plans.',
        fontSize: 'Z',
        color: 'inkMuted',
        padding: 'Y Z',
        background: 'amber.15',
        round: 'Z',
        marginTop: 'Y'
    }
};


var $a966b7efd1e2719f$exports = {};

$parcel$export($a966b7efd1e2719f$exports, "AllergyPill", () => $a966b7efd1e2719f$export$e438be36bb943eb3);
$parcel$export($a966b7efd1e2719f$exports, "PatientBanner", () => $a966b7efd1e2719f$export$3378e13560ce1329);
const $a966b7efd1e2719f$export$e438be36bb943eb3 = {
    tag: 'span',
    text: (el, s)=>s.label || 'Allergy',
    fontSize: 'Y',
    fontWeight: '600',
    padding: 'X Y',
    round: 'B',
    background: 'red.15',
    color: 'red'
};
const $a966b7efd1e2719f$export$3378e13560ce1329 = {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'Z A',
    background: 'inkSubtle',
    color: 'white',
    width: '100%',
    flexWrap: 'wrap',
    AvatarInitial: {
        text: (el, s)=>s.name ? s.name.charAt(0) : '?',
        width: 'C',
        height: 'C',
        round: 'D',
        background: 'teal',
        color: 'white',
        fontWeight: '700',
        fontSize: 'A',
        flow: 'x',
        align: 'center center',
        flexShrink: '0'
    },
    PatientName: {
        text: (el, s)=>s.name || 'Patient',
        fontSize: 'A',
        fontWeight: '700',
        color: 'white'
    },
    Age: {
        text: (el, s)=>s.age ? s.age + ' yrs' : '',
        fontSize: 'Z',
        color: 'white.70'
    },
    Allergies: {
        if: (el, s)=>!!s.allergies,
        flow: 'x',
        gap: 'X',
        flexWrap: 'wrap',
        childExtends: 'AllergyPill',
        childrenAs: 'state'
    },
    InsuranceBadge: {
        if: (el, s)=>!!s.insurance,
        tag: 'span',
        text: (el, s)=>s.insurance || '',
        fontSize: 'Y',
        fontWeight: '600',
        padding: 'X Z',
        round: 'B',
        background: 'blue.15',
        color: 'blue'
    },
    QuickStats: {
        flow: 'x',
        gap: 'Z',
        align: 'center center',
        marginLeft: 'auto',
        TotalProcedures: {
            flow: 'x',
            gap: 'X',
            align: 'center center',
            padding: 'X Z',
            round: 'B',
            background: 'teal.15',
            ProcIcon: {
                extends: 'Icon',
                icon: 'clipboard',
                fontSize: 'Y',
                color: 'teal'
            },
            ProcCount: {
                text: (el, s)=>{
                    var history = s.root && s.root.toothHistory ? s.root.toothHistory : {};
                    var total = 0;
                    var keys = Object.keys(history);
                    for(var i = 0; i < keys.length; i++)total += history[keys[i]].length;
                    return total + ' {{ procedures | polyglot }}';
                },
                fontSize: 'Y',
                fontWeight: '600',
                color: 'teal'
            }
        },
        NextAppointment: {
            flow: 'x',
            gap: 'X',
            align: 'center center',
            padding: 'X Z',
            round: 'B',
            background: 'blue.15',
            ApptIcon: {
                extends: 'Icon',
                icon: 'calendar',
                fontSize: 'Y',
                color: 'blue'
            },
            ApptText: {
                text: '{{ nextAppt | polyglot }}: Mar 25',
                fontSize: 'Y',
                fontWeight: '600',
                color: 'blue'
            }
        },
        LastVisit: {
            if: (el, s)=>!!s.lastVisit,
            text: (el, s)=>'Last visit: ' + (s.lastVisit || ''),
            fontSize: 'Y',
            color: 'white.70'
        }
    }
};


var $5e5bd3b1e4958dc1$exports = {};

$parcel$export($5e5bd3b1e4958dc1$exports, "TreatmentSummaryBar", () => $5e5bd3b1e4958dc1$export$841887fe6e5d7873);
const $5e5bd3b1e4958dc1$export$841887fe6e5d7873 = {
    flow: 'x',
    align: 'center space-between',
    padding: 'A B',
    background: 'inkMid',
    borderTop: '1px solid inkBorder',
    position: 'sticky',
    bottom: '0',
    zIndex: '10',
    gap: 'B',
    '@mobileL': {
        flow: 'y',
        gap: 'Z',
        padding: 'A'
    },
    SummaryNumbers: {
        flow: 'x',
        gap: 'C',
        align: 'center flex-start',
        '@mobileL': {
            gap: 'A',
            flexWrap: 'wrap'
        },
        TotalFee: {
            flow: 'y',
            gap: 'W',
            TotalLabel: {
                text: 'Total Fee',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '500'
            },
            TotalValue: {
                text: (el, s)=>{
                    var v = s.totalFee || 3470;
                    return "\u20BE" + Number(v).toLocaleString();
                },
                fontSize: 'B',
                fontWeight: '700',
                color: 'inkText'
            }
        },
        InsuranceEst: {
            flow: 'y',
            gap: 'W',
            InsLabel: {
                text: 'Insurance Est.',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '500'
            },
            InsValue: {
                text: (el, s)=>{
                    var v = s.insuranceCoverage || s.insuranceEst || 1850;
                    return "\u20BE" + Number(v).toLocaleString();
                },
                fontSize: 'B',
                fontWeight: '700',
                color: 'teal'
            }
        },
        PatientPortion: {
            flow: 'y',
            gap: 'W',
            PatLabel: {
                text: 'Patient Portion',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '500'
            },
            PatValue: {
                text: (el, s)=>{
                    var v = s.patientPortion || 1620;
                    return "\u20BE" + Number(v).toLocaleString();
                },
                fontSize: 'B',
                fontWeight: '700',
                color: 'inkText'
            }
        }
    },
    SummaryActions: {
        flow: 'x',
        gap: 'Z',
        align: 'center center',
        flexShrink: '0',
        PresentBtn: {
            extends: 'Button',
            text: '{{ presentToPatient | polyglot }}',
            background: 'teal',
            color: 'ink',
            fontWeight: '600',
            padding: 'Z A',
            round: 'A',
            fontSize: 'Z',
            cursor: 'pointer',
            border: 'none'
        },
        PortalBtn: {
            extends: 'Button',
            text: '{{ sendToPortal | polyglot }}',
            background: 'inkSurface',
            color: 'inkText',
            fontWeight: '600',
            padding: 'Z A',
            round: 'A',
            fontSize: 'Z',
            cursor: 'pointer',
            border: '1px solid inkBorder'
        }
    }
};


var $826d0b2e40d87197$exports = {};

$parcel$export($826d0b2e40d87197$exports, "ServicePreCheck", () => $826d0b2e40d87197$export$2a3a941eef02a4fd);
const $47cf5d3907e799ee$var$SERVICE_DEPENDENCIES = {
    whitening: {
        requires: [
            'cleaning'
        ],
        within: '6 months',
        question: 'lastCleaningDate'
    },
    implant: {
        requires: [
            'ctScan',
            'consultation'
        ],
        question: 'hasCtScan'
    },
    orthodonticAdjustment: {
        requires: [
            'bracesPlacement'
        ],
        question: 'hasBraces'
    },
    rootCanal: {
        requires: [
            'xray'
        ],
        question: 'hasRecentXray'
    }
};
const $47cf5d3907e799ee$export$7a470df434686642 = (serviceId, answers)=>{
    const dep = $47cf5d3907e799ee$var$SERVICE_DEPENDENCIES[serviceId];
    if (!dep) return {
        passed: true,
        missing: [],
        dependency: null
    };
    const missing = [];
    if (dep.question === 'lastCleaningDate') {
        const dateVal = answers.lastCleaningDate;
        if (!dateVal) missing.push('cleaning');
        else {
            const cleaningDate = new Date(dateVal);
            const sixMonthsAgo = new Date();
            sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
            if (cleaningDate < sixMonthsAgo) missing.push('cleaning');
        }
    }
    if (dep.question === 'hasCtScan') {
        if (!answers.hasCtScan) missing.push('ctScan');
        if (!answers.hasConsultation) missing.push('consultation');
    }
    if (dep.question === 'hasBraces') {
        if (!answers.hasBraces) missing.push('bracesPlacement');
    }
    if (dep.question === 'hasRecentXray') {
        if (!answers.hasRecentXray) missing.push('xray');
    }
    return {
        passed: missing.length === 0,
        missing: missing,
        dependency: dep
    };
};


const $826d0b2e40d87197$var$SERVICE_QUESTIONS = {
    whitening: [
        {
            key: 'lastCleaningDate',
            type: 'date',
            label: '{{ lastCleaningQuestion | polyglot }}'
        }
    ],
    implant: [
        {
            key: 'hasCtScan',
            type: 'checkbox',
            label: '{{ hasCtScanQuestion | polyglot }}'
        },
        {
            key: 'hasConsultation',
            type: 'checkbox',
            label: '{{ hasConsultationQuestion | polyglot }}'
        }
    ],
    orthodonticAdjustment: [
        {
            key: 'hasBraces',
            type: 'checkbox',
            label: '{{ hasBracesQuestion | polyglot }}'
        }
    ],
    rootCanal: [
        {
            key: 'hasRecentXray',
            type: 'checkbox',
            label: '{{ hasRecentXrayQuestion | polyglot }}'
        }
    ]
};
const $826d0b2e40d87197$export$2a3a941eef02a4fd = {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    width: '100%',
    PreCheckTitle: {
        tag: 'h2',
        text: '{{ preCheckTitle | polyglot }}',
        fontSize: 'B',
        fontWeight: '700',
        color: 'inkText'
    },
    PreCheckSubtitle: {
        text: '{{ preCheckSubtitle | polyglot }}',
        fontSize: 'Z',
        color: 'inkMuted'
    },
    QuestionList: {
        flow: 'y',
        gap: 'Z',
        children: (el, s)=>{
            const serviceId = s.root.selectedServiceId;
            return $826d0b2e40d87197$var$SERVICE_QUESTIONS[serviceId] || [];
        },
        childrenAs: 'state',
        childExtends: 'PreCheckQuestion'
    },
    PreCheckQuestion: {
        flow: 'x',
        align: 'center start',
        gap: 'Z',
        padding: 'Z A',
        round: 'Y',
        background: 'inkSurface',
        border: '1px solid inkBorder',
        QuestionInput: {
            extends: 'Input',
            tag: 'input',
            type: (el, s)=>s.type || 'text',
            padding: 'Y Z',
            round: 'Y',
            background: 'ink',
            color: 'inkText',
            border: '1px solid inkBorder',
            fontSize: 'Z',
            width: (el, s)=>s.type === 'checkbox' ? 'A' : '100%',
            height: (el, s)=>s.type === 'checkbox' ? 'A' : 'auto',
            cursor: 'pointer',
            onChange: (e, el, s)=>{
                const answers = s.root.preCheckAnswers || {};
                const val = s.type === 'checkbox' ? el.node.checked : el.node.value;
                answers[s.key] = val;
                const result = (0, $47cf5d3907e799ee$export$7a470df434686642)(s.root.selectedServiceId, answers);
                s.root.update({
                    preCheckAnswers: answers,
                    preCheckPassed: result.passed,
                    preCheckResult: result
                });
            }
        },
        QuestionLabel: {
            text: (el, s)=>s.label,
            fontSize: 'Z',
            color: 'inkText',
            flex: '1'
        }
    },
    PreCheckWarning: {
        flow: 'y',
        gap: 'Y',
        padding: 'A',
        round: 'Y',
        background: 'orange.1',
        border: '1px solid orange.3',
        show: (el, s)=>s.root.preCheckResult && !s.root.preCheckResult.passed && s.root.preCheckResult.missing.length > 0,
        WarningIcon: {
            extends: 'Icon',
            name: 'alertTriangle',
            fontSize: 'A',
            color: 'orange'
        },
        WarningText: {
            text: '{{ prerequisiteWarning | polyglot }}',
            fontSize: 'Z',
            color: 'orange',
            fontWeight: '600'
        },
        MissingList: {
            flow: 'y',
            gap: 'X',
            children: (el, s)=>(s.root.preCheckResult && s.root.preCheckResult.missing || []).map((m)=>({
                        name: m
                    })),
            childrenAs: 'state',
            childExtends: 'MissingItem'
        },
        MissingItem: {
            text: (el, s)=>"\u2022 " + s.name,
            fontSize: 'Y',
            color: 'orange.8'
        },
        BookPrereqBtn: {
            extends: 'Button',
            text: '{{ bookPrerequisiteFirst | polyglot }}',
            background: 'orange',
            color: 'white',
            fontWeight: '600',
            padding: 'Y A',
            round: 'Y',
            fontSize: 'Y',
            cursor: 'pointer',
            border: 'none',
            marginTop: 'Y',
            onClick: (e, el, s)=>{
                const missing = s.root.preCheckResult && s.root.preCheckResult.missing;
                if (missing && missing[0]) s.root.update({
                    selectedServiceId: missing[0],
                    activeBookingStep: 2,
                    preCheckAnswers: {},
                    preCheckPassed: false,
                    preCheckResult: null
                });
            }
        }
    },
    PreCheckPassedMsg: {
        flow: 'x',
        align: 'center center',
        gap: 'Y',
        padding: 'A',
        round: 'Y',
        background: 'teal.1',
        border: '1px solid teal.3',
        show: (el, s)=>s.root.preCheckPassed === true,
        PassedIcon: {
            extends: 'Icon',
            name: 'checkCircle',
            fontSize: 'A',
            color: 'teal'
        },
        PassedText: {
            text: '{{ preCheckPassed | polyglot }}',
            fontSize: 'Z',
            color: 'teal',
            fontWeight: '600'
        }
    },
    ContinueBtn: {
        extends: 'Button',
        text: '{{ continueToScheduling | polyglot }}',
        show: (el, s)=>s.root.preCheckPassed === true,
        background: '#0D1117',
        color: '#FFFFFF',
        fontWeight: '600',
        padding: 'Z B',
        round: 'B',
        fontSize: 'Z',
        cursor: 'pointer',
        border: 'none',
        width: '100%',
        textAlign: 'center',
        marginTop: 'Y',
        onClick: (e, el, s)=>s.root.update({
                activeBookingStep: 4
            })
    },
    NoPrereqMsg: {
        flow: 'y',
        align: 'center center',
        gap: 'Y',
        padding: 'A',
        show: (el, s)=>{
            const serviceId = s.root.selectedServiceId;
            return !$826d0b2e40d87197$var$SERVICE_QUESTIONS[serviceId];
        },
        NoPrereqText: {
            text: '{{ preCheckPassed | polyglot }}',
            fontSize: 'Z',
            color: 'teal',
            fontWeight: '600'
        },
        AutoContinueBtn: {
            extends: 'Button',
            text: '{{ continueToScheduling | polyglot }}',
            background: '#0D1117',
            color: '#FFFFFF',
            fontWeight: '600',
            padding: 'Z B',
            round: 'B',
            fontSize: 'Z',
            cursor: 'pointer',
            border: 'none',
            width: '100%',
            textAlign: 'center',
            onClick: (e, el, s)=>s.root.update({
                    activeBookingStep: 4
                })
        }
    }
};


var $31e9cd8ecc45595b$exports = {};

$parcel$export($31e9cd8ecc45595b$exports, "ChatSidebar", () => $31e9cd8ecc45595b$export$c9634fb3dbc93f1f);
const $31e9cd8ecc45595b$export$c9634fb3dbc93f1f = {
    flow: 'y',
    width: 'F3',
    background: 'inkMid',
    borderRight: '1px solid inkBorder',
    height: '100vh',
    position: 'sticky',
    top: '0',
    overflow: 'auto',
    '@mobileL': {
        display: 'none'
    },
    Header: {
        padding: 'A',
        borderBottom: '1px solid inkBorder',
        Title: {
            text: '{{ teamChat | polyglot }}',
            fontSize: 'A',
            fontWeight: '700',
            color: 'inkText'
        }
    },
    ChannelsSection: {
        flow: 'y',
        gap: '0',
        padding: 'Z 0',
        SectionLabel: {
            text: '{{ channels | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            letterSpacing: 'X',
            padding: 'Y A',
            textTransform: 'uppercase'
        },
        ChannelCabinet1: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'cabinet-1' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Hash: {
                    text: '#',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: (el, s)=>s.root.activeChatChannel === 'cabinet-1' ? 'teal' : 'inkMuted'
                },
                Label: {
                    text: '{{ cabinet1 | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: (el, s)=>s.root.activeChatChannel === 'cabinet-1' ? '600' : '400',
                    color: (el, s)=>s.root.activeChatChannel === 'cabinet-1' ? 'teal' : 'inkText'
                }
            },
            Badge: {
                text: '3',
                fontSize: 'Y',
                fontWeight: '700',
                padding: 'W Y',
                round: 'Z',
                background: 'teal',
                color: 'white',
                minWidth: 'A',
                textAlign: 'center'
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'cabinet-1'
                })
        },
        ChannelCabinet2: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'cabinet-2' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Hash: {
                    text: '#',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: (el, s)=>s.root.activeChatChannel === 'cabinet-2' ? 'teal' : 'inkMuted'
                },
                Label: {
                    text: '{{ cabinet2 | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: (el, s)=>s.root.activeChatChannel === 'cabinet-2' ? '600' : '400',
                    color: (el, s)=>s.root.activeChatChannel === 'cabinet-2' ? 'teal' : 'inkText'
                }
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'cabinet-2'
                })
        },
        ChannelReception: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'reception' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Hash: {
                    text: '#',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: (el, s)=>s.root.activeChatChannel === 'reception' ? 'teal' : 'inkMuted'
                },
                Label: {
                    text: '{{ reception | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: (el, s)=>s.root.activeChatChannel === 'reception' ? '600' : '400',
                    color: (el, s)=>s.root.activeChatChannel === 'reception' ? 'teal' : 'inkText'
                }
            },
            Badge: {
                text: '5',
                fontSize: 'Y',
                fontWeight: '700',
                padding: 'W Y',
                round: 'Z',
                background: 'red',
                color: 'white',
                minWidth: 'A',
                textAlign: 'center'
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'reception'
                })
        },
        ChannelDoctors: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'doctors' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Hash: {
                    text: '#',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: (el, s)=>s.root.activeChatChannel === 'doctors' ? 'teal' : 'inkMuted'
                },
                Label: {
                    text: '{{ doctors | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: (el, s)=>s.root.activeChatChannel === 'doctors' ? '600' : '400',
                    color: (el, s)=>s.root.activeChatChannel === 'doctors' ? 'teal' : 'inkText'
                }
            },
            Badge: {
                text: '1',
                fontSize: 'Y',
                fontWeight: '700',
                padding: 'W Y',
                round: 'Z',
                background: 'amber',
                color: 'white',
                minWidth: 'A',
                textAlign: 'center'
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'doctors'
                })
        },
        ChannelManagement: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'management' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Hash: {
                    text: '#',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: (el, s)=>s.root.activeChatChannel === 'management' ? 'teal' : 'inkMuted'
                },
                Label: {
                    text: '{{ management | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: (el, s)=>s.root.activeChatChannel === 'management' ? '600' : '400',
                    color: (el, s)=>s.root.activeChatChannel === 'management' ? 'teal' : 'inkText'
                }
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'management'
                })
        },
        ChannelGeneral: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'general' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Hash: {
                    text: '#',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: (el, s)=>s.root.activeChatChannel === 'general' ? 'teal' : 'inkMuted'
                },
                Label: {
                    text: '{{ general | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: (el, s)=>s.root.activeChatChannel === 'general' ? '600' : '400',
                    color: (el, s)=>s.root.activeChatChannel === 'general' ? 'teal' : 'inkText'
                }
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'general'
                })
        }
    },
    DirectMessagesSection: {
        flow: 'y',
        gap: '0',
        padding: 'Z 0',
        borderTop: '1px solid inkBorder',
        SectionLabel: {
            text: '{{ directMessages | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            letterSpacing: 'X',
            padding: 'Y A',
            textTransform: 'uppercase'
        },
        DmKvaratskhelia: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'dm-kvaratskhelia' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Avatar: {
                    text: 'GK',
                    fontSize: 'Y',
                    fontWeight: '700',
                    width: 'B',
                    height: 'B',
                    round: 'B',
                    background: 'teal.15',
                    color: 'teal',
                    display: 'flex',
                    align: 'center center'
                },
                Info: {
                    flow: 'y',
                    gap: '0',
                    Name: {
                        text: 'Dr. Kvaratskhelia',
                        fontSize: 'Z',
                        fontWeight: (el, s)=>s.root.activeChatChannel === 'dm-kvaratskhelia' ? '600' : '400',
                        color: (el, s)=>s.root.activeChatChannel === 'dm-kvaratskhelia' ? 'teal' : 'inkText'
                    },
                    Status: {
                        text: '{{ online | polyglot }}',
                        fontSize: 'Y',
                        color: 'green'
                    }
                }
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'dm-kvaratskhelia'
                })
        },
        DmBeridze: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'dm-beridze' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Avatar: {
                    text: 'NB',
                    fontSize: 'Y',
                    fontWeight: '700',
                    width: 'B',
                    height: 'B',
                    round: 'B',
                    background: 'purple.15',
                    color: 'purple',
                    display: 'flex',
                    align: 'center center'
                },
                Info: {
                    flow: 'y',
                    gap: '0',
                    Name: {
                        text: 'Dr. Beridze',
                        fontSize: 'Z',
                        fontWeight: (el, s)=>s.root.activeChatChannel === 'dm-beridze' ? '600' : '400',
                        color: (el, s)=>s.root.activeChatChannel === 'dm-beridze' ? 'teal' : 'inkText'
                    },
                    Status: {
                        text: '{{ online | polyglot }}',
                        fontSize: 'Y',
                        color: 'green'
                    }
                }
            },
            Badge: {
                text: '2',
                fontSize: 'Y',
                fontWeight: '700',
                padding: 'W Y',
                round: 'Z',
                background: 'teal',
                color: 'white',
                minWidth: 'A',
                textAlign: 'center'
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'dm-beridze'
                })
        },
        DmNino: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Y A',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.root.activeChatChannel === 'dm-nino' ? 'teal.15' : 'transparent',
            ':hover': {
                background: 'teal.08'
            },
            Left: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Avatar: {
                    text: 'NT',
                    fontSize: 'Y',
                    fontWeight: '700',
                    width: 'B',
                    height: 'B',
                    round: 'B',
                    background: 'amber.15',
                    color: 'amber',
                    display: 'flex',
                    align: 'center center'
                },
                Info: {
                    flow: 'y',
                    gap: '0',
                    Name: {
                        text: '{{ hygienistNino | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: (el, s)=>s.root.activeChatChannel === 'dm-nino' ? '600' : '400',
                        color: (el, s)=>s.root.activeChatChannel === 'dm-nino' ? 'teal' : 'inkText'
                    },
                    Status: {
                        text: '{{ away | polyglot }}',
                        fontSize: 'Y',
                        color: 'amber'
                    }
                }
            },
            onClick: (e, el, s)=>s.root.update({
                    activeChatChannel: 'dm-nino'
                })
        }
    }
};


var $260a5b5edf3aab0b$exports = {};

$parcel$export($260a5b5edf3aab0b$exports, "ChatMessage", () => $260a5b5edf3aab0b$export$423c13fd52bec8ad);
const $260a5b5edf3aab0b$export$423c13fd52bec8ad = {
    flow: 'x',
    gap: 'Z',
    padding: 'Z A',
    align: 'flex-start flex-start',
    borderLeft: (el, s)=>{
        const urgency = s.urgency || 'normal';
        if (urgency === 'urgent') return '3px solid red';
        if (urgency === 'important') return '3px solid amber';
        return '3px solid transparent';
    },
    background: (el, s)=>{
        const urgency = s.urgency || 'normal';
        if (urgency === 'urgent') return 'red.05';
        if (urgency === 'important') return 'amber.05';
        return 'transparent';
    },
    ':hover': {
        background: 'inkMid'
    },
    transition: 'background 150ms ease',
    Avatar: {
        width: 'C',
        height: 'C',
        minWidth: 'C',
        round: 'C',
        background: (el, s)=>s.avatarColor || 'teal.15',
        color: (el, s)=>s.avatarTextColor || 'teal',
        display: 'flex',
        align: 'center center',
        fontSize: 'Z',
        fontWeight: '700',
        text: (el, s)=>s.initials || '??'
    },
    Content: {
        flow: 'y',
        gap: 'W',
        flex: '1',
        Header: {
            flow: 'x',
            gap: 'Y',
            align: 'center flex-start',
            SenderName: {
                text: (el, s)=>s.sender || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            },
            Timestamp: {
                text: (el, s)=>s.timestamp || '',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            UrgencyTag: {
                show: (el, s)=>s.urgency && s.urgency !== 'normal',
                text: (el, s)=>s.urgency === 'urgent' ? '{{ urgent | polyglot }}' : '{{ important | polyglot }}',
                fontSize: 'Y',
                fontWeight: '600',
                padding: 'W Y',
                round: 'Y',
                background: (el, s)=>s.urgency === 'urgent' ? 'red.15' : 'amber.15',
                color: (el, s)=>s.urgency === 'urgent' ? 'red' : 'amber'
            }
        },
        MessageText: {
            text: (el, s)=>s.text || '',
            fontSize: 'Z',
            color: 'inkText',
            lineHeight: '1.5'
        },
        StatusIndicator: {
            show: (el, s)=>!!s.status,
            flow: 'x',
            gap: 'W',
            align: 'center flex-start',
            StatusIcon: {
                fontSize: 'Y',
                color: (el, s)=>s.status === 'read' ? 'teal' : 'inkMuted',
                text: (el, s)=>{
                    if (s.status === 'sent') return '\u2713';
                    if (s.status === 'delivered') return '\u2713\u2713';
                    if (s.status === 'read') return '\u2713\u2713';
                    return '';
                }
            },
            StatusLabel: {
                fontSize: 'Y',
                color: (el, s)=>s.status === 'read' ? 'teal' : 'inkMuted',
                text: (el, s)=>{
                    if (s.status === 'sent') return '{{ sent | polyglot }}';
                    if (s.status === 'delivered') return '{{ delivered | polyglot }}';
                    if (s.status === 'read') return '{{ read | polyglot }}';
                    return '';
                }
            }
        }
    }
};


var $7b00be04df0391fc$exports = {};

$parcel$export($7b00be04df0391fc$exports, "ChatInput", () => $7b00be04df0391fc$export$19b903fd083c557c);
const $7b00be04df0391fc$export$19b903fd083c557c = {
    flow: 'x',
    gap: 'Y',
    padding: 'Z A',
    borderTop: '1px solid inkBorder',
    background: 'inkMid',
    align: 'center flex-start',
    MessageField: {
        extends: 'Input',
        placeholder: '{{ typeAMessage | polyglot }}',
        flex: '1',
        padding: 'Z A',
        round: 'Z',
        background: 'inkSurface',
        border: '1px solid inkBorder',
        color: 'inkText',
        fontSize: 'Z',
        onKeypress: (e, el, s)=>{
            if (e.key === 'Enter' && !e.shiftKey) e.preventDefault();
        }
    },
    SendBtn: {
        extends: 'Button',
        text: '{{ send | polyglot }}',
        padding: 'Z A',
        round: 'Z',
        background: 'teal',
        color: 'white',
        fontWeight: '600',
        fontSize: 'Z',
        cursor: 'pointer',
        flexShrink: '0',
        border: 'none',
        transition: 'opacity 150ms ease',
        ':hover': {
            opacity: '0.85'
        }
    }
};


var $d79130fc0ca8b1f4$exports = {};

$parcel$export($d79130fc0ca8b1f4$exports, "AiNoteInterpreter", () => $d79130fc0ca8b1f4$export$85b3180959ca6225);
const $d79130fc0ca8b1f4$export$85b3180959ca6225 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    state: {
        noteInterpretMode: 'original'
    },
    Header: {
        flow: 'x',
        align: 'center space-between',
        Title: {
            flow: 'x',
            gap: 'Y',
            align: 'center flex-start',
            AiIcon: {
                text: 'AI',
                fontSize: 'X',
                fontWeight: '800',
                padding: 'X Y',
                round: 'X',
                background: 'violet.15',
                color: 'violet'
            },
            Label: {
                text: '{{ noteInterpreter | polyglot }}',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkText'
            }
        },
        ModeToggle: {
            flow: 'x',
            gap: '0',
            round: 'Y',
            overflow: 'hidden',
            border: '1px solid inkBorder',
            OriginalTab: {
                tag: 'button',
                text: '{{ original | polyglot }}',
                fontSize: 'Y',
                fontWeight: '600',
                padding: 'X Z',
                cursor: 'pointer',
                border: 'none',
                background: (el, s)=>s.noteInterpretMode === 'original' ? 'teal' : 'ink',
                color: (el, s)=>s.noteInterpretMode === 'original' ? 'white' : 'inkMuted',
                onClick: (el, s)=>s.update({
                        noteInterpretMode: 'original'
                    })
            },
            InterpretedTab: {
                tag: 'button',
                text: '{{ interpreted | polyglot }}',
                fontSize: 'Y',
                fontWeight: '600',
                padding: 'X Z',
                cursor: 'pointer',
                border: 'none',
                background: (el, s)=>s.noteInterpretMode === 'interpreted' ? 'teal' : 'ink',
                color: (el, s)=>s.noteInterpretMode === 'interpreted' ? 'white' : 'inkMuted',
                onClick: (el, s)=>s.update({
                        noteInterpretMode: 'interpreted'
                    })
            }
        }
    },
    NoteContent: {
        flow: 'y',
        gap: 'Y',
        padding: 'Z',
        round: 'Y',
        background: 'ink',
        minHeight: 'D',
        OriginalView: {
            show: (el, s)=>s.noteInterpretMode === 'original',
            text: (el, s)=>s.root.activeNoteText || '{{ noNoteSelected | polyglot }}',
            fontSize: 'Z',
            color: 'inkText',
            lineHeight: '1.5',
            whiteSpace: 'pre-wrap'
        },
        InterpretedView: {
            show: (el, s)=>s.noteInterpretMode === 'interpreted',
            flow: 'y',
            gap: 'Y',
            InterpretedText: {
                tag: 'div',
                fontSize: 'Z',
                color: 'inkText',
                lineHeight: '1.5',
                whiteSpace: 'pre-wrap',
                html: (el, s)=>{
                    var text = s.root.activeNoteText || '';
                    if (!text) return '<span style="opacity:0.5">{{ noNoteSelected | polyglot }}</span>';
                    var result = el.call('normalizeTerms', text);
                    if (!result || !result.changes || !result.changes.length) return text;
                    var output = result.normalized;
                    var changes = result.changes.slice().sort(function(a, b) {
                        return b.position - a.position;
                    });
                    for(var i = 0; i < changes.length; i++){
                        var c = changes[i];
                        var before = output.slice(0, c.position);
                        var term = output.slice(c.position, c.position + c.normalized.length);
                        var after = output.slice(c.position + c.normalized.length);
                        output = before + '<span style="background:rgba(139,92,246,0.15);padding:1px 4px;border-radius:4px;cursor:help" title="' + c.original + '">' + term + '</span>' + after;
                    }
                    return output;
                }
            }
        }
    },
    ChangeSummary: {
        show: (el, s)=>s.noteInterpretMode === 'interpreted',
        flow: 'y',
        gap: 'X',
        padding: 'Z',
        round: 'Y',
        background: 'violet.05',
        border: '1px solid violet.15',
        SummaryLabel: {
            text: '{{ termsNormalized | polyglot }}',
            fontSize: 'Y',
            fontWeight: '700',
            color: 'violet'
        },
        ChangesList: {
            flow: 'y',
            gap: 'X',
            childExtends: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                fontSize: 'Y'
            },
            $collection: (el, s)=>{
                var text = s.root.activeNoteText || '';
                if (!text) return [];
                var result = el.call('normalizeTerms', text);
                if (!result || !result.changes) return [];
                return result.changes.map(function(c) {
                    return {
                        OriginalTerm: {
                            text: c.original,
                            color: 'red',
                            textDecoration: 'line-through',
                            fontWeight: '500'
                        },
                        Arrow: {
                            text: '\u2192',
                            color: 'inkMuted'
                        },
                        NormalizedTerm: {
                            text: c.normalized,
                            color: 'green',
                            fontWeight: '600'
                        }
                    };
                });
            }
        }
    }
};


var $b3cc7bc69bb5e9f7$exports = {};

$parcel$export($b3cc7bc69bb5e9f7$exports, "InformedConsentForm", () => $b3cc7bc69bb5e9f7$export$e1d12e0f13dd0644);
const $b3cc7bc69bb5e9f7$var$CONSENT_SECTIONS = [
    {
        key: 'procedure',
        titleKey: 'consentProcedureTitle',
        descKey: 'consentProcedureDesc'
    },
    {
        key: 'risks',
        titleKey: 'consentRisksTitle',
        descKey: 'consentRisksDesc'
    },
    {
        key: 'alternatives',
        titleKey: 'consentAlternativesTitle',
        descKey: 'consentAlternativesDesc'
    },
    {
        key: 'outcomes',
        titleKey: 'consentOutcomesTitle',
        descKey: 'consentOutcomesDesc'
    },
    {
        key: 'aftercare',
        titleKey: 'consentAftercareTitle',
        descKey: 'consentAftercareDesc'
    }
];
const $b3cc7bc69bb5e9f7$var$ConsentCheckSection = {
    flow: 'y',
    gap: 'Y',
    padding: 'Z A',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    SectionHeading: {
        tag: 'h4',
        text: (el, s)=>`{{ ${s.titleKey} | polyglot }}`,
        fontSize: 'Z',
        fontWeight: '700',
        color: 'inkText'
    },
    SectionDescription: {
        tag: 'p',
        text: (el, s)=>`{{ ${s.descKey} | polyglot }}`,
        fontSize: 'Y',
        color: 'inkMuted',
        lineHeight: '1.6'
    },
    CheckRow: {
        flow: 'x',
        align: 'center flex-start',
        gap: 'Y',
        cursor: 'pointer',
        onClick: (e, el, s)=>{
            const checks = {
                ...s.root.consentChecks || {}
            };
            checks[s.key] = !checks[s.key];
            s.root.update({
                consentChecks: checks
            });
        },
        Checkbox: {
            tag: 'span',
            text: (el, s)=>(s.root.consentChecks || {})[s.key] ? '\u2713' : '',
            width: 'B',
            height: 'B',
            minWidth: 'B',
            round: 'Y',
            border: (el, s)=>(s.root.consentChecks || {})[s.key] ? '2px solid teal' : '2px solid inkBorder',
            background: (el, s)=>(s.root.consentChecks || {})[s.key] ? 'teal' : 'transparent',
            color: 'white',
            fontSize: 'Y',
            fontWeight: '700',
            flow: 'x',
            align: 'center center',
            flexShrink: '0',
            transition: 'background .15s, border-color .15s'
        },
        CheckLabel: {
            text: '{{ consentAcknowledge | polyglot }}',
            fontSize: 'Y',
            color: 'inkText',
            userSelect: 'none'
        }
    }
};
const $b3cc7bc69bb5e9f7$export$e1d12e0f13dd0644 = {
    flow: 'y',
    gap: 'Z',
    FormTitle: {
        tag: 'h3',
        text: '{{ informedConsentTitle | polyglot }}',
        fontSize: 'A',
        fontWeight: '700',
        color: 'inkText'
    },
    TreatmentLabel: {
        text: (el, s)=>s.treatmentName || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'teal'
    },
    Sections: {
        flow: 'y',
        gap: 'Z',
        childExtends: $b3cc7bc69bb5e9f7$var$ConsentCheckSection,
        childrenAs: 'state',
        children: ()=>$b3cc7bc69bb5e9f7$var$CONSENT_SECTIONS
    }
};


var $6bfb8e6f8449f18b$exports = {};

$parcel$export($6bfb8e6f8449f18b$exports, "ESignature", () => $6bfb8e6f8449f18b$export$8444289548f15a04);
const $6bfb8e6f8449f18b$var$allChecked = (s)=>{
    const checks = s.root.consentChecks || {};
    return checks.procedure && checks.risks && checks.alternatives && checks.outcomes && checks.aftercare;
};
const $6bfb8e6f8449f18b$export$8444289548f15a04 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    SignatureTitle: {
        tag: 'h4',
        text: '{{ eSignatureTitle | polyglot }}',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'inkText'
    },
    DisabledNotice: {
        if: (el, s)=>!$6bfb8e6f8449f18b$var$allChecked(s),
        text: '{{ consentCheckAllFirst | polyglot }}',
        fontSize: 'Y',
        color: 'amber',
        fontWeight: '500'
    },
    CanvasWrap: {
        position: 'relative',
        width: '100%',
        height: '200px',
        round: 'Y',
        border: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) ? '2px solid teal' : '2px solid inkBorder',
        background: 'white',
        overflow: 'hidden',
        opacity: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) ? '1' : '0.4',
        pointerEvents: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) ? 'auto' : 'none',
        transition: 'opacity .2s, border-color .2s',
        SignCanvas: {
            tag: 'canvas',
            width: '100%',
            height: '100%',
            style: {
                display: 'block'
            },
            onRender: (el, s)=>{
                if (el.__initialized) return;
                el.__initialized = true;
                const canvas = el.node;
                const resize = ()=>{
                    const rect = canvas.parentElement.getBoundingClientRect();
                    canvas.width = rect.width;
                    canvas.height = rect.height;
                };
                resize();
                const ctx = canvas.getContext('2d');
                ctx.lineWidth = 2;
                ctx.lineCap = 'round';
                ctx.strokeStyle = '#1a1a2e';
                let drawing = false;
                const getPos = (e)=>{
                    const rect = canvas.getBoundingClientRect();
                    const touch = e.touches ? e.touches[0] : e;
                    return {
                        x: touch.clientX - rect.left,
                        y: touch.clientY - rect.top
                    };
                };
                const start = (e)=>{
                    e.preventDefault();
                    drawing = true;
                    const p = getPos(e);
                    ctx.beginPath();
                    ctx.moveTo(p.x, p.y);
                };
                const move = (e)=>{
                    if (!drawing) return;
                    e.preventDefault();
                    const p = getPos(e);
                    ctx.lineTo(p.x, p.y);
                    ctx.stroke();
                };
                const stop = ()=>{
                    drawing = false;
                };
                canvas.addEventListener('mousedown', start);
                canvas.addEventListener('mousemove', move);
                canvas.addEventListener('mouseup', stop);
                canvas.addEventListener('mouseleave', stop);
                canvas.addEventListener('touchstart', start, {
                    passive: false
                });
                canvas.addEventListener('touchmove', move, {
                    passive: false
                });
                canvas.addEventListener('touchend', stop);
                el.__ctx = ctx;
                el.__canvas = canvas;
                el.__resize = resize;
                window.addEventListener('resize', resize);
            }
        }
    },
    Actions: {
        flow: 'x',
        gap: 'Y',
        marginTop: 'Y',
        ClearBtn: {
            extends: 'Button',
            text: '{{ clearSignature | polyglot }}',
            fontSize: 'Y',
            padding: 'Y Z',
            round: 'Z',
            background: 'inkSurface',
            color: 'inkText',
            fontWeight: '600',
            cursor: 'pointer',
            opacity: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) ? '1' : '0.4',
            pointerEvents: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) ? 'auto' : 'none',
            onClick: (e, el, s)=>{
                const canvasEl = el.parent.parent.CanvasWrap.SignCanvas;
                if (canvasEl.__canvas && canvasEl.__ctx) {
                    canvasEl.__resize();
                    canvasEl.__ctx.lineWidth = 2;
                    canvasEl.__ctx.lineCap = 'round';
                    canvasEl.__ctx.strokeStyle = '#1a1a2e';
                }
                s.root.update({
                    signatureData: null,
                    signatureCaptured: false
                });
            }
        },
        ConfirmBtn: {
            extends: 'Button',
            text: '{{ confirmSignature | polyglot }}',
            fontSize: 'Y',
            padding: 'Y Z',
            round: 'Z',
            background: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) && !s.root.signatureCaptured ? 'teal' : 'inkSurface',
            color: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) && !s.root.signatureCaptured ? 'white' : 'inkMuted',
            fontWeight: '600',
            cursor: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) && !s.root.signatureCaptured ? 'pointer' : 'default',
            opacity: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) && !s.root.signatureCaptured ? '1' : '0.4',
            pointerEvents: (el, s)=>$6bfb8e6f8449f18b$var$allChecked(s) && !s.root.signatureCaptured ? 'auto' : 'none',
            onClick: (e, el, s)=>{
                const canvasEl = el.parent.parent.CanvasWrap.SignCanvas;
                if (canvasEl.__canvas) {
                    const data = canvasEl.__canvas.toDataURL('image/png');
                    s.root.update({
                        signatureData: data,
                        signatureCaptured: true,
                        signatureTimestamp: new Date().toLocaleString()
                    });
                }
            }
        }
    },
    SignedConfirmation: {
        if: (el, s)=>!!s.root.signatureCaptured,
        flow: 'x',
        align: 'center flex-start',
        gap: 'Y',
        padding: 'Y Z',
        round: 'Y',
        background: 'green.15',
        SignedIcon: {
            tag: 'span',
            text: '\u2713',
            color: 'green',
            fontWeight: '700',
            fontSize: 'Z'
        },
        SignedText: {
            text: (el, s)=>`{{ signatureCapturedAt | polyglot }} ${s.root.signatureTimestamp || ''}`,
            fontSize: 'Y',
            color: 'green',
            fontWeight: '500'
        }
    }
};


var $ea0d742937f80291$exports = {};

$parcel$export($ea0d742937f80291$exports, "ConsentCard", () => $ea0d742937f80291$export$aa03b7434af985b0);
const $ea0d742937f80291$export$aa03b7434af985b0 = {
    flow: 'y',
    gap: 'Y',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    transition: 'box-shadow .15s',
    ':hover': {
        boxShadow: '0 2px 12px 0 ink.10'
    },
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        TreatmentName: {
            text: (el, s)=>s.treatmentName || '{{ untitled | polyglot }}',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        StatusBadge: {
            tag: 'span',
            text: (el, s)=>s.consentStatus || 'Pending',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const st = s.consentStatus || 'Pending';
                if (st === 'Signed') return 'green.15';
                if (st === 'Pending') return 'amber.15';
                if (st === 'Expired') return 'red.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const st = s.consentStatus || 'Pending';
                if (st === 'Signed') return 'green';
                if (st === 'Pending') return 'amber';
                if (st === 'Expired') return 'red';
                return 'inkMuted';
            }
        }
    },
    PatientName: {
        text: (el, s)=>s.patientName || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText'
    },
    DateSigned: {
        text: (el, s)=>s.dateSigned ? `{{ signed | polyglot }}: ${s.dateSigned}` : '{{ awaitingSignature | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted'
    },
    ViewBtn: {
        extends: 'Button',
        text: '{{ viewDetails | polyglot }}',
        fontSize: 'Y',
        padding: 'Y Z',
        round: 'Z',
        background: 'teal',
        color: 'white',
        fontWeight: '600',
        cursor: 'pointer',
        alignSelf: 'flex-start'
    }
};


var $68ee1ecd60a3592e$exports = {};

$parcel$export($68ee1ecd60a3592e$exports, "CabinetSlot", () => $68ee1ecd60a3592e$export$1967a1e715700db1);
const $68ee1ecd60a3592e$export$1967a1e715700db1 = {
    flow: 'y',
    gap: 'X',
    padding: 'Z',
    round: 'Y',
    minHeight: 'B1',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    ':hover': {
        opacity: '0.85',
        transform: 'scale(1.01)'
    },
    background: (el, s)=>{
        const st = s.status;
        if (st === 'occupied') return 'blue.15';
        if (st === 'cleaning') return 'amber.15';
        if (st === 'maintenance') return 'red.15';
        return 'teal.15';
    },
    borderLeft: (el, s)=>{
        const st = s.status;
        if (st === 'occupied') return '3px solid blue';
        if (st === 'cleaning') return '3px solid amber';
        if (st === 'maintenance') return '3px solid red';
        return '3px solid teal';
    },
    onClick: (e, el, s)=>{
        s.root.update({
            selectedSlot: {
                cabinet: s.cabinetName || '',
                time: s.time || '',
                status: s.status || 'available',
                doctor: s.doctor || '',
                patient: s.patient || '',
                procedure: s.procedure || ''
            }
        });
    },
    TimeLabel: {
        text: (el, s)=>s.time || '',
        fontSize: 'Y',
        fontWeight: '700',
        color: 'inkText'
    },
    DoctorName: {
        text: (el, s)=>s.doctor || '',
        fontSize: 'Y',
        color: 'inkMuted',
        fontStyle: 'italic',
        show: (el, s)=>s.status === 'occupied'
    },
    PatientName: {
        text: (el, s)=>s.patient || '',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'inkText',
        show: (el, s)=>s.status === 'occupied'
    },
    ProcedureType: {
        text: (el, s)=>s.procedure || '',
        fontSize: 'Y',
        color: 'inkMuted',
        show: (el, s)=>s.status === 'occupied'
    },
    StatusLabel: {
        fontSize: 'Y',
        fontWeight: '600',
        show: (el, s)=>s.status !== 'occupied',
        text: (el, s)=>{
            const st = s.status;
            if (st === 'cleaning') return '{{ cleaning | polyglot }}';
            if (st === 'maintenance') return '{{ maintenance | polyglot }}';
            return '{{ available | polyglot }}';
        },
        color: (el, s)=>{
            const st = s.status;
            if (st === 'cleaning') return 'amber';
            if (st === 'maintenance') return 'red';
            return 'teal';
        }
    }
};


var $f0c1d9a3046ca680$exports = {};

$parcel$export($f0c1d9a3046ca680$exports, "CabinetColumn", () => $f0c1d9a3046ca680$export$dedb0f1fc57038fa);
const $f0c1d9a3046ca680$export$dedb0f1fc57038fa = {
    flow: 'y',
    minWidth: '220px',
    width: '220px',
    background: 'inkMid',
    round: 'A',
    border: '1px solid inkBorder',
    overflow: 'hidden',
    flexShrink: '0',
    Header: {
        flow: 'y',
        gap: 'Y',
        padding: 'A',
        align: 'center center',
        background: 'inkMid',
        borderBottom: '1px solid inkBorder',
        CabinetName: {
            text: (el, s)=>s.cabinetName || 'Cabinet 1',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        StatusBadge: {
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'C',
            text: (el, s)=>{
                const st = s.cabinetStatus;
                if (st === 'in-use') return '{{ inUse | polyglot }}';
                if (st === 'cleaning') return '{{ cleaning | polyglot }}';
                if (st === 'maintenance') return '{{ maintenance | polyglot }}';
                return '{{ available | polyglot }}';
            },
            background: (el, s)=>{
                const st = s.cabinetStatus;
                if (st === 'in-use') return 'blue.15';
                if (st === 'cleaning') return 'amber.15';
                if (st === 'maintenance') return 'red.15';
                return 'teal.15';
            },
            color: (el, s)=>{
                const st = s.cabinetStatus;
                if (st === 'in-use') return 'blue';
                if (st === 'cleaning') return 'amber';
                if (st === 'maintenance') return 'red';
                return 'teal';
            }
        }
    },
    Slots: {
        flow: 'y',
        gap: 'Y',
        padding: 'Z',
        overflow: 'auto',
        flex: '1',
        childExtends: 'CabinetSlot'
    }
};


var $6a1e07e9c45b6877$exports = {};

$parcel$export($6a1e07e9c45b6877$exports, "DoctorRating", () => $6a1e07e9c45b6877$export$631b6aa356096ef8);
const $6a1e07e9c45b6877$export$631b6aa356096ef8 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    width: '100%',
    isCompact: (el, s)=>s.compact === true,
    '.isCompact': {
        padding: '0',
        background: 'transparent',
        border: 'none',
        gap: 'Y'
    },
    TopRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-start',
        StarDisplay: {
            flow: 'x',
            gap: 'W',
            children: (el, s)=>{
                const rating = s.rating || 0;
                return Array.from({
                    length: 5
                }, (_, i)=>({
                        filled: i < Math.round(rating),
                        index: i
                    }));
            },
            childrenAs: 'state',
            childProps: {
                extends: 'Icon',
                icon: 'star',
                width: 'A',
                height: 'A',
                color: (el, s)=>s.filled ? 'teal' : 'inkBorder'
            }
        },
        AvgRating: {
            text: (el, s)=>String(s.rating || '0.0'),
            fontSize: 'B',
            fontWeight: '700',
            color: 'inkText'
        },
        TotalReviews: {
            text: (el, s)=>'(' + (s.totalReviews || 0) + ' {{ reviews | polyglot }})',
            fontSize: 'Z',
            color: 'inkMuted',
            alignSelf: 'center'
        }
    },
    '.isCompact > TopRow': {
        AvgRating: {
            fontSize: 'Z'
        },
        StarDisplay: {
            childProps: {
                width: 'Z',
                height: 'Z'
            }
        }
    },
    Categories: {
        flow: 'y',
        gap: 'Y',
        marginTop: 'Y',
        show: (el, s)=>!s.compact,
        ProfRow: {
            flow: 'x',
            gap: 'Z',
            align: 'center flex-start',
            CatLabel: {
                text: '{{ professionalism | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                width: 'F',
                flexShrink: '0'
            },
            CatStars: {
                flow: 'x',
                gap: 'W',
                children: (el, s)=>{
                    const val = s.categories && s.categories.professionalism || 0;
                    return Array.from({
                        length: 5
                    }, (_, i)=>({
                            filled: i < Math.round(val)
                        }));
                },
                childrenAs: 'state',
                childProps: {
                    extends: 'Icon',
                    icon: 'star',
                    width: 'Y',
                    height: 'Y',
                    color: (el, s)=>s.filled ? 'teal' : 'inkBorder'
                }
            },
            CatVal: {
                text: (el, s)=>String(s.categories && s.categories.professionalism || '0'),
                fontSize: 'Y',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        PainRow: {
            flow: 'x',
            gap: 'Z',
            align: 'center flex-start',
            CatLabel: {
                text: '{{ painManagement | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                width: 'F',
                flexShrink: '0'
            },
            CatStars: {
                flow: 'x',
                gap: 'W',
                children: (el, s)=>{
                    const val = s.categories && s.categories.painManagement || 0;
                    return Array.from({
                        length: 5
                    }, (_, i)=>({
                            filled: i < Math.round(val)
                        }));
                },
                childrenAs: 'state',
                childProps: {
                    extends: 'Icon',
                    icon: 'star',
                    width: 'Y',
                    height: 'Y',
                    color: (el, s)=>s.filled ? 'teal' : 'inkBorder'
                }
            },
            CatVal: {
                text: (el, s)=>String(s.categories && s.categories.painManagement || '0'),
                fontSize: 'Y',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        ExplRow: {
            flow: 'x',
            gap: 'Z',
            align: 'center flex-start',
            CatLabel: {
                text: '{{ explanationQuality | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                width: 'F',
                flexShrink: '0'
            },
            CatStars: {
                flow: 'x',
                gap: 'W',
                children: (el, s)=>{
                    const val = s.categories && s.categories.explanationQuality || 0;
                    return Array.from({
                        length: 5
                    }, (_, i)=>({
                            filled: i < Math.round(val)
                        }));
                },
                childrenAs: 'state',
                childProps: {
                    extends: 'Icon',
                    icon: 'star',
                    width: 'Y',
                    height: 'Y',
                    color: (el, s)=>s.filled ? 'teal' : 'inkBorder'
                }
            },
            CatVal: {
                text: (el, s)=>String(s.categories && s.categories.explanationQuality || '0'),
                fontSize: 'Y',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        PunctRow: {
            flow: 'x',
            gap: 'Z',
            align: 'center flex-start',
            CatLabel: {
                text: '{{ punctuality | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                width: 'F',
                flexShrink: '0'
            },
            CatStars: {
                flow: 'x',
                gap: 'W',
                children: (el, s)=>{
                    const val = s.categories && s.categories.punctuality || 0;
                    return Array.from({
                        length: 5
                    }, (_, i)=>({
                            filled: i < Math.round(val)
                        }));
                },
                childrenAs: 'state',
                childProps: {
                    extends: 'Icon',
                    icon: 'star',
                    width: 'Y',
                    height: 'Y',
                    color: (el, s)=>s.filled ? 'teal' : 'inkBorder'
                }
            },
            CatVal: {
                text: (el, s)=>String(s.categories && s.categories.punctuality || '0'),
                fontSize: 'Y',
                fontWeight: '600',
                color: 'inkText'
            }
        }
    }
};


var $b2ce94b93f6f9779$exports = {};

$parcel$export($b2ce94b93f6f9779$exports, "ReviewCard", () => $b2ce94b93f6f9779$export$82cac57774882155);
const $b2ce94b93f6f9779$export$82cac57774882155 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    width: '100%',
    transition: 'all 0.2s ease',
    ReviewHeader: {
        flow: 'x',
        align: 'center space-between',
        AuthorInfo: {
            flow: 'x',
            gap: 'Z',
            align: 'center flex-start',
            Avatar: {
                width: 'C',
                height: 'C',
                round: 'C',
                background: 'teal.15',
                flow: 'x',
                align: 'center center',
                flexShrink: '0',
                Initial: {
                    text: (el, s)=>{
                        const name = s.anonymous ? '?' : s.patientName || '?';
                        return name.charAt(0).toUpperCase();
                    },
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: 'teal'
                }
            },
            NameDate: {
                flow: 'y',
                gap: 'W',
                AuthorName: {
                    text: (el, s)=>s.anonymous ? '{{ anonymousPatient | polyglot }}' : s.patientName || '{{ anonymousPatient | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'inkText'
                },
                ReviewDate: {
                    text: (el, s)=>s.date || '',
                    fontSize: 'Y',
                    color: 'inkMuted'
                }
            }
        },
        StarDisplay: {
            flow: 'x',
            gap: 'W',
            children: (el, s)=>{
                const rating = s.rating || 0;
                return Array.from({
                    length: 5
                }, (_, i)=>({
                        filled: i < Math.round(rating)
                    }));
            },
            childrenAs: 'state',
            childProps: {
                extends: 'Icon',
                icon: 'star',
                width: 'Z',
                height: 'Z',
                color: (el, s)=>s.filled ? 'teal' : 'inkBorder'
            }
        }
    },
    ReviewText: {
        text: (el, s)=>s.text || '',
        fontSize: 'Z',
        color: 'inkSubtle',
        lineHeight: '1.7'
    },
    CategoryBadges: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        show: (el, s)=>s.categories && Object.keys(s.categories).length > 0,
        children: (el, s)=>{
            if (!s.categories) return [];
            const labels = {
                professionalism: 'Professionalism',
                painManagement: 'Pain Mgmt',
                explanationQuality: 'Explanation',
                punctuality: 'Punctuality'
            };
            return Object.entries(s.categories).map(([key, val])=>({
                    label: labels[key] || key,
                    value: val
                }));
        },
        childrenAs: 'state',
        childProps: {
            flow: 'x',
            gap: 'W',
            align: 'center center',
            padding: 'W Y',
            round: 'C',
            background: 'inkSurface',
            BadgeLabel: {
                text: (el, s)=>s.label,
                fontSize: 'Y',
                color: 'inkSubtle'
            },
            BadgeStar: {
                extends: 'Icon',
                icon: 'star',
                width: 'Y',
                height: 'Y',
                color: 'teal'
            },
            BadgeVal: {
                text: (el, s)=>String(s.value),
                fontSize: 'Y',
                fontWeight: '600',
                color: 'inkText'
            }
        }
    },
    DoctorResponse: {
        flow: 'y',
        gap: 'Y',
        padding: 'Z A',
        marginTop: 'Y',
        borderLeft: '2px solid teal',
        background: 'teal.05',
        round: '0 Y Y 0',
        show: (el, s)=>!!s.doctorResponse,
        ResponseLabel: {
            flow: 'x',
            gap: 'Y',
            align: 'center flex-start',
            DocIcon: {
                extends: 'Icon',
                icon: 'user',
                width: 'Y',
                height: 'Y',
                color: 'teal'
            },
            DocLabel: {
                text: '{{ doctorResponse | polyglot }}',
                fontSize: 'Y',
                fontWeight: '600',
                color: 'teal'
            }
        },
        ResponseText: {
            text: (el, s)=>s.doctorResponse || '',
            fontSize: 'Z',
            color: 'inkSubtle',
            lineHeight: '1.6'
        }
    },
    VoteRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-start',
        marginTop: 'Y',
        HelpfulLabel: {
            text: '{{ helpfulQuestion | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        HelpfulBtn: {
            flow: 'x',
            gap: 'W',
            align: 'center center',
            padding: 'W Y',
            round: 'Y',
            cursor: 'pointer',
            background: 'transparent',
            border: '1px solid inkBorder',
            transition: 'all 0.15s ease',
            ':hover': {
                background: 'teal.1',
                borderColor: 'teal'
            },
            onClick: (e, el, s)=>{
                const current = s.helpfulCount || 0;
                s.update({
                    helpfulCount: current + 1
                });
            },
            ThumbUp: {
                extends: 'Icon',
                icon: 'thumbsUp',
                width: 'Y',
                height: 'Y',
                color: 'inkMuted'
            },
            HelpfulCount: {
                text: (el, s)=>String(s.helpfulCount || 0),
                fontSize: 'Y',
                color: 'inkMuted'
            }
        },
        NotHelpfulBtn: {
            flow: 'x',
            gap: 'W',
            align: 'center center',
            padding: 'W Y',
            round: 'Y',
            cursor: 'pointer',
            background: 'transparent',
            border: '1px solid inkBorder',
            transition: 'all 0.15s ease',
            ':hover': {
                background: 'crimson.1',
                borderColor: 'crimson'
            },
            onClick: (e, el, s)=>{
                const current = s.notHelpfulCount || 0;
                s.update({
                    notHelpfulCount: current + 1
                });
            },
            ThumbDown: {
                extends: 'Icon',
                icon: 'thumbsDown',
                width: 'Y',
                height: 'Y',
                color: 'inkMuted'
            },
            NotHelpfulCount: {
                text: (el, s)=>String(s.notHelpfulCount || 0),
                fontSize: 'Y',
                color: 'inkMuted'
            }
        }
    }
};


var $8756016566b3dfa4$exports = {};

$parcel$export($8756016566b3dfa4$exports, "ReviewList", () => $8756016566b3dfa4$export$4c3f144ef44053eb);
const $8756016566b3dfa4$export$4c3f144ef44053eb = {
    flow: 'y',
    gap: 'A',
    width: '100%',
    state: {
        reviewFilter: 'recent',
        reviews: [
            {
                patientName: 'Nino M.',
                date: 'Mar 12, 2026',
                rating: 5,
                text: 'Absolutely wonderful experience. Dr. Kvaratskhelia explained every step of my root canal procedure clearly and made sure I was comfortable throughout. Highly recommend!',
                categories: {
                    professionalism: 5,
                    painManagement: 5,
                    explanationQuality: 5,
                    punctuality: 4
                },
                doctorResponse: 'Thank you, Nino! We always strive to make every patient feel at ease. Looking forward to your next check-up.',
                helpfulCount: 12,
                notHelpfulCount: 1
            },
            {
                patientName: 'Giorgi T.',
                date: 'Mar 5, 2026',
                rating: 4,
                text: 'Great clinic with modern equipment. Wait time was a bit longer than expected but the treatment quality was excellent. The staff was very professional and friendly.',
                categories: {
                    professionalism: 5,
                    painManagement: 4,
                    explanationQuality: 4,
                    punctuality: 3
                },
                helpfulCount: 8,
                notHelpfulCount: 0
            },
            {
                anonymous: true,
                date: 'Feb 28, 2026',
                rating: 5,
                text: 'Best dental experience I have ever had. The pain management during my wisdom tooth extraction was incredible - I barely felt anything. Will definitely come back.',
                categories: {
                    professionalism: 5,
                    painManagement: 5,
                    explanationQuality: 4,
                    punctuality: 5
                },
                helpfulCount: 15,
                notHelpfulCount: 2
            },
            {
                patientName: 'Mariam K.',
                date: 'Feb 20, 2026',
                rating: 3,
                text: 'Decent service overall. The cleaning was thorough but the appointment started 20 minutes late. Communication about delays could be improved.',
                categories: {
                    professionalism: 4,
                    painManagement: 3,
                    explanationQuality: 3,
                    punctuality: 2
                },
                doctorResponse: 'We apologize for the delay, Mariam. We are working on improving our scheduling to minimize wait times.',
                helpfulCount: 6,
                notHelpfulCount: 3
            },
            {
                patientName: 'Luka B.',
                date: 'Feb 10, 2026',
                rating: 5,
                text: 'Outstanding professionalism. Dr. Datunashvili took extra time to explain my treatment options and helped me choose the best plan for my budget. Five stars all around.',
                categories: {
                    professionalism: 5,
                    painManagement: 5,
                    explanationQuality: 5,
                    punctuality: 5
                },
                helpfulCount: 20,
                notHelpfulCount: 0
            }
        ]
    },
    FilterBar: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        marginBottom: 'Y',
        FilterLabel: {
            text: '{{ sortBy | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            marginRight: 'Y'
        },
        RecentPill: {
            text: '{{ recent | polyglot }}',
            fontSize: 'Y',
            fontWeight: '500',
            padding: 'W Z',
            round: 'C',
            cursor: 'pointer',
            transition: 'all 0.15s ease',
            background: (el, s)=>s.root.reviewFilter === 'recent' ? 'teal' : 'inkSurface',
            color: (el, s)=>s.root.reviewFilter === 'recent' ? 'ink' : 'inkSubtle',
            onClick: (e, el, s)=>s.root.update({
                    reviewFilter: 'recent'
                })
        },
        HighestPill: {
            text: '{{ highest | polyglot }}',
            fontSize: 'Y',
            fontWeight: '500',
            padding: 'W Z',
            round: 'C',
            cursor: 'pointer',
            transition: 'all 0.15s ease',
            background: (el, s)=>s.root.reviewFilter === 'highest' ? 'teal' : 'inkSurface',
            color: (el, s)=>s.root.reviewFilter === 'highest' ? 'ink' : 'inkSubtle',
            onClick: (e, el, s)=>s.root.update({
                    reviewFilter: 'highest'
                })
        },
        LowestPill: {
            text: '{{ lowest | polyglot }}',
            fontSize: 'Y',
            fontWeight: '500',
            padding: 'W Z',
            round: 'C',
            cursor: 'pointer',
            transition: 'all 0.15s ease',
            background: (el, s)=>s.root.reviewFilter === 'lowest' ? 'teal' : 'inkSurface',
            color: (el, s)=>s.root.reviewFilter === 'lowest' ? 'ink' : 'inkSubtle',
            onClick: (e, el, s)=>s.root.update({
                    reviewFilter: 'lowest'
                })
        }
    },
    ReviewItems: {
        flow: 'y',
        gap: 'Z',
        width: '100%',
        childExtends: 'ReviewCard',
        childrenAs: 'state',
        children: (el, s)=>{
            const reviews = [
                ...s.reviews || []
            ];
            const filter = s.root.reviewFilter || 'recent';
            if (filter === 'highest') reviews.sort((a, b)=>b.rating - a.rating);
            else if (filter === 'lowest') reviews.sort((a, b)=>a.rating - b.rating);
            return reviews;
        }
    }
};


var $16cde78b62cd4b1d$exports = {};

$parcel$export($16cde78b62cd4b1d$exports, "GoogleRatingBadge", () => $16cde78b62cd4b1d$export$6c7ba364e25bf37d);
const $16cde78b62cd4b1d$export$6c7ba364e25bf37d = {
    flow: 'x',
    gap: 'Z',
    align: 'center center',
    padding: 'Y Z',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    width: 'fit-content',
    GoogleIcon: {
        tag: 'img',
        width: 'A',
        height: 'A',
        flexShrink: '0',
        attr: {
            src: 'https://www.google.com/favicon.ico',
            alt: 'Google'
        }
    },
    RatingInfo: {
        flow: 'x',
        gap: 'W',
        align: 'center center',
        StarIcon: {
            extends: 'Icon',
            icon: 'star',
            width: 'Z',
            height: 'Z',
            color: 'amber'
        },
        RatingVal: {
            text: (el, s)=>String(s.googleRating || '4.8'),
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        ReviewCount: {
            text: (el, s)=>'(' + (s.googleReviews || 0) + ')',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    ViewLink: {
        extends: 'Link',
        text: '{{ viewOnGoogle | polyglot }}',
        href: (el, s)=>s.googleUrl || '#',
        attr: {
            target: '_blank',
            rel: 'noopener noreferrer'
        },
        fontSize: 'Y',
        fontWeight: '500',
        color: 'teal',
        textDecoration: 'none',
        marginLeft: 'Y',
        ':hover': {
            textDecoration: 'underline'
        }
    }
};


var $0ff2da8668a518b7$exports = {};

$parcel$export($0ff2da8668a518b7$exports, "ChartLegend", () => $0ff2da8668a518b7$export$420ac06db41dd9da);
const $0ff2da8668a518b7$export$420ac06db41dd9da = {
    flow: 'y',
    gap: 'Y',
    padding: 'Z A',
    background: 'inkMid',
    round: 'Y',
    border: '1px solid inkBorder',
    LegendToggle: {
        flow: 'x',
        align: 'center space-between',
        cursor: 'pointer',
        onClick: (el, s)=>{
            s.root.update({
                legendOpen: !s.root.legendOpen
            });
        },
        LegendTitle: {
            text: '{{ chartLegend | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        ToggleIcon: {
            extends: 'Icon',
            icon: (el, s)=>s.root.legendOpen ? 'chevronUp' : 'chevronDown',
            fontSize: 'Z',
            color: 'inkMuted'
        }
    },
    LegendItems: {
        show: (el, s)=>s.root.legendOpen !== false,
        flow: 'x',
        gap: 'Z',
        flexWrap: 'wrap',
        paddingTop: 'Y',
        Healthy: {
            flow: 'x',
            gap: 'X',
            align: 'center flex-start',
            Swatch: {
                width: 'Y',
                height: 'Y',
                round: 'C',
                background: 'toothHealthy',
                border: '1px solid inkBorder'
            },
            Label: {
                tag: 'span',
                text: '{{ healthy | polyglot }}',
                fontSize: 'Y',
                color: 'inkText',
                fontWeight: '500'
            }
        },
        Caries: {
            flow: 'x',
            gap: 'X',
            align: 'center flex-start',
            Swatch: {
                width: 'Y',
                height: 'Y',
                round: 'C',
                background: 'toothCaries',
                border: '1px solid inkBorder'
            },
            Label: {
                tag: 'span',
                text: '{{ caries | polyglot }}',
                fontSize: 'Y',
                color: 'inkText',
                fontWeight: '500'
            }
        },
        Restored: {
            flow: 'x',
            gap: 'X',
            align: 'center flex-start',
            Swatch: {
                width: 'Y',
                height: 'Y',
                round: 'C',
                background: 'toothRestored',
                border: '1px solid inkBorder'
            },
            Label: {
                tag: 'span',
                text: '{{ restored | polyglot }}',
                fontSize: 'Y',
                color: 'inkText',
                fontWeight: '500'
            }
        },
        Crown: {
            flow: 'x',
            gap: 'X',
            align: 'center flex-start',
            Swatch: {
                width: 'Y',
                height: 'Y',
                round: 'C',
                background: 'toothCrown',
                border: '1px solid inkBorder'
            },
            Label: {
                tag: 'span',
                text: '{{ crownStatus | polyglot }}',
                fontSize: 'Y',
                color: 'inkText',
                fontWeight: '500'
            }
        },
        Implant: {
            flow: 'x',
            gap: 'X',
            align: 'center flex-start',
            Swatch: {
                width: 'Y',
                height: 'Y',
                round: 'C',
                background: 'toothImplant',
                border: '1px solid inkBorder'
            },
            Label: {
                tag: 'span',
                text: '{{ implant | polyglot }}',
                fontSize: 'Y',
                color: 'inkText',
                fontWeight: '500'
            }
        },
        Braces: {
            flow: 'x',
            gap: 'X',
            align: 'center flex-start',
            Swatch: {
                width: 'Y',
                height: 'Y',
                round: 'C',
                background: 'toothBraces',
                border: '1px solid inkBorder'
            },
            Label: {
                tag: 'span',
                text: '{{ braces | polyglot }}',
                fontSize: 'Y',
                color: 'inkText',
                fontWeight: '500'
            }
        },
        Missing: {
            flow: 'x',
            gap: 'X',
            align: 'center flex-start',
            Swatch: {
                width: 'Y',
                height: 'Y',
                round: 'C',
                background: 'toothMissing',
                border: '1px solid inkBorder'
            },
            Label: {
                tag: 'span',
                text: '{{ missing | polyglot }}',
                fontSize: 'Y',
                color: 'inkText',
                fontWeight: '500'
            }
        },
        Bridge: {
            flow: 'x',
            gap: 'X',
            align: 'center flex-start',
            Swatch: {
                width: 'Y',
                height: 'Y',
                round: 'C',
                background: 'toothBridge',
                border: '1px dashed blue'
            },
            Label: {
                tag: 'span',
                text: '{{ bridge | polyglot }}',
                fontSize: 'Y',
                color: 'inkText',
                fontWeight: '500'
            }
        }
    }
};


var $b53ec3462f5b7099$exports = {};

$parcel$export($b53ec3462f5b7099$exports, "InvoiceCard", () => $b53ec3462f5b7099$export$3ec0e7e2a513ed02);
$parcel$export($b53ec3462f5b7099$exports, "InvoiceProcedureItem", () => $b53ec3462f5b7099$export$c9f6724c595063e5);
const $b53ec3462f5b7099$export$3ec0e7e2a513ed02 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    HeaderRow: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        InvoiceNumber: {
            text: (el, s)=>s.invoiceNumber || '',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        InvoiceStatus: {
            tag: 'span',
            text: (el, s)=>s.invoiceStatus || '',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const st = s.invoiceStatus;
                if (st === 'Draft') return 'inkSurface';
                if (st === 'Sent') return 'blue.15';
                if (st === 'Paid') return 'green.15';
                if (st === 'Overdue') return 'red.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const st = s.invoiceStatus;
                if (st === 'Draft') return 'inkMuted';
                if (st === 'Sent') return 'blue';
                if (st === 'Paid') return 'green';
                if (st === 'Overdue') return 'red';
                return 'inkMuted';
            }
        }
    },
    PatientName: {
        text: (el, s)=>s.patientName || '',
        fontSize: 'Z',
        color: 'inkText',
        fontWeight: '600'
    },
    InvoiceDate: {
        text: (el, s)=>s.invoiceDate ? `{{ date | polyglot }}: ${s.invoiceDate}` : '',
        fontSize: 'Y',
        color: 'inkMuted'
    },
    Divider: {
        height: '1px',
        background: 'inkBorder'
    },
    ProcedureList: {
        flow: 'y',
        gap: 'Y',
        ProcedureListLabel: {
            text: '{{ procedures | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X',
            marginBottom: 'X'
        },
        Items: {
            flow: 'y',
            gap: 'X',
            children: (el, s)=>(s.procedures || []).map((proc)=>({
                        name: proc.name,
                        cost: proc.cost
                    })),
            childrenAs: 'state',
            childExtends: 'InvoiceProcedureItem'
        }
    },
    Divider2: {
        height: '1px',
        background: 'inkBorder'
    },
    TotalRow: {
        flow: 'x',
        justifyContent: 'space-between',
        align: 'center flex-start',
        Label: {
            text: '{{ total | polyglot }}',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        Value: {
            text: (el, s)=>s.totalAmount || '',
            fontSize: 'A',
            fontWeight: '800',
            color: 'inkText'
        }
    },
    ActionsRow: {
        flow: 'x',
        gap: 'Y',
        marginTop: 'Y',
        SendBtn: {
            tag: 'button',
            text: '{{ send | polyglot }}',
            padding: 'Y Z',
            round: 'A',
            background: 'teal',
            color: 'ink',
            fontSize: 'Y',
            fontWeight: '600',
            cursor: 'pointer',
            border: 'none'
        },
        PrintBtn: {
            tag: 'button',
            text: '{{ print | polyglot }}',
            padding: 'Y Z',
            round: 'A',
            background: 'inkSurface',
            color: 'inkMuted',
            fontSize: 'Y',
            fontWeight: '600',
            cursor: 'pointer',
            border: 'none'
        },
        DownloadBtn: {
            tag: 'button',
            text: '{{ download | polyglot }}',
            padding: 'Y Z',
            round: 'A',
            background: 'inkSurface',
            color: 'inkMuted',
            fontSize: 'Y',
            fontWeight: '600',
            cursor: 'pointer',
            border: 'none'
        }
    }
};
const $b53ec3462f5b7099$export$c9f6724c595063e5 = {
    flow: 'x',
    justifyContent: 'space-between',
    align: 'center flex-start',
    padding: 'Y 0',
    ProcName: {
        text: (el, s)=>s.name || '',
        fontSize: 'Y',
        color: 'inkText'
    },
    ProcCost: {
        text: (el, s)=>s.cost || '',
        fontSize: 'Y',
        fontWeight: '600',
        color: 'inkText'
    }
};


var $2321bdb3b882440b$exports = {};

$parcel$export($2321bdb3b882440b$exports, "PaymentModal", () => $2321bdb3b882440b$export$3ff09aa788237818);
const $2321bdb3b882440b$export$3ff09aa788237818 = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    background: 'rgba(0, 0, 0, 0.65)',
    display: 'flex',
    align: 'center center',
    zIndex: '1000',
    ModalContent: {
        flow: 'y',
        gap: 'A',
        padding: 'C',
        round: 'A',
        background: 'inkMid',
        border: '1px solid inkBorder',
        width: '480px',
        maxWidth: '90vw',
        maxHeight: '85vh',
        overflow: 'auto',
        ModalHeader: {
            flow: 'x',
            justifyContent: 'space-between',
            align: 'center flex-start',
            Title: {
                text: '{{ processPayment | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'inkText'
            },
            CloseBtn: {
                tag: 'button',
                text: '\u2715',
                fontSize: 'A',
                background: 'none',
                border: 'none',
                color: 'inkMuted',
                cursor: 'pointer',
                onClick: (e, el, s)=>s.root.update({
                        paymentModalOpen: false
                    })
            }
        },
        AmountSection: {
            flow: 'y',
            gap: 'Y',
            AmountLabel: {
                text: '{{ totalDue | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            },
            AmountValue: {
                text: (el, s)=>s.root.paymentAmount || '\u20BE0',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText'
            },
            PartialPaymentRow: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                PartialLabel: {
                    text: '{{ customAmount | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted',
                    whiteSpace: 'nowrap'
                },
                PartialInput: {
                    tag: 'input',
                    type: 'text',
                    placeholder: '{{ enterAmount | polyglot }}',
                    padding: 'Y Z',
                    round: 'Y',
                    background: 'inkSurface',
                    border: '1px solid inkBorder',
                    color: 'inkText',
                    fontSize: 'Z',
                    flex: '1',
                    outline: 'none',
                    onChange: (e, el, s)=>s.root.update({
                            paymentAmount: e.target.value
                        })
                }
            }
        },
        Divider: {
            height: '1px',
            background: 'inkBorder'
        },
        MethodSection: {
            flow: 'y',
            gap: 'Z',
            MethodLabel: {
                text: '{{ paymentMethod | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            },
            MethodOptions: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 'Y',
                CardOption: {
                    flow: 'y',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'Z',
                    round: 'Z',
                    cursor: 'pointer',
                    border: (el, s)=>s.root.paymentMethod === 'card' ? '2px solid teal' : '1px solid inkBorder',
                    background: (el, s)=>s.root.paymentMethod === 'card' ? 'teal.15' : 'inkSurface',
                    onClick: (e, el, s)=>s.root.update({
                            paymentMethod: 'card'
                        }),
                    Icon: {
                        text: '\uD83D\uDCB3',
                        fontSize: 'B'
                    },
                    Label: {
                        text: '{{ card | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText'
                    }
                },
                CashOption: {
                    flow: 'y',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'Z',
                    round: 'Z',
                    cursor: 'pointer',
                    border: (el, s)=>s.root.paymentMethod === 'cash' ? '2px solid teal' : '1px solid inkBorder',
                    background: (el, s)=>s.root.paymentMethod === 'cash' ? 'teal.15' : 'inkSurface',
                    onClick: (e, el, s)=>s.root.update({
                            paymentMethod: 'cash'
                        }),
                    Icon: {
                        text: '\uD83D\uDCB5',
                        fontSize: 'B'
                    },
                    Label: {
                        text: '{{ cash | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText'
                    }
                },
                BankOption: {
                    flow: 'y',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'Z',
                    round: 'Z',
                    cursor: 'pointer',
                    border: (el, s)=>s.root.paymentMethod === 'bank' ? '2px solid teal' : '1px solid inkBorder',
                    background: (el, s)=>s.root.paymentMethod === 'bank' ? 'teal.15' : 'inkSurface',
                    onClick: (e, el, s)=>s.root.update({
                            paymentMethod: 'bank'
                        }),
                    Icon: {
                        text: '\uD83C\uDFE6',
                        fontSize: 'B'
                    },
                    Label: {
                        text: '{{ bankTransfer | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText'
                    }
                },
                InstallmentOption: {
                    flow: 'y',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'Z',
                    round: 'Z',
                    cursor: 'pointer',
                    border: (el, s)=>s.root.paymentMethod === 'installment' ? '2px solid teal' : '1px solid inkBorder',
                    background: (el, s)=>s.root.paymentMethod === 'installment' ? 'teal.15' : 'inkSurface',
                    onClick: (e, el, s)=>s.root.update({
                            paymentMethod: 'installment'
                        }),
                    Icon: {
                        text: '\uD83D\uDCC5',
                        fontSize: 'B'
                    },
                    Label: {
                        text: '{{ installment | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText'
                    }
                }
            }
        },
        Divider2: {
            height: '1px',
            background: 'inkBorder'
        },
        BreakdownSection: {
            flow: 'y',
            gap: 'Y',
            BreakdownLabel: {
                text: '{{ breakdown | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            },
            SubtotalRow: {
                flow: 'x',
                justifyContent: 'space-between',
                Label: {
                    text: '{{ subtotal | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted'
                },
                Value: {
                    text: (el, s)=>s.root.paymentAmount || '\u20BE0',
                    fontSize: 'Y',
                    fontWeight: '600',
                    color: 'inkText'
                }
            },
            InsuranceRow: {
                flow: 'x',
                justifyContent: 'space-between',
                Label: {
                    text: '{{ insuranceCoverage | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted'
                },
                Value: {
                    text: '\u20BE0',
                    fontSize: 'Y',
                    fontWeight: '600',
                    color: 'green'
                }
            },
            PatientDueRow: {
                flow: 'x',
                justifyContent: 'space-between',
                Label: {
                    text: '{{ patientDue | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: 'inkText'
                },
                Value: {
                    text: (el, s)=>s.root.paymentAmount || '\u20BE0',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: 'inkText'
                }
            }
        },
        ProcessBtn: {
            tag: 'button',
            text: '{{ processPaymentBtn | polyglot }}',
            padding: 'Z A',
            round: 'A',
            background: 'teal',
            color: 'ink',
            fontSize: 'Z',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            textAlign: 'center',
            width: '100%',
            onClick: (e, el, s)=>s.root.update({
                    paymentModalOpen: false
                })
        },
        ReceiptPreview: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z',
            round: 'Y',
            background: 'inkSurface',
            border: '1px dashed inkBorder',
            ReceiptTitle: {
                text: '{{ receiptPreview | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600'
            },
            ReceiptLine1: {
                text: (el, s)=>`{{ method | polyglot }}: ${s.root.paymentMethod || "\u2014"}`,
                fontSize: 'Y',
                color: 'inkMuted'
            },
            ReceiptLine2: {
                text: (el, s)=>`{{ amount | polyglot }}: ${s.root.paymentAmount || '\u20BE0'}`,
                fontSize: 'Y',
                color: 'inkMuted'
            }
        }
    }
};


var $dd38944709a8bd41$exports = {};

$parcel$export($dd38944709a8bd41$exports, "ReceiptCard", () => $dd38944709a8bd41$export$d98889c0df000e71);
const $dd38944709a8bd41$export$d98889c0df000e71 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    HeaderRow: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        ReceiptNumber: {
            text: (el, s)=>s.receiptNumber || '',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        ReceiptDate: {
            text: (el, s)=>s.receiptDate || '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    PatientName: {
        text: (el, s)=>s.patientName || '',
        fontSize: 'Z',
        color: 'inkText',
        fontWeight: '600'
    },
    Divider: {
        height: '1px',
        background: 'inkBorder'
    },
    DetailsSection: {
        flow: 'y',
        gap: 'Y',
        AmountPaidRow: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ amountPaid | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.amountPaid || '',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'green'
            }
        },
        MethodRow: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ paymentMethod | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.method || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        RemainingRow: {
            flow: 'x',
            justifyContent: 'space-between',
            Label: {
                text: '{{ remainingBalance | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.remainingBalance || '\u20BE0',
                fontSize: 'Z',
                fontWeight: '700',
                color: (el, s)=>s.remainingBalance && s.remainingBalance !== '\u20BE0' ? 'amber' : 'green'
            }
        }
    },
    ActionsRow: {
        flow: 'x',
        gap: 'Y',
        marginTop: 'Y',
        PrintBtn: {
            tag: 'button',
            text: '{{ print | polyglot }}',
            padding: 'Y Z',
            round: 'A',
            background: 'inkSurface',
            color: 'inkMuted',
            fontSize: 'Y',
            fontWeight: '600',
            cursor: 'pointer',
            border: 'none'
        },
        DownloadBtn: {
            tag: 'button',
            text: '{{ download | polyglot }}',
            padding: 'Y Z',
            round: 'A',
            background: 'inkSurface',
            color: 'inkMuted',
            fontSize: 'Y',
            fontWeight: '600',
            cursor: 'pointer',
            border: 'none'
        }
    }
};


var $6d1678e34a15d7c7$exports = {};

$parcel$export($6d1678e34a15d7c7$exports, "InventoryCard", () => $6d1678e34a15d7c7$export$a7cbe62cdde8a19f);
const $6d1678e34a15d7c7$export$a7cbe62cdde8a19f = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    HeaderRow: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        MaterialName: {
            text: (el, s)=>s.name || '',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        CategoryBadge: {
            tag: 'span',
            text: (el, s)=>s.category || '',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const c = s.category;
                if (c === 'Restorative') return 'blue.15';
                if (c === 'Endodontic') return 'purple.15';
                if (c === 'Prosthetic') return 'teal.15';
                if (c === 'Surgical') return 'red.15';
                if (c === 'Hygiene') return 'green.15';
                if (c === 'Disposables') return 'amber.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const c = s.category;
                if (c === 'Restorative') return 'blue';
                if (c === 'Endodontic') return 'purple';
                if (c === 'Prosthetic') return 'teal';
                if (c === 'Surgical') return 'red';
                if (c === 'Hygiene') return 'green';
                if (c === 'Disposables') return 'amber';
                return 'inkMuted';
            }
        }
    },
    DetailsRow: {
        flow: 'x',
        gap: 'A',
        flexWrap: 'wrap',
        QtyInfo: {
            flow: 'y',
            gap: 'X',
            QtyLabel: {
                text: '{{ quantity | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            QtyValue: {
                text: (el, s)=>`${s.quantity || 0} ${s.unit || ''}`,
                fontSize: 'Z',
                fontWeight: '700',
                color: 'inkText'
            }
        },
        ReorderInfo: {
            flow: 'y',
            gap: 'X',
            ReorderLabel: {
                text: '{{ reorderLevel | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            ReorderValue: {
                text: (el, s)=>`${s.reorderLevel || 0} ${s.unit || ''}`,
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkMuted'
            }
        }
    },
    StockBar: {
        flow: 'y',
        gap: 'X',
        StockLabel: {
            flow: 'x',
            justifyContent: 'space-between',
            LevelText: {
                text: '{{ stockLevel | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Percent: {
                text: (el, s)=>{
                    const pct = s.maxCapacity ? Math.round(s.quantity / s.maxCapacity * 100) : 0;
                    return `${pct}%`;
                },
                fontSize: 'Y',
                fontWeight: '600',
                color: 'inkMuted'
            }
        },
        BarTrack: {
            height: '6px',
            round: 'C',
            background: 'inkSurface',
            overflow: 'hidden',
            BarFill: {
                height: '100%',
                round: 'C',
                width: (el, s)=>{
                    const pct = s.maxCapacity ? Math.min(100, Math.round(s.quantity / s.maxCapacity * 100)) : 0;
                    return `${pct}%`;
                },
                background: (el, s)=>{
                    const qty = s.quantity || 0;
                    const reorder = s.reorderLevel || 0;
                    if (qty <= reorder) return 'red';
                    if (qty <= reorder * 1.5) return 'amber';
                    return 'green';
                }
            }
        }
    },
    Divider: {
        height: '1px',
        background: 'inkBorder'
    },
    OrderBtn: {
        extends: 'Button',
        tag: 'button',
        text: '{{ orderNow | polyglot }}',
        background: 'teal',
        color: 'ink',
        fontWeight: '600',
        padding: 'Y A',
        round: 'A',
        fontSize: 'Y',
        cursor: 'pointer',
        border: 'none',
        alignSelf: 'flex-start'
    }
};


var $b8dbec74df9324a7$exports = {};

$parcel$export($b8dbec74df9324a7$exports, "SupplierCard", () => $b8dbec74df9324a7$export$4f421c068a9640b6);
const $b8dbec74df9324a7$export$4f421c068a9640b6 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    HeaderRow: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        SupplierName: {
            text: (el, s)=>s.name || '',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'inkText'
        },
        AvailabilityBadge: {
            tag: 'span',
            text: (el, s)=>s.deliveryAvailable ? '{{ available | polyglot }}' : '{{ unavailable | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>s.deliveryAvailable ? 'green.15' : 'red.15',
            color: (el, s)=>s.deliveryAvailable ? 'green' : 'red'
        }
    },
    ContactInfo: {
        flow: 'y',
        gap: 'X',
        ContactName: {
            text: (el, s)=>s.contact || '',
            fontSize: 'Z',
            color: 'inkText'
        },
        Phone: {
            text: (el, s)=>s.phone || '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    RatingRow: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        RatingLabel: {
            text: '{{ reliability | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        RatingStars: {
            flow: 'x',
            gap: 'X',
            text: (el, s)=>{
                const r = s.rating || 0;
                return '\u2605'.repeat(Math.round(r)) + '\u2606'.repeat(5 - Math.round(r));
            },
            fontSize: 'Z',
            color: 'amber'
        }
    },
    Divider: {
        height: '1px',
        background: 'inkBorder'
    },
    DeliveryRow: {
        flow: 'x',
        gap: 'A',
        flexWrap: 'wrap',
        EstDays: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ estDelivery | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.estimatedDays ? `${s.estimatedDays} {{ days | polyglot }}` : "\u2014",
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        },
        MinOrder: {
            flow: 'y',
            gap: 'X',
            Label: {
                text: '{{ minOrder | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Value: {
                text: (el, s)=>s.minimumOrder || "\u2014",
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            }
        }
    },
    PlaceOrderBtn: {
        extends: 'Button',
        tag: 'button',
        text: '{{ placeOrder | polyglot }}',
        background: 'teal',
        color: 'ink',
        fontWeight: '600',
        padding: 'Y A',
        round: 'A',
        fontSize: 'Y',
        cursor: 'pointer',
        border: 'none',
        alignSelf: 'flex-start'
    }
};


var $a5eb4635aeb1fa7e$exports = {};

$parcel$export($a5eb4635aeb1fa7e$exports, "MaterialUsageRow", () => $a5eb4635aeb1fa7e$export$211c38b97f1ea946);
const $a5eb4635aeb1fa7e$export$211c38b97f1ea946 = {
    flow: 'x',
    gap: 'Z',
    align: 'center flex-start',
    padding: 'Z B',
    round: 'Z',
    background: 'inkMid',
    border: '1px solid inkBorder',
    MaterialField: {
        flex: '2',
        flow: 'y',
        gap: 'X',
        Label: {
            text: '{{ material | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        Value: {
            text: (el, s)=>s.materialName || '',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        }
    },
    QtyField: {
        flex: '1',
        flow: 'y',
        gap: 'X',
        Label: {
            text: '{{ qtyUsed | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        Value: {
            text: (el, s)=>s.quantityUsed != null ? String(s.quantityUsed) : '',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        }
    },
    UnitField: {
        flex: '1',
        flow: 'y',
        gap: 'X',
        Label: {
            text: '{{ unit | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        Value: {
            text: (el, s)=>s.unit || '',
            fontSize: 'Z',
            color: 'inkMuted'
        }
    },
    RemoveBtn: {
        tag: 'button',
        text: '\u2715',
        fontSize: 'Z',
        color: 'red',
        background: 'red.15',
        border: 'none',
        round: 'Y',
        width: 'B',
        height: 'B',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center'
    }
};


var $b4b6cbbe956493f0$exports = {};

$parcel$export($b4b6cbbe956493f0$exports, "DocumentCard", () => $b4b6cbbe956493f0$export$6a639350e64e609c);
const $b4b6cbbe956493f0$export$6a639350e64e609c = {
    flow: 'y',
    gap: 'Y',
    padding: 'Z',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    cursor: 'pointer',
    transition: 'border 150ms ease, boxShadow 150ms ease',
    ':hover': {
        border: '1px solid inkSubtle',
        boxShadow: '0 2px 8px rgba(0,0,0,.12)'
    },
    width: '100%',
    on: {
        click: (e, el, s)=>{
            s.root.update({
                selectedDocument: {
                    id: s.id,
                    filename: s.filename,
                    type: s.docType,
                    date: s.date,
                    device: s.device,
                    tooth: s.tooth,
                    patient: s.patient
                }
            });
        }
    },
    Thumbnail: {
        width: '100%',
        height: 'F',
        round: 'Y',
        overflow: 'hidden',
        background: (el, s)=>{
            const t = s.docType || 'other';
            if (t === 'xray') return 'ink';
            if (t === 'ctScan') return 'blue.08';
            if (t === 'intraoral3d') return 'violet.08';
            if (t === 'photo') return 'teal.08';
            return 'inkSurface';
        },
        align: 'center center',
        display: 'flex',
        ThumbIcon: {
            extends: 'Icon',
            name: (el, s)=>{
                const t = s.docType || 'other';
                if (t === 'xray') return 'scan';
                if (t === 'ctScan') return 'layers';
                if (t === 'intraoral3d') return 'box';
                if (t === 'photo') return 'camera';
                return 'file';
            },
            fontSize: 'C',
            color: (el, s)=>{
                const t = s.docType || 'other';
                if (t === 'xray') return 'inkMuted';
                if (t === 'ctScan') return 'blue';
                if (t === 'intraoral3d') return 'violet';
                if (t === 'photo') return 'teal';
                return 'inkMuted';
            }
        }
    },
    InfoSection: {
        flow: 'y',
        gap: 'X',
        TopRow: {
            flow: 'x',
            align: 'center flex-start',
            justifyContent: 'space-between',
            TypeBadge: {
                tag: 'span',
                text: (el, s)=>{
                    const t = s.docType || 'other';
                    if (t === 'xray') return 'X-ray';
                    if (t === 'ctScan') return 'CT Scan';
                    if (t === 'intraoral3d') return '3D Scan';
                    if (t === 'photo') return 'Photo';
                    return 'Other';
                },
                fontSize: 'Y',
                fontWeight: '600',
                padding: 'X Y',
                round: 'B',
                background: (el, s)=>{
                    const t = s.docType || 'other';
                    if (t === 'xray') return 'amber.15';
                    if (t === 'ctScan') return 'blue.15';
                    if (t === 'intraoral3d') return 'violet.15';
                    if (t === 'photo') return 'teal.15';
                    return 'inkSurface';
                },
                color: (el, s)=>{
                    const t = s.docType || 'other';
                    if (t === 'xray') return 'amber';
                    if (t === 'ctScan') return 'blue';
                    if (t === 'intraoral3d') return 'violet';
                    if (t === 'photo') return 'teal';
                    return 'inkMuted';
                }
            },
            ToothLabel: {
                text: (el, s)=>s.tooth ? `#${s.tooth}` : '',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '500'
            }
        },
        Filename: {
            text: (el, s)=>s.filename || '',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        MetaRow: {
            flow: 'x',
            gap: 'Y',
            align: 'center flex-start',
            DateLabel: {
                text: (el, s)=>s.date || '',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            Separator: {
                text: '\u00b7',
                fontSize: 'Y',
                color: 'inkMuted'
            },
            DeviceLabel: {
                text: (el, s)=>s.device || '',
                fontSize: 'Y',
                color: 'inkMuted'
            }
        }
    }
};


var $c7198d146b7249b6$exports = {};

$parcel$export($c7198d146b7249b6$exports, "DeviceStatusBadge", () => $c7198d146b7249b6$export$708cd994ce75efb1);
const $c7198d146b7249b6$export$708cd994ce75efb1 = {
    flow: 'x',
    align: 'center center',
    gap: 'X',
    display: 'inline-flex',
    StatusDot: {
        width: '8px',
        height: '8px',
        round: 'D',
        flexShrink: '0',
        background: (el, s)=>{
            const st = s.deviceStatus || 'disconnected';
            if (st === 'connected') return 'teal';
            if (st === 'scanning') return 'amber';
            return 'inkMuted';
        },
        animation: (el, s)=>s.deviceStatus === 'scanning' ? 'pulse 1.5s ease-in-out infinite' : 'none'
    },
    StatusText: {
        text: (el, s)=>{
            const st = s.deviceStatus || 'disconnected';
            if (st === 'connected') return '{{ connected | polyglot }}';
            if (st === 'scanning') return '{{ scanning | polyglot }}';
            return '{{ disconnected | polyglot }}';
        },
        fontSize: 'Y',
        fontWeight: '500',
        color: (el, s)=>{
            const st = s.deviceStatus || 'disconnected';
            if (st === 'connected') return 'teal';
            if (st === 'scanning') return 'amber';
            return 'inkMuted';
        }
    }
};


var $ed600830d3ddf7b8$exports = {};

$parcel$export($ed600830d3ddf7b8$exports, "DeviceImportPanel", () => $ed600830d3ddf7b8$export$6177b7fc45f2812a);
$parcel$export($ed600830d3ddf7b8$exports, "DeviceImportRow", () => $ed600830d3ddf7b8$export$68dcaebed245da1b);
const $ed600830d3ddf7b8$export$6177b7fc45f2812a = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    PanelHeader: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        Title: {
            text: '{{ equipmentDevices | polyglot }}',
            fontSize: 'A',
            fontWeight: '700',
            color: 'inkText'
        },
        CollapseBtn: {
            extends: 'Button',
            text: (el, s)=>s.root.devicesCollapsed ? '{{ expand | polyglot }}' : '{{ collapse | polyglot }}',
            fontSize: 'Y',
            padding: 'X Z',
            round: 'Y',
            background: 'inkSurface',
            color: 'inkMuted',
            border: '1px solid inkBorder',
            cursor: 'pointer',
            on: {
                click: (e, el, s)=>s.root.update({
                        devicesCollapsed: !s.root.devicesCollapsed
                    })
            }
        }
    },
    DeviceList: {
        flow: 'y',
        gap: 'Y',
        display: (el, s)=>s.root.devicesCollapsed ? 'none' : 'flex',
        children: [
            {
                deviceName: 'Dexis Periapical Sensor',
                deviceType: 'Periapical X-ray',
                deviceStatus: 'connected',
                autoImport: true
            },
            {
                deviceName: 'Planmeca ProMax 3D',
                deviceType: 'Panoramic X-ray',
                deviceStatus: 'connected',
                autoImport: true
            },
            {
                deviceName: 'Carestream CS 8200 3D',
                deviceType: 'CBCT Scanner',
                deviceStatus: 'scanning',
                autoImport: false
            },
            {
                deviceName: 'iTero Element 5D',
                deviceType: 'Intraoral Scanner',
                deviceStatus: 'connected',
                autoImport: true
            },
            {
                deviceName: 'DEXIS IXS Cam',
                deviceType: 'Intraoral Camera',
                deviceStatus: 'disconnected',
                autoImport: false
            }
        ],
        childrenAs: 'state',
        childExtends: 'DeviceImportRow'
    }
};
const $ed600830d3ddf7b8$export$68dcaebed245da1b = {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    padding: 'Z',
    round: 'Y',
    background: 'inkSurface',
    border: '1px solid inkBorder',
    DeviceInfo: {
        flow: 'y',
        gap: 'W',
        flex: '1',
        DeviceName: {
            text: (el, s)=>s.deviceName || '',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        },
        DeviceType: {
            text: (el, s)=>s.deviceType || '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    Badge: {
        extends: 'DeviceStatusBadge'
    },
    AutoImportToggle: {
        flow: 'x',
        align: 'center center',
        gap: 'X',
        AutoLabel: {
            text: '{{ autoImport | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        },
        Toggle: {
            width: '32px',
            height: '18px',
            round: 'B',
            cursor: 'pointer',
            transition: 'background 150ms ease',
            background: (el, s)=>s.autoImport ? 'teal' : 'inkBorder',
            position: 'relative',
            Knob: {
                width: '14px',
                height: '14px',
                round: 'D',
                background: 'white',
                position: 'absolute',
                top: '2px',
                left: (el, s)=>s.autoImport ? '16px' : '2px',
                transition: 'left 150ms ease'
            },
            on: {
                click: (e, el, s)=>s.update({
                        autoImport: !s.autoImport
                    })
            }
        }
    },
    ImportBtn: {
        extends: 'Button',
        text: '{{ importLatest | polyglot }}',
        fontSize: 'Y',
        padding: 'X Z',
        round: 'Y',
        background: 'inkText',
        color: 'inkMid',
        fontWeight: '500',
        cursor: 'pointer',
        opacity: (el, s)=>s.deviceStatus === 'disconnected' ? '.4' : '1',
        pointerEvents: (el, s)=>s.deviceStatus === 'disconnected' ? 'none' : 'auto'
    }
};


var $90b9b022f7ba3147$exports = {};

$parcel$export($90b9b022f7ba3147$exports, "DocumentViewer", () => $90b9b022f7ba3147$export$c749023b2d124212);
const $90b9b022f7ba3147$export$c749023b2d124212 = {
    display: (el, s)=>s.root.selectedDocument ? 'flex' : 'none',
    flow: 'y',
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,.85)',
    zIndex: '1000',
    ViewerToolbar: {
        flow: 'x',
        align: 'center flex-start',
        justifyContent: 'space-between',
        padding: 'Z A',
        background: 'ink',
        borderBottom: '1px solid inkBorder',
        flexShrink: '0',
        LeftInfo: {
            flow: 'x',
            align: 'center flex-start',
            gap: 'Z',
            DocName: {
                text: (el, s)=>s.root.selectedDocument?.filename || '',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
            },
            DocType: {
                tag: 'span',
                text: (el, s)=>{
                    const t = s.root.selectedDocument?.type || '';
                    if (t === 'xray') return 'X-ray';
                    if (t === 'ctScan') return 'CT Scan';
                    if (t === 'intraoral3d') return '3D Scan';
                    if (t === 'photo') return 'Photo';
                    return t;
                },
                fontSize: 'Y',
                padding: 'X Y',
                round: 'B',
                background: 'inkSurface',
                color: 'inkMuted'
            }
        },
        CenterControls: {
            flow: 'x',
            align: 'center center',
            gap: 'Y',
            ZoomOutBtn: {
                extends: 'Button',
                text: '\u2212',
                fontSize: 'A',
                width: 'B',
                height: 'B',
                round: 'Y',
                background: 'inkSurface',
                color: 'inkText',
                cursor: 'pointer',
                border: '1px solid inkBorder',
                align: 'center center',
                display: 'flex'
            },
            ZoomLabel: {
                text: '100%',
                fontSize: 'Y',
                color: 'inkMuted',
                minWidth: 'B1',
                textAlign: 'center'
            },
            ZoomInBtn: {
                extends: 'Button',
                text: '+',
                fontSize: 'A',
                width: 'B',
                height: 'B',
                round: 'Y',
                background: 'inkSurface',
                color: 'inkText',
                cursor: 'pointer',
                border: '1px solid inkBorder',
                align: 'center center',
                display: 'flex'
            },
            Divider: {
                width: '1px',
                height: 'A',
                background: 'inkBorder'
            },
            BrightnessGroup: {
                flow: 'x',
                align: 'center center',
                gap: 'X',
                BrLabel: {
                    text: '{{ brightness | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted'
                },
                BrSlider: {
                    tag: 'input',
                    attr: {
                        type: 'range',
                        min: '0',
                        max: '200',
                        value: '100'
                    },
                    width: 'C1',
                    accentColor: 'teal'
                }
            },
            ContrastGroup: {
                flow: 'x',
                align: 'center center',
                gap: 'X',
                CoLabel: {
                    text: '{{ contrast | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted'
                },
                CoSlider: {
                    tag: 'input',
                    attr: {
                        type: 'range',
                        min: '0',
                        max: '200',
                        value: '100'
                    },
                    width: 'C1',
                    accentColor: 'teal'
                }
            },
            Divider2: {
                width: '1px',
                height: 'A',
                background: 'inkBorder'
            },
            AnnotateBtn: {
                extends: 'Button',
                text: '{{ annotate | polyglot }}',
                fontSize: 'Y',
                padding: 'X Z',
                round: 'Y',
                background: 'inkSurface',
                color: 'inkText',
                cursor: 'pointer',
                border: '1px solid inkBorder'
            },
            CompareBtn: {
                extends: 'Button',
                text: '{{ beforeAfter | polyglot }}',
                fontSize: 'Y',
                padding: 'X Z',
                round: 'Y',
                background: 'inkSurface',
                color: 'inkText',
                cursor: 'pointer',
                border: '1px solid inkBorder'
            }
        },
        CloseBtn: {
            extends: 'Button',
            text: '\u2715',
            fontSize: 'A',
            width: 'B',
            height: 'B',
            round: 'Y',
            background: 'inkSurface',
            color: 'inkText',
            cursor: 'pointer',
            border: '1px solid inkBorder',
            align: 'center center',
            display: 'flex',
            on: {
                click: (e, el, s)=>s.root.update({
                        selectedDocument: null
                    })
            }
        }
    },
    ViewerCanvas: {
        flex: '1',
        display: 'flex',
        align: 'center center',
        overflow: 'auto',
        PlaceholderArea: {
            width: 'H',
            height: 'G',
            maxWidth: '90%',
            maxHeight: '80vh',
            round: 'A',
            background: 'inkMid',
            border: '2px dashed inkBorder',
            display: 'flex',
            align: 'center center',
            flow: 'y',
            gap: 'Z',
            PlaceholderIcon: {
                extends: 'Icon',
                name: (el, s)=>{
                    const t = s.root.selectedDocument?.type || 'other';
                    if (t === 'xray') return 'scan';
                    if (t === 'ctScan') return 'layers';
                    if (t === 'intraoral3d') return 'box';
                    if (t === 'photo') return 'camera';
                    return 'file';
                },
                fontSize: 'E',
                color: 'inkMuted'
            },
            PlaceholderText: {
                text: (el, s)=>s.root.selectedDocument?.filename || '{{ documentPreview | polyglot }}',
                fontSize: 'A',
                color: 'inkMuted',
                textAlign: 'center'
            },
            PlaceholderMeta: {
                text: (el, s)=>{
                    const d = s.root.selectedDocument;
                    if (!d) return '';
                    const parts = [];
                    if (d.device) parts.push(d.device);
                    if (d.tooth) parts.push(`Tooth #${d.tooth}`);
                    if (d.date) parts.push(d.date);
                    return parts.join('  \u00b7  ');
                },
                fontSize: 'Z',
                color: 'inkMuted'
            }
        }
    }
};


var $e0bc1935b2d7715f$exports = {};

$parcel$export($e0bc1935b2d7715f$exports, "RadiologyReferralForm", () => $e0bc1935b2d7715f$export$1c2caa860ae8b576);
const $e0bc1935b2d7715f$export$1c2caa860ae8b576 = {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    FormTitle: {
        text: '{{ newRadiologyReferral | polyglot }}',
        fontSize: 'B',
        fontWeight: '700',
        color: 'inkText'
    },
    PatientField: {
        flow: 'y',
        gap: 'Y',
        Label: {
            text: '{{ patientName | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted'
        },
        Input: {
            tag: 'input',
            type: 'text',
            placeholder: 'Giorgi Beridze',
            padding: 'Z',
            round: 'Z',
            border: '1px solid inkBorder',
            background: 'inkSurface',
            color: 'inkText',
            fontSize: 'Z',
            outline: 'none',
            width: '100%',
            value: (el, s)=>s.root.newReferral && s.root.newReferral.patientName || '',
            onInput: (e, el, s)=>s.root.update({
                    newReferral: {
                        ...s.root.newReferral || {},
                        patientName: e.target.value
                    }
                })
        }
    },
    ImagingTypeField: {
        flow: 'y',
        gap: 'Y',
        Label: {
            text: '{{ imagingType | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted'
        },
        ImagingTypeSelector: {}
    },
    TargetAreaField: {
        flow: 'y',
        gap: 'Y',
        Label: {
            text: '{{ targetArea | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted'
        },
        Input: {
            tag: 'input',
            type: 'text',
            placeholder: '#14, #15 or Full Mouth',
            padding: 'Z',
            round: 'Z',
            border: '1px solid inkBorder',
            background: 'inkSurface',
            color: 'inkText',
            fontSize: 'Z',
            outline: 'none',
            width: '100%',
            value: (el, s)=>s.root.newReferral && s.root.newReferral.targetArea || '',
            onInput: (e, el, s)=>s.root.update({
                    newReferral: {
                        ...s.root.newReferral || {},
                        targetArea: e.target.value
                    }
                })
        }
    },
    ClinicalQuestionField: {
        flow: 'y',
        gap: 'Y',
        Label: {
            text: '{{ clinicalQuestion | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted'
        },
        TextArea: {
            tag: 'textarea',
            placeholder: 'What do you need to evaluate?',
            padding: 'Z',
            round: 'Z',
            border: '1px solid inkBorder',
            background: 'inkSurface',
            color: 'inkText',
            fontSize: 'Z',
            outline: 'none',
            width: '100%',
            minHeight: '80px',
            resize: 'vertical',
            fontFamily: 'inherit',
            value: (el, s)=>s.root.newReferral && s.root.newReferral.clinicalQuestion || '',
            onInput: (e, el, s)=>s.root.update({
                    newReferral: {
                        ...s.root.newReferral || {},
                        clinicalQuestion: e.target.value
                    }
                })
        }
    },
    UrgencyField: {
        flow: 'y',
        gap: 'Y',
        Label: {
            text: '{{ urgency | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted'
        },
        Options: {
            flow: 'x',
            gap: 'Z',
            NormalBtn: {
                tag: 'button',
                text: '{{ normal | polyglot }}',
                padding: 'Y A',
                round: 'Z',
                fontSize: 'Z',
                fontWeight: '600',
                cursor: 'pointer',
                border: 'none',
                background: (el, s)=>(s.root.newReferral && s.root.newReferral.urgency) === 'urgent' ? 'inkSurface' : 'teal',
                color: (el, s)=>(s.root.newReferral && s.root.newReferral.urgency) === 'urgent' ? 'inkMuted' : 'white',
                onClick: (e, el, s)=>s.root.update({
                        newReferral: {
                            ...s.root.newReferral || {},
                            urgency: 'normal'
                        }
                    })
            },
            UrgentBtn: {
                tag: 'button',
                text: '{{ urgent | polyglot }}',
                padding: 'Y A',
                round: 'Z',
                fontSize: 'Z',
                fontWeight: '600',
                cursor: 'pointer',
                border: 'none',
                background: (el, s)=>(s.root.newReferral && s.root.newReferral.urgency) === 'urgent' ? 'red' : 'inkSurface',
                color: (el, s)=>(s.root.newReferral && s.root.newReferral.urgency) === 'urgent' ? 'white' : 'inkMuted',
                onClick: (e, el, s)=>s.root.update({
                        newReferral: {
                            ...s.root.newReferral || {},
                            urgency: 'urgent'
                        }
                    })
            }
        }
    },
    SubmitBtn: {
        extends: 'Button',
        text: '{{ submitReferral | polyglot }}',
        fontSize: 'Z',
        padding: 'Z A',
        round: 'Z',
        background: 'teal',
        color: 'white',
        fontWeight: '700',
        cursor: 'pointer',
        alignSelf: 'flex-start',
        marginTop: 'Z',
        onClick: (e, el, s)=>{
            const ref = s.root.newReferral || {};
            const queue = s.root.radiologyQueue || [];
            queue.unshift({
                id: 'RAD-' + Date.now(),
                patientName: ref.patientName || 'Unknown',
                referringDoctor: 'Dr. Lomidze',
                imagingType: s.root.selectedImagingType || 'Periapical',
                targetArea: ref.targetArea || '',
                clinicalQuestion: ref.clinicalQuestion || '',
                urgency: ref.urgency || 'normal',
                status: 'pending',
                createdAt: new Date().toLocaleString()
            });
            s.root.update({
                radiologyQueue: queue,
                newReferral: {},
                selectedImagingType: null,
                radiologyTab: 'queue'
            });
        }
    }
};


var $2d46aeeb5e17174a$exports = {};

$parcel$export($2d46aeeb5e17174a$exports, "RadiologyQueueCard", () => $2d46aeeb5e17174a$export$8da7d269d036994c);
const $2d46aeeb5e17174a$export$8da7d269d036994c = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    borderLeft: (el, s)=>s.urgency === 'urgent' ? '4px solid red' : '1px solid inkBorder',
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        ImagingBadge: {
            tag: 'span',
            text: (el, s)=>s.imagingType || 'Periapical',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: 'teal.15',
            color: 'teal'
        },
        StatusBadge: {
            tag: 'span',
            text: (el, s)=>{
                const st = s.status || 'pending';
                if (st === 'pending') return 'Pending';
                if (st === 'inProgress') return 'In Progress';
                if (st === 'completed') return 'Completed';
                return st;
            },
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Z',
            round: 'B',
            background: (el, s)=>{
                const st = s.status || 'pending';
                if (st === 'pending') return 'amber.15';
                if (st === 'inProgress') return 'blue.15';
                if (st === 'completed') return 'teal.15';
                return 'inkSurface';
            },
            color: (el, s)=>{
                const st = s.status || 'pending';
                if (st === 'pending') return 'amber';
                if (st === 'inProgress') return 'blue';
                if (st === 'completed') return 'teal';
                return 'inkMuted';
            }
        }
    },
    PatientName: {
        text: (el, s)=>s.patientName || 'Patient Name',
        fontSize: 'A',
        fontWeight: '600',
        color: 'inkText'
    },
    ReferringDoctor: {
        text: (el, s)=>s.referringDoctor || 'Dr. Smith',
        fontSize: 'Z',
        color: 'inkMuted'
    },
    TargetArea: {
        text: (el, s)=>s.targetArea ? 'Target: ' + s.targetArea : '',
        fontSize: 'Z',
        color: 'inkSubtle',
        show: (el, s)=>!!s.targetArea
    },
    ClinicalQuestion: {
        text: (el, s)=>s.clinicalQuestion || '',
        fontSize: 'Z',
        color: 'inkSubtle',
        fontStyle: 'italic',
        show: (el, s)=>!!s.clinicalQuestion
    },
    Timestamp: {
        text: (el, s)=>s.createdAt || '',
        fontSize: 'Y',
        color: 'inkSubtle'
    },
    UrgencyTag: {
        tag: 'span',
        text: 'URGENT',
        fontSize: 'Y',
        fontWeight: '700',
        color: 'red',
        show: (el, s)=>s.urgency === 'urgent'
    },
    Actions: {
        flow: 'x',
        gap: 'Y',
        marginTop: 'Y',
        StartBtn: {
            tag: 'button',
            text: '{{ startImaging | polyglot }}',
            padding: 'Y Z',
            round: 'Z',
            fontSize: 'Y',
            fontWeight: '600',
            cursor: 'pointer',
            border: 'none',
            background: 'blue',
            color: 'white',
            show: (el, s)=>s.status === 'pending',
            onClick: (e, el, s)=>{
                const queue = (s.root.radiologyQueue || []).map((r)=>r.id === s.id ? {
                        ...r,
                        status: 'inProgress'
                    } : r);
                s.root.update({
                    radiologyQueue: queue
                });
            }
        },
        CompleteBtn: {
            tag: 'button',
            text: '{{ markComplete | polyglot }}',
            padding: 'Y Z',
            round: 'Z',
            fontSize: 'Y',
            fontWeight: '600',
            cursor: 'pointer',
            border: 'none',
            background: 'teal',
            color: 'white',
            show: (el, s)=>s.status === 'inProgress',
            onClick: (e, el, s)=>{
                const queue = (s.root.radiologyQueue || []).map((r)=>r.id === s.id ? {
                        ...r,
                        status: 'completed'
                    } : r);
                s.root.update({
                    radiologyQueue: queue
                });
            }
        },
        CompletedLabel: {
            tag: 'span',
            text: '{{ completed | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'teal',
            show: (el, s)=>s.status === 'completed'
        }
    }
};


var $9885843027d23762$exports = {};

$parcel$export($9885843027d23762$exports, "ImagingTypeSelector", () => $9885843027d23762$export$b4473f7e30cb0c18);
const $9885843027d23762$export$b4473f7e30cb0c18 = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
    gap: 'Z',
    PeriapicalOption: {
        flow: 'y',
        gap: 'Y',
        padding: 'A',
        round: 'Z',
        cursor: 'pointer',
        border: (el, s)=>s.root.selectedImagingType === 'Periapical' ? '2px solid teal' : '1px solid inkBorder',
        background: (el, s)=>s.root.selectedImagingType === 'Periapical' ? 'teal.15' : 'inkSurface',
        onClick: (e, el, s)=>s.root.update({
                selectedImagingType: 'Periapical'
            }),
        Icon: {
            text: '\uD83E\uDDB7',
            fontSize: 'C'
        },
        Label: {
            text: '{{ periapical | polyglot }}',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        },
        Desc: {
            text: '{{ singleToothView | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    PanoramicOption: {
        flow: 'y',
        gap: 'Y',
        padding: 'A',
        round: 'Z',
        cursor: 'pointer',
        border: (el, s)=>s.root.selectedImagingType === 'Panoramic' ? '2px solid teal' : '1px solid inkBorder',
        background: (el, s)=>s.root.selectedImagingType === 'Panoramic' ? 'teal.15' : 'inkSurface',
        onClick: (e, el, s)=>s.root.update({
                selectedImagingType: 'Panoramic'
            }),
        Icon: {
            text: '\uD83C\uDF05',
            fontSize: 'C'
        },
        Label: {
            text: '{{ panoramic | polyglot }}',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        },
        Desc: {
            text: '{{ fullMouthView | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    CbctOption: {
        flow: 'y',
        gap: 'Y',
        padding: 'A',
        round: 'Z',
        cursor: 'pointer',
        border: (el, s)=>s.root.selectedImagingType === 'CBCT' ? '2px solid teal' : '1px solid inkBorder',
        background: (el, s)=>s.root.selectedImagingType === 'CBCT' ? 'teal.15' : 'inkSurface',
        onClick: (e, el, s)=>s.root.update({
                selectedImagingType: 'CBCT'
            }),
        Icon: {
            text: '\uD83D\uDDA5\uFE0F',
            fontSize: 'C'
        },
        Label: {
            text: 'CBCT',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        },
        Desc: {
            text: '3D Imaging',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    CephalometricOption: {
        flow: 'y',
        gap: 'Y',
        padding: 'A',
        round: 'Z',
        cursor: 'pointer',
        border: (el, s)=>s.root.selectedImagingType === 'Cephalometric' ? '2px solid teal' : '1px solid inkBorder',
        background: (el, s)=>s.root.selectedImagingType === 'Cephalometric' ? 'teal.15' : 'inkSurface',
        onClick: (e, el, s)=>s.root.update({
                selectedImagingType: 'Cephalometric'
            }),
        Icon: {
            text: '\uD83D\uDC64',
            fontSize: 'C'
        },
        Label: {
            text: '{{ cephalometric | polyglot }}',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        },
        Desc: {
            text: '{{ lateralSkullView | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    }
};


var $58af3e1c1a0c18b9$exports = {};

$parcel$export($58af3e1c1a0c18b9$exports, "DoctorProfileCard", () => $58af3e1c1a0c18b9$export$86a015b2b23312b3);
const $58af3e1c1a0c18b9$export$86a015b2b23312b3 = {
    flow: 'y',
    gap: 'A',
    padding: 'A',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    width: '100%',
    DoctorHeader: {
        flow: 'x',
        gap: 'Z',
        align: 'flex-start flex-start',
        DoctorAvatar: {
            width: 'D',
            height: 'D',
            round: 'D',
            background: 'teal.15',
            flexShrink: '0',
            flow: 'x',
            align: 'center center',
            Initials: {
                text: (el, s)=>{
                    const parts = (s.doctorName || '').split(' ');
                    return parts.map((p)=>p.charAt(0)).join('').toUpperCase().slice(0, 2);
                },
                fontSize: 'B',
                fontWeight: '700',
                color: 'teal'
            }
        },
        DoctorInfo: {
            flow: 'y',
            gap: 'W',
            flex: '1',
            minWidth: '0',
            DoctorName: {
                text: (el, s)=>s.doctorName,
                fontSize: 'A',
                fontWeight: '700',
                color: 'inkText'
            },
            DoctorSpecialties: {
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                children: (el, s)=>(s.specialties || []).map((sp)=>({
                            label: sp
                        })),
                childrenAs: 'state',
                childProps: {
                    text: (el, s)=>s.label,
                    fontSize: 'Y',
                    padding: 'X Y',
                    round: 'C',
                    background: 'teal.1',
                    color: 'teal',
                    fontWeight: '500'
                }
            },
            DoctorRating: {
                flow: 'x',
                gap: 'W',
                align: 'center flex-start',
                marginTop: 'W',
                RatingStar: {
                    extends: 'Icon',
                    icon: 'star',
                    width: 'Z',
                    height: 'Z',
                    color: 'amber'
                },
                RatingNum: {
                    text: (el, s)=>String(s.rating || '0'),
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: 'inkText'
                },
                ReviewCount: {
                    text: (el, s)=>'(' + (s.reviewCount || 0) + ')',
                    fontSize: 'Y',
                    color: 'inkMuted'
                }
            }
        }
    },
    DoctorClinics: {
        flow: 'y',
        gap: 'Z',
        marginTop: 'Z',
        ClinicsLabel: {
            text: '{{ availableAtClinics | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'inkMuted',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: 'W'
        },
        ClinicEntries: {
            flow: 'y',
            gap: 'Y',
            children: (el, s)=>s.clinics || [],
            childrenAs: 'state',
            childProps: {
                flow: 'y',
                gap: 'Y',
                padding: 'Z',
                round: 'Z',
                background: 'inkSurface',
                border: '1px solid inkBorder',
                ClinicRow: {
                    flow: 'x',
                    align: 'center space-between',
                    gap: 'Z',
                    ClinicInfo: {
                        flow: 'y',
                        gap: 'W',
                        flex: '1',
                        minWidth: '0',
                        ClinicName: {
                            text: (el, s)=>s.clinicName,
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ClinicTimes: {
                            text: (el, s)=>(s.availableTimes || []).slice(0, 3).join(', '),
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    BookClinicBtn: {
                        extends: 'Button',
                        text: '{{ bookAtClinic | polyglot }}',
                        background: '#0D1117',
                        color: '#FFFFFF',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Z',
                        fontSize: 'Y',
                        cursor: 'pointer',
                        border: 'none',
                        flexShrink: '0',
                        onClick: (e, el, s)=>{
                            s.root.update({
                                selectedClinic: s.clinicName,
                                selectedClinicId: s.clinicId,
                                activeBookingStep: 2
                            });
                        }
                    }
                },
                ClinicDiscount: {
                    show: (el, s)=>{
                        const discounts = s.root.clinicDiscounts;
                        return discounts && discounts[s.clinicId];
                    },
                    flow: 'x',
                    gap: 'W',
                    align: 'center flex-start',
                    padding: 'W Y',
                    round: 'Y',
                    background: 'teal.15',
                    width: 'fit-content',
                    DiscountIcon: {
                        extends: 'Icon',
                        icon: 'tag',
                        width: 'Y',
                        height: 'Y',
                        color: 'teal'
                    },
                    DiscountText: {
                        text: '{{ specialOfferAvailable | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'teal'
                    }
                }
            }
        }
    }
};


var $0746fb0dac44c0d8$exports = {};

$parcel$export($0746fb0dac44c0d8$exports, "PatientHistoryForm", () => $0746fb0dac44c0d8$export$79b4084af5c6e5b5);
const $0746fb0dac44c0d8$export$79b4084af5c6e5b5 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B',
    background: 'inkSurface',
    round: 'Z',
    border: '1px solid inkBorder',
    width: '100%',
    FormTitle: {
        flow: 'x',
        align: 'center space-between',
        TitleText: {
            text: '{{ addDentalHistory | polyglot }}',
            fontSize: 'A',
            fontWeight: '700',
            color: 'inkText'
        },
        PatientReportedBadge: {
            text: '{{ patientReported | polyglot }}',
            fontSize: 'Y',
            fontWeight: '600',
            padding: 'X Y',
            round: 'B',
            background: 'orange.15',
            color: 'orange'
        }
    },
    ToothSelector: {
        flow: 'y',
        gap: 'X',
        ToothLabel: {
            text: '{{ toothNumber | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        ToothSelect: {
            tag: 'select',
            padding: 'Y Z',
            round: 'Y',
            border: '1px solid inkBorder',
            background: 'inkMid',
            color: 'inkText',
            fontSize: 'Z',
            width: '100%',
            cursor: 'pointer',
            value: (el, s)=>s.historyFormTooth || '',
            onChange: (el, s)=>{
                s.update({
                    historyFormTooth: el.node.value
                });
            },
            OptionDefault: {
                tag: 'option',
                value: '',
                text: '{{ selectTooth | polyglot }}'
            },
            $collection: (el, s)=>{
                var teeth = [];
                var quads = [
                    [
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18
                    ],
                    [
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28
                    ],
                    [
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38
                    ],
                    [
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48
                    ]
                ];
                for(var q = 0; q < quads.length; q++)for(var t = 0; t < quads[q].length; t++)teeth.push({
                    tag: 'option',
                    value: String(quads[q][t]),
                    text: 'Tooth #' + quads[q][t]
                });
                return teeth;
            }
        }
    },
    ProcedureSelector: {
        flow: 'y',
        gap: 'X',
        ProcLabel: {
            text: '{{ procedureType | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        ProcSelect: {
            tag: 'select',
            padding: 'Y Z',
            round: 'Y',
            border: '1px solid inkBorder',
            background: 'inkMid',
            color: 'inkText',
            fontSize: 'Z',
            width: '100%',
            cursor: 'pointer',
            value: (el, s)=>s.historyFormProcedure || '',
            onChange: (el, s)=>{
                s.update({
                    historyFormProcedure: el.node.value
                });
            },
            OptionDefault: {
                tag: 'option',
                value: '',
                text: '{{ selectProcedure | polyglot }}'
            },
            OptionFilling: {
                tag: 'option',
                value: 'Filling',
                text: '{{ filling | polyglot }}'
            },
            OptionCrown: {
                tag: 'option',
                value: 'Crown',
                text: '{{ crown | polyglot }}'
            },
            OptionRootCanal: {
                tag: 'option',
                value: 'Root Canal',
                text: '{{ rootCanal | polyglot }}'
            },
            OptionExtraction: {
                tag: 'option',
                value: 'Extraction',
                text: '{{ extraction | polyglot }}'
            },
            OptionImplant: {
                tag: 'option',
                value: 'Implant',
                text: '{{ implantProc | polyglot }}'
            },
            OptionCleaning: {
                tag: 'option',
                value: 'Cleaning',
                text: '{{ cleaningProc | polyglot }}'
            },
            OptionWhitening: {
                tag: 'option',
                value: 'Whitening',
                text: '{{ whiteningProc | polyglot }}'
            },
            OptionBraces: {
                tag: 'option',
                value: 'Braces',
                text: '{{ bracesProc | polyglot }}'
            },
            OptionOther: {
                tag: 'option',
                value: 'Other',
                text: '{{ other | polyglot }}'
            }
        }
    },
    DateRow: {
        flow: 'x',
        gap: 'Z',
        MonthField: {
            flow: 'y',
            gap: 'X',
            flex: '1',
            MonthLabel: {
                text: '{{ month | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            },
            MonthSelect: {
                tag: 'select',
                padding: 'Y Z',
                round: 'Y',
                border: '1px solid inkBorder',
                background: 'inkMid',
                color: 'inkText',
                fontSize: 'Z',
                width: '100%',
                cursor: 'pointer',
                value: (el, s)=>s.historyFormMonth || '',
                onChange: (el, s)=>{
                    s.update({
                        historyFormMonth: el.node.value
                    });
                },
                OptionDefault: {
                    tag: 'option',
                    value: '',
                    text: '{{ selectMonth | polyglot }}'
                },
                OptionJan: {
                    tag: 'option',
                    value: '01',
                    text: 'January'
                },
                OptionFeb: {
                    tag: 'option',
                    value: '02',
                    text: 'February'
                },
                OptionMar: {
                    tag: 'option',
                    value: '03',
                    text: 'March'
                },
                OptionApr: {
                    tag: 'option',
                    value: '04',
                    text: 'April'
                },
                OptionMay: {
                    tag: 'option',
                    value: '05',
                    text: 'May'
                },
                OptionJun: {
                    tag: 'option',
                    value: '06',
                    text: 'June'
                },
                OptionJul: {
                    tag: 'option',
                    value: '07',
                    text: 'July'
                },
                OptionAug: {
                    tag: 'option',
                    value: '08',
                    text: 'August'
                },
                OptionSep: {
                    tag: 'option',
                    value: '09',
                    text: 'September'
                },
                OptionOct: {
                    tag: 'option',
                    value: '10',
                    text: 'October'
                },
                OptionNov: {
                    tag: 'option',
                    value: '11',
                    text: 'November'
                },
                OptionDec: {
                    tag: 'option',
                    value: '12',
                    text: 'December'
                }
            }
        },
        YearField: {
            flow: 'y',
            gap: 'X',
            flex: '1',
            YearLabel: {
                text: '{{ year | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: 'X'
            },
            YearSelect: {
                tag: 'select',
                padding: 'Y Z',
                round: 'Y',
                border: '1px solid inkBorder',
                background: 'inkMid',
                color: 'inkText',
                fontSize: 'Z',
                width: '100%',
                cursor: 'pointer',
                value: (el, s)=>s.historyFormYear || '',
                onChange: (el, s)=>{
                    s.update({
                        historyFormYear: el.node.value
                    });
                },
                OptionDefault: {
                    tag: 'option',
                    value: '',
                    text: '{{ selectYear | polyglot }}'
                },
                Option2026: {
                    tag: 'option',
                    value: '2026',
                    text: '2026'
                },
                Option2025: {
                    tag: 'option',
                    value: '2025',
                    text: '2025'
                },
                Option2024: {
                    tag: 'option',
                    value: '2024',
                    text: '2024'
                },
                Option2023: {
                    tag: 'option',
                    value: '2023',
                    text: '2023'
                },
                Option2022: {
                    tag: 'option',
                    value: '2022',
                    text: '2022'
                },
                Option2021: {
                    tag: 'option',
                    value: '2021',
                    text: '2021'
                },
                Option2020: {
                    tag: 'option',
                    value: '2020',
                    text: '2020'
                }
            }
        }
    },
    DoctorField: {
        flow: 'y',
        gap: 'X',
        DoctorLabel: {
            text: '{{ doctorNameOptional | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        DoctorInput: {
            tag: 'input',
            attr: {
                type: 'text',
                placeholder: '{{ enterDoctorName | polyglot }}'
            },
            padding: 'Y Z',
            round: 'Y',
            border: '1px solid inkBorder',
            background: 'inkMid',
            color: 'inkText',
            fontSize: 'Z',
            width: '100%',
            value: (el, s)=>s.historyFormDoctor || '',
            onInput: (el, s)=>{
                s.update({
                    historyFormDoctor: el.node.value
                });
            }
        }
    },
    ClinicField: {
        flow: 'y',
        gap: 'X',
        ClinicLabel: {
            text: '{{ clinicNameOptional | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        ClinicInput: {
            tag: 'input',
            attr: {
                type: 'text',
                placeholder: '{{ enterClinicName | polyglot }}'
            },
            padding: 'Y Z',
            round: 'Y',
            border: '1px solid inkBorder',
            background: 'inkMid',
            color: 'inkText',
            fontSize: 'Z',
            width: '100%',
            value: (el, s)=>s.historyFormClinic || '',
            onInput: (el, s)=>{
                s.update({
                    historyFormClinic: el.node.value
                });
            }
        }
    },
    NotesField: {
        flow: 'y',
        gap: 'X',
        NotesLabel: {
            text: '{{ notes | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        NotesTextarea: {
            tag: 'textarea',
            attr: {
                rows: '3',
                placeholder: '{{ enterNotes | polyglot }}'
            },
            padding: 'Y Z',
            round: 'Y',
            border: '1px solid inkBorder',
            background: 'inkMid',
            color: 'inkText',
            fontSize: 'Z',
            width: '100%',
            resize: 'vertical',
            value: (el, s)=>s.historyFormNotes || '',
            onInput: (el, s)=>{
                s.update({
                    historyFormNotes: el.node.value
                });
            }
        }
    },
    FormActions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-end',
        marginTop: 'Y',
        CancelButton: {
            text: '{{ cancel | polyglot }}',
            padding: 'Z A',
            round: 'Y',
            background: 'inkMid',
            border: '1px solid inkBorder',
            color: 'inkText',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: 'Z',
            onClick: (el, s)=>{
                s.root.update({
                    showHistoryForm: false
                });
            }
        },
        SubmitButton: {
            text: '{{ submitHistory | polyglot }}',
            padding: 'Z A',
            round: 'Y',
            background: 'teal',
            color: 'white',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: 'Z',
            onClick: (el, s)=>{
                var tooth = Number(s.historyFormTooth);
                var procedure = s.historyFormProcedure;
                if (!tooth || !procedure) return;
                var months = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ];
                var monthIdx = Number(s.historyFormMonth || '1') - 1;
                var year = s.historyFormYear || '2026';
                var dateStr = months[monthIdx] + ' ' + year;
                var entry = {
                    procedure: procedure,
                    doctor: s.historyFormDoctor || '',
                    clinic: s.historyFormClinic || '',
                    date: dateStr,
                    notes: s.historyFormNotes || '',
                    verified: false
                };
                var toothHistory = Object.assign({}, s.root.toothHistory || {});
                var existing = toothHistory[tooth] ? toothHistory[tooth].slice() : [];
                existing.unshift(entry);
                toothHistory[tooth] = existing;
                s.root.update({
                    toothHistory: toothHistory,
                    showHistoryForm: false
                });
                s.update({
                    historyFormTooth: '',
                    historyFormProcedure: '',
                    historyFormMonth: '',
                    historyFormYear: '',
                    historyFormDoctor: '',
                    historyFormClinic: '',
                    historyFormNotes: ''
                });
            }
        }
    }
};


var $104dcf36032eed6e$exports = {};

$parcel$export($104dcf36032eed6e$exports, "NoteAutocomplete", () => $104dcf36032eed6e$export$dbcae8eda165f401);
$parcel$export($104dcf36032eed6e$exports, "NoteAutocompleteSuggestion", () => $104dcf36032eed6e$export$bd6d86f782d18e8);
const $104dcf36032eed6e$export$dbcae8eda165f401 = {
    position: 'relative',
    flow: 'y',
    width: '100%',
    state: {
        autocompleteVisible: false,
        autocompleteSuggestions: [],
        autocompleteIndex: -1,
        autocompleteInputValue: ''
    },
    AutocompleteInput: {
        tag: 'input',
        attr: {
            type: 'text',
            autocomplete: 'off'
        },
        placeholder: '{{ typeToSearch | polyglot }}',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        border: '1px solid inkBorder',
        background: 'ink',
        color: 'inkText',
        fontSize: 'Z',
        onInput: (ev, el, s)=>{
            var val = el.node.value;
            s.root.update({
                autocompleteInputValue: val
            });
            if (val.length < 2) {
                s.root.update({
                    autocompleteVisible: false,
                    autocompleteSuggestions: [],
                    autocompleteIndex: -1
                });
                return;
            }
            var results = el.call('noteAutocomplete', val);
            s.root.update({
                autocompleteVisible: results.length > 0,
                autocompleteSuggestions: results,
                autocompleteIndex: -1
            });
        },
        onKeydown: (ev, el, s)=>{
            var suggestions = s.root.autocompleteSuggestions || [];
            var idx = s.root.autocompleteIndex !== undefined ? s.root.autocompleteIndex : -1;
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                var next = idx < suggestions.length - 1 ? idx + 1 : 0;
                s.root.update({
                    autocompleteIndex: next
                });
            } else if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                var prev = idx > 0 ? idx - 1 : suggestions.length - 1;
                s.root.update({
                    autocompleteIndex: prev
                });
            } else if (ev.key === 'Enter' && idx >= 0 && suggestions[idx]) {
                ev.preventDefault();
                el.node.value = suggestions[idx].en;
                s.root.update({
                    autocompleteVisible: false,
                    autocompleteSuggestions: [],
                    autocompleteIndex: -1,
                    autocompleteInputValue: suggestions[idx].en
                });
            } else if (ev.key === 'Escape') s.root.update({
                autocompleteVisible: false,
                autocompleteIndex: -1
            });
        },
        onBlur: (ev, el, s)=>{
            setTimeout(function() {
                s.root.update({
                    autocompleteVisible: false,
                    autocompleteIndex: -1
                });
            }, 200);
        }
    },
    SuggestionDropdown: {
        show: (el, s)=>s.root.autocompleteVisible,
        position: 'absolute',
        top: '100%',
        left: '0',
        width: '100%',
        zIndex: '100',
        marginTop: 'X',
        background: 'inkMid',
        border: '1px solid inkBorder',
        round: 'Y',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        children: (el, s)=>{
            var suggestions = s.root.autocompleteSuggestions || [];
            return suggestions.map(function(item, i) {
                return {
                    index: i,
                    termEn: item.en,
                    termKa: item.ka,
                    termCategory: item.category
                };
            });
        },
        childrenAs: 'state',
        childExtends: 'NoteAutocompleteSuggestion'
    }
};
const $104dcf36032eed6e$export$bd6d86f782d18e8 = {
    flow: 'x',
    align: 'center space-between',
    padding: 'Y Z',
    cursor: 'pointer',
    background: (el, s)=>{
        var idx = s.root.autocompleteIndex;
        return s.index === idx ? 'teal.15' : 'transparent';
    },
    transition: 'background 0.1s',
    ':hover': {
        background: 'teal.15'
    },
    TermInfo: {
        flow: 'y',
        gap: 'X',
        TermEn: {
            text: (el, s)=>s.termEn || '',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
        },
        TermKa: {
            text: (el, s)=>s.termKa || '',
            fontSize: 'Y',
            color: 'inkMuted'
        }
    },
    CategoryBadge: {
        tag: 'span',
        text: (el, s)=>s.termCategory || '',
        fontSize: 'X',
        fontWeight: '600',
        padding: 'X Y',
        round: 'X',
        textTransform: 'uppercase',
        background: (el, s)=>{
            var cat = s.termCategory;
            if (cat === 'procedure') return 'teal.15';
            if (cat === 'finding') return 'amber.15';
            if (cat === 'material') return 'blue.15';
            if (cat === 'medication') return 'purple.15';
            return 'inkSurface';
        },
        color: (el, s)=>{
            var cat = s.termCategory;
            if (cat === 'procedure') return 'teal';
            if (cat === 'finding') return 'amber';
            if (cat === 'material') return 'blue';
            if (cat === 'medication') return 'purple';
            return 'inkMuted';
        }
    },
    onClick: (el, s)=>{
        s.root.update({
            autocompleteVisible: false,
            autocompleteSuggestions: [],
            autocompleteIndex: -1,
            autocompleteInputValue: s.termEn
        });
        // Find the input and set its value
        var root = el.parent.parent;
        if (root && root.AutocompleteInput && root.AutocompleteInput.node) root.AutocompleteInput.node.value = s.termEn;
    }
};


var $a43fd1753f1f81b0$exports = {};

$parcel$export($a43fd1753f1f81b0$exports, "SpecialtyFilter", () => $a43fd1753f1f81b0$export$eb33de89bec976b0);
$parcel$export($a43fd1753f1f81b0$exports, "SpecialtyPill", () => $a43fd1753f1f81b0$export$55d978c1a8150666);
const $a43fd1753f1f81b0$export$eb33de89bec976b0 = {
    flow: 'x',
    gap: 'Y',
    flexWrap: 'wrap',
    align: 'center flex-start',
    state: {
        specialties: [
            {
                key: 'all',
                label: '{{ all | polyglot }}',
                count: 5
            },
            {
                key: 'orthodontics',
                label: '{{ orthodontics | polyglot }}',
                count: 0
            },
            {
                key: 'endodontics',
                label: '{{ endodontics | polyglot }}',
                count: 1
            },
            {
                key: 'periodontics',
                label: '{{ periodontics | polyglot }}',
                count: 2
            },
            {
                key: 'surgery',
                label: '{{ surgery | polyglot }}',
                count: 0
            },
            {
                key: 'general',
                label: '{{ general | polyglot }}',
                count: 1
            },
            {
                key: 'prosthetics',
                label: '{{ prosthetics | polyglot }}',
                count: 1
            }
        ]
    },
    children: (el, s)=>{
        var specs = s.specialties || [];
        return specs.map(function(spec) {
            return {
                filterKey: spec.key,
                filterLabel: spec.label,
                filterCount: spec.count
            };
        });
    },
    childrenAs: 'state',
    childExtends: 'SpecialtyPill'
};
const $a43fd1753f1f81b0$export$55d978c1a8150666 = {
    flow: 'x',
    gap: 'X',
    align: 'center center',
    padding: 'Y A',
    round: 'C',
    cursor: 'pointer',
    fontSize: 'Z',
    fontWeight: '600',
    transition: 'background 0.15s, color 0.15s',
    background: (el, s)=>{
        var active = s.root.noteSpecialtyFilter || 'all';
        return s.filterKey === active ? 'teal' : 'inkSurface';
    },
    color: (el, s)=>{
        var active = s.root.noteSpecialtyFilter || 'all';
        return s.filterKey === active ? 'inkText' : 'inkMuted';
    },
    ':hover': {
        opacity: '0.85'
    },
    PillLabel: {
        text: (el, s)=>s.filterLabel || ''
    },
    PillCount: {
        tag: 'span',
        text: (el, s)=>s.filterCount !== undefined ? String(s.filterCount) : '0',
        fontSize: 'X',
        fontWeight: '700',
        padding: 'X Y',
        round: 'C',
        minWidth: 'Z',
        textAlign: 'center',
        background: (el, s)=>{
            var active = s.root.noteSpecialtyFilter || 'all';
            return s.filterKey === active ? 'teal.3' : 'inkBorder';
        },
        color: (el, s)=>{
            var active = s.root.noteSpecialtyFilter || 'all';
            return s.filterKey === active ? 'inkText' : 'inkMuted';
        }
    },
    onClick: (el, s)=>{
        s.root.update({
            noteSpecialtyFilter: s.filterKey
        });
    }
};


$parcel$exportWildcard($b940b823876787d8$exports, $1361c0857020ec79$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $3e7d9d0c898609d2$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $9636b0bca02a11fc$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $8091e96233427455$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $032a0868926608de$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $ec3f9d7c7c1f789a$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $18de0e4585488af7$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $960e970dc63774b5$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b755e2fd8d543f30$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $14e5064f35397f79$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $142b97f260d45453$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $19f071aa89dd3a6b$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $6adc95ecda5c309e$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b1cc20cced7368fe$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $741f1041f5324f0c$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $e09c7e6cacc12172$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $8aba4b6de89427c7$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $c6bcb1da226598d7$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $1b7b9ca0dc4e4c87$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d39763d811cd1e53$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $ef2aa5000ca42c4b$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d94fc369bc06faad$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $0facdb3adfab73f3$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $5d673512a9117fe3$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b2bcaff2106d22a4$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b11e431348e0cc21$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $e791da1e519e3866$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $fb3cc24df2f6a035$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $403c48608a3af55e$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $f918ed4841c6aab1$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $e44a7f8d70078042$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $78912a1ebc9679bc$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $43bf22cb6cdbd180$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b3dba13d61cef323$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $7784c6f1fd59027d$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $f04008839a986e0c$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $67883e541bbbc832$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $4d80c719a303ed6b$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $fadd47535bac1056$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $18eda60775471865$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $9267baef54d8d235$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $caf35111e5293e4f$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $60f8e0a81eb161fd$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $11b41673cc060e9f$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $88ef4cc8fece9e19$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $60fc3d52c5182c70$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $57275b097b61842e$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $354620d77410b75a$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $4debbafc7bdaa8be$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $bc96e42e6114e68d$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $70283f9df385c538$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $950698d4d1413b23$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d0ea885a4e40b154$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $a7129e33134b01bf$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $26c70c0245bc7136$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d0d345c73715026a$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d7115285f384c954$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $51e3af5a0cb05d74$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $1cec1237daf50111$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $2f8e33763a765e93$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $30924b58f89821b8$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $9938164d635e4121$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $e00105f4cbc5a90f$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $172ff3cc87e49b82$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $4f093a273ed50522$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $c5713fe43a4c045d$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $7ed557d2698990e7$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $a966b7efd1e2719f$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $5e5bd3b1e4958dc1$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $826d0b2e40d87197$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $31e9cd8ecc45595b$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $260a5b5edf3aab0b$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $7b00be04df0391fc$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $d79130fc0ca8b1f4$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b3cc7bc69bb5e9f7$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $6bfb8e6f8449f18b$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $ea0d742937f80291$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $68ee1ecd60a3592e$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $f0c1d9a3046ca680$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $6a1e07e9c45b6877$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b2ce94b93f6f9779$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $8756016566b3dfa4$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $16cde78b62cd4b1d$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $0ff2da8668a518b7$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b53ec3462f5b7099$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $2321bdb3b882440b$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $dd38944709a8bd41$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $6d1678e34a15d7c7$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b8dbec74df9324a7$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $a5eb4635aeb1fa7e$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $b4b6cbbe956493f0$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $c7198d146b7249b6$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $ed600830d3ddf7b8$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $90b9b022f7ba3147$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $e0bc1935b2d7715f$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $2d46aeeb5e17174a$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $9885843027d23762$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $58af3e1c1a0c18b9$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $0746fb0dac44c0d8$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $104dcf36032eed6e$exports);
$parcel$exportWildcard($b940b823876787d8$exports, $a43fd1753f1f81b0$exports);


var $5006d5ef181f83de$exports = {};



const $b9becae6bd307dfe$var$mapClinic = (c)=>{
    var services = c.services;
    if (typeof services === 'string') try {
        services = JSON.parse(services);
    } catch  {
        services = [];
    }
    return {
        id: c.id,
        name: c.name,
        address: c.address,
        district: c.district,
        phone: c.phone,
        rating: c.rating || 0,
        reviews: c.reviews || 0,
        lat: c.lat,
        lng: c.lng,
        services: services || [],
        hours: c.hours,
        priceRange: c.price_range,
        logo: c.logo,
        website: c.website
    };
};
const $b9becae6bd307dfe$export$2e68a2c819d29977 = {
    from: 'clinics',
    params: {
        status: 'active'
    },
    order: {
        by: 'rating',
        asc: false
    },
    cache: '5m',
    transform: (data, el)=>{
        const clinics = (data || []).map($b9becae6bd307dfe$var$mapClinic);
        const root = el.state.root || el.state;
        if (root && root.update) root.update({
            clinics: clinics,
            clinicsLoaded: true
        }, {
            preventFetch: true
        });
        return clinics;
    }
};


const $8d2c7cae8dfd7a3b$var$triggerAi = async (query, s)=>{
    const thread = [
        ...s.root.aiModalThread || [],
        {
            role: 'user',
            content: query
        }
    ];
    s.root.update({
        showAiModal: true,
        aiModalThread: thread,
        aiModalLoading: true
    });
    try {
        const reply = await (0, $fb3cc24df2f6a035$export$62406c3f3822876c)(thread, s.root.clinics || []);
        s.root.update({
            aiModalThread: [
                ...thread,
                {
                    role: 'assistant',
                    content: reply
                }
            ],
            aiModalLoading: false
        });
    } catch (err) {
        s.root.update({
            aiModalThread: [
                ...thread,
                {
                    role: 'assistant',
                    content: 'Error: ' + err.message
                }
            ],
            aiModalLoading: false
        });
    }
};
const $8d2c7cae8dfd7a3b$export$a9ae88069d8ac14e = {
    extends: 'Page',
    flow: 'y',
    background: '#FFFFFF',
    color: 'inkText',
    ClinicsData: {
        fetch: (0, $b9becae6bd307dfe$export$2e68a2c819d29977),
        display: 'none'
    },
    AiModal: {},
    NavBar: {
        background: 'transparent',
        backdropFilter: 'none',
        borderBottom: 'none',
        position: 'absolute',
        top: '0',
        zIndex: '10',
        LogoLink: {
            color: '#0D1117'
        },
        NavLinks: {
            FeaturesLink: {
                color: '#0D1117'
            },
            PricingLink: {
                color: '#0D1117'
            },
            ClinicsLink: {
                color: '#0D1117'
            },
            AiLink: {
                color: '#0D1117'
            },
            ForBusinessLink: {
                color: '#0D1117'
            }
        },
        NavRight: {
            DashLink: {
                color: '#0D1117'
            }
        }
    },
    HeroSection: {
        tag: 'section',
        position: 'relative',
        overflow: 'hidden',
        flow: 'y',
        align: 'center center',
        textAlign: 'center',
        width: '100%',
        minHeight: '90dvh',
        background: '#F5F6FA url(https://i.ibb.co/ym9m7N2s/unnamed.jpg) center / cover no-repeat',
        '@mobileL': {
            minHeight: '80dvh'
        },
        HeroContent: {
            position: 'relative',
            zIndex: '1',
            flow: 'y',
            align: 'center center',
            gap: 'A',
            padding: '0 B F B',
            maxWidth: 'K',
            width: '100%',
            '@mobileL': {
                padding: '0 A D A',
                gap: 'Z'
            },
            HeroTagline: {
                tag: 'span',
                text: '{{ heroTagline | polyglot }}',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: 'Y',
                background: 'white',
                padding: 'Y A',
                round: 'D',
                border: 'none'
            },
            HeroTitle: {
                tag: 'h1',
                text: '{{ heroTitle | polyglot }}',
                fontSize: 'H',
                fontWeight: '800',
                letterSpacing: '-0.05em',
                lineHeight: '1.0',
                color: 'inkText',
                '@mobileL': {
                    fontSize: 'E'
                }
            },
            HeroSubtitle: {
                tag: 'h2',
                text: '{{ heroSubtitle | polyglot }}',
                fontSize: 'B',
                fontWeight: '400',
                color: 'inkText',
                maxWidth: 'I',
                lineHeight: '1.5',
                '@mobileL': {
                    fontSize: 'A'
                }
            }
        },
        HeroPrompt: {
            position: 'absolute',
            bottom: 'C',
            left: '50%',
            attr: {
                style: 'transform: translateX(-50%)'
            },
            flow: 'y',
            align: 'center center',
            gap: 'A',
            width: '100%',
            maxWidth: 'I',
            zIndex: '2',
            padding: '0 B',
            '@mobileL': {
                bottom: 'B',
                padding: '0 A'
            },
            PromptInput: {
                flow: 'x',
                align: 'flex-end center',
                gap: 'Z',
                width: '100%',
                background: 'rgba(255,255,255,0.75)',
                backdropFilter: 'blur(16px)',
                border: '1px solid rgba(0,0,0,0.1)',
                round: 'B',
                padding: 'A',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                ':hover': {
                    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                    border: '1px solid rgba(0,0,0,0.15)'
                },
                SearchInput: {
                    tag: 'textarea',
                    placeholder: '{{ searchPlaceholder | polyglot }}',
                    flex: '1',
                    padding: 'Y 0',
                    background: 'transparent',
                    border: 'none',
                    fontSize: 'A',
                    fontFamily: 'inherit',
                    color: '#1D1D1F',
                    outline: 'none',
                    resize: 'none',
                    height: 'D',
                    lineHeight: '1.5',
                    attr: {
                        rows: '3'
                    },
                    on: {
                        keydown: (e, el, s)=>{
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                const query = el.node.value;
                                if (!query.trim()) return;
                                el.node.value = '';
                                $8d2c7cae8dfd7a3b$var$triggerAi(query, s);
                            }
                        }
                    }
                },
                SearchBtn: {
                    tag: 'button',
                    background: '#0D1117',
                    color: '#FFFFFF',
                    fontWeight: '600',
                    width: 'B1',
                    height: 'B1',
                    round: 'B',
                    cursor: 'pointer',
                    border: 'none',
                    transition: 'all 0.2s ease',
                    ':hover': {
                        opacity: '0.9'
                    },
                    align: 'center center',
                    flexShrink: '0',
                    ArrowIcon: {
                        extends: 'Icon',
                        icon: 'arrowUp',
                        width: 'A',
                        height: 'A',
                        color: '#FFFFFF'
                    },
                    onClick: (e, el, s)=>{
                        const input = el.lookup('SearchInput');
                        const query = input.node.value;
                        if (!query.trim()) return;
                        input.node.value = '';
                        $8d2c7cae8dfd7a3b$var$triggerAi(query, s);
                    }
                }
            },
            PromptChips: {
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                align: 'center center',
                children: [
                    {
                        label: '{{ chipImplant | polyglot }}'
                    },
                    {
                        label: '{{ chipWhitening | polyglot }}'
                    },
                    {
                        label: '{{ chipEmergency | polyglot }}'
                    },
                    {
                        label: '{{ chipOrtho | polyglot }}'
                    }
                ],
                childrenAs: 'state',
                childExtends: {
                    tag: 'button',
                    text: (el, s)=>s.label,
                    background: 'rgba(255,255,255,0.5)',
                    backdropFilter: 'blur(8px)',
                    border: '1px solid rgba(0,0,0,0.08)',
                    padding: 'Y Z',
                    round: 'C',
                    fontSize: 'Z',
                    color: '#555',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    ':hover': {
                        background: 'rgba(255,255,255,0.8)',
                        color: '#1D1D1F'
                    },
                    onClick: (e, el, s)=>$8d2c7cae8dfd7a3b$var$triggerAi(s.label, s)
                }
            }
        }
    },
    ScrollHint: {
        flow: 'y',
        align: 'center center',
        gap: 'Y',
        padding: 'B 0',
        opacity: '0.3',
        ScrollText: {
            text: '{{ scrollExplore | polyglot }}',
            fontSize: 'Y',
            color: '#1D1D1F',
            textTransform: 'uppercase',
            letterSpacing: '0.15em',
            fontWeight: '500'
        },
        ScrollArrow: {
            extends: 'Icon',
            icon: 'chevronDown',
            width: 'Z',
            height: 'Z',
            color: '#1D1D1F'
        }
    },
    PopularClinics: {
        tag: 'section',
        flow: 'y',
        gap: 'B',
        padding: 'D B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        '@mobileL': {
            padding: 'C A'
        },
        PopularSubtitle: {
            text: '{{ topRated | polyglot }}',
            fontSize: 'B',
            fontWeight: '400',
            color: 'inkMuted',
            textAlign: 'left',
            marginBottom: 'A',
            lineHeight: '1.5'
        },
        ClinicsLayout: {
            flow: 'x',
            gap: 'A',
            width: '100%',
            align: 'stretch flex-start',
            '@mobileL': {
                flow: 'y'
            },
            ClinicsList: {
                flex: '1',
                flow: 'y',
                gap: 'A',
                minWidth: '0',
                position: 'relative',
                ClinicGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 'A',
                    '@mobileL': {
                        gridTemplateColumns: '1fr'
                    },
                    children: (el, s)=>(s.root.clinics || []).slice(0, 6),
                    childrenAs: 'state',
                    childExtends: 'ClinicListCard'
                },
                GradientOverlay: {
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    width: '100%',
                    height: 'F',
                    background: 'linear-gradient(to bottom, transparent 0%, rgba(255,255,255,0.5) 25%, #FFFFFF 75%)',
                    zIndex: '1'
                },
                ViewAllBtn: {
                    extends: 'Link',
                    href: '/clinics',
                    text: '{{ viewAllClinics | polyglot }}',
                    position: 'absolute',
                    bottom: 'Y',
                    left: 'A',
                    zIndex: '2',
                    background: '#0D1117',
                    color: '#FFFFFF',
                    fontWeight: '600',
                    padding: 'Z B',
                    round: 'C',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    boxShadow: '0 4px 24px rgba(255,255,255,0.8)',
                    transition: 'all 0.2s ease',
                    ':hover': {
                        boxShadow: '0 8px 32px rgba(255,255,255,0.9)'
                    }
                }
            },
            MapPanel: {
                width: '420px',
                flexShrink: '0',
                flow: 'y',
                gap: 'Z',
                '@mobileL': {
                    width: '100%'
                },
                MapContainer: {
                    width: '100%',
                    flex: '1',
                    minHeight: '400px',
                    round: 'A',
                    border: 'none',
                    overflow: 'hidden',
                    attr: {
                        id: 'clinic-map'
                    },
                    onRender: (el, s)=>{
                        if (el.node._mapInit) return;
                        el.node._mapInit = true;
                        const initMap = ()=>{
                            const mapStyles = [
                                {
                                    featureType: 'poi',
                                    stylers: [
                                        {
                                            visibility: 'off'
                                        }
                                    ]
                                },
                                {
                                    featureType: 'transit',
                                    stylers: [
                                        {
                                            visibility: 'off'
                                        }
                                    ]
                                },
                                {
                                    featureType: 'road',
                                    elementType: 'labels',
                                    stylers: [
                                        {
                                            visibility: 'simplified'
                                        }
                                    ]
                                },
                                {
                                    featureType: 'water',
                                    elementType: 'geometry',
                                    stylers: [
                                        {
                                            color: '#e3e8ee'
                                        }
                                    ]
                                },
                                {
                                    featureType: 'landscape',
                                    stylers: [
                                        {
                                            color: '#f5f5f5'
                                        }
                                    ]
                                },
                                {
                                    featureType: 'road',
                                    elementType: 'geometry',
                                    stylers: [
                                        {
                                            color: '#ffffff'
                                        }
                                    ]
                                },
                                {
                                    featureType: 'road.arterial',
                                    elementType: 'geometry',
                                    stylers: [
                                        {
                                            color: '#e8e8e8'
                                        }
                                    ]
                                }
                            ];
                            const map = new google.maps.Map(el.node, {
                                center: {
                                    lat: 41.715,
                                    lng: 44.78
                                },
                                zoom: 13,
                                styles: mapStyles,
                                disableDefaultUI: true,
                                zoomControl: true,
                                zoomControlOptions: {
                                    position: google.maps.ControlPosition.RIGHT_TOP
                                }
                            });
                            const clinics = s.root.clinics || [];
                            clinics.forEach((c)=>{
                                if (!c.lat || !c.lng) return;
                                const marker = new google.maps.Marker({
                                    position: {
                                        lat: c.lat,
                                        lng: c.lng
                                    },
                                    map: map,
                                    title: c.name,
                                    icon: {
                                        path: 'M12 2C9.5 2 7 3.5 6 5.5c-1.5 3-.5 5 0 7.5.5 2.5-.5 5.5 1 8 .5.8 1.5 1 2 1s1-.5 1.5-2c.5-1.5 1-2 1.5-2s1 .5 1.5 2c.5 1.5 1 2 1.5 2s1.5-.2 2-1c1.5-2.5.5-5.5 1-8 .5-2.5 1.5-4.5 0-7.5C17 3.5 14.5 2 12 2z',
                                        fillColor: '#0D1117',
                                        fillOpacity: 1,
                                        strokeColor: '#FFFFFF',
                                        strokeWeight: 2,
                                        scale: 1.2,
                                        anchor: new google.maps.Point(12, 22)
                                    }
                                });
                                const info = new google.maps.InfoWindow({
                                    content: '<div style="font-family:system-ui;padding:4px"><b>' + c.name + '</b><br><span style="color:#00C9A7">' + c.district + "</span><br>\u2605 " + c.rating + '</div>'
                                });
                                marker.addListener('click', ()=>info.open(map, marker));
                            });
                            el.node._map = map;
                        };
                        if (window.google && window.google.maps) initMap();
                        else {
                            window.initClinicMap = initMap;
                            const script = document.createElement('script');
                            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAIjI_gvh-OUSEdzgfHKh2v1GvwiEp2Ztg&callback=initClinicMap';
                            script.async = true;
                            script.defer = true;
                            document.head.appendChild(script);
                        }
                    }
                },
                ShareLocationBtn: {
                    tag: 'button',
                    flow: 'x',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'Z A',
                    round: 'Z',
                    background: '#0D1117',
                    color: '#FFFFFF',
                    border: 'none',
                    fontSize: 'Z',
                    fontWeight: '600',
                    cursor: 'pointer',
                    width: '100%',
                    transition: 'all 0.2s ease',
                    ':hover': {
                        opacity: '0.9'
                    },
                    onClick: (e, el, s)=>{
                        if (navigator.geolocation) navigator.geolocation.getCurrentPosition((pos)=>{
                            s.root.update({
                                userLat: pos.coords.latitude,
                                userLng: pos.coords.longitude,
                                locationShared: true
                            });
                        }, ()=>{
                            alert('Location access denied. Please enable location services.');
                        });
                    },
                    LocIcon: {
                        extends: 'Icon',
                        icon: 'mapPin',
                        width: 'A',
                        height: 'A',
                        color: '#FFFFFF'
                    },
                    LocText: {
                        text: (el, s)=>s.root.locationShared ? '{{ locationShared | polyglot }}' : '{{ shareLocation | polyglot }}'
                    }
                }
            }
        }
    },
    StatsBar: {
        tag: 'section',
        flow: 'x',
        align: 'center center',
        gap: 'C',
        padding: 'D B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        flexWrap: 'wrap',
        '@mobileL': {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 'B',
            padding: 'C A'
        },
        Stat1: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum: {
                text: '150+',
                fontSize: 'D',
                fontWeight: '800',
                color: '#0D1117',
                letterSpacing: '-0.02em'
            },
            StatLabel: {
                text: '{{ statClinics | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: '500'
            }
        },
        StatDiv1: {
            width: '1px',
            background: 'rgba(0,0,0,0.1)',
            height: 'B',
            '@mobileL': {
                display: 'none'
            }
        },
        Stat2: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum: {
                text: '65%',
                fontSize: 'D',
                fontWeight: '800',
                color: '#0D1117',
                letterSpacing: '-0.02em'
            },
            StatLabel: {
                text: '{{ statNoShows | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: '500'
            }
        },
        StatDiv2: {
            width: '1px',
            background: 'rgba(0,0,0,0.1)',
            height: 'B',
            '@mobileL': {
                display: 'none'
            }
        },
        Stat3: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum: {
                text: '24/7',
                fontSize: 'D',
                fontWeight: '800',
                color: '#0D1117',
                letterSpacing: '-0.02em'
            },
            StatLabel: {
                text: '{{ statBooking | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: '500'
            }
        },
        StatDiv3: {
            width: '1px',
            background: 'rgba(0,0,0,0.1)',
            height: 'B',
            '@mobileL': {
                display: 'none'
            }
        },
        Stat4: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum: {
                text: '500+',
                fontSize: 'D',
                fontWeight: '800',
                color: '#0D1117',
                letterSpacing: '-0.02em'
            },
            StatLabel: {
                text: '{{ statDentists | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: '500'
            }
        },
        StatDiv4: {
            width: '1px',
            background: 'rgba(0,0,0,0.1)',
            height: 'B',
            '@mobileL': {
                display: 'none'
            }
        },
        Stat5: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum: {
                text: '4.8',
                fontSize: 'D',
                fontWeight: '800',
                color: '#0D1117',
                letterSpacing: '-0.02em'
            },
            StatLabel: {
                text: '{{ statRating | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: '500'
            }
        },
        StatDiv5: {
            width: '1px',
            background: 'rgba(0,0,0,0.1)',
            height: 'B',
            '@mobileL': {
                display: 'none'
            }
        },
        Stat6: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum: {
                text: '12K+',
                fontSize: 'D',
                fontWeight: '800',
                color: '#0D1117',
                letterSpacing: '-0.02em'
            },
            StatLabel: {
                text: '{{ statPatients | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: '500'
            }
        }
    },
    ClaimBanner: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        gap: 'Z',
        padding: 'C B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        '@mobileL': {
            padding: 'B A'
        },
        BannerBox: {
            extends: 'Link',
            href: '/business',
            textDecoration: 'none',
            flow: 'y',
            align: 'flex-start flex-start',
            gap: 'Z',
            padding: 'B C',
            round: 'B',
            background: '#0D1117',
            width: '100%',
            position: 'relative',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            ':hover': {
                opacity: '0.95'
            },
            '@mobileL': {
                padding: 'B A'
            },
            BannerTitle: {
                tag: 'h3',
                text: '{{ ownClinic | polyglot }}',
                fontSize: 'E',
                fontWeight: '700',
                color: '#FFFFFF',
                letterSpacing: '-0.03em'
            },
            BannerText: {
                text: '{{ claimText | polyglot }}',
                fontSize: 'A',
                fontWeight: '400',
                color: '#FFFFFF',
                lineHeight: '1.6',
                maxWidth: 'I'
            },
            BannerBtn: {
                extends: 'Link',
                href: '/business',
                text: '{{ enterSpaceForClinics | polyglot }}',
                background: 'transparent',
                color: '#FFFFFF',
                fontWeight: '600',
                padding: '0',
                fontSize: 'A',
                textDecoration: 'none',
                cursor: 'pointer',
                position: 'absolute',
                bottom: 'C',
                right: 'C',
                transition: 'all 0.2s ease',
                ':hover': {
                    color: '#FFFFFF'
                }
            }
        }
    },
    FooterSection: {
        tag: 'footer',
        flow: 'y',
        gap: 'Z',
        padding: 'B B',
        width: '100%',
        borderTop: '1px solid inkBorder',
        align: 'center center',
        FooterTop: {
            flow: 'x',
            align: 'center space-between',
            width: '100%',
            maxWidth: 'K',
            '@mobileL': {
                flow: 'y',
                gap: 'A',
                align: 'center center'
            },
            FooterLogo: {
                text: 'MCAI',
                fontSize: 'A',
                fontWeight: '700',
                color: 'inkText'
            },
            FooterLinks: {
                flow: 'x',
                gap: 'B',
                FeatLink: {
                    extends: 'Link',
                    text: '{{ features2 | polyglot }}',
                    href: '/#features',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    },
                    transition: 'color 0.2s ease'
                },
                PriceLink: {
                    extends: 'Link',
                    text: '{{ pricing2 | polyglot }}',
                    href: '/#pricing',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    },
                    transition: 'color 0.2s ease'
                },
                BookLink: {
                    extends: 'Link',
                    text: '{{ book | polyglot }}',
                    href: '/booking',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    },
                    transition: 'color 0.2s ease'
                },
                DashLink: {
                    extends: 'Link',
                    text: '{{ dashboard2 | polyglot }}',
                    href: '/dashboard',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    },
                    transition: 'color 0.2s ease'
                }
            },
            FooterContact: {
                text: 'hello@MCAI.ge',
                fontSize: 'Z',
                color: 'inkMuted'
            }
        },
        FooterCopy: {
            text: '{{ u00a92026Mcai | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            marginTop: 'Z'
        }
    }
};



const $1a65142485aed81e$export$8252328d63b22f49 = {
    extends: 'Page',
    flow: 'y',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    ClinicsData: {
        fetch: (0, $b9becae6bd307dfe$export$2e68a2c819d29977),
        display: 'none'
    },
    NavBar: {},
    BookingContainer: {
        flow: 'y',
        gap: 'B',
        padding: 'C B',
        maxWidth: 'J',
        margin: '0 auto',
        width: '100%',
        '@mobileL': {
            padding: 'B A'
        },
        BookingTitle: {
            tag: 'h1',
            text: '{{ bookingTitle | polyglot }}',
            fontSize: 'C',
            fontWeight: '700',
            letterSpacing: '-0.02em',
            textAlign: 'center',
            color: 'inkText'
        },
        BookingSubtitle: {
            text: '{{ selectClinic | polyglot }}',
            fontSize: 'A',
            color: 'inkMuted',
            textAlign: 'center',
            marginBottom: 'A'
        },
        BookingModeToggle: {
            flow: 'x',
            gap: 'Y',
            align: 'center center',
            padding: 'Y',
            round: 'Z',
            background: 'inkSurface',
            border: '1px solid inkBorder',
            width: 'fit-content',
            margin: '0 auto',
            marginBottom: 'A',
            show: (el, s)=>s.root.activeBookingStep === 1,
            ClinicModeBtn: {
                extends: 'Button',
                text: '{{ bookByClinic | polyglot }}',
                padding: 'Y A',
                round: 'Y',
                fontSize: 'Z',
                fontWeight: '600',
                cursor: 'pointer',
                border: 'none',
                background: (el, s)=>(s.root.bookingMode || 'clinic') === 'clinic' ? '#0D1117' : 'transparent',
                color: (el, s)=>(s.root.bookingMode || 'clinic') === 'clinic' ? '#FFFFFF' : 'inkMuted',
                onClick: (e, el, s)=>s.root.update({
                        bookingMode: 'clinic',
                        hidePrices: false
                    })
            },
            DoctorModeBtn: {
                extends: 'Button',
                text: '{{ bookByDoctor | polyglot }}',
                padding: 'Y A',
                round: 'Y',
                fontSize: 'Z',
                fontWeight: '600',
                cursor: 'pointer',
                border: 'none',
                background: (el, s)=>s.root.bookingMode === 'doctor' ? '#0D1117' : 'transparent',
                color: (el, s)=>s.root.bookingMode === 'doctor' ? '#FFFFFF' : 'inkMuted',
                onClick: (e, el, s)=>s.root.update({
                        bookingMode: 'doctor',
                        hidePrices: true,
                        clinicDiscounts: {
                            'c1': {
                                percent: 15
                            },
                            'c3': {
                                percent: 10
                            },
                            'c5': {
                                percent: 20
                            }
                        }
                    })
            }
        },
        StepIndicator: {},
        StepClinic: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.activeBookingStep === 1 && (s.root.bookingMode || 'clinic') === 'clinic',
            StepHeading: {
                tag: 'h2',
                text: '{{ chooseClinic | polyglot }}',
                fontSize: 'B',
                fontWeight: '600',
                color: 'inkText'
            },
            SearchRow: {
                flow: 'x',
                gap: 'Z',
                align: 'center center',
                '@mobileL': {
                    flow: 'y'
                },
                SearchInput: {
                    extends: 'Input',
                    tag: 'input',
                    type: 'text',
                    placeholder: 'Search clinics, districts...',
                    padding: 'Z A',
                    round: 'A',
                    background: 'inkSurface',
                    color: 'inkText',
                    border: '1px solid inkBorder',
                    fontSize: 'Z',
                    flex: '1',
                    onInput: (e, el, s)=>s.root.update({
                            clinicFilter: el.node.value
                        })
                },
                NearMeBtn: {
                    extends: 'Button',
                    text: '{{ nearMe | polyglot }}',
                    background: 'rgba(0,0,0,0.06)',
                    color: '#0D1117',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    fontSize: 'Z',
                    cursor: 'pointer',
                    border: 'none'
                }
            },
            ClinicCount: {
                text: (el, s)=>{
                    const clinics = s.root.clinics || [];
                    const q = s.root.clinicFilter;
                    if (!q) return clinics.length + ' clinics available';
                    const n = clinics.filter((c)=>c.name.toLowerCase().includes(q.toLowerCase()) || c.district.toLowerCase().includes(q.toLowerCase()) || (c.address || '').toLowerCase().includes(q.toLowerCase())).length;
                    return n + ' clinics found';
                },
                fontSize: 'Y',
                color: 'inkMuted'
            },
            ClinicList: {
                flow: 'y',
                gap: 'Z',
                maxHeight: 'I',
                overflow: 'auto',
                children: (el, s)=>s.root.clinics || [],
                childrenAs: 'state',
                childExtends: 'ClinicCard'
            }
        },
        StepDoctor: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.activeBookingStep === 1 && s.root.bookingMode === 'doctor',
            StepHeading: {
                tag: 'h2',
                text: '{{ chooseDoctor | polyglot }}',
                fontSize: 'B',
                fontWeight: '600',
                color: 'inkText'
            },
            DoctorSearchInput: {
                extends: 'Input',
                tag: 'input',
                type: 'text',
                placeholder: 'Search doctors by name or specialty...',
                padding: 'Z A',
                round: 'A',
                background: 'inkSurface',
                color: 'inkText',
                border: '1px solid inkBorder',
                fontSize: 'Z',
                width: '100%',
                onInput: (e, el, s)=>s.root.update({
                        doctorFilter: el.node.value
                    })
            },
            DoctorList: {
                flow: 'y',
                gap: 'Z',
                maxHeight: 'I',
                overflow: 'auto',
                marginTop: 'Z',
                children: (el, s)=>{
                    const doctors = s.root.sampleDoctors || [
                        {
                            doctorName: 'Dr. Nino Beridze',
                            specialties: [
                                'Implantology',
                                'Oral Surgery'
                            ],
                            rating: 4.9,
                            reviewCount: 187,
                            clinics: [
                                {
                                    clinicName: 'Denta Plus',
                                    clinicId: 'c1',
                                    availableTimes: [
                                        '09:00',
                                        '11:30',
                                        '14:00'
                                    ]
                                },
                                {
                                    clinicName: 'SmileLab',
                                    clinicId: 'c3',
                                    availableTimes: [
                                        '10:00',
                                        '15:00'
                                    ]
                                }
                            ]
                        },
                        {
                            doctorName: 'Dr. Giorgi Tsiklauri',
                            specialties: [
                                'Orthodontics',
                                'Cosmetic Dentistry'
                            ],
                            rating: 4.8,
                            reviewCount: 124,
                            clinics: [
                                {
                                    clinicName: 'OrthoGeorgia',
                                    clinicId: 'c2',
                                    availableTimes: [
                                        '09:30',
                                        '13:00'
                                    ]
                                },
                                {
                                    clinicName: 'Denta Plus',
                                    clinicId: 'c1',
                                    availableTimes: [
                                        '16:00'
                                    ]
                                }
                            ]
                        },
                        {
                            doctorName: 'Dr. Tamta Kvaratskhelia',
                            specialties: [
                                'Pediatric Dentistry',
                                'Preventive Care'
                            ],
                            rating: 4.7,
                            reviewCount: 96,
                            clinics: [
                                {
                                    clinicName: 'KidSmile Clinic',
                                    clinicId: 'c4',
                                    availableTimes: [
                                        '10:00',
                                        '12:00',
                                        '14:30'
                                    ]
                                },
                                {
                                    clinicName: 'SmileLab',
                                    clinicId: 'c3',
                                    availableTimes: [
                                        '09:00'
                                    ]
                                }
                            ]
                        },
                        {
                            doctorName: 'Dr. Dato Javakhishvili',
                            specialties: [
                                'Endodontics',
                                'Restorative'
                            ],
                            rating: 4.6,
                            reviewCount: 78,
                            clinics: [
                                {
                                    clinicName: 'CavityFree',
                                    clinicId: 'c5',
                                    availableTimes: [
                                        '11:00',
                                        '13:30',
                                        '16:00'
                                    ]
                                }
                            ]
                        },
                        {
                            doctorName: 'Dr. Ana Lomidze',
                            specialties: [
                                'Periodontics',
                                'Implantology'
                            ],
                            rating: 4.9,
                            reviewCount: 203,
                            clinics: [
                                {
                                    clinicName: 'Denta Plus',
                                    clinicId: 'c1',
                                    availableTimes: [
                                        '08:30',
                                        '12:00'
                                    ]
                                },
                                {
                                    clinicName: 'CavityFree',
                                    clinicId: 'c5',
                                    availableTimes: [
                                        '14:00',
                                        '17:00'
                                    ]
                                }
                            ]
                        }
                    ];
                    const q = s.root.doctorFilter;
                    if (!q) return doctors;
                    const lower = q.toLowerCase();
                    return doctors.filter((d)=>d.doctorName.toLowerCase().includes(lower) || (d.specialties || []).some((sp)=>sp.toLowerCase().includes(lower)));
                },
                childrenAs: 'state',
                childExtends: 'DoctorProfileCard'
            }
        },
        StepService: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.activeBookingStep === 2,
            StepHeading: {
                tag: 'h2',
                text: '{{ selectAService | polyglot }}',
                fontSize: 'B',
                fontWeight: '600',
                color: 'inkText'
            },
            ServiceList: {
                flow: 'y',
                gap: 'Z',
                children: (el, s)=>s.root.services,
                childrenAs: 'state',
                childExtends: 'ServiceOption'
            }
        },
        StepPreCheck: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.activeBookingStep === 3,
            StepHeading: {
                tag: 'h2',
                text: '{{ preCheckTitle | polyglot }}',
                fontSize: 'B',
                fontWeight: '600',
                color: 'inkText'
            },
            ServicePreCheck: {}
        },
        StepDate: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.activeBookingStep === 4,
            StepHeading: {
                tag: 'h2',
                text: '{{ pickADate | polyglot }}',
                fontSize: 'B',
                fontWeight: '600',
                color: 'inkText'
            },
            DateGrid: {
                flow: 'x',
                flexWrap: 'wrap',
                gap: 'Z',
                children: (el, s)=>s.root.dates,
                childrenAs: 'state',
                childExtends: 'DateOption'
            }
        },
        StepTime: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.activeBookingStep === 5,
            StepHeading: {
                tag: 'h2',
                text: '{{ pickATime | polyglot }}',
                fontSize: 'B',
                fontWeight: '600',
                color: 'inkText'
            },
            TimeGrid: {
                flow: 'x',
                flexWrap: 'wrap',
                gap: 'Z',
                children: (el, s)=>s.root.times,
                childrenAs: 'state',
                childExtends: 'TimeOption'
            }
        },
        StepConfirm: {
            flow: 'y',
            gap: 'A',
            show: (el, s)=>s.root.activeBookingStep === 6,
            padding: 'B',
            round: 'A',
            background: 'inkMid',
            border: '1px solid inkBorder',
            StepHeading: {
                tag: 'h2',
                text: '{{ confirmYourBooking | polyglot }}',
                fontSize: 'B',
                fontWeight: '700',
                color: 'inkText'
            },
            SummaryClinic: {
                flow: 'x',
                gap: 'Z',
                SumLabel: {
                    text: '{{ clinicLabel | polyglot }}',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    fontWeight: '600'
                },
                SumValue: {
                    text: (el, s)=>s.root.selectedClinic || "\u2014",
                    fontSize: 'Z',
                    color: 'inkText'
                }
            },
            SummaryService: {
                flow: 'x',
                gap: 'Z',
                SumLabel: {
                    text: '{{ serviceLabel | polyglot }}',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    fontWeight: '600'
                },
                SumValue: {
                    text: (el, s)=>s.root.selectedService || "\u2014",
                    fontSize: 'Z',
                    color: 'inkText'
                }
            },
            SummaryDate: {
                flow: 'x',
                gap: 'Z',
                SumLabel: {
                    text: '{{ dateLabel | polyglot }}',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    fontWeight: '600'
                },
                SumValue: {
                    text: (el, s)=>s.root.selectedDate || "\u2014",
                    fontSize: 'Z',
                    color: 'inkText'
                }
            },
            SummaryTime: {
                flow: 'x',
                gap: 'Z',
                SumLabel: {
                    text: '{{ timeLabel | polyglot }}',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    fontWeight: '600'
                },
                SumValue: {
                    text: (el, s)=>s.root.selectedTime || "\u2014",
                    fontSize: 'Z',
                    color: 'inkText'
                }
            },
            ConfirmBtn: {
                extends: 'Button',
                text: '{{ confirmBooking | polyglot }}',
                marginTop: 'A',
                background: '#0D1117',
                color: '#FFFFFF',
                fontWeight: '600',
                padding: 'Z B',
                round: 'B',
                fontSize: 'Z2',
                cursor: 'pointer',
                border: 'none',
                width: '100%',
                textAlign: 'center'
            }
        },
        BookingNav: {
            flow: 'x',
            gap: 'A',
            align: 'center space-between',
            marginTop: 'B',
            BackBtn: {
                extends: 'Button',
                text: '{{ back | polyglot }}',
                show: (el, s)=>s.root.activeBookingStep > 1,
                background: 'inkSurface',
                color: 'inkText',
                fontWeight: '600',
                padding: 'Z B',
                round: 'B',
                fontSize: 'Z',
                cursor: 'pointer',
                border: '1px solid inkBorder',
                onClick: (e, el, s)=>s.root.update({
                        activeBookingStep: s.root.activeBookingStep - 1
                    })
            },
            NextBtn: {
                extends: 'Button',
                text: '{{ next | polyglot }}',
                show: (el, s)=>s.root.activeBookingStep < 6,
                background: '#0D1117',
                color: '#FFFFFF',
                fontWeight: '600',
                padding: 'Z B',
                round: 'B',
                fontSize: 'Z',
                cursor: 'pointer',
                border: 'none',
                marginLeft: 'auto',
                onClick: (e, el, s)=>s.root.update({
                        activeBookingStep: s.root.activeBookingStep + 1
                    })
            }
        }
    }
};


const $4a3b6042fbd7c8f3$export$a5f98448b9315739 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    onRender: (el, s)=>{
        const path = window.location.pathname;
        const tabMap = {
            '/dashboard': 'appointments',
            '/dashboard/patients': 'patients',
            '/dashboard/calendar': 'calendar',
            '/dashboard/finance': 'finance',
            '/dashboard/settings': 'settings'
        };
        const tab = tabMap[path] || 'appointments';
        if (tab !== s.root.activeTab) s.root.update({
            activeTab: tab
        });
    },
    NavSidebar: {},
    AppointmentModal: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── APPOINTMENTS ──────────────────────────────
            AppointmentsView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeTab === 'appointments',
                StatsRow: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y'
                    },
                    StatToday: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'B',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        StatLabel: {
                            text: "Today's Appts",
                            fontSize: 'Z',
                            color: 'inkMuted',
                            fontWeight: '500'
                        },
                        StatValue: {
                            text: '6',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'inkText',
                            letterSpacing: '-0.02em'
                        }
                    },
                    StatRevenue: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'B',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        StatLabel: {
                            text: '{{ revenueToday | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted',
                            fontWeight: '500'
                        },
                        StatValue: {
                            text: "\u20BE1,380",
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'inkText',
                            letterSpacing: '-0.02em'
                        }
                    },
                    StatNoShows: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'B',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        StatLabel: {
                            text: '{{ noshows | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted',
                            fontWeight: '500'
                        },
                        StatValue: {
                            text: '0',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'green',
                            letterSpacing: '-0.02em'
                        }
                    },
                    StatConfirmed: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'B',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        StatLabel: {
                            text: '{{ confirmed | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted',
                            fontWeight: '500'
                        },
                        StatValue: {
                            text: '83%',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'inkText',
                            letterSpacing: '-0.02em'
                        }
                    }
                },
                ApptTable: {
                    flow: 'y',
                    background: 'inkMid',
                    round: 'A',
                    border: '1px solid inkBorder',
                    overflow: 'hidden',
                    ApptHeaderRow: {
                        display: 'grid',
                        gridTemplateColumns: '70px 1fr 1fr 1fr 100px',
                        padding: 'Z A',
                        borderBottom: '1px solid inkBorder',
                        '@mobileL': {
                            display: 'none'
                        },
                        ColTime: {
                            text: '{{ time | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        ColPatient: {
                            text: '{{ patient | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        ColService: {
                            text: '{{ service | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        ColDoctor: {
                            text: '{{ doctor | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        ColStatus: {
                            text: '{{ status2 | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X',
                            textAlign: 'right'
                        }
                    },
                    children: (el, s)=>s.root.appointments,
                    childrenAs: 'state',
                    childExtends: 'AppointmentRow'
                }
            },
            // ─── PATIENTS ──────────────────────────────────
            PatientsView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeTab === 'patients',
                PatientsToolbar: {
                    flow: 'x',
                    gap: 'A',
                    align: 'center space-between',
                    '@mobileL': {
                        flow: 'y'
                    },
                    PatientSearch: {
                        extends: 'Input',
                        tag: 'input',
                        type: 'text',
                        placeholder: 'Search patients...',
                        padding: 'Z A',
                        round: 'A',
                        background: 'inkSurface',
                        color: 'inkText',
                        border: '1px solid inkBorder',
                        fontSize: 'Z',
                        flex: '1'
                    },
                    AddPatientBtn: {
                        extends: 'Button',
                        text: '{{ addPatient | polyglot }}',
                        background: '#0D1117',
                        color: '#FFFFFF',
                        fontWeight: '600',
                        padding: 'Z A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none'
                    }
                },
                PatientGrid: {
                    flow: 'y',
                    gap: 'Y',
                    children: (el, s)=>s.root.patients,
                    childrenAs: 'state',
                    childExtends: 'PatientCard'
                }
            },
            // ─── CALENDAR ──────────────────────────────────
            CalendarView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeTab === 'appointments' || s.root.activeTab === 'calendar',
                CalToolbar: {
                    flow: 'x',
                    align: 'center space-between',
                    marginBottom: 'Z',
                    CalTitle: {
                        tag: 'h3',
                        text: '{{ mondayMarch19 | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    DoctorLegend: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        LegDoc1: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            Dot1: {
                                width: 'Z',
                                height: 'Z',
                                round: 'Z',
                                background: 'teal'
                            },
                            Lab1: {
                                text: 'Dr. Lomidze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        LegDoc2: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            Dot2: {
                                width: 'Z',
                                height: 'Z',
                                round: 'Z',
                                background: 'amber'
                            },
                            Lab2: {
                                text: 'Dr. Beridze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        LegDoc3: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            Dot3: {
                                width: 'Z',
                                height: 'Z',
                                round: 'Z',
                                background: 'purple'
                            },
                            Lab3: {
                                text: 'Dr. Kvaratskhelia',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        LegDoc4: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            Dot4: {
                                width: 'Z',
                                height: 'Z',
                                round: 'Z',
                                background: 'green'
                            },
                            Lab4: {
                                text: 'Hyg. Nino',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    }
                },
                CalendarGrid: {
                    flow: 'y',
                    background: 'inkMid',
                    round: 'A',
                    border: '1px solid inkBorder',
                    overflow: 'auto',
                    maxHeight: 'J',
                    Row0800: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '08:00',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'R. Kharazishvili',
                                            time: '08:00',
                                            service: 'Crown Consult',
                                            doctor: 'Dr. Lomidze',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "R. Kharazishvili \u2014 Crown Consult",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'K. Gabrichidze',
                                            time: '08:00',
                                            service: 'New Patient Exam',
                                            doctor: 'Dr. Beridze',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "K. Gabrichidze \u2014 New Patient Exam",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row0830: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '08:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'T. Kapanadze',
                                            time: '08:30',
                                            service: 'Consultation',
                                            doctor: 'Dr. Kvaratskhelia',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "T. Kapanadze \u2014 Consultation",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'K. Gabrichidze',
                                            time: '08:30',
                                            service: 'New Patient Exam cont.',
                                            doctor: 'Dr. Beridze',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "K. Gabrichidze \u2014 Exam cont.",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row0900: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '09:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'Giorgi Beridze',
                                            time: '09:00',
                                            service: 'Checkup',
                                            doctor: 'Dr. Lomidze',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "G. Beridze \u2014 Checkup",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'D. Gelashvili',
                                            time: '09:00',
                                            service: 'SRP Quad',
                                            doctor: 'Dr. Beridze',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "D. Gelashvili \u2014 SRP Quad",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtC: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid green',
                                paddingLeft: 'Z',
                                background: 'green.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'green.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'I. Diasamidze',
                                            time: '09:00',
                                            service: 'Prophy Clean',
                                            doctor: 'Hyg. Nino',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "I. Diasamidze \u2014 Prophy Clean",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row0930: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '09:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                Name: {
                                    text: "T. Kapanadze \u2014 Crown Prep",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "D. Gelashvili \u2014 SRP cont.",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1000: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '10:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                Name: {
                                    text: "M. Tsiklauri \u2014 Exam + X-Ray",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid green',
                                paddingLeft: 'Z',
                                background: 'green.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'green.15'
                                },
                                Name: {
                                    text: "T. Lomidze \u2014 Perio Maint.",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1030: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '10:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'Nino Kapanadze',
                                            time: '10:30',
                                            service: 'Whitening',
                                            doctor: 'Dr. Kvaratskhelia',
                                            status: 'Pending'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "N. Kapanadze \u2014 Whitening",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "Z. Dolidze \u2014 Implant Consult",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtC: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid green',
                                paddingLeft: 'Z',
                                background: 'green.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'green.15'
                                },
                                Name: {
                                    text: "N. Gogiberidze \u2014 Fluoride Tx",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1100: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '11:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'Davit Gelashvili',
                                            time: '11:00',
                                            service: 'Implant Phase 2',
                                            doctor: 'Dr. Lomidze',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "D. Gelashvili \u2014 Implant Ph.2",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                Name: {
                                    text: "S. Meladze \u2014 Composite Fill",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtC: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid green',
                                paddingLeft: 'Z',
                                background: 'green.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'green.15'
                                },
                                Name: {
                                    text: "L. Mchedlishvili \u2014 Sealants",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1130: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '11:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                Name: {
                                    text: "R. Kharazishvili \u2014 Bridge Prep",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "E. Tsereteli \u2014 Perio Check",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1200: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '12:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            LunchLabel: {
                                text: '{{ lunchBreak | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted',
                                fontStyle: 'italic'
                            }
                        }
                    },
                    Row1230: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '12:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                Name: {
                                    text: "A. Javakhishvili \u2014 Post-Op Review",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 4",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1300: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '13:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                Name: {
                                    text: "V. Papunashvili \u2014 Post-Op Check",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 4",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "A. Javakhishvili \u2014 Consultation",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1330: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '13:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                Name: {
                                    text: "B. Shengelia \u2014 Exam",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "G. Beridze \u2014 Whitening",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 4",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1400: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '14:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                Name: {
                                    text: "K. Gabrichidze \u2014 Root Canal",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'Mariam Tsiklauri',
                                            time: '14:00',
                                            service: 'Orthodontics',
                                            doctor: 'Dr. Beridze',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "M. Tsiklauri \u2014 Orthodontics",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtC: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                Name: {
                                    text: "V. Papunashvili \u2014 Extraction",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 4",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1430: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '14:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                Name: {
                                    text: "K. Gabrichidze \u2014 Root Canal cont.",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "Z. Dolidze \u2014 Implant Place",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1500: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '15:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                Name: {
                                    text: "T. Kapanadze \u2014 Crown Seat",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "L. Mchedlishvili \u2014 Ortho Check",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1530: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '15:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'Ana Javakhishvili',
                                            time: '15:30',
                                            service: 'Root Canal',
                                            doctor: 'Dr. Lomidze',
                                            status: 'Pending'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "A. Javakhishvili \u2014 Root Canal",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid green',
                                paddingLeft: 'Z',
                                background: 'green.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'green.15'
                                },
                                Name: {
                                    text: "B. Shengelia \u2014 Prophy Clean",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtC: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                Name: {
                                    text: "N. Kapanadze \u2014 Composite",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 4",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1600: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '16:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                Name: {
                                    text: "D. Gelashvili \u2014 Follow-Up",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid green',
                                paddingLeft: 'Z',
                                background: 'green.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'green.15'
                                },
                                Name: {
                                    text: "I. Diasamidze \u2014 Perio Review",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1630: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '16:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "E. Tsereteli \u2014 Exam Consult",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1700: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '17:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'Luka Mchedlishvili',
                                            time: '17:00',
                                            service: 'Extraction',
                                            doctor: 'Dr. Kvaratskhelia',
                                            status: 'Cancelled'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "L. Mchedlishvili \u2014 Extraction",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 4",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid teal',
                                paddingLeft: 'Z',
                                background: 'teal.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'teal.15'
                                },
                                Name: {
                                    text: "T. Lomidze \u2014 Scaling",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Lomidze \xb7 Cab 1",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1730: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '17:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                Name: {
                                    text: "M. Tsiklauri \u2014 Retainer Check",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1800: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '18:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            flow: 'x',
                            gap: 'Y',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z',
                            EvtA: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid amber',
                                paddingLeft: 'Z',
                                background: 'amber.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'amber.15'
                                },
                                onClick: (e, el, s)=>s.root.update({
                                        selectedAppointment: {
                                            patient: 'Tamara Lomidze',
                                            time: '18:00',
                                            service: 'Checkup',
                                            doctor: 'Dr. Beridze',
                                            status: 'Confirmed'
                                        },
                                        showAppointmentModal: true
                                    }),
                                Name: {
                                    text: "T. Lomidze \u2014 Checkup",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            EvtB: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                padding: 'Y Z',
                                round: 'Y',
                                borderLeft: '3px solid purple',
                                paddingLeft: 'Z',
                                background: 'purple.08',
                                cursor: 'pointer',
                                ':hover': {
                                    background: 'purple.15'
                                },
                                Name: {
                                    text: "N. Gogiberidze \u2014 Emergency",
                                    fontSize: 'Y',
                                    color: 'inkText'
                                },
                                Meta: {
                                    text: "Dr. Kvaratskhelia \xb7 Cab 4",
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    Row1830: {
                        flow: 'x',
                        borderBottom: '1px solid inkBorder',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '18:30',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z'
                        }
                    },
                    Row1900: {
                        flow: 'x',
                        minHeight: 'C',
                        TimeLabel: {
                            width: 'D',
                            padding: 'Y Z',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            textAlign: 'right',
                            text: '19:00',
                            fontWeight: '600',
                            flexShrink: '0'
                        },
                        SlotArea: {
                            flex: '1',
                            borderLeft: '1px solid inkBorder',
                            padding: 'Y Z'
                        }
                    }
                }
            },
            // ─── SETTINGS ─────────────────────────────────
            SettingsView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeTab === 'settings',
                SettingsForm: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    FieldClinicName: {
                        flow: 'y',
                        gap: 'Y',
                        FieldLabel: {
                            tag: 'label',
                            text: '{{ clinicName | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'inkMuted'
                        },
                        FieldInput: {
                            extends: 'Input',
                            tag: 'input',
                            type: 'text',
                            placeholder: 'Your Clinic Name',
                            value: 'Denta Plus',
                            padding: 'Z A',
                            round: 'A',
                            background: 'inkSurface',
                            color: 'inkText',
                            border: '1px solid inkBorder',
                            fontSize: 'Z',
                            width: '100%'
                        }
                    },
                    FieldPhone: {
                        flow: 'y',
                        gap: 'Y',
                        FieldLabel: {
                            tag: 'label',
                            text: '{{ phone | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'inkMuted'
                        },
                        FieldInput: {
                            extends: 'Input',
                            tag: 'input',
                            type: 'tel',
                            placeholder: '+995 XXX XXX XXX',
                            value: '+995 555 123 456',
                            padding: 'Z A',
                            round: 'A',
                            background: 'inkSurface',
                            color: 'inkText',
                            border: '1px solid inkBorder',
                            fontSize: 'Z',
                            width: '100%'
                        }
                    },
                    FieldAddress: {
                        flow: 'y',
                        gap: 'Y',
                        FieldLabel: {
                            tag: 'label',
                            text: '{{ address | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'inkMuted'
                        },
                        FieldInput: {
                            extends: 'Input',
                            tag: 'input',
                            type: 'text',
                            placeholder: 'Street, City',
                            value: 'Rustaveli Ave 42, Tbilisi',
                            padding: 'Z A',
                            round: 'A',
                            background: 'inkSurface',
                            color: 'inkText',
                            border: '1px solid inkBorder',
                            fontSize: 'Z',
                            width: '100%'
                        }
                    },
                    InsuranceSection: {
                        flow: 'y',
                        gap: 'Z',
                        marginTop: 'A',
                        InsuranceLabel: {
                            text: '{{ acceptedInsurance | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'inkMuted',
                            marginBottom: 'Y'
                        },
                        InsCheckAldagi: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center flex-start',
                            cursor: 'pointer',
                            CheckBox: {
                                tag: 'input',
                                attr: {
                                    type: 'checkbox',
                                    checked: true
                                },
                                width: 'Z',
                                height: 'Z'
                            },
                            CheckLabel: {
                                text: 'Aldagi',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        },
                        InsCheckGpi: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center flex-start',
                            cursor: 'pointer',
                            CheckBox: {
                                tag: 'input',
                                attr: {
                                    type: 'checkbox',
                                    checked: true
                                },
                                width: 'Z',
                                height: 'Z'
                            },
                            CheckLabel: {
                                text: 'GPI',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        },
                        InsCheckImedi: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center flex-start',
                            cursor: 'pointer',
                            CheckBox: {
                                tag: 'input',
                                attr: {
                                    type: 'checkbox'
                                },
                                width: 'Z',
                                height: 'Z'
                            },
                            CheckLabel: {
                                text: 'Imedi L',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        },
                        InsCheckUnison: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center flex-start',
                            cursor: 'pointer',
                            CheckBox: {
                                tag: 'input',
                                attr: {
                                    type: 'checkbox'
                                },
                                width: 'Z',
                                height: 'Z'
                            },
                            CheckLabel: {
                                text: '{{ unison | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        }
                    },
                    SaveBtn: {
                        extends: 'Button',
                        text: '{{ saveSettings | polyglot }}',
                        marginTop: 'A',
                        background: '#0D1117',
                        color: '#FFFFFF',
                        fontWeight: '600',
                        padding: 'Z B',
                        round: 'B',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none'
                    }
                }
            },
            // ─── AI REDIRECT ──────────────────────────────
            AiDashView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeTab === 'ai',
                padding: 'D',
                align: 'center center',
                AiRedirectMsg: {
                    flow: 'y',
                    gap: 'A',
                    align: 'center center',
                    textAlign: 'center',
                    AiIcon: {
                        extends: 'Icon',
                        icon: 'sparkle',
                        width: 'C',
                        height: 'C',
                        color: 'purple'
                    },
                    AiText: {
                        text: '{{ aiToolsAreAvailable | polyglot }}',
                        fontSize: 'A',
                        color: 'inkMuted'
                    },
                    AiLink: {
                        extends: 'Link',
                        text: '{{ openTheFullAi | polyglot }}',
                        href: '/ai',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'purple',
                        textDecoration: 'none',
                        cursor: 'pointer'
                    }
                }
            }
        }
    }
};


const $f250953c056a57a9$export$216d10c62dfd0dd9 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>{
                        var path = window.location.pathname;
                        var tab = 'overview';
                        if (path === '/chart') tab = 'chart';
                        else if (path === '/perio') tab = 'perio';
                        else if (path === '/treatment-plan') tab = 'treatmentPlan';
                        else if (path === '/clinical-notes') tab = 'notes';
                        else if (path === '/medical-history') tab = 'medHistory';
                        s.root.update({
                            activeTab: 'patients',
                            activePatientSection: tab,
                            medHistorySubTab: 'conditions',
                            addEventOpen: false,
                            addNewDropOpen: false
                        });
                    });
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── PATIENT HEADER ──────────────────────────
            PatientHeader: {
                flow: 'x',
                gap: 'A',
                align: 'center flex-start',
                padding: 'B',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                '@mobileL': {
                    flow: 'y',
                    align: 'center center',
                    textAlign: 'center'
                },
                AvatarCircle: {
                    width: 'D',
                    height: 'D',
                    round: 'E',
                    background: '#0D1117',
                    color: '#FFFFFF',
                    fontWeight: '700',
                    fontSize: 'B',
                    flow: 'x',
                    align: 'center center',
                    text: 'GB',
                    flexShrink: '0'
                },
                PatientInfo: {
                    flow: 'y',
                    gap: 'Y',
                    flex: '1',
                    PatientName: {
                        tag: 'h2',
                        text: '{{ giorgiBeridze | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    PatientMeta: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        AgeTag: {
                            text: '{{ age34 | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted'
                        },
                        PhoneTag: {
                            text: '+995 555 11 22 33',
                            fontSize: 'Z',
                            color: 'inkMuted'
                        },
                        LastVisitTag: {
                            text: '{{ lastVisitMar10 | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted'
                        },
                        NextApptTag: {
                            text: '{{ nextMar19 | polyglot }}',
                            fontSize: 'Z',
                            color: 'teal'
                        }
                    },
                    AllergyTags: {
                        flow: 'x',
                        gap: 'Y',
                        marginTop: 'Y',
                        TagPenicillin: {
                            text: '{{ penicillin | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'red.15',
                            color: 'red'
                        },
                        TagLatex: {
                            text: '{{ latex | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'red.15',
                            color: 'red'
                        }
                    },
                    ChapterTags: {
                        flow: 'x',
                        gap: 'Y',
                        marginTop: 'X',
                        flexWrap: 'wrap',
                        TagFollowup: {
                            text: 'Follow-up',
                            fontSize: 'Y',
                            fontWeight: '500',
                            padding: 'X Z',
                            round: 'B',
                            background: 'teal.12',
                            color: 'teal'
                        },
                        TagRootCanal: {
                            text: 'Root Canal',
                            fontSize: 'Y',
                            fontWeight: '500',
                            padding: 'X Z',
                            round: 'B',
                            background: 'purple.12',
                            color: 'purple'
                        },
                        TagRestorative: {
                            text: 'Restorative',
                            fontSize: 'Y',
                            fontWeight: '500',
                            padding: 'X Z',
                            round: 'B',
                            background: 'blue.12',
                            color: 'blue'
                        },
                        TagInitial: {
                            text: 'Initial Exam',
                            fontSize: 'Y',
                            fontWeight: '500',
                            padding: 'X Z',
                            round: 'B',
                            background: 'inkSurface',
                            color: 'inkMuted',
                            border: '1px solid inkBorder'
                        }
                    }
                }
            },
            // ─── PATIENT TABS (merged with med history subtabs) ──────────────────
            PatientTabs: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                flexWrap: 'wrap',
                TabProfile: {
                    text: 'Profile',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.activePatientSection === 'profile' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activePatientSection === 'profile' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activePatientSection: 'profile'
                        })
                },
                TabOverview: {
                    text: 'Timeline',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.activePatientSection === 'overview' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activePatientSection === 'overview' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activePatientSection: 'overview'
                        })
                },
                TabChart: {
                    text: '{{ navChart | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.activePatientSection === 'chart' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activePatientSection === 'chart' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activePatientSection: 'chart'
                        })
                },
                TabTreatmentPlan: {
                    text: '{{ treatmentPlanTab | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.activePatientSection === 'treatmentPlan' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activePatientSection === 'treatmentPlan' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activePatientSection: 'treatmentPlan'
                        })
                },
                TabMedHistory: {
                    text: '{{ navMedHistory | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.activePatientSection === 'medHistory' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activePatientSection === 'medHistory' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activePatientSection: 'medHistory'
                        })
                },
                TabDocuments: {
                    text: '{{ documents | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.activePatientSection === 'documents' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activePatientSection === 'documents' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activePatientSection: 'documents'
                        })
                },
                TabConsent: {
                    text: 'Consent',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.activePatientSection === 'consent' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activePatientSection === 'consent' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activePatientSection: 'consent'
                        })
                },
                MedHistSep: {
                    show: (el, s)=>s.root.activePatientSection === 'medHistory',
                    width: '1px',
                    alignSelf: 'stretch',
                    background: 'inkBorder',
                    margin: '0 Y',
                    flexShrink: '0'
                },
                SubTabConditions: {
                    show: (el, s)=>s.root.activePatientSection === 'medHistory',
                    text: '{{ conditions | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.medHistorySubTab === 'conditions' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.medHistorySubTab === 'conditions' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            medHistorySubTab: 'conditions'
                        })
                },
                SubTabMedications: {
                    show: (el, s)=>s.root.activePatientSection === 'medHistory',
                    text: '{{ medications | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.medHistorySubTab === 'medications' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.medHistorySubTab === 'medications' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            medHistorySubTab: 'medications'
                        })
                },
                SubTabAllergies: {
                    show: (el, s)=>s.root.activePatientSection === 'medHistory',
                    text: '{{ allergies | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.medHistorySubTab === 'allergies' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.medHistorySubTab === 'allergies' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            medHistorySubTab: 'allergies'
                        })
                },
                SubTabVitals: {
                    show: (el, s)=>s.root.activePatientSection === 'medHistory',
                    text: '{{ vitals | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.medHistorySubTab === 'vitals' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.medHistorySubTab === 'vitals' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            medHistorySubTab: 'vitals'
                        })
                },
                SubTabImaging: {
                    show: (el, s)=>s.root.activePatientSection === 'medHistory',
                    text: '{{ imaging | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: (el, s)=>s.root.medHistorySubTab === 'imaging' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.medHistorySubTab === 'imaging' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            medHistorySubTab: 'imaging'
                        })
                },
                // ─── Add New split-button (right side of tab bar) ─
                TabSpacer: {
                    flex: '1'
                },
                AddNewDropdownWrap: {
                    position: 'relative',
                    alignSelf: 'center',
                    flow: 'x',
                    // Left: clicking opens the EHR form with current/default type
                    AddNewMainBtn: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        padding: 'Y A',
                        borderRadius: '6px 0 0 6px',
                        background: 'teal',
                        color: 'white',
                        fontSize: 'Y',
                        fontWeight: '600',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        onClick: (e, el, s)=>s.root.update({
                                addNewDropOpen: false,
                                addEventOpen: true
                            }),
                        BtnLabel: {
                            tag: 'span',
                            text: '+ Add New'
                        }
                    },
                    // Right: arrow opens the type-picker dropdown
                    AddNewArrowBtn: {
                        flow: 'x',
                        align: 'center center',
                        padding: 'Y Z',
                        borderLeft: '1px solid rgba(255,255,255,0.25)',
                        borderRadius: '0 6px 6px 0',
                        background: 'teal',
                        color: 'white',
                        fontSize: 'Y',
                        cursor: 'pointer',
                        onClick: (e, el, s)=>{
                            e.stopPropagation();
                            s.root.update({
                                addNewDropOpen: !s.root.addNewDropOpen
                            });
                        },
                        ArrowIcon: {
                            tag: 'span',
                            text: "\u25BE"
                        }
                    },
                    DropMenu: {
                        show: (el, s)=>!!s.root.addNewDropOpen,
                        position: 'absolute',
                        top: '110%',
                        right: '0',
                        zIndex: '9999',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderRadius: 'A',
                        overflow: 'hidden',
                        minWidth: '240px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
                        flow: 'y',
                        // ── Base Templates ────────────────────
                        BaseTemplatesHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            padding: 'Y A',
                            borderBottom: '1px solid inkBorder',
                            TplHeaderLabel: {
                                text: 'Base Templates',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'inkMuted',
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em'
                            }
                        },
                        Opt1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Consultation'
                                }),
                            TOpt1Icon: {
                                tag: 'span',
                                text: "\uD83D\uDCCB",
                                fontSize: 'Z'
                            },
                            TOpt1Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt1Name: {
                                    text: 'Consultation',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt1Desc: {
                                    text: 'SOAP notes, vitals, diagnosis',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Treatment'
                                }),
                            TOpt2Icon: {
                                tag: 'span',
                                text: "\uD83E\uDDB7",
                                fontSize: 'Z'
                            },
                            TOpt2Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt2Name: {
                                    text: 'Treatment',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt2Desc: {
                                    text: 'CDT code, teeth, procedure',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Diagnosis'
                                }),
                            TOpt3Icon: {
                                tag: 'span',
                                text: "\uD83D\uDD2C",
                                fontSize: 'Z'
                            },
                            TOpt3Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt3Name: {
                                    text: 'Diagnosis',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt3Desc: {
                                    text: 'ICD-10, severity, differential',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt4: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Prescription'
                                }),
                            TOpt4Icon: {
                                tag: 'span',
                                text: "\uD83D\uDC8A",
                                fontSize: 'Z'
                            },
                            TOpt4Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt4Name: {
                                    text: 'Prescription',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt4Desc: {
                                    text: 'Drug, dosage, route, frequency',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt5: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Imaging / Radiology'
                                }),
                            TOpt5Icon: {
                                tag: 'span',
                                text: "\uD83E\uDE7B",
                                fontSize: 'Z'
                            },
                            TOpt5Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt5Name: {
                                    text: 'Imaging / X-ray',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt5Desc: {
                                    text: 'DICOM, upload, radiation dose',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt6: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Lab Result'
                                }),
                            TOpt6Icon: {
                                tag: 'span',
                                text: "\uD83E\uDDEA",
                                fontSize: 'Z'
                            },
                            TOpt6Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt6Name: {
                                    text: 'Lab Result',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt6Desc: {
                                    text: 'LOINC, values, reference ranges',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt7: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Referral'
                                }),
                            TOpt7Icon: {
                                tag: 'span',
                                text: "\uD83D\uDCE4",
                                fontSize: 'Z'
                            },
                            TOpt7Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt7Name: {
                                    text: 'Referral',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt7Desc: {
                                    text: 'Specialist, reason, urgency',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt8: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Surgery'
                                }),
                            TOpt8Icon: {
                                tag: 'span',
                                text: "\uD83D\uDD2A",
                                fontSize: 'Z'
                            },
                            TOpt8Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt8Name: {
                                    text: 'Surgery',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt8Desc: {
                                    text: 'CDT/CPT, anesthesia, team',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt9: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Note'
                                }),
                            TOpt9Icon: {
                                tag: 'span',
                                text: "\uD83D\uDCDD",
                                fontSize: 'Z'
                            },
                            TOpt9Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt9Name: {
                                    text: 'Note',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt9Desc: {
                                    text: 'Free-text clinical note',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Opt10: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            color: 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Follow-up'
                                }),
                            TOpt10Icon: {
                                tag: 'span',
                                text: "\u21A9",
                                fontSize: 'Z'
                            },
                            TOpt10Info: {
                                flow: 'y',
                                gap: 'X',
                                TOpt10Name: {
                                    text: 'Follow-up',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                TOpt10Desc: {
                                    text: 'Post-treatment check, SOAP',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        // ── Custom Templates ─────────────────
                        CustomSep: {
                            height: '1px',
                            background: 'inkBorder'
                        },
                        CustomHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            padding: 'Y A',
                            CustHeaderLabel: {
                                text: 'Custom Templates',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'inkMuted',
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em'
                            }
                        },
                        CustomTpl1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Consultation'
                                }),
                            CTpl1Icon: {
                                tag: 'span',
                                text: "\u2B50",
                                fontSize: 'Z'
                            },
                            CTpl1Info: {
                                flow: 'y',
                                gap: 'X',
                                CTpl1Name: {
                                    text: 'New Patient Intake',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                CTpl1Desc: {
                                    text: 'Based on Consultation',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        CustomTpl2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y A',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    addNewDropOpen: false,
                                    addEventOpen: true,
                                    newEventType: 'Treatment'
                                }),
                            CTpl2Icon: {
                                tag: 'span',
                                text: "\u2B50",
                                fontSize: 'Z'
                            },
                            CTpl2Info: {
                                flow: 'y',
                                gap: 'X',
                                CTpl2Name: {
                                    text: 'Root Canal Protocol',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                CTpl2Desc: {
                                    text: 'Based on Treatment',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        AddCustomBtn: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            padding: 'Z A',
                            cursor: 'pointer',
                            borderTop: '1px solid inkBorder',
                            background: 'ink',
                            AddCustIcon: {
                                tag: 'span',
                                text: '+',
                                fontSize: 'A',
                                color: 'teal',
                                fontWeight: '700'
                            },
                            AddCustLabel: {
                                text: 'Create Custom Template',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'teal'
                            }
                        }
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // 0. PROFILE
            // ═══════════════════════════════════════════════
            ProfileSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activePatientSection === 'profile',
                ProfileGrid: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    align: 'flex-start flex-start',
                    // ─── Left Column ──────────────────────────
                    ProfileLeft: {
                        flow: 'y',
                        gap: 'A',
                        flex: '1',
                        minWidth: '260px',
                        PersonalCard: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            CardTitle: {
                                tag: 'h4',
                                text: 'Personal Information',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText',
                                marginBottom: 'X'
                            },
                            PRow1: {
                                flow: 'x',
                                gap: 'A',
                                flexWrap: 'wrap',
                                DOBField: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    DOBLabel: {
                                        text: 'Date of Birth',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    DOBVal: {
                                        text: 'Mar 14, 1992',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                GenderField: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    GLabel: {
                                        text: 'Gender',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    GVal: {
                                        text: 'Male',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                BloodField: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    BLabel: {
                                        text: 'Blood Type',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    BVal: {
                                        text: 'A+',
                                        fontSize: 'Z',
                                        color: 'red',
                                        fontWeight: '600'
                                    }
                                }
                            },
                            PRow2: {
                                flow: 'x',
                                gap: 'A',
                                flexWrap: 'wrap',
                                EmailField: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    ELabel: {
                                        text: 'Email',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    EVal: {
                                        text: 'giorgi.beridze@gmail.com',
                                        fontSize: 'Z',
                                        color: 'teal'
                                    }
                                },
                                PhoneField: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    PLabel: {
                                        text: 'Phone',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    PVal: {
                                        text: '+995 555 11 22 33',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                }
                            },
                            PRow3: {
                                flow: 'x',
                                gap: 'A',
                                flexWrap: 'wrap',
                                AddressField: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '2',
                                    ALabel: {
                                        text: 'Address',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    AVal: {
                                        text: '14 Rustaveli Ave, Tbilisi, Georgia',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                LangField: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    LLabel: {
                                        text: 'Language',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    LVal: {
                                        text: 'Georgian / English',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                }
                            }
                        },
                        EmergencyCard: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            ECTitle: {
                                tag: 'h4',
                                text: 'Emergency Contact',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText',
                                marginBottom: 'X'
                            },
                            ECRow: {
                                flow: 'x',
                                gap: 'A',
                                flexWrap: 'wrap',
                                ECName: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    ECNLabel: {
                                        text: 'Name',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    ECNVal: {
                                        text: 'Nino Beridze',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                ECRel: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    ECRLabel: {
                                        text: 'Relationship',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    ECRVal: {
                                        text: 'Spouse',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                ECPhone: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    ECPLabel: {
                                        text: 'Phone',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    ECPVal: {
                                        text: '+995 555 44 55 66',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                }
                            }
                        },
                        RefSourceCard: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            RefTitle: {
                                tag: 'h4',
                                text: 'Referral & Source',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText',
                                marginBottom: 'X'
                            },
                            RefRow: {
                                flow: 'x',
                                gap: 'A',
                                flexWrap: 'wrap',
                                RefSource: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    RSLabel: {
                                        text: 'How they found us',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    RSVal: {
                                        text: 'Referred by Dr. Lomidze',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                RefDate: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    RDLabel: {
                                        text: 'First Visit',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    RDVal: {
                                        text: 'Jan 10, 2026',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                RefStatus: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    RStLabel: {
                                        text: 'Patient Status',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    RStVal: {
                                        text: 'Active',
                                        fontSize: 'Z',
                                        color: 'green',
                                        fontWeight: '600'
                                    }
                                }
                            }
                        }
                    },
                    // ─── Right Column ─────────────────────────
                    ProfileRight: {
                        flow: 'y',
                        gap: 'A',
                        flex: '1',
                        minWidth: '260px',
                        InsuranceCard: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            InsTitle: {
                                tag: 'h4',
                                text: 'Insurance',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText',
                                marginBottom: 'X'
                            },
                            InsRow1: {
                                flow: 'x',
                                gap: 'A',
                                flexWrap: 'wrap',
                                InsProv: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    IPLabel: {
                                        text: 'Provider',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    IPVal: {
                                        text: 'GPI Insurance',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                InsPlan: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    IPlanLabel: {
                                        text: 'Plan',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    IPlanVal: {
                                        text: 'Gold Dental Plus',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                }
                            },
                            InsRow2: {
                                flow: 'x',
                                gap: 'A',
                                flexWrap: 'wrap',
                                InsMemberId: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    IMLabel: {
                                        text: 'Member ID',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    IMVal: {
                                        text: 'GPI-2026-48291',
                                        fontSize: 'Z',
                                        color: 'teal',
                                        fontWeight: '600'
                                    }
                                },
                                InsGroup: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    IGLabel: {
                                        text: 'Group',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    IGVal: {
                                        text: 'GRP-9041',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                },
                                InsExp: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    IELabel: {
                                        text: 'Expiry',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    IEVal: {
                                        text: 'Dec 31, 2026',
                                        fontSize: 'Z',
                                        color: 'inkText'
                                    }
                                }
                            },
                            InsCoverageRow: {
                                flow: 'x',
                                gap: 'A',
                                flexWrap: 'wrap',
                                marginTop: 'Y',
                                CovPreventive: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    CPLabel: {
                                        text: 'Preventive',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    CPVal: {
                                        text: '100%',
                                        fontSize: 'Z',
                                        color: 'green',
                                        fontWeight: '700'
                                    }
                                },
                                CovBasic: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    CBLabel: {
                                        text: 'Basic',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    CBVal: {
                                        text: '80%',
                                        fontSize: 'Z',
                                        color: 'teal',
                                        fontWeight: '700'
                                    }
                                },
                                CovMajor: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    CMLabel: {
                                        text: 'Major',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    CMVal: {
                                        text: '50%',
                                        fontSize: 'Z',
                                        color: 'gold',
                                        fontWeight: '700'
                                    }
                                },
                                CovOrtho: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    COLabel: {
                                        text: 'Ortho',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    COVal: {
                                        text: 'Not covered',
                                        fontSize: 'Z',
                                        color: 'inkMuted'
                                    }
                                }
                            }
                        },
                        PrimaryDoctorCard: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            PDTitle: {
                                tag: 'h4',
                                text: 'Care Team',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText',
                                marginBottom: 'X'
                            },
                            DoctorRow1: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center flex-start',
                                DAvatar1: {
                                    width: 'C',
                                    height: 'C',
                                    round: 'E',
                                    background: 'teal.20',
                                    color: 'teal',
                                    fontWeight: '700',
                                    fontSize: 'Y',
                                    flow: 'x',
                                    align: 'center center',
                                    text: 'LK',
                                    flexShrink: '0'
                                },
                                DInfo1: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    DName1: {
                                        text: 'Dr. Luka Kvaratskhelia',
                                        fontSize: 'Z',
                                        fontWeight: '600',
                                        color: 'inkText'
                                    },
                                    DRole1: {
                                        text: "Primary Dentist \xb7 General & Restorative",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                }
                            },
                            DoctorRow2: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center flex-start',
                                DAvatar2: {
                                    width: 'C',
                                    height: 'C',
                                    round: 'E',
                                    background: 'purple.20',
                                    color: 'purple',
                                    fontWeight: '700',
                                    fontSize: 'Y',
                                    flow: 'x',
                                    align: 'center center',
                                    text: 'NB',
                                    flexShrink: '0'
                                },
                                DInfo2: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    DName2: {
                                        text: 'Dr. Nata Beridze',
                                        fontSize: 'Z',
                                        fontWeight: '600',
                                        color: 'inkText'
                                    },
                                    DRole2: {
                                        text: 'Periodontist',
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                }
                            }
                        },
                        AllergiesCard: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid red.20',
                            AlgTitle: {
                                tag: 'h4',
                                text: "\u26A0 Allergies & Alerts",
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'red',
                                marginBottom: 'X'
                            },
                            AlgRow: {
                                flow: 'x',
                                gap: 'Z',
                                flexWrap: 'wrap',
                                AlgPenicillin: {
                                    flow: 'y',
                                    gap: 'X',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'red.08',
                                    border: '1px solid red.20',
                                    AlgName: {
                                        text: 'Penicillin',
                                        fontSize: 'Z',
                                        fontWeight: '700',
                                        color: 'red'
                                    },
                                    AlgSeverity: {
                                        text: "Severe \xb7 Anaphylaxis",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                },
                                AlgLatex: {
                                    flow: 'y',
                                    gap: 'X',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'red.08',
                                    border: '1px solid red.20',
                                    AlgName2: {
                                        text: 'Latex',
                                        fontSize: 'Z',
                                        fontWeight: '700',
                                        color: 'red'
                                    },
                                    AlgSeverity2: {
                                        text: "Moderate \xb7 Contact dermatitis",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                }
                            },
                            AlgNote: {
                                text: 'Always verify before prescribing antibiotics. Latex-free gloves required.',
                                fontSize: 'Y',
                                color: 'inkMuted',
                                marginTop: 'Y',
                                fontStyle: 'italic'
                            }
                        },
                        PreferencesCard: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            PrefTitle: {
                                tag: 'h4',
                                text: 'Preferences & Notes',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText',
                                marginBottom: 'X'
                            },
                            PrefRows: {
                                flow: 'y',
                                gap: 'Z',
                                PrefAnx: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center flex-start',
                                    PrefIcon: {
                                        text: "\uD83D\uDE30",
                                        fontSize: 'Z'
                                    },
                                    PrefText: {
                                        flow: 'y',
                                        gap: 'X',
                                        PrefLabel: {
                                            text: 'Dental anxiety',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        PrefDesc: {
                                            text: "Moderate \u2014 prefers detailed explanations before procedures",
                                            fontSize: 'Y',
                                            color: 'inkMuted'
                                        }
                                    }
                                },
                                PrefLang: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center flex-start',
                                    PrefIcon2: {
                                        text: "\uD83C\uDF10",
                                        fontSize: 'Z'
                                    },
                                    PrefText2: {
                                        flow: 'y',
                                        gap: 'X',
                                        PrefLabel2: {
                                            text: 'Preferred language',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        PrefDesc2: {
                                            text: 'Georgian primary, English accepted',
                                            fontSize: 'Y',
                                            color: 'inkMuted'
                                        }
                                    }
                                },
                                PrefAppt: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center flex-start',
                                    PrefIcon3: {
                                        text: "\uD83D\uDD50",
                                        fontSize: 'Z'
                                    },
                                    PrefText3: {
                                        flow: 'y',
                                        gap: 'X',
                                        PrefLabel3: {
                                            text: 'Appointment preference',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        PrefDesc3: {
                                            text: 'Morning appointments, weekdays only',
                                            fontSize: 'Y',
                                            color: 'inkMuted'
                                        }
                                    }
                                },
                                PrefComm: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center flex-start',
                                    PrefIcon4: {
                                        text: "\uD83D\uDCF1",
                                        fontSize: 'Z'
                                    },
                                    PrefText4: {
                                        flow: 'y',
                                        gap: 'X',
                                        PrefLabel4: {
                                            text: 'Communication',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        PrefDesc4: {
                                            text: 'SMS reminders preferred, no cold calls',
                                            fontSize: 'Y',
                                            color: 'inkMuted'
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // 1. OVERVIEW
            // ═══════════════════════════════════════════════
            OverviewSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activePatientSection === 'overview',
                // ─── Add Event Form Panel (EHR-ready) ─────
                AddEventPanel: {
                    show: (el, s)=>s.root.addEventOpen,
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid teal',
                    marginBottom: 'A',
                    PanelHeader: {
                        flow: 'x',
                        align: 'center space-between',
                        marginBottom: 'Z',
                        PanelLeft: {
                            flow: 'y',
                            gap: 'X',
                            PanelTitle: {
                                tag: 'h4',
                                text: 'New Record',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            PanelSubtitle: {
                                text: 'All fields marked * are required for EHR sync',
                                fontSize: 'X',
                                color: 'inkMuted'
                            }
                        },
                        CloseBtn: {
                            tag: 'span',
                            text: "\u2715",
                            fontSize: 'Z',
                            color: 'inkMuted',
                            cursor: 'pointer',
                            padding: 'Y',
                            onClick: (e, el, s)=>s.root.update({
                                    addEventOpen: false
                                })
                        }
                    },
                    // ── Record Type Selector (top of form) ─
                    RecordTypeRow: {
                        flow: 'x',
                        gap: 'Y',
                        flexWrap: 'wrap',
                        marginBottom: 'Z',
                        padding: 'Z A',
                        background: 'ink',
                        round: 'Y',
                        border: '1px solid inkBorder',
                        TypeRowLabel: {
                            tag: 'span',
                            text: 'Record Type:',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            alignSelf: 'center',
                            whiteSpace: 'nowrap',
                            marginRight: 'Y'
                        },
                        TypeChip1: {
                            tag: 'span',
                            text: "\uD83D\uDCCB Consultation",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>(s.root.newEventType || 'Consultation') === 'Consultation' ? '700' : '400',
                            background: (el, s)=>(s.root.newEventType || 'Consultation') === 'Consultation' ? 'teal' : 'inkMid',
                            color: (el, s)=>(s.root.newEventType || 'Consultation') === 'Consultation' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Consultation'
                                })
                        },
                        TypeChip2: {
                            tag: 'span',
                            text: "\uD83E\uDDB7 Treatment",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Treatment' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Treatment' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Treatment' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Treatment'
                                })
                        },
                        TypeChip3: {
                            tag: 'span',
                            text: "\uD83D\uDD2C Diagnosis",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Diagnosis' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Diagnosis' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Diagnosis' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Diagnosis'
                                })
                        },
                        TypeChip4: {
                            tag: 'span',
                            text: "\uD83D\uDC8A Prescription",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Prescription' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Prescription' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Prescription' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Prescription'
                                })
                        },
                        TypeChip5: {
                            tag: 'span',
                            text: "\uD83E\uDE7B Imaging",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Imaging / Radiology' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Imaging / Radiology' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Imaging / Radiology' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Imaging / Radiology'
                                })
                        },
                        TypeChip6: {
                            tag: 'span',
                            text: "\uD83E\uDDEA Lab Result",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Lab Result' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Lab Result' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Lab Result' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Lab Result'
                                })
                        },
                        TypeChip7: {
                            tag: 'span',
                            text: "\uD83D\uDCE4 Referral",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Referral' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Referral' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Referral' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Referral'
                                })
                        },
                        TypeChip8: {
                            tag: 'span',
                            text: "\uD83D\uDD2A Surgery",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Surgery' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Surgery' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Surgery' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Surgery'
                                })
                        },
                        TypeChip9: {
                            tag: 'span',
                            text: "\uD83D\uDCDD Note",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Note' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Note' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Note' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Note'
                                })
                        },
                        TypeChip10: {
                            tag: 'span',
                            text: "\u21A9 Follow-up",
                            fontSize: 'Y',
                            padding: 'X Z',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: (el, s)=>s.root.newEventType === 'Follow-up' ? '700' : '400',
                            background: (el, s)=>s.root.newEventType === 'Follow-up' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.newEventType === 'Follow-up' ? 'white' : 'inkText',
                            onClick: (e, el, s)=>s.root.update({
                                    newEventType: 'Follow-up'
                                })
                        }
                    },
                    // ── EHR Sync Block ──────────────────────
                    EhrSyncBlock: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'Z A',
                        round: 'Y',
                        background: 'ink',
                        border: '1px solid inkBorder',
                        EhrBlockTitle: {
                            text: 'EHR / System Sync',
                            fontSize: 'Y',
                            fontWeight: '700',
                            color: 'teal',
                            marginBottom: 'X'
                        },
                        EhrRow1: {
                            flow: 'x',
                            gap: 'A',
                            flexWrap: 'wrap',
                            EhrSystemField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '160px',
                                EhrSysLabel: {
                                    tag: 'label',
                                    text: 'EHR System',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                EhrSysSelect: {
                                    tag: 'select',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%',
                                    children: [
                                        {
                                            tag: 'option',
                                            text: "\u2014 None \u2014"
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Epic'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Cerner / Oracle Health'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'OpenDental'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Dentrix'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Curve Dental'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Carestream Dental'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Eaglesoft'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'FHIR R4 Endpoint'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'HL7 v2'
                                        }
                                    ]
                                }
                            },
                            EhrIdField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '140px',
                                EhrIdLabel: {
                                    tag: 'label',
                                    text: 'External Record ID',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                EhrIdInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. EHR-2026-00847',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            SyncStatusField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '120px',
                                SyncLabel: {
                                    tag: 'label',
                                    text: 'Sync Status',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                SyncSelect: {
                                    tag: 'select',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%',
                                    children: [
                                        {
                                            tag: 'option',
                                            text: 'Not Synced'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Sync on Save'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Manual Sync'
                                        }
                                    ]
                                }
                            }
                        },
                        EhrRow2: {
                            flow: 'x',
                            gap: 'A',
                            flexWrap: 'wrap',
                            IcdField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '140px',
                                IcdLabel: {
                                    tag: 'label',
                                    text: 'ICD-10 Diagnosis Code',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                IcdInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. K04.0',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            CdtField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '140px',
                                CdtLabel: {
                                    tag: 'label',
                                    text: 'CDT / CPT Procedure Code *',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                CdtInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. D3310',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            SnomedField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '140px',
                                SnomedLabel: {
                                    tag: 'label',
                                    text: 'SNOMED CT Code',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                SnomedInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. 109355002',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            LoincField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '140px',
                                LoincLabel: {
                                    tag: 'label',
                                    text: 'LOINC (Labs/Vitals)',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                LoincInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. 2160-0',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            }
                        }
                    },
                    // ── Core Fields ─────────────────────────
                    CoreRow1: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        EventTypeField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '160px',
                            TypeLabel: {
                                tag: 'label',
                                text: 'Event Type *',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            TypeSelect: {
                                tag: 'select',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                children: [
                                    {
                                        tag: 'option',
                                        text: 'Consultation'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Treatment'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Diagnosis'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Prescription'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Imaging / Radiology'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Lab Result'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Referral'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Surgery'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Follow-up'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Note'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Other'
                                    }
                                ]
                            }
                        },
                        DateField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '140px',
                            DateLabel: {
                                tag: 'label',
                                text: 'Date *',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            DateInput: {
                                tag: 'input',
                                type: 'date',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%'
                            }
                        },
                        TimeField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '110px',
                            TimeLabel: {
                                tag: 'label',
                                text: 'Time',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            TimeInput: {
                                tag: 'input',
                                type: 'time',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%'
                            }
                        },
                        DurationField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '100px',
                            DurLabel: {
                                tag: 'label',
                                text: 'Duration',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            DurInput: {
                                tag: 'input',
                                type: 'text',
                                placeholder: 'e.g. 30 min',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%'
                            }
                        }
                    },
                    CoreRow2: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        DoctorField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '180px',
                            DocLabel: {
                                tag: 'label',
                                text: 'Doctor / Personnel *',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            DocSelect: {
                                tag: 'select',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                children: [
                                    {
                                        tag: 'option',
                                        text: 'Dr. Ana Lomidze'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Dr. Giorgi Kvaratskhelia'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Dr. Nino Beridze'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Nurse Salome'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Hygienist Tamar'
                                    }
                                ]
                            }
                        },
                        CabinetField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '120px',
                            CabLabel: {
                                tag: 'label',
                                text: 'Cabinet',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            CabSelect: {
                                tag: 'select',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                children: [
                                    {
                                        tag: 'option',
                                        text: 'Cabinet 1'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Cabinet 2'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Cabinet 3'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Cabinet 4'
                                    }
                                ]
                            }
                        },
                        TeethField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '140px',
                            TeethLabel: {
                                tag: 'label',
                                text: 'Teeth Involved',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            TeethInput: {
                                tag: 'input',
                                type: 'text',
                                placeholder: 'e.g. #14, #21',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%'
                            }
                        }
                    },
                    TitleField: {
                        flow: 'y',
                        gap: 'X',
                        TitleLabel: {
                            tag: 'label',
                            text: 'Title *',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted'
                        },
                        TitleInput: {
                            tag: 'input',
                            type: 'text',
                            placeholder: "Event title\u2026",
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'ink',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            width: '100%'
                        }
                    },
                    // ── SOAP Notes ──────────────────────────
                    SoapBlock: {
                        show: (el, s)=>{
                            var t = s.root.newEventType || 'Consultation';
                            return [
                                'Consultation',
                                'Follow-up',
                                'Treatment',
                                'Surgery',
                                'Diagnosis'
                            ].indexOf(t) !== -1;
                        },
                        flow: 'y',
                        gap: 'Z',
                        padding: 'Z A',
                        round: 'Y',
                        background: 'ink',
                        border: '1px solid inkBorder',
                        SoapTitle: {
                            text: 'SOAP Notes',
                            fontSize: 'Y',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'X'
                        },
                        SubjectiveField: {
                            flow: 'y',
                            gap: 'X',
                            SLabel: {
                                tag: 'label',
                                text: "S \u2014 Subjective (Chief Complaint)",
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            SInput: {
                                tag: 'textarea',
                                placeholder: "Patient-reported symptoms, history of present illness\u2026",
                                fontSize: 'Z',
                                padding: 'Z',
                                round: 'Y',
                                background: 'inkMid',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                minHeight: 'E',
                                resize: 'vertical',
                                lineHeight: '1.6'
                            }
                        },
                        ObjectiveField: {
                            flow: 'y',
                            gap: 'X',
                            OLabel: {
                                tag: 'label',
                                text: "O \u2014 Objective (Clinical Findings)",
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            OInput: {
                                tag: 'textarea',
                                placeholder: "Examination findings, vitals, test results\u2026",
                                fontSize: 'Z',
                                padding: 'Z',
                                round: 'Y',
                                background: 'inkMid',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                minHeight: 'E',
                                resize: 'vertical',
                                lineHeight: '1.6'
                            }
                        },
                        AssessmentField: {
                            flow: 'y',
                            gap: 'X',
                            ALabel: {
                                tag: 'label',
                                text: "A \u2014 Assessment (Diagnosis)",
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            AInput: {
                                tag: 'textarea',
                                placeholder: "Clinical diagnosis, differential diagnosis\u2026",
                                fontSize: 'Z',
                                padding: 'Z',
                                round: 'Y',
                                background: 'inkMid',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                minHeight: 'E',
                                resize: 'vertical',
                                lineHeight: '1.6'
                            }
                        },
                        PlanField: {
                            flow: 'y',
                            gap: 'X',
                            PLabel: {
                                tag: 'label',
                                text: "P \u2014 Plan (Treatment)",
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            PInput: {
                                tag: 'textarea',
                                placeholder: "Treatment plan, medications, follow-up instructions\u2026",
                                fontSize: 'Z',
                                padding: 'Z',
                                round: 'Y',
                                background: 'inkMid',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                minHeight: 'E',
                                resize: 'vertical',
                                lineHeight: '1.6'
                            }
                        }
                    },
                    // ── Vitals ─────────────────────────────
                    VitalsBlock: {
                        show: (el, s)=>{
                            var t = s.root.newEventType || 'Consultation';
                            return [
                                'Consultation',
                                'Follow-up',
                                'Surgery'
                            ].indexOf(t) !== -1;
                        },
                        flow: 'y',
                        gap: 'Z',
                        padding: 'Z A',
                        round: 'Y',
                        background: 'ink',
                        border: '1px solid inkBorder',
                        VitalsTitle: {
                            text: 'Vital Signs',
                            fontSize: 'Y',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'X'
                        },
                        VitalsRow: {
                            flow: 'x',
                            gap: 'A',
                            flexWrap: 'wrap',
                            BpField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '100px',
                                BpLabel: {
                                    tag: 'label',
                                    text: 'BP (mmHg)',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                BpInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: '120/80',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            HrField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '90px',
                                HrLabel: {
                                    tag: 'label',
                                    text: 'HR (bpm)',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                HrInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: '72',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            TempField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '90px',
                                TempLabel: {
                                    tag: 'label',
                                    text: "Temp (\xb0C)",
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                TempInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: '36.6',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            O2Field: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '90px',
                                O2Label: {
                                    tag: 'label',
                                    text: "SpO\u2082 (%)",
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                O2Input: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: '98',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            WeightField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '90px',
                                WeightLabel: {
                                    tag: 'label',
                                    text: 'Weight (kg)',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                WeightInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: '70',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            }
                        }
                    },
                    // ── Medication / Prescription ──────────
                    MedBlock: {
                        show: (el, s)=>(s.root.newEventType || 'Consultation') === 'Prescription',
                        flow: 'y',
                        gap: 'Z',
                        padding: 'Z A',
                        round: 'Y',
                        background: 'ink',
                        border: '1px solid inkBorder',
                        MedTitle: {
                            text: 'Medication / Prescription',
                            fontSize: 'Y',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'X'
                        },
                        MedRow1: {
                            flow: 'x',
                            gap: 'A',
                            flexWrap: 'wrap',
                            DrugField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '2',
                                minWidth: '160px',
                                DrugLabel: {
                                    tag: 'label',
                                    text: 'Drug Name',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                DrugInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. Amoxicillin',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            DoseField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '100px',
                                DoseLabel: {
                                    tag: 'label',
                                    text: 'Dosage',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                DoseInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: '500mg',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            FreqField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '110px',
                                FreqLabel: {
                                    tag: 'label',
                                    text: 'Frequency',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                FreqInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'TID x 7 days',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            RouteField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '100px',
                                RouteLabel: {
                                    tag: 'label',
                                    text: 'Route',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                RouteSelect: {
                                    tag: 'select',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%',
                                    children: [
                                        {
                                            tag: 'option',
                                            text: 'Oral'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Topical'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'IV'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'IM'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Sublingual'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Inhalation'
                                        }
                                    ]
                                }
                            }
                        }
                    },
                    // ── Attachments ─────────────────────────
                    AttachmentsRow: {
                        show: (el, s)=>{
                            var t = s.root.newEventType || 'Consultation';
                            return [
                                'Imaging / Radiology',
                                'Lab Result',
                                'Treatment',
                                'Surgery',
                                'Referral'
                            ].indexOf(t) !== -1;
                        },
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        ImagesField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '200px',
                            ImgLabel: {
                                tag: 'label',
                                text: 'Attach Images / X-rays / DICOM',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            ImgUploadBox: {
                                flow: 'y',
                                align: 'center center',
                                gap: 'Y',
                                padding: 'B A',
                                round: 'Y',
                                border: '2px dashed inkBorder',
                                background: 'ink',
                                cursor: 'pointer',
                                UploadIcon: {
                                    tag: 'span',
                                    text: "\u2B06",
                                    fontSize: 'A',
                                    color: 'inkMuted'
                                },
                                UploadText: {
                                    text: 'Click to upload or drag & drop',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                },
                                UploadHint: {
                                    text: "PNG, JPG, DICOM, PDF \u2014 max 20MB each",
                                    fontSize: 'X',
                                    color: 'inkSubtle'
                                }
                            }
                        },
                        DocsField: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            minWidth: '200px',
                            DocsLabel: {
                                tag: 'label',
                                text: 'Reference Documents',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            DocsSelect: {
                                tag: 'select',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                children: [
                                    {
                                        tag: 'option',
                                        text: "\u2014 Select document \u2014"
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Treatment Plan Mar 2026'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Lab Results Feb 2026'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Referral Letter Jan 2026'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Consent Form'
                                    },
                                    {
                                        tag: 'option',
                                        text: 'Insurance Pre-auth'
                                    }
                                ]
                            },
                            DocsNote: {
                                text: 'Multiple docs can be referenced',
                                fontSize: 'X',
                                color: 'inkSubtle',
                                marginTop: 'X'
                            }
                        }
                    },
                    // ── Referral Fields ─────────────────────
                    ReferralBlock: {
                        show: (el, s)=>(s.root.newEventType || 'Consultation') === 'Referral',
                        flow: 'y',
                        gap: 'Z',
                        padding: 'Z A',
                        round: 'Y',
                        background: 'ink',
                        border: '1px solid inkBorder',
                        RefTitle: {
                            text: 'Referral Details',
                            fontSize: 'Y',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'X'
                        },
                        RefRow: {
                            flow: 'x',
                            gap: 'A',
                            flexWrap: 'wrap',
                            RefToField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '2',
                                minWidth: '160px',
                                RefToLabel: {
                                    tag: 'label',
                                    text: 'Referred To',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                RefToInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. Dr. Ivane Lomidze',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            SpecField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '140px',
                                SpecLabel: {
                                    tag: 'label',
                                    text: 'Specialty',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                SpecSelect: {
                                    tag: 'select',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%',
                                    children: [
                                        {
                                            tag: 'option',
                                            text: 'Periodontics'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Oral Surgery'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Endodontics'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Orthodontics'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Prosthodontics'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'General Dentistry'
                                        }
                                    ]
                                }
                            },
                            UrgField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '120px',
                                UrgLabel: {
                                    tag: 'label',
                                    text: 'Urgency',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                UrgSelect: {
                                    tag: 'select',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%',
                                    children: [
                                        {
                                            tag: 'option',
                                            text: 'Routine'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Soon (2 weeks)'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Urgent (48 hrs)'
                                        }
                                    ]
                                }
                            }
                        },
                        RefReasonField: {
                            flow: 'y',
                            gap: 'X',
                            RefReasonLabel: {
                                tag: 'label',
                                text: 'Reason for Referral',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            RefReasonInput: {
                                tag: 'textarea',
                                placeholder: "Clinical reason, findings, expected outcome\u2026",
                                fontSize: 'Z',
                                padding: 'Z',
                                round: 'Y',
                                background: 'inkMid',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                minHeight: 'E',
                                resize: 'vertical',
                                lineHeight: '1.6'
                            }
                        }
                    },
                    // ── Lab Result Fields ─────────────────────
                    LabBlock: {
                        show: (el, s)=>(s.root.newEventType || 'Consultation') === 'Lab Result',
                        flow: 'y',
                        gap: 'Z',
                        padding: 'Z A',
                        round: 'Y',
                        background: 'ink',
                        border: '1px solid inkBorder',
                        LabTitle: {
                            text: 'Lab Result Details',
                            fontSize: 'Y',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'X'
                        },
                        LabRow1: {
                            flow: 'x',
                            gap: 'A',
                            flexWrap: 'wrap',
                            LoincField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '140px',
                                LoincLabel: {
                                    tag: 'label',
                                    text: 'LOINC Code',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'teal'
                                },
                                LoincInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. 2951-2',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid teal.30',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            LabNameField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '2',
                                minWidth: '160px',
                                LabNameLabel: {
                                    tag: 'label',
                                    text: 'Test Name',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                LabNameInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. CBC, HbA1c',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            LabValField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '100px',
                                LabValLabel: {
                                    tag: 'label',
                                    text: 'Result Value',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                LabValInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. 5.4',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            LabRefField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '110px',
                                LabRefLabel: {
                                    tag: 'label',
                                    text: 'Reference Range',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                LabRefInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: "e.g. 4.0\u20135.6",
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            }
                        }
                    },
                    // ── Surgery Fields ─────────────────────────
                    SurgeryBlock: {
                        show: (el, s)=>(s.root.newEventType || 'Consultation') === 'Surgery',
                        flow: 'y',
                        gap: 'Z',
                        padding: 'Z A',
                        round: 'Y',
                        background: 'ink',
                        border: '1px solid inkBorder',
                        SurgTitle: {
                            text: 'Surgery Details',
                            fontSize: 'Y',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'X'
                        },
                        SurgRow: {
                            flow: 'x',
                            gap: 'A',
                            flexWrap: 'wrap',
                            AnesField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '140px',
                                AnesLabel: {
                                    tag: 'label',
                                    text: 'Anesthesia Type',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                AnesSelect: {
                                    tag: 'select',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%',
                                    children: [
                                        {
                                            tag: 'option',
                                            text: 'Local'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'Local + Sedation'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'General'
                                        },
                                        {
                                            tag: 'option',
                                            text: 'None'
                                        }
                                    ]
                                }
                            },
                            SurgDurField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '110px',
                                SDurLabel: {
                                    tag: 'label',
                                    text: 'Duration (min)',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                SDurInput: {
                                    tag: 'input',
                                    type: 'number',
                                    placeholder: '90',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            SurgTeamField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '2',
                                minWidth: '160px',
                                STeamLabel: {
                                    tag: 'label',
                                    text: 'Surgical Team',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted'
                                },
                                STeamInput: {
                                    tag: 'input',
                                    type: 'text',
                                    placeholder: 'e.g. Dr. Kvaratskhelia, Nurse Salome',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkMid',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            }
                        }
                    },
                    // ── Note simple ─────────────────────────────
                    NoteBlock: {
                        show: (el, s)=>(s.root.newEventType || 'Consultation') === 'Note',
                        flow: 'y',
                        gap: 'X',
                        NoteLabel: {
                            tag: 'label',
                            text: 'Note',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted'
                        },
                        NoteInput: {
                            tag: 'textarea',
                            placeholder: "Enter clinical note\u2026",
                            fontSize: 'Z',
                            padding: 'Z',
                            round: 'Y',
                            background: 'ink',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            width: '100%',
                            minHeight: 'F',
                            resize: 'vertical',
                            lineHeight: '1.6'
                        }
                    },
                    // ── Visibility & Actions ─────────────────
                    BottomRow: {
                        flow: 'x',
                        gap: 'A',
                        align: 'center space-between',
                        flexWrap: 'wrap',
                        marginTop: 'Z',
                        VisibilityRow: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            VisLabel: {
                                text: 'Visibility:',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            VisToggle: {
                                flow: 'x',
                                gap: '0',
                                round: 'Y',
                                overflow: 'hidden',
                                border: '1px solid inkBorder',
                                PrivateBtn: {
                                    text: "\uD83D\uDD12 Private",
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'Y Z',
                                    cursor: 'pointer',
                                    background: (el, s)=>s.root.newEventVisibility !== 'shared' ? 'teal' : 'ink',
                                    color: (el, s)=>s.root.newEventVisibility !== 'shared' ? 'white' : 'inkMuted',
                                    onClick: (e, el, s)=>s.root.update({
                                            newEventVisibility: 'private'
                                        })
                                },
                                SharedBtn: {
                                    text: "\uD83D\uDC65 Shared",
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'Y Z',
                                    cursor: 'pointer',
                                    background: (el, s)=>s.root.newEventVisibility === 'shared' ? 'teal' : 'ink',
                                    color: (el, s)=>s.root.newEventVisibility === 'shared' ? 'white' : 'inkMuted',
                                    onClick: (e, el, s)=>s.root.update({
                                            newEventVisibility: 'shared'
                                        })
                                }
                            }
                        },
                        PanelActions: {
                            flow: 'x',
                            gap: 'Z',
                            CancelBtn: {
                                text: 'Cancel',
                                fontSize: 'Z',
                                fontWeight: '600',
                                padding: 'Y A',
                                round: 'A',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkMuted',
                                cursor: 'pointer',
                                onClick: (e, el, s)=>s.root.update({
                                        addEventOpen: false
                                    })
                            },
                            SaveDraftBtn: {
                                text: 'Save Draft',
                                fontSize: 'Z',
                                fontWeight: '600',
                                padding: 'Y A',
                                round: 'A',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                cursor: 'pointer',
                                onClick: (e, el, s)=>s.root.update({
                                        addEventOpen: false
                                    })
                            },
                            SaveSyncBtn: {
                                text: "\u21BB Save & Sync to EHR",
                                fontSize: 'Z',
                                fontWeight: '600',
                                padding: 'Y A',
                                round: 'A',
                                background: 'teal',
                                color: 'white',
                                cursor: 'pointer',
                                onClick: (e, el, s)=>s.root.update({
                                        addEventOpen: false
                                    })
                            }
                        }
                    }
                },
                TimelineFilters: {
                    flow: 'x',
                    gap: 'Z',
                    flexWrap: 'wrap',
                    align: 'center flex-start',
                    SearchBox: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        flex: '1',
                        minWidth: '200px',
                        maxWidth: '320px',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        SearchIcon: {
                            tag: 'span',
                            text: "\uD83D\uDD0D",
                            fontSize: 'Y'
                        },
                        SearchInput: {
                            tag: 'input',
                            type: 'text',
                            placeholder: "Search records\u2026",
                            fontSize: 'Z',
                            background: 'transparent',
                            border: 'none',
                            color: 'inkText',
                            outline: 'none',
                            flex: '1'
                        }
                    },
                    DateFromField: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        DateFromLabel: {
                            tag: 'span',
                            text: 'From',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            whiteSpace: 'nowrap'
                        },
                        DateFromInput: {
                            tag: 'input',
                            type: 'date',
                            fontSize: 'Y',
                            background: 'transparent',
                            border: 'none',
                            color: 'inkText',
                            outline: 'none'
                        }
                    },
                    DateToField: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        DateToLabel: {
                            tag: 'span',
                            text: 'To',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            whiteSpace: 'nowrap'
                        },
                        DateToInput: {
                            tag: 'input',
                            type: 'date',
                            fontSize: 'Y',
                            background: 'transparent',
                            border: 'none',
                            color: 'inkText',
                            outline: 'none'
                        }
                    },
                    DoctorFilter: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        DoctorIcon: {
                            tag: 'span',
                            text: "\uD83D\uDC64",
                            fontSize: 'Y'
                        },
                        DoctorSelect: {
                            tag: 'select',
                            fontSize: 'Y',
                            background: 'transparent',
                            border: 'none',
                            color: 'inkText',
                            outline: 'none',
                            cursor: 'pointer',
                            children: [
                                {
                                    tag: 'option',
                                    text: 'All Doctors'
                                },
                                {
                                    tag: 'option',
                                    text: 'Dr. Kvaratskhelia'
                                },
                                {
                                    tag: 'option',
                                    text: 'Dr. Beridze'
                                },
                                {
                                    tag: 'option',
                                    text: 'Dr. Chikobava'
                                }
                            ]
                        }
                    },
                    SortFilter: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        SortIcon: {
                            tag: 'span',
                            text: "\u2195",
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        SortSelect: {
                            tag: 'select',
                            fontSize: 'Y',
                            background: 'transparent',
                            border: 'none',
                            color: 'inkText',
                            outline: 'none',
                            cursor: 'pointer',
                            children: [
                                {
                                    tag: 'option',
                                    text: 'Newest First'
                                },
                                {
                                    tag: 'option',
                                    text: 'Oldest First'
                                },
                                {
                                    tag: 'option',
                                    text: 'By Type'
                                },
                                {
                                    tag: 'option',
                                    text: 'By Doctor'
                                }
                            ]
                        }
                    },
                    // ── Type filter dropdown ────────────────────
                    TypeFilterWrap: {
                        position: 'relative',
                        TypeFilterBtn: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            padding: 'Y Z',
                            round: 'Y',
                            cursor: 'pointer',
                            background: (el, s)=>s.root.tlFilter ? 'teal.15' : 'inkMid',
                            border: (el, s)=>s.root.tlFilter ? '1px solid teal.30' : '1px solid inkBorder',
                            onClick: (e, el, s)=>{
                                e.stopPropagation();
                                s.root.update({
                                    typeFilterOpen: !s.root.typeFilterOpen
                                });
                            },
                            TypeBtnLabel: {
                                tag: 'span',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: (el, s)=>s.root.tlFilter ? 'teal' : 'inkText',
                                text: (el, s)=>s.root.tlFilter ? s.root.tlFilter : 'Type'
                            },
                            TypeBtnArrow: {
                                tag: 'span',
                                text: "\u25BE",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        TypeFilterMenu: {
                            show: (el, s)=>!!s.root.typeFilterOpen,
                            position: 'absolute',
                            top: '110%',
                            left: '0',
                            zIndex: '9999',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            borderRadius: 'A',
                            overflow: 'hidden',
                            minWidth: '180px',
                            boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
                            flow: 'y',
                            TFAll: {
                                text: 'All Types',
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>!s.root.tlFilter ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>!s.root.tlFilter ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: null,
                                        typeFilterOpen: false
                                    })
                            },
                            TFSep: {
                                height: '1px',
                                background: 'inkBorder',
                                margin: '0'
                            },
                            TFConsult: {
                                text: "\uD83D\uDCCB Consultation",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Consultation' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Consultation' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Consultation',
                                        typeFilterOpen: false
                                    })
                            },
                            TFTreatment: {
                                text: "\uD83E\uDDB7 Treatment",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Treatment' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Treatment' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Treatment',
                                        typeFilterOpen: false
                                    })
                            },
                            TFDiagnosis: {
                                text: "\uD83D\uDD2C Diagnosis",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Diagnosis' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Diagnosis' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Diagnosis',
                                        typeFilterOpen: false
                                    })
                            },
                            TFPrescription: {
                                text: "\uD83D\uDC8A Prescription",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Prescription' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Prescription' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Prescription',
                                        typeFilterOpen: false
                                    })
                            },
                            TFImaging: {
                                text: "\uD83E\uDE7B Imaging",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Imaging' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Imaging' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Imaging',
                                        typeFilterOpen: false
                                    })
                            },
                            TFLab: {
                                text: "\uD83E\uDDEA Lab Result",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Lab' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Lab' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Lab',
                                        typeFilterOpen: false
                                    })
                            },
                            TFReferral: {
                                text: "\uD83D\uDCE4 Referral",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Referral' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Referral' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Referral',
                                        typeFilterOpen: false
                                    })
                            },
                            TFSurgery: {
                                text: "\uD83D\uDD2A Surgery",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Surgery' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Surgery' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Surgery',
                                        typeFilterOpen: false
                                    })
                            },
                            TFFollowup: {
                                text: "\u21A9 Follow-up",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Follow-up' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Follow-up' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Follow-up',
                                        typeFilterOpen: false
                                    })
                            },
                            TFNote: {
                                text: "\uD83D\uDCDD Note",
                                fontSize: 'Z',
                                padding: 'Y A',
                                cursor: 'pointer',
                                color: (el, s)=>s.root.tlFilter === 'Note' ? 'teal' : 'inkText',
                                fontWeight: (el, s)=>s.root.tlFilter === 'Note' ? '700' : '400',
                                onClick: (e, el, s)=>s.root.update({
                                        tlFilter: 'Note',
                                        typeFilterOpen: false
                                    })
                            }
                        }
                    }
                },
                TimelineLayout: {
                    flow: 'x',
                    gap: 'A',
                    align: 'flex-start flex-start',
                    TimelineList: {
                        flow: 'y',
                        gap: 'A',
                        flex: '1',
                        minWidth: '0',
                        // ── CHAPTER 1 — Post-Treatment Follow-up ──────────────
                        Chapter01: {
                            flow: 'y',
                            round: 'A',
                            border: '1px solid teal.30',
                            overflow: 'hidden',
                            // Chapter Header
                            Ch01Header: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center space-between',
                                cursor: 'pointer',
                                padding: 'Z A',
                                background: 'teal.08',
                                onClick: (e, el, s)=>s.root.update({
                                        c01open: s.root.c01open === false ? true : false
                                    }),
                                Ch01Left: {
                                    flow: 'y',
                                    gap: 'X',
                                    Ch01Title: {
                                        tag: 'h4',
                                        text: 'Post-Treatment Follow-up',
                                        fontSize: 'Z',
                                        fontWeight: '700',
                                        color: 'teal'
                                    },
                                    Ch01Meta: {
                                        text: "Mar 2026 \xb7 Dr. Kvaratskhelia \xb7 1 visit",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                },
                                Ch01Right: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center center',
                                    Ch01Badge: {
                                        tag: 'span',
                                        text: 'Follow-up',
                                        fontSize: 'Y',
                                        fontWeight: '600',
                                        padding: 'X Z',
                                        round: 'B',
                                        background: 'teal.15',
                                        color: 'teal'
                                    },
                                    Ch01Chevron: {
                                        tag: 'span',
                                        text: (el, s)=>s.root.c01open !== false ? "\u25BE" : "\u25B8",
                                        fontSize: 'Z',
                                        color: 'inkMuted',
                                        marginLeft: 'Y'
                                    }
                                }
                            },
                            // Chapter Body
                            Ch01Body: {
                                show: (el, s)=>s.root.c01open !== false,
                                flow: 'y',
                                gap: 'Y',
                                padding: 'Z A',
                                background: 'inkMid',
                                // Visit 1
                                Visit01: {
                                    flow: 'y',
                                    gap: 'Y',
                                    V01Header: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        V01DatePill: {
                                            tag: 'span',
                                            text: 'Mar 15, 2026',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'ink',
                                            color: 'teal'
                                        },
                                        V01Info: {
                                            tag: 'span',
                                            text: "30 min \xb7 Dr. Kvaratskhelia",
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            alignSelf: 'center'
                                        }
                                    },
                                    Entry01: {
                                        flow: 'x',
                                        gap: 'Z',
                                        cursor: 'pointer',
                                        background: (el, s)=>s.root.selectedEntry === 'e01' ? 'teal.08' : 'transparent',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        margin: '0 -Z',
                                        onClick: (e, el, s)=>s.root.update({
                                                selectedEntry: s.root.selectedEntry === 'e01' ? null : 'e01',
                                                seTitle: 'Follow-up Consultation',
                                                seDate: 'Mar 15, 2026',
                                                seDoctor: 'Dr. Kvaratskhelia',
                                                seType: 'Follow-up',
                                                seDuration: '30 min',
                                                seColor: 'teal',
                                                seDesc: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
                                                seTeeth: '#14',
                                                seVisibility: 'Shared'
                                            }),
                                        CategoryDot: {
                                            width: 'Z',
                                            height: 'Z',
                                            round: 'Z',
                                            background: 'teal',
                                            flexShrink: '0',
                                            marginTop: 'Y'
                                        },
                                        EntryContent: {
                                            flow: 'y',
                                            gap: 'X',
                                            flex: '1',
                                            EntryTitle: {
                                                text: 'Follow-up Consultation',
                                                fontSize: 'Z',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            },
                                            EntryDesc: {
                                                text: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
                                                fontSize: 'Y',
                                                color: 'inkSubtle',
                                                lineHeight: '1.5'
                                            }
                                        }
                                    }
                                },
                                TpLink01: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center space-between',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'teal.06',
                                    border: '1px solid teal.20',
                                    cursor: 'pointer',
                                    marginTop: 'Y',
                                    onClick: (e, el, s)=>s.root.update({
                                            activePatientSection: 'treatmentPlan',
                                            selectedPhase: 'p4',
                                            tpCollP4: false
                                        }),
                                    TpLink01Left: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center center',
                                        TpLink01Icon: {
                                            extends: 'Icon',
                                            icon: 'clipboard',
                                            width: 'B',
                                            height: 'B',
                                            color: 'teal'
                                        },
                                        TpLink01Text: {
                                            flow: 'y',
                                            gap: 'X',
                                            TpLink01Label: {
                                                text: 'Treatment Plan',
                                                fontSize: 'X',
                                                fontWeight: '600',
                                                color: 'teal',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em'
                                            },
                                            TpLink01Name: {
                                                text: 'Phase 4: Maintenance',
                                                fontSize: 'Y',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            }
                                        }
                                    },
                                    TpLink01Arrow: {
                                        extends: 'Icon',
                                        icon: 'arrowRight',
                                        width: 'B',
                                        height: 'B',
                                        color: 'teal'
                                    }
                                }
                            }
                        },
                        // ── CHAPTER 2 — Root Canal Treatment, Tooth #14 ────────
                        Chapter02: {
                            flow: 'y',
                            round: 'A',
                            border: '1px solid purple.30',
                            overflow: 'hidden',
                            Ch02Header: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center space-between',
                                cursor: 'pointer',
                                padding: 'Z A',
                                background: 'purple.08',
                                onClick: (e, el, s)=>s.root.update({
                                        c02open: s.root.c02open === false ? true : false
                                    }),
                                Ch02Left: {
                                    flow: 'y',
                                    gap: 'X',
                                    Ch02Title: {
                                        tag: 'h4',
                                        text: "Root Canal Treatment \u2014 Tooth #14",
                                        fontSize: 'Z',
                                        fontWeight: '700',
                                        color: 'purple'
                                    },
                                    Ch02Meta: {
                                        text: "Mar 3 \u2013 Mar 10, 2026 \xb7 Dr. Kvaratskhelia \xb7 4 visits",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                },
                                Ch02Right: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center center',
                                    Ch02Badge: {
                                        tag: 'span',
                                        text: 'Treatment Episode',
                                        fontSize: 'Y',
                                        fontWeight: '600',
                                        padding: 'X Z',
                                        round: 'B',
                                        background: 'purple.15',
                                        color: 'purple'
                                    },
                                    Ch02Chevron: {
                                        tag: 'span',
                                        text: (el, s)=>s.root.c02open !== false ? "\u25BE" : "\u25B8",
                                        fontSize: 'Z',
                                        color: 'inkMuted',
                                        marginLeft: 'Y'
                                    }
                                }
                            },
                            Ch02Body: {
                                show: (el, s)=>s.root.c02open !== false,
                                flow: 'y',
                                gap: 'A',
                                padding: 'Z A',
                                background: 'inkMid',
                                // Visit A — Mar 10
                                Visit02A: {
                                    flow: 'y',
                                    gap: 'Y',
                                    V02AHeader: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        V02ADatePill: {
                                            tag: 'span',
                                            text: 'Mar 10, 2026',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'ink',
                                            color: 'purple'
                                        },
                                        V02AInfo: {
                                            tag: 'span',
                                            text: "90 min \xb7 Obturation Session",
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            alignSelf: 'center'
                                        }
                                    },
                                    Entry02: {
                                        flow: 'x',
                                        gap: 'Z',
                                        cursor: 'pointer',
                                        background: (el, s)=>s.root.selectedEntry === 'e02' ? 'purple.08' : 'transparent',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        margin: '0 -Z',
                                        onClick: (e, el, s)=>s.root.update({
                                                selectedEntry: s.root.selectedEntry === 'e02' ? null : 'e02',
                                                seTitle: "Root Canal Treatment \u2014 Phase 2",
                                                seDate: 'Mar 10, 2026',
                                                seDoctor: 'Dr. Kvaratskhelia',
                                                seType: 'Treatment',
                                                seDuration: '90 min',
                                                seColor: 'purple',
                                                seDesc: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
                                                seTeeth: '#14',
                                                seVisibility: 'Shared'
                                            }),
                                        CategoryDot: {
                                            width: 'Z',
                                            height: 'Z',
                                            round: 'Z',
                                            background: 'purple',
                                            flexShrink: '0',
                                            marginTop: 'Y'
                                        },
                                        EntryContent: {
                                            flow: 'y',
                                            gap: 'X',
                                            flex: '1',
                                            EntryTitle: {
                                                text: "Root Canal Treatment \u2014 Phase 2",
                                                fontSize: 'Z',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            },
                                            EntryDesc: {
                                                text: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
                                                fontSize: 'Y',
                                                color: 'inkSubtle',
                                                lineHeight: '1.5'
                                            }
                                        }
                                    }
                                },
                                VisitDivider1: {
                                    height: '1px',
                                    background: 'inkBorder'
                                },
                                // Visit B — Mar 8
                                Visit02B: {
                                    flow: 'y',
                                    gap: 'Y',
                                    V02BHeader: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        V02BDatePill: {
                                            tag: 'span',
                                            text: 'Mar 8, 2026',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'ink',
                                            color: 'blue'
                                        },
                                        V02BInfo: {
                                            tag: 'span',
                                            text: "15 min \xb7 Imaging",
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            alignSelf: 'center'
                                        }
                                    },
                                    Entry03: {
                                        flow: 'x',
                                        gap: 'Z',
                                        cursor: 'pointer',
                                        background: (el, s)=>s.root.selectedEntry === 'e03' ? 'blue.08' : 'transparent',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        margin: '0 -Z',
                                        onClick: (e, el, s)=>s.root.update({
                                                selectedEntry: s.root.selectedEntry === 'e03' ? null : 'e03',
                                                seTitle: 'Periapical X-ray',
                                                seDate: 'Mar 8, 2026',
                                                seDoctor: 'Dr. Kvaratskhelia',
                                                seType: 'Imaging / Radiology',
                                                seDuration: '15 min',
                                                seColor: 'blue',
                                                seDesc: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
                                                seTeeth: '#14',
                                                seVisibility: 'Shared'
                                            }),
                                        CategoryDot: {
                                            width: 'Z',
                                            height: 'Z',
                                            round: 'Z',
                                            background: 'blue',
                                            flexShrink: '0',
                                            marginTop: 'Y'
                                        },
                                        EntryContent: {
                                            flow: 'y',
                                            gap: 'X',
                                            flex: '1',
                                            EntryTitle: {
                                                text: 'Periapical X-ray',
                                                fontSize: 'Z',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            },
                                            EntryDesc: {
                                                text: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
                                                fontSize: 'Y',
                                                color: 'inkSubtle',
                                                lineHeight: '1.5'
                                            }
                                        }
                                    }
                                },
                                VisitDivider2: {
                                    height: '1px',
                                    background: 'inkBorder'
                                },
                                // Visit C — Mar 5
                                Visit02C: {
                                    flow: 'y',
                                    gap: 'Y',
                                    V02CHeader: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        V02CDatePill: {
                                            tag: 'span',
                                            text: 'Mar 5, 2026',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'ink',
                                            color: 'amber'
                                        },
                                        V02CInfo: {
                                            tag: 'span',
                                            text: "\u2014 \xb7 Prescription",
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            alignSelf: 'center'
                                        }
                                    },
                                    Entry04: {
                                        flow: 'x',
                                        gap: 'Z',
                                        cursor: 'pointer',
                                        background: (el, s)=>s.root.selectedEntry === 'e04' ? 'amber.08' : 'transparent',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        margin: '0 -Z',
                                        onClick: (e, el, s)=>s.root.update({
                                                selectedEntry: s.root.selectedEntry === 'e04' ? null : 'e04',
                                                seTitle: 'Medication: Amoxicillin 500mg',
                                                seDate: 'Mar 5, 2026',
                                                seDoctor: 'Dr. Kvaratskhelia',
                                                seType: 'Prescription',
                                                seDuration: "\u2014",
                                                seColor: 'amber',
                                                seDesc: "Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy \u2014 confirmed Amoxicillin tolerance via skin test.",
                                                seTeeth: '#14',
                                                seVisibility: 'Shared'
                                            }),
                                        CategoryDot: {
                                            width: 'Z',
                                            height: 'Z',
                                            round: 'Z',
                                            background: 'amber',
                                            flexShrink: '0',
                                            marginTop: 'Y'
                                        },
                                        EntryContent: {
                                            flow: 'y',
                                            gap: 'X',
                                            flex: '1',
                                            EntryTitle: {
                                                text: 'Medication Prescribed: Amoxicillin 500mg',
                                                fontSize: 'Z',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            },
                                            EntryDesc: {
                                                text: "Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy \u2014 confirmed Amoxicillin tolerance via skin test.",
                                                fontSize: 'Y',
                                                color: 'inkSubtle',
                                                lineHeight: '1.5'
                                            }
                                        }
                                    }
                                },
                                VisitDivider3: {
                                    height: '1px',
                                    background: 'inkBorder'
                                },
                                // Visit D — Mar 3
                                Visit02D: {
                                    flow: 'y',
                                    gap: 'Y',
                                    V02DHeader: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        V02DDatePill: {
                                            tag: 'span',
                                            text: 'Mar 3, 2026',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'ink',
                                            color: 'red'
                                        },
                                        V02DInfo: {
                                            tag: 'span',
                                            text: "45 min \xb7 Diagnosis",
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            alignSelf: 'center'
                                        }
                                    },
                                    Entry05: {
                                        flow: 'x',
                                        gap: 'Z',
                                        cursor: 'pointer',
                                        background: (el, s)=>s.root.selectedEntry === 'e05' ? 'red.08' : 'transparent',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        margin: '0 -Z',
                                        onClick: (e, el, s)=>s.root.update({
                                                selectedEntry: s.root.selectedEntry === 'e05' ? null : 'e05',
                                                seTitle: 'Diagnosis: Acute Pulpitis #14',
                                                seDate: 'Mar 3, 2026',
                                                seDoctor: 'Dr. Kvaratskhelia',
                                                seType: 'Diagnosis',
                                                seDuration: '45 min',
                                                seColor: 'red',
                                                seDesc: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
                                                seTeeth: '#14',
                                                seVisibility: 'Shared'
                                            }),
                                        CategoryDot: {
                                            width: 'Z',
                                            height: 'Z',
                                            round: 'Z',
                                            background: 'red',
                                            flexShrink: '0',
                                            marginTop: 'Y'
                                        },
                                        EntryContent: {
                                            flow: 'y',
                                            gap: 'X',
                                            flex: '1',
                                            EntryTitle: {
                                                text: 'Diagnosis: Acute Pulpitis #14',
                                                fontSize: 'Z',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            },
                                            EntryDesc: {
                                                text: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
                                                fontSize: 'Y',
                                                color: 'inkSubtle',
                                                lineHeight: '1.5'
                                            }
                                        }
                                    }
                                },
                                TpLink02: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center space-between',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'purple.06',
                                    border: '1px solid purple.20',
                                    cursor: 'pointer',
                                    marginTop: 'Y',
                                    onClick: (e, el, s)=>s.root.update({
                                            activePatientSection: 'treatmentPlan',
                                            selectedPhase: 'p1',
                                            tpCollP1: false,
                                            tpCollP2: false
                                        }),
                                    TpLink02Left: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center center',
                                        TpLink02Icon: {
                                            extends: 'Icon',
                                            icon: 'clipboard',
                                            width: 'B',
                                            height: 'B',
                                            color: 'purple'
                                        },
                                        TpLink02Text: {
                                            flow: 'y',
                                            gap: 'X',
                                            TpLink02Label: {
                                                text: 'Treatment Plan',
                                                fontSize: 'X',
                                                fontWeight: '600',
                                                color: 'purple',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em'
                                            },
                                            TpLink02Name: {
                                                text: "Phase 1: Urgent/Emergency \xb7 Phase 2: Disease Control",
                                                fontSize: 'Y',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            }
                                        }
                                    },
                                    TpLink02Arrow: {
                                        extends: 'Icon',
                                        icon: 'arrowRight',
                                        width: 'B',
                                        height: 'B',
                                        color: 'purple'
                                    }
                                }
                            }
                        },
                        // ── CHAPTER 3 — Restorative Treatment ─────────────────
                        Chapter03: {
                            flow: 'y',
                            round: 'A',
                            border: '1px solid inkBorder',
                            overflow: 'hidden',
                            Ch03Header: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center space-between',
                                cursor: 'pointer',
                                padding: 'Z A',
                                background: 'ink',
                                onClick: (e, el, s)=>s.root.update({
                                        c03open: s.root.c03open === false ? true : false
                                    }),
                                Ch03Left: {
                                    flow: 'y',
                                    gap: 'X',
                                    Ch03Title: {
                                        tag: 'h4',
                                        text: 'Restorative Treatment',
                                        fontSize: 'Z',
                                        fontWeight: '700',
                                        color: 'inkText'
                                    },
                                    Ch03Meta: {
                                        text: "Feb 2026 \xb7 Dr. Beridze \xb7 1 visit",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                },
                                Ch03Right: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center center',
                                    Ch03Badge: {
                                        tag: 'span',
                                        text: 'Restorative',
                                        fontSize: 'Y',
                                        fontWeight: '600',
                                        padding: 'X Z',
                                        round: 'B',
                                        background: 'purple.15',
                                        color: 'purple'
                                    },
                                    Ch03Chevron: {
                                        tag: 'span',
                                        text: (el, s)=>s.root.c03open !== false ? "\u25BE" : "\u25B8",
                                        fontSize: 'Z',
                                        color: 'inkMuted',
                                        marginLeft: 'Y'
                                    }
                                }
                            },
                            Ch03Body: {
                                show: (el, s)=>s.root.c03open !== false,
                                flow: 'y',
                                gap: 'Y',
                                padding: 'Z A',
                                background: 'inkMid',
                                Visit03: {
                                    flow: 'y',
                                    gap: 'Y',
                                    V03Header: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        V03DatePill: {
                                            tag: 'span',
                                            text: 'Feb 15, 2026',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'ink',
                                            color: 'purple'
                                        },
                                        V03Info: {
                                            tag: 'span',
                                            text: "60 min \xb7 Dr. Beridze",
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            alignSelf: 'center'
                                        }
                                    },
                                    Entry06: {
                                        flow: 'x',
                                        gap: 'Z',
                                        cursor: 'pointer',
                                        background: (el, s)=>s.root.selectedEntry === 'e06' ? 'purple.08' : 'transparent',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        margin: '0 -Z',
                                        onClick: (e, el, s)=>s.root.update({
                                                selectedEntry: s.root.selectedEntry === 'e06' ? null : 'e06',
                                                seTitle: "Composite Filling \u2014 Tooth #21",
                                                seDate: 'Feb 15, 2026',
                                                seDoctor: 'Dr. Beridze',
                                                seType: 'Treatment',
                                                seDuration: '60 min',
                                                seColor: 'purple',
                                                seDesc: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
                                                seTeeth: '#21',
                                                seVisibility: 'Shared'
                                            }),
                                        CategoryDot: {
                                            width: 'Z',
                                            height: 'Z',
                                            round: 'Z',
                                            background: 'purple',
                                            flexShrink: '0',
                                            marginTop: 'Y'
                                        },
                                        EntryContent: {
                                            flow: 'y',
                                            gap: 'X',
                                            flex: '1',
                                            EntryTitle: {
                                                text: "Composite Filling \u2014 Tooth #21",
                                                fontSize: 'Z',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            },
                                            EntryDesc: {
                                                text: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
                                                fontSize: 'Y',
                                                color: 'inkSubtle',
                                                lineHeight: '1.5'
                                            }
                                        }
                                    }
                                },
                                TpLink03: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center space-between',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'blue.06',
                                    border: '1px solid blue.20',
                                    cursor: 'pointer',
                                    marginTop: 'Y',
                                    onClick: (e, el, s)=>s.root.update({
                                            activePatientSection: 'treatmentPlan',
                                            selectedPhase: 'p3',
                                            tpCollP3: false
                                        }),
                                    TpLink03Left: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center center',
                                        TpLink03Icon: {
                                            extends: 'Icon',
                                            icon: 'clipboard',
                                            width: 'B',
                                            height: 'B',
                                            color: 'blue'
                                        },
                                        TpLink03Text: {
                                            flow: 'y',
                                            gap: 'X',
                                            TpLink03Label: {
                                                text: 'Treatment Plan',
                                                fontSize: 'X',
                                                fontWeight: '600',
                                                color: 'blue',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em'
                                            },
                                            TpLink03Name: {
                                                text: 'Phase 3: Restorative',
                                                fontSize: 'Y',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            }
                                        }
                                    },
                                    TpLink03Arrow: {
                                        extends: 'Icon',
                                        icon: 'arrowRight',
                                        width: 'B',
                                        height: 'B',
                                        color: 'blue'
                                    }
                                }
                            }
                        },
                        // ── CHAPTER 4 — Initial Consultation ──────────────────
                        Chapter04: {
                            flow: 'y',
                            round: 'A',
                            border: '1px solid inkBorder',
                            overflow: 'hidden',
                            Ch04Header: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center space-between',
                                cursor: 'pointer',
                                padding: 'Z A',
                                background: 'ink',
                                onClick: (e, el, s)=>s.root.update({
                                        c04open: s.root.c04open === false ? true : false
                                    }),
                                Ch04Left: {
                                    flow: 'y',
                                    gap: 'X',
                                    Ch04Title: {
                                        tag: 'h4',
                                        text: 'Initial Consultation & Exam',
                                        fontSize: 'Z',
                                        fontWeight: '700',
                                        color: 'inkText'
                                    },
                                    Ch04Meta: {
                                        text: "Jan 2026 \xb7 Dr. Kvaratskhelia \xb7 1 visit",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                },
                                Ch04Right: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center center',
                                    Ch04Badge: {
                                        tag: 'span',
                                        text: 'Exam',
                                        fontSize: 'Y',
                                        fontWeight: '600',
                                        padding: 'X Z',
                                        round: 'B',
                                        background: 'teal.15',
                                        color: 'teal'
                                    },
                                    Ch04Chevron: {
                                        tag: 'span',
                                        text: (el, s)=>s.root.c04open !== false ? "\u25BE" : "\u25B8",
                                        fontSize: 'Z',
                                        color: 'inkMuted',
                                        marginLeft: 'Y'
                                    }
                                }
                            },
                            Ch04Body: {
                                show: (el, s)=>s.root.c04open !== false,
                                flow: 'y',
                                gap: 'Y',
                                padding: 'Z A',
                                background: 'inkMid',
                                Visit04: {
                                    flow: 'y',
                                    gap: 'Y',
                                    V04Header: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        V04DatePill: {
                                            tag: 'span',
                                            text: 'Jan 20, 2026',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'ink',
                                            color: 'teal'
                                        },
                                        V04Info: {
                                            tag: 'span',
                                            text: "90 min \xb7 Dr. Kvaratskhelia",
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            alignSelf: 'center'
                                        }
                                    },
                                    Entry07: {
                                        flow: 'x',
                                        gap: 'Z',
                                        cursor: 'pointer',
                                        background: (el, s)=>s.root.selectedEntry === 'e07' ? 'teal.08' : 'transparent',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        margin: '0 -Z',
                                        onClick: (e, el, s)=>s.root.update({
                                                selectedEntry: s.root.selectedEntry === 'e07' ? null : 'e07',
                                                seTitle: 'Comprehensive Examination',
                                                seDate: 'Jan 20, 2026',
                                                seDoctor: 'Dr. Kvaratskhelia',
                                                seType: 'Consultation',
                                                seDuration: '90 min',
                                                seColor: 'teal',
                                                seDesc: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
                                                seTeeth: 'Full mouth',
                                                seVisibility: 'Shared'
                                            }),
                                        CategoryDot: {
                                            width: 'Z',
                                            height: 'Z',
                                            round: 'Z',
                                            background: 'teal',
                                            flexShrink: '0',
                                            marginTop: 'Y'
                                        },
                                        EntryContent: {
                                            flow: 'y',
                                            gap: 'X',
                                            flex: '1',
                                            EntryTitle: {
                                                text: 'Comprehensive Examination',
                                                fontSize: 'Z',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            },
                                            EntryDesc: {
                                                text: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
                                                fontSize: 'Y',
                                                color: 'inkSubtle',
                                                lineHeight: '1.5'
                                            }
                                        }
                                    }
                                },
                                TpLink04: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center space-between',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'inkSurface',
                                    border: '1px solid inkBorder',
                                    cursor: 'pointer',
                                    marginTop: 'Y',
                                    onClick: (e, el, s)=>s.root.update({
                                            activePatientSection: 'treatmentPlan',
                                            selectedPhase: 'p2',
                                            tpCollP1: false,
                                            tpCollP2: false
                                        }),
                                    TpLink04Left: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center center',
                                        TpLink04Icon: {
                                            extends: 'Icon',
                                            icon: 'clipboard',
                                            width: 'B',
                                            height: 'B',
                                            color: 'inkMuted'
                                        },
                                        TpLink04Text: {
                                            flow: 'y',
                                            gap: 'X',
                                            TpLink04Label: {
                                                text: 'Treatment Plan',
                                                fontSize: 'X',
                                                fontWeight: '600',
                                                color: 'inkMuted',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em'
                                            },
                                            TpLink04Name: {
                                                text: "Phase 1: Urgent/Emergency \xb7 Phase 2: Disease Control",
                                                fontSize: 'Y',
                                                fontWeight: '600',
                                                color: 'inkText'
                                            }
                                        }
                                    },
                                    TpLink04Arrow: {
                                        extends: 'Icon',
                                        icon: 'arrowRight',
                                        width: 'B',
                                        height: 'B',
                                        color: 'inkMuted'
                                    }
                                }
                            }
                        }
                    },
                    // ─── Entry Detail Panel (EHR form, pre-filled) ──
                    EntryDetailPanel: {
                        show: (el, s)=>!!s.root.selectedEntry,
                        flow: 'y',
                        gap: 'Z',
                        width: 'H',
                        flexShrink: '0',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: (el, s)=>`1px solid ${s.root.seColor || 'teal'}`,
                        position: 'sticky',
                        top: 'A',
                        overflow: 'auto',
                        maxHeight: '85vh',
                        DPanelHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            marginBottom: 'Z',
                            DPanelLeft: {
                                flow: 'y',
                                gap: 'X',
                                DTypeBadge: {
                                    tag: 'span',
                                    text: (el, s)=>s.root.seType || 'Record',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Z',
                                    round: 'B',
                                    background: (el, s)=>`${s.root.seColor || 'teal'}.15`,
                                    color: (el, s)=>s.root.seColor || 'teal'
                                },
                                DSubtitle: {
                                    text: 'View / Edit Record',
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            },
                            DCloseBtn: {
                                tag: 'span',
                                text: "\u2715",
                                fontSize: 'Z',
                                color: 'inkMuted',
                                cursor: 'pointer',
                                padding: 'Y',
                                onClick: (e, el, s)=>s.root.update({
                                        selectedEntry: null
                                    })
                            }
                        },
                        // ── EHR Sync ─────────────────────────────
                        DEhrBlock: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'ink',
                            border: '1px solid inkBorder',
                            marginBottom: 'Z',
                            DEhrTitle: {
                                text: 'EHR / System Sync',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'teal',
                                marginBottom: 'X'
                            },
                            DEhrRow: {
                                flow: 'x',
                                gap: 'Z',
                                flexWrap: 'wrap',
                                DEhrSys: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    minWidth: '120px',
                                    DEhrSysL: {
                                        tag: 'label',
                                        text: 'EHR System',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    DEhrSysV: {
                                        tag: 'select',
                                        fontSize: 'Z',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        background: 'inkMid',
                                        border: '1px solid inkBorder',
                                        color: 'inkText',
                                        width: '100%',
                                        children: [
                                            {
                                                tag: 'option',
                                                text: "\u2014 None \u2014"
                                            },
                                            {
                                                tag: 'option',
                                                text: 'Epic'
                                            },
                                            {
                                                tag: 'option',
                                                text: 'OpenDental'
                                            },
                                            {
                                                tag: 'option',
                                                text: 'Dentrix'
                                            }
                                        ]
                                    }
                                },
                                DSyncSt: {
                                    flow: 'y',
                                    gap: 'X',
                                    flex: '1',
                                    minWidth: '100px',
                                    DSyncStL: {
                                        tag: 'label',
                                        text: 'Sync Status',
                                        fontSize: 'Y',
                                        color: 'inkMuted',
                                        fontWeight: '600'
                                    },
                                    DSyncStV: {
                                        tag: 'select',
                                        fontSize: 'Z',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        background: 'inkMid',
                                        border: '1px solid inkBorder',
                                        color: 'inkText',
                                        width: '100%',
                                        children: [
                                            {
                                                tag: 'option',
                                                text: 'Not Synced'
                                            },
                                            {
                                                tag: 'option',
                                                text: 'Sync on Save'
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        // ── Core Fields ──────────────────────────
                        DCoreRow1: {
                            flow: 'x',
                            gap: 'Z',
                            flexWrap: 'wrap',
                            marginBottom: 'Z',
                            DTypeField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '120px',
                                DTypeL: {
                                    tag: 'label',
                                    text: 'Event Type *',
                                    fontSize: 'Y',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                },
                                DTypeV: {
                                    tag: 'input',
                                    type: 'text',
                                    value: (el, s)=>s.root.seType || '',
                                    placeholder: 'Type',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'ink',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            DDateField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '110px',
                                DDateL: {
                                    tag: 'label',
                                    text: 'Date *',
                                    fontSize: 'Y',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                },
                                DDateV: {
                                    tag: 'input',
                                    type: 'text',
                                    value: (el, s)=>s.root.seDate || '',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'ink',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            }
                        },
                        DCoreRow2: {
                            flow: 'x',
                            gap: 'Z',
                            flexWrap: 'wrap',
                            marginBottom: 'Z',
                            DDoctField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '130px',
                                DDoctL: {
                                    tag: 'label',
                                    text: 'Doctor *',
                                    fontSize: 'Y',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                },
                                DDoctV: {
                                    tag: 'input',
                                    type: 'text',
                                    value: (el, s)=>s.root.seDoctor || '',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'ink',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            DTeethField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '90px',
                                DTeethL: {
                                    tag: 'label',
                                    text: 'Teeth',
                                    fontSize: 'Y',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                },
                                DTeethV: {
                                    tag: 'input',
                                    type: 'text',
                                    value: (el, s)=>s.root.seTeeth || '',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'ink',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            },
                            DDurField: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                minWidth: '90px',
                                DDurL: {
                                    tag: 'label',
                                    text: 'Duration',
                                    fontSize: 'Y',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                },
                                DDurV: {
                                    tag: 'input',
                                    type: 'text',
                                    value: (el, s)=>s.root.seDuration || '',
                                    fontSize: 'Z',
                                    padding: 'Y Z',
                                    round: 'Y',
                                    background: 'ink',
                                    border: '1px solid inkBorder',
                                    color: 'inkText',
                                    width: '100%'
                                }
                            }
                        },
                        DTitleField: {
                            flow: 'y',
                            gap: 'X',
                            marginBottom: 'Z',
                            DTitleL: {
                                tag: 'label',
                                text: 'Title *',
                                fontSize: 'Y',
                                color: 'inkMuted',
                                fontWeight: '600'
                            },
                            DTitleV: {
                                tag: 'input',
                                type: 'text',
                                value: (el, s)=>s.root.seTitle || '',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%'
                            }
                        },
                        // ── Clinical Notes (SOAP) ────────────────
                        DSoapBlock: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'ink',
                            border: '1px solid inkBorder',
                            marginBottom: 'Z',
                            DSoapTitle: {
                                text: 'Clinical Notes',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'inkMuted',
                                marginBottom: 'X'
                            },
                            DSoapText: {
                                tag: 'textarea',
                                value: (el, s)=>s.root.seDesc || '',
                                fontSize: 'Z',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'inkMid',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                width: '100%',
                                rows: '5',
                                lineHeight: '1.6',
                                placeholder: 'Clinical notes, SOAP...'
                            }
                        },
                        // ── Visibility + Actions ─────────────────
                        DVisRow: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            marginBottom: 'Z',
                            DVisLabel: {
                                tag: 'span',
                                text: 'Visibility:',
                                fontSize: 'Y',
                                color: 'inkMuted',
                                fontWeight: '600',
                                alignSelf: 'center'
                            },
                            DPrivBtn: {
                                tag: 'span',
                                text: 'Private',
                                fontSize: 'Y',
                                padding: 'X Z',
                                round: 'B',
                                cursor: 'pointer',
                                fontWeight: (el, s)=>s.root.seVisibility === 'Private' ? '700' : '400',
                                background: (el, s)=>s.root.seVisibility === 'Private' ? 'ink' : 'transparent',
                                border: (el, s)=>s.root.seVisibility === 'Private' ? '1px solid inkBorder' : '1px solid transparent',
                                color: 'inkText',
                                onClick: (e, el, s)=>s.root.update({
                                        seVisibility: 'Private'
                                    })
                            },
                            DSharedBtn: {
                                tag: 'span',
                                text: 'Shared',
                                fontSize: 'Y',
                                padding: 'X Z',
                                round: 'B',
                                cursor: 'pointer',
                                fontWeight: (el, s)=>s.root.seVisibility !== 'Private' ? '700' : '400',
                                background: (el, s)=>s.root.seVisibility !== 'Private' ? 'teal.15' : 'transparent',
                                border: (el, s)=>s.root.seVisibility !== 'Private' ? '1px solid teal.30' : '1px solid transparent',
                                color: (el, s)=>s.root.seVisibility !== 'Private' ? 'teal' : 'inkMuted',
                                onClick: (e, el, s)=>s.root.update({
                                        seVisibility: 'Shared'
                                    })
                            }
                        },
                        DActions: {
                            flow: 'x',
                            gap: 'Y',
                            flexWrap: 'wrap',
                            DCancelBtn: {
                                text: 'Close',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkMuted',
                                cursor: 'pointer',
                                flex: '1',
                                textAlign: 'center',
                                onClick: (e, el, s)=>s.root.update({
                                        selectedEntry: null
                                    })
                            },
                            DPrintBtn: {
                                text: 'Print',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'ink',
                                border: '1px solid inkBorder',
                                color: 'inkText',
                                cursor: 'pointer',
                                flex: '1',
                                textAlign: 'center'
                            },
                            DSaveBtn: {
                                text: "\u21BB Save & Sync",
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'teal',
                                color: 'white',
                                cursor: 'pointer',
                                flex: '1',
                                textAlign: 'center'
                            }
                        }
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // 2. CHART (Odontogram)
            // ═══════════════════════════════════════════════
            ChartSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activePatientSection === 'chart',
                ChartLayout: {
                    flow: 'x',
                    gap: 'A',
                    align: 'stretch flex-start',
                    '@mobileL': {
                        flow: 'y'
                    },
                    OdontogramSection: {
                        flow: 'y',
                        gap: 'A',
                        flex: '1',
                        ChartLegend: {},
                        OdontogramGrid: {},
                        ProcedureButtonBar: {
                            flow: 'x',
                            gap: 'Y',
                            flexWrap: 'wrap',
                            padding: 'Z 0',
                            children: [
                                {
                                    name: 'Periodic Exam',
                                    code: 'D0120'
                                },
                                {
                                    name: 'FMX',
                                    code: 'D0210'
                                },
                                {
                                    name: 'Bitewings',
                                    code: 'D0274'
                                },
                                {
                                    name: 'Prophylaxis',
                                    code: 'D1110'
                                },
                                {
                                    name: 'Composite',
                                    code: 'D2391'
                                },
                                {
                                    name: 'Crown',
                                    code: 'D2750'
                                },
                                {
                                    name: 'Root Canal',
                                    code: 'D3310'
                                },
                                {
                                    name: 'SRP',
                                    code: 'D4341'
                                },
                                {
                                    name: 'Extraction',
                                    code: 'D7140'
                                }
                            ],
                            childrenAs: 'state',
                            childExtends: 'ProcedureButton'
                        }
                    },
                    ToothDetailPanel: {
                        show: (el, s)=>s.root.selectedTooth !== null
                    }
                },
                // ─── Chart History ─────────────────────────────
                ChartHistorySection: {
                    flow: 'y',
                    gap: 'Z',
                    marginTop: 'A',
                    HistoryHeader: {
                        flow: 'x',
                        gap: 'A',
                        align: 'center space-between',
                        HistoryTitle: {
                            tag: 'h3',
                            text: 'Chart History',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'inkText'
                        },
                        HistorySubtitle: {
                            text: 'Odontogram snapshots over time',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            alignSelf: 'center'
                        }
                    },
                    HistoryTabs: {
                        flow: 'x',
                        gap: 'Z',
                        borderBottom: '1px solid inkBorder',
                        paddingBottom: 'Y',
                        TabMar2026: {
                            text: 'Mar 2026',
                            fontSize: 'Z',
                            fontWeight: '600',
                            padding: 'Y Z',
                            cursor: 'pointer',
                            color: (el, s)=>s.root.chartHistTab !== 'jan2026' && s.root.chartHistTab !== 'initial' ? 'teal' : 'inkMuted',
                            borderBottom: (el, s)=>s.root.chartHistTab !== 'jan2026' && s.root.chartHistTab !== 'initial' ? '2px solid teal' : '2px solid transparent',
                            onClick: (e, el, s)=>s.root.update({
                                    chartHistTab: 'mar2026'
                                })
                        },
                        TabJan2026: {
                            text: 'Jan 2026',
                            fontSize: 'Z',
                            fontWeight: '600',
                            padding: 'Y Z',
                            cursor: 'pointer',
                            color: (el, s)=>s.root.chartHistTab === 'jan2026' ? 'teal' : 'inkMuted',
                            borderBottom: (el, s)=>s.root.chartHistTab === 'jan2026' ? '2px solid teal' : '2px solid transparent',
                            onClick: (e, el, s)=>s.root.update({
                                    chartHistTab: 'jan2026'
                                })
                        },
                        TabInitial: {
                            text: 'Initial (Jan 2026)',
                            fontSize: 'Z',
                            fontWeight: '600',
                            padding: 'Y Z',
                            cursor: 'pointer',
                            color: (el, s)=>s.root.chartHistTab === 'initial' ? 'teal' : 'inkMuted',
                            borderBottom: (el, s)=>s.root.chartHistTab === 'initial' ? '2px solid teal' : '2px solid transparent',
                            onClick: (e, el, s)=>s.root.update({
                                    chartHistTab: 'initial'
                                })
                        }
                    },
                    HistorySnapshot: {
                        flow: 'y',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        SnapshotMeta: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            flexWrap: 'wrap',
                            SnapDate: {
                                text: (el, s)=>s.root.chartHistTab === 'jan2026' ? "Jan 20, 2026 \xb7 Initial Exam" : s.root.chartHistTab === 'initial' ? "Jan 20, 2026 \xb7 Baseline" : "Mar 10, 2026 \xb7 Latest",
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            SnapDoctor: {
                                text: (el, s)=>s.root.chartHistTab === 'jan2026' || s.root.chartHistTab === 'initial' ? 'Dr. Kvaratskhelia' : 'Dr. Lomidze',
                                fontSize: 'Y',
                                color: 'inkMuted',
                                alignSelf: 'center'
                            }
                        },
                        SnapChanges: {
                            flow: 'y',
                            gap: 'Y',
                            ChangesLabel: {
                                text: 'Changes from this visit:',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            ChangesList: {
                                flow: 'y',
                                gap: 'X',
                                C1: {
                                    show: (el, s)=>s.root.chartHistTab !== 'jan2026' && s.root.chartHistTab !== 'initial',
                                    flow: 'x',
                                    gap: 'Y',
                                    align: 'center flex-start',
                                    Dot: {
                                        width: 'X',
                                        height: 'X',
                                        round: 'X',
                                        background: 'purple',
                                        flexShrink: '0',
                                        marginTop: 'X'
                                    },
                                    Txt: {
                                        tag: 'span',
                                        text: "Crown prep on #14 \u2014 PFM crown cemented",
                                        fontSize: 'Y',
                                        color: 'inkSubtle'
                                    }
                                },
                                C2: {
                                    show: (el, s)=>s.root.chartHistTab !== 'jan2026' && s.root.chartHistTab !== 'initial',
                                    flow: 'x',
                                    gap: 'Y',
                                    align: 'center flex-start',
                                    Dot: {
                                        width: 'X',
                                        height: 'X',
                                        round: 'X',
                                        background: 'amber',
                                        flexShrink: '0',
                                        marginTop: 'X'
                                    },
                                    Txt: {
                                        tag: 'span',
                                        text: 'Root canal completed on #14',
                                        fontSize: 'Y',
                                        color: 'inkSubtle'
                                    }
                                },
                                C3: {
                                    show: (el, s)=>s.root.chartHistTab === 'jan2026' || s.root.chartHistTab === 'initial',
                                    flow: 'x',
                                    gap: 'Y',
                                    align: 'center flex-start',
                                    Dot: {
                                        width: 'X',
                                        height: 'X',
                                        round: 'X',
                                        background: 'red',
                                        flexShrink: '0',
                                        marginTop: 'X'
                                    },
                                    Txt: {
                                        tag: 'span',
                                        text: 'Caries detected: #14 occlusal, #15 mesial',
                                        fontSize: 'Y',
                                        color: 'inkSubtle'
                                    }
                                },
                                C4: {
                                    show: (el, s)=>s.root.chartHistTab === 'jan2026' || s.root.chartHistTab === 'initial',
                                    flow: 'x',
                                    gap: 'Y',
                                    align: 'center flex-start',
                                    Dot: {
                                        width: 'X',
                                        height: 'X',
                                        round: 'X',
                                        background: 'amber',
                                        flexShrink: '0',
                                        marginTop: 'X'
                                    },
                                    Txt: {
                                        tag: 'span',
                                        text: "Perio pockets 4mm+ on 24 sites \u2014 Stage III Grade B",
                                        fontSize: 'Y',
                                        color: 'inkSubtle'
                                    }
                                }
                            }
                        },
                        OdontogramGrid: {}
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // 3. PERIO
            // ═══════════════════════════════════════════════
            PerioSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activePatientSection === 'perio',
                PerioHeader: {
                    flow: 'x',
                    gap: 'A',
                    align: 'center space-between',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y',
                        gap: 'Z'
                    },
                    HeaderLeft: {
                        flow: 'x',
                        gap: 'A',
                        align: 'center flex-start',
                        PageTitle: {
                            tag: 'h3',
                            text: '{{ periodontalChart | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'inkText'
                        },
                        PerioExamSelector: {}
                    },
                    HeaderRight: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center flex-start',
                        NewExamBtn: {
                            extends: 'Button',
                            text: '{{ newExam2 | polyglot }}',
                            background: 'teal',
                            color: 'inkText',
                            fontWeight: '600',
                            padding: 'Y A',
                            round: 'A',
                            fontSize: 'Z',
                            cursor: 'pointer',
                            border: 'none'
                        },
                        VoiceToggle: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            padding: 'Y A',
                            round: 'A',
                            cursor: 'pointer',
                            background: (el, s)=>s.root.voiceEntry ? 'purple' : 'inkMid',
                            border: (el, s)=>s.root.voiceEntry ? '1px solid purple' : '1px solid inkBorder',
                            onClick: (e, el, s)=>s.root.update({
                                    voiceEntry: !s.root.voiceEntry
                                }),
                            MicIcon: {
                                extends: 'Icon',
                                icon: 'microphone',
                                width: 'Z',
                                height: 'Z',
                                color: (el, s)=>s.root.voiceEntry ? 'inkText' : 'inkMuted'
                            },
                            VoiceLabel: {
                                text: '{{ voiceEntry2 | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: (el, s)=>s.root.voiceEntry ? 'inkText' : 'inkMuted'
                            }
                        }
                    }
                },
                PerioGrid: {},
                PerioIndexCards: {
                    state: {
                        bleeding: 18,
                        plaque: 12,
                        sitesFourPlus: 24,
                        sitesSixPlus: 6
                    }
                },
                PerioAiInsight: {
                    extends: 'AiInsightCard',
                    state: {
                        insight: 'Based on current exam: AAP Stage III, Grade B periodontitis. 6 sites show progression. Recommend: SRP quadrants 1,4. Re-evaluate in 4-6 weeks.',
                        confidence: '89'
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // 4. TREATMENT PLAN
            // ═══════════════════════════════════════════════
            TreatmentPlanSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activePatientSection === 'treatmentPlan',
                PlanHeader: {
                    flow: 'x',
                    gap: 'A',
                    align: 'center space-between',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y',
                        gap: 'Z'
                    },
                    PageTitle: {
                        tag: 'h3',
                        text: '{{ treatmentPlan | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    ChairSideToggle: {
                        extends: 'Button',
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        padding: 'Y Z',
                        round: 'C',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: 'Y',
                        border: (el, s)=>s.root.chairSideMode ? '1px solid teal' : '1px solid inkBorder',
                        background: (el, s)=>s.root.chairSideMode ? 'teal.15' : 'inkSurface',
                        color: (el, s)=>s.root.chairSideMode ? 'teal' : 'inkMuted',
                        transition: 'all 0.2s ease',
                        ToggleIcon: {
                            extends: 'Icon',
                            icon: (el, s)=>s.root.chairSideMode ? 'eye' : 'eyeOff',
                            fontSize: 'Z'
                        },
                        Label: {
                            text: (el, s)=>s.root.chairSideMode ? '{{ chairSideMode | polyglot }}' : '{{ adminMode | polyglot }}'
                        },
                        onClick: (e, el, s)=>s.root.update({
                                chairSideMode: !s.root.chairSideMode
                            })
                    }
                },
                PlanSelector: {
                    flow: 'x',
                    gap: 'Z',
                    borderBottom: '1px solid inkBorder',
                    paddingBottom: 'Y',
                    TabPlanA: {
                        text: '{{ planARecommended | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        padding: 'Y Z',
                        cursor: 'pointer',
                        color: (el, s)=>s.root.activePlan === 'planA' ? 'teal' : 'inkMuted',
                        borderBottom: (el, s)=>s.root.activePlan === 'planA' ? '2px solid teal' : '2px solid transparent',
                        onClick: (e, el, s)=>s.root.update({
                                activePlan: 'planA'
                            })
                    },
                    TabPlanB: {
                        text: '{{ planBConservative | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        padding: 'Y Z',
                        cursor: 'pointer',
                        color: (el, s)=>s.root.activePlan === 'planB' ? 'teal' : 'inkMuted',
                        borderBottom: (el, s)=>s.root.activePlan === 'planB' ? '2px solid teal' : '2px solid transparent',
                        onClick: (e, el, s)=>s.root.update({
                                activePlan: 'planB'
                            })
                    },
                    TabNewPlan: {
                        text: '{{ newPlan2 | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        padding: 'Y Z',
                        cursor: 'pointer',
                        color: 'inkMuted'
                    }
                },
                PlanAView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.activePlan !== 'planB',
                    // ── Two-column layout (phases + timeline summary) ──
                    PlanLayout: {
                        flow: 'x',
                        gap: 'A',
                        align: 'flex-start flex-start',
                        PhaseColumn: {
                            flow: 'y',
                            gap: 'A',
                            flex: '1',
                            minWidth: '0',
                            // ── PHASE 1 ──────────────────────────────────
                            Phase1Card: {
                                flow: 'y',
                                round: 'A',
                                overflow: 'hidden',
                                border: '1px solid teal',
                                PhaseHeader1: {
                                    flow: 'x',
                                    align: 'center space-between',
                                    padding: 'Z A',
                                    cursor: 'pointer',
                                    background: 'teal.08',
                                    onClick: (e, el, s)=>s.root.update({
                                            selectedPhase: s.root.selectedPhase === 'p1' ? null : 'p1',
                                            tpCollP1: !s.root.tpCollP1
                                        }),
                                    PhLeft1: {
                                        flow: 'y',
                                        gap: 'X',
                                        PhTitle1: {
                                            tag: 'h4',
                                            text: 'Phase 1: Urgent/Emergency',
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        },
                                        PhMeta1: {
                                            text: "2 procedures \xb7 Dr. Lomidze",
                                            fontSize: 'Y',
                                            color: 'inkMuted'
                                        }
                                    },
                                    PhRight1: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center center',
                                        PhBadge1: {
                                            tag: 'span',
                                            text: 'active',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'teal.15',
                                            color: 'teal'
                                        },
                                        PhChev1: {
                                            tag: 'span',
                                            text: (el, s)=>s.root.tpCollP1 ? "\u25B8" : "\u25BE",
                                            fontSize: 'Z',
                                            color: 'inkMuted',
                                            marginLeft: 'Y'
                                        }
                                    }
                                },
                                PhBody1: {
                                    show: (el, s)=>!s.root.tpCollP1,
                                    flow: 'y',
                                    background: 'inkMid',
                                    borderTop: '1px solid inkBorder',
                                    Row1: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        borderBottom: '1px solid inkBorder',
                                        R1Code: {
                                            tag: 'span',
                                            text: 'D7140',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R1Desc: {
                                            flex: '1',
                                            text: 'Extraction #36',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R1Tooth: {
                                            tag: 'span',
                                            text: '#36',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R1Fee: {
                                            tag: 'span',
                                            text: "\u20BE150",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    Row2: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        R2Code: {
                                            tag: 'span',
                                            text: 'D2950',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R2Desc: {
                                            flex: '1',
                                            text: 'Core Buildup #14',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R2Tooth: {
                                            tag: 'span',
                                            text: '#14',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R2Fee: {
                                            tag: 'span',
                                            text: "\u20BE120",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    PhSum1: {
                                        flow: 'x',
                                        align: 'center space-between',
                                        padding: 'Y A',
                                        background: 'inkSurface',
                                        borderTop: '1px solid inkBorder',
                                        SumLbl: {
                                            text: 'Phase Total',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            color: 'inkMuted'
                                        },
                                        SumRight: {
                                            flow: 'x',
                                            gap: 'A',
                                            SumAmt: {
                                                text: "\u20BE270",
                                                fontSize: 'Z',
                                                fontWeight: '700',
                                                color: 'teal'
                                            },
                                            SumCnt: {
                                                text: '2 procedures',
                                                fontSize: 'Y',
                                                color: 'inkMuted'
                                            }
                                        }
                                    }
                                }
                            },
                            // ── PHASE 2 ──────────────────────────────────
                            Phase2Card: {
                                flow: 'y',
                                round: 'A',
                                overflow: 'hidden',
                                border: '1px solid inkBorder',
                                PhaseHeader2: {
                                    flow: 'x',
                                    align: 'center space-between',
                                    padding: 'Z A',
                                    cursor: 'pointer',
                                    background: 'ink',
                                    onClick: (e, el, s)=>s.root.update({
                                            selectedPhase: s.root.selectedPhase === 'p2' ? null : 'p2',
                                            tpCollP2: !s.root.tpCollP2
                                        }),
                                    PhLeft2: {
                                        flow: 'y',
                                        gap: 'X',
                                        PhTitle2: {
                                            tag: 'h4',
                                            text: 'Phase 2: Disease Control',
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'inkText'
                                        },
                                        PhMeta2: {
                                            text: "3 procedures \xb7 Dr. Kvaratskhelia",
                                            fontSize: 'Y',
                                            color: 'inkMuted'
                                        }
                                    },
                                    PhRight2: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center center',
                                        PhBadge2: {
                                            tag: 'span',
                                            text: 'pending',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'inkMid',
                                            color: 'inkMuted'
                                        },
                                        PhChev2: {
                                            tag: 'span',
                                            text: (el, s)=>s.root.tpCollP2 ? "\u25B8" : "\u25BE",
                                            fontSize: 'Z',
                                            color: 'inkMuted',
                                            marginLeft: 'Y'
                                        }
                                    }
                                },
                                PhBody2: {
                                    show: (el, s)=>!s.root.tpCollP2,
                                    flow: 'y',
                                    background: 'inkMid',
                                    borderTop: '1px solid inkBorder',
                                    Row3: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        borderBottom: '1px solid inkBorder',
                                        R3Code: {
                                            tag: 'span',
                                            text: 'D4341',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R3Desc: {
                                            flex: '1',
                                            text: 'SRP Quadrant 1',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R3Tooth: {
                                            tag: 'span',
                                            text: 'Q1',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R3Fee: {
                                            tag: 'span',
                                            text: "\u20BE200",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    Row4: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        borderBottom: '1px solid inkBorder',
                                        R4Code: {
                                            tag: 'span',
                                            text: 'D4341',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R4Desc: {
                                            flex: '1',
                                            text: 'SRP Quadrant 4',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R4Tooth: {
                                            tag: 'span',
                                            text: 'Q4',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R4Fee: {
                                            tag: 'span',
                                            text: "\u20BE200",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    Row5: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        R5Code: {
                                            tag: 'span',
                                            text: 'D4910',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R5Desc: {
                                            flex: '1',
                                            text: 'Perio Maintenance',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R5Tooth: {
                                            tag: 'span',
                                            text: 'Full',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R5Fee: {
                                            tag: 'span',
                                            text: "\u20BE80",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    PhSum2: {
                                        flow: 'x',
                                        align: 'center space-between',
                                        padding: 'Y A',
                                        background: 'inkSurface',
                                        borderTop: '1px solid inkBorder',
                                        SumLbl: {
                                            text: 'Phase Total',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            color: 'inkMuted'
                                        },
                                        SumRight: {
                                            flow: 'x',
                                            gap: 'A',
                                            SumAmt: {
                                                text: "\u20BE480",
                                                fontSize: 'Z',
                                                fontWeight: '700',
                                                color: 'teal'
                                            },
                                            SumCnt: {
                                                text: '3 procedures',
                                                fontSize: 'Y',
                                                color: 'inkMuted'
                                            }
                                        }
                                    }
                                }
                            },
                            // ── PHASE 3 ──────────────────────────────────
                            Phase3Card: {
                                flow: 'y',
                                round: 'A',
                                overflow: 'hidden',
                                border: '1px solid inkBorder',
                                PhaseHeader3: {
                                    flow: 'x',
                                    align: 'center space-between',
                                    padding: 'Z A',
                                    cursor: 'pointer',
                                    background: 'ink',
                                    onClick: (e, el, s)=>s.root.update({
                                            selectedPhase: s.root.selectedPhase === 'p3' ? null : 'p3',
                                            tpCollP3: !s.root.tpCollP3
                                        }),
                                    PhLeft3: {
                                        flow: 'y',
                                        gap: 'X',
                                        PhTitle3: {
                                            tag: 'h4',
                                            text: 'Phase 3: Restorative',
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'inkText'
                                        },
                                        PhMeta3: {
                                            text: "3 procedures \xb7 Dr. Lomidze, Dr. Beridze",
                                            fontSize: 'Y',
                                            color: 'inkMuted'
                                        }
                                    },
                                    PhRight3: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center center',
                                        PhBadge3: {
                                            tag: 'span',
                                            text: 'pending',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'inkMid',
                                            color: 'inkMuted'
                                        },
                                        PhChev3: {
                                            tag: 'span',
                                            text: (el, s)=>s.root.tpCollP3 ? "\u25B8" : "\u25BE",
                                            fontSize: 'Z',
                                            color: 'inkMuted',
                                            marginLeft: 'Y'
                                        }
                                    }
                                },
                                PhBody3: {
                                    show: (el, s)=>!s.root.tpCollP3,
                                    flow: 'y',
                                    background: 'inkMid',
                                    borderTop: '1px solid inkBorder',
                                    Row6: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        borderBottom: '1px solid inkBorder',
                                        R6Code: {
                                            tag: 'span',
                                            text: 'D2750',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R6Desc: {
                                            flex: '1',
                                            text: 'Crown #14',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R6Tooth: {
                                            tag: 'span',
                                            text: '#14',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R6Fee: {
                                            tag: 'span',
                                            text: "\u20BE800",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    Row7: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        borderBottom: '1px solid inkBorder',
                                        R7Code: {
                                            tag: 'span',
                                            text: 'D6010',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R7Desc: {
                                            flex: '1',
                                            text: 'Implant #36',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R7Tooth: {
                                            tag: 'span',
                                            text: '#36',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R7Fee: {
                                            tag: 'span',
                                            text: "\u20BE1,200",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    Row8: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        R8Code: {
                                            tag: 'span',
                                            text: 'D6058',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R8Desc: {
                                            flex: '1',
                                            text: 'Implant Crown #36',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R8Tooth: {
                                            tag: 'span',
                                            text: '#36',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R8Fee: {
                                            tag: 'span',
                                            text: "\u20BE600",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    PhSum3: {
                                        flow: 'x',
                                        align: 'center space-between',
                                        padding: 'Y A',
                                        background: 'inkSurface',
                                        borderTop: '1px solid inkBorder',
                                        SumLbl: {
                                            text: 'Phase Total',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            color: 'inkMuted'
                                        },
                                        SumRight: {
                                            flow: 'x',
                                            gap: 'A',
                                            SumAmt: {
                                                text: "\u20BE2,600",
                                                fontSize: 'Z',
                                                fontWeight: '700',
                                                color: 'teal'
                                            },
                                            SumCnt: {
                                                text: '3 procedures',
                                                fontSize: 'Y',
                                                color: 'inkMuted'
                                            }
                                        }
                                    }
                                }
                            },
                            // ── PHASE 4 ──────────────────────────────────
                            Phase4Card: {
                                flow: 'y',
                                round: 'A',
                                overflow: 'hidden',
                                border: '1px solid inkBorder',
                                PhaseHeader4: {
                                    flow: 'x',
                                    align: 'center space-between',
                                    padding: 'Z A',
                                    cursor: 'pointer',
                                    background: 'ink',
                                    onClick: (e, el, s)=>s.root.update({
                                            selectedPhase: s.root.selectedPhase === 'p4' ? null : 'p4',
                                            tpCollP4: !s.root.tpCollP4
                                        }),
                                    PhLeft4: {
                                        flow: 'y',
                                        gap: 'X',
                                        PhTitle4: {
                                            tag: 'h4',
                                            text: 'Phase 4: Maintenance',
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'inkText'
                                        },
                                        PhMeta4: {
                                            text: "3 procedures \xb7 Multiple providers",
                                            fontSize: 'Y',
                                            color: 'inkMuted'
                                        }
                                    },
                                    PhRight4: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center center',
                                        PhBadge4: {
                                            tag: 'span',
                                            text: 'pending',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            padding: 'X Z',
                                            round: 'B',
                                            background: 'inkMid',
                                            color: 'inkMuted'
                                        },
                                        PhChev4: {
                                            tag: 'span',
                                            text: (el, s)=>s.root.tpCollP4 ? "\u25B8" : "\u25BE",
                                            fontSize: 'Z',
                                            color: 'inkMuted',
                                            marginLeft: 'Y'
                                        }
                                    }
                                },
                                PhBody4: {
                                    show: (el, s)=>!s.root.tpCollP4,
                                    flow: 'y',
                                    background: 'inkMid',
                                    borderTop: '1px solid inkBorder',
                                    Row9: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        borderBottom: '1px solid inkBorder',
                                        R9Code: {
                                            tag: 'span',
                                            text: 'D0120',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R9Desc: {
                                            flex: '1',
                                            text: 'Periodic Exam',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R9Tooth: {
                                            tag: 'span',
                                            text: 'Full',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R9Fee: {
                                            tag: 'span',
                                            text: "\u20BE30",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    Row10: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        borderBottom: '1px solid inkBorder',
                                        R10Code: {
                                            tag: 'span',
                                            text: 'D1110',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R10Desc: {
                                            flex: '1',
                                            text: 'Prophylaxis',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R10Tooth: {
                                            tag: 'span',
                                            text: 'Full',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R10Fee: {
                                            tag: 'span',
                                            text: "\u20BE50",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    Row11: {
                                        flow: 'x',
                                        gap: 'Z',
                                        align: 'center flex-start',
                                        padding: 'Y A',
                                        R11Code: {
                                            tag: 'span',
                                            text: 'D0274',
                                            fontSize: 'Y',
                                            fontWeight: '700',
                                            color: 'teal',
                                            width: 'E',
                                            flexShrink: '0'
                                        },
                                        R11Desc: {
                                            flex: '1',
                                            text: 'BWX',
                                            fontSize: 'Z',
                                            color: 'inkText'
                                        },
                                        R11Tooth: {
                                            tag: 'span',
                                            text: 'Full',
                                            fontSize: 'Y',
                                            color: 'inkMuted',
                                            width: 'D'
                                        },
                                        R11Fee: {
                                            tag: 'span',
                                            text: "\u20BE40",
                                            fontSize: 'Z',
                                            fontWeight: '700',
                                            color: 'teal'
                                        }
                                    },
                                    PhSum4: {
                                        flow: 'x',
                                        align: 'center space-between',
                                        padding: 'Y A',
                                        background: 'inkSurface',
                                        borderTop: '1px solid inkBorder',
                                        SumLbl: {
                                            text: 'Phase Total',
                                            fontSize: 'Y',
                                            fontWeight: '600',
                                            color: 'inkMuted'
                                        },
                                        SumRight: {
                                            flow: 'x',
                                            gap: 'A',
                                            SumAmt: {
                                                text: "\u20BE120",
                                                fontSize: 'Z',
                                                fontWeight: '700',
                                                color: 'teal'
                                            },
                                            SumCnt: {
                                                text: '3 procedures',
                                                fontSize: 'Y',
                                                color: 'inkMuted'
                                            }
                                        }
                                    }
                                }
                            },
                            TreatmentSummaryBar: {
                                state: {
                                    totalFee: 3470,
                                    insuranceCoverage: 2776,
                                    patientPortion: 694,
                                    currency: "\u20BE"
                                }
                            },
                            AiInsightCard: {
                                state: {
                                    insight: 'Recommended sequencing: Complete Phase 1 extraction and buildup first, then SRP for disease control. Wait 3-4 months post-extraction before implant placement in #36. Crown #14 can proceed after SRP completion.',
                                    confidence: '92'
                                }
                            }
                        },
                        // ── Phase → Timeline link panel ───────────────
                        PhaseTimelinePanel: {
                            show: (el, s)=>!!s.root.selectedPhase,
                            flow: 'y',
                            gap: 'Z',
                            width: 'H',
                            flexShrink: '0',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid teal.30',
                            position: 'sticky',
                            top: 'A',
                            PanelTopRow: {
                                flow: 'x',
                                align: 'center space-between',
                                marginBottom: 'Z',
                                PanelHead: {
                                    flow: 'y',
                                    gap: 'X',
                                    PanelLabel: {
                                        text: 'Timeline Summary',
                                        fontSize: 'Y',
                                        fontWeight: '700',
                                        color: 'teal'
                                    },
                                    PanelPhaseName: {
                                        text: (el, s)=>{
                                            var p = s.root.selectedPhase;
                                            if (p === 'p1') return 'Phase 1: Urgent/Emergency';
                                            if (p === 'p2') return 'Phase 2: Disease Control';
                                            if (p === 'p3') return 'Phase 3: Restorative';
                                            return 'Phase 4: Maintenance';
                                        },
                                        fontSize: 'Z',
                                        fontWeight: '600',
                                        color: 'inkText'
                                    }
                                },
                                ClosePhase: {
                                    tag: 'span',
                                    text: "\u2715",
                                    fontSize: 'Z',
                                    color: 'inkMuted',
                                    cursor: 'pointer',
                                    onClick: (e, el, s)=>s.root.update({
                                            selectedPhase: null
                                        })
                                }
                            },
                            RelatedEntries: {
                                flow: 'y',
                                gap: 'Y',
                                paddingTop: 'Z',
                                borderTop: '1px solid inkBorder',
                                RelLabel: {
                                    text: 'Related visits from history:',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkMuted',
                                    marginBottom: 'X'
                                },
                                // Phase 1 entries
                                P1Entries: {
                                    show: (el, s)=>s.root.selectedPhase === 'p1',
                                    flow: 'y',
                                    gap: 'Y',
                                    E1: {
                                        flow: 'y',
                                        gap: 'X',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        background: 'ink',
                                        border: '1px solid inkBorder',
                                        EDate: {
                                            text: 'Mar 3, 2026',
                                            fontSize: 'Y',
                                            color: 'red',
                                            fontWeight: '600'
                                        },
                                        ETitle: {
                                            text: 'Diagnosis: Acute Pulpitis #14',
                                            fontSize: 'Z',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        EDesc: {
                                            text: 'Triggered extraction & buildup planning for #14',
                                            fontSize: 'Y',
                                            color: 'inkSubtle'
                                        }
                                    }
                                },
                                // Phase 2 entries
                                P2Entries: {
                                    show: (el, s)=>s.root.selectedPhase === 'p2',
                                    flow: 'y',
                                    gap: 'Y',
                                    E2: {
                                        flow: 'y',
                                        gap: 'X',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        background: 'ink',
                                        border: '1px solid inkBorder',
                                        EDate: {
                                            text: 'Jan 20, 2026',
                                            fontSize: 'Y',
                                            color: 'teal',
                                            fontWeight: '600'
                                        },
                                        ETitle: {
                                            text: 'Comprehensive Examination',
                                            fontSize: 'Z',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        EDesc: {
                                            text: "Stage III Grade B periodontitis identified \u2014 SRP indicated for Q1 & Q4",
                                            fontSize: 'Y',
                                            color: 'inkSubtle'
                                        }
                                    }
                                },
                                // Phase 3 entries
                                P3Entries: {
                                    show: (el, s)=>s.root.selectedPhase === 'p3',
                                    flow: 'y',
                                    gap: 'Y',
                                    E3: {
                                        flow: 'y',
                                        gap: 'X',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        background: 'ink',
                                        border: '1px solid inkBorder',
                                        EDate: {
                                            text: 'Mar 10, 2026',
                                            fontSize: 'Y',
                                            color: 'purple',
                                            fontWeight: '600'
                                        },
                                        ETitle: {
                                            text: "Root Canal Treatment \u2014 Phase 2",
                                            fontSize: 'Z',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        EDesc: {
                                            text: "Obturation complete \u2014 Crown #14 scheduled post-SRP",
                                            fontSize: 'Y',
                                            color: 'inkSubtle'
                                        }
                                    },
                                    E3b: {
                                        flow: 'y',
                                        gap: 'X',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        background: 'ink',
                                        border: '1px solid inkBorder',
                                        EDate: {
                                            text: 'Feb 15, 2026',
                                            fontSize: 'Y',
                                            color: 'purple',
                                            fontWeight: '600'
                                        },
                                        ETitle: {
                                            text: "Composite Filling \u2014 Tooth #21",
                                            fontSize: 'Z',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        EDesc: {
                                            text: 'Prior restorative work completed successfully',
                                            fontSize: 'Y',
                                            color: 'inkSubtle'
                                        }
                                    }
                                },
                                // Phase 4 entries
                                P4Entries: {
                                    show: (el, s)=>s.root.selectedPhase === 'p4',
                                    flow: 'y',
                                    gap: 'Y',
                                    E4: {
                                        flow: 'y',
                                        gap: 'X',
                                        padding: 'Y Z',
                                        round: 'Y',
                                        background: 'ink',
                                        border: '1px solid inkBorder',
                                        EDate: {
                                            text: 'Mar 15, 2026',
                                            fontSize: 'Y',
                                            color: 'teal',
                                            fontWeight: '600'
                                        },
                                        ETitle: {
                                            text: 'Follow-up Consultation',
                                            fontSize: 'Z',
                                            fontWeight: '600',
                                            color: 'inkText'
                                        },
                                        EDesc: {
                                            text: "Maintenance protocol initiated \u2014 next recall in 3 months",
                                            fontSize: 'Y',
                                            color: 'inkSubtle'
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                PlanBView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.activePlan === 'planB',
                    ConservativeNote: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        NoteTitle: {
                            text: '{{ conservativeApproach | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'amber'
                        },
                        NoteDesc: {
                            text: '{{ thisPlanPrioritizesDisease | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted',
                            lineHeight: '1.6'
                        }
                    },
                    ConservativePhases: {
                        flow: 'y',
                        gap: 'A',
                        children: [
                            {
                                title: 'Phase 1: Disease Control',
                                phase: 1,
                                status: 'active',
                                rows: [
                                    {
                                        code: 'D4341',
                                        description: 'SRP Quadrant 1',
                                        tooth: 'Q1',
                                        provider: 'Dr. Kvaratskhelia',
                                        fee: 200,
                                        status: 'planned'
                                    },
                                    {
                                        code: 'D4341',
                                        description: 'SRP Quadrant 4',
                                        tooth: 'Q4',
                                        provider: 'Dr. Kvaratskhelia',
                                        fee: 200,
                                        status: 'planned'
                                    },
                                    {
                                        code: 'D4910',
                                        description: 'Perio Maintenance',
                                        tooth: 'Full',
                                        provider: 'Dr. Kvaratskhelia',
                                        fee: 80,
                                        status: 'planned'
                                    }
                                ]
                            },
                            {
                                title: 'Phase 2: Re-evaluation & Restorative',
                                phase: 2,
                                status: 'pending',
                                rows: [
                                    {
                                        code: 'D0120',
                                        description: 'Periodic Exam',
                                        tooth: 'Full',
                                        provider: 'Dr. Lomidze',
                                        fee: 30,
                                        status: 'planned'
                                    },
                                    {
                                        code: 'D2950',
                                        description: 'Core Buildup #14',
                                        tooth: '#14',
                                        provider: 'Dr. Lomidze',
                                        fee: 120,
                                        status: 'planned'
                                    },
                                    {
                                        code: 'D2750',
                                        description: 'Crown #14',
                                        tooth: '#14',
                                        provider: 'Dr. Lomidze',
                                        fee: 800,
                                        status: 'planned'
                                    }
                                ]
                            },
                            {
                                title: 'Phase 3: Maintenance',
                                phase: 3,
                                status: 'pending',
                                rows: [
                                    {
                                        code: 'D1110',
                                        description: 'Prophylaxis',
                                        tooth: 'Full',
                                        provider: 'Dr. Kvaratskhelia',
                                        fee: 50,
                                        status: 'planned'
                                    },
                                    {
                                        code: 'D0274',
                                        description: 'BWX',
                                        tooth: 'Full',
                                        provider: 'Dr. Lomidze',
                                        fee: 40,
                                        status: 'planned'
                                    }
                                ]
                            }
                        ],
                        childrenAs: 'state',
                        childExtends: 'TreatmentPhase'
                    },
                    TreatmentSummaryBar: {
                        state: {
                            totalFee: 1520,
                            insuranceCoverage: 1216,
                            patientPortion: 304,
                            currency: "\u20BE"
                        }
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // 5. NOTES (Clinical Notes) — REMOVED
            // ═══════════════════════════════════════════════
            NotesSection: {
                show: false,
                NotesHeader: {
                    flow: 'x',
                    gap: 'A',
                    align: 'center space-between',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y',
                        gap: 'Z'
                    },
                    PageTitle: {
                        tag: 'h3',
                        text: '{{ clinicalNotes | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    NewNoteBtn: {
                        extends: 'Button',
                        text: '{{ newNote | polyglot }}',
                        background: 'teal',
                        color: 'inkText',
                        fontWeight: '600',
                        padding: 'Y A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none'
                    }
                },
                TwoPanelLayout: {
                    flow: 'x',
                    gap: 'A',
                    align: 'stretch flex-start',
                    flex: '1',
                    '@mobileL': {
                        flow: 'y'
                    },
                    NotesTimeline: {
                        flow: 'y',
                        gap: 'Z',
                        width: 'G',
                        flexShrink: '0',
                        '@mobileL': {
                            width: '100%'
                        },
                        children: [
                            {
                                date: 'Mar 10, 2026',
                                provider: 'Dr. Lomidze',
                                procedure: 'Crown Prep',
                                summary: 'Tooth #14 prepared for PFM crown. Impression taken. Temporary crown placed. Patient tolerated procedure well.',
                                noteIndex: 0
                            },
                            {
                                date: 'Feb 15, 2026',
                                provider: 'Dr. Lomidze',
                                procedure: 'Root Canal Completion',
                                summary: 'RCT #14 completed. 3 canals identified and obturated. Post-op periapical radiograph confirmed adequate fill.',
                                noteIndex: 1
                            },
                            {
                                date: 'Jan 20, 2026',
                                provider: 'Dr. Kvaratskhelia',
                                procedure: 'Periodic Exam',
                                summary: 'Periodic exam. Caries detected on #14 occlusal, #15 mesial. Perio probing stable. Treatment plan discussed.',
                                noteIndex: 2
                            },
                            {
                                date: 'Nov 5, 2025',
                                provider: 'Dr. Kvaratskhelia',
                                procedure: 'Prophylaxis',
                                summary: 'Routine prophylaxis performed. Light calculus removed. OHI reinforced. Fluoride varnish applied.',
                                noteIndex: 3
                            },
                            {
                                date: 'Sep 15, 2025',
                                provider: 'Dr. Lomidze',
                                procedure: 'Perio Exam',
                                summary: 'Full periodontal examination. BPE scores recorded. Multiple 4-5mm pockets in Q1 and Q4. SRP recommended.',
                                noteIndex: 4
                            }
                        ],
                        childrenAs: 'state',
                        childExtends: 'ClinicalNoteCard'
                    },
                    NoteEditor: {
                        flow: 'y',
                        gap: 'A',
                        flex: '1',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        NoteTemplateBar: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            flexWrap: 'wrap',
                            marginBottom: 'Z',
                            TemplateLabel: {
                                text: '{{ template | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            NoteTemplate: {
                                state: {
                                    templates: [
                                        {
                                            label: 'SOAP Note',
                                            value: 'soap'
                                        },
                                        {
                                            label: 'Procedure Note',
                                            value: 'procedure'
                                        },
                                        {
                                            label: 'Exam Note',
                                            value: 'exam'
                                        },
                                        {
                                            label: 'Perio Note',
                                            value: 'perio'
                                        },
                                        {
                                            label: 'Consult Note',
                                            value: 'consult'
                                        }
                                    ]
                                }
                            }
                        },
                        EditorTitle: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            marginBottom: 'Z',
                            NoteDate: {
                                text: 'Mar 10, 2026',
                                fontSize: 'A',
                                fontWeight: '700',
                                color: 'teal'
                            },
                            NoteProcedure: {
                                text: '{{ crownPrep | polyglot }}',
                                fontSize: 'A',
                                fontWeight: '600',
                                color: 'inkMuted'
                            }
                        },
                        SoapNote: {
                            state: {
                                subjective: 'Patient reports no pain since last visit. Temporary restoration intact. Ready for crown preparation.',
                                objective: 'Tooth #14: Temporary filling intact. No percussion sensitivity. Periapical radiograph shows adequate root canal fill. Gingival tissue healthy around #14.',
                                assessment: 'Tooth #14 status post-RCT, ready for crown preparation. No signs of infection or failure.',
                                plan: 'PFM crown preparation #14. Final impression with PVS material. Fabricate temporary crown. Schedule crown delivery in 2 weeks.',
                                provider: 'Dr. Lomidze',
                                date: 'Mar 10, 2026'
                            }
                        },
                        AiScribePanel: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkSurface',
                            border: '1px solid inkBorder',
                            marginTop: 'Z',
                            ScribeHeader: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                SparkleIcon: {
                                    extends: 'Icon',
                                    icon: 'sparkle',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'purple'
                                },
                                ScribeTitle: {
                                    text: '{{ aiScribe | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'purple'
                                }
                            },
                            ScribeDesc: {
                                text: '{{ recordYourClinicalEncounter | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkMuted',
                                lineHeight: '1.5',
                                marginTop: 'Y'
                            },
                            ScribeActions: {
                                flow: 'x',
                                gap: 'Z',
                                marginTop: 'Z',
                                flexWrap: 'wrap',
                                RecordBtn: {
                                    extends: 'Button',
                                    flow: 'x',
                                    gap: 'Y',
                                    align: 'center center',
                                    background: 'purple',
                                    color: 'inkText',
                                    fontWeight: '600',
                                    padding: 'Y A',
                                    round: 'A',
                                    fontSize: 'Z',
                                    cursor: 'pointer',
                                    border: 'none',
                                    MicIcon: {
                                        extends: 'Icon',
                                        icon: 'microphone',
                                        width: 'Z',
                                        height: 'Z',
                                        color: 'inkText'
                                    },
                                    BtnLabel: {
                                        text: '{{ startRecording | polyglot }}'
                                    }
                                },
                                GenerateBtn: {
                                    extends: 'Button',
                                    flow: 'x',
                                    gap: 'Y',
                                    align: 'center center',
                                    background: 'inkMid',
                                    color: 'inkText',
                                    fontWeight: '600',
                                    padding: 'Y A',
                                    round: 'A',
                                    fontSize: 'Z',
                                    cursor: 'pointer',
                                    border: '1px solid inkBorder',
                                    GenIcon: {
                                        extends: 'Icon',
                                        icon: 'sparkle',
                                        width: 'Z',
                                        height: 'Z',
                                        color: 'purple'
                                    },
                                    BtnLabel: {
                                        text: '{{ generateNote | polyglot }}'
                                    }
                                }
                            }
                        }
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // 6. MEDICAL HISTORY
            // ═══════════════════════════════════════════════
            MedHistorySection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activePatientSection === 'medHistory',
                // ─── Conditions ───────────────────────────
                ConditionsView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.medHistorySubTab === 'conditions',
                    ConditionsTitle: {
                        tag: 'h3',
                        text: '{{ activeConditions | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    CondCard1: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        CondHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            CondName: {
                                text: '{{ chronicPeriodontitis | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            CondBadge: {
                                text: '{{ active | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'red.15',
                                color: 'red'
                            }
                        },
                        CondCode: {
                            text: 'ICD-10: K05.31',
                            fontSize: 'Y',
                            color: 'teal',
                            fontWeight: '500'
                        },
                        CondDesc: {
                            text: '{{ generalizedMildChronicPeriodon | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted',
                            lineHeight: '1.5'
                        },
                        CondMeta: {
                            flow: 'x',
                            gap: 'A',
                            CondOnset: {
                                text: '{{ onsetJan2026 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            CondProvider: {
                                text: 'Dr. Kvaratskhelia',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    CondCard2: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        CondHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            CondName: {
                                text: '{{ dentalCaries | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            CondBadge: {
                                text: '{{ resolved | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        CondCode: {
                            text: 'ICD-10: K02.9',
                            fontSize: 'Y',
                            color: 'teal',
                            fontWeight: '500'
                        },
                        CondDesc: {
                            text: '{{ cariousLesionOnTooth | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted',
                            lineHeight: '1.5'
                        },
                        CondMeta: {
                            flow: 'x',
                            gap: 'A',
                            CondOnset: {
                                text: '{{ onsetJan2026 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            CondResolved: {
                                text: '{{ resolvedFeb2026 | polyglot }}',
                                fontSize: 'Y',
                                color: 'green'
                            }
                        }
                    },
                    CondCard3: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        CondHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            CondName: {
                                text: '{{ bruxism | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            CondBadge: {
                                text: '{{ active | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'amber.15',
                                color: 'amber'
                            }
                        },
                        CondCode: {
                            text: 'ICD-10: G47.63',
                            fontSize: 'Y',
                            color: 'teal',
                            fontWeight: '500'
                        },
                        CondDesc: {
                            text: '{{ nocturnalBruxismWearFacets | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkMuted',
                            lineHeight: '1.5'
                        },
                        CondMeta: {
                            flow: 'x',
                            gap: 'A',
                            CondOnset: {
                                text: '{{ onsetJan2026 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            CondProvider: {
                                text: 'Dr. Lomidze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    }
                },
                // ─── Medications ──────────────────────────
                MedicationsView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.medHistorySubTab === 'medications',
                    ActiveMedsTitle: {
                        tag: 'h3',
                        text: '{{ activeMedications | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    MedActive1: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        MedInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            MedName: {
                                text: '{{ lisinopril10mg | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            MedDosage: {
                                text: '{{ onceDailyOral | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            MedReason: {
                                text: '{{ hypertensionManagement | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkSubtle'
                            }
                        },
                        MedBadge: {
                            text: '{{ active | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'green.15',
                            color: 'green'
                        }
                    },
                    MedActive2: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        MedInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            MedName: {
                                text: '{{ chlorhexidine012Rinse | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            MedDosage: {
                                text: '{{ twiceDailyOralRinse | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            MedReason: {
                                text: '{{ periodontalMaintenance | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkSubtle'
                            }
                        },
                        MedBadge: {
                            text: '{{ active | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'green.15',
                            color: 'green'
                        }
                    },
                    MedActive3: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        MedInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            MedName: {
                                text: '{{ ibuprofen400mg | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            MedDosage: {
                                text: '{{ asNeededForPain | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            MedReason: {
                                text: '{{ postprocedurePainManagement | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkSubtle'
                            }
                        },
                        MedBadge: {
                            text: '{{ active | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'green.15',
                            color: 'green'
                        }
                    },
                    PastMedsTitle: {
                        tag: 'h3',
                        text: '{{ pastMedications | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText',
                        marginTop: 'A'
                    },
                    MedPast1: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        opacity: '0.7',
                        MedInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            MedName: {
                                text: '{{ amoxicillin500mg | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            MedDosage: {
                                text: '3x daily for 7 days (Mar 5-12, 2026)',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            MedReason: {
                                text: '{{ periapicalInfectionProphylaxis | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkSubtle'
                            }
                        },
                        MedBadge: {
                            text: '{{ completed2 | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'inkSurface',
                            color: 'inkMuted'
                        }
                    },
                    MedPast2: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        opacity: '0.7',
                        MedInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            MedName: {
                                text: '{{ metronidazole250mg | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            MedDosage: {
                                text: '3x daily for 5 days (Feb 20-25, 2026)',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            MedReason: {
                                text: '{{ adjunctPeriodontalTherapy | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkSubtle'
                            }
                        },
                        MedBadge: {
                            text: '{{ completed2 | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'inkSurface',
                            color: 'inkMuted'
                        }
                    }
                },
                // ─── Allergies ────────────────────────────
                AllergiesView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.medHistorySubTab === 'allergies',
                    AllergiesTitle: {
                        tag: 'h3',
                        text: '{{ documentedAllergies | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    AllergyPenicillin: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '2px solid red',
                        AllergyHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            AllergyName: {
                                text: '{{ penicillin | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            SeverityBadge: {
                                text: '{{ severe | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                padding: 'X Z',
                                round: 'B',
                                background: 'red.15',
                                color: 'red'
                            }
                        },
                        AllergyReaction: {
                            text: '{{ reactionAnaphylaxisUrticariaAn | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle',
                            lineHeight: '1.5'
                        },
                        AllergyNote: {
                            text: '{{ crossreactivityWithCephalospor | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            lineHeight: '1.5'
                        },
                        AllergyDate: {
                            text: '{{ documentedJan102026 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    AllergyLatex: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '2px solid amber',
                        AllergyHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            AllergyName: {
                                text: '{{ latex | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            SeverityBadge: {
                                text: '{{ moderate | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                padding: 'X Z',
                                round: 'B',
                                background: 'amber.15',
                                color: 'amber'
                            }
                        },
                        AllergyReaction: {
                            text: '{{ reactionContactDermatitisLocal | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle',
                            lineHeight: '1.5'
                        },
                        AllergyNote: {
                            text: '{{ useNitrileGlovesOnly | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            lineHeight: '1.5'
                        },
                        AllergyDate: {
                            text: '{{ documentedJan102026 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    AllergyLidocaine: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        AllergyHeader: {
                            flow: 'x',
                            align: 'center space-between',
                            AllergyName: {
                                text: '{{ lidocaine | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            SeverityBadge: {
                                text: '{{ mild | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                padding: 'X Z',
                                round: 'B',
                                background: 'inkSurface',
                                color: 'inkMuted'
                            }
                        },
                        AllergyReaction: {
                            text: '{{ reactionMildTinglingProlonged | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle',
                            lineHeight: '1.5'
                        },
                        AllergyNote: {
                            text: '{{ useArticaineAsAlternative | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted',
                            lineHeight: '1.5'
                        },
                        AllergyDate: {
                            text: '{{ documentedJan102026 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                },
                // ─── Vitals ───────────────────────────────
                VitalsView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.medHistorySubTab === 'vitals',
                    VitalsTitle: {
                        tag: 'h3',
                        text: '{{ latestVitalsMar15 | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    VitalsRow: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        '@mobileL': {
                            flow: 'y'
                        },
                        CardBP: {
                            extends: 'StatCard',
                            state: {
                                label: 'Blood Pressure',
                                value: '128/82',
                                unit: 'mmHg',
                                status: 'elevated'
                            }
                        },
                        CardHR: {
                            extends: 'StatCard',
                            state: {
                                label: 'Heart Rate',
                                value: '72',
                                unit: 'bpm',
                                status: 'normal'
                            }
                        },
                        CardTemp: {
                            extends: 'StatCard',
                            state: {
                                label: 'Temperature',
                                value: '36.8',
                                unit: "\xb0C",
                                status: 'normal'
                            }
                        },
                        CardO2: {
                            extends: 'StatCard',
                            state: {
                                label: 'O2 Saturation',
                                value: '98',
                                unit: '%',
                                status: 'normal'
                            }
                        },
                        CardWeight: {
                            extends: 'StatCard',
                            state: {
                                label: 'Weight',
                                value: '78',
                                unit: 'kg',
                                status: 'normal'
                            }
                        }
                    }
                },
                // ─── Imaging ──────────────────────────────
                ImagingView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.medHistorySubTab === 'imaging',
                    ImagingTitle: {
                        tag: 'h3',
                        text: '{{ imagingRecords | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    ImagingGrid: {
                        flow: 'x',
                        flexWrap: 'wrap',
                        gap: 'A',
                        '@mobileL': {
                            flow: 'y'
                        },
                        Img1: {
                            flow: 'y',
                            gap: 'Y',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            ImgPlaceholder: {
                                width: '100%',
                                height: 'E',
                                background: 'inkSurface',
                                round: 'Y',
                                flow: 'x',
                                align: 'center center',
                                ImgLabel: {
                                    text: '{{ panoramicOpg | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            ImgDate: {
                                text: 'Jan 20, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Img2: {
                            flow: 'y',
                            gap: 'Y',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            ImgPlaceholder: {
                                width: '100%',
                                height: 'E',
                                background: 'inkSurface',
                                round: 'Y',
                                flow: 'x',
                                align: 'center center',
                                ImgLabel: {
                                    text: '{{ periapical14 | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            ImgDate: {
                                text: 'Mar 8, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Img3: {
                            flow: 'y',
                            gap: 'Y',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            ImgPlaceholder: {
                                width: '100%',
                                height: 'E',
                                background: 'inkSurface',
                                round: 'Y',
                                flow: 'x',
                                align: 'center center',
                                ImgLabel: {
                                    text: '{{ bitewingRl | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            ImgDate: {
                                text: 'Jan 20, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // 7. DOCUMENTS
            // ═══════════════════════════════════════════════
            DocumentsSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activePatientSection === 'documents',
                XrayGrid: {
                    flow: 'x',
                    flexWrap: 'wrap',
                    gap: 'A',
                    '@mobileL': {
                        flow: 'y'
                    },
                    Xray1: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        align: 'center center',
                        XrayPlaceholder: {
                            width: '100%',
                            height: 'E',
                            background: 'inkSurface',
                            round: 'Y',
                            flow: 'x',
                            align: 'center center',
                            XrayIcon: {
                                extends: 'Icon',
                                icon: 'xray',
                                width: 'B',
                                height: 'B',
                                color: 'inkMuted'
                            }
                        },
                        XrayLabel: {
                            text: '{{ periapical14 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        XrayDate: {
                            text: 'Mar 10, 2026',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    Xray2: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        align: 'center center',
                        XrayPlaceholder: {
                            width: '100%',
                            height: 'E',
                            background: 'inkSurface',
                            round: 'Y',
                            flow: 'x',
                            align: 'center center',
                            XrayIcon: {
                                extends: 'Icon',
                                icon: 'xray',
                                width: 'B',
                                height: 'B',
                                color: 'inkMuted'
                            }
                        },
                        XrayLabel: {
                            text: '{{ panoramicOpg | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        XrayDate: {
                            text: 'Jan 20, 2026',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    Xray3: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        align: 'center center',
                        XrayPlaceholder: {
                            width: '100%',
                            height: 'E',
                            background: 'inkSurface',
                            round: 'Y',
                            flow: 'x',
                            align: 'center center',
                            XrayIcon: {
                                extends: 'Icon',
                                icon: 'xray',
                                width: 'B',
                                height: 'B',
                                color: 'inkMuted'
                            }
                        },
                        XrayLabel: {
                            text: '{{ bitewingRight | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        XrayDate: {
                            text: 'Jan 20, 2026',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    Xray4: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        align: 'center center',
                        XrayPlaceholder: {
                            width: '100%',
                            height: 'E',
                            background: 'inkSurface',
                            round: 'Y',
                            flow: 'x',
                            align: 'center center',
                            XrayIcon: {
                                extends: 'Icon',
                                icon: 'xray',
                                width: 'B',
                                height: 'B',
                                color: 'inkMuted'
                            }
                        },
                        XrayLabel: {
                            text: '{{ bitewingLeft | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        XrayDate: {
                            text: 'Jan 20, 2026',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                },
                DocsList: {
                    flow: 'y',
                    gap: 'Z',
                    marginTop: 'A',
                    DocsTitle: {
                        tag: 'h3',
                        text: '{{ patientDocuments | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    DocRow1: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        DocInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            DocName: {
                                text: '{{ consentFormRootCanal | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '500',
                                color: 'inkText'
                            },
                            DocDate: {
                                text: 'Mar 3, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        DocType: {
                            text: 'PDF',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'inkSurface',
                            color: 'inkMuted'
                        }
                    },
                    DocRow2: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        DocInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            DocName: {
                                text: '{{ treatmentPlanAgreement | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '500',
                                color: 'inkText'
                            },
                            DocDate: {
                                text: 'Jan 20, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        DocType: {
                            text: 'PDF',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'inkSurface',
                            color: 'inkMuted'
                        }
                    },
                    DocRow3: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        DocInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            DocName: {
                                text: '{{ medicalHistoryQuestionnaire | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '500',
                                color: 'inkText'
                            },
                            DocDate: {
                                text: 'Jan 10, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        DocType: {
                            text: 'PDF',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'inkSurface',
                            color: 'inkMuted'
                        }
                    },
                    DocRow4: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        align: 'center flex-start',
                        DocInfo: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            DocName: {
                                text: '{{ insuranceAuthorizationGpi | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '500',
                                color: 'inkText'
                            },
                            DocDate: {
                                text: 'Jan 12, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        DocType: {
                            text: 'PDF',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'inkSurface',
                            color: 'inkMuted'
                        }
                    }
                },
                UploadBtn: {
                    extends: 'Button',
                    text: '{{ uploadDocument | polyglot }}',
                    marginTop: 'Z',
                    background: 'inkSurface',
                    color: 'inkText',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    fontSize: 'Z',
                    cursor: 'pointer',
                    border: '1px solid inkBorder'
                }
            },
            // ═══════════════════════════════════════════════
            // CONSENT
            // ═══════════════════════════════════════════════
            ConsentSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activePatientSection === 'consent',
                ConsentHeader: {
                    flow: 'x',
                    gap: 'A',
                    align: 'center space-between',
                    flexWrap: 'wrap',
                    ConsentTitle: {
                        tag: 'h3',
                        text: 'Consent Forms',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    NewConsentBtn: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        padding: 'Y A',
                        round: 'A',
                        background: 'teal',
                        color: 'white',
                        fontSize: 'Z',
                        fontWeight: '600',
                        cursor: 'pointer',
                        border: 'none',
                        BtnIcon: {
                            tag: 'span',
                            text: '+'
                        },
                        BtnLabel: {
                            tag: 'span',
                            text: 'Request New Consent'
                        }
                    }
                },
                ConsentStats: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    StatSigned: {
                        flow: 'y',
                        gap: 'X',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid green.20',
                        flex: '1',
                        minWidth: 'E',
                        SVal: {
                            text: '3',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'green'
                        },
                        SLabel: {
                            text: 'Signed',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    StatPending: {
                        flow: 'y',
                        gap: 'X',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid gold.20',
                        flex: '1',
                        minWidth: 'E',
                        SVal2: {
                            text: '1',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'gold'
                        },
                        SLabel2: {
                            text: 'Pending Signature',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    StatExpired: {
                        flow: 'y',
                        gap: 'X',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'E',
                        SVal3: {
                            text: '0',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'inkMuted'
                        },
                        SLabel3: {
                            text: 'Expired',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                },
                ConsentList: {
                    flow: 'y',
                    gap: 'Z',
                    ConsentListTitle: {
                        tag: 'h4',
                        text: 'All Consent Forms',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'inkText',
                        marginBottom: 'X'
                    },
                    CForm1: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid green.20',
                        align: 'center flex-start',
                        CFormIcon1: {
                            tag: 'span',
                            text: "\u2705",
                            fontSize: 'A',
                            flexShrink: '0'
                        },
                        CFormInfo1: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            CFormName1: {
                                text: "Root Canal Treatment \u2014 Tooth #14",
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            CFormMeta1: {
                                flow: 'x',
                                gap: 'A',
                                CFormDate1: {
                                    text: 'Signed Mar 3, 2026',
                                    fontSize: 'Y',
                                    color: 'green'
                                },
                                CFormDoc1: {
                                    text: 'Dr. Kvaratskhelia',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        CFormBadge1: {
                            text: 'Signed',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'green.15',
                            color: 'green'
                        },
                        CFormAction1: {
                            tag: 'span',
                            text: 'View PDF',
                            fontSize: 'Y',
                            color: 'teal',
                            cursor: 'pointer',
                            fontWeight: '600',
                            marginLeft: 'Y'
                        }
                    },
                    CForm2: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid green.20',
                        align: 'center flex-start',
                        CFormIcon2: {
                            tag: 'span',
                            text: "\u2705",
                            fontSize: 'A',
                            flexShrink: '0'
                        },
                        CFormInfo2: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            CFormName2: {
                                text: 'Treatment Plan Agreement',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            CFormMeta2: {
                                flow: 'x',
                                gap: 'A',
                                CFormDate2: {
                                    text: 'Signed Jan 20, 2026',
                                    fontSize: 'Y',
                                    color: 'green'
                                },
                                CFormDoc2: {
                                    text: 'Dr. Kvaratskhelia',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        CFormBadge2: {
                            text: 'Signed',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'green.15',
                            color: 'green'
                        },
                        CFormAction2: {
                            tag: 'span',
                            text: 'View PDF',
                            fontSize: 'Y',
                            color: 'teal',
                            cursor: 'pointer',
                            fontWeight: '600',
                            marginLeft: 'Y'
                        }
                    },
                    CForm3: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid green.20',
                        align: 'center flex-start',
                        CFormIcon3: {
                            tag: 'span',
                            text: "\u2705",
                            fontSize: 'A',
                            flexShrink: '0'
                        },
                        CFormInfo3: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            CFormName3: {
                                text: 'Medical History & HIPAA Authorization',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            CFormMeta3: {
                                flow: 'x',
                                gap: 'A',
                                CFormDate3: {
                                    text: 'Signed Jan 10, 2026',
                                    fontSize: 'Y',
                                    color: 'green'
                                },
                                CFormDoc3: {
                                    text: 'Dr. Kvaratskhelia',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        CFormBadge3: {
                            text: 'Signed',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'green.15',
                            color: 'green'
                        },
                        CFormAction3: {
                            tag: 'span',
                            text: 'View PDF',
                            fontSize: 'Y',
                            color: 'teal',
                            cursor: 'pointer',
                            fontWeight: '600',
                            marginLeft: 'Y'
                        }
                    },
                    CForm4: {
                        flow: 'x',
                        gap: 'A',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid gold.30',
                        align: 'center flex-start',
                        CFormIcon4: {
                            tag: 'span',
                            text: "\u23F3",
                            fontSize: 'A',
                            flexShrink: '0'
                        },
                        CFormInfo4: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            CFormName4: {
                                text: "Implant Surgery \u2014 Tooth #36 Consent",
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            CFormMeta4: {
                                flow: 'x',
                                gap: 'A',
                                CFormDate4: {
                                    text: "Sent Mar 16, 2026 \xb7 Awaiting signature",
                                    fontSize: 'Y',
                                    color: 'gold'
                                },
                                CFormDoc4: {
                                    text: 'Dr. Lomidze',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        CFormBadge4: {
                            text: 'Pending',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'gold.15',
                            color: 'gold'
                        },
                        CFormResend4: {
                            tag: 'span',
                            text: 'Resend',
                            fontSize: 'Y',
                            color: 'teal',
                            cursor: 'pointer',
                            fontWeight: '600',
                            marginLeft: 'Y'
                        }
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $90c7a4816bdf5a4c$export$4a82ecccfc2a9a4a = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'patients'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── HEADER ────────────────────────────
            PageHeader: {
                flow: 'x',
                align: 'center space-between',
                marginBottom: 'Z',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Z'
                },
                TitleWrap: {
                    flow: 'y',
                    gap: 'Y',
                    PageTitle: {
                        tag: 'h1',
                        text: '{{ navPatients | polyglot }}',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'inkText',
                        letterSpacing: '-0.02em'
                    },
                    PageSubtitle: {
                        text: '24 total patients',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    }
                },
                AddPatientBtn: {
                    tag: 'button',
                    text: '{{ addPatient | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    background: 'inkText',
                    color: 'inkMid',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'opacity 150ms ease',
                    ':hover': {
                        opacity: '0.8'
                    }
                }
            },
            // ─── SEARCH & FILTERS ─────────────────
            SearchRow: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                marginBottom: 'Z',
                '@mobileL': {
                    flow: 'y'
                },
                SearchInput: {
                    tag: 'input',
                    type: 'text',
                    placeholder: 'Search patients by name, phone, or ID...',
                    flex: '1',
                    padding: 'Z A',
                    round: 'A',
                    background: 'inkSurface',
                    color: 'inkText',
                    border: '1px solid inkBorder',
                    fontSize: 'Z',
                    outline: 'none',
                    transition: 'border 150ms ease',
                    ':focus': {
                        border: '1px solid teal'
                    }
                },
                FilterBtns: {
                    flow: 'x',
                    gap: 'Y',
                    flexShrink: '0',
                    AllBtn: {
                        tag: 'button',
                        text: '{{ all | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkText',
                        color: 'inkMid',
                        border: 'none',
                        cursor: 'pointer'
                    },
                    ActiveBtn: {
                        tag: 'button',
                        text: '{{ active | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'transparent',
                        color: 'inkMuted',
                        border: '1px solid inkBorder',
                        cursor: 'pointer'
                    },
                    NewBtn: {
                        tag: 'button',
                        text: '{{ new | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'transparent',
                        color: 'inkMuted',
                        border: '1px solid inkBorder',
                        cursor: 'pointer'
                    }
                }
            },
            // ─── PATIENTS TABLE ───────────────────
            PatientsTable: {
                flow: 'y',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                overflow: 'hidden',
                TableHeader: {
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    background: 'inkSurface',
                    '@tabletS': {
                        gridTemplateColumns: '2fr 1fr 1fr 80px'
                    },
                    ColName: {
                        text: '{{ patient | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em'
                    },
                    ColPhone: {
                        text: '{{ phone2 | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em'
                    },
                    ColLastVisit: {
                        text: '{{ lastVisit | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em'
                    },
                    ColNextAppt: {
                        text: '{{ nextAppt | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    ColBalance: {
                        text: '{{ balance | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    ColAction: {
                        text: '',
                        fontSize: 'Y'
                    }
                },
                Row1: {
                    tag: 'a',
                    href: '/patient',
                    textDecoration: 'none',
                    color: 'inkText',
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    cursor: 'pointer',
                    transition: 'background 150ms ease',
                    ':hover': {
                        background: 'inkSurface'
                    },
                    '@tabletS': {
                        gridTemplateColumns: '2fr 1fr 1fr 80px'
                    },
                    CellName: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        Avatar: {
                            width: 'B',
                            height: 'B',
                            round: 'E',
                            background: '#0D1117',
                            color: '#FFFFFF',
                            fontWeight: '600',
                            fontSize: 'Y',
                            flow: 'x',
                            align: 'center center',
                            text: 'GB',
                            flexShrink: '0'
                        },
                        NameWrap: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ giorgiBeridze | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Id: {
                                text: '{{ pt001 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    CellPhone: {
                        text: '+995 555 11 22',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellLastVisit: {
                        text: 'Mar 10',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellNext: {
                        text: 'Mar 19',
                        fontSize: 'Z',
                        color: 'teal',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellBalance: {
                        text: "\u20BE0",
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellAction: {
                        text: "\u2192",
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center center',
                        flow: 'x'
                    }
                },
                Row2: {
                    tag: 'a',
                    href: '/patient',
                    textDecoration: 'none',
                    color: 'inkText',
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    cursor: 'pointer',
                    transition: 'background 150ms ease',
                    ':hover': {
                        background: 'inkSurface'
                    },
                    '@tabletS': {
                        gridTemplateColumns: '2fr 1fr 1fr 80px'
                    },
                    CellName: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        Avatar: {
                            width: 'B',
                            height: 'B',
                            round: 'E',
                            background: '#0D1117',
                            color: '#FFFFFF',
                            fontWeight: '600',
                            fontSize: 'Y',
                            flow: 'x',
                            align: 'center center',
                            text: 'NK',
                            flexShrink: '0'
                        },
                        NameWrap: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ ninoKapanadze | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Id: {
                                text: '{{ pt002 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    CellPhone: {
                        text: '+995 555 33 44',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellLastVisit: {
                        text: 'Mar 5',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellNext: {
                        text: 'Mar 21',
                        fontSize: 'Z',
                        color: 'teal',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellBalance: {
                        text: "\u20BE350",
                        fontSize: 'Z',
                        color: 'amber',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellAction: {
                        text: "\u2192",
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center center',
                        flow: 'x'
                    }
                },
                Row3: {
                    tag: 'a',
                    href: '/patient',
                    textDecoration: 'none',
                    color: 'inkText',
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    cursor: 'pointer',
                    transition: 'background 150ms ease',
                    ':hover': {
                        background: 'inkSurface'
                    },
                    '@tabletS': {
                        gridTemplateColumns: '2fr 1fr 1fr 80px'
                    },
                    CellName: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        Avatar: {
                            width: 'B',
                            height: 'B',
                            round: 'E',
                            background: '#0D1117',
                            color: '#FFFFFF',
                            fontWeight: '600',
                            fontSize: 'Y',
                            flow: 'x',
                            align: 'center center',
                            text: 'DG',
                            flexShrink: '0'
                        },
                        NameWrap: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ davitGelashvili | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Id: {
                                text: '{{ pt003 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    CellPhone: {
                        text: '+995 555 55 66',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellLastVisit: {
                        text: 'Feb 28',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellNext: {
                        text: 'Mar 25',
                        fontSize: 'Z',
                        color: 'teal',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellBalance: {
                        text: "\u20BE1,200",
                        fontSize: 'Z',
                        color: 'red',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellAction: {
                        text: "\u2192",
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center center',
                        flow: 'x'
                    }
                },
                Row4: {
                    tag: 'a',
                    href: '/patient',
                    textDecoration: 'none',
                    color: 'inkText',
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    cursor: 'pointer',
                    transition: 'background 150ms ease',
                    ':hover': {
                        background: 'inkSurface'
                    },
                    '@tabletS': {
                        gridTemplateColumns: '2fr 1fr 1fr 80px'
                    },
                    CellName: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        Avatar: {
                            width: 'B',
                            height: 'B',
                            round: 'E',
                            background: '#0D1117',
                            color: '#FFFFFF',
                            fontWeight: '600',
                            fontSize: 'Y',
                            flow: 'x',
                            align: 'center center',
                            text: 'MT',
                            flexShrink: '0'
                        },
                        NameWrap: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ mariamTsiklauri | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Id: {
                                text: '{{ pt004 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    CellPhone: {
                        text: '+995 555 77 88',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellLastVisit: {
                        text: 'Mar 12',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellNext: {
                        text: '-',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellBalance: {
                        text: "\u20BE0",
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellAction: {
                        text: "\u2192",
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center center',
                        flow: 'x'
                    }
                },
                Row5: {
                    tag: 'a',
                    href: '/patient',
                    textDecoration: 'none',
                    color: 'inkText',
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    cursor: 'pointer',
                    transition: 'background 150ms ease',
                    ':hover': {
                        background: 'inkSurface'
                    },
                    '@tabletS': {
                        gridTemplateColumns: '2fr 1fr 1fr 80px'
                    },
                    CellName: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        Avatar: {
                            width: 'B',
                            height: 'B',
                            round: 'E',
                            background: '#0D1117',
                            color: '#FFFFFF',
                            fontWeight: '600',
                            fontSize: 'Y',
                            flow: 'x',
                            align: 'center center',
                            text: 'AJ',
                            flexShrink: '0'
                        },
                        NameWrap: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ anaJavakhishvili | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Id: {
                                text: '{{ pt005 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    CellPhone: {
                        text: '+995 555 99 00',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellLastVisit: {
                        text: 'Mar 8',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellNext: {
                        text: 'Mar 22',
                        fontSize: 'Z',
                        color: 'teal',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellBalance: {
                        text: "\u20BE180",
                        fontSize: 'Z',
                        color: 'amber',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellAction: {
                        text: "\u2192",
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center center',
                        flow: 'x'
                    }
                },
                Row6: {
                    tag: 'a',
                    href: '/patient',
                    textDecoration: 'none',
                    color: 'inkText',
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    cursor: 'pointer',
                    transition: 'background 150ms ease',
                    ':hover': {
                        background: 'inkSurface'
                    },
                    '@tabletS': {
                        gridTemplateColumns: '2fr 1fr 1fr 80px'
                    },
                    CellName: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        Avatar: {
                            width: 'B',
                            height: 'B',
                            round: 'E',
                            background: '#0D1117',
                            color: '#FFFFFF',
                            fontWeight: '600',
                            fontSize: 'Y',
                            flow: 'x',
                            align: 'center center',
                            text: 'LM',
                            flexShrink: '0'
                        },
                        NameWrap: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ lukaMchedlishvili | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Id: {
                                text: '{{ pt006 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    CellPhone: {
                        text: '+995 555 12 34',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellLastVisit: {
                        text: 'Mar 15',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellNext: {
                        text: 'Apr 2',
                        fontSize: 'Z',
                        color: 'teal',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellBalance: {
                        text: "\u20BE0",
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellAction: {
                        text: "\u2192",
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center center',
                        flow: 'x'
                    }
                },
                Row7: {
                    tag: 'a',
                    href: '/patient',
                    textDecoration: 'none',
                    color: 'inkText',
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
                    padding: 'Z A',
                    cursor: 'pointer',
                    transition: 'background 150ms ease',
                    ':hover': {
                        background: 'inkSurface'
                    },
                    '@tabletS': {
                        gridTemplateColumns: '2fr 1fr 1fr 80px'
                    },
                    CellName: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center',
                        Avatar: {
                            width: 'B',
                            height: 'B',
                            round: 'E',
                            background: '#0D1117',
                            color: '#FFFFFF',
                            fontWeight: '600',
                            fontSize: 'Y',
                            flow: 'x',
                            align: 'center center',
                            text: 'TL',
                            flexShrink: '0'
                        },
                        NameWrap: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ tamtaLomidze | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Id: {
                                text: '{{ pt007 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    CellPhone: {
                        text: '+995 555 56 78',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellLastVisit: {
                        text: 'Mar 1',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x'
                    },
                    CellNext: {
                        text: '-',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellBalance: {
                        text: "\u20BE500",
                        fontSize: 'Z',
                        color: 'red',
                        fontWeight: '500',
                        align: 'center flex-start',
                        flow: 'x',
                        '@tabletS': {
                            display: 'none'
                        }
                    },
                    CellAction: {
                        text: "\u2192",
                        fontSize: 'Z',
                        color: 'inkMuted',
                        align: 'center center',
                        flow: 'x'
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $15127687dc86b386$export$f38c853ae54ed474 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'ai'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── AI TOOL TABS ──────────────────────────
            AiToolTabs: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                TabAssistant: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center flex-start',
                    text: '{{ aiAssistant | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeAiTool === 'assistant' ? 'purple' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeAiTool === 'assistant' ? '2px solid purple' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeAiTool: 'assistant'
                        })
                },
                TabXray: {
                    text: '{{ xrayAnalysis | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeAiTool === 'xray' ? 'purple' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeAiTool === 'xray' ? '2px solid purple' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeAiTool: 'xray'
                        })
                },
                TabNotes: {
                    text: '{{ notesTab | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeAiTool === 'notes' ? 'purple' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeAiTool === 'notes' ? '2px solid purple' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeAiTool: 'notes'
                        })
                },
                TabPerioAi: {
                    text: '{{ perioAssessment | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeAiTool === 'perio-ai' ? 'purple' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeAiTool === 'perio-ai' ? '2px solid purple' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeAiTool: 'perio-ai'
                        })
                },
                TabRisk: {
                    text: '{{ aiRiskAssessment | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeAiTool === 'risk' ? 'purple' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeAiTool === 'risk' ? '2px solid purple' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeAiTool: 'risk'
                        })
                },
                TabComm: {
                    text: '{{ patientCommunication | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeAiTool === 'comm' ? 'purple' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeAiTool === 'comm' ? '2px solid purple' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeAiTool: 'comm'
                        })
                }
            },
            // ─── AI ASSISTANT ──────────────────────────
            AiAssistantTool: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                show: (el, s)=>s.root.activeAiTool === 'assistant',
                MessageList: {
                    flow: 'y',
                    gap: 'A',
                    flex: '1',
                    overflow: 'auto',
                    padding: 'A 0',
                    children: (el, s)=>s.root.messages,
                    childExtends: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'A',
                        round: 'A',
                        maxWidth: '80%',
                        background: (el, s)=>s.role === 'user' ? 'teal.12' : 'inkMid',
                        alignSelf: (el, s)=>s.role === 'user' ? 'flex-end' : 'flex-start',
                        border: (el, s)=>s.role === 'user' ? '1px solid teal.2' : '1px solid inkBorder',
                        RoleLabel: {
                            text: (el, s)=>s.role === 'user' ? 'You' : 'AI Assistant',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: (el, s)=>s.role === 'user' ? 'teal' : 'purple'
                        },
                        MessageContent: {
                            html: (el, s)=>s.content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>'),
                            fontSize: 'Z',
                            color: 'inkText',
                            lineHeight: '1.6'
                        }
                    },
                    childrenAs: 'state'
                },
                TypingIndicator: {
                    show: (el, s)=>s.root.isTyping,
                    text: '{{ aiThinking | polyglot }}',
                    fontSize: 'Y',
                    color: 'purple',
                    fontWeight: '500',
                    padding: 'Y 0'
                },
                SuggestionRow: {
                    flow: 'x',
                    gap: 'Y',
                    flexWrap: 'wrap',
                    padding: 'Y 0',
                    ChipOne: {
                        text: '{{ summarizeHistory | polyglot }}',
                        fontSize: 'Y',
                        padding: 'Y Z',
                        round: 'B',
                        background: 'purple.1',
                        color: 'purple',
                        border: '1px solid purple.2',
                        cursor: 'pointer',
                        fontWeight: '500',
                        onClick: (e, el, s)=>{
                            const updated = [
                                ...s.root.messages,
                                {
                                    role: 'user',
                                    content: 'Summarize patient history'
                                }
                            ];
                            s.root.update({
                                messages: updated
                            });
                        }
                    },
                    ChipTwo: {
                        text: '{{ generateTxPlan | polyglot }}',
                        fontSize: 'Y',
                        padding: 'Y Z',
                        round: 'B',
                        background: 'purple.1',
                        color: 'purple',
                        border: '1px solid purple.2',
                        cursor: 'pointer',
                        fontWeight: '500',
                        onClick: (e, el, s)=>{
                            const updated = [
                                ...s.root.messages,
                                {
                                    role: 'user',
                                    content: 'Generate treatment plan'
                                }
                            ];
                            s.root.update({
                                messages: updated
                            });
                        }
                    },
                    ChipThree: {
                        text: '{{ checkDrugInteractions | polyglot }}',
                        fontSize: 'Y',
                        padding: 'Y Z',
                        round: 'B',
                        background: 'purple.1',
                        color: 'purple',
                        border: '1px solid purple.2',
                        cursor: 'pointer',
                        fontWeight: '500',
                        onClick: (e, el, s)=>{
                            const updated = [
                                ...s.root.messages,
                                {
                                    role: 'user',
                                    content: 'Check drug interactions'
                                }
                            ];
                            s.root.update({
                                messages: updated
                            });
                        }
                    },
                    ChipFour: {
                        text: '{{ writeClinicalNote | polyglot }}',
                        fontSize: 'Y',
                        padding: 'Y Z',
                        round: 'B',
                        background: 'purple.1',
                        color: 'purple',
                        border: '1px solid purple.2',
                        cursor: 'pointer',
                        fontWeight: '500',
                        onClick: (e, el, s)=>{
                            const updated = [
                                ...s.root.messages,
                                {
                                    role: 'user',
                                    content: 'Write clinical note'
                                }
                            ];
                            s.root.update({
                                messages: updated
                            });
                        }
                    }
                },
                ChatInputRow: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center center',
                    padding: 'Y 0',
                    ChatInput: {
                        extends: 'Input',
                        tag: 'input',
                        type: 'text',
                        placeholder: '{{ askAiAssistant | polyglot }}',
                        padding: 'Z A',
                        round: 'A',
                        background: 'inkSurface',
                        color: 'inkText',
                        border: '1px solid inkBorder',
                        fontSize: 'Z',
                        flex: '1'
                    },
                    SendBtn: {
                        extends: 'Button',
                        flow: 'x',
                        align: 'center center',
                        gap: 'Y',
                        background: '#0D1117',
                        color: '#FFFFFF',
                        fontWeight: '600',
                        padding: 'Z A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none',
                        SendIcon: {
                            extends: 'Icon',
                            icon: 'send',
                            width: 'Z',
                            height: 'Z'
                        },
                        SendLabel: {
                            text: '{{ send | polyglot }}'
                        },
                        onClick: async (e, el, s)=>{
                            const input = el.lookup('ChatInput');
                            const msg = input.node.value;
                            if (!msg.trim()) return;
                            input.node.value = '';
                            const updated = [
                                ...s.root.messages,
                                {
                                    role: 'user',
                                    content: msg
                                }
                            ];
                            s.root.update({
                                messages: updated,
                                isTyping: true
                            });
                            try {
                                const res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        systemInstruction: {
                                            parts: [
                                                {
                                                    text: 'You are a dental clinical assistant for Georgian dental clinics. Help dentists with treatment planning, clinical notes, drug interactions, and patient communication. You speak Georgian and English. Be concise and clinically accurate. Use Georgian medical terminology when appropriate.'
                                                }
                                            ]
                                        },
                                        contents: updated.map((m)=>({
                                                role: m.role === 'assistant' ? 'model' : 'user',
                                                parts: [
                                                    {
                                                        text: m.content
                                                    }
                                                ]
                                            }))
                                    })
                                });
                                const data = await res.json();
                                const reply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response';
                                s.root.update({
                                    messages: [
                                        ...updated,
                                        {
                                            role: 'assistant',
                                            content: reply
                                        }
                                    ],
                                    isTyping: false
                                });
                            } catch (err) {
                                s.root.update({
                                    messages: [
                                        ...updated,
                                        {
                                            role: 'assistant',
                                            content: 'Error: ' + err.message
                                        }
                                    ],
                                    isTyping: false
                                });
                            }
                        }
                    }
                }
            },
            // ─── X-RAY ANALYSIS ────────────────────────
            AiXrayTool: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeAiTool === 'xray',
                UploadZone: {
                    flow: 'y',
                    align: 'center center',
                    gap: 'Z',
                    padding: 'D',
                    round: 'A',
                    border: '2px dashed inkBorder',
                    background: 'inkMid',
                    cursor: 'pointer',
                    UploadIcon: {
                        extends: 'Icon',
                        icon: 'upload',
                        width: 'C',
                        height: 'C',
                        color: 'teal'
                    },
                    UploadText: {
                        text: '{{ dropXray | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        textAlign: 'center'
                    },
                    UploadHint: {
                        text: '{{ supportsFormats | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                AnalysisResults: {
                    flow: 'y',
                    gap: 'Z',
                    marginTop: 'A',
                    ResultsTitle: {
                        text: '{{ analysisResults | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText',
                        marginBottom: 'Y'
                    },
                    Finding1: {
                        extends: 'AiInsightCard',
                        state: {
                            insight: 'Periapical radiolucency detected at tooth #14 apex. Approximately 3mm diameter. Consistent with chronic periapical abscess.',
                            confidence: '92'
                        }
                    },
                    Finding2: {
                        extends: 'AiInsightCard',
                        state: {
                            insight: 'Mesial caries detected on tooth #36. Early dentin involvement. Recommend composite restoration.',
                            confidence: '87'
                        }
                    },
                    Finding3: {
                        extends: 'AiInsightCard',
                        state: {
                            insight: 'Mild horizontal bone loss in posterior mandibular region. Monitor at next recall visit.',
                            confidence: '78'
                        }
                    },
                    RecommendationBox: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid purple',
                        RecTitle: {
                            text: '{{ aiRecommendation | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '700',
                            color: 'purple'
                        },
                        RecText: {
                            text: '{{ priorityCompleteRctOn | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle',
                            lineHeight: '1.6'
                        }
                    },
                    ExportBtn: {
                        extends: 'Button',
                        text: '{{ exportToTxPlan | polyglot }}',
                        marginTop: 'Z',
                        background: 'teal',
                        color: 'ink',
                        fontWeight: '600',
                        padding: 'Z A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none'
                    }
                }
            },
            // ─── CLINICAL NOTES ────────────────────────
            AiNotesTool: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeAiTool === 'notes',
                NotesForm: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    FieldPatient: {
                        flow: 'y',
                        gap: 'Y',
                        FieldLabel: {
                            tag: 'label',
                            text: '{{ patientName | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'inkMuted'
                        },
                        FieldInput: {
                            extends: 'Input',
                            tag: 'input',
                            type: 'text',
                            placeholder: 'e.g. Giorgi Beridze',
                            padding: 'Z A',
                            round: 'A',
                            background: 'inkSurface',
                            color: 'inkText',
                            border: '1px solid inkBorder',
                            fontSize: 'Z',
                            width: '100%'
                        }
                    },
                    FieldProcedure: {
                        flow: 'y',
                        gap: 'Y',
                        FieldLabel: {
                            tag: 'label',
                            text: '{{ procedure | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'inkMuted'
                        },
                        FieldInput: {
                            extends: 'Input',
                            tag: 'input',
                            type: 'text',
                            placeholder: 'e.g. Root Canal Treatment',
                            padding: 'Z A',
                            round: 'A',
                            background: 'inkSurface',
                            color: 'inkText',
                            border: '1px solid inkBorder',
                            fontSize: 'Z',
                            width: '100%'
                        }
                    },
                    FieldObservations: {
                        flow: 'y',
                        gap: 'Y',
                        FieldLabel: {
                            tag: 'label',
                            text: '{{ observations | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '500',
                            color: 'inkMuted'
                        },
                        FieldTextarea: {
                            extends: 'Input',
                            tag: 'textarea',
                            placeholder: 'Clinical observations, findings, measurements...',
                            padding: 'Z A',
                            round: 'A',
                            background: 'inkSurface',
                            color: 'inkText',
                            border: '1px solid inkBorder',
                            fontSize: 'Z',
                            width: '100%',
                            minHeight: 'E',
                            resize: 'vertical'
                        }
                    },
                    GenerateBtn: {
                        extends: 'Button',
                        text: '{{ generateClinicalNote | polyglot }}',
                        marginTop: 'Y',
                        background: 'teal',
                        color: 'ink',
                        fontWeight: '600',
                        padding: 'Z A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none'
                    }
                },
                GeneratedNote: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkSurface',
                    border: '1px solid inkBorder',
                    marginTop: 'A',
                    NoteHeader: {
                        flow: 'x',
                        align: 'center space-between',
                        NoteTitle: {
                            text: '{{ generatedSoap | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'inkText'
                        },
                        NoteDate: {
                            text: 'Mar 18, 2026',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    SoapSubjective: {
                        flow: 'y',
                        gap: 'X',
                        marginTop: 'Z',
                        SoapLabel: {
                            text: '{{ subjective | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '700',
                            color: 'teal'
                        },
                        SoapText: {
                            text: '{{ patientReportsPersistentDull | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle',
                            lineHeight: '1.5'
                        }
                    },
                    SoapObjective: {
                        flow: 'y',
                        gap: 'X',
                        marginTop: 'Z',
                        SoapLabel: {
                            text: '{{ objective | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '700',
                            color: 'teal'
                        },
                        SoapText: {
                            text: '{{ tooth14PositivePercussion | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle',
                            lineHeight: '1.5'
                        }
                    },
                    SoapAssessment: {
                        flow: 'y',
                        gap: 'X',
                        marginTop: 'Z',
                        SoapLabel: {
                            text: '{{ assessment | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '700',
                            color: 'teal'
                        },
                        SoapText: {
                            text: '{{ chronicPeriapicalAbscess14 | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle',
                            lineHeight: '1.5'
                        }
                    },
                    SoapPlan: {
                        flow: 'y',
                        gap: 'X',
                        marginTop: 'Z',
                        SoapLabel: {
                            text: '{{ plan | polyglot }}',
                            fontSize: 'Z',
                            fontWeight: '700',
                            color: 'teal'
                        },
                        SoapText: {
                            text: "Initiate RCT #14. Access cavity prepared. Working length determined (21mm). Canals irrigated with 2.5% NaOCl. Calcium hydroxide intracanal dressing placed. Temporary restoration with Cavit. Review in 2 weeks for obturation. Note: Patient allergic to Penicillin \u2014 prescribe Clindamycin 300mg QID x 5 days if infection develops.",
                            fontSize: 'Z',
                            color: 'inkSubtle',
                            lineHeight: '1.5'
                        }
                    },
                    CopyBtn: {
                        extends: 'Button',
                        text: '{{ copyToRecord | polyglot }}',
                        marginTop: 'A',
                        background: 'inkMid',
                        color: 'inkText',
                        fontWeight: '600',
                        padding: 'Z A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: '1px solid inkBorder'
                    }
                }
            },
            // ─── PERIO AI ASSESSMENT ──────────────────
            AiPerioTool: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeAiTool === 'perio-ai',
                PerioAiTitle: {
                    tag: 'h2',
                    text: '{{ aiPerioAssessment | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'inkText'
                },
                PerioAiDesc: {
                    text: '{{ enterProbingData | polyglot }}',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    lineHeight: '1.5'
                },
                PerioInputArea: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    PerioTextarea: {
                        extends: 'Input',
                        tag: 'textarea',
                        placeholder: 'Enter probing depths, BOP sites, and clinical findings...',
                        padding: 'Z A',
                        round: 'A',
                        background: 'inkSurface',
                        color: 'inkText',
                        border: '1px solid inkBorder',
                        fontSize: 'Z',
                        width: '100%',
                        minHeight: 'E',
                        resize: 'vertical'
                    },
                    AnalyzePerioBtn: {
                        extends: 'Button',
                        text: '{{ analyzeWithGemini | polyglot }}',
                        background: 'purple',
                        color: 'white',
                        fontWeight: '600',
                        padding: 'Z A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none',
                        marginTop: 'Y',
                        onClick: async (e, el, s)=>{
                            var textarea = el.lookup('PerioTextarea');
                            var input = textarea.node.value;
                            if (!input.trim()) return;
                            s.root.update({
                                isTyping: true
                            });
                            try {
                                var res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        systemInstruction: {
                                            parts: [
                                                {
                                                    text: 'You are a periodontal assessment AI. Analyze the provided probing data, bleeding indices, and attachment levels. Classify using the 2017 AAP/EFP staging and grading system. Identify sites showing progression vs prior exam. Recommend treatment. Be concise and clinically specific.'
                                                }
                                            ]
                                        },
                                        contents: [
                                            {
                                                role: 'user',
                                                parts: [
                                                    {
                                                        text: input
                                                    }
                                                ]
                                            }
                                        ]
                                    })
                                });
                                var data = await res.json();
                                var reply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response';
                                s.root.update({
                                    perioAiResult: reply,
                                    isTyping: false
                                });
                            } catch (err) {
                                s.root.update({
                                    perioAiResult: 'Error: ' + err.message,
                                    isTyping: false
                                });
                            }
                        }
                    }
                },
                PerioAiResult: {
                    show: (el, s)=>s.root.perioAiResult,
                    extends: 'AiInsightCard',
                    state: {
                        insight: (el, s)=>s.root.perioAiResult || '',
                        confidence: '89'
                    }
                }
            },
            // ─── RISK ASSESSMENT ──────────────────────
            AiRiskTool: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeAiTool === 'risk',
                RiskTitle: {
                    tag: 'h2',
                    text: '{{ aiRiskAssessment | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'inkText'
                },
                RiskDesc: {
                    text: '{{ enterConditions | polyglot }}',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    lineHeight: '1.5'
                },
                RiskInputArea: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    RiskTextarea: {
                        extends: 'Input',
                        tag: 'textarea',
                        placeholder: 'Enter conditions, medications, family history, vitals...',
                        padding: 'Z A',
                        round: 'A',
                        background: 'inkSurface',
                        color: 'inkText',
                        border: '1px solid inkBorder',
                        fontSize: 'Z',
                        width: '100%',
                        minHeight: 'E',
                        resize: 'vertical'
                    },
                    AnalyzeRiskBtn: {
                        extends: 'Button',
                        text: '{{ generateRiskProfile | polyglot }}',
                        background: 'purple',
                        color: 'white',
                        fontWeight: '600',
                        padding: 'Z A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none',
                        marginTop: 'Y',
                        onClick: async (e, el, s)=>{
                            var textarea = el.lookup('RiskTextarea');
                            var input = textarea.node.value;
                            if (!input.trim()) return;
                            s.root.update({
                                isTyping: true
                            });
                            try {
                                var res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        systemInstruction: {
                                            parts: [
                                                {
                                                    text: 'You are a dental risk assessment AI. Given the patient conditions, family history, medications, and vitals, generate a comprehensive dental risk profile. Assess risks for: caries, periodontal disease, oral cancer, endodontic complications, and medication-related issues. Use evidence-based risk factors. Be concise and clinically specific.'
                                                }
                                            ]
                                        },
                                        contents: [
                                            {
                                                role: 'user',
                                                parts: [
                                                    {
                                                        text: input
                                                    }
                                                ]
                                            }
                                        ]
                                    })
                                });
                                var data = await res.json();
                                var reply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response';
                                s.root.update({
                                    riskAiResult: reply,
                                    isTyping: false
                                });
                            } catch (err) {
                                s.root.update({
                                    riskAiResult: 'Error: ' + err.message,
                                    isTyping: false
                                });
                            }
                        }
                    }
                },
                RiskAiResult: {
                    show: (el, s)=>s.root.riskAiResult,
                    extends: 'AiInsightCard',
                    state: {
                        insight: (el, s)=>s.root.riskAiResult || '',
                        confidence: '85'
                    }
                }
            },
            // ─── PATIENT COMMUNICATION ────────────────
            AiCommTool: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeAiTool === 'comm',
                CommTitle: {
                    tag: 'h2',
                    text: '{{ patientCommunication | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'inkText'
                },
                CommDesc: {
                    text: '{{ generateExplanations | polyglot }}',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    lineHeight: '1.5'
                },
                CommInputArea: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    CommTextarea: {
                        extends: 'Input',
                        tag: 'textarea',
                        placeholder: 'Describe the treatment plan or clinical finding to explain to the patient...',
                        padding: 'Z A',
                        round: 'A',
                        background: 'inkSurface',
                        color: 'inkText',
                        border: '1px solid inkBorder',
                        fontSize: 'Z',
                        width: '100%',
                        minHeight: 'E',
                        resize: 'vertical'
                    },
                    LangToggle: {
                        flow: 'x',
                        gap: 'Y',
                        marginTop: 'Y',
                        LangKa: {
                            tag: 'button',
                            text: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
                            padding: 'Y Z',
                            round: 'C',
                            background: 'teal',
                            color: 'ink',
                            fontSize: 'Y',
                            fontWeight: '500',
                            cursor: 'pointer',
                            border: 'none'
                        },
                        LangEn: {
                            tag: 'button',
                            text: '{{ english | polyglot }}',
                            padding: 'Y Z',
                            round: 'C',
                            background: 'inkSurface',
                            color: 'inkMuted',
                            fontSize: 'Y',
                            fontWeight: '500',
                            cursor: 'pointer',
                            border: 'none'
                        }
                    },
                    GenerateCommBtn: {
                        extends: 'Button',
                        text: '{{ generateExplanation | polyglot }}',
                        background: 'purple',
                        color: 'white',
                        fontWeight: '600',
                        padding: 'Z A',
                        round: 'A',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        border: 'none',
                        marginTop: 'Y',
                        onClick: async (e, el, s)=>{
                            var textarea = el.lookup('CommTextarea');
                            var input = textarea.node.value;
                            if (!input.trim()) return;
                            s.root.update({
                                isTyping: true
                            });
                            try {
                                var res = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent?key=AIzaSyC0Y2BcOff1cLeSxuU0jlXFbiPfGraZfJc', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        systemInstruction: {
                                            parts: [
                                                {
                                                    text: "You are a dental patient communication assistant. Generate a clear, empathetic, patient-friendly explanation of the dental treatment or finding described. Use simple language, avoid jargon. Respond in Georgian (\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8) by default. Include: what the issue is, why treatment is needed, what the procedure involves, expected recovery, and approximate cost range in Georgian Lari (\u20BE). Be reassuring and professional."
                                                }
                                            ]
                                        },
                                        contents: [
                                            {
                                                role: 'user',
                                                parts: [
                                                    {
                                                        text: input
                                                    }
                                                ]
                                            }
                                        ]
                                    })
                                });
                                var data = await res.json();
                                var reply = data.candidates?.[0]?.content?.parts?.[0]?.text || 'No response';
                                s.root.update({
                                    commAiResult: reply,
                                    isTyping: false
                                });
                            } catch (err) {
                                s.root.update({
                                    commAiResult: 'Error: ' + err.message,
                                    isTyping: false
                                });
                            }
                        }
                    }
                },
                CommAiResult: {
                    show: (el, s)=>s.root.commAiResult,
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A',
                    round: 'A',
                    background: 'inkSurface',
                    border: '1px solid purple',
                    marginTop: 'A',
                    CommResultLabel: {
                        text: '{{ patientFriendly | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'purple'
                    },
                    CommResultText: {
                        html: (el, s)=>{
                            var text = s.root.commAiResult || '';
                            return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>');
                        },
                        fontSize: 'Z',
                        color: 'inkSubtle',
                        lineHeight: '1.6'
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};



const $956d6a891425b558$export$842a8f91a5b0af68 = {
    extends: 'Page',
    flow: 'y',
    background: 'white',
    color: '#1D1D1F',
    ClinicsData: {
        fetch: (0, $b9becae6bd307dfe$export$2e68a2c819d29977),
        display: 'none'
    },
    NavBar: {
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(0,0,0,0.06)'
    },
    HeroHeader: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        textAlign: 'center',
        padding: 'D B C B',
        width: '100%',
        background: 'linear-gradient(180deg, #F0F0F5 0%, #FFFFFF 100%)',
        '@mobileL': {
            padding: 'C A B A'
        },
        PageTitle: {
            tag: 'h1',
            text: '{{ clinicsTitle | polyglot }}',
            fontSize: 'E',
            fontWeight: '700',
            letterSpacing: '-0.03em',
            color: 'inkText'
        },
        PageSubtitle: {
            text: (el, s)=>(s.root.clinics || []).length + ' {{ verifiedClinics | polyglot }}',
            fontSize: 'A',
            color: 'inkMuted',
            marginTop: 'Y'
        },
        SearchBar: {
            flow: 'x',
            align: 'center center',
            gap: 'Y',
            width: '100%',
            maxWidth: 'J',
            margin: 'C1 - -',
            '@mobileL': {
                flow: 'y'
            },
            SearchInput: {
                tag: 'input',
                type: 'text',
                placeholder: '{{ searchByName | polyglot }}',
                flex: '1',
                padding: 'Z1 A',
                round: 'C',
                background: '#FFFFFF',
                color: '#1D1D1F',
                border: '1px solid rgba(0,0,0,0.1)',
                fontSize: 'Z',
                outline: 'none',
                boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                ':focus': {
                    border: '1px solid rgba(0,0,0,0.2)',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
                },
                onInput: (e, el, s)=>s.root.update({
                        clinicFilter: el.node.value
                    })
            },
            MapToggleBtn: {
                tag: 'button',
                flow: 'x',
                align: 'center center',
                gap: 'W',
                background: (el, s)=>s.root.showClinicsMap ? '#0D1117' : '#FFFFFF',
                color: (el, s)=>s.root.showClinicsMap ? '#FFFFFF' : '#1D1D1F',
                fontWeight: '500',
                padding: 'Z1 A',
                round: 'C',
                fontSize: 'Z',
                cursor: 'pointer',
                border: '1px solid rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease',
                flexShrink: '0',
                onClick: (e, el, s)=>s.root.update({
                        showClinicsMap: !s.root.showClinicsMap
                    }),
                MapIcon: {
                    extends: 'Icon',
                    icon: 'mapPin',
                    width: 'Z2',
                    height: 'Z2'
                },
                MapLabel: {
                    text: (el, s)=>s.root.showClinicsMap ? '{{ hideMap | polyglot }}' : '{{ showMap | polyglot }}'
                }
            },
            NearMeBtn: {
                tag: 'button',
                flow: 'x',
                align: 'center center',
                gap: 'W',
                background: '#FFFFFF',
                color: 'teal',
                fontWeight: '500',
                padding: 'Z1 A',
                round: 'C',
                fontSize: 'Z',
                cursor: 'pointer',
                border: '1px solid rgba(0,0,0,0.1)',
                flexShrink: '0',
                transition: 'all 0.2s ease',
                ':hover': {
                    background: 'teal.05'
                },
                onClick: (e, el, s)=>{
                    if (navigator.geolocation) navigator.geolocation.getCurrentPosition((pos)=>s.root.update({
                            userLat: pos.coords.latitude,
                            userLng: pos.coords.longitude,
                            locationShared: true
                        }), ()=>alert('Location access denied.'));
                },
                NearIcon: {
                    extends: 'Icon',
                    icon: 'mapPin',
                    width: 'Z2',
                    height: 'Z2'
                },
                NearLabel: {
                    text: '{{ nearMe | polyglot }}'
                }
            }
        },
        ResultCount: {
            text: (el, s)=>{
                const q = s.root.clinicFilter;
                if (!q) return '';
                const n = (s.root.clinics || []).filter((c)=>{
                    const lower = q.toLowerCase();
                    return c.name.toLowerCase().includes(lower) || c.district.toLowerCase().includes(lower) || (c.services || []).some((sv)=>sv.toLowerCase().includes(lower));
                }).length;
                return n + ' clinics match "' + q + '"';
            },
            fontSize: 'Y',
            color: 'inkMuted',
            marginTop: 'Y'
        }
    },
    ContentLayout: {
        display: 'grid',
        gridTemplateColumns: (el, s)=>s.root.showClinicsMap ? '2fr 1fr' : '1fr',
        gap: 'A',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        padding: 'B B',
        alignItems: 'start',
        '@tabletS': {
            gridTemplateColumns: '1fr'
        },
        '@mobileL': {
            gridTemplateColumns: '1fr',
            padding: 'A'
        },
        ClinicGrid: {
            flow: 'y',
            gap: 'A',
            minWidth: '0',
            GridInner: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(max(320px, calc((100% - 4 * 15px) / 5)), 1fr))',
                '@mobileL': {
                    gridTemplateColumns: '1fr'
                },
                gap: 'A',
                children: (el, s)=>{
                    const clinics = s.root.clinics || [];
                    const q = s.root.clinicFilter;
                    let filtered = clinics;
                    if (q) {
                        const lower = q.toLowerCase();
                        filtered = clinics.filter((c)=>c.name.toLowerCase().includes(lower) || c.district.toLowerCase().includes(lower) || (c.services || []).some((sv)=>sv.toLowerCase().includes(lower)));
                    }
                    return filtered.slice(0, s.root.clinicsVisible || 24);
                },
                childrenAs: 'state',
                childExtends: 'ClinicListCard'
            },
            LoadMoreTrigger: {
                show: (el, s)=>(s.root.clinics || []).length > (s.root.clinicsVisible || 24),
                height: 'C',
                flow: 'x',
                align: 'center center',
                onRender: (el, s)=>{
                    if (el.node._observer || typeof IntersectionObserver === 'undefined') return;
                    el.node._observer = new IntersectionObserver((entries)=>{
                        if (entries[0].isIntersecting) {
                            const current = s.root.clinicsVisible || 24;
                            const total = (s.root.clinics || []).length;
                            if (current < total) s.root.update({
                                clinicsVisible: Math.min(current + 24, total)
                            });
                        }
                    }, {
                        threshold: 0.1
                    });
                    el.node._observer.observe(el.node);
                },
                LoadMoreText: {
                    text: (el, s)=>{
                        const visible = s.root.clinicsVisible || 24;
                        const total = (s.root.clinics || []).length;
                        return visible < total ? '{{ loadingMore | polyglot }}' : '';
                    },
                    fontSize: 'Z',
                    color: 'inkMuted'
                }
            }
        },
        MapPanel: {
            flow: 'y',
            position: 'sticky',
            top: 'C',
            height: 'calc(100vh - 80px)',
            show: (el, s)=>!!s.root.showClinicsMap,
            '@tabletS': {
                position: 'static',
                height: '400px'
            },
            '@mobileL': {
                height: '300px'
            },
            MapContainer: {
                width: '100%',
                height: '100%',
                round: 'A',
                overflow: 'hidden',
                attr: {
                    id: 'clinics-page-map'
                },
                onRender: (el, s)=>{
                    if (el.node._mapInit) return;
                    el.node._mapInit = true;
                    const initMap = ()=>{
                        const mapStyles = [
                            {
                                featureType: 'poi',
                                stylers: [
                                    {
                                        visibility: 'off'
                                    }
                                ]
                            },
                            {
                                featureType: 'transit',
                                stylers: [
                                    {
                                        visibility: 'off'
                                    }
                                ]
                            },
                            {
                                featureType: 'water',
                                elementType: 'geometry',
                                stylers: [
                                    {
                                        color: '#e3e8ee'
                                    }
                                ]
                            },
                            {
                                featureType: 'landscape',
                                stylers: [
                                    {
                                        color: '#f5f5f5'
                                    }
                                ]
                            },
                            {
                                featureType: 'road',
                                elementType: 'geometry',
                                stylers: [
                                    {
                                        color: '#ffffff'
                                    }
                                ]
                            },
                            {
                                featureType: 'road.arterial',
                                elementType: 'geometry',
                                stylers: [
                                    {
                                        color: '#e8e8e8'
                                    }
                                ]
                            }
                        ];
                        const map = new google.maps.Map(el.node, {
                            center: {
                                lat: 41.715,
                                lng: 44.78
                            },
                            zoom: 13,
                            styles: mapStyles,
                            disableDefaultUI: true,
                            zoomControl: true,
                            zoomControlOptions: {
                                position: google.maps.ControlPosition.RIGHT_TOP
                            }
                        });
                        const clinics = s.root.clinics || [];
                        clinics.forEach((c)=>{
                            if (!c.lat || !c.lng) return;
                            const marker = new google.maps.Marker({
                                position: {
                                    lat: c.lat,
                                    lng: c.lng
                                },
                                map: map,
                                title: c.name,
                                icon: {
                                    path: 'M12 2C9.5 2 7 3.5 6 5.5c-1.5 3-.5 5 0 7.5.5 2.5-.5 5.5 1 8 .5.8 1.5 1 2 1s1-.5 1.5-2c.5-1.5 1-2 1.5-2s1 .5 1.5 2c.5 1.5 1 2 1.5 2s1.5-.2 2-1c1.5-2.5.5-5.5 1-8 .5-2.5 1.5-4.5 0-7.5C17 3.5 14.5 2 12 2z',
                                    fillColor: '#0D1117',
                                    fillOpacity: 1,
                                    strokeColor: '#FFFFFF',
                                    strokeWeight: 2,
                                    scale: 1.2,
                                    anchor: new google.maps.Point(12, 22)
                                }
                            });
                            const info = new google.maps.InfoWindow({
                                content: '<div style="font-family:system-ui;padding:4px"><b>' + c.name + '</b><br><span style="color:#00C9A7">' + c.district + "</span><br>\u2605 " + c.rating + '</div>'
                            });
                            marker.addListener('click', ()=>info.open(map, marker));
                        });
                    };
                    if (window.google && window.google.maps) initMap();
                    else {
                        window.initClinicsMap = initMap;
                        const script = document.createElement('script');
                        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAIjI_gvh-OUSEdzgfHKh2v1GvwiEp2Ztg&callback=initClinicsMap';
                        script.async = true;
                        script.defer = true;
                        document.head.appendChild(script);
                    }
                }
            }
        }
    }
};



const $e70a088f651a7ea0$var$getClinic = (s)=>{
    const id = new URLSearchParams(window.location.search).get('id');
    return (s.root.clinics || []).find((x)=>x.id === id);
};
const $e70a088f651a7ea0$export$222135dc4747ad42 = {
    extends: 'Page',
    flow: 'y',
    background: 'ink',
    color: 'inkText',
    ClinicsData: {
        fetch: (0, $b9becae6bd307dfe$export$2e68a2c819d29977),
        display: 'none'
    },
    NavBar: {},
    ClinicDetail: {
        flow: 'y',
        gap: 'A',
        padding: 'C B B B',
        width: '100%',
        flex: '1',
        '@mobileL': {
            padding: 'B A A A'
        },
        BackRow: {
            extends: 'Link',
            href: '/clinics',
            text: '{{ backToAllClinics | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            textDecoration: 'none',
            fontWeight: '500',
            marginBottom: 'Y',
            ':hover': {
                color: 'inkText'
            }
        },
        MainLayout: {
            flow: 'x',
            gap: 'A',
            width: '100%',
            align: 'stretch flex-start',
            '@mobileL': {
                flow: 'y'
            },
            LeftCol: {
                flex: '1',
                flow: 'y',
                gap: 'A',
                minWidth: '0',
                HeaderCard: {
                    flow: 'x',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    align: 'flex-start flex-start',
                    '@mobileL': {
                        flow: 'y'
                    },
                    ClinicLogo: {
                        tag: 'img',
                        width: 'E',
                        height: 'E',
                        round: 'Z',
                        flexShrink: '0',
                        attr: {
                            src: (el, s)=>{
                                const c = $e70a088f651a7ea0$var$getClinic(s);
                                return c ? c.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(c.name) + '&background=0D1117&color=00C9A7&size=128&bold=true&format=svg' : '';
                            }
                        }
                    },
                    ClinicInfo: {
                        flow: 'y',
                        gap: 'Y',
                        flex: '1',
                        NameRow: {
                            flow: 'x',
                            align: 'center space-between',
                            ClinicName: {
                                tag: 'h1',
                                text: (el, s)=>{
                                    const c = $e70a088f651a7ea0$var$getClinic(s);
                                    return c ? c.name : 'Clinic not found';
                                },
                                fontSize: 'C',
                                fontWeight: '700',
                                letterSpacing: '-0.02em'
                            },
                            RatingBadge: {
                                flow: 'x',
                                gap: 'W',
                                align: 'center center',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'teal.1',
                                flexShrink: '0',
                                RatingStar: {
                                    extends: 'Icon',
                                    icon: 'star',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'teal'
                                },
                                RatingVal: {
                                    text: (el, s)=>{
                                        const c = $e70a088f651a7ea0$var$getClinic(s);
                                        return c ? String(c.rating) : '';
                                    },
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'teal'
                                },
                                ReviewCount: {
                                    text: (el, s)=>{
                                        const c = $e70a088f651a7ea0$var$getClinic(s);
                                        return c ? '(' + c.reviews + ')' : '';
                                    },
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        AddressText: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center flex-start',
                            PinIcon: {
                                extends: 'Icon',
                                icon: 'mapPin',
                                width: 'Z',
                                height: 'Z',
                                color: 'inkMuted'
                            },
                            Addr: {
                                text: (el, s)=>{
                                    const c = $e70a088f651a7ea0$var$getClinic(s);
                                    return c ? c.address + ', ' + c.district + ', Tbilisi' : '';
                                },
                                fontSize: 'Z',
                                color: 'inkMuted'
                            }
                        },
                        ContactRow: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            PhoneLink: {
                                extends: 'Link',
                                href: (el, s)=>{
                                    const c = $e70a088f651a7ea0$var$getClinic(s);
                                    return c ? 'tel:' + c.phone.replace(/\s/g, '') : '#';
                                },
                                textDecoration: 'none',
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                PhoneIcon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                PhoneText: {
                                    text: (el, s)=>{
                                        const c = $e70a088f651a7ea0$var$getClinic(s);
                                        return c ? c.phone : '';
                                    },
                                    fontSize: 'Z',
                                    color: 'teal',
                                    fontWeight: '500'
                                }
                            },
                            HoursInfo: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                ClockIcon: {
                                    extends: 'Icon',
                                    icon: 'clock',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                HoursText: {
                                    text: (el, s)=>{
                                        const c = $e70a088f651a7ea0$var$getClinic(s);
                                        return c ? c.hours : '';
                                    },
                                    fontSize: 'Z',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        ServiceTags: {
                            flow: 'x',
                            gap: 'Y',
                            flexWrap: 'wrap',
                            marginTop: 'Y',
                            children: (el, s)=>{
                                const c = $e70a088f651a7ea0$var$getClinic(s);
                                return c ? c.services.map((sv)=>({
                                        label: sv
                                    })) : [];
                            },
                            childrenAs: 'state',
                            childProps: {
                                text: (el, s)=>s.label,
                                padding: 'W Y',
                                round: 'C',
                                fontSize: 'Y',
                                fontWeight: '500',
                                background: 'inkSurface',
                                color: 'inkSubtle'
                            }
                        },
                        PriceRow: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center flex-start',
                            marginTop: 'Y',
                            PriceLabel: {
                                text: '{{ priceRange2 | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkMuted'
                            },
                            PriceValue: {
                                text: (el, s)=>{
                                    const c = $e70a088f651a7ea0$var$getClinic(s);
                                    return c ? c.priceRange : '';
                                },
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            }
                        }
                    }
                },
                MapCard: {
                    round: 'A',
                    overflow: 'hidden',
                    border: '1px solid inkBorder',
                    MapContainer: {
                        width: '100%',
                        flex: '1',
                        minHeight: '350px',
                        attr: {
                            id: 'clinic-detail-map'
                        },
                        onRender: (el, s)=>{
                            if (el.node._mapInit) return;
                            el.node._mapInit = true;
                            const c = $e70a088f651a7ea0$var$getClinic(s);
                            if (!c || !c.lat || !c.lng) return;
                            const initMap = ()=>{
                                const mapStyles = [
                                    {
                                        featureType: 'poi',
                                        stylers: [
                                            {
                                                visibility: 'off'
                                            }
                                        ]
                                    },
                                    {
                                        featureType: 'transit',
                                        stylers: [
                                            {
                                                visibility: 'off'
                                            }
                                        ]
                                    },
                                    {
                                        featureType: 'water',
                                        elementType: 'geometry',
                                        stylers: [
                                            {
                                                color: '#e3e8ee'
                                            }
                                        ]
                                    },
                                    {
                                        featureType: 'landscape',
                                        stylers: [
                                            {
                                                color: '#f5f5f5'
                                            }
                                        ]
                                    },
                                    {
                                        featureType: 'road',
                                        elementType: 'geometry',
                                        stylers: [
                                            {
                                                color: '#ffffff'
                                            }
                                        ]
                                    }
                                ];
                                const map = new google.maps.Map(el.node, {
                                    center: {
                                        lat: c.lat,
                                        lng: c.lng
                                    },
                                    zoom: 15,
                                    styles: mapStyles,
                                    disableDefaultUI: true,
                                    zoomControl: true
                                });
                                new google.maps.Marker({
                                    position: {
                                        lat: c.lat,
                                        lng: c.lng
                                    },
                                    map: map,
                                    title: c.name,
                                    icon: {
                                        path: 'M12 2C9.5 2 7 3.5 6 5.5c-1.5 3-.5 5 0 7.5.5 2.5-.5 5.5 1 8 .5.8 1.5 1 2 1s1-.5 1.5-2c.5-1.5 1-2 1.5-2s1 .5 1.5 2c.5 1.5 1 2 1.5 2s1.5-.2 2-1c1.5-2.5.5-5.5 1-8 .5-2.5 1.5-4.5 0-7.5C17 3.5 14.5 2 12 2z',
                                        fillColor: '#0D1117',
                                        fillOpacity: 1,
                                        strokeColor: '#FFFFFF',
                                        strokeWeight: 2,
                                        scale: 1.5,
                                        anchor: new google.maps.Point(12, 22)
                                    }
                                });
                            };
                            if (window.google && window.google.maps) initMap();
                            else {
                                window.initClinicDetailMap = initMap;
                                const script = document.createElement('script');
                                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAIjI_gvh-OUSEdzgfHKh2v1GvwiEp2Ztg&callback=initClinicDetailMap';
                                script.async = true;
                                script.defer = true;
                                document.head.appendChild(script);
                            }
                        }
                    }
                }
            },
            RightCol: {
                width: '380px',
                flexShrink: '0',
                flow: 'y',
                gap: 'A',
                '@mobileL': {
                    width: '100%'
                },
                BookingCard: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    BookTitle: {
                        text: '{{ bookAnAppointment | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    DatePicker: {
                        flow: 'y',
                        gap: 'Y',
                        DateLabel: {
                            text: '{{ selectDate2 | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em'
                        },
                        DateGrid: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(7, 1fr)',
                            gap: 'W',
                            children: (el, s)=>s.root.dates,
                            childrenAs: 'state',
                            childExtends: 'DateOption'
                        }
                    },
                    TimePicker: {
                        flow: 'y',
                        gap: 'Y',
                        TimeLabel: {
                            text: '{{ selectTime2 | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em'
                        },
                        TimeGrid: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: 'W',
                            children: (el, s)=>s.root.times,
                            childrenAs: 'state',
                            childExtends: 'TimeOption'
                        }
                    },
                    BookBtn: {
                        extends: 'Link',
                        href: '/booking',
                        text: '{{ confirmBooking2 | polyglot }}',
                        background: '#0D1117',
                        color: '#FFFFFF',
                        fontWeight: '600',
                        padding: 'Z1 C',
                        round: 'Z',
                        fontSize: 'Z',
                        textDecoration: 'none',
                        textAlign: 'center',
                        width: '100%',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        ':hover': {
                            opacity: '0.9'
                        },
                        attr: {
                            style: 'display:block; text-align:center'
                        }
                    }
                }
            }
        }
    },
    FooterSection: {
        tag: 'footer',
        flow: 'y',
        gap: 'Z',
        padding: 'B B',
        width: '100%',
        borderTop: '1px solid inkBorder',
        align: 'center center',
        FooterTop: {
            flow: 'x',
            align: 'center space-between',
            width: '100%',
            maxWidth: 'K',
            '@mobileL': {
                flow: 'y',
                gap: 'A',
                align: 'center center'
            },
            FooterLogo: {
                text: 'MCAI',
                fontSize: 'A',
                fontWeight: '700',
                color: 'inkText'
            },
            FooterLinks: {
                flow: 'x',
                gap: 'B',
                ClinicsLink: {
                    extends: 'Link',
                    text: '{{ clinics | polyglot }}',
                    href: '/clinics',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    },
                    transition: 'color 0.2s ease'
                },
                BusinessLink: {
                    extends: 'Link',
                    text: '{{ forBusiness2 | polyglot }}',
                    href: '/business',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    },
                    transition: 'color 0.2s ease'
                }
            },
            FooterContact: {
                text: 'hello@mcai.ge',
                fontSize: 'Z',
                color: 'inkMuted'
            }
        },
        FooterCopy: {
            text: '{{ u00a92026Mcai | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            marginTop: 'Y'
        }
    }
};


const $34df3c86e4d1197d$export$77b22b9e6b40491c = {
    extends: 'Page',
    flow: 'y',
    background: 'white',
    color: 'inkText',
    NavBar: {},
    HeroSection: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        textAlign: 'center',
        width: '100%',
        padding: 'G B E B',
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
        backgroundImage: 'https://images.unsplash.com/photo-1738293728393-c72504a0f72d?q=80&w=2734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        '@mobileL': {
            padding: 'F A D A'
        },
        position: 'relative',
        ':before': {
            content: '""',
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            background: 'white.65',
            zIndex: '0'
        },
        HeroContent: {
            tag: 'hgroup',
            flow: 'y',
            gap: 'A',
            position: 'relative',
            zIndex: '1',
            HeroBadge: {
                tag: 'span',
                text: '{{ businessHeroBadge | polyglot }}',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'teal',
                textTransform: 'uppercase',
                letterSpacing: 'Y',
                background: 'tealLight',
                padding: 'Y Z',
                round: 'D',
                alignSelf: 'center'
            },
            HeroTitle: {
                tag: 'h1',
                text: '{{ businessHeroTitle | polyglot }}',
                fontSize: 'G',
                fontWeight: '800',
                letterSpacing: '-0.05em',
                lineHeight: '1.0',
                color: 'inkText',
                '@mobileL': {
                    fontSize: 'E'
                }
            },
            HeroSubtitle: {
                tag: 'h2',
                text: '{{ businessHeroSubtitle | polyglot }}',
                fontSize: 'B',
                fontWeight: '400',
                color: 'inkMuted',
                maxWidth: 'J',
                lineHeight: '1.6',
                marginTop: 'Z',
                '@mobileL': {
                    fontSize: 'A'
                }
            },
            HeroActions: {
                flow: 'x',
                gap: 'Z',
                marginTop: 'B',
                align: 'center center',
                '@mobileL': {
                    flow: 'y',
                    width: '100%'
                },
                DemoBtn: {
                    extends: 'Link',
                    href: '/dashboard',
                    text: '{{ tryDemo | polyglot }}',
                    background: 'teal',
                    color: 'white',
                    fontWeight: '600',
                    padding: 'Z1 B',
                    round: 'B',
                    fontSize: 'A',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease',
                    ':hover': {
                        opacity: '0.9'
                    }
                },
                PitchBtn: {
                    extends: 'Link',
                    href: '/pitch',
                    text: '{{ viewPitch | polyglot }}',
                    background: 'inkSurface',
                    color: 'inkText',
                    fontWeight: '600',
                    padding: 'Z1 B',
                    round: 'B',
                    fontSize: 'A',
                    textDecoration: 'none',
                    border: '1px solid inkBorder',
                    transition: 'all 0.2s ease',
                    ':hover': {
                        background: 'inkBorder'
                    }
                }
            }
        }
    },
    ProblemsSection: {
        tag: 'section',
        flow: 'y',
        gap: 'B',
        padding: 'E B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        '@mobileL': {
            padding: 'D A'
        },
        ProblemTitle: {
            tag: 'h2',
            text: '{{ theProblem | polyglot }}',
            fontSize: 'D',
            fontWeight: '700',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            marginBottom: 'Z',
            color: 'inkText'
        },
        ProblemSubtitle: {
            text: '{{ problemSubtitle | polyglot }}',
            fontSize: 'B',
            fontWeight: '400',
            color: 'inkMuted',
            textAlign: 'center',
            marginBottom: 'C',
            lineHeight: '1.5'
        },
        ProblemCards: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 'A',
            '@tabletS': {
                gridTemplateColumns: 'repeat(2, 1fr)'
            },
            '@mobileL': {
                gridTemplateColumns: '1fr'
            },
            children: [
                {
                    icon: 'barChart',
                    title: 'Excel & WhatsApp Chaos',
                    detail: 'Clinics manage appointments through spreadsheets and chat groups. Zero automation, constant errors, lost records.'
                },
                {
                    icon: 'bell',
                    title: '25% No-Show Rate',
                    detail: 'Without automated reminders, patients forget appointments. Empty chairs mean \u20BE500+/day in lost revenue.'
                },
                {
                    icon: 'file',
                    title: 'Paper Charts in 2026',
                    detail: 'Handwritten clinical notes, no digital odontogram, no perio tracking. Critical data trapped in filing cabinets.'
                },
                {
                    icon: 'dollarSign',
                    title: 'Insurance Black Hole',
                    detail: 'Manual claims to Aldagi, GPI, Imedi L take hours. Denied claims pile up with no tracking or appeal workflow.'
                }
            ],
            childrenAs: 'state',
            childExtends: 'PainPointCard'
        }
    },
    PlatformSection: {
        tag: 'section',
        flow: 'y',
        gap: 'B',
        padding: 'E B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        attr: {
            id: 'features'
        },
        '@mobileL': {
            padding: 'D A'
        },
        PlatformTitle: {
            tag: 'h2',
            text: '{{ oneplatform | polyglot }}',
            fontSize: 'D',
            fontWeight: '700',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            marginBottom: 'Z',
            color: 'inkText'
        },
        PlatformSubtitle: {
            text: '{{ platformSubtitle | polyglot }}',
            fontSize: 'B',
            fontWeight: '400',
            color: 'inkMuted',
            textAlign: 'center',
            marginBottom: 'C',
            lineHeight: '1.5'
        },
        ClinicalModules: {
            flow: 'y',
            gap: 'A',
            marginBottom: 'C',
            ClinicalLabel: {
                text: '{{ clinical | polyglot }}',
                fontSize: 'Y',
                fontWeight: '700',
                color: 'teal',
                letterSpacing: 'Y',
                textTransform: 'uppercase',
                marginBottom: 'Z'
            },
            ClinicalGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 'A',
                '@tabletS': {
                    gridTemplateColumns: 'repeat(2, 1fr)'
                },
                '@mobileL': {
                    gridTemplateColumns: '1fr'
                },
                children: [
                    {
                        icon: 'tooth',
                        title: 'Digital Odontogram',
                        detail: 'FDI 32-tooth chart with 5-surface tracking. Click any surface to record caries, restorations, crowns, implants, and missing teeth.'
                    },
                    {
                        icon: 'activity',
                        title: 'Perio Charting',
                        detail: '192-site periodontal grid. 6-point probing, BOP, CAL, furcation, mobility. AAP staging via Gemini AI.'
                    },
                    {
                        icon: 'clipboard',
                        title: 'Treatment Planning',
                        detail: 'Phased plans with CDT codes, insurance estimates, patient portions. Drag-and-drop reordering. AI sequencing.'
                    },
                    {
                        icon: 'file',
                        title: 'SOAP Notes + AI Scribe',
                        detail: 'Structured clinical documentation with templates. Gemini generates notes from voice or chart data.'
                    }
                ],
                childrenAs: 'state',
                childExtends: 'FeatureCard'
            }
        },
        OpsModules: {
            flow: 'y',
            gap: 'A',
            marginBottom: 'C',
            OpsLabel: {
                text: '{{ operations | polyglot }}',
                fontSize: 'Y',
                fontWeight: '700',
                color: 'amber',
                letterSpacing: 'Y',
                textTransform: 'uppercase',
                marginBottom: 'Z'
            },
            OpsGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 'A',
                '@tabletS': {
                    gridTemplateColumns: 'repeat(2, 1fr)'
                },
                '@mobileL': {
                    gridTemplateColumns: '1fr'
                },
                children: [
                    {
                        icon: 'calendar',
                        title: 'Multi-Chair Scheduling',
                        detail: 'Week view with multiple operatories. Provider color-coding, production goals, waitlist management.'
                    },
                    {
                        icon: 'dollarSign',
                        title: 'Billing & Insurance',
                        detail: 'Claims tracking for Aldagi, GPI, Imedi L. Patient ledger, aging buckets, payment plans, eligibility checks.'
                    },
                    {
                        icon: 'rx',
                        title: 'e-Prescribing',
                        detail: 'Digital prescriptions with templates. Gemini-powered drug interaction checking. Georgian pharmacy integration.'
                    },
                    {
                        icon: 'flask',
                        title: 'Lab Case Tracking',
                        detail: 'Kanban pipeline: Ordered \u2192 Fabrication \u2192 Shipped \u2192 Received. Vendor management, quality tracking.'
                    }
                ],
                childrenAs: 'state',
                childExtends: 'FeatureCard'
            }
        },
        MoreModules: {
            flow: 'y',
            gap: 'A',
            MoreLabel: {
                text: '{{ analyticsEnterprise | polyglot }}',
                fontSize: 'Y',
                fontWeight: '700',
                color: 'purple',
                letterSpacing: 'Y',
                textTransform: 'uppercase',
                marginBottom: 'Z'
            },
            MoreGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 'A',
                '@tabletS': {
                    gridTemplateColumns: 'repeat(2, 1fr)'
                },
                '@mobileL': {
                    gridTemplateColumns: '1fr'
                },
                children: [
                    {
                        icon: 'barChart',
                        title: 'Production Reports',
                        detail: 'Gross/net production, collection rates, treatment acceptance, recall effectiveness. Per-provider breakdown.'
                    },
                    {
                        icon: 'send',
                        title: 'Referral Management',
                        detail: 'Inbound/outbound referrals to specialists. AI-generated referral letters. Status tracking.'
                    },
                    {
                        icon: 'pulse',
                        title: 'Medical History',
                        detail: '11-view patient record: timeline, conditions (ICD-10), medications, allergies, vitals, imaging, documents.'
                    },
                    {
                        icon: 'shield',
                        title: 'Enterprise Admin',
                        detail: 'RBAC, audit logs, compliance meters, multi-tenancy, SSO, feature flags, API management.'
                    }
                ],
                childrenAs: 'state',
                childExtends: 'FeatureCard'
            }
        }
    },
    AiSection: {
        tag: 'section',
        flow: 'y',
        gap: 'B',
        padding: 'E B',
        width: '100%',
        background: 'inkMid',
        attr: {
            id: 'ai'
        },
        '@mobileL': {
            padding: 'D A'
        },
        AiInner: {
            flow: 'y',
            gap: 'B',
            maxWidth: 'K',
            margin: '0 auto',
            width: '100%',
            AiTitle: {
                tag: 'h2',
                text: '{{ geminiBuiltIn | polyglot }}',
                fontSize: 'D',
                fontWeight: '700',
                letterSpacing: '-0.03em',
                textAlign: 'center',
                marginBottom: 'Y',
                color: 'inkText'
            },
            AiSubtitle: {
                text: '{{ geminiSubtitle | polyglot }}',
                fontSize: 'A',
                color: 'purple',
                textAlign: 'center',
                marginBottom: 'C',
                fontWeight: '500'
            },
            AiCards: {
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: 'A',
                '@tabletS': {
                    gridTemplateColumns: 'repeat(2, 1fr)'
                },
                '@mobileL': {
                    gridTemplateColumns: '1fr'
                },
                XrayAiCard: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'white',
                    border: '1px solid purple.2',
                    transition: 'all 0.3s ease',
                    ':hover': {
                        borderColor: 'purple'
                    },
                    CardIcon1: {
                        extends: 'Icon',
                        icon: 'xray',
                        width: 'B',
                        height: 'B',
                        color: 'purple'
                    },
                    CardTitle1: {
                        text: '{{ xrayAnalysis2 | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    CardDetail1: {
                        text: '{{ uploadDentalRadiographsFor | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        lineHeight: '1.7'
                    }
                },
                PerioAiCard: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'white',
                    border: '1px solid purple.2',
                    transition: 'all 0.3s ease',
                    ':hover': {
                        borderColor: 'purple'
                    },
                    CardIcon2: {
                        extends: 'Icon',
                        icon: 'activity',
                        width: 'B',
                        height: 'B',
                        color: 'purple'
                    },
                    CardTitle2: {
                        text: '{{ perioAssessment2 | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    CardDetail2: {
                        text: '{{ automaticAapStaginggradingFrom | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        lineHeight: '1.7'
                    }
                },
                ScribeAiCard: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'white',
                    border: '1px solid purple.2',
                    transition: 'all 0.3s ease',
                    ':hover': {
                        borderColor: 'purple'
                    },
                    CardIcon3: {
                        extends: 'Icon',
                        icon: 'clipboard',
                        width: 'B',
                        height: 'B',
                        color: 'purple'
                    },
                    CardTitle3: {
                        text: '{{ clinicalScribe2 | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    CardDetail3: {
                        text: '{{ generatesSoapNotesFrom | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        lineHeight: '1.7'
                    }
                },
                RiskAiCard: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'white',
                    border: '1px solid purple.2',
                    transition: 'all 0.3s ease',
                    ':hover': {
                        borderColor: 'purple'
                    },
                    CardIcon4: {
                        extends: 'Icon',
                        icon: 'shield',
                        width: 'B',
                        height: 'B',
                        color: 'purple'
                    },
                    CardTitle4: {
                        text: '{{ riskProfiling2 | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    CardDetail4: {
                        text: '{{ analyzesConditionsFamilyHistor | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        lineHeight: '1.7'
                    }
                },
                TxAiCard: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'white',
                    border: '1px solid purple.2',
                    transition: 'all 0.3s ease',
                    ':hover': {
                        borderColor: 'purple'
                    },
                    CardIcon5: {
                        extends: 'Icon',
                        icon: 'sparkle',
                        width: 'B',
                        height: 'B',
                        color: 'purple'
                    },
                    CardTitle5: {
                        text: '{{ treatmentSequencing2 | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    CardDetail5: {
                        text: '{{ aioptimizedTreatmentPhasingCon | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        lineHeight: '1.7'
                    }
                },
                CommAiCard: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'white',
                    border: '1px solid purple.2',
                    transition: 'all 0.3s ease',
                    ':hover': {
                        borderColor: 'purple'
                    },
                    CardIcon6: {
                        extends: 'Icon',
                        icon: 'globe',
                        width: 'B',
                        height: 'B',
                        color: 'purple'
                    },
                    CardTitle6: {
                        text: '{{ patientCommunication2 | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    CardDetail6: {
                        text: '{{ generatesPatientfriendlyExplan | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        lineHeight: '1.7'
                    }
                }
            }
        }
    },
    IntegrationsSection: {
        tag: 'section',
        flow: 'y',
        gap: 'B',
        padding: 'E B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        '@mobileL': {
            padding: 'D A'
        },
        IntTitle: {
            tag: 'h2',
            text: '{{ georgianEcosystem | polyglot }}',
            fontSize: 'D',
            fontWeight: '700',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            marginBottom: 'Z',
            color: 'inkText'
        },
        IntSubtitle: {
            text: '{{ integrationsSubtitle | polyglot }}',
            fontSize: 'B',
            fontWeight: '400',
            color: 'inkMuted',
            textAlign: 'center',
            marginBottom: 'C',
            lineHeight: '1.5'
        },
        IntGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 'A',
            '@tabletS': {
                gridTemplateColumns: 'repeat(2, 1fr)'
            },
            '@mobileL': {
                gridTemplateColumns: '1fr'
            },
            InsuranceCard: {
                flow: 'y',
                gap: 'Z',
                padding: 'B',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                InsLabel: {
                    text: '{{ insurance2 | polyglot }}',
                    fontSize: 'Y',
                    fontWeight: '700',
                    color: 'teal',
                    letterSpacing: 'X',
                    textTransform: 'uppercase'
                },
                InsNames: {
                    text: 'Aldagi  \u00B7  GPI  \u00B7  Imedi L  \u00B7  Unison',
                    fontSize: 'Z',
                    color: 'inkText',
                    fontWeight: '500',
                    lineHeight: '1.6'
                },
                InsDetail: {
                    text: '{{ automatedClaimsEligibilityVeri | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted',
                    lineHeight: '1.5'
                }
            },
            PaymentsCard: {
                flow: 'y',
                gap: 'Z',
                padding: 'B',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                PayLabel: {
                    text: '{{ payments2 | polyglot }}',
                    fontSize: 'Y',
                    fontWeight: '700',
                    color: 'teal',
                    letterSpacing: 'X',
                    textTransform: 'uppercase'
                },
                PayNames: {
                    text: 'TBC Pay  \u00B7  BOG iPay  \u00B7  Stripe',
                    fontSize: 'Z',
                    color: 'inkText',
                    fontWeight: '500',
                    lineHeight: '1.6'
                },
                PayDetail: {
                    text: '{{ onlinePaymentsPaymentPlans | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted',
                    lineHeight: '1.5'
                }
            },
            MessagingCard: {
                flow: 'y',
                gap: 'Z',
                padding: 'B',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                MsgLabel: {
                    text: '{{ messaging2 | polyglot }}',
                    fontSize: 'Y',
                    fontWeight: '700',
                    color: 'teal',
                    letterSpacing: 'X',
                    textTransform: 'uppercase'
                },
                MsgNames: {
                    text: 'WhatsApp  \u00B7  SMS.ge  \u00B7  Email',
                    fontSize: 'Z',
                    color: 'inkText',
                    fontWeight: '500',
                    lineHeight: '1.6'
                },
                MsgDetail: {
                    text: '{{ appointmentRemindersRecallCamp | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted',
                    lineHeight: '1.5'
                }
            },
            EhrCard: {
                flow: 'y',
                gap: 'Z',
                padding: 'B',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                EhrLabel: {
                    text: '{{ ehrLabs2 | polyglot }}',
                    fontSize: 'Y',
                    fontWeight: '700',
                    color: 'teal',
                    letterSpacing: 'X',
                    textTransform: 'uppercase'
                },
                EhrNames: {
                    text: 'FHIR R4  \u00B7  HL7v2  \u00B7  DICOM',
                    fontSize: 'Z',
                    color: 'inkText',
                    fontWeight: '500',
                    lineHeight: '1.6'
                },
                EhrDetail: {
                    text: '{{ interoperableHealthRecordsLab | polyglot }}',
                    fontSize: 'Y',
                    color: 'inkMuted',
                    lineHeight: '1.5'
                }
            }
        }
    },
    StatsSection: {
        tag: 'section',
        flow: 'x',
        align: 'center center',
        gap: 'D',
        padding: 'D B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        flexWrap: 'wrap',
        '@mobileL': {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 'B',
            padding: 'C A'
        },
        StatClinics: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum1: {
                text: '212+',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                letterSpacing: '-0.02em'
            },
            StatLabel1: {
                text: '{{ clinicsInDatabase | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: 'X',
                fontWeight: '500'
            }
        },
        StatModules: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum2: {
                text: '15',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                letterSpacing: '-0.02em'
            },
            StatLabel2: {
                text: '{{ platformModules2 | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: 'X',
                fontWeight: '500'
            }
        },
        StatAi: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum3: {
                text: '6',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                letterSpacing: '-0.02em'
            },
            StatLabel3: {
                text: 'AI Tools (Gemini)',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: 'X',
                fontWeight: '500'
            }
        },
        StatIntegrations: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            StatNum4: {
                text: '20+',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                letterSpacing: '-0.02em'
            },
            StatLabel4: {
                text: '{{ integrations2 | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textTransform: 'uppercase',
                letterSpacing: 'X',
                fontWeight: '500'
            }
        }
    },
    PricingSection: {
        tag: 'section',
        flow: 'y',
        gap: 'B',
        padding: 'E B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        attr: {
            id: 'pricing'
        },
        '@mobileL': {
            padding: 'D A'
        },
        PricingTitle: {
            tag: 'h2',
            text: '{{ pricingTitle | polyglot }}',
            fontSize: 'D',
            fontWeight: '700',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            marginBottom: 'Z',
            color: 'inkText'
        },
        PricingSubtitle: {
            text: '{{ pricingSubtitle | polyglot }}',
            fontSize: 'B',
            fontWeight: '400',
            color: 'inkMuted',
            textAlign: 'center',
            marginBottom: 'C',
            lineHeight: '1.5'
        },
        PricingRow: {
            flow: 'x',
            gap: 'A',
            flexWrap: 'wrap',
            '@mobileL': {
                flow: 'y'
            },
            children: [
                {
                    tier: 'Starter',
                    amount: '\u20BE0',
                    period: '/month',
                    description: '1 dentist, basic charting, 50 patients, booking widget. No credit card required.',
                    highlighted: false
                },
                {
                    tier: 'Growth',
                    amount: '\u20BE79',
                    period: '/month',
                    description: '3 providers, full odontogram + perio, scheduling, SMS reminders, basic billing, AI notes.',
                    highlighted: false
                },
                {
                    tier: 'Professional',
                    amount: '\u20BE199',
                    period: '/month',
                    description: 'Unlimited providers, all 15 modules, insurance integration (Aldagi/GPI), e-prescribing, lab tracking, full AI suite.',
                    highlighted: true
                },
                {
                    tier: 'Enterprise',
                    amount: '\u20BE399+',
                    period: '/month',
                    description: 'Multi-location, RBAC, audit logs, SSO, custom integrations, dedicated account manager, 99.9% SLA.',
                    highlighted: false
                }
            ],
            childrenAs: 'state',
            childExtends: 'PricingCard'
        }
    },
    TestimonialsSection: {
        tag: 'section',
        flow: 'y',
        gap: 'B',
        padding: 'E B',
        width: '100%',
        maxWidth: 'K',
        margin: '0 auto',
        '@mobileL': {
            padding: 'D A'
        },
        TestimonialsTitle: {
            tag: 'h2',
            text: '{{ trustedBy | polyglot }}',
            fontSize: 'D',
            fontWeight: '700',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            marginBottom: 'C',
            color: 'inkText'
        },
        TestimonialCards: {
            flow: 'x',
            gap: 'A',
            flexWrap: 'wrap',
            '@mobileL': {
                flow: 'y'
            },
            children: [
                {
                    quote: 'We cut no-shows by 65% in the first month. The digital odontogram replaced our paper charts overnight \u2014 our hygienists love the perio module.',
                    clinic: 'Denta Plus',
                    location: 'Tbilisi \u00B7 5 Locations'
                },
                {
                    quote: 'Insurance claim processing went from 3 hours/day to 15 minutes. Aldagi and GPI claims are now automated. The billing module alone justified the cost.',
                    clinic: 'NB Dental',
                    location: 'Tbilisi, Vake'
                },
                {
                    quote: 'The AI clinical notes save our doctors 40 minutes per day. Gemini generates accurate SOAP notes from our charting data \u2014 in Georgian.',
                    clinic: "Richter's Clinic",
                    location: 'Tbilisi, Saburtalo'
                }
            ],
            childrenAs: 'state',
            childExtends: 'TestimonialCard'
        }
    },
    CtaSection: {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        gap: 'A',
        padding: 'F B',
        width: '100%',
        textAlign: 'center',
        background: 'inkText',
        '@mobileL': {
            padding: 'E A'
        },
        CtaTitle: {
            tag: 'h2',
            text: '{{ readyModernize | polyglot }}',
            fontSize: 'D',
            fontWeight: '700',
            letterSpacing: '-0.03em',
            color: 'white'
        },
        CtaSubtitle: {
            text: '{{ joinCount | polyglot }}',
            fontSize: 'B',
            fontWeight: '400',
            color: 'white.6',
            marginBottom: 'A',
            lineHeight: '1.5'
        },
        CtaActions: {
            flow: 'x',
            gap: 'Z',
            align: 'center center',
            '@mobileL': {
                flow: 'y',
                width: '100%'
            },
            CtaDemoBtn: {
                extends: 'Link',
                href: '/dashboard',
                text: '{{ startTrial | polyglot }}',
                background: 'teal',
                color: 'white',
                fontWeight: '600',
                padding: 'Z1 B',
                round: 'B',
                fontSize: 'A',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
                ':hover': {
                    opacity: '0.9'
                }
            },
            CtaContactBtn: {
                extends: 'Link',
                href: 'mailto:hello@mcai.ge',
                text: '{{ contactSales | polyglot }}',
                background: 'transparent',
                color: 'white',
                fontWeight: '600',
                padding: 'Z1 B',
                round: 'B',
                fontSize: 'A',
                textDecoration: 'none',
                border: '1px solid white.3',
                transition: 'all 0.2s ease',
                ':hover': {
                    background: 'white.1'
                }
            }
        },
        CtaNote: {
            text: '{{ noCreditCard | polyglot }}',
            fontSize: 'Y',
            color: 'white.4',
            marginTop: 'A'
        }
    },
    FooterSection: {
        tag: 'footer',
        flow: 'y',
        gap: 'Z',
        padding: 'B B',
        width: '100%',
        borderTop: '1px solid inkBorder',
        align: 'center center',
        FooterTop: {
            flow: 'x',
            align: 'center space-between',
            width: '100%',
            maxWidth: 'K',
            '@mobileL': {
                flow: 'y',
                gap: 'A',
                align: 'center center'
            },
            FooterLogo: {
                text: 'MCAI',
                fontSize: 'A',
                fontWeight: '700',
                color: 'inkText'
            },
            FooterLinks: {
                flow: 'x',
                gap: 'B',
                HomeLink: {
                    extends: 'Link',
                    text: '{{ home2 | polyglot }}',
                    href: '/',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    }
                },
                FeatLink: {
                    extends: 'Link',
                    text: '{{ features2 | polyglot }}',
                    href: '/business#features',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    }
                },
                PriceLink: {
                    extends: 'Link',
                    text: '{{ pricing2 | polyglot }}',
                    href: '/business#pricing',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    }
                },
                DashLink: {
                    extends: 'Link',
                    text: '{{ dashboard2 | polyglot }}',
                    href: '/dashboard',
                    color: 'inkMuted',
                    fontSize: 'Z',
                    textDecoration: 'none',
                    fontWeight: '500',
                    ':hover': {
                        color: 'inkText'
                    }
                }
            },
            FooterContact: {
                text: 'hello@mcai.ge',
                fontSize: 'Z',
                color: 'inkMuted'
            }
        },
        FooterCopy: {
            text: '{{ u00a92026McaiU2014 | polyglot }}',
            fontSize: 'Y',
            color: 'inkMuted',
            marginTop: 'Z'
        }
    }
};


const $3fbc106dffca817d$export$db91f62ac6eecc05 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'scheduling',
                            schedView: s.root.schedView || 'calendar'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── TOOLBAR ───────────────────────────────────
            ScheduleToolbar: {
                flow: 'x',
                gap: 'A',
                align: 'center space-between',
                flexWrap: 'wrap',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Z'
                },
                LeftControls: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center flex-start',
                    ViewTabs: {
                        flow: 'x',
                        gap: '0',
                        round: 'Y',
                        overflow: 'hidden',
                        border: '1px solid inkBorder',
                        CalendarTab: {
                            text: 'Calendar',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            cursor: 'pointer',
                            background: (el, s)=>s.root.schedView === 'calendar' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.schedView === 'calendar' ? 'ink' : 'inkMuted',
                            onClick: (e, el, s)=>s.root.update({
                                    schedView: 'calendar'
                                })
                        },
                        ListTab: {
                            text: 'List',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            cursor: 'pointer',
                            background: (el, s)=>s.root.schedView === 'list' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.schedView === 'list' ? 'ink' : 'inkMuted',
                            onClick: (e, el, s)=>s.root.update({
                                    schedView: 'list'
                                })
                        },
                        CabinetsTab: {
                            text: 'Cabinets',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            cursor: 'pointer',
                            background: (el, s)=>s.root.schedView === 'cabinets' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.schedView === 'cabinets' ? 'ink' : 'inkMuted',
                            onClick: (e, el, s)=>s.root.update({
                                    schedView: 'cabinets'
                                })
                        }
                    },
                    DateNav: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        PrevBtn: {
                            text: "\u2190",
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            cursor: 'pointer'
                        },
                        TodayBtn: {
                            text: '{{ today | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'teal',
                            cursor: 'pointer'
                        },
                        NextBtn: {
                            text: "\u2192",
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            cursor: 'pointer'
                        },
                        DateLabel: {
                            text: "Mar 17 \u2013 Mar 23, 2026",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText',
                            marginLeft: 'Y'
                        }
                    },
                    ProviderFilter: {
                        show: (el, s)=>s.root.schedView !== 'cabinets',
                        tag: 'select',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        color: 'inkText',
                        fontSize: 'Y',
                        Option1: {
                            tag: 'option',
                            text: '{{ allProviders | polyglot }}',
                            attr: {
                                value: 'all'
                            }
                        },
                        Option2: {
                            tag: 'option',
                            text: 'Dr. Kvaratskhelia',
                            attr: {
                                value: 'kvaratskhelia'
                            }
                        },
                        Option3: {
                            tag: 'option',
                            text: 'Dr. Beridze',
                            attr: {
                                value: 'beridze'
                            }
                        },
                        Option4: {
                            tag: 'option',
                            text: '{{ hygienistNino | polyglot }}',
                            attr: {
                                value: 'nino'
                            }
                        }
                    }
                },
                RightControls: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center flex-end',
                    ProductionGoalMeter: {},
                    WaitlistToggle: {
                        text: '{{ waitlist | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        color: 'amber',
                        cursor: 'pointer',
                        onClick: (e, el, s)=>s.root.update({
                                showWaitlist: !s.root.showWaitlist
                            })
                    }
                }
            },
            // ─── PROVIDER LEGEND (calendar/list only) ──────
            ProviderLegend: {
                flow: 'x',
                gap: 'A',
                marginBottom: 'Y',
                show: (el, s)=>s.root.schedView !== 'cabinets',
                Leg1: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center center',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'teal'
                    },
                    Label: {
                        text: 'Dr. Kvaratskhelia',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                Leg2: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center center',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'purple'
                    },
                    Label: {
                        text: 'Dr. Beridze',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                Leg3: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center center',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'amber'
                    },
                    Label: {
                        text: '{{ hygienistNino | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // CALENDAR VIEW
            // ═══════════════════════════════════════════════
            WeekCalendarSection: {
                flow: 'y',
                background: 'inkMid',
                round: 'A',
                border: '1px solid inkBorder',
                overflow: 'auto',
                show: (el, s)=>s.root.schedView === 'calendar',
                DayHeaders: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    position: 'sticky',
                    top: '0',
                    background: 'inkMid',
                    zIndex: '1',
                    TimeCol: {
                        padding: 'Z'
                    },
                    MonHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'teal',
                        borderLeft: '1px solid inkBorder',
                        text: '{{ mon17 | polyglot }}'
                    },
                    TueHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText',
                        borderLeft: '1px solid inkBorder',
                        text: '{{ tue18 | polyglot }}'
                    },
                    WedHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText',
                        borderLeft: '1px solid inkBorder',
                        text: '{{ wed19 | polyglot }}'
                    },
                    ThuHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText',
                        borderLeft: '1px solid inkBorder',
                        text: '{{ thu20 | polyglot }}'
                    },
                    FriHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText',
                        borderLeft: '1px solid inkBorder',
                        text: '{{ fri21 | polyglot }}'
                    }
                },
                Row0800: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkMuted',
                        textAlign: 'right',
                        text: '08:00'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row0900: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '09:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        flow: 'y',
                        gap: 'X',
                        Evt1: {
                            text: 'Crown Prep #14',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'T. Kapanadze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        },
                        Evt2: {
                            text: 'Prophy + Clean',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: "I. Diasamidze \xb7 Cab 3",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'SRP Quad 1',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: 'D. Gelashvili',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1000: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '10:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        flow: 'y',
                        gap: 'X',
                        Evt1: {
                            text: 'Exam + X-ray',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid purple',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'purple.08',
                            PatName: {
                                text: "M. Tsiklauri \xb7 Cab 2",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Unconfirmed',
                                fontSize: 'Y',
                                color: 'amber',
                                fontWeight: '600'
                            }
                        },
                        Evt2: {
                            text: 'Perio Maint.',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: "T. Lomidze \xb7 Cab 3",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'RCT #36',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'G. Beridze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        flow: 'y',
                        gap: 'X',
                        Evt1: {
                            text: 'Prophy + Polish',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: "I. Diasamidze \xb7 Cab 3",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        },
                        Evt2: {
                            text: 'Composite Fill',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: "M. Tsiklauri \xb7 Cab 1",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Perio Maintenance',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: 'T. Lomidze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    }
                },
                Row1100: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '11:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Prophy',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: 'A. Javakhishvili',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'In Chair',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            }
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        flow: 'y',
                        gap: 'X',
                        Evt1: {
                            text: 'Sealants x4',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid purple',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'purple.08',
                            PatName: {
                                text: "N. Kapanadze \xb7 Cab 2",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        },
                        Evt2: {
                            text: 'Prophy Clean',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: "N. Gogiberidze \xb7 Cab 3",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'In Chair',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            }
                        }
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Whitening',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid purple',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'purple.08',
                            PatName: {
                                text: 'L. Mchedlishvili',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Unconfirmed',
                                fontSize: 'Y',
                                color: 'amber',
                                fontWeight: '600'
                            }
                        }
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1200: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '12:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    }
                },
                Row1300: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '13:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Veneer Prep #11',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'K. Gabrichidze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Completed',
                                fontSize: 'Y',
                                color: 'teal',
                                fontWeight: '600'
                            }
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        flow: 'y',
                        gap: 'X',
                        Evt1: {
                            text: 'Extraction #48',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: "V. Papunashvili \xb7 Cab 4",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Completed',
                                fontSize: 'Y',
                                color: 'teal',
                                fontWeight: '600'
                            }
                        },
                        Evt2: {
                            text: 'Fluoride Tx',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: "S. Meladze \xb7 Cab 3",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'In Chair',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            }
                        }
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Composite #25',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'S. Meladze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    }
                },
                Row1400: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '14:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Bridge Prep #34-36',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'R. Kharazishvili',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        flow: 'y',
                        gap: 'X',
                        Evt1: {
                            text: 'Composite #22',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid purple',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'purple.08',
                            PatName: {
                                text: "Z. Dolidze \xb7 Cab 2",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'No Show',
                                fontSize: 'Y',
                                color: 'red',
                                fontWeight: '600'
                            }
                        },
                        Evt2: {
                            text: 'Implant Place',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: "G. Beridze \xb7 Cab 4",
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'In Chair',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            }
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Implant Consult',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid purple',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'purple.08',
                            PatName: {
                                text: 'E. Tsereteli',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1500: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '15:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Prophy',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: 'N. Gogiberidze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Completed',
                                fontSize: 'Y',
                                color: 'teal',
                                fontWeight: '600'
                            }
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Crown Seat #14',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'T. Kapanadze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    }
                },
                Row1600: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '16:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Checkup',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid purple',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'purple.08',
                            PatName: {
                                text: 'B. Shengelia',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'No Show',
                                fontSize: 'Y',
                                color: 'red',
                                fontWeight: '600'
                            }
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Fluoride Treatment',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: 'M. Tsiklauri',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1700: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '17:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Emergency Walk-in',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'L. Mchedlishvili',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'In Chair',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            }
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Scaling',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid amber',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'amber.08',
                            PatName: {
                                text: 'G. Beridze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Unconfirmed',
                                fontSize: 'Y',
                                color: 'amber',
                                fontWeight: '600'
                            }
                        }
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // LIST VIEW
            // ═══════════════════════════════════════════════
            ListViewSection: {
                flow: 'y',
                gap: 'Z',
                show: (el, s)=>s.root.schedView === 'list',
                MonGroup: {
                    flow: 'y',
                    gap: 'Y',
                    DayLabel: {
                        text: 'MON 17',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'teal',
                        padding: 'Y 0',
                        borderBottom: '1px solid inkBorder'
                    },
                    Appts: {
                        flow: 'y',
                        gap: 'X',
                        A1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '09:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'teal'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Crown Prep #14',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "T. Kapanadze \xb7 Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '09:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Prophy + Clean',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "I. Diasamidze \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '10:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'purple'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Exam + X-ray',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "M. Tsiklauri \xb7 Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Unconfirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'amber.15',
                                color: 'amber'
                            }
                        },
                        A4: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '11:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Prophy',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "A. Javakhishvili \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'In Chair',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'blue.15',
                                color: 'blue'
                            }
                        },
                        A5: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '14:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'teal'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Bridge Prep #34-36',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "R. Kharazishvili \xb7 Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A6: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '16:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'purple'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Checkup',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "B. Shengelia \xb7 Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'No Show',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'red.15',
                                color: 'red'
                            }
                        }
                    }
                },
                TueGroup: {
                    flow: 'y',
                    gap: 'Y',
                    DayLabel: {
                        text: 'TUE 18',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'inkText',
                        padding: 'Y 0',
                        borderBottom: '1px solid inkBorder'
                    },
                    Appts: {
                        flow: 'y',
                        gap: 'X',
                        A1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '10:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'teal'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'RCT #36',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "G. Beridze \xb7 Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '13:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'teal'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Veneer Prep #11',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "K. Gabrichidze \xb7 Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Completed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'teal.15',
                                color: 'teal'
                            }
                        },
                        A3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '14:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'purple'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Composite #22',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "Z. Dolidze \xb7 Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'No Show',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'red.15',
                                color: 'red'
                            }
                        },
                        A4: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '15:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Prophy',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "N. Gogiberidze \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Completed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'teal.15',
                                color: 'teal'
                            }
                        },
                        A5: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '17:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'teal'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Emergency Walk-in',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "L. Mchedlishvili \xb7 Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'In Chair',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'blue.15',
                                color: 'blue'
                            }
                        }
                    }
                },
                WedGroup: {
                    flow: 'y',
                    gap: 'Y',
                    DayLabel: {
                        text: "WED 19 \u2014 TODAY",
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'teal',
                        padding: 'Y 0',
                        borderBottom: '1px solid inkBorder'
                    },
                    Appts: {
                        flow: 'y',
                        gap: 'X',
                        A1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '09:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'SRP Quad 1',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "D. Gelashvili \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '11:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'purple'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Sealants x4',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "N. Kapanadze \xb7 Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '13:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'teal'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Extraction #48',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "V. Papunashvili \xb7 Dr. Kvaratskhelia \xb7 Cab 4",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Completed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'teal.15',
                                color: 'teal'
                            }
                        },
                        A4: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '13:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Fluoride Tx',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "S. Meladze \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'In Chair',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'blue.15',
                                color: 'blue'
                            }
                        },
                        A5: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '16:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Fluoride Treatment',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "M. Tsiklauri \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        }
                    }
                },
                ThuGroup: {
                    flow: 'y',
                    gap: 'Y',
                    DayLabel: {
                        text: 'THU 20',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'inkText',
                        padding: 'Y 0',
                        borderBottom: '1px solid inkBorder'
                    },
                    Appts: {
                        flow: 'y',
                        gap: 'X',
                        A1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '10:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Prophy + Polish',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "I. Diasamidze \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '11:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'purple'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Whitening',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "L. Mchedlishvili \xb7 Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Unconfirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'amber.15',
                                color: 'amber'
                            }
                        },
                        A3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '14:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'purple'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Implant Consult',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "E. Tsereteli \xb7 Dr. Beridze \xb7 Cab 2",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A4: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '17:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Scaling',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "G. Beridze \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Unconfirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'amber.15',
                                color: 'amber'
                            }
                        }
                    }
                },
                FriGroup: {
                    flow: 'y',
                    gap: 'Y',
                    DayLabel: {
                        text: 'FRI 21',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'inkText',
                        padding: 'Y 0',
                        borderBottom: '1px solid inkBorder'
                    },
                    Appts: {
                        flow: 'y',
                        gap: 'X',
                        A1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '10:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'amber'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Perio Maintenance',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "T. Lomidze \xb7 Hyg. Nino \xb7 Cab 3",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '13:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'teal'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Composite #25',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "S. Meladze \xb7 Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        A3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            TimeCol: {
                                text: '15:00',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                minWidth: 'B',
                                flexShrink: '0'
                            },
                            Bar: {
                                width: 'X',
                                borderRadius: '2px',
                                alignSelf: 'stretch',
                                flexShrink: '0',
                                background: 'teal'
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ProcName: {
                                    text: 'Crown Seat #14',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                PatRow: {
                                    text: "T. Kapanadze \xb7 Dr. Kvaratskhelia \xb7 Cab 1",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            StatusBadge: {
                                tag: 'span',
                                text: 'Confirmed',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        }
                    }
                }
            },
            // ═══════════════════════════════════════════════
            // CABINETS VIEW
            // ═══════════════════════════════════════════════
            CabinetsViewSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.schedView === 'cabinets',
                CabinetsDateBar: {
                    flow: 'x',
                    gap: 'A',
                    align: 'center space-between',
                    flexWrap: 'wrap',
                    StatusLegend: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        Leg1: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            Dot: {
                                width: 'Z',
                                height: 'Z',
                                round: 'Z',
                                background: 'teal'
                            },
                            Label: {
                                text: '{{ available | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Leg2: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            Dot: {
                                width: 'Z',
                                height: 'Z',
                                round: 'Z',
                                background: 'blue'
                            },
                            Label: {
                                text: '{{ occupied | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Leg3: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            Dot: {
                                width: 'Z',
                                height: 'Z',
                                round: 'Z',
                                background: 'amber'
                            },
                            Label: {
                                text: '{{ cleaning | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Leg4: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center center',
                            Dot: {
                                width: 'Z',
                                height: 'Z',
                                round: 'Z',
                                background: 'red'
                            },
                            Label: {
                                text: '{{ maintenance | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    DateDisplay: {
                        text: 'Mar 19, 2026',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'inkMuted'
                    }
                },
                CabinetGrid: {
                    flow: 'x',
                    gap: 'A',
                    overflow: 'auto',
                    padding: 'Y 0',
                    flex: '1',
                    Cabinet1: {
                        extends: 'CabinetColumn',
                        state: {
                            cabinetName: 'Cabinet 1',
                            cabinetStatus: 'in-use'
                        },
                        Slots: {
                            S0900: {
                                state: {
                                    time: '09:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'T. Kapanadze',
                                    procedure: '{{ crownPrep | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S0930: {
                                state: {
                                    time: '09:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'T. Kapanadze',
                                    procedure: '{{ crownPrep | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1000: {
                                state: {
                                    time: '10:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1030: {
                                state: {
                                    time: '10:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'M. Tsiklauri',
                                    procedure: '{{ compositeF | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1100: {
                                state: {
                                    time: '11:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'M. Tsiklauri',
                                    procedure: '{{ compositeF | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1130: {
                                state: {
                                    time: '11:30',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1200: {
                                state: {
                                    time: '12:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1230: {
                                state: {
                                    time: '12:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1300: {
                                state: {
                                    time: '13:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'R. Kharazishvili',
                                    procedure: '{{ bridgePrep | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1330: {
                                state: {
                                    time: '13:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'R. Kharazishvili',
                                    procedure: '{{ bridgePrep | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1400: {
                                state: {
                                    time: '14:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'R. Kharazishvili',
                                    procedure: '{{ bridgePrep | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1430: {
                                state: {
                                    time: '14:30',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1500: {
                                state: {
                                    time: '15:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'A. Javakhishvili',
                                    procedure: '{{ rootCanal | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1530: {
                                state: {
                                    time: '15:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'A. Javakhishvili',
                                    procedure: '{{ rootCanal | polyglot }}',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1600: {
                                state: {
                                    time: '16:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1630: {
                                state: {
                                    time: '16:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1700: {
                                state: {
                                    time: '17:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 1'
                                }
                            },
                            S1730: {
                                state: {
                                    time: '17:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 1'
                                }
                            }
                        }
                    },
                    Cabinet2: {
                        extends: 'CabinetColumn',
                        state: {
                            cabinetName: 'Cabinet 2',
                            cabinetStatus: 'available'
                        },
                        Slots: {
                            S0900: {
                                state: {
                                    time: '09:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'D. Gelashvili',
                                    procedure: '{{ srpQuad | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S0930: {
                                state: {
                                    time: '09:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'D. Gelashvili',
                                    procedure: '{{ srpQuad | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1000: {
                                state: {
                                    time: '10:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'D. Gelashvili',
                                    procedure: '{{ srpQuad | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1030: {
                                state: {
                                    time: '10:30',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1100: {
                                state: {
                                    time: '11:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1130: {
                                state: {
                                    time: '11:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1200: {
                                state: {
                                    time: '12:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1230: {
                                state: {
                                    time: '12:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1300: {
                                state: {
                                    time: '13:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'K. Gabrichidze',
                                    procedure: '{{ veneerPrep | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1330: {
                                state: {
                                    time: '13:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'K. Gabrichidze',
                                    procedure: '{{ veneerPrep | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1400: {
                                state: {
                                    time: '14:00',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1430: {
                                state: {
                                    time: '14:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'Z. Dolidze',
                                    procedure: '{{ implantPlace | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1500: {
                                state: {
                                    time: '15:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'Z. Dolidze',
                                    procedure: '{{ implantPlace | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1530: {
                                state: {
                                    time: '15:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'Z. Dolidze',
                                    procedure: '{{ implantPlace | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1600: {
                                state: {
                                    time: '16:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1630: {
                                state: {
                                    time: '16:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'E. Tsereteli',
                                    procedure: '{{ examConsult | polyglot }}',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1700: {
                                state: {
                                    time: '17:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 2'
                                }
                            },
                            S1730: {
                                state: {
                                    time: '17:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 2'
                                }
                            }
                        }
                    },
                    Cabinet3: {
                        extends: 'CabinetColumn',
                        state: {
                            cabinetName: 'Cabinet 3',
                            cabinetStatus: 'in-use'
                        },
                        Slots: {
                            S0900: {
                                state: {
                                    time: '09:00',
                                    status: 'occupied',
                                    doctor: 'Hyg. Nino',
                                    patient: 'I. Diasamidze',
                                    procedure: '{{ prophyClean | polyglot }}',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S0930: {
                                state: {
                                    time: '09:30',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1000: {
                                state: {
                                    time: '10:00',
                                    status: 'occupied',
                                    doctor: 'Hyg. Nino',
                                    patient: 'T. Lomidze',
                                    procedure: '{{ perioMaint | polyglot }}',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1030: {
                                state: {
                                    time: '10:30',
                                    status: 'occupied',
                                    doctor: 'Hyg. Nino',
                                    patient: 'T. Lomidze',
                                    procedure: '{{ perioMaint | polyglot }}',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1100: {
                                state: {
                                    time: '11:00',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1130: {
                                state: {
                                    time: '11:30',
                                    status: 'occupied',
                                    doctor: 'Hyg. Nino',
                                    patient: 'N. Gogiberidze',
                                    procedure: '{{ prophyClean | polyglot }}',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1200: {
                                state: {
                                    time: '12:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1230: {
                                state: {
                                    time: '12:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1300: {
                                state: {
                                    time: '13:00',
                                    status: 'occupied',
                                    doctor: 'Hyg. Nino',
                                    patient: 'S. Meladze',
                                    procedure: '{{ fluorideTx | polyglot }}',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1330: {
                                state: {
                                    time: '13:30',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1400: {
                                state: {
                                    time: '14:00',
                                    status: 'occupied',
                                    doctor: 'Hyg. Nino',
                                    patient: 'L. Mchedlishvili',
                                    procedure: '{{ sealants | polyglot }}',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1430: {
                                state: {
                                    time: '14:30',
                                    status: 'occupied',
                                    doctor: 'Hyg. Nino',
                                    patient: 'L. Mchedlishvili',
                                    procedure: '{{ sealants | polyglot }}',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1500: {
                                state: {
                                    time: '15:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1530: {
                                state: {
                                    time: '15:30',
                                    status: 'occupied',
                                    doctor: 'Hyg. Nino',
                                    patient: 'B. Shengelia',
                                    procedure: '{{ prophyClean | polyglot }}',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1600: {
                                state: {
                                    time: '16:00',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1630: {
                                state: {
                                    time: '16:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1700: {
                                state: {
                                    time: '17:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 3'
                                }
                            },
                            S1730: {
                                state: {
                                    time: '17:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 3'
                                }
                            }
                        }
                    },
                    Cabinet4: {
                        extends: 'CabinetColumn',
                        state: {
                            cabinetName: 'Cabinet 4',
                            cabinetStatus: 'maintenance'
                        },
                        Slots: {
                            S0900: {
                                state: {
                                    time: '09:00',
                                    status: 'maintenance',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S0930: {
                                state: {
                                    time: '09:30',
                                    status: 'maintenance',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1000: {
                                state: {
                                    time: '10:00',
                                    status: 'maintenance',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1030: {
                                state: {
                                    time: '10:30',
                                    status: 'maintenance',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1100: {
                                state: {
                                    time: '11:00',
                                    status: 'maintenance',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1130: {
                                state: {
                                    time: '11:30',
                                    status: 'maintenance',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1200: {
                                state: {
                                    time: '12:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1230: {
                                state: {
                                    time: '12:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1300: {
                                state: {
                                    time: '13:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Kvaratskhelia',
                                    patient: 'V. Papunashvili',
                                    procedure: '{{ extraction | polyglot }}',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1330: {
                                state: {
                                    time: '13:30',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1400: {
                                state: {
                                    time: '14:00',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'G. Beridze',
                                    procedure: '{{ whitening | polyglot }}',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1430: {
                                state: {
                                    time: '14:30',
                                    status: 'occupied',
                                    doctor: 'Dr. Beridze',
                                    patient: 'G. Beridze',
                                    procedure: '{{ whitening | polyglot }}',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1500: {
                                state: {
                                    time: '15:00',
                                    status: 'cleaning',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1530: {
                                state: {
                                    time: '15:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1600: {
                                state: {
                                    time: '16:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1630: {
                                state: {
                                    time: '16:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1700: {
                                state: {
                                    time: '17:00',
                                    status: 'available',
                                    cabinetName: 'Cabinet 4'
                                }
                            },
                            S1730: {
                                state: {
                                    time: '17:30',
                                    status: 'available',
                                    cabinetName: 'Cabinet 4'
                                }
                            }
                        }
                    }
                },
                SlotDetail: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    show: (el, s)=>s.root.selectedSlot,
                    DetailHeader: {
                        flow: 'x',
                        align: 'center space-between',
                        DetailTitle: {
                            text: '{{ slotDetails | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'inkText'
                        },
                        CloseBtn: {
                            text: "\u2715",
                            fontSize: 'Z',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkSurface',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            cursor: 'pointer',
                            onClick: (e, el, s)=>s.root.update({
                                    selectedSlot: null
                                })
                        }
                    },
                    DetailGrid: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: 'Z',
                        '@mobileL': {
                            gridTemplateColumns: '1fr'
                        },
                        CabinetField: {
                            flow: 'y',
                            gap: 'X',
                            FieldLabel: {
                                text: '{{ cabinet | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                textTransform: 'uppercase',
                                letterSpacing: 'X'
                            },
                            FieldValue: {
                                text: (el, s)=>s.root.selectedSlot?.cabinet || '-',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        },
                        TimeField: {
                            flow: 'y',
                            gap: 'X',
                            FieldLabel: {
                                text: '{{ time | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                textTransform: 'uppercase',
                                letterSpacing: 'X'
                            },
                            FieldValue: {
                                text: (el, s)=>s.root.selectedSlot?.time || '-',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        },
                        StatusField: {
                            flow: 'y',
                            gap: 'X',
                            FieldLabel: {
                                text: '{{ status | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                textTransform: 'uppercase',
                                letterSpacing: 'X'
                            },
                            FieldValue: {
                                text: (el, s)=>s.root.selectedSlot?.status || '-',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: (el, s)=>{
                                    const st = s.root.selectedSlot?.status;
                                    if (st === 'occupied') return 'blue';
                                    if (st === 'cleaning') return 'amber';
                                    if (st === 'maintenance') return 'red';
                                    return 'teal';
                                }
                            }
                        },
                        DoctorField: {
                            flow: 'y',
                            gap: 'X',
                            show: (el, s)=>s.root.selectedSlot?.status === 'occupied',
                            FieldLabel: {
                                text: '{{ doctor | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                textTransform: 'uppercase',
                                letterSpacing: 'X'
                            },
                            FieldValue: {
                                text: (el, s)=>s.root.selectedSlot?.doctor || '-',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        },
                        PatientField: {
                            flow: 'y',
                            gap: 'X',
                            show: (el, s)=>s.root.selectedSlot?.status === 'occupied',
                            FieldLabel: {
                                text: '{{ patient | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                textTransform: 'uppercase',
                                letterSpacing: 'X'
                            },
                            FieldValue: {
                                text: (el, s)=>s.root.selectedSlot?.patient || '-',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        },
                        ProcedureField: {
                            flow: 'y',
                            gap: 'X',
                            show: (el, s)=>s.root.selectedSlot?.status === 'occupied',
                            FieldLabel: {
                                text: '{{ procedure | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted',
                                textTransform: 'uppercase',
                                letterSpacing: 'X'
                            },
                            FieldValue: {
                                text: (el, s)=>s.root.selectedSlot?.procedure || '-',
                                fontSize: 'Z',
                                color: 'inkText'
                            }
                        }
                    }
                }
            },
            // ─── WAITLIST PANEL ────────────────────────────
            WaitlistPanel: {
                flow: 'y',
                gap: 'Z',
                padding: 'B',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                show: (el, s)=>s.root.showWaitlist,
                WaitlistHeader: {
                    flow: 'x',
                    align: 'center space-between',
                    WaitlistTitle: {
                        text: '{{ waitlist | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'amber'
                    },
                    WaitlistCount: {
                        text: '3 patients',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                WaitlistGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 'Z',
                    '@mobileL': {
                        gridTemplateColumns: '1fr'
                    },
                    WaitItem1: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center space-between',
                        padding: 'Z',
                        round: 'Y',
                        background: 'inkSurface',
                        border: '1px solid inkBorder',
                        Info: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            Name: {
                                text: '{{ ninoKapanadze | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Detail: {
                                text: '{{ wantsMonwedAmSlot | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Actions: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center',
                            flexShrink: '0',
                            AssignBtn: {
                                tag: 'button',
                                text: '{{ assignToSchedule | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'inkText',
                                color: 'inkMid',
                                border: 'none',
                                cursor: 'pointer'
                            },
                            AutoBtn: {
                                tag: 'button',
                                text: '{{ autoAssign | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'transparent',
                                color: 'primary',
                                border: '1px solid primary',
                                cursor: 'pointer'
                            }
                        },
                        Priority: {
                            text: '{{ high | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y',
                            round: 'B',
                            background: 'red.15',
                            color: 'red',
                            flexShrink: '0'
                        }
                    },
                    WaitItem2: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center space-between',
                        padding: 'Z',
                        round: 'Y',
                        background: 'inkSurface',
                        border: '1px solid inkBorder',
                        Info: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            Name: {
                                text: '{{ davitGelashvili | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Detail: {
                                text: '{{ anyMorningSlotU2022 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Actions: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center',
                            flexShrink: '0',
                            AssignBtn: {
                                tag: 'button',
                                text: '{{ assignToSchedule | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'inkText',
                                color: 'inkMid',
                                border: 'none',
                                cursor: 'pointer'
                            },
                            AutoBtn: {
                                tag: 'button',
                                text: '{{ autoAssign | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'transparent',
                                color: 'primary',
                                border: '1px solid primary',
                                cursor: 'pointer'
                            }
                        },
                        Priority: {
                            text: '{{ medium | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y',
                            round: 'B',
                            background: 'amber.15',
                            color: 'amber',
                            flexShrink: '0'
                        }
                    },
                    WaitItem3: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center space-between',
                        padding: 'Z',
                        round: 'Y',
                        background: 'inkSurface',
                        border: '1px solid inkBorder',
                        Info: {
                            flow: 'y',
                            gap: 'X',
                            flex: '1',
                            Name: {
                                text: '{{ irakliDiasamidze | polyglot }}',
                                fontSize: 'Z',
                                fontWeight: '600',
                                color: 'inkText'
                            },
                            Detail: {
                                text: '{{ friPmPreferredU2022 | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Actions: {
                            flow: 'x',
                            gap: 'Y',
                            align: 'center',
                            flexShrink: '0',
                            AssignBtn: {
                                tag: 'button',
                                text: '{{ assignToSchedule | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'inkText',
                                color: 'inkMid',
                                border: 'none',
                                cursor: 'pointer'
                            },
                            AutoBtn: {
                                tag: 'button',
                                text: '{{ autoAssign | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'transparent',
                                color: 'primary',
                                border: '1px solid primary',
                                cursor: 'pointer'
                            }
                        },
                        Priority: {
                            text: '{{ low | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y',
                            round: 'B',
                            background: 'green.15',
                            color: 'green',
                            flexShrink: '0'
                        }
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $942c0fe183543074$export$d87cfcc979a5825c = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'billing'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            BillingNav: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                TabClaims: {
                    text: '{{ claims | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.billingTab === 'claims' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.billingTab === 'claims' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            billingTab: 'claims'
                        })
                },
                TabLedger: {
                    text: '{{ ledger | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.billingTab === 'ledger' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.billingTab === 'ledger' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            billingTab: 'ledger'
                        })
                },
                TabAging: {
                    text: '{{ aging | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.billingTab === 'aging' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.billingTab === 'aging' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            billingTab: 'aging'
                        })
                },
                TabPlans: {
                    text: '{{ paymentPlans | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.billingTab === 'plans' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.billingTab === 'plans' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            billingTab: 'plans'
                        })
                },
                TabEligibility: {
                    text: '{{ eligibility | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.billingTab === 'eligibility' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.billingTab === 'eligibility' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            billingTab: 'eligibility'
                        })
                },
                TabPayments: {
                    text: '{{ payments | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.billingTab === 'payments' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.billingTab === 'payments' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            billingTab: 'payments'
                        })
                }
            },
            // Claims View
            ClaimsView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.billingTab === 'claims',
                ClaimFilterBar: {
                    flow: 'x',
                    gap: 'Y',
                    flexWrap: 'wrap',
                    paddingBottom: 'Z',
                    AllPill: {
                        tag: 'button',
                        text: '{{ allFilter | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'teal',
                        color: 'ink',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    SubmittedPill: {
                        tag: 'button',
                        text: '{{ submitted | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    PaidPill: {
                        tag: 'button',
                        text: '{{ paid | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    DeniedPill: {
                        tag: 'button',
                        text: '{{ denied | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    }
                },
                ClaimsList: {
                    flow: 'y',
                    gap: 'Z',
                    children: [
                        {
                            claimNumber: 'CLM-2026-001',
                            patientName: 'Giorgi Beridze',
                            provider: 'Dr. Lomidze',
                            dateOfService: 'Mar 10, 2026',
                            codes: [
                                'D2750',
                                'D2950'
                            ],
                            totalCharged: '\u20BE920',
                            insurancePayment: '\u20BE600',
                            patientResponsibility: '\u20BE320',
                            status: 'Paid'
                        },
                        {
                            claimNumber: 'CLM-2026-002',
                            patientName: 'Nino Kapanadze',
                            provider: 'Dr. Kvaratskhelia',
                            dateOfService: 'Mar 12, 2026',
                            codes: [
                                'D1110',
                                'D0274'
                            ],
                            totalCharged: '\u20BE90',
                            insurancePayment: '\u20BE90',
                            patientResponsibility: '\u20BE0',
                            status: 'Paid'
                        },
                        {
                            claimNumber: 'CLM-2026-003',
                            patientName: 'Davit Gelashvili',
                            provider: 'Dr. Lomidze',
                            dateOfService: 'Mar 15, 2026',
                            codes: [
                                'D6010'
                            ],
                            totalCharged: '\u20BE1,200',
                            insurancePayment: '\u20BE0',
                            patientResponsibility: '\u20BE1,200',
                            status: 'Denied'
                        },
                        {
                            claimNumber: 'CLM-2026-004',
                            patientName: 'Mariam Tsiklauri',
                            provider: 'Dr. Beridze',
                            dateOfService: 'Mar 14, 2026',
                            codes: [
                                'D4341',
                                'D4341'
                            ],
                            totalCharged: '\u20BE400',
                            insurancePayment: '\u20BE320',
                            patientResponsibility: '\u20BE80',
                            status: 'Submitted'
                        },
                        {
                            claimNumber: 'CLM-2026-005',
                            patientName: 'Ana Javakhishvili',
                            provider: 'Dr. Lomidze',
                            dateOfService: 'Mar 8, 2026',
                            codes: [
                                'D3310'
                            ],
                            totalCharged: '\u20BE350',
                            insurancePayment: '\u20BE280',
                            patientResponsibility: '\u20BE70',
                            status: 'Paid'
                        },
                        {
                            claimNumber: 'CLM-2026-006',
                            patientName: 'Luka Mchedlishvili',
                            provider: 'Dr. Kvaratskhelia',
                            dateOfService: 'Mar 1, 2026',
                            codes: [
                                'D7140'
                            ],
                            totalCharged: '\u20BE150',
                            insurancePayment: '\u20BE0',
                            patientResponsibility: '\u20BE150',
                            status: 'Appealed'
                        },
                        {
                            claimNumber: 'CLM-2026-007',
                            patientName: 'Tamara Lomidze',
                            provider: 'Dr. Lomidze',
                            dateOfService: 'Feb 28, 2026',
                            codes: [
                                'D2391',
                                'D2391'
                            ],
                            totalCharged: '\u20BE160',
                            insurancePayment: '\u20BE128',
                            patientResponsibility: '\u20BE32',
                            status: 'Paid'
                        },
                        {
                            claimNumber: 'CLM-2026-008',
                            patientName: 'Irakli Diasamidze',
                            provider: 'Dr. Beridze',
                            dateOfService: 'Mar 16, 2026',
                            codes: [
                                'D0120',
                                'D0274'
                            ],
                            totalCharged: '\u20BE70',
                            insurancePayment: '\u20BE70',
                            patientResponsibility: '\u20BE0',
                            status: 'Submitted'
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'ClaimCard'
                }
            },
            // Ledger View
            LedgerView: {
                flow: 'y',
                gap: 'Z',
                show: (el, s)=>s.root.billingTab === 'ledger',
                LedgerHeader: {
                    text: '{{ patientLedgerU2014Giorgi | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText',
                    marginBottom: 'Z'
                },
                LedgerTable: {
                    flow: 'y',
                    children: [
                        {
                            date: 'Mar 10',
                            description: 'Crown #14',
                            provider: 'Dr. Lomidze',
                            code: 'D2750',
                            charge: '\u20BE800',
                            payment: '',
                            adjustment: '',
                            balance: '\u20BE800',
                            insurance: '\u20BE520'
                        },
                        {
                            date: 'Mar 10',
                            description: 'Core Buildup #14',
                            provider: 'Dr. Lomidze',
                            code: 'D2950',
                            charge: '\u20BE120',
                            payment: '',
                            adjustment: '',
                            balance: '\u20BE920',
                            insurance: '\u20BE80'
                        },
                        {
                            date: 'Mar 12',
                            description: 'Insurance Payment',
                            provider: '',
                            code: '',
                            charge: '',
                            payment: '\u20BE600',
                            adjustment: '',
                            balance: '\u20BE320',
                            insurance: ''
                        },
                        {
                            date: 'Mar 15',
                            description: 'Patient Payment',
                            provider: '',
                            code: '',
                            charge: '',
                            payment: '\u20BE200',
                            adjustment: '',
                            balance: '\u20BE120',
                            insurance: ''
                        },
                        {
                            date: 'Mar 18',
                            description: 'Courtesy Discount',
                            provider: '',
                            code: '',
                            charge: '',
                            payment: '',
                            adjustment: '\u20BE20',
                            balance: '\u20BE100',
                            insurance: ''
                        },
                        {
                            date: 'Feb 15',
                            description: 'Root Canal #14',
                            provider: 'Dr. Lomidze',
                            code: 'D3310',
                            charge: '\u20BE350',
                            payment: '',
                            adjustment: '',
                            balance: '\u20BE450',
                            insurance: '\u20BE280'
                        },
                        {
                            date: 'Feb 18',
                            description: 'Insurance Payment',
                            provider: '',
                            code: '',
                            charge: '',
                            payment: '\u20BE280',
                            adjustment: '',
                            balance: '\u20BE170',
                            insurance: ''
                        },
                        {
                            date: 'Feb 20',
                            description: 'Patient Payment',
                            provider: '',
                            code: '',
                            charge: '',
                            payment: '\u20BE170',
                            adjustment: '',
                            balance: '\u20BE0',
                            insurance: ''
                        },
                        {
                            date: 'Jan 20',
                            description: 'Periodic Exam',
                            provider: 'Dr. Kvaratskhelia',
                            code: 'D0120',
                            charge: '\u20BE30',
                            payment: '',
                            adjustment: '',
                            balance: '\u20BE30',
                            insurance: '\u20BE30'
                        },
                        {
                            date: 'Jan 20',
                            description: 'Bitewings',
                            provider: 'Dr. Kvaratskhelia',
                            code: 'D0274',
                            charge: '\u20BE40',
                            payment: '',
                            adjustment: '',
                            balance: '\u20BE70',
                            insurance: '\u20BE40'
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'LedgerRow'
                }
            },
            // Aging View
            AgingView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.billingTab === 'aging',
                AgingBucket: {
                    state: {
                        current: '\u20BE4,200',
                        currentCount: 28,
                        thirty: '\u20BE1,800',
                        thirtyCount: 12,
                        sixty: '\u20BE900',
                        sixtyCount: 6,
                        ninety: '\u20BE2,100',
                        ninetyCount: 8
                    }
                },
                AgingTitle: {
                    text: '{{ agedAccounts | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText',
                    marginTop: 'A'
                },
                SendStatementsBtn: {
                    extends: 'Button',
                    text: '{{ sendStatements | polyglot }}',
                    background: 'teal',
                    color: 'ink',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    fontSize: 'Z',
                    cursor: 'pointer',
                    border: 'none',
                    marginTop: 'Z'
                }
            },
            // Payment Plans View
            PaymentPlansView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.billingTab === 'plans',
                PlansTitle: {
                    text: '{{ activePaymentPlans | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                PlansGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: 'A',
                    children: [
                        {
                            totalBalance: '\u20BE1,620',
                            monthlyPayment: '\u20BE270',
                            paymentsRemaining: 6,
                            nextPaymentDate: 'Apr 1, 2026',
                            autoPay: true,
                            patientName: 'Giorgi Beridze',
                            paidPercent: 0
                        },
                        {
                            totalBalance: '\u20BE800',
                            monthlyPayment: '\u20BE200',
                            paymentsRemaining: 4,
                            nextPaymentDate: 'Apr 5, 2026',
                            autoPay: true,
                            patientName: 'Davit Gelashvili',
                            paidPercent: 25
                        },
                        {
                            totalBalance: '\u20BE450',
                            monthlyPayment: '\u20BE150',
                            paymentsRemaining: 3,
                            nextPaymentDate: 'Apr 10, 2026',
                            autoPay: false,
                            patientName: 'Ana Javakhishvili',
                            paidPercent: 40
                        },
                        {
                            totalBalance: '\u20BE1,200',
                            monthlyPayment: '\u20BE100',
                            paymentsRemaining: 12,
                            nextPaymentDate: 'Apr 1, 2026',
                            autoPay: true,
                            patientName: 'Luka Mchedlishvili',
                            paidPercent: 10
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'PaymentPlanCard'
                }
            },
            // Eligibility View
            EligibilityView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.billingTab === 'eligibility',
                EligibilityTitle: {
                    text: '{{ insuranceEligibility | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                EligibilityGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                    gap: 'A',
                    children: [
                        {
                            insuranceName: 'Aldagi Insurance',
                            policyNumber: 'ALD-2026-44521',
                            planType: 'PPO Premium',
                            annualMax: '\u20BE5,000',
                            annualUsed: '\u20BE1,200',
                            remaining: '\u20BE3,800',
                            deductibleMet: true,
                            coverage: {
                                preventive: '100%',
                                basic: '80%',
                                major: '50%',
                                ortho: '50%'
                            },
                            verifiedDate: 'Mar 18, 2026',
                            expired: false
                        },
                        {
                            insuranceName: 'GPI Insurance',
                            policyNumber: 'GPI-2026-78432',
                            planType: 'HMO Standard',
                            annualMax: '\u20BE3,000',
                            annualUsed: '\u20BE1,800',
                            remaining: '\u20BE1,200',
                            deductibleMet: true,
                            coverage: {
                                preventive: '100%',
                                basic: '70%',
                                major: '40%',
                                ortho: '0%'
                            },
                            verifiedDate: 'Mar 15, 2026',
                            expired: false
                        },
                        {
                            insuranceName: 'Imedi L',
                            policyNumber: 'IML-2025-33210',
                            planType: 'Basic',
                            annualMax: '\u20BE2,000',
                            annualUsed: '\u20BE2,000',
                            remaining: '\u20BE0',
                            deductibleMet: false,
                            coverage: {
                                preventive: '80%',
                                basic: '50%',
                                major: '0%',
                                ortho: '0%'
                            },
                            verifiedDate: 'Dec 31, 2025',
                            expired: true
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'EligibilityCard'
                }
            },
            // Payments View
            PaymentsView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.billingTab === 'payments',
                PaymentsSummary: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: 'Z',
                    TotalReceivedStat: {
                        extends: 'StatCard',
                        state: {
                            label: '{{ totalReceived | polyglot }}',
                            value: '\u20BE3,240',
                            trend: '+12%',
                            trendUp: true
                        }
                    },
                    PendingStat: {
                        extends: 'StatCard',
                        state: {
                            label: '{{ pending | polyglot }}',
                            value: '\u20BE1,470',
                            trend: '6 {{ invoices | polyglot }}',
                            trendUp: false
                        }
                    },
                    OutstandingStat: {
                        extends: 'StatCard',
                        state: {
                            label: '{{ outstanding | polyglot }}',
                            value: '\u20BE2,350',
                            trend: '4 {{ overdue | polyglot }}',
                            trendUp: false
                        }
                    }
                },
                PaymentsHeader: {
                    flow: 'x',
                    justifyContent: 'space-between',
                    align: 'center flex-start',
                    PaymentsTitle: {
                        text: '{{ paymentHistory | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    NewPaymentBtn: {
                        tag: 'button',
                        text: '{{ newPayment | polyglot }}',
                        padding: 'Y Z',
                        round: 'A',
                        background: 'teal',
                        color: 'ink',
                        fontSize: 'Y',
                        fontWeight: '600',
                        cursor: 'pointer',
                        border: 'none',
                        onClick: (e, el, s)=>s.root.update({
                                paymentModalOpen: true,
                                paymentMethod: 'card',
                                paymentAmount: '\u20BE320'
                            })
                    }
                },
                PaymentFilterBar: {
                    flow: 'x',
                    gap: 'Y',
                    flexWrap: 'wrap',
                    paddingBottom: 'Z',
                    AllPill: {
                        tag: 'button',
                        text: '{{ allFilter | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'teal',
                        color: 'ink',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    PaidPill: {
                        tag: 'button',
                        text: '{{ paid | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    PendingPill: {
                        tag: 'button',
                        text: '{{ pending | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    OverduePill: {
                        tag: 'button',
                        text: '{{ overdue | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    }
                },
                InvoicesList: {
                    flow: 'y',
                    gap: 'Z',
                    children: [
                        {
                            invoiceNumber: 'INV-2026-001',
                            patientName: 'Giorgi Beridze',
                            invoiceDate: 'Mar 10, 2026',
                            procedures: [
                                {
                                    name: 'Crown #14 (D2750)',
                                    cost: '\u20BE800'
                                },
                                {
                                    name: 'Core Buildup #14 (D2950)',
                                    cost: '\u20BE120'
                                }
                            ],
                            totalAmount: '\u20BE920',
                            invoiceStatus: 'Paid'
                        },
                        {
                            invoiceNumber: 'INV-2026-002',
                            patientName: 'Nino Kapanadze',
                            invoiceDate: 'Mar 12, 2026',
                            procedures: [
                                {
                                    name: 'Prophylaxis (D1110)',
                                    cost: '\u20BE50'
                                },
                                {
                                    name: 'Bitewings (D0274)',
                                    cost: '\u20BE40'
                                }
                            ],
                            totalAmount: '\u20BE90',
                            invoiceStatus: 'Paid'
                        },
                        {
                            invoiceNumber: 'INV-2026-003',
                            patientName: 'Davit Gelashvili',
                            invoiceDate: 'Mar 15, 2026',
                            procedures: [
                                {
                                    name: 'Implant (D6010)',
                                    cost: '\u20BE1,200'
                                }
                            ],
                            totalAmount: '\u20BE1,200',
                            invoiceStatus: 'Overdue'
                        },
                        {
                            invoiceNumber: 'INV-2026-004',
                            patientName: 'Mariam Tsiklauri',
                            invoiceDate: 'Mar 14, 2026',
                            procedures: [
                                {
                                    name: 'SRP Upper Right (D4341)',
                                    cost: '\u20BE200'
                                },
                                {
                                    name: 'SRP Lower Right (D4341)',
                                    cost: '\u20BE200'
                                }
                            ],
                            totalAmount: '\u20BE400',
                            invoiceStatus: 'Sent'
                        },
                        {
                            invoiceNumber: 'INV-2026-005',
                            patientName: 'Ana Javakhishvili',
                            invoiceDate: 'Mar 8, 2026',
                            procedures: [
                                {
                                    name: 'Root Canal #14 (D3310)',
                                    cost: '\u20BE350'
                                }
                            ],
                            totalAmount: '\u20BE350',
                            invoiceStatus: 'Paid'
                        },
                        {
                            invoiceNumber: 'INV-2026-006',
                            patientName: 'Luka Mchedlishvili',
                            invoiceDate: 'Mar 1, 2026',
                            procedures: [
                                {
                                    name: 'Extraction #32 (D7140)',
                                    cost: '\u20BE150'
                                }
                            ],
                            totalAmount: '\u20BE150',
                            invoiceStatus: 'Overdue'
                        },
                        {
                            invoiceNumber: 'INV-2026-007',
                            patientName: 'Irakli Diasamidze',
                            invoiceDate: 'Mar 16, 2026',
                            procedures: [
                                {
                                    name: 'Periodic Exam (D0120)',
                                    cost: '\u20BE30'
                                },
                                {
                                    name: 'Bitewings (D0274)',
                                    cost: '\u20BE40'
                                }
                            ],
                            totalAmount: '\u20BE70',
                            invoiceStatus: 'Draft'
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'InvoiceCard'
                },
                RecentReceipts: {
                    flow: 'y',
                    gap: 'Z',
                    marginTop: 'A',
                    ReceiptsTitle: {
                        text: '{{ recentReceipts | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText',
                        marginBottom: 'Z'
                    },
                    ReceiptsList: {
                        flow: 'y',
                        gap: 'Z',
                        children: [
                            {
                                receiptNumber: 'RCP-2026-001',
                                receiptDate: 'Mar 12, 2026',
                                patientName: 'Giorgi Beridze',
                                amountPaid: '\u20BE320',
                                method: 'Card',
                                remainingBalance: '\u20BE0'
                            },
                            {
                                receiptNumber: 'RCP-2026-002',
                                receiptDate: 'Mar 12, 2026',
                                patientName: 'Nino Kapanadze',
                                amountPaid: '\u20BE90',
                                method: 'Cash',
                                remainingBalance: '\u20BE0'
                            },
                            {
                                receiptNumber: 'RCP-2026-003',
                                receiptDate: 'Mar 10, 2026',
                                patientName: 'Ana Javakhishvili',
                                amountPaid: '\u20BE280',
                                method: 'Bank Transfer',
                                remainingBalance: '\u20BE70'
                            }
                        ],
                        childrenAs: 'state',
                        childExtends: 'ReceiptCard'
                    }
                }
            }
        },
        // Payment Modal
        PaymentModalOverlay: {
            extends: 'PaymentModal',
            if: (el, s)=>s.root.paymentModalOpen
        },
        MobileTabBar: {}
    }
};


const $efb21f9094973eba$export$352930477e0e7ab = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'prescriptions'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            RxNav: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                TabActive: {
                    text: '{{ activeRx | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeRxTab === 'active' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeRxTab === 'active' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeRxTab: 'active'
                        })
                },
                TabPast: {
                    text: '{{ pastRx | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeRxTab === 'past' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeRxTab === 'past' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeRxTab: 'past'
                        })
                },
                TabTemplates: {
                    text: '{{ templates | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeRxTab === 'templates' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeRxTab === 'templates' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeRxTab: 'templates'
                        })
                },
                TabInteractions: {
                    text: '{{ interactionCheck | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.activeRxTab === 'interactions' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.activeRxTab === 'interactions' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            activeRxTab: 'interactions'
                        })
                }
            },
            // Active Prescriptions
            ActiveRxView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeRxTab === 'active',
                ActiveTitle: {
                    text: '{{ activePrescriptions | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                ActiveList: {
                    flow: 'x wrap',
                    gap: 'Z',
                    children: [
                        {
                            drugName: 'Amoxicillin',
                            dosage: '500mg',
                            frequency: 'TID (3x daily)',
                            duration: '7 days',
                            prescribedBy: 'Dr. Lomidze',
                            prescribedDate: 'Mar 16, 2026',
                            patientName: 'Giorgi Beridze',
                            refillsRemaining: 0,
                            indication: 'Post-extraction prophylaxis',
                            pharmacy: 'GPC Pharmacy, Rustaveli Ave',
                            status: 'Active'
                        },
                        {
                            drugName: 'Ibuprofen',
                            dosage: '400mg',
                            frequency: 'PRN (as needed)',
                            duration: '5 days',
                            prescribedBy: 'Dr. Lomidze',
                            prescribedDate: 'Mar 16, 2026',
                            patientName: 'Giorgi Beridze',
                            refillsRemaining: 1,
                            indication: 'Post-operative pain management',
                            pharmacy: 'GPC Pharmacy, Rustaveli Ave',
                            status: 'Active'
                        },
                        {
                            drugName: 'Chlorhexidine Gluconate',
                            dosage: '0.12% rinse',
                            frequency: 'BID (2x daily)',
                            duration: '14 days',
                            prescribedBy: 'Dr. Kvaratskhelia',
                            prescribedDate: 'Mar 14, 2026',
                            patientName: 'Nino Kapanadze',
                            refillsRemaining: 0,
                            indication: 'Periodontal therapy adjunct',
                            pharmacy: 'Aversi Pharmacy, Chavchavadze',
                            status: 'Active'
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'PrescriptionCard'
                }
            },
            // Past Prescriptions
            PastRxView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeRxTab === 'past',
                PastTitle: {
                    text: '{{ pastPrescriptions | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                PastList: {
                    flow: 'y',
                    gap: 'Z',
                    opacity: '0.5',
                    children: [
                        {
                            drugName: 'Amoxicillin',
                            dosage: '500mg',
                            frequency: 'TID',
                            duration: '10 days',
                            prescribedBy: 'Dr. Lomidze',
                            prescribedDate: 'Feb 10, 2026',
                            patientName: 'Davit Gelashvili',
                            refillsRemaining: 0,
                            indication: 'Dental abscess',
                            pharmacy: 'GPC Pharmacy',
                            status: 'Expired'
                        },
                        {
                            drugName: 'Metronidazole',
                            dosage: '400mg',
                            frequency: 'TID',
                            duration: '7 days',
                            prescribedBy: 'Dr. Beridze',
                            prescribedDate: 'Feb 5, 2026',
                            patientName: 'Mariam Tsiklauri',
                            refillsRemaining: 0,
                            indication: 'Anaerobic infection',
                            pharmacy: 'Aversi Pharmacy',
                            status: 'Expired'
                        },
                        {
                            drugName: 'Clindamycin',
                            dosage: '300mg',
                            frequency: 'QID',
                            duration: '7 days',
                            prescribedBy: 'Dr. Lomidze',
                            prescribedDate: 'Jan 22, 2026',
                            patientName: 'Ana Javakhishvili',
                            refillsRemaining: 0,
                            indication: 'Penicillin allergy alternative',
                            pharmacy: 'PSP Pharmacy',
                            status: 'Expired'
                        },
                        {
                            drugName: 'Acetaminophen',
                            dosage: '500mg',
                            frequency: 'Q6H PRN',
                            duration: '3 days',
                            prescribedBy: 'Dr. Kvaratskhelia',
                            prescribedDate: 'Jan 18, 2026',
                            patientName: 'Luka Mchedlishvili',
                            refillsRemaining: 0,
                            indication: 'Post-extraction pain',
                            pharmacy: 'GPC Pharmacy',
                            status: 'Expired'
                        },
                        {
                            drugName: 'Fluconazole',
                            dosage: '100mg',
                            frequency: 'QD',
                            duration: '14 days',
                            prescribedBy: 'Dr. Beridze',
                            prescribedDate: 'Jan 10, 2026',
                            patientName: 'Tamara Lomidze',
                            refillsRemaining: 0,
                            indication: 'Oral candidiasis',
                            pharmacy: 'Aversi Pharmacy',
                            status: 'Expired'
                        },
                        {
                            drugName: 'Dexamethasone',
                            dosage: '4mg',
                            frequency: 'BID',
                            duration: '3 days',
                            prescribedBy: 'Dr. Lomidze',
                            prescribedDate: 'Dec 20, 2025',
                            patientName: 'Irakli Diasamidze',
                            refillsRemaining: 0,
                            indication: 'Post-surgical swelling',
                            pharmacy: 'PSP Pharmacy',
                            status: 'Expired'
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'PrescriptionCard'
                }
            },
            // Templates View
            TemplatesView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeRxTab === 'templates',
                TemplatesTitle: {
                    text: '{{ prescriptionTemplates | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                RxTemplateSelector: {}
            },
            // Interaction Check View
            InteractionCheckView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.activeRxTab === 'interactions',
                InteractionsTitle: {
                    text: '{{ drugInteractionChecker | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                InteractionAlerts: {
                    flow: 'y',
                    gap: 'Z',
                    Alert1: {
                        extends: 'DrugInteractionAlert',
                        state: {
                            drugA: 'Amoxicillin',
                            drugB: 'Warfarin',
                            severity: 'Major',
                            description: 'Amoxicillin may increase the anticoagulant effect of Warfarin. Monitor INR closely and adjust Warfarin dose if necessary. Risk of bleeding may be elevated during concurrent use.',
                            recommendation: 'Monitor INR within 3-5 days of starting Amoxicillin. Consider dose reduction of Warfarin if INR rises above therapeutic range.'
                        }
                    },
                    Alert2: {
                        extends: 'DrugInteractionAlert',
                        state: {
                            drugA: 'Ibuprofen',
                            drugB: 'Aspirin',
                            severity: 'Moderate',
                            description: 'Ibuprofen may reduce the cardioprotective antiplatelet effect of low-dose Aspirin. NSAIDs compete for COX-1 binding site when taken concurrently.',
                            recommendation: 'Administer Aspirin at least 30 minutes before or 8 hours after Ibuprofen. Consider alternative analgesic such as Acetaminophen.'
                        }
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $82a9ec07acc8e442$export$6bfc9f488d92f769 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'lab'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        width: '100%',
        overflow: 'hidden',
        TopBar: {},
        ContentArea: {
            flow: 'x',
            gap: 'B',
            padding: 'B',
            flex: '1',
            height: '100%',
            width: '100%',
            PipelineSection: {
                flow: 'y',
                gap: 'A',
                flex: '1',
                height: '100%',
                width: '100%',
                overflowX: 'auto',
                PipelineTitle: {
                    text: '{{ labCasePipeline | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                LabPipeline: {
                    height: '100%',
                    Submitted: {
                        Cards: {
                            children: [
                                {
                                    caseId: 'LAB-003',
                                    patientName: 'Davit Gelashvili',
                                    provider: 'Dr. Lomidze',
                                    labVendor: 'TbilisiDent Lab',
                                    type: 'Implant Abutment + Crown #19',
                                    shade: 'A3',
                                    dateSubmitted: 'Mar 12, 2026',
                                    dateExpected: 'Mar 26, 2026',
                                    status: 'Impression Sent',
                                    notes: 'Digital scan uploaded'
                                },
                                {
                                    caseId: 'LAB-006',
                                    patientName: 'Luka Mchedlishvili',
                                    provider: 'Dr. Kvaratskhelia',
                                    labVendor: 'Caucasus Dental Lab',
                                    type: 'Veneer #8, #9',
                                    shade: 'BL1',
                                    dateSubmitted: 'Mar 15, 2026',
                                    dateExpected: 'Mar 29, 2026',
                                    status: 'Impression Sent',
                                    notes: 'Minimal prep, ultra-thin'
                                },
                                {
                                    caseId: 'LAB-008',
                                    patientName: 'Irakli Diasamidze',
                                    provider: 'Dr. Beridze',
                                    labVendor: 'TbilisiDent Lab',
                                    type: 'E.max Inlay #30',
                                    shade: 'A1',
                                    dateSubmitted: 'Mar 16, 2026',
                                    dateExpected: 'Mar 24, 2026',
                                    status: 'Impression Sent',
                                    notes: 'Conservative preparation'
                                }
                            ],
                            childrenAs: 'state',
                            childExtends: 'LabCaseCard'
                        }
                    },
                    Fabrication: {
                        Cards: {
                            children: [
                                {
                                    caseId: 'LAB-001',
                                    patientName: 'Giorgi Beridze',
                                    provider: 'Dr. Lomidze',
                                    labVendor: 'TbilisiDent Lab',
                                    type: 'PFM Crown #14',
                                    shade: 'A2',
                                    dateSubmitted: 'Mar 10, 2026',
                                    dateExpected: 'Mar 20, 2026',
                                    status: 'In Fabrication',
                                    notes: 'Custom staining requested'
                                },
                                {
                                    caseId: 'LAB-004',
                                    patientName: 'Mariam Tsiklauri',
                                    provider: 'Dr. Beridze',
                                    labVendor: 'Euro Dental Georgia',
                                    type: 'Night Guard (upper)',
                                    shade: '',
                                    dateSubmitted: 'Mar 14, 2026',
                                    dateExpected: 'Mar 21, 2026',
                                    status: 'In Fabrication',
                                    notes: 'Hard/soft combo, 2mm thickness'
                                }
                            ],
                            childrenAs: 'state',
                            childExtends: 'LabCaseCard'
                        }
                    },
                    Quality: {
                        Cards: {
                            children: [
                                {
                                    caseId: 'LAB-005',
                                    patientName: 'Ana Javakhishvili',
                                    provider: 'Dr. Lomidze',
                                    labVendor: 'TbilisiDent Lab',
                                    type: '3-unit Bridge #3-5',
                                    shade: 'A2',
                                    dateSubmitted: 'Mar 5, 2026',
                                    dateExpected: 'Mar 19, 2026',
                                    status: 'Quality Check',
                                    notes: 'Full contour zirconia'
                                }
                            ],
                            childrenAs: 'state',
                            childExtends: 'LabCaseCard'
                        }
                    },
                    TryIn: {
                        Cards: {
                            children: [
                                {
                                    caseId: 'LAB-007',
                                    patientName: 'Tamara Lomidze',
                                    provider: 'Dr. Lomidze',
                                    labVendor: 'Euro Dental Georgia',
                                    type: 'Partial Denture (lower)',
                                    shade: 'A3',
                                    dateSubmitted: 'Mar 1, 2026',
                                    dateExpected: 'Mar 22, 2026',
                                    status: 'Try-in Scheduled',
                                    notes: 'Cast metal framework'
                                }
                            ],
                            childrenAs: 'state',
                            childExtends: 'LabCaseCard'
                        }
                    },
                    Ready: {
                        Cards: {
                            children: [
                                {
                                    caseId: 'LAB-002',
                                    patientName: 'Nino Kapanadze',
                                    provider: 'Dr. Kvaratskhelia',
                                    labVendor: 'Caucasus Dental Lab',
                                    type: 'Zirconia Crown #8',
                                    shade: 'BL2',
                                    dateSubmitted: 'Mar 8, 2026',
                                    dateExpected: 'Mar 18, 2026',
                                    status: 'Ready for Pickup',
                                    notes: 'Patient prefers high translucency'
                                }
                            ],
                            childrenAs: 'state',
                            childExtends: 'LabCaseCard'
                        }
                    }
                }
            },
            VendorPanel: {
                flow: 'y',
                gap: 'A',
                width: '280px',
                minWidth: '280px',
                background: 'inkSurface',
                round: 'A',
                padding: 'A',
                VendorTitle: {
                    text: '{{ labVendors2 | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: 'inkText',
                    marginBottom: 'Z'
                },
                Vendor1: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'Z',
                    borderBottom: '1px solid inkBorder',
                    VendorName1: {
                        text: '{{ tbilisidentLab | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'inkText'
                    },
                    VendorInfo1: {
                        flow: 'x',
                        gap: 'Z',
                        flexWrap: 'wrap',
                        Turnaround1: {
                            text: '{{ turnaround710Days | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        Rating1: {
                            text: '{{ rating485 | polyglot }}',
                            fontSize: 'Y',
                            color: 'gold'
                        },
                        ActiveCases1: {
                            text: '{{ activeCases4 | polyglot }}',
                            fontSize: 'Y',
                            color: 'teal'
                        }
                    }
                },
                Vendor2: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'Z',
                    borderBottom: '1px solid inkBorder',
                    VendorName2: {
                        text: '{{ caucasusDentalLab | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'inkText'
                    },
                    VendorInfo2: {
                        flow: 'x',
                        gap: 'Z',
                        flexWrap: 'wrap',
                        Turnaround2: {
                            text: '{{ turnaround57Days | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        Rating2: {
                            text: '{{ rating465 | polyglot }}',
                            fontSize: 'Y',
                            color: 'gold'
                        },
                        ActiveCases2: {
                            text: '{{ activeCases2 | polyglot }}',
                            fontSize: 'Y',
                            color: 'teal'
                        }
                    }
                },
                Vendor3: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'Z',
                    VendorName3: {
                        text: '{{ euroDentalGeorgia | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'inkText'
                    },
                    VendorInfo3: {
                        flow: 'x',
                        gap: 'Z',
                        flexWrap: 'wrap',
                        Turnaround3: {
                            text: '{{ turnaround1014Days | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        Rating3: {
                            text: '{{ rating445 | polyglot }}',
                            fontSize: 'Y',
                            color: 'gold'
                        },
                        ActiveCases3: {
                            text: '{{ activeCases2 | polyglot }}',
                            fontSize: 'Y',
                            color: 'teal'
                        }
                    }
                }
            }
        }
    }
};


const $05f5f13c3cb66234$export$17606da954476c13 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'referrals'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            ReferralHeader: {
                flow: 'x',
                justifyContent: 'space-between',
                alignItems: 'center',
                ReferralTitle: {
                    text: '{{ referrals | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                NewReferralBtn: {
                    extends: 'Button',
                    text: '{{ newReferral | polyglot }}',
                    background: 'teal',
                    color: 'ink',
                    fontWeight: '600',
                    padding: 'Y A',
                    round: 'A',
                    fontSize: 'Z',
                    cursor: 'pointer',
                    border: 'none'
                }
            },
            ReferralFilterBar: {
                flow: 'x',
                gap: 'Y',
                paddingBottom: 'Z',
                AllPill: {
                    tag: 'button',
                    text: '{{ all | polyglot }}',
                    padding: 'Y Z',
                    round: 'C',
                    background: (el, s)=>s.root.referralFilter === 'all' ? 'teal' : 'inkSurface',
                    color: (el, s)=>s.root.referralFilter === 'all' ? 'ink' : 'inkMuted',
                    fontSize: 'Y',
                    fontWeight: '500',
                    cursor: 'pointer',
                    border: 'none',
                    onClick: (e, el, s)=>s.root.update({
                            referralFilter: 'all'
                        })
                },
                InboundPill: {
                    tag: 'button',
                    text: '{{ inbound2 | polyglot }}',
                    padding: 'Y Z',
                    round: 'C',
                    background: (el, s)=>s.root.referralFilter === 'inbound' ? 'teal' : 'inkSurface',
                    color: (el, s)=>s.root.referralFilter === 'inbound' ? 'ink' : 'inkMuted',
                    fontSize: 'Y',
                    fontWeight: '500',
                    cursor: 'pointer',
                    border: 'none',
                    onClick: (e, el, s)=>s.root.update({
                            referralFilter: 'inbound'
                        })
                },
                OutboundPill: {
                    tag: 'button',
                    text: '{{ outbound2 | polyglot }}',
                    padding: 'Y Z',
                    round: 'C',
                    background: (el, s)=>s.root.referralFilter === 'outbound' ? 'teal' : 'inkSurface',
                    color: (el, s)=>s.root.referralFilter === 'outbound' ? 'ink' : 'inkMuted',
                    fontSize: 'Y',
                    fontWeight: '500',
                    cursor: 'pointer',
                    border: 'none',
                    onClick: (e, el, s)=>s.root.update({
                            referralFilter: 'outbound'
                        })
                }
            },
            ReferralsList: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                gap: 'A',
                children: [
                    {
                        referralId: 'REF-001',
                        patientName: 'Giorgi Beridze',
                        direction: 'Outbound',
                        referringDoctor: 'Dr. Lomidze',
                        referredTo: 'Dr. Vakhtang Chitishvili',
                        specialty: 'Oral Surgery',
                        reason: 'Impacted wisdom tooth extraction (#32)',
                        urgency: 'Routine',
                        referralStatus: 'Sent',
                        dateSent: 'Mar 10, 2026',
                        appointmentDate: 'Mar 25, 2026',
                        notes: 'Panoramic X-ray attached'
                    },
                    {
                        referralId: 'REF-002',
                        patientName: 'Nino Kapanadze',
                        direction: 'Inbound',
                        referringDoctor: 'Dr. Elene Gorgiladze',
                        referredTo: 'Dr. Kvaratskhelia',
                        specialty: 'Periodontics',
                        reason: 'Advanced periodontal disease, bone grafting evaluation',
                        urgency: 'Urgent',
                        referralStatus: 'Scheduled',
                        dateSent: 'Mar 12, 2026',
                        appointmentDate: 'Mar 19, 2026',
                        notes: 'Patient referred from general practice'
                    },
                    {
                        referralId: 'REF-003',
                        patientName: 'Davit Gelashvili',
                        direction: 'Outbound',
                        referringDoctor: 'Dr. Lomidze',
                        referredTo: 'Dr. Zurab Khmaladze',
                        specialty: 'Endodontics',
                        reason: 'Retreatment of failed root canal #19',
                        urgency: 'Routine',
                        referralStatus: 'Sent',
                        dateSent: 'Mar 15, 2026',
                        appointmentDate: '',
                        notes: 'Awaiting specialist availability'
                    },
                    {
                        referralId: 'REF-004',
                        patientName: 'Mariam Tsiklauri',
                        direction: 'Inbound',
                        referringDoctor: 'Dr. Nana Tsereteli',
                        referredTo: 'Dr. Beridze',
                        specialty: 'Orthodontics',
                        reason: 'Class II malocclusion, Invisalign evaluation',
                        urgency: 'Routine',
                        referralStatus: 'Completed',
                        dateSent: 'Feb 28, 2026',
                        appointmentDate: 'Mar 8, 2026',
                        notes: 'Treatment plan approved, started aligner therapy'
                    },
                    {
                        referralId: 'REF-005',
                        patientName: 'Ana Javakhishvili',
                        direction: 'Outbound',
                        referringDoctor: 'Dr. Kvaratskhelia',
                        referredTo: 'Dr. Giorgi Margvelashvili',
                        specialty: 'Prosthodontics',
                        reason: 'Full-arch implant restoration planning',
                        urgency: 'Routine',
                        referralStatus: 'Sent',
                        dateSent: 'Mar 5, 2026',
                        appointmentDate: 'Mar 22, 2026',
                        notes: 'CBCT scan completed, forwarded digitally'
                    },
                    {
                        referralId: 'REF-006',
                        patientName: 'Luka Mchedlishvili',
                        direction: 'Inbound',
                        referringDoctor: 'Dr. Tamar Datunashvili',
                        referredTo: 'Dr. Lomidze',
                        specialty: 'Oral Surgery',
                        reason: 'Biopsy of suspicious oral lesion, left buccal mucosa',
                        urgency: 'Urgent',
                        referralStatus: 'Scheduled',
                        dateSent: 'Mar 16, 2026',
                        appointmentDate: 'Mar 18, 2026',
                        notes: 'Priority appointment, patient anxious'
                    },
                    {
                        referralId: 'REF-007',
                        patientName: 'Tamara Lomidze',
                        direction: 'Outbound',
                        referringDoctor: 'Dr. Beridze',
                        referredTo: 'Dr. Manana Gogoladze',
                        specialty: 'Pediatric Dentistry',
                        reason: 'Behavioral management for pediatric patient (age 5)',
                        urgency: 'Routine',
                        referralStatus: 'Sent',
                        dateSent: 'Mar 1, 2026',
                        appointmentDate: '',
                        notes: 'Specialist not accepting new patients, seeking alternative'
                    },
                    {
                        referralId: 'REF-008',
                        patientName: 'Irakli Diasamidze',
                        direction: 'Inbound',
                        referringDoctor: 'Dr. Levan Topuria',
                        referredTo: 'Dr. Kvaratskhelia',
                        specialty: 'TMJ/Orofacial Pain',
                        reason: 'Chronic TMJ dysfunction, failed conservative treatment',
                        urgency: 'Routine',
                        referralStatus: 'Sent',
                        dateSent: 'Mar 14, 2026',
                        appointmentDate: '',
                        notes: 'MRI results pending, will schedule upon receipt'
                    },
                    {
                        referralId: 'REF-009',
                        patientName: 'Salome Khomasuridze',
                        direction: 'Outbound',
                        referringDoctor: 'Dr. Beridze',
                        referredTo: 'Dr. Eka Nadaraia',
                        specialty: 'Periodontics',
                        reason: 'Stage III periodontitis, surgical intervention required',
                        urgency: 'Urgent',
                        referralStatus: 'LetterSent',
                        dateSent: 'Mar 17, 2026',
                        appointmentDate: 'Mar 24, 2026',
                        notes: 'Full-mouth radiographs and perio charting attached'
                    },
                    {
                        referralId: 'REF-010',
                        patientName: 'Tornike Arsenishvili',
                        direction: 'Inbound',
                        referringDoctor: 'Dr. Beka Chkheidze',
                        referredTo: 'Dr. Lomidze',
                        specialty: 'Oral Surgery',
                        reason: 'Supernumerary tooth removal, upper anterior',
                        urgency: 'Routine',
                        referralStatus: 'Completed',
                        dateSent: 'Feb 20, 2026',
                        appointmentDate: 'Mar 5, 2026',
                        notes: 'Surgery completed successfully, post-op clear'
                    },
                    {
                        referralId: 'REF-011',
                        patientName: 'Natia Gogichaishvili',
                        direction: 'Outbound',
                        referringDoctor: 'Dr. Kvaratskhelia',
                        referredTo: 'Dr. Irma Kvariani',
                        specialty: 'Orthodontics',
                        reason: 'Adult orthodontics consultation, crowding lower arch',
                        urgency: 'Routine',
                        referralStatus: 'Sent',
                        dateSent: 'Mar 18, 2026',
                        appointmentDate: '',
                        notes: 'Photos and study models forwarded'
                    },
                    {
                        referralId: 'REF-012',
                        patientName: 'Zaza Mgeladze',
                        direction: 'Inbound',
                        referringDoctor: 'Dr. Maka Sikharulidze',
                        referredTo: 'Dr. Beridze',
                        specialty: 'Implantology',
                        reason: 'Single implant placement #14, bone volume adequate',
                        urgency: 'Routine',
                        referralStatus: 'Scheduled',
                        dateSent: 'Mar 10, 2026',
                        appointmentDate: 'Apr 2, 2026',
                        notes: 'CBCT sent, treatment plan approved by patient'
                    }
                ],
                childrenAs: 'state',
                childExtends: 'ReferralCard'
            }
        },
        MobileTabBar: {}
    }
};


const $b8cac88ae81b99b1$export$f7c42a96c638d4dc = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'reports',
                            reportType: s.root.reportType || 'production'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            PageTitle: {
                tag: 'h2',
                text: '{{ reportsAnalytics | polyglot }}',
                fontSize: 'C',
                fontWeight: '700',
                color: 'inkText',
                letterSpacing: '-0.02em'
            },
            // ─── REPORT TYPE NAV ─────────────────────────
            ReportTypeNav: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                flexWrap: 'wrap',
                TabProduction: {
                    text: '{{ production | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.reportType === 'production' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.reportType === 'production' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            reportType: 'production'
                        })
                },
                TabCollections: {
                    text: '{{ collections | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.reportType === 'collections' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.reportType === 'collections' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            reportType: 'collections'
                        })
                },
                TabScheduling: {
                    text: '{{ schedulingReport | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.reportType === 'scheduling' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.reportType === 'scheduling' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            reportType: 'scheduling'
                        })
                },
                TabAcceptance: {
                    text: '{{ treatmentAcceptance | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.reportType === 'acceptance' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.reportType === 'acceptance' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            reportType: 'acceptance'
                        })
                },
                TabRecall: {
                    text: '{{ recall | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.reportType === 'recall' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.reportType === 'recall' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            reportType: 'recall'
                        })
                }
            },
            // ─── PRODUCTION VIEW ─────────────────────────
            ProductionView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.reportType === 'production',
                ProductionStatsRow: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y'
                    },
                    CardGross: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Gross Production',
                            value: "\u20BE48,200",
                            trend: '+12%',
                            trendColor: 'green'
                        }
                    },
                    CardNet: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Net Production',
                            value: "\u20BE42,100",
                            trend: '+9%',
                            trendColor: 'green'
                        }
                    },
                    CardCollections: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Collections',
                            value: "\u20BE38,900",
                            trend: '+7%',
                            trendColor: 'green'
                        }
                    },
                    CardRate: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Collection Rate',
                            value: '92.4%',
                            trend: '+2.1%',
                            trendColor: 'green'
                        }
                    }
                },
                ProviderSection: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    ProviderTitle: {
                        tag: 'h3',
                        text: '{{ productionByProvider | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText',
                        marginBottom: 'Z'
                    },
                    ProviderDrK: {
                        extends: 'ProductionReport',
                        state: {
                            provider: 'Dr. Kvaratskhelia',
                            amount: "\u20BE28,000",
                            percentage: 58
                        }
                    },
                    ProviderDrB: {
                        extends: 'ProductionReport',
                        state: {
                            provider: 'Dr. Beridze',
                            amount: "\u20BE14,200",
                            percentage: 29
                        }
                    },
                    ProviderHygN: {
                        extends: 'ProductionReport',
                        state: {
                            provider: 'Hyg. Nino',
                            amount: "\u20BE6,000",
                            percentage: 13
                        }
                    }
                },
                CategorySection: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    CategoryTitle: {
                        tag: 'h3',
                        text: '{{ productionByCategory | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText',
                        marginBottom: 'Z'
                    },
                    CategoryBars: {
                        flow: 'y',
                        gap: 'Z',
                        BarPreventive: {
                            flow: 'y',
                            gap: 'X',
                            BarLabel: {
                                flow: 'x',
                                align: 'center space-between',
                                LabelText: {
                                    text: '{{ preventive2 | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'inkSubtle'
                                },
                                LabelPct: {
                                    text: '18%',
                                    fontSize: 'Z',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                }
                            },
                            BarTrack: {
                                height: 'Y',
                                round: 'Y',
                                background: 'inkSurface',
                                overflow: 'hidden',
                                BarFill: {
                                    width: '18%',
                                    height: '100%',
                                    background: 'teal',
                                    round: 'Y'
                                }
                            }
                        },
                        BarRestorative: {
                            flow: 'y',
                            gap: 'X',
                            BarLabel: {
                                flow: 'x',
                                align: 'center space-between',
                                LabelText: {
                                    text: '{{ restorative | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'inkSubtle'
                                },
                                LabelPct: {
                                    text: '34%',
                                    fontSize: 'Z',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                }
                            },
                            BarTrack: {
                                height: 'Y',
                                round: 'Y',
                                background: 'inkSurface',
                                overflow: 'hidden',
                                BarFill: {
                                    width: '34%',
                                    height: '100%',
                                    background: 'blue',
                                    round: 'Y'
                                }
                            }
                        },
                        BarEndo: {
                            flow: 'y',
                            gap: 'X',
                            BarLabel: {
                                flow: 'x',
                                align: 'center space-between',
                                LabelText: {
                                    text: '{{ endodontics | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'inkSubtle'
                                },
                                LabelPct: {
                                    text: '12%',
                                    fontSize: 'Z',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                }
                            },
                            BarTrack: {
                                height: 'Y',
                                round: 'Y',
                                background: 'inkSurface',
                                overflow: 'hidden',
                                BarFill: {
                                    width: '12%',
                                    height: '100%',
                                    background: 'amber',
                                    round: 'Y'
                                }
                            }
                        },
                        BarPerio: {
                            flow: 'y',
                            gap: 'X',
                            BarLabel: {
                                flow: 'x',
                                align: 'center space-between',
                                LabelText: {
                                    text: '{{ periodontics | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'inkSubtle'
                                },
                                LabelPct: {
                                    text: '15%',
                                    fontSize: 'Z',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                }
                            },
                            BarTrack: {
                                height: 'Y',
                                round: 'Y',
                                background: 'inkSurface',
                                overflow: 'hidden',
                                BarFill: {
                                    width: '15%',
                                    height: '100%',
                                    background: 'purple',
                                    round: 'Y'
                                }
                            }
                        },
                        BarProsth: {
                            flow: 'y',
                            gap: 'X',
                            BarLabel: {
                                flow: 'x',
                                align: 'center space-between',
                                LabelText: {
                                    text: '{{ prosthodontics | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'inkSubtle'
                                },
                                LabelPct: {
                                    text: '16%',
                                    fontSize: 'Z',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                }
                            },
                            BarTrack: {
                                height: 'Y',
                                round: 'Y',
                                background: 'inkSurface',
                                overflow: 'hidden',
                                BarFill: {
                                    width: '16%',
                                    height: '100%',
                                    background: 'gold',
                                    round: 'Y'
                                }
                            }
                        },
                        BarSurgery: {
                            flow: 'y',
                            gap: 'X',
                            BarLabel: {
                                flow: 'x',
                                align: 'center space-between',
                                LabelText: {
                                    text: '{{ surgery | polyglot }}',
                                    fontSize: 'Z',
                                    color: 'inkSubtle'
                                },
                                LabelPct: {
                                    text: '5%',
                                    fontSize: 'Z',
                                    color: 'inkMuted',
                                    fontWeight: '600'
                                }
                            },
                            BarTrack: {
                                height: 'Y',
                                round: 'Y',
                                background: 'inkSurface',
                                overflow: 'hidden',
                                BarFill: {
                                    width: '5%',
                                    height: '100%',
                                    background: 'red',
                                    round: 'Y'
                                }
                            }
                        }
                    }
                }
            },
            // ─── COLLECTIONS VIEW ────────────────────────
            CollectionsView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.reportType === 'collections',
                CollectionsStats: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y'
                    },
                    CardTotal: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Total Collected',
                            value: "\u20BE38,900",
                            trend: '+7%',
                            trendColor: 'green'
                        }
                    },
                    CardOutstanding: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Outstanding',
                            value: "\u20BE5,300",
                            trend: '-3%',
                            trendColor: 'green'
                        }
                    },
                    CardInsurance: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Insurance Pending',
                            value: "\u20BE3,200",
                            trend: '+1%',
                            trendColor: 'amber'
                        }
                    },
                    CardWriteOff: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Write-offs',
                            value: "\u20BE890",
                            trend: '-12%',
                            trendColor: 'green'
                        }
                    }
                },
                AgingReport: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    AgingTitle: {
                        tag: 'h3',
                        text: '{{ agingReport | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText',
                        marginBottom: 'Z'
                    },
                    Age0to30: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Label: {
                            text: '0-30 days',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: "\u20BE2,100",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'green'
                        }
                    },
                    Age31to60: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Label: {
                            text: '31-60 days',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: "\u20BE1,400",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'amber'
                        }
                    },
                    Age61to90: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Label: {
                            text: '61-90 days',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: "\u20BE980",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'amber'
                        }
                    },
                    Age90Plus: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        Label: {
                            text: '90+ days',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: "\u20BE820",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'red'
                        }
                    }
                }
            },
            // ─── SCHEDULING VIEW ─────────────────────────
            SchedulingView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.reportType === 'scheduling',
                SchedulingStats: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y'
                    },
                    CardUtil: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Chair Utilization',
                            value: '78%',
                            trend: '+5%',
                            trendColor: 'green'
                        }
                    },
                    CardNoShow: {
                        extends: 'ReportCard',
                        state: {
                            title: 'No-show Rate',
                            value: '4.2%',
                            trend: '-1.8%',
                            trendColor: 'green'
                        }
                    },
                    CardAvgWait: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Avg Wait Time',
                            value: '8 min',
                            trend: '-2 min',
                            trendColor: 'green'
                        }
                    },
                    CardAppts: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Total Appointments',
                            value: '342',
                            trend: '+18',
                            trendColor: 'green'
                        }
                    }
                },
                ScheduleByDay: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    DayTitle: {
                        tag: 'h3',
                        text: '{{ appointmentsByDay | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText',
                        marginBottom: 'Z'
                    },
                    DayMon: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Label: {
                            text: '{{ monday | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: '52',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText'
                        }
                    },
                    DayTue: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Label: {
                            text: '{{ tuesday | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: '61',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText'
                        }
                    },
                    DayWed: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Label: {
                            text: '{{ wednesday | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: '58',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText'
                        }
                    },
                    DayThu: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Label: {
                            text: '{{ thursday | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: '64',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText'
                        }
                    },
                    DayFri: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Label: {
                            text: '{{ friday | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: '68',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText'
                        }
                    },
                    DaySat: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        Label: {
                            text: '{{ saturday | polyglot }}',
                            fontSize: 'Z',
                            color: 'inkSubtle'
                        },
                        Value: {
                            text: '39',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText'
                        }
                    }
                }
            },
            // ─── TREATMENT ACCEPTANCE VIEW ───────────────
            TreatmentAcceptanceView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.reportType === 'acceptance',
                AcceptanceStats: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y'
                    },
                    CardPresented: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Plans Presented',
                            value: '45',
                            trend: '+8',
                            trendColor: 'green'
                        }
                    },
                    CardAccepted: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Accepted',
                            value: '31',
                            trend: '+5',
                            trendColor: 'green'
                        }
                    },
                    CardAcceptRate: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Acceptance Rate',
                            value: '68.9%',
                            trend: '+3.2%',
                            trendColor: 'green'
                        }
                    }
                },
                DeclinedSection: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    DeclinedTitle: {
                        tag: 'h3',
                        text: '{{ topDeclinedTreatments | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText',
                        marginBottom: 'Z'
                    },
                    DecRow1: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Info: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ implantPlacement | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkText',
                                fontWeight: '500'
                            },
                            Reason: {
                                text: '{{ costConcerns | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Count: {
                            text: '5 declined',
                            fontSize: 'Z',
                            color: 'red',
                            fontWeight: '600'
                        }
                    },
                    DecRow2: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Info: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ ceramicCrown | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkText',
                                fontWeight: '500'
                            },
                            Reason: {
                                text: '{{ wantsToWait | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Count: {
                            text: '3 declined',
                            fontSize: 'Z',
                            color: 'red',
                            fontWeight: '600'
                        }
                    },
                    DecRow3: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Info: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ orthodontics | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkText',
                                fontWeight: '500'
                            },
                            Reason: {
                                text: '{{ insuranceNotCovering | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Count: {
                            text: '3 declined',
                            fontSize: 'Z',
                            color: 'red',
                            fontWeight: '600'
                        }
                    },
                    DecRow4: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        borderBottom: '1px solid inkBorder',
                        Info: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ whitening | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkText',
                                fontWeight: '500'
                            },
                            Reason: {
                                text: '{{ notAPriority | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Count: {
                            text: '2 declined',
                            fontSize: 'Z',
                            color: 'amber',
                            fontWeight: '600'
                        }
                    },
                    DecRow5: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z 0',
                        Info: {
                            flow: 'y',
                            gap: 'X',
                            Name: {
                                text: '{{ rootCanal | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkText',
                                fontWeight: '500'
                            },
                            Reason: {
                                text: '{{ seekingSecondOpinion | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        Count: {
                            text: '1 declined',
                            fontSize: 'Z',
                            color: 'amber',
                            fontWeight: '600'
                        }
                    }
                }
            },
            // ─── RECALL VIEW ─────────────────────────────
            RecallView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.reportType === 'recall',
                RecallChart: {
                    extends: 'RecallEffectivenessChart'
                },
                RecallStats: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    '@mobileL': {
                        flow: 'y'
                    },
                    CardDue: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Due This Month',
                            value: '120',
                            trend: '+15',
                            trendColor: 'amber'
                        }
                    },
                    CardScheduled: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Scheduled',
                            value: '78',
                            trend: '+12',
                            trendColor: 'green'
                        }
                    },
                    CardOverdue: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Overdue',
                            value: '42',
                            trend: '-8',
                            trendColor: 'green'
                        }
                    },
                    CardReactivation: {
                        extends: 'ReportCard',
                        state: {
                            title: 'Reactivation Rate',
                            value: '65%',
                            trend: '+4%',
                            trendColor: 'green'
                        }
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $468c87eeae29dd40$export$26b870b33373704f = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'enterprise',
                            enterprisePanel: s.root.enterprisePanel || 'rbac'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'x',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                flow: 'y',
                padding: 'A'
            },
            // ─── ENTERPRISE SIDEBAR ──────────────────────
            EnterpriseSidebar: {
                flow: 'y',
                gap: 'Y',
                width: 'G',
                flexShrink: '0',
                padding: 'A',
                round: 'A',
                background: 'inkMid',
                border: '1px solid gold',
                '@mobileL': {
                    width: '100%',
                    flow: 'x',
                    flexWrap: 'wrap',
                    padding: 'Z'
                },
                SidebarTitle: {
                    text: '{{ enterprise | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'gold',
                    marginBottom: 'Z',
                    '@mobileL': {
                        display: 'none'
                    }
                },
                NavRbac: {
                    text: '{{ rbac | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    round: 'Y',
                    color: (el, s)=>s.root.enterprisePanel === 'rbac' ? 'gold' : 'inkMuted',
                    background: (el, s)=>s.root.enterprisePanel === 'rbac' ? 'gold.10' : 'transparent',
                    onClick: (e, el, s)=>s.root.update({
                            enterprisePanel: 'rbac'
                        })
                },
                NavAudit: {
                    text: '{{ auditLog | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    round: 'Y',
                    color: (el, s)=>s.root.enterprisePanel === 'audit' ? 'gold' : 'inkMuted',
                    background: (el, s)=>s.root.enterprisePanel === 'audit' ? 'gold.10' : 'transparent',
                    onClick: (e, el, s)=>s.root.update({
                            enterprisePanel: 'audit'
                        })
                },
                NavCompliance: {
                    text: '{{ compliance | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    round: 'Y',
                    color: (el, s)=>s.root.enterprisePanel === 'compliance' ? 'gold' : 'inkMuted',
                    background: (el, s)=>s.root.enterprisePanel === 'compliance' ? 'gold.10' : 'transparent',
                    onClick: (e, el, s)=>s.root.update({
                            enterprisePanel: 'compliance'
                        })
                },
                NavTenancy: {
                    text: '{{ multiTenancy | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    round: 'Y',
                    color: (el, s)=>s.root.enterprisePanel === 'tenancy' ? 'gold' : 'inkMuted',
                    background: (el, s)=>s.root.enterprisePanel === 'tenancy' ? 'gold.10' : 'transparent',
                    onClick: (e, el, s)=>s.root.update({
                            enterprisePanel: 'tenancy'
                        })
                },
                NavSso: {
                    text: '{{ sso | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    round: 'Y',
                    color: (el, s)=>s.root.enterprisePanel === 'sso' ? 'gold' : 'inkMuted',
                    background: (el, s)=>s.root.enterprisePanel === 'sso' ? 'gold.10' : 'transparent',
                    onClick: (e, el, s)=>s.root.update({
                            enterprisePanel: 'sso'
                        })
                },
                NavFlags: {
                    text: '{{ featureFlags | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    round: 'Y',
                    color: (el, s)=>s.root.enterprisePanel === 'flags' ? 'gold' : 'inkMuted',
                    background: (el, s)=>s.root.enterprisePanel === 'flags' ? 'gold.10' : 'transparent',
                    onClick: (e, el, s)=>s.root.update({
                            enterprisePanel: 'flags'
                        })
                },
                NavApi: {
                    text: '{{ apiManagement | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    round: 'Y',
                    color: (el, s)=>s.root.enterprisePanel === 'api' ? 'gold' : 'inkMuted',
                    background: (el, s)=>s.root.enterprisePanel === 'api' ? 'gold.10' : 'transparent',
                    onClick: (e, el, s)=>s.root.update({
                            enterprisePanel: 'api'
                        })
                },
                NavData: {
                    text: '{{ dataManagement | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    round: 'Y',
                    color: (el, s)=>s.root.enterprisePanel === 'data' ? 'gold' : 'inkMuted',
                    background: (el, s)=>s.root.enterprisePanel === 'data' ? 'gold.10' : 'transparent',
                    onClick: (e, el, s)=>s.root.update({
                            enterprisePanel: 'data'
                        })
                }
            },
            // ─── PANEL CONTENT ───────────────────────────
            PanelContent: {
                flow: 'y',
                flex: '1',
                gap: 'A',
                // ─── RBAC VIEW ────────────────────────────
                RbacView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.enterprisePanel === 'rbac',
                    RbacTitle: {
                        tag: 'h2',
                        text: '{{ rolebasedAccessControl | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    RolesGrid: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        '@mobileL': {
                            flow: 'y'
                        },
                        BadgeAdmin: {
                            extends: 'RbacBadge',
                            state: {
                                role: 'Admin',
                                description: 'Full system access',
                                userCount: 2,
                                color: 'red'
                            }
                        },
                        BadgeDoctor: {
                            extends: 'RbacBadge',
                            state: {
                                role: 'Doctor',
                                description: 'Patient records, treatment plans',
                                userCount: 4,
                                color: 'teal'
                            }
                        },
                        BadgeHygienist: {
                            extends: 'RbacBadge',
                            state: {
                                role: 'Hygienist',
                                description: 'Perio charts, hygiene notes',
                                userCount: 3,
                                color: 'blue'
                            }
                        },
                        BadgeReceptionist: {
                            extends: 'RbacBadge',
                            state: {
                                role: 'Receptionist',
                                description: 'Scheduling, billing',
                                userCount: 5,
                                color: 'amber'
                            }
                        },
                        BadgeLabTech: {
                            extends: 'RbacBadge',
                            state: {
                                role: 'Lab Tech',
                                description: 'Lab orders, results',
                                userCount: 2,
                                color: 'purple'
                            }
                        },
                        BadgePatient: {
                            extends: 'RbacBadge',
                            state: {
                                role: 'Patient',
                                description: 'Portal access only',
                                userCount: 1240,
                                color: 'green'
                            }
                        }
                    },
                    PermissionMatrix: {
                        flow: 'y',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        overflow: 'auto',
                        MatrixTitle: {
                            text: '{{ permissionMatrix | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'inkText',
                            padding: 'A A Z A'
                        },
                        MatrixHeader: {
                            display: 'grid',
                            gridTemplateColumns: '150px repeat(6, 1fr)',
                            padding: 'Z A',
                            borderBottom: '1px solid inkBorder',
                            gap: 'Y',
                            ColModule: {
                                text: '{{ module | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'inkMuted'
                            },
                            ColAdmin: {
                                text: '{{ admin | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'red',
                                textAlign: 'center'
                            },
                            ColDoctor: {
                                text: '{{ doctor2 | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'teal',
                                textAlign: 'center'
                            },
                            ColHygienist: {
                                text: '{{ hygienist | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'blue',
                                textAlign: 'center'
                            },
                            ColReceptionist: {
                                text: '{{ reception | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'amber',
                                textAlign: 'center'
                            },
                            ColLabTech: {
                                text: '{{ lab | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'purple',
                                textAlign: 'center'
                            },
                            ColPatient: {
                                text: '{{ patient2 | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'green',
                                textAlign: 'center'
                            }
                        },
                        RowPatients: {
                            display: 'grid',
                            gridTemplateColumns: '150px repeat(6, 1fr)',
                            padding: 'Z A',
                            borderBottom: '1px solid inkBorder',
                            gap: 'Y',
                            Module: {
                                text: '{{ patients | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            },
                            P1: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P2: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P3: {
                                text: '{{ read | polyglot }}',
                                fontSize: 'Y',
                                color: 'amber',
                                textAlign: 'center'
                            },
                            P4: {
                                text: '{{ read | polyglot }}',
                                fontSize: 'Y',
                                color: 'amber',
                                textAlign: 'center'
                            },
                            P5: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P6: {
                                text: '{{ own | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                textAlign: 'center'
                            }
                        },
                        RowBilling: {
                            display: 'grid',
                            gridTemplateColumns: '150px repeat(6, 1fr)',
                            padding: 'Z A',
                            borderBottom: '1px solid inkBorder',
                            gap: 'Y',
                            Module: {
                                text: '{{ billing | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            },
                            P1: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P2: {
                                text: '{{ read | polyglot }}',
                                fontSize: 'Y',
                                color: 'amber',
                                textAlign: 'center'
                            },
                            P3: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P4: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P5: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P6: {
                                text: '{{ own | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                textAlign: 'center'
                            }
                        },
                        RowScheduling: {
                            display: 'grid',
                            gridTemplateColumns: '150px repeat(6, 1fr)',
                            padding: 'Z A',
                            borderBottom: '1px solid inkBorder',
                            gap: 'Y',
                            Module: {
                                text: '{{ scheduling | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            },
                            P1: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P2: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P3: {
                                text: '{{ own | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                textAlign: 'center'
                            },
                            P4: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P5: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P6: {
                                text: '{{ own | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                textAlign: 'center'
                            }
                        },
                        RowReports: {
                            display: 'grid',
                            gridTemplateColumns: '150px repeat(6, 1fr)',
                            padding: 'Z A',
                            borderBottom: '1px solid inkBorder',
                            gap: 'Y',
                            Module: {
                                text: '{{ reports | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            },
                            P1: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P2: {
                                text: '{{ own | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                textAlign: 'center'
                            },
                            P3: {
                                text: '{{ own | polyglot }}',
                                fontSize: 'Y',
                                color: 'blue',
                                textAlign: 'center'
                            },
                            P4: {
                                text: '{{ read | polyglot }}',
                                fontSize: 'Y',
                                color: 'amber',
                                textAlign: 'center'
                            },
                            P5: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P6: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            }
                        },
                        RowSettings: {
                            display: 'grid',
                            gridTemplateColumns: '150px repeat(6, 1fr)',
                            padding: 'Z A',
                            borderBottom: '1px solid inkBorder',
                            gap: 'Y',
                            Module: {
                                text: '{{ settings | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            },
                            P1: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P2: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P3: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P4: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P5: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P6: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            }
                        },
                        RowLab: {
                            display: 'grid',
                            gridTemplateColumns: '150px repeat(6, 1fr)',
                            padding: 'Z A',
                            gap: 'Y',
                            Module: {
                                text: '{{ labOrders | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            },
                            P1: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P2: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P3: {
                                text: '{{ read | polyglot }}',
                                fontSize: 'Y',
                                color: 'amber',
                                textAlign: 'center'
                            },
                            P4: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            },
                            P5: {
                                text: '{{ full | polyglot }}',
                                fontSize: 'Y',
                                color: 'green',
                                textAlign: 'center'
                            },
                            P6: {
                                text: '{{ none | polyglot }}',
                                fontSize: 'Y',
                                color: 'red',
                                textAlign: 'center'
                            }
                        }
                    }
                },
                // ─── AUDIT LOG VIEW ──────────────────────────
                AuditLogView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.enterprisePanel === 'audit',
                    AuditTitle: {
                        tag: 'h2',
                        text: '{{ auditLog2 | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    AuditFilters: {
                        flow: 'x',
                        gap: 'Z',
                        flexWrap: 'wrap',
                        marginBottom: 'Z',
                        FilterSearch: {
                            extends: 'Input',
                            tag: 'input',
                            type: 'text',
                            placeholder: 'Search audit log...',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkSurface',
                            color: 'inkText',
                            border: '1px solid inkBorder',
                            fontSize: 'Z',
                            flex: '1',
                            minWidth: 'E'
                        },
                        FilterType: {
                            text: '{{ allTypes | polyglot }}',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'inkMuted',
                            cursor: 'pointer'
                        },
                        FilterDate: {
                            text: '{{ last7Days | polyglot }}',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'inkMuted',
                            cursor: 'pointer'
                        }
                    },
                    AuditList: {
                        flow: 'y',
                        gap: 'Y',
                        Log01: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-18 14:32:05',
                                user: 'Dr. Kvaratskhelia',
                                action: 'Updated patient record',
                                target: 'Giorgi Beridze',
                                ip: '192.168.1.45',
                                severity: 'info'
                            }
                        },
                        Log02: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-18 14:15:22',
                                user: 'Admin',
                                action: 'Modified RBAC permissions',
                                target: 'Hygienist role',
                                ip: '192.168.1.10',
                                severity: 'warning'
                            }
                        },
                        Log03: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-18 13:48:11',
                                user: 'Receptionist Nana',
                                action: 'Created appointment',
                                target: 'M. Tsiklauri - Mar 22',
                                ip: '192.168.1.32',
                                severity: 'info'
                            }
                        },
                        Log04: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-18 12:05:44',
                                user: 'System',
                                action: 'Automated backup completed',
                                target: 'Database snapshot',
                                ip: '10.0.0.1',
                                severity: 'info'
                            }
                        },
                        Log05: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-18 11:22:18',
                                user: 'Dr. Beridze',
                                action: 'Exported patient data',
                                target: 'Bulk export (42 records)',
                                ip: '192.168.1.51',
                                severity: 'warning'
                            }
                        },
                        Log06: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-18 10:55:03',
                                user: 'Admin',
                                action: 'Added new user',
                                target: 'Hyg. Salome Janelidze',
                                ip: '192.168.1.10',
                                severity: 'info'
                            }
                        },
                        Log07: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-18 09:30:17',
                                user: 'System',
                                action: 'Failed login attempt',
                                target: 'unknown@gmail.com',
                                ip: '85.114.22.198',
                                severity: 'error'
                            }
                        },
                        Log08: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-17 17:45:29',
                                user: 'Dr. Kvaratskhelia',
                                action: 'Signed treatment plan',
                                target: 'Patient: Ana Javakhishvili',
                                ip: '192.168.1.45',
                                severity: 'info'
                            }
                        },
                        Log09: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-17 16:12:08',
                                user: 'Admin',
                                action: 'Updated integration settings',
                                target: 'Google Calendar sync',
                                ip: '192.168.1.10',
                                severity: 'info'
                            }
                        },
                        Log10: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-17 14:30:55',
                                user: 'Lab Tech Giorgi',
                                action: 'Uploaded lab results',
                                target: 'Order #LAB-2026-089',
                                ip: '192.168.1.67',
                                severity: 'info'
                            }
                        },
                        Log11: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-17 11:08:42',
                                user: 'System',
                                action: 'SSL certificate renewed',
                                target: 'denta.plus.ge',
                                ip: '10.0.0.1',
                                severity: 'info'
                            }
                        },
                        Log12: {
                            extends: 'AuditLogRow',
                            state: {
                                timestamp: '2026-03-17 09:00:00',
                                user: 'System',
                                action: 'Daily compliance check passed',
                                target: 'All modules',
                                ip: '10.0.0.1',
                                severity: 'info'
                            }
                        }
                    }
                },
                // ─── COMPLIANCE VIEW ─────────────────────────
                ComplianceView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.enterprisePanel === 'compliance',
                    ComplianceTitle: {
                        tag: 'h2',
                        text: '{{ complianceDashboard | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    MetersRow: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        '@mobileL': {
                            flow: 'y'
                        },
                        MeterEncryption: {
                            extends: 'ComplianceMeter',
                            state: {
                                label: 'Encryption',
                                value: 100,
                                status: 'compliant'
                            }
                        },
                        MeterAccess: {
                            extends: 'ComplianceMeter',
                            state: {
                                label: 'Access Controls',
                                value: 92,
                                status: 'compliant'
                            }
                        },
                        MeterConsent: {
                            extends: 'ComplianceMeter',
                            state: {
                                label: 'Consent Management',
                                value: 78,
                                status: 'warning'
                            }
                        },
                        MeterRetention: {
                            extends: 'ComplianceMeter',
                            state: {
                                label: 'Data Retention',
                                value: 65,
                                status: 'attention'
                            }
                        }
                    },
                    ComplianceDetails: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'B',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        DetailsTitle: {
                            text: '{{ complianceChecklist | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'Z'
                        },
                        Check1: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y 0',
                            borderBottom: '1px solid inkBorder',
                            Dot: {
                                text: '{{ pass | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'green',
                                width: 'C'
                            },
                            Label: {
                                text: '{{ dataEncryptedAtRest | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            }
                        },
                        Check2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y 0',
                            borderBottom: '1px solid inkBorder',
                            Dot: {
                                text: '{{ pass | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'green',
                                width: 'C'
                            },
                            Label: {
                                text: '{{ dataEncryptedInTransit | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            }
                        },
                        Check3: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y 0',
                            borderBottom: '1px solid inkBorder',
                            Dot: {
                                text: '{{ pass | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'green',
                                width: 'C'
                            },
                            Label: {
                                text: '{{ mfaEnabledForAll | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            }
                        },
                        Check4: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y 0',
                            borderBottom: '1px solid inkBorder',
                            Dot: {
                                text: '{{ warn | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'amber',
                                width: 'C'
                            },
                            Label: {
                                text: '3 patients missing updated consent forms',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            }
                        },
                        Check5: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y 0',
                            borderBottom: '1px solid inkBorder',
                            Dot: {
                                text: '{{ warn | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'amber',
                                width: 'C'
                            },
                            Label: {
                                text: '{{ dataRetentionPolicyReview | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            }
                        },
                        Check6: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y 0',
                            Dot: {
                                text: '{{ pass | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'green',
                                width: 'C'
                            },
                            Label: {
                                text: '{{ auditLoggingActiveOn | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkSubtle'
                            }
                        }
                    }
                },
                // ─── MULTI-TENANCY VIEW ──────────────────────
                MultiTenancyView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.enterprisePanel === 'tenancy',
                    TenancyTitle: {
                        tag: 'h2',
                        text: '{{ multitenancyManagement | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    TenantGrid: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        '@mobileL': {
                            flow: 'y'
                        },
                        Tenant1: {
                            extends: 'TenantCard',
                            state: {
                                name: 'Denta Plus',
                                clinics: 5,
                                users: 32,
                                plan: 'Enterprise',
                                status: 'active'
                            }
                        },
                        Tenant2: {
                            extends: 'TenantCard',
                            state: {
                                name: 'NB Dental',
                                clinics: 3,
                                users: 18,
                                plan: 'Professional',
                                status: 'active'
                            }
                        },
                        Tenant3: {
                            extends: 'TenantCard',
                            state: {
                                name: 'Dream Dental',
                                clinics: 1,
                                users: 6,
                                plan: 'Starter',
                                status: 'active'
                            }
                        },
                        Tenant4: {
                            extends: 'TenantCard',
                            state: {
                                name: "Richter's Dental Group",
                                clinics: 8,
                                users: 54,
                                plan: 'Enterprise',
                                status: 'active'
                            }
                        }
                    }
                },
                // ─── SSO VIEW ────────────────────────────────
                SsoView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.enterprisePanel === 'sso',
                    SsoTitle: {
                        tag: 'h2',
                        text: '{{ singleSignonSso | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    SsoProviders: {
                        flow: 'y',
                        gap: 'Z',
                        SsoSaml: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            SsoInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                SsoName: {
                                    text: '{{ saml20 | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                SsoDesc: {
                                    text: '{{ enterpriseIdentityProviderInte | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            SsoBadge: {
                                text: '{{ configured | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        SsoOidc: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            SsoInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                SsoName: {
                                    text: '{{ openidConnect | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                SsoDesc: {
                                    text: '{{ oauth20BasedAuthentication | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            SsoBadge: {
                                text: '{{ available2 | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'inkSurface',
                                color: 'inkMuted'
                            }
                        },
                        SsoGoogle: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            SsoInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                SsoName: {
                                    text: 'Google Workspace',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                SsoDesc: {
                                    text: '{{ signInWithGoogle | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            SsoBadge: {
                                text: '{{ connected2 | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        SsoAzure: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            SsoInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                SsoName: {
                                    text: '{{ azureAd | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                SsoDesc: {
                                    text: '{{ microsoftAzureActiveDirectory | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            SsoBadge: {
                                text: '{{ available2 | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'inkSurface',
                                color: 'inkMuted'
                            }
                        }
                    }
                },
                // ─── FEATURE FLAGS VIEW ──────────────────────
                FeatureFlagsView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.enterprisePanel === 'flags',
                    FlagsTitle: {
                        tag: 'h2',
                        text: '{{ featureFlags2 | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    FlagsList: {
                        flow: 'y',
                        gap: 'Z',
                        Flag1: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            FlagInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                FlagName: {
                                    text: '{{ aixrayanalysis | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText',
                                    fontFamily: 'monospace'
                                },
                                FlagDesc: {
                                    text: '{{ aipoweredXrayAnalysisAnd | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            FlagToggle: {
                                text: 'ON',
                                fontSize: 'Y',
                                fontWeight: '700',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green',
                                cursor: 'pointer'
                            }
                        },
                        Flag2: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            FlagInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                FlagName: {
                                    text: '{{ voiceperio | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText',
                                    fontFamily: 'monospace'
                                },
                                FlagDesc: {
                                    text: '{{ voiceactivatedPeriodontalChart | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            FlagToggle: {
                                text: 'ON',
                                fontSize: 'Y',
                                fontWeight: '700',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green',
                                cursor: 'pointer'
                            }
                        },
                        Flag3: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            FlagInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                FlagName: {
                                    text: '{{ patientportalv2 | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText',
                                    fontFamily: 'monospace'
                                },
                                FlagDesc: {
                                    text: '{{ nextgenerationPatientSelfservi | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            FlagToggle: {
                                text: 'OFF',
                                fontSize: 'Y',
                                fontWeight: '700',
                                padding: 'X Z',
                                round: 'B',
                                background: 'inkSurface',
                                color: 'inkMuted',
                                cursor: 'pointer'
                            }
                        },
                        Flag4: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            FlagInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                FlagName: {
                                    text: '{{ whatsappreminders | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText',
                                    fontFamily: 'monospace'
                                },
                                FlagDesc: {
                                    text: 'WhatsApp appointment reminder integration',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            FlagToggle: {
                                text: 'ON',
                                fontSize: 'Y',
                                fontWeight: '700',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green',
                                cursor: 'pointer'
                            }
                        },
                        Flag5: {
                            flow: 'x',
                            gap: 'A',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            align: 'center flex-start',
                            FlagInfo: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                FlagName: {
                                    text: '{{ multilanguage | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '600',
                                    color: 'inkText',
                                    fontFamily: 'monospace'
                                },
                                FlagDesc: {
                                    text: '{{ multilanguageSupportGeorgianEn | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            FlagToggle: {
                                text: 'OFF',
                                fontSize: 'Y',
                                fontWeight: '700',
                                padding: 'X Z',
                                round: 'B',
                                background: 'inkSurface',
                                color: 'inkMuted',
                                cursor: 'pointer'
                            }
                        }
                    }
                },
                // ─── API VIEW ────────────────────────────────
                ApiView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.enterprisePanel === 'api',
                    ApiTitle: {
                        tag: 'h2',
                        text: '{{ apiManagement2 | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    ApiStats: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        '@mobileL': {
                            flow: 'y'
                        },
                        StatRequests: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            StatLabel: {
                                text: '{{ requests24h | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkMuted'
                            },
                            StatValue: {
                                text: '12,847',
                                fontSize: 'B',
                                fontWeight: '700',
                                color: 'inkText'
                            }
                        },
                        StatLatency: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            StatLabel: {
                                text: '{{ avgLatency | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkMuted'
                            },
                            StatValue: {
                                text: '45ms',
                                fontSize: 'B',
                                fontWeight: '700',
                                color: 'green'
                            }
                        },
                        StatUptime: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            StatLabel: {
                                text: '{{ uptime | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkMuted'
                            },
                            StatValue: {
                                text: '99.97%',
                                fontSize: 'B',
                                fontWeight: '700',
                                color: 'green'
                            }
                        }
                    },
                    ApiKeys: {
                        flow: 'y',
                        gap: 'Z',
                        KeysTitle: {
                            text: '{{ apiKeys | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'Y'
                        },
                        Key1: {
                            extends: 'ApiKeyRow',
                            state: {
                                name: 'Production',
                                key: 'dk_prod_****_8f2a',
                                created: 'Jan 5, 2026',
                                lastUsed: '2 min ago',
                                status: 'active'
                            }
                        },
                        Key2: {
                            extends: 'ApiKeyRow',
                            state: {
                                name: 'Staging',
                                key: 'dk_stg_****_c4b1',
                                created: 'Jan 5, 2026',
                                lastUsed: '3 hours ago',
                                status: 'active'
                            }
                        },
                        Key3: {
                            extends: 'ApiKeyRow',
                            state: {
                                name: 'Patient Portal',
                                key: 'dk_portal_****_9e3d',
                                created: 'Feb 12, 2026',
                                lastUsed: '15 min ago',
                                status: 'active'
                            }
                        }
                    }
                },
                // ─── DATA VIEW ───────────────────────────────
                DataView: {
                    flow: 'y',
                    gap: 'A',
                    show: (el, s)=>s.root.enterprisePanel === 'data',
                    DataTitle: {
                        tag: 'h2',
                        text: '{{ dataManagement2 | polyglot }}',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    DataStats: {
                        flow: 'x',
                        gap: 'A',
                        flexWrap: 'wrap',
                        '@mobileL': {
                            flow: 'y'
                        },
                        StatStorage: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            StatLabel: {
                                text: '{{ storageUsed | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkMuted'
                            },
                            StatValue: {
                                text: '24.8 GB',
                                fontSize: 'B',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            StatExtra: {
                                text: '{{ of100Gb | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        StatRecords: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            StatLabel: {
                                text: '{{ totalRecords | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkMuted'
                            },
                            StatValue: {
                                text: '148,230',
                                fontSize: 'B',
                                fontWeight: '700',
                                color: 'inkText'
                            }
                        },
                        StatBackup: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'A',
                            round: 'A',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            flex: '1',
                            minWidth: 'E',
                            StatLabel: {
                                text: '{{ lastBackup | polyglot }}',
                                fontSize: 'Z',
                                color: 'inkMuted'
                            },
                            StatValue: {
                                text: '2h ago',
                                fontSize: 'B',
                                fontWeight: '700',
                                color: 'green'
                            },
                            StatExtra: {
                                text: '{{ nextIn4h | polyglot }}',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        }
                    },
                    DataActions: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'B',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        ActionsTitle: {
                            text: '{{ dataOperations | polyglot }}',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'inkText',
                            marginBottom: 'Z'
                        },
                        ActionExport: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z 0',
                            borderBottom: '1px solid inkBorder',
                            ActionLabel: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ActionName: {
                                    text: '{{ exportAllData | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '500',
                                    color: 'inkText'
                                },
                                ActionDesc: {
                                    text: '{{ downloadCompleteDatabaseExport | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            ActionBtn: {
                                text: '{{ export | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'inkSurface',
                                color: 'inkText',
                                cursor: 'pointer',
                                border: '1px solid inkBorder'
                            }
                        },
                        ActionPurge: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z 0',
                            borderBottom: '1px solid inkBorder',
                            ActionLabel: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ActionName: {
                                    text: '{{ purgeOldRecords | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '500',
                                    color: 'inkText'
                                },
                                ActionDesc: {
                                    text: '{{ removeRecordsPastRetention | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            ActionBtn: {
                                text: '{{ purge | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'red.15',
                                color: 'red',
                                cursor: 'pointer',
                                border: '1px solid red'
                            }
                        },
                        ActionMigrate: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z 0',
                            ActionLabel: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                ActionName: {
                                    text: '{{ dataMigration | polyglot }}',
                                    fontSize: 'Z',
                                    fontWeight: '500',
                                    color: 'inkText'
                                },
                                ActionDesc: {
                                    text: '{{ importDataFromExternal | polyglot }}',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            ActionBtn: {
                                text: '{{ import | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'inkSurface',
                                color: 'inkText',
                                cursor: 'pointer',
                                border: '1px solid inkBorder'
                            }
                        }
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $ec0ab458d2b9f4ac$export$d55f97af03376191 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'integrations',
                            integrationCategory: s.root.integrationCategory || 'all'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            PageTitle: {
                tag: 'h2',
                text: '{{ integrations2 | polyglot }}',
                fontSize: 'C',
                fontWeight: '700',
                color: 'inkText',
                letterSpacing: '-0.02em'
            },
            // ─── FILTER BAR ──────────────────────────────
            IntegrationFilterBar: {
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                paddingBottom: 'A',
                borderBottom: '1px solid inkBorder',
                PillAll: {
                    text: '{{ allFilter | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'all' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'all' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'all'
                        })
                },
                PillEhr: {
                    text: '{{ ehr | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'ehr' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'ehr' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'ehr'
                        })
                },
                PillLabs: {
                    text: '{{ labs | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'labs' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'labs' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'labs'
                        })
                },
                PillInsurance: {
                    text: '{{ insurance | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'insurance' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'insurance' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'insurance'
                        })
                },
                PillPayments: {
                    text: '{{ payments | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'payments' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'payments' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'payments'
                        })
                },
                PillMessaging: {
                    text: '{{ messaging | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'messaging' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'messaging' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'messaging'
                        })
                },
                PillTelehealth: {
                    text: '{{ telehealth | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'telehealth' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'telehealth' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'telehealth'
                        })
                },
                PillScheduling: {
                    text: '{{ schedulingReport | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'scheduling' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'scheduling' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'scheduling'
                        })
                },
                PillAi: {
                    text: '{{ aiMl | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'ai' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'ai' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'ai'
                        })
                },
                PillWearables: {
                    text: '{{ wearables | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'B',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.integrationCategory === 'wearables' ? 'ink' : 'inkMuted',
                    background: (el, s)=>s.root.integrationCategory === 'wearables' ? 'teal' : 'inkMid',
                    onClick: (e, el, s)=>s.root.update({
                            integrationCategory: 'wearables'
                        })
                }
            },
            // ─── INTEGRATION grid ────────────────────────
            IntegrationGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: 'A',
                '@mobileL': {
                    gridTemplateColumns: '1fr'
                },
                // EHR
                CardEpic: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ehr',
                    state: {
                        name: 'Epic',
                        category: 'EHR',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=epic.com&sz=128',
                        status: 'connected'
                    }
                },
                CardCerner: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ehr',
                    state: {
                        name: 'Cerner',
                        category: 'EHR',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=oracle.com&sz=128',
                        status: 'connected'
                    }
                },
                CardFhir: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ehr',
                    state: {
                        name: 'Generic FHIR',
                        category: 'EHR',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=hl7.org&sz=128',
                        status: 'available'
                    }
                },
                // Labs
                CardQuest: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'labs',
                    state: {
                        name: 'Quest Diagnostics',
                        category: 'Labs',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=questdiagnostics.com&sz=128',
                        status: 'connected'
                    }
                },
                CardLabCorp: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'labs',
                    state: {
                        name: 'LabCorp',
                        category: 'Labs',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=labcorp.com&sz=128',
                        status: 'connected'
                    }
                },
                CardLis: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'labs',
                    state: {
                        name: 'In-house LIS',
                        category: 'Labs',
                        status: 'connected'
                    }
                },
                // Insurance (Georgian)
                CardAldagi: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'insurance',
                    state: {
                        name: 'Aldagi',
                        category: 'Insurance',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=aldagi.ge&sz=128',
                        status: 'connected'
                    }
                },
                CardGpi: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'insurance',
                    state: {
                        name: 'GPI',
                        category: 'Insurance',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=gpih.ge&sz=128',
                        status: 'connected'
                    }
                },
                CardImedi: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'insurance',
                    state: {
                        name: 'Imedi L',
                        category: 'Insurance',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=imedil.ge&sz=128',
                        status: 'disconnected'
                    }
                },
                CardUnison: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'insurance',
                    state: {
                        name: 'Unison',
                        category: 'Insurance',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=unison.ge&sz=128',
                        status: 'available'
                    }
                },
                // Payments
                CardTbc: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'payments',
                    state: {
                        name: 'TBC Pay',
                        category: 'Payments',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=tbcbank.ge&sz=128',
                        status: 'connected'
                    }
                },
                CardBog: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'payments',
                    state: {
                        name: 'BOG iPay',
                        category: 'Payments',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=bog.ge&sz=128',
                        status: 'available'
                    }
                },
                CardStripe: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'payments',
                    state: {
                        name: 'Stripe',
                        category: 'Payments',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=stripe.com&sz=128',
                        status: 'available'
                    }
                },
                // Messaging
                CardWhatsapp: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'messaging',
                    state: {
                        name: 'WhatsApp',
                        category: 'Messaging',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=whatsapp.com&sz=128',
                        status: 'connected'
                    }
                },
                CardSms: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'messaging',
                    state: {
                        name: 'SMS.ge',
                        category: 'Messaging',
                        status: 'connected'
                    }
                },
                CardEmail: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'messaging',
                    state: {
                        name: 'Email SMTP',
                        category: 'Messaging',
                        status: 'connected'
                    }
                },
                // Telehealth
                CardZoom: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'telehealth',
                    state: {
                        name: 'Zoom Health',
                        category: 'Telehealth',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=zoom.us&sz=128',
                        status: 'available'
                    }
                },
                CardTwilio: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'telehealth',
                    state: {
                        name: 'Twilio',
                        category: 'Telehealth',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=twilio.com&sz=128',
                        status: 'available'
                    }
                },
                // Scheduling
                CardGcal: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'scheduling',
                    state: {
                        name: 'Google Calendar',
                        category: 'Scheduling',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=google.com&sz=128',
                        status: 'connected'
                    }
                },
                CardOutlook: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'scheduling',
                    state: {
                        name: 'Outlook Calendar',
                        category: 'Scheduling',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=microsoft.com&sz=128',
                        status: 'available'
                    }
                },
                // AI/ML
                CardGemini: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ai',
                    state: {
                        name: 'Google Gemini',
                        category: 'AI/ML',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=deepmind.com&sz=128',
                        status: 'connected'
                    }
                },
                CardMedGemma: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ai',
                    state: {
                        name: 'MedGemma',
                        category: 'AI/ML',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=google.com&sz=128',
                        status: 'available'
                    }
                },
                CardDentiAi: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ai',
                    state: {
                        name: 'Denti.AI',
                        category: 'AI/ML',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=denti.ai&sz=128',
                        status: 'available'
                    }
                },
                CardOverjet: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ai',
                    state: {
                        name: 'Overjet',
                        category: 'AI/ML',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=overjet.com&sz=128',
                        status: 'available'
                    }
                },
                // Wearables
                CardHealthKit: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'wearables',
                    state: {
                        name: 'Apple HealthKit',
                        category: 'Wearables',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=apple.com&sz=128',
                        status: 'available'
                    }
                },
                CardHealthConnect: {
                    extends: 'IntegrationCard',
                    show: (el, s)=>s.root.integrationCategory === 'all' || s.root.integrationCategory === 'wearables',
                    state: {
                        name: 'Google Health Connect',
                        category: 'Wearables',
                        logoUrl: 'https://www.google.com/s2/favicons?domain=google.com&sz=128',
                        status: 'available'
                    }
                }
            }
        }
    },
    // ─── INTEGRATION MODAL ──────────────────────────
    IntegrationModal: {
        show: (el, s)=>s.root.integrationModal?.open,
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '1000',
        flow: 'x',
        align: 'center center',
        Overlay: {
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            background: 'rgba(0,0,0,0.5)',
            cursor: 'pointer',
            on: {
                click: (e, el, s)=>s.root.update({
                        integrationModal: {
                            open: false
                        }
                    })
            }
        },
        ModalCard: {
            position: 'relative',
            flow: 'y',
            gap: 'A',
            width: '100%',
            maxWidth: 'H',
            maxHeight: '90vh',
            overflow: 'auto',
            background: 'inkMid',
            round: 'B',
            padding: 'C',
            border: '1px solid inkBorder',
            boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
            zIndex: '1001',
            CloseBtn: {
                tag: 'button',
                text: '{{ u2715 | polyglot }}',
                position: 'absolute',
                top: 'A',
                right: 'A',
                background: 'transparent',
                border: 'none',
                color: 'inkMuted',
                fontSize: 'A',
                cursor: 'pointer',
                padding: 'Y',
                ':hover': {
                    color: 'inkText'
                },
                on: {
                    click: (e, el, s)=>s.root.update({
                            integrationModal: {
                                open: false
                            }
                        })
                }
            },
            ModalHeader: {
                flow: 'x',
                gap: 'Z',
                align: 'flex-start flex-start',
                HeaderLogo: {
                    tag: 'img',
                    src: (el, s)=>{
                        const m = s.root.integrationModal;
                        if (m?.logoUrl) return m.logoUrl;
                        return `https://ui-avatars.com/api/?name=${encodeURIComponent(m?.name || '?')}&background=f0f0f0&color=333&size=96&bold=true&format=svg`;
                    },
                    width: 'A1',
                    height: 'A1',
                    round: 'Y',
                    objectFit: 'contain',
                    background: 'inkSurface',
                    marginTop: 'X'
                },
                HeaderInfo: {
                    flow: 'y',
                    gap: 'Y',
                    ModalName: {
                        text: (el, s)=>s.root.integrationModal?.name || '',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText',
                        lineHeight: '1'
                    },
                    ModalCategory: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center',
                        CatTag: {
                            tag: 'span',
                            text: (el, s)=>s.root.integrationModal?.category || '',
                            fontSize: 'Y',
                            padding: 'X Y',
                            round: 'B',
                            background: 'inkSurface',
                            color: 'inkMuted'
                        },
                        StatusDot: {
                            flow: 'x',
                            gap: 'X',
                            align: 'center',
                            Dot: {
                                width: '8px',
                                height: '8px',
                                round: 'D',
                                background: (el, s)=>{
                                    const st = s.root.integrationModal?.status;
                                    if (st === 'connected') return 'green';
                                    if (st === 'disconnected') return 'red';
                                    return 'inkMuted';
                                }
                            },
                            StatusLabel: {
                                fontSize: 'Y',
                                text: (el, s)=>{
                                    const st = s.root.integrationModal?.status;
                                    if (st === 'connected') return 'Connected';
                                    if (st === 'disconnected') return 'Disconnected';
                                    return 'Not Installed';
                                },
                                color: (el, s)=>{
                                    const st = s.root.integrationModal?.status;
                                    if (st === 'connected') return 'green';
                                    if (st === 'disconnected') return 'red';
                                    return 'inkMuted';
                                }
                            }
                        }
                    }
                }
            },
            Divider: {
                width: '100%',
                height: '1px',
                background: 'inkBorder'
            },
            // ─── SETTINGS SECTION ──────────────
            SettingsSection: {
                flow: 'y',
                gap: 'Z',
                SectionTitle: {
                    text: '{{ configuration | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'inkText',
                    margin: '- - Y -'
                },
                FieldApiKey: {
                    flow: 'y',
                    gap: 'Y',
                    FieldLabel: {
                        tag: 'label',
                        text: '{{ apiKey | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '500',
                        color: 'inkMuted'
                    },
                    FieldInput: {
                        tag: 'input',
                        type: 'text',
                        placeholder: 'Enter API key...',
                        padding: 'Z',
                        round: 'Y',
                        background: 'inkSurface',
                        color: 'inkText',
                        border: '1px solid inkBorder',
                        fontSize: 'Z',
                        width: '100%',
                        outline: 'none'
                    }
                },
                FieldEndpoint: {
                    flow: 'y',
                    gap: 'Y',
                    FieldLabel: {
                        tag: 'label',
                        text: '{{ endpointUrl | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '500',
                        color: 'inkMuted'
                    },
                    FieldInput: {
                        tag: 'input',
                        type: 'text',
                        placeholder: 'https://api.example.com/v1',
                        padding: 'Z',
                        round: 'Y',
                        background: 'inkSurface',
                        color: 'inkText',
                        border: '1px solid inkBorder',
                        fontSize: 'Z',
                        width: '100%',
                        outline: 'none'
                    }
                },
                FieldProtocol: {
                    flow: 'y',
                    gap: 'Y',
                    FieldLabel: {
                        tag: 'label',
                        text: '{{ protocol | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '500',
                        color: 'inkMuted'
                    },
                    FieldValue: {
                        text: (el, s)=>s.root.integrationModal?.protocol || 'REST API',
                        fontSize: 'Z',
                        color: 'inkSubtle',
                        padding: 'Z',
                        round: 'Y',
                        background: 'inkSurface',
                        border: '1px solid inkBorder'
                    }
                }
            },
            // ─── SYNC SETTINGS ──────────────────
            SyncSection: {
                flow: 'y',
                gap: 'Z',
                show: (el, s)=>s.root.integrationModal?.status === 'connected',
                SyncTitle: {
                    text: '{{ syncSettings | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'inkText',
                    margin: '- - Y -'
                },
                SyncFrequency: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'Z',
                    round: 'Y',
                    background: 'inkSurface',
                    border: '1px solid inkBorder',
                    FreqLabel: {
                        text: '{{ syncFrequency | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkText'
                    },
                    FreqValue: {
                        tag: 'select',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        color: 'inkText',
                        fontSize: 'Y',
                        Opt1: {
                            tag: 'option',
                            text: '{{ every5Minutes | polyglot }}'
                        },
                        Opt2: {
                            tag: 'option',
                            text: '{{ every15Minutes | polyglot }}'
                        },
                        Opt3: {
                            tag: 'option',
                            text: '{{ everyHour | polyglot }}'
                        },
                        Opt4: {
                            tag: 'option',
                            text: '{{ manualOnly | polyglot }}'
                        }
                    }
                },
                AutoSync: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'Z',
                    round: 'Y',
                    background: 'inkSurface',
                    border: '1px solid inkBorder',
                    AutoLabel: {
                        text: '{{ autosyncOnChanges | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkText'
                    },
                    AutoToggle: {
                        tag: 'input',
                        attr: {
                            type: 'checkbox',
                            checked: true
                        },
                        width: 'Z',
                        height: 'Z'
                    }
                },
                LastSyncInfo: {
                    flow: 'x',
                    align: 'center space-between',
                    padding: 'Z',
                    round: 'Y',
                    background: 'inkSurface',
                    border: '1px solid inkBorder',
                    SyncLabel: {
                        text: '{{ lastSynced | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    },
                    SyncTime: {
                        text: '2 minutes ago',
                        fontSize: 'Z',
                        color: 'green',
                        fontWeight: '500'
                    }
                }
            },
            // ─── ACTIONS ────────────────────────
            ModalActions: {
                flow: 'x',
                gap: 'Z',
                align: 'center flex-end',
                marginTop: 'Z',
                DisconnectBtn: {
                    tag: 'button',
                    show: (el, s)=>s.root.integrationModal?.status === 'connected',
                    text: '{{ disconnect | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'Y',
                    background: 'transparent',
                    color: 'red',
                    border: '1px solid red',
                    cursor: 'pointer',
                    transition: 'all 150ms ease',
                    ':hover': {
                        background: 'red.08'
                    }
                },
                TestBtn: {
                    tag: 'button',
                    text: '{{ testConnection | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'Y',
                    background: 'inkSurface',
                    color: 'inkText',
                    border: '1px solid inkBorder',
                    cursor: 'pointer',
                    transition: 'all 150ms ease',
                    ':hover': {
                        background: 'inkMid'
                    }
                },
                SaveBtn: {
                    tag: 'button',
                    text: (el, s)=>s.root.integrationModal?.status === 'connected' ? 'Save Changes' : 'Install & Connect',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'Y',
                    background: 'inkText',
                    color: 'inkMid',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'opacity 150ms ease',
                    ':hover': {
                        opacity: '0.8'
                    },
                    on: {
                        click: (e, el, s)=>s.root.update({
                                integrationModal: {
                                    open: false
                                }
                            })
                    }
                }
            }
        }
    }
};


const $087ae3a5e9d9d71b$export$7f740c0bb80e297e = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'finance'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            PageHeader: {
                flow: 'x',
                align: 'center space-between',
                marginBottom: 'Z',
                TitleWrap: {
                    flow: 'y',
                    gap: 'Y',
                    PageTitle: {
                        tag: 'h1',
                        text: '{{ finance | polyglot }}',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'inkText',
                        letterSpacing: '-0.02em'
                    },
                    PageSubtitle: {
                        text: '{{ revenueInvoicesPayments | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    }
                },
                ExportBtn: {
                    tag: 'button',
                    text: '{{ exportReport | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    background: 'inkSurface',
                    color: 'inkText',
                    border: '1px solid inkBorder',
                    cursor: 'pointer',
                    transition: 'all 150ms ease',
                    ':hover': {
                        background: 'inkMid'
                    }
                }
            },
            FinanceStatsRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                '@mobileL': {
                    flow: 'y'
                },
                StatMonthly: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'E',
                    StatLabel: {
                        text: '{{ monthlyRevenue | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        fontWeight: '500'
                    },
                    StatValue: {
                        text: '{{ u20be12400 | polyglot }}',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'teal',
                        letterSpacing: '-0.02em'
                    },
                    StatTrend: {
                        text: '+18%',
                        fontSize: 'Y',
                        color: 'green',
                        fontWeight: '600'
                    }
                },
                StatPending: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'E',
                    StatLabel: {
                        text: '{{ pending | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        fontWeight: '500'
                    },
                    StatValue: {
                        text: '{{ u20be2100 | polyglot }}',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'amber',
                        letterSpacing: '-0.02em'
                    },
                    StatTrend: {
                        text: '{{ str208 | polyglot }}',
                        fontSize: 'Y',
                        color: 'green',
                        fontWeight: '600'
                    }
                },
                StatWeek: {
                    flow: 'y',
                    gap: 'Z',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'E',
                    StatLabel: {
                        text: '{{ thisWeek | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted',
                        fontWeight: '500'
                    },
                    StatValue: {
                        text: '{{ u20be3800 | polyglot }}',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'teal',
                        letterSpacing: '-0.02em'
                    }
                }
            },
            ChartSection: {
                flow: 'y',
                gap: 'A',
                padding: 'B',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                ChartTitle: {
                    tag: 'h3',
                    text: '{{ weeklyRevenue | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                ChartBars: {
                    flow: 'x',
                    align: 'flex-end center',
                    gap: 'Z',
                    height: 'F',
                    padding: 'A 0',
                    BarMon: {
                        flow: 'y',
                        align: 'center flex-end',
                        flex: '1',
                        gap: 'Y',
                        BarFill: {
                            background: '#0D1117',
                            width: '100%',
                            height: '40%',
                            round: 'X X 0 0'
                        },
                        BarLabel: {
                            text: '{{ mon2 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    BarTue: {
                        flow: 'y',
                        align: 'center flex-end',
                        flex: '1',
                        gap: 'Y',
                        BarFill: {
                            background: '#0D1117',
                            width: '100%',
                            height: '55%',
                            round: 'X X 0 0'
                        },
                        BarLabel: {
                            text: '{{ tue2 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    BarWed: {
                        flow: 'y',
                        align: 'center flex-end',
                        flex: '1',
                        gap: 'Y',
                        BarFill: {
                            background: '#0D1117',
                            width: '100%',
                            height: '48%',
                            round: 'X X 0 0'
                        },
                        BarLabel: {
                            text: '{{ wed2 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    BarThu: {
                        flow: 'y',
                        align: 'center flex-end',
                        flex: '1',
                        gap: 'Y',
                        BarFill: {
                            background: '#0D1117',
                            width: '100%',
                            height: '62%',
                            round: 'X X 0 0'
                        },
                        BarLabel: {
                            text: '{{ thu2 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    BarFri: {
                        flow: 'y',
                        align: 'center flex-end',
                        flex: '1',
                        gap: 'Y',
                        BarFill: {
                            background: '#0D1117',
                            width: '100%',
                            height: '75%',
                            round: 'X X 0 0'
                        },
                        BarLabel: {
                            text: '{{ fri2 | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    BarSat: {
                        flow: 'y',
                        align: 'center flex-end',
                        flex: '1',
                        gap: 'Y',
                        BarFill: {
                            background: '#0D1117',
                            width: '100%',
                            height: '90%',
                            round: 'X X 0 0'
                        },
                        BarLabel: {
                            text: '{{ sat2 | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '700',
                            color: 'inkText'
                        }
                    }
                }
            },
            InvoiceSection: {
                flow: 'y',
                gap: 'Z',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                overflow: 'hidden',
                InvoiceHeader: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    background: 'inkSurface',
                    ColInv: {
                        text: '{{ invoice | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em'
                    },
                    ColPat: {
                        text: '{{ patient | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em'
                    },
                    ColSvc: {
                        text: '{{ service | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em'
                    },
                    ColAmt: {
                        text: '{{ amount | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        textAlign: 'right'
                    },
                    ColSts: {
                        text: '{{ status2 | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkMuted',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        textAlign: 'right'
                    }
                },
                InvRow1: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    align: 'center',
                    InvNum: {
                        text: '{{ inv001 | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkSubtle'
                    },
                    InvPat: {
                        text: '{{ giorgiBeridze | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkText'
                    },
                    InvSvc: {
                        text: '{{ checkupXray | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    },
                    InvAmt: {
                        text: '{{ u20be80 | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'inkText',
                        textAlign: 'right'
                    },
                    InvSts: {
                        extends: 'StatusBadge',
                        state: {
                            status: 'Paid'
                        }
                    }
                },
                InvRow2: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    align: 'center',
                    InvNum: {
                        text: '{{ inv002 | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkSubtle'
                    },
                    InvPat: {
                        text: '{{ ninoKapanadze | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkText'
                    },
                    InvSvc: {
                        text: '{{ whitening | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    },
                    InvAmt: {
                        text: '{{ u20be120 | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'inkText',
                        textAlign: 'right'
                    },
                    InvSts: {
                        extends: 'StatusBadge',
                        state: {
                            status: 'Pending'
                        }
                    }
                },
                InvRow3: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
                    padding: 'Z A',
                    borderBottom: '1px solid inkBorder',
                    align: 'center',
                    InvNum: {
                        text: '{{ inv003 | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkSubtle'
                    },
                    InvPat: {
                        text: '{{ davitGelashvili | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkText'
                    },
                    InvSvc: {
                        text: '{{ implantPhase1 | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    },
                    InvAmt: {
                        text: '{{ u20be300 | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'inkText',
                        textAlign: 'right'
                    },
                    InvSts: {
                        extends: 'StatusBadge',
                        state: {
                            status: 'Paid'
                        }
                    }
                },
                InvRow4: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 2fr 2fr 1fr 80px',
                    padding: 'Z A',
                    align: 'center',
                    InvNum: {
                        text: '{{ inv004 | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkSubtle'
                    },
                    InvPat: {
                        text: '{{ anaJavakhishvili | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkText'
                    },
                    InvSvc: {
                        text: '{{ rootCanal | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    },
                    InvAmt: {
                        text: '{{ u20be149 | polyglot }}',
                        fontSize: 'Z',
                        fontWeight: '600',
                        color: 'inkText',
                        textAlign: 'right'
                    },
                    InvSts: {
                        extends: 'StatusBadge',
                        state: {
                            status: 'Overdue'
                        }
                    }
                }
            }
        }
    }
};


const $386b39b9d06f3a9f$export$6c9e2d66dea2a302 = {
    extends: 'Page',
    flow: 'y',
    align: 'center center',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    overflow: 'hidden',
    state: {
        slide: 0
    },
    SlideWrapper: {
        flow: 'y',
        align: 'center center',
        width: '100%',
        flex: '1',
        position: 'relative',
        SlideCover: {
            show: (el, s)=>s.slide === 0,
            flow: 'y',
            align: 'center center',
            gap: 'A',
            padding: 'C B',
            textAlign: 'center',
            width: '100%',
            SlideNumber: {
                text: '01 / 08',
                fontSize: 'Y',
                color: 'inkMuted',
                letterSpacing: '2px'
            },
            TitleGeorgian: {
                tag: 'h1',
                text: '{{ dcai | polyglot }}',
                fontSize: 'E',
                fontWeight: '800',
                color: 'inkText',
                lineHeight: '1'
            },
            TitleEnglish: {
                tag: 'h2',
                text: '{{ dentalBookingOpsPlatform | polyglot }}',
                fontSize: 'C',
                fontWeight: '300',
                color: 'teal'
            },
            Subtitle: {
                text: '{{ theMissingInfrastructureFor | polyglot }}',
                fontSize: 'A2',
                color: 'inkSubtle',
                maxWidth: 'H',
                marginTop: 'A'
            },
            TagRow: {
                flow: 'x',
                gap: 'A',
                align: 'center center',
                marginTop: 'B',
                TagBook: {
                    tag: 'span',
                    text: '{{ book | polyglot }}',
                    padding: 'X B',
                    round: 'Z',
                    background: 'teal',
                    color: 'ink',
                    fontWeight: '700',
                    fontSize: 'Z2'
                },
                TagManage: {
                    tag: 'span',
                    text: '{{ manage | polyglot }}',
                    padding: 'X B',
                    round: 'Z',
                    background: 'tealLight',
                    color: 'tealDark',
                    fontWeight: '700',
                    fontSize: 'Z2',
                    border: '1px solid',
                    borderColor: 'primary'
                },
                TagGrow: {
                    tag: 'span',
                    text: '{{ grow | polyglot }}',
                    padding: 'X B',
                    round: 'Z',
                    background: 'tealLight',
                    color: 'tealDark',
                    fontWeight: '700',
                    fontSize: 'Z2',
                    border: '1px solid',
                    borderColor: 'primary'
                }
            }
        },
        SlideMarket: {
            show: (el, s)=>s.slide === 1,
            flow: 'y',
            gap: 'B',
            padding: 'C B',
            maxWidth: 'J',
            width: '100%',
            SlideNumber: {
                text: '02 / 08',
                fontSize: 'Y',
                color: 'inkMuted',
                letterSpacing: '2px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ marketSize | polyglot }}',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                marginBottom: 'A'
            },
            StatsRow: {
                flow: 'x',
                gap: 'B',
                '@tabletS': {
                    flow: 'y'
                },
                StatTotal: {
                    flow: 'y',
                    flex: '1',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    gap: 'Y',
                    StatNumber: {
                        text: "600\u20131,000",
                        fontSize: 'D',
                        fontWeight: '800',
                        color: 'teal'
                    },
                    StatLabel: {
                        text: '{{ dentalClinicsInGeorgia | polyglot }}',
                        fontSize: 'Z2',
                        color: 'inkSubtle'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                StatTbilisi: {
                    flow: 'y',
                    flex: '1',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    gap: 'Y',
                    StatNumber: {
                        text: "400\u2013600",
                        fontSize: 'D',
                        fontWeight: '800',
                        color: 'teal'
                    },
                    StatLabel: {
                        text: '{{ inTbilisiAlone | polyglot }}',
                        fontSize: 'Z2',
                        color: 'inkSubtle'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                StatPlatforms: {
                    flow: 'y',
                    flex: '1',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    gap: 'Y',
                    StatNumber: {
                        text: '0',
                        fontSize: 'D',
                        fontWeight: '800',
                        color: 'amber'
                    },
                    StatLabel: {
                        text: '{{ unifiedBookingOrOps | polyglot }}',
                        fontSize: 'Z2',
                        color: 'inkSubtle'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                }
            },
            IncumbentNote: {
                padding: 'A',
                round: 'Z',
                background: 'inkSurface',
                border: '1px solid',
                borderColor: 'inkBorder',
                NoteText: {
                    text: '{{ dentosgeIsTheOnly | polyglot }}',
                    fontSize: 'Z2',
                    color: 'inkMuted'
                }
            }
        },
        SlideProblem: {
            show: (el, s)=>s.slide === 2,
            flow: 'y',
            gap: 'B',
            padding: 'C B',
            maxWidth: 'J',
            width: '100%',
            SlideNumber: {
                text: '03 / 08',
                fontSize: 'Y',
                color: 'inkMuted',
                letterSpacing: '2px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ theProblem | polyglot }}',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                marginBottom: 'A'
            },
            ProblemList: {
                flow: 'y',
                gap: 'A',
                ProblemExcel: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    ProblemEmoji: {
                        text: "\uD83D\uDCCB",
                        fontSize: 'B'
                    },
                    ProblemContent: {
                        flow: 'y',
                        gap: 'X',
                        ProblemHeading: {
                            text: '{{ clinicsRunOnExcel | polyglot }}',
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ProblemDetail: {
                            text: '{{ noStructuredWorkflowConstant | polyglot }}',
                            color: 'inkMuted',
                            fontSize: 'Z2'
                        }
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                ProblemNoShows: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    ProblemEmoji: {
                        text: "\uD83D\uDCC9",
                        fontSize: 'B'
                    },
                    ProblemContent: {
                        flow: 'y',
                        gap: 'X',
                        ProblemHeading: {
                            text: '{{ noshowsCost1525Of | polyglot }}',
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ProblemDetail: {
                            text: '{{ noAutomatedRemindersOr | polyglot }}',
                            color: 'inkMuted',
                            fontSize: 'Z2'
                        }
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                ProblemInsurance: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    ProblemEmoji: {
                        text: "\uD83C\uDFE6",
                        fontSize: 'B'
                    },
                    ProblemContent: {
                        flow: 'y',
                        gap: 'X',
                        ProblemHeading: {
                            text: '{{ insuranceBillingIsManual | polyglot }}',
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ProblemDetail: {
                            text: "Aldagi, GPI, Imedi L \u2014 all handled via phone and paper forms",
                            color: 'inkMuted',
                            fontSize: 'Z2'
                        }
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                ProblemBooking: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    ProblemEmoji: {
                        text: "\uD83D\uDCF5",
                        fontSize: 'B'
                    },
                    ProblemContent: {
                        flow: 'y',
                        gap: 'X',
                        ProblemHeading: {
                            text: `Patients can't book online 24/7`,
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ProblemDetail: {
                            text: '{{ dentalTourismPatientsEspeciall | polyglot }}',
                            color: 'inkMuted',
                            fontSize: 'Z2'
                        }
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                }
            }
        },
        SlideSolution: {
            show: (el, s)=>s.slide === 3,
            flow: 'y',
            gap: 'B',
            padding: 'C B',
            maxWidth: 'J',
            width: '100%',
            SlideNumber: {
                text: '04 / 08',
                fontSize: 'Y',
                color: 'inkMuted',
                letterSpacing: '2px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ theSolution | polyglot }}',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                marginBottom: 'A'
            },
            SolutionGrid: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                SolutionBooking: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    flex: '1',
                    minWidth: 'G',
                    SolutionEmoji: {
                        text: "\uD83D\uDCC5",
                        fontSize: 'B'
                    },
                    SolutionHeading: {
                        text: '{{ onlineBookingWidgetMarketplace | polyglot }}',
                        fontWeight: '600',
                        color: 'inkText',
                        fontSize: 'Z2'
                    },
                    SolutionDetail: {
                        text: '{{ patientsBook247From | polyglot }}',
                        color: 'inkMuted',
                        fontSize: 'Y'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                SolutionRecords: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    flex: '1',
                    minWidth: 'G',
                    SolutionEmoji: {
                        text: "\uD83E\uDDB7",
                        fontSize: 'B'
                    },
                    SolutionHeading: {
                        text: '{{ patientRecordsTreatmentManagem | polyglot }}',
                        fontWeight: '600',
                        color: 'inkText',
                        fontSize: 'Z2'
                    },
                    SolutionDetail: {
                        text: '{{ fullHistoryTreatmentPlans | polyglot }}',
                        color: 'inkMuted',
                        fontSize: 'Y'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                SolutionInsurance: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    flex: '1',
                    minWidth: 'G',
                    SolutionEmoji: {
                        text: "\uD83C\uDFE5",
                        fontSize: 'B'
                    },
                    SolutionHeading: {
                        text: '{{ insuranceIntegrations | polyglot }}',
                        fontWeight: '600',
                        color: 'inkText',
                        fontSize: 'Z2'
                    },
                    SolutionDetail: {
                        text: "Aldagi, GPI, Imedi L \u2014 automated",
                        color: 'inkMuted',
                        fontSize: 'Y'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                SolutionReminders: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    flex: '1',
                    minWidth: 'G',
                    SolutionEmoji: {
                        text: "\uD83D\uDCAC",
                        fontSize: 'B'
                    },
                    SolutionHeading: {
                        text: '{{ smsWhatsappReminders | polyglot }}',
                        fontWeight: '600',
                        color: 'inkText',
                        fontSize: 'Z2'
                    },
                    SolutionDetail: {
                        text: '{{ cutNoshowsByUp | polyglot }}',
                        color: 'inkMuted',
                        fontSize: 'Y'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                SolutionFinance: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    flex: '1',
                    minWidth: 'G',
                    SolutionEmoji: {
                        text: "\uD83D\uDCCA",
                        fontSize: 'B'
                    },
                    SolutionHeading: {
                        text: '{{ financialReportingDashboard | polyglot }}',
                        fontWeight: '600',
                        color: 'inkText',
                        fontSize: 'Z2'
                    },
                    SolutionDetail: {
                        text: '{{ revenueSalariesExpensesRealtim | polyglot }}',
                        color: 'inkMuted',
                        fontSize: 'Y'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                }
            }
        },
        SlidePricing: {
            show: (el, s)=>s.slide === 4,
            flow: 'y',
            gap: 'B',
            padding: 'C B',
            maxWidth: 'J',
            width: '100%',
            SlideNumber: {
                text: '05 / 08',
                fontSize: 'Y',
                color: 'inkMuted',
                letterSpacing: '2px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ willingnessToPay | polyglot }}',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                marginBottom: 'A'
            },
            PricingRow: {
                flow: 'x',
                gap: 'A',
                '@tabletS': {
                    flow: 'y'
                },
                PricingFree: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    flex: '1',
                    PricingTier: {
                        text: '{{ free | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '700',
                        color: 'inkMuted',
                        letterSpacing: '2px',
                        textTransform: 'uppercase'
                    },
                    PricingAmount: {
                        text: "\u20BE0",
                        fontSize: 'C',
                        fontWeight: '800',
                        color: 'inkText'
                    },
                    PricingPeriod: {
                        text: '{{ month | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    },
                    PricingDescription: {
                        text: '{{ listingBookingWidget | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        marginTop: 'Y'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                PricingGrowth: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'inkSurface',
                    border: '1px solid',
                    borderColor: 'teal',
                    flex: '1',
                    PricingTier: {
                        text: '{{ growth | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '700',
                        color: 'teal',
                        letterSpacing: '2px',
                        textTransform: 'uppercase'
                    },
                    PricingAmount: {
                        text: "\u20BE49",
                        fontSize: 'C',
                        fontWeight: '800',
                        color: 'inkText'
                    },
                    PricingPeriod: {
                        text: '{{ month | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    },
                    PricingDescription: {
                        text: '{{ calendarRemindersPatientCards | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        marginTop: 'Y'
                    }
                },
                PricingPro: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'teal',
                    flex: '1',
                    PricingTier: {
                        text: '{{ pro | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '700',
                        color: 'ink',
                        letterSpacing: '2px',
                        textTransform: 'uppercase'
                    },
                    PricingAmount: {
                        text: "\u20BE149",
                        fontSize: 'C',
                        fontWeight: '800',
                        color: 'ink'
                    },
                    PricingPeriod: {
                        text: '{{ month | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMid'
                    },
                    PricingDescription: {
                        text: '{{ fullOpsInsuranceAnalytics | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMid',
                        marginTop: 'Y'
                    },
                    border: '1px solid',
                    borderColor: 'tealDark'
                },
                PricingEnterprise: {
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    flex: '1',
                    PricingTier: {
                        text: '{{ navEnterprise | polyglot }}',
                        fontSize: 'Y',
                        fontWeight: '700',
                        color: 'inkMuted',
                        letterSpacing: '2px',
                        textTransform: 'uppercase'
                    },
                    PricingAmount: {
                        text: "\u20BE300+",
                        fontSize: 'C',
                        fontWeight: '800',
                        color: 'inkText'
                    },
                    PricingPeriod: {
                        text: '{{ month | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    },
                    PricingDescription: {
                        text: '{{ multibranchApiAccessReporting | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        marginTop: 'Y'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                }
            },
            PricingNote: {
                text: '{{ wtp0515OfMonthly | polyglot }}',
                fontSize: 'Y',
                color: 'inkMuted',
                textAlign: 'center',
                marginTop: 'A'
            }
        },
        SlideOpportunity: {
            show: (el, s)=>s.slide === 5,
            flow: 'y',
            gap: 'B',
            padding: 'C B',
            maxWidth: 'J',
            width: '100%',
            SlideNumber: {
                text: '06 / 08',
                fontSize: 'Y',
                color: 'inkMuted',
                letterSpacing: '2px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ marketOpportunity | polyglot }}',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                marginBottom: 'A'
            },
            OpportunityRow: {
                flow: 'x',
                gap: 'B',
                '@tabletS': {
                    flow: 'y'
                },
                OpportunityClinics: {
                    flow: 'y',
                    flex: '1',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    gap: 'Y',
                    OpportunityNumber: {
                        text: '300',
                        fontSize: 'D',
                        fontWeight: '800',
                        color: 'teal'
                    },
                    OpportunityLabel: {
                        text: '{{ addressableClinicsAtLaunch | polyglot }}',
                        color: 'inkSubtle',
                        fontSize: 'Z2'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                OpportunityMrr: {
                    flow: 'y',
                    flex: '1',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    gap: 'Y',
                    OpportunityNumber: {
                        text: "\u20BE45K",
                        fontSize: 'D',
                        fontWeight: '800',
                        color: 'teal'
                    },
                    OpportunityLabel: {
                        text: '{{ mrrAtFullPenetration | polyglot }}',
                        color: 'inkSubtle',
                        fontSize: 'Z2'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                OpportunityUsd: {
                    flow: 'y',
                    flex: '1',
                    padding: 'B',
                    round: 'A',
                    background: 'inkMid',
                    gap: 'Y',
                    OpportunityNumber: {
                        text: '$16K',
                        fontSize: 'D',
                        fontWeight: '800',
                        color: 'teal'
                    },
                    OpportunityLabel: {
                        text: '{{ initialMrrCeilingUsd | polyglot }}',
                        color: 'inkSubtle',
                        fontSize: 'Z2'
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                }
            },
            ExpansionNote: {
                padding: 'A',
                round: 'Z',
                background: 'inkSurface',
                border: '1px solid',
                borderColor: 'inkBorder',
                ExpansionText: {
                    text: '{{ nextExpansionArmeniaAzerbaijan | polyglot }}',
                    fontSize: 'Z2',
                    color: 'inkMuted'
                }
            }
        },
        SlideWhyNow: {
            show: (el, s)=>s.slide === 6,
            flow: 'y',
            gap: 'B',
            padding: 'C B',
            maxWidth: 'J',
            width: '100%',
            SlideNumber: {
                text: '07 / 08',
                fontSize: 'Y',
                color: 'inkMuted',
                letterSpacing: '2px'
            },
            SlideTitle: {
                tag: 'h2',
                text: '{{ whyNow | polyglot }}',
                fontSize: 'D',
                fontWeight: '800',
                color: 'inkText',
                marginBottom: 'A'
            },
            ReasonList: {
                flow: 'y',
                gap: 'A',
                ReasonTourism: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    ReasonEmoji: {
                        text: "\u2708\uFE0F",
                        fontSize: 'B'
                    },
                    ReasonContent: {
                        flow: 'y',
                        gap: 'X',
                        ReasonHeading: {
                            text: '{{ dentalTourismBoom | polyglot }}',
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ReasonDetail: {
                            text: '{{ internationalPatientsNeedEngli | polyglot }}',
                            color: 'inkMuted',
                            fontSize: 'Z2'
                        }
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                ReasonDigital: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    ReasonEmoji: {
                        text: "\uD83D\uDCF1",
                        fontSize: 'B'
                    },
                    ReasonContent: {
                        flow: 'y',
                        gap: 'X',
                        ReasonHeading: {
                            text: '{{ postcovidDigitizationPressure | polyglot }}',
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ReasonDetail: {
                            text: '{{ clinicsThatSurvivedAre | polyglot }}',
                            color: 'inkMuted',
                            fontSize: 'Z2'
                        }
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                ReasonIncumbent: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    ReasonEmoji: {
                        text: "\uD83C\uDFC6",
                        fontSize: 'B'
                    },
                    ReasonContent: {
                        flow: 'y',
                        gap: 'X',
                        ReasonHeading: {
                            text: '{{ noStrongLocalIncumbent | polyglot }}',
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ReasonDetail: {
                            text: '{{ dentosgeOnlyCoversDiscovery | polyglot }}',
                            color: 'inkMuted',
                            fontSize: 'Z2'
                        }
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                },
                ReasonHub: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    ReasonEmoji: {
                        text: '{{ str570 | polyglot }}',
                        fontSize: 'B'
                    },
                    ReasonContent: {
                        flow: 'y',
                        gap: 'X',
                        ReasonHeading: {
                            text: '{{ georgiaIsAHealthcare | polyglot }}',
                            fontWeight: '600',
                            color: 'inkText'
                        },
                        ReasonDetail: {
                            text: '{{ lowCostHighQuality | polyglot }}',
                            color: 'inkMuted',
                            fontSize: 'Z2'
                        }
                    },
                    border: '1px solid',
                    borderColor: 'inkBorder'
                }
            }
        },
        SlideCta: {
            show: (el, s)=>s.slide === 7,
            flow: 'y',
            align: 'center center',
            gap: 'B',
            padding: 'C B',
            textAlign: 'center',
            width: '100%',
            SlideNumber: {
                text: '08 / 08',
                fontSize: 'Y',
                color: 'inkMuted',
                letterSpacing: '2px'
            },
            CtaTitle: {
                tag: 'h2',
                text: `Let's Build It`,
                fontSize: 'E',
                fontWeight: '800',
                color: 'inkText'
            },
            CtaSubtitle: {
                text: '{{ joinThePartnerClinic | polyglot }}',
                fontSize: 'A2',
                color: 'teal',
                fontWeight: '600'
            },
            CtaDescription: {
                text: `We're onboarding founding clinics to shape the product. No commitment. Full white-glove setup.`,
                fontSize: 'A',
                color: 'inkSubtle',
                maxWidth: 'H',
                lineHeight: '1.6'
            },
            CtaContact: {
                flow: 'y',
                align: 'center center',
                gap: 'Y',
                marginTop: 'A',
                CtaEmail: {
                    text: 'hello@dental.ge',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'teal'
                },
                CtaTagline: {
                    tag: 'span',
                    text: '{{ builtForGeorgianClinics | polyglot }}',
                    fontSize: 'Z2',
                    color: 'inkMuted'
                }
            }
        }
    },
    SlideNav: {
        flow: 'x',
        align: 'center space-between',
        padding: 'A B',
        width: '100%',
        PrevButton: {
            extends: 'Button',
            text: '{{ prev | polyglot }}',
            theme: 'dialog',
            padding: 'Y A',
            round: 'Z',
            show: (el, s)=>s.slide > 0,
            onClick: (e, el, s)=>s.update({
                    slide: s.slide - 1
                })
        },
        DotIndicators: {
            flow: 'x',
            gap: 'Y',
            align: 'center center',
            DotOne: {
                tag: 'span',
                boxSize: 'Y',
                round: '100%',
                cursor: 'pointer',
                background: (el, s)=>s.slide === 0 ? 'teal' : 'inkBorder',
                onClick: (e, el, s)=>s.update({
                        slide: 0
                    })
            },
            DotTwo: {
                tag: 'span',
                boxSize: 'Y',
                round: '100%',
                cursor: 'pointer',
                background: (el, s)=>s.slide === 1 ? 'teal' : 'inkBorder',
                onClick: (e, el, s)=>s.update({
                        slide: 1
                    })
            },
            DotThree: {
                tag: 'span',
                boxSize: 'Y',
                round: '100%',
                cursor: 'pointer',
                background: (el, s)=>s.slide === 2 ? 'teal' : 'inkBorder',
                onClick: (e, el, s)=>s.update({
                        slide: 2
                    })
            },
            DotFour: {
                tag: 'span',
                boxSize: 'Y',
                round: '100%',
                cursor: 'pointer',
                background: (el, s)=>s.slide === 3 ? 'teal' : 'inkBorder',
                onClick: (e, el, s)=>s.update({
                        slide: 3
                    })
            },
            DotFive: {
                tag: 'span',
                boxSize: 'Y',
                round: '100%',
                cursor: 'pointer',
                background: (el, s)=>s.slide === 4 ? 'teal' : 'inkBorder',
                onClick: (e, el, s)=>s.update({
                        slide: 4
                    })
            },
            DotSix: {
                tag: 'span',
                boxSize: 'Y',
                round: '100%',
                cursor: 'pointer',
                background: (el, s)=>s.slide === 5 ? 'teal' : 'inkBorder',
                onClick: (e, el, s)=>s.update({
                        slide: 5
                    })
            },
            DotSeven: {
                tag: 'span',
                boxSize: 'Y',
                round: '100%',
                cursor: 'pointer',
                background: (el, s)=>s.slide === 6 ? 'teal' : 'inkBorder',
                onClick: (e, el, s)=>s.update({
                        slide: 6
                    })
            },
            DotEight: {
                tag: 'span',
                boxSize: 'Y',
                round: '100%',
                cursor: 'pointer',
                background: (el, s)=>s.slide === 7 ? 'teal' : 'inkBorder',
                onClick: (e, el, s)=>s.update({
                        slide: 7
                    })
            }
        },
        NextButton: {
            extends: 'Button',
            text: '{{ next2 | polyglot }}',
            theme: 'primary',
            padding: 'Y A',
            round: 'Z',
            show: (el, s)=>s.slide < 7,
            onClick: (e, el, s)=>s.update({
                    slide: s.slide + 1
                })
        },
        FinishButton: {
            extends: 'Button',
            text: '{{ getInTouch | polyglot }}',
            theme: 'primary',
            padding: 'Y A',
            round: 'Z',
            show: (el, s)=>s.slide === 7,
            onClick: (e, el, s)=>s.update({
                    slide: 0
                })
        }
    }
};


const $8f52cbf804c46fad$export$530dccc8e24f4e99 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'chat',
                            activeChatChannel: s.root.activeChatChannel || 'cabinet-1'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    ChatSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'hidden',
        height: '100vh',
        TopBar: {},
        ChannelHeader: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z A',
            borderBottom: '1px solid inkBorder',
            background: 'inkMid',
            ChannelName: {
                flow: 'x',
                gap: 'Y',
                align: 'center flex-start',
                Hash: {
                    text: '#',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'teal'
                },
                Name: {
                    text: (el, s)=>{
                        const ch = s.root.activeChatChannel || 'cabinet-1';
                        const names = {
                            'cabinet-1': 'Cabinet 1',
                            'cabinet-2': 'Cabinet 2',
                            'reception': 'Reception',
                            'doctors': 'Doctors',
                            'management': 'Management',
                            'general': 'General',
                            'dm-kvaratskhelia': 'Dr. Kvaratskhelia',
                            'dm-beridze': 'Dr. Beridze',
                            'dm-nino': 'Hygienist Nino'
                        };
                        return names[ch] || ch;
                    },
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'inkText'
                }
            },
            MemberCount: {
                text: '6 Members',
                fontSize: 'Y',
                color: 'inkMuted'
            }
        },
        MessageThread: {
            flow: 'y',
            gap: '0',
            flex: '1',
            overflow: 'auto',
            background: 'inkSurface',
            // ─── SAMPLE MESSAGES ─────────────────────────
            Msg1: {
                extends: 'ChatMessage',
                state: {
                    initials: 'GK',
                    avatarColor: 'teal.15',
                    avatarTextColor: 'teal',
                    sender: 'Dr. Kvaratskhelia',
                    timestamp: '09:12',
                    text: 'Cabinet 1 is ready for the crown prep. Patient Kapanadze has arrived and is in the chair.',
                    status: 'read',
                    urgency: 'normal'
                }
            },
            Msg2: {
                extends: 'ChatMessage',
                state: {
                    initials: 'NT',
                    avatarColor: 'amber.15',
                    avatarTextColor: 'amber',
                    sender: 'Hygienist Nino',
                    timestamp: '09:15',
                    text: "X-rays are uploaded to the chart. Periapical on #14 shows slight radiolucency \u2014 please review before proceeding.",
                    status: 'read',
                    urgency: 'important'
                }
            },
            Msg3: {
                extends: 'ChatMessage',
                state: {
                    initials: 'NB',
                    avatarColor: 'purple.15',
                    avatarTextColor: 'purple',
                    sender: 'Dr. Beridze',
                    timestamp: '09:18',
                    text: 'I can see it on the PA. Looks like a small periapical lesion. Recommend vitality test before crown prep. May need endo consult.',
                    status: 'delivered',
                    urgency: 'normal'
                }
            },
            Msg4: {
                extends: 'ChatMessage',
                state: {
                    initials: 'MR',
                    avatarColor: 'blue.15',
                    avatarTextColor: 'blue',
                    sender: 'Maria (Reception)',
                    timestamp: '09:22',
                    text: "Patient in Cabinet 2 just called \u2014 running 15 minutes late. Should I adjust the schedule?",
                    status: 'read',
                    urgency: 'normal'
                }
            },
            Msg5: {
                extends: 'ChatMessage',
                state: {
                    initials: 'GK',
                    avatarColor: 'teal.15',
                    avatarTextColor: 'teal',
                    sender: 'Dr. Kvaratskhelia',
                    timestamp: '09:24',
                    text: "Yes, push Cabinet 2 back 15 min. Also \u2014 we need the endo kit in Cabinet 1 ASAP. Vitality test is negative on #14.",
                    status: 'delivered',
                    urgency: 'urgent'
                }
            },
            Msg6: {
                extends: 'ChatMessage',
                state: {
                    initials: 'NT',
                    avatarColor: 'amber.15',
                    avatarTextColor: 'amber',
                    sender: 'Hygienist Nino',
                    timestamp: '09:26',
                    text: 'Endo kit on its way. I will prep the rubber dam setup as well.',
                    status: 'sent',
                    urgency: 'normal'
                }
            },
            Msg7: {
                extends: 'ChatMessage',
                state: {
                    initials: 'NB',
                    avatarColor: 'purple.15',
                    avatarTextColor: 'purple',
                    sender: 'Dr. Beridze',
                    timestamp: '09:30',
                    text: 'I can take over Cabinet 2 while you handle the endo. My 10:00 just cancelled.',
                    status: 'read',
                    urgency: 'normal'
                }
            }
        },
        ChatInput: {}
    }
};


const $f2a44cce6d451de2$var$SAMPLE_CONSENTS = [
    {
        treatmentName: "Root Canal \u2014 Tooth #14",
        patientName: 'Giorgi Beridze',
        consentStatus: 'Signed',
        dateSigned: 'Mar 15, 2026'
    },
    {
        treatmentName: "Crown Placement \u2014 Tooth #30",
        patientName: 'Nino Kvaratskhelia',
        consentStatus: 'Pending',
        dateSigned: null
    },
    {
        treatmentName: "Implant \u2014 Tooth #19",
        patientName: 'Luka Maisuradze',
        consentStatus: 'Signed',
        dateSigned: 'Mar 10, 2026'
    },
    {
        treatmentName: 'Wisdom Tooth Extraction',
        patientName: 'Ana Tsulukidze',
        consentStatus: 'Expired',
        dateSigned: 'Jan 05, 2026'
    },
    {
        treatmentName: 'Teeth Whitening',
        patientName: 'Davit Janelidze',
        consentStatus: 'Signed',
        dateSigned: 'Mar 18, 2026'
    }
];
const $f2a44cce6d451de2$export$a6dfab0e9e63c404 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'consent',
                            consentView: 'new',
                            consentChecks: {}
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            PageHeader: {
                flow: 'x',
                align: 'center space-between',
                flexWrap: 'wrap',
                gap: 'Z',
                PageTitle: {
                    tag: 'h2',
                    text: '{{ informedConsent | polyglot }}',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'inkText'
                }
            },
            ViewTabs: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                NewConsentTab: {
                    text: '{{ newConsent | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.consentView === 'new' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.consentView === 'new' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            consentView: 'new'
                        })
                },
                HistoryTab: {
                    text: '{{ consentHistory | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.consentView === 'history' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.consentView === 'history' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            consentView: 'history'
                        })
                }
            },
            NewConsentView: {
                if: (el, s)=>s.root.consentView === 'new',
                flow: 'y',
                gap: 'B',
                PatientBanner: {
                    state: {
                        name: 'Giorgi Beridze',
                        age: 34,
                        allergies: [
                            {
                                label: 'Penicillin',
                                severity: 'severe'
                            }
                        ],
                        insurance: 'Aldagi',
                        lastVisit: 'Mar 15, 2026'
                    }
                },
                InformedConsentForm: {
                    state: {
                        treatmentName: "Root Canal Treatment \u2014 Tooth #14"
                    }
                },
                ESignature: {}
            },
            HistoryView: {
                if: (el, s)=>s.root.consentView === 'history',
                flow: 'y',
                gap: 'Z',
                ConsentList: {
                    flow: 'y',
                    gap: 'Z',
                    childExtends: 'ConsentCard',
                    childrenAs: 'state',
                    children: ()=>$f2a44cce6d451de2$var$SAMPLE_CONSENTS
                }
            }
        }
    }
};


const $18e445e8c6d48fa9$export$d2acecc3fc1bf481 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'cabinets'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── PAGE HEADER ─────────────────────────────
            PageHeader: {
                flow: 'x',
                gap: 'A',
                align: 'center space-between',
                flexWrap: 'wrap',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Z'
                },
                LeftSection: {
                    flow: 'y',
                    gap: 'X',
                    Title: {
                        text: '{{ cabinetSchedule | polyglot }}',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    Subtitle: {
                        text: '{{ cabinetScheduleDesc | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    }
                },
                RightControls: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center flex-end',
                    DateNav: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        PrevBtn: {
                            text: '\u2190',
                            fontSize: 'Z',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            cursor: 'pointer'
                        },
                        TodayBtn: {
                            text: '{{ today | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'teal',
                            cursor: 'pointer'
                        },
                        NextBtn: {
                            text: '\u2192',
                            fontSize: 'Z',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            cursor: 'pointer'
                        },
                        DateLabel: {
                            text: 'Mar 19, 2026',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText',
                            marginLeft: 'Y'
                        }
                    }
                }
            },
            // ─── STATUS LEGEND ────────────────────────────
            StatusLegend: {
                flow: 'x',
                gap: 'A',
                marginBottom: 'Y',
                flexWrap: 'wrap',
                Leg1: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center center',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'teal'
                    },
                    Label: {
                        text: '{{ available | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                Leg2: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center center',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'blue'
                    },
                    Label: {
                        text: '{{ occupied | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                Leg3: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center center',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'amber'
                    },
                    Label: {
                        text: '{{ cleaning | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                Leg4: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center center',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'red'
                    },
                    Label: {
                        text: '{{ maintenance | polyglot }}',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                }
            },
            // ─── CABINET COLUMNS ──────────────────────────
            CabinetGrid: {
                flow: 'x',
                gap: 'A',
                overflow: 'auto',
                padding: 'Y 0',
                flex: '1',
                // Cabinet 1 — mostly occupied
                Cabinet1: {
                    extends: 'CabinetColumn',
                    state: {
                        cabinetName: 'Cabinet 1',
                        cabinetStatus: 'in-use'
                    },
                    Slots: {
                        S0900: {
                            state: {
                                time: '09:00',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'T. Kapanadze',
                                procedure: '{{ crownPrep | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S0930: {
                            state: {
                                time: '09:30',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'T. Kapanadze',
                                procedure: '{{ crownPrep | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1000: {
                            state: {
                                time: '10:00',
                                status: 'available',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1030: {
                            state: {
                                time: '10:30',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'M. Tsiklauri',
                                procedure: '{{ compositeF | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1100: {
                            state: {
                                time: '11:00',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'M. Tsiklauri',
                                procedure: '{{ compositeF | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1130: {
                            state: {
                                time: '11:30',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1200: {
                            state: {
                                time: '12:00',
                                status: 'available',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1230: {
                            state: {
                                time: '12:30',
                                status: 'available',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1300: {
                            state: {
                                time: '13:00',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'R. Kharazishvili',
                                procedure: '{{ bridgePrep | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1330: {
                            state: {
                                time: '13:30',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'R. Kharazishvili',
                                procedure: '{{ bridgePrep | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1400: {
                            state: {
                                time: '14:00',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'R. Kharazishvili',
                                procedure: '{{ bridgePrep | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1430: {
                            state: {
                                time: '14:30',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1500: {
                            state: {
                                time: '15:00',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'A. Javakhishvili',
                                procedure: '{{ rootCanal | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1530: {
                            state: {
                                time: '15:30',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'A. Javakhishvili',
                                procedure: '{{ rootCanal | polyglot }}',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1600: {
                            state: {
                                time: '16:00',
                                status: 'available',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1630: {
                            state: {
                                time: '16:30',
                                status: 'available',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1700: {
                            state: {
                                time: '17:00',
                                status: 'available',
                                cabinetName: 'Cabinet 1'
                            }
                        },
                        S1730: {
                            state: {
                                time: '17:30',
                                status: 'available',
                                cabinetName: 'Cabinet 1'
                            }
                        }
                    }
                },
                // Cabinet 2 — mixed schedule
                Cabinet2: {
                    extends: 'CabinetColumn',
                    state: {
                        cabinetName: 'Cabinet 2',
                        cabinetStatus: 'available'
                    },
                    Slots: {
                        S0900: {
                            state: {
                                time: '09:00',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'D. Gelashvili',
                                procedure: '{{ srpQuad | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S0930: {
                            state: {
                                time: '09:30',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'D. Gelashvili',
                                procedure: '{{ srpQuad | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1000: {
                            state: {
                                time: '10:00',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'D. Gelashvili',
                                procedure: '{{ srpQuad | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1030: {
                            state: {
                                time: '10:30',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1100: {
                            state: {
                                time: '11:00',
                                status: 'available',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1130: {
                            state: {
                                time: '11:30',
                                status: 'available',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1200: {
                            state: {
                                time: '12:00',
                                status: 'available',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1230: {
                            state: {
                                time: '12:30',
                                status: 'available',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1300: {
                            state: {
                                time: '13:00',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'K. Gabrichidze',
                                procedure: '{{ veneerPrep | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1330: {
                            state: {
                                time: '13:30',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'K. Gabrichidze',
                                procedure: '{{ veneerPrep | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1400: {
                            state: {
                                time: '14:00',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1430: {
                            state: {
                                time: '14:30',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'Z. Dolidze',
                                procedure: '{{ implantPlace | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1500: {
                            state: {
                                time: '15:00',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'Z. Dolidze',
                                procedure: '{{ implantPlace | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1530: {
                            state: {
                                time: '15:30',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'Z. Dolidze',
                                procedure: '{{ implantPlace | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1600: {
                            state: {
                                time: '16:00',
                                status: 'available',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1630: {
                            state: {
                                time: '16:30',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'E. Tsereteli',
                                procedure: '{{ examConsult | polyglot }}',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1700: {
                            state: {
                                time: '17:00',
                                status: 'available',
                                cabinetName: 'Cabinet 2'
                            }
                        },
                        S1730: {
                            state: {
                                time: '17:30',
                                status: 'available',
                                cabinetName: 'Cabinet 2'
                            }
                        }
                    }
                },
                // Cabinet 3 — hygienist room
                Cabinet3: {
                    extends: 'CabinetColumn',
                    state: {
                        cabinetName: 'Cabinet 3',
                        cabinetStatus: 'in-use'
                    },
                    Slots: {
                        S0900: {
                            state: {
                                time: '09:00',
                                status: 'occupied',
                                doctor: 'Hyg. Nino',
                                patient: 'I. Diasamidze',
                                procedure: '{{ prophyClean | polyglot }}',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S0930: {
                            state: {
                                time: '09:30',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1000: {
                            state: {
                                time: '10:00',
                                status: 'occupied',
                                doctor: 'Hyg. Nino',
                                patient: 'T. Lomidze',
                                procedure: '{{ perioMaint | polyglot }}',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1030: {
                            state: {
                                time: '10:30',
                                status: 'occupied',
                                doctor: 'Hyg. Nino',
                                patient: 'T. Lomidze',
                                procedure: '{{ perioMaint | polyglot }}',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1100: {
                            state: {
                                time: '11:00',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1130: {
                            state: {
                                time: '11:30',
                                status: 'occupied',
                                doctor: 'Hyg. Nino',
                                patient: 'N. Gogiberidze',
                                procedure: '{{ prophyClean | polyglot }}',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1200: {
                            state: {
                                time: '12:00',
                                status: 'available',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1230: {
                            state: {
                                time: '12:30',
                                status: 'available',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1300: {
                            state: {
                                time: '13:00',
                                status: 'occupied',
                                doctor: 'Hyg. Nino',
                                patient: 'S. Meladze',
                                procedure: '{{ fluorideTx | polyglot }}',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1330: {
                            state: {
                                time: '13:30',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1400: {
                            state: {
                                time: '14:00',
                                status: 'occupied',
                                doctor: 'Hyg. Nino',
                                patient: 'L. Mchedlishvili',
                                procedure: '{{ sealants | polyglot }}',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1430: {
                            state: {
                                time: '14:30',
                                status: 'occupied',
                                doctor: 'Hyg. Nino',
                                patient: 'L. Mchedlishvili',
                                procedure: '{{ sealants | polyglot }}',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1500: {
                            state: {
                                time: '15:00',
                                status: 'available',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1530: {
                            state: {
                                time: '15:30',
                                status: 'occupied',
                                doctor: 'Hyg. Nino',
                                patient: 'B. Shengelia',
                                procedure: '{{ prophyClean | polyglot }}',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1600: {
                            state: {
                                time: '16:00',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1630: {
                            state: {
                                time: '16:30',
                                status: 'available',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1700: {
                            state: {
                                time: '17:00',
                                status: 'available',
                                cabinetName: 'Cabinet 3'
                            }
                        },
                        S1730: {
                            state: {
                                time: '17:30',
                                status: 'available',
                                cabinetName: 'Cabinet 3'
                            }
                        }
                    }
                },
                // Cabinet 4 — under maintenance in AM
                Cabinet4: {
                    extends: 'CabinetColumn',
                    state: {
                        cabinetName: 'Cabinet 4',
                        cabinetStatus: 'maintenance'
                    },
                    Slots: {
                        S0900: {
                            state: {
                                time: '09:00',
                                status: 'maintenance',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S0930: {
                            state: {
                                time: '09:30',
                                status: 'maintenance',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1000: {
                            state: {
                                time: '10:00',
                                status: 'maintenance',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1030: {
                            state: {
                                time: '10:30',
                                status: 'maintenance',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1100: {
                            state: {
                                time: '11:00',
                                status: 'maintenance',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1130: {
                            state: {
                                time: '11:30',
                                status: 'maintenance',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1200: {
                            state: {
                                time: '12:00',
                                status: 'available',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1230: {
                            state: {
                                time: '12:30',
                                status: 'available',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1300: {
                            state: {
                                time: '13:00',
                                status: 'occupied',
                                doctor: 'Dr. Kvaratskhelia',
                                patient: 'V. Papunashvili',
                                procedure: '{{ extraction | polyglot }}',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1330: {
                            state: {
                                time: '13:30',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1400: {
                            state: {
                                time: '14:00',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'G. Beridze',
                                procedure: '{{ whitening | polyglot }}',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1430: {
                            state: {
                                time: '14:30',
                                status: 'occupied',
                                doctor: 'Dr. Beridze',
                                patient: 'G. Beridze',
                                procedure: '{{ whitening | polyglot }}',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1500: {
                            state: {
                                time: '15:00',
                                status: 'cleaning',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1530: {
                            state: {
                                time: '15:30',
                                status: 'available',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1600: {
                            state: {
                                time: '16:00',
                                status: 'available',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1630: {
                            state: {
                                time: '16:30',
                                status: 'available',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1700: {
                            state: {
                                time: '17:00',
                                status: 'available',
                                cabinetName: 'Cabinet 4'
                            }
                        },
                        S1730: {
                            state: {
                                time: '17:30',
                                status: 'available',
                                cabinetName: 'Cabinet 4'
                            }
                        }
                    }
                }
            },
            // ─── SELECTED SLOT DETAIL ─────────────────────
            SlotDetail: {
                flow: 'y',
                gap: 'Z',
                padding: 'B',
                round: 'A',
                background: 'inkMid',
                border: '1px solid inkBorder',
                show: (el, s)=>s.root.selectedSlot,
                DetailHeader: {
                    flow: 'x',
                    align: 'center space-between',
                    DetailTitle: {
                        text: '{{ slotDetails | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    CloseBtn: {
                        text: '\u2715',
                        fontSize: 'Z',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkSurface',
                        border: '1px solid inkBorder',
                        color: 'inkText',
                        cursor: 'pointer',
                        onClick: (e, el, s)=>s.root.update({
                                selectedSlot: null
                            })
                    }
                },
                DetailGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 'Z',
                    '@mobileL': {
                        gridTemplateColumns: '1fr'
                    },
                    CabinetField: {
                        flow: 'y',
                        gap: 'X',
                        FieldLabel: {
                            text: '{{ cabinet | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        FieldValue: {
                            text: (el, s)=>s.root.selectedSlot?.cabinet || '-',
                            fontSize: 'Z',
                            color: 'inkText'
                        }
                    },
                    TimeField: {
                        flow: 'y',
                        gap: 'X',
                        FieldLabel: {
                            text: '{{ time | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        FieldValue: {
                            text: (el, s)=>s.root.selectedSlot?.time || '-',
                            fontSize: 'Z',
                            color: 'inkText'
                        }
                    },
                    StatusField: {
                        flow: 'y',
                        gap: 'X',
                        FieldLabel: {
                            text: '{{ status | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        FieldValue: {
                            text: (el, s)=>s.root.selectedSlot?.status || '-',
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: (el, s)=>{
                                const st = s.root.selectedSlot?.status;
                                if (st === 'occupied') return 'blue';
                                if (st === 'cleaning') return 'amber';
                                if (st === 'maintenance') return 'red';
                                return 'teal';
                            }
                        }
                    },
                    DoctorField: {
                        flow: 'y',
                        gap: 'X',
                        show: (el, s)=>s.root.selectedSlot?.status === 'occupied',
                        FieldLabel: {
                            text: '{{ doctor | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        FieldValue: {
                            text: (el, s)=>s.root.selectedSlot?.doctor || '-',
                            fontSize: 'Z',
                            color: 'inkText'
                        }
                    },
                    PatientField: {
                        flow: 'y',
                        gap: 'X',
                        show: (el, s)=>s.root.selectedSlot?.status === 'occupied',
                        FieldLabel: {
                            text: '{{ patient | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        FieldValue: {
                            text: (el, s)=>s.root.selectedSlot?.patient || '-',
                            fontSize: 'Z',
                            color: 'inkText'
                        }
                    },
                    ProcedureField: {
                        flow: 'y',
                        gap: 'X',
                        show: (el, s)=>s.root.selectedSlot?.status === 'occupied',
                        FieldLabel: {
                            text: '{{ procedure | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            color: 'inkMuted',
                            textTransform: 'uppercase',
                            letterSpacing: 'X'
                        },
                        FieldValue: {
                            text: (el, s)=>s.root.selectedSlot?.procedure || '-',
                            fontSize: 'Z',
                            color: 'inkText'
                        }
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $d7f053e17fe69c28$var$SAMPLE_DOCUMENTS = [
    {
        id: 'd1',
        filename: 'PA_14_15_periapical.dcm',
        docType: 'xray',
        date: '2026-03-18',
        device: 'Dexis Sensor',
        tooth: '14',
        patient: 'Sarah Chen'
    },
    {
        id: 'd2',
        filename: 'Pano_FullArch_20260315.dcm',
        docType: 'xray',
        date: '2026-03-15',
        device: 'Planmeca ProMax',
        tooth: null,
        patient: 'Sarah Chen'
    },
    {
        id: 'd3',
        filename: 'CBCT_Implant_Site_36.dcm',
        docType: 'ctScan',
        date: '2026-03-14',
        device: 'CS 8200 3D',
        tooth: '36',
        patient: 'James Rivera'
    },
    {
        id: 'd4',
        filename: 'CBCT_Impacted_48.dcm',
        docType: 'ctScan',
        date: '2026-03-10',
        device: 'CS 8200 3D',
        tooth: '48',
        patient: 'Maria Lopez'
    },
    {
        id: 'd5',
        filename: 'UpperArch_Scan_v2.stl',
        docType: 'intraoral3d',
        date: '2026-03-17',
        device: 'iTero Element 5D',
        tooth: null,
        patient: 'Sarah Chen'
    },
    {
        id: 'd6',
        filename: 'LowerArch_Scan.stl',
        docType: 'intraoral3d',
        date: '2026-03-17',
        device: 'iTero Element 5D',
        tooth: null,
        patient: 'James Rivera'
    },
    {
        id: 'd7',
        filename: 'IntraoralPhoto_11_Fracture.jpg',
        docType: 'photo',
        date: '2026-03-18',
        device: 'DEXIS IXS Cam',
        tooth: '11',
        patient: 'Emily Tran'
    },
    {
        id: 'd8',
        filename: 'IntraoralPhoto_Occlusal_Upper.jpg',
        docType: 'photo',
        date: '2026-03-16',
        device: 'DEXIS IXS Cam',
        tooth: null,
        patient: 'Sarah Chen'
    },
    {
        id: 'd9',
        filename: 'BW_Left_Posterior.dcm',
        docType: 'xray',
        date: '2026-03-12',
        device: 'Dexis Sensor',
        tooth: '18-21',
        patient: 'Carlos Ortega'
    },
    {
        id: 'd10',
        filename: 'Consent_Form_Signed.pdf',
        docType: 'other',
        date: '2026-03-18',
        device: 'Upload',
        tooth: null,
        patient: 'Sarah Chen'
    }
];
const $d7f053e17fe69c28$var$DOC_TABS = [
    'all',
    'xray',
    'ctScan',
    'intraoral3d',
    'photo'
];
const $d7f053e17fe69c28$export$3260cc9ddc8b12d = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'documents',
                            docFilter: 'all'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── PAGE HEADER ──────────────────────────
            PageHeader: {
                flow: 'x',
                align: 'center flex-start',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 'Z',
                HeaderLeft: {
                    flow: 'y',
                    gap: 'X',
                    Title: {
                        text: '{{ documents | polyglot }}',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    Subtitle: {
                        text: '{{ documentMgmtSubtitle | polyglot }}',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    }
                },
                UploadBtn: {
                    extends: 'Button',
                    text: '{{ uploadDocument | polyglot }}',
                    fontSize: 'Z',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'teal',
                    color: 'white',
                    fontWeight: '600',
                    cursor: 'pointer'
                }
            },
            // ─── DEVICE IMPORT PANEL ──────────────────
            DeviceImportPanel: {},
            // ─── FILTER TABS ──────────────────────────
            FilterTabs: {
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                AllTab: {
                    text: '{{ all | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'Y',
                    cursor: 'pointer',
                    background: (el, s)=>(s.root.docFilter || 'all') === 'all' ? 'inkText' : 'inkSurface',
                    color: (el, s)=>(s.root.docFilter || 'all') === 'all' ? 'inkMid' : 'inkMuted',
                    on: {
                        click: (e, el, s)=>s.root.update({
                                docFilter: 'all'
                            })
                    }
                },
                XrayTab: {
                    text: '{{ xrays | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'Y',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.docFilter === 'xray' ? 'amber.15' : 'inkSurface',
                    color: (el, s)=>s.root.docFilter === 'xray' ? 'amber' : 'inkMuted',
                    on: {
                        click: (e, el, s)=>s.root.update({
                                docFilter: 'xray'
                            })
                    }
                },
                CtTab: {
                    text: '{{ ctScans | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'Y',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.docFilter === 'ctScan' ? 'blue.15' : 'inkSurface',
                    color: (el, s)=>s.root.docFilter === 'ctScan' ? 'blue' : 'inkMuted',
                    on: {
                        click: (e, el, s)=>s.root.update({
                                docFilter: 'ctScan'
                            })
                    }
                },
                ThreeDTab: {
                    text: '3D Scans',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'Y',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.docFilter === 'intraoral3d' ? 'violet.15' : 'inkSurface',
                    color: (el, s)=>s.root.docFilter === 'intraoral3d' ? 'violet' : 'inkMuted',
                    on: {
                        click: (e, el, s)=>s.root.update({
                                docFilter: 'intraoral3d'
                            })
                    }
                },
                PhotosTab: {
                    text: '{{ photos | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    round: 'Y',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.docFilter === 'photo' ? 'teal.15' : 'inkSurface',
                    color: (el, s)=>s.root.docFilter === 'photo' ? 'teal' : 'inkMuted',
                    on: {
                        click: (e, el, s)=>s.root.update({
                                docFilter: 'photo'
                            })
                    }
                }
            },
            // ─── DOCUMENT grid ────────────────────────
            DocumentGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                gap: 'A',
                '@mobileL': {
                    gridTemplateColumns: '1fr 1fr'
                },
                '@mobileS': {
                    gridTemplateColumns: '1fr'
                },
                children: (el, s)=>{
                    const filter = s.root.docFilter || 'all';
                    return $d7f053e17fe69c28$var$SAMPLE_DOCUMENTS.filter((d)=>filter === 'all' || d.docType === filter);
                },
                childrenAs: 'state',
                childExtends: 'DocumentCard'
            },
            // ─── EMPTY STATE ─────────────────────────
            EmptyState: {
                display: (el, s)=>{
                    const filter = s.root.docFilter || 'all';
                    const count = $d7f053e17fe69c28$var$SAMPLE_DOCUMENTS.filter((d)=>filter === 'all' || d.docType === filter).length;
                    return count === 0 ? 'flex' : 'none';
                },
                flow: 'y',
                align: 'center center',
                gap: 'Z',
                padding: 'D',
                EmptyIcon: {
                    extends: 'Icon',
                    name: 'folder',
                    fontSize: 'D',
                    color: 'inkMuted'
                },
                EmptyText: {
                    text: '{{ noDocumentsFound | polyglot }}',
                    fontSize: 'A',
                    color: 'inkMuted'
                }
            }
        }
    },
    // ─── DOCUMENT VIEWER OVERLAY ────────────────
    DocumentViewer: {}
};


const $78a580fb1cf61fb0$export$50015f3d0c7b8cdc = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    NavSidebar: {},
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'inventory'
                        }));
                }
                return false;
            };
        })()
    },
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            InventoryNav: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                TabStock: {
                    text: '{{ stock | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.inventoryTab === 'stock' || !s.root.inventoryTab ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.inventoryTab === 'stock' || !s.root.inventoryTab ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            inventoryTab: 'stock'
                        })
                },
                TabOrders: {
                    text: '{{ orders | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.inventoryTab === 'orders' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.inventoryTab === 'orders' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            inventoryTab: 'orders'
                        })
                },
                TabSuppliers: {
                    text: '{{ suppliers | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.inventoryTab === 'suppliers' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.inventoryTab === 'suppliers' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            inventoryTab: 'suppliers'
                        })
                },
                TabUsage: {
                    text: '{{ usageLog | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.inventoryTab === 'usage' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.inventoryTab === 'usage' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            inventoryTab: 'usage'
                        })
                }
            },
            // Stock View
            StockView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.inventoryTab === 'stock' || !s.root.inventoryTab,
                StatsRow: {
                    flow: 'x',
                    gap: 'Z',
                    flexWrap: 'wrap',
                    marginBottom: 'Z',
                    TotalItems: {
                        extends: 'StatCard',
                        state: {
                            label: '{{ totalItems | polyglot }}',
                            value: '142',
                            delta: '+8'
                        }
                    },
                    LowStockStat: {
                        extends: 'StatCard',
                        state: {
                            label: '{{ lowStock | polyglot }}',
                            value: '5',
                            delta: '-2'
                        }
                    },
                    PendingOrders: {
                        extends: 'StatCard',
                        state: {
                            label: '{{ pendingOrders | polyglot }}',
                            value: '3'
                        }
                    },
                    MonthlySpend: {
                        extends: 'StatCard',
                        state: {
                            label: '{{ monthlySpend | polyglot }}',
                            value: '\u20BE4,280',
                            delta: '+12%'
                        }
                    }
                },
                LowStockAlerts: {
                    flow: 'y',
                    gap: 'Z',
                    marginBottom: 'A',
                    AlertTitle: {
                        text: '{{ lowStockAlerts | polyglot }}',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'red'
                    },
                    AlertGrid: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                        gap: 'Z',
                        children: [
                            {
                                name: 'Composite Resin A2',
                                category: 'Restorative',
                                quantity: 3,
                                unit: 'syringes',
                                reorderLevel: 5,
                                maxCapacity: 30
                            },
                            {
                                name: 'Nitrile Gloves (M)',
                                category: 'Disposables',
                                quantity: 2,
                                unit: 'boxes',
                                reorderLevel: 5,
                                maxCapacity: 20
                            },
                            {
                                name: 'Gutta Percha Points',
                                category: 'Endodontic',
                                quantity: 8,
                                unit: 'packs',
                                reorderLevel: 10,
                                maxCapacity: 50
                            }
                        ],
                        childrenAs: 'state',
                        childExtends: 'InventoryCard'
                    }
                },
                CategoryFilter: {
                    flow: 'x',
                    gap: 'Y',
                    flexWrap: 'wrap',
                    paddingBottom: 'Z',
                    AllPill: {
                        tag: 'button',
                        text: '{{ allFilter | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'teal',
                        color: 'ink',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    RestorativePill: {
                        tag: 'button',
                        text: '{{ restorative | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    EndodonticPill: {
                        tag: 'button',
                        text: '{{ endodontic | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    ProstheticPill: {
                        tag: 'button',
                        text: '{{ prosthetic | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    SurgicalPill: {
                        tag: 'button',
                        text: '{{ surgical | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    HygienePill: {
                        tag: 'button',
                        text: '{{ hygiene | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    },
                    DisposablesPill: {
                        tag: 'button',
                        text: '{{ disposables | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none'
                    }
                },
                InventoryGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: 'A',
                    children: [
                        {
                            name: 'Composite Resin A2',
                            category: 'Restorative',
                            quantity: 3,
                            unit: 'syringes',
                            reorderLevel: 5,
                            maxCapacity: 30
                        },
                        {
                            name: 'Ceramic Crowns (Premolar)',
                            category: 'Prosthetic',
                            quantity: 18,
                            unit: 'units',
                            reorderLevel: 8,
                            maxCapacity: 40
                        },
                        {
                            name: 'Endodontic Files #25',
                            category: 'Endodontic',
                            quantity: 22,
                            unit: 'packs',
                            reorderLevel: 10,
                            maxCapacity: 50
                        },
                        {
                            name: 'Surgical Sutures 4-0',
                            category: 'Surgical',
                            quantity: 14,
                            unit: 'packs',
                            reorderLevel: 6,
                            maxCapacity: 30
                        },
                        {
                            name: 'Prophy Paste (Mint)',
                            category: 'Hygiene',
                            quantity: 25,
                            unit: 'cups',
                            reorderLevel: 10,
                            maxCapacity: 60
                        },
                        {
                            name: 'Nitrile Gloves (M)',
                            category: 'Disposables',
                            quantity: 2,
                            unit: 'boxes',
                            reorderLevel: 5,
                            maxCapacity: 20
                        },
                        {
                            name: 'Dental Adhesive',
                            category: 'Restorative',
                            quantity: 12,
                            unit: 'bottles',
                            reorderLevel: 4,
                            maxCapacity: 20
                        },
                        {
                            name: 'Gutta Percha Points',
                            category: 'Endodontic',
                            quantity: 8,
                            unit: 'packs',
                            reorderLevel: 10,
                            maxCapacity: 50
                        },
                        {
                            name: 'Impression Material (VPS)',
                            category: 'Prosthetic',
                            quantity: 15,
                            unit: 'cartridges',
                            reorderLevel: 6,
                            maxCapacity: 30
                        },
                        {
                            name: 'Scalpel Blades #15',
                            category: 'Surgical',
                            quantity: 30,
                            unit: 'blades',
                            reorderLevel: 10,
                            maxCapacity: 50
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'InventoryCard'
                }
            },
            // Orders View
            OrdersView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.inventoryTab === 'orders',
                OrdersTitle: {
                    text: '{{ pendingOrders | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                OrdersList: {
                    flow: 'y',
                    gap: 'Z',
                    Order1: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'B',
                        round: 'Z',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        TopRow: {
                            flow: 'x',
                            justifyContent: 'space-between',
                            align: 'center flex-start',
                            OrderId: {
                                text: 'ORD-2026-041',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            Status: {
                                tag: 'span',
                                text: '{{ shipped | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'blue.15',
                                color: 'blue'
                            }
                        },
                        Supplier: {
                            text: 'DentSupply Georgia',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        Items: {
                            text: 'Composite Resin A2 x20, Dental Adhesive x10',
                            fontSize: 'Y',
                            color: 'inkText'
                        },
                        DateRow: {
                            flow: 'x',
                            gap: 'A',
                            Ordered: {
                                text: '{{ ordered | polyglot }}: Mar 15, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            ETA: {
                                text: 'ETA: Mar 21, 2026',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'teal'
                            }
                        }
                    },
                    Order2: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'B',
                        round: 'Z',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        TopRow: {
                            flow: 'x',
                            justifyContent: 'space-between',
                            align: 'center flex-start',
                            OrderId: {
                                text: 'ORD-2026-042',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            Status: {
                                tag: 'span',
                                text: '{{ processing | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'amber.15',
                                color: 'amber'
                            }
                        },
                        Supplier: {
                            text: 'MedGeo Supplies',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        Items: {
                            text: 'Nitrile Gloves (M) x10, Scalpel Blades #15 x5',
                            fontSize: 'Y',
                            color: 'inkText'
                        },
                        DateRow: {
                            flow: 'x',
                            gap: 'A',
                            Ordered: {
                                text: '{{ ordered | polyglot }}: Mar 17, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            ETA: {
                                text: 'ETA: Mar 24, 2026',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'teal'
                            }
                        }
                    },
                    Order3: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'B',
                        round: 'Z',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        TopRow: {
                            flow: 'x',
                            justifyContent: 'space-between',
                            align: 'center flex-start',
                            OrderId: {
                                text: 'ORD-2026-043',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            Status: {
                                tag: 'span',
                                text: '{{ confirmed | polyglot }}',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: 'green.15',
                                color: 'green'
                            }
                        },
                        Supplier: {
                            text: 'Caucasus Dental Co.',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        },
                        Items: {
                            text: 'Gutta Percha Points x15, Endodontic Files #25 x10',
                            fontSize: 'Y',
                            color: 'inkText'
                        },
                        DateRow: {
                            flow: 'x',
                            gap: 'A',
                            Ordered: {
                                text: '{{ ordered | polyglot }}: Mar 18, 2026',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            ETA: {
                                text: 'ETA: Mar 25, 2026',
                                fontSize: 'Y',
                                fontWeight: '600',
                                color: 'teal'
                            }
                        }
                    }
                }
            },
            // Suppliers View
            SuppliersView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.inventoryTab === 'suppliers',
                SuppliersTitle: {
                    text: '{{ suppliers | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                SuppliersGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                    gap: 'A',
                    children: [
                        {
                            name: 'DentSupply Georgia',
                            contact: 'Giorgi Kharadze',
                            phone: '+995 577 123 456',
                            deliveryAvailable: true,
                            rating: 5,
                            estimatedDays: 3,
                            minimumOrder: '\u20BE200'
                        },
                        {
                            name: 'MedGeo Supplies',
                            contact: 'Nino Avaliani',
                            phone: '+995 599 234 567',
                            deliveryAvailable: true,
                            rating: 4,
                            estimatedDays: 5,
                            minimumOrder: '\u20BE150'
                        },
                        {
                            name: 'Caucasus Dental Co.',
                            contact: 'Davit Topuria',
                            phone: '+995 571 345 678',
                            deliveryAvailable: true,
                            rating: 4,
                            estimatedDays: 4,
                            minimumOrder: '\u20BE300'
                        },
                        {
                            name: 'EuroDent Import',
                            contact: 'Ana Merabishvili',
                            phone: '+995 555 456 789',
                            deliveryAvailable: false,
                            rating: 3,
                            estimatedDays: 14,
                            minimumOrder: '\u20BE500'
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'SupplierCard'
                }
            },
            // Usage Log View
            UsageView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.inventoryTab === 'usage',
                UsageTitle: {
                    text: '{{ usageLog | polyglot }}',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inkText'
                },
                UsageSubtitle: {
                    text: '{{ recentMaterialUsage | polyglot }}',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    marginBottom: 'Z'
                },
                UsageList: {
                    flow: 'y',
                    gap: 'Z',
                    children: [
                        {
                            materialName: 'Composite Resin A2',
                            quantityUsed: 2,
                            unit: 'syringes'
                        },
                        {
                            materialName: 'Dental Adhesive',
                            quantityUsed: 1,
                            unit: 'bottle'
                        },
                        {
                            materialName: 'Nitrile Gloves (M)',
                            quantityUsed: 4,
                            unit: 'pairs'
                        },
                        {
                            materialName: 'Prophy Paste (Mint)',
                            quantityUsed: 3,
                            unit: 'cups'
                        },
                        {
                            materialName: 'Surgical Sutures 4-0',
                            quantityUsed: 1,
                            unit: 'pack'
                        },
                        {
                            materialName: 'Endodontic Files #25',
                            quantityUsed: 2,
                            unit: 'packs'
                        },
                        {
                            materialName: 'Impression Material (VPS)',
                            quantityUsed: 2,
                            unit: 'cartridges'
                        },
                        {
                            materialName: 'Scalpel Blades #15',
                            quantityUsed: 3,
                            unit: 'blades'
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'MaterialUsageRow'
                }
            }
        },
        MobileTabBar: {}
    }
};


const $c2e06f40f10dab9f$var$sampleQueue = [
    {
        id: 'RAD-001',
        patientName: 'Giorgi Beridze',
        referringDoctor: 'Dr. Lomidze',
        imagingType: 'CBCT',
        targetArea: '#14, #15',
        clinicalQuestion: 'Evaluate bone density for implant placement',
        urgency: 'urgent',
        status: 'pending',
        createdAt: 'Mar 19, 2026 08:30'
    },
    {
        id: 'RAD-002',
        patientName: 'Nino Kapanadze',
        referringDoctor: 'Dr. Kvaratskhelia',
        imagingType: 'Panoramic',
        targetArea: 'Full Mouth',
        clinicalQuestion: 'Comprehensive evaluation before orthodontic treatment',
        urgency: 'normal',
        status: 'inProgress',
        createdAt: 'Mar 19, 2026 09:15'
    },
    {
        id: 'RAD-003',
        patientName: 'Davit Gelashvili',
        referringDoctor: 'Dr. Beridze',
        imagingType: 'Periapical',
        targetArea: '#30',
        clinicalQuestion: 'Suspected periapical abscess, rule out fracture',
        urgency: 'urgent',
        status: 'pending',
        createdAt: 'Mar 19, 2026 10:00'
    },
    {
        id: 'RAD-004',
        patientName: 'Mariam Tsiklauri',
        referringDoctor: 'Dr. Lomidze',
        imagingType: 'Cephalometric',
        targetArea: 'Lateral',
        clinicalQuestion: 'Pre-orthodontic cephalometric analysis',
        urgency: 'normal',
        status: 'completed',
        createdAt: 'Mar 18, 2026 14:20'
    },
    {
        id: 'RAD-005',
        patientName: 'Ana Javakhishvili',
        referringDoctor: 'Dr. Kvaratskhelia',
        imagingType: 'CBCT',
        targetArea: '#3, #4, #5',
        clinicalQuestion: 'Sinus proximity assessment before extraction',
        urgency: 'normal',
        status: 'completed',
        createdAt: 'Mar 18, 2026 11:45'
    },
    {
        id: 'RAD-006',
        patientName: 'Luka Mchedlishvili',
        referringDoctor: 'Dr. Beridze',
        imagingType: 'Periapical',
        targetArea: '#19',
        clinicalQuestion: 'Post root canal treatment follow-up',
        urgency: 'normal',
        status: 'inProgress',
        createdAt: 'Mar 19, 2026 07:50'
    }
];
const $c2e06f40f10dab9f$export$a396a716b69298e7 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'radiology',
                            radiologyTab: s.root.radiologyTab || 'queue',
                            radiologyQueue: s.root.radiologyQueue || $c2e06f40f10dab9f$var$sampleQueue,
                            radiologyFilter: s.root.radiologyFilter || 'all'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ---- STATS BAR ----
            StatsBar: {
                flow: 'x',
                gap: 'Z',
                flexWrap: 'wrap',
                marginBottom: 'Z',
                PendingStat: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center flex-start',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'amber.15',
                    flex: '1',
                    minWidth: '140px',
                    Icon: {
                        text: '\u23F3',
                        fontSize: 'A'
                    },
                    Info: {
                        flow: 'y',
                        Count: {
                            text: (el, s)=>String((s.root.radiologyQueue || []).filter((r)=>r.status === 'pending').length),
                            fontSize: 'B',
                            fontWeight: '700',
                            color: 'amber'
                        },
                        Label: {
                            text: '{{ pending | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                },
                InProgressStat: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center flex-start',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'blue.15',
                    flex: '1',
                    minWidth: '140px',
                    Icon: {
                        text: '\uD83D\uDD04',
                        fontSize: 'A'
                    },
                    Info: {
                        flow: 'y',
                        Count: {
                            text: (el, s)=>String((s.root.radiologyQueue || []).filter((r)=>r.status === 'inProgress').length),
                            fontSize: 'B',
                            fontWeight: '700',
                            color: 'blue'
                        },
                        Label: {
                            text: '{{ inProgress | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                },
                CompletedStat: {
                    flow: 'x',
                    gap: 'Y',
                    align: 'center flex-start',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'teal.15',
                    flex: '1',
                    minWidth: '140px',
                    Icon: {
                        text: '\u2705',
                        fontSize: 'A'
                    },
                    Info: {
                        flow: 'y',
                        Count: {
                            text: (el, s)=>String((s.root.radiologyQueue || []).filter((r)=>r.status === 'completed').length),
                            fontSize: 'B',
                            fontWeight: '700',
                            color: 'teal'
                        },
                        Label: {
                            text: '{{ completedToday | polyglot }}',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                }
            },
            // ---- TAB NAV ----
            RadiologyNav: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                TabNewReferral: {
                    text: '{{ newReferral | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.radiologyTab === 'newReferral' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.radiologyTab === 'newReferral' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            radiologyTab: 'newReferral'
                        })
                },
                TabQueue: {
                    text: '{{ queue | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.radiologyTab === 'queue' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.radiologyTab === 'queue' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            radiologyTab: 'queue'
                        })
                }
            },
            // ---- NEW REFERRAL VIEW ----
            NewReferralView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.radiologyTab === 'newReferral',
                maxWidth: '640px',
                RadiologyReferralForm: {}
            },
            // ---- QUEUE VIEW ----
            QueueView: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>s.root.radiologyTab === 'queue',
                QueueFilterBar: {
                    flow: 'x',
                    gap: 'Y',
                    flexWrap: 'wrap',
                    paddingBottom: 'Z',
                    AllPill: {
                        tag: 'button',
                        text: '{{ allFilter | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none',
                        background: (el, s)=>s.root.radiologyFilter === 'all' ? 'teal' : 'inkSurface',
                        color: (el, s)=>s.root.radiologyFilter === 'all' ? 'ink' : 'inkMuted',
                        onClick: (e, el, s)=>s.root.update({
                                radiologyFilter: 'all'
                            })
                    },
                    PendingPill: {
                        tag: 'button',
                        text: '{{ pending | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none',
                        background: (el, s)=>s.root.radiologyFilter === 'pending' ? 'amber' : 'inkSurface',
                        color: (el, s)=>s.root.radiologyFilter === 'pending' ? 'ink' : 'inkMuted',
                        onClick: (e, el, s)=>s.root.update({
                                radiologyFilter: 'pending'
                            })
                    },
                    InProgressPill: {
                        tag: 'button',
                        text: '{{ inProgress | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none',
                        background: (el, s)=>s.root.radiologyFilter === 'inProgress' ? 'blue' : 'inkSurface',
                        color: (el, s)=>s.root.radiologyFilter === 'inProgress' ? 'white' : 'inkMuted',
                        onClick: (e, el, s)=>s.root.update({
                                radiologyFilter: 'inProgress'
                            })
                    },
                    CompletedPill: {
                        tag: 'button',
                        text: '{{ completed | polyglot }}',
                        padding: 'Y Z',
                        round: 'C',
                        fontSize: 'Y',
                        fontWeight: '500',
                        cursor: 'pointer',
                        border: 'none',
                        background: (el, s)=>s.root.radiologyFilter === 'completed' ? 'teal' : 'inkSurface',
                        color: (el, s)=>s.root.radiologyFilter === 'completed' ? 'ink' : 'inkMuted',
                        onClick: (e, el, s)=>s.root.update({
                                radiologyFilter: 'completed'
                            })
                    }
                },
                QueueList: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                    gap: 'A',
                    children: (el, s)=>{
                        const queue = s.root.radiologyQueue || [];
                        const filter = s.root.radiologyFilter || 'all';
                        return filter === 'all' ? queue : queue.filter((r)=>r.status === filter);
                    },
                    childrenAs: 'state',
                    childExtends: 'RadiologyQueueCard'
                }
            }
        }
    }
};


const $652d68f80c2c6f71$export$472071ac89399e9a = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'staff'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── HEADER ───────────────────────────────────
            PageHeader: {
                flow: 'x',
                align: 'center space-between',
                marginBottom: 'Z',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Z'
                },
                TitleWrap: {
                    flow: 'y',
                    gap: 'Y',
                    PageTitle: {
                        tag: 'h1',
                        text: 'Staff',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'inkText',
                        letterSpacing: '-0.02em'
                    },
                    PageSubtitle: {
                        text: '12 team members',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    }
                },
                AddStaffBtn: {
                    tag: 'button',
                    text: '+ Add Member',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    background: 'inkText',
                    color: 'inkMid',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'opacity 150ms ease',
                    ':hover': {
                        opacity: '0.8'
                    }
                }
            },
            // ─── STATS ROW ────────────────────────────────
            StatsRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                marginBottom: 'Z',
                '@mobileL': {
                    flow: 'y'
                },
                StatDoctors: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'E',
                    StatValue: {
                        text: '4',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'teal',
                        letterSpacing: '-0.02em'
                    },
                    StatLabel: {
                        text: 'Doctors',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatHygienists: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'E',
                    StatValue: {
                        text: '2',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'green',
                        letterSpacing: '-0.02em'
                    },
                    StatLabel: {
                        text: 'Hygienists',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatAssistants: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'E',
                    StatValue: {
                        text: '3',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'amber',
                        letterSpacing: '-0.02em'
                    },
                    StatLabel: {
                        text: 'Assistants',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatAdmin: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'E',
                    StatValue: {
                        text: '3',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'purple',
                        letterSpacing: '-0.02em'
                    },
                    StatLabel: {
                        text: 'Admin / Front Desk',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                }
            },
            // ─── DOCTORS ──────────────────────────────────
            DoctorsSection: {
                flow: 'y',
                gap: 'Z',
                SectionHeader: {
                    flow: 'x',
                    align: 'center flex-start',
                    gap: 'Y',
                    marginBottom: 'Y',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'teal',
                        flexShrink: '0'
                    },
                    Title: {
                        text: 'Doctors',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    Count: {
                        text: '4 members',
                        fontSize: 'Y',
                        color: 'inkMuted',
                        marginLeft: 'Y'
                    }
                },
                Cards: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: 'A',
                    Dr1: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid teal',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'teal.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'AL',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'teal'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Dr. Ana Lomidze',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'General Dentist',
                                    fontSize: 'Y',
                                    color: 'teal',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2019',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon\u2013Fri, 09:00\u201318:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 101 101',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow3: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'activity',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '8 patients today',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'teal.15',
                            color: 'teal',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    },
                    Dr2: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid teal',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'teal.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'GB',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'teal'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Dr. Giorgi Beridze',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Implantologist',
                                    fontSize: 'Y',
                                    color: 'teal',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2017',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon\u2013Sat, 09:00\u201317:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 202 202',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow3: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'activity',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '6 patients today',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'teal.15',
                            color: 'teal',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    },
                    Dr3: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid teal',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'teal.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'NK',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'teal'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Dr. Nino Kvaratskhelia',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Orthodontist',
                                    fontSize: 'Y',
                                    color: 'teal',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2020',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Tue\u2013Sat, 10:00\u201319:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 303 303',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow3: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'activity',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '5 patients today',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'teal.15',
                            color: 'teal',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    },
                    Dr4: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid teal',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'inkSurface',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'DM',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'inkMuted'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Dr. Davit Mchedlidze',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Endodontist',
                                    fontSize: 'Y',
                                    color: 'teal',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2022',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon, Wed, Fri, 10:00\u201317:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 404 404',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow3: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'activity',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: 'Day off',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Part-time',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'amber.15',
                            color: 'amber',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    }
                }
            },
            // ─── HYGIENISTS ───────────────────────────────
            HygienistsSection: {
                flow: 'y',
                gap: 'Z',
                SectionHeader: {
                    flow: 'x',
                    align: 'center flex-start',
                    gap: 'Y',
                    marginBottom: 'Y',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'green',
                        flexShrink: '0'
                    },
                    Title: {
                        text: 'Hygienists',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    Count: {
                        text: '2 members',
                        fontSize: 'Y',
                        color: 'inkMuted',
                        marginLeft: 'Y'
                    }
                },
                Cards: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: 'A',
                    Hyg1: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid green',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'green.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'NG',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'green'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Nino Gabrichidze',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Dental Hygienist',
                                    fontSize: 'Y',
                                    color: 'green',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2021',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon\u2013Fri, 09:00\u201317:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 505 505',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow3: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'activity',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '7 patients today',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'green.15',
                            color: 'green',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    },
                    Hyg2: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid green',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'green.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'LT',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'green'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Lali Tsereteli',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Dental Hygienist',
                                    fontSize: 'Y',
                                    color: 'green',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2023',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Tue\u2013Sat, 10:00\u201318:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 606 606',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow3: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'activity',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '4 patients today',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'green.15',
                            color: 'green',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    }
                }
            },
            // ─── ASSISTANTS ───────────────────────────────
            AssistantsSection: {
                flow: 'y',
                gap: 'Z',
                SectionHeader: {
                    flow: 'x',
                    align: 'center flex-start',
                    gap: 'Y',
                    marginBottom: 'Y',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'amber',
                        flexShrink: '0'
                    },
                    Title: {
                        text: 'Dental Assistants',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    Count: {
                        text: '3 members',
                        fontSize: 'Y',
                        color: 'inkMuted',
                        marginLeft: 'Y'
                    }
                },
                Cards: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: 'A',
                    Asst1: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid amber',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'amber.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'MK',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'amber'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Mariam Kapanadze',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Dental Assistant',
                                    fontSize: 'Y',
                                    color: 'amber',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2022',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon\u2013Fri, 08:30\u201317:30",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'users',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: 'Assists Dr. Lomidze',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'amber.15',
                            color: 'amber',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    },
                    Asst2: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid amber',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'amber.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'TG',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'amber'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Tamar Gelashvili',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Dental Assistant',
                                    fontSize: 'Y',
                                    color: 'amber',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2023',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Tue\u2013Sat, 09:00\u201318:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'users',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: 'Assists Dr. Beridze',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'amber.15',
                            color: 'amber',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    },
                    Asst3: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid amber',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'inkSurface',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'GD',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'inkMuted'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Giorgi Dolidze',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Dental Assistant',
                                    fontSize: 'Y',
                                    color: 'amber',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2024',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon\u2013Fri, 10:00\u201319:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'users',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: 'Assists Dr. Kvaratskhelia',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Probation',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'blue.15',
                            color: 'blue',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    }
                }
            },
            // ─── ADMIN / FRONT DESK ───────────────────────
            AdminSection: {
                flow: 'y',
                gap: 'Z',
                SectionHeader: {
                    flow: 'x',
                    align: 'center flex-start',
                    gap: 'Y',
                    marginBottom: 'Y',
                    Dot: {
                        width: 'Z',
                        height: 'Z',
                        round: 'Z',
                        background: 'purple',
                        flexShrink: '0'
                    },
                    Title: {
                        text: 'Admin & Front Desk',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    Count: {
                        text: '3 members',
                        fontSize: 'Y',
                        color: 'inkMuted',
                        marginLeft: 'Y'
                    }
                },
                Cards: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: 'A',
                    Admin1: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid purple',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'purple.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'KJ',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'purple'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Keti Javakhishvili',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Practice Manager',
                                    fontSize: 'Y',
                                    color: 'purple',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2018',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon\u2013Fri, 08:00\u201317:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 707 707',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'purple.15',
                            color: 'purple',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    },
                    Admin2: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid purple',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'purple.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'SM',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'purple'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Salome Meladze',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Receptionist',
                                    fontSize: 'Y',
                                    color: 'purple',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2022',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon\u2013Sat, 09:00\u201318:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 808 808',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'purple.15',
                            color: 'purple',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    },
                    Admin3: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        borderTop: '3px solid purple',
                        CardTop: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            Avatar: {
                                width: 'C',
                                height: 'C',
                                round: 'C',
                                background: 'purple.15',
                                align: 'center center',
                                flow: 'x',
                                flexShrink: '0',
                                Initials: {
                                    text: 'IA',
                                    fontSize: 'A',
                                    fontWeight: '700',
                                    color: 'purple'
                                }
                            },
                            Info: {
                                flow: 'y',
                                gap: 'X',
                                Name: {
                                    text: 'Irakli Abuladze',
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                Role: {
                                    text: 'Billing Coordinator',
                                    fontSize: 'Y',
                                    color: 'purple',
                                    fontWeight: '600'
                                },
                                Since: {
                                    text: 'Since 2023',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        Divider: {
                            height: '1px',
                            background: 'inkBorder',
                            margin: 'Z 0'
                        },
                        CardInfo: {
                            flow: 'y',
                            gap: 'Y',
                            DetailRow1: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'calendar',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: "Mon\u2013Fri, 09:00\u201318:00",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            DetailRow2: {
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                Icon: {
                                    extends: 'Icon',
                                    icon: 'phone',
                                    width: 'Z',
                                    height: 'Z',
                                    color: 'inkMuted'
                                },
                                Val: {
                                    text: '+995 555 909 909',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        },
                        StatusBadge: {
                            text: 'Active',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: 'purple.15',
                            color: 'purple',
                            width: 'fit-content',
                            marginTop: 'Y'
                        }
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $8ea780561eeb84e4$export$5c97e62a4a7198ec = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'mySchedule',
                            viewMode: s.root.viewMode || 'week'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            // ─── DOCTOR HEADER ─────────────────────────────
            DoctorHeader: {
                flow: 'x',
                gap: 'B',
                align: 'center flex-start',
                flexWrap: 'wrap',
                Avatar: {
                    width: 'C',
                    height: 'C',
                    round: 'C',
                    background: 'teal.20',
                    align: 'center center',
                    flexShrink: '0',
                    Initials: {
                        text: 'AK',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'teal'
                    }
                },
                Info: {
                    flow: 'y',
                    gap: 'X',
                    Name: {
                        text: 'Dr. Ana Lomidze',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    Role: {
                        text: "General & Restorative Dentist \xb7 Cabinet 1",
                        fontSize: 'Z',
                        color: 'inkMuted'
                    },
                    StatusRow: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center flex-start',
                        ActiveDot: {
                            width: 'Y',
                            height: 'Y',
                            round: 'Y',
                            background: 'green',
                            flexShrink: '0'
                        },
                        StatusText: {
                            text: "On Duty \xb7 Next patient in 12 min",
                            fontSize: 'Y',
                            color: 'green'
                        }
                    }
                },
                Spacer: {
                    flex: '1'
                },
                TodayDate: {
                    text: 'Wed, Mar 19, 2026',
                    fontSize: 'Z',
                    color: 'inkMuted',
                    alignSelf: 'flex-start',
                    paddingTop: 'Y'
                }
            },
            // ─── TODAY STATS ───────────────────────────────
            TodayStats: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                gap: 'Z',
                StatAppts: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'teal.10',
                    border: '1px solid teal.25',
                    Val: {
                        text: '6',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'teal'
                    },
                    Lbl: {
                        text: 'Appointments',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatDone: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'green.10',
                    border: '1px solid green.25',
                    Val: {
                        text: '2',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'green'
                    },
                    Lbl: {
                        text: 'Completed',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatRemaining: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'amber.10',
                    border: '1px solid amber.25',
                    Val: {
                        text: '4',
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'amber'
                    },
                    Lbl: {
                        text: 'Remaining',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatProduction: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'purple.10',
                    border: '1px solid purple.25',
                    Val: {
                        text: "\u20BE3,240",
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'purple'
                    },
                    Lbl: {
                        text: 'Est. Production',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                }
            },
            // ─── NEXT PATIENT CARD ─────────────────────────
            NextPatientCard: {
                flow: 'x',
                gap: 'A',
                padding: 'A',
                round: 'A',
                background: 'teal.08',
                border: '2px solid teal.30',
                align: 'center flex-start',
                flexWrap: 'wrap',
                NextLabel: {
                    flow: 'y',
                    gap: 'X',
                    flexShrink: '0',
                    Tag: {
                        text: 'NEXT PATIENT',
                        fontSize: 'Y',
                        fontWeight: '700',
                        color: 'teal',
                        letterSpacing: '0.08em'
                    },
                    Time: {
                        text: '10:00 AM',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    }
                },
                Divider: {
                    width: '1px',
                    background: 'teal.30',
                    alignSelf: 'stretch',
                    flexShrink: '0'
                },
                PatientInfo: {
                    flow: 'y',
                    gap: 'X',
                    flex: '1',
                    PatName: {
                        text: 'Giorgi Beridze',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    Procedure: {
                        text: "RCT #36 \xb7 60 min \xb7 Cabinet 1",
                        fontSize: 'Z',
                        color: 'inkMuted'
                    },
                    Notes: {
                        text: 'Check periapical X-ray before start. Patient is slightly anxious.',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        fontStyle: 'italic'
                    }
                },
                PatientActions: {
                    flow: 'x',
                    gap: 'Y',
                    flexShrink: '0',
                    ViewChartBtn: {
                        tag: 'button',
                        text: 'View Chart',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Z',
                        background: 'teal',
                        color: 'ink',
                        border: 'none',
                        cursor: 'pointer'
                    },
                    CheckInBtn: {
                        tag: 'button',
                        text: 'Check In',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Z',
                        background: 'inkSurface',
                        color: 'inkText',
                        border: '1px solid inkBorder',
                        cursor: 'pointer'
                    }
                }
            },
            // ─── TOOLBAR ───────────────────────────────────
            ScheduleToolbar: {
                flow: 'x',
                gap: 'A',
                align: 'center space-between',
                flexWrap: 'wrap',
                '@mobileL': {
                    flow: 'y',
                    gap: 'Z'
                },
                LeftControls: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center flex-start',
                    ViewToggle: {
                        flow: 'x',
                        gap: '0',
                        round: 'Y',
                        overflow: 'hidden',
                        border: '1px solid inkBorder',
                        DayBtn: {
                            text: '{{ day | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            cursor: 'pointer',
                            background: (el, s)=>s.root.viewMode === 'day' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.viewMode === 'day' ? 'white' : 'inkMuted',
                            onClick: (e, el, s)=>s.root.update({
                                    viewMode: 'day'
                                })
                        },
                        WeekBtn: {
                            text: '{{ week | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            cursor: 'pointer',
                            background: (el, s)=>s.root.viewMode === 'week' ? 'teal' : 'inkMid',
                            color: (el, s)=>s.root.viewMode === 'week' ? 'white' : 'inkMuted',
                            onClick: (e, el, s)=>s.root.update({
                                    viewMode: 'week'
                                })
                        }
                    },
                    DateNav: {
                        flow: 'x',
                        gap: 'Y',
                        align: 'center center',
                        PrevBtn: {
                            text: "\u2190",
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            cursor: 'pointer'
                        },
                        TodayBtn: {
                            text: '{{ today | polyglot }}',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'teal',
                            cursor: 'pointer'
                        },
                        NextBtn: {
                            text: "\u2192",
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            color: 'inkText',
                            cursor: 'pointer'
                        },
                        DateLabel: {
                            text: "Mar 17 \u2013 Mar 23, 2026",
                            fontSize: 'Z',
                            fontWeight: '600',
                            color: 'inkText',
                            marginLeft: 'Y'
                        }
                    }
                },
                RightControls: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center flex-end',
                    BlockTimeBtn: {
                        tag: 'button',
                        text: 'Block Time',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        color: 'inkMuted',
                        cursor: 'pointer'
                    },
                    NewApptBtn: {
                        tag: 'button',
                        text: '+ New Appointment',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'Y Z',
                        round: 'Y',
                        background: 'teal',
                        color: 'ink',
                        border: 'none',
                        cursor: 'pointer'
                    }
                }
            },
            // ─── WEEK CALENDAR (MY APPOINTMENTS ONLY) ─────
            WeekCalendarSection: {
                flow: 'y',
                background: 'inkMid',
                round: 'A',
                border: '1px solid inkBorder',
                overflow: 'auto',
                DayHeaders: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    position: 'sticky',
                    top: '0',
                    background: 'inkMid',
                    zIndex: '1',
                    TimeCol: {
                        padding: 'Z'
                    },
                    MonHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText',
                        borderLeft: '1px solid inkBorder',
                        text: 'MON 17'
                    },
                    TueHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'teal',
                        borderLeft: '1px solid inkBorder',
                        text: 'TUE 18'
                    },
                    WedHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'teal',
                        borderLeft: '1px solid inkBorder',
                        text: 'WED 19',
                        background: 'teal.05'
                    },
                    ThuHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText',
                        borderLeft: '1px solid inkBorder',
                        text: 'THU 20'
                    },
                    FriHead: {
                        padding: 'Z Y',
                        textAlign: 'center',
                        fontSize: 'Y',
                        fontWeight: '600',
                        color: 'inkText',
                        borderLeft: '1px solid inkBorder',
                        text: 'FRI 21'
                    }
                },
                Row0800: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkMuted',
                        textAlign: 'right',
                        text: '08:00'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row0900: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '09:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Crown Prep #14',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'T. Kapanadze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1000: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '10:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'RCT #36',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'G. Beridze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1100: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '11:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03',
                        Evt: {
                            text: 'Implant Consult',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'N. Kapanadze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1200: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '12:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        LunchLabel: {
                            text: "\u2014 Lunch \u2014",
                            fontSize: 'Y',
                            color: 'inkMuted',
                            fontStyle: 'italic'
                        }
                    }
                },
                Row1300: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '13:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Veneer Prep #11',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'K. Gabrichidze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Completed',
                                fontSize: 'Y',
                                color: 'teal',
                                fontWeight: '600'
                            }
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Composite #25',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'S. Meladze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    }
                },
                Row1400: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '14:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Bridge Prep #34-36',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'R. Kharazishvili',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03',
                        Evt: {
                            text: 'Extraction #48',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'V. Papunashvili',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Completed',
                                fontSize: 'Y',
                                color: 'teal',
                                fontWeight: '600'
                            }
                        }
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1500: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '15:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Crown Seat #14',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid teal',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'teal.08',
                            PatName: {
                                text: 'T. Kapanadze',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'Confirmed',
                                fontSize: 'Y',
                                color: 'green',
                                fontWeight: '600'
                            }
                        }
                    }
                },
                Row1600: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    borderBottom: '1px solid inkBorder',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '16:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                },
                Row1700: {
                    display: 'grid',
                    gridTemplateColumns: '60px repeat(5, 1fr)',
                    minHeight: 'C',
                    TimeLabel: {
                        padding: 'Y Z',
                        fontSize: 'Y',
                        color: 'inkSubtle',
                        textAlign: 'right',
                        text: '17:00',
                        fontWeight: '600'
                    },
                    MonSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    TueSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        Evt: {
                            text: 'Emergency Walk-in',
                            fontSize: 'Z',
                            padding: 'Y Z',
                            round: 'Y',
                            borderLeft: '3px solid red',
                            paddingLeft: 'Y',
                            color: 'inkText',
                            background: 'red.08',
                            PatName: {
                                text: 'L. Mchedlishvili',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            },
                            StatusTag: {
                                text: 'In Chair',
                                fontSize: 'Y',
                                color: 'blue',
                                fontWeight: '600'
                            }
                        }
                    },
                    WedSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y',
                        background: 'teal.03'
                    },
                    ThuSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    },
                    FriSlot: {
                        borderLeft: '1px solid inkBorder',
                        padding: 'Y'
                    }
                }
            }
        },
        MobileTabBar: {}
    }
};


const $d4a053fc05e2465c$var$BASE_TEMPLATES = [
    {
        id: 't1',
        name: 'Standard Consultation',
        type: 'Consultation',
        fields: 12,
        description: 'Full SOAP notes, vitals, and treatment plan entry',
        lastUsed: 'Mar 18, 2026',
        usageCount: 248,
        icon: 'clipboard',
        color: 'teal',
        custom: false
    },
    {
        id: 't2',
        name: 'Follow-up Visit',
        type: 'Follow-up',
        fields: 8,
        description: 'Progress check with abbreviated SOAP and status update',
        lastUsed: 'Mar 19, 2026',
        usageCount: 186,
        icon: 'refreshCw',
        color: 'blue',
        custom: false
    },
    {
        id: 't3',
        name: 'Treatment Record',
        type: 'Treatment',
        fields: 14,
        description: 'Procedure record with materials, tooth chart, and clinical notes',
        lastUsed: 'Mar 17, 2026',
        usageCount: 312,
        icon: 'tool',
        color: 'purple',
        custom: false
    },
    {
        id: 't4',
        name: 'Surgical Procedure',
        type: 'Surgery',
        fields: 16,
        description: 'Pre-op, intraoperative notes, anesthesia, and post-op instructions',
        lastUsed: 'Mar 15, 2026',
        usageCount: 67,
        icon: 'activity',
        color: 'red',
        custom: false
    },
    {
        id: 't5',
        name: 'Diagnosis Report',
        type: 'Diagnosis',
        fields: 10,
        description: 'ICD-10 coding, findings, severity, and treatment recommendation',
        lastUsed: 'Mar 16, 2026',
        usageCount: 143,
        icon: 'search',
        color: 'amber',
        custom: false
    },
    {
        id: 't6',
        name: 'Prescription',
        type: 'Prescription',
        fields: 7,
        description: 'Drug, dosage, frequency, instructions, and allergy check',
        lastUsed: 'Mar 18, 2026',
        usageCount: 201,
        icon: 'fileText',
        color: 'green',
        custom: false
    },
    {
        id: 't7',
        name: 'Imaging / Radiology',
        type: 'Imaging',
        fields: 9,
        description: 'X-ray/CBCT/Pano findings, annotations, and file attachments',
        lastUsed: 'Mar 14, 2026',
        usageCount: 159,
        icon: 'aperture',
        color: 'violet',
        custom: false
    },
    {
        id: 't8',
        name: 'Lab Result Entry',
        type: 'Lab Result',
        fields: 6,
        description: 'Lab order tracking, results, pathology notes, and follow-up actions',
        lastUsed: 'Mar 12, 2026',
        usageCount: 44,
        icon: 'flask',
        color: 'orange',
        custom: false
    },
    {
        id: 't9',
        name: 'Referral Note',
        type: 'Referral',
        fields: 11,
        description: 'Specialty, reason, urgency, attached records, and follow-up',
        lastUsed: 'Mar 17, 2026',
        usageCount: 88,
        icon: 'send',
        color: 'teal',
        custom: false
    },
    {
        id: 't10',
        name: 'Clinical Note',
        type: 'Note',
        fields: 4,
        description: 'Free-form clinical note with tags, visibility, and attachments',
        lastUsed: 'Mar 19, 2026',
        usageCount: 97,
        icon: 'edit',
        color: 'inkMuted',
        custom: false
    }
];
const $d4a053fc05e2465c$var$CUSTOM_TEMPLATES = [
    {
        id: 'ct1',
        name: 'Implant Assessment',
        type: 'Consultation',
        fields: 18,
        description: 'Extended implant workup: CBCT review, bone density, prosthetic planning',
        lastUsed: 'Mar 10, 2026',
        usageCount: 23,
        icon: 'clipboard',
        color: 'teal',
        custom: true,
        createdBy: 'Dr. Kvaratskhelia'
    },
    {
        id: 'ct2',
        name: 'Perio Maintenance',
        type: 'Treatment',
        fields: 13,
        description: 'Recall visit: probing, BOP, plaque index, calculus, SRP notes',
        lastUsed: 'Mar 16, 2026',
        usageCount: 41,
        icon: 'tool',
        color: 'blue',
        custom: true,
        createdBy: 'Dr. Lomidze'
    },
    {
        id: 'ct3',
        name: 'Ortho Progress Check',
        type: 'Follow-up',
        fields: 9,
        description: 'Aligner/wire change, measurements, photos, patient compliance',
        lastUsed: 'Mar 8, 2026',
        usageCount: 17,
        icon: 'refreshCw',
        color: 'purple',
        custom: true,
        createdBy: 'Dr. Beridze'
    }
];
const $d4a053fc05e2465c$export$a8fc3402335b0b04 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'templates',
                            tplFilter: 'all'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            PageHeader: {
                flow: 'x',
                align: 'center space-between',
                flexWrap: 'wrap',
                gap: 'Z',
                HeaderLeft: {
                    flow: 'y',
                    gap: 'X',
                    PageTitle: {
                        tag: 'h1',
                        text: 'Record Templates',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'inkText',
                        letterSpacing: '-0.02em'
                    },
                    PageSubtitle: {
                        text: "10 base templates \xb7 3 custom",
                        fontSize: 'Z',
                        color: 'inkMuted'
                    }
                },
                NewTemplateBtn: {
                    tag: 'button',
                    text: '+ Create Custom Template',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    background: 'teal',
                    color: 'ink',
                    border: 'none',
                    cursor: 'pointer'
                }
            },
            StatsRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                StatBase: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'F',
                    StatVal: {
                        text: '10',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'teal',
                        letterSpacing: '-0.02em'
                    },
                    StatLbl: {
                        text: 'Base Templates',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatCustom: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'F',
                    StatVal: {
                        text: '3',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'purple',
                        letterSpacing: '-0.02em'
                    },
                    StatLbl: {
                        text: 'Custom Templates',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatUsages: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'F',
                    StatVal: {
                        text: '1,545',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'green',
                        letterSpacing: '-0.02em'
                    },
                    StatLbl: {
                        text: 'Total Uses This Month',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatTypes: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'F',
                    StatVal: {
                        text: '7',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'amber',
                        letterSpacing: '-0.02em'
                    },
                    StatLbl: {
                        text: 'Active Record Types',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                }
            },
            FilterBar: {
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                AllPill: {
                    tag: 'button',
                    text: 'All',
                    padding: 'Y Z',
                    round: 'C',
                    fontSize: 'Y',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    background: (el, s)=>(s.root.tplFilter || 'all') === 'all' ? 'inkText' : 'inkSurface',
                    color: (el, s)=>(s.root.tplFilter || 'all') === 'all' ? 'ink' : 'inkMuted',
                    onClick: (e, el, s)=>s.root.update({
                            tplFilter: 'all'
                        })
                },
                BasePill: {
                    tag: 'button',
                    text: 'Base',
                    padding: 'Y Z',
                    round: 'C',
                    fontSize: 'Y',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.tplFilter === 'base' ? 'teal.15' : 'inkSurface',
                    color: (el, s)=>s.root.tplFilter === 'base' ? 'teal' : 'inkMuted',
                    onClick: (e, el, s)=>s.root.update({
                            tplFilter: 'base'
                        })
                },
                CustomPill: {
                    tag: 'button',
                    text: 'Custom',
                    padding: 'Y Z',
                    round: 'C',
                    fontSize: 'Y',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.tplFilter === 'custom' ? 'purple.15' : 'inkSurface',
                    color: (el, s)=>s.root.tplFilter === 'custom' ? 'purple' : 'inkMuted',
                    onClick: (e, el, s)=>s.root.update({
                            tplFilter: 'custom'
                        })
                }
            },
            // ─── BASE TEMPLATES ────────────────────────────
            BaseTplSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>(s.root.tplFilter || 'all') !== 'custom',
                SectionHead: {
                    flow: 'x',
                    align: 'center flex-start',
                    gap: 'Z',
                    SectionTitle: {
                        text: 'Base Templates',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    SectionBadge: {
                        tag: 'span',
                        text: '10',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'X Y',
                        round: 'C',
                        background: 'inkSurface',
                        color: 'inkMuted'
                    }
                },
                BaseTplGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                    gap: 'A',
                    children: $d4a053fc05e2465c$var$BASE_TEMPLATES,
                    childrenAs: 'state',
                    childExtends: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        cursor: 'pointer',
                        CardTop: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            marginBottom: 'X',
                            CardIcon: {
                                width: 'C',
                                height: 'C',
                                round: 'Y',
                                flexShrink: '0',
                                flow: 'x',
                                align: 'center center',
                                background: (el, s)=>(s.color || 'teal') + '.12',
                                CardIconInner: {
                                    extends: 'Icon',
                                    icon: (el, s)=>s.icon || 'clipboard',
                                    width: 'B',
                                    height: 'B',
                                    color: (el, s)=>s.color || 'teal'
                                }
                            },
                            CardMeta: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                CardName: {
                                    text: (el, s)=>s.name,
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                CardType: {
                                    tag: 'span',
                                    text: (el, s)=>s.type,
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: (el, s)=>s.color || 'teal'
                                }
                            }
                        },
                        CardDesc: {
                            text: (el, s)=>s.description,
                            fontSize: 'Y',
                            color: 'inkMuted',
                            lineHeight: '1.5',
                            flex: '1'
                        },
                        CardFooter: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center space-between',
                            paddingTop: 'Z',
                            borderTop: '1px solid inkBorder',
                            marginTop: 'Y',
                            FooterMeta: {
                                flow: 'y',
                                gap: 'X',
                                FieldCount: {
                                    text: (el, s)=>(s.fields || 0) + ' fields',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                },
                                UsageCount: {
                                    text: (el, s)=>'Used ' + (s.usageCount || 0) + 'x',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            FooterActions: {
                                flow: 'x',
                                gap: 'Y',
                                UseBtn: {
                                    tag: 'button',
                                    text: 'Use',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Z',
                                    round: 'Y',
                                    background: 'teal',
                                    color: 'ink',
                                    border: 'none',
                                    cursor: 'pointer'
                                },
                                EditBtn: {
                                    tag: 'button',
                                    text: 'Edit',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Z',
                                    round: 'Y',
                                    background: 'inkSurface',
                                    color: 'inkText',
                                    border: '1px solid inkBorder',
                                    cursor: 'pointer'
                                }
                            }
                        }
                    }
                }
            },
            // ─── CUSTOM TEMPLATES ──────────────────────────
            CustomTplSection: {
                flow: 'y',
                gap: 'A',
                show: (el, s)=>(s.root.tplFilter || 'all') !== 'base',
                SectionHead2: {
                    flow: 'x',
                    align: 'center flex-start',
                    gap: 'Z',
                    SectionTitle2: {
                        text: 'Custom Templates',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'inkText'
                    },
                    SectionBadge2: {
                        tag: 'span',
                        text: '3',
                        fontSize: 'Y',
                        fontWeight: '600',
                        padding: 'X Y',
                        round: 'C',
                        background: 'purple.12',
                        color: 'purple'
                    }
                },
                CustomTplGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                    gap: 'A',
                    children: $d4a053fc05e2465c$var$CUSTOM_TEMPLATES,
                    childrenAs: 'state',
                    childExtends: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid purple.20',
                        cursor: 'pointer',
                        CardTop2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            marginBottom: 'X',
                            CardIcon2: {
                                width: 'C',
                                height: 'C',
                                round: 'Y',
                                flexShrink: '0',
                                flow: 'x',
                                align: 'center center',
                                background: (el, s)=>(s.color || 'purple') + '.12',
                                CardIconInner2: {
                                    extends: 'Icon',
                                    icon: (el, s)=>s.icon || 'clipboard',
                                    width: 'B',
                                    height: 'B',
                                    color: (el, s)=>s.color || 'purple'
                                }
                            },
                            CardMeta2: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                CardName2: {
                                    text: (el, s)=>s.name,
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                CardTypeMeta: {
                                    flow: 'x',
                                    gap: 'Y',
                                    align: 'center flex-start',
                                    CardType2: {
                                        tag: 'span',
                                        text: (el, s)=>s.type,
                                        fontSize: 'Y',
                                        fontWeight: '600',
                                        color: (el, s)=>s.color || 'purple'
                                    },
                                    CustomBadge: {
                                        tag: 'span',
                                        text: 'Custom',
                                        fontSize: 'X',
                                        fontWeight: '600',
                                        padding: 'X Y',
                                        round: 'C',
                                        background: 'purple.12',
                                        color: 'purple'
                                    }
                                }
                            }
                        },
                        CardDesc2: {
                            text: (el, s)=>s.description,
                            fontSize: 'Y',
                            color: 'inkMuted',
                            lineHeight: '1.5',
                            flex: '1'
                        },
                        CardFooter2: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center space-between',
                            paddingTop: 'Z',
                            borderTop: '1px solid inkBorder',
                            marginTop: 'Y',
                            FooterMeta2: {
                                flow: 'y',
                                gap: 'X',
                                FieldCount2: {
                                    text: (el, s)=>(s.fields || 0) + ' fields',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                },
                                CreatedBy: {
                                    text: (el, s)=>'By ' + (s.createdBy || 'Unknown'),
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            FooterActions2: {
                                flow: 'x',
                                gap: 'Y',
                                UseBtn2: {
                                    tag: 'button',
                                    text: 'Use',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Z',
                                    round: 'Y',
                                    background: 'purple',
                                    color: 'white',
                                    border: 'none',
                                    cursor: 'pointer'
                                },
                                EditBtn2: {
                                    tag: 'button',
                                    text: 'Edit',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Z',
                                    round: 'Y',
                                    background: 'inkSurface',
                                    color: 'inkText',
                                    border: '1px solid inkBorder',
                                    cursor: 'pointer'
                                },
                                DupBtn: {
                                    tag: 'button',
                                    text: 'Duplicate',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Z',
                                    round: 'Y',
                                    background: 'inkSurface',
                                    color: 'inkMuted',
                                    border: '1px solid inkBorder',
                                    cursor: 'pointer'
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};


const $5a331253da4c0af9$var$FIELD_TYPES = [
    {
        id: 'ft1',
        label: 'Text Input',
        icon: 'type',
        desc: 'Single-line text'
    },
    {
        id: 'ft2',
        label: 'Text Area',
        icon: 'alignLeft',
        desc: 'Multi-line text'
    },
    {
        id: 'ft3',
        label: 'Date Picker',
        icon: 'calendar',
        desc: 'Date or date range'
    },
    {
        id: 'ft4',
        label: 'Dropdown',
        icon: 'chevronDown',
        desc: 'Select from list'
    },
    {
        id: 'ft5',
        label: 'Checkbox',
        icon: 'checkSquare',
        desc: 'Yes / No toggle'
    },
    {
        id: 'ft6',
        label: 'Multi-select',
        icon: 'list',
        desc: 'Multiple choices'
    },
    {
        id: 'ft7',
        label: 'Number',
        icon: 'hash',
        desc: 'Numeric value'
    },
    {
        id: 'ft8',
        label: 'Signature',
        icon: 'edit',
        desc: 'E-signature pad'
    },
    {
        id: 'ft9',
        label: 'Tooth Selector',
        icon: 'grid',
        desc: 'Dental chart picker'
    },
    {
        id: 'ft10',
        label: 'File Upload',
        icon: 'upload',
        desc: 'Document or image'
    }
];
const $5a331253da4c0af9$var$FORM_LIBRARY = [
    {
        id: 'f1',
        name: 'New Patient Intake',
        category: 'Intake',
        fields: 22,
        status: 'Active',
        lastEdited: 'Mar 12, 2026',
        submissions: 148,
        createdBy: 'Dr. Kvaratskhelia'
    },
    {
        id: 'f2',
        name: 'Medical History Update',
        category: 'History',
        fields: 31,
        status: 'Active',
        lastEdited: 'Feb 28, 2026',
        submissions: 203,
        createdBy: 'Admin'
    },
    {
        id: 'f3',
        name: 'Pain Assessment Form',
        category: 'Clinical',
        fields: 9,
        status: 'Active',
        lastEdited: 'Mar 1, 2026',
        submissions: 89,
        createdBy: 'Dr. Lomidze'
    },
    {
        id: 'f4',
        name: 'Post-Op Instructions',
        category: 'Clinical',
        fields: 6,
        status: 'Draft',
        lastEdited: 'Mar 17, 2026',
        submissions: 0,
        createdBy: 'Dr. Beridze'
    },
    {
        id: 'f5',
        name: 'Perio Screening Chart',
        category: 'Clinical',
        fields: 14,
        status: 'Active',
        lastEdited: 'Mar 5, 2026',
        submissions: 62,
        createdBy: 'Dr. Kvaratskhelia'
    },
    {
        id: 'f6',
        name: 'Treatment Satisfaction Survey',
        category: 'Feedback',
        fields: 8,
        status: 'Active',
        lastEdited: 'Mar 10, 2026',
        submissions: 97,
        createdBy: 'Admin'
    }
];
const $5a331253da4c0af9$var$ACTIVE_FIELDS = [
    {
        id: 'af1',
        label: 'Patient Full Name',
        type: 'Text Input',
        required: true
    },
    {
        id: 'af2',
        label: 'Date of Birth',
        type: 'Date Picker',
        required: true
    },
    {
        id: 'af3',
        label: 'Chief Complaint',
        type: 'Text Area',
        required: true
    },
    {
        id: 'af4',
        label: "Pain Level (1\u201310)",
        type: 'Number',
        required: false
    },
    {
        id: 'af5',
        label: 'Affected Tooth',
        type: 'Tooth Selector',
        required: false
    },
    {
        id: 'af6',
        label: 'Duration of Symptoms',
        type: 'Dropdown',
        required: false
    },
    {
        id: 'af7',
        label: 'Previous Treatment',
        type: 'Checkbox',
        required: false
    },
    {
        id: 'af8',
        label: 'Additional Notes',
        type: 'Text Area',
        required: false
    }
];
const $5a331253da4c0af9$export$b76a50d99a15c808 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'templates',
                            fbView: 'library'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            PageHeader: {
                flow: 'x',
                align: 'center space-between',
                flexWrap: 'wrap',
                gap: 'Z',
                HeaderLeft: {
                    flow: 'y',
                    gap: 'X',
                    PageTitle: {
                        tag: 'h1',
                        text: 'Form Builder',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'inkText',
                        letterSpacing: '-0.02em'
                    },
                    PageSubtitle: {
                        text: 'Design custom intake and clinical forms for your patients',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    }
                },
                NewFormBtn: {
                    tag: 'button',
                    text: '+ New Form',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    background: 'teal',
                    color: 'ink',
                    border: 'none',
                    cursor: 'pointer',
                    onClick: (e, el, s)=>s.root.update({
                            fbView: 'builder'
                        })
                }
            },
            ViewTabs: {
                flow: 'x',
                gap: 'Z',
                borderBottom: '1px solid inkBorder',
                paddingBottom: 'Y',
                LibraryTab: {
                    text: 'Form Library',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>(s.root.fbView || 'library') === 'library' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>(s.root.fbView || 'library') === 'library' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            fbView: 'library'
                        })
                },
                BuilderTab: {
                    text: 'Builder',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Y Z',
                    cursor: 'pointer',
                    color: (el, s)=>s.root.fbView === 'builder' ? 'teal' : 'inkMuted',
                    borderBottom: (el, s)=>s.root.fbView === 'builder' ? '2px solid teal' : '2px solid transparent',
                    onClick: (e, el, s)=>s.root.update({
                            fbView: 'builder'
                        })
                }
            },
            // ─── LIBRARY VIEW ──────────────────────────────
            LibraryView: {
                show: (el, s)=>(s.root.fbView || 'library') === 'library',
                flow: 'y',
                gap: 'A',
                LibraryStats: {
                    flow: 'x',
                    gap: 'A',
                    flexWrap: 'wrap',
                    StatActive: {
                        flow: 'y',
                        gap: 'X',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'F',
                        SVal: {
                            text: '5',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'teal',
                            letterSpacing: '-0.02em'
                        },
                        SLbl: {
                            text: 'Active Forms',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    StatDraft: {
                        flow: 'y',
                        gap: 'X',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'F',
                        SVal: {
                            text: '1',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'amber',
                            letterSpacing: '-0.02em'
                        },
                        SLbl: {
                            text: 'Draft Forms',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    StatSubs: {
                        flow: 'y',
                        gap: 'X',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flex: '1',
                        minWidth: 'F',
                        SVal: {
                            text: '599',
                            fontSize: 'C',
                            fontWeight: '700',
                            color: 'green',
                            letterSpacing: '-0.02em'
                        },
                        SLbl: {
                            text: 'Total Submissions',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                },
                FormList: {
                    flow: 'y',
                    gap: 'Z',
                    children: $5a331253da4c0af9$var$FORM_LIBRARY,
                    childrenAs: 'state',
                    childExtends: {
                        flow: 'x',
                        gap: 'A',
                        align: 'center space-between',
                        padding: 'A',
                        round: 'A',
                        background: 'inkMid',
                        border: '1px solid inkBorder',
                        flexWrap: 'wrap',
                        FormInfo: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center flex-start',
                            flex: '1',
                            minWidth: '200px',
                            FormIconWrap: {
                                width: 'D',
                                height: 'D',
                                round: 'Y',
                                flexShrink: '0',
                                flow: 'x',
                                align: 'center center',
                                background: 'teal.10',
                                FIcon: {
                                    extends: 'Icon',
                                    icon: 'fileText',
                                    width: 'B',
                                    height: 'B',
                                    color: 'teal'
                                }
                            },
                            FormMeta: {
                                flow: 'y',
                                gap: 'X',
                                FormName: {
                                    text: (el, s)=>s.name,
                                    fontSize: 'Z',
                                    fontWeight: '700',
                                    color: 'inkText'
                                },
                                FormMetaRow: {
                                    flow: 'x',
                                    gap: 'Z',
                                    flexWrap: 'wrap',
                                    FormCat: {
                                        tag: 'span',
                                        text: (el, s)=>s.category,
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    },
                                    MetaDot: {
                                        tag: 'span',
                                        text: "\xb7",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    },
                                    FormFields: {
                                        text: (el, s)=>(s.fields || 0) + ' fields',
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    },
                                    MetaDot2: {
                                        tag: 'span',
                                        text: "\xb7",
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    },
                                    FormSubs: {
                                        text: (el, s)=>(s.submissions || 0) + ' submissions',
                                        fontSize: 'Y',
                                        color: 'inkMuted'
                                    }
                                }
                            }
                        },
                        FormRight: {
                            flow: 'x',
                            gap: 'A',
                            align: 'center center',
                            StatusBadge: {
                                tag: 'span',
                                text: (el, s)=>s.status,
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'B',
                                background: (el, s)=>s.status === 'Active' ? 'green.12' : 'amber.12',
                                color: (el, s)=>s.status === 'Active' ? 'green' : 'amber'
                            },
                            FormActions: {
                                flow: 'x',
                                gap: 'Y',
                                PreviewBtn: {
                                    tag: 'button',
                                    text: 'Preview',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Z',
                                    round: 'Y',
                                    background: 'inkSurface',
                                    color: 'inkMuted',
                                    border: '1px solid inkBorder',
                                    cursor: 'pointer'
                                },
                                EditBtn: {
                                    tag: 'button',
                                    text: 'Edit',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Z',
                                    round: 'Y',
                                    background: 'teal',
                                    color: 'ink',
                                    border: 'none',
                                    cursor: 'pointer',
                                    onClick: (e, el, s)=>s.root.update({
                                            fbView: 'builder'
                                        })
                                }
                            }
                        }
                    }
                }
            },
            // ─── BUILDER VIEW ──────────────────────────────
            BuilderView: {
                show: (el, s)=>s.root.fbView === 'builder',
                flow: 'x',
                gap: 'A',
                align: 'flex-start',
                '@mobileL': {
                    flow: 'y'
                },
                FieldPalette: {
                    flow: 'y',
                    gap: 'Z',
                    width: 'I',
                    flexShrink: '0',
                    '@mobileL': {
                        width: '100%'
                    },
                    PaletteHeader: {
                        flow: 'y',
                        gap: 'X',
                        marginBottom: 'Y',
                        PaletteTitle: {
                            text: 'Field Types',
                            fontSize: 'Z',
                            fontWeight: '700',
                            color: 'inkText'
                        },
                        PaletteSub: {
                            text: 'Click to add to form',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    },
                    FieldList: {
                        flow: 'y',
                        gap: 'Y',
                        children: $5a331253da4c0af9$var$FIELD_TYPES,
                        childrenAs: 'state',
                        childExtends: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Y Z',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            cursor: 'pointer',
                            FieldIcon: {
                                extends: 'Icon',
                                icon: (el, s)=>s.icon || 'type',
                                width: 'B',
                                height: 'B',
                                color: 'teal',
                                flexShrink: '0'
                            },
                            FieldInfo: {
                                flow: 'y',
                                gap: 'X',
                                FieldLabel: {
                                    text: (el, s)=>s.label,
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    color: 'inkText'
                                },
                                FieldDesc: {
                                    text: (el, s)=>s.desc,
                                    fontSize: 'X',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    }
                },
                BuilderCanvas: {
                    flow: 'y',
                    gap: 'Z',
                    flex: '1',
                    CanvasHeader: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'Z A',
                        background: 'inkMid',
                        round: 'A',
                        border: '1px solid inkBorder',
                        marginBottom: 'Y',
                        CanvasLeft: {
                            flow: 'y',
                            gap: 'X',
                            FormNameInput: {
                                tag: 'input',
                                type: 'text',
                                value: 'New Patient Intake',
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText',
                                background: 'transparent',
                                border: 'none',
                                outline: 'none',
                                padding: '0'
                            },
                            FormCategory: {
                                tag: 'span',
                                text: 'Category: Intake',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        CanvasActions: {
                            flow: 'x',
                            gap: 'Z',
                            SaveDraftBtn: {
                                tag: 'button',
                                text: 'Save Draft',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'inkSurface',
                                color: 'inkText',
                                border: '1px solid inkBorder',
                                cursor: 'pointer'
                            },
                            PublishBtn: {
                                tag: 'button',
                                text: 'Publish Form',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'Y Z',
                                round: 'Y',
                                background: 'teal',
                                color: 'ink',
                                border: 'none',
                                cursor: 'pointer'
                            }
                        }
                    },
                    CanvasFields: {
                        flow: 'y',
                        gap: 'Z',
                        children: $5a331253da4c0af9$var$ACTIVE_FIELDS,
                        childrenAs: 'state',
                        childExtends: {
                            flow: 'x',
                            gap: 'Z',
                            align: 'center flex-start',
                            padding: 'Z A',
                            round: 'Y',
                            background: 'inkMid',
                            border: '1px solid inkBorder',
                            DragHandle: {
                                tag: 'span',
                                text: "\u283F",
                                fontSize: 'A',
                                color: 'inkMuted',
                                cursor: 'grab',
                                flexShrink: '0'
                            },
                            FieldBody: {
                                flow: 'y',
                                gap: 'X',
                                flex: '1',
                                FieldRow: {
                                    flow: 'x',
                                    gap: 'Z',
                                    align: 'center flex-start',
                                    FieldLabelText: {
                                        text: (el, s)=>s.label,
                                        fontSize: 'Z',
                                        fontWeight: '600',
                                        color: 'inkText'
                                    },
                                    RequiredDot: {
                                        tag: 'span',
                                        text: (el, s)=>s.required ? ' *' : '',
                                        fontSize: 'Z',
                                        color: 'red',
                                        fontWeight: '700'
                                    }
                                },
                                FieldTypePill: {
                                    tag: 'span',
                                    text: (el, s)=>s.type,
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            },
                            FieldActions: {
                                flow: 'x',
                                gap: 'Y',
                                flexShrink: '0',
                                RequireToggle: {
                                    tag: 'span',
                                    text: (el, s)=>s.required ? 'Required' : 'Optional',
                                    fontSize: 'Y',
                                    fontWeight: '600',
                                    padding: 'X Y',
                                    round: 'C',
                                    background: (el, s)=>s.required ? 'teal.12' : 'inkSurface',
                                    color: (el, s)=>s.required ? 'teal' : 'inkMuted',
                                    cursor: 'pointer'
                                },
                                DeleteField: {
                                    extends: 'Icon',
                                    icon: 'trash2',
                                    width: 'B',
                                    height: 'B',
                                    color: 'inkMuted',
                                    cursor: 'pointer'
                                }
                            }
                        }
                    },
                    AddFieldHint: {
                        flow: 'x',
                        gap: 'Z',
                        align: 'center center',
                        padding: 'A',
                        round: 'A',
                        border: '1px dashed inkBorder',
                        color: 'inkMuted',
                        cursor: 'pointer',
                        marginTop: 'Y',
                        AddIcon: {
                            extends: 'Icon',
                            icon: 'plus',
                            width: 'B',
                            height: 'B',
                            color: 'inkMuted'
                        },
                        AddText: {
                            text: 'Click a field type on the left to add',
                            fontSize: 'Y',
                            color: 'inkMuted'
                        }
                    }
                }
            }
        }
    }
};


const $1fd454a3354bd208$var$CONSENT_TEMPLATES = [
    {
        id: 'ctp1',
        name: 'Root Canal Treatment',
        category: 'Endodontics',
        fields: 14,
        signedCount: 312,
        lastUsed: 'Mar 18, 2026',
        status: 'Active',
        risk: 'Medium',
        version: 'v3.1',
        icon: 'activity',
        color: 'red'
    },
    {
        id: 'ctp2',
        name: 'Tooth Extraction',
        category: 'Oral Surgery',
        fields: 12,
        signedCount: 487,
        lastUsed: 'Mar 19, 2026',
        status: 'Active',
        risk: 'Medium',
        version: 'v2.4',
        icon: 'tool',
        color: 'amber'
    },
    {
        id: 'ctp3',
        name: 'Dental Implant Placement',
        category: 'Implantology',
        fields: 18,
        signedCount: 143,
        lastUsed: 'Mar 17, 2026',
        status: 'Active',
        risk: 'High',
        version: 'v4.0',
        icon: 'anchor',
        color: 'purple'
    },
    {
        id: 'ctp4',
        name: 'Crown & Bridge Procedure',
        category: 'Restorative',
        fields: 11,
        signedCount: 228,
        lastUsed: 'Mar 16, 2026',
        status: 'Active',
        risk: 'Low',
        version: 'v2.2',
        icon: 'shield',
        color: 'blue'
    },
    {
        id: 'ctp5',
        name: 'Orthodontic Treatment',
        category: 'Orthodontics',
        fields: 16,
        signedCount: 89,
        lastUsed: 'Mar 10, 2026',
        status: 'Active',
        risk: 'Low',
        version: 'v1.8',
        icon: 'sliders',
        color: 'teal'
    },
    {
        id: 'ctp6',
        name: 'Periodontal Surgery',
        category: 'Periodontics',
        fields: 15,
        signedCount: 64,
        lastUsed: 'Mar 8, 2026',
        status: 'Active',
        risk: 'High',
        version: 'v3.0',
        icon: 'scissors',
        color: 'red'
    },
    {
        id: 'ctp7',
        name: 'Teeth Whitening',
        category: 'Cosmetic',
        fields: 8,
        signedCount: 201,
        lastUsed: 'Mar 18, 2026',
        status: 'Active',
        risk: 'Low',
        version: 'v1.5',
        icon: 'sun',
        color: 'amber'
    },
    {
        id: 'ctp8',
        name: 'IV Sedation / Anesthesia',
        category: 'Anesthesia',
        fields: 22,
        signedCount: 37,
        lastUsed: 'Mar 14, 2026',
        status: 'Active',
        risk: 'High',
        version: 'v5.2',
        icon: 'droplet',
        color: 'violet'
    },
    {
        id: 'ctp9',
        name: 'Bone Grafting',
        category: 'Oral Surgery',
        fields: 17,
        signedCount: 52,
        lastUsed: 'Mar 12, 2026',
        status: 'Active',
        risk: 'High',
        version: 'v2.7',
        icon: 'layers',
        color: 'orange'
    },
    {
        id: 'ctp10',
        name: 'General Dental Treatment',
        category: 'General',
        fields: 9,
        signedCount: 634,
        lastUsed: 'Mar 19, 2026',
        status: 'Active',
        risk: 'Low',
        version: 'v1.2',
        icon: 'clipboard',
        color: 'green'
    },
    {
        id: 'ctp11',
        name: 'Pediatric Sedation',
        category: 'Pediatric',
        fields: 20,
        signedCount: 28,
        lastUsed: 'Mar 7, 2026',
        status: 'Active',
        risk: 'High',
        version: 'v3.3',
        icon: 'heart',
        color: 'pink'
    },
    {
        id: 'ctp12',
        name: 'Photography & Media Use',
        category: 'Administrative',
        fields: 5,
        signedCount: 179,
        lastUsed: 'Mar 15, 2026',
        status: 'Draft',
        risk: 'Low',
        version: 'v1.0',
        icon: 'camera',
        color: 'inkMuted'
    }
];
const $1fd454a3354bd208$export$5dc27ed9ff714f57 = {
    extends: 'Page',
    flow: 'x',
    minHeight: '100vh',
    background: 'ink',
    color: 'inkText',
    TabInit: {
        display: 'none',
        show: (()=>{
            let d = false;
            return (el, s)=>{
                if (!d) {
                    d = true;
                    Promise.resolve().then(()=>s.root.update({
                            activeTab: 'templates',
                            ctFilter: 'all'
                        }));
                }
                return false;
            };
        })()
    },
    NavSidebar: {},
    MainContent: {
        flow: 'y',
        flex: '1',
        overflow: 'auto',
        TopBar: {},
        ContentArea: {
            flow: 'y',
            gap: 'B',
            padding: 'B',
            flex: '1',
            '@mobileL': {
                padding: 'A'
            },
            PageHeader: {
                flow: 'x',
                align: 'center space-between',
                flexWrap: 'wrap',
                gap: 'Z',
                HeaderLeft: {
                    flow: 'y',
                    gap: 'X',
                    PageTitle: {
                        tag: 'h1',
                        text: 'Consent Templates',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'inkText',
                        letterSpacing: '-0.02em'
                    },
                    PageSubtitle: {
                        text: 'Manage informed consent forms for all procedures',
                        fontSize: 'Z',
                        color: 'inkMuted'
                    }
                },
                NewConsentBtn: {
                    tag: 'button',
                    text: '+ New Template',
                    fontSize: 'Z',
                    fontWeight: '600',
                    padding: 'Z A',
                    round: 'A',
                    background: 'teal',
                    color: 'ink',
                    border: 'none',
                    cursor: 'pointer'
                }
            },
            StatsRow: {
                flow: 'x',
                gap: 'A',
                flexWrap: 'wrap',
                StatTemplates: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'F',
                    SVal: {
                        text: '11',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'teal',
                        letterSpacing: '-0.02em'
                    },
                    SLbl: {
                        text: 'Active Templates',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatSigned: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flex: '1',
                    minWidth: 'F',
                    SVal: {
                        text: '2,454',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'green',
                        letterSpacing: '-0.02em'
                    },
                    SLbl: {
                        text: 'Total Signed',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatHighRisk: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid red.20',
                    flex: '1',
                    minWidth: 'F',
                    SVal: {
                        text: '5',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'red',
                        letterSpacing: '-0.02em'
                    },
                    SLbl: {
                        text: 'High-Risk Procedures',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                },
                StatDraft: {
                    flow: 'y',
                    gap: 'X',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid amber.20',
                    flex: '1',
                    minWidth: 'F',
                    SVal: {
                        text: '1',
                        fontSize: 'C',
                        fontWeight: '700',
                        color: 'amber',
                        letterSpacing: '-0.02em'
                    },
                    SLbl: {
                        text: 'Pending Review',
                        fontSize: 'Y',
                        color: 'inkMuted'
                    }
                }
            },
            FilterRow: {
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                AllPill: {
                    tag: 'button',
                    text: 'All',
                    padding: 'Y Z',
                    round: 'C',
                    fontSize: 'Y',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    background: (el, s)=>(s.root.ctFilter || 'all') === 'all' ? 'inkText' : 'inkSurface',
                    color: (el, s)=>(s.root.ctFilter || 'all') === 'all' ? 'ink' : 'inkMuted',
                    onClick: (e, el, s)=>s.root.update({
                            ctFilter: 'all'
                        })
                },
                HighPill: {
                    tag: 'button',
                    text: 'High Risk',
                    padding: 'Y Z',
                    round: 'C',
                    fontSize: 'Y',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.ctFilter === 'High' ? 'red.15' : 'inkSurface',
                    color: (el, s)=>s.root.ctFilter === 'High' ? 'red' : 'inkMuted',
                    onClick: (e, el, s)=>s.root.update({
                            ctFilter: 'High'
                        })
                },
                MedPill: {
                    tag: 'button',
                    text: 'Medium Risk',
                    padding: 'Y Z',
                    round: 'C',
                    fontSize: 'Y',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.ctFilter === 'Medium' ? 'amber.15' : 'inkSurface',
                    color: (el, s)=>s.root.ctFilter === 'Medium' ? 'amber' : 'inkMuted',
                    onClick: (e, el, s)=>s.root.update({
                            ctFilter: 'Medium'
                        })
                },
                LowPill: {
                    tag: 'button',
                    text: 'Low Risk',
                    padding: 'Y Z',
                    round: 'C',
                    fontSize: 'Y',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    background: (el, s)=>s.root.ctFilter === 'Low' ? 'green.15' : 'inkSurface',
                    color: (el, s)=>s.root.ctFilter === 'Low' ? 'green' : 'inkMuted',
                    onClick: (e, el, s)=>s.root.update({
                            ctFilter: 'Low'
                        })
                }
            },
            ConsentList: {
                flow: 'y',
                gap: 'Z',
                children: (el, s)=>{
                    var filter = s.root.ctFilter || 'all';
                    return filter === 'all' ? $1fd454a3354bd208$var$CONSENT_TEMPLATES : $1fd454a3354bd208$var$CONSENT_TEMPLATES.filter(function(t) {
                        return t.risk === filter;
                    });
                },
                childrenAs: 'state',
                childExtends: {
                    flow: 'x',
                    gap: 'A',
                    align: 'center space-between',
                    padding: 'A',
                    round: 'A',
                    background: 'inkMid',
                    border: '1px solid inkBorder',
                    flexWrap: 'wrap',
                    TemplateInfo: {
                        flow: 'x',
                        gap: 'A',
                        align: 'center flex-start',
                        flex: '1',
                        minWidth: '200px',
                        TemplateIconWrap: {
                            width: 'D',
                            height: 'D',
                            round: 'Y',
                            flexShrink: '0',
                            flow: 'x',
                            align: 'center center',
                            background: (el, s)=>(s.color || 'teal') + '.10',
                            TIcon: {
                                extends: 'Icon',
                                icon: (el, s)=>s.icon || 'clipboard',
                                width: 'B',
                                height: 'B',
                                color: (el, s)=>s.color || 'teal'
                            }
                        },
                        TemplateMeta: {
                            flow: 'y',
                            gap: 'X',
                            TemplateName: {
                                text: (el, s)=>s.name,
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'inkText'
                            },
                            TemplateMetaRow: {
                                flow: 'x',
                                gap: 'Z',
                                align: 'center flex-start',
                                flexWrap: 'wrap',
                                TplCat: {
                                    tag: 'span',
                                    text: (el, s)=>s.category,
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                },
                                Dot1: {
                                    tag: 'span',
                                    text: "\xb7",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                },
                                TplFields: {
                                    text: (el, s)=>(s.fields || 0) + ' fields',
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                },
                                Dot2: {
                                    tag: 'span',
                                    text: "\xb7",
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                },
                                TplVersion: {
                                    text: (el, s)=>s.version,
                                    fontSize: 'Y',
                                    color: 'inkMuted'
                                }
                            }
                        }
                    },
                    TemplateRight: {
                        flow: 'x',
                        gap: 'A',
                        align: 'center center',
                        flexShrink: '0',
                        SignedCount: {
                            flow: 'y',
                            gap: 'X',
                            align: 'flex-end flex-end',
                            SignedNum: {
                                text: (el, s)=>String(s.signedCount || 0),
                                fontSize: 'Z',
                                fontWeight: '700',
                                color: 'teal'
                            },
                            SignedLbl: {
                                text: 'signed',
                                fontSize: 'Y',
                                color: 'inkMuted'
                            }
                        },
                        RiskBadge: {
                            tag: 'span',
                            text: (el, s)=>(s.risk || 'Low') + ' Risk',
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: (el, s)=>s.risk === 'High' ? 'red.12' : s.risk === 'Medium' ? 'amber.12' : 'green.12',
                            color: (el, s)=>s.risk === 'High' ? 'red' : s.risk === 'Medium' ? 'amber' : 'green'
                        },
                        StatusBadge: {
                            tag: 'span',
                            text: (el, s)=>s.status,
                            fontSize: 'Y',
                            fontWeight: '600',
                            padding: 'X Z',
                            round: 'B',
                            background: (el, s)=>s.status === 'Active' ? 'teal.12' : 'amber.12',
                            color: (el, s)=>s.status === 'Active' ? 'teal' : 'amber'
                        },
                        TemplateActions: {
                            flow: 'x',
                            gap: 'Y',
                            PreviewBtn: {
                                tag: 'button',
                                text: 'Preview',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'Y',
                                background: 'inkSurface',
                                color: 'inkMuted',
                                border: '1px solid inkBorder',
                                cursor: 'pointer'
                            },
                            UseBtn: {
                                tag: 'button',
                                text: 'Use',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'Y',
                                background: 'teal',
                                color: 'ink',
                                border: 'none',
                                cursor: 'pointer'
                            },
                            EditBtn: {
                                tag: 'button',
                                text: 'Edit',
                                fontSize: 'Y',
                                fontWeight: '600',
                                padding: 'X Z',
                                round: 'Y',
                                background: 'inkSurface',
                                color: 'inkText',
                                border: '1px solid inkBorder',
                                cursor: 'pointer'
                            }
                        }
                    }
                }
            }
        }
    }
};


var $45001c780dea3812$export$2e2bcd8739ae039 = {
    '/': (0, $8d2c7cae8dfd7a3b$export$a9ae88069d8ac14e),
    '/booking': (0, $1a65142485aed81e$export$8252328d63b22f49),
    '/dashboard': (0, $4a3b6042fbd7c8f3$export$a5f98448b9315739),
    '/patient': (0, $f250953c056a57a9$export$216d10c62dfd0dd9),
    '/patients': (0, $90c7a4816bdf5a4c$export$4a82ecccfc2a9a4a),
    '/ai': (0, $15127687dc86b386$export$f38c853ae54ed474),
    '/clinics': (0, $956d6a891425b558$export$842a8f91a5b0af68),
    '/clinic': (0, $e70a088f651a7ea0$export$222135dc4747ad42),
    '/business': (0, $34df3c86e4d1197d$export$77b22b9e6b40491c),
    // Clinical pages merged into /patient
    '/chart': (0, $f250953c056a57a9$export$216d10c62dfd0dd9),
    '/perio': (0, $f250953c056a57a9$export$216d10c62dfd0dd9),
    '/treatment-plan': (0, $f250953c056a57a9$export$216d10c62dfd0dd9),
    '/clinical-notes': (0, $f250953c056a57a9$export$216d10c62dfd0dd9),
    '/medical-history': (0, $f250953c056a57a9$export$216d10c62dfd0dd9),
    // Operations
    '/scheduling': (0, $3fbc106dffca817d$export$db91f62ac6eecc05),
    '/billing': (0, $942c0fe183543074$export$d87cfcc979a5825c),
    '/prescriptions': (0, $efb21f9094973eba$export$352930477e0e7ab),
    '/lab-cases': (0, $82a9ec07acc8e442$export$6bfc9f488d92f769),
    '/referrals': (0, $05f5f13c3cb66234$export$17606da954476c13),
    '/reports': (0, $b8cac88ae81b99b1$export$f7c42a96c638d4dc),
    '/enterprise': (0, $468c87eeae29dd40$export$26b870b33373704f),
    '/finances': (0, $087ae3a5e9d9d71b$export$7f740c0bb80e297e),
    '/integrations': (0, $ec0ab458d2b9f4ac$export$d55f97af03376191),
    '/pitch': (0, $386b39b9d06f3a9f$export$6c9e2d66dea2a302),
    '/chat': (0, $8f52cbf804c46fad$export$530dccc8e24f4e99),
    '/consent': (0, $f2a44cce6d451de2$export$a6dfab0e9e63c404),
    '/cabinets': (0, $18e445e8c6d48fa9$export$d2acecc3fc1bf481),
    '/documents': (0, $d7f053e17fe69c28$export$3260cc9ddc8b12d),
    '/radiology': (0, $c2e06f40f10dab9f$export$a396a716b69298e7),
    '/inventory': (0, $78a580fb1cf61fb0$export$50015f3d0c7b8cdc),
    '/staff': (0, $652d68f80c2c6f71$export$472071ac89399e9a),
    '/my-schedule': (0, $8ea780561eeb84e4$export$5c97e62a4a7198ec),
    // Templates
    '/templates': (0, $d4a053fc05e2465c$export$a8fc3402335b0b04),
    '/templates/forms': (0, $5a331253da4c0af9$export$b76a50d99a15c808),
    '/templates/consent': (0, $1fd454a3354bd208$export$5dc27ed9ff714f57)
};


var $b42a2ac40ecd9203$exports = {};

$parcel$export($b42a2ac40ecd9203$exports, "clinicsFetch", () => $b9becae6bd307dfe$export$2e68a2c819d29977);
$parcel$export($b42a2ac40ecd9203$exports, "checkPrerequisites", () => $47cf5d3907e799ee$export$7a470df434686642);
$parcel$export($b42a2ac40ecd9203$exports, "normalizeTerms", () => $594e75063512f685$export$515a60bbd27e428e);
$parcel$export($b42a2ac40ecd9203$exports, "noteAutocomplete", () => $538b98b3d83b3b2b$export$d8936bc503be5a1c);


const $594e75063512f685$export$515a60bbd27e428e = function normalizeTerms(text) {
    var dictionary = {
        'night eye': 'Night Guard',
        '\u10DC\u10D0\u10D8\u10D7 \u10D0\u10D8': 'Night Guard',
        'NE': 'Night Guard',
        '\u10DC\u10D8\u10EC\u10D8': 'Night Guard',
        'RCT': 'Root Canal Treatment',
        '\u10D4\u10DC\u10D3\u10DD': 'Root Canal Treatment',
        'root canal': 'Root Canal Treatment',
        '\u10D9\u10DD\u10DB\u10DE': 'Composite Filling',
        'composite': 'Composite Filling',
        '\u10D1\u10DF\u10D4\u10DC\u10D8': 'Composite Filling',
        '\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10D8': 'Composite Filling',
        '\u10D4\u10E5\u10E1\u10E2\u10E0\u10D0\u10E5\u10EA\u10D8\u10D0': 'Extraction',
        'extraction': 'Extraction',
        '\u10D0\u10DB\u10DD\u10E6\u10D4\u10D1\u10D0': 'Extraction',
        '\u10D8\u10DB\u10DE\u10DA': 'Implant',
        'implant': 'Implant',
        '\u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8': 'Implant',
        '\u10DE\u10E0\u10DD\u10D7\u10D4\u10D6\u10D8': 'Prosthesis',
        'denture': 'Prosthesis',
        '\u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8': 'Crown',
        'crown': 'Crown',
        '\u10D5\u10D8\u10DC\u10D8\u10E0\u10D8': 'Veneer',
        'veneer': 'Veneer',
        '\u10E1\u10D9\u10D4\u10D8\u10DA\u10D8\u10DC\u10D2\u10D8': 'Scaling',
        'scaling': 'Scaling',
        '\u10EC\u10DB\u10D4\u10DC\u10D3\u10D0': 'Professional Cleaning',
        'cleaning': 'Professional Cleaning',
        '\u10D2\u10D0\u10D7\u10D4\u10D7\u10E0\u10D4\u10D1\u10D0': 'Whitening',
        'whitening': 'Whitening',
        '\u10D1\u10E0\u10D4\u10D9\u10D4\u10E2\u10D8': 'Braces',
        'braces': 'Braces',
        '\u10DD\u10E0\u10D7\u10DD': 'Orthodontic Treatment',
        'ortho': 'Orthodontic Treatment',
        '\u10DE\u10D0\u10DC\u10DD\u10E0\u10D0\u10DB\u10D0': 'Panoramic X-ray',
        'OPG': 'Panoramic X-ray',
        '\u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8': 'Periapical X-ray',
        'PA': 'Periapical X-ray',
        'CBCT': 'Cone Beam CT',
        '\u10D9\u10D0\u10E2\u10D4': 'Cone Beam CT'
    };
    var changes = [];
    var normalized = text;
    // Sort keys by length descending so longer matches take priority
    var keys = Object.keys(dictionary).sort(function(a, b) {
        return b.length - a.length;
    });
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var regex = new RegExp('\\b' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'gi');
        var match;
        while((match = regex.exec(normalized)) !== null)if (match[0].toLowerCase() !== dictionary[key].toLowerCase()) changes.push({
            original: match[0],
            normalized: dictionary[key],
            position: match.index
        });
    }
    // Apply replacements from end to start to preserve positions
    changes.sort(function(a, b) {
        return b.position - a.position;
    });
    for(var j = 0; j < changes.length; j++){
        var c = changes[j];
        normalized = normalized.slice(0, c.position) + c.normalized + normalized.slice(c.position + c.original.length);
    }
    // Re-sort changes by position ascending for output
    changes.sort(function(a, b) {
        return a.position - b.position;
    });
    return {
        normalized: normalized,
        changes: changes
    };
};


const $538b98b3d83b3b2b$export$d8936bc503be5a1c = function noteAutocomplete(partial) {
    if (!partial || partial.length < 2) return [];
    var terms = [
        // Procedures
        {
            en: 'Composite Filling',
            ka: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10E3\u10E0\u10D8 \u10D1\u10DF\u10D4\u10DC\u10D8",
            category: 'procedure'
        },
        {
            en: 'Root Canal Treatment',
            ka: "\u10E4\u10D4\u10E1\u10D5\u10D8\u10E1 \u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0",
            category: 'procedure'
        },
        {
            en: 'Scaling',
            ka: "\u10E1\u10D9\u10D4\u10D8\u10DA\u10D8\u10DC\u10D2\u10D8",
            category: 'procedure'
        },
        {
            en: 'Crown Preparation',
            ka: "\u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE\u10D0\u10E0\u10D0\u10EA\u10D8\u10D0",
            category: 'procedure'
        },
        {
            en: 'Extraction',
            ka: "\u10D4\u10E5\u10E1\u10E2\u10E0\u10D0\u10E5\u10EA\u10D8\u10D0",
            category: 'procedure'
        },
        {
            en: 'Implant Placement',
            ka: "\u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8\u10E1 \u10D3\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0",
            category: 'procedure'
        },
        {
            en: 'Veneer Preparation',
            ka: "\u10D5\u10D8\u10DC\u10D8\u10E0\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE\u10D0\u10E0\u10D0\u10EA\u10D8\u10D0",
            category: 'procedure'
        },
        {
            en: 'Bridge Preparation',
            ka: "\u10EE\u10D8\u10D3\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE\u10D0\u10E0\u10D0\u10EA\u10D8\u10D0",
            category: 'procedure'
        },
        {
            en: 'Bone Grafting',
            ka: "\u10EB\u10D5\u10DA\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10DC\u10D4\u10E0\u10D2\u10D5\u10D0",
            category: 'procedure'
        },
        {
            en: 'Sinus Lift',
            ka: "\u10E1\u10D8\u10DC\u10E3\u10E1 \u10DA\u10D8\u10E4\u10E2\u10D8",
            category: 'procedure'
        },
        {
            en: 'Teeth Whitening',
            ka: "\u10D9\u10D1\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D7\u10D4\u10D7\u10E0\u10D4\u10D1\u10D0",
            category: 'procedure'
        },
        {
            en: 'Root Planing',
            ka: "\u10E4\u10D4\u10E1\u10D5\u10D8\u10E1 \u10DB\u10DD\u10E8\u10E0\u10D8\u10D0\u10DA\u10D4\u10D1\u10D0",
            category: 'procedure'
        },
        {
            en: 'Frenectomy',
            ka: "\u10E4\u10E0\u10D4\u10DC\u10D4\u10E5\u10E2\u10DD\u10DB\u10D8\u10D0",
            category: 'procedure'
        },
        {
            en: 'Pulpotomy',
            ka: "\u10DE\u10E3\u10DA\u10DE\u10DD\u10E2\u10DD\u10DB\u10D8\u10D0",
            category: 'procedure'
        },
        {
            en: 'Apicoectomy',
            ka: "\u10D0\u10DE\u10D8\u10D9\u10DD\u10D4\u10E5\u10E2\u10DD\u10DB\u10D8\u10D0",
            category: 'procedure'
        },
        // Findings
        {
            en: 'Caries',
            ka: "\u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8",
            category: 'finding'
        },
        {
            en: 'Periodontitis',
            ka: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10D8\u10E2\u10D8",
            category: 'finding'
        },
        {
            en: 'Gingivitis',
            ka: "\u10D2\u10D8\u10DC\u10D2\u10D8\u10D5\u10D8\u10E2\u10D8",
            category: 'finding'
        },
        {
            en: 'Abscess',
            ka: "\u10D0\u10D1\u10E1\u10EA\u10D4\u10E1\u10D8",
            category: 'finding'
        },
        {
            en: 'Fracture',
            ka: "\u10E4\u10E0\u10D0\u10E5\u10E2\u10E3\u10E0\u10D0",
            category: 'finding'
        },
        {
            en: 'Erosion',
            ka: "\u10D4\u10E0\u10DD\u10D6\u10D8\u10D0",
            category: 'finding'
        },
        {
            en: 'Recession',
            ka: "\u10E0\u10D4\u10EA\u10D4\u10E1\u10D8\u10D0",
            category: 'finding'
        },
        {
            en: 'Pulpitis',
            ka: "\u10DE\u10E3\u10DA\u10DE\u10D8\u10E2\u10D8",
            category: 'finding'
        },
        {
            en: 'Malocclusion',
            ka: "\u10DB\u10D0\u10DA\u10DD\u10D9\u10DA\u10E3\u10D6\u10D8\u10D0",
            category: 'finding'
        },
        {
            en: 'Bruxism',
            ka: "\u10D1\u10E0\u10E3\u10E5\u10E1\u10D8\u10D6\u10DB\u10D8",
            category: 'finding'
        },
        {
            en: 'Periapical Lesion',
            ka: "\u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D3\u10D0\u10D6\u10D8\u10D0\u10DC\u10D4\u10D1\u10D0",
            category: 'finding'
        },
        {
            en: 'Calculus',
            ka: "\u10D9\u10D0\u10DA\u10D9\u10E3\u10DA\u10E3\u10E1\u10D8",
            category: 'finding'
        },
        {
            en: 'Mobility',
            ka: "\u10DB\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0",
            category: 'finding'
        },
        // Materials
        {
            en: 'Composite Resin',
            ka: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10E3\u10E0\u10D8 \u10E4\u10D8\u10E1\u10D8",
            category: 'material'
        },
        {
            en: 'Glass Ionomer',
            ka: "\u10DB\u10D8\u10DC\u10D0 \u10D8\u10DD\u10DC\u10DD\u10DB\u10D4\u10E0\u10D8",
            category: 'material'
        },
        {
            en: 'Amalgam',
            ka: "\u10D0\u10DB\u10D0\u10DA\u10D2\u10D0\u10DB\u10D0",
            category: 'material'
        },
        {
            en: 'Zirconia',
            ka: "\u10EA\u10D8\u10E0\u10D9\u10DD\u10DC\u10D8\u10D0",
            category: 'material'
        },
        {
            en: 'Porcelain',
            ka: "\u10E4\u10D0\u10D8\u10E4\u10E3\u10E0\u10D8",
            category: 'material'
        },
        {
            en: 'Titanium',
            ka: "\u10E2\u10D8\u10E2\u10D0\u10DC\u10D8",
            category: 'material'
        },
        {
            en: 'Gutta Percha',
            ka: "\u10D2\u10E3\u10E2\u10D0 \u10DE\u10D4\u10E0\u10E9\u10D0",
            category: 'material'
        },
        {
            en: 'PVS Impression Material',
            ka: "PVS \u10D0\u10DC\u10D0\u10D1\u10D4\u10ED\u10D3\u10D8\u10E1 \u10DB\u10D0\u10E1\u10D0\u10DA\u10D0",
            category: 'material'
        },
        {
            en: 'Calcium Hydroxide',
            ka: "\u10D9\u10D0\u10DA\u10EA\u10D8\u10E3\u10DB\u10D8\u10E1 \u10F0\u10D8\u10D3\u10E0\u10DD\u10E5\u10E1\u10D8\u10D3\u10D8",
            category: 'material'
        },
        // Medications
        {
            en: 'Amoxicillin',
            ka: "\u10D0\u10DB\u10DD\u10E5\u10E1\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8",
            category: 'medication'
        },
        {
            en: 'Ibuprofen',
            ka: "\u10D8\u10D1\u10E3\u10DE\u10E0\u10DD\u10E4\u10D4\u10DC\u10D8",
            category: 'medication'
        },
        {
            en: 'Chlorhexidine',
            ka: "\u10E5\u10DA\u10DD\u10E0\u10F0\u10D4\u10E5\u10E1\u10D8\u10D3\u10D8\u10DC\u10D8",
            category: 'medication'
        },
        {
            en: 'Lidocaine',
            ka: "\u10DA\u10D8\u10D3\u10DD\u10D9\u10D0\u10D8\u10DC\u10D8",
            category: 'medication'
        },
        {
            en: 'Metronidazole',
            ka: "\u10DB\u10D4\u10E2\u10E0\u10DD\u10DC\u10D8\u10D3\u10D0\u10D6\u10DD\u10DA\u10D8",
            category: 'medication'
        },
        {
            en: 'Clindamycin',
            ka: "\u10D9\u10DA\u10D8\u10DC\u10D3\u10D0\u10DB\u10D8\u10EA\u10D8\u10DC\u10D8",
            category: 'medication'
        },
        {
            en: 'Articaine',
            ka: "\u10D0\u10E0\u10E2\u10D8\u10D9\u10D0\u10D8\u10DC\u10D8",
            category: 'medication'
        },
        {
            en: 'Dexamethasone',
            ka: "\u10D3\u10D4\u10E5\u10E1\u10D0\u10DB\u10D4\u10D7\u10D0\u10D6\u10DD\u10DC\u10D8",
            category: 'medication'
        }
    ];
    var query = partial.toLowerCase();
    var matches = [];
    for(var i = 0; i < terms.length; i++){
        var term = terms[i];
        var enLower = term.en.toLowerCase();
        var kaLower = term.ka.toLowerCase();
        if (enLower.indexOf(query) !== -1 || kaLower.indexOf(query) !== -1) matches.push(term);
        if (matches.length >= 5) break;
    }
    return matches;
};




var $3bda623ffab03480$exports = {};


var $1a9a2097450ea0af$export$2e2bcd8739ae039 = {
    color: {
        black: '#000000',
        white: '#ffffff',
        teal: '#00C9A7',
        tealDark: '#00A389',
        tealLight: '#E0FAF5',
        ink: '#FAFAFA',
        inkMid: '#FFFFFF',
        inkSurface: '#F0F0F5',
        inkBorder: '#D2D2D7',
        inkMuted: '#6E6E73',
        inkSubtle: '#3A3A3C',
        inkText: '#1D1D1F',
        amber: '#F0A500',
        red: '#F85149',
        green: '#3FB950',
        purple: '#BC8CFF',
        toothHealthy: '#E8F5E9',
        toothCaries: '#FFCDD2',
        toothRestored: '#BBDEFB',
        toothCrown: '#FFE0B2',
        toothMissing: '#E0E0E0',
        toothImplant: '#E1BEE7',
        toothBridge: '#B3E5FC',
        toothBraces: '#C8E6C9',
        toothVeneer: '#F3E5F5',
        toothSelected: '#00C9A7',
        perioHealthy: '#4CAF50',
        perioWarning: '#FF9800',
        perioCritical: '#F44336',
        perioBleeding: '#E53935',
        blue: '#2196F3',
        gold: '#FFB300'
    },
    gradient: {},
    theme: {
        document: {
            color: 'inkText',
            background: '#FAFAFA'
        },
        none: {
            color: 'none',
            background: 'none'
        },
        transparent: {
            color: 'currentColor',
            background: 'transparent'
        },
        primary: {
            background: 'teal',
            color: 'white'
        },
        dialog: {
            background: 'inkSurface',
            color: 'inkText',
            border: '1px solid',
            borderColor: 'inkBorder'
        },
        surface: {
            background: 'inkMid',
            color: 'inkText'
        },
        warning: {
            background: 'amber',
            color: 'ink'
        },
        danger: {
            background: 'red',
            color: 'white'
        },
        success: {
            background: 'green',
            color: 'ink'
        },
        ai: {
            background: 'purple',
            color: 'white'
        },
        tooth: {
            background: 'toothHealthy',
            color: 'inkText'
        },
        caries: {
            background: 'toothCaries',
            color: 'inkText'
        },
        restored: {
            background: 'toothRestored',
            color: 'inkText'
        },
        crown: {
            background: 'toothCrown',
            color: 'inkText'
        },
        implant: {
            background: 'toothImplant',
            color: 'inkText'
        },
        perio: {
            background: 'perioHealthy',
            color: 'white'
        },
        perioDanger: {
            background: 'perioCritical',
            color: 'white'
        },
        enterprise: {
            background: 'gold',
            color: 'inkText'
        },
        info: {
            background: 'blue',
            color: 'white'
        }
    },
    font: {},
    font_family: {
        default: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Inter', 'Segoe UI', Roboto, sans-serif"
    },
    typography: {
        base: 16,
        ratio: 1.25,
        subSequence: true,
        templates: {}
    },
    spacing: {
        base: 16,
        ratio: 1.618,
        subSequence: true
    },
    icons: {
        calendar: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8 2a1 1 0 011 1v1h6V3a1 1 0 112 0v1h2a3 3 0 013 3v12a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3h2V3a1 1 0 011-1zM4 10v9a1 1 0 001 1h14a1 1 0 001-1v-9H4z" fill="currentColor"/></svg>',
        users: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 12a4 4 0 100-8 4 4 0 000 8zm-2 2a6 6 0 00-6 6 1 1 0 001 1h14a1 1 0 001-1 6 6 0 00-6-6H7zm10-6a3 3 0 110 6 1 1 0 010-2 1 1 0 100-2 1 1 0 010-2zm2 8a1 1 0 011 1 5 5 0 01-3 4.58 1 1 0 01-.5-1.94A3 3 0 0018 17a1 1 0 011-1z" fill="currentColor"/></svg>',
        dollarSign: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 1a1 1 0 011 1v1.07A4.5 4.5 0 0117 7.5a1 1 0 01-2 0A2.5 2.5 0 0012.5 5H10a2.5 2.5 0 000 5h4a4.5 4.5 0 011 8.93V20a1 1 0 11-2 0v-1.07A4.5 4.5 0 017 14.5a1 1 0 012 0 2.5 2.5 0 002.5 2.5H14a2.5 2.5 0 000-5h-4a4.5 4.5 0 01-1-8.93V2a1 1 0 011-1z" fill="currentColor"/></svg>',
        settings: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 15a3 3 0 100-6 3 3 0 000 6z" fill="currentColor"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z" fill="currentColor"/></svg>',
        check: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/></svg>',
        arrowLeft: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor"/></svg>',
        arrowRight: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 11h12.17l-5.59-5.59L12 4l8 8-8 8-1.41-1.41L16.17 13H4v-2z" fill="currentColor"/></svg>',
        star: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/></svg>',
        clock: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 11h-2V7h2v4h3v2h-3z" fill="currentColor"/></svg>',
        menu: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" fill="currentColor"/></svg>',
        mail: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/></svg>',
        mapPin: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" fill="currentColor"/></svg>',
        barChart: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 9h4v12H5V9zm5-6h4v18h-4V3zm5 8h4v10h-4V11z" fill="currentColor"/></svg>',
        shield: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" fill="currentColor"/></svg>',
        bell: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4a1.5 1.5 0 00-3 0v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" fill="currentColor"/></svg>',
        phone: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.25 1.01l-2.2 2.2z" fill="currentColor"/></svg>',
        search: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/></svg>',
        tooth: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C9.5 2 7 3.5 6 5.5c-1.5 3-.5 5 0 7.5.5 2.5-.5 5.5 1 8 .5.8 1.5 1 2 1s1-.5 1.5-2c.5-1.5 1-2 1.5-2s1 .5 1.5 2c.5 1.5 1 2 1.5 2s1.5-.2 2-1c1.5-2.5.5-5.5 1-8 .5-2.5 1.5-4.5 0-7.5C17 3.5 14.5 2 12 2z" fill="currentColor"/></svg>',
        sparkle: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L14.5 9.5 22 12l-7.5 2.5L12 22l-2.5-7.5L2 12l7.5-2.5L12 2z" fill="currentColor"/></svg>',
        upload: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 15v4a2 2 0 01-2 2H7a2 2 0 01-2-2v-4h2v4h10v-4h2zM13 3.83l4.59 4.58L16.17 9.83 13 6.66V16h-2V6.66L7.83 9.83 6.41 8.41 12 2.83z" fill="currentColor"/></svg>',
        send: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" fill="currentColor"/></svg>',
        file: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zm-1 2l5 5h-5V4zM8 13h8v2H8v-2zm0 4h8v2H8v-2zm0-8h3v2H8V9z" fill="currentColor"/></svg>',
        xray: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-7 14a5 5 0 110-10 5 5 0 010 10zm0-8a3 3 0 100 6 3 3 0 000-6z" fill="currentColor"/></svg>',
        clipboard: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 2h-4.18C14.4.84 13.3 0 12 0S9.6.84 9.18 2H5a2 2 0 00-2 2v16a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2zm-7 0a1 1 0 110 2 1 1 0 010-2zm7 18H5V4h2v3h10V4h2v16z" fill="currentColor"/></svg>',
        home: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="currentColor"/></svg>',
        activity: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        sun: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 7a5 5 0 100 10 5 5 0 000-10zM12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" stroke-width="2" fill="currentColor" stroke-linecap="round"/></svg>',
        moon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fill="currentColor"/></svg>',
        chevronDown: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" fill="currentColor"/></svg>',
        globe: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1a2 2 0 002 2v1.93zm6.9-2.54A1.99 1.99 0 0016 16h-1v-3a1 1 0 00-1-1H8v-2h2a1 1 0 001-1V7h2a2 2 0 002-2v-.41a7.98 7.98 0 012.9 12.8z" fill="currentColor"/></svg>',
        arrowUp: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" fill="currentColor"/></svg>',
        fourStar: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C12 0 14.5 7.5 12 12C9.5 7.5 12 0 12 0ZM12 24C12 24 9.5 16.5 12 12C14.5 16.5 12 24 12 24ZM0 12C0 12 7.5 9.5 12 12C7.5 14.5 0 12 0 12ZM24 12C24 12 16.5 14.5 12 12C16.5 9.5 24 12 24 12Z" fill="currentColor"/></svg>',
        screw: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L10 4h4L12 2zM10 5v2h4V5h-4zM9 8l1 1h4l1-1H9zM10 10v2h4v-2h-4zM9 13l1 1h4l1-1H9zM10 15v2h4v-2h-4zM9 18l1 1h4l1-1H9zM11 20v2h2v-2h-2z" fill="currentColor"/></svg>',
        rx: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 3h6a4 4 0 010 8H7l7 8m0 0l3-3.5M14 19l3 3.5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        flask: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 3h6v2h-1v5l4 7H6l4-7V5H9V3zm3 7.5L9.5 15h5L12 10.5z" fill="currentColor"/></svg>',
        link: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        drag: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="6" r="1.5" fill="currentColor"/><circle cx="15" cy="6" r="1.5" fill="currentColor"/><circle cx="9" cy="12" r="1.5" fill="currentColor"/><circle cx="15" cy="12" r="1.5" fill="currentColor"/><circle cx="9" cy="18" r="1.5" fill="currentColor"/><circle cx="15" cy="18" r="1.5" fill="currentColor"/></svg>',
        layers: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        lock: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="11" width="18" height="11" rx="2" fill="currentColor"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="2" fill="none"/></svg>',
        key: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.78 7.78 5.5 5.5 0 017.78-7.78zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        flag: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" fill="currentColor"/><line x1="4" y1="22" x2="4" y2="15" stroke="currentColor" stroke-width="2"/></svg>',
        pulse: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 12h4l3-9 4 18 3-9h6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        stethoscope: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 2v6a6 6 0 0012 0V2" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/><circle cx="19" cy="14" r="2" fill="currentColor"/><path d="M19 16v2a4 4 0 01-4 4h-2a4 4 0 01-4-4v-2" stroke="currentColor" stroke-width="2" fill="none"/></svg>',
        pill: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 1.5a4.95 4.95 0 00-3.5 1.45l-4.05 4.05a4.95 4.95 0 000 7l4.05 4.05a4.95 4.95 0 007 0l4.05-4.05a4.95 4.95 0 000-7L14 2.95A4.95 4.95 0 0010.5 1.5zM8.4 4.35L12 7.95l-4.6 4.6-3.6-3.6a2.95 2.95 0 010-4.2z" fill="currentColor" transform="translate(2 2)"/></svg>',
        syringe: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 2l4 4-2 2-1-1-5 5v4l-2 2-5-5-3 3-2-2 3-3-5-5 2-2h4l5-5-1-1 2-2z" fill="currentColor"/></svg>',
        bone: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.2 3.8a3 3 0 00-4.2 0L5.8 12a3 3 0 000 4.2 3 3 0 001.4.8 3 3 0 00-.8 1.4 3 3 0 004.2 0 3 3 0 00.8-1.4 3 3 0 001.4.8 3 3 0 004.2 0L18.2 8a3 3 0 000-4.2zm-.8 1.4a3 3 0 00.8 1.4 3 3 0 00-1.4.8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        crown: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 20h20L19 8l-4 4-3-6-3 6-4-4-3 12z" fill="currentColor"/></svg>',
        clipboard2: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 2h-4.18C14.4.84 13.3 0 12 0S9.6.84 9.18 2H5a2 2 0 00-2 2v16a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2zm-7 0a1 1 0 110 2 1 1 0 010-2zm7 18H5V4h2v3h10V4h2v16z" fill="currentColor"/><path d="M9 14l2 2 4-4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        folder: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2h-8l-2-2z" fill="currentColor"/></svg>',
        archive: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21 8v13H3V8" fill="none" stroke="currentColor" stroke-width="2"/><path d="M1 3h22v5H1z" fill="currentColor"/><path d="M10 12h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
        refresh: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23 4v6h-6M1 20v-6h6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        filter: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" fill="currentColor"/></svg>',
        download: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/><path d="M7 10l5 5 5-5M12 15V3" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        printer: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 9V2h12v7" stroke="currentColor" stroke-width="2" fill="none"/><rect x="2" y="9" width="20" height="9" rx="1" fill="currentColor"/><path d="M6 18v4h12v-4" fill="none" stroke="currentColor" stroke-width="2"/></svg>',
        eye: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" fill="currentColor"/></svg>',
        eyeOff: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
        plus: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        minus: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        x: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        chevronRight: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        chevronLeft: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        chevronUp: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 15l-6-6-6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        arrowDown: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 5v14M19 12l-7 7-7-7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        edit: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" stroke-width="2" fill="none"/><path d="M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z" fill="currentColor"/></svg>',
        trash: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        copy: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" stroke-width="2" fill="none"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" stroke-width="2" fill="none"/></svg>',
        externalLink: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        grid: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="7" height="7" fill="currentColor"/><rect x="14" y="3" width="7" height="7" fill="currentColor"/><rect x="3" y="14" width="7" height="7" fill="currentColor"/><rect x="14" y="14" width="7" height="7" fill="currentColor"/></svg>',
        list: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        pieChart: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21.21 15.89A10 10 0 118 2.83" stroke="currentColor" stroke-width="2" fill="none"/><path d="M22 12A10 10 0 0012 2v10z" fill="currentColor"/></svg>',
        trendUp: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23 6l-9.5 9.5-5-5L1 18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6h6v6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        trendDown: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23 18l-9.5-9.5-5 5L1 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 18h6v-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        alertTriangle: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4m0 4h.01" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        info2: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none"/><path d="M12 16v-4m0-4h.01" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        helpCircle: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3m.08 4h.01" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        mic: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="9" y="1" width="6" height="11" rx="3" fill="currentColor"/><path d="M19 10v2a7 7 0 01-14 0v-2M12 19v4m-4 0h8" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        micOff: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l22 22M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/><path d="M17 16.95A7 7 0 015 12v-2m14 0v2c0 .87-.16 1.71-.46 2.49M12 19v4m-4 0h8" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        play: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 3l14 9-14 9V3z" fill="currentColor"/></svg>',
        pause: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="4" width="4" height="16" fill="currentColor"/><rect x="14" y="4" width="4" height="16" fill="currentColor"/></svg>',
        stop: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" fill="currentColor"/></svg>',
        voiceWave: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 12h2m4-6v12m4-16v20m4-14v8m4-4h2" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
        microphone: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z" fill="currentColor"/><path d="M19 10v2a7 7 0 01-14 0v-2M12 19v4m-4 0h8" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        tag: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="7" r="1" fill="currentColor"/></svg>',
        thumbsUp: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        thumbsDown: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 15v4a3 3 0 003 3l4-9V2H5.72a2 2 0 00-2 1.7l-1.38 9a2 2 0 002 2.3H10zM17 2h2.67A2.31 2.31 0 0122 4v7a2.31 2.31 0 01-2.33 2H17" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        user: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" fill="none"/></svg>',
        aperture: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none"/><path d="M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83M16.62 12l-5.74 9.94" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        checkSquare: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 11l3 3L22 4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        creditCard: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="4" width="22" height="16" rx="2" ry="2" stroke="currentColor" stroke-width="2" fill="none"/><path d="M1 10h22" stroke="currentColor" stroke-width="2"/></svg>',
        fileText: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        messageSquare: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        package: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 9.4l-9-5.19M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    },
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    verbose: false
};


var $f00b8cc44c2f4180$export$2e2bcd8739ae039 = {};



var $dNnfS = parcelRequire("dNnfS");
var $3e7bb68d55e4c07c$export$2e2bcd8739ae039 = {
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    globalTheme: 'light',
    verbose: false,
    fetch: {
        adapter: 'supabase',
        createClient: $dNnfS.createClient,
        url: 'https://ighhbtzddnmzvlsfoxnb.supabase.co',
        key: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlnaGhidHpkZG5tenZsc2ZveG5iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4NDc5ODksImV4cCI6MjA4OTQyMzk4OX0.15jwVnzHSizO_-HfC1vQLxAT0SzXJkbGs-nps6Zm_v4',
        db: {
            schema: 'public'
        },
        retry: {
            retry: '3',
            delay: '1000'
        }
    },
    polyglot: {
        defaultLang: 'en',
        languages: [
            'en',
            'ka',
            'ru',
            'uk',
            'tr',
            'zh',
            'hi',
            'msa'
        ],
        storageLangKey: 'dental_lang',
        storagePrefix: 'dental_t_'
    }
};


var $bc1454a6c0cf0628$export$2e2bcd8739ae039 = {
    en: {
        // Nav
        home: 'Home',
        features: 'Features',
        pricing: 'Pricing',
        clinicsNav: 'Clinics',
        aiAssistant: 'AI Assistant',
        forBusiness: 'For Business',
        dashboard: 'Dashboard',
        getStarted: 'Get Started',
        tryDemo: 'Try Live Demo',
        viewPitch: 'View Pitch Deck',
        // Landing Hero
        heroTagline: 'Dental Platform for Georgia',
        heroTitle: 'All dental clinics hub',
        heroSubtitle: 'Your AI assistant to find the best dental care in Georgia',
        searchPlaceholder: 'Search clinics, services, or ask anything...',
        chipImplant: 'Best implant clinics in Tbilisi',
        chipWhitening: 'Teeth whitening near me',
        chipEmergency: 'Emergency dental care',
        chipOrtho: 'Orthodontics for adults',
        scrollExplore: 'Scroll to explore',
        topRated: 'Top-rated dental clinics in Tbilisi',
        viewAllClinics: 'View all clinics',
        shareLocation: 'Share location for nearby clinics',
        locationShared: "Location shared \u2014 showing nearby",
        // Landing Stats
        statClinics: 'Clinics',
        statNoShows: 'Less No-shows',
        statBooking: 'Online Booking',
        statDentists: 'Dentists',
        statRating: 'Avg Rating',
        statPatients: 'Patients',
        // Landing Actions
        findClinics: 'Find Best Clinics',
        forBusinessBtn: 'For Business',
        // Landing Claim
        ownClinic: 'Do you own a dental clinic?',
        claimText: "Claim your listing or add it to our database. We'll help people find your clinic.",
        getListed: "Get Listed \u2192",
        // Clinics Page
        clinicsTitle: 'Dental Clinics in Georgia',
        verifiedClinics: 'verified clinics with ratings and reviews',
        searchByName: 'Search by name, district, or service...',
        hideMap: 'Hide Map',
        showMap: 'Map',
        nearMe: 'Near Me',
        clinicsMatch: 'clinics match',
        reviews: 'reviews',
        loadingMore: 'Loading more...',
        // Clinic Detail
        callClinic: 'Call',
        bookAppointment: 'Book Appointment',
        services: 'Services',
        workingHours: 'Working Hours',
        priceRange: 'Price Range',
        location: 'Location',
        visitWebsite: 'Visit Website',
        // Booking
        bookingTitle: 'Book an Appointment',
        step: 'Step',
        selectClinic: 'Select Clinic',
        selectService: 'Select Service',
        selectDate: 'Select Date',
        selectTime: 'Select Time',
        confirm: 'Confirm',
        next: 'Next',
        back: 'Back',
        clinicsAvailable: 'clinics available',
        clinicsFound: 'clinics found',
        confirmBooking: 'Confirm Booking',
        bookingConfirmed: 'Your appointment has been booked!',
        patientName: 'Patient Name',
        phoneNumber: 'Phone Number',
        email: 'Email',
        notes: 'Notes (optional)',
        // Doctor Booking
        bookByClinic: 'Book by Clinic',
        bookByDoctor: 'Book by Doctor',
        chooseDoctor: 'Choose a Doctor',
        specialOffer: 'Special offer',
        specialOfferAvailable: 'Special offer available',
        availableAtClinics: 'Available at clinics',
        bookAtClinic: 'Book here',
        // Business Page
        businessHeroBadge: "15+ Modules  \xb7  212+ Clinics  \xb7  Gemini AI",
        businessHeroTitle: 'The Operating System for Dental Clinics',
        businessHeroSubtitle: "Clinical charting, periodontal analysis, treatment planning, scheduling, billing, e-prescribing, lab management, and AI diagnostics \u2014 all in one platform built for Georgia.",
        theProblem: 'The Problem',
        problemSubtitle: 'Georgian dental clinics lose revenue daily due to fragmented tools',
        excelChaos: 'Excel & WhatsApp Chaos',
        excelChaosDetail: 'Clinics manage appointments through spreadsheets and chat groups. Zero automation, constant errors, lost records.',
        noShowRate: '25% No-Show Rate',
        noShowDetail: "Without automated reminders, patients forget appointments. Empty chairs mean \u20BE500+/day in lost revenue.",
        paperCharts: 'Paper Charts in 2026',
        paperChartsDetail: 'Handwritten clinical notes, no digital odontogram, no perio tracking. Critical data trapped in filing cabinets.',
        insuranceBlackHole: 'Insurance Black Hole',
        insuranceDetail: 'Manual claims to Aldagi, GPI, Imedi L take hours. Denied claims pile up with no tracking or appeal workflow.',
        // Platform Modules
        oneplatform: 'One Platform, Every Module',
        platformSubtitle: '15 integrated modules purpose-built for dental practices',
        clinical: 'CLINICAL',
        operations: 'OPERATIONS',
        analyticsEnterprise: 'ANALYTICS & ENTERPRISE',
        digitalOdontogram: 'Digital Odontogram',
        digitalOdontogramDetail: 'FDI 32-tooth chart with 5-surface tracking. Click any surface to record caries, restorations, crowns, implants, and missing teeth.',
        perioCharting: 'Perio Charting',
        perioChartingDetail: '192-site periodontal grid. 6-point probing, BOP, CAL, furcation, mobility. AAP staging via Gemini AI.',
        treatmentPlanning: 'Treatment Planning',
        treatmentPlanningDetail: 'Phased plans with CDT codes, insurance estimates, patient portions. Drag-and-drop reordering. AI sequencing.',
        soapNotes: 'SOAP Notes + AI Scribe',
        soapNotesDetail: 'Structured clinical documentation with templates. Gemini generates notes from voice or chart data.',
        multiChairScheduling: 'Multi-Chair Scheduling',
        multiChairDetail: 'Week view with multiple operatories. Provider color-coding, production goals, waitlist management.',
        billingInsurance: 'Billing & Insurance',
        billingDetail: 'Claims tracking for Aldagi, GPI, Imedi L. Patient ledger, aging buckets, payment plans, eligibility checks.',
        ePrescribing: 'e-Prescribing',
        ePrescribingDetail: 'Digital prescriptions with templates. Gemini-powered drug interaction checking. Georgian pharmacy integration.',
        labTracking: 'Lab Case Tracking',
        labTrackingDetail: "Kanban pipeline: Ordered \u2192 Fabrication \u2192 Shipped \u2192 Received. Vendor management, quality tracking.",
        productionReports: 'Production Reports',
        productionReportsDetail: 'Gross/net production, collection rates, treatment acceptance, recall effectiveness. Per-provider breakdown.',
        referralMgmt: 'Referral Management',
        referralMgmtDetail: 'Inbound/outbound referrals to specialists. AI-generated referral letters. Status tracking.',
        medicalHistory: 'Medical History',
        medicalHistoryDetail: '11-view patient record: timeline, conditions (ICD-10), medications, allergies, vitals, imaging, documents.',
        enterpriseAdmin: 'Enterprise Admin',
        enterpriseAdminDetail: 'RBAC, audit logs, compliance meters, multi-tenancy, SSO, feature flags, API management.',
        // AI Section
        geminiBuiltIn: 'Gemini AI Built In',
        geminiSubtitle: 'Every module powered by Google Gemini 3.1',
        xrayAnalysis: 'X-ray Analysis',
        xrayDetail: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment: 'Perio Assessment',
        perioAssessmentDetail: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe: 'Clinical Scribe',
        clinicalScribeDetail: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling: 'Risk Profiling',
        riskProfilingDetail: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing: 'Treatment Sequencing',
        treatmentSequencingDetail: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientComm: 'Patient Communication',
        patientCommDetail: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        // Integrations
        georgianEcosystem: 'Georgian Ecosystem Ready',
        integrationsSubtitle: 'Pre-built integrations with local insurance, payments, and messaging',
        insurance: 'INSURANCE',
        payments: 'PAYMENTS',
        messaging: 'MESSAGING',
        ehrLabs: 'EHR & LABS',
        // Stats
        clinicsInDb: 'Clinics in Database',
        platformModules: 'Platform Modules',
        aiTools: 'AI Tools (Gemini)',
        integrations: 'Integrations',
        // Pricing
        pricingTitle: 'Pricing',
        pricingSubtitle: 'Start free, scale as you grow',
        // Testimonials
        trustedBy: 'Trusted by Leading Clinics',
        // CTA
        readyModernize: 'Ready to modernize your practice?',
        joinCount: 'Join 212+ dental clinics across Georgia already on the platform.',
        startTrial: 'Start Free Trial',
        contactSales: 'Contact Sales',
        noCreditCard: "No credit card required  \xb7  Free tier available  \xb7  Setup in 5 minutes",
        // Footer
        copyright: "\xa9 2026 MCAI \u2014 Dental Clinic Operating System",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: 'Dashboard',
        navPatients: 'Patients',
        navChart: 'Chart',
        navPerio: 'Perio',
        navTreatmentPlans: 'Treatment Plans',
        navNotes: 'Notes',
        navScheduling: 'Scheduling',
        navBilling: 'Billing',
        navPrescriptions: 'Prescriptions',
        navLabCases: 'Lab Cases',
        navReferrals: 'Referrals',
        navReports: 'Reports',
        navMedHistory: 'Medical History',
        navFinances: 'Finance',
        navCabinets: 'Cabinets',
        navRadiology: 'Radiology',
        navDocuments: 'Documents',
        navConsent: 'Consent',
        navInventory: 'Inventory',
        navChat: 'Chat',
        navIntegrations: 'Integrations',
        navEnterprise: 'Enterprise',
        sectionClinical: 'CLINICAL',
        sectionOperations: 'OPERATIONS',
        sectionComm: 'COMMUNICATION',
        sectionAnalytics: 'ANALYTICS',
        sectionAiTools: 'AI TOOLS',
        sectionAdmin: 'ADMIN',
        // Booking Page
        chooseClinic: 'Choose a Clinic',
        selectAService: 'Select a Service',
        pickADate: 'Pick a Date',
        pickATime: 'Pick a Time',
        confirmYourBooking: 'Confirm Your Booking',
        clinicLabel: 'Clinic:',
        serviceLabel: 'Service:',
        dateLabel: 'Date:',
        timeLabel: 'Time:',
        // AI Page
        send: 'Send',
        procedure: 'Procedure',
        observations: 'Observations',
        aiThinking: 'AI is thinking...',
        summarizeHistory: 'Summarize patient history',
        generateTxPlan: 'Generate treatment plan',
        checkDrugInteractions: 'Check drug interactions',
        writeClinicalNote: 'Write clinical note',
        askAiAssistant: 'Ask the AI assistant...',
        dropXray: 'Drop X-ray image or click to upload',
        supportsFormats: 'Supports DICOM, PNG, JPG',
        analysisResults: 'Analysis Results (Demo)',
        aiRecommendation: 'AI Recommendation',
        exportToTxPlan: 'Export to Treatment Plan',
        generateClinicalNote: 'Generate Clinical Note',
        generatedSoap: 'Generated Clinical Note (SOAP)',
        subjective: "S \u2014 Subjective",
        objective: "O \u2014 Objective",
        assessment: "A \u2014 Assessment",
        plan: "P \u2014 Plan",
        copyToRecord: 'Copy to Patient Record',
        aiPerioAssessment: 'AI Periodontal Assessment',
        enterProbingData: 'Enter probing data to get AAP staging/grading and treatment recommendations.',
        analyzeWithGemini: 'Analyze with Gemini',
        aiRiskAssessment: 'AI Risk Assessment',
        enterConditions: 'Enter patient conditions, family history, and vitals to generate a risk profile.',
        generateRiskProfile: 'Generate Risk Profile',
        patientCommunication: 'Patient Communication',
        generateExplanations: 'Generate patient-friendly treatment explanations in Georgian or English.',
        generateExplanation: 'Generate Explanation',
        patientFriendly: 'Patient-Friendly Explanation',
        // Billing Page
        claims: 'Claims',
        ledger: 'Ledger',
        aging: 'Aging',
        paymentPlans: 'Payment Plans',
        eligibility: 'Eligibility',
        allFilter: 'All',
        submitted: 'Submitted',
        paid: 'Paid',
        denied: 'Denied',
        patientLedger: 'Patient Ledger',
        agedAccounts: 'Aged Accounts',
        sendStatements: 'Send Statements',
        activePaymentPlans: 'Active Payment Plans',
        insuranceEligibility: 'Insurance Eligibility',
        // Clinical Charting
        odontogram: 'Odontogram',
        perioTab: 'Perio',
        treatmentPlanTab: 'Treatment Plan',
        notesTab: 'Notes',
        progressNotes: 'Progress Notes',
        openFullPerio: "Open Full Periodontal Chart \u2192",
        openFullTxPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes: "Open Clinical Notes \u2192",
        newExam: 'New Exam',
        voiceEntry: 'Voice Entry',
        bleedingIndex: 'Bleeding Index',
        plaqueIndex: 'Plaque Index',
        sitesAbove4: "Sites \u2265 4mm",
        sitesAbove6: "Sites \u2265 6mm",
        planA: 'Plan A: Recommended',
        planB: 'Plan B: Conservative',
        newPlan: '+ New Plan',
        presentToPatient: 'Present to Patient',
        sendToPortal: 'Send to Portal',
        totalFee: 'Total Fee',
        insuranceEst: 'Insurance Est.',
        patientPortion: 'Patient Portion',
        chairSideMode: 'Chair-side Mode',
        adminMode: 'Admin Mode',
        proceduresAcrossPhases: '{0} procedures across {1} phases',
        // Scheduling
        day: 'Day',
        week: 'Week',
        today: 'Today',
        providerFilter: 'All Providers',
        productionGoal: 'Production Goal',
        waitlist: 'Waitlist',
        // Prescriptions
        activeRx: 'Active',
        pastRx: 'Past',
        templates: 'Templates',
        interactionCheck: 'Interaction Check',
        // Lab Cases
        ordered: 'Ordered',
        sentToLab: 'Sent to Lab',
        inFabrication: 'In Fabrication',
        shipped: 'Shipped',
        received: 'Received',
        labVendors: 'Lab Vendors',
        // Referrals
        allDirections: 'All',
        inbound: 'Inbound',
        outbound: 'Outbound',
        generateLetter: 'Generate Letter',
        // Reports
        production: 'Production',
        collections: 'Collections',
        schedulingReport: 'Scheduling',
        treatmentAcceptance: 'Treatment Acceptance',
        recall: 'Recall',
        grossProduction: 'Gross Production',
        netProduction: 'Net Production',
        collectionRate: 'Collection Rate',
        plansPresented: 'Plans Presented',
        accepted: 'Accepted',
        acceptanceRate: 'Acceptance Rate',
        dueThisMonth: 'Due This Month',
        scheduled: 'Scheduled',
        completed: 'Completed',
        overdue: 'Overdue',
        reactivationRate: 'Reactivation Rate',
        // Medical History
        timeline: 'Timeline',
        conditions: 'Conditions',
        medications: 'Medications',
        allergies: 'Allergies',
        labResults: 'Lab Results',
        vitals: 'Vitals',
        immunizations: 'Immunizations',
        familyHistory: 'Family History',
        imaging: 'Imaging',
        documents: 'Documents',
        // Enterprise
        rbac: 'RBAC',
        auditLog: 'Audit Log',
        compliance: 'Compliance',
        multiTenancy: 'Multi-Tenancy',
        sso: 'SSO & Security',
        featureFlags: 'Feature Flags',
        apiManagement: 'API Management',
        dataManagement: 'Data Management',
        // Integrations
        ehr: 'EHR',
        labs: 'Labs',
        telehealth: 'Telehealth',
        aiMl: 'AI/ML',
        wearables: 'Wearables',
        connected: 'Connected',
        disconnected: 'Disconnected',
        available: 'Available',
        // Components
        status: 'Status',
        healthy: 'Healthy',
        caries: 'Caries',
        restored: 'Restored',
        missing: 'Missing',
        implant: 'Implant',
        crownStatus: 'Crown',
        bridge: 'Bridge',
        veneer: 'Veneer',
        braces: 'Braces',
        surfaces: 'Surfaces',
        procedureHistory: 'Procedure History',
        procedureTimeline: 'Procedure Timeline',
        noHistory: 'No procedures recorded',
        chartLegend: 'Chart Legend',
        addProcedure: 'Add Procedure',
        addHistory: 'Add History',
        addDentalHistory: 'Add Dental History',
        patientReported: 'Patient-reported',
        verified: 'Verified',
        toothNumber: 'Tooth Number',
        selectTooth: 'Select tooth...',
        procedureType: 'Procedure Type',
        selectProcedure: 'Select procedure...',
        filling: 'Filling',
        crown: 'Crown',
        rootCanal: 'Root Canal',
        extraction: 'Extraction',
        implantProc: 'Implant',
        cleaningProc: 'Cleaning',
        whiteningProc: 'Whitening',
        bracesProc: 'Braces',
        other: 'Other',
        month: 'Month',
        year: 'Year',
        selectMonth: 'Select month...',
        selectYear: 'Select year...',
        doctorNameOptional: 'Doctor Name (Optional)',
        enterDoctorName: 'Enter doctor name',
        clinicNameOptional: 'Clinic Name (Optional)',
        enterClinicName: 'Enter clinic name',
        notes: 'Notes',
        enterNotes: 'Add any notes about this procedure...',
        cancel: 'Cancel',
        appointmentDetails: 'Appointment Details',
        openPatientRecord: 'Open Patient Record',
        submitHistory: 'Submit History',
        procedures: 'procedures',
        nextAppt: 'Next',
        totalCharged: 'Total Charged',
        insurancePayment: 'Insurance Payment',
        patientResponsibility: 'Patient Responsibility',
        expand: 'Expand',
        policyNumber: 'Policy #',
        planType: 'Plan Type',
        annualMax: 'Annual Max',
        used: 'Used',
        remaining: 'Remaining',
        coverageByCategory: 'Coverage by Category',
        preventive: 'Preventive',
        basic: 'Basic',
        major: 'Major',
        ortho: 'Ortho',
        current: 'Current',
        thirtyDay: '30 Day',
        sixtyDay: '60 Day',
        ninetyPlus: '90+ Day',
        totalBalance: 'Total Balance',
        monthlyPayment: 'Monthly Payment',
        paymentsRemaining: 'Payments Remaining',
        nextPayment: 'Next Payment',
        paymentProgress: 'Payment Progress',
        choosePlan: 'Choose Plan',
        aiInsight: 'AI Insight',
        confidence: 'Confidence',
        revoke: 'Revoke',
        exams: 'Exams',
        phaseTotal: 'Phase Total',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
        thinking: 'Thinking...',
        followUpPlaceholder: 'Ask a follow-up question...',
        priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
        patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
        tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
        chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
        english: 'English',
        patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
        xrayAnalysis2: 'X-ray Analysis',
        uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment2: 'Perio Assessment',
        automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe2: 'Clinical Scribe',
        generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling2: 'Risk Profiling',
        analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing2: 'Treatment Sequencing',
        aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientCommunication2: 'Patient Communication',
        generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        insurance2: 'INSURANCE',
        automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
        payments2: 'PAYMENTS',
        onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
        messaging2: 'MESSAGING',
        appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
        ehrLabs2: 'EHR & LABS',
        interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
        clinicsInDatabase: 'Clinics in Database',
        platformModules2: 'Platform Modules',
        integrations2: 'Integrations',
        home2: 'Home',
        features2: 'Features',
        pricing2: 'Pricing',
        dashboard2: 'Dashboard',
        u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
        openFullPeriodontalChart: "Open Full Periodontal Chart \u2192",
        openFullTreatmentPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes2: "Open Clinical Notes \u2192",
        backToAllClinics: "\u2190 Back to all clinics",
        priceRange2: 'Price range:',
        bookAnAppointment: 'Book an Appointment',
        selectDate2: 'Select date',
        selectTime2: 'Select time',
        confirmBooking2: "Confirm Booking \u2192",
        clinics: 'Clinics',
        forBusiness2: 'For Business',
        u00a92026Mcai: '\u00A9 2026 MCAI',
        clinicalNotes: 'Clinical Notes',
        newNote: '+ New Note',
        template: 'Template:',
        crownPrep: 'Crown Prep',
        aiScribe: 'AI Scribe',
        recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
        startRecording: 'Start Recording',
        generateNote: 'Generate Note',
        general: 'General',
        prosthetics: 'Prosthetics',
        typeToSearch: 'Type to search dental terms...',
        revenueToday: 'Revenue Today',
        noshows: 'No-shows',
        confirmed: 'Confirmed',
        time: 'TIME',
        patient: 'PATIENT',
        service: 'SERVICE',
        doctor: 'DOCTOR',
        status2: 'STATUS',
        addPatient: '+ Add Patient',
        mondayMarch19: 'Monday, March 19',
        gBeridzeCheckup: "G. Beridze \u2014 Checkup",
        nKapanadzeWhitening: "N. Kapanadze \u2014 Whitening",
        dGelashviliImplantPhase: "D. Gelashvili \u2014 Implant Phase 2",
        lunchBreak: "\u2014 Lunch Break \u2014",
        mTsiklauriOrthodontics: "M. Tsiklauri \u2014 Orthodontics",
        aJavakhishviliRootCanal: "A. Javakhishvili \u2014 Root Canal",
        lMchedlishviliExtraction: "L. Mchedlishvili \u2014 Extraction",
        tLomidzeCheckup: "T. Lomidze \u2014 Checkup",
        clinicName: 'Clinic Name',
        phone: 'Phone',
        address: 'Address',
        acceptedInsurance: 'Accepted Insurance',
        unison: 'Unison',
        saveSettings: 'Save Settings',
        aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
        openTheFullAi: "Open the full AI Assistant \u2192",
        enterprise: 'Enterprise',
        rolebasedAccessControl: 'Role-Based Access Control',
        permissionMatrix: 'Permission Matrix',
        module: 'Module',
        admin: 'Admin',
        doctor2: 'Doctor',
        hygienist: 'Hygienist',
        reception: 'Reception',
        lab: 'Lab',
        patient2: 'Patient',
        patients: 'Patients',
        full: 'Full',
        read: 'Read',
        none: 'None',
        own: 'Own',
        billing: 'Billing',
        scheduling: 'Scheduling',
        reports: 'Reports',
        settings: 'Settings',
        labOrders: 'Lab Orders',
        auditLog2: 'Audit Log',
        allTypes: 'All Types',
        last7Days: 'Last 7 days',
        complianceDashboard: 'Compliance Dashboard',
        complianceChecklist: 'Compliance Checklist',
        pass: 'PASS',
        dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
        dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
        mfaEnabledForAll: 'MFA enabled for all admin accounts',
        warn: 'WARN',
        dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
        auditLoggingActiveOn: 'Audit logging active on all modules',
        multitenancyManagement: 'Multi-Tenancy Management',
        singleSignonSso: 'Single Sign-On (SSO)',
        saml20: 'SAML 2.0',
        enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
        configured: 'Configured',
        openidConnect: 'OpenID Connect',
        oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
        available2: 'Available',
        signInWithGoogle: 'Sign in with Google organization accounts',
        connected2: 'Connected',
        azureAd: 'Azure AD',
        microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
        featureFlags2: 'Feature Flags',
        aixrayanalysis: 'ai_xray_analysis',
        aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
        voiceperio: 'voice_perio',
        voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
        patientportalv2: 'patient_portal_v2',
        nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
        whatsappreminders: 'whatsapp_reminders',
        multilanguage: 'multi_language',
        multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
        apiManagement2: 'API Management',
        requests24h: 'Requests (24h)',
        avgLatency: 'Avg Latency',
        uptime: 'Uptime',
        apiKeys: 'API Keys',
        dataManagement2: 'Data Management',
        storageUsed: 'Storage Used',
        of100Gb: 'of 100 GB',
        totalRecords: 'Total Records',
        lastBackup: 'Last Backup',
        nextIn4h: 'Next: in 4h',
        dataOperations: 'Data Operations',
        exportAllData: 'Export All Data',
        downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
        export: 'Export',
        purgeOldRecords: 'Purge Old Records',
        removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
        purge: 'Purge',
        dataMigration: 'Data Migration',
        importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
        import: 'Import',
        finance: 'Finance',
        revenueInvoicesPayments: 'Revenue, invoices & payments',
        exportReport: 'Export Report',
        monthlyRevenue: 'Monthly Revenue',
        u20be12400: '\u20BE12,400',
        pending: 'Pending',
        u20be2100: '\u20BE2,100',
        str208: '-5%',
        thisWeek: 'This Week',
        u20be3800: '\u20BE3,800',
        weeklyRevenue: 'Weekly Revenue',
        mon2: 'Mon',
        tue2: 'Tue',
        wed2: 'Wed',
        thu2: 'Thu',
        fri2: 'Fri',
        sat2: 'Sat',
        invoice: 'INVOICE',
        amount: 'AMOUNT',
        inv001: 'INV-001',
        giorgiBeridze: 'Giorgi Beridze',
        checkupXray: 'Checkup + X-ray',
        u20be80: '\u20BE80',
        inv002: 'INV-002',
        ninoKapanadze: 'Nino Kapanadze',
        whitening: 'Whitening',
        u20be120: '\u20BE120',
        inv003: 'INV-003',
        davitGelashvili: 'Davit Gelashvili',
        implantPhase1: 'Implant Phase 1',
        u20be300: '\u20BE300+',
        inv004: 'INV-004',
        anaJavakhishvili: 'Ana Javakhishvili',
        rootCanal: 'Root Canal',
        u20be149: '\u20BE149',
        u2715: '\u2715',
        configuration: 'Configuration',
        apiKey: 'API Key',
        endpointUrl: 'Endpoint URL',
        protocol: 'Protocol',
        syncSettings: 'Sync Settings',
        syncFrequency: 'Sync Frequency',
        every5Minutes: 'Every 5 minutes',
        every15Minutes: 'Every 15 minutes',
        everyHour: 'Every hour',
        manualOnly: 'Manual only',
        autosyncOnChanges: 'Auto-sync on changes',
        lastSynced: 'Last synced',
        disconnect: 'Disconnect',
        testConnection: 'Test Connection',
        labCasePipeline: 'Lab Case Pipeline',
        labVendors2: 'Lab Vendors',
        tbilisidentLab: 'TbilisiDent Lab',
        turnaround710Days: 'Turnaround: 7-10 days',
        rating485: 'Rating: 4.8/5',
        activeCases4: 'Active Cases: 4',
        caucasusDentalLab: 'Caucasus Dental Lab',
        turnaround57Days: 'Turnaround: 5-7 days',
        rating465: 'Rating: 4.6/5',
        activeCases2: 'Active Cases: 2',
        euroDentalGeorgia: 'Euro Dental Georgia',
        turnaround1014Days: 'Turnaround: 10-14 days',
        rating445: 'Rating: 4.4/5',
        enterSpaceForClinics: "Enter space for clinics \u2192",
        book: 'Book',
        followupConsultation: 'Follow-up Consultation',
        postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
        rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
        completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
        periapicalXray: 'Periapical X-ray',
        workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
        medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
        prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
        diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
        patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
        compositeFillingTooth21: 'Composite Filling - Tooth #21',
        classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
        labResultsCbcPanel: 'Lab Results: CBC Panel',
        completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
        fullmouthRadiographs: 'Full-mouth Radiographs',
        panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
        comprehensiveExamination: 'Comprehensive Examination',
        initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
        medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
        patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
        patientRegistration: 'Patient Registration',
        newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
        activeConditions: 'Active Conditions',
        chronicPeriodontitis: 'Chronic Periodontitis',
        active: 'Active',
        generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
        onsetJan2026: 'Onset: Jan 2026',
        dentalCaries: 'Dental Caries',
        resolved: 'Resolved',
        cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
        resolvedFeb2026: 'Resolved: Feb 2026',
        bruxism: 'Bruxism',
        nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
        activeMedications: 'Active Medications',
        lisinopril10mg: 'Lisinopril 10mg',
        onceDailyOral: 'Once daily, oral',
        hypertensionManagement: 'Hypertension management',
        chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
        twiceDailyOralRinse: 'Twice daily, oral rinse',
        periodontalMaintenance: 'Periodontal maintenance',
        ibuprofen400mg: 'Ibuprofen 400mg',
        asNeededForPain: 'As needed for pain, max 3x daily',
        postprocedurePainManagement: 'Post-procedure pain management',
        pastMedications: 'Past Medications',
        amoxicillin500mg: 'Amoxicillin 500mg',
        periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
        completed2: 'Completed',
        metronidazole250mg: 'Metronidazole 250mg',
        adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
        paracetamol500mg: 'Paracetamol 500mg',
        asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
        postfillingSensitivity: 'Post-filling sensitivity',
        diclofenac50mg: 'Diclofenac 50mg',
        twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
        postexamSoreness: 'Post-exam soreness',
        documentedAllergies: 'Documented Allergies',
        penicillin: 'Penicillin',
        severe: 'SEVERE',
        reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
        crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
        documentedJan102026: 'Documented: Jan 10, 2026',
        latex: 'Latex',
        moderate: 'MODERATE',
        reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
        useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
        lidocaine: 'Lidocaine',
        mild: 'MILD',
        reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
        useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
        latestVitalsMar15: "Latest Vitals \u2014 Mar 15, 2026",
        labResults2: 'Lab Results',
        test: 'TEST',
        result: 'RESULT',
        reference: 'REFERENCE',
        date: 'DATE',
        hemoglobin: 'Hemoglobin',
        platelets: 'Platelets',
        glucoseFasting: 'Glucose (fasting)',
        immunizationRecords: 'Immunization Records',
        hepatitisB: 'Hepatitis B',
        completed3doseSeries2019: 'Completed: 3-dose series, 2019',
        upToDate: 'Up to date',
        tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
        lastBooster2022: 'Last booster: 2022',
        covid19: 'COVID-19',
        lastDoseSep2024: 'Last dose: Sep 2024',
        dueForBooster: 'Due for booster',
        familyMedicalHistory: 'Family Medical History',
        father: 'Father',
        hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
        mother: 'Mother',
        osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
        sibling: 'Sibling',
        bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
        imagingRecords: 'Imaging Records',
        panoramicOpg: 'Panoramic OPG',
        periapical14: 'Periapical #14',
        bitewingRl: 'Bitewing R+L',
        patientDocuments: 'Patient Documents',
        consentFormRootCanal: 'Consent Form - Root Canal',
        treatmentPlanAgreement: 'Treatment Plan Agreement',
        medicalHistoryQuestionnaire: 'Medical History Questionnaire',
        insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
        insuranceInformation: 'Insurance Information',
        provider: 'Provider:',
        policy: 'Policy #:',
        group: 'Group:',
        corporatePlanPremium: 'Corporate Plan - Premium',
        coverage: 'Coverage:',
        deductible: 'Deductible:',
        annualMax2: 'Annual Max:',
        valid: 'Valid:',
        age34: 'Age: 34',
        lastVisitMar10: 'Last visit: Mar 10',
        nextMar19: 'Next: Mar 19',
        overview: 'Overview',
        dentalChart: 'Dental Chart',
        treatmentPlan: 'Treatment Plan',
        history: 'History',
        documents2: 'Documents',
        allergies2: 'Allergies',
        medicalNotes: 'Medical Notes',
        insurance3: 'Insurance',
        upperArch: 'Upper Arch',
        lowerArch: 'Lower Arch',
        tooth: 'TOOTH',
        procedure2: 'PROCEDURE',
        price: 'PRICE',
        rootCanalTreatment: 'Root Canal Treatment',
        ceramicCrown: 'Ceramic Crown',
        compositeFilling: 'Composite Filling',
        implantPlacement: 'Implant Placement',
        total: 'Total',
        addProcedure2: '+ Add Procedure',
        march102026: 'March 10, 2026',
        periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
        february152026: 'February 15, 2026',
        compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
        january202026: 'January 20, 2026',
        comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
        bitewingRight: 'Bitewing Right',
        bitewingLeft: 'Bitewing Left',
        uploadDocument: '+ Upload Document',
        all: 'All',
        new: 'New',
        phone2: 'PHONE',
        lastVisit: 'LAST VISIT',
        nextAppt: 'NEXT APPT',
        balance: 'BALANCE',
        pt001: 'PT-001',
        pt002: 'PT-002',
        pt003: 'PT-003',
        mariamTsiklauri: 'Mariam Tsiklauri',
        pt004: 'PT-004',
        pt005: 'PT-005',
        lukaMchedlishvili: 'Luka Mchedlishvili',
        pt006: 'PT-006',
        tamtaLomidze: 'Tamta Lomidze',
        pt007: 'PT-007',
        periodontalChart: 'Periodontal Chart',
        newExam2: '+ New Exam',
        voiceEntry2: 'Voice Entry',
        dcai: 'DCAI',
        dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
        theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
        manage: 'Manage',
        grow: 'Grow',
        marketSize: 'Market Size',
        dentalClinicsInGeorgia: 'dental clinics in Georgia',
        inTbilisiAlone: 'in Tbilisi alone',
        unifiedBookingOrOps: 'unified booking or ops platforms',
        dentosgeIsTheOnly: "\u26A0\uFE0F  dentos.ge is the only partial incumbent \u2014 no full ops layer",
        theProblem2: 'The Problem',
        str511: "\uD83D\uDCCB",
        clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
        noStructuredWorkflowConstant: 'No structured workflow, constant human error',
        str514: "\uD83D\uDCC9",
        noshowsCost1525Of: "No-shows cost 15\u201325% of revenue",
        noAutomatedRemindersOr: 'No automated reminders or confirmation system',
        str517: "\uD83C\uDFE6",
        insuranceBillingIsManual: 'Insurance billing is manual and painful',
        str519: "\uD83D\uDCF5",
        dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
        theSolution: 'The Solution',
        str523: "\uD83D\uDCC5",
        onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
        patientsBook247From: 'Patients book 24/7 from any device',
        str526: "\uD83E\uDDB7",
        patientRecordsTreatmentManagem: 'Patient records & treatment management',
        fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
        str529: "\uD83C\uDFE5",
        insuranceIntegrations: 'Insurance integrations',
        str531: "\uD83D\uDCAC",
        smsWhatsappReminders: 'SMS / WhatsApp reminders',
        cutNoshowsByUp: 'Cut no-shows by up to 40%',
        str534: "\uD83D\uDCCA",
        financialReportingDashboard: 'Financial reporting dashboard',
        revenueSalariesExpensesRealtim: "Revenue, salaries, expenses \u2014 realtime",
        willingnessToPay: 'Willingness to Pay',
        free: 'Free',
        month: '/month',
        listingBookingWidget: 'Listing + booking widget',
        growth: 'Growth',
        calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
        pro: 'Pro',
        fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
        multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
        wtp0515OfMonthly: "\uD83D\uDCA1 WTP: 0.5\u20131.5% of monthly revenue \u2014 clinics earning \u20BE15K\u201350K/mo pay \u20BE100\u2013350/mo comfortably",
        marketOpportunity: 'Market Opportunity',
        addressableClinicsAtLaunch: 'addressable clinics at launch',
        mrrAtFullPenetration: "MRR at full penetration (\u20BE49 avg)",
        // Nav
        home: 'Home',
        features: 'Features',
        pricing: 'Pricing',
        clinicsNav: 'Clinics',
        aiAssistant: 'AI Assistant',
        forBusiness: 'For Business',
        dashboard: 'Dashboard',
        getStarted: 'Get Started',
        tryDemo: 'Try Live Demo',
        viewPitch: 'View Pitch Deck',
        // Landing Hero
        heroTagline: 'Dental Platform for Georgia',
        heroTitle: 'All dental clinics hub',
        heroSubtitle: 'Your AI assistant to find the best dental care in Georgia',
        searchPlaceholder: 'Search clinics, services, or ask anything...',
        chipImplant: 'Best implant clinics in Tbilisi',
        chipWhitening: 'Teeth whitening near me',
        chipEmergency: 'Emergency dental care',
        chipOrtho: 'Orthodontics for adults',
        scrollExplore: 'Scroll to explore',
        topRated: 'Top-rated dental clinics in Tbilisi',
        viewAllClinics: 'View all clinics',
        shareLocation: 'Share location for nearby clinics',
        locationShared: "Location shared \u2014 showing nearby",
        // Landing Stats
        statClinics: 'Clinics',
        statNoShows: 'Less No-shows',
        statBooking: 'Online Booking',
        statDentists: 'Dentists',
        statRating: 'Avg Rating',
        statPatients: 'Patients',
        // Landing Actions
        findClinics: 'Find Best Clinics',
        forBusinessBtn: 'For Business',
        // Landing Claim
        ownClinic: 'Do you own a dental clinic?',
        claimText: "Claim your listing or add it to our database. We'll help people find your clinic.",
        getListed: "Get Listed \u2192",
        // Clinics Page
        clinicsTitle: 'Dental Clinics in Georgia',
        verifiedClinics: 'verified clinics with ratings and reviews',
        searchByName: 'Search by name, district, or service...',
        hideMap: 'Hide Map',
        showMap: 'Map',
        nearMe: 'Near Me',
        clinicsMatch: 'clinics match',
        reviews: 'reviews',
        loadingMore: 'Loading more...',
        // Clinic Detail
        callClinic: 'Call',
        bookAppointment: 'Book Appointment',
        services: 'Services',
        workingHours: 'Working Hours',
        priceRange: 'Price Range',
        location: 'Location',
        visitWebsite: 'Visit Website',
        // Booking
        bookingTitle: 'Book an Appointment',
        step: 'Step',
        selectClinic: 'Select Clinic',
        selectService: 'Select Service',
        selectDate: 'Select Date',
        selectTime: 'Select Time',
        confirm: 'Confirm',
        next: 'Next',
        back: 'Back',
        clinicsAvailable: 'clinics available',
        clinicsFound: 'clinics found',
        confirmBooking: 'Confirm Booking',
        bookingConfirmed: 'Your appointment has been booked!',
        patientName: 'Patient Name',
        phoneNumber: 'Phone Number',
        email: 'Email',
        notes: 'Notes (optional)',
        // Doctor Booking
        bookByClinic: 'Book by Clinic',
        bookByDoctor: 'Book by Doctor',
        chooseDoctor: 'Choose a Doctor',
        specialOffer: 'Special offer',
        specialOfferAvailable: 'Special offer available',
        availableAtClinics: 'Available at clinics',
        bookAtClinic: 'Book here',
        // Business Page
        businessHeroBadge: "15+ Modules  \xb7  212+ Clinics  \xb7  Gemini AI",
        businessHeroTitle: 'The Operating System for Dental Clinics',
        businessHeroSubtitle: "Clinical charting, periodontal analysis, treatment planning, scheduling, billing, e-prescribing, lab management, and AI diagnostics \u2014 all in one platform built for Georgia.",
        theProblem: 'The Problem',
        problemSubtitle: 'Georgian dental clinics lose revenue daily due to fragmented tools',
        excelChaos: 'Excel & WhatsApp Chaos',
        excelChaosDetail: 'Clinics manage appointments through spreadsheets and chat groups. Zero automation, constant errors, lost records.',
        noShowRate: '25% No-Show Rate',
        noShowDetail: "Without automated reminders, patients forget appointments. Empty chairs mean \u20BE500+/day in lost revenue.",
        paperCharts: 'Paper Charts in 2026',
        paperChartsDetail: 'Handwritten clinical notes, no digital odontogram, no perio tracking. Critical data trapped in filing cabinets.',
        insuranceBlackHole: 'Insurance Black Hole',
        insuranceDetail: 'Manual claims to Aldagi, GPI, Imedi L take hours. Denied claims pile up with no tracking or appeal workflow.',
        // Platform Modules
        oneplatform: 'One Platform, Every Module',
        platformSubtitle: '15 integrated modules purpose-built for dental practices',
        clinical: 'CLINICAL',
        operations: 'OPERATIONS',
        analyticsEnterprise: 'ANALYTICS & ENTERPRISE',
        digitalOdontogram: 'Digital Odontogram',
        digitalOdontogramDetail: 'FDI 32-tooth chart with 5-surface tracking. Click any surface to record caries, restorations, crowns, implants, and missing teeth.',
        perioCharting: 'Perio Charting',
        perioChartingDetail: '192-site periodontal grid. 6-point probing, BOP, CAL, furcation, mobility. AAP staging via Gemini AI.',
        treatmentPlanning: 'Treatment Planning',
        treatmentPlanningDetail: 'Phased plans with CDT codes, insurance estimates, patient portions. Drag-and-drop reordering. AI sequencing.',
        soapNotes: 'SOAP Notes + AI Scribe',
        soapNotesDetail: 'Structured clinical documentation with templates. Gemini generates notes from voice or chart data.',
        multiChairScheduling: 'Multi-Chair Scheduling',
        multiChairDetail: 'Week view with multiple operatories. Provider color-coding, production goals, waitlist management.',
        billingInsurance: 'Billing & Insurance',
        billingDetail: 'Claims tracking for Aldagi, GPI, Imedi L. Patient ledger, aging buckets, payment plans, eligibility checks.',
        ePrescribing: 'e-Prescribing',
        ePrescribingDetail: 'Digital prescriptions with templates. Gemini-powered drug interaction checking. Georgian pharmacy integration.',
        labTracking: 'Lab Case Tracking',
        labTrackingDetail: "Kanban pipeline: Ordered \u2192 Fabrication \u2192 Shipped \u2192 Received. Vendor management, quality tracking.",
        productionReports: 'Production Reports',
        productionReportsDetail: 'Gross/net production, collection rates, treatment acceptance, recall effectiveness. Per-provider breakdown.',
        referralMgmt: 'Referral Management',
        referralMgmtDetail: 'Inbound/outbound referrals to specialists. AI-generated referral letters. Status tracking.',
        medicalHistory: 'Medical History',
        medicalHistoryDetail: '11-view patient record: timeline, conditions (ICD-10), medications, allergies, vitals, imaging, documents.',
        enterpriseAdmin: 'Enterprise Admin',
        enterpriseAdminDetail: 'RBAC, audit logs, compliance meters, multi-tenancy, SSO, feature flags, API management.',
        // AI Section
        geminiBuiltIn: 'Gemini AI Built In',
        geminiSubtitle: 'Every module powered by Google Gemini 3.1',
        xrayAnalysis: 'X-ray Analysis',
        xrayDetail: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment: 'Perio Assessment',
        perioAssessmentDetail: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe: 'Clinical Scribe',
        clinicalScribeDetail: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling: 'Risk Profiling',
        riskProfilingDetail: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing: 'Treatment Sequencing',
        treatmentSequencingDetail: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientComm: 'Patient Communication',
        patientCommDetail: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        // Integrations
        georgianEcosystem: 'Georgian Ecosystem Ready',
        integrationsSubtitle: 'Pre-built integrations with local insurance, payments, and messaging',
        insurance: 'INSURANCE',
        payments: 'PAYMENTS',
        messaging: 'MESSAGING',
        ehrLabs: 'EHR & LABS',
        // Stats
        clinicsInDb: 'Clinics in Database',
        platformModules: 'Platform Modules',
        aiTools: 'AI Tools (Gemini)',
        integrations: 'Integrations',
        // Pricing
        pricingTitle: 'Pricing',
        pricingSubtitle: 'Start free, scale as you grow',
        // Testimonials
        trustedBy: 'Trusted by Leading Clinics',
        // CTA
        readyModernize: 'Ready to modernize your practice?',
        joinCount: 'Join 212+ dental clinics across Georgia already on the platform.',
        startTrial: 'Start Free Trial',
        contactSales: 'Contact Sales',
        noCreditCard: "No credit card required  \xb7  Free tier available  \xb7  Setup in 5 minutes",
        // Footer
        copyright: "\xa9 2026 MCAI \u2014 Dental Clinic Operating System",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: 'Dashboard',
        navPatients: 'Patients',
        navChart: 'Chart',
        navPerio: 'Perio',
        navTreatmentPlans: 'Treatment Plans',
        navNotes: 'Notes',
        navScheduling: 'Scheduling',
        navBilling: 'Billing',
        navPrescriptions: 'Prescriptions',
        navLabCases: 'Lab Cases',
        navReferrals: 'Referrals',
        navReports: 'Reports',
        navMedHistory: 'Medical History',
        navFinances: 'Finance',
        navCabinets: 'Cabinets',
        navRadiology: 'Radiology',
        navDocuments: 'Documents',
        navConsent: 'Consent',
        navInventory: 'Inventory',
        navChat: 'Chat',
        navIntegrations: 'Integrations',
        navEnterprise: 'Enterprise',
        sectionClinical: 'CLINICAL',
        sectionOperations: 'OPERATIONS',
        sectionComm: 'COMMUNICATION',
        sectionAnalytics: 'ANALYTICS',
        sectionAiTools: 'AI TOOLS',
        sectionAdmin: 'ADMIN',
        // Booking Page
        chooseClinic: 'Choose a Clinic',
        selectAService: 'Select a Service',
        pickADate: 'Pick a Date',
        pickATime: 'Pick a Time',
        confirmYourBooking: 'Confirm Your Booking',
        clinicLabel: 'Clinic:',
        serviceLabel: 'Service:',
        dateLabel: 'Date:',
        timeLabel: 'Time:',
        // AI Page
        send: 'Send',
        procedure: 'Procedure',
        observations: 'Observations',
        aiThinking: 'AI is thinking...',
        summarizeHistory: 'Summarize patient history',
        generateTxPlan: 'Generate treatment plan',
        checkDrugInteractions: 'Check drug interactions',
        writeClinicalNote: 'Write clinical note',
        askAiAssistant: 'Ask the AI assistant...',
        dropXray: 'Drop X-ray image or click to upload',
        supportsFormats: 'Supports DICOM, PNG, JPG',
        analysisResults: 'Analysis Results (Demo)',
        aiRecommendation: 'AI Recommendation',
        exportToTxPlan: 'Export to Treatment Plan',
        generateClinicalNote: 'Generate Clinical Note',
        generatedSoap: 'Generated Clinical Note (SOAP)',
        subjective: "S \u2014 Subjective",
        objective: "O \u2014 Objective",
        assessment: "A \u2014 Assessment",
        plan: "P \u2014 Plan",
        copyToRecord: 'Copy to Patient Record',
        aiPerioAssessment: 'AI Periodontal Assessment',
        enterProbingData: 'Enter probing data to get AAP staging/grading and treatment recommendations.',
        analyzeWithGemini: 'Analyze with Gemini',
        aiRiskAssessment: 'AI Risk Assessment',
        enterConditions: 'Enter patient conditions, family history, and vitals to generate a risk profile.',
        generateRiskProfile: 'Generate Risk Profile',
        patientCommunication: 'Patient Communication',
        generateExplanations: 'Generate patient-friendly treatment explanations in Georgian or English.',
        generateExplanation: 'Generate Explanation',
        patientFriendly: 'Patient-Friendly Explanation',
        // Billing Page
        claims: 'Claims',
        ledger: 'Ledger',
        aging: 'Aging',
        paymentPlans: 'Payment Plans',
        eligibility: 'Eligibility',
        allFilter: 'All',
        submitted: 'Submitted',
        paid: 'Paid',
        denied: 'Denied',
        patientLedger: 'Patient Ledger',
        agedAccounts: 'Aged Accounts',
        sendStatements: 'Send Statements',
        activePaymentPlans: 'Active Payment Plans',
        insuranceEligibility: 'Insurance Eligibility',
        // Clinical Charting
        odontogram: 'Odontogram',
        perioTab: 'Perio',
        treatmentPlanTab: 'Treatment Plan',
        notesTab: 'Notes',
        progressNotes: 'Progress Notes',
        openFullPerio: "Open Full Periodontal Chart \u2192",
        openFullTxPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes: "Open Clinical Notes \u2192",
        newExam: 'New Exam',
        voiceEntry: 'Voice Entry',
        bleedingIndex: 'Bleeding Index',
        plaqueIndex: 'Plaque Index',
        sitesAbove4: "Sites \u2265 4mm",
        sitesAbove6: "Sites \u2265 6mm",
        planA: 'Plan A: Recommended',
        planB: 'Plan B: Conservative',
        newPlan: '+ New Plan',
        presentToPatient: 'Present to Patient',
        sendToPortal: 'Send to Portal',
        totalFee: 'Total Fee',
        insuranceEst: 'Insurance Est.',
        patientPortion: 'Patient Portion',
        chairSideMode: 'Chair-side Mode',
        adminMode: 'Admin Mode',
        proceduresAcrossPhases: '{0} procedures across {1} phases',
        // Scheduling
        day: 'Day',
        week: 'Week',
        today: 'Today',
        providerFilter: 'All Providers',
        productionGoal: 'Production Goal',
        waitlist: 'Waitlist',
        // Prescriptions
        activeRx: 'Active',
        pastRx: 'Past',
        templates: 'Templates',
        interactionCheck: 'Interaction Check',
        // Lab Cases
        ordered: 'Ordered',
        sentToLab: 'Sent to Lab',
        inFabrication: 'In Fabrication',
        shipped: 'Shipped',
        received: 'Received',
        labVendors: 'Lab Vendors',
        // Referrals
        allDirections: 'All',
        inbound: 'Inbound',
        outbound: 'Outbound',
        generateLetter: 'Generate Letter',
        // Reports
        production: 'Production',
        collections: 'Collections',
        schedulingReport: 'Scheduling',
        treatmentAcceptance: 'Treatment Acceptance',
        recall: 'Recall',
        grossProduction: 'Gross Production',
        netProduction: 'Net Production',
        collectionRate: 'Collection Rate',
        plansPresented: 'Plans Presented',
        accepted: 'Accepted',
        acceptanceRate: 'Acceptance Rate',
        dueThisMonth: 'Due This Month',
        scheduled: 'Scheduled',
        completed: 'Completed',
        overdue: 'Overdue',
        reactivationRate: 'Reactivation Rate',
        // Medical History
        timeline: 'Timeline',
        conditions: 'Conditions',
        medications: 'Medications',
        allergies: 'Allergies',
        labResults: 'Lab Results',
        vitals: 'Vitals',
        immunizations: 'Immunizations',
        familyHistory: 'Family History',
        imaging: 'Imaging',
        documents: 'Documents',
        // Enterprise
        rbac: 'RBAC',
        auditLog: 'Audit Log',
        compliance: 'Compliance',
        multiTenancy: 'Multi-Tenancy',
        sso: 'SSO & Security',
        featureFlags: 'Feature Flags',
        apiManagement: 'API Management',
        dataManagement: 'Data Management',
        // Integrations
        ehr: 'EHR',
        labs: 'Labs',
        telehealth: 'Telehealth',
        aiMl: 'AI/ML',
        wearables: 'Wearables',
        connected: 'Connected',
        disconnected: 'Disconnected',
        available: 'Available',
        // Components
        status: 'Status',
        healthy: 'Healthy',
        caries: 'Caries',
        restored: 'Restored',
        missing: 'Missing',
        implant: 'Implant',
        crownStatus: 'Crown',
        bridge: 'Bridge',
        veneer: 'Veneer',
        braces: 'Braces',
        surfaces: 'Surfaces',
        procedureHistory: 'Procedure History',
        procedureTimeline: 'Procedure Timeline',
        noHistory: 'No procedures recorded',
        chartLegend: 'Chart Legend',
        addProcedure: 'Add Procedure',
        addHistory: 'Add History',
        addDentalHistory: 'Add Dental History',
        patientReported: 'Patient-reported',
        verified: 'Verified',
        toothNumber: 'Tooth Number',
        selectTooth: 'Select tooth...',
        procedureType: 'Procedure Type',
        selectProcedure: 'Select procedure...',
        filling: 'Filling',
        crown: 'Crown',
        rootCanal: 'Root Canal',
        extraction: 'Extraction',
        implantProc: 'Implant',
        cleaningProc: 'Cleaning',
        whiteningProc: 'Whitening',
        bracesProc: 'Braces',
        other: 'Other',
        month: 'Month',
        year: 'Year',
        selectMonth: 'Select month...',
        selectYear: 'Select year...',
        doctorNameOptional: 'Doctor Name (Optional)',
        enterDoctorName: 'Enter doctor name',
        clinicNameOptional: 'Clinic Name (Optional)',
        enterClinicName: 'Enter clinic name',
        notes: 'Notes',
        enterNotes: 'Add any notes about this procedure...',
        cancel: 'Cancel',
        appointmentDetails: 'Appointment Details',
        openPatientRecord: 'Open Patient Record',
        submitHistory: 'Submit History',
        procedures: 'procedures',
        nextAppt: 'Next',
        totalCharged: 'Total Charged',
        insurancePayment: 'Insurance Payment',
        patientResponsibility: 'Patient Responsibility',
        expand: 'Expand',
        policyNumber: 'Policy #',
        planType: 'Plan Type',
        annualMax: 'Annual Max',
        used: 'Used',
        remaining: 'Remaining',
        coverageByCategory: 'Coverage by Category',
        preventive: 'Preventive',
        basic: 'Basic',
        major: 'Major',
        ortho: 'Ortho',
        current: 'Current',
        thirtyDay: '30 Day',
        sixtyDay: '60 Day',
        ninetyPlus: '90+ Day',
        totalBalance: 'Total Balance',
        monthlyPayment: 'Monthly Payment',
        paymentsRemaining: 'Payments Remaining',
        nextPayment: 'Next Payment',
        paymentProgress: 'Payment Progress',
        choosePlan: 'Choose Plan',
        aiInsight: 'AI Insight',
        confidence: 'Confidence',
        revoke: 'Revoke',
        exams: 'Exams',
        phaseTotal: 'Phase Total',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
        thinking: 'Thinking...',
        followUpPlaceholder: 'Ask a follow-up question...',
        initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
        nextExpansionArmeniaAzerbaijan: "\uD83C\uDF0D  Next expansion: Armenia \u2192 Azerbaijan \u2192 broader Caucasus dental market",
        whyNow: 'Why Now',
        str561: "\u2708\uFE0F",
        dentalTourismBoom: 'Dental tourism boom',
        internationalPatientsNeedEngli: 'International patients need English-language online booking now',
        str564: "\uD83D\uDCF1",
        postcovidDigitizationPressure: 'Post-COVID digitization pressure',
        clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
        str567: "\uD83C\uDFC6",
        noStrongLocalIncumbent: 'No strong local incumbent',
        dentosgeOnlyCoversDiscovery: "dentos.ge only covers discovery \u2014 zero full ops platform exists",
        str570: "\uD83C\uDDEC\uD83C\uDDEA",
        georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
        lowCostHighQuality: "Low cost, high quality \u2014 50\u201370% cheaper than Western Europe",
        joinThePartnerClinic: "Join the Partner Clinic Program \u2014 first 3 months free",
        builtForGeorgianClinics: "\uD83E\uDDB7 Built for Georgian clinics, by people who live here",
        prev: "\u2190 Prev",
        next2: "Next \u2192",
        getInTouch: "\uD83E\uDDB7 Get in Touch",
        activePrescriptions: 'Active Prescriptions',
        pastPrescriptions: 'Past Prescriptions',
        prescriptionTemplates: 'Prescription Templates',
        drugInteractionChecker: 'Drug Interaction Checker',
        referrals: 'Referrals',
        newReferral: '+ New Referral',
        inbound2: 'Inbound',
        outbound2: 'Outbound',
        reportsAnalytics: 'Reports & Analytics',
        productionByProvider: 'Production by Provider',
        productionByCategory: 'Production by Category',
        preventive2: 'Preventive',
        restorative: 'Restorative',
        endodontics: 'Endodontics',
        periodontics: 'Periodontics',
        prosthodontics: 'Prosthodontics',
        surgery: 'Surgery',
        agingReport: 'Aging Report',
        appointmentsByDay: 'Appointments by Day',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        topDeclinedTreatments: 'Top Declined Treatments',
        costConcerns: 'Cost concerns',
        wantsToWait: 'Wants to wait',
        orthodontics: 'Orthodontics',
        insuranceNotCovering: 'Insurance not covering',
        notAPriority: 'Not a priority',
        seekingSecondOpinion: 'Seeking second opinion',
        u2190: '\u2190',
        u2192: '\u2192',
        allProviders: 'All Providers',
        hygienistNino: 'Hygienist Nino',
        mon17: 'MON 17',
        tue18: 'TUE 18',
        wed19: 'WED 19',
        thu20: 'THU 20',
        fri21: 'FRI 21',
        crownPrep14: 'Crown Prep #14',
        tKapanadze: 'T. Kapanadze',
        srpQuad1: 'SRP Quad 1',
        dGelashvili: 'D. Gelashvili',
        examXray: 'Exam + X-ray',
        mTsiklauri: 'M. Tsiklauri',
        unconfirmed: 'Unconfirmed',
        rct36: 'RCT #36',
        gBeridze: 'G. Beridze',
        prophyPolish: 'Prophy + Polish',
        iDiasamidze: 'I. Diasamidze',
        perioMaintenance: 'Perio Maintenance',
        tLomidze: 'T. Lomidze',
        prophy: 'Prophy',
        aJavakhishvili: 'A. Javakhishvili',
        inChair: 'In Chair',
        sealantsX4: 'Sealants x4',
        nKapanadze: 'N. Kapanadze',
        lMchedlishvili: 'L. Mchedlishvili',
        u2014LunchU2014: '\u2014 Lunch \u2014',
        veneerPrep11: 'Veneer Prep #11',
        kGabrichidze: 'K. Gabrichidze',
        composite25: 'Composite #25',
        sMeladze: 'S. Meladze',
        bridgePrep3436: 'Bridge Prep #34-36',
        rKharazishvili: 'R. Kharazishvili',
        composite22: 'Composite #22',
        zDolidze: 'Z. Dolidze',
        noShow: 'No Show',
        extraction48: 'Extraction #48',
        vPapunashvili: 'V. Papunashvili',
        implantConsult: 'Implant Consult',
        eTsereteli: 'E. Tsereteli',
        nGogiberidze: 'N. Gogiberidze',
        crownSeat14: 'Crown Seat #14',
        checkup: 'Checkup',
        bShengelia: 'B. Shengelia',
        fluorideTreatment: 'Fluoride Treatment',
        emergencyWalkin: 'Emergency Walk-in',
        scaling: 'Scaling',
        wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
        assignToSchedule: 'Assign to Schedule',
        autoAssign: 'Auto Assign',
        high: 'High',
        anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
        medium: 'Medium',
        irakliDiasamidze: 'Irakli Diasamidze',
        friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
        low: 'Low',
        planARecommended: 'Plan A: Recommended',
        planBConservative: 'Plan B: Conservative',
        newPlan2: '+ New Plan',
        conservativeApproach: 'Conservative Approach',
        thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
        u00b7: '\u00B7',
        treatmentPlanComparison: 'Treatment Plan Comparison',
        u00b72: '\u00b7',
        exams2: 'Exams:',
        metric: 'Metric',
        pdMm: 'PD (mm)',
        gmMm: 'GM (mm)',
        calMm: 'CAL (mm)',
        suppuration: 'Suppuration',
        furcation: 'Furcation',
        mobility: 'Mobility',
        qty: 'Qty',
        refills: 'Refills',
        goal: 'Goal',
        current2: 'Current',
        totalDue: 'Total Due',
        scheduled2: 'Scheduled',
        overdue2: 'Overdue',
        reactivation: 'Reactivation',
        chiefComplaint: 'Chief Complaint',
        painScale: 'Pain Scale:',
        clinicalFindings: 'Clinical Findings',
        diagnosis: 'Diagnosis',
        prescriptions: 'Prescriptions',
        u201c: '\u201C',
        xray: 'X-Ray',
        cleaning: 'Cleaning',
        // Informed Consent
        informedConsent: 'Informed Consent',
        informedConsentTitle: 'Informed Consent Form',
        newConsent: 'New Consent',
        consentHistory: 'Consent History',
        consentProcedureTitle: 'Procedure Description',
        consentProcedureDesc: 'Your dentist has recommended the following procedure. This section describes the nature, purpose, and expected steps of the planned treatment. Please read carefully before acknowledging.',
        consentRisksTitle: 'Risks & Complications',
        consentRisksDesc: 'As with any medical or dental procedure, there are potential risks including but not limited to infection, bleeding, nerve damage, allergic reaction to materials or anesthesia, and the possibility that the treatment may not achieve the desired outcome.',
        consentAlternativesTitle: 'Alternative Treatments',
        consentAlternativesDesc: 'Alternative treatment options may include no treatment, delayed treatment, or different procedures. Each alternative carries its own benefits and risks. Your dentist can discuss these options with you in detail.',
        consentOutcomesTitle: 'Expected Outcomes',
        consentOutcomesDesc: 'The expected outcome of this procedure is to restore dental health, function, and/or aesthetics. Individual results may vary based on the complexity of the case, patient compliance, and other health factors.',
        consentAftercareTitle: 'Aftercare Instructions',
        consentAftercareDesc: 'Following the procedure, you will receive specific aftercare instructions. These may include dietary restrictions, medication schedules, activity limitations, and follow-up appointment requirements. Adherence to these instructions is essential for optimal healing.',
        consentAcknowledge: 'I understand and agree',
        eSignatureTitle: 'Electronic Signature',
        consentCheckAllFirst: 'Please acknowledge all sections above before signing',
        clearSignature: 'Clear Signature',
        confirmSignature: 'Confirm Signature',
        signatureCapturedAt: 'Signature captured at',
        signed: 'Signed',
        awaitingSignature: 'Awaiting signature',
        viewDetails: 'View Details',
        untitled: 'Untitled',
        amountPaid: 'Amount Paid',
        annotate: 'Annotate',
        anonymousPatient: 'Anonymous Patient',
        autoImport: 'Auto Import',
        away: 'Away',
        bankTransfer: 'Bank Transfer',
        beforeAfter: 'Before After',
        bookPrerequisiteFirst: 'Book Prerequisite First',
        breakdown: 'Breakdown',
        bridgePrep: 'Bridge Prep',
        brightness: 'Brightness',
        cabinet: 'Cabinet',
        cabinet1: 'Cabinet 1',
        cabinet2: 'Cabinet 2',
        cabinetSchedule: 'Cabinet Schedule',
        cabinetScheduleDesc: 'Cabinet Schedule Desc',
        card: 'Card',
        cash: 'Cash',
        cbct: 'Cbct',
        cephalometric: 'Cephalometric',
        channels: 'Channels',
        clinicalQuestion: 'Clinical Question',
        clinicAvgRating: 'Clinic Avg Rating',
        collapse: 'Collapse',
        completedToday: 'Completed Today',
        compositeF: 'Composite F',
        continueToScheduling: 'Continue To Scheduling',
        contrast: 'Contrast',
        ctScans: 'Ct Scans',
        customAmount: 'Custom Amount',
        days: 'Days',
        delivered: 'Delivered',
        directMessages: 'Direct Messages',
        disposables: 'Disposables',
        doctorResponse: 'Doctor Response',
        doctors: 'Doctors',
        documentMgmtSubtitle: 'Document Mgmt Subtitle',
        documentPreview: 'Document Preview',
        download: 'Download',
        endodontic: 'Endodontic',
        enterAmount: 'Enter Amount',
        equipmentDevices: 'Equipment Devices',
        estDelivery: 'Est Delivery',
        examConsult: 'Exam Consult',
        explanationQuality: 'Explanation Quality',
        fluorideTx: 'Fluoride Tx',
        fullMouthView: 'Full Mouth View',
        hasBracesQuestion: 'Has Braces Question',
        hasConsultationQuestion: 'Has Consultation Question',
        hasCtScanQuestion: 'Has Ct Scan Question',
        hasRecentXrayQuestion: 'Has Recent Xray Question',
        helpfulQuestion: 'Helpful Question',
        highest: 'Highest',
        hygiene: 'Hygiene',
        imagingType: 'Imaging Type',
        implantPlace: 'Implant Place',
        important: 'Important',
        importLatest: 'Import Latest',
        inProgress: 'In Progress',
        installment: 'Installment',
        insuranceCoverage: 'Insurance Coverage',
        interpreted: 'Interpreted',
        inUse: 'In Use',
        invoices: 'Invoices',
        lastCleaningQuestion: 'Last Cleaning Question',
        lateralSkullView: 'Lateral Skull View',
        lowest: 'Lowest',
        lowStock: 'Low Stock',
        lowStockAlerts: 'Low Stock Alerts',
        maintenance: 'Maintenance',
        management: 'Management',
        markComplete: 'Mark Complete',
        material: 'Material',
        method: 'Method',
        minOrder: 'Min Order',
        monthlySpend: 'Monthly Spend',
        newPayment: 'New Payment',
        newRadiologyReferral: 'New Radiology Referral',
        nextAppointment: 'Next Appointment',
        noDocumentsFound: 'No Documents Found',
        noNoteSelected: 'No Note Selected',
        normal: 'Normal',
        noteInterpreter: 'Note Interpreter',
        occupied: 'Occupied',
        online: 'Online',
        orderNow: 'Order Now',
        orders: 'Orders',
        original: 'Original',
        outstanding: 'Outstanding',
        painManagement: 'Pain Management',
        panoramic: 'Panoramic',
        patientDue: 'Patient Due',
        paymentHistory: 'Payment History',
        paymentMethod: 'Payment Method',
        pendingOrders: 'Pending Orders',
        periapical: 'Periapical',
        perioMaint: 'Perio Maint',
        photos: 'Photos',
        placeOrder: 'Place Order',
        preCheck: 'Pre Check',
        preCheckPassed: 'Pre Check Passed',
        preCheckSubtitle: 'Pre Check Subtitle',
        preCheckTitle: 'Pre Check Title',
        prerequisiteWarning: 'Prerequisite Warning',
        print: 'Print',
        processing: 'Processing',
        processPayment: 'Process Payment',
        processPaymentBtn: 'Process Payment Btn',
        professionalism: 'Professionalism',
        prophyClean: 'Prophy Clean',
        prosthetic: 'Prosthetic',
        punctuality: 'Punctuality',
        qtyUsed: 'Qty Used',
        quantity: 'Quantity',
        queue: 'Queue',
        receiptPreview: 'Receipt Preview',
        recent: 'Recent',
        recentMaterialUsage: 'Recent Material Usage',
        recentReceipts: 'Recent Receipts',
        reliability: 'Reliability',
        remainingBalance: 'Remaining Balance',
        reorderLevel: 'Reorder Level',
        scanning: 'Scanning',
        sealants: 'Sealants',
        sent: 'Sent',
        singleToothView: 'Single Tooth View',
        slotDetails: 'Slot Details',
        sortBy: 'Sort By',
        srpQuad: 'Srp Quad',
        startImaging: 'Start Imaging',
        stock: 'Stock',
        stockLevel: 'Stock Level',
        submitReferral: 'Submit Referral',
        subtotal: 'Subtotal',
        suppliers: 'Suppliers',
        surgical: 'Surgical',
        targetArea: 'Target Area',
        teamChat: 'Team Chat',
        termsNormalized: 'Terms Normalized',
        threeDImaging: 'Three D Imaging',
        totalItems: 'Total Items',
        totalReceived: 'Total Received',
        typeAMessage: 'Type A Message',
        unavailable: 'Unavailable',
        unit: 'Unit',
        urgency: 'Urgency',
        urgent: 'Urgent',
        usageLog: 'Usage Log',
        veneerPrep: 'Veneer Prep',
        viewOnGoogle: 'View On Google',
        xrays: 'Xrays'
    },
    ka: {
        // Nav
        home: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8",
        features: "\u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D4\u10D1\u10D8",
        pricing: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8",
        clinicsNav: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8",
        aiAssistant: "AI \u10D0\u10E1\u10D8\u10E1\u10E2\u10D4\u10DC\u10E2\u10D8",
        forBusiness: "\u10D1\u10D8\u10D6\u10DC\u10D4\u10E1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        dashboard: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8 \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8",
        getStarted: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0",
        tryDemo: "\u10E1\u10EA\u10D0\u10D3\u10D4\u10D7 \u10D3\u10D4\u10DB\u10DD",
        viewPitch: "\u10DE\u10E0\u10D4\u10D6\u10D4\u10DC\u10E2\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0",
        // Landing Hero
        heroTagline: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1\u10D7\u10D5\u10D8\u10E1",
        heroTitle: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10D4\u10E0\u10D7 \u10E1\u10D8\u10D5\u10E0\u10EA\u10D4\u10E8\u10D8",
        heroSubtitle: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 AI \u10D0\u10E1\u10D8\u10E1\u10E2\u10D4\u10DC\u10E2\u10D8 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E8\u10D8 \u10E1\u10D0\u10E3\u10D9\u10D4\u10D7\u10D4\u10E1\u10DD \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10E1\u10D0\u10EB\u10D4\u10D1\u10DC\u10D0\u10D3",
        searchPlaceholder: "\u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D4\u10D7 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8, \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D4\u10D1\u10D8 \u10D0\u10DC \u10F0\u10D9\u10D8\u10D7\u10EE\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D4...",
        chipImplant: "\u10E1\u10D0\u10E3\u10D9\u10D4\u10D7\u10D4\u10E1\u10DD \u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10E8\u10D8",
        chipWhitening: "\u10D9\u10D1\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D7\u10D4\u10D7\u10E0\u10D4\u10D1\u10D0 \u10E9\u10D4\u10DB\u10D7\u10D0\u10DC \u10D0\u10EE\u10DA\u10DD\u10E1",
        chipEmergency: "\u10D2\u10D0\u10D3\u10D0\u10E3\u10D3\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D3\u10D0\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D0",
        chipOrtho: "\u10DD\u10E0\u10D7\u10DD\u10D3\u10DD\u10DC\u10E2\u10D8\u10D0 \u10DB\u10DD\u10D6\u10E0\u10D3\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        scrollExplore: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10EE\u10D5\u10D8\u10D4\u10D7 \u10E1\u10D0\u10DC\u10D0\u10EE\u10D0\u10D5\u10D0\u10D3",
        topRated: "\u10E1\u10D0\u10E3\u10D9\u10D4\u10D7\u10D4\u10E1\u10DD \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10E8\u10D8",
        viewAllClinics: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0",
        shareLocation: "\u10D2\u10D0\u10D0\u10D6\u10D8\u10D0\u10E0\u10D4\u10D7 \u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0 \u10D0\u10EE\u10DA\u10DD\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        locationShared: "\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0 \u10D2\u10D0\u10D6\u10D8\u10D0\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u2014 \u10D0\u10EE\u10DA\u10DD\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10E9\u10D0\u10DC\u10E1",
        // Landing Stats
        statClinics: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0",
        statNoShows: "\u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D0",
        statBooking: "\u10DD\u10DC\u10DA\u10D0\u10D8\u10DC \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        statDentists: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8",
        statRating: "\u10E1\u10D0\u10E8. \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        statPatients: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8",
        // Landing Actions
        findClinics: "\u10D8\u10DE\u10DD\u10D5\u10D4\u10D7 \u10E1\u10D0\u10E3\u10D9\u10D4\u10D7\u10D4\u10E1\u10DD \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8",
        forBusinessBtn: "\u10D1\u10D8\u10D6\u10DC\u10D4\u10E1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        // Landing Claim
        ownClinic: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D8\u10E1 \u10DB\u10E4\u10DA\u10DD\u10D1\u10D4\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D7?",
        claimText: "\u10D3\u10D0\u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10D0\u10DC \u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4\u10D7 \u10E9\u10D5\u10D4\u10DC\u10E1 \u10D1\u10D0\u10D6\u10D0\u10E8\u10D8. \u10D3\u10D0\u10D5\u10D4\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D8\u10D7 \u10EE\u10D0\u10DA\u10EE\u10E1 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D8\u10E1 \u10DE\u10DD\u10D5\u10DC\u10D0\u10E8\u10D8.",
        getListed: "\u10D3\u10D0\u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D3\u10D8\u10D7 \u2192",
        // Clinics Page
        clinicsTitle: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E8\u10D8",
        verifiedClinics: "\u10D5\u10D4\u10E0\u10D8\u10E4\u10D8\u10EA\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D4\u10D1\u10D8\u10D7\u10D0 \u10D3\u10D0 \u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D4\u10D1\u10D8\u10D7",
        searchByName: "\u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D4\u10D7 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7, \u10E0\u10D0\u10D8\u10DD\u10DC\u10D8\u10D7 \u10D0\u10DC \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8\u10D7...",
        hideMap: "\u10E0\u10E3\u10D9\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10DA\u10D5\u10D0",
        showMap: "\u10E0\u10E3\u10D9\u10D0",
        nearMe: "\u10E9\u10D4\u10DB\u10D7\u10D0\u10DC \u10D0\u10EE\u10DA\u10DD\u10E1",
        clinicsMatch: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0",
        reviews: "\u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0",
        loadingMore: "\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0...",
        // Clinic Detail
        callClinic: "\u10D3\u10D0\u10E0\u10D4\u10D9\u10D5\u10D0",
        bookAppointment: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10EF\u10D0\u10D5\u10E8\u10DC\u10D0",
        services: "\u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D4\u10D1\u10D8",
        workingHours: "\u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10E1\u10D0\u10D0\u10D7\u10D4\u10D1\u10D8",
        priceRange: "\u10E4\u10D0\u10E1\u10D8\u10E1 \u10D3\u10D8\u10D0\u10DE\u10D0\u10D6\u10DD\u10DC\u10D8",
        location: "\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0",
        visitWebsite: "\u10D5\u10D4\u10D1\u10E1\u10D0\u10D8\u10E2\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0",
        // Booking
        bookingTitle: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10EF\u10D0\u10D5\u10E8\u10DC\u10D0",
        step: "\u10DC\u10D0\u10D1\u10D8\u10EF\u10D8",
        selectClinic: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0",
        selectService: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8",
        selectDate: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        selectTime: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D3\u10E0\u10DD",
        confirm: "\u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0",
        next: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8",
        back: "\u10E3\u10D9\u10D0\u10DC",
        clinicsAvailable: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0",
        clinicsFound: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0",
        confirmBooking: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0",
        bookingConfirmed: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10D3\u10D0\u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10DA\u10D8\u10D0!",
        patientName: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8",
        phoneNumber: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8",
        email: "\u10D4\u10DA.\u10E4\u10DD\u10E1\u10E2\u10D0",
        notes: "\u10E8\u10D4\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10D1\u10D8 (\u10D0\u10E0\u10D0\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD)",
        // Business Page
        businessHeroBadge: "15+ \u10DB\u10DD\u10D3\u10E3\u10DA\u10D8  \xb7  212+ \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0  \xb7  Gemini AI",
        businessHeroTitle: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8\u10E1 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0",
        businessHeroSubtitle: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E9\u10D0\u10E0\u10E2\u10D8\u10DC\u10D2\u10D8, \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8, \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D5\u10D0, \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8, \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D0, \u10D4\u10DA.\u10E0\u10D4\u10EA\u10D4\u10DE\u10E2\u10D4\u10D1\u10D8, \u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0 \u10D3\u10D0 AI \u10D3\u10D8\u10D0\u10D2\u10DC\u10DD\u10E1\u10E2\u10D8\u10D9\u10D0 \u2014 \u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10D8 \u10D4\u10E0\u10D7 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0\u10D6\u10D4.",
        theProblem: "\u10DE\u10E0\u10DD\u10D1\u10DA\u10D4\u10DB\u10D0",
        problemSubtitle: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u10E7\u10DD\u10D5\u10D4\u10DA\u10D3\u10E6\u10D8\u10E3\u10E0\u10D0\u10D3 \u10D9\u10D0\u10E0\u10D2\u10D0\u10D5\u10D4\u10DC \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10E1 \u10E4\u10E0\u10D0\u10D2\u10DB\u10D4\u10DC\u10E2\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD",
        excelChaos: "Excel \u10D3\u10D0 WhatsApp \u10E5\u10D0\u10DD\u10E1\u10D8",
        excelChaosDetail: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10E1 \u10EA\u10EE\u10E0\u10D8\u10DA\u10D4\u10D1\u10D8\u10D7 \u10D3\u10D0 \u10E9\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10DB\u10D0\u10E0\u10D7\u10D0\u10D5\u10D4\u10DC. \u10DC\u10E3\u10DA\u10DD\u10D5\u10D0\u10DC\u10D8 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0, \u10DB\u10E3\u10D3\u10DB\u10D8\u10D5\u10D8 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D4\u10D1\u10D8, \u10D3\u10D0\u10D9\u10D0\u10E0\u10D2\u10E3\u10DA\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8.",
        noShowRate: "25% \u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D8\u10E1 \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D4\u10DA\u10D8",
        noShowDetail: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4 \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10E1 \u10D0\u10D5\u10D8\u10EC\u10E7\u10D3\u10D4\u10D1\u10D0\u10D7. \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8 \u10E1\u10D0\u10D5\u10D0\u10E0\u10EB\u10DA\u10D4\u10D1\u10D8 \u20BE500+/\u10D3\u10E6\u10D4\u10E8\u10D8 \u10D3\u10D0\u10D9\u10D0\u10E0\u10D2\u10E3\u10DA \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10E1 \u10DC\u10D8\u10E8\u10DC\u10D0\u10D5\u10E1.",
        paperCharts: "\u10E5\u10D0\u10E6\u10D0\u10DA\u10D3\u10D8\u10E1 \u10E9\u10D0\u10E0\u10E2\u10D4\u10D1\u10D8 2026-\u10E8\u10D8",
        paperChartsDetail: "\u10EE\u10D4\u10DA\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8, \u10EA\u10D8\u10E4\u10E0\u10E3\u10DA\u10D8 \u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10D2\u10E0\u10D0\u10DB\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4, \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4. \u10D9\u10E0\u10D8\u10E2\u10D8\u10D9\u10E3\u10DA\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10E9\u10D0\u10D9\u10D4\u10E2\u10D8\u10DA\u10D8\u10D0 \u10E1\u10D0\u10E5\u10D0\u10E6\u10D0\u10DA\u10D3\u10D4\u10D4\u10D1\u10E8\u10D8.",
        insuranceBlackHole: "\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D8\u10E1 \u10E8\u10D0\u10D5\u10D8 \u10EE\u10D5\u10E0\u10D4\u10DA\u10D8",
        insuranceDetail: "\u10EE\u10D4\u10DA\u10D8\u10D7 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D4\u10D1\u10D8 \u10D0\u10DA\u10D3\u10D0\u10D2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1, GPI-\u10E1\u10D7\u10D5\u10D8\u10E1, \u10D8\u10DB\u10D4\u10D3\u10D8 \u10D4\u10DA-\u10E1\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10D0\u10D7\u10D4\u10D1\u10E1 \u10DB\u10DD\u10D8\u10D7\u10EE\u10DD\u10D5\u10E1. \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D4\u10D1\u10D8 \u10D2\u10E0\u10DD\u10D5\u10D3\u10D4\u10D1\u10D0 \u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D2\u10D0\u10E1\u10D0\u10E9\u10D8\u10D5\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4.",
        // Platform Modules
        oneplatform: "\u10D4\u10E0\u10D7\u10D8 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0, \u10E7\u10D5\u10D4\u10DA\u10D0 \u10DB\u10DD\u10D3\u10E3\u10DA\u10D8",
        platformSubtitle: "15 \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10DD\u10D3\u10E3\u10DA\u10D8 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10DE\u10E0\u10D0\u10E5\u10E2\u10D8\u10D9\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        clinical: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8",
        operations: "\u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
        analyticsEnterprise: "\u10D0\u10DC\u10D0\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0 \u10D3\u10D0 \u10D4\u10DC\u10E2\u10D4\u10E0\u10DE\u10E0\u10D0\u10D8\u10D6\u10D8",
        digitalOdontogram: "\u10EA\u10D8\u10E4\u10E0\u10E3\u10DA\u10D8 \u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10D2\u10E0\u10D0\u10DB\u10D0",
        digitalOdontogramDetail: "FDI 32-\u10D9\u10D1\u10D8\u10DA\u10D8\u10D0\u10DC\u10D8 \u10E0\u10E3\u10D9\u10D0 5-\u10D6\u10D4\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8\u10D0\u10DC\u10D8 \u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8\u10D7. \u10D3\u10D0\u10D0\u10EC\u10D9\u10D0\u10DE\u10E3\u10DC\u10D4\u10D7 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10D6\u10D4\u10D3\u10D0\u10DE\u10D8\u10E0\u10D6\u10D4 \u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8\u10E1, \u10E0\u10D4\u10E1\u10E2\u10D0\u10D5\u10E0\u10D0\u10EA\u10D8\u10D8\u10E1, \u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8\u10E1, \u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D0\u10DB\u10DD\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10D1\u10D8\u10DA\u10D8\u10E1 \u10D0\u10E6\u10E1\u10D0\u10DC\u10D8\u10E8\u10DC\u10D0\u10D5\u10D0\u10D3.",
        perioCharting: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E9\u10D0\u10E0\u10E2\u10D8\u10DC\u10D2\u10D8",
        perioChartingDetail: "192-\u10D0\u10D3\u10D2\u10D8\u10DA\u10D8\u10D0\u10DC\u10D8 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D1\u10D0\u10D3\u10D4. 6-\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10D0\u10DC\u10D8 \u10D6\u10DD\u10DC\u10D3\u10D8\u10E0\u10D4\u10D1\u10D0, BOP, CAL, \u10E4\u10E3\u10E0\u10D9\u10D0\u10EA\u10D8\u10D0, \u10DB\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0. AAP \u10E1\u10E2\u10D4\u10D8\u10EF\u10D8\u10DC\u10D2\u10D8 Gemini AI-\u10D8\u10D7.",
        treatmentPlanning: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D5\u10D0",
        treatmentPlanningDetail: "\u10E4\u10D0\u10D6\u10E3\u10E0\u10D8 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8 CDT \u10D9\u10DD\u10D3\u10D4\u10D1\u10D8\u10D7, \u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D4\u10D1\u10D8\u10D7, \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10EC\u10D8\u10DA\u10D8\u10D7. \u10D2\u10D0\u10D3\u10D0\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10D2\u10D0\u10D3\u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. AI \u10E1\u10D4\u10D9\u10D5\u10D4\u10DC\u10EA\u10D8\u10E0\u10D4\u10D1\u10D0.",
        soapNotes: "SOAP \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8 + AI \u10E1\u10D9\u10E0\u10D8\u10D1\u10D8",
        soapNotesDetail: "\u10E1\u10E2\u10E0\u10E3\u10E5\u10E2\u10E3\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D0\u10EA\u10D8\u10D0 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D4\u10D1\u10D8\u10D7. Gemini \u10E5\u10DB\u10DC\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10E1 \u10EE\u10DB\u10D8\u10D3\u10D0\u10DC \u10D0\u10DC \u10E9\u10D0\u10E0\u10E2\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC.",
        multiChairScheduling: "\u10DB\u10E0\u10D0\u10D5\u10D0\u10DA\u10E1\u10D0\u10D5\u10D0\u10E0\u10EB\u10DA\u10D8\u10D0\u10DC\u10D8 \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8",
        multiChairDetail: "\u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10EE\u10D4\u10D3\u10D8 \u10DB\u10E0\u10D0\u10D5\u10D0\u10DA\u10D8 \u10DD\u10DE\u10D4\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D8\u10D7. \u10DE\u10E0\u10DD\u10D5\u10D0\u10D8\u10D3\u10D4\u10E0\u10D8\u10E1 \u10E4\u10D4\u10E0\u10D8\u10D7 \u10D9\u10DD\u10D3\u10D8\u10E0\u10D4\u10D1\u10D0, \u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D4\u10D1\u10D8, \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10D8\u10E1 \u10E1\u10D8\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0.",
        billingInsurance: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0",
        billingDetail: "\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8 \u10D0\u10DA\u10D3\u10D0\u10D2\u10D8, GPI, \u10D8\u10DB\u10D4\u10D3\u10D8 \u10D4\u10DA-\u10E1\u10D7\u10D5\u10D8\u10E1. \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D1\u10D0\u10DA\u10D0\u10DC\u10E1\u10D8, \u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E1\u10D0\u10D9\u10DD\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8, \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8, \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0.",
        ePrescribing: "\u10D4\u10DA.\u10E0\u10D4\u10EA\u10D4\u10DE\u10E2\u10D4\u10D1\u10D8",
        ePrescribingDetail: "\u10EA\u10D8\u10E4\u10E0\u10E3\u10DA\u10D8 \u10E0\u10D4\u10EA\u10D4\u10DE\u10E2\u10D4\u10D1\u10D8 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D4\u10D1\u10D8\u10D7. Gemini-\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10EC\u10D0\u10DB\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E3\u10E0\u10D7\u10D8\u10D4\u10E0\u10D7\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0. \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA \u10D0\u10E4\u10D7\u10D8\u10D0\u10E5\u10D4\u10D1\u10D7\u10D0\u10DC \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D0.",
        labTracking: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8",
        labTrackingDetail: "\u10D9\u10D0\u10DC\u10D1\u10D0\u10DC \u10DE\u10D0\u10D8\u10DE\u10DA\u10D0\u10D8\u10DC\u10D8: \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10DA\u10D8 \u2192 \u10E4\u10D0\u10D1\u10E0\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0 \u2192 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8 \u2192 \u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8. \u10DB\u10DD\u10DB\u10EC\u10DD\u10D3\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0, \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8\u10E1 \u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8.",
        productionReports: "\u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8",
        productionReportsDetail: "\u10DB\u10D7\u10DA\u10D8\u10D0\u10DC\u10D8/\u10EC\u10DB\u10D8\u10DC\u10D3\u10D0 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D0, \u10E8\u10D4\u10D2\u10E0\u10DD\u10D5\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8, \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0, \u10D2\u10D0\u10DB\u10DD\u10EB\u10D0\u10EE\u10D4\u10D1\u10D8\u10E1 \u10D4\u10E4\u10D4\u10E5\u10E2\u10E3\u10E0\u10DD\u10D1\u10D0. \u10DE\u10E0\u10DD\u10D5\u10D0\u10D8\u10D3\u10D4\u10E0\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7 \u10D3\u10D0\u10E8\u10DA\u10D0.",
        referralMgmt: "\u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        referralMgmtDetail: "\u10E8\u10D4\u10DB\u10DD\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8/\u10D2\u10D0\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8 \u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10D4\u10D1\u10D8 \u10E1\u10DE\u10D4\u10EA\u10D8\u10D0\u10DA\u10D8\u10E1\u10E2\u10D4\u10D1\u10D7\u10D0\u10DC. AI-\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10D0\u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10DD \u10EC\u10D4\u10E0\u10D8\u10DA\u10D4\u10D1\u10D8. \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8\u10E1 \u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8.",
        medicalHistory: "\u10E1\u10D0\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10DD \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        medicalHistoryDetail: "11-\u10EE\u10D4\u10D3\u10D8\u10D0\u10DC\u10D8 \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8: \u10E5\u10E0\u10DD\u10DC\u10DD\u10DA\u10DD\u10D2\u10D8\u10D0, \u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D4\u10D1\u10D8 (ICD-10), \u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8, \u10D0\u10DA\u10D4\u10E0\u10D2\u10D8\u10D4\u10D1\u10D8, \u10E1\u10D0\u10E1\u10D8\u10EA\u10DD\u10EA\u10EE\u10DA\u10DD \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8, \u10D2\u10D0\u10DB\u10DD\u10E1\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8, \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8.",
        enterpriseAdmin: "\u10D4\u10DC\u10E2\u10D4\u10E0\u10DE\u10E0\u10D0\u10D8\u10D6 \u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10D0",
        enterpriseAdminDetail: "RBAC, \u10D0\u10E3\u10D3\u10D8\u10E2\u10D8\u10E1 \u10DF\u10E3\u10E0\u10DC\u10D0\u10DA\u10D8, \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10DD\u10D1\u10D8\u10E1 \u10DB\u10D4\u10E2\u10E0\u10D8\u10D9\u10D4\u10D1\u10D8, \u10DB\u10E3\u10DA\u10E2\u10D8-\u10E2\u10D4\u10DC\u10D0\u10DC\u10E2\u10DD\u10D1\u10D0, SSO, \u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E4\u10DA\u10D0\u10D2\u10D4\u10D1\u10D8, API \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0.",
        // AI Section
        geminiBuiltIn: "Gemini AI \u10E9\u10D0\u10E8\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8",
        geminiSubtitle: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10DB\u10DD\u10D3\u10E3\u10DA\u10D8 Google Gemini 3.1-\u10D8\u10D7 \u10D0\u10E0\u10D8\u10E1 \u10D0\u10E6\u10ED\u10E3\u10E0\u10D5\u10D8\u10DA\u10D8",
        xrayAnalysis: "\u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8",
        xrayDetail: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D7 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8 AI-\u10D8\u10D7 \u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8\u10E1 \u10D0\u10E6\u10DB\u10DD\u10E9\u10D4\u10DC\u10D8\u10E1, \u10EB\u10D5\u10DA\u10D8\u10E1 \u10D3\u10DD\u10DC\u10D8\u10E1 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DE\u10D0\u10D7\u10DD\u10DA\u10DD\u10D2\u10D8\u10D8\u10E1 \u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1.",
        perioAssessment: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        perioAssessmentDetail: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 AAP \u10E1\u10E2\u10D4\u10D8\u10EF\u10D8\u10DC\u10D2\u10D8/\u10D2\u10E0\u10D4\u10D8\u10D3\u10D8\u10DC\u10D2\u10D8 \u10D6\u10DD\u10DC\u10D3\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC. \u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8\u10D8\u10E1 \u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0, SRP \u10D0\u10DC \u10E5\u10D8\u10E0\u10E3\u10E0\u10D2\u10D8\u10E3\u10DA\u10D8 \u10E9\u10D0\u10E0\u10D4\u10D5\u10D8\u10E1 \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D0\u10EA\u10D8\u10D0.",
        clinicalScribe: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E1\u10D9\u10E0\u10D8\u10D1\u10D8",
        clinicalScribeDetail: "SOAP \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0 \u10EE\u10DB\u10DD\u10D5\u10D0\u10DC\u10D8 \u10E9\u10D0\u10EC\u10D4\u10E0\u10D8\u10D3\u10D0\u10DC \u10D0\u10DC \u10E9\u10D0\u10E0\u10E2\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC. CDT \u10D9\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0 ICD-10-\u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0.",
        riskProfiling: "\u10E0\u10D8\u10E1\u10D9\u10D8\u10E1 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8\u10E0\u10D4\u10D1\u10D0",
        riskProfilingDetail: "\u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D4\u10D1\u10E1 \u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0\u10E1, \u10DD\u10EF\u10D0\u10EE\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0\u10E1 \u10D3\u10D0 \u10E1\u10D0\u10E1\u10D8\u10EA\u10DD\u10EA\u10EE\u10DA\u10DD \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10DA\u10D4\u10D1\u10E1 \u10E7\u10DD\u10D5\u10DA\u10D8\u10E1\u10DB\u10DD\u10DB\u10EA\u10D5\u10D4\u10DA\u10D8 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E0\u10D8\u10E1\u10D9\u10D8\u10E1 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10E5\u10DB\u10DC\u10D4\u10DA\u10D0\u10D3.",
        treatmentSequencing: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E1\u10D4\u10D9\u10D5\u10D4\u10DC\u10EA\u10D8\u10E0\u10D4\u10D1\u10D0",
        treatmentSequencingDetail: "AI-\u10DD\u10DE\u10E2\u10D8\u10DB\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E4\u10D0\u10D6\u10D8\u10E0\u10D4\u10D1\u10D0 \u10E8\u10D4\u10EE\u10DD\u10E0\u10EA\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1, \u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10EC\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10D8\u10D7.",
        patientComm: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0",
        patientCommDetail: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10E1\u10D0\u10D2\u10D4\u10D1\u10D8 \u10D0\u10EE\u10E1\u10DC\u10D0-\u10D2\u10D0\u10DC\u10DB\u10D0\u10E0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D0\u10D3. \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10DF\u10D0\u10E0\u10D2\u10DD\u10DC\u10D8\u10E1 \u10D2\u10D0\u10E1\u10D0\u10D2\u10D4\u10D1 \u10D4\u10DC\u10D0\u10D6\u10D4 \u10D7\u10D0\u10E0\u10D2\u10DB\u10DC\u10D0.",
        // Integrations
        georgianEcosystem: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10D4\u10D9\u10DD\u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0 \u10DB\u10D6\u10D0\u10D3\u10D0\u10D0",
        integrationsSubtitle: "\u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0 \u10D0\u10D2\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8 \u10D0\u10D3\u10D2\u10D8\u10DA\u10DD\u10D1\u10E0\u10D8\u10D5 \u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0\u10E1\u10D7\u10D0\u10DC, \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D7\u10D0\u10DC \u10D3\u10D0 \u10DB\u10D4\u10E1\u10D8\u10EF\u10D8\u10DC\u10D2\u10D7\u10D0\u10DC",
        insurance: "\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0",
        payments: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8",
        messaging: "\u10DB\u10D4\u10E1\u10D8\u10EF\u10D8\u10DC\u10D2\u10D8",
        ehrLabs: "EHR \u10D3\u10D0 \u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8",
        // Stats
        clinicsInDb: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10D1\u10D0\u10D6\u10D0\u10E8\u10D8",
        platformModules: "\u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D8\u10E1 \u10DB\u10DD\u10D3\u10E3\u10DA\u10D8",
        aiTools: "AI \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 (Gemini)",
        integrations: "\u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D0",
        // Pricing
        pricingTitle: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8",
        pricingSubtitle: "\u10D3\u10D0\u10D8\u10EC\u10E7\u10D4\u10D7 \u10E3\u10E4\u10D0\u10E1\u10DD\u10D3, \u10D2\u10D0\u10D8\u10D6\u10D0\u10E0\u10D3\u10D4\u10D7 \u10D7\u10D0\u10DC\u10D3\u10D0\u10D7\u10D0\u10DC",
        // Testimonials
        trustedBy: "\u10EC\u10D0\u10DB\u10E7\u10D5\u10D0\u10DC\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8\u10E1 \u10DC\u10D3\u10DD\u10D1\u10D8\u10D7",
        // CTA
        readyModernize: "\u10DB\u10D6\u10D0\u10D3 \u10EE\u10D0\u10E0\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10DE\u10E0\u10D0\u10E5\u10E2\u10D8\u10D9\u10D8\u10E1 \u10DB\u10DD\u10D3\u10D4\u10E0\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1?",
        joinCount: "\u10E8\u10D4\u10E3\u10D4\u10E0\u10D7\u10D3\u10D8\u10D7 212+ \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0\u10E1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E8\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10E3\u10D9\u10D5\u10D4 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0\u10D6\u10D4\u10D0.",
        startTrial: "\u10E3\u10E4\u10D0\u10E1\u10DD \u10EA\u10D3\u10D8\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0",
        contactSales: "\u10D2\u10D0\u10E7\u10D8\u10D3\u10D5\u10D4\u10D1\u10D7\u10D0\u10DC \u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10D0",
        noCreditCard: "\u10E1\u10D0\u10D9\u10E0\u10D4\u10D3\u10D8\u10E2\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8 \u10D0\u10E0 \u10E1\u10ED\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0  \xb7  \u10E3\u10E4\u10D0\u10E1\u10DD \u10D2\u10D4\u10D2\u10DB\u10D0 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0  \xb7  \u10D3\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0 5 \u10EC\u10E3\u10D7\u10E8\u10D8",
        // Footer
        copyright: "\xa9 2026 MCAI \u2014 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8\u10E1 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8 \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8",
        navPatients: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        navChart: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E0\u10E3\u10D9\u10D0",
        navPerio: "\u10DE\u10D4\u10E0\u10D8\u10DD",
        navTreatmentPlans: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8",
        navNotes: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8",
        navScheduling: "\u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8",
        navBilling: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D0",
        navPrescriptions: "\u10E0\u10D4\u10EA\u10D4\u10DE\u10E2\u10D4\u10D1\u10D8",
        navLabCases: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10D8",
        navReferrals: "\u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10D4\u10D1\u10D8",
        navReports: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8",
        navMedHistory: "\u10E1\u10D0\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10DD \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        navFinances: "\u10E4\u10D8\u10DC\u10D0\u10DC\u10E1\u10D4\u10D1\u10D8",
        navCabinets: "\u10D9\u10D0\u10D1\u10D8\u10DC\u10D4\u10E2\u10D4\u10D1\u10D8",
        navRadiology: "\u10E0\u10D0\u10D3\u10D8\u10DD\u10DA\u10DD\u10D2\u10D8\u10D0",
        navDocuments: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        navConsent: "\u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0",
        navInventory: "\u10D8\u10DC\u10D5\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8",
        navChat: "\u10E9\u10D0\u10D7\u10D8",
        navIntegrations: "\u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        navEnterprise: "\u10D4\u10DC\u10E2\u10D4\u10E0\u10DE\u10E0\u10D0\u10D8\u10D6\u10D8",
        sectionClinical: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8",
        sectionOperations: "\u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
        sectionComm: "\u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0",
        sectionAnalytics: "\u10D0\u10DC\u10D0\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0",
        sectionAiTools: "AI \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        sectionAdmin: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10D0",
        // Booking Page
        chooseClinic: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0",
        selectAService: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8",
        pickADate: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        pickATime: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D3\u10E0\u10DD",
        confirmYourBooking: "\u10D3\u10D0\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D7 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        clinicLabel: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0:",
        serviceLabel: "\u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8:",
        dateLabel: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8:",
        timeLabel: "\u10D3\u10E0\u10DD:",
        // AI Page
        send: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        procedure: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D0",
        observations: "\u10D3\u10D0\u10D9\u10D5\u10D8\u10E0\u10D5\u10D4\u10D1\u10D4\u10D1\u10D8",
        aiThinking: "AI \u10E4\u10D8\u10E5\u10E0\u10DD\u10D1\u10E1...",
        summarizeHistory: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10E8\u10D4\u10EF\u10D0\u10DB\u10D4\u10D1\u10D0",
        generateTxPlan: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0",
        checkDrugInteractions: "\u10EC\u10D0\u10DB\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E3\u10E0\u10D7\u10D8\u10D4\u10E0\u10D7\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0",
        writeClinicalNote: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D3\u10D0\u10EC\u10D4\u10E0\u10D0",
        askAiAssistant: "\u10F0\u10D9\u10D8\u10D7\u10EE\u10D4\u10D7 AI \u10D0\u10E1\u10D8\u10E1\u10E2\u10D4\u10DC\u10E2\u10E1...",
        dropXray: "\u10E9\u10D0\u10D0\u10D2\u10D3\u10D4\u10D7 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8\u10E1 \u10E1\u10E3\u10E0\u10D0\u10D7\u10D8 \u10D0\u10DC \u10D3\u10D0\u10D0\u10EC\u10D9\u10D0\u10DE\u10E3\u10DC\u10D4\u10D7 \u10D0\u10E1\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D0\u10D3",
        supportsFormats: "\u10DB\u10EE\u10D0\u10E0\u10D3\u10D0\u10ED\u10D4\u10E0\u10D8\u10DA\u10D8\u10D0 DICOM, PNG, JPG",
        analysisResults: "\u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10D8 (\u10D3\u10D4\u10DB\u10DD)",
        aiRecommendation: "AI \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D0\u10EA\u10D8\u10D0",
        exportToTxPlan: "\u10D4\u10E5\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D0\u10E8\u10D8",
        generateClinicalNote: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0",
        generatedSoap: "\u10D2\u10D4\u10DC\u10D4\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 (SOAP)",
        subjective: "S \u2014 \u10E1\u10E3\u10D1\u10D8\u10D4\u10E5\u10E2\u10E3\u10E0\u10D8",
        objective: "O \u2014 \u10DD\u10D1\u10D8\u10D4\u10E5\u10E2\u10E3\u10E0\u10D8",
        assessment: "A \u2014 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        plan: "P \u2014 \u10D2\u10D4\u10D2\u10DB\u10D0",
        copyToRecord: "\u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10D0 \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10E8\u10D8",
        aiPerioAssessment: "AI \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        enterProbingData: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10D6\u10DD\u10DC\u10D3\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 AAP \u10E1\u10E2\u10D4\u10D8\u10EF\u10D8\u10DC\u10D2\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1.",
        analyzeWithGemini: "\u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8 Gemini-\u10D8\u10D7",
        aiRiskAssessment: "AI \u10E0\u10D8\u10E1\u10D9\u10D8\u10E1 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        enterConditions: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0, \u10DD\u10EF\u10D0\u10EE\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0 \u10D3\u10D0 \u10E1\u10D0\u10E1\u10D8\u10EA\u10DD\u10EA\u10EE\u10DA\u10DD \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8 \u10E0\u10D8\u10E1\u10D9\u10D8\u10E1 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10E5\u10DB\u10DC\u10D4\u10DA\u10D0\u10D3.",
        generateRiskProfile: "\u10E0\u10D8\u10E1\u10D9\u10D8\u10E1 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0",
        patientCommunication: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0",
        generateExplanations: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10E1\u10D0\u10D2\u10D4\u10D1\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D0\u10EE\u10E1\u10DC\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D0\u10D3 \u10D0\u10DC \u10D8\u10DC\u10D2\u10DA\u10D8\u10E1\u10E3\u10E0\u10D0\u10D3.",
        generateExplanation: "\u10D0\u10EE\u10E1\u10DC\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0",
        patientFriendly: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10E1\u10D0\u10D2\u10D4\u10D1\u10D8 \u10D0\u10EE\u10E1\u10DC\u10D0",
        // Billing Page
        claims: "\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D4\u10D1\u10D8",
        ledger: "\u10D1\u10D0\u10DA\u10D0\u10DC\u10E1\u10D8\u10E1 \u10EC\u10D8\u10D2\u10DC\u10D8",
        aging: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E1\u10D0\u10D9\u10D8",
        paymentPlans: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8",
        eligibility: "\u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D4\u10D1\u10D0",
        allFilter: "\u10E7\u10D5\u10D4\u10DA\u10D0",
        submitted: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8",
        paid: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        denied: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8",
        patientLedger: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D1\u10D0\u10DA\u10D0\u10DC\u10E1\u10D8",
        agedAccounts: "\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10D3\u10D0\u10EA\u10D8\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8",
        sendStatements: "\u10D0\u10DB\u10DD\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        activePaymentPlans: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8",
        insuranceEligibility: "\u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D4\u10D1\u10D0",
        // Clinical Charting
        odontogram: "\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10D2\u10E0\u10D0\u10DB\u10D0",
        perioTab: "\u10DE\u10D4\u10E0\u10D8\u10DD",
        treatmentPlanTab: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D0",
        notesTab: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8",
        progressNotes: "\u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8",
        openFullPerio: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E9\u10D0\u10E0\u10E2\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u2192",
        openFullTxPlanner: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D2\u10D4\u10D2\u10DB\u10D0\u10D5\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u2192",
        openClinicalNotes: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u2192",
        newExam: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0",
        voiceEntry: "\u10EE\u10DB\u10DD\u10D5\u10D0\u10DC\u10D8 \u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0",
        bleedingIndex: "\u10E1\u10D8\u10E1\u10EE\u10DA\u10D3\u10D4\u10DC\u10D8\u10E1 \u10D8\u10DC\u10D3\u10D4\u10E5\u10E1\u10D8",
        plaqueIndex: "\u10DC\u10D0\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D8\u10DC\u10D3\u10D4\u10E5\u10E1\u10D8",
        sitesAbove4: "\u10E3\u10D1\u10DC\u10D4\u10D1\u10D8 \u2265 4\u10DB\u10DB",
        sitesAbove6: "\u10E3\u10D1\u10DC\u10D4\u10D1\u10D8 \u2265 6\u10DB\u10DB",
        planA: "\u10D2\u10D4\u10D2\u10DB\u10D0 A: \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8",
        planB: "\u10D2\u10D4\u10D2\u10DB\u10D0 B: \u10D9\u10DD\u10DC\u10E1\u10D4\u10E0\u10D5\u10D0\u10E2\u10D8\u10E3\u10DA\u10D8",
        newPlan: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10D2\u10D4\u10D2\u10DB\u10D0",
        presentToPatient: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10EC\u10D0\u10E0\u10D3\u10D2\u10D4\u10DC\u10D0",
        sendToPortal: "\u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D6\u10D4 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0",
        totalFee: "\u10EF\u10D0\u10DB\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E4\u10D0\u10E1\u10E3\u10E0\u10D8",
        insuranceEst: "\u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        patientPortion: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10EC\u10D8\u10DA\u10D8",
        // Scheduling
        day: "\u10D3\u10E6\u10D4",
        week: "\u10D9\u10D5\u10D8\u10E0\u10D0",
        today: "\u10D3\u10E6\u10D4\u10E1",
        providerFilter: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10DE\u10E0\u10DD\u10D5\u10D0\u10D8\u10D3\u10D4\u10E0\u10D8",
        productionGoal: "\u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D0\u10DC\u10D8",
        waitlist: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10D8\u10E1 \u10E1\u10D8\u10D0",
        // Prescriptions
        activeRx: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8",
        pastRx: "\u10EC\u10D0\u10E0\u10E1\u10E3\u10DA\u10D8",
        templates: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D4\u10D1\u10D8",
        interactionCheck: "\u10E3\u10E0\u10D7\u10D8\u10D4\u10E0\u10D7\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0",
        // Lab Cases
        ordered: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10DA\u10D8",
        sentToLab: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D0\u10E8\u10D8 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8",
        inFabrication: "\u10E4\u10D0\u10D1\u10E0\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0\u10E8\u10D8",
        shipped: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8",
        received: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8",
        labVendors: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EC\u10DD\u10D3\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8",
        // Referrals
        allDirections: "\u10E7\u10D5\u10D4\u10DA\u10D0",
        inbound: "\u10E8\u10D4\u10DB\u10DD\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8",
        outbound: "\u10D2\u10D0\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8",
        generateLetter: "\u10EC\u10D4\u10E0\u10D8\u10DA\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0",
        // Reports
        production: "\u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D0",
        collections: "\u10E8\u10D4\u10D2\u10E0\u10DD\u10D5\u10D4\u10D1\u10D0",
        schedulingReport: "\u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8",
        treatmentAcceptance: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0",
        recall: "\u10D2\u10D0\u10DB\u10DD\u10EB\u10D0\u10EE\u10D4\u10D1\u10D0",
        grossProduction: "\u10DB\u10D7\u10DA\u10D8\u10D0\u10DC\u10D8 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D0",
        netProduction: "\u10EC\u10DB\u10D8\u10DC\u10D3\u10D0 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D0",
        collectionRate: "\u10E8\u10D4\u10D2\u10E0\u10DD\u10D5\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D4\u10DA\u10D8",
        plansPresented: "\u10EC\u10D0\u10E0\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8",
        accepted: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8",
        acceptanceRate: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D4\u10DA\u10D8",
        dueThisMonth: "\u10D0\u10DB \u10D7\u10D5\u10D4\u10E8\u10D8 \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8",
        scheduled: "\u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8",
        completed: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8",
        overdue: "\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10D3\u10D0\u10EA\u10D8\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8",
        reactivationRate: "\u10E0\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D4\u10DA\u10D8",
        // Medical History
        timeline: "\u10E5\u10E0\u10DD\u10DC\u10DD\u10DA\u10DD\u10D2\u10D8\u10D0",
        conditions: "\u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D4\u10D1\u10D8",
        medications: "\u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        allergies: "\u10D0\u10DA\u10D4\u10E0\u10D2\u10D8\u10D4\u10D1\u10D8",
        labResults: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10D8",
        vitals: "\u10E1\u10D0\u10E1\u10D8\u10EA\u10DD\u10EA\u10EE\u10DA\u10DD \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8",
        immunizations: "\u10D8\u10DB\u10E3\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        familyHistory: "\u10DD\u10EF\u10D0\u10EE\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        imaging: "\u10D2\u10D0\u10DB\u10DD\u10E1\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8",
        documents: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u10D0\u10E3\u10D3\u10D8\u10E2\u10D8\u10E1 \u10DF\u10E3\u10E0\u10DC\u10D0\u10DA\u10D8",
        compliance: "\u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10DD\u10D1\u10D0",
        multiTenancy: "\u10DB\u10E3\u10DA\u10E2\u10D8-\u10E2\u10D4\u10DC\u10D0\u10DC\u10E2\u10DD\u10D1\u10D0",
        sso: "SSO \u10D3\u10D0 \u10E3\u10E1\u10D0\u10E4\u10E0\u10D7\u10EE\u10DD\u10D4\u10D1\u10D0",
        featureFlags: "\u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E4\u10DA\u10D0\u10D2\u10D4\u10D1\u10D8",
        apiManagement: "API \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        dataManagement: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        // Integrations
        ehr: 'EHR',
        labs: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8",
        telehealth: "\u10E2\u10D4\u10DA\u10D4\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10D0",
        aiMl: 'AI/ML',
        wearables: "\u10E2\u10D0\u10E0\u10D4\u10D1\u10D0\u10D3\u10D8 \u10DB\u10DD\u10EC\u10E7\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D4\u10D1\u10D8",
        connected: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8",
        disconnected: "\u10D2\u10D0\u10D7\u10D8\u10E8\u10E3\u10DA\u10D8",
        available: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8",
        // Components
        status: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8",
        healthy: "\u10EF\u10D0\u10DC\u10DB\u10E0\u10D7\u10D4\u10DA\u10D8",
        caries: "\u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8",
        restored: "\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8",
        missing: "\u10D0\u10E0\u10DB\u10E5\u10DD\u10DC\u10D4",
        implant: "\u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8",
        crownStatus: "\u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8",
        bridge: "\u10EE\u10D8\u10D3\u10D8",
        veneer: "\u10D5\u10D8\u10DC\u10D8\u10E0\u10D8",
        surfaces: "\u10D6\u10D4\u10D3\u10D0\u10DE\u10D8\u10E0\u10D4\u10D1\u10D8",
        procedureHistory: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        addProcedure: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0",
        totalCharged: "\u10EF\u10D0\u10DB\u10E3\u10E0\u10D8 \u10D7\u10D0\u10DC\u10EE\u10D0",
        insurancePayment: "\u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0",
        patientResponsibility: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0",
        expand: "\u10D2\u10D0\u10E8\u10DA\u10D0",
        policyNumber: "\u10DE\u10DD\u10DA\u10D8\u10E1\u10D8\u10E1 #",
        planType: "\u10D2\u10D4\u10D2\u10DB\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8",
        annualMax: "\u10EC\u10DA\u10D8\u10E3\u10E0\u10D8 \u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10E3\u10DB\u10D8",
        used: "\u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8",
        remaining: "\u10D3\u10D0\u10E0\u10E9\u10D4\u10DC\u10D8\u10DA\u10D8",
        coverageByCategory: "\u10D3\u10D0\u10E4\u10D0\u10E0\u10D5\u10D0 \u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7",
        preventive: "\u10DE\u10E0\u10D4\u10D5\u10D4\u10DC\u10EA\u10D8\u10E3\u10DA\u10D8",
        basic: "\u10D1\u10D0\u10D6\u10D8\u10E1\u10E3\u10E0\u10D8",
        major: "\u10EB\u10D8\u10E0\u10D8\u10D7\u10D0\u10D3\u10D8",
        ortho: "\u10DD\u10E0\u10D7\u10DD",
        current: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4",
        thirtyDay: "30 \u10D3\u10E6\u10D4",
        sixtyDay: "60 \u10D3\u10E6\u10D4",
        ninetyPlus: "90+ \u10D3\u10E6\u10D4",
        totalBalance: "\u10EF\u10D0\u10DB\u10E3\u10E0\u10D8 \u10D1\u10D0\u10DA\u10D0\u10DC\u10E1\u10D8",
        monthlyPayment: "\u10E7\u10DD\u10D5\u10D4\u10DA\u10D7\u10D5\u10D8\u10E3\u10E0\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0",
        paymentsRemaining: "\u10D3\u10D0\u10E0\u10E9\u10D4\u10DC\u10D8\u10DA\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8",
        nextPayment: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0",
        paymentProgress: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 \u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8",
        choosePlan: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D2\u10D4\u10D2\u10DB\u10D0",
        aiInsight: "AI \u10D8\u10DC\u10E1\u10D0\u10D8\u10E2\u10D8",
        confidence: "\u10E1\u10D0\u10DC\u10D3\u10DD\u10DD\u10D1\u10D0",
        revoke: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0",
        exams: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D4\u10D1\u10D8",
        phaseTotal: "\u10E4\u10D0\u10D6\u10D8\u10E1 \u10EF\u10D0\u10DB\u10D8",
        mon: "\u10DD\u10E0\u10E8",
        tue: "\u10E1\u10D0\u10DB",
        wed: "\u10DD\u10D7\u10EE",
        thu: "\u10EE\u10E3\u10D7",
        fri: "\u10DE\u10D0\u10E0",
        sat: "\u10E8\u10D0\u10D1",
        sun: "\u10D9\u10D5\u10D8",
        thinking: "\u10E4\u10D8\u10E5\u10E0\u10DD\u10D1\u10E1...",
        followUpPlaceholder: "\u10D3\u10D0\u10E1\u10D5\u10D8\u10D7 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0...",
        priorityCompleteRctOn: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8: \u10D3\u10D0\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D7 \u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0 #14-\u10D6\u10D4, \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D0\u10E6\u10D0\u10D3\u10D2\u10D8\u10DC\u10D4\u10D7 #36. \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D4\u10D7 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0 \u10EB\u10D5\u10DA\u10D8\u10E1 \u10D3\u10D0\u10D9\u10D0\u10E0\u10D2\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10E4\u10D0\u10E1\u10D4\u10D1\u10DA\u10D0\u10D3. \u10D2\u10D0\u10DC\u10D8\u10EE\u10D8\u10DA\u10D4\u10D7 CBCT #14-\u10D8\u10E1 \u10D3\u10D0\u10D6\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10E3\u10E0\u10D8 3D \u10EE\u10D4\u10D3\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1.",
        patientReportsPersistentDull: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8 \u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10D0\u10D5\u10E1 \u10DB\u10E3\u10D3\u10DB\u10D8\u10D5 \u10E2\u10D9\u10D8\u10D5\u10D8\u10DA\u10E1 \u10D6\u10D4\u10D3\u10D0 \u10DB\u10D0\u10E0\u10EA\u10EE\u10D4\u10DC\u10D0 \u10D9\u10D5\u10D0\u10D3\u10E0\u10D0\u10DC\u10E2\u10E8\u10D8 2 \u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10D2\u10D0\u10DC\u10DB\u10D0\u10D5\u10DA\u10DD\u10D1\u10D0\u10E8\u10D8. \u10E2\u10D9\u10D8\u10D5\u10D8\u10DA\u10D8 \u10D8\u10D6\u10E0\u10D3\u10D4\u10D1\u10D0 \u10EA\u10EE\u10D4\u10DA\u10D8 \u10E1\u10D0\u10E1\u10DB\u10D4\u10DA\u10D4\u10D1\u10D8\u10D7. \u10E1\u10DE\u10DD\u10DC\u10E2\u10D0\u10DC\u10E3\u10E0\u10D8 \u10E1\u10D8\u10E1\u10EE\u10DA\u10D3\u10D4\u10DC\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1. \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8 \u10D0\u10E4\u10D0\u10E1\u10D4\u10D1\u10E1 \u10E2\u10D9\u10D8\u10D5\u10D8\u10DA\u10E1 5/10.",
        tooth14PositivePercussion: "\u10D9\u10D1\u10D8\u10DA\u10D8 #14: \u10D3\u10D0\u10D3\u10D4\u10D1\u10D8\u10D7\u10D8 \u10DE\u10D4\u10E0\u10D9\u10E3\u10E1\u10D8\u10D8\u10E1 \u10E2\u10D4\u10E1\u10E2\u10D8. \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7\u10D8 \u10E1\u10D8\u10EA\u10DD\u10EA\u10EE\u10DA\u10D8\u10E1\u10E3\u10DC\u10D0\u10E0\u10D8\u10D0\u10DC\u10DD\u10D1\u10D0 (\u10EA\u10D8\u10D5\u10D8 \u10E2\u10D4\u10E1\u10E2\u10D8). \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D6\u10D4 3\u10DB\u10DB \u10E0\u10D0\u10D3\u10D8\u10DD\u10DA\u10E3\u10EA\u10D4\u10DC\u10E2\u10DD\u10D1\u10D0 \u10D0\u10DE\u10D4\u10E5\u10E1\u10D6\u10D4. \u10D6\u10DD\u10DC\u10D3\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D8\u10E6\u10E0\u10DB\u10D4\u10D4\u10D1\u10D8 \u10DC\u10DD\u10E0\u10DB\u10D8\u10E1 \u10E4\u10D0\u10E0\u10D2\u10DA\u10D4\u10D1\u10E8\u10D8 (2-3\u10DB\u10DB). \u10DB\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1. \u10DB\u10D4\u10D6\u10DD\u10D1\u10D4\u10DA\u10D8 \u10D9\u10D1\u10D8\u10DA\u10D4\u10D1\u10D8 \u10E1\u10D8\u10EA\u10DD\u10EA\u10EE\u10DA\u10D8\u10E1\u10E3\u10DC\u10D0\u10E0\u10D8\u10D0\u10DC\u10D8\u10D0.",
        chronicPeriapicalAbscess14: "\u10E5\u10E0\u10DD\u10DC\u10D8\u10D9\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D0\u10D1\u10E1\u10EA\u10D4\u10E1\u10D8 #14. \u10DE\u10E3\u10DA\u10DE\u10D8\u10E1 \u10DC\u10D4\u10D9\u10E0\u10DD\u10D6\u10D8 \u10E6\u10E0\u10DB\u10D0 \u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D0\u10D3. \u10DB\u10EC\u10D5\u10D0\u10D5\u10D4 \u10D8\u10DC\u10E4\u10D4\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DC\u10D8\u10E8\u10DC\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1.",
        english: "\u10D8\u10DC\u10D2\u10DA\u10D8\u10E1\u10E3\u10E0\u10D8",
        patientLedgerU2014Giorgi: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D1\u10D0\u10DA\u10D0\u10DC\u10E1\u10D8 \u2014 \u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10D1\u10D4\u10E0\u10D8\u10EB\u10D4",
        xrayAnalysis2: "\u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8",
        uploadDentalRadiographsFor: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D7 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10DD\u10D2\u10E0\u10D0\u10DB\u10D4\u10D1\u10D8 AI-\u10D8\u10D7 \u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8\u10E1 \u10D0\u10E6\u10DB\u10DD\u10E9\u10D4\u10DC\u10D8\u10E1, \u10EB\u10D5\u10DA\u10D8\u10E1 \u10D3\u10DD\u10DC\u10D8\u10E1 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DE\u10D0\u10D7\u10DD\u10DA\u10DD\u10D2\u10D8\u10D8\u10E1 \u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1.",
        perioAssessment2: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        automaticAapStaginggradingFrom: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 AAP \u10E1\u10E2\u10D4\u10D8\u10EF\u10D8\u10DC\u10D2\u10D8/\u10D2\u10E0\u10D4\u10D8\u10D3\u10D8\u10DC\u10D2\u10D8 \u10D6\u10DD\u10DC\u10D3\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC. \u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8\u10D8\u10E1 \u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0, SRP \u10D0\u10DC \u10E5\u10D8\u10E0\u10E3\u10E0\u10D2\u10D8\u10E3\u10DA\u10D8 \u10E9\u10D0\u10E0\u10D4\u10D5\u10D8\u10E1 \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D0\u10EA\u10D8\u10D0.",
        clinicalScribe2: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E1\u10D9\u10E0\u10D8\u10D1\u10D8",
        generatesSoapNotesFrom: "SOAP \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0 \u10EE\u10DB\u10DD\u10D5\u10D0\u10DC\u10D8 \u10E9\u10D0\u10EC\u10D4\u10E0\u10D8\u10D3\u10D0\u10DC \u10D0\u10DC \u10E9\u10D0\u10E0\u10E2\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC. CDT \u10D9\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 ICD-10-\u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0.",
        riskProfiling2: "\u10E0\u10D8\u10E1\u10D9\u10D8\u10E1 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8\u10E0\u10D4\u10D1\u10D0",
        analyzesConditionsFamilyHistor: "\u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D4\u10D1\u10E1 \u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0\u10E1, \u10DD\u10EF\u10D0\u10EE\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0\u10E1 \u10D3\u10D0 \u10E1\u10D0\u10E1\u10D8\u10EA\u10DD\u10EA\u10EE\u10DA\u10DD \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10DA\u10D4\u10D1\u10E1 \u10E7\u10DD\u10D5\u10DA\u10D8\u10E1\u10DB\u10DD\u10DB\u10EA\u10D5\u10D4\u10DA\u10D8 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E0\u10D8\u10E1\u10D9\u10D8\u10E1 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10E5\u10DB\u10DC\u10D4\u10DA\u10D0\u10D3.",
        treatmentSequencing2: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E1\u10D4\u10D9\u10D5\u10D4\u10DC\u10EA\u10D8\u10E0\u10D4\u10D1\u10D0",
        aioptimizedTreatmentPhasingCon: "AI-\u10DD\u10DE\u10E2\u10D8\u10DB\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E4\u10D0\u10D6\u10D8\u10E0\u10D4\u10D1\u10D0 \u10E8\u10D4\u10EE\u10DD\u10E0\u10EA\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1, \u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10EC\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10D8\u10D7.",
        patientCommunication2: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0",
        generatesPatientfriendlyExplan: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10E1\u10D0\u10D2\u10D4\u10D1\u10D8 \u10D0\u10EE\u10E1\u10DC\u10D0-\u10D2\u10D0\u10DC\u10DB\u10D0\u10E0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D0\u10D3. \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10DF\u10D0\u10E0\u10D2\u10DD\u10DC\u10D8\u10E1 \u10D2\u10D0\u10E1\u10D0\u10D2\u10D4\u10D1 \u10D4\u10DC\u10D0\u10D6\u10D4 \u10D7\u10D0\u10E0\u10D2\u10DB\u10DC\u10D0.",
        insurance2: "\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0",
        automatedClaimsEligibilityVeri: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D4\u10D1\u10D8, \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D5\u10D4\u10E0\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0, ERA-\u10E1 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10D0",
        payments2: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8",
        onlinePaymentsPaymentPlans: "\u10DD\u10DC\u10DA\u10D0\u10D8\u10DC \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8, \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8, \u10D0\u10D5\u10E2\u10DD-\u10D1\u10D8\u10DA\u10D8\u10DC\u10D2\u10D8",
        messaging2: "\u10DB\u10D4\u10E1\u10D8\u10EF\u10D8\u10DC\u10D2\u10D8",
        appointmentRemindersRecallCamp: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8, \u10D2\u10D0\u10DB\u10DD\u10EB\u10D0\u10EE\u10D4\u10D1\u10D8\u10E1 \u10D9\u10D0\u10DB\u10DE\u10D0\u10DC\u10D8\u10D4\u10D1\u10D8, \u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D8\u10E1 \u10DB\u10D4\u10E1\u10D8\u10EF\u10D8\u10DC\u10D2\u10D8",
        ehrLabs2: "EHR \u10D3\u10D0 \u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8",
        interoperableHealthRecordsLab: "\u10D8\u10DC\u10E2\u10D4\u10E0\u10DD\u10DE\u10D4\u10E0\u10D0\u10D1\u10D4\u10DA\u10E3\u10E0\u10D8 \u10EF\u10D0\u10DC\u10DB\u10E0\u10D7\u10D4\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8, \u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D4\u10D1\u10D8, \u10D2\u10D0\u10DB\u10DD\u10E1\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0",
        clinicsInDatabase: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10D1\u10D0\u10D6\u10D0\u10E8\u10D8",
        platformModules2: "\u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D8\u10E1 \u10DB\u10DD\u10D3\u10E3\u10DA\u10D4\u10D1\u10D8",
        integrations2: "\u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        home2: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8",
        features2: "\u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D4\u10D1\u10D8",
        pricing2: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8",
        dashboard2: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8 \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8",
        u00a92026McaiU2014: "\xa9 2026 MCAI \u2014 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8\u10E1 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0",
        openFullPeriodontalChart: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E9\u10D0\u10E0\u10E2\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u2192",
        openFullTreatmentPlanner: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D2\u10D4\u10D2\u10DB\u10D0\u10D5\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u2192",
        openClinicalNotes2: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u2192",
        backToAllClinics: "\u2190 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0\u10D6\u10D4 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0",
        priceRange2: "\u10E4\u10D0\u10E1\u10D8\u10E1 \u10D3\u10D8\u10D0\u10DE\u10D0\u10D6\u10DD\u10DC\u10D8:",
        bookAnAppointment: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10EF\u10D0\u10D5\u10E8\u10DC\u10D0",
        selectDate2: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        selectTime2: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D3\u10E0\u10DD",
        confirmBooking2: "\u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0 \u2192",
        clinics: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8",
        forBusiness2: "\u10D1\u10D8\u10D6\u10DC\u10D4\u10E1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        u00a92026Mcai: '\u00A9 2026 MCAI',
        clinicalNotes: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8",
        newNote: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8",
        template: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8:",
        crownPrep: "\u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE\u10D0\u10E0\u10D0\u10EA\u10D8\u10D0",
        aiScribe: "AI \u10E1\u10D9\u10E0\u10D8\u10D1\u10D8",
        recordYourClinicalEncounter: "\u10E9\u10D0\u10EC\u10D4\u10E0\u10D4\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10E8\u10D4\u10EE\u10D5\u10D4\u10D3\u10E0\u10D0 \u10D3\u10D0 \u10DB\u10D8\u10D4\u10EA\u10D8\u10D7 AI-\u10E1 \u10E1\u10E2\u10E0\u10E3\u10E5\u10E2\u10E3\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 SOAP \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D0\u10D3 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D0.",
        startRecording: "\u10E9\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0",
        generateNote: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10EA\u10D8\u10D0",
        general: "\u10D6\u10DD\u10D2\u10D0\u10D3\u10D8",
        prosthetics: "\u10DE\u10E0\u10DD\u10D7\u10D4\u10D6\u10D8\u10E0\u10D4\u10D1\u10D0",
        typeToSearch: "\u10D0\u10D9\u10E0\u10D8\u10E4\u10D4\u10D7 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E2\u10D4\u10E0\u10DB\u10D8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10EB\u10D8\u10D4\u10D1\u10DA\u10D0\u10D3...",
        revenueToday: "\u10D3\u10E6\u10D4\u10D5\u10D0\u10DC\u10D3\u10D4\u10DA\u10D8 \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10D8",
        noshows: "\u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D4\u10D1\u10D8",
        confirmed: "\u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8",
        time: "\u10D3\u10E0\u10DD",
        patient: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8",
        service: "\u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8",
        doctor: "\u10D4\u10E5\u10D8\u10DB\u10D8",
        status2: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8",
        addPatient: "+ \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0",
        mondayMarch19: "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8, 19 \u10DB\u10D0\u10E0\u10E2\u10D8",
        gBeridzeCheckup: "\u10D2. \u10D1\u10D4\u10E0\u10D8\u10EB\u10D4 \u2014 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0",
        nKapanadzeWhitening: "\u10DC. \u10D9\u10D0\u10DE\u10D0\u10DC\u10D0\u10EB\u10D4 \u2014 \u10D2\u10D0\u10D7\u10D4\u10D7\u10E0\u10D4\u10D1\u10D0",
        dGelashviliImplantPhase: "\u10D3. \u10D2\u10D4\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8 \u2014 \u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8\u10E1 \u10E4\u10D0\u10D6\u10D0 2",
        lunchBreak: "\u2014 \u10E8\u10D4\u10E1\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0 \u2014",
        mTsiklauriOrthodontics: "\u10DB. \u10EA\u10D8\u10D9\u10DA\u10D0\u10E3\u10E0\u10D8 \u2014 \u10DD\u10E0\u10D7\u10DD\u10D3\u10DD\u10DC\u10E2\u10D8\u10D0",
        aJavakhishviliRootCanal: "\u10D0. \u10EF\u10D0\u10D5\u10D0\u10EE\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8 \u2014 \u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0",
        lMchedlishviliExtraction: "\u10DA. \u10DB\u10ED\u10D4\u10D3\u10DA\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8 \u2014 \u10D9\u10D1\u10D8\u10DA\u10D8\u10E1 \u10D0\u10DB\u10DD\u10E6\u10D4\u10D1\u10D0",
        tLomidzeCheckup: "\u10D7. \u10DA\u10DD\u10DB\u10D8\u10EB\u10D4 \u2014 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0",
        clinicName: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8",
        phone: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8",
        address: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        acceptedInsurance: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0",
        unison: 'Unison',
        saveSettings: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0",
        aiToolsAreAvailable: "AI \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10E1\u10E0\u10E3\u10DA\u10D8 \u10D0\u10E1\u10D8\u10E1\u10E2\u10D4\u10DC\u10E2\u10D8\u10E1 \u10EE\u10D4\u10D3\u10E8\u10D8.",
        openTheFullAi: "\u10E1\u10E0\u10E3\u10DA\u10D8 AI \u10D0\u10E1\u10D8\u10E1\u10E2\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u2192",
        enterprise: "\u10D4\u10DC\u10E2\u10D4\u10E0\u10DE\u10E0\u10D0\u10D8\u10D6\u10D8",
        rolebasedAccessControl: "\u10E0\u10DD\u10DA\u10D4\u10D1\u10D6\u10D4 \u10D3\u10D0\u10E4\u10E3\u10EB\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10E1 \u10D9\u10DD\u10DC\u10E2\u10E0\u10DD\u10DA\u10D8",
        permissionMatrix: "\u10DC\u10D4\u10D1\u10D0\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0",
        module: "\u10DB\u10DD\u10D3\u10E3\u10DA\u10D8",
        admin: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8",
        doctor2: "\u10D4\u10E5\u10D8\u10DB\u10D8",
        hygienist: "\u10F0\u10D8\u10D2\u10D8\u10D4\u10DC\u10D8\u10E1\u10E2\u10D8",
        reception: "\u10E0\u10D4\u10EA\u10D4\u10E4\u10EA\u10D8\u10D0",
        lab: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D0",
        patient2: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8",
        patients: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        full: "\u10E1\u10E0\u10E3\u10DA\u10D8",
        read: "\u10EC\u10D0\u10D9\u10D8\u10D7\u10EE\u10D5\u10D0",
        none: "\u10D0\u10E0\u10EA\u10D4\u10E0\u10D7\u10D8",
        own: "\u10E1\u10D0\u10D9\u10E3\u10D7\u10D0\u10E0\u10D8",
        billing: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D0",
        scheduling: "\u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8",
        reports: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8",
        settings: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8",
        labOrders: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D4\u10D1\u10D8",
        auditLog2: "\u10D0\u10E3\u10D3\u10D8\u10E2\u10D8\u10E1 \u10DF\u10E3\u10E0\u10DC\u10D0\u10DA\u10D8",
        allTypes: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10E2\u10D8\u10DE\u10D8",
        last7Days: "\u10D1\u10DD\u10DA\u10DD 7 \u10D3\u10E6\u10D4",
        complianceDashboard: "\u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10DD\u10D1\u10D8\u10E1 \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8",
        complianceChecklist: "\u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10DD\u10D1\u10D8\u10E1 \u10E9\u10D4\u10D9\u10DA\u10D8\u10E1\u10E2\u10D8",
        pass: "\u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10E3\u10DA\u10D8",
        dataEncryptedAtRest: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D3\u10D0\u10E8\u10D8\u10E4\u10E0\u10E3\u10DA\u10D8\u10D0 \u10DB\u10DD\u10E1\u10D5\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D4\u10DF\u10D8\u10DB\u10E8\u10D8 (AES-256)",
        dataEncryptedInTransit: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D3\u10D0\u10E8\u10D8\u10E4\u10E0\u10E3\u10DA\u10D8\u10D0 \u10E2\u10E0\u10D0\u10DC\u10D6\u10D8\u10E2\u10E8\u10D8 (TLS 1.3)",
        mfaEnabledForAll: "MFA \u10E9\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8\u10D0 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        warn: "\u10D2\u10D0\u10E4\u10E0\u10D7\u10EE\u10D8\u10DA\u10D4\u10D1\u10D0",
        dataRetentionPolicyReview: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D8\u10E1 \u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0 14 \u10D3\u10E6\u10D8\u10D7 \u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10D3\u10D0\u10EA\u10D8\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0",
        auditLoggingActiveOn: "\u10D0\u10E3\u10D3\u10D8\u10E2\u10D8\u10E1 \u10DA\u10DD\u10D2\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8\u10D0 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10DB\u10DD\u10D3\u10E3\u10DA\u10D6\u10D4",
        multitenancyManagement: "\u10DB\u10E3\u10DA\u10E2\u10D8-\u10E2\u10D4\u10DC\u10D0\u10DC\u10E2\u10DD\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        singleSignonSso: "\u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8 \u10E8\u10D4\u10E1\u10D5\u10DA\u10D0 (SSO)",
        saml20: 'SAML 2.0',
        enterpriseIdentityProviderInte: "\u10D4\u10DC\u10E2\u10D4\u10E0\u10DE\u10E0\u10D0\u10D8\u10D6 \u10D8\u10D3\u10D4\u10DC\u10E2\u10DD\u10D1\u10D8\u10E1 \u10DE\u10E0\u10DD\u10D5\u10D0\u10D8\u10D3\u10D4\u10E0\u10D8\u10E1 \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D0",
        configured: "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D2\u10E3\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8",
        openidConnect: 'OpenID Connect',
        oauth20BasedAuthentication: "OAuth 2.0 \u10D3\u10D0\u10E4\u10E3\u10EB\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D0\u10D5\u10D7\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0",
        available2: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8",
        signInWithGoogle: "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0 Google \u10DD\u10E0\u10D2\u10D0\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8\u10D7",
        connected2: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8",
        azureAd: 'Azure AD',
        microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
        featureFlags2: "\u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E4\u10DA\u10D0\u10D2\u10D4\u10D1\u10D8",
        aixrayanalysis: 'ai_xray_analysis',
        aipoweredXrayAnalysisAnd: "AI-\u10D8\u10D7 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8 \u10D3\u10D0 \u10D0\u10DC\u10DD\u10DB\u10D0\u10DA\u10D8\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E6\u10DB\u10DD\u10E9\u10D4\u10DC\u10D0",
        voiceperio: 'voice_perio',
        voiceactivatedPeriodontalChart: "\u10EE\u10DB\u10D8\u10D7 \u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E9\u10D0\u10E0\u10E2\u10D8\u10DC\u10D2\u10D8",
        patientportalv2: 'patient_portal_v2',
        nextgenerationPatientSelfservi: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D7\u10D0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D7\u10D5\u10D8\u10D7\u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DE\u10DD\u10E0\u10E2\u10D0\u10DA\u10D8",
        whatsappreminders: 'whatsapp_reminders',
        multilanguage: 'multi_language',
        multilanguageSupportGeorgianEn: "\u10DB\u10E0\u10D0\u10D5\u10D0\u10DA\u10D4\u10DC\u10DD\u10D5\u10D0\u10DC\u10D8 \u10DB\u10EE\u10D0\u10E0\u10D3\u10D0\u10ED\u10D4\u10E0\u10D0 (\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8, \u10D8\u10DC\u10D2\u10DA\u10D8\u10E1\u10E3\u10E0\u10D8, \u10E0\u10E3\u10E1\u10E3\u10DA\u10D8)",
        apiManagement2: "API \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        requests24h: "\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D4\u10D1\u10D8 (24\u10E1\u10D7)",
        avgLatency: "\u10E1\u10D0\u10E8. \u10E8\u10D4\u10E7\u10DD\u10D5\u10DC\u10D4\u10D1\u10D0",
        uptime: "\u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10D8\u10E1 \u10D3\u10E0\u10DD",
        apiKeys: "API \u10D2\u10D0\u10E1\u10D0\u10E6\u10D4\u10D1\u10D4\u10D1\u10D8",
        dataManagement2: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        storageUsed: "\u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10D0\u10EA\u10D0\u10D5\u10D8",
        of100Gb: "100 GB-\u10D3\u10D0\u10DC",
        totalRecords: "\u10EF\u10D0\u10DB\u10E3\u10E0\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8",
        lastBackup: "\u10D1\u10DD\u10DA\u10DD \u10E1\u10D0\u10E0\u10D4\u10D6\u10D4\u10E0\u10D5\u10DD \u10D0\u10E1\u10DA\u10D8",
        nextIn4h: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8: 4\u10E1\u10D7-\u10E8\u10D8",
        dataOperations: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        exportAllData: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D8\u10E1 \u10D4\u10E5\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8",
        downloadCompleteDatabaseExport: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D1\u10D0\u10D6\u10D8\u10E1 \u10D4\u10E5\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8\u10E1 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 FHIR R4 \u10E4\u10DD\u10E0\u10DB\u10D0\u10E2\u10E8\u10D8",
        export: "\u10D4\u10E5\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8",
        purgeOldRecords: "\u10EB\u10D5\u10D4\u10DA\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0",
        removeRecordsPastRetention: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0 (7+ \u10EC\u10D4\u10DA\u10D8)",
        purge: "\u10EC\u10D0\u10E8\u10DA\u10D0",
        dataMigration: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10DB\u10D8\u10D2\u10E0\u10D0\u10EA\u10D8\u10D0",
        importDataFromExternal: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8 \u10D2\u10D0\u10E0\u10D4 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC (CSV, HL7, FHIR)",
        import: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8",
        finance: "\u10E4\u10D8\u10DC\u10D0\u10DC\u10E1\u10D4\u10D1\u10D8",
        revenueInvoicesPayments: "\u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10D8, \u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8",
        exportReport: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8\u10E1 \u10D4\u10E5\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8",
        monthlyRevenue: "\u10E7\u10DD\u10D5\u10D4\u10DA\u10D7\u10D5\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10D8",
        u20be12400: '\u20BE12,400',
        pending: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8",
        u20be2100: '\u20BE2,100',
        str208: '-5%',
        thisWeek: "\u10D0\u10DB \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8",
        u20be3800: '\u20BE3,800',
        weeklyRevenue: "\u10E7\u10DD\u10D5\u10D4\u10DA\u10D9\u10D5\u10D8\u10E0\u10D4\u10E3\u10DA\u10D8 \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10D8",
        mon2: "\u10DD\u10E0\u10E8",
        tue2: "\u10E1\u10D0\u10DB",
        wed2: "\u10DD\u10D7\u10EE",
        thu2: "\u10EE\u10E3\u10D7",
        fri2: "\u10DE\u10D0\u10E0",
        sat2: "\u10E8\u10D0\u10D1",
        invoice: "\u10D8\u10DC\u10D5\u10DD\u10D8\u10E1\u10D8",
        amount: "\u10D7\u10D0\u10DC\u10EE\u10D0",
        inv001: 'INV-001',
        giorgiBeridze: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10D8 \u10D1\u10D4\u10E0\u10D8\u10EB\u10D4",
        checkupXray: "\u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0 + \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8",
        u20be80: '\u20BE80',
        inv002: 'INV-002',
        ninoKapanadze: "\u10DC\u10D8\u10DC\u10DD \u10D9\u10D0\u10DE\u10D0\u10DC\u10D0\u10EB\u10D4",
        whitening: "\u10D2\u10D0\u10D7\u10D4\u10D7\u10E0\u10D4\u10D1\u10D0",
        u20be120: '\u20BE120',
        inv003: 'INV-003',
        davitGelashvili: "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10D2\u10D4\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        implantPhase1: "\u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8\u10E1 \u10E4\u10D0\u10D6\u10D0 1",
        u20be300: '\u20BE300+',
        inv004: 'INV-004',
        anaJavakhishvili: "\u10D0\u10DC\u10D0 \u10EF\u10D0\u10D5\u10D0\u10EE\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8",
        rootCanal: "\u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0",
        u20be149: '\u20BE149',
        u2715: '\u2715',
        configuration: "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D2\u10E3\u10E0\u10D0\u10EA\u10D8\u10D0",
        apiKey: "API \u10D2\u10D0\u10E1\u10D0\u10E6\u10D4\u10D1\u10D8",
        endpointUrl: "\u10D1\u10DD\u10DA\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 URL",
        protocol: "\u10DE\u10E0\u10DD\u10E2\u10DD\u10D9\u10DD\u10DA\u10D8",
        syncSettings: "\u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8",
        syncFrequency: "\u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D8\u10E1 \u10E1\u10D8\u10EE\u10E8\u10D8\u10E0\u10D4",
        every5Minutes: "\u10E7\u10DD\u10D5\u10D4\u10DA 5 \u10EC\u10E3\u10D7\u10E8\u10D8",
        every15Minutes: "\u10E7\u10DD\u10D5\u10D4\u10DA 15 \u10EC\u10E3\u10D7\u10E8\u10D8",
        everyHour: "\u10E7\u10DD\u10D5\u10D4\u10DA \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8",
        manualOnly: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10EE\u10D4\u10DA\u10D8\u10D7",
        autosyncOnChanges: "\u10D0\u10D5\u10E2\u10DD-\u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D6\u10D4",
        lastSynced: "\u10D1\u10DD\u10DA\u10DD \u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0",
        disconnect: "\u10D2\u10D0\u10D7\u10D8\u10E8\u10D5\u10D0",
        testConnection: "\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D8\u10E1 \u10E2\u10D4\u10E1\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0",
        labCasePipeline: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D0\u10D8\u10DE\u10DA\u10D0\u10D8\u10DC\u10D8",
        labVendors2: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EC\u10DD\u10D3\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8",
        tbilisidentLab: "TbilisiDent \u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D0",
        turnaround710Days: "\u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0: 7-10 \u10D3\u10E6\u10D4",
        rating485: "\u10E0\u10D4\u10D8\u10E2\u10D8\u10DC\u10D2\u10D8: 4.8/5",
        activeCases4: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10D8: 4",
        caucasusDentalLab: "\u10D9\u10D0\u10D5\u10D9\u10D0\u10E1\u10D8\u10D8\u10E1 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10D0",
        turnaround57Days: "\u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0: 5-7 \u10D3\u10E6\u10D4",
        rating465: "\u10E0\u10D4\u10D8\u10E2\u10D8\u10DC\u10D2\u10D8: 4.6/5",
        activeCases2: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10D8: 2",
        euroDentalGeorgia: 'Euro Dental Georgia',
        turnaround1014Days: "\u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0: 10-14 \u10D3\u10E6\u10D4",
        rating445: "\u10E0\u10D4\u10D8\u10E2\u10D8\u10DC\u10D2\u10D8: 4.4/5",
        enterSpaceForClinics: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D5\u10DA\u10D0 \u2192",
        book: "\u10D3\u10D0\u10EF\u10D0\u10D5\u10E8\u10DC\u10D0",
        followupConsultation: "\u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10D8 \u10D9\u10DD\u10DC\u10E1\u10E3\u10DA\u10E2\u10D0\u10EA\u10D8\u10D0",
        postoperativeCheckAfterRoot: "#14-\u10D6\u10D4 \u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10DE\u10DD\u10E1\u10E2\u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0. \u10D9\u10D0\u10E0\u10D2\u10D0\u10D3 \u10D8\u10EE\u10DD\u10E0\u10EA\u10D4\u10D1\u10D0, \u10D8\u10DC\u10E4\u10D4\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DC\u10D8\u10E8\u10DC\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1. \u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE\u10D0\u10E0\u10D0\u10EA\u10D8\u10D0 \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8\u10D0.",
        rootCanalTreatmentPhase: "\u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0 - \u10E4\u10D0\u10D6\u10D0 2",
        completedObturationOnTooth: "#14 \u10D9\u10D1\u10D8\u10DA\u10D6\u10D4 \u10DD\u10D1\u10E2\u10E3\u10E0\u10D0\u10EA\u10D8\u10D0 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0. \u10D2\u10E3\u10E2\u10D0\u10DE\u10D4\u10E0\u10E9\u10D8\u10E1 \u10E8\u10D4\u10D5\u10E1\u10D4\u10D1\u10D0, \u10DA\u10D0\u10E2\u10D4\u10E0\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D9\u10DD\u10DC\u10D3\u10D4\u10DC\u10E1\u10D0\u10EA\u10D8\u10D8\u10E1 \u10E2\u10D4\u10E5\u10DC\u10D8\u10D9\u10D0. \u10DE\u10DD\u10E1\u10E2\u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10DB\u10D0 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10DB\u10D0 \u10D0\u10D3\u10D4\u10D9\u10D5\u10D0\u10E2\u10E3\u10E0\u10D8 \u10E8\u10D4\u10D5\u10E1\u10D4\u10D1\u10D0 \u10D3\u10D0\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D0.",
        periapicalXray: "\u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8",
        workingLengthRadiographFor: "#14 \u10D9\u10D1\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10E1\u10D8\u10D2\u10E0\u10EB\u10D8\u10E1 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10DD\u10D2\u10E0\u10D0\u10DB\u10D0. \u10D0\u10E0\u10EE\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE\u10D0\u10E0\u10D0\u10EA\u10D8\u10D0 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D3\u10D0 21\u10DB\u10DB-\u10D6\u10D4. \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E6\u10D8\u10DC\u10D8\u10E8\u10DC\u10D0.",
        medicationPrescribedAmoxicilli: "\u10D3\u10D0\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8 \u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D8: \u10D0\u10DB\u10DD\u10E5\u10E1\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8 500\u10DB\u10D2",
        prescribed7dayCourseOf: "\u10D3\u10D0\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8\u10D0 7-\u10D3\u10E6\u10D8\u10D0\u10DC\u10D8 \u10D9\u10E3\u10E0\u10E1\u10D8 \u10D0\u10DB\u10DD\u10E5\u10E1\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8\u10D7 \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D8\u10DC\u10E4\u10D4\u10E5\u10EA\u10D8\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10E1 \u10D0\u10EA\u10DC\u10DD\u10D1\u10D4\u10E1 \u10DE\u10D4\u10DC\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8\u10E1 \u10D0\u10DA\u10D4\u10E0\u10D2\u10D8\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 - \u10D0\u10DB\u10DD\u10E5\u10E1\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8\u10E1 \u10E2\u10DD\u10DA\u10D4\u10E0\u10D0\u10DC\u10E2\u10DD\u10D1\u10D0 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D3\u10D0 \u10D9\u10D0\u10DC\u10D8\u10E1 \u10E2\u10D4\u10E1\u10E2\u10D8\u10D7.",
        diagnosisAcutePulpitis14: "\u10D3\u10D8\u10D0\u10D2\u10DC\u10DD\u10D6\u10D8: \u10DB\u10EC\u10D5\u10D0\u10D5\u10D4 \u10DE\u10E3\u10DA\u10DE\u10D8\u10E2\u10D8 #14",
        patientPresentedWithSevere: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8\u10D0 \u10DB\u10EB\u10D8\u10DB\u10D4 \u10E1\u10DE\u10DD\u10DC\u10E2\u10D0\u10DC\u10E3\u10E0\u10D8 \u10E2\u10D9\u10D8\u10D5\u10D8\u10DA\u10D8\u10D7 \u10D6\u10D4\u10D3\u10D0 \u10DB\u10D0\u10E0\u10EF\u10D5\u10D4\u10DC\u10D0 \u10D9\u10D5\u10D0\u10D3\u10E0\u10D0\u10DC\u10E2\u10E8\u10D8. \u10EA\u10D8\u10D5\u10D8 \u10E2\u10D4\u10E1\u10E2\u10D8 \u10D3\u10D0\u10D3\u10D4\u10D1\u10D8\u10D7\u10D8, \u10DE\u10D4\u10E0\u10D9\u10E3\u10E1\u10D8\u10D0 \u10DB\u10E2\u10D9\u10D8\u10D5\u10DC\u10D4\u10E3\u10DA\u10D8. \u10D3\u10D8\u10D0\u10D2\u10DC\u10DD\u10E1\u10E2\u10D8\u10E0\u10D3\u10D0 \u10DB\u10EC\u10D5\u10D0\u10D5\u10D4 \u10E8\u10D4\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0\u10D3\u10D8 \u10DE\u10E3\u10DA\u10DE\u10D8\u10E2\u10D8.",
        compositeFillingTooth21: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10E3\u10E0\u10D8 \u10D1\u10DF\u10D4\u10DC\u10D8 - \u10D9\u10D1\u10D8\u10DA\u10D8 #21",
        classIiCompositeRestoration: "\u10D9\u10DA\u10D0\u10E1\u10D8 II \u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10E3\u10E0\u10D8 \u10E0\u10D4\u10E1\u10E2\u10D0\u10D5\u10E0\u10D0\u10EA\u10D8\u10D0 #21-\u10D6\u10D4. \u10E4\u10D4\u10E0\u10D8 A2. \u10E0\u10D4\u10D6\u10D8\u10DC\u10D8\u10E1 \u10D9\u10DD\u10E4\u10D4\u10E0\u10D3\u10D0\u10DB\u10D8\u10D7 \u10D8\u10D6\u10DD\u10DA\u10D0\u10EA\u10D8\u10D0. \u10D8\u10DC\u10D9\u10E0\u10D4\u10DB\u10D4\u10DC\u10E2\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E4\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10E2\u10D4\u10E5\u10DC\u10D8\u10D9\u10D0. \u10DD\u10D9\u10DA\u10E3\u10D6\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DD\u10E0\u10D4\u10E5\u10EA\u10D8\u10D0 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0.",
        labResultsCbcPanel: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10D8: CBC \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8",
        completeBloodCountWithin: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10D8 \u10DC\u10DD\u10E0\u10DB\u10D8\u10E1 \u10E4\u10D0\u10E0\u10D2\u10DA\u10D4\u10D1\u10E8\u10D8. WBC 6.2, RBC 4.8, \u10F0\u10D4\u10DB\u10DD\u10D2\u10DA\u10DD\u10D1\u10D8\u10DC\u10D8 14.2 \u10D2/\u10D3\u10DA, \u10D7\u10E0\u10DD\u10DB\u10D1\u10DD\u10EA\u10D8\u10E2\u10D4\u10D1\u10D8 245K. \u10DC\u10D4\u10D1\u10D0\u10D3\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8\u10D0 \u10E5\u10D8\u10E0\u10E3\u10E0\u10D2\u10D8\u10E3\u10DA\u10D8 \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1.",
        fullmouthRadiographs: "\u10E1\u10E0\u10E3\u10DA-\u10DE\u10D8\u10E0\u10D8\u10E1 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10DD\u10D2\u10E0\u10D0\u10DB\u10D4\u10D1\u10D8",
        panoramicOpgAndFull: "\u10DE\u10D0\u10DC\u10DD\u10E0\u10D0\u10DB\u10E3\u10DA\u10D8 OPG \u10D3\u10D0 \u10E1\u10E0\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E1\u10D4\u10E0\u10D8\u10D0 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0. \u10D0\u10E6\u10DB\u10DD\u10E9\u10D4\u10DC\u10D4\u10D1\u10D8: \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E0\u10D0\u10D3\u10D8\u10DD\u10DA\u10E3\u10EA\u10D4\u10DC\u10E2\u10DD\u10D1\u10D0 #14-\u10D6\u10D4, \u10D0\u10D3\u10E0\u10D4\u10E3\u10DA\u10D8 \u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8\u10E1 \u10DA\u10D4\u10D6\u10D8\u10D0 #21-\u10D6\u10D4, \u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10DA\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10E1\u10E3\u10D1\u10E3\u10E5\u10D8 \u10EB\u10D5\u10DA\u10D8\u10E1 \u10D3\u10D0\u10D9\u10D0\u10E0\u10D2\u10D5\u10D0.",
        comprehensiveExamination: "\u10E7\u10DD\u10D5\u10DA\u10D8\u10E1\u10DB\u10DD\u10DB\u10EA\u10D5\u10D4\u10DA\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0",
        initialComprehensiveExamFull: "\u10E1\u10D0\u10EC\u10E7\u10D8\u10E1\u10D8 \u10E7\u10DD\u10D5\u10DA\u10D8\u10E1\u10DB\u10DD\u10DB\u10EA\u10D5\u10D4\u10DA\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0. \u10E1\u10E0\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E9\u10D0\u10E0\u10E2\u10D8\u10DC\u10D2\u10D8 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0. BPE \u10E5\u10E3\u10DA\u10D4\u10D1\u10D8: 2,2,3,2,3,2. \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D0 \u10D2\u10D0\u10DC\u10EE\u10D8\u10DA\u10E3\u10DA\u10D8\u10D0 \u10D3\u10D0 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0 \u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0. \u10EC\u10DC\u10D4\u10D5\u10D0 \u10E9\u10D0\u10EC\u10D4\u10E0\u10D8\u10DA\u10D8\u10D0 128/82.",
        medicationUpdateLisinopril10mg: "\u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0: \u10DA\u10D8\u10D6\u10D8\u10DC\u10DD\u10DE\u10E0\u10D8\u10DA\u10D8 10\u10DB\u10D2",
        patientReportedCurrentMedicati: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10DB\u10D0 \u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10D0 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D8: \u10DA\u10D8\u10D6\u10D8\u10DC\u10DD\u10DE\u10E0\u10D8\u10DA\u10D8 10\u10DB\u10D2 \u10E7\u10DD\u10D5\u10D4\u10DA\u10D3\u10E6\u10D8\u10E3\u10E0\u10D0\u10D3 \u10F0\u10D8\u10DE\u10D4\u10E0\u10E2\u10D4\u10DC\u10D6\u10D8\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. \u10E1\u10EE\u10D5\u10D0 \u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1. \u10DD\u10EF\u10D0\u10EE\u10D8\u10E1 \u10D4\u10E5\u10D8\u10DB\u10D8: \u10D3\u10DD\u10E5\u10E2. \u10DB\u10D0\u10D8\u10E1\u10E3\u10E0\u10D0\u10EB\u10D4, \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10DD \u10EA\u10D4\u10DC\u10E2\u10E0\u10D8.",
        patientRegistration: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10D0",
        newPatientRegistrationMedical: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10D0. \u10E1\u10D0\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10DD \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E0\u10D8 \u10E8\u10D4\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0. \u10D0\u10DA\u10D4\u10E0\u10D2\u10D8\u10D4\u10D1\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: \u10DE\u10D4\u10DC\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8 (\u10DB\u10EB\u10D8\u10DB\u10D4), \u10DA\u10D0\u10E2\u10D4\u10E5\u10E1\u10D8 (\u10D6\u10DD\u10DB\u10D8\u10D4\u10E0\u10D8), \u10DA\u10D8\u10D3\u10DD\u10D9\u10D0\u10D8\u10DC\u10D8 (\u10DB\u10E1\u10E3\u10D1\u10E3\u10E5\u10D8). \u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0: GPI Health.",
        activeConditions: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D4\u10D1\u10D8",
        chronicPeriodontitis: "\u10E5\u10E0\u10DD\u10DC\u10D8\u10D9\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10D8\u10E2\u10D8",
        active: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8",
        generalizedMildChronicPeriodon: "\u10D2\u10D4\u10DC\u10D4\u10E0\u10D0\u10DA\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10E1\u10E3\u10D1\u10E3\u10E5\u10D8 \u10E5\u10E0\u10DD\u10DC\u10D8\u10D9\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10D8\u10E2\u10D8 \u10DA\u10DD\u10D9\u10D0\u10DA\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D6\u10DD\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E9\u10D0\u10E0\u10D7\u10E3\u10DA\u10DD\u10D1\u10D8\u10D7. BPE \u10E5\u10E3\u10DA\u10D4\u10D1\u10D8 \u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10D4\u10D1\u10E1 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D4\u10D1\u10D0\u10D6\u10D4.",
        onsetJan2026: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0: \u10D8\u10D0\u10DC 2026",
        dentalCaries: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8",
        resolved: "\u10DB\u10DD\u10D2\u10D5\u10D0\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8",
        cariousLesionOnTooth: "\u10D9\u10D0\u10E0\u10D8\u10D4\u10E1\u10D8\u10E1 \u10DA\u10D4\u10D6\u10D8\u10D0 \u10D9\u10D1\u10D8\u10DA\u10D6\u10D4 #21, \u10DB\u10D4\u10D6\u10D8\u10DD-\u10DD\u10D9\u10DA\u10E3\u10D6\u10D8\u10E3\u10E0\u10D8 \u10D6\u10D4\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8. \u10DC\u10D0\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10D4\u10D1\u10D8 \u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10E3\u10E0\u10D8 \u10E0\u10D4\u10E1\u10E2\u10D0\u10D5\u10E0\u10D0\u10EA\u10D8\u10D8\u10D7 2026 \u10EC\u10DA\u10D8\u10E1 15 \u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10E1.",
        resolvedFeb2026: "\u10DB\u10DD\u10D2\u10D5\u10D0\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8: \u10D7\u10D4\u10D1 2026",
        bruxism: "\u10D1\u10E0\u10E3\u10E5\u10E1\u10D8\u10D6\u10DB\u10D8",
        nocturnalBruxismWearFacets: "\u10E6\u10D0\u10DB\u10D8\u10E1 \u10D1\u10E0\u10E3\u10E5\u10E1\u10D8\u10D6\u10DB\u10D8. \u10EA\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E4\u10D0\u10E1\u10D4\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E6\u10D8\u10DC\u10D8\u10E8\u10DC\u10D0 \u10EC\u10D8\u10DC\u10D0 \u10D9\u10D1\u10D8\u10DA\u10D4\u10D1\u10D6\u10D4. \u10E6\u10D0\u10DB\u10D8\u10E1 \u10D9\u10D0\u10DE\u10D0 \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0, \u10DB\u10D0\u10D2\u10E0\u10D0\u10DB \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10E1 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D3\u10D0\u10E3\u10EC\u10E7\u10D8\u10D0 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0.",
        activeMedications: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        lisinopril10mg: "\u10DA\u10D8\u10D6\u10D8\u10DC\u10DD\u10DE\u10E0\u10D8\u10DA\u10D8 10\u10DB\u10D2",
        onceDailyOral: "\u10D3\u10E6\u10D4\u10E8\u10D8 \u10D4\u10E0\u10D7\u10EE\u10D4\u10DA, \u10DE\u10D4\u10E0\u10DD\u10E0\u10D0\u10DA\u10E3\u10E0\u10D0\u10D3",
        hypertensionManagement: "\u10F0\u10D8\u10DE\u10D4\u10E0\u10E2\u10D4\u10DC\u10D6\u10D8\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        chlorhexidine012Rinse: "\u10E5\u10DA\u10DD\u10E0\u10F0\u10D4\u10E5\u10E1\u10D8\u10D3\u10D8\u10DC\u10D8 0.12% \u10EE\u10E1\u10DC\u10D0\u10E0\u10D8",
        twiceDailyOralRinse: "\u10D3\u10E6\u10D4\u10E8\u10D8 \u10DD\u10E0\u10EF\u10D4\u10E0, \u10DE\u10D8\u10E0\u10D8\u10E1 \u10E6\u10E0\u10E3\u10E1 \u10EE\u10E1\u10DC\u10D0\u10E0\u10D8",
        periodontalMaintenance: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10DD\u10D5\u10DA\u10D0",
        ibuprofen400mg: "\u10D8\u10D1\u10E3\u10DE\u10E0\u10DD\u10E4\u10D4\u10DC\u10D8 400\u10DB\u10D2",
        asNeededForPain: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D4\u10D1\u10D8\u10E1\u10D0\u10DB\u10D4\u10D1\u10E0 \u10E2\u10D9\u10D8\u10D5\u10D8\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1, \u10DB\u10D0\u10E5\u10E1. 3-\u10EF\u10D4\u10E0 \u10D3\u10E6\u10D4\u10E8\u10D8",
        postprocedurePainManagement: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10D8 \u10E2\u10D9\u10D8\u10D5\u10D8\u10DA\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        pastMedications: "\u10EC\u10D0\u10E0\u10E1\u10E3\u10DA\u10D8 \u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        amoxicillin500mg: "\u10D0\u10DB\u10DD\u10E5\u10E1\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8 500\u10DB\u10D2",
        periapicalInfectionProphylaxis: "\u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D8\u10DC\u10E4\u10D4\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D0\u10E5\u10E2\u10D8\u10D9\u10D0",
        completed2: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8",
        metronidazole250mg: "\u10DB\u10D4\u10E2\u10E0\u10DD\u10DC\u10D8\u10D3\u10D0\u10D6\u10DD\u10DA\u10D8 250\u10DB\u10D2",
        adjunctPeriodontalTherapy: "\u10D3\u10D0\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D7\u10D4\u10E0\u10D0\u10DE\u10D8\u10D0",
        paracetamol500mg: "\u10DE\u10D0\u10E0\u10D0\u10EA\u10D4\u10E2\u10D0\u10DB\u10DD\u10DA\u10D8 500\u10DB\u10D2",
        asNeededFeb1518: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D4\u10D1\u10D8\u10E1\u10D0\u10DB\u10D4\u10D1\u10E0 (\u10D7\u10D4\u10D1 15-18, 2026)",
        postfillingSensitivity: "\u10D1\u10DF\u10D4\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10D8 \u10DB\u10D2\u10E0\u10EB\u10DC\u10DD\u10D1\u10D4\u10DA\u10DD\u10D1\u10D0",
        diclofenac50mg: "\u10D3\u10D8\u10D9\u10DA\u10DD\u10E4\u10D4\u10DC\u10D0\u10D9\u10D8 50\u10DB\u10D2",
        twiceDailyFor3: "\u10D3\u10E6\u10D4\u10E8\u10D8 \u10DD\u10E0\u10EF\u10D4\u10E0, 3 \u10D3\u10E6\u10D4 (\u10D8\u10D0\u10DC 22-24, 2026)",
        postexamSoreness: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10D8 \u10DB\u10E2\u10D9\u10D8\u10D5\u10DC\u10D4\u10E3\u10DA\u10DD\u10D1\u10D0",
        documentedAllergies: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D0\u10DA\u10D4\u10E0\u10D2\u10D8\u10D4\u10D1\u10D8",
        penicillin: "\u10DE\u10D4\u10DC\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8",
        severe: "\u10DB\u10EB\u10D8\u10DB\u10D4",
        reactionAnaphylaxisUrticariaAn: "\u10E0\u10D4\u10D0\u10E5\u10EA\u10D8\u10D0: \u10D0\u10DC\u10D0\u10E4\u10D8\u10DA\u10D0\u10E5\u10E1\u10D8\u10D0, \u10E3\u10E0\u10E2\u10D8\u10D9\u10D0\u10E0\u10D8\u10D0, \u10D0\u10DC\u10D2\u10D8\u10DD\u10D4\u10D3\u10D4\u10DB\u10D0",
        crossreactivityWithCephalospor: "\u10EA\u10D4\u10E4\u10D0\u10DA\u10DD\u10E1\u10DE\u10DD\u10E0\u10D8\u10DC\u10D4\u10D1\u10D7\u10D0\u10DC \u10EF\u10D5\u10D0\u10E0\u10D4\u10D3\u10D8\u10DC\u10D8 \u10E0\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0. \u10D0\u10DB\u10DD\u10E5\u10E1\u10D8\u10EA\u10D8\u10DA\u10D8\u10DC\u10D8\u10E1 \u10E2\u10DD\u10DA\u10D4\u10E0\u10D0\u10DC\u10E2\u10DD\u10D1\u10D0 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u10D6\u10D4\u10D3\u10D0\u10DB\u10EE\u10D4\u10D3\u10D5\u10D4\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E5\u10D5\u10D4\u10E8 \u10E9\u10D0\u10E2\u10D0\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10D0\u10DC\u10D8\u10E1 \u10E2\u10D4\u10E1\u10E2\u10D8\u10D7. \u10D3\u10D0\u10D0\u10E4\u10D8\u10E5\u10E1\u10D8\u10E0\u10D4\u10D7 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10E1\u10D0\u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10DD \u10EC\u10D4\u10E0\u10D8\u10DA\u10E8\u10D8.",
        documentedJan102026: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: 2026 \u10EC\u10DA\u10D8\u10E1 10 \u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        latex: "\u10DA\u10D0\u10E2\u10D4\u10E5\u10E1\u10D8",
        moderate: "\u10D6\u10DD\u10DB\u10D8\u10D4\u10E0\u10D8",
        reactionContactDermatitisLocal: "\u10E0\u10D4\u10D0\u10E5\u10EA\u10D8\u10D0: \u10E1\u10D0\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10DD \u10D3\u10D4\u10E0\u10DB\u10D0\u10E2\u10D8\u10E2\u10D8, \u10DA\u10DD\u10D9\u10D0\u10DA\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E8\u10D4\u10E8\u10E3\u10DE\u10D4\u10D1\u10D0",
        useNitrileGlovesOnly: "\u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D7 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10DC\u10D8\u10E2\u10E0\u10D8\u10DA\u10D8\u10E1 \u10EE\u10D4\u10DA\u10D7\u10D0\u10D7\u10DB\u10D0\u10DC\u10D4\u10D1\u10D8. \u10DA\u10D0\u10E2\u10D4\u10E5\u10E1\u10D8\u10E1\u10D2\u10D0\u10DC \u10D7\u10D0\u10D5\u10D8\u10E1\u10E3\u10E4\u10D0\u10DA\u10D8 \u10D2\u10D0\u10E0\u10D4\u10DB\u10DD \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. \u10D7\u10D5\u10D0\u10DA\u10E1\u10D0\u10E9\u10D8\u10DC\u10DD\u10D3 \u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10D4\u10D7 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10E8\u10D8.",
        lidocaine: "\u10DA\u10D8\u10D3\u10DD\u10D9\u10D0\u10D8\u10DC\u10D8",
        mild: "\u10DB\u10E1\u10E3\u10D1\u10E3\u10E5\u10D8",
        reactionMildTinglingProlonged: "\u10E0\u10D4\u10D0\u10E5\u10EA\u10D8\u10D0: \u10DB\u10E1\u10E3\u10D1\u10E3\u10E5\u10D8 \u10E9\u10EE\u10D5\u10DA\u10D4\u10E2\u10D0, \u10DB\u10DD\u10E1\u10D0\u10DA\u10DD\u10D3\u10DC\u10D4\u10DA \u10D5\u10D0\u10D3\u10D0\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10D3\u10D0\u10D1\u10E3\u10DF\u10D4\u10D1\u10D0",
        useArticaineAsAlternative: "\u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D7 \u10D0\u10E0\u10E2\u10D8\u10D9\u10D0\u10D8\u10DC\u10D8 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10D0\u10DA\u10E2\u10D4\u10E0\u10DC\u10D0\u10E2\u10D8\u10E3\u10DA\u10D8 \u10D0\u10D3\u10D2\u10D8\u10DA\u10DD\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D0\u10DC\u10D4\u10E1\u10D7\u10D4\u10E2\u10D8\u10D9\u10D8. \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8 \u10D9\u10D0\u10E0\u10D2\u10D0\u10D3 \u10D8\u10E2\u10D0\u10DC\u10E1 \u10DB\u10D4\u10DE\u10D8\u10D5\u10D0\u10D9\u10D0\u10D8\u10DC\u10E1. \u10D3\u10D0\u10D0\u10D9\u10D5\u10D8\u10E0\u10D3\u10D8\u10D7 \u10D0\u10E0\u10D0\u10E9\u10D5\u10D4\u10E3\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5 \u10E0\u10D4\u10D0\u10E5\u10EA\u10D8\u10D4\u10D1\u10E1.",
        latestVitalsMar15: "\u10E3\u10D0\u10EE\u10DA\u10D4\u10E1\u10D8 \u10E1\u10D0\u10E1\u10D8\u10EA\u10DD\u10EA\u10EE\u10DA\u10DD \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8 \u2014 2026 \u10EC\u10DA\u10D8\u10E1 15 \u10DB\u10D0\u10E0\u10E2\u10D8",
        labResults2: "\u10DA\u10D0\u10D1\u10DD\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E3\u10DA\u10D8 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10D8",
        test: "\u10E2\u10D4\u10E1\u10E2\u10D8",
        result: "\u10E8\u10D4\u10D3\u10D4\u10D2\u10D8",
        reference: "\u10E1\u10D0\u10EA\u10DC\u10DD\u10D1\u10D0\u10E0\u10DD",
        date: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        hemoglobin: "\u10F0\u10D4\u10DB\u10DD\u10D2\u10DA\u10DD\u10D1\u10D8\u10DC\u10D8",
        platelets: "\u10D7\u10E0\u10DD\u10DB\u10D1\u10DD\u10EA\u10D8\u10E2\u10D4\u10D1\u10D8",
        glucoseFasting: "\u10D2\u10DA\u10E3\u10D9\u10DD\u10D6\u10D0 (\u10E3\u10D6\u10DB\u10DD\u10D6\u10D4)",
        immunizationRecords: "\u10D8\u10DB\u10E3\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8",
        hepatitisB: "\u10F0\u10D4\u10DE\u10D0\u10E2\u10D8\u10E2\u10D8 B",
        completed3doseSeries2019: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8: 3-\u10D3\u10DD\u10D6\u10D8\u10D0\u10DC\u10D8 \u10E1\u10D4\u10E0\u10D8\u10D0, 2019",
        upToDate: "\u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8",
        tetanusdiphtheriaTd: "\u10E2\u10D4\u10E2\u10D0\u10DC\u10E3\u10E1\u10D8/\u10D3\u10D8\u10E4\u10D7\u10D4\u10E0\u10D8\u10D0 (Td)",
        lastBooster2022: "\u10D1\u10DD\u10DA\u10DD \u10D1\u10E3\u10E1\u10E2\u10D4\u10E0\u10D8: 2022",
        covid19: 'COVID-19',
        lastDoseSep2024: "\u10D1\u10DD\u10DA\u10DD \u10D3\u10DD\u10D6\u10D0: \u10E1\u10D4\u10E5 2024",
        dueForBooster: "\u10D1\u10E3\u10E1\u10E2\u10D4\u10E0\u10D8\u10E1 \u10D3\u10E0\u10DD \u10D3\u10D2\u10D4\u10D1\u10D0",
        familyMedicalHistory: "\u10DD\u10EF\u10D0\u10EE\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10DD \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        father: "\u10DB\u10D0\u10DB\u10D0",
        hypertensionType2Diabetes: "\u10F0\u10D8\u10DE\u10D4\u10E0\u10E2\u10D4\u10DC\u10D6\u10D8\u10D0, \u10E2\u10D8\u10DE\u10D8 2 \u10D3\u10D8\u10D0\u10D1\u10D4\u10E2\u10D8, \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D3\u10D0\u10D0\u10D5\u10D0\u10D3\u10D4\u10D1\u10D0",
        mother: "\u10D3\u10D4\u10D3\u10D0",
        osteoporosisDrugAllergySulfona: "\u10DD\u10E1\u10E2\u10D4\u10DD\u10DE\u10DD\u10E0\u10DD\u10D6\u10D8, \u10EC\u10D0\u10DB\u10DA\u10D8\u10E1 \u10D0\u10DA\u10D4\u10E0\u10D2\u10D8\u10D0 (\u10E1\u10E3\u10DA\u10E4\u10DD\u10DC\u10D0\u10DB\u10D8\u10D3\u10D4\u10D1\u10D8)",
        sibling: "\u10D3\u10D0-\u10EB\u10DB\u10D0",
        bruxismDentalAnxiety: "\u10D1\u10E0\u10E3\u10E5\u10E1\u10D8\u10D6\u10DB\u10D8, \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E8\u10E4\u10DD\u10D7\u10D5\u10D0",
        imagingRecords: "\u10D2\u10D0\u10DB\u10DD\u10E1\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8",
        panoramicOpg: "\u10DE\u10D0\u10DC\u10DD\u10E0\u10D0\u10DB\u10E3\u10DA\u10D8 OPG",
        periapical14: "\u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 #14",
        bitewingRl: "\u10D1\u10D8\u10E2\u10D5\u10D8\u10DC\u10D2\u10D8 R+L",
        patientDocuments: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        consentFormRootCanal: "\u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10E4\u10DD\u10E0\u10DB\u10D0 - \u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0",
        treatmentPlanAgreement: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D8\u10E1 \u10E8\u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D0",
        medicalHistoryQuestionnaire: "\u10E1\u10D0\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10DD \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E0\u10D8",
        insuranceAuthorizationGpi: "\u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10D0\u10D5\u10E2\u10DD\u10E0\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0 - GPI",
        insuranceInformation: "\u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0",
        provider: "\u10DE\u10E0\u10DD\u10D5\u10D0\u10D8\u10D3\u10D4\u10E0\u10D8:",
        policy: "\u10DE\u10DD\u10DA\u10D8\u10E1\u10D8 #:",
        group: "\u10EF\u10D2\u10E3\u10E4\u10D8:",
        corporatePlanPremium: "\u10D9\u10DD\u10E0\u10DE\u10DD\u10E0\u10D0\u10E2\u10D8\u10E3\u10DA\u10D8 \u10D2\u10D4\u10D2\u10DB\u10D0 - \u10DE\u10E0\u10D4\u10DB\u10D8\u10E3\u10DB",
        coverage: "\u10D3\u10D0\u10E4\u10D0\u10E0\u10D5\u10D0:",
        deductible: "\u10D7\u10D0\u10DC\u10D0\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0:",
        annualMax2: "\u10EC\u10DA\u10D8\u10E3\u10E0\u10D8 \u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10E3\u10DB\u10D8:",
        valid: "\u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D8:",
        age34: "\u10D0\u10E1\u10D0\u10D9\u10D8: 34",
        lastVisitMar10: "\u10D1\u10DD\u10DA\u10DD \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8: \u10DB\u10D0\u10E0 10",
        nextMar19: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8: \u10DB\u10D0\u10E0 19",
        overview: "\u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0",
        dentalChart: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E0\u10E3\u10D9\u10D0",
        treatmentPlan: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D0",
        history: "\u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        documents2: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        allergies2: "\u10D0\u10DA\u10D4\u10E0\u10D2\u10D8\u10D4\u10D1\u10D8",
        medicalNotes: "\u10E1\u10D0\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10DD \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8",
        insurance3: "\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0",
        upperArch: "\u10D6\u10D4\u10D3\u10D0 \u10E0\u10D9\u10D0\u10DA\u10D8",
        lowerArch: "\u10E5\u10D5\u10D4\u10D3\u10D0 \u10E0\u10D9\u10D0\u10DA\u10D8",
        tooth: "\u10D9\u10D1\u10D8\u10DA\u10D8",
        procedure2: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D0",
        price: "\u10E4\u10D0\u10E1\u10D8",
        rootCanalTreatment: "\u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0",
        ceramicCrown: "\u10D9\u10D4\u10E0\u10D0\u10DB\u10D8\u10D9\u10E3\u10DA\u10D8 \u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8",
        compositeFilling: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10E3\u10E0\u10D8 \u10D1\u10DF\u10D4\u10DC\u10D8",
        implantPlacement: "\u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8\u10E1 \u10E9\u10D0\u10D3\u10D2\u10DB\u10D0",
        total: "\u10EF\u10D0\u10DB\u10D8",
        addProcedure2: "+ \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0",
        march102026: "2026 \u10EC\u10DA\u10D8\u10E1 10 \u10DB\u10D0\u10E0\u10E2\u10D8",
        periapicalXrayRootCanal: "\u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8, \u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 #14-\u10D6\u10D4. \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10E1\u10D8\u10D2\u10E0\u10EB\u10D4 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10E3\u10DA\u10D8\u10D0. \u10D9\u10D0\u10DA\u10EA\u10D8\u10E3\u10DB\u10D8\u10E1 \u10F0\u10D8\u10D3\u10E0\u10DD\u10E5\u10E1\u10D8\u10D3\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD \u10E1\u10D0\u10E4\u10D0\u10E0\u10D8 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0.",
        february152026: "2026 \u10EC\u10DA\u10D8\u10E1 15 \u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        compositeFillingOn21: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10E3\u10E0\u10D8 \u10D1\u10DF\u10D4\u10DC\u10D8 #21-\u10D6\u10D4. \u10E4\u10D4\u10E0\u10D8 A2. \u10DD\u10D9\u10DA\u10E3\u10D6\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DD\u10E0\u10D4\u10E5\u10EA\u10D8\u10D0 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0. \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10DB\u10D0 \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D0 \u10D9\u10D0\u10E0\u10D2\u10D0\u10D3 \u10D0\u10E2\u10D0\u10E0\u10D0.",
        january202026: "2026 \u10EC\u10DA\u10D8\u10E1 20 \u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        comprehensiveExaminationFullmo: "\u10E7\u10DD\u10D5\u10DA\u10D8\u10E1\u10DB\u10DD\u10DB\u10EA\u10D5\u10D4\u10DA\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0. \u10E1\u10E0\u10E3\u10DA-\u10DE\u10D8\u10E0\u10D8\u10E1 \u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10DD\u10D2\u10E0\u10D0\u10DB\u10D4\u10D1\u10D8. \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D0 \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D7\u10D0\u10DC \u10D2\u10D0\u10DC\u10EE\u10D8\u10DA\u10E3\u10DA\u10D8\u10D0. \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10E4\u10DD\u10E0\u10DB\u10D4\u10D1\u10D8 \u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D8\u10DA\u10D8\u10D0.",
        bitewingRight: "\u10D1\u10D8\u10E2\u10D5\u10D8\u10DC\u10D2\u10D8 \u10DB\u10D0\u10E0\u10EF\u10D5\u10D4\u10DC\u10D0",
        bitewingLeft: "\u10D1\u10D8\u10E2\u10D5\u10D8\u10DC\u10D2\u10D8 \u10DB\u10D0\u10E0\u10EA\u10EE\u10D4\u10DC\u10D0",
        uploadDocument: "+ \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0",
        all: "\u10E7\u10D5\u10D4\u10DA\u10D0",
        new: "\u10D0\u10EE\u10D0\u10DA\u10D8",
        phone2: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8",
        lastVisit: "\u10D1\u10DD\u10DA\u10DD \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8",
        nextAppt: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8",
        balance: "\u10D1\u10D0\u10DA\u10D0\u10DC\u10E1\u10D8",
        pt001: 'PT-001',
        pt002: 'PT-002',
        pt003: 'PT-003',
        mariamTsiklauri: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB \u10EA\u10D8\u10D9\u10DA\u10D0\u10E3\u10E0\u10D8",
        pt004: 'PT-004',
        pt005: 'PT-005',
        lukaMchedlishvili: "\u10DA\u10E3\u10D9\u10D0 \u10DB\u10ED\u10D4\u10D3\u10DA\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8",
        pt006: 'PT-006',
        tamtaLomidze: "\u10D7\u10D0\u10DB\u10D7\u10D0 \u10DA\u10DD\u10DB\u10D8\u10EB\u10D4",
        pt007: 'PT-007',
        periodontalChart: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E9\u10D0\u10E0\u10E2\u10D8",
        newExam2: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0",
        voiceEntry2: "\u10EE\u10DB\u10DD\u10D5\u10D0\u10DC\u10D8 \u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0",
        dcai: 'DCAI',
        dentalBookingOpsPlatform: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8\u10E1 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0",
        theMissingInfrastructureFor: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D0\u10D9\u10DA\u10D8\u10D0\u10DC\u10D8 \u10D8\u10DC\u10E4\u10E0\u10D0\u10E1\u10E2\u10E0\u10E3\u10E5\u10E2\u10E3\u10E0\u10D0",
        manage: "\u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        grow: "\u10D6\u10E0\u10D3\u10D0",
        marketSize: "\u10D1\u10D0\u10D6\u10E0\u10D8\u10E1 \u10D6\u10DD\u10DB\u10D0",
        dentalClinicsInGeorgia: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D0 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E8\u10D8",
        inTbilisiAlone: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10E8\u10D8",
        unifiedBookingOrOps: "\u10D4\u10E0\u10D7\u10D8\u10D0\u10DC\u10D8 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D0\u10DC \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0",
        dentosgeIsTheOnly: "\u26A0\uFE0F  dentos.ge \u10D4\u10E0\u10D7\u10D0\u10D3\u10D4\u10E0\u10D7\u10D8 \u10DC\u10D0\u10EC\u10D8\u10DA\u10DD\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D9\u10DD\u10DC\u10D9\u10E3\u10E0\u10D4\u10DC\u10E2\u10D8\u10D0 \u2014 \u10E1\u10E0\u10E3\u10DA\u10D8 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8 \u10E4\u10D4\u10DC\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1",
        theProblem2: "\u10DE\u10E0\u10DD\u10D1\u10DA\u10D4\u10DB\u10D0",
        str511: "\uD83D\uDCCB",
        clinicsRunOnExcel: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10D4\u10DC Excel + WhatsApp + \u10E5\u10D0\u10E6\u10D0\u10DA\u10D3\u10D8\u10D7",
        noStructuredWorkflowConstant: "\u10E1\u10E2\u10E0\u10E3\u10E5\u10E2\u10E3\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10DE\u10E0\u10DD\u10EA\u10D4\u10E1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1, \u10DB\u10E3\u10D3\u10DB\u10D8\u10D5\u10D8 \u10D0\u10D3\u10D0\u10DB\u10D8\u10D0\u10DC\u10E3\u10E0\u10D8 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0",
        str514: "\uD83D\uDCC9",
        noshowsCost1525Of: "\u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D4\u10D1\u10D8 \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10DA\u10D8\u10E1 15\u201325%-\u10E1 \u10E8\u10D4\u10D0\u10D3\u10D2\u10D4\u10DC\u10E1",
        noAutomatedRemindersOr: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D0\u10DC \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
        str517: "\uD83C\uDFE6",
        insuranceBillingIsManual: "\u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D0 \u10EE\u10D4\u10DA\u10D8\u10D7\u10D0\u10D0 \u10D3\u10D0 \u10DB\u10E2\u10D9\u10D8\u10D5\u10DC\u10D4\u10E3\u10DA\u10D8",
        str519: "\uD83D\uDCF5",
        dentalTourismPatientsEspeciall: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E2\u10E3\u10E0\u10D8\u10D6\u10DB\u10D8\u10E1 \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D9\u10E3\u10D7\u10E0\u10D4\u10D1\u10D8\u10D7 \u10D4\u10DA\u10D8\u10D0\u10DC \u10EA\u10D8\u10E4\u10E0\u10E3\u10DA \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10E1",
        theSolution: "\u10D2\u10D0\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10D8",
        str523: "\uD83D\uDCC5",
        onlineBookingWidgetMarketplace: "\u10DD\u10DC\u10DA\u10D0\u10D8\u10DC \u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D5\u10D8\u10EF\u10D4\u10E2\u10D8 + \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10E4\u10DA\u10D4\u10D8\u10E1\u10D8",
        patientsBook247From: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10D0\u10DC 24/7 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10DB\u10DD\u10EC\u10E7\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D8\u10D3\u10D0\u10DC",
        str526: "\uD83E\uDDB7",
        patientRecordsTreatmentManagem: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        fullHistoryTreatmentPlans: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0, \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D4\u10D1\u10D8, \u10D4\u10DA-\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8",
        str529: "\uD83C\uDFE5",
        insuranceIntegrations: "\u10E1\u10D0\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10DD \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8",
        str531: "\uD83D\uDCAC",
        smsWhatsappReminders: "SMS / WhatsApp \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8",
        cutNoshowsByUp: "\u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 40%-\u10DB\u10D3\u10D4 \u10E8\u10D4\u10DB\u10EA\u10D8\u10E0\u10D4\u10D1\u10D0",
        str534: "\uD83D\uDCCA",
        financialReportingDashboard: "\u10E4\u10D8\u10DC\u10D0\u10DC\u10E1\u10E3\u10E0\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D2\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8",
        revenueSalariesExpensesRealtim: "\u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10D0\u10DA\u10D8, \u10EE\u10D4\u10DA\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8, \u10EE\u10D0\u10E0\u10EF\u10D4\u10D1\u10D8 \u2014 \u10E0\u10D4\u10D0\u10DA\u10E3\u10E0 \u10D3\u10E0\u10DD\u10E8\u10D8",
        willingnessToPay: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 \u10DB\u10D6\u10D0\u10DD\u10D1\u10D0",
        free: "\u10E3\u10E4\u10D0\u10E1\u10DD",
        month: "/\u10D7\u10D5\u10D4\u10E8\u10D8",
        listingBookingWidget: "\u10DA\u10D8\u10E1\u10E2\u10D8\u10DC\u10D2\u10D8 + \u10EF\u10D0\u10D5\u10E8\u10DC\u10D8\u10E1 \u10D5\u10D8\u10EF\u10D4\u10E2\u10D8",
        growth: "\u10D6\u10E0\u10D3\u10D0",
        calendarRemindersPatientCards: "\u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10D0\u10E0\u10D8 + \u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8 + \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10D1\u10D8",
        pro: "\u10DE\u10E0\u10DD",
        fullOpsInsuranceAnalytics: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8 + \u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0 + \u10D0\u10DC\u10D0\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0",
        multibranchApiAccessReporting: "\u10DB\u10E0\u10D0\u10D5\u10D0\u10DA\u10E4\u10D8\u10DA\u10D8\u10D0\u10DA\u10D8 + API \u10EC\u10D5\u10D3\u10DD\u10DB\u10D0 + \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D2\u10D4\u10D1\u10D0",
        wtp0515OfMonthly: "\uD83D\uDCA1 WTP: \u10E7\u10DD\u10D5\u10D4\u10DA\u10D7\u10D5\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10DA\u10D8\u10E1 0.5\u20131.5% \u2014 \u20BE15K\u201350K/\u10D7\u10D5\u10D4\u10E8\u10D8 \u10E8\u10D4\u10DB\u10DD\u10E1\u10D0\u10D5\u10DA\u10D8\u10E1 \u10DB\u10E5\u10DD\u10DC\u10D4 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u20BE100\u2013350/\u10D7\u10D5\u10D4\u10E8\u10D8 \u10D9\u10DD\u10DB\u10E4\u10DD\u10E0\u10E2\u10E3\u10DA\u10D0\u10D3 \u10D8\u10EE\u10D3\u10D8\u10D0\u10DC",
        marketOpportunity: "\u10D1\u10D0\u10D6\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0",
        addressableClinicsAtLaunch: "\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u10D2\u10D0\u10E8\u10D5\u10D4\u10D1\u10D8\u10E1\u10D0\u10E1",
        mrrAtFullPenetration: "MRR \u10E1\u10E0\u10E3\u10DA\u10D8 \u10DE\u10D4\u10DC\u10D4\u10E2\u10E0\u10D0\u10EA\u10D8\u10D8\u10E1\u10D0\u10E1 (\u20BE49 \u10E1\u10D0\u10E8.)",
        initialMrrCeilingUsd: "\u10E1\u10D0\u10EC\u10E7\u10D8\u10E1\u10D8 MRR \u10ED\u10D4\u10E0\u10D8 (USD)",
        nextExpansionArmeniaAzerbaijan: "\uD83C\uDF0D  \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D2\u10D0\u10E4\u10D0\u10E0\u10D7\u10DD\u10D4\u10D1\u10D0: \u10E1\u10DD\u10DB\u10EE\u10D4\u10D7\u10D8 \u2192 \u10D0\u10D6\u10D4\u10E0\u10D1\u10D0\u10D8\u10EF\u10D0\u10DC\u10D8 \u2192 \u10E4\u10D0\u10E0\u10D7\u10DD \u10D9\u10D0\u10D5\u10D9\u10D0\u10E1\u10D8\u10D8\u10E1 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10D1\u10D0\u10D6\u10D0\u10E0\u10D8",
        whyNow: "\u10E0\u10D0\u10E2\u10DD\u10DB \u10D0\u10EE\u10DA\u10D0",
        str561: "\u2708\uFE0F",
        dentalTourismBoom: "\u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10E2\u10E3\u10E0\u10D8\u10D6\u10DB\u10D8\u10E1 \u10D1\u10E3\u10DB\u10D8",
        internationalPatientsNeedEngli: "\u10E1\u10D0\u10D4\u10E0\u10D7\u10D0\u10E8\u10DD\u10E0\u10D8\u10E1\u10DD \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10E1 \u10E1\u10ED\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0\u10D7 \u10D8\u10DC\u10D2\u10DA\u10D8\u10E1\u10E3\u10E0\u10D4\u10DC\u10DD\u10D5\u10D0\u10DC\u10D8 \u10DD\u10DC\u10DA\u10D0\u10D8\u10DC \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8 \u10D0\u10EE\u10DA\u10D0\u10D5\u10D4",
        str564: "\uD83D\uDCF1",
        postcovidDigitizationPressure: "\u10DE\u10DD\u10E1\u10E2-COVID \u10EA\u10D8\u10E4\u10E0\u10D8\u10D6\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D6\u10D4\u10EC\u10DD\u10DA\u10D0",
        clinicsThatSurvivedAre: "\u10D2\u10D0\u10D3\u10D0\u10E0\u10E9\u10D4\u10DC\u10D8\u10DA\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8 \u10DB\u10D6\u10D0\u10D3 \u10D0\u10E0\u10D8\u10D0\u10DC \u10E2\u10D4\u10E5\u10DC\u10DD\u10DA\u10DD\u10D2\u10D8\u10D0\u10E8\u10D8 \u10D8\u10DC\u10D5\u10D4\u10E1\u10E2\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
        str567: "\uD83C\uDFC6",
        noStrongLocalIncumbent: "\u10EB\u10DA\u10D8\u10D4\u10E0\u10D8 \u10D0\u10D3\u10D2\u10D8\u10DA\u10DD\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D9\u10DD\u10DC\u10D9\u10E3\u10E0\u10D4\u10DC\u10E2\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1",
        dentosgeOnlyCoversDiscovery: "dentos.ge \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10D0\u10E6\u10DB\u10DD\u10E9\u10D4\u10DC\u10D0\u10E1 \u10E4\u10D0\u10E0\u10D0\u10D5\u10E1 \u2014 \u10E1\u10E0\u10E3\u10DA\u10D8 \u10DD\u10DE\u10D4\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1",
        str570: "\uD83C\uDDEC\uD83C\uDDEA",
        georgiaIsAHealthcare: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD \u10EF\u10D0\u10DC\u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10F0\u10D0\u10D1\u10D8\u10D0 \u10D9\u10D0\u10D5\u10D9\u10D0\u10E1\u10D8\u10D0\u10E8\u10D8",
        lowCostHighQuality: "\u10D3\u10D0\u10D1\u10D0\u10DA\u10D8 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0, \u10DB\u10D0\u10E6\u10D0\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8 \u2014 \u10D3\u10D0\u10E1\u10D0\u10D5\u10DA\u10D4\u10D7 \u10D4\u10D5\u10E0\u10DD\u10DE\u10D0\u10D6\u10D4 50\u201370%-\u10D8\u10D7 \u10D8\u10D0\u10E4\u10D8",
        joinThePartnerClinic: "\u10E8\u10D4\u10E3\u10D4\u10E0\u10D7\u10D3\u10D8\u10D7 \u10DE\u10D0\u10E0\u10E2\u10DC\u10D8\u10DD\u10E0\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D8\u10E1 \u10DE\u10E0\u10DD\u10D2\u10E0\u10D0\u10DB\u10D0\u10E1 \u2014 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 3 \u10D7\u10D5\u10D4 \u10E3\u10E4\u10D0\u10E1\u10DD",
        builtForGeorgianClinics: "\uD83E\uDDB7 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0 \u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1, \u10D0\u10D3\u10D0\u10DB\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10D0\u10E5 \u10EA\u10EE\u10DD\u10D5\u10E0\u10DD\u10D1\u10D4\u10DC",
        prev: "\u2190 \u10EC\u10D8\u10DC\u10D0",
        next2: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u2192",
        getInTouch: "\uD83E\uDDB7 \u10D3\u10D0\u10D2\u10D5\u10D8\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D8\u10D7",
        activePrescriptions: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E0\u10D4\u10EA\u10D4\u10DE\u10E2\u10D4\u10D1\u10D8",
        pastPrescriptions: "\u10EC\u10D0\u10E0\u10E1\u10E3\u10DA\u10D8 \u10E0\u10D4\u10EA\u10D4\u10DE\u10E2\u10D4\u10D1\u10D8",
        prescriptionTemplates: "\u10E0\u10D4\u10EA\u10D4\u10DE\u10E2\u10D8\u10E1 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D4\u10D1\u10D8",
        drugInteractionChecker: "\u10EC\u10D0\u10DB\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E3\u10E0\u10D7\u10D8\u10D4\u10E0\u10D7\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D4\u10DA\u10D8",
        referrals: "\u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10D4\u10D1\u10D8",
        newReferral: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10D8",
        inbound2: "\u10E8\u10D4\u10DB\u10DD\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8",
        outbound2: "\u10D2\u10D0\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8",
        reportsAnalytics: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D0\u10DC\u10D0\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0",
        productionByProvider: "\u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D0 \u10DE\u10E0\u10DD\u10D5\u10D0\u10D8\u10D3\u10D4\u10E0\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7",
        productionByCategory: "\u10EC\u10D0\u10E0\u10DB\u10DD\u10D4\u10D1\u10D0 \u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7",
        preventive2: "\u10DE\u10E0\u10D4\u10D5\u10D4\u10DC\u10EA\u10D8\u10E3\u10DA\u10D8",
        restorative: "\u10E0\u10D4\u10E1\u10E2\u10D0\u10D5\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8",
        endodontics: "\u10D4\u10DC\u10D3\u10DD\u10D3\u10DD\u10DC\u10E2\u10D8\u10D0",
        periodontics: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10D0",
        prosthodontics: "\u10DE\u10E0\u10DD\u10D7\u10D4\u10D6\u10D8\u10E0\u10D4\u10D1\u10D0",
        surgery: "\u10E5\u10D8\u10E0\u10E3\u10E0\u10D2\u10D8\u10D0",
        agingReport: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8",
        appointmentsByDay: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10D3\u10E6\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7",
        monday: "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        tuesday: "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        wednesday: "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        thursday: "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        friday: "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        saturday: "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        topDeclinedTreatments: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10D6\u10D4 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D4\u10D1\u10D8",
        costConcerns: "\u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E8\u10E4\u10DD\u10D7\u10D4\u10D1\u10D0",
        wantsToWait: "\u10E1\u10E3\u10E0\u10E1 \u10DA\u10DD\u10D3\u10D8\u10DC\u10D8",
        orthodontics: "\u10DD\u10E0\u10D7\u10DD\u10D3\u10DD\u10DC\u10E2\u10D8\u10D0",
        insuranceNotCovering: "\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0 \u10D0\u10E0 \u10E4\u10D0\u10E0\u10D0\u10D5\u10E1",
        notAPriority: "\u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8",
        seekingSecondOpinion: "\u10DB\u10D4\u10DD\u10E0\u10D4 \u10D0\u10D6\u10E0\u10D8\u10E1 \u10EB\u10D8\u10D4\u10D1\u10D0",
        u2190: '\u2190',
        u2192: '\u2192',
        allProviders: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10DE\u10E0\u10DD\u10D5\u10D0\u10D8\u10D3\u10D4\u10E0\u10D8",
        hygienistNino: "\u10F0\u10D8\u10D2\u10D8\u10D4\u10DC\u10D8\u10E1\u10E2\u10D8 \u10DC\u10D8\u10DC\u10DD",
        mon17: "\u10DD\u10E0\u10E8 17",
        tue18: "\u10E1\u10D0\u10DB 18",
        wed19: "\u10DD\u10D7\u10EE 19",
        thu20: "\u10EE\u10E3\u10D7 20",
        fri21: "\u10DE\u10D0\u10E0 21",
        crownPrep14: "\u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE #14",
        tKapanadze: "\u10D7. \u10D9\u10D0\u10DE\u10D0\u10DC\u10D0\u10EB\u10D4",
        srpQuad1: "SRP \u10D9\u10D5\u10D0\u10D3\u10E0\u10D0\u10DC\u10E2\u10D8 1",
        dGelashvili: "\u10D3. \u10D2\u10D4\u10DA\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        examXray: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D0 + \u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8",
        mTsiklauri: "\u10DB. \u10EA\u10D8\u10D9\u10DA\u10D0\u10E3\u10E0\u10D8",
        unconfirmed: "\u10D3\u10D0\u10E3\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8",
        rct36: "\u10D0\u10E0\u10EE\u10D8\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0 #36",
        gBeridze: "\u10D2. \u10D1\u10D4\u10E0\u10D8\u10EB\u10D4",
        prophyPolish: "\u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D0\u10E5\u10E2\u10D8\u10D9\u10D0 + \u10DE\u10DD\u10DA\u10D8\u10E0\u10D4\u10D1\u10D0",
        iDiasamidze: "\u10D8. \u10D3\u10D8\u10D0\u10E1\u10D0\u10DB\u10D8\u10EB\u10D4",
        perioMaintenance: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10DD\u10D5\u10DA\u10D0",
        tLomidze: "\u10D7. \u10DA\u10DD\u10DB\u10D8\u10EB\u10D4",
        prophy: "\u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D0\u10E5\u10E2\u10D8\u10D9\u10D0",
        aJavakhishvili: "\u10D0. \u10EF\u10D0\u10D5\u10D0\u10EE\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8",
        inChair: "\u10E1\u10D0\u10D5\u10D0\u10E0\u10EB\u10D4\u10DA\u10E8\u10D8",
        sealantsX4: "\u10E1\u10D8\u10DA\u10D0\u10DC\u10E2\u10D4\u10D1\u10D8 x4",
        nKapanadze: "\u10DC. \u10D9\u10D0\u10DE\u10D0\u10DC\u10D0\u10EB\u10D4",
        lMchedlishvili: "\u10DA. \u10DB\u10ED\u10D4\u10D3\u10DA\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8",
        u2014LunchU2014: "\u2014 \u10E8\u10D4\u10E1\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0 \u2014",
        veneerPrep11: "\u10D5\u10D8\u10DC\u10D8\u10E0\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE #11",
        kGabrichidze: "\u10D9. \u10D2\u10D0\u10D1\u10E0\u10D8\u10E9\u10D8\u10EB\u10D4",
        composite25: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10D8 #25",
        sMeladze: "\u10E1. \u10DB\u10D4\u10DA\u10D0\u10EB\u10D4",
        bridgePrep3436: "\u10EE\u10D8\u10D3\u10D8\u10E1 \u10DE\u10E0\u10D4\u10DE #34-36",
        rKharazishvili: "\u10E0. \u10EE\u10D0\u10E0\u10D0\u10D6\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8",
        composite22: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10D8 #22",
        zDolidze: "\u10D6. \u10D3\u10DD\u10DA\u10D8\u10EB\u10D4",
        noShow: "\u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D0",
        extraction48: "\u10D0\u10DB\u10DD\u10E6\u10D4\u10D1\u10D0 #48",
        vPapunashvili: "\u10D5. \u10DE\u10D0\u10DE\u10E3\u10DC\u10D0\u10E8\u10D5\u10D8\u10DA\u10D8",
        implantConsult: "\u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8\u10E1 \u10D9\u10DD\u10DC\u10E1\u10E3\u10DA\u10E2\u10D0\u10EA\u10D8\u10D0",
        eTsereteli: "\u10D4. \u10EC\u10D4\u10E0\u10D4\u10D7\u10D4\u10DA\u10D8",
        nGogiberidze: "\u10DC. \u10D2\u10DD\u10D2\u10D8\u10D1\u10D4\u10E0\u10D8\u10EB\u10D4",
        crownSeat14: "\u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8\u10E1 \u10D3\u10D0\u10D3\u10D2\u10DB\u10D0 #14",
        checkup: "\u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0",
        bShengelia: "\u10D1. \u10E8\u10D4\u10DC\u10D2\u10D4\u10DA\u10D8\u10D0",
        fluorideTreatment: "\u10E4\u10E2\u10DD\u10E0\u10D8\u10D7 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0",
        emergencyWalkin: "\u10D2\u10D0\u10D3\u10D0\u10E3\u10D3\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        scaling: "\u10E1\u10D9\u10D4\u10D8\u10DA\u10D8\u10DC\u10D2\u10D8",
        wantsMonwedAmSlot: "\u10E1\u10E3\u10E0\u10E1 \u10DD\u10E0\u10E8/\u10DD\u10D7\u10EE \u10D3\u10D8\u10DA\u10D8\u10E1 \u10E1\u10DA\u10DD\u10E2\u10D8 \u2022 \u10D2\u10D0\u10D7\u10D4\u10D7\u10E0\u10D4\u10D1\u10D0",
        assignToSchedule: "\u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10E8\u10D8 \u10DB\u10D8\u10DC\u10D8\u10ED\u10D4\u10D1\u10D0",
        autoAssign: "\u10D0\u10D5\u10E2\u10DD-\u10DB\u10D8\u10DC\u10D8\u10ED\u10D4\u10D1\u10D0",
        high: "\u10DB\u10D0\u10E6\u10D0\u10DA\u10D8",
        anyMorningSlotU2022: "\u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10D3\u10D8\u10DA\u10D8\u10E1 \u10E1\u10DA\u10DD\u10E2\u10D8 \u2022 \u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8",
        medium: "\u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10DD",
        irakliDiasamidze: "\u10D8\u10E0\u10D0\u10D9\u10DA\u10D8 \u10D3\u10D8\u10D0\u10E1\u10D0\u10DB\u10D8\u10EB\u10D4",
        friPmPreferredU2022: "\u10DE\u10D0\u10E0 \u10E8\u10E3\u10D0\u10D3\u10E6\u10D4 \u10E1\u10D0\u10E1\u10E3\u10E0\u10D5\u10D4\u10DA\u10D8\u10D0 \u2022 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0",
        low: "\u10D3\u10D0\u10D1\u10D0\u10DA\u10D8",
        planARecommended: "\u10D2\u10D4\u10D2\u10DB\u10D0 A: \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8",
        planBConservative: "\u10D2\u10D4\u10D2\u10DB\u10D0 B: \u10D9\u10DD\u10DC\u10E1\u10D4\u10E0\u10D5\u10D0\u10E2\u10D8\u10E3\u10DA\u10D8",
        newPlan2: "+ \u10D0\u10EE\u10D0\u10DA\u10D8 \u10D2\u10D4\u10D2\u10DB\u10D0",
        conservativeApproach: "\u10D9\u10DD\u10DC\u10E1\u10D4\u10E0\u10D5\u10D0\u10E2\u10D8\u10E3\u10DA\u10D8 \u10DB\u10D8\u10D3\u10D2\u10DD\u10DB\u10D0",
        thisPlanPrioritizesDisease: "\u10D4\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D0 \u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10E1 \u10D0\u10DC\u10D8\u10ED\u10D4\u10D1\u10E1 \u10D3\u10D0\u10D0\u10D5\u10D0\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D9\u10DD\u10DC\u10E2\u10E0\u10DD\u10DA\u10E1\u10D0 \u10D3\u10D0 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10E1 \u10EB\u10D8\u10E0\u10D8\u10D7\u10D0\u10D3\u10D8 \u10E0\u10D4\u10E1\u10E2\u10D0\u10D5\u10E0\u10D0\u10EA\u10D8\u10E3\u10DA\u10D8 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0\u10DB\u10D3\u10D4. \u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8\u10E1 \u10E9\u10D0\u10D3\u10D2\u10DB\u10D0 \u10D2\u10D0\u10D3\u10D0\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10DD\u10DC\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10EE\u10D4\u10DA\u10D0\u10EE\u10D0\u10DA\u10D8 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8.",
        u00b7: '\u00B7',
        treatmentPlanComparison: "\u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D0\u10E0\u10D4\u10D1\u10D0",
        u00b72: '\u00b7',
        exams2: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D5\u10DA\u10D4\u10D5\u10D4\u10D1\u10D8:",
        metric: "\u10DB\u10D4\u10E2\u10E0\u10D8\u10D9\u10D0",
        pdMm: "PD (\u10DB\u10DB)",
        gmMm: "GM (\u10DB\u10DB)",
        calMm: "CAL (\u10DB\u10DB)",
        suppuration: "\u10E1\u10E3\u10DE\u10E3\u10E0\u10D0\u10EA\u10D8\u10D0",
        furcation: "\u10E4\u10E3\u10E0\u10D9\u10D0\u10EA\u10D8\u10D0",
        mobility: "\u10DB\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0",
        qty: "\u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0",
        refills: "\u10D2\u10D0\u10DC\u10DB\u10D4\u10DD\u10E0\u10D4\u10D1\u10D8\u10D7\u10D8 \u10E8\u10D4\u10D5\u10E1\u10D4\u10D1\u10D0",
        goal: "\u10DB\u10D8\u10D6\u10D0\u10DC\u10D8",
        current2: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4",
        totalDue: "\u10EF\u10D0\u10DB\u10E3\u10E0\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D0",
        scheduled2: "\u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8",
        overdue2: "\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10D3\u10D0\u10EA\u10D8\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8",
        reactivation: "\u10E0\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0",
        chiefComplaint: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8 \u10E9\u10D8\u10D5\u10D8\u10DA\u10D8",
        painScale: "\u10E2\u10D9\u10D8\u10D5\u10D8\u10DA\u10D8\u10E1 \u10E8\u10D9\u10D0\u10DA\u10D0:",
        clinicalFindings: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10E3\u10E0\u10D8 \u10D0\u10E6\u10DB\u10DD\u10E9\u10D4\u10DC\u10D4\u10D1\u10D8",
        diagnosis: "\u10D3\u10D8\u10D0\u10D2\u10DC\u10DD\u10D6\u10D8",
        prescriptions: "\u10E0\u10D4\u10EA\u10D4\u10DE\u10E2\u10D4\u10D1\u10D8",
        u201c: '\u201C',
        xray: "\u10E0\u10D4\u10DC\u10E2\u10D2\u10D4\u10DC\u10D8",
        cleaning: "\u10DE\u10E0\u10DD\u10E4\u10D4\u10E1\u10D8\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EC\u10DB\u10D4\u10DC\u10D3\u10D0",
        // Booking Extended
        bookByClinic: "\u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D8\u10D7 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        bookByDoctor: "\u10D4\u10E5\u10D8\u10DB\u10D8\u10D7 \u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8",
        bookAtClinic: "\u10D3\u10D0\u10EF\u10D0\u10D5\u10E8\u10DC\u10D4\u10D7 \u10D0\u10E5",
        chooseDoctor: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D4\u10E5\u10D8\u10DB\u10D8",
        availableAtClinics: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10D9\u10DA\u10D8\u10DC\u10D8\u10D9\u10D4\u10D1\u10E8\u10D8",
        specialOffer: "\u10E1\u10DE\u10D4\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10D0",
        specialOfferAvailable: "\u10E1\u10DE\u10D4\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10D0 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0",
        viewDetails: "\u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0",
        // Chart & Clinical Extended
        chartLegend: "\u10E9\u10D0\u10E0\u10E2\u10D8\u10E1 \u10DA\u10D4\u10D2\u10D4\u10DC\u10D3\u10D0",
        chairSideMode: "\u10E1\u10D0\u10D5\u10D0\u10E0\u10EB\u10DA\u10D8\u10E1 \u10E0\u10D4\u10DF\u10D8\u10DB\u10D8",
        adminMode: "\u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8\u10E1 \u10E0\u10D4\u10DF\u10D8\u10DB\u10D8",
        braces: "\u10D1\u10E0\u10D4\u10D9\u10D4\u10E2\u10D4\u10D1\u10D8",
        procedureTimeline: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E5\u10E0\u10DD\u10DC\u10DD\u10DA\u10DD\u10D2\u10D8\u10D0",
        proceduresAcrossPhases: "{0} \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D0 {1} \u10E4\u10D0\u10D6\u10D0\u10E8\u10D8",
        untitled: "\u10E3\u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10DD",
        noHistory: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10E9\u10D0\u10EC\u10D4\u10E0\u10D8\u10DA\u10D8",
        // Informed Consent
        informedConsent: "\u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0",
        informedConsentTitle: "\u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10E4\u10DD\u10E0\u10DB\u10D0",
        newConsent: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0",
        consentHistory: "\u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        consentProcedureTitle: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10E1 \u10D0\u10E6\u10EC\u10D4\u10E0\u10D0",
        consentProcedureDesc: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10DB\u10D0 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10DB\u10D0 \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D0\u10EA\u10D8\u10D0 \u10D2\u10D0\u10E3\u10EC\u10D8\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D0\u10E1. \u10D4\u10E1 \u10E1\u10D4\u10E5\u10EA\u10D8\u10D0 \u10D0\u10E6\u10EC\u10D4\u10E0\u10E1 \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D1\u10E3\u10DC\u10D4\u10D1\u10D0\u10E1, \u10DB\u10D8\u10D6\u10D0\u10DC\u10E1 \u10D3\u10D0 \u10DB\u10DD\u10E1\u10D0\u10DA\u10DD\u10D3\u10DC\u10D4\u10DA \u10D4\u10E2\u10D0\u10DE\u10D4\u10D1\u10E1. \u10D2\u10D7\u10EE\u10DD\u10D5\u10D7, \u10E7\u10E3\u10E0\u10D0\u10D3\u10E6\u10D4\u10D1\u10D8\u10D7 \u10EC\u10D0\u10D8\u10D9\u10D8\u10D7\u10EE\u10DD\u10D7 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0\u10DB\u10D3\u10D4.",
        consentRisksTitle: "\u10E0\u10D8\u10E1\u10D9\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10E0\u10D7\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8",
        consentRisksDesc: "\u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10E1\u10D0\u10DB\u10D4\u10D3\u10D8\u10EA\u10D8\u10DC\u10DD \u10D0\u10DC \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0 \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D0\u10E8\u10D8, \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1 \u10DE\u10DD\u10E2\u10D4\u10DC\u10EA\u10D8\u10E3\u10E0\u10D8 \u10E0\u10D8\u10E1\u10D9\u10D4\u10D1\u10D8, \u10DB\u10D0\u10D7 \u10E8\u10DD\u10E0\u10D8\u10E1, \u10DB\u10D0\u10D2\u10E0\u10D0\u10DB \u10D0\u10E0\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3, \u10D8\u10DC\u10E4\u10D4\u10E5\u10EA\u10D8\u10D0, \u10E1\u10D8\u10E1\u10EE\u10DA\u10D3\u10D4\u10DC\u10D0, \u10DC\u10D4\u10E0\u10D5\u10D8\u10E1 \u10D3\u10D0\u10D6\u10D8\u10D0\u10DC\u10D4\u10D1\u10D0, \u10DB\u10D0\u10E1\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D0\u10DC \u10D0\u10DC\u10D4\u10E1\u10D7\u10D4\u10D6\u10D8\u10D8\u10E1 \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7 \u10D0\u10DA\u10D4\u10E0\u10D2\u10D8\u10E3\u10DA\u10D8 \u10E0\u10D4\u10D0\u10E5\u10EA\u10D8\u10D0 \u10D3\u10D0 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E1\u10D0\u10E1\u10E3\u10E0\u10D5\u10D4\u10DA\u10D8 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D8\u10E1 \u10DB\u10D8\u10E3\u10E6\u10EC\u10D4\u10D5\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0.",
        consentAlternativesTitle: "\u10D0\u10DA\u10E2\u10D4\u10E0\u10DC\u10D0\u10E2\u10D8\u10E3\u10DA\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0",
        consentAlternativesDesc: "\u10D0\u10DA\u10E2\u10D4\u10E0\u10DC\u10D0\u10E2\u10D8\u10E3\u10DA\u10D8 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D4\u10D1\u10D8 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10DB\u10DD\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1 \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0\u10D6\u10D4 \u10E3\u10D0\u10E0\u10D8\u10E1 \u10D7\u10E5\u10DB\u10D0\u10E1, \u10D2\u10D0\u10D3\u10D0\u10D3\u10D4\u10D1\u10E3\u10DA \u10DB\u10D9\u10E3\u10E0\u10DC\u10D0\u10DA\u10DD\u10D1\u10D0\u10E1 \u10D0\u10DC \u10E1\u10EE\u10D5\u10D0 \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D4\u10D1\u10E1. \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA \u10D0\u10DA\u10E2\u10D4\u10E0\u10DC\u10D0\u10E2\u10D8\u10D5\u10D0\u10E1 \u10D0\u10E5\u10D5\u10E1 \u10E1\u10D0\u10D9\u10E3\u10D7\u10D0\u10E0\u10D8 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D3\u10D0 \u10E0\u10D8\u10E1\u10D9\u10D4\u10D1\u10D8. \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 \u10D3\u10D4\u10E2\u10D0\u10DA\u10E3\u10E0\u10D0\u10D3 \u10D2\u10D0\u10DC\u10D8\u10EE\u10D8\u10DA\u10DD\u10E1 \u10D4\u10E1 \u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D4\u10D1\u10D8.",
        consentOutcomesTitle: "\u10DB\u10DD\u10E1\u10D0\u10DA\u10DD\u10D3\u10DC\u10D4\u10DA\u10D8 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10D8",
        consentOutcomesDesc: "\u10D0\u10DB \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10E1 \u10DB\u10DD\u10E1\u10D0\u10DA\u10DD\u10D3\u10DC\u10D4\u10DA\u10D8 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D8\u10D0 \u10E1\u10E2\u10DD\u10DB\u10D0\u10E2\u10DD\u10DA\u10DD\u10D2\u10D8\u10E3\u10E0\u10D8 \u10EF\u10D0\u10DC\u10DB\u10E0\u10D7\u10D4\u10DA\u10DD\u10D1\u10D8\u10E1, \u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D8\u10E1 \u10D3\u10D0/\u10D0\u10DC \u10D4\u10E1\u10D7\u10D4\u10E2\u10D8\u10D9\u10D8\u10E1 \u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0. \u10D8\u10DC\u10D3\u10D8\u10D5\u10D8\u10D3\u10E3\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10D8 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D2\u10D0\u10DC\u10E1\u10EE\u10D5\u10D0\u10D5\u10D3\u10D4\u10D1\u10DD\u10D3\u10D4\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D8\u10E1 \u10E1\u10D8\u10E0\u10D7\u10E3\u10DA\u10D8\u10E1, \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8\u10E1 \u10D7\u10D0\u10DC\u10D0\u10DB\u10E8\u10E0\u10DD\u10DB\u10DA\u10DD\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E1\u10EE\u10D5\u10D0 \u10EF\u10D0\u10DC\u10DB\u10E0\u10D7\u10D4\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E4\u10D0\u10E5\u10E2\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7.",
        consentAftercareTitle: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10D8 \u10DB\u10DD\u10D5\u10DA\u10D8\u10E1 \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D4\u10D1\u10D8",
        consentAftercareDesc: "\u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D7\u10E5\u10D5\u10D4\u10DC \u10DB\u10D8\u10D8\u10E6\u10D4\u10D1\u10D7 \u10E1\u10DE\u10D4\u10EA\u10D8\u10E4\u10D8\u10D9\u10E3\u10E0 \u10DB\u10DD\u10D5\u10DA\u10D8\u10E1 \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D4\u10D1\u10E1. \u10D4\u10E1 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10DB\u10DD\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1 \u10D3\u10D8\u10D4\u10E2\u10E3\u10E0 \u10E8\u10D4\u10D6\u10E6\u10E3\u10D3\u10D5\u10D4\u10D1\u10E1, \u10DB\u10D4\u10D3\u10D8\u10D9\u10D0\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10E1, \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D6\u10E6\u10E3\u10D3\u10D5\u10D4\u10D1\u10E1 \u10D3\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D4\u10D1\u10E1. \u10D0\u10DB \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D0 \u10D0\u10E3\u10EA\u10D8\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10DD\u10DE\u10E2\u10D8\u10DB\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E8\u10D4\u10EE\u10DD\u10E0\u10EA\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1.",
        consentAcknowledge: "\u10D5\u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D5\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1",
        consentCheckAllFirst: "\u10D2\u10D7\u10EE\u10DD\u10D5\u10D7, \u10D3\u10D0\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D7 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D6\u10D4\u10DB\u10DD\u10D7 \u10DB\u10DD\u10EA\u10D4\u10DB\u10E3\u10DA\u10D8 \u10E1\u10D4\u10E5\u10EA\u10D8\u10D0 \u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D0\u10DB\u10D3\u10D4",
        // E-Signature
        eSignatureTitle: "\u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D0",
        clearSignature: "\u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0",
        confirmSignature: "\u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0",
        awaitingSignature: "\u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D8\u10E1 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8",
        signatureCapturedAt: "\u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D0 \u10D3\u10D0\u10E4\u10D8\u10E5\u10E1\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0",
        signed: "\u10EE\u10D4\u10DA\u10DB\u10DD\u10EC\u10D4\u10E0\u10D8\u10DA\u10D8",
        amountPaid: "\u10D7\u10D0\u10DC\u10EE\u10D0 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10DA\u10D8",
        annotate: "\u10D0\u10DC\u10DD\u10E2\u10D0\u10EA\u10D8\u10D0",
        anonymousPatient: "Anonymous \u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8",
        autoImport: "Auto \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8",
        away: "\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8",
        bankTransfer: "Bank \u10D2\u10D0\u10D3\u10D0\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0",
        beforeAfter: 'Before After',
        bookPrerequisiteFirst: 'Book Prerequisite First',
        breakdown: "\u10D3\u10D0\u10E8\u10DA\u10D0",
        bridgePrep: 'Bridge Prep',
        brightness: "\u10E1\u10D8\u10D9\u10D0\u10E8\u10D9\u10D0\u10E8\u10D4",
        cabinet: "\u10D9\u10D0\u10D1\u10D8\u10DC\u10D4\u10E2\u10D8",
        cabinet1: "\u10D9\u10D0\u10D1\u10D8\u10DC\u10D4\u10E2\u10D8 1",
        cabinet2: "\u10D9\u10D0\u10D1\u10D8\u10DC\u10D4\u10E2\u10D8 2",
        cabinetSchedule: "\u10D9\u10D0\u10D1\u10D8\u10DC\u10D4\u10E2\u10D8 \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8",
        cabinetScheduleDesc: "\u10D9\u10D0\u10D1\u10D8\u10DC\u10D4\u10E2\u10D8 \u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8 Desc",
        card: "\u10D1\u10D0\u10E0\u10D0\u10D7\u10D8",
        cash: "\u10DC\u10D0\u10E6\u10D3\u10D8",
        cbct: 'Cbct',
        cephalometric: 'Cephalometric',
        channels: 'Channels',
        clinicalQuestion: "Clinical \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0",
        clinicAvgRating: "Clinic Avg \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0",
        collapse: "\u10D0\u10D9\u10D4\u10EA\u10D5\u10D0",
        completedToday: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10E6\u10D4\u10E1",
        compositeF: 'Composite F',
        continueToScheduling: "\u10D2\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10D4\u10D1\u10D0 To Scheduling",
        contrast: "\u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10E1\u10E2\u10D8",
        ctScans: 'Ct Scans',
        customAmount: "\u10E1\u10EE\u10D5\u10D0 \u10D7\u10D0\u10DC\u10EE\u10D0",
        days: "\u10D3\u10E6\u10D4",
        delivered: 'Delivered',
        directMessages: "\u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 Messages",
        disposables: 'Disposables',
        doctorResponse: "\u10D4\u10E5\u10D8\u10DB\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8",
        doctors: 'Doctors',
        documentMgmtSubtitle: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 Mgmt Subtitle",
        documentPreview: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D4\u10D3\u10D5\u10D0",
        download: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0",
        endodontic: "\u10D4\u10DC\u10D3\u10DD\u10D3\u10DD\u10DC\u10E2\u10D8\u10E3\u10E0\u10D8",
        enterAmount: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10D7\u10D0\u10DC\u10EE\u10D0",
        equipmentDevices: "\u10D0\u10E6\u10ED\u10E3\u10E0\u10D5\u10D8\u10DA\u10DD\u10D1\u10D0 Devices",
        estDelivery: "Est \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0",
        examConsult: 'Exam Consult',
        explanationQuality: "\u10D0\u10EE\u10E1\u10DC\u10D0 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8",
        fluorideTx: 'Fluoride Tx',
        fullMouthView: "Full Mouth \u10EE\u10D4\u10D3\u10D8",
        hasBracesQuestion: "Has Braces \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0",
        hasConsultationQuestion: "Has Consultation \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0",
        hasCtScanQuestion: "Has Ct \u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0",
        hasRecentXrayQuestion: "Has \u10D1\u10DD\u10DA\u10DD Xray \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0",
        helpfulQuestion: "\u10E1\u10D0\u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0",
        highest: "\u10E3\u10DB\u10D0\u10E6\u10DA\u10D4\u10E1\u10D8",
        hygiene: "\u10F0\u10D8\u10D2\u10D8\u10D4\u10DC\u10D0",
        imagingType: "\u10D5\u10D8\u10D6\u10E3\u10D0\u10DA\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0 Type",
        implantPlace: "Implant \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D0",
        important: "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D5\u10D0\u10DC\u10D8",
        importLatest: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8 Latest",
        inProgress: "In \u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8",
        installment: "\u10D2\u10D0\u10DC\u10D5\u10D0\u10D3\u10D4\u10D1\u10D0",
        insuranceCoverage: "\u10D3\u10D0\u10D6\u10E6\u10D5\u10D4\u10D5\u10D0 \u10D3\u10D0\u10E4\u10D0\u10E0\u10D5\u10D0",
        interpreted: 'Interpreted',
        inUse: 'In Use',
        invoices: 'Invoices',
        lastCleaningQuestion: "Last Cleaning \u10D9\u10D8\u10D7\u10EE\u10D5\u10D0",
        lateralSkullView: "Lateral Skull \u10EE\u10D4\u10D3\u10D8",
        lowest: "\u10E3\u10D3\u10D0\u10D1\u10DA\u10D4\u10E1\u10D8",
        lowStock: "\u10D3\u10D0\u10D1\u10D0\u10DA\u10D8 \u10DB\u10D0\u10E0\u10D0\u10D2\u10D8",
        lowStockAlerts: "\u10D3\u10D0\u10D1\u10D0\u10DA\u10D8 \u10DB\u10D0\u10E0\u10D0\u10D2\u10D8 \u10D2\u10D0\u10E4\u10E0\u10D7\u10EE\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8",
        maintenance: "\u10DB\u10DD\u10D5\u10DA\u10D0",
        management: "\u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        markComplete: "\u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0 \u10E1\u10E0\u10E3\u10DA\u10D8",
        material: "\u10DB\u10D0\u10E1\u10D0\u10DA\u10D0",
        method: "\u10DB\u10D4\u10D7\u10DD\u10D3\u10D8",
        minOrder: "Min \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D0",
        monthlySpend: "\u10D7\u10D5\u10D8\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E0\u10EF\u10D8",
        newPayment: "New \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0",
        newRadiologyReferral: "New Radiology \u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10D8",
        nextAppointment: "Next \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8",
        noDocumentsFound: 'No Documents Found',
        noNoteSelected: 'No Note Selected',
        normal: "\u10DC\u10DD\u10E0\u10DB\u10D0\u10DA\u10E3\u10E0\u10D8",
        noteInterpreter: 'Note Interpreter',
        occupied: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8",
        online: "\u10DD\u10DC\u10DA\u10D0\u10D8\u10DC",
        orderNow: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D0 Now",
        orders: 'Orders',
        original: 'Original',
        outstanding: "\u10D3\u10D0\u10E0\u10E9\u10D4\u10DC\u10D8\u10DA\u10D8",
        painManagement: "Pain \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0",
        panoramic: "\u10DE\u10D0\u10DC\u10DD\u10E0\u10D0\u10DB\u10E3\u10DA\u10D8",
        patientDue: "\u10DE\u10D0\u10EA\u10D8\u10D4\u10DC\u10E2\u10D8 \u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10EE\u10D3\u10D4\u10DA\u10D8",
        paymentHistory: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0",
        paymentMethod: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0 \u10DB\u10D4\u10D7\u10DD\u10D3\u10D8",
        pendingOrders: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8 Orders",
        periapical: "\u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8",
        perioMaint: 'Perio Maint',
        photos: 'Photos',
        placeOrder: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D0 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D0",
        preCheck: 'Pre Check',
        preCheckPassed: 'Pre Check Passed',
        preCheckSubtitle: 'Pre Check Subtitle',
        preCheckTitle: 'Pre Check Title',
        prerequisiteWarning: 'Prerequisite Warning',
        print: "\u10D1\u10D4\u10ED\u10D3\u10D5\u10D0",
        processing: 'Processing',
        processPayment: "\u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0",
        processPaymentBtn: "\u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0 Btn",
        professionalism: "\u10DE\u10E0\u10DD\u10E4\u10D4\u10E1\u10D8\u10DD\u10DC\u10D0\u10DA\u10D8\u10D6\u10DB\u10D8",
        prophyClean: 'Prophy Clean',
        prosthetic: "\u10DE\u10E0\u10DD\u10D7\u10D4\u10D6\u10D8\u10E0\u10D4\u10D1\u10D0",
        punctuality: "\u10DE\u10E3\u10DC\u10E5\u10E2\u10E3\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D0",
        qtyUsed: 'Qty Used',
        quantity: "\u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0",
        queue: "\u10E0\u10D8\u10D2\u10D8",
        receiptPreview: "\u10E5\u10D5\u10D8\u10D7\u10D0\u10E0\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D4\u10D3\u10D5\u10D0",
        recent: "\u10D1\u10DD\u10DA\u10DD",
        recentMaterialUsage: "\u10D1\u10DD\u10DA\u10DD \u10DB\u10D0\u10E1\u10D0\u10DA\u10D0 Usage",
        recentReceipts: "\u10D1\u10DD\u10DA\u10DD Receipts",
        reliability: "\u10E1\u10D0\u10D8\u10DB\u10D4\u10D3\u10DD\u10DD\u10D1\u10D0",
        remainingBalance: "Remaining \u10D1\u10D0\u10DA\u10D0\u10DC\u10E1\u10D8",
        reorderLevel: 'Reorder Level',
        scanning: 'Scanning',
        sealants: 'Sealants',
        sent: 'Sent',
        singleToothView: "Single Tooth \u10EE\u10D4\u10D3\u10D8",
        slotDetails: 'Slot Details',
        sortBy: "\u10E1\u10DD\u10E0\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0 By",
        srpQuad: 'Srp Quad',
        startImaging: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0 \u10D5\u10D8\u10D6\u10E3\u10D0\u10DA\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0",
        stock: "\u10DB\u10D0\u10E0\u10D0\u10D2\u10D8",
        stockLevel: "\u10DB\u10D0\u10E0\u10D0\u10D2\u10D8 Level",
        submitReferral: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0 \u10E0\u10D4\u10E4\u10D4\u10E0\u10D0\u10DA\u10D8",
        subtotal: "\u10E5\u10D5\u10D4\u10EF\u10D0\u10DB\u10D8",
        suppliers: 'Suppliers',
        surgical: "\u10E5\u10D8\u10E0\u10E3\u10E0\u10D2\u10D8\u10E3\u10DA\u10D8",
        targetArea: 'Target Area',
        teamChat: "\u10D2\u10E3\u10DC\u10D3\u10D8 \u10E9\u10D0\u10E2\u10D8",
        termsNormalized: 'Terms Normalized',
        threeDImaging: "Three D \u10D5\u10D8\u10D6\u10E3\u10D0\u10DA\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0",
        totalItems: 'Total Items',
        totalReceived: 'Total Received',
        typeAMessage: "Type A \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0",
        unavailable: 'Unavailable',
        unit: "\u10D4\u10E0\u10D7\u10D4\u10E3\u10DA\u10D8",
        urgency: 'Urgency',
        urgent: "\u10D2\u10D0\u10D3\u10D0\u10E3\u10D3\u10D4\u10D1\u10D4\u10DA\u10D8",
        usageLog: 'Usage Log',
        veneerPrep: 'Veneer Prep',
        viewOnGoogle: "\u10EE\u10D4\u10D3\u10D8 On Google",
        xrays: 'Xrays'
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        features: "\u0424\u0443\u043D\u043A\u0446\u0438\u0438",
        pricing: "\u0426\u0435\u043D\u044B",
        clinicsNav: "\u041A\u043B\u0438\u043D\u0438\u043A\u0438",
        aiAssistant: "\u0418\u0418 \u0410\u0441\u0441\u0438\u0441\u0442\u0435\u043D\u0442",
        forBusiness: "\u0414\u043B\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430",
        dashboard: "\u041F\u0430\u043D\u0435\u043B\u044C",
        getStarted: "\u041D\u0430\u0447\u0430\u0442\u044C",
        tryDemo: "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0434\u0435\u043C\u043E",
        viewPitch: "\u041F\u0440\u0435\u0437\u0435\u043D\u0442\u0430\u0446\u0438\u044F",
        heroTagline: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0438\u0438",
        heroTitle: "\u0412\u0441\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438",
        heroSubtitle: "\u0412\u0430\u0448 AI-\u0430\u0441\u0441\u0438\u0441\u0442\u0435\u043D\u0442 \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430 \u043B\u0443\u0447\u0448\u0435\u0439 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438 \u0432 \u0413\u0440\u0443\u0437\u0438\u0438",
        searchPlaceholder: "\u041F\u043E\u0438\u0441\u043A \u043A\u043B\u0438\u043D\u0438\u043A, \u0443\u0441\u043B\u0443\u0433 \u0438\u043B\u0438 \u0437\u0430\u0434\u0430\u0439\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441...",
        chipImplant: "\u041B\u0443\u0447\u0448\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438 \u0438\u043C\u043F\u043B\u0430\u043D\u0442\u0430\u0446\u0438\u0438 \u0432 \u0422\u0431\u0438\u043B\u0438\u0441\u0438",
        chipWhitening: "\u041E\u0442\u0431\u0435\u043B\u0438\u0432\u0430\u043D\u0438\u0435 \u0437\u0443\u0431\u043E\u0432 \u0440\u044F\u0434\u043E\u043C",
        chipEmergency: "\u042D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u0430\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C",
        chipOrtho: "\u041E\u0440\u0442\u043E\u0434\u043E\u043D\u0442\u0438\u044F \u0434\u043B\u044F \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0445",
        scrollExplore: "\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430",
        topRated: "\u041B\u0443\u0447\u0448\u0438\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438 \u0422\u0431\u0438\u043B\u0438\u0441\u0438",
        viewAllClinics: "\u0412\u0441\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438",
        shareLocation: "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u043B\u043E\u043A\u0430\u0446\u0438\u0435\u0439 \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        locationShared: "\u041B\u043E\u043A\u0430\u0446\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430 \u2014 \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u043C \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435",
        statClinics: "\u041A\u043B\u0438\u043D\u0438\u043A\u0438",
        statNoShows: "\u041C\u0435\u043D\u044C\u0448\u0435 \u043D\u0435\u044F\u0432\u043E\u043A",
        statBooking: "\u041E\u043D\u043B\u0430\u0439\u043D \u0437\u0430\u043F\u0438\u0441\u044C",
        statDentists: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438",
        statRating: "\u0421\u0440\u0435\u0434\u043D\u0438\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433",
        statPatients: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442\u044B",
        findClinics: "\u041D\u0430\u0439\u0442\u0438 \u043B\u0443\u0447\u0448\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438",
        forBusinessBtn: "\u0414\u043B\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430",
        ownClinic: "\u0423 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043A\u043B\u0438\u043D\u0438\u043A\u0430?",
        claimText: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0432\u043E\u044E \u043A\u043B\u0438\u043D\u0438\u043A\u0443 \u0438\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0435\u0451 \u0432 \u043D\u0430\u0448\u0443 \u0431\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445.",
        getListed: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u2192",
        clinicsTitle: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438 \u0432 \u0413\u0440\u0443\u0437\u0438\u0438",
        verifiedClinics: "\u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043A\u043B\u0438\u043D\u0438\u043A \u0441 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430\u043C\u0438 \u0438 \u043E\u0442\u0437\u044B\u0432\u0430\u043C\u0438",
        searchByName: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E, \u0440\u0430\u0439\u043E\u043D\u0443 \u0438\u043B\u0438 \u0443\u0441\u043B\u0443\u0433\u0435...",
        hideMap: "\u0421\u043A\u0440\u044B\u0442\u044C \u043A\u0430\u0440\u0442\u0443",
        showMap: "\u041A\u0430\u0440\u0442\u0430",
        nearMe: "\u0420\u044F\u0434\u043E\u043C",
        clinicsMatch: "\u043A\u043B\u0438\u043D\u0438\u043A \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442",
        reviews: "\u043E\u0442\u0437\u044B\u0432\u043E\u0432",
        loadingMore: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
        callClinic: "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C",
        bookAppointment: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F",
        services: "\u0423\u0441\u043B\u0443\u0433\u0438",
        workingHours: "\u0427\u0430\u0441\u044B \u0440\u0430\u0431\u043E\u0442\u044B",
        priceRange: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0446\u0435\u043D",
        location: "\u0420\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
        visitWebsite: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442",
        bookingTitle: "\u0417\u0430\u043F\u0438\u0441\u044C \u043D\u0430 \u043F\u0440\u0438\u0451\u043C",
        step: "\u0428\u0430\u0433",
        selectClinic: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0443",
        selectService: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0441\u043B\u0443\u0433\u0443",
        selectDate: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
        selectTime: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F",
        confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
        next: "\u0414\u0430\u043B\u0435\u0435",
        back: "\u041D\u0430\u0437\u0430\u0434",
        clinicsAvailable: "\u043A\u043B\u0438\u043D\u0438\u043A \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        clinicsFound: "\u043A\u043B\u0438\u043D\u0438\u043A \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        confirmBooking: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C",
        bookingConfirmed: "\u0412\u0430\u0448 \u0432\u0438\u0437\u0438\u0442 \u0437\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D!",
        patientName: "\u0418\u043C\u044F \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
        email: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
        notes: "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
        businessHeroBadge: "15+ \u041C\u043E\u0434\u0443\u043B\u0435\u0439  \xb7  212+ \u041A\u043B\u0438\u043D\u0438\u043A  \xb7  Gemini AI",
        businessHeroTitle: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0434\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        businessHeroSubtitle: "\u041A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043A\u0430\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0430\u043D\u0430\u043B\u0438\u0437, \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F, \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435, \u0431\u0438\u043B\u043B\u0438\u043D\u0433, \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u0440\u0435\u0446\u0435\u043F\u0442\u044B, \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0435\u0439 \u0438 \u0418\u0418-\u0434\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 \u2014 \u0432\u0441\u0451 \u0432 \u043E\u0434\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435 \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0438\u0438.",
        theProblem: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
        problemSubtitle: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438 \u0435\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u043E \u0442\u0435\u0440\u044F\u044E\u0442 \u0434\u043E\u0445\u043E\u0434 \u0438\u0437-\u0437\u0430 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        excelChaos: "\u0425\u0430\u043E\u0441 Excel \u0438 WhatsApp",
        excelChaosDetail: "\u041A\u043B\u0438\u043D\u0438\u043A\u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0442 \u0437\u0430\u043F\u0438\u0441\u044F\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0438 \u0447\u0430\u0442\u044B. \u041D\u0443\u043B\u0435\u0432\u0430\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044F, \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u044B\u0435 \u043E\u0448\u0438\u0431\u043A\u0438.",
        noShowRate: "25% \u043D\u0435\u044F\u0432\u043E\u043A",
        noShowDetail: "\u0411\u0435\u0437 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0439 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u044B \u0437\u0430\u0431\u044B\u0432\u0430\u044E\u0442 \u043E \u0432\u0438\u0437\u0438\u0442\u0430\u0445. \u041F\u0443\u0441\u0442\u044B\u0435 \u043A\u0440\u0435\u0441\u043B\u0430 \u2014 \u20BE500+/\u0434\u0435\u043D\u044C \u043F\u043E\u0442\u0435\u0440\u044C.",
        paperCharts: "\u0411\u0443\u043C\u0430\u0436\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B \u0432 2026",
        paperChartsDetail: "\u0420\u0443\u043A\u043E\u043F\u0438\u0441\u043D\u044B\u0435 \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0438, \u0431\u0435\u0437 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0439 \u043E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u044B. \u041A\u0440\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0437\u0430\u043F\u0435\u0440\u0442\u044B \u0432 \u0448\u043A\u0430\u0444\u0430\u0445.",
        insuranceBlackHole: "\u0427\u0451\u0440\u043D\u0430\u044F \u0434\u044B\u0440\u0430 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F",
        insuranceDetail: "\u0420\u0443\u0447\u043D\u044B\u0435 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0438 \u0432 Aldagi, GPI, Imedi L \u0437\u0430\u043D\u0438\u043C\u0430\u044E\u0442 \u0447\u0430\u0441\u044B. \u041E\u0442\u043A\u043B\u043E\u043D\u0451\u043D\u043D\u044B\u0435 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0438 \u043A\u043E\u043F\u044F\u0442\u0441\u044F.",
        oneplatform: "\u041E\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430, \u0432\u0441\u0435 \u043C\u043E\u0434\u0443\u043B\u0438",
        platformSubtitle: "15 \u0438\u043D\u0442\u0435\u0433\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043C\u043E\u0434\u0443\u043B\u0435\u0439 \u0434\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438",
        clinical: "\u041A\u041B\u0418\u041D\u0418\u0427\u0415\u0421\u041A\u0418\u0415",
        operations: "\u041E\u041F\u0415\u0420\u0410\u0426\u0418\u041E\u041D\u041D\u042B\u0415",
        analyticsEnterprise: "\u0410\u041D\u0410\u041B\u0418\u0422\u0418\u041A\u0410 \u0418 ENTERPRISE",
        digitalOdontogram: "\u0426\u0438\u0444\u0440\u043E\u0432\u0430\u044F \u043E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u0430",
        digitalOdontogramDetail: "FDI 32-\u0437\u0443\u0431\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 \u0441 5-\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u044B\u043C \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435\u043C.",
        perioCharting: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043A\u0430\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        perioChartingDetail: "192-\u0442\u043E\u0447\u0435\u0447\u043D\u0430\u044F \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u0435\u0442\u043A\u0430. 6-\u0442\u043E\u0447\u0435\u0447\u043D\u043E\u0435 \u0437\u043E\u043D\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, BOP, CAL.",
        treatmentPlanning: "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        treatmentPlanningDetail: "\u0424\u0430\u0437\u043E\u0432\u044B\u0435 \u043F\u043B\u0430\u043D\u044B \u0441 CDT-\u043A\u043E\u0434\u0430\u043C\u0438, \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u044B\u043C\u0438 \u043E\u0446\u0435\u043D\u043A\u0430\u043C\u0438. \u0418\u0418-\u0441\u0435\u043A\u0432\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435.",
        soapNotes: "SOAP \u0437\u0430\u043F\u0438\u0441\u0438 + \u0418\u0418 \u0441\u043A\u0440\u0430\u0439\u0431",
        soapNotesDetail: "\u0421\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F \u0441 \u0448\u0430\u0431\u043B\u043E\u043D\u0430\u043C\u0438. Gemini \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0443\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0438 \u0438\u0437 \u0433\u043E\u043B\u043E\u0441\u0430.",
        multiChairScheduling: "\u041C\u043D\u043E\u0433\u043E\u043A\u0440\u0435\u0441\u0435\u043B\u044C\u043D\u043E\u0435 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        multiChairDetail: "\u041D\u0435\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u0432\u0438\u0434 \u0441 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u043C\u0438 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0430\u043C\u0438. \u0426\u0432\u0435\u0442\u043E\u0432\u0430\u044F \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u0440\u0430\u0447\u0435\u0439.",
        billingInsurance: "\u0411\u0438\u043B\u043B\u0438\u043D\u0433 \u0438 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435",
        billingDetail: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0439 \u0434\u043B\u044F Aldagi, GPI, Imedi L. \u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u044F, \u043F\u043B\u0430\u043D\u044B \u043E\u043F\u043B\u0430\u0442\u044B.",
        ePrescribing: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u0440\u0435\u0446\u0435\u043F\u0442\u044B",
        ePrescribingDetail: "\u0426\u0438\u0444\u0440\u043E\u0432\u044B\u0435 \u0440\u0435\u0446\u0435\u043F\u0442\u044B \u0441 \u0448\u0430\u0431\u043B\u043E\u043D\u0430\u043C\u0438. \u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u043B\u0435\u043A\u0430\u0440\u0441\u0442\u0432 \u0447\u0435\u0440\u0435\u0437 Gemini.",
        labTracking: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0438",
        labTrackingDetail: "\u041A\u0430\u043D\u0431\u0430\u043D: \u0417\u0430\u043A\u0430\u0437\u0430\u043D\u043E \u2192 \u0418\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u2192 \u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u2192 \u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E.",
        productionReports: "\u041E\u0442\u0447\u0451\u0442\u044B \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0430",
        productionReportsDetail: "\u0412\u0430\u043B\u043E\u0432\u043E\u0435/\u0447\u0438\u0441\u0442\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E, \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u0441\u0431\u043E\u0440\u0430, \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F.",
        referralMgmt: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043C\u0438",
        referralMgmtDetail: "\u0412\u0445\u043E\u0434\u044F\u0449\u0438\u0435/\u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043A \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430\u043C. \u0418\u0418-\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0443\u0435\u043C\u044B\u0435 \u043F\u0438\u0441\u044C\u043C\u0430.",
        medicalHistory: "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0430\u044F \u0438\u0441\u0442\u043E\u0440\u0438\u044F",
        medicalHistoryDetail: "11-\u0432\u0438\u0434\u043E\u0432\u0430\u044F \u043A\u0430\u0440\u0442\u0430 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430: \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u044F, \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F, \u043C\u0435\u0434\u0438\u043A\u0430\u043C\u0435\u043D\u0442\u044B, \u0430\u043B\u043B\u0435\u0440\u0433\u0438\u0438.",
        enterpriseAdmin: "Enterprise \u0430\u0434\u043C\u0438\u043D",
        enterpriseAdminDetail: "RBAC, \u0436\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0430, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435, \u043C\u0443\u043B\u044C\u0442\u0438\u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0441\u0442\u044C, SSO, \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 API.",
        geminiBuiltIn: "\u0412\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0439 Gemini AI",
        geminiSubtitle: "\u041A\u0430\u0436\u0434\u044B\u0439 \u043C\u043E\u0434\u0443\u043B\u044C \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430 Google Gemini 3.1",
        xrayAnalysis: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0440\u0435\u043D\u0442\u0433\u0435\u043D\u0430",
        xrayDetail: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0440\u0435\u043D\u0442\u0433\u0435\u043D\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0434\u043B\u044F \u0418\u0418-\u0434\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0438 \u043A\u0430\u0440\u0438\u0435\u0441\u0430.",
        perioAssessment: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0446\u0435\u043D\u043A\u0430",
        perioAssessmentDetail: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u0442\u0430\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435/\u0433\u0440\u0430\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 AAP \u043F\u043E \u0434\u0430\u043D\u043D\u044B\u043C \u0437\u043E\u043D\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.",
        clinicalScribe: "\u041A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0441\u043A\u0440\u0430\u0439\u0431",
        clinicalScribeDetail: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u044F SOAP-\u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0438\u0437 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0438\u043B\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442\u044B.",
        riskProfiling: "\u041F\u0440\u043E\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0440\u0438\u0441\u043A\u043E\u0432",
        riskProfilingDetail: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0439, \u0441\u0435\u043C\u0435\u0439\u043D\u043E\u0433\u043E \u0430\u043D\u0430\u043C\u043D\u0435\u0437\u0430 \u0434\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0440\u0438\u0441\u043A\u0430.",
        treatmentSequencing: "\u0421\u0435\u043A\u0432\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        treatmentSequencingDetail: "\u0418\u0418-\u043E\u043F\u0442\u0438\u043C\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0444\u0430\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F \u0441 \u0443\u0447\u0451\u0442\u043E\u043C \u0437\u0430\u0436\u0438\u0432\u043B\u0435\u043D\u0438\u044F \u0438 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F.",
        patientComm: "\u041A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u044F \u0441 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u043E\u043C",
        patientCommDetail: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u044F \u043F\u043E\u043D\u044F\u0442\u043D\u044B\u0445 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0439 \u043D\u0430 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u043C \u044F\u0437\u044B\u043A\u0435.",
        georgianEcosystem: "\u0413\u043E\u0442\u043E\u0432\u043E \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u0439 \u044D\u043A\u043E\u0441\u0438\u0441\u0442\u0435\u043C\u044B",
        integrationsSubtitle: "\u041F\u0440\u0435\u0434\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438 \u0441 \u043C\u0435\u0441\u0442\u043D\u044B\u043C \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435\u043C, \u043F\u043B\u0430\u0442\u0435\u0436\u0430\u043C\u0438 \u0438 \u043C\u0435\u0441\u0441\u0435\u043D\u0434\u0436\u0435\u0440\u0430\u043C\u0438",
        insurance: "\u0421\u0422\u0420\u0410\u0425\u041E\u0412\u0410\u041D\u0418\u0415",
        payments: "\u041F\u041B\u0410\u0422\u0415\u0416\u0418",
        messaging: "\u0421\u041E\u041E\u0411\u0429\u0415\u041D\u0418\u042F",
        ehrLabs: "\u042D\u041C\u041A \u0418 \u041B\u0410\u0411\u041E\u0420\u0410\u0422\u041E\u0420\u0418\u0418",
        clinicsInDb: "\u041A\u043B\u0438\u043D\u0438\u043A \u0432 \u0431\u0430\u0437\u0435",
        platformModules: "\u041C\u043E\u0434\u0443\u043B\u0435\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B",
        aiTools: "\u0418\u0418-\u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u043E\u0432 (Gemini)",
        integrations: "\u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0439",
        pricingTitle: "\u0426\u0435\u043D\u044B",
        pricingSubtitle: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E, \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C \u043F\u043E \u043C\u0435\u0440\u0435 \u0440\u043E\u0441\u0442\u0430",
        trustedBy: "\u0414\u043E\u0432\u0435\u0440\u0438\u0435 \u0432\u0435\u0434\u0443\u0449\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        readyModernize: "\u0413\u043E\u0442\u043E\u0432\u044B \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u0448\u0443 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0443?",
        joinCount: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u043A 212+ \u043A\u043B\u0438\u043D\u0438\u043A\u0430\u043C \u0432 \u0413\u0440\u0443\u0437\u0438\u0438.",
        startTrial: "\u041D\u0430\u0447\u0430\u0442\u044C \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E",
        contactSales: "\u0421\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F \u0441 \u043F\u0440\u043E\u0434\u0430\u0436\u0430\u043C\u0438",
        noCreditCard: "\u0411\u0435\u0437 \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B  \xb7  \u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0439 \u0442\u0430\u0440\u0438\u0444  \xb7  \u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0437\u0430 5 \u043C\u0438\u043D\u0443\u0442",
        copyright: "\xa9 2026 MCAI \u2014 \u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u041F\u0430\u043D\u0435\u043B\u044C",
        navPatients: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442\u044B",
        navChart: "\u041A\u0430\u0440\u0442\u0430",
        navPerio: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u044F",
        navTreatmentPlans: "\u041F\u043B\u0430\u043D\u044B \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        navNotes: "\u0417\u0430\u043F\u0438\u0441\u0438",
        navScheduling: "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        navBilling: "\u0411\u0438\u043B\u043B\u0438\u043D\u0433",
        navPrescriptions: "\u0420\u0435\u0446\u0435\u043F\u0442\u044B",
        navLabCases: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u043D\u044B\u0435 \u0441\u043B\u0443\u0447\u0430\u0438",
        navReferrals: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
        navReports: "\u041E\u0442\u0447\u0451\u0442\u044B",
        navMedHistory: "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0430\u044F \u0438\u0441\u0442\u043E\u0440\u0438\u044F",
        navIntegrations: "\u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438",
        navEnterprise: "\u041F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0435",
        sectionClinical: "\u041A\u041B\u0418\u041D\u0418\u041A\u0410",
        sectionOperations: "\u041E\u041F\u0415\u0420\u0410\u0426\u0418\u0418",
        sectionAnalytics: "\u0410\u041D\u0410\u041B\u0418\u0422\u0418\u041A\u0410",
        sectionAiTools: "\u0418\u0418 \u0418\u041D\u0421\u0422\u0420\u0423\u041C\u0415\u041D\u0422\u042B",
        sectionAdmin: "\u0410\u0414\u041C\u0418\u041D\u0418\u0421\u0422\u0420\u0418\u0420\u041E\u0412\u0410\u041D\u0418\u0415",
        // Booking Page
        chooseClinic: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0443",
        selectAService: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0441\u043B\u0443\u0433\u0443",
        pickADate: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
        pickATime: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F",
        confirmYourBooking: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u044C",
        clinicLabel: "\u041A\u043B\u0438\u043D\u0438\u043A\u0430:",
        serviceLabel: "\u0423\u0441\u043B\u0443\u0433\u0430:",
        dateLabel: "\u0414\u0430\u0442\u0430:",
        timeLabel: "\u0412\u0440\u0435\u043C\u044F:",
        // AI Page
        send: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        procedure: "\u041F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430",
        observations: "\u041D\u0430\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F",
        aiThinking: "\u0418\u0418 \u0434\u0443\u043C\u0430\u0435\u0442...",
        summarizeHistory: "\u0420\u0435\u0437\u044E\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        generateTxPlan: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        checkDrugInteractions: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043B\u0435\u043A\u0430\u0440\u0441\u0442\u0432",
        writeClinicalNote: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
        askAiAssistant: "\u0421\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0418\u0418-\u0430\u0441\u0441\u0438\u0441\u0442\u0435\u043D\u0442\u0430...",
        dropXray: "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0440\u0435\u043D\u0442\u0433\u0435\u043D \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438",
        supportsFormats: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044E\u0442\u0441\u044F DICOM, PNG, JPG",
        analysisResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0430\u043D\u0430\u043B\u0438\u0437\u0430 (\u0434\u0435\u043C\u043E)",
        aiRecommendation: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u044F \u0418\u0418",
        exportToTxPlan: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u043F\u043B\u0430\u043D \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        generateClinicalNote: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
        generatedSoap: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C (SOAP)",
        subjective: "S \u2014 \u0421\u0443\u0431\u044A\u0435\u043A\u0442\u0438\u0432\u043D\u043E",
        objective: "O \u2014 \u041E\u0431\u044A\u0435\u043A\u0442\u0438\u0432\u043D\u043E",
        assessment: "A \u2014 \u041E\u0446\u0435\u043D\u043A\u0430",
        plan: "P \u2014 \u041F\u043B\u0430\u043D",
        copyToRecord: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u043A\u0430\u0440\u0442\u0443 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        aiPerioAssessment: "\u0418\u0418 \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0446\u0435\u043D\u043A\u0430",
        enterProbingData: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0437\u043E\u043D\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043B\u044F AAP \u0441\u0442\u0430\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0439 \u043F\u043E \u043B\u0435\u0447\u0435\u043D\u0438\u044E.",
        analyzeWithGemini: "\u0410\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441 Gemini",
        aiRiskAssessment: "\u0418\u0418 \u043E\u0446\u0435\u043D\u043A\u0430 \u0440\u0438\u0441\u043A\u043E\u0432",
        enterConditions: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430, \u0441\u0435\u043C\u0435\u0439\u043D\u044B\u0439 \u0430\u043D\u0430\u043C\u043D\u0435\u0437 \u0438 \u0432\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0438 \u0434\u043B\u044F \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0440\u0438\u0441\u043A\u0430.",
        generateRiskProfile: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0440\u0438\u0441\u043A\u0430",
        patientCommunication: "\u041A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u044F \u0441 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u043E\u043C",
        generateExplanations: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u044F \u043F\u043E\u043D\u044F\u0442\u043D\u044B\u0445 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0439 \u043B\u0435\u0447\u0435\u043D\u0438\u044F \u043D\u0430 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u043C \u0438\u043B\u0438 \u0430\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u043E\u043C.",
        generateExplanation: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0435",
        patientFriendly: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E\u0435 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0435",
        // Billing Page
        claims: "\u041F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0438",
        ledger: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u043A\u0430\u044F \u043A\u043D\u0438\u0433\u0430",
        aging: "\u0421\u0442\u0430\u0440\u0435\u043D\u0438\u0435 \u0437\u0430\u0434\u043E\u043B\u0436\u0435\u043D\u043D\u043E\u0441\u0442\u0438",
        paymentPlans: "\u041F\u043B\u0430\u043D\u044B \u043E\u043F\u043B\u0430\u0442\u044B",
        eligibility: "\u041F\u0440\u0430\u0432\u043E \u043D\u0430 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435",
        allFilter: "\u0412\u0441\u0435",
        submitted: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        denied: "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E",
        patientLedger: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u044F \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        agedAccounts: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043D\u044B\u0435 \u0441\u0447\u0435\u0442\u0430",
        sendStatements: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0432\u044B\u043F\u0438\u0441\u043A\u0438",
        activePaymentPlans: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u043D\u044B \u043E\u043F\u043B\u0430\u0442\u044B",
        insuranceEligibility: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u043E\u0435 \u043F\u0440\u0430\u0432\u043E",
        // Clinical Charting
        odontogram: "\u041E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u0430",
        perioTab: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u044F",
        treatmentPlanTab: "\u041F\u043B\u0430\u043D \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        notesTab: "\u0417\u0430\u043F\u0438\u0441\u0438",
        progressNotes: "\u0417\u0430\u043F\u0438\u0441\u0438 \u043E \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0435",
        openFullPerio: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u043B\u043D\u0443\u044E \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043A\u0430\u0440\u0442\u0443 \u2192",
        openFullTxPlanner: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u043B\u0435\u0447\u0435\u043D\u0438\u044F \u2192",
        openClinicalNotes: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0438 \u2192",
        newExam: "\u041D\u043E\u0432\u044B\u0439 \u043E\u0441\u043C\u043E\u0442\u0440",
        voiceEntry: "\u0413\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u0432\u0432\u043E\u0434",
        bleedingIndex: "\u0418\u043D\u0434\u0435\u043A\u0441 \u043A\u0440\u043E\u0432\u043E\u0442\u043E\u0447\u0438\u0432\u043E\u0441\u0442\u0438",
        plaqueIndex: "\u0418\u043D\u0434\u0435\u043A\u0441 \u043D\u0430\u043B\u0451\u0442\u0430",
        sitesAbove4: "\u0423\u0447\u0430\u0441\u0442\u043A\u0438 \u2265 4\u043C\u043C",
        sitesAbove6: "\u0423\u0447\u0430\u0441\u0442\u043A\u0438 \u2265 6\u043C\u043C",
        planA: "\u041F\u043B\u0430\u043D A: \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C\u044B\u0439",
        planB: "\u041F\u043B\u0430\u043D B: \u041A\u043E\u043D\u0441\u0435\u0440\u0432\u0430\u0442\u0438\u0432\u043D\u044B\u0439",
        newPlan: "+ \u041D\u043E\u0432\u044B\u0439 \u043F\u043B\u0430\u043D",
        presentToPatient: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443",
        sendToPortal: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u043F\u043E\u0440\u0442\u0430\u043B",
        totalFee: "\u041E\u0431\u0449\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C",
        insuranceEst: "\u041E\u0446\u0435\u043D\u043A\u0430 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u043A\u0438",
        patientPortion: "\u0414\u043E\u043B\u044F \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        chairSideMode: "\u0420\u0435\u0436\u0438\u043C \u0443 \u043A\u0440\u0435\u0441\u043B\u0430",
        adminMode: "\u0420\u0435\u0436\u0438\u043C \u0430\u0434\u043C\u0438\u043D\u0430",
        proceduresAcrossPhases: "{0} \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440 \u0432 {1} \u0444\u0430\u0437\u0430\u0445",
        // Scheduling
        day: "\u0414\u0435\u043D\u044C",
        week: "\u041D\u0435\u0434\u0435\u043B\u044F",
        today: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
        providerFilter: "\u0412\u0441\u0435 \u0432\u0440\u0430\u0447\u0438",
        productionGoal: "\u0426\u0435\u043B\u044C \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0430",
        waitlist: "\u041B\u0438\u0441\u0442 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F",
        // Prescriptions
        activeRx: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435",
        pastRx: "\u041F\u0440\u043E\u0448\u043B\u044B\u0435",
        templates: "\u0428\u0430\u0431\u043B\u043E\u043D\u044B",
        interactionCheck: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439",
        // Lab Cases
        ordered: "\u0417\u0430\u043A\u0430\u0437\u0430\u043D\u043E",
        sentToLab: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044E",
        inFabrication: "\u0412 \u0438\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0438",
        shipped: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        received: "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E",
        labVendors: "\u041F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0438 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0439",
        // Referrals
        allDirections: "\u0412\u0441\u0435",
        inbound: "\u0412\u0445\u043E\u0434\u044F\u0449\u0438\u0435",
        outbound: "\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435",
        generateLetter: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E",
        // Reports
        production: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
        collections: "\u0421\u0431\u043E\u0440\u044B",
        schedulingReport: "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        treatmentAcceptance: "\u041F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        recall: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0439 \u0432\u044B\u0437\u043E\u0432",
        grossProduction: "\u0412\u0430\u043B\u043E\u0432\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
        netProduction: "\u0427\u0438\u0441\u0442\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
        collectionRate: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0441\u0431\u043E\u0440\u0430",
        plansPresented: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u043F\u043B\u0430\u043D\u043E\u0432",
        accepted: "\u041F\u0440\u0438\u043D\u044F\u0442\u043E",
        acceptanceRate: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F",
        dueThisMonth: "\u0417\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u043D\u0430 \u044D\u0442\u043E\u0442 \u043C\u0435\u0441\u044F\u0446",
        scheduled: "\u0417\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
        completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        overdue: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043E",
        reactivationRate: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0440\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438",
        // Medical History
        timeline: "\u0425\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u044F",
        conditions: "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F",
        medications: "\u041C\u0435\u0434\u0438\u043A\u0430\u043C\u0435\u043D\u0442\u044B",
        allergies: "\u0410\u043B\u043B\u0435\u0440\u0433\u0438\u0438",
        labResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0430\u043D\u0430\u043B\u0438\u0437\u043E\u0432",
        vitals: "\u0412\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0438",
        immunizations: "\u0418\u043C\u043C\u0443\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
        familyHistory: "\u0421\u0435\u043C\u0435\u0439\u043D\u044B\u0439 \u0430\u043D\u0430\u043C\u043D\u0435\u0437",
        imaging: "\u0412\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F",
        documents: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u0416\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0430",
        compliance: "\u0421\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435",
        multiTenancy: "\u041C\u0443\u043B\u044C\u0442\u0438\u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0441\u0442\u044C",
        sso: "SSO \u0438 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
        featureFlags: "\u0424\u043B\u0430\u0433\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0439",
        apiManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 API",
        dataManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u043C\u0438",
        // Integrations
        ehr: "\u042D\u041C\u041A",
        labs: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0438",
        telehealth: "\u0422\u0435\u043B\u0435\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0430",
        aiMl: "\u0418\u0418/\u041C\u041E",
        wearables: "\u041D\u043E\u0441\u0438\u043C\u044B\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430",
        connected: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        disconnected: "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        // Components
        status: "\u0421\u0442\u0430\u0442\u0443\u0441",
        healthy: "\u0417\u0434\u043E\u0440\u043E\u0432\u044B\u0439",
        caries: "\u041A\u0430\u0440\u0438\u0435\u0441",
        restored: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D",
        missing: "\u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442",
        implant: "\u0418\u043C\u043F\u043B\u0430\u043D\u0442",
        crownStatus: "\u041A\u043E\u0440\u043E\u043D\u043A\u0430",
        bridge: "\u041C\u043E\u0441\u0442",
        veneer: "\u0412\u0438\u043D\u0438\u0440",
        surfaces: "\u041F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438",
        procedureHistory: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440",
        addProcedure: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443",
        totalCharged: "\u0412\u0441\u0435\u0433\u043E \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E",
        insurancePayment: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u043E\u0439 \u043F\u043B\u0430\u0442\u0451\u0436",
        patientResponsibility: "\u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        expand: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
        policyNumber: "\u041F\u043E\u043B\u0438\u0441 \u2116",
        planType: "\u0422\u0438\u043F \u043F\u043B\u0430\u043D\u0430",
        annualMax: "\u0413\u043E\u0434\u043E\u0432\u043E\u0439 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C",
        used: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u043E",
        remaining: "\u041E\u0441\u0442\u0430\u0442\u043E\u043A",
        coverageByCategory: "\u041F\u043E\u043A\u0440\u044B\u0442\u0438\u0435 \u043F\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043C",
        preventive: "\u041F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u043A\u0430",
        basic: "\u0411\u0430\u0437\u043E\u0432\u043E\u0435",
        major: "\u041E\u0441\u043D\u043E\u0432\u043D\u043E\u0435",
        ortho: "\u041E\u0440\u0442\u043E\u0434\u043E\u043D\u0442\u0438\u044F",
        current: "\u0422\u0435\u043A\u0443\u0449\u0438\u0435",
        thirtyDay: "30 \u0434\u043D\u0435\u0439",
        sixtyDay: "60 \u0434\u043D\u0435\u0439",
        ninetyPlus: "90+ \u0434\u043D\u0435\u0439",
        totalBalance: "\u041E\u0431\u0449\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441",
        monthlyPayment: "\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u0451\u0436",
        paymentsRemaining: "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439",
        nextPayment: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043F\u043B\u0430\u0442\u0451\u0436",
        paymentProgress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441 \u043E\u043F\u043B\u0430\u0442\u044B",
        choosePlan: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u043B\u0430\u043D",
        aiInsight: "\u0418\u0418 \u0438\u043D\u0441\u0430\u0439\u0442",
        confidence: "\u0423\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C",
        revoke: "\u041E\u0442\u043E\u0437\u0432\u0430\u0442\u044C",
        exams: "\u041E\u0441\u043C\u043E\u0442\u0440\u044B",
        phaseTotal: "\u0418\u0442\u043E\u0433\u043E \u043F\u043E \u0444\u0430\u0437\u0435",
        mon: "\u041F\u043D",
        tue: "\u0412\u0442",
        wed: "\u0421\u0440",
        thu: "\u0427\u0442",
        fri: "\u041F\u0442",
        sat: "\u0421\u0431",
        sun: "\u0412\u0441",
        thinking: "\u0414\u0443\u043C\u0430\u044E...",
        followUpPlaceholder: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0432\u043E\u043F\u0440\u043E\u0441...",
        priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
        patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
        tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
        chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
        english: 'English',
        patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
        xrayAnalysis2: 'X-ray Analysis',
        uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment2: 'Perio Assessment',
        automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe2: "\u041A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 Scribe",
        generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling2: 'Risk Profiling',
        analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing2: "\u041B\u0435\u0447\u0435\u043D\u0438\u0435 Sequencing",
        aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientCommunication2: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442 Communication",
        generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        insurance2: 'INSURANCE',
        automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
        payments2: 'PAYMENTS',
        onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
        messaging2: 'MESSAGING',
        appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
        ehrLabs2: 'EHR & LABS',
        interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
        clinicsInDatabase: 'Clinics in Database',
        platformModules2: 'Platform Modules',
        integrations2: 'Integrations',
        home2: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        features2: 'Features',
        pricing2: 'Pricing',
        dashboard2: "\u041F\u0430\u043D\u0435\u043B\u044C",
        u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
        openFullPeriodontalChart: "Open Full Periodontal Chart \u2192",
        openFullTreatmentPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes2: "Open Clinical Notes \u2192",
        backToAllClinics: "\u2190 Back to all clinics",
        priceRange2: 'Price range:',
        bookAnAppointment: 'Book an Appointment',
        selectDate2: 'Select date',
        selectTime2: 'Select time',
        confirmBooking2: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C Booking \u2192",
        clinics: 'Clinics',
        forBusiness2: 'For Business',
        u00a92026Mcai: '\u00A9 2026 MCAI',
        clinicalNotes: "\u041A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 Notes",
        newNote: "+ \u041D\u043E\u0432\u044B\u0439 Note",
        template: 'Template:',
        crownPrep: 'Crown Prep',
        aiScribe: 'AI Scribe',
        recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
        startRecording: 'Start Recording',
        generateNote: 'Generate Note',
        general: 'General',
        prosthetics: 'Prosthetics',
        typeToSearch: 'Type to search dental terms...',
        revenueToday: "\u0412\u044B\u0440\u0443\u0447\u043A\u0430 \u0421\u0435\u0433\u043E\u0434\u043D\u044F",
        noshows: 'No-shows',
        confirmed: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D",
        time: 'TIME',
        patient: 'PATIENT',
        service: 'SERVICE',
        doctor: 'DOCTOR',
        status2: 'STATUS',
        addPatient: "+ Add \u041F\u0430\u0446\u0438\u0435\u043D\u0442",
        mondayMarch19: 'Monday, March 19',
        gBeridzeCheckup: "G. Beridze \u2014 Checkup",
        nKapanadzeWhitening: "N. Kapanadze \u2014 Whitening",
        dGelashviliImplantPhase: "D. Gelashvili \u2014 Implant Phase 2",
        lunchBreak: "\u2014 Lunch Break \u2014",
        mTsiklauriOrthodontics: "M. Tsiklauri \u2014 Orthodontics",
        aJavakhishviliRootCanal: "A. Javakhishvili \u2014 Root Canal",
        lMchedlishviliExtraction: "L. Mchedlishvili \u2014 Extraction",
        tLomidzeCheckup: "T. Lomidze \u2014 Checkup",
        clinicName: "\u041A\u043B\u0438\u043D\u0438\u043A\u0430 Name",
        phone: 'Phone',
        address: 'Address',
        acceptedInsurance: "Accepted \u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435",
        unison: 'Unison',
        saveSettings: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
        openTheFullAi: "Open the full AI Assistant \u2192",
        enterprise: 'Enterprise',
        rolebasedAccessControl: 'Role-Based Access Control',
        permissionMatrix: 'Permission Matrix',
        module: 'Module',
        admin: 'Admin',
        doctor2: "\u0414\u043E\u043A\u0442\u043E\u0440",
        hygienist: 'Hygienist',
        reception: 'Reception',
        lab: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044F",
        patient2: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442",
        patients: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442\u044B",
        full: 'Full',
        read: 'Read',
        none: 'None',
        own: 'Own',
        billing: 'Billing',
        scheduling: 'Scheduling',
        reports: 'Reports',
        settings: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        labOrders: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044F Orders",
        auditLog2: 'Audit Log',
        allTypes: "\u0412\u0441\u0435 Types",
        last7Days: 'Last 7 days',
        complianceDashboard: "Compliance \u041F\u0430\u043D\u0435\u043B\u044C",
        complianceChecklist: 'Compliance Checklist',
        pass: 'PASS',
        dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
        dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
        mfaEnabledForAll: 'MFA enabled for all admin accounts',
        warn: 'WARN',
        dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
        auditLoggingActiveOn: 'Audit logging active on all modules',
        multitenancyManagement: 'Multi-Tenancy Management',
        singleSignonSso: 'Single Sign-On (SSO)',
        saml20: 'SAML 2.0',
        enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
        configured: 'Configured',
        openidConnect: 'OpenID Connect',
        oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
        available2: "\u0414\u043E\u0441\u0442\u0443\u043F\u0435\u043D",
        signInWithGoogle: 'Sign in with Google organization accounts',
        connected2: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0451\u043D",
        azureAd: 'Azure AD',
        microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
        featureFlags2: 'Feature Flags',
        aixrayanalysis: 'ai_xray_analysis',
        aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
        voiceperio: 'voice_perio',
        voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
        patientportalv2: 'patient_portal_v2',
        nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
        whatsappreminders: 'whatsapp_reminders',
        multilanguage: 'multi_language',
        multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
        apiManagement2: 'API Management',
        requests24h: 'Requests (24h)',
        avgLatency: 'Avg Latency',
        uptime: 'Uptime',
        apiKeys: 'API Keys',
        dataManagement2: 'Data Management',
        storageUsed: 'Storage Used',
        of100Gb: 'of 100 GB',
        totalRecords: "\u0418\u0442\u043E\u0433\u043E Records",
        lastBackup: 'Last Backup',
        nextIn4h: 'Next: in 4h',
        dataOperations: 'Data Operations',
        exportAllData: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0412\u0441\u0435 Data",
        downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
        export: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442",
        purgeOldRecords: 'Purge Old Records',
        removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
        purge: 'Purge',
        dataMigration: 'Data Migration',
        importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
        import: "\u0418\u043C\u043F\u043E\u0440\u0442",
        finance: 'Finance',
        revenueInvoicesPayments: 'Revenue, invoices & payments',
        exportReport: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u041E\u0442\u0447\u0451\u0442",
        monthlyRevenue: "Monthly \u0412\u044B\u0440\u0443\u0447\u043A\u0430",
        u20be12400: '\u20BE12,400',
        pending: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435",
        u20be2100: '\u20BE2,100',
        str208: '-5%',
        thisWeek: 'This Week',
        u20be3800: '\u20BE3,800',
        weeklyRevenue: "Weekly \u0412\u044B\u0440\u0443\u0447\u043A\u0430",
        mon2: 'Mon',
        tue2: 'Tue',
        wed2: 'Wed',
        thu2: 'Thu',
        fri2: 'Fri',
        sat2: 'Sat',
        invoice: 'INVOICE',
        amount: 'AMOUNT',
        inv001: 'INV-001',
        giorgiBeridze: 'Giorgi Beridze',
        checkupXray: 'Checkup + X-ray',
        u20be80: '\u20BE80',
        inv002: 'INV-002',
        ninoKapanadze: 'Nino Kapanadze',
        whitening: 'Whitening',
        u20be120: '\u20BE120',
        inv003: 'INV-003',
        davitGelashvili: 'Davit Gelashvili',
        implantPhase1: 'Implant Phase 1',
        u20be300: '\u20BE300+',
        inv004: 'INV-004',
        anaJavakhishvili: 'Ana Javakhishvili',
        rootCanal: 'Root Canal',
        u20be149: '\u20BE149',
        u2715: '\u2715',
        configuration: 'Configuration',
        apiKey: 'API Key',
        endpointUrl: 'Endpoint URL',
        protocol: 'Protocol',
        syncSettings: "Sync \u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        syncFrequency: 'Sync Frequency',
        every5Minutes: 'Every 5 minutes',
        every15Minutes: 'Every 15 minutes',
        everyHour: 'Every hour',
        manualOnly: 'Manual only',
        autosyncOnChanges: 'Auto-sync on changes',
        lastSynced: 'Last synced',
        disconnect: 'Disconnect',
        testConnection: 'Test Connection',
        labCasePipeline: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044F Case Pipeline",
        labVendors2: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044F Vendors",
        tbilisidentLab: "TbilisiDent \u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044F",
        turnaround710Days: 'Turnaround: 7-10 days',
        rating485: 'Rating: 4.8/5',
        activeCases4: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0439 Cases: 4",
        caucasusDentalLab: "Caucasus Dental \u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044F",
        turnaround57Days: 'Turnaround: 5-7 days',
        rating465: 'Rating: 4.6/5',
        activeCases2: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0439 Cases: 2",
        euroDentalGeorgia: 'Euro Dental Georgia',
        turnaround1014Days: 'Turnaround: 10-14 days',
        rating445: 'Rating: 4.4/5',
        enterSpaceForClinics: "Enter space for clinics \u2192",
        book: 'Book',
        followupConsultation: 'Follow-up Consultation',
        postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
        rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
        completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
        periapicalXray: 'Periapical X-ray',
        workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
        medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
        prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
        diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
        patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
        compositeFillingTooth21: 'Composite Filling - Tooth #21',
        classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
        labResultsCbcPanel: 'Lab Results: CBC Panel',
        completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
        fullmouthRadiographs: 'Full-mouth Radiographs',
        panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
        comprehensiveExamination: 'Comprehensive Examination',
        initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
        medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
        patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
        patientRegistration: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442 Registration",
        newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
        activeConditions: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0439 Conditions",
        chronicPeriodontitis: 'Chronic Periodontitis',
        active: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0439",
        generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
        onsetJan2026: 'Onset: Jan 2026',
        dentalCaries: 'Dental Caries',
        resolved: 'Resolved',
        cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
        resolvedFeb2026: 'Resolved: Feb 2026',
        bruxism: 'Bruxism',
        nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
        activeMedications: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0439 Medications",
        lisinopril10mg: 'Lisinopril 10mg',
        onceDailyOral: 'Once daily, oral',
        hypertensionManagement: 'Hypertension management',
        chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
        twiceDailyOralRinse: 'Twice daily, oral rinse',
        periodontalMaintenance: 'Periodontal maintenance',
        ibuprofen400mg: 'Ibuprofen 400mg',
        asNeededForPain: 'As needed for pain, max 3x daily',
        postprocedurePainManagement: 'Post-procedure pain management',
        pastMedications: 'Past Medications',
        amoxicillin500mg: 'Amoxicillin 500mg',
        periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
        completed2: "\u0417\u0430\u0432\u0435\u0440\u0448\u0451\u043D",
        metronidazole250mg: 'Metronidazole 250mg',
        adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
        paracetamol500mg: 'Paracetamol 500mg',
        asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
        postfillingSensitivity: 'Post-filling sensitivity',
        diclofenac50mg: 'Diclofenac 50mg',
        twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
        postexamSoreness: 'Post-exam soreness',
        documentedAllergies: 'Documented Allergies',
        penicillin: 'Penicillin',
        severe: 'SEVERE',
        reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
        crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
        documentedJan102026: 'Documented: Jan 10, 2026',
        latex: 'Latex',
        moderate: 'MODERATE',
        reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
        useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
        lidocaine: 'Lidocaine',
        mild: 'MILD',
        reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
        useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
        latestVitalsMar15: "Latest Vitals \u2014 Mar 15, 2026",
        labResults2: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044F Results",
        test: 'TEST',
        result: 'RESULT',
        reference: 'REFERENCE',
        date: 'DATE',
        hemoglobin: 'Hemoglobin',
        platelets: 'Platelets',
        glucoseFasting: 'Glucose (fasting)',
        immunizationRecords: 'Immunization Records',
        hepatitisB: 'Hepatitis B',
        completed3doseSeries2019: 'Completed: 3-dose series, 2019',
        upToDate: 'Up to date',
        tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
        lastBooster2022: 'Last booster: 2022',
        covid19: 'COVID-19',
        lastDoseSep2024: 'Last dose: Sep 2024',
        dueForBooster: 'Due for booster',
        familyMedicalHistory: 'Family Medical History',
        father: 'Father',
        hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
        mother: 'Mother',
        osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
        sibling: 'Sibling',
        bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
        imagingRecords: 'Imaging Records',
        panoramicOpg: 'Panoramic OPG',
        periapical14: 'Periapical #14',
        bitewingRl: 'Bitewing R+L',
        patientDocuments: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442 Documents",
        consentFormRootCanal: 'Consent Form - Root Canal',
        treatmentPlanAgreement: "\u041B\u0435\u0447\u0435\u043D\u0438\u0435 Plan Agreement",
        medicalHistoryQuestionnaire: 'Medical History Questionnaire',
        insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
        insuranceInformation: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435 Information",
        provider: 'Provider:',
        policy: 'Policy #:',
        group: 'Group:',
        corporatePlanPremium: 'Corporate Plan - Premium',
        coverage: 'Coverage:',
        deductible: 'Deductible:',
        annualMax2: 'Annual Max:',
        valid: 'Valid:',
        age34: 'Age: 34',
        lastVisitMar10: 'Last visit: Mar 10',
        nextMar19: 'Next: Mar 19',
        overview: 'Overview',
        dentalChart: 'Dental Chart',
        treatmentPlan: "\u041B\u0435\u0447\u0435\u043D\u0438\u0435 Plan",
        history: 'History',
        documents2: 'Documents',
        allergies2: 'Allergies',
        medicalNotes: 'Medical Notes',
        insurance3: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435",
        upperArch: 'Upper Arch',
        lowerArch: 'Lower Arch',
        tooth: 'TOOTH',
        procedure2: 'PROCEDURE',
        price: 'PRICE',
        rootCanalTreatment: "Root Canal \u041B\u0435\u0447\u0435\u043D\u0438\u0435",
        ceramicCrown: 'Ceramic Crown',
        compositeFilling: 'Composite Filling',
        implantPlacement: 'Implant Placement',
        total: "\u0418\u0442\u043E\u0433\u043E",
        addProcedure2: "+ Add \u041F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430",
        march102026: 'March 10, 2026',
        periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
        february152026: 'February 15, 2026',
        compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
        january202026: 'January 20, 2026',
        comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
        bitewingRight: 'Bitewing Right',
        bitewingLeft: 'Bitewing Left',
        uploadDocument: "+ \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C Document",
        all: "\u0412\u0441\u0435",
        new: "\u041D\u043E\u0432\u044B\u0439",
        phone2: 'PHONE',
        lastVisit: 'LAST VISIT',
        nextAppt: 'NEXT APPT',
        balance: 'BALANCE',
        pt001: 'PT-001',
        pt002: 'PT-002',
        pt003: 'PT-003',
        mariamTsiklauri: 'Mariam Tsiklauri',
        pt004: 'PT-004',
        pt005: 'PT-005',
        lukaMchedlishvili: 'Luka Mchedlishvili',
        pt006: 'PT-006',
        tamtaLomidze: 'Tamta Lomidze',
        pt007: 'PT-007',
        periodontalChart: 'Periodontal Chart',
        newExam2: "+ \u041D\u043E\u0432\u044B\u0439 Exam",
        voiceEntry2: 'Voice Entry',
        dcai: 'DCAI',
        dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
        theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
        manage: 'Manage',
        grow: 'Grow',
        marketSize: 'Market Size',
        dentalClinicsInGeorgia: 'dental clinics in Georgia',
        inTbilisiAlone: 'in Tbilisi alone',
        unifiedBookingOrOps: 'unified booking or ops platforms',
        dentosgeIsTheOnly: "\u26A0\uFE0F  dentos.ge is the only partial incumbent \u2014 no full ops layer",
        theProblem2: 'The Problem',
        str511: "\uD83D\uDCCB",
        clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
        noStructuredWorkflowConstant: 'No structured workflow, constant human error',
        str514: "\uD83D\uDCC9",
        noshowsCost1525Of: "No-shows cost 15\u201325% of revenue",
        noAutomatedRemindersOr: 'No automated reminders or confirmation system',
        str517: "\uD83C\uDFE6",
        insuranceBillingIsManual: 'Insurance billing is manual and painful',
        str519: "\uD83D\uDCF5",
        dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
        theSolution: 'The Solution',
        str523: "\uD83D\uDCC5",
        onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
        patientsBook247From: 'Patients book 24/7 from any device',
        str526: "\uD83E\uDDB7",
        patientRecordsTreatmentManagem: 'Patient records & treatment management',
        fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
        str529: "\uD83C\uDFE5",
        insuranceIntegrations: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435 integrations",
        str531: "\uD83D\uDCAC",
        smsWhatsappReminders: 'SMS / WhatsApp reminders',
        cutNoshowsByUp: 'Cut no-shows by up to 40%',
        str534: "\uD83D\uDCCA",
        financialReportingDashboard: 'Financial reporting dashboard',
        revenueSalariesExpensesRealtim: "Revenue, salaries, expenses \u2014 realtime",
        willingnessToPay: 'Willingness to Pay',
        free: 'Free',
        month: '/month',
        listingBookingWidget: 'Listing + booking widget',
        growth: 'Growth',
        calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
        pro: 'Pro',
        fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
        multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
        wtp0515OfMonthly: "\uD83D\uDCA1 WTP: 0.5\u20131.5% of monthly revenue \u2014 clinics earning \u20BE15K\u201350K/mo pay \u20BE100\u2013350/mo comfortably",
        marketOpportunity: 'Market Opportunity',
        addressableClinicsAtLaunch: 'addressable clinics at launch',
        mrrAtFullPenetration: "MRR at full penetration (\u20BE49 avg)",
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        features: "\u0424\u0443\u043D\u043A\u0446\u0438\u0438",
        pricing: "\u0426\u0435\u043D\u044B",
        clinicsNav: "\u041A\u043B\u0438\u043D\u0438\u043A\u0438",
        aiAssistant: "\u0418\u0418 \u0410\u0441\u0441\u0438\u0441\u0442\u0435\u043D\u0442",
        forBusiness: "\u0414\u043B\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430",
        dashboard: "\u041F\u0430\u043D\u0435\u043B\u044C",
        getStarted: "\u041D\u0430\u0447\u0430\u0442\u044C",
        tryDemo: "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0434\u0435\u043C\u043E",
        viewPitch: "\u041F\u0440\u0435\u0437\u0435\u043D\u0442\u0430\u0446\u0438\u044F",
        heroTagline: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0438\u0438",
        heroTitle: "\u0412\u0441\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438",
        heroSubtitle: "\u0412\u0430\u0448 AI-\u0430\u0441\u0441\u0438\u0441\u0442\u0435\u043D\u0442 \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430 \u043B\u0443\u0447\u0448\u0435\u0439 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438 \u0432 \u0413\u0440\u0443\u0437\u0438\u0438",
        searchPlaceholder: "\u041F\u043E\u0438\u0441\u043A \u043A\u043B\u0438\u043D\u0438\u043A, \u0443\u0441\u043B\u0443\u0433 \u0438\u043B\u0438 \u0437\u0430\u0434\u0430\u0439\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441...",
        chipImplant: "\u041B\u0443\u0447\u0448\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438 \u0438\u043C\u043F\u043B\u0430\u043D\u0442\u0430\u0446\u0438\u0438 \u0432 \u0422\u0431\u0438\u043B\u0438\u0441\u0438",
        chipWhitening: "\u041E\u0442\u0431\u0435\u043B\u0438\u0432\u0430\u043D\u0438\u0435 \u0437\u0443\u0431\u043E\u0432 \u0440\u044F\u0434\u043E\u043C",
        chipEmergency: "\u042D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u0430\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C",
        chipOrtho: "\u041E\u0440\u0442\u043E\u0434\u043E\u043D\u0442\u0438\u044F \u0434\u043B\u044F \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0445",
        scrollExplore: "\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430",
        topRated: "\u041B\u0443\u0447\u0448\u0438\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438 \u0422\u0431\u0438\u043B\u0438\u0441\u0438",
        viewAllClinics: "\u0412\u0441\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438",
        shareLocation: "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u043B\u043E\u043A\u0430\u0446\u0438\u0435\u0439 \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        locationShared: "\u041B\u043E\u043A\u0430\u0446\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430 \u2014 \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u043C \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435",
        statClinics: "\u041A\u043B\u0438\u043D\u0438\u043A\u0438",
        statNoShows: "\u041C\u0435\u043D\u044C\u0448\u0435 \u043D\u0435\u044F\u0432\u043E\u043A",
        statBooking: "\u041E\u043D\u043B\u0430\u0439\u043D \u0437\u0430\u043F\u0438\u0441\u044C",
        statDentists: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438",
        statRating: "\u0421\u0440\u0435\u0434\u043D\u0438\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433",
        statPatients: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442\u044B",
        findClinics: "\u041D\u0430\u0439\u0442\u0438 \u043B\u0443\u0447\u0448\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438",
        forBusinessBtn: "\u0414\u043B\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430",
        ownClinic: "\u0423 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043A\u043B\u0438\u043D\u0438\u043A\u0430?",
        claimText: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0432\u043E\u044E \u043A\u043B\u0438\u043D\u0438\u043A\u0443 \u0438\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0435\u0451 \u0432 \u043D\u0430\u0448\u0443 \u0431\u0430\u0437\u0443 \u0434\u0430\u043D\u043D\u044B\u0445.",
        getListed: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u2192",
        clinicsTitle: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438 \u0432 \u0413\u0440\u0443\u0437\u0438\u0438",
        verifiedClinics: "\u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043A\u043B\u0438\u043D\u0438\u043A \u0441 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430\u043C\u0438 \u0438 \u043E\u0442\u0437\u044B\u0432\u0430\u043C\u0438",
        searchByName: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E, \u0440\u0430\u0439\u043E\u043D\u0443 \u0438\u043B\u0438 \u0443\u0441\u043B\u0443\u0433\u0435...",
        hideMap: "\u0421\u043A\u0440\u044B\u0442\u044C \u043A\u0430\u0440\u0442\u0443",
        showMap: "\u041A\u0430\u0440\u0442\u0430",
        nearMe: "\u0420\u044F\u0434\u043E\u043C",
        clinicsMatch: "\u043A\u043B\u0438\u043D\u0438\u043A \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442",
        reviews: "\u043E\u0442\u0437\u044B\u0432\u043E\u0432",
        loadingMore: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
        callClinic: "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C",
        bookAppointment: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F",
        services: "\u0423\u0441\u043B\u0443\u0433\u0438",
        workingHours: "\u0427\u0430\u0441\u044B \u0440\u0430\u0431\u043E\u0442\u044B",
        priceRange: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0446\u0435\u043D",
        location: "\u0420\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
        visitWebsite: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442",
        bookingTitle: "\u0417\u0430\u043F\u0438\u0441\u044C \u043D\u0430 \u043F\u0440\u0438\u0451\u043C",
        step: "\u0428\u0430\u0433",
        selectClinic: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0443",
        selectService: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0441\u043B\u0443\u0433\u0443",
        selectDate: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
        selectTime: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F",
        confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
        next: "\u0414\u0430\u043B\u0435\u0435",
        back: "\u041D\u0430\u0437\u0430\u0434",
        clinicsAvailable: "\u043A\u043B\u0438\u043D\u0438\u043A \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        clinicsFound: "\u043A\u043B\u0438\u043D\u0438\u043A \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        confirmBooking: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C",
        bookingConfirmed: "\u0412\u0430\u0448 \u0432\u0438\u0437\u0438\u0442 \u0437\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D!",
        patientName: "\u0418\u043C\u044F \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
        email: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
        notes: "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
        businessHeroBadge: "15+ \u041C\u043E\u0434\u0443\u043B\u0435\u0439  \xb7  212+ \u041A\u043B\u0438\u043D\u0438\u043A  \xb7  Gemini AI",
        businessHeroTitle: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0434\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        businessHeroSubtitle: "\u041A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043A\u0430\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0430\u043D\u0430\u043B\u0438\u0437, \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F, \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435, \u0431\u0438\u043B\u043B\u0438\u043D\u0433, \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u0440\u0435\u0446\u0435\u043F\u0442\u044B, \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0435\u0439 \u0438 \u0418\u0418-\u0434\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 \u2014 \u0432\u0441\u0451 \u0432 \u043E\u0434\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435 \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0438\u0438.",
        theProblem: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
        problemSubtitle: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0438 \u0435\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u043E \u0442\u0435\u0440\u044F\u044E\u0442 \u0434\u043E\u0445\u043E\u0434 \u0438\u0437-\u0437\u0430 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        excelChaos: "\u0425\u0430\u043E\u0441 Excel \u0438 WhatsApp",
        excelChaosDetail: "\u041A\u043B\u0438\u043D\u0438\u043A\u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0442 \u0437\u0430\u043F\u0438\u0441\u044F\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0438 \u0447\u0430\u0442\u044B. \u041D\u0443\u043B\u0435\u0432\u0430\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u044F, \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u044B\u0435 \u043E\u0448\u0438\u0431\u043A\u0438.",
        noShowRate: "25% \u043D\u0435\u044F\u0432\u043E\u043A",
        noShowDetail: "\u0411\u0435\u0437 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0439 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u044B \u0437\u0430\u0431\u044B\u0432\u0430\u044E\u0442 \u043E \u0432\u0438\u0437\u0438\u0442\u0430\u0445. \u041F\u0443\u0441\u0442\u044B\u0435 \u043A\u0440\u0435\u0441\u043B\u0430 \u2014 \u20BE500+/\u0434\u0435\u043D\u044C \u043F\u043E\u0442\u0435\u0440\u044C.",
        paperCharts: "\u0411\u0443\u043C\u0430\u0436\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B \u0432 2026",
        paperChartsDetail: "\u0420\u0443\u043A\u043E\u043F\u0438\u0441\u043D\u044B\u0435 \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0438, \u0431\u0435\u0437 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0439 \u043E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u044B. \u041A\u0440\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0437\u0430\u043F\u0435\u0440\u0442\u044B \u0432 \u0448\u043A\u0430\u0444\u0430\u0445.",
        insuranceBlackHole: "\u0427\u0451\u0440\u043D\u0430\u044F \u0434\u044B\u0440\u0430 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F",
        insuranceDetail: "\u0420\u0443\u0447\u043D\u044B\u0435 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0438 \u0432 Aldagi, GPI, Imedi L \u0437\u0430\u043D\u0438\u043C\u0430\u044E\u0442 \u0447\u0430\u0441\u044B. \u041E\u0442\u043A\u043B\u043E\u043D\u0451\u043D\u043D\u044B\u0435 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0438 \u043A\u043E\u043F\u044F\u0442\u0441\u044F.",
        oneplatform: "\u041E\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430, \u0432\u0441\u0435 \u043C\u043E\u0434\u0443\u043B\u0438",
        platformSubtitle: "15 \u0438\u043D\u0442\u0435\u0433\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043C\u043E\u0434\u0443\u043B\u0435\u0439 \u0434\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438",
        clinical: "\u041A\u041B\u0418\u041D\u0418\u0427\u0415\u0421\u041A\u0418\u0415",
        operations: "\u041E\u041F\u0415\u0420\u0410\u0426\u0418\u041E\u041D\u041D\u042B\u0415",
        analyticsEnterprise: "\u0410\u041D\u0410\u041B\u0418\u0422\u0418\u041A\u0410 \u0418 ENTERPRISE",
        digitalOdontogram: "\u0426\u0438\u0444\u0440\u043E\u0432\u0430\u044F \u043E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u0430",
        digitalOdontogramDetail: "FDI 32-\u0437\u0443\u0431\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 \u0441 5-\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u043D\u044B\u043C \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435\u043C.",
        perioCharting: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043A\u0430\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        perioChartingDetail: "192-\u0442\u043E\u0447\u0435\u0447\u043D\u0430\u044F \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u0435\u0442\u043A\u0430. 6-\u0442\u043E\u0447\u0435\u0447\u043D\u043E\u0435 \u0437\u043E\u043D\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435, BOP, CAL.",
        treatmentPlanning: "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        treatmentPlanningDetail: "\u0424\u0430\u0437\u043E\u0432\u044B\u0435 \u043F\u043B\u0430\u043D\u044B \u0441 CDT-\u043A\u043E\u0434\u0430\u043C\u0438, \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u044B\u043C\u0438 \u043E\u0446\u0435\u043D\u043A\u0430\u043C\u0438. \u0418\u0418-\u0441\u0435\u043A\u0432\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435.",
        soapNotes: "SOAP \u0437\u0430\u043F\u0438\u0441\u0438 + \u0418\u0418 \u0441\u043A\u0440\u0430\u0439\u0431",
        soapNotesDetail: "\u0421\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F \u0441 \u0448\u0430\u0431\u043B\u043E\u043D\u0430\u043C\u0438. Gemini \u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0443\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0438 \u0438\u0437 \u0433\u043E\u043B\u043E\u0441\u0430.",
        multiChairScheduling: "\u041C\u043D\u043E\u0433\u043E\u043A\u0440\u0435\u0441\u0435\u043B\u044C\u043D\u043E\u0435 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        multiChairDetail: "\u041D\u0435\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u0432\u0438\u0434 \u0441 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u043C\u0438 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0430\u043C\u0438. \u0426\u0432\u0435\u0442\u043E\u0432\u0430\u044F \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u0440\u0430\u0447\u0435\u0439.",
        billingInsurance: "\u0411\u0438\u043B\u043B\u0438\u043D\u0433 \u0438 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435",
        billingDetail: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0439 \u0434\u043B\u044F Aldagi, GPI, Imedi L. \u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u044F, \u043F\u043B\u0430\u043D\u044B \u043E\u043F\u043B\u0430\u0442\u044B.",
        ePrescribing: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u0440\u0435\u0446\u0435\u043F\u0442\u044B",
        ePrescribingDetail: "\u0426\u0438\u0444\u0440\u043E\u0432\u044B\u0435 \u0440\u0435\u0446\u0435\u043F\u0442\u044B \u0441 \u0448\u0430\u0431\u043B\u043E\u043D\u0430\u043C\u0438. \u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u043B\u0435\u043A\u0430\u0440\u0441\u0442\u0432 \u0447\u0435\u0440\u0435\u0437 Gemini.",
        labTracking: "\u041E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0438",
        labTrackingDetail: "\u041A\u0430\u043D\u0431\u0430\u043D: \u0417\u0430\u043A\u0430\u0437\u0430\u043D\u043E \u2192 \u0418\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u2192 \u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u2192 \u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E.",
        productionReports: "\u041E\u0442\u0447\u0451\u0442\u044B \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0430",
        productionReportsDetail: "\u0412\u0430\u043B\u043E\u0432\u043E\u0435/\u0447\u0438\u0441\u0442\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E, \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u0441\u0431\u043E\u0440\u0430, \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F.",
        referralMgmt: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043C\u0438",
        referralMgmtDetail: "\u0412\u0445\u043E\u0434\u044F\u0449\u0438\u0435/\u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043A \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430\u043C. \u0418\u0418-\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u0443\u0435\u043C\u044B\u0435 \u043F\u0438\u0441\u044C\u043C\u0430.",
        medicalHistory: "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0430\u044F \u0438\u0441\u0442\u043E\u0440\u0438\u044F",
        medicalHistoryDetail: "11-\u0432\u0438\u0434\u043E\u0432\u0430\u044F \u043A\u0430\u0440\u0442\u0430 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430: \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u044F, \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F, \u043C\u0435\u0434\u0438\u043A\u0430\u043C\u0435\u043D\u0442\u044B, \u0430\u043B\u043B\u0435\u0440\u0433\u0438\u0438.",
        enterpriseAdmin: "Enterprise \u0430\u0434\u043C\u0438\u043D",
        enterpriseAdminDetail: "RBAC, \u0436\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0430, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435, \u043C\u0443\u043B\u044C\u0442\u0438\u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0441\u0442\u044C, SSO, \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 API.",
        geminiBuiltIn: "\u0412\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0439 Gemini AI",
        geminiSubtitle: "\u041A\u0430\u0436\u0434\u044B\u0439 \u043C\u043E\u0434\u0443\u043B\u044C \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430 Google Gemini 3.1",
        xrayAnalysis: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0440\u0435\u043D\u0442\u0433\u0435\u043D\u0430",
        xrayDetail: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0440\u0435\u043D\u0442\u0433\u0435\u043D\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0434\u043B\u044F \u0418\u0418-\u0434\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0438 \u043A\u0430\u0440\u0438\u0435\u0441\u0430.",
        perioAssessment: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0446\u0435\u043D\u043A\u0430",
        perioAssessmentDetail: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u0442\u0430\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435/\u0433\u0440\u0430\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 AAP \u043F\u043E \u0434\u0430\u043D\u043D\u044B\u043C \u0437\u043E\u043D\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.",
        clinicalScribe: "\u041A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0441\u043A\u0440\u0430\u0439\u0431",
        clinicalScribeDetail: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u044F SOAP-\u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0438\u0437 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0438\u043B\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442\u044B.",
        riskProfiling: "\u041F\u0440\u043E\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0440\u0438\u0441\u043A\u043E\u0432",
        riskProfilingDetail: "\u0410\u043D\u0430\u043B\u0438\u0437 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0439, \u0441\u0435\u043C\u0435\u0439\u043D\u043E\u0433\u043E \u0430\u043D\u0430\u043C\u043D\u0435\u0437\u0430 \u0434\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0440\u0438\u0441\u043A\u0430.",
        treatmentSequencing: "\u0421\u0435\u043A\u0432\u0435\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        treatmentSequencingDetail: "\u0418\u0418-\u043E\u043F\u0442\u0438\u043C\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0444\u0430\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F \u0441 \u0443\u0447\u0451\u0442\u043E\u043C \u0437\u0430\u0436\u0438\u0432\u043B\u0435\u043D\u0438\u044F \u0438 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F.",
        patientComm: "\u041A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u044F \u0441 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u043E\u043C",
        patientCommDetail: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u044F \u043F\u043E\u043D\u044F\u0442\u043D\u044B\u0445 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0439 \u043D\u0430 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u043C \u044F\u0437\u044B\u043A\u0435.",
        georgianEcosystem: "\u0413\u043E\u0442\u043E\u0432\u043E \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u0439 \u044D\u043A\u043E\u0441\u0438\u0441\u0442\u0435\u043C\u044B",
        integrationsSubtitle: "\u041F\u0440\u0435\u0434\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438 \u0441 \u043C\u0435\u0441\u0442\u043D\u044B\u043C \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435\u043C, \u043F\u043B\u0430\u0442\u0435\u0436\u0430\u043C\u0438 \u0438 \u043C\u0435\u0441\u0441\u0435\u043D\u0434\u0436\u0435\u0440\u0430\u043C\u0438",
        insurance: "\u0421\u0422\u0420\u0410\u0425\u041E\u0412\u0410\u041D\u0418\u0415",
        payments: "\u041F\u041B\u0410\u0422\u0415\u0416\u0418",
        messaging: "\u0421\u041E\u041E\u0411\u0429\u0415\u041D\u0418\u042F",
        ehrLabs: "\u042D\u041C\u041A \u0418 \u041B\u0410\u0411\u041E\u0420\u0410\u0422\u041E\u0420\u0418\u0418",
        clinicsInDb: "\u041A\u043B\u0438\u043D\u0438\u043A \u0432 \u0431\u0430\u0437\u0435",
        platformModules: "\u041C\u043E\u0434\u0443\u043B\u0435\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B",
        aiTools: "\u0418\u0418-\u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u043E\u0432 (Gemini)",
        integrations: "\u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0439",
        pricingTitle: "\u0426\u0435\u043D\u044B",
        pricingSubtitle: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E, \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C \u043F\u043E \u043C\u0435\u0440\u0435 \u0440\u043E\u0441\u0442\u0430",
        trustedBy: "\u0414\u043E\u0432\u0435\u0440\u0438\u0435 \u0432\u0435\u0434\u0443\u0449\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        readyModernize: "\u0413\u043E\u0442\u043E\u0432\u044B \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u0448\u0443 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0443?",
        joinCount: "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u043A 212+ \u043A\u043B\u0438\u043D\u0438\u043A\u0430\u043C \u0432 \u0413\u0440\u0443\u0437\u0438\u0438.",
        startTrial: "\u041D\u0430\u0447\u0430\u0442\u044C \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E",
        contactSales: "\u0421\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F \u0441 \u043F\u0440\u043E\u0434\u0430\u0436\u0430\u043C\u0438",
        noCreditCard: "\u0411\u0435\u0437 \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B  \xb7  \u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0439 \u0442\u0430\u0440\u0438\u0444  \xb7  \u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0437\u0430 5 \u043C\u0438\u043D\u0443\u0442",
        copyright: "\xa9 2026 MCAI \u2014 \u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043A\u043B\u0438\u043D\u0438\u043A",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u041F\u0430\u043D\u0435\u043B\u044C",
        navPatients: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442\u044B",
        navChart: "\u041A\u0430\u0440\u0442\u0430",
        navPerio: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u044F",
        navTreatmentPlans: "\u041F\u043B\u0430\u043D\u044B \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        navNotes: "\u0417\u0430\u043F\u0438\u0441\u0438",
        navScheduling: "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        navBilling: "\u0411\u0438\u043B\u043B\u0438\u043D\u0433",
        navPrescriptions: "\u0420\u0435\u0446\u0435\u043F\u0442\u044B",
        navLabCases: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u043D\u044B\u0435 \u0441\u043B\u0443\u0447\u0430\u0438",
        navReferrals: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
        navReports: "\u041E\u0442\u0447\u0451\u0442\u044B",
        navMedHistory: "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0430\u044F \u0438\u0441\u0442\u043E\u0440\u0438\u044F",
        navIntegrations: "\u0418\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438",
        navEnterprise: "\u041F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0435",
        sectionClinical: "\u041A\u041B\u0418\u041D\u0418\u041A\u0410",
        sectionOperations: "\u041E\u041F\u0415\u0420\u0410\u0426\u0418\u0418",
        sectionAnalytics: "\u0410\u041D\u0410\u041B\u0418\u0422\u0418\u041A\u0410",
        sectionAiTools: "\u0418\u0418 \u0418\u041D\u0421\u0422\u0420\u0423\u041C\u0415\u041D\u0422\u042B",
        sectionAdmin: "\u0410\u0414\u041C\u0418\u041D\u0418\u0421\u0422\u0420\u0418\u0420\u041E\u0412\u0410\u041D\u0418\u0415",
        // Booking Page
        chooseClinic: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043B\u0438\u043D\u0438\u043A\u0443",
        selectAService: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0441\u043B\u0443\u0433\u0443",
        pickADate: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
        pickATime: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F",
        confirmYourBooking: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u044C",
        clinicLabel: "\u041A\u043B\u0438\u043D\u0438\u043A\u0430:",
        serviceLabel: "\u0423\u0441\u043B\u0443\u0433\u0430:",
        dateLabel: "\u0414\u0430\u0442\u0430:",
        timeLabel: "\u0412\u0440\u0435\u043C\u044F:",
        // AI Page
        send: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        procedure: "\u041F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430",
        observations: "\u041D\u0430\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F",
        aiThinking: "\u0418\u0418 \u0434\u0443\u043C\u0430\u0435\u0442...",
        summarizeHistory: "\u0420\u0435\u0437\u044E\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        generateTxPlan: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        checkDrugInteractions: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043B\u0435\u043A\u0430\u0440\u0441\u0442\u0432",
        writeClinicalNote: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
        askAiAssistant: "\u0421\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0418\u0418-\u0430\u0441\u0441\u0438\u0441\u0442\u0435\u043D\u0442\u0430...",
        dropXray: "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0440\u0435\u043D\u0442\u0433\u0435\u043D \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438",
        supportsFormats: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044E\u0442\u0441\u044F DICOM, PNG, JPG",
        analysisResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0430\u043D\u0430\u043B\u0438\u0437\u0430 (\u0434\u0435\u043C\u043E)",
        aiRecommendation: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u044F \u0418\u0418",
        exportToTxPlan: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u043F\u043B\u0430\u043D \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        generateClinicalNote: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
        generatedSoap: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C (SOAP)",
        subjective: "S \u2014 \u0421\u0443\u0431\u044A\u0435\u043A\u0442\u0438\u0432\u043D\u043E",
        objective: "O \u2014 \u041E\u0431\u044A\u0435\u043A\u0442\u0438\u0432\u043D\u043E",
        assessment: "A \u2014 \u041E\u0446\u0435\u043D\u043A\u0430",
        plan: "P \u2014 \u041F\u043B\u0430\u043D",
        copyToRecord: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u043A\u0430\u0440\u0442\u0443 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        aiPerioAssessment: "\u0418\u0418 \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0446\u0435\u043D\u043A\u0430",
        enterProbingData: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0437\u043E\u043D\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043B\u044F AAP \u0441\u0442\u0430\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0439 \u043F\u043E \u043B\u0435\u0447\u0435\u043D\u0438\u044E.",
        analyzeWithGemini: "\u0410\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441 Gemini",
        aiRiskAssessment: "\u0418\u0418 \u043E\u0446\u0435\u043D\u043A\u0430 \u0440\u0438\u0441\u043A\u043E\u0432",
        enterConditions: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430, \u0441\u0435\u043C\u0435\u0439\u043D\u044B\u0439 \u0430\u043D\u0430\u043C\u043D\u0435\u0437 \u0438 \u0432\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0438 \u0434\u043B\u044F \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0440\u0438\u0441\u043A\u0430.",
        generateRiskProfile: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0440\u0438\u0441\u043A\u0430",
        patientCommunication: "\u041A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u044F \u0441 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u043E\u043C",
        generateExplanations: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0438\u044F \u043F\u043E\u043D\u044F\u0442\u043D\u044B\u0445 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0439 \u043B\u0435\u0447\u0435\u043D\u0438\u044F \u043D\u0430 \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u043A\u043E\u043C \u0438\u043B\u0438 \u0430\u043D\u0433\u043B\u0438\u0439\u0441\u043A\u043E\u043C.",
        generateExplanation: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0435",
        patientFriendly: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E\u0435 \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443 \u043E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0435",
        // Billing Page
        claims: "\u041F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0438",
        ledger: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u043A\u0430\u044F \u043A\u043D\u0438\u0433\u0430",
        aging: "\u0421\u0442\u0430\u0440\u0435\u043D\u0438\u0435 \u0437\u0430\u0434\u043E\u043B\u0436\u0435\u043D\u043D\u043E\u0441\u0442\u0438",
        paymentPlans: "\u041F\u043B\u0430\u043D\u044B \u043E\u043F\u043B\u0430\u0442\u044B",
        eligibility: "\u041F\u0440\u0430\u0432\u043E \u043D\u0430 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435",
        allFilter: "\u0412\u0441\u0435",
        submitted: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        denied: "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E",
        patientLedger: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u044F \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        agedAccounts: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043D\u044B\u0435 \u0441\u0447\u0435\u0442\u0430",
        sendStatements: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0432\u044B\u043F\u0438\u0441\u043A\u0438",
        activePaymentPlans: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u043D\u044B \u043E\u043F\u043B\u0430\u0442\u044B",
        insuranceEligibility: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u043E\u0435 \u043F\u0440\u0430\u0432\u043E",
        // Clinical Charting
        odontogram: "\u041E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u0430",
        perioTab: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u044F",
        treatmentPlanTab: "\u041F\u043B\u0430\u043D \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        notesTab: "\u0417\u0430\u043F\u0438\u0441\u0438",
        progressNotes: "\u0417\u0430\u043F\u0438\u0441\u0438 \u043E \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0435",
        openFullPerio: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u043B\u043D\u0443\u044E \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043A\u0430\u0440\u0442\u0443 \u2192",
        openFullTxPlanner: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u043B\u0435\u0447\u0435\u043D\u0438\u044F \u2192",
        openClinicalNotes: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0438 \u2192",
        newExam: "\u041D\u043E\u0432\u044B\u0439 \u043E\u0441\u043C\u043E\u0442\u0440",
        voiceEntry: "\u0413\u043E\u043B\u043E\u0441\u043E\u0432\u043E\u0439 \u0432\u0432\u043E\u0434",
        bleedingIndex: "\u0418\u043D\u0434\u0435\u043A\u0441 \u043A\u0440\u043E\u0432\u043E\u0442\u043E\u0447\u0438\u0432\u043E\u0441\u0442\u0438",
        plaqueIndex: "\u0418\u043D\u0434\u0435\u043A\u0441 \u043D\u0430\u043B\u0451\u0442\u0430",
        sitesAbove4: "\u0423\u0447\u0430\u0441\u0442\u043A\u0438 \u2265 4\u043C\u043C",
        sitesAbove6: "\u0423\u0447\u0430\u0441\u0442\u043A\u0438 \u2265 6\u043C\u043C",
        planA: "\u041F\u043B\u0430\u043D A: \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C\u044B\u0439",
        planB: "\u041F\u043B\u0430\u043D B: \u041A\u043E\u043D\u0441\u0435\u0440\u0432\u0430\u0442\u0438\u0432\u043D\u044B\u0439",
        newPlan: "+ \u041D\u043E\u0432\u044B\u0439 \u043F\u043B\u0430\u043D",
        presentToPatient: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0443",
        sendToPortal: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u043F\u043E\u0440\u0442\u0430\u043B",
        totalFee: "\u041E\u0431\u0449\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C",
        insuranceEst: "\u041E\u0446\u0435\u043D\u043A\u0430 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u043A\u0438",
        patientPortion: "\u0414\u043E\u043B\u044F \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        chairSideMode: "\u0420\u0435\u0436\u0438\u043C \u0443 \u043A\u0440\u0435\u0441\u043B\u0430",
        adminMode: "\u0420\u0435\u0436\u0438\u043C \u0430\u0434\u043C\u0438\u043D\u0430",
        proceduresAcrossPhases: "{0} \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440 \u0432 {1} \u0444\u0430\u0437\u0430\u0445",
        // Scheduling
        day: "\u0414\u0435\u043D\u044C",
        week: "\u041D\u0435\u0434\u0435\u043B\u044F",
        today: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
        providerFilter: "\u0412\u0441\u0435 \u0432\u0440\u0430\u0447\u0438",
        productionGoal: "\u0426\u0435\u043B\u044C \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0430",
        waitlist: "\u041B\u0438\u0441\u0442 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F",
        // Prescriptions
        activeRx: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0435",
        pastRx: "\u041F\u0440\u043E\u0448\u043B\u044B\u0435",
        templates: "\u0428\u0430\u0431\u043B\u043E\u043D\u044B",
        interactionCheck: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0432\u0437\u0430\u0438\u043C\u043E\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439",
        // Lab Cases
        ordered: "\u0417\u0430\u043A\u0430\u0437\u0430\u043D\u043E",
        sentToLab: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u044E",
        inFabrication: "\u0412 \u0438\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0438",
        shipped: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        received: "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E",
        labVendors: "\u041F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0438 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0439",
        // Referrals
        allDirections: "\u0412\u0441\u0435",
        inbound: "\u0412\u0445\u043E\u0434\u044F\u0449\u0438\u0435",
        outbound: "\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435",
        generateLetter: "\u0421\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E",
        // Reports
        production: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
        collections: "\u0421\u0431\u043E\u0440\u044B",
        schedulingReport: "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        treatmentAcceptance: "\u041F\u0440\u0438\u043D\u044F\u0442\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F",
        recall: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0439 \u0432\u044B\u0437\u043E\u0432",
        grossProduction: "\u0412\u0430\u043B\u043E\u0432\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
        netProduction: "\u0427\u0438\u0441\u0442\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
        collectionRate: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0441\u0431\u043E\u0440\u0430",
        plansPresented: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u043F\u043B\u0430\u043D\u043E\u0432",
        accepted: "\u041F\u0440\u0438\u043D\u044F\u0442\u043E",
        acceptanceRate: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F",
        dueThisMonth: "\u0417\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u043D\u0430 \u044D\u0442\u043E\u0442 \u043C\u0435\u0441\u044F\u0446",
        scheduled: "\u0417\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
        completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        overdue: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043E",
        reactivationRate: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0440\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438",
        // Medical History
        timeline: "\u0425\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u044F",
        conditions: "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F",
        medications: "\u041C\u0435\u0434\u0438\u043A\u0430\u043C\u0435\u043D\u0442\u044B",
        allergies: "\u0410\u043B\u043B\u0435\u0440\u0433\u0438\u0438",
        labResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0430\u043D\u0430\u043B\u0438\u0437\u043E\u0432",
        vitals: "\u0412\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0438",
        immunizations: "\u0418\u043C\u043C\u0443\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
        familyHistory: "\u0421\u0435\u043C\u0435\u0439\u043D\u044B\u0439 \u0430\u043D\u0430\u043C\u043D\u0435\u0437",
        imaging: "\u0412\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F",
        documents: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u0416\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0430",
        compliance: "\u0421\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435",
        multiTenancy: "\u041C\u0443\u043B\u044C\u0442\u0438\u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0441\u0442\u044C",
        sso: "SSO \u0438 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
        featureFlags: "\u0424\u043B\u0430\u0433\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0439",
        apiManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 API",
        dataManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u043C\u0438",
        // Integrations
        ehr: "\u042D\u041C\u041A",
        labs: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0438",
        telehealth: "\u0422\u0435\u043B\u0435\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0430",
        aiMl: "\u0418\u0418/\u041C\u041E",
        wearables: "\u041D\u043E\u0441\u0438\u043C\u044B\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430",
        connected: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        disconnected: "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        // Components
        status: "\u0421\u0442\u0430\u0442\u0443\u0441",
        healthy: "\u0417\u0434\u043E\u0440\u043E\u0432\u044B\u0439",
        caries: "\u041A\u0430\u0440\u0438\u0435\u0441",
        restored: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D",
        missing: "\u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442",
        implant: "\u0418\u043C\u043F\u043B\u0430\u043D\u0442",
        crownStatus: "\u041A\u043E\u0440\u043E\u043D\u043A\u0430",
        bridge: "\u041C\u043E\u0441\u0442",
        veneer: "\u0412\u0438\u043D\u0438\u0440",
        surfaces: "\u041F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438",
        procedureHistory: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440",
        addProcedure: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443",
        totalCharged: "\u0412\u0441\u0435\u0433\u043E \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E",
        insurancePayment: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u043E\u0439 \u043F\u043B\u0430\u0442\u0451\u0436",
        patientResponsibility: "\u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043F\u0430\u0446\u0438\u0435\u043D\u0442\u0430",
        expand: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
        policyNumber: "\u041F\u043E\u043B\u0438\u0441 \u2116",
        planType: "\u0422\u0438\u043F \u043F\u043B\u0430\u043D\u0430",
        annualMax: "\u0413\u043E\u0434\u043E\u0432\u043E\u0439 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C",
        used: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u043E",
        remaining: "\u041E\u0441\u0442\u0430\u0442\u043E\u043A",
        coverageByCategory: "\u041F\u043E\u043A\u0440\u044B\u0442\u0438\u0435 \u043F\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043C",
        preventive: "\u041F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u043A\u0430",
        basic: "\u0411\u0430\u0437\u043E\u0432\u043E\u0435",
        major: "\u041E\u0441\u043D\u043E\u0432\u043D\u043E\u0435",
        ortho: "\u041E\u0440\u0442\u043E\u0434\u043E\u043D\u0442\u0438\u044F",
        current: "\u0422\u0435\u043A\u0443\u0449\u0438\u0435",
        thirtyDay: "30 \u0434\u043D\u0435\u0439",
        sixtyDay: "60 \u0434\u043D\u0435\u0439",
        ninetyPlus: "90+ \u0434\u043D\u0435\u0439",
        totalBalance: "\u041E\u0431\u0449\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441",
        monthlyPayment: "\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u0451\u0436",
        paymentsRemaining: "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439",
        nextPayment: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043F\u043B\u0430\u0442\u0451\u0436",
        paymentProgress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441 \u043E\u043F\u043B\u0430\u0442\u044B",
        choosePlan: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u043B\u0430\u043D",
        aiInsight: "\u0418\u0418 \u0438\u043D\u0441\u0430\u0439\u0442",
        confidence: "\u0423\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C",
        revoke: "\u041E\u0442\u043E\u0437\u0432\u0430\u0442\u044C",
        exams: "\u041E\u0441\u043C\u043E\u0442\u0440\u044B",
        phaseTotal: "\u0418\u0442\u043E\u0433\u043E \u043F\u043E \u0444\u0430\u0437\u0435",
        mon: "\u041F\u043D",
        tue: "\u0412\u0442",
        wed: "\u0421\u0440",
        thu: "\u0427\u0442",
        fri: "\u041F\u0442",
        sat: "\u0421\u0431",
        sun: "\u0412\u0441",
        thinking: "\u0414\u0443\u043C\u0430\u044E...",
        followUpPlaceholder: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0432\u043E\u043F\u0440\u043E\u0441...",
        initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
        nextExpansionArmeniaAzerbaijan: "\uD83C\uDF0D  Next expansion: Armenia \u2192 Azerbaijan \u2192 broader Caucasus dental market",
        whyNow: 'Why Now',
        str561: "\u2708\uFE0F",
        dentalTourismBoom: 'Dental tourism boom',
        internationalPatientsNeedEngli: 'International patients need English-language online booking now',
        str564: "\uD83D\uDCF1",
        postcovidDigitizationPressure: 'Post-COVID digitization pressure',
        clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
        str567: "\uD83C\uDFC6",
        noStrongLocalIncumbent: 'No strong local incumbent',
        dentosgeOnlyCoversDiscovery: "dentos.ge only covers discovery \u2014 zero full ops platform exists",
        str570: "\uD83C\uDDEC\uD83C\uDDEA",
        georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
        lowCostHighQuality: "Low cost, high quality \u2014 50\u201370% cheaper than Western Europe",
        joinThePartnerClinic: "Join the Partner Clinic Program \u2014 first 3 months free",
        builtForGeorgianClinics: "\uD83E\uDDB7 Built for Georgian clinics, by people who live here",
        prev: "\u2190 Prev",
        next2: "\u0414\u0430\u043B\u0435\u0435 \u2192",
        getInTouch: "\uD83E\uDDB7 Get in Touch",
        activePrescriptions: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0439 Prescriptions",
        pastPrescriptions: 'Past Prescriptions',
        prescriptionTemplates: "\u0420\u0435\u0446\u0435\u043F\u0442 Templates",
        drugInteractionChecker: 'Drug Interaction Checker',
        referrals: 'Referrals',
        newReferral: "+ \u041D\u043E\u0432\u044B\u0439 \u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
        inbound2: "\u0412\u0445\u043E\u0434\u044F\u0449\u0438\u0439",
        outbound2: "\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0439",
        reportsAnalytics: 'Reports & Analytics',
        productionByProvider: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E by \u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440",
        productionByCategory: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E by Category",
        preventive2: 'Preventive',
        restorative: 'Restorative',
        endodontics: 'Endodontics',
        periodontics: 'Periodontics',
        prosthodontics: 'Prosthodontics',
        surgery: 'Surgery',
        agingReport: "Aging \u041E\u0442\u0447\u0451\u0442",
        appointmentsByDay: "\u0412\u0438\u0437\u0438\u0442\u044B by Day",
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        topDeclinedTreatments: 'Top Declined Treatments',
        costConcerns: 'Cost concerns',
        wantsToWait: 'Wants to wait',
        orthodontics: 'Orthodontics',
        insuranceNotCovering: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435 not covering",
        notAPriority: 'Not a priority',
        seekingSecondOpinion: 'Seeking second opinion',
        u2190: '\u2190',
        u2192: '\u2192',
        allProviders: "\u0412\u0441\u0435 Providers",
        hygienistNino: 'Hygienist Nino',
        mon17: 'MON 17',
        tue18: 'TUE 18',
        wed19: 'WED 19',
        thu20: 'THU 20',
        fri21: 'FRI 21',
        crownPrep14: 'Crown Prep #14',
        tKapanadze: 'T. Kapanadze',
        srpQuad1: 'SRP Quad 1',
        dGelashvili: 'D. Gelashvili',
        examXray: 'Exam + X-ray',
        mTsiklauri: 'M. Tsiklauri',
        unconfirmed: 'Unconfirmed',
        rct36: 'RCT #36',
        gBeridze: 'G. Beridze',
        prophyPolish: 'Prophy + Polish',
        iDiasamidze: 'I. Diasamidze',
        perioMaintenance: 'Perio Maintenance',
        tLomidze: 'T. Lomidze',
        prophy: 'Prophy',
        aJavakhishvili: 'A. Javakhishvili',
        inChair: 'In Chair',
        sealantsX4: 'Sealants x4',
        nKapanadze: 'N. Kapanadze',
        lMchedlishvili: 'L. Mchedlishvili',
        u2014LunchU2014: '\u2014 Lunch \u2014',
        veneerPrep11: 'Veneer Prep #11',
        kGabrichidze: 'K. Gabrichidze',
        composite25: 'Composite #25',
        sMeladze: 'S. Meladze',
        bridgePrep3436: 'Bridge Prep #34-36',
        rKharazishvili: 'R. Kharazishvili',
        composite22: 'Composite #22',
        zDolidze: 'Z. Dolidze',
        noShow: 'No Show',
        extraction48: 'Extraction #48',
        vPapunashvili: 'V. Papunashvili',
        implantConsult: 'Implant Consult',
        eTsereteli: 'E. Tsereteli',
        nGogiberidze: 'N. Gogiberidze',
        crownSeat14: 'Crown Seat #14',
        checkup: 'Checkup',
        bShengelia: 'B. Shengelia',
        fluorideTreatment: "Fluoride \u041B\u0435\u0447\u0435\u043D\u0438\u0435",
        emergencyWalkin: 'Emergency Walk-in',
        scaling: 'Scaling',
        wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
        assignToSchedule: 'Assign to Schedule',
        autoAssign: 'Auto Assign',
        high: 'High',
        anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
        medium: 'Medium',
        irakliDiasamidze: 'Irakli Diasamidze',
        friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
        low: 'Low',
        planARecommended: 'Plan A: Recommended',
        planBConservative: 'Plan B: Conservative',
        newPlan2: "+ \u041D\u043E\u0432\u044B\u0439 Plan",
        conservativeApproach: 'Conservative Approach',
        thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
        u00b7: '\u00B7',
        treatmentPlanComparison: "\u041B\u0435\u0447\u0435\u043D\u0438\u0435 Plan Comparison",
        u00b72: '\u00b7',
        exams2: 'Exams:',
        metric: 'Metric',
        pdMm: 'PD (mm)',
        gmMm: 'GM (mm)',
        calMm: 'CAL (mm)',
        suppuration: 'Suppuration',
        furcation: 'Furcation',
        mobility: 'Mobility',
        qty: 'Qty',
        refills: 'Refills',
        goal: 'Goal',
        current2: 'Current',
        totalDue: "\u0418\u0442\u043E\u0433\u043E Due",
        scheduled2: 'Scheduled',
        overdue2: 'Overdue',
        reactivation: 'Reactivation',
        chiefComplaint: 'Chief Complaint',
        painScale: 'Pain Scale:',
        clinicalFindings: "\u041A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 Findings",
        diagnosis: "\u0414\u0438\u0430\u0433\u043D\u043E\u0437",
        prescriptions: 'Prescriptions',
        u201c: '\u201C',
        xray: 'X-Ray',
        cleaning: 'Cleaning',
        amountPaid: "\u0421\u0443\u043C\u043C\u0430 \u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        annotate: 'Annotate',
        anonymousPatient: "Anonymous \u041F\u0430\u0446\u0438\u0435\u043D\u0442",
        autoImport: "Auto \u0418\u043C\u043F\u043E\u0440\u0442",
        away: 'Away',
        bankTransfer: "Bank \u041F\u0435\u0440\u0435\u0432\u043E\u0434",
        beforeAfter: 'Before After',
        bookPrerequisiteFirst: 'Book Prerequisite First',
        breakdown: 'Breakdown',
        bridgePrep: 'Bridge Prep',
        brightness: 'Brightness',
        cabinet: "\u041A\u0430\u0431\u0438\u043D\u0435\u0442",
        cabinet1: "\u041A\u0430\u0431\u0438\u043D\u0435\u0442 1",
        cabinet2: "\u041A\u0430\u0431\u0438\u043D\u0435\u0442 2",
        cabinetSchedule: "\u041A\u0430\u0431\u0438\u043D\u0435\u0442 \u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        cabinetScheduleDesc: "\u041A\u0430\u0431\u0438\u043D\u0435\u0442 \u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 Desc",
        card: "\u041A\u0430\u0440\u0442\u0430",
        cash: "\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u0435",
        cbct: 'Cbct',
        cephalometric: 'Cephalometric',
        channels: 'Channels',
        clinicalQuestion: "Clinical \u0412\u043E\u043F\u0440\u043E\u0441",
        clinicAvgRating: "Clinic Avg \u0420\u0435\u0439\u0442\u0438\u043D\u0433",
        collapse: 'Collapse',
        completedToday: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0421\u0435\u0433\u043E\u0434\u043D\u044F",
        compositeF: 'Composite F',
        continueToScheduling: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C To Scheduling",
        contrast: 'Contrast',
        ctScans: 'Ct Scans',
        customAmount: "Custom \u0421\u0443\u043C\u043C\u0430",
        days: "\u0414\u043D\u0438",
        delivered: 'Delivered',
        directMessages: 'Direct Messages',
        disposables: 'Disposables',
        doctorResponse: "\u0414\u043E\u043A\u0442\u043E\u0440 Response",
        doctors: 'Doctors',
        documentMgmtSubtitle: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 Mgmt Subtitle",
        documentPreview: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
        download: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C",
        endodontic: 'Endodontic',
        enterAmount: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0421\u0443\u043C\u043C\u0430",
        equipmentDevices: 'Equipment Devices',
        estDelivery: "Est \u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
        examConsult: 'Exam Consult',
        explanationQuality: "Explanation \u041A\u0430\u0447\u0435\u0441\u0442\u0432\u043E",
        fluorideTx: 'Fluoride Tx',
        fullMouthView: "Full Mouth \u0412\u0438\u0434",
        hasBracesQuestion: "Has Braces \u0412\u043E\u043F\u0440\u043E\u0441",
        hasConsultationQuestion: "Has Consultation \u0412\u043E\u043F\u0440\u043E\u0441",
        hasCtScanQuestion: "Has Ct \u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0412\u043E\u043F\u0440\u043E\u0441",
        hasRecentXrayQuestion: "Has \u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435 Xray \u0412\u043E\u043F\u0440\u043E\u0441",
        helpfulQuestion: "Helpful \u0412\u043E\u043F\u0440\u043E\u0441",
        highest: 'Highest',
        hygiene: 'Hygiene',
        imagingType: "\u0412\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F Type",
        implantPlace: 'Implant Place',
        important: 'Important',
        importLatest: "\u0418\u043C\u043F\u043E\u0440\u0442 Latest",
        inProgress: 'In Progress',
        installment: "\u0420\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0430",
        insuranceCoverage: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0435 \u041F\u043E\u043A\u0440\u044B\u0442\u0438\u0435",
        interpreted: 'Interpreted',
        inUse: 'In Use',
        invoices: 'Invoices',
        lastCleaningQuestion: "Last Cleaning \u0412\u043E\u043F\u0440\u043E\u0441",
        lateralSkullView: "Lateral Skull \u0412\u0438\u0434",
        lowest: 'Lowest',
        lowStock: "\u041D\u0438\u0437\u043A\u0438\u0439 \u0417\u0430\u043F\u0430\u0441",
        lowStockAlerts: "\u041D\u0438\u0437\u043A\u0438\u0439 \u0417\u0430\u043F\u0430\u0441 \u041E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F",
        maintenance: 'Maintenance',
        management: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
        markComplete: 'Mark Complete',
        material: "\u041C\u0430\u0442\u0435\u0440\u0438\u0430\u043B",
        method: "\u041C\u0435\u0442\u043E\u0434",
        minOrder: "Min \u0417\u0430\u043A\u0430\u0437",
        monthlySpend: "\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0439 Spend",
        newPayment: "New \u041E\u043F\u043B\u0430\u0442\u0430",
        newRadiologyReferral: "New Radiology \u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
        nextAppointment: 'Next Appointment',
        noDocumentsFound: 'No Documents Found',
        noNoteSelected: 'No Note Selected',
        normal: "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u044B\u0439",
        noteInterpreter: 'Note Interpreter',
        occupied: 'Occupied',
        online: "\u041E\u043D\u043B\u0430\u0439\u043D",
        orderNow: "\u0417\u0430\u043A\u0430\u0437 Now",
        orders: 'Orders',
        original: 'Original',
        outstanding: "\u041E\u0441\u0442\u0430\u0442\u043E\u043A",
        painManagement: "Pain \u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
        panoramic: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u043D\u044B\u0439",
        patientDue: "\u041F\u0430\u0446\u0438\u0435\u043D\u0442 \u041A \u043E\u043F\u043B\u0430\u0442\u0435",
        paymentHistory: "\u041E\u043F\u043B\u0430\u0442\u0430 \u0418\u0441\u0442\u043E\u0440\u0438\u044F",
        paymentMethod: "\u041E\u043F\u043B\u0430\u0442\u0430 \u041C\u0435\u0442\u043E\u0434",
        pendingOrders: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 Orders",
        periapical: 'Periapical',
        perioMaint: 'Perio Maint',
        photos: 'Photos',
        placeOrder: "Place \u0417\u0430\u043A\u0430\u0437",
        preCheck: 'Pre Check',
        preCheckPassed: 'Pre Check Passed',
        preCheckSubtitle: 'Pre Check Subtitle',
        preCheckTitle: 'Pre Check Title',
        prerequisiteWarning: 'Prerequisite Warning',
        print: "\u041F\u0435\u0447\u0430\u0442\u044C",
        processing: 'Processing',
        processPayment: "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041E\u043F\u043B\u0430\u0442\u0430",
        processPaymentBtn: "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041E\u043F\u043B\u0430\u0442\u0430 Btn",
        professionalism: 'Professionalism',
        prophyClean: 'Prophy Clean',
        prosthetic: 'Prosthetic',
        punctuality: 'Punctuality',
        qtyUsed: 'Qty Used',
        quantity: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E",
        queue: "\u041E\u0447\u0435\u0440\u0435\u0434\u044C",
        receiptPreview: "\u041A\u0432\u0438\u0442\u0430\u043D\u0446\u0438\u044F \u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
        recent: "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435",
        recentMaterialUsage: "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435 \u041C\u0430\u0442\u0435\u0440\u0438\u0430\u043B Usage",
        recentReceipts: "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435 Receipts",
        reliability: 'Reliability',
        remainingBalance: "Remaining \u0411\u0430\u043B\u0430\u043D\u0441",
        reorderLevel: 'Reorder Level',
        scanning: 'Scanning',
        sealants: 'Sealants',
        sent: 'Sent',
        singleToothView: "Single Tooth \u0412\u0438\u0434",
        slotDetails: 'Slot Details',
        sortBy: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 By",
        srpQuad: 'Srp Quad',
        startImaging: "Start \u0412\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F",
        stock: "\u0417\u0430\u043F\u0430\u0441",
        stockLevel: "\u0417\u0430\u043F\u0430\u0441 Level",
        submitReferral: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
        subtotal: 'Subtotal',
        suppliers: 'Suppliers',
        surgical: 'Surgical',
        targetArea: 'Target Area',
        teamChat: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430 \u0427\u0430\u0442",
        termsNormalized: 'Terms Normalized',
        threeDImaging: "Three D \u0412\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F",
        totalItems: 'Total Items',
        totalReceived: 'Total Received',
        typeAMessage: "Type A \u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
        unavailable: 'Unavailable',
        unit: "\u0415\u0434\u0438\u043D\u0438\u0446\u0430",
        urgency: 'Urgency',
        urgent: "\u0421\u0440\u043E\u0447\u043D\u043E",
        usageLog: 'Usage Log',
        veneerPrep: 'Veneer Prep',
        viewOnGoogle: "\u0412\u0438\u0434 On Google",
        xrays: 'Xrays'
    },
    uk: {
        home: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430",
        features: "\u0424\u0443\u043D\u043A\u0446\u0456\u0457",
        pricing: "\u0426\u0456\u043D\u0438",
        clinicsNav: "\u041A\u043B\u0456\u043D\u0456\u043A\u0438",
        aiAssistant: "AI \u0410\u0441\u0438\u0441\u0442\u0435\u043D\u0442",
        forBusiness: "\u0414\u043B\u044F \u0431\u0456\u0437\u043D\u0435\u0441\u0443",
        dashboard: "\u041F\u0430\u043D\u0435\u043B\u044C",
        getStarted: "\u041F\u043E\u0447\u0430\u0442\u0438",
        tryDemo: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0434\u0435\u043C\u043E",
        viewPitch: "\u041F\u0440\u0435\u0437\u0435\u043D\u0442\u0430\u0446\u0456\u044F",
        heroTagline: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0456\u0457",
        heroTitle: "\u0423\u0441\u0456 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438",
        heroSubtitle: "\u0412\u0430\u0448 AI-\u0430\u0441\u0438\u0441\u0442\u0435\u043D\u0442 \u0434\u043B\u044F \u043F\u043E\u0448\u0443\u043A\u0443 \u043D\u0430\u0439\u043A\u0440\u0430\u0449\u043E\u0457 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u0457 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438 \u0432 \u0413\u0440\u0443\u0437\u0456\u0457",
        searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u043A\u043B\u0456\u043D\u0456\u043A, \u043F\u043E\u0441\u043B\u0443\u0433 \u0430\u0431\u043E \u0437\u0430\u043F\u0438\u0442\u0430\u0439\u0442\u0435...",
        chipImplant: "\u041A\u0440\u0430\u0449\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438 \u0456\u043C\u043F\u043B\u0430\u043D\u0442\u0430\u0446\u0456\u0457 \u0443 \u0422\u0431\u0456\u043B\u0456\u0441\u0456",
        chipWhitening: "\u0412\u0456\u0434\u0431\u0456\u043B\u044E\u0432\u0430\u043D\u043D\u044F \u0437\u0443\u0431\u0456\u0432 \u043F\u043E\u0440\u0443\u0447",
        chipEmergency: "\u0415\u043A\u0441\u0442\u0440\u0435\u043D\u0430 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
        chipOrtho: "\u041E\u0440\u0442\u043E\u0434\u043E\u043D\u0442\u0456\u044F \u0434\u043B\u044F \u0434\u043E\u0440\u043E\u0441\u043B\u0438\u0445",
        scrollExplore: "\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u0456\u0442\u044C \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443",
        topRated: "\u041D\u0430\u0439\u043A\u0440\u0430\u0449\u0456 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438 \u0422\u0431\u0456\u043B\u0456\u0441\u0456",
        viewAllClinics: "\u0412\u0441\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438",
        shareLocation: "\u041F\u043E\u0434\u0456\u043B\u0456\u0442\u044C\u0441\u044F \u043B\u043E\u043A\u0430\u0446\u0456\u0454\u044E",
        locationShared: "\u041B\u043E\u043A\u0430\u0446\u0456\u044E \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
        statClinics: "\u041A\u043B\u0456\u043D\u0456\u043A\u0438",
        statNoShows: "\u041C\u0435\u043D\u0448\u0435 \u043D\u0435\u044F\u0432\u043E\u043A",
        statBooking: "\u041E\u043D\u043B\u0430\u0439\u043D \u0437\u0430\u043F\u0438\u0441",
        statDentists: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438",
        statRating: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433",
        statPatients: "\u041F\u0430\u0446\u0456\u0454\u043D\u0442\u0438",
        findClinics: "\u0417\u043D\u0430\u0439\u0442\u0438 \u043A\u043B\u0456\u043D\u0456\u043A\u0438",
        forBusinessBtn: "\u0414\u043B\u044F \u0431\u0456\u0437\u043D\u0435\u0441\u0443",
        ownClinic: "\u0412\u0438 \u0432\u043B\u0430\u0441\u043D\u0438\u043A \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u0457 \u043A\u043B\u0456\u043D\u0456\u043A\u0438?",
        claimText: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0439\u0442\u0435 \u0441\u0432\u043E\u044E \u043A\u043B\u0456\u043D\u0456\u043A\u0443 \u0432 \u043D\u0430\u0448\u0456\u0439 \u0431\u0430\u0437\u0456.",
        getListed: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u2192",
        clinicsTitle: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438 \u0432 \u0413\u0440\u0443\u0437\u0456\u0457",
        verifiedClinics: "\u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043A\u043B\u0456\u043D\u0456\u043A",
        searchByName: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u0440\u0430\u0439\u043E\u043D\u043E\u043C \u0430\u0431\u043E \u043F\u043E\u0441\u043B\u0443\u0433\u043E\u044E...",
        hideMap: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043A\u0430\u0440\u0442\u0443",
        showMap: "\u041A\u0430\u0440\u0442\u0430",
        nearMe: "\u041F\u043E\u0440\u0443\u0447",
        clinicsMatch: "\u043A\u043B\u0456\u043D\u0456\u043A \u0437\u0431\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F",
        reviews: "\u0432\u0456\u0434\u0433\u0443\u043A\u0456\u0432",
        loadingMore: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
        callClinic: "\u0417\u0430\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443\u0432\u0430\u0442\u0438",
        bookAppointment: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438\u0441\u044F",
        services: "\u041F\u043E\u0441\u043B\u0443\u0433\u0438",
        workingHours: "\u0413\u043E\u0434\u0438\u043D\u0438 \u0440\u043E\u0431\u043E\u0442\u0438",
        priceRange: "\u0414\u0456\u0430\u043F\u0430\u0437\u043E\u043D \u0446\u0456\u043D",
        location: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
        visitWebsite: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442",
        bookingTitle: "\u0417\u0430\u043F\u0438\u0441 \u043D\u0430 \u043F\u0440\u0438\u0439\u043E\u043C",
        step: "\u041A\u0440\u043E\u043A",
        selectClinic: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u043B\u0456\u043D\u0456\u043A\u0443",
        selectService: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u043E\u0441\u043B\u0443\u0433\u0443",
        selectDate: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0430\u0442\u0443",
        selectTime: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0430\u0441",
        confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        next: "\u0414\u0430\u043B\u0456",
        back: "\u041D\u0430\u0437\u0430\u0434",
        clinicsAvailable: "\u043A\u043B\u0456\u043D\u0456\u043A \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        clinicsFound: "\u043A\u043B\u0456\u043D\u0456\u043A \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        confirmBooking: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0437\u0430\u043F\u0438\u0441",
        bookingConfirmed: "\u0412\u0430\u0448 \u0432\u0456\u0437\u0438\u0442 \u0437\u0430\u0431\u0440\u043E\u043D\u044C\u043E\u0432\u0430\u043D\u043E!",
        patientName: "\u0406\u043C'\u044F \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
        email: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
        notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
        businessHeroBadge: "15+ \u041C\u043E\u0434\u0443\u043B\u0456\u0432  \xb7  212+ \u041A\u043B\u0456\u043D\u0456\u043A  \xb7  Gemini AI",
        businessHeroTitle: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0439\u043D\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0434\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0438\u0445 \u043A\u043B\u0456\u043D\u0456\u043A",
        businessHeroSubtitle: "\u041A\u043B\u0456\u043D\u0456\u0447\u043D\u0435 \u043A\u0430\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F, \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0438\u0439 \u0430\u043D\u0430\u043B\u0456\u0437, \u043F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F, \u0440\u043E\u0437\u043A\u043B\u0430\u0434, \u0431\u0456\u043B\u0456\u043D\u0433, \u0435-\u0440\u0435\u0446\u0435\u043F\u0442\u0438, \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0454\u044E \u0442\u0430 \u0406\u0406-\u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 \u2014 \u0432\u0441\u0435 \u043D\u0430 \u043E\u0434\u043D\u0456\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456 \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0456\u0457.",
        theProblem: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
        problemSubtitle: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0456 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438 \u0449\u043E\u0434\u043D\u044F \u0432\u0442\u0440\u0430\u0447\u0430\u044E\u0442\u044C \u0434\u043E\u0445\u0456\u0434 \u0447\u0435\u0440\u0435\u0437 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432\u0430\u043D\u0456 \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438",
        excelChaos: "\u0425\u0430\u043E\u0441 Excel \u0442\u0430 WhatsApp",
        excelChaosDetail: "\u041A\u043B\u0456\u043D\u0456\u043A\u0438 \u043A\u0435\u0440\u0443\u044E\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u0442\u0430\u0431\u043B\u0438\u0446\u0456 \u0442\u0430 \u0447\u0430\u0442\u0438. \u041D\u0443\u043B\u044C\u043E\u0432\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0456\u044F, \u043F\u043E\u0441\u0442\u0456\u0439\u043D\u0456 \u043F\u043E\u043C\u0438\u043B\u043A\u0438.",
        noShowRate: "25% \u043D\u0435\u044F\u0432\u043E\u043A",
        noShowDetail: "\u0411\u0435\u0437 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438\u0445 \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u044C \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0438 \u0437\u0430\u0431\u0443\u0432\u0430\u044E\u0442\u044C \u043F\u0440\u043E \u0432\u0456\u0437\u0438\u0442\u0438. \u041F\u043E\u0440\u043E\u0436\u043D\u0456 \u043A\u0440\u0456\u0441\u043B\u0430 \u2014 \u20BE500+/\u0434\u0435\u043D\u044C \u0432\u0442\u0440\u0430\u0442.",
        paperCharts: "\u041F\u0430\u043F\u0435\u0440\u043E\u0432\u0456 \u043A\u0430\u0440\u0442\u0438 \u0443 2026",
        paperChartsDetail: "\u0420\u0443\u043A\u043E\u043F\u0438\u0441\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0456 \u0437\u0430\u043F\u0438\u0441\u0438, \u0431\u0435\u0437 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0457 \u043E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u0438. \u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0456 \u0434\u0430\u043D\u0456 \u0437\u0430\u043C\u043A\u043D\u0435\u043D\u0456 \u0443 \u0448\u0430\u0444\u0430\u0445.",
        insuranceBlackHole: "\u0427\u043E\u0440\u043D\u0430 \u0434\u0456\u0440\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
        insuranceDetail: "\u0420\u0443\u0447\u043D\u0456 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0457 \u0434\u043E Aldagi, GPI, Imedi L \u0437\u0430\u0439\u043C\u0430\u044E\u0442\u044C \u0433\u043E\u0434\u0438\u043D\u0438. \u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u0456 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0457 \u043D\u0430\u043A\u043E\u043F\u0438\u0447\u0443\u044E\u0442\u044C\u0441\u044F.",
        oneplatform: "\u041E\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430, \u0432\u0441\u0456 \u043C\u043E\u0434\u0443\u043B\u0456",
        platformSubtitle: "15 \u0456\u043D\u0442\u0435\u0433\u0440\u043E\u0432\u0430\u043D\u0438\u0445 \u043C\u043E\u0434\u0443\u043B\u0456\u0432 \u0434\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u0457 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438",
        clinical: "\u041A\u041B\u0406\u041D\u0406\u0427\u041D\u0406",
        operations: "\u041E\u041F\u0415\u0420\u0410\u0426\u0406\u0419\u041D\u0406",
        analyticsEnterprise: "\u0410\u041D\u0410\u041B\u0406\u0422\u0418\u041A\u0410 \u0422\u0410 ENTERPRISE",
        digitalOdontogram: "\u0426\u0438\u0444\u0440\u043E\u0432\u0430 \u043E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u0430",
        digitalOdontogramDetail: "FDI 32-\u0437\u0443\u0431\u043D\u0430 \u043A\u0430\u0440\u0442\u0430 \u0437 5-\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u0435\u0432\u0438\u043C \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F\u043C.",
        perioCharting: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0435 \u043A\u0430\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        perioChartingDetail: "192-\u0442\u043E\u0447\u043A\u043E\u0432\u0430 \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u0441\u0456\u0442\u043A\u0430. 6-\u0442\u043E\u0447\u043A\u043E\u0432\u0435 \u0437\u043E\u043D\u0434\u0443\u0432\u0430\u043D\u043D\u044F, BOP, CAL.",
        treatmentPlanning: "\u041F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        treatmentPlanningDetail: "\u0424\u0430\u0437\u043E\u0432\u0456 \u043F\u043B\u0430\u043D\u0438 \u0437 CDT-\u043A\u043E\u0434\u0430\u043C\u0438, \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0438\u043C\u0438 \u043E\u0446\u0456\u043D\u043A\u0430\u043C\u0438. \u0406\u0406-\u0441\u0435\u043A\u0432\u0435\u043D\u0443\u0432\u0430\u043D\u043D\u044F.",
        soapNotes: "SOAP \u0437\u0430\u043F\u0438\u0441\u0438 + \u0406\u0406 \u0441\u043A\u0440\u0430\u0439\u0431",
        soapNotesDetail: "\u0421\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u043E\u0432\u0430\u043D\u0430 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F \u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0430\u043C\u0438. Gemini \u0433\u0435\u043D\u0435\u0440\u0443\u0454 \u0437\u0430\u043F\u0438\u0441\u0438 \u0437 \u0433\u043E\u043B\u043E\u0441\u0443.",
        multiChairScheduling: "\u0411\u0430\u0433\u0430\u0442\u043E\u043A\u0440\u0456\u0441\u0435\u043B\u044C\u043D\u0438\u0439 \u0440\u043E\u0437\u043A\u043B\u0430\u0434",
        multiChairDetail: "\u0422\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434 \u0437 \u043A\u0456\u043B\u044C\u043A\u043E\u043C\u0430 \u043A\u0430\u0431\u0456\u043D\u0435\u0442\u0430\u043C\u0438. \u041A\u043E\u043B\u044C\u043E\u0440\u043E\u0432\u0435 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0430\u0440\u0456\u0432.",
        billingInsurance: "\u0411\u0456\u043B\u0456\u043D\u0433 \u0442\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
        billingDetail: "\u0412\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0439 \u0434\u043B\u044F Aldagi, GPI, Imedi L. \u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0456\u044F, \u043F\u043B\u0430\u043D\u0438 \u043E\u043F\u043B\u0430\u0442\u0438.",
        ePrescribing: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0456 \u0440\u0435\u0446\u0435\u043F\u0442\u0438",
        ePrescribingDetail: "\u0426\u0438\u0444\u0440\u043E\u0432\u0456 \u0440\u0435\u0446\u0435\u043F\u0442\u0438 \u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0430\u043C\u0438. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0432\u0437\u0430\u0454\u043C\u043E\u0434\u0456\u0439 \u043B\u0456\u043A\u0456\u0432 \u0447\u0435\u0440\u0435\u0437 Gemini.",
        labTracking: "\u0412\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0457",
        labTrackingDetail: "\u041A\u0430\u043D\u0431\u0430\u043D: \u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E \u2192 \u0412\u0438\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u2192 \u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u2192 \u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E.",
        productionReports: "\u0417\u0432\u0456\u0442\u0438 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u0430",
        productionReportsDetail: "\u0412\u0430\u043B\u043E\u0432\u0435/\u0447\u0438\u0441\u0442\u0435 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E, \u0440\u0456\u0432\u0435\u043D\u044C \u0437\u0431\u043E\u0440\u0443, \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F.",
        referralMgmt: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F\u043C\u0438",
        referralMgmtDetail: "\u0412\u0445\u0456\u0434\u043D\u0456/\u0432\u0438\u0445\u0456\u0434\u043D\u0456 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0434\u043E \u0441\u043F\u0435\u0446\u0456\u0430\u043B\u0456\u0441\u0442\u0456\u0432. \u0406\u0406-\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u0456 \u043B\u0438\u0441\u0442\u0438.",
        medicalHistory: "\u041C\u0435\u0434\u0438\u0447\u043D\u0430 \u0456\u0441\u0442\u043E\u0440\u0456\u044F",
        medicalHistoryDetail: "11-\u0432\u0438\u0434\u043E\u0432\u0430 \u043A\u0430\u0440\u0442\u0430 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430: \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u044F, \u0441\u0442\u0430\u043D\u0438, \u043C\u0435\u0434\u0438\u043A\u0430\u043C\u0435\u043D\u0442\u0438, \u0430\u043B\u0435\u0440\u0433\u0456\u0457.",
        enterpriseAdmin: "Enterprise \u0430\u0434\u043C\u0456\u043D",
        enterpriseAdminDetail: "RBAC, \u0436\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0443, \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C, \u043C\u0443\u043B\u044C\u0442\u0438\u043E\u0440\u0435\u043D\u0434\u043D\u0456\u0441\u0442\u044C, SSO, \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F API.",
        geminiBuiltIn: "\u0412\u0431\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0439 Gemini AI",
        geminiSubtitle: "\u041A\u043E\u0436\u0435\u043D \u043C\u043E\u0434\u0443\u043B\u044C \u043F\u0440\u0430\u0446\u044E\u0454 \u043D\u0430 Google Gemini 3.1",
        xrayAnalysis: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0440\u0435\u043D\u0442\u0433\u0435\u043D\u0443",
        xrayDetail: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u0440\u0435\u043D\u0442\u0433\u0435\u043D\u043E\u0433\u0440\u0430\u043C\u0438 \u0434\u043B\u044F \u0406\u0406-\u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0438 \u043A\u0430\u0440\u0456\u0454\u0441\u0443.",
        perioAssessment: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u043E\u0446\u0456\u043D\u043A\u0430",
        perioAssessmentDetail: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u0441\u0442\u0430\u0434\u0456\u044E\u0432\u0430\u043D\u043D\u044F/\u0433\u0440\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F AAP \u0437\u0430 \u0434\u0430\u043D\u0438\u043C\u0438 \u0437\u043E\u043D\u0434\u0443\u0432\u0430\u043D\u043D\u044F.",
        clinicalScribe: "\u041A\u043B\u0456\u043D\u0456\u0447\u043D\u0438\u0439 \u0441\u043A\u0440\u0430\u0439\u0431",
        clinicalScribeDetail: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F SOAP-\u0437\u0430\u043F\u0438\u0441\u0456\u0432 \u0437 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 \u0430\u0431\u043E \u0434\u0430\u043D\u0438\u0445 \u043A\u0430\u0440\u0442\u0438.",
        riskProfiling: "\u041F\u0440\u043E\u0444\u0456\u043B\u044E\u0432\u0430\u043D\u043D\u044F \u0440\u0438\u0437\u0438\u043A\u0456\u0432",
        riskProfilingDetail: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0441\u0442\u0430\u043D\u0456\u0432, \u0441\u0456\u043C\u0435\u0439\u043D\u043E\u0433\u043E \u0430\u043D\u0430\u043C\u043D\u0435\u0437\u0443 \u0434\u043B\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u0444\u0456\u043B\u044E \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u0433\u043E \u0440\u0438\u0437\u0438\u043A\u0443.",
        treatmentSequencing: "\u0421\u0435\u043A\u0432\u0435\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        treatmentSequencingDetail: "\u0406\u0406-\u043E\u043F\u0442\u0438\u043C\u0456\u0437\u043E\u0432\u0430\u043D\u0435 \u0444\u0430\u0437\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0437 \u0443\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F\u043C \u0437\u0430\u0433\u043E\u0454\u043D\u043D\u044F \u0442\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F.",
        patientComm: "\u041A\u043E\u043C\u0443\u043D\u0456\u043A\u0430\u0446\u0456\u044F \u0437 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u043E\u043C",
        patientCommDetail: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F \u0437\u0440\u043E\u0437\u0443\u043C\u0456\u043B\u0438\u0445 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0443 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u044C \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u044E \u043C\u043E\u0432\u043E\u044E.",
        georgianEcosystem: "\u0413\u043E\u0442\u043E\u0432\u043E \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u0457 \u0435\u043A\u043E\u0441\u0438\u0441\u0442\u0435\u043C\u0438",
        integrationsSubtitle: "\u041F\u0435\u0440\u0435\u0434\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0456 \u0456\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457 \u0437 \u043C\u0456\u0441\u0446\u0435\u0432\u0438\u043C \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F\u043C, \u043F\u043B\u0430\u0442\u0435\u0436\u0430\u043C\u0438 \u0442\u0430 \u043C\u0435\u0441\u0435\u043D\u0434\u0436\u0435\u0440\u0430\u043C\u0438",
        insurance: "\u0421\u0422\u0420\u0410\u0425\u0423\u0412\u0410\u041D\u041D\u042F",
        payments: "\u041F\u041B\u0410\u0422\u0415\u0416\u0406",
        messaging: "\u041F\u041E\u0412\u0406\u0414\u041E\u041C\u041B\u0415\u041D\u041D\u042F",
        ehrLabs: "\u0415\u041C\u041A \u0422\u0410 \u041B\u0410\u0411\u041E\u0420\u0410\u0422\u041E\u0420\u0406\u0407",
        clinicsInDb: "\u041A\u043B\u0456\u043D\u0456\u043A \u0443 \u0431\u0430\u0437\u0456",
        platformModules: "\u041C\u043E\u0434\u0443\u043B\u0456\u0432 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0438",
        aiTools: "\u0406\u0406-\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0456\u0432 (Gemini)",
        integrations: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0439",
        pricingTitle: "\u0426\u0456\u043D\u0438",
        pricingSubtitle: "\u041F\u043E\u0447\u043D\u0456\u0442\u044C \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
        trustedBy: "\u0414\u043E\u0432\u0456\u0440\u0430 \u043A\u043B\u0456\u043D\u0456\u043A",
        readyModernize: "\u0413\u043E\u0442\u043E\u0432\u0456 \u0434\u043E \u043C\u043E\u0434\u0435\u0440\u043D\u0456\u0437\u0430\u0446\u0456\u0457?",
        joinCount: "\u041F\u0440\u0438\u0454\u0434\u043D\u0443\u0439\u0442\u0435\u0441\u044C \u0434\u043E 212+ \u043A\u043B\u0456\u043D\u0456\u043A \u0443 \u0413\u0440\u0443\u0437\u0456\u0457.",
        startTrial: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
        contactSales: "\u0417\u0432'\u044F\u0437\u0430\u0442\u0438\u0441\u044F \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0430\u043C\u0438",
        noCreditCard: "\u0411\u0435\u0437 \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u043E\u0457 \u043A\u0430\u0440\u0442\u043A\u0438  \xb7  \u0411\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0438\u0439 \u0442\u0430\u0440\u0438\u0444  \xb7  \u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430 5 \u0445\u0432\u0438\u043B\u0438\u043D",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u041F\u0430\u043D\u0435\u043B\u044C",
        navPatients: "\u041F\u0430\u0446\u0456\u0454\u043D\u0442\u0438",
        navChart: "\u041A\u0430\u0440\u0442\u0430",
        navPerio: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u044F",
        navTreatmentPlans: "\u041F\u043B\u0430\u043D\u0438 \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        navNotes: "\u0417\u0430\u043F\u0438\u0441\u0438",
        navScheduling: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434",
        navBilling: "\u0411\u0456\u043B\u0456\u043D\u0433",
        navPrescriptions: "\u0420\u0435\u0446\u0435\u043F\u0442\u0438",
        navLabCases: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u043D\u0456 \u0432\u0438\u043F\u0430\u0434\u043A\u0438",
        navReferrals: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
        navReports: "\u0417\u0432\u0456\u0442\u0438",
        navMedHistory: "\u041C\u0435\u0434\u0438\u0447\u043D\u0430 \u0456\u0441\u0442\u043E\u0440\u0456\u044F",
        navIntegrations: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457",
        navEnterprise: "\u041F\u0456\u0434\u043F\u0440\u0438\u0454\u043C\u0441\u0442\u0432\u043E",
        sectionClinical: "\u041A\u041B\u0406\u041D\u0406\u041A\u0410",
        sectionOperations: "\u041E\u041F\u0415\u0420\u0410\u0426\u0406\u0407",
        sectionAnalytics: "\u0410\u041D\u0410\u041B\u0406\u0422\u0418\u041A\u0410",
        sectionAiTools: "\u0406\u0406 \u0406\u041D\u0421\u0422\u0420\u0423\u041C\u0415\u041D\u0422\u0418",
        sectionAdmin: "\u0410\u0414\u041C\u0406\u041D\u0406\u0421\u0422\u0420\u0423\u0412\u0410\u041D\u041D\u042F",
        // Booking Page
        chooseClinic: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u043B\u0456\u043D\u0456\u043A\u0443",
        selectAService: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u043E\u0441\u043B\u0443\u0433\u0443",
        pickADate: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0430\u0442\u0443",
        pickATime: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0430\u0441",
        confirmYourBooking: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0437\u0430\u043F\u0438\u0441",
        clinicLabel: "\u041A\u043B\u0456\u043D\u0456\u043A\u0430:",
        serviceLabel: "\u041F\u043E\u0441\u043B\u0443\u0433\u0430:",
        dateLabel: "\u0414\u0430\u0442\u0430:",
        timeLabel: "\u0427\u0430\u0441:",
        // AI Page
        send: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        procedure: "\u041F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430",
        observations: "\u0421\u043F\u043E\u0441\u0442\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
        aiThinking: "\u0406\u0406 \u0434\u0443\u043C\u0430\u0454...",
        summarizeHistory: "\u0423\u0437\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0442\u0438 \u0456\u0441\u0442\u043E\u0440\u0456\u044E \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        generateTxPlan: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043F\u043B\u0430\u043D \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        checkDrugInteractions: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0432\u0437\u0430\u0454\u043C\u043E\u0434\u0456\u044E \u043B\u0456\u043A\u0456\u0432",
        writeClinicalNote: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
        askAiAssistant: "\u0417\u0430\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u0406\u0406-\u0430\u0441\u0438\u0441\u0442\u0435\u043D\u0442\u0430...",
        dropXray: "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0440\u0435\u043D\u0442\u0433\u0435\u043D \u0430\u0431\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0434\u043B\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        supportsFormats: "\u041F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u044E\u0442\u044C\u0441\u044F DICOM, PNG, JPG",
        analysisResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u0430\u043D\u0430\u043B\u0456\u0437\u0443 (\u0434\u0435\u043C\u043E)",
        aiRecommendation: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u044F \u0406\u0406",
        exportToTxPlan: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0443 \u043F\u043B\u0430\u043D \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        generateClinicalNote: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
        generatedSoap: "\u0417\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u0438\u0439 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 (SOAP)",
        subjective: "S \u2014 \u0421\u0443\u0431'\u0454\u043A\u0442\u0438\u0432\u043D\u0435",
        objective: "O \u2014 \u041E\u0431'\u0454\u043A\u0442\u0438\u0432\u043D\u0435",
        assessment: "A \u2014 \u041E\u0446\u0456\u043D\u043A\u0430",
        plan: "P \u2014 \u041F\u043B\u0430\u043D",
        copyToRecord: "\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0434\u043E \u043A\u0430\u0440\u0442\u0438 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        aiPerioAssessment: "\u0406\u0406 \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u043E\u0446\u0456\u043D\u043A\u0430",
        enterProbingData: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0434\u0430\u043D\u0456 \u0437\u043E\u043D\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043B\u044F AAP \u0441\u0442\u0430\u0434\u0456\u044E\u0432\u0430\u043D\u043D\u044F \u0442\u0430 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u0439 \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F.",
        analyzeWithGemini: "\u0410\u043D\u0430\u043B\u0456\u0437\u0443\u0432\u0430\u0442\u0438 \u0437 Gemini",
        aiRiskAssessment: "\u0406\u0406 \u043E\u0446\u0456\u043D\u043A\u0430 \u0440\u0438\u0437\u0438\u043A\u0456\u0432",
        enterConditions: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0441\u0442\u0430\u043D \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430, \u0441\u0456\u043C\u0435\u0439\u043D\u0438\u0439 \u0430\u043D\u0430\u043C\u043D\u0435\u0437 \u0442\u0430 \u0432\u0456\u0442\u0430\u043B\u044C\u043D\u0456 \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u0457 \u043F\u0440\u043E\u0444\u0456\u043B\u044E \u0440\u0438\u0437\u0438\u043A\u0443.",
        generateRiskProfile: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u043E\u0444\u0456\u043B\u044C \u0440\u0438\u0437\u0438\u043A\u0443",
        patientCommunication: "\u041A\u043E\u043C\u0443\u043D\u0456\u043A\u0430\u0446\u0456\u044F \u0437 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u043E\u043C",
        generateExplanations: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F \u0437\u0440\u043E\u0437\u0443\u043C\u0456\u043B\u0438\u0445 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0443 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u044C \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u044E \u0430\u0431\u043E \u0430\u043D\u0433\u043B\u0456\u0439\u0441\u044C\u043A\u043E\u044E.",
        generateExplanation: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u043D\u044F",
        patientFriendly: "\u0417\u0440\u043E\u0437\u0443\u043C\u0456\u043B\u0435 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0443 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u043D\u044F",
        // Billing Page
        claims: "\u041F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0457",
        ledger: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u044C\u043A\u0430 \u043A\u043D\u0438\u0433\u0430",
        aging: "\u0421\u0442\u0430\u0440\u0456\u043D\u043D\u044F \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u043E\u0441\u0442\u0456",
        paymentPlans: "\u041F\u043B\u0430\u043D\u0438 \u043E\u043F\u043B\u0430\u0442\u0438",
        eligibility: "\u041F\u0440\u0430\u0432\u043E \u043D\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
        allFilter: "\u0423\u0441\u0456",
        submitted: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
        paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        denied: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        patientLedger: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0456\u044F \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        agedAccounts: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u0440\u0430\u0445\u0443\u043D\u043A\u0438",
        sendStatements: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0432\u0438\u043F\u0438\u0441\u043A\u0438",
        activePaymentPlans: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043F\u043B\u0430\u043D\u0438 \u043E\u043F\u043B\u0430\u0442\u0438",
        insuranceEligibility: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0435 \u043F\u0440\u0430\u0432\u043E",
        // Clinical Charting
        odontogram: "\u041E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u0430",
        perioTab: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u044F",
        treatmentPlanTab: "\u041F\u043B\u0430\u043D \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        notesTab: "\u0417\u0430\u043F\u0438\u0441\u0438",
        progressNotes: "\u0417\u0430\u043F\u0438\u0441\u0438 \u043F\u0440\u043E \u043F\u0440\u043E\u0433\u0440\u0435\u0441",
        openFullPerio: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u043E\u0432\u043D\u0443 \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0443 \u043A\u0430\u0440\u0442\u0443 \u2192",
        openFullTxPlanner: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u043F\u043B\u0430\u043D\u0443\u0432\u0430\u043B\u044C\u043D\u0438\u043A \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u2192",
        openClinicalNotes: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0456 \u0437\u0430\u043F\u0438\u0441\u0438 \u2192",
        newExam: "\u041D\u043E\u0432\u0438\u0439 \u043E\u0433\u043B\u044F\u0434",
        voiceEntry: "\u0413\u043E\u043B\u043E\u0441\u043E\u0432\u0438\u0439 \u0432\u0432\u0456\u0434",
        bleedingIndex: "\u0406\u043D\u0434\u0435\u043A\u0441 \u043A\u0440\u043E\u0432\u043E\u0442\u043E\u0447\u0438\u0432\u043E\u0441\u0442\u0456",
        plaqueIndex: "\u0406\u043D\u0434\u0435\u043A\u0441 \u043D\u0430\u043B\u044C\u043E\u0442\u0443",
        sitesAbove4: "\u0414\u0456\u043B\u044F\u043D\u043A\u0438 \u2265 4\u043C\u043C",
        sitesAbove6: "\u0414\u0456\u043B\u044F\u043D\u043A\u0438 \u2265 6\u043C\u043C",
        planA: "\u041F\u043B\u0430\u043D A: \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0439",
        planB: "\u041F\u043B\u0430\u043D B: \u041A\u043E\u043D\u0441\u0435\u0440\u0432\u0430\u0442\u0438\u0432\u043D\u0438\u0439",
        newPlan: "+ \u041D\u043E\u0432\u0438\u0439 \u043F\u043B\u0430\u043D",
        presentToPatient: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0443",
        sendToPortal: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043D\u0430 \u043F\u043E\u0440\u0442\u0430\u043B",
        totalFee: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
        insuranceEst: "\u041E\u0446\u0456\u043D\u043A\u0430 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u043A\u0438",
        patientPortion: "\u0427\u0430\u0441\u0442\u043A\u0430 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        chairSideMode: "\u0420\u0435\u0436\u0438\u043C \u0431\u0456\u043B\u044F \u043A\u0440\u0456\u0441\u043B\u0430",
        adminMode: "\u0420\u0435\u0436\u0438\u043C \u0430\u0434\u043C\u0456\u043D\u0430",
        proceduresAcrossPhases: "{0} \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440 \u0443 {1} \u0444\u0430\u0437\u0430\u0445",
        // Scheduling
        day: "\u0414\u0435\u043D\u044C",
        week: "\u0422\u0438\u0436\u0434\u0435\u043D\u044C",
        today: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        providerFilter: "\u0423\u0441\u0456 \u043B\u0456\u043A\u0430\u0440\u0456",
        productionGoal: "\u0426\u0456\u043B\u044C \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u0430",
        waitlist: "\u041B\u0438\u0441\u0442 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        // Prescriptions
        activeRx: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
        pastRx: "\u041C\u0438\u043D\u0443\u043B\u0456",
        templates: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438",
        interactionCheck: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0432\u0437\u0430\u0454\u043C\u043E\u0434\u0456\u0439",
        // Lab Cases
        ordered: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
        sentToLab: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0434\u043E \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0457",
        inFabrication: "\u0423 \u0432\u0438\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u0456",
        shipped: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        received: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
        labVendors: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0438 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0439",
        // Referrals
        allDirections: "\u0423\u0441\u0456",
        inbound: "\u0412\u0445\u0456\u0434\u043D\u0456",
        outbound: "\u0412\u0438\u0445\u0456\u0434\u043D\u0456",
        generateLetter: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043B\u0438\u0441\u0442",
        // Reports
        production: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
        collections: "\u0417\u0431\u043E\u0440\u0438",
        schedulingReport: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434",
        treatmentAcceptance: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        recall: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0438\u0439 \u0432\u0438\u043A\u043B\u0438\u043A",
        grossProduction: "\u0412\u0430\u043B\u043E\u0432\u0435 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
        netProduction: "\u0427\u0438\u0441\u0442\u0435 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
        collectionRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u0437\u0431\u043E\u0440\u0443",
        plansPresented: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u043F\u043B\u0430\u043D\u0456\u0432",
        accepted: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
        acceptanceRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F",
        dueThisMonth: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E \u043D\u0430 \u0446\u0435\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        scheduled: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E",
        completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        overdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
        reactivationRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u0440\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u0457",
        // Medical History
        timeline: "\u0425\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u044F",
        conditions: "\u0421\u0442\u0430\u043D\u0438",
        medications: "\u041C\u0435\u0434\u0438\u043A\u0430\u043C\u0435\u043D\u0442\u0438",
        allergies: "\u0410\u043B\u0435\u0440\u0433\u0456\u0457",
        labResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u0430\u043D\u0430\u043B\u0456\u0437\u0456\u0432",
        vitals: "\u0412\u0456\u0442\u0430\u043B\u044C\u043D\u0456 \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A\u0438",
        immunizations: "\u0406\u043C\u0443\u043D\u0456\u0437\u0430\u0446\u0456\u0457",
        familyHistory: "\u0421\u0456\u043C\u0435\u0439\u043D\u0438\u0439 \u0430\u043D\u0430\u043C\u043D\u0435\u0437",
        imaging: "\u0412\u0456\u0437\u0443\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F",
        documents: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u0416\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0443",
        compliance: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C",
        multiTenancy: "\u041C\u0443\u043B\u044C\u0442\u0438\u043E\u0440\u0435\u043D\u0434\u043D\u0456\u0441\u0442\u044C",
        sso: "SSO \u0442\u0430 \u0431\u0435\u0437\u043F\u0435\u043A\u0430",
        featureFlags: "\u041F\u0440\u0430\u043F\u043E\u0440\u0446\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0439",
        apiManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F API",
        dataManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u043C\u0438",
        // Integrations
        ehr: "\u0415\u041C\u041A",
        labs: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0457",
        telehealth: "\u0422\u0435\u043B\u0435\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0430",
        aiMl: "\u0406\u0406/\u041C\u041D",
        wearables: "\u041D\u043E\u0441\u0438\u043C\u0456 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457",
        connected: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        disconnected: "\u0412\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        // Components
        status: "\u0421\u0442\u0430\u0442\u0443\u0441",
        healthy: "\u0417\u0434\u043E\u0440\u043E\u0432\u0438\u0439",
        caries: "\u041A\u0430\u0440\u0456\u0454\u0441",
        restored: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439",
        missing: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439",
        implant: "\u0406\u043C\u043F\u043B\u0430\u043D\u0442",
        crownStatus: "\u041A\u043E\u0440\u043E\u043D\u043A\u0430",
        bridge: "\u041C\u0456\u0441\u0442",
        veneer: "\u0412\u0456\u043D\u0456\u0440",
        surfaces: "\u041F\u043E\u0432\u0435\u0440\u0445\u043D\u0456",
        procedureHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440",
        addProcedure: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443",
        totalCharged: "\u0412\u0441\u044C\u043E\u0433\u043E \u043D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
        insurancePayment: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436",
        patientResponsibility: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0456\u0441\u0442\u044C \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        expand: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
        policyNumber: "\u041F\u043E\u043B\u0456\u0441 \u2116",
        planType: "\u0422\u0438\u043F \u043F\u043B\u0430\u043D\u0443",
        annualMax: "\u0420\u0456\u0447\u043D\u0438\u0439 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C",
        used: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043E",
        remaining: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A",
        coverageByCategory: "\u041F\u043E\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u043C\u0438",
        preventive: "\u041F\u0440\u043E\u0444\u0456\u043B\u0430\u043A\u0442\u0438\u043A\u0430",
        basic: "\u0411\u0430\u0437\u043E\u0432\u0435",
        major: "\u041E\u0441\u043D\u043E\u0432\u043D\u0435",
        ortho: "\u041E\u0440\u0442\u043E\u0434\u043E\u043D\u0442\u0456\u044F",
        current: "\u041F\u043E\u0442\u043E\u0447\u043D\u0456",
        thirtyDay: "30 \u0434\u043D\u0456\u0432",
        sixtyDay: "60 \u0434\u043D\u0456\u0432",
        ninetyPlus: "90+ \u0434\u043D\u0456\u0432",
        totalBalance: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441",
        monthlyPayment: "\u0429\u043E\u043C\u0456\u0441\u044F\u0447\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436",
        paymentsRemaining: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0456\u0432",
        nextPayment: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436",
        paymentProgress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441 \u043E\u043F\u043B\u0430\u0442\u0438",
        choosePlan: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043F\u043B\u0430\u043D",
        aiInsight: "\u0406\u0406 \u0456\u043D\u0441\u0430\u0439\u0442",
        confidence: "\u0412\u043F\u0435\u0432\u043D\u0435\u043D\u0456\u0441\u0442\u044C",
        revoke: "\u0412\u0456\u0434\u043A\u043B\u0438\u043A\u0430\u0442\u0438",
        exams: "\u041E\u0433\u043B\u044F\u0434\u0438",
        phaseTotal: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u0444\u0430\u0437\u0438",
        mon: "\u041F\u043D",
        tue: "\u0412\u0442",
        wed: "\u0421\u0440",
        thu: "\u0427\u0442",
        fri: "\u041F\u0442",
        sat: "\u0421\u0431",
        sun: "\u041D\u0434",
        thinking: "\u0414\u0443\u043C\u0430\u044E...",
        followUpPlaceholder: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0435 \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F...",
        priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
        patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
        tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
        chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
        english: 'English',
        patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
        xrayAnalysis2: 'X-ray Analysis',
        uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment2: 'Perio Assessment',
        automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe2: 'Clinical Scribe',
        generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling2: 'Risk Profiling',
        analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing2: 'Treatment Sequencing',
        aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientCommunication2: 'Patient Communication',
        generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        insurance2: 'INSURANCE',
        automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
        payments2: 'PAYMENTS',
        onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
        messaging2: 'MESSAGING',
        appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
        ehrLabs2: 'EHR & LABS',
        interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
        clinicsInDatabase: 'Clinics in Database',
        platformModules2: 'Platform Modules',
        integrations2: 'Integrations',
        home2: 'Home',
        features2: 'Features',
        pricing2: 'Pricing',
        dashboard2: 'Dashboard',
        u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
        openFullPeriodontalChart: "Open Full Periodontal Chart \u2192",
        openFullTreatmentPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes2: "Open Clinical Notes \u2192",
        backToAllClinics: "\u2190 Back to all clinics",
        priceRange2: 'Price range:',
        bookAnAppointment: 'Book an Appointment',
        selectDate2: 'Select date',
        selectTime2: 'Select time',
        confirmBooking2: "Confirm Booking \u2192",
        clinics: 'Clinics',
        forBusiness2: 'For Business',
        u00a92026Mcai: '\u00A9 2026 MCAI',
        clinicalNotes: 'Clinical Notes',
        newNote: '+ New Note',
        template: 'Template:',
        crownPrep: 'Crown Prep',
        aiScribe: 'AI Scribe',
        recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
        startRecording: 'Start Recording',
        generateNote: 'Generate Note',
        general: 'General',
        prosthetics: 'Prosthetics',
        typeToSearch: 'Type to search dental terms...',
        revenueToday: 'Revenue Today',
        noshows: 'No-shows',
        confirmed: 'Confirmed',
        time: 'TIME',
        patient: 'PATIENT',
        service: 'SERVICE',
        doctor: 'DOCTOR',
        status2: 'STATUS',
        addPatient: '+ Add Patient',
        mondayMarch19: 'Monday, March 19',
        gBeridzeCheckup: "G. Beridze \u2014 Checkup",
        nKapanadzeWhitening: "N. Kapanadze \u2014 Whitening",
        dGelashviliImplantPhase: "D. Gelashvili \u2014 Implant Phase 2",
        lunchBreak: "\u2014 Lunch Break \u2014",
        mTsiklauriOrthodontics: "M. Tsiklauri \u2014 Orthodontics",
        aJavakhishviliRootCanal: "A. Javakhishvili \u2014 Root Canal",
        lMchedlishviliExtraction: "L. Mchedlishvili \u2014 Extraction",
        tLomidzeCheckup: "T. Lomidze \u2014 Checkup",
        clinicName: 'Clinic Name',
        phone: 'Phone',
        address: 'Address',
        acceptedInsurance: 'Accepted Insurance',
        unison: 'Unison',
        saveSettings: 'Save Settings',
        aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
        openTheFullAi: "Open the full AI Assistant \u2192",
        enterprise: 'Enterprise',
        rolebasedAccessControl: 'Role-Based Access Control',
        permissionMatrix: 'Permission Matrix',
        module: 'Module',
        admin: 'Admin',
        doctor2: 'Doctor',
        hygienist: 'Hygienist',
        reception: 'Reception',
        lab: 'Lab',
        patient2: 'Patient',
        patients: 'Patients',
        full: 'Full',
        read: 'Read',
        none: 'None',
        own: 'Own',
        billing: 'Billing',
        scheduling: 'Scheduling',
        reports: 'Reports',
        settings: 'Settings',
        labOrders: 'Lab Orders',
        auditLog2: 'Audit Log',
        allTypes: 'All Types',
        last7Days: 'Last 7 days',
        complianceDashboard: 'Compliance Dashboard',
        complianceChecklist: 'Compliance Checklist',
        pass: 'PASS',
        dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
        dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
        mfaEnabledForAll: 'MFA enabled for all admin accounts',
        warn: 'WARN',
        dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
        auditLoggingActiveOn: 'Audit logging active on all modules',
        multitenancyManagement: 'Multi-Tenancy Management',
        singleSignonSso: 'Single Sign-On (SSO)',
        saml20: 'SAML 2.0',
        enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
        configured: 'Configured',
        openidConnect: 'OpenID Connect',
        oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
        available2: 'Available',
        signInWithGoogle: 'Sign in with Google organization accounts',
        connected2: 'Connected',
        azureAd: 'Azure AD',
        microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
        featureFlags2: 'Feature Flags',
        aixrayanalysis: 'ai_xray_analysis',
        aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
        voiceperio: 'voice_perio',
        voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
        patientportalv2: 'patient_portal_v2',
        nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
        whatsappreminders: 'whatsapp_reminders',
        multilanguage: 'multi_language',
        multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
        apiManagement2: 'API Management',
        requests24h: 'Requests (24h)',
        avgLatency: 'Avg Latency',
        uptime: 'Uptime',
        apiKeys: 'API Keys',
        dataManagement2: 'Data Management',
        storageUsed: 'Storage Used',
        of100Gb: 'of 100 GB',
        totalRecords: 'Total Records',
        lastBackup: 'Last Backup',
        nextIn4h: 'Next: in 4h',
        dataOperations: 'Data Operations',
        exportAllData: 'Export All Data',
        downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
        export: 'Export',
        purgeOldRecords: 'Purge Old Records',
        removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
        purge: 'Purge',
        dataMigration: 'Data Migration',
        importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
        import: 'Import',
        finance: 'Finance',
        revenueInvoicesPayments: 'Revenue, invoices & payments',
        exportReport: 'Export Report',
        monthlyRevenue: 'Monthly Revenue',
        u20be12400: '\u20BE12,400',
        pending: 'Pending',
        u20be2100: '\u20BE2,100',
        str208: '-5%',
        thisWeek: 'This Week',
        u20be3800: '\u20BE3,800',
        weeklyRevenue: 'Weekly Revenue',
        mon2: 'Mon',
        tue2: 'Tue',
        wed2: 'Wed',
        thu2: 'Thu',
        fri2: 'Fri',
        sat2: 'Sat',
        invoice: 'INVOICE',
        amount: 'AMOUNT',
        inv001: 'INV-001',
        giorgiBeridze: 'Giorgi Beridze',
        checkupXray: 'Checkup + X-ray',
        u20be80: '\u20BE80',
        inv002: 'INV-002',
        ninoKapanadze: 'Nino Kapanadze',
        whitening: 'Whitening',
        u20be120: '\u20BE120',
        inv003: 'INV-003',
        davitGelashvili: 'Davit Gelashvili',
        implantPhase1: 'Implant Phase 1',
        u20be300: '\u20BE300+',
        inv004: 'INV-004',
        anaJavakhishvili: 'Ana Javakhishvili',
        rootCanal: 'Root Canal',
        u20be149: '\u20BE149',
        u2715: '\u2715',
        configuration: 'Configuration',
        apiKey: 'API Key',
        endpointUrl: 'Endpoint URL',
        protocol: 'Protocol',
        syncSettings: 'Sync Settings',
        syncFrequency: 'Sync Frequency',
        every5Minutes: 'Every 5 minutes',
        every15Minutes: 'Every 15 minutes',
        everyHour: 'Every hour',
        manualOnly: 'Manual only',
        autosyncOnChanges: 'Auto-sync on changes',
        lastSynced: 'Last synced',
        disconnect: 'Disconnect',
        testConnection: 'Test Connection',
        labCasePipeline: 'Lab Case Pipeline',
        labVendors2: 'Lab Vendors',
        tbilisidentLab: 'TbilisiDent Lab',
        turnaround710Days: 'Turnaround: 7-10 days',
        rating485: 'Rating: 4.8/5',
        activeCases4: 'Active Cases: 4',
        caucasusDentalLab: 'Caucasus Dental Lab',
        turnaround57Days: 'Turnaround: 5-7 days',
        rating465: 'Rating: 4.6/5',
        activeCases2: 'Active Cases: 2',
        euroDentalGeorgia: 'Euro Dental Georgia',
        turnaround1014Days: 'Turnaround: 10-14 days',
        rating445: 'Rating: 4.4/5',
        enterSpaceForClinics: "Enter space for clinics \u2192",
        book: 'Book',
        followupConsultation: 'Follow-up Consultation',
        postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
        rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
        completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
        periapicalXray: 'Periapical X-ray',
        workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
        medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
        prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
        diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
        patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
        compositeFillingTooth21: 'Composite Filling - Tooth #21',
        classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
        labResultsCbcPanel: 'Lab Results: CBC Panel',
        completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
        fullmouthRadiographs: 'Full-mouth Radiographs',
        panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
        comprehensiveExamination: 'Comprehensive Examination',
        initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
        medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
        patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
        patientRegistration: 'Patient Registration',
        newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
        activeConditions: 'Active Conditions',
        chronicPeriodontitis: 'Chronic Periodontitis',
        active: 'Active',
        generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
        onsetJan2026: 'Onset: Jan 2026',
        dentalCaries: 'Dental Caries',
        resolved: 'Resolved',
        cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
        resolvedFeb2026: 'Resolved: Feb 2026',
        bruxism: 'Bruxism',
        nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
        activeMedications: 'Active Medications',
        lisinopril10mg: 'Lisinopril 10mg',
        onceDailyOral: 'Once daily, oral',
        hypertensionManagement: 'Hypertension management',
        chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
        twiceDailyOralRinse: 'Twice daily, oral rinse',
        periodontalMaintenance: 'Periodontal maintenance',
        ibuprofen400mg: 'Ibuprofen 400mg',
        asNeededForPain: 'As needed for pain, max 3x daily',
        postprocedurePainManagement: 'Post-procedure pain management',
        pastMedications: 'Past Medications',
        amoxicillin500mg: 'Amoxicillin 500mg',
        periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
        completed2: 'Completed',
        metronidazole250mg: 'Metronidazole 250mg',
        adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
        paracetamol500mg: 'Paracetamol 500mg',
        asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
        postfillingSensitivity: 'Post-filling sensitivity',
        diclofenac50mg: 'Diclofenac 50mg',
        twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
        postexamSoreness: 'Post-exam soreness',
        documentedAllergies: 'Documented Allergies',
        penicillin: 'Penicillin',
        severe: 'SEVERE',
        reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
        crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
        documentedJan102026: 'Documented: Jan 10, 2026',
        latex: 'Latex',
        moderate: 'MODERATE',
        reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
        useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
        lidocaine: 'Lidocaine',
        mild: 'MILD',
        reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
        useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
        latestVitalsMar15: "Latest Vitals \u2014 Mar 15, 2026",
        labResults2: 'Lab Results',
        test: 'TEST',
        result: 'RESULT',
        reference: 'REFERENCE',
        date: 'DATE',
        hemoglobin: 'Hemoglobin',
        platelets: 'Platelets',
        glucoseFasting: 'Glucose (fasting)',
        immunizationRecords: 'Immunization Records',
        hepatitisB: 'Hepatitis B',
        completed3doseSeries2019: 'Completed: 3-dose series, 2019',
        upToDate: 'Up to date',
        tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
        lastBooster2022: 'Last booster: 2022',
        covid19: 'COVID-19',
        lastDoseSep2024: 'Last dose: Sep 2024',
        dueForBooster: 'Due for booster',
        familyMedicalHistory: 'Family Medical History',
        father: 'Father',
        hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
        mother: 'Mother',
        osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
        sibling: 'Sibling',
        bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
        imagingRecords: 'Imaging Records',
        panoramicOpg: 'Panoramic OPG',
        periapical14: 'Periapical #14',
        bitewingRl: 'Bitewing R+L',
        patientDocuments: 'Patient Documents',
        consentFormRootCanal: 'Consent Form - Root Canal',
        treatmentPlanAgreement: 'Treatment Plan Agreement',
        medicalHistoryQuestionnaire: 'Medical History Questionnaire',
        insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
        insuranceInformation: 'Insurance Information',
        provider: 'Provider:',
        policy: 'Policy #:',
        group: 'Group:',
        corporatePlanPremium: 'Corporate Plan - Premium',
        coverage: 'Coverage:',
        deductible: 'Deductible:',
        annualMax2: 'Annual Max:',
        valid: 'Valid:',
        age34: 'Age: 34',
        lastVisitMar10: 'Last visit: Mar 10',
        nextMar19: 'Next: Mar 19',
        overview: 'Overview',
        dentalChart: 'Dental Chart',
        treatmentPlan: 'Treatment Plan',
        history: 'History',
        documents2: 'Documents',
        allergies2: 'Allergies',
        medicalNotes: 'Medical Notes',
        insurance3: 'Insurance',
        upperArch: 'Upper Arch',
        lowerArch: 'Lower Arch',
        tooth: 'TOOTH',
        procedure2: 'PROCEDURE',
        price: 'PRICE',
        rootCanalTreatment: 'Root Canal Treatment',
        ceramicCrown: 'Ceramic Crown',
        compositeFilling: 'Composite Filling',
        implantPlacement: 'Implant Placement',
        total: 'Total',
        addProcedure2: '+ Add Procedure',
        march102026: 'March 10, 2026',
        periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
        february152026: 'February 15, 2026',
        compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
        january202026: 'January 20, 2026',
        comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
        bitewingRight: 'Bitewing Right',
        bitewingLeft: 'Bitewing Left',
        uploadDocument: '+ Upload Document',
        all: 'All',
        new: 'New',
        phone2: 'PHONE',
        lastVisit: 'LAST VISIT',
        nextAppt: 'NEXT APPT',
        balance: 'BALANCE',
        pt001: 'PT-001',
        pt002: 'PT-002',
        pt003: 'PT-003',
        mariamTsiklauri: 'Mariam Tsiklauri',
        pt004: 'PT-004',
        pt005: 'PT-005',
        lukaMchedlishvili: 'Luka Mchedlishvili',
        pt006: 'PT-006',
        tamtaLomidze: 'Tamta Lomidze',
        pt007: 'PT-007',
        periodontalChart: 'Periodontal Chart',
        newExam2: '+ New Exam',
        voiceEntry2: 'Voice Entry',
        dcai: 'DCAI',
        dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
        theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
        manage: 'Manage',
        grow: 'Grow',
        marketSize: 'Market Size',
        dentalClinicsInGeorgia: 'dental clinics in Georgia',
        inTbilisiAlone: 'in Tbilisi alone',
        unifiedBookingOrOps: 'unified booking or ops platforms',
        dentosgeIsTheOnly: "\u26A0\uFE0F  dentos.ge is the only partial incumbent \u2014 no full ops layer",
        theProblem2: 'The Problem',
        str511: "\uD83D\uDCCB",
        clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
        noStructuredWorkflowConstant: 'No structured workflow, constant human error',
        str514: "\uD83D\uDCC9",
        noshowsCost1525Of: "No-shows cost 15\u201325% of revenue",
        noAutomatedRemindersOr: 'No automated reminders or confirmation system',
        str517: "\uD83C\uDFE6",
        insuranceBillingIsManual: 'Insurance billing is manual and painful',
        str519: "\uD83D\uDCF5",
        dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
        theSolution: 'The Solution',
        str523: "\uD83D\uDCC5",
        onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
        patientsBook247From: 'Patients book 24/7 from any device',
        str526: "\uD83E\uDDB7",
        patientRecordsTreatmentManagem: 'Patient records & treatment management',
        fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
        str529: "\uD83C\uDFE5",
        insuranceIntegrations: 'Insurance integrations',
        str531: "\uD83D\uDCAC",
        smsWhatsappReminders: 'SMS / WhatsApp reminders',
        cutNoshowsByUp: 'Cut no-shows by up to 40%',
        str534: "\uD83D\uDCCA",
        financialReportingDashboard: 'Financial reporting dashboard',
        revenueSalariesExpensesRealtim: "Revenue, salaries, expenses \u2014 realtime",
        willingnessToPay: 'Willingness to Pay',
        free: 'Free',
        month: '/month',
        listingBookingWidget: 'Listing + booking widget',
        growth: 'Growth',
        calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
        pro: 'Pro',
        fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
        multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
        wtp0515OfMonthly: "\uD83D\uDCA1 WTP: 0.5\u20131.5% of monthly revenue \u2014 clinics earning \u20BE15K\u201350K/mo pay \u20BE100\u2013350/mo comfortably",
        marketOpportunity: 'Market Opportunity',
        addressableClinicsAtLaunch: 'addressable clinics at launch',
        mrrAtFullPenetration: "MRR at full penetration (\u20BE49 avg)",
        home: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430",
        features: "\u0424\u0443\u043D\u043A\u0446\u0456\u0457",
        pricing: "\u0426\u0456\u043D\u0438",
        clinicsNav: "\u041A\u043B\u0456\u043D\u0456\u043A\u0438",
        aiAssistant: "AI \u0410\u0441\u0438\u0441\u0442\u0435\u043D\u0442",
        forBusiness: "\u0414\u043B\u044F \u0431\u0456\u0437\u043D\u0435\u0441\u0443",
        dashboard: "\u041F\u0430\u043D\u0435\u043B\u044C",
        getStarted: "\u041F\u043E\u0447\u0430\u0442\u0438",
        tryDemo: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0434\u0435\u043C\u043E",
        viewPitch: "\u041F\u0440\u0435\u0437\u0435\u043D\u0442\u0430\u0446\u0456\u044F",
        heroTagline: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0456\u0457",
        heroTitle: "\u0423\u0441\u0456 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438",
        heroSubtitle: "\u0412\u0430\u0448 AI-\u0430\u0441\u0438\u0441\u0442\u0435\u043D\u0442 \u0434\u043B\u044F \u043F\u043E\u0448\u0443\u043A\u0443 \u043D\u0430\u0439\u043A\u0440\u0430\u0449\u043E\u0457 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u0457 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438 \u0432 \u0413\u0440\u0443\u0437\u0456\u0457",
        searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u043A\u043B\u0456\u043D\u0456\u043A, \u043F\u043E\u0441\u043B\u0443\u0433 \u0430\u0431\u043E \u0437\u0430\u043F\u0438\u0442\u0430\u0439\u0442\u0435...",
        chipImplant: "\u041A\u0440\u0430\u0449\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438 \u0456\u043C\u043F\u043B\u0430\u043D\u0442\u0430\u0446\u0456\u0457 \u0443 \u0422\u0431\u0456\u043B\u0456\u0441\u0456",
        chipWhitening: "\u0412\u0456\u0434\u0431\u0456\u043B\u044E\u0432\u0430\u043D\u043D\u044F \u0437\u0443\u0431\u0456\u0432 \u043F\u043E\u0440\u0443\u0447",
        chipEmergency: "\u0415\u043A\u0441\u0442\u0440\u0435\u043D\u0430 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
        chipOrtho: "\u041E\u0440\u0442\u043E\u0434\u043E\u043D\u0442\u0456\u044F \u0434\u043B\u044F \u0434\u043E\u0440\u043E\u0441\u043B\u0438\u0445",
        scrollExplore: "\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u0456\u0442\u044C \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443",
        topRated: "\u041D\u0430\u0439\u043A\u0440\u0430\u0449\u0456 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438 \u0422\u0431\u0456\u043B\u0456\u0441\u0456",
        viewAllClinics: "\u0412\u0441\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438",
        shareLocation: "\u041F\u043E\u0434\u0456\u043B\u0456\u0442\u044C\u0441\u044F \u043B\u043E\u043A\u0430\u0446\u0456\u0454\u044E",
        locationShared: "\u041B\u043E\u043A\u0430\u0446\u0456\u044E \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
        statClinics: "\u041A\u043B\u0456\u043D\u0456\u043A\u0438",
        statNoShows: "\u041C\u0435\u043D\u0448\u0435 \u043D\u0435\u044F\u0432\u043E\u043A",
        statBooking: "\u041E\u043D\u043B\u0430\u0439\u043D \u0437\u0430\u043F\u0438\u0441",
        statDentists: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0438",
        statRating: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433",
        statPatients: "\u041F\u0430\u0446\u0456\u0454\u043D\u0442\u0438",
        findClinics: "\u0417\u043D\u0430\u0439\u0442\u0438 \u043A\u043B\u0456\u043D\u0456\u043A\u0438",
        forBusinessBtn: "\u0414\u043B\u044F \u0431\u0456\u0437\u043D\u0435\u0441\u0443",
        ownClinic: "\u0412\u0438 \u0432\u043B\u0430\u0441\u043D\u0438\u043A \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u0457 \u043A\u043B\u0456\u043D\u0456\u043A\u0438?",
        claimText: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0439\u0442\u0435 \u0441\u0432\u043E\u044E \u043A\u043B\u0456\u043D\u0456\u043A\u0443 \u0432 \u043D\u0430\u0448\u0456\u0439 \u0431\u0430\u0437\u0456.",
        getListed: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u2192",
        clinicsTitle: "\u0421\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438 \u0432 \u0413\u0440\u0443\u0437\u0456\u0457",
        verifiedClinics: "\u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043A\u043B\u0456\u043D\u0456\u043A",
        searchByName: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u0440\u0430\u0439\u043E\u043D\u043E\u043C \u0430\u0431\u043E \u043F\u043E\u0441\u043B\u0443\u0433\u043E\u044E...",
        hideMap: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043A\u0430\u0440\u0442\u0443",
        showMap: "\u041A\u0430\u0440\u0442\u0430",
        nearMe: "\u041F\u043E\u0440\u0443\u0447",
        clinicsMatch: "\u043A\u043B\u0456\u043D\u0456\u043A \u0437\u0431\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F",
        reviews: "\u0432\u0456\u0434\u0433\u0443\u043A\u0456\u0432",
        loadingMore: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
        callClinic: "\u0417\u0430\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443\u0432\u0430\u0442\u0438",
        bookAppointment: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438\u0441\u044F",
        services: "\u041F\u043E\u0441\u043B\u0443\u0433\u0438",
        workingHours: "\u0413\u043E\u0434\u0438\u043D\u0438 \u0440\u043E\u0431\u043E\u0442\u0438",
        priceRange: "\u0414\u0456\u0430\u043F\u0430\u0437\u043E\u043D \u0446\u0456\u043D",
        location: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
        visitWebsite: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442",
        bookingTitle: "\u0417\u0430\u043F\u0438\u0441 \u043D\u0430 \u043F\u0440\u0438\u0439\u043E\u043C",
        step: "\u041A\u0440\u043E\u043A",
        selectClinic: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u043B\u0456\u043D\u0456\u043A\u0443",
        selectService: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u043E\u0441\u043B\u0443\u0433\u0443",
        selectDate: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0430\u0442\u0443",
        selectTime: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0430\u0441",
        confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        next: "\u0414\u0430\u043B\u0456",
        back: "\u041D\u0430\u0437\u0430\u0434",
        clinicsAvailable: "\u043A\u043B\u0456\u043D\u0456\u043A \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        clinicsFound: "\u043A\u043B\u0456\u043D\u0456\u043A \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        confirmBooking: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0437\u0430\u043F\u0438\u0441",
        bookingConfirmed: "\u0412\u0430\u0448 \u0432\u0456\u0437\u0438\u0442 \u0437\u0430\u0431\u0440\u043E\u043D\u044C\u043E\u0432\u0430\u043D\u043E!",
        patientName: "\u0406\u043C'\u044F \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
        email: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
        notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
        businessHeroBadge: "15+ \u041C\u043E\u0434\u0443\u043B\u0456\u0432  \xb7  212+ \u041A\u043B\u0456\u043D\u0456\u043A  \xb7  Gemini AI",
        businessHeroTitle: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0439\u043D\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0434\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0438\u0445 \u043A\u043B\u0456\u043D\u0456\u043A",
        businessHeroSubtitle: "\u041A\u043B\u0456\u043D\u0456\u0447\u043D\u0435 \u043A\u0430\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F, \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0438\u0439 \u0430\u043D\u0430\u043B\u0456\u0437, \u043F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F, \u0440\u043E\u0437\u043A\u043B\u0430\u0434, \u0431\u0456\u043B\u0456\u043D\u0433, \u0435-\u0440\u0435\u0446\u0435\u043F\u0442\u0438, \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0454\u044E \u0442\u0430 \u0406\u0406-\u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 \u2014 \u0432\u0441\u0435 \u043D\u0430 \u043E\u0434\u043D\u0456\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456 \u0434\u043B\u044F \u0413\u0440\u0443\u0437\u0456\u0457.",
        theProblem: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
        problemSubtitle: "\u0413\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u0456 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u043A\u0438 \u0449\u043E\u0434\u043D\u044F \u0432\u0442\u0440\u0430\u0447\u0430\u044E\u0442\u044C \u0434\u043E\u0445\u0456\u0434 \u0447\u0435\u0440\u0435\u0437 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432\u0430\u043D\u0456 \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438",
        excelChaos: "\u0425\u0430\u043E\u0441 Excel \u0442\u0430 WhatsApp",
        excelChaosDetail: "\u041A\u043B\u0456\u043D\u0456\u043A\u0438 \u043A\u0435\u0440\u0443\u044E\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u0442\u0430\u0431\u043B\u0438\u0446\u0456 \u0442\u0430 \u0447\u0430\u0442\u0438. \u041D\u0443\u043B\u044C\u043E\u0432\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0456\u044F, \u043F\u043E\u0441\u0442\u0456\u0439\u043D\u0456 \u043F\u043E\u043C\u0438\u043B\u043A\u0438.",
        noShowRate: "25% \u043D\u0435\u044F\u0432\u043E\u043A",
        noShowDetail: "\u0411\u0435\u0437 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438\u0445 \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u044C \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0438 \u0437\u0430\u0431\u0443\u0432\u0430\u044E\u0442\u044C \u043F\u0440\u043E \u0432\u0456\u0437\u0438\u0442\u0438. \u041F\u043E\u0440\u043E\u0436\u043D\u0456 \u043A\u0440\u0456\u0441\u043B\u0430 \u2014 \u20BE500+/\u0434\u0435\u043D\u044C \u0432\u0442\u0440\u0430\u0442.",
        paperCharts: "\u041F\u0430\u043F\u0435\u0440\u043E\u0432\u0456 \u043A\u0430\u0440\u0442\u0438 \u0443 2026",
        paperChartsDetail: "\u0420\u0443\u043A\u043E\u043F\u0438\u0441\u043D\u0456 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0456 \u0437\u0430\u043F\u0438\u0441\u0438, \u0431\u0435\u0437 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0457 \u043E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u0438. \u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0456 \u0434\u0430\u043D\u0456 \u0437\u0430\u043C\u043A\u043D\u0435\u043D\u0456 \u0443 \u0448\u0430\u0444\u0430\u0445.",
        insuranceBlackHole: "\u0427\u043E\u0440\u043D\u0430 \u0434\u0456\u0440\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
        insuranceDetail: "\u0420\u0443\u0447\u043D\u0456 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0457 \u0434\u043E Aldagi, GPI, Imedi L \u0437\u0430\u0439\u043C\u0430\u044E\u0442\u044C \u0433\u043E\u0434\u0438\u043D\u0438. \u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u0456 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0457 \u043D\u0430\u043A\u043E\u043F\u0438\u0447\u0443\u044E\u0442\u044C\u0441\u044F.",
        oneplatform: "\u041E\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430, \u0432\u0441\u0456 \u043C\u043E\u0434\u0443\u043B\u0456",
        platformSubtitle: "15 \u0456\u043D\u0442\u0435\u0433\u0440\u043E\u0432\u0430\u043D\u0438\u0445 \u043C\u043E\u0434\u0443\u043B\u0456\u0432 \u0434\u043B\u044F \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u0457 \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438",
        clinical: "\u041A\u041B\u0406\u041D\u0406\u0427\u041D\u0406",
        operations: "\u041E\u041F\u0415\u0420\u0410\u0426\u0406\u0419\u041D\u0406",
        analyticsEnterprise: "\u0410\u041D\u0410\u041B\u0406\u0422\u0418\u041A\u0410 \u0422\u0410 ENTERPRISE",
        digitalOdontogram: "\u0426\u0438\u0444\u0440\u043E\u0432\u0430 \u043E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u0430",
        digitalOdontogramDetail: "FDI 32-\u0437\u0443\u0431\u043D\u0430 \u043A\u0430\u0440\u0442\u0430 \u0437 5-\u043F\u043E\u0432\u0435\u0440\u0445\u043D\u0435\u0432\u0438\u043C \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F\u043C.",
        perioCharting: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0435 \u043A\u0430\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        perioChartingDetail: "192-\u0442\u043E\u0447\u043A\u043E\u0432\u0430 \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u0441\u0456\u0442\u043A\u0430. 6-\u0442\u043E\u0447\u043A\u043E\u0432\u0435 \u0437\u043E\u043D\u0434\u0443\u0432\u0430\u043D\u043D\u044F, BOP, CAL.",
        treatmentPlanning: "\u041F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        treatmentPlanningDetail: "\u0424\u0430\u0437\u043E\u0432\u0456 \u043F\u043B\u0430\u043D\u0438 \u0437 CDT-\u043A\u043E\u0434\u0430\u043C\u0438, \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0438\u043C\u0438 \u043E\u0446\u0456\u043D\u043A\u0430\u043C\u0438. \u0406\u0406-\u0441\u0435\u043A\u0432\u0435\u043D\u0443\u0432\u0430\u043D\u043D\u044F.",
        soapNotes: "SOAP \u0437\u0430\u043F\u0438\u0441\u0438 + \u0406\u0406 \u0441\u043A\u0440\u0430\u0439\u0431",
        soapNotesDetail: "\u0421\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u043E\u0432\u0430\u043D\u0430 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F \u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0430\u043C\u0438. Gemini \u0433\u0435\u043D\u0435\u0440\u0443\u0454 \u0437\u0430\u043F\u0438\u0441\u0438 \u0437 \u0433\u043E\u043B\u043E\u0441\u0443.",
        multiChairScheduling: "\u0411\u0430\u0433\u0430\u0442\u043E\u043A\u0440\u0456\u0441\u0435\u043B\u044C\u043D\u0438\u0439 \u0440\u043E\u0437\u043A\u043B\u0430\u0434",
        multiChairDetail: "\u0422\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434 \u0437 \u043A\u0456\u043B\u044C\u043A\u043E\u043C\u0430 \u043A\u0430\u0431\u0456\u043D\u0435\u0442\u0430\u043C\u0438. \u041A\u043E\u043B\u044C\u043E\u0440\u043E\u0432\u0435 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0430\u0440\u0456\u0432.",
        billingInsurance: "\u0411\u0456\u043B\u0456\u043D\u0433 \u0442\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
        billingDetail: "\u0412\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0439 \u0434\u043B\u044F Aldagi, GPI, Imedi L. \u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0456\u044F, \u043F\u043B\u0430\u043D\u0438 \u043E\u043F\u043B\u0430\u0442\u0438.",
        ePrescribing: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0456 \u0440\u0435\u0446\u0435\u043F\u0442\u0438",
        ePrescribingDetail: "\u0426\u0438\u0444\u0440\u043E\u0432\u0456 \u0440\u0435\u0446\u0435\u043F\u0442\u0438 \u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0430\u043C\u0438. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0432\u0437\u0430\u0454\u043C\u043E\u0434\u0456\u0439 \u043B\u0456\u043A\u0456\u0432 \u0447\u0435\u0440\u0435\u0437 Gemini.",
        labTracking: "\u0412\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0457",
        labTrackingDetail: "\u041A\u0430\u043D\u0431\u0430\u043D: \u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E \u2192 \u0412\u0438\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u2192 \u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u2192 \u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E.",
        productionReports: "\u0417\u0432\u0456\u0442\u0438 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u0430",
        productionReportsDetail: "\u0412\u0430\u043B\u043E\u0432\u0435/\u0447\u0438\u0441\u0442\u0435 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E, \u0440\u0456\u0432\u0435\u043D\u044C \u0437\u0431\u043E\u0440\u0443, \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F.",
        referralMgmt: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F\u043C\u0438",
        referralMgmtDetail: "\u0412\u0445\u0456\u0434\u043D\u0456/\u0432\u0438\u0445\u0456\u0434\u043D\u0456 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0434\u043E \u0441\u043F\u0435\u0446\u0456\u0430\u043B\u0456\u0441\u0442\u0456\u0432. \u0406\u0406-\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u0456 \u043B\u0438\u0441\u0442\u0438.",
        medicalHistory: "\u041C\u0435\u0434\u0438\u0447\u043D\u0430 \u0456\u0441\u0442\u043E\u0440\u0456\u044F",
        medicalHistoryDetail: "11-\u0432\u0438\u0434\u043E\u0432\u0430 \u043A\u0430\u0440\u0442\u0430 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430: \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u044F, \u0441\u0442\u0430\u043D\u0438, \u043C\u0435\u0434\u0438\u043A\u0430\u043C\u0435\u043D\u0442\u0438, \u0430\u043B\u0435\u0440\u0433\u0456\u0457.",
        enterpriseAdmin: "Enterprise \u0430\u0434\u043C\u0456\u043D",
        enterpriseAdminDetail: "RBAC, \u0436\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0443, \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C, \u043C\u0443\u043B\u044C\u0442\u0438\u043E\u0440\u0435\u043D\u0434\u043D\u0456\u0441\u0442\u044C, SSO, \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F API.",
        geminiBuiltIn: "\u0412\u0431\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0439 Gemini AI",
        geminiSubtitle: "\u041A\u043E\u0436\u0435\u043D \u043C\u043E\u0434\u0443\u043B\u044C \u043F\u0440\u0430\u0446\u044E\u0454 \u043D\u0430 Google Gemini 3.1",
        xrayAnalysis: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0440\u0435\u043D\u0442\u0433\u0435\u043D\u0443",
        xrayDetail: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0456 \u0440\u0435\u043D\u0442\u0433\u0435\u043D\u043E\u0433\u0440\u0430\u043C\u0438 \u0434\u043B\u044F \u0406\u0406-\u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0438 \u043A\u0430\u0440\u0456\u0454\u0441\u0443.",
        perioAssessment: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u043E\u0446\u0456\u043D\u043A\u0430",
        perioAssessmentDetail: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u0441\u0442\u0430\u0434\u0456\u044E\u0432\u0430\u043D\u043D\u044F/\u0433\u0440\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F AAP \u0437\u0430 \u0434\u0430\u043D\u0438\u043C\u0438 \u0437\u043E\u043D\u0434\u0443\u0432\u0430\u043D\u043D\u044F.",
        clinicalScribe: "\u041A\u043B\u0456\u043D\u0456\u0447\u043D\u0438\u0439 \u0441\u043A\u0440\u0430\u0439\u0431",
        clinicalScribeDetail: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F SOAP-\u0437\u0430\u043F\u0438\u0441\u0456\u0432 \u0437 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 \u0430\u0431\u043E \u0434\u0430\u043D\u0438\u0445 \u043A\u0430\u0440\u0442\u0438.",
        riskProfiling: "\u041F\u0440\u043E\u0444\u0456\u043B\u044E\u0432\u0430\u043D\u043D\u044F \u0440\u0438\u0437\u0438\u043A\u0456\u0432",
        riskProfilingDetail: "\u0410\u043D\u0430\u043B\u0456\u0437 \u0441\u0442\u0430\u043D\u0456\u0432, \u0441\u0456\u043C\u0435\u0439\u043D\u043E\u0433\u043E \u0430\u043D\u0430\u043C\u043D\u0435\u0437\u0443 \u0434\u043B\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u0444\u0456\u043B\u044E \u0441\u0442\u043E\u043C\u0430\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u0433\u043E \u0440\u0438\u0437\u0438\u043A\u0443.",
        treatmentSequencing: "\u0421\u0435\u043A\u0432\u0435\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        treatmentSequencingDetail: "\u0406\u0406-\u043E\u043F\u0442\u0438\u043C\u0456\u0437\u043E\u0432\u0430\u043D\u0435 \u0444\u0430\u0437\u0443\u0432\u0430\u043D\u043D\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0437 \u0443\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F\u043C \u0437\u0430\u0433\u043E\u0454\u043D\u043D\u044F \u0442\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F.",
        patientComm: "\u041A\u043E\u043C\u0443\u043D\u0456\u043A\u0430\u0446\u0456\u044F \u0437 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u043E\u043C",
        patientCommDetail: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F \u0437\u0440\u043E\u0437\u0443\u043C\u0456\u043B\u0438\u0445 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0443 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u044C \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u044E \u043C\u043E\u0432\u043E\u044E.",
        georgianEcosystem: "\u0413\u043E\u0442\u043E\u0432\u043E \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u0457 \u0435\u043A\u043E\u0441\u0438\u0441\u0442\u0435\u043C\u0438",
        integrationsSubtitle: "\u041F\u0435\u0440\u0435\u0434\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0456 \u0456\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457 \u0437 \u043C\u0456\u0441\u0446\u0435\u0432\u0438\u043C \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F\u043C, \u043F\u043B\u0430\u0442\u0435\u0436\u0430\u043C\u0438 \u0442\u0430 \u043C\u0435\u0441\u0435\u043D\u0434\u0436\u0435\u0440\u0430\u043C\u0438",
        insurance: "\u0421\u0422\u0420\u0410\u0425\u0423\u0412\u0410\u041D\u041D\u042F",
        payments: "\u041F\u041B\u0410\u0422\u0415\u0416\u0406",
        messaging: "\u041F\u041E\u0412\u0406\u0414\u041E\u041C\u041B\u0415\u041D\u041D\u042F",
        ehrLabs: "\u0415\u041C\u041A \u0422\u0410 \u041B\u0410\u0411\u041E\u0420\u0410\u0422\u041E\u0420\u0406\u0407",
        clinicsInDb: "\u041A\u043B\u0456\u043D\u0456\u043A \u0443 \u0431\u0430\u0437\u0456",
        platformModules: "\u041C\u043E\u0434\u0443\u043B\u0456\u0432 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0438",
        aiTools: "\u0406\u0406-\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0456\u0432 (Gemini)",
        integrations: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0439",
        pricingTitle: "\u0426\u0456\u043D\u0438",
        pricingSubtitle: "\u041F\u043E\u0447\u043D\u0456\u0442\u044C \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
        trustedBy: "\u0414\u043E\u0432\u0456\u0440\u0430 \u043A\u043B\u0456\u043D\u0456\u043A",
        readyModernize: "\u0413\u043E\u0442\u043E\u0432\u0456 \u0434\u043E \u043C\u043E\u0434\u0435\u0440\u043D\u0456\u0437\u0430\u0446\u0456\u0457?",
        joinCount: "\u041F\u0440\u0438\u0454\u0434\u043D\u0443\u0439\u0442\u0435\u0441\u044C \u0434\u043E 212+ \u043A\u043B\u0456\u043D\u0456\u043A \u0443 \u0413\u0440\u0443\u0437\u0456\u0457.",
        startTrial: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
        contactSales: "\u0417\u0432'\u044F\u0437\u0430\u0442\u0438\u0441\u044F \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0430\u043C\u0438",
        noCreditCard: "\u0411\u0435\u0437 \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u043E\u0457 \u043A\u0430\u0440\u0442\u043A\u0438  \xb7  \u0411\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0438\u0439 \u0442\u0430\u0440\u0438\u0444  \xb7  \u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430 5 \u0445\u0432\u0438\u043B\u0438\u043D",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u041F\u0430\u043D\u0435\u043B\u044C",
        navPatients: "\u041F\u0430\u0446\u0456\u0454\u043D\u0442\u0438",
        navChart: "\u041A\u0430\u0440\u0442\u0430",
        navPerio: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u044F",
        navTreatmentPlans: "\u041F\u043B\u0430\u043D\u0438 \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        navNotes: "\u0417\u0430\u043F\u0438\u0441\u0438",
        navScheduling: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434",
        navBilling: "\u0411\u0456\u043B\u0456\u043D\u0433",
        navPrescriptions: "\u0420\u0435\u0446\u0435\u043F\u0442\u0438",
        navLabCases: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u043D\u0456 \u0432\u0438\u043F\u0430\u0434\u043A\u0438",
        navReferrals: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
        navReports: "\u0417\u0432\u0456\u0442\u0438",
        navMedHistory: "\u041C\u0435\u0434\u0438\u0447\u043D\u0430 \u0456\u0441\u0442\u043E\u0440\u0456\u044F",
        navIntegrations: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457",
        navEnterprise: "\u041F\u0456\u0434\u043F\u0440\u0438\u0454\u043C\u0441\u0442\u0432\u043E",
        sectionClinical: "\u041A\u041B\u0406\u041D\u0406\u041A\u0410",
        sectionOperations: "\u041E\u041F\u0415\u0420\u0410\u0426\u0406\u0407",
        sectionAnalytics: "\u0410\u041D\u0410\u041B\u0406\u0422\u0418\u041A\u0410",
        sectionAiTools: "\u0406\u0406 \u0406\u041D\u0421\u0422\u0420\u0423\u041C\u0415\u041D\u0422\u0418",
        sectionAdmin: "\u0410\u0414\u041C\u0406\u041D\u0406\u0421\u0422\u0420\u0423\u0412\u0410\u041D\u041D\u042F",
        // Booking Page
        chooseClinic: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u043B\u0456\u043D\u0456\u043A\u0443",
        selectAService: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u043E\u0441\u043B\u0443\u0433\u0443",
        pickADate: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0430\u0442\u0443",
        pickATime: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0430\u0441",
        confirmYourBooking: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0437\u0430\u043F\u0438\u0441",
        clinicLabel: "\u041A\u043B\u0456\u043D\u0456\u043A\u0430:",
        serviceLabel: "\u041F\u043E\u0441\u043B\u0443\u0433\u0430:",
        dateLabel: "\u0414\u0430\u0442\u0430:",
        timeLabel: "\u0427\u0430\u0441:",
        // AI Page
        send: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        procedure: "\u041F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430",
        observations: "\u0421\u043F\u043E\u0441\u0442\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
        aiThinking: "\u0406\u0406 \u0434\u0443\u043C\u0430\u0454...",
        summarizeHistory: "\u0423\u0437\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0442\u0438 \u0456\u0441\u0442\u043E\u0440\u0456\u044E \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        generateTxPlan: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043F\u043B\u0430\u043D \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        checkDrugInteractions: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0432\u0437\u0430\u0454\u043C\u043E\u0434\u0456\u044E \u043B\u0456\u043A\u0456\u0432",
        writeClinicalNote: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
        askAiAssistant: "\u0417\u0430\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u0406\u0406-\u0430\u0441\u0438\u0441\u0442\u0435\u043D\u0442\u0430...",
        dropXray: "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0440\u0435\u043D\u0442\u0433\u0435\u043D \u0430\u0431\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0434\u043B\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        supportsFormats: "\u041F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u044E\u0442\u044C\u0441\u044F DICOM, PNG, JPG",
        analysisResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u0430\u043D\u0430\u043B\u0456\u0437\u0443 (\u0434\u0435\u043C\u043E)",
        aiRecommendation: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u044F \u0406\u0406",
        exportToTxPlan: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0443 \u043F\u043B\u0430\u043D \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        generateClinicalNote: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
        generatedSoap: "\u0417\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u0438\u0439 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 (SOAP)",
        subjective: "S \u2014 \u0421\u0443\u0431'\u0454\u043A\u0442\u0438\u0432\u043D\u0435",
        objective: "O \u2014 \u041E\u0431'\u0454\u043A\u0442\u0438\u0432\u043D\u0435",
        assessment: "A \u2014 \u041E\u0446\u0456\u043D\u043A\u0430",
        plan: "P \u2014 \u041F\u043B\u0430\u043D",
        copyToRecord: "\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0434\u043E \u043A\u0430\u0440\u0442\u0438 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        aiPerioAssessment: "\u0406\u0406 \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0430 \u043E\u0446\u0456\u043D\u043A\u0430",
        enterProbingData: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0434\u0430\u043D\u0456 \u0437\u043E\u043D\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043B\u044F AAP \u0441\u0442\u0430\u0434\u0456\u044E\u0432\u0430\u043D\u043D\u044F \u0442\u0430 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u0439 \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F.",
        analyzeWithGemini: "\u0410\u043D\u0430\u043B\u0456\u0437\u0443\u0432\u0430\u0442\u0438 \u0437 Gemini",
        aiRiskAssessment: "\u0406\u0406 \u043E\u0446\u0456\u043D\u043A\u0430 \u0440\u0438\u0437\u0438\u043A\u0456\u0432",
        enterConditions: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0441\u0442\u0430\u043D \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430, \u0441\u0456\u043C\u0435\u0439\u043D\u0438\u0439 \u0430\u043D\u0430\u043C\u043D\u0435\u0437 \u0442\u0430 \u0432\u0456\u0442\u0430\u043B\u044C\u043D\u0456 \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u0457 \u043F\u0440\u043E\u0444\u0456\u043B\u044E \u0440\u0438\u0437\u0438\u043A\u0443.",
        generateRiskProfile: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u043E\u0444\u0456\u043B\u044C \u0440\u0438\u0437\u0438\u043A\u0443",
        patientCommunication: "\u041A\u043E\u043C\u0443\u043D\u0456\u043A\u0430\u0446\u0456\u044F \u0437 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u043E\u043C",
        generateExplanations: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F \u0437\u0440\u043E\u0437\u0443\u043C\u0456\u043B\u0438\u0445 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0443 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u044C \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0433\u0440\u0443\u0437\u0438\u043D\u0441\u044C\u043A\u043E\u044E \u0430\u0431\u043E \u0430\u043D\u0433\u043B\u0456\u0439\u0441\u044C\u043A\u043E\u044E.",
        generateExplanation: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u043D\u044F",
        patientFriendly: "\u0417\u0440\u043E\u0437\u0443\u043C\u0456\u043B\u0435 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0443 \u043F\u043E\u044F\u0441\u043D\u0435\u043D\u043D\u044F",
        // Billing Page
        claims: "\u041F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0457",
        ledger: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u044C\u043A\u0430 \u043A\u043D\u0438\u0433\u0430",
        aging: "\u0421\u0442\u0430\u0440\u0456\u043D\u043D\u044F \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u043E\u0441\u0442\u0456",
        paymentPlans: "\u041F\u043B\u0430\u043D\u0438 \u043E\u043F\u043B\u0430\u0442\u0438",
        eligibility: "\u041F\u0440\u0430\u0432\u043E \u043D\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
        allFilter: "\u0423\u0441\u0456",
        submitted: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
        paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        denied: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        patientLedger: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0456\u044F \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        agedAccounts: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u0440\u0430\u0445\u0443\u043D\u043A\u0438",
        sendStatements: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0432\u0438\u043F\u0438\u0441\u043A\u0438",
        activePaymentPlans: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043F\u043B\u0430\u043D\u0438 \u043E\u043F\u043B\u0430\u0442\u0438",
        insuranceEligibility: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0435 \u043F\u0440\u0430\u0432\u043E",
        // Clinical Charting
        odontogram: "\u041E\u0434\u043E\u043D\u0442\u043E\u0433\u0440\u0430\u043C\u0430",
        perioTab: "\u041F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u044F",
        treatmentPlanTab: "\u041F\u043B\u0430\u043D \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        notesTab: "\u0417\u0430\u043F\u0438\u0441\u0438",
        progressNotes: "\u0417\u0430\u043F\u0438\u0441\u0438 \u043F\u0440\u043E \u043F\u0440\u043E\u0433\u0440\u0435\u0441",
        openFullPerio: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u043E\u0432\u043D\u0443 \u043F\u0430\u0440\u043E\u0434\u043E\u043D\u0442\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u0443 \u043A\u0430\u0440\u0442\u0443 \u2192",
        openFullTxPlanner: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u043F\u043B\u0430\u043D\u0443\u0432\u0430\u043B\u044C\u043D\u0438\u043A \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u2192",
        openClinicalNotes: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043A\u043B\u0456\u043D\u0456\u0447\u043D\u0456 \u0437\u0430\u043F\u0438\u0441\u0438 \u2192",
        newExam: "\u041D\u043E\u0432\u0438\u0439 \u043E\u0433\u043B\u044F\u0434",
        voiceEntry: "\u0413\u043E\u043B\u043E\u0441\u043E\u0432\u0438\u0439 \u0432\u0432\u0456\u0434",
        bleedingIndex: "\u0406\u043D\u0434\u0435\u043A\u0441 \u043A\u0440\u043E\u0432\u043E\u0442\u043E\u0447\u0438\u0432\u043E\u0441\u0442\u0456",
        plaqueIndex: "\u0406\u043D\u0434\u0435\u043A\u0441 \u043D\u0430\u043B\u044C\u043E\u0442\u0443",
        sitesAbove4: "\u0414\u0456\u043B\u044F\u043D\u043A\u0438 \u2265 4\u043C\u043C",
        sitesAbove6: "\u0414\u0456\u043B\u044F\u043D\u043A\u0438 \u2265 6\u043C\u043C",
        planA: "\u041F\u043B\u0430\u043D A: \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0439",
        planB: "\u041F\u043B\u0430\u043D B: \u041A\u043E\u043D\u0441\u0435\u0440\u0432\u0430\u0442\u0438\u0432\u043D\u0438\u0439",
        newPlan: "+ \u041D\u043E\u0432\u0438\u0439 \u043F\u043B\u0430\u043D",
        presentToPatient: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0443",
        sendToPortal: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043D\u0430 \u043F\u043E\u0440\u0442\u0430\u043B",
        totalFee: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
        insuranceEst: "\u041E\u0446\u0456\u043D\u043A\u0430 \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u043A\u0438",
        patientPortion: "\u0427\u0430\u0441\u0442\u043A\u0430 \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        chairSideMode: "\u0420\u0435\u0436\u0438\u043C \u0431\u0456\u043B\u044F \u043A\u0440\u0456\u0441\u043B\u0430",
        adminMode: "\u0420\u0435\u0436\u0438\u043C \u0430\u0434\u043C\u0456\u043D\u0430",
        proceduresAcrossPhases: "{0} \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440 \u0443 {1} \u0444\u0430\u0437\u0430\u0445",
        // Scheduling
        day: "\u0414\u0435\u043D\u044C",
        week: "\u0422\u0438\u0436\u0434\u0435\u043D\u044C",
        today: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        providerFilter: "\u0423\u0441\u0456 \u043B\u0456\u043A\u0430\u0440\u0456",
        productionGoal: "\u0426\u0456\u043B\u044C \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u0430",
        waitlist: "\u041B\u0438\u0441\u0442 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        // Prescriptions
        activeRx: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
        pastRx: "\u041C\u0438\u043D\u0443\u043B\u0456",
        templates: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438",
        interactionCheck: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0432\u0437\u0430\u0454\u043C\u043E\u0434\u0456\u0439",
        // Lab Cases
        ordered: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
        sentToLab: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0434\u043E \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0457",
        inFabrication: "\u0423 \u0432\u0438\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u0456",
        shipped: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        received: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
        labVendors: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0438 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0439",
        // Referrals
        allDirections: "\u0423\u0441\u0456",
        inbound: "\u0412\u0445\u0456\u0434\u043D\u0456",
        outbound: "\u0412\u0438\u0445\u0456\u0434\u043D\u0456",
        generateLetter: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043B\u0438\u0441\u0442",
        // Reports
        production: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
        collections: "\u0417\u0431\u043E\u0440\u0438",
        schedulingReport: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434",
        treatmentAcceptance: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F \u043B\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
        recall: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0438\u0439 \u0432\u0438\u043A\u043B\u0438\u043A",
        grossProduction: "\u0412\u0430\u043B\u043E\u0432\u0435 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
        netProduction: "\u0427\u0438\u0441\u0442\u0435 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
        collectionRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u0437\u0431\u043E\u0440\u0443",
        plansPresented: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u043F\u043B\u0430\u043D\u0456\u0432",
        accepted: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
        acceptanceRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F",
        dueThisMonth: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E \u043D\u0430 \u0446\u0435\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        scheduled: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E",
        completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        overdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
        reactivationRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u0440\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u0457",
        // Medical History
        timeline: "\u0425\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u044F",
        conditions: "\u0421\u0442\u0430\u043D\u0438",
        medications: "\u041C\u0435\u0434\u0438\u043A\u0430\u043C\u0435\u043D\u0442\u0438",
        allergies: "\u0410\u043B\u0435\u0440\u0433\u0456\u0457",
        labResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u0430\u043D\u0430\u043B\u0456\u0437\u0456\u0432",
        vitals: "\u0412\u0456\u0442\u0430\u043B\u044C\u043D\u0456 \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A\u0438",
        immunizations: "\u0406\u043C\u0443\u043D\u0456\u0437\u0430\u0446\u0456\u0457",
        familyHistory: "\u0421\u0456\u043C\u0435\u0439\u043D\u0438\u0439 \u0430\u043D\u0430\u043C\u043D\u0435\u0437",
        imaging: "\u0412\u0456\u0437\u0443\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F",
        documents: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u0416\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0443",
        compliance: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C",
        multiTenancy: "\u041C\u0443\u043B\u044C\u0442\u0438\u043E\u0440\u0435\u043D\u0434\u043D\u0456\u0441\u0442\u044C",
        sso: "SSO \u0442\u0430 \u0431\u0435\u0437\u043F\u0435\u043A\u0430",
        featureFlags: "\u041F\u0440\u0430\u043F\u043E\u0440\u0446\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0439",
        apiManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F API",
        dataManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u043C\u0438",
        // Integrations
        ehr: "\u0415\u041C\u041A",
        labs: "\u041B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0456\u0457",
        telehealth: "\u0422\u0435\u043B\u0435\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0430",
        aiMl: "\u0406\u0406/\u041C\u041D",
        wearables: "\u041D\u043E\u0441\u0438\u043C\u0456 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457",
        connected: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        disconnected: "\u0412\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        // Components
        status: "\u0421\u0442\u0430\u0442\u0443\u0441",
        healthy: "\u0417\u0434\u043E\u0440\u043E\u0432\u0438\u0439",
        caries: "\u041A\u0430\u0440\u0456\u0454\u0441",
        restored: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439",
        missing: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439",
        implant: "\u0406\u043C\u043F\u043B\u0430\u043D\u0442",
        crownStatus: "\u041A\u043E\u0440\u043E\u043D\u043A\u0430",
        bridge: "\u041C\u0456\u0441\u0442",
        veneer: "\u0412\u0456\u043D\u0456\u0440",
        surfaces: "\u041F\u043E\u0432\u0435\u0440\u0445\u043D\u0456",
        procedureHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440",
        addProcedure: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0443",
        totalCharged: "\u0412\u0441\u044C\u043E\u0433\u043E \u043D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
        insurancePayment: "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436",
        patientResponsibility: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0456\u0441\u0442\u044C \u043F\u0430\u0446\u0456\u0454\u043D\u0442\u0430",
        expand: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
        policyNumber: "\u041F\u043E\u043B\u0456\u0441 \u2116",
        planType: "\u0422\u0438\u043F \u043F\u043B\u0430\u043D\u0443",
        annualMax: "\u0420\u0456\u0447\u043D\u0438\u0439 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C",
        used: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043E",
        remaining: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A",
        coverageByCategory: "\u041F\u043E\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u043C\u0438",
        preventive: "\u041F\u0440\u043E\u0444\u0456\u043B\u0430\u043A\u0442\u0438\u043A\u0430",
        basic: "\u0411\u0430\u0437\u043E\u0432\u0435",
        major: "\u041E\u0441\u043D\u043E\u0432\u043D\u0435",
        ortho: "\u041E\u0440\u0442\u043E\u0434\u043E\u043D\u0442\u0456\u044F",
        current: "\u041F\u043E\u0442\u043E\u0447\u043D\u0456",
        thirtyDay: "30 \u0434\u043D\u0456\u0432",
        sixtyDay: "60 \u0434\u043D\u0456\u0432",
        ninetyPlus: "90+ \u0434\u043D\u0456\u0432",
        totalBalance: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441",
        monthlyPayment: "\u0429\u043E\u043C\u0456\u0441\u044F\u0447\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436",
        paymentsRemaining: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0456\u0432",
        nextPayment: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436",
        paymentProgress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441 \u043E\u043F\u043B\u0430\u0442\u0438",
        choosePlan: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043F\u043B\u0430\u043D",
        aiInsight: "\u0406\u0406 \u0456\u043D\u0441\u0430\u0439\u0442",
        confidence: "\u0412\u043F\u0435\u0432\u043D\u0435\u043D\u0456\u0441\u0442\u044C",
        revoke: "\u0412\u0456\u0434\u043A\u043B\u0438\u043A\u0430\u0442\u0438",
        exams: "\u041E\u0433\u043B\u044F\u0434\u0438",
        phaseTotal: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u0444\u0430\u0437\u0438",
        mon: "\u041F\u043D",
        tue: "\u0412\u0442",
        wed: "\u0421\u0440",
        thu: "\u0427\u0442",
        fri: "\u041F\u0442",
        sat: "\u0421\u0431",
        sun: "\u041D\u0434",
        thinking: "\u0414\u0443\u043C\u0430\u044E...",
        followUpPlaceholder: "\u0417\u0430\u0434\u0430\u0439\u0442\u0435 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0435 \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F...",
        initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
        nextExpansionArmeniaAzerbaijan: "\uD83C\uDF0D  Next expansion: Armenia \u2192 Azerbaijan \u2192 broader Caucasus dental market",
        whyNow: 'Why Now',
        str561: "\u2708\uFE0F",
        dentalTourismBoom: 'Dental tourism boom',
        internationalPatientsNeedEngli: 'International patients need English-language online booking now',
        str564: "\uD83D\uDCF1",
        postcovidDigitizationPressure: 'Post-COVID digitization pressure',
        clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
        str567: "\uD83C\uDFC6",
        noStrongLocalIncumbent: 'No strong local incumbent',
        dentosgeOnlyCoversDiscovery: "dentos.ge only covers discovery \u2014 zero full ops platform exists",
        str570: "\uD83C\uDDEC\uD83C\uDDEA",
        georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
        lowCostHighQuality: "Low cost, high quality \u2014 50\u201370% cheaper than Western Europe",
        joinThePartnerClinic: "Join the Partner Clinic Program \u2014 first 3 months free",
        builtForGeorgianClinics: "\uD83E\uDDB7 Built for Georgian clinics, by people who live here",
        prev: "\u2190 Prev",
        next2: "Next \u2192",
        getInTouch: "\uD83E\uDDB7 Get in Touch",
        activePrescriptions: 'Active Prescriptions',
        pastPrescriptions: 'Past Prescriptions',
        prescriptionTemplates: 'Prescription Templates',
        drugInteractionChecker: 'Drug Interaction Checker',
        referrals: 'Referrals',
        newReferral: '+ New Referral',
        inbound2: 'Inbound',
        outbound2: 'Outbound',
        reportsAnalytics: 'Reports & Analytics',
        productionByProvider: 'Production by Provider',
        productionByCategory: 'Production by Category',
        preventive2: 'Preventive',
        restorative: 'Restorative',
        endodontics: 'Endodontics',
        periodontics: 'Periodontics',
        prosthodontics: 'Prosthodontics',
        surgery: 'Surgery',
        agingReport: 'Aging Report',
        appointmentsByDay: 'Appointments by Day',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        topDeclinedTreatments: 'Top Declined Treatments',
        costConcerns: 'Cost concerns',
        wantsToWait: 'Wants to wait',
        orthodontics: 'Orthodontics',
        insuranceNotCovering: 'Insurance not covering',
        notAPriority: 'Not a priority',
        seekingSecondOpinion: 'Seeking second opinion',
        u2190: '\u2190',
        u2192: '\u2192',
        allProviders: 'All Providers',
        hygienistNino: 'Hygienist Nino',
        mon17: 'MON 17',
        tue18: 'TUE 18',
        wed19: 'WED 19',
        thu20: 'THU 20',
        fri21: 'FRI 21',
        crownPrep14: 'Crown Prep #14',
        tKapanadze: 'T. Kapanadze',
        srpQuad1: 'SRP Quad 1',
        dGelashvili: 'D. Gelashvili',
        examXray: 'Exam + X-ray',
        mTsiklauri: 'M. Tsiklauri',
        unconfirmed: 'Unconfirmed',
        rct36: 'RCT #36',
        gBeridze: 'G. Beridze',
        prophyPolish: 'Prophy + Polish',
        iDiasamidze: 'I. Diasamidze',
        perioMaintenance: 'Perio Maintenance',
        tLomidze: 'T. Lomidze',
        prophy: 'Prophy',
        aJavakhishvili: 'A. Javakhishvili',
        inChair: 'In Chair',
        sealantsX4: 'Sealants x4',
        nKapanadze: 'N. Kapanadze',
        lMchedlishvili: 'L. Mchedlishvili',
        u2014LunchU2014: '\u2014 Lunch \u2014',
        veneerPrep11: 'Veneer Prep #11',
        kGabrichidze: 'K. Gabrichidze',
        composite25: 'Composite #25',
        sMeladze: 'S. Meladze',
        bridgePrep3436: 'Bridge Prep #34-36',
        rKharazishvili: 'R. Kharazishvili',
        composite22: 'Composite #22',
        zDolidze: 'Z. Dolidze',
        noShow: 'No Show',
        extraction48: 'Extraction #48',
        vPapunashvili: 'V. Papunashvili',
        implantConsult: 'Implant Consult',
        eTsereteli: 'E. Tsereteli',
        nGogiberidze: 'N. Gogiberidze',
        crownSeat14: 'Crown Seat #14',
        checkup: 'Checkup',
        bShengelia: 'B. Shengelia',
        fluorideTreatment: 'Fluoride Treatment',
        emergencyWalkin: 'Emergency Walk-in',
        scaling: 'Scaling',
        wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
        assignToSchedule: 'Assign to Schedule',
        autoAssign: 'Auto Assign',
        high: 'High',
        anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
        medium: 'Medium',
        irakliDiasamidze: 'Irakli Diasamidze',
        friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
        low: 'Low',
        planARecommended: 'Plan A: Recommended',
        planBConservative: 'Plan B: Conservative',
        newPlan2: '+ New Plan',
        conservativeApproach: 'Conservative Approach',
        thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
        u00b7: '\u00B7',
        treatmentPlanComparison: 'Treatment Plan Comparison',
        u00b72: '\u00b7',
        exams2: 'Exams:',
        metric: 'Metric',
        pdMm: 'PD (mm)',
        gmMm: 'GM (mm)',
        calMm: 'CAL (mm)',
        suppuration: 'Suppuration',
        furcation: 'Furcation',
        mobility: 'Mobility',
        qty: 'Qty',
        refills: 'Refills',
        goal: 'Goal',
        current2: 'Current',
        totalDue: 'Total Due',
        scheduled2: 'Scheduled',
        overdue2: 'Overdue',
        reactivation: 'Reactivation',
        chiefComplaint: 'Chief Complaint',
        painScale: 'Pain Scale:',
        clinicalFindings: 'Clinical Findings',
        diagnosis: 'Diagnosis',
        prescriptions: 'Prescriptions',
        u201c: '\u201C',
        xray: 'X-Ray',
        cleaning: 'Cleaning',
        amountPaid: 'Amount Paid',
        annotate: 'Annotate',
        anonymousPatient: 'Anonymous Patient',
        autoImport: 'Auto Import',
        away: 'Away',
        bankTransfer: 'Bank Transfer',
        beforeAfter: 'Before After',
        bookPrerequisiteFirst: 'Book Prerequisite First',
        breakdown: 'Breakdown',
        bridgePrep: 'Bridge Prep',
        brightness: 'Brightness',
        cabinet: 'Cabinet',
        cabinet1: 'Cabinet 1',
        cabinet2: 'Cabinet 2',
        cabinetSchedule: 'Cabinet Schedule',
        cabinetScheduleDesc: 'Cabinet Schedule Desc',
        card: 'Card',
        cash: 'Cash',
        cbct: 'Cbct',
        cephalometric: 'Cephalometric',
        channels: 'Channels',
        clinicalQuestion: 'Clinical Question',
        clinicAvgRating: 'Clinic Avg Rating',
        collapse: 'Collapse',
        completedToday: 'Completed Today',
        compositeF: 'Composite F',
        continueToScheduling: 'Continue To Scheduling',
        contrast: 'Contrast',
        ctScans: 'Ct Scans',
        customAmount: 'Custom Amount',
        days: 'Days',
        delivered: 'Delivered',
        directMessages: 'Direct Messages',
        disposables: 'Disposables',
        doctorResponse: 'Doctor Response',
        doctors: 'Doctors',
        documentMgmtSubtitle: 'Document Mgmt Subtitle',
        documentPreview: 'Document Preview',
        download: 'Download',
        endodontic: 'Endodontic',
        enterAmount: 'Enter Amount',
        equipmentDevices: 'Equipment Devices',
        estDelivery: 'Est Delivery',
        examConsult: 'Exam Consult',
        explanationQuality: 'Explanation Quality',
        fluorideTx: 'Fluoride Tx',
        fullMouthView: 'Full Mouth View',
        hasBracesQuestion: 'Has Braces Question',
        hasConsultationQuestion: 'Has Consultation Question',
        hasCtScanQuestion: 'Has Ct Scan Question',
        hasRecentXrayQuestion: 'Has Recent Xray Question',
        helpfulQuestion: 'Helpful Question',
        highest: 'Highest',
        hygiene: 'Hygiene',
        imagingType: 'Imaging Type',
        implantPlace: 'Implant Place',
        important: 'Important',
        importLatest: 'Import Latest',
        inProgress: 'In Progress',
        installment: 'Installment',
        insuranceCoverage: 'Insurance Coverage',
        interpreted: 'Interpreted',
        inUse: 'In Use',
        invoices: 'Invoices',
        lastCleaningQuestion: 'Last Cleaning Question',
        lateralSkullView: 'Lateral Skull View',
        lowest: 'Lowest',
        lowStock: 'Low Stock',
        lowStockAlerts: 'Low Stock Alerts',
        maintenance: 'Maintenance',
        management: 'Management',
        markComplete: 'Mark Complete',
        material: 'Material',
        method: 'Method',
        minOrder: 'Min Order',
        monthlySpend: 'Monthly Spend',
        newPayment: 'New Payment',
        newRadiologyReferral: 'New Radiology Referral',
        nextAppointment: 'Next Appointment',
        noDocumentsFound: 'No Documents Found',
        noNoteSelected: 'No Note Selected',
        normal: 'Normal',
        noteInterpreter: 'Note Interpreter',
        occupied: 'Occupied',
        online: 'Online',
        orderNow: 'Order Now',
        orders: 'Orders',
        original: 'Original',
        outstanding: 'Outstanding',
        painManagement: 'Pain Management',
        panoramic: 'Panoramic',
        patientDue: 'Patient Due',
        paymentHistory: 'Payment History',
        paymentMethod: 'Payment Method',
        pendingOrders: 'Pending Orders',
        periapical: 'Periapical',
        perioMaint: 'Perio Maint',
        photos: 'Photos',
        placeOrder: 'Place Order',
        preCheck: 'Pre Check',
        preCheckPassed: 'Pre Check Passed',
        preCheckSubtitle: 'Pre Check Subtitle',
        preCheckTitle: 'Pre Check Title',
        prerequisiteWarning: 'Prerequisite Warning',
        print: 'Print',
        processing: 'Processing',
        processPayment: 'Process Payment',
        processPaymentBtn: 'Process Payment Btn',
        professionalism: 'Professionalism',
        prophyClean: 'Prophy Clean',
        prosthetic: 'Prosthetic',
        punctuality: 'Punctuality',
        qtyUsed: 'Qty Used',
        quantity: 'Quantity',
        queue: 'Queue',
        receiptPreview: 'Receipt Preview',
        recent: 'Recent',
        recentMaterialUsage: 'Recent Material Usage',
        recentReceipts: 'Recent Receipts',
        reliability: 'Reliability',
        remainingBalance: 'Remaining Balance',
        reorderLevel: 'Reorder Level',
        scanning: 'Scanning',
        sealants: 'Sealants',
        sent: 'Sent',
        singleToothView: 'Single Tooth View',
        slotDetails: 'Slot Details',
        sortBy: 'Sort By',
        srpQuad: 'Srp Quad',
        startImaging: 'Start Imaging',
        stock: 'Stock',
        stockLevel: 'Stock Level',
        submitReferral: 'Submit Referral',
        subtotal: 'Subtotal',
        suppliers: 'Suppliers',
        surgical: 'Surgical',
        targetArea: 'Target Area',
        teamChat: 'Team Chat',
        termsNormalized: 'Terms Normalized',
        threeDImaging: 'Three D Imaging',
        totalItems: 'Total Items',
        totalReceived: 'Total Received',
        typeAMessage: 'Type A Message',
        unavailable: 'Unavailable',
        unit: 'Unit',
        urgency: 'Urgency',
        urgent: 'Urgent',
        usageLog: 'Usage Log',
        veneerPrep: 'Veneer Prep',
        viewOnGoogle: 'View On Google',
        xrays: 'Xrays'
    },
    tr: {
        home: 'Ana Sayfa',
        features: "\xd6zellikler",
        pricing: 'Fiyatlar',
        clinicsNav: 'Klinikler',
        aiAssistant: 'AI Asistan',
        forBusiness: "\u0130\u015Fletmeler \u0130\xe7in",
        dashboard: 'Panel',
        getStarted: "Ba\u015Fla",
        tryDemo: 'Demoyu Dene',
        viewPitch: "Sunumu G\xf6r",
        heroTagline: "G\xfcrcistan i\xe7in Di\u015F Hekimli\u011Fi Platformu",
        heroTitle: "T\xfcm di\u015F klinikleri merkezi",
        heroSubtitle: "G\xfcrcistan'da en iyi di\u015F bak\u0131m\u0131n\u0131 bulmak i\xe7in AI asistan\u0131n\u0131z",
        searchPlaceholder: "Klinik, hizmet aray\u0131n veya soru sorun...",
        chipImplant: "Tiflis'teki en iyi implant klinikleri",
        chipWhitening: "Yak\u0131n\u0131mdaki di\u015F beyazlatma",
        chipEmergency: "Acil di\u015F bak\u0131m\u0131",
        chipOrtho: "Yeti\u015Fkinler i\xe7in ortodonti",
        scrollExplore: "Ke\u015Ffetmek i\xe7in kayd\u0131r\u0131n",
        topRated: "Tiflis'in en iyi di\u015F klinikleri",
        viewAllClinics: "T\xfcm klinikler",
        shareLocation: "Yak\u0131n klinikler i\xe7in konum payla\u015F",
        locationShared: "Konum payla\u015F\u0131ld\u0131",
        statClinics: 'Klinikler',
        statNoShows: 'Daha az iptal',
        statBooking: 'Online randevu',
        statDentists: "Di\u015F Hekimi",
        statRating: 'Ort. Puan',
        statPatients: 'Hastalar',
        findClinics: "En \u0130yi Klinikleri Bul",
        forBusinessBtn: "\u0130\u015Fletmeler \u0130\xe7in",
        clinicsTitle: "G\xfcrcistan'daki Di\u015F Klinikleri",
        verifiedClinics: "onayl\u0131 klinik",
        searchByName: "\u0130sim, b\xf6lge veya hizmete g\xf6re aray\u0131n...",
        reviews: 'yorum',
        loadingMore: "Y\xfckleniyor...",
        callClinic: 'Ara',
        bookAppointment: 'Randevu Al',
        services: 'Hizmetler',
        workingHours: "\xc7al\u0131\u015Fma Saatleri",
        priceRange: "Fiyat Aral\u0131\u011F\u0131",
        location: 'Konum',
        visitWebsite: 'Siteyi Ziyaret Et',
        bookingTitle: 'Randevu Al',
        step: "Ad\u0131m",
        selectClinic: "Klinik Se\xe7in",
        selectService: "Hizmet Se\xe7in",
        selectDate: "Tarih Se\xe7in",
        selectTime: "Saat Se\xe7in",
        confirm: 'Onayla',
        next: "\u0130leri",
        back: 'Geri',
        clinicsAvailable: 'klinik mevcut',
        confirmBooking: 'Randevuyu Onayla',
        patientName: "Hasta Ad\u0131",
        phoneNumber: "Telefon Numaras\u0131",
        email: 'E-posta',
        ownClinic: "Bir di\u015F klini\u011Finiz mi var?",
        claimText: "Klini\u011Finizi veritaban\u0131m\u0131za kaydedin veya ekleyin.",
        getListed: "Kaydolun \u2192",
        hideMap: "Haritay\u0131 Gizle",
        showMap: 'Harita',
        nearMe: "Yak\u0131n\u0131mda",
        clinicsMatch: "klinik e\u015Fle\u015Fiyor",
        clinicsFound: 'klinik bulundu',
        bookingConfirmed: "Randevunuz onayland\u0131!",
        notes: "Notlar (iste\u011Fe ba\u011Fl\u0131)",
        businessHeroBadge: "15+ Mod\xfcl  \xb7  212+ Klinik  \xb7  Gemini AI",
        businessHeroTitle: "Di\u015F Klinikleri \u0130\xe7in \u0130\u015Fletim Sistemi",
        businessHeroSubtitle: "Klinik kartlama, periodontal analiz, tedavi planlamas\u0131, planlama, faturaland\u0131rma, e-re\xe7ete, laboratuvar y\xf6netimi ve AI tan\u0131 \u2014 G\xfcrcistan i\xe7in tek platformda.",
        theProblem: 'Sorun',
        problemSubtitle: "G\xfcrcistan di\u015F klinikleri par\xe7al\u0131 ara\xe7lar nedeniyle g\xfcnl\xfck gelir kaybediyor",
        excelChaos: 'Excel ve WhatsApp Kaosu',
        excelChaosDetail: "Klinikler randevular\u0131 tablolar ve sohbet gruplar\u0131yla y\xf6netiyor. S\u0131f\u0131r otomasyon, s\xfcrekli hatalar.",
        noShowRate: "%25 \u0130ptal Oran\u0131",
        noShowDetail: "Otomatik hat\u0131rlatmalar olmadan hastalar randevular\u0131 unutuyor. Bo\u015F koltuklar g\xfcnde \u20BE500+ kay\u0131p.",
        paperCharts: "2026'da Ka\u011F\u0131t Kartlar",
        paperChartsDetail: "El yaz\u0131s\u0131 klinik notlar, dijital odontogram yok. Kritik veriler dosya dolaplar\u0131nda kilitli.",
        insuranceBlackHole: "Sigorta Kara Deli\u011Fi",
        insuranceDetail: "Aldagi, GPI, Imedi L'ye manuel talepler saatler s\xfcr\xfcyor. Reddedilen talepler birikiyor.",
        oneplatform: "Tek Platform, Her Mod\xfcl",
        platformSubtitle: "Di\u015F hekimli\u011Fi uygulamalar\u0131 i\xe7in 15 entegre mod\xfcl",
        clinical: "KL\u0130N\u0130K",
        operations: 'OPERASYONLAR',
        analyticsEnterprise: "ANAL\u0130T\u0130K VE KURUMSAL",
        digitalOdontogram: 'Dijital Odontogram',
        digitalOdontogramDetail: "FDI 32 di\u015Fli kart, 5 y\xfczey takibi.",
        perioCharting: 'Periodontal Kartlama',
        perioChartingDetail: "192 noktal\u0131 periodontal \u0131zgara. 6 noktal\u0131 sondaj, BOP, CAL.",
        treatmentPlanning: "Tedavi Planlamas\u0131",
        treatmentPlanningDetail: "CDT kodlar\u0131yla faz planlar\u0131, sigorta tahminleri. AI sekanslamas\u0131.",
        soapNotes: "SOAP Notlar\u0131 + AI Yaz\u0131c\u0131",
        soapNotesDetail: "\u015Eablonlarla yap\u0131land\u0131r\u0131lm\u0131\u015F klinik dok\xfcmantasyon. Gemini sesten not \xfcretiyor.",
        multiChairScheduling: "\xc7oklu Koltuk Planlamas\u0131",
        multiChairDetail: "Birden fazla operatoryumlu haftal\u0131k g\xf6r\xfcn\xfcm. Doktor renk kodlamas\u0131.",
        billingInsurance: "Faturaland\u0131rma ve Sigorta",
        billingDetail: "Aldagi, GPI, Imedi L i\xe7in talep takibi. Hasta defteri, \xf6deme planlar\u0131.",
        ePrescribing: "E-Re\xe7ete",
        ePrescribingDetail: "\u015Eablonlarla dijital re\xe7eteler. Gemini ile ila\xe7 etkile\u015Fim kontrol\xfc.",
        labTracking: 'Laboratuvar Takibi',
        labTrackingDetail: "Kanban: Sipari\u015F \u2192 \xdcretim \u2192 G\xf6nderim \u2192 Teslim.",
        productionReports: "\xdcretim Raporlar\u0131",
        productionReportsDetail: "Br\xfct/net \xfcretim, tahsilat oranlar\u0131, tedavi kabul\xfc.",
        referralMgmt: "Sevk Y\xf6netimi",
        referralMgmtDetail: "Uzmanlara gelen/giden sevkler. AI ile olu\u015Fturulan mektuplar.",
        medicalHistory: "T\u0131bbi Ge\xe7mi\u015F",
        medicalHistoryDetail: "11 g\xf6r\xfcn\xfcml\xfc hasta kayd\u0131: zaman \xe7izelgesi, durumlar, ila\xe7lar, alerjiler.",
        enterpriseAdmin: "Kurumsal Y\xf6netim",
        enterpriseAdminDetail: "RBAC, denetim g\xfcnl\xfc\u011F\xfc, uyumluluk, \xe7oklu kirac\u0131l\u0131k, SSO, API y\xf6netimi.",
        geminiBuiltIn: "Yerle\u015Fik Gemini AI",
        geminiSubtitle: "Her mod\xfcl Google Gemini 3.1 ile \xe7al\u0131\u015F\u0131r",
        xrayAnalysis: "R\xf6ntgen Analizi",
        xrayDetail: "AI \xe7\xfcr\xfck tespiti i\xe7in di\u015F r\xf6ntgenlerini y\xfckleyin.",
        perioAssessment: "Periodontal De\u011Ferlendirme",
        perioAssessmentDetail: 'Sondaj verilerinden otomatik AAP evreleme/derecelendirme.',
        clinicalScribe: "Klinik Yaz\u0131c\u0131",
        clinicalScribeDetail: "Ses kay\u0131tlar\u0131ndan veya kart verilerinden SOAP not \xfcretimi.",
        riskProfiling: 'Risk Profilleme',
        riskProfilingDetail: "Di\u015F riski profili i\xe7in durumlar, aile ge\xe7mi\u015Fi analizi.",
        treatmentSequencing: 'Tedavi Sekanslama',
        treatmentSequencingDetail: "\u0130yile\u015Fme ve sigortay\u0131 dikkate alan AI optimizeli tedavi fazlamas\u0131.",
        patientComm: "Hasta \u0130leti\u015Fimi",
        patientCommDetail: "G\xfcrc\xfcce hasta dostu a\xe7\u0131klamalar \xfcretimi.",
        georgianEcosystem: "G\xfcrcistan Ekosistemi Haz\u0131r",
        integrationsSubtitle: "Yerel sigorta, \xf6deme ve mesajla\u015Fma ile \xf6nceden olu\u015Fturulmu\u015F entegrasyonlar",
        insurance: "S\u0130GORTA",
        payments: "\xd6DEMELER",
        messaging: "MESAJLA\u015EMA",
        ehrLabs: 'EHR VE LABORATUVARLAR',
        clinicsInDb: "Veritaban\u0131ndaki Klinikler",
        platformModules: "Platform Mod\xfclleri",
        aiTools: "AI Ara\xe7lar\u0131 (Gemini)",
        integrations: 'Entegrasyonlar',
        pricingTitle: 'Fiyatlar',
        pricingSubtitle: "\xdccretsiz ba\u015Flay\u0131n",
        trustedBy: "Kliniklerin G\xfcveni",
        readyModernize: "Modernle\u015Fmeye haz\u0131r m\u0131s\u0131n\u0131z?",
        joinCount: "G\xfcrcistan'daki 212+ klini\u011Fe kat\u0131l\u0131n.",
        startTrial: "\xdccretsiz Dene",
        contactSales: "Sat\u0131\u015Fla \u0130leti\u015Fim",
        noCreditCard: "Kredi kart\u0131 gerekmez  \xb7  \xdccretsiz plan  \xb7  5 dakikada kurulum",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: 'Panel',
        navPatients: 'Hastalar',
        navChart: 'Kart',
        navPerio: 'Periodontoloji',
        navTreatmentPlans: "Tedavi Planlar\u0131",
        navNotes: 'Notlar',
        navScheduling: 'Planlama',
        navBilling: "Faturaland\u0131rma",
        navPrescriptions: "Re\xe7eteler",
        navLabCases: "Laboratuvar Vakalar\u0131",
        navReferrals: 'Sevkler',
        navReports: 'Raporlar',
        navMedHistory: "T\u0131bbi Ge\xe7mi\u015F",
        navIntegrations: 'Entegrasyonlar',
        navEnterprise: 'Kurumsal',
        sectionClinical: "KL\u0130N\u0130K",
        sectionOperations: 'OPERASYONLAR',
        sectionAnalytics: "ANAL\u0130T\u0130K",
        sectionAiTools: "AI ARA\xc7LARI",
        sectionAdmin: "Y\xd6NET\u0130M",
        // Booking Page
        chooseClinic: "Klinik Se\xe7in",
        selectAService: "Hizmet Se\xe7in",
        pickADate: "Tarih Se\xe7in",
        pickATime: "Saat Se\xe7in",
        confirmYourBooking: "Randevunuzu Onaylay\u0131n",
        clinicLabel: 'Klinik:',
        serviceLabel: 'Hizmet:',
        dateLabel: 'Tarih:',
        timeLabel: 'Saat:',
        // AI Page
        send: "G\xf6nder",
        procedure: "Prosed\xfcr",
        observations: "G\xf6zlemler",
        aiThinking: "AI d\xfc\u015F\xfcn\xfcyor...",
        summarizeHistory: "Hasta ge\xe7mi\u015Fini \xf6zetle",
        generateTxPlan: "Tedavi plan\u0131 olu\u015Ftur",
        checkDrugInteractions: "\u0130la\xe7 etkile\u015Fimlerini kontrol et",
        writeClinicalNote: 'Klinik not yaz',
        askAiAssistant: 'AI asistana sorun...',
        dropXray: "R\xf6ntgen g\xf6r\xfcnt\xfcs\xfcn\xfc b\u0131rak\u0131n veya y\xfcklemek i\xe7in t\u0131klay\u0131n",
        supportsFormats: 'DICOM, PNG, JPG desteklenir',
        analysisResults: "Analiz Sonu\xe7lar\u0131 (Demo)",
        aiRecommendation: "AI \xd6nerisi",
        exportToTxPlan: "Tedavi Plan\u0131na Aktar",
        generateClinicalNote: "Klinik Not Olu\u015Ftur",
        generatedSoap: "Olu\u015Fturulan Klinik Not (SOAP)",
        subjective: "S \u2014 Subjektif",
        objective: "O \u2014 Objektif",
        assessment: "A \u2014 De\u011Ferlendirme",
        plan: "P \u2014 Plan",
        copyToRecord: "Hasta Kayd\u0131na Kopyala",
        aiPerioAssessment: "AI Periodontal De\u011Ferlendirme",
        enterProbingData: "AAP evreleme/derecelendirme ve tedavi \xf6nerileri i\xe7in sondaj verilerini girin.",
        analyzeWithGemini: 'Gemini ile Analiz Et',
        aiRiskAssessment: "AI Risk De\u011Ferlendirmesi",
        enterConditions: "Risk profili olu\u015Fturmak i\xe7in hasta durumlar\u0131n\u0131, aile ge\xe7mi\u015Fini ve vital bulgular\u0131n\u0131 girin.",
        generateRiskProfile: "Risk Profili Olu\u015Ftur",
        patientCommunication: "Hasta \u0130leti\u015Fimi",
        generateExplanations: "G\xfcrc\xfcce veya \u0130ngilizce hasta dostu tedavi a\xe7\u0131klamalar\u0131 olu\u015Fturun.",
        generateExplanation: "A\xe7\u0131klama Olu\u015Ftur",
        patientFriendly: "Hasta Dostu A\xe7\u0131klama",
        // Billing Page
        claims: 'Talepler',
        ledger: 'Muhasebe Defteri',
        aging: "Ya\u015Fland\u0131rma",
        paymentPlans: "\xd6deme Planlar\u0131",
        eligibility: 'Uygunluk',
        allFilter: "T\xfcm\xfc",
        submitted: "G\xf6nderildi",
        paid: "\xd6dendi",
        denied: 'Reddedildi',
        patientLedger: 'Hasta Muhasebesi',
        agedAccounts: "Vadesi Ge\xe7mi\u015F Hesaplar",
        sendStatements: "Hesap \xd6zetlerini G\xf6nder",
        activePaymentPlans: "Aktif \xd6deme Planlar\u0131",
        insuranceEligibility: "Sigorta Uygunlu\u011Fu",
        // Clinical Charting
        odontogram: 'Odontogram',
        perioTab: 'Periodontoloji',
        treatmentPlanTab: "Tedavi Plan\u0131",
        notesTab: 'Notlar',
        progressNotes: "\u0130lerleme Notlar\u0131",
        openFullPerio: "Tam Periodontal Kart\u0131 A\xe7 \u2192",
        openFullTxPlanner: "Tam Tedavi Planlay\u0131c\u0131s\u0131n\u0131 A\xe7 \u2192",
        openClinicalNotes: "Klinik Notlar\u0131 A\xe7 \u2192",
        newExam: 'Yeni Muayene',
        voiceEntry: "Sesli Giri\u015F",
        bleedingIndex: "Kanama \u0130ndeksi",
        plaqueIndex: "Plak \u0130ndeksi",
        sitesAbove4: "B\xf6lgeler \u2265 4mm",
        sitesAbove6: "B\xf6lgeler \u2265 6mm",
        planA: "Plan A: \xd6nerilen",
        planB: 'Plan B: Konservatif',
        newPlan: '+ Yeni Plan',
        presentToPatient: 'Hastaya Sun',
        sendToPortal: "Portala G\xf6nder",
        totalFee: "Toplam \xdccret",
        insuranceEst: 'Sigorta Tahmini',
        patientPortion: "Hasta Pay\u0131",
        chairSideMode: 'Koltuk Modu',
        adminMode: "Y\xf6netici Modu",
        proceduresAcrossPhases: "{1} fazda {0} i\u015Flem",
        // Scheduling
        day: "G\xfcn",
        week: 'Hafta',
        today: "Bug\xfcn",
        providerFilter: "T\xfcm Sa\u011Flay\u0131c\u0131lar",
        productionGoal: "\xdcretim Hedefi",
        waitlist: 'Bekleme Listesi',
        // Prescriptions
        activeRx: 'Aktif',
        pastRx: "Ge\xe7mi\u015F",
        templates: "\u015Eablonlar",
        interactionCheck: "Etkile\u015Fim Kontrol\xfc",
        // Lab Cases
        ordered: "Sipari\u015F Verildi",
        sentToLab: "Laboratuvara G\xf6nderildi",
        inFabrication: "\xdcretimde",
        shipped: "G\xf6nderildi",
        received: "Teslim Al\u0131nd\u0131",
        labVendors: "Laboratuvar Tedarik\xe7ileri",
        // Referrals
        allDirections: "T\xfcm\xfc",
        inbound: 'Gelen',
        outbound: 'Giden',
        generateLetter: "Mektup Olu\u015Ftur",
        // Reports
        production: "\xdcretim",
        collections: 'Tahsilatlar',
        schedulingReport: 'Planlama',
        treatmentAcceptance: "Tedavi Kabul\xfc",
        recall: "Geri \xc7a\u011F\u0131rma",
        grossProduction: "Br\xfct \xdcretim",
        netProduction: "Net \xdcretim",
        collectionRate: "Tahsilat Oran\u0131",
        plansPresented: 'Sunulan Planlar',
        accepted: 'Kabul Edildi',
        acceptanceRate: "Kabul Oran\u0131",
        dueThisMonth: 'Bu Ay Planlanan',
        scheduled: "Planland\u0131",
        completed: "Tamamland\u0131",
        overdue: "Gecikmi\u015F",
        reactivationRate: "Reaktivasyon Oran\u0131",
        // Medical History
        timeline: "Zaman \xc7izelgesi",
        conditions: 'Durumlar',
        medications: "\u0130la\xe7lar",
        allergies: 'Alerjiler',
        labResults: "Laboratuvar Sonu\xe7lar\u0131",
        vitals: 'Vital Bulgular',
        immunizations: "A\u015F\u0131lar",
        familyHistory: "Aile Ge\xe7mi\u015Fi",
        imaging: "G\xf6r\xfcnt\xfcleme",
        documents: 'Belgeler',
        // Enterprise
        rbac: 'RBAC',
        auditLog: "Denetim G\xfcnl\xfc\u011F\xfc",
        compliance: 'Uyumluluk',
        multiTenancy: "\xc7oklu Kirac\u0131l\u0131k",
        sso: "SSO ve G\xfcvenlik",
        featureFlags: "\xd6zellik Bayraklar\u0131",
        apiManagement: "API Y\xf6netimi",
        dataManagement: "Veri Y\xf6netimi",
        // Integrations
        ehr: 'EHR',
        labs: 'Laboratuvarlar',
        telehealth: "Telesa\u011Fl\u0131k",
        aiMl: 'AI/ML',
        wearables: 'Giyilebilir Cihazlar',
        connected: "Ba\u011Fl\u0131",
        disconnected: "Ba\u011Flant\u0131 Kesildi",
        available: 'Mevcut',
        // Components
        status: 'Durum',
        healthy: "Sa\u011Fl\u0131kl\u0131",
        caries: "\xc7\xfcr\xfck",
        restored: "Restore Edilmi\u015F",
        missing: 'Eksik',
        implant: "\u0130mplant",
        crownStatus: 'Kron',
        bridge: "K\xf6pr\xfc",
        veneer: 'Veneer',
        braces: 'Braces',
        surfaces: "Y\xfczeyler",
        procedureHistory: "\u0130\u015Flem Ge\xe7mi\u015Fi",
        addProcedure: "\u0130\u015Flem Ekle",
        totalCharged: "Toplam Bor\xe7",
        insurancePayment: "Sigorta \xd6demesi",
        patientResponsibility: "Hasta Sorumlulu\u011Fu",
        expand: "Geni\u015Flet",
        policyNumber: "Poli\xe7e No",
        planType: "Plan T\xfcr\xfc",
        annualMax: "Y\u0131ll\u0131k Maksimum",
        used: "Kullan\u0131lan",
        remaining: 'Kalan',
        coverageByCategory: "Kategoriye G\xf6re Kapsam",
        preventive: "\xd6nleyici",
        basic: 'Temel',
        major: "B\xfcy\xfck",
        ortho: 'Ortodonti',
        current: "G\xfcncel",
        thirtyDay: "30 G\xfcn",
        sixtyDay: "60 G\xfcn",
        ninetyPlus: "90+ G\xfcn",
        totalBalance: 'Toplam Bakiye',
        monthlyPayment: "Ayl\u0131k \xd6deme",
        paymentsRemaining: "Kalan \xd6demeler",
        nextPayment: "Sonraki \xd6deme",
        paymentProgress: "\xd6deme \u0130lerlemesi",
        choosePlan: "Plan Se\xe7",
        aiInsight: "AI \u0130\xe7g\xf6r\xfcs\xfc",
        confidence: "G\xfcven",
        revoke: "\u0130ptal Et",
        exams: 'Muayeneler',
        phaseTotal: "Faz Toplam\u0131",
        mon: 'Pzt',
        tue: 'Sal',
        wed: "\xc7ar",
        thu: 'Per',
        fri: 'Cum',
        sat: 'Cmt',
        sun: 'Paz',
        thinking: "D\xfc\u015F\xfcn\xfcyor...",
        followUpPlaceholder: 'Takip sorusu sorun...',
        priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
        patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
        tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
        chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
        english: 'English',
        patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
        xrayAnalysis2: 'X-ray Analysis',
        uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment2: 'Perio Assessment',
        automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe2: 'Clinical Scribe',
        generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling2: 'Risk Profiling',
        analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing2: 'Treatment Sequencing',
        aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientCommunication2: 'Patient Communication',
        generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        insurance2: 'INSURANCE',
        automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
        payments2: 'PAYMENTS',
        onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
        messaging2: 'MESSAGING',
        appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
        ehrLabs2: 'EHR & LABS',
        interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
        clinicsInDatabase: 'Clinics in Database',
        platformModules2: 'Platform Modules',
        integrations2: 'Integrations',
        home2: 'Home',
        features2: 'Features',
        pricing2: 'Pricing',
        dashboard2: 'Dashboard',
        u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
        openFullPeriodontalChart: "Open Full Periodontal Chart \u2192",
        openFullTreatmentPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes2: "Open Clinical Notes \u2192",
        backToAllClinics: "\u2190 Back to all clinics",
        priceRange2: 'Price range:',
        bookAnAppointment: 'Book an Appointment',
        selectDate2: 'Select date',
        selectTime2: 'Select time',
        confirmBooking2: "Confirm Booking \u2192",
        clinics: 'Clinics',
        forBusiness2: 'For Business',
        u00a92026Mcai: '\u00A9 2026 MCAI',
        clinicalNotes: 'Clinical Notes',
        newNote: '+ New Note',
        template: 'Template:',
        crownPrep: 'Crown Prep',
        aiScribe: 'AI Scribe',
        recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
        startRecording: 'Start Recording',
        generateNote: 'Generate Note',
        general: 'General',
        prosthetics: 'Prosthetics',
        typeToSearch: 'Type to search dental terms...',
        revenueToday: 'Revenue Today',
        noshows: 'No-shows',
        confirmed: 'Confirmed',
        time: 'TIME',
        patient: 'PATIENT',
        service: 'SERVICE',
        doctor: 'DOCTOR',
        status2: 'STATUS',
        addPatient: '+ Add Patient',
        mondayMarch19: 'Monday, March 19',
        gBeridzeCheckup: "G. Beridze \u2014 Checkup",
        nKapanadzeWhitening: "N. Kapanadze \u2014 Whitening",
        dGelashviliImplantPhase: "D. Gelashvili \u2014 Implant Phase 2",
        lunchBreak: "\u2014 Lunch Break \u2014",
        mTsiklauriOrthodontics: "M. Tsiklauri \u2014 Orthodontics",
        aJavakhishviliRootCanal: "A. Javakhishvili \u2014 Root Canal",
        lMchedlishviliExtraction: "L. Mchedlishvili \u2014 Extraction",
        tLomidzeCheckup: "T. Lomidze \u2014 Checkup",
        clinicName: 'Clinic Name',
        phone: 'Phone',
        address: 'Address',
        acceptedInsurance: 'Accepted Insurance',
        unison: 'Unison',
        saveSettings: 'Save Settings',
        aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
        openTheFullAi: "Open the full AI Assistant \u2192",
        enterprise: 'Enterprise',
        rolebasedAccessControl: 'Role-Based Access Control',
        permissionMatrix: 'Permission Matrix',
        module: 'Module',
        admin: 'Admin',
        doctor2: 'Doctor',
        hygienist: 'Hygienist',
        reception: 'Reception',
        lab: 'Lab',
        patient2: 'Patient',
        patients: 'Patients',
        full: 'Full',
        read: 'Read',
        none: 'None',
        own: 'Own',
        billing: 'Billing',
        scheduling: 'Scheduling',
        reports: 'Reports',
        settings: 'Settings',
        labOrders: 'Lab Orders',
        auditLog2: 'Audit Log',
        allTypes: 'All Types',
        last7Days: 'Last 7 days',
        complianceDashboard: 'Compliance Dashboard',
        complianceChecklist: 'Compliance Checklist',
        pass: 'PASS',
        dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
        dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
        mfaEnabledForAll: 'MFA enabled for all admin accounts',
        warn: 'WARN',
        dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
        auditLoggingActiveOn: 'Audit logging active on all modules',
        multitenancyManagement: 'Multi-Tenancy Management',
        singleSignonSso: 'Single Sign-On (SSO)',
        saml20: 'SAML 2.0',
        enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
        configured: 'Configured',
        openidConnect: 'OpenID Connect',
        oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
        available2: 'Available',
        signInWithGoogle: 'Sign in with Google organization accounts',
        connected2: 'Connected',
        azureAd: 'Azure AD',
        microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
        featureFlags2: 'Feature Flags',
        aixrayanalysis: 'ai_xray_analysis',
        aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
        voiceperio: 'voice_perio',
        voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
        patientportalv2: 'patient_portal_v2',
        nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
        whatsappreminders: 'whatsapp_reminders',
        multilanguage: 'multi_language',
        multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
        apiManagement2: 'API Management',
        requests24h: 'Requests (24h)',
        avgLatency: 'Avg Latency',
        uptime: 'Uptime',
        apiKeys: 'API Keys',
        dataManagement2: 'Data Management',
        storageUsed: 'Storage Used',
        of100Gb: 'of 100 GB',
        totalRecords: 'Total Records',
        lastBackup: 'Last Backup',
        nextIn4h: 'Next: in 4h',
        dataOperations: 'Data Operations',
        exportAllData: 'Export All Data',
        downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
        export: 'Export',
        purgeOldRecords: 'Purge Old Records',
        removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
        purge: 'Purge',
        dataMigration: 'Data Migration',
        importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
        import: 'Import',
        finance: 'Finance',
        revenueInvoicesPayments: 'Revenue, invoices & payments',
        exportReport: 'Export Report',
        monthlyRevenue: 'Monthly Revenue',
        u20be12400: '\u20BE12,400',
        pending: 'Pending',
        u20be2100: '\u20BE2,100',
        str208: '-5%',
        thisWeek: 'This Week',
        u20be3800: '\u20BE3,800',
        weeklyRevenue: 'Weekly Revenue',
        mon2: 'Mon',
        tue2: 'Tue',
        wed2: 'Wed',
        thu2: 'Thu',
        fri2: 'Fri',
        sat2: 'Sat',
        invoice: 'INVOICE',
        amount: 'AMOUNT',
        inv001: 'INV-001',
        giorgiBeridze: 'Giorgi Beridze',
        checkupXray: 'Checkup + X-ray',
        u20be80: '\u20BE80',
        inv002: 'INV-002',
        ninoKapanadze: 'Nino Kapanadze',
        whitening: 'Whitening',
        u20be120: '\u20BE120',
        inv003: 'INV-003',
        davitGelashvili: 'Davit Gelashvili',
        implantPhase1: 'Implant Phase 1',
        u20be300: '\u20BE300+',
        inv004: 'INV-004',
        anaJavakhishvili: 'Ana Javakhishvili',
        rootCanal: 'Root Canal',
        u20be149: '\u20BE149',
        u2715: '\u2715',
        configuration: 'Configuration',
        apiKey: 'API Key',
        endpointUrl: 'Endpoint URL',
        protocol: 'Protocol',
        syncSettings: 'Sync Settings',
        syncFrequency: 'Sync Frequency',
        every5Minutes: 'Every 5 minutes',
        every15Minutes: 'Every 15 minutes',
        everyHour: 'Every hour',
        manualOnly: 'Manual only',
        autosyncOnChanges: 'Auto-sync on changes',
        lastSynced: 'Last synced',
        disconnect: 'Disconnect',
        testConnection: 'Test Connection',
        labCasePipeline: 'Lab Case Pipeline',
        labVendors2: 'Lab Vendors',
        tbilisidentLab: 'TbilisiDent Lab',
        turnaround710Days: 'Turnaround: 7-10 days',
        rating485: 'Rating: 4.8/5',
        activeCases4: 'Active Cases: 4',
        caucasusDentalLab: 'Caucasus Dental Lab',
        turnaround57Days: 'Turnaround: 5-7 days',
        rating465: 'Rating: 4.6/5',
        activeCases2: 'Active Cases: 2',
        euroDentalGeorgia: 'Euro Dental Georgia',
        turnaround1014Days: 'Turnaround: 10-14 days',
        rating445: 'Rating: 4.4/5',
        enterSpaceForClinics: "Enter space for clinics \u2192",
        book: 'Book',
        followupConsultation: 'Follow-up Consultation',
        postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
        rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
        completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
        periapicalXray: 'Periapical X-ray',
        workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
        medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
        prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
        diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
        patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
        compositeFillingTooth21: 'Composite Filling - Tooth #21',
        classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
        labResultsCbcPanel: 'Lab Results: CBC Panel',
        completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
        fullmouthRadiographs: 'Full-mouth Radiographs',
        panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
        comprehensiveExamination: 'Comprehensive Examination',
        initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
        medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
        patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
        patientRegistration: 'Patient Registration',
        newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
        activeConditions: 'Active Conditions',
        chronicPeriodontitis: 'Chronic Periodontitis',
        active: 'Active',
        generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
        onsetJan2026: 'Onset: Jan 2026',
        dentalCaries: 'Dental Caries',
        resolved: 'Resolved',
        cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
        resolvedFeb2026: 'Resolved: Feb 2026',
        bruxism: 'Bruxism',
        nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
        activeMedications: 'Active Medications',
        lisinopril10mg: 'Lisinopril 10mg',
        onceDailyOral: 'Once daily, oral',
        hypertensionManagement: 'Hypertension management',
        chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
        twiceDailyOralRinse: 'Twice daily, oral rinse',
        periodontalMaintenance: 'Periodontal maintenance',
        ibuprofen400mg: 'Ibuprofen 400mg',
        asNeededForPain: 'As needed for pain, max 3x daily',
        postprocedurePainManagement: 'Post-procedure pain management',
        pastMedications: 'Past Medications',
        amoxicillin500mg: 'Amoxicillin 500mg',
        periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
        completed2: 'Completed',
        metronidazole250mg: 'Metronidazole 250mg',
        adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
        paracetamol500mg: 'Paracetamol 500mg',
        asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
        postfillingSensitivity: 'Post-filling sensitivity',
        diclofenac50mg: 'Diclofenac 50mg',
        twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
        postexamSoreness: 'Post-exam soreness',
        documentedAllergies: 'Documented Allergies',
        penicillin: 'Penicillin',
        severe: 'SEVERE',
        reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
        crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
        documentedJan102026: 'Documented: Jan 10, 2026',
        latex: 'Latex',
        moderate: 'MODERATE',
        reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
        useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
        lidocaine: 'Lidocaine',
        mild: 'MILD',
        reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
        useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
        latestVitalsMar15: "Latest Vitals \u2014 Mar 15, 2026",
        labResults2: 'Lab Results',
        test: 'TEST',
        result: 'RESULT',
        reference: 'REFERENCE',
        date: 'DATE',
        hemoglobin: 'Hemoglobin',
        platelets: 'Platelets',
        glucoseFasting: 'Glucose (fasting)',
        immunizationRecords: 'Immunization Records',
        hepatitisB: 'Hepatitis B',
        completed3doseSeries2019: 'Completed: 3-dose series, 2019',
        upToDate: 'Up to date',
        tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
        lastBooster2022: 'Last booster: 2022',
        covid19: 'COVID-19',
        lastDoseSep2024: 'Last dose: Sep 2024',
        dueForBooster: 'Due for booster',
        familyMedicalHistory: 'Family Medical History',
        father: 'Father',
        hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
        mother: 'Mother',
        osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
        sibling: 'Sibling',
        bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
        imagingRecords: 'Imaging Records',
        panoramicOpg: 'Panoramic OPG',
        periapical14: 'Periapical #14',
        bitewingRl: 'Bitewing R+L',
        patientDocuments: 'Patient Documents',
        consentFormRootCanal: 'Consent Form - Root Canal',
        treatmentPlanAgreement: 'Treatment Plan Agreement',
        medicalHistoryQuestionnaire: 'Medical History Questionnaire',
        insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
        insuranceInformation: 'Insurance Information',
        provider: 'Provider:',
        policy: 'Policy #:',
        group: 'Group:',
        corporatePlanPremium: 'Corporate Plan - Premium',
        coverage: 'Coverage:',
        deductible: 'Deductible:',
        annualMax2: 'Annual Max:',
        valid: 'Valid:',
        age34: 'Age: 34',
        lastVisitMar10: 'Last visit: Mar 10',
        nextMar19: 'Next: Mar 19',
        overview: 'Overview',
        dentalChart: 'Dental Chart',
        treatmentPlan: 'Treatment Plan',
        history: 'History',
        documents2: 'Documents',
        allergies2: 'Allergies',
        medicalNotes: 'Medical Notes',
        insurance3: 'Insurance',
        upperArch: 'Upper Arch',
        lowerArch: 'Lower Arch',
        tooth: 'TOOTH',
        procedure2: 'PROCEDURE',
        price: 'PRICE',
        rootCanalTreatment: 'Root Canal Treatment',
        ceramicCrown: 'Ceramic Crown',
        compositeFilling: 'Composite Filling',
        implantPlacement: 'Implant Placement',
        total: 'Total',
        addProcedure2: '+ Add Procedure',
        march102026: 'March 10, 2026',
        periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
        february152026: 'February 15, 2026',
        compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
        january202026: 'January 20, 2026',
        comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
        bitewingRight: 'Bitewing Right',
        bitewingLeft: 'Bitewing Left',
        uploadDocument: '+ Upload Document',
        all: 'All',
        new: 'New',
        phone2: 'PHONE',
        lastVisit: 'LAST VISIT',
        nextAppt: 'NEXT APPT',
        balance: 'BALANCE',
        pt001: 'PT-001',
        pt002: 'PT-002',
        pt003: 'PT-003',
        mariamTsiklauri: 'Mariam Tsiklauri',
        pt004: 'PT-004',
        pt005: 'PT-005',
        lukaMchedlishvili: 'Luka Mchedlishvili',
        pt006: 'PT-006',
        tamtaLomidze: 'Tamta Lomidze',
        pt007: 'PT-007',
        periodontalChart: 'Periodontal Chart',
        newExam2: '+ New Exam',
        voiceEntry2: 'Voice Entry',
        dcai: 'DCAI',
        dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
        theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
        manage: 'Manage',
        grow: 'Grow',
        marketSize: 'Market Size',
        dentalClinicsInGeorgia: 'dental clinics in Georgia',
        inTbilisiAlone: 'in Tbilisi alone',
        unifiedBookingOrOps: 'unified booking or ops platforms',
        dentosgeIsTheOnly: "\u26A0\uFE0F  dentos.ge is the only partial incumbent \u2014 no full ops layer",
        theProblem2: 'The Problem',
        str511: "\uD83D\uDCCB",
        clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
        noStructuredWorkflowConstant: 'No structured workflow, constant human error',
        str514: "\uD83D\uDCC9",
        noshowsCost1525Of: "No-shows cost 15\u201325% of revenue",
        noAutomatedRemindersOr: 'No automated reminders or confirmation system',
        str517: "\uD83C\uDFE6",
        insuranceBillingIsManual: 'Insurance billing is manual and painful',
        str519: "\uD83D\uDCF5",
        dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
        theSolution: 'The Solution',
        str523: "\uD83D\uDCC5",
        onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
        patientsBook247From: 'Patients book 24/7 from any device',
        str526: "\uD83E\uDDB7",
        patientRecordsTreatmentManagem: 'Patient records & treatment management',
        fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
        str529: "\uD83C\uDFE5",
        insuranceIntegrations: 'Insurance integrations',
        str531: "\uD83D\uDCAC",
        smsWhatsappReminders: 'SMS / WhatsApp reminders',
        cutNoshowsByUp: 'Cut no-shows by up to 40%',
        str534: "\uD83D\uDCCA",
        financialReportingDashboard: 'Financial reporting dashboard',
        revenueSalariesExpensesRealtim: "Revenue, salaries, expenses \u2014 realtime",
        willingnessToPay: 'Willingness to Pay',
        free: 'Free',
        month: '/month',
        listingBookingWidget: 'Listing + booking widget',
        growth: 'Growth',
        calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
        pro: 'Pro',
        fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
        multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
        wtp0515OfMonthly: "\uD83D\uDCA1 WTP: 0.5\u20131.5% of monthly revenue \u2014 clinics earning \u20BE15K\u201350K/mo pay \u20BE100\u2013350/mo comfortably",
        marketOpportunity: 'Market Opportunity',
        addressableClinicsAtLaunch: 'addressable clinics at launch',
        mrrAtFullPenetration: "MRR at full penetration (\u20BE49 avg)",
        home: 'Ana Sayfa',
        features: "\xd6zellikler",
        pricing: 'Fiyatlar',
        clinicsNav: 'Klinikler',
        aiAssistant: 'AI Asistan',
        forBusiness: "\u0130\u015Fletmeler \u0130\xe7in",
        dashboard: 'Panel',
        getStarted: "Ba\u015Fla",
        tryDemo: 'Demoyu Dene',
        viewPitch: "Sunumu G\xf6r",
        heroTagline: "G\xfcrcistan i\xe7in Di\u015F Hekimli\u011Fi Platformu",
        heroTitle: "T\xfcm di\u015F klinikleri merkezi",
        heroSubtitle: "G\xfcrcistan'da en iyi di\u015F bak\u0131m\u0131n\u0131 bulmak i\xe7in AI asistan\u0131n\u0131z",
        searchPlaceholder: "Klinik, hizmet aray\u0131n veya soru sorun...",
        chipImplant: "Tiflis'teki en iyi implant klinikleri",
        chipWhitening: "Yak\u0131n\u0131mdaki di\u015F beyazlatma",
        chipEmergency: "Acil di\u015F bak\u0131m\u0131",
        chipOrtho: "Yeti\u015Fkinler i\xe7in ortodonti",
        scrollExplore: "Ke\u015Ffetmek i\xe7in kayd\u0131r\u0131n",
        topRated: "Tiflis'in en iyi di\u015F klinikleri",
        viewAllClinics: "T\xfcm klinikler",
        shareLocation: "Yak\u0131n klinikler i\xe7in konum payla\u015F",
        locationShared: "Konum payla\u015F\u0131ld\u0131",
        statClinics: 'Klinikler',
        statNoShows: 'Daha az iptal',
        statBooking: 'Online randevu',
        statDentists: "Di\u015F Hekimi",
        statRating: 'Ort. Puan',
        statPatients: 'Hastalar',
        findClinics: "En \u0130yi Klinikleri Bul",
        forBusinessBtn: "\u0130\u015Fletmeler \u0130\xe7in",
        clinicsTitle: "G\xfcrcistan'daki Di\u015F Klinikleri",
        verifiedClinics: "onayl\u0131 klinik",
        searchByName: "\u0130sim, b\xf6lge veya hizmete g\xf6re aray\u0131n...",
        reviews: 'yorum',
        loadingMore: "Y\xfckleniyor...",
        callClinic: 'Ara',
        bookAppointment: 'Randevu Al',
        services: 'Hizmetler',
        workingHours: "\xc7al\u0131\u015Fma Saatleri",
        priceRange: "Fiyat Aral\u0131\u011F\u0131",
        location: 'Konum',
        visitWebsite: 'Siteyi Ziyaret Et',
        bookingTitle: 'Randevu Al',
        step: "Ad\u0131m",
        selectClinic: "Klinik Se\xe7in",
        selectService: "Hizmet Se\xe7in",
        selectDate: "Tarih Se\xe7in",
        selectTime: "Saat Se\xe7in",
        confirm: 'Onayla',
        next: "\u0130leri",
        back: 'Geri',
        clinicsAvailable: 'klinik mevcut',
        confirmBooking: 'Randevuyu Onayla',
        patientName: "Hasta Ad\u0131",
        phoneNumber: "Telefon Numaras\u0131",
        email: 'E-posta',
        ownClinic: "Bir di\u015F klini\u011Finiz mi var?",
        claimText: "Klini\u011Finizi veritaban\u0131m\u0131za kaydedin veya ekleyin.",
        getListed: "Kaydolun \u2192",
        hideMap: "Haritay\u0131 Gizle",
        showMap: 'Harita',
        nearMe: "Yak\u0131n\u0131mda",
        clinicsMatch: "klinik e\u015Fle\u015Fiyor",
        clinicsFound: 'klinik bulundu',
        bookingConfirmed: "Randevunuz onayland\u0131!",
        notes: "Notlar (iste\u011Fe ba\u011Fl\u0131)",
        businessHeroBadge: "15+ Mod\xfcl  \xb7  212+ Klinik  \xb7  Gemini AI",
        businessHeroTitle: "Di\u015F Klinikleri \u0130\xe7in \u0130\u015Fletim Sistemi",
        businessHeroSubtitle: "Klinik kartlama, periodontal analiz, tedavi planlamas\u0131, planlama, faturaland\u0131rma, e-re\xe7ete, laboratuvar y\xf6netimi ve AI tan\u0131 \u2014 G\xfcrcistan i\xe7in tek platformda.",
        theProblem: 'Sorun',
        problemSubtitle: "G\xfcrcistan di\u015F klinikleri par\xe7al\u0131 ara\xe7lar nedeniyle g\xfcnl\xfck gelir kaybediyor",
        excelChaos: 'Excel ve WhatsApp Kaosu',
        excelChaosDetail: "Klinikler randevular\u0131 tablolar ve sohbet gruplar\u0131yla y\xf6netiyor. S\u0131f\u0131r otomasyon, s\xfcrekli hatalar.",
        noShowRate: "%25 \u0130ptal Oran\u0131",
        noShowDetail: "Otomatik hat\u0131rlatmalar olmadan hastalar randevular\u0131 unutuyor. Bo\u015F koltuklar g\xfcnde \u20BE500+ kay\u0131p.",
        paperCharts: "2026'da Ka\u011F\u0131t Kartlar",
        paperChartsDetail: "El yaz\u0131s\u0131 klinik notlar, dijital odontogram yok. Kritik veriler dosya dolaplar\u0131nda kilitli.",
        insuranceBlackHole: "Sigorta Kara Deli\u011Fi",
        insuranceDetail: "Aldagi, GPI, Imedi L'ye manuel talepler saatler s\xfcr\xfcyor. Reddedilen talepler birikiyor.",
        oneplatform: "Tek Platform, Her Mod\xfcl",
        platformSubtitle: "Di\u015F hekimli\u011Fi uygulamalar\u0131 i\xe7in 15 entegre mod\xfcl",
        clinical: "KL\u0130N\u0130K",
        operations: 'OPERASYONLAR',
        analyticsEnterprise: "ANAL\u0130T\u0130K VE KURUMSAL",
        digitalOdontogram: 'Dijital Odontogram',
        digitalOdontogramDetail: "FDI 32 di\u015Fli kart, 5 y\xfczey takibi.",
        perioCharting: 'Periodontal Kartlama',
        perioChartingDetail: "192 noktal\u0131 periodontal \u0131zgara. 6 noktal\u0131 sondaj, BOP, CAL.",
        treatmentPlanning: "Tedavi Planlamas\u0131",
        treatmentPlanningDetail: "CDT kodlar\u0131yla faz planlar\u0131, sigorta tahminleri. AI sekanslamas\u0131.",
        soapNotes: "SOAP Notlar\u0131 + AI Yaz\u0131c\u0131",
        soapNotesDetail: "\u015Eablonlarla yap\u0131land\u0131r\u0131lm\u0131\u015F klinik dok\xfcmantasyon. Gemini sesten not \xfcretiyor.",
        multiChairScheduling: "\xc7oklu Koltuk Planlamas\u0131",
        multiChairDetail: "Birden fazla operatoryumlu haftal\u0131k g\xf6r\xfcn\xfcm. Doktor renk kodlamas\u0131.",
        billingInsurance: "Faturaland\u0131rma ve Sigorta",
        billingDetail: "Aldagi, GPI, Imedi L i\xe7in talep takibi. Hasta defteri, \xf6deme planlar\u0131.",
        ePrescribing: "E-Re\xe7ete",
        ePrescribingDetail: "\u015Eablonlarla dijital re\xe7eteler. Gemini ile ila\xe7 etkile\u015Fim kontrol\xfc.",
        labTracking: 'Laboratuvar Takibi',
        labTrackingDetail: "Kanban: Sipari\u015F \u2192 \xdcretim \u2192 G\xf6nderim \u2192 Teslim.",
        productionReports: "\xdcretim Raporlar\u0131",
        productionReportsDetail: "Br\xfct/net \xfcretim, tahsilat oranlar\u0131, tedavi kabul\xfc.",
        referralMgmt: "Sevk Y\xf6netimi",
        referralMgmtDetail: "Uzmanlara gelen/giden sevkler. AI ile olu\u015Fturulan mektuplar.",
        medicalHistory: "T\u0131bbi Ge\xe7mi\u015F",
        medicalHistoryDetail: "11 g\xf6r\xfcn\xfcml\xfc hasta kayd\u0131: zaman \xe7izelgesi, durumlar, ila\xe7lar, alerjiler.",
        enterpriseAdmin: "Kurumsal Y\xf6netim",
        enterpriseAdminDetail: "RBAC, denetim g\xfcnl\xfc\u011F\xfc, uyumluluk, \xe7oklu kirac\u0131l\u0131k, SSO, API y\xf6netimi.",
        geminiBuiltIn: "Yerle\u015Fik Gemini AI",
        geminiSubtitle: "Her mod\xfcl Google Gemini 3.1 ile \xe7al\u0131\u015F\u0131r",
        xrayAnalysis: "R\xf6ntgen Analizi",
        xrayDetail: "AI \xe7\xfcr\xfck tespiti i\xe7in di\u015F r\xf6ntgenlerini y\xfckleyin.",
        perioAssessment: "Periodontal De\u011Ferlendirme",
        perioAssessmentDetail: 'Sondaj verilerinden otomatik AAP evreleme/derecelendirme.',
        clinicalScribe: "Klinik Yaz\u0131c\u0131",
        clinicalScribeDetail: "Ses kay\u0131tlar\u0131ndan veya kart verilerinden SOAP not \xfcretimi.",
        riskProfiling: 'Risk Profilleme',
        riskProfilingDetail: "Di\u015F riski profili i\xe7in durumlar, aile ge\xe7mi\u015Fi analizi.",
        treatmentSequencing: 'Tedavi Sekanslama',
        treatmentSequencingDetail: "\u0130yile\u015Fme ve sigortay\u0131 dikkate alan AI optimizeli tedavi fazlamas\u0131.",
        patientComm: "Hasta \u0130leti\u015Fimi",
        patientCommDetail: "G\xfcrc\xfcce hasta dostu a\xe7\u0131klamalar \xfcretimi.",
        georgianEcosystem: "G\xfcrcistan Ekosistemi Haz\u0131r",
        integrationsSubtitle: "Yerel sigorta, \xf6deme ve mesajla\u015Fma ile \xf6nceden olu\u015Fturulmu\u015F entegrasyonlar",
        insurance: "S\u0130GORTA",
        payments: "\xd6DEMELER",
        messaging: "MESAJLA\u015EMA",
        ehrLabs: 'EHR VE LABORATUVARLAR',
        clinicsInDb: "Veritaban\u0131ndaki Klinikler",
        platformModules: "Platform Mod\xfclleri",
        aiTools: "AI Ara\xe7lar\u0131 (Gemini)",
        integrations: 'Entegrasyonlar',
        pricingTitle: 'Fiyatlar',
        pricingSubtitle: "\xdccretsiz ba\u015Flay\u0131n",
        trustedBy: "Kliniklerin G\xfcveni",
        readyModernize: "Modernle\u015Fmeye haz\u0131r m\u0131s\u0131n\u0131z?",
        joinCount: "G\xfcrcistan'daki 212+ klini\u011Fe kat\u0131l\u0131n.",
        startTrial: "\xdccretsiz Dene",
        contactSales: "Sat\u0131\u015Fla \u0130leti\u015Fim",
        noCreditCard: "Kredi kart\u0131 gerekmez  \xb7  \xdccretsiz plan  \xb7  5 dakikada kurulum",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: 'Panel',
        navPatients: 'Hastalar',
        navChart: 'Kart',
        navPerio: 'Periodontoloji',
        navTreatmentPlans: "Tedavi Planlar\u0131",
        navNotes: 'Notlar',
        navScheduling: 'Planlama',
        navBilling: "Faturaland\u0131rma",
        navPrescriptions: "Re\xe7eteler",
        navLabCases: "Laboratuvar Vakalar\u0131",
        navReferrals: 'Sevkler',
        navReports: 'Raporlar',
        navMedHistory: "T\u0131bbi Ge\xe7mi\u015F",
        navIntegrations: 'Entegrasyonlar',
        navEnterprise: 'Kurumsal',
        sectionClinical: "KL\u0130N\u0130K",
        sectionOperations: 'OPERASYONLAR',
        sectionAnalytics: "ANAL\u0130T\u0130K",
        sectionAiTools: "AI ARA\xc7LARI",
        sectionAdmin: "Y\xd6NET\u0130M",
        // Booking Page
        chooseClinic: "Klinik Se\xe7in",
        selectAService: "Hizmet Se\xe7in",
        pickADate: "Tarih Se\xe7in",
        pickATime: "Saat Se\xe7in",
        confirmYourBooking: "Randevunuzu Onaylay\u0131n",
        clinicLabel: 'Klinik:',
        serviceLabel: 'Hizmet:',
        dateLabel: 'Tarih:',
        timeLabel: 'Saat:',
        // AI Page
        send: "G\xf6nder",
        procedure: "Prosed\xfcr",
        observations: "G\xf6zlemler",
        aiThinking: "AI d\xfc\u015F\xfcn\xfcyor...",
        summarizeHistory: "Hasta ge\xe7mi\u015Fini \xf6zetle",
        generateTxPlan: "Tedavi plan\u0131 olu\u015Ftur",
        checkDrugInteractions: "\u0130la\xe7 etkile\u015Fimlerini kontrol et",
        writeClinicalNote: 'Klinik not yaz',
        askAiAssistant: 'AI asistana sorun...',
        dropXray: "R\xf6ntgen g\xf6r\xfcnt\xfcs\xfcn\xfc b\u0131rak\u0131n veya y\xfcklemek i\xe7in t\u0131klay\u0131n",
        supportsFormats: 'DICOM, PNG, JPG desteklenir',
        analysisResults: "Analiz Sonu\xe7lar\u0131 (Demo)",
        aiRecommendation: "AI \xd6nerisi",
        exportToTxPlan: "Tedavi Plan\u0131na Aktar",
        generateClinicalNote: "Klinik Not Olu\u015Ftur",
        generatedSoap: "Olu\u015Fturulan Klinik Not (SOAP)",
        subjective: "S \u2014 Subjektif",
        objective: "O \u2014 Objektif",
        assessment: "A \u2014 De\u011Ferlendirme",
        plan: "P \u2014 Plan",
        copyToRecord: "Hasta Kayd\u0131na Kopyala",
        aiPerioAssessment: "AI Periodontal De\u011Ferlendirme",
        enterProbingData: "AAP evreleme/derecelendirme ve tedavi \xf6nerileri i\xe7in sondaj verilerini girin.",
        analyzeWithGemini: 'Gemini ile Analiz Et',
        aiRiskAssessment: "AI Risk De\u011Ferlendirmesi",
        enterConditions: "Risk profili olu\u015Fturmak i\xe7in hasta durumlar\u0131n\u0131, aile ge\xe7mi\u015Fini ve vital bulgular\u0131n\u0131 girin.",
        generateRiskProfile: "Risk Profili Olu\u015Ftur",
        patientCommunication: "Hasta \u0130leti\u015Fimi",
        generateExplanations: "G\xfcrc\xfcce veya \u0130ngilizce hasta dostu tedavi a\xe7\u0131klamalar\u0131 olu\u015Fturun.",
        generateExplanation: "A\xe7\u0131klama Olu\u015Ftur",
        patientFriendly: "Hasta Dostu A\xe7\u0131klama",
        // Billing Page
        claims: 'Talepler',
        ledger: 'Muhasebe Defteri',
        aging: "Ya\u015Fland\u0131rma",
        paymentPlans: "\xd6deme Planlar\u0131",
        eligibility: 'Uygunluk',
        allFilter: "T\xfcm\xfc",
        submitted: "G\xf6nderildi",
        paid: "\xd6dendi",
        denied: 'Reddedildi',
        patientLedger: 'Hasta Muhasebesi',
        agedAccounts: "Vadesi Ge\xe7mi\u015F Hesaplar",
        sendStatements: "Hesap \xd6zetlerini G\xf6nder",
        activePaymentPlans: "Aktif \xd6deme Planlar\u0131",
        insuranceEligibility: "Sigorta Uygunlu\u011Fu",
        // Clinical Charting
        odontogram: 'Odontogram',
        perioTab: 'Periodontoloji',
        treatmentPlanTab: "Tedavi Plan\u0131",
        notesTab: 'Notlar',
        progressNotes: "\u0130lerleme Notlar\u0131",
        openFullPerio: "Tam Periodontal Kart\u0131 A\xe7 \u2192",
        openFullTxPlanner: "Tam Tedavi Planlay\u0131c\u0131s\u0131n\u0131 A\xe7 \u2192",
        openClinicalNotes: "Klinik Notlar\u0131 A\xe7 \u2192",
        newExam: 'Yeni Muayene',
        voiceEntry: "Sesli Giri\u015F",
        bleedingIndex: "Kanama \u0130ndeksi",
        plaqueIndex: "Plak \u0130ndeksi",
        sitesAbove4: "B\xf6lgeler \u2265 4mm",
        sitesAbove6: "B\xf6lgeler \u2265 6mm",
        planA: "Plan A: \xd6nerilen",
        planB: 'Plan B: Konservatif',
        newPlan: '+ Yeni Plan',
        presentToPatient: 'Hastaya Sun',
        sendToPortal: "Portala G\xf6nder",
        totalFee: "Toplam \xdccret",
        insuranceEst: 'Sigorta Tahmini',
        patientPortion: "Hasta Pay\u0131",
        chairSideMode: 'Koltuk Modu',
        adminMode: "Y\xf6netici Modu",
        proceduresAcrossPhases: "{1} fazda {0} i\u015Flem",
        // Scheduling
        day: "G\xfcn",
        week: 'Hafta',
        today: "Bug\xfcn",
        providerFilter: "T\xfcm Sa\u011Flay\u0131c\u0131lar",
        productionGoal: "\xdcretim Hedefi",
        waitlist: 'Bekleme Listesi',
        // Prescriptions
        activeRx: 'Aktif',
        pastRx: "Ge\xe7mi\u015F",
        templates: "\u015Eablonlar",
        interactionCheck: "Etkile\u015Fim Kontrol\xfc",
        // Lab Cases
        ordered: "Sipari\u015F Verildi",
        sentToLab: "Laboratuvara G\xf6nderildi",
        inFabrication: "\xdcretimde",
        shipped: "G\xf6nderildi",
        received: "Teslim Al\u0131nd\u0131",
        labVendors: "Laboratuvar Tedarik\xe7ileri",
        // Referrals
        allDirections: "T\xfcm\xfc",
        inbound: 'Gelen',
        outbound: 'Giden',
        generateLetter: "Mektup Olu\u015Ftur",
        // Reports
        production: "\xdcretim",
        collections: 'Tahsilatlar',
        schedulingReport: 'Planlama',
        treatmentAcceptance: "Tedavi Kabul\xfc",
        recall: "Geri \xc7a\u011F\u0131rma",
        grossProduction: "Br\xfct \xdcretim",
        netProduction: "Net \xdcretim",
        collectionRate: "Tahsilat Oran\u0131",
        plansPresented: 'Sunulan Planlar',
        accepted: 'Kabul Edildi',
        acceptanceRate: "Kabul Oran\u0131",
        dueThisMonth: 'Bu Ay Planlanan',
        scheduled: "Planland\u0131",
        completed: "Tamamland\u0131",
        overdue: "Gecikmi\u015F",
        reactivationRate: "Reaktivasyon Oran\u0131",
        // Medical History
        timeline: "Zaman \xc7izelgesi",
        conditions: 'Durumlar',
        medications: "\u0130la\xe7lar",
        allergies: 'Alerjiler',
        labResults: "Laboratuvar Sonu\xe7lar\u0131",
        vitals: 'Vital Bulgular',
        immunizations: "A\u015F\u0131lar",
        familyHistory: "Aile Ge\xe7mi\u015Fi",
        imaging: "G\xf6r\xfcnt\xfcleme",
        documents: 'Belgeler',
        // Enterprise
        rbac: 'RBAC',
        auditLog: "Denetim G\xfcnl\xfc\u011F\xfc",
        compliance: 'Uyumluluk',
        multiTenancy: "\xc7oklu Kirac\u0131l\u0131k",
        sso: "SSO ve G\xfcvenlik",
        featureFlags: "\xd6zellik Bayraklar\u0131",
        apiManagement: "API Y\xf6netimi",
        dataManagement: "Veri Y\xf6netimi",
        // Integrations
        ehr: 'EHR',
        labs: 'Laboratuvarlar',
        telehealth: "Telesa\u011Fl\u0131k",
        aiMl: 'AI/ML',
        wearables: 'Giyilebilir Cihazlar',
        connected: "Ba\u011Fl\u0131",
        disconnected: "Ba\u011Flant\u0131 Kesildi",
        available: 'Mevcut',
        // Components
        status: 'Durum',
        healthy: "Sa\u011Fl\u0131kl\u0131",
        caries: "\xc7\xfcr\xfck",
        restored: "Restore Edilmi\u015F",
        missing: 'Eksik',
        implant: "\u0130mplant",
        crownStatus: 'Kron',
        bridge: "K\xf6pr\xfc",
        veneer: 'Veneer',
        braces: 'Braces',
        surfaces: "Y\xfczeyler",
        procedureHistory: "\u0130\u015Flem Ge\xe7mi\u015Fi",
        addProcedure: "\u0130\u015Flem Ekle",
        totalCharged: "Toplam Bor\xe7",
        insurancePayment: "Sigorta \xd6demesi",
        patientResponsibility: "Hasta Sorumlulu\u011Fu",
        expand: "Geni\u015Flet",
        policyNumber: "Poli\xe7e No",
        planType: "Plan T\xfcr\xfc",
        annualMax: "Y\u0131ll\u0131k Maksimum",
        used: "Kullan\u0131lan",
        remaining: 'Kalan',
        coverageByCategory: "Kategoriye G\xf6re Kapsam",
        preventive: "\xd6nleyici",
        basic: 'Temel',
        major: "B\xfcy\xfck",
        ortho: 'Ortodonti',
        current: "G\xfcncel",
        thirtyDay: "30 G\xfcn",
        sixtyDay: "60 G\xfcn",
        ninetyPlus: "90+ G\xfcn",
        totalBalance: 'Toplam Bakiye',
        monthlyPayment: "Ayl\u0131k \xd6deme",
        paymentsRemaining: "Kalan \xd6demeler",
        nextPayment: "Sonraki \xd6deme",
        paymentProgress: "\xd6deme \u0130lerlemesi",
        choosePlan: "Plan Se\xe7",
        aiInsight: "AI \u0130\xe7g\xf6r\xfcs\xfc",
        confidence: "G\xfcven",
        revoke: "\u0130ptal Et",
        exams: 'Muayeneler',
        phaseTotal: "Faz Toplam\u0131",
        mon: 'Pzt',
        tue: 'Sal',
        wed: "\xc7ar",
        thu: 'Per',
        fri: 'Cum',
        sat: 'Cmt',
        sun: 'Paz',
        thinking: "D\xfc\u015F\xfcn\xfcyor...",
        followUpPlaceholder: 'Takip sorusu sorun...',
        initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
        nextExpansionArmeniaAzerbaijan: "\uD83C\uDF0D  Next expansion: Armenia \u2192 Azerbaijan \u2192 broader Caucasus dental market",
        whyNow: 'Why Now',
        str561: "\u2708\uFE0F",
        dentalTourismBoom: 'Dental tourism boom',
        internationalPatientsNeedEngli: 'International patients need English-language online booking now',
        str564: "\uD83D\uDCF1",
        postcovidDigitizationPressure: 'Post-COVID digitization pressure',
        clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
        str567: "\uD83C\uDFC6",
        noStrongLocalIncumbent: 'No strong local incumbent',
        dentosgeOnlyCoversDiscovery: "dentos.ge only covers discovery \u2014 zero full ops platform exists",
        str570: "\uD83C\uDDEC\uD83C\uDDEA",
        georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
        lowCostHighQuality: "Low cost, high quality \u2014 50\u201370% cheaper than Western Europe",
        joinThePartnerClinic: "Join the Partner Clinic Program \u2014 first 3 months free",
        builtForGeorgianClinics: "\uD83E\uDDB7 Built for Georgian clinics, by people who live here",
        prev: "\u2190 Prev",
        next2: "Next \u2192",
        getInTouch: "\uD83E\uDDB7 Get in Touch",
        activePrescriptions: 'Active Prescriptions',
        pastPrescriptions: 'Past Prescriptions',
        prescriptionTemplates: 'Prescription Templates',
        drugInteractionChecker: 'Drug Interaction Checker',
        referrals: 'Referrals',
        newReferral: '+ New Referral',
        inbound2: 'Inbound',
        outbound2: 'Outbound',
        reportsAnalytics: 'Reports & Analytics',
        productionByProvider: 'Production by Provider',
        productionByCategory: 'Production by Category',
        preventive2: 'Preventive',
        restorative: 'Restorative',
        endodontics: 'Endodontics',
        periodontics: 'Periodontics',
        prosthodontics: 'Prosthodontics',
        surgery: 'Surgery',
        agingReport: 'Aging Report',
        appointmentsByDay: 'Appointments by Day',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        topDeclinedTreatments: 'Top Declined Treatments',
        costConcerns: 'Cost concerns',
        wantsToWait: 'Wants to wait',
        orthodontics: 'Orthodontics',
        insuranceNotCovering: 'Insurance not covering',
        notAPriority: 'Not a priority',
        seekingSecondOpinion: 'Seeking second opinion',
        u2190: '\u2190',
        u2192: '\u2192',
        allProviders: 'All Providers',
        hygienistNino: 'Hygienist Nino',
        mon17: 'MON 17',
        tue18: 'TUE 18',
        wed19: 'WED 19',
        thu20: 'THU 20',
        fri21: 'FRI 21',
        crownPrep14: 'Crown Prep #14',
        tKapanadze: 'T. Kapanadze',
        srpQuad1: 'SRP Quad 1',
        dGelashvili: 'D. Gelashvili',
        examXray: 'Exam + X-ray',
        mTsiklauri: 'M. Tsiklauri',
        unconfirmed: 'Unconfirmed',
        rct36: 'RCT #36',
        gBeridze: 'G. Beridze',
        prophyPolish: 'Prophy + Polish',
        iDiasamidze: 'I. Diasamidze',
        perioMaintenance: 'Perio Maintenance',
        tLomidze: 'T. Lomidze',
        prophy: 'Prophy',
        aJavakhishvili: 'A. Javakhishvili',
        inChair: 'In Chair',
        sealantsX4: 'Sealants x4',
        nKapanadze: 'N. Kapanadze',
        lMchedlishvili: 'L. Mchedlishvili',
        u2014LunchU2014: '\u2014 Lunch \u2014',
        veneerPrep11: 'Veneer Prep #11',
        kGabrichidze: 'K. Gabrichidze',
        composite25: 'Composite #25',
        sMeladze: 'S. Meladze',
        bridgePrep3436: 'Bridge Prep #34-36',
        rKharazishvili: 'R. Kharazishvili',
        composite22: 'Composite #22',
        zDolidze: 'Z. Dolidze',
        noShow: 'No Show',
        extraction48: 'Extraction #48',
        vPapunashvili: 'V. Papunashvili',
        implantConsult: 'Implant Consult',
        eTsereteli: 'E. Tsereteli',
        nGogiberidze: 'N. Gogiberidze',
        crownSeat14: 'Crown Seat #14',
        checkup: 'Checkup',
        bShengelia: 'B. Shengelia',
        fluorideTreatment: 'Fluoride Treatment',
        emergencyWalkin: 'Emergency Walk-in',
        scaling: 'Scaling',
        wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
        assignToSchedule: 'Assign to Schedule',
        autoAssign: 'Auto Assign',
        high: 'High',
        anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
        medium: 'Medium',
        irakliDiasamidze: 'Irakli Diasamidze',
        friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
        low: 'Low',
        planARecommended: 'Plan A: Recommended',
        planBConservative: 'Plan B: Conservative',
        newPlan2: '+ New Plan',
        conservativeApproach: 'Conservative Approach',
        thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
        u00b7: '\u00B7',
        treatmentPlanComparison: 'Treatment Plan Comparison',
        u00b72: '\u00b7',
        exams2: 'Exams:',
        metric: 'Metric',
        pdMm: 'PD (mm)',
        gmMm: 'GM (mm)',
        calMm: 'CAL (mm)',
        suppuration: 'Suppuration',
        furcation: 'Furcation',
        mobility: 'Mobility',
        qty: 'Qty',
        refills: 'Refills',
        goal: 'Goal',
        current2: 'Current',
        totalDue: 'Total Due',
        scheduled2: 'Scheduled',
        overdue2: 'Overdue',
        reactivation: 'Reactivation',
        chiefComplaint: 'Chief Complaint',
        painScale: 'Pain Scale:',
        clinicalFindings: 'Clinical Findings',
        diagnosis: 'Diagnosis',
        prescriptions: 'Prescriptions',
        u201c: '\u201C',
        xray: 'X-Ray',
        cleaning: 'Cleaning',
        amountPaid: 'Amount Paid',
        annotate: 'Annotate',
        anonymousPatient: 'Anonymous Patient',
        autoImport: 'Auto Import',
        away: 'Away',
        bankTransfer: 'Bank Transfer',
        beforeAfter: 'Before After',
        bookPrerequisiteFirst: 'Book Prerequisite First',
        breakdown: 'Breakdown',
        bridgePrep: 'Bridge Prep',
        brightness: 'Brightness',
        cabinet: 'Cabinet',
        cabinet1: 'Cabinet 1',
        cabinet2: 'Cabinet 2',
        cabinetSchedule: 'Cabinet Schedule',
        cabinetScheduleDesc: 'Cabinet Schedule Desc',
        card: 'Card',
        cash: 'Cash',
        cbct: 'Cbct',
        cephalometric: 'Cephalometric',
        channels: 'Channels',
        clinicalQuestion: 'Clinical Question',
        clinicAvgRating: 'Clinic Avg Rating',
        collapse: 'Collapse',
        completedToday: 'Completed Today',
        compositeF: 'Composite F',
        continueToScheduling: 'Continue To Scheduling',
        contrast: 'Contrast',
        ctScans: 'Ct Scans',
        customAmount: 'Custom Amount',
        days: 'Days',
        delivered: 'Delivered',
        directMessages: 'Direct Messages',
        disposables: 'Disposables',
        doctorResponse: 'Doctor Response',
        doctors: 'Doctors',
        documentMgmtSubtitle: 'Document Mgmt Subtitle',
        documentPreview: 'Document Preview',
        download: 'Download',
        endodontic: 'Endodontic',
        enterAmount: 'Enter Amount',
        equipmentDevices: 'Equipment Devices',
        estDelivery: 'Est Delivery',
        examConsult: 'Exam Consult',
        explanationQuality: 'Explanation Quality',
        fluorideTx: 'Fluoride Tx',
        fullMouthView: 'Full Mouth View',
        hasBracesQuestion: 'Has Braces Question',
        hasConsultationQuestion: 'Has Consultation Question',
        hasCtScanQuestion: 'Has Ct Scan Question',
        hasRecentXrayQuestion: 'Has Recent Xray Question',
        helpfulQuestion: 'Helpful Question',
        highest: 'Highest',
        hygiene: 'Hygiene',
        imagingType: 'Imaging Type',
        implantPlace: 'Implant Place',
        important: 'Important',
        importLatest: 'Import Latest',
        inProgress: 'In Progress',
        installment: 'Installment',
        insuranceCoverage: 'Insurance Coverage',
        interpreted: 'Interpreted',
        inUse: 'In Use',
        invoices: 'Invoices',
        lastCleaningQuestion: 'Last Cleaning Question',
        lateralSkullView: 'Lateral Skull View',
        lowest: 'Lowest',
        lowStock: 'Low Stock',
        lowStockAlerts: 'Low Stock Alerts',
        maintenance: 'Maintenance',
        management: 'Management',
        markComplete: 'Mark Complete',
        material: 'Material',
        method: 'Method',
        minOrder: 'Min Order',
        monthlySpend: 'Monthly Spend',
        newPayment: 'New Payment',
        newRadiologyReferral: 'New Radiology Referral',
        nextAppointment: 'Next Appointment',
        noDocumentsFound: 'No Documents Found',
        noNoteSelected: 'No Note Selected',
        normal: 'Normal',
        noteInterpreter: 'Note Interpreter',
        occupied: 'Occupied',
        online: 'Online',
        orderNow: 'Order Now',
        orders: 'Orders',
        original: 'Original',
        outstanding: 'Outstanding',
        painManagement: 'Pain Management',
        panoramic: 'Panoramic',
        patientDue: 'Patient Due',
        paymentHistory: 'Payment History',
        paymentMethod: 'Payment Method',
        pendingOrders: 'Pending Orders',
        periapical: 'Periapical',
        perioMaint: 'Perio Maint',
        photos: 'Photos',
        placeOrder: 'Place Order',
        preCheck: 'Pre Check',
        preCheckPassed: 'Pre Check Passed',
        preCheckSubtitle: 'Pre Check Subtitle',
        preCheckTitle: 'Pre Check Title',
        prerequisiteWarning: 'Prerequisite Warning',
        print: 'Print',
        processing: 'Processing',
        processPayment: 'Process Payment',
        processPaymentBtn: 'Process Payment Btn',
        professionalism: 'Professionalism',
        prophyClean: 'Prophy Clean',
        prosthetic: 'Prosthetic',
        punctuality: 'Punctuality',
        qtyUsed: 'Qty Used',
        quantity: 'Quantity',
        queue: 'Queue',
        receiptPreview: 'Receipt Preview',
        recent: 'Recent',
        recentMaterialUsage: 'Recent Material Usage',
        recentReceipts: 'Recent Receipts',
        reliability: 'Reliability',
        remainingBalance: 'Remaining Balance',
        reorderLevel: 'Reorder Level',
        scanning: 'Scanning',
        sealants: 'Sealants',
        sent: 'Sent',
        singleToothView: 'Single Tooth View',
        slotDetails: 'Slot Details',
        sortBy: 'Sort By',
        srpQuad: 'Srp Quad',
        startImaging: 'Start Imaging',
        stock: 'Stock',
        stockLevel: 'Stock Level',
        submitReferral: 'Submit Referral',
        subtotal: 'Subtotal',
        suppliers: 'Suppliers',
        surgical: 'Surgical',
        targetArea: 'Target Area',
        teamChat: 'Team Chat',
        termsNormalized: 'Terms Normalized',
        threeDImaging: 'Three D Imaging',
        totalItems: 'Total Items',
        totalReceived: 'Total Received',
        typeAMessage: 'Type A Message',
        unavailable: 'Unavailable',
        unit: 'Unit',
        urgency: 'Urgency',
        urgent: 'Urgent',
        usageLog: 'Usage Log',
        veneerPrep: 'Veneer Prep',
        viewOnGoogle: 'View On Google',
        xrays: 'Xrays'
    },
    zh: {
        home: "\u9996\u9875",
        features: "\u529F\u80FD",
        pricing: "\u4EF7\u683C",
        clinicsNav: "\u8BCA\u6240",
        aiAssistant: "AI\u52A9\u624B",
        forBusiness: "\u4F01\u4E1A\u7248",
        dashboard: "\u4EEA\u8868\u677F",
        getStarted: "\u5F00\u59CB",
        tryDemo: "\u8BD5\u7528\u6F14\u793A",
        viewPitch: "\u67E5\u770B\u6F14\u793A",
        heroTagline: "\u683C\u9C81\u5409\u4E9A\u7259\u79D1\u5E73\u53F0",
        heroTitle: "\u6240\u6709\u7259\u79D1\u8BCA\u6240\u4E2D\u5FC3",
        heroSubtitle: "\u60A8\u7684AI\u52A9\u624B\uFF0C\u5E2E\u60A8\u627E\u5230\u683C\u9C81\u5409\u4E9A\u6700\u597D\u7684\u7259\u79D1\u62A4\u7406",
        searchPlaceholder: "\u641C\u7D22\u8BCA\u6240\u3001\u670D\u52A1\u6216\u63D0\u95EE...",
        chipImplant: "\u7B2C\u6BD4\u5229\u65AF\u6700\u4F73\u79CD\u690D\u7259\u8BCA\u6240",
        chipWhitening: "\u9644\u8FD1\u7684\u7259\u9F7F\u7F8E\u767D",
        chipEmergency: "\u7D27\u6025\u7259\u79D1\u62A4\u7406",
        chipOrtho: "\u6210\u4EBA\u6B63\u7578",
        scrollExplore: "\u6EDA\u52A8\u6D4F\u89C8",
        topRated: "\u7B2C\u6BD4\u5229\u65AF\u8BC4\u5206\u6700\u9AD8\u7684\u7259\u79D1\u8BCA\u6240",
        viewAllClinics: "\u67E5\u770B\u6240\u6709\u8BCA\u6240",
        shareLocation: "\u5206\u4EAB\u4F4D\u7F6E\u67E5\u627E\u9644\u8FD1\u8BCA\u6240",
        locationShared: "\u4F4D\u7F6E\u5DF2\u5206\u4EAB",
        statClinics: "\u8BCA\u6240",
        statNoShows: "\u51CF\u5C11\u7F3A\u5E2D",
        statBooking: "\u5728\u7EBF\u9884\u7EA6",
        statDentists: "\u7259\u533B",
        statRating: "\u5E73\u5747\u8BC4\u5206",
        statPatients: "\u60A3\u8005",
        findClinics: "\u67E5\u627E\u6700\u4F73\u8BCA\u6240",
        clinicsTitle: "\u683C\u9C81\u5409\u4E9A\u7259\u79D1\u8BCA\u6240",
        verifiedClinics: "\u5DF2\u9A8C\u8BC1\u8BCA\u6240",
        searchByName: "\u6309\u540D\u79F0\u3001\u533A\u57DF\u6216\u670D\u52A1\u641C\u7D22...",
        reviews: "\u8BC4\u4EF7",
        loadingMore: "\u52A0\u8F7D\u4E2D...",
        callClinic: "\u62E8\u6253\u7535\u8BDD",
        bookAppointment: "\u9884\u7EA6",
        services: "\u670D\u52A1",
        workingHours: "\u8425\u4E1A\u65F6\u95F4",
        priceRange: "\u4EF7\u683C\u8303\u56F4",
        location: "\u4F4D\u7F6E",
        bookingTitle: "\u9884\u7EA6",
        step: "\u6B65\u9AA4",
        selectClinic: "\u9009\u62E9\u8BCA\u6240",
        selectService: "\u9009\u62E9\u670D\u52A1",
        selectDate: "\u9009\u62E9\u65E5\u671F",
        selectTime: "\u9009\u62E9\u65F6\u95F4",
        confirm: "\u786E\u8BA4",
        next: "\u4E0B\u4E00\u6B65",
        back: "\u8FD4\u56DE",
        forBusinessBtn: "\u4F01\u4E1A\u7248",
        ownClinic: "\u60A8\u62E5\u6709\u4E00\u5BB6\u7259\u79D1\u8BCA\u6240\u5417\uFF1F",
        claimText: "\u5728\u6211\u4EEC\u7684\u6570\u636E\u5E93\u4E2D\u6CE8\u518C\u6216\u6DFB\u52A0\u60A8\u7684\u8BCA\u6240\u3002",
        getListed: "\u7ACB\u5373\u6CE8\u518C \u2192",
        hideMap: "\u9690\u85CF\u5730\u56FE",
        showMap: "\u5730\u56FE",
        nearMe: "\u9644\u8FD1",
        clinicsMatch: "\u8BCA\u6240\u5339\u914D",
        visitWebsite: "\u8BBF\u95EE\u7F51\u7AD9",
        clinicsAvailable: "\u8BCA\u6240\u53EF\u7528",
        clinicsFound: "\u8BCA\u6240\u627E\u5230",
        confirmBooking: "\u786E\u8BA4\u9884\u7EA6",
        bookingConfirmed: "\u60A8\u7684\u9884\u7EA6\u5DF2\u786E\u8BA4\uFF01",
        patientName: "\u60A3\u8005\u59D3\u540D",
        phoneNumber: "\u7535\u8BDD\u53F7\u7801",
        email: "\u7535\u5B50\u90AE\u7BB1",
        notes: "\u5907\u6CE8\uFF08\u53EF\u9009\uFF09",
        businessHeroBadge: "15+ \u6A21\u5757  \xb7  212+ \u8BCA\u6240  \xb7  Gemini AI",
        businessHeroTitle: "\u7259\u79D1\u8BCA\u6240\u64CD\u4F5C\u7CFB\u7EDF",
        businessHeroSubtitle: "\u4E34\u5E8A\u5236\u56FE\u3001\u7259\u5468\u5206\u6790\u3001\u6CBB\u7597\u8BA1\u5212\u3001\u6392\u73ED\u3001\u8BA1\u8D39\u3001\u7535\u5B50\u5904\u65B9\u3001\u5B9E\u9A8C\u5BA4\u7BA1\u7406\u548CAI\u8BCA\u65AD\u2014\u2014\u4E13\u4E3A\u683C\u9C81\u5409\u4E9A\u6253\u9020\u7684\u4E00\u7AD9\u5F0F\u5E73\u53F0\u3002",
        theProblem: "\u95EE\u9898",
        problemSubtitle: "\u683C\u9C81\u5409\u4E9A\u7259\u79D1\u8BCA\u6240\u56E0\u5DE5\u5177\u788E\u7247\u5316\u6BCF\u5929\u635F\u5931\u6536\u5165",
        excelChaos: "Excel\u548CWhatsApp\u6DF7\u4E71",
        excelChaosDetail: "\u8BCA\u6240\u901A\u8FC7\u7535\u5B50\u8868\u683C\u548C\u804A\u5929\u7FA4\u7BA1\u7406\u9884\u7EA6\u3002\u96F6\u81EA\u52A8\u5316\uFF0C\u6301\u7EED\u51FA\u9519\u3002",
        noShowRate: "25%\u723D\u7EA6\u7387",
        noShowDetail: "\u6CA1\u6709\u81EA\u52A8\u63D0\u9192\uFF0C\u60A3\u8005\u5FD8\u8BB0\u9884\u7EA6\u3002\u7A7A\u6905\u5B50\u610F\u5473\u7740\u6BCF\u5929\u20BE500+\u7684\u6536\u5165\u635F\u5931\u3002",
        paperCharts: "2026\u5E74\u4ECD\u7528\u7EB8\u8D28\u75C5\u5386",
        paperChartsDetail: "\u624B\u5199\u4E34\u5E8A\u7B14\u8BB0\uFF0C\u6CA1\u6709\u6570\u5B57\u7259\u4F4D\u56FE\u3002\u5173\u952E\u6570\u636E\u9501\u5728\u6587\u4EF6\u67DC\u4E2D\u3002",
        insuranceBlackHole: "\u4FDD\u9669\u9ED1\u6D1E",
        insuranceDetail: "\u5411Aldagi\u3001GPI\u3001Imedi L\u63D0\u4EA4\u4EBA\u5DE5\u7406\u8D54\u9700\u6570\u5C0F\u65F6\u3002\u88AB\u62D2\u7406\u8D54\u4E0D\u65AD\u79EF\u538B\u3002",
        oneplatform: "\u4E00\u4E2A\u5E73\u53F0\uFF0C\u6240\u6709\u6A21\u5757",
        platformSubtitle: "15\u4E2A\u4E3A\u7259\u79D1\u5B9E\u8DF5\u91CF\u8EAB\u5B9A\u5236\u7684\u96C6\u6210\u6A21\u5757",
        clinical: "\u4E34\u5E8A",
        operations: "\u8FD0\u8425",
        analyticsEnterprise: "\u5206\u6790\u4E0E\u4F01\u4E1A",
        digitalOdontogram: "\u6570\u5B57\u7259\u4F4D\u56FE",
        digitalOdontogramDetail: "FDI 32\u9F7F\u56FE\uFF0C5\u9762\u8FFD\u8E2A\u3002",
        perioCharting: "\u7259\u5468\u5236\u56FE",
        perioChartingDetail: "192\u4F4D\u70B9\u7259\u5468\u7F51\u683C\u30026\u70B9\u63A2\u8BCA\u3001BOP\u3001CAL\u3002",
        treatmentPlanning: "\u6CBB\u7597\u8BA1\u5212",
        treatmentPlanningDetail: "\u5E26CDT\u4EE3\u7801\u7684\u5206\u671F\u8BA1\u5212\uFF0C\u4FDD\u9669\u4F30\u7B97\u3002AI\u6392\u5E8F\u3002",
        soapNotes: "SOAP\u7B14\u8BB0 + AI\u4E66\u5199\u5458",
        soapNotesDetail: "\u5E26\u6A21\u677F\u7684\u7ED3\u6784\u5316\u4E34\u5E8A\u6587\u6863\u3002Gemini\u4ECE\u8BED\u97F3\u751F\u6210\u7B14\u8BB0\u3002",
        multiChairScheduling: "\u591A\u6905\u4F4D\u6392\u73ED",
        multiChairDetail: "\u591A\u64CD\u4F5C\u95F4\u5468\u89C6\u56FE\u3002\u533B\u751F\u989C\u8272\u7F16\u7801\u3002",
        billingInsurance: "\u8BA1\u8D39\u4E0E\u4FDD\u9669",
        billingDetail: "Aldagi\u3001GPI\u3001Imedi L\u7406\u8D54\u8FFD\u8E2A\u3002\u60A3\u8005\u53F0\u8D26\u3001\u4ED8\u6B3E\u8BA1\u5212\u3002",
        ePrescribing: "\u7535\u5B50\u5904\u65B9",
        ePrescribingDetail: "\u5E26\u6A21\u677F\u7684\u6570\u5B57\u5904\u65B9\u3002Gemini\u836F\u7269\u76F8\u4E92\u4F5C\u7528\u68C0\u67E5\u3002",
        labTracking: "\u5B9E\u9A8C\u5BA4\u8FFD\u8E2A",
        labTrackingDetail: "\u770B\u677F\uFF1A\u5DF2\u4E0B\u5355 \u2192 \u5236\u4F5C\u4E2D \u2192 \u5DF2\u53D1\u8D27 \u2192 \u5DF2\u6536\u5230\u3002",
        productionReports: "\u4EA7\u51FA\u62A5\u544A",
        productionReportsDetail: "\u6BDB/\u51C0\u4EA7\u51FA\u3001\u6536\u6B3E\u7387\u3001\u6CBB\u7597\u63A5\u53D7\u7387\u3002",
        referralMgmt: "\u8F6C\u8BCA\u7BA1\u7406",
        referralMgmtDetail: "\u5411\u4E13\u79D1\u533B\u751F\u7684\u8F6C\u5165/\u8F6C\u51FA\u8F6C\u8BCA\u3002AI\u751F\u6210\u7684\u8F6C\u8BCA\u51FD\u3002",
        medicalHistory: "\u75C5\u53F2",
        medicalHistoryDetail: "11\u89C6\u56FE\u60A3\u8005\u8BB0\u5F55\uFF1A\u65F6\u95F4\u7EBF\u3001\u75C5\u60C5\u3001\u836F\u7269\u3001\u8FC7\u654F\u3002",
        enterpriseAdmin: "\u4F01\u4E1A\u7BA1\u7406",
        enterpriseAdminDetail: "RBAC\u3001\u5BA1\u8BA1\u65E5\u5FD7\u3001\u5408\u89C4\u3001\u591A\u79DF\u6237\u3001SSO\u3001API\u7BA1\u7406\u3002",
        geminiBuiltIn: "\u5185\u7F6EGemini AI",
        geminiSubtitle: "\u6BCF\u4E2A\u6A21\u5757\u7531Google Gemini 3.1\u9A71\u52A8",
        xrayAnalysis: "X\u5149\u5206\u6790",
        xrayDetail: "\u4E0A\u4F20\u7259\u79D1X\u5149\u7247\u8FDB\u884CAI\u9F8B\u9F7F\u68C0\u6D4B\u3002",
        perioAssessment: "\u7259\u5468\u8BC4\u4F30",
        perioAssessmentDetail: "\u6839\u636E\u63A2\u8BCA\u6570\u636E\u81EA\u52A8AAP\u5206\u671F/\u5206\u7EA7\u3002",
        clinicalScribe: "\u4E34\u5E8A\u4E66\u5199\u5458",
        clinicalScribeDetail: "\u4ECE\u8BED\u97F3\u5F55\u97F3\u6216\u75C5\u5386\u6570\u636E\u751F\u6210SOAP\u7B14\u8BB0\u3002",
        riskProfiling: "\u98CE\u9669\u8BC4\u4F30",
        riskProfilingDetail: "\u5206\u6790\u75C5\u60C5\u3001\u5BB6\u65CF\u53F2\u4EE5\u521B\u5EFA\u7259\u79D1\u98CE\u9669\u6863\u6848\u3002",
        treatmentSequencing: "\u6CBB\u7597\u6392\u5E8F",
        treatmentSequencingDetail: "AI\u4F18\u5316\u7684\u6CBB\u7597\u5206\u671F\uFF0C\u8003\u8651\u6108\u5408\u671F\u548C\u4FDD\u9669\u3002",
        patientComm: "\u60A3\u8005\u6C9F\u901A",
        patientCommDetail: "\u751F\u6210\u683C\u9C81\u5409\u4E9A\u8BED\u7684\u60A3\u8005\u53CB\u597D\u578B\u89E3\u91CA\u3002",
        georgianEcosystem: "\u683C\u9C81\u5409\u4E9A\u751F\u6001\u7CFB\u7EDF\u5C31\u7EEA",
        integrationsSubtitle: "\u4E0E\u5F53\u5730\u4FDD\u9669\u3001\u652F\u4ED8\u548C\u901A\u8BAF\u7684\u9884\u5EFA\u96C6\u6210",
        insurance: "\u4FDD\u9669",
        payments: "\u652F\u4ED8",
        messaging: "\u901A\u8BAF",
        ehrLabs: "\u7535\u5B50\u75C5\u5386\u4E0E\u5B9E\u9A8C\u5BA4",
        clinicsInDb: "\u6570\u636E\u5E93\u4E2D\u7684\u8BCA\u6240",
        platformModules: "\u5E73\u53F0\u6A21\u5757",
        aiTools: "AI\u5DE5\u5177\uFF08Gemini\uFF09",
        integrations: "\u96C6\u6210",
        pricingTitle: "\u4EF7\u683C",
        pricingSubtitle: "\u514D\u8D39\u5F00\u59CB\uFF0C\u968F\u9700\u6269\u5C55",
        trustedBy: "\u8BCA\u6240\u4FE1\u8D56",
        readyModernize: "\u51C6\u5907\u597D\u73B0\u4EE3\u5316\u4E86\u5417\uFF1F",
        joinCount: "\u52A0\u5165\u683C\u9C81\u5409\u4E9A212+\u5BB6\u8BCA\u6240\u3002",
        startTrial: "\u514D\u8D39\u8BD5\u7528",
        contactSales: "\u8054\u7CFB\u9500\u552E",
        noCreditCard: "\u65E0\u9700\u4FE1\u7528\u5361  \xb7  \u514D\u8D39\u8BA1\u5212  \xb7  5\u5206\u949F\u8BBE\u7F6E",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u4EEA\u8868\u677F",
        navPatients: "\u60A3\u8005",
        navChart: "\u75C5\u5386",
        navPerio: "\u7259\u5468",
        navTreatmentPlans: "\u6CBB\u7597\u8BA1\u5212",
        navNotes: "\u7B14\u8BB0",
        navScheduling: "\u6392\u73ED",
        navBilling: "\u8D26\u5355",
        navPrescriptions: "\u5904\u65B9",
        navLabCases: "\u5B9E\u9A8C\u5BA4\u75C5\u4F8B",
        navReferrals: "\u8F6C\u8BCA",
        navReports: "\u62A5\u544A",
        navMedHistory: "\u75C5\u53F2",
        navIntegrations: "\u96C6\u6210",
        navEnterprise: "\u4F01\u4E1A",
        sectionClinical: "\u4E34\u5E8A",
        sectionOperations: "\u8FD0\u8425",
        sectionAnalytics: "\u5206\u6790",
        sectionAiTools: "AI\u5DE5\u5177",
        sectionAdmin: "\u7BA1\u7406",
        // Booking Page
        chooseClinic: "\u9009\u62E9\u8BCA\u6240",
        selectAService: "\u9009\u62E9\u670D\u52A1",
        pickADate: "\u9009\u62E9\u65E5\u671F",
        pickATime: "\u9009\u62E9\u65F6\u95F4",
        confirmYourBooking: "\u786E\u8BA4\u60A8\u7684\u9884\u7EA6",
        clinicLabel: "\u8BCA\u6240\uFF1A",
        serviceLabel: "\u670D\u52A1\uFF1A",
        dateLabel: "\u65E5\u671F\uFF1A",
        timeLabel: "\u65F6\u95F4\uFF1A",
        // AI Page
        send: "\u53D1\u9001",
        procedure: "\u624B\u672F",
        observations: "\u89C2\u5BDF",
        aiThinking: "AI\u6B63\u5728\u601D\u8003...",
        summarizeHistory: "\u603B\u7ED3\u60A3\u8005\u75C5\u53F2",
        generateTxPlan: "\u751F\u6210\u6CBB\u7597\u8BA1\u5212",
        checkDrugInteractions: "\u68C0\u67E5\u836F\u7269\u76F8\u4E92\u4F5C\u7528",
        writeClinicalNote: "\u7F16\u5199\u4E34\u5E8A\u7B14\u8BB0",
        askAiAssistant: "\u8BE2\u95EEAI\u52A9\u624B...",
        dropXray: "\u62D6\u653EX\u5149\u7247\u6216\u70B9\u51FB\u4E0A\u4F20",
        supportsFormats: "\u652F\u6301DICOM\u3001PNG\u3001JPG",
        analysisResults: "\u5206\u6790\u7ED3\u679C\uFF08\u6F14\u793A\uFF09",
        aiRecommendation: "AI\u5EFA\u8BAE",
        exportToTxPlan: "\u5BFC\u51FA\u81F3\u6CBB\u7597\u8BA1\u5212",
        generateClinicalNote: "\u751F\u6210\u4E34\u5E8A\u7B14\u8BB0",
        generatedSoap: "\u751F\u6210\u7684\u4E34\u5E8A\u7B14\u8BB0\uFF08SOAP\uFF09",
        subjective: "S \u2014 \u4E3B\u89C2",
        objective: "O \u2014 \u5BA2\u89C2",
        assessment: "A \u2014 \u8BC4\u4F30",
        plan: "P \u2014 \u8BA1\u5212",
        copyToRecord: "\u590D\u5236\u5230\u60A3\u8005\u8BB0\u5F55",
        aiPerioAssessment: "AI\u7259\u5468\u8BC4\u4F30",
        enterProbingData: "\u8F93\u5165\u63A2\u8BCA\u6570\u636E\u4EE5\u83B7\u53D6AAP\u5206\u671F/\u5206\u7EA7\u548C\u6CBB\u7597\u5EFA\u8BAE\u3002",
        analyzeWithGemini: "\u4F7F\u7528Gemini\u5206\u6790",
        aiRiskAssessment: "AI\u98CE\u9669\u8BC4\u4F30",
        enterConditions: "\u8F93\u5165\u60A3\u8005\u72B6\u51B5\u3001\u5BB6\u65CF\u53F2\u548C\u751F\u547D\u4F53\u5F81\u4EE5\u751F\u6210\u98CE\u9669\u6863\u6848\u3002",
        generateRiskProfile: "\u751F\u6210\u98CE\u9669\u6863\u6848",
        patientCommunication: "\u60A3\u8005\u6C9F\u901A",
        generateExplanations: "\u751F\u6210\u683C\u9C81\u5409\u4E9A\u8BED\u6216\u82F1\u8BED\u7684\u60A3\u8005\u53CB\u597D\u578B\u6CBB\u7597\u8BF4\u660E\u3002",
        generateExplanation: "\u751F\u6210\u8BF4\u660E",
        patientFriendly: "\u60A3\u8005\u53CB\u597D\u578B\u8BF4\u660E",
        // Billing Page
        claims: "\u7406\u8D54",
        ledger: "\u53F0\u8D26",
        aging: "\u8D26\u9F84",
        paymentPlans: "\u4ED8\u6B3E\u8BA1\u5212",
        eligibility: "\u8D44\u683C",
        allFilter: "\u5168\u90E8",
        submitted: "\u5DF2\u63D0\u4EA4",
        paid: "\u5DF2\u652F\u4ED8",
        denied: "\u5DF2\u62D2\u7EDD",
        patientLedger: "\u60A3\u8005\u53F0\u8D26",
        agedAccounts: "\u903E\u671F\u8D26\u6237",
        sendStatements: "\u53D1\u9001\u5BF9\u8D26\u5355",
        activePaymentPlans: "\u6D3B\u8DC3\u4ED8\u6B3E\u8BA1\u5212",
        insuranceEligibility: "\u4FDD\u9669\u8D44\u683C",
        // Clinical Charting
        odontogram: "\u7259\u4F4D\u56FE",
        perioTab: "\u7259\u5468",
        treatmentPlanTab: "\u6CBB\u7597\u8BA1\u5212",
        notesTab: "\u7B14\u8BB0",
        progressNotes: "\u8FDB\u5C55\u7B14\u8BB0",
        openFullPerio: "\u6253\u5F00\u5B8C\u6574\u7259\u5468\u56FE \u2192",
        openFullTxPlanner: "\u6253\u5F00\u5B8C\u6574\u6CBB\u7597\u89C4\u5212\u5668 \u2192",
        openClinicalNotes: "\u6253\u5F00\u4E34\u5E8A\u7B14\u8BB0 \u2192",
        newExam: "\u65B0\u68C0\u67E5",
        voiceEntry: "\u8BED\u97F3\u8F93\u5165",
        bleedingIndex: "\u51FA\u8840\u6307\u6570",
        plaqueIndex: "\u83CC\u6591\u6307\u6570",
        sitesAbove4: "\u4F4D\u70B9 \u2265 4mm",
        sitesAbove6: "\u4F4D\u70B9 \u2265 6mm",
        planA: "\u65B9\u6848A\uFF1A\u63A8\u8350",
        planB: "\u65B9\u6848B\uFF1A\u4FDD\u5B88",
        newPlan: "+ \u65B0\u65B9\u6848",
        presentToPatient: "\u5411\u60A3\u8005\u5C55\u793A",
        sendToPortal: "\u53D1\u9001\u81F3\u95E8\u6237",
        totalFee: "\u603B\u8D39\u7528",
        insuranceEst: "\u4FDD\u9669\u4F30\u7B97",
        patientPortion: "\u60A3\u8005\u90E8\u5206",
        chairSideMode: "\u6905\u65C1\u6A21\u5F0F",
        adminMode: "\u7BA1\u7406\u6A21\u5F0F",
        proceduresAcrossPhases: "{1}\u4E2A\u9636\u6BB5\u4E2D\u7684{0}\u4E2A\u7A0B\u5E8F",
        // Scheduling
        day: "\u65E5",
        week: "\u5468",
        today: "\u4ECA\u5929",
        providerFilter: "\u6240\u6709\u533B\u751F",
        productionGoal: "\u4EA7\u51FA\u76EE\u6807",
        waitlist: "\u5019\u8865\u540D\u5355",
        // Prescriptions
        activeRx: "\u6709\u6548",
        pastRx: "\u5386\u53F2",
        templates: "\u6A21\u677F",
        interactionCheck: "\u76F8\u4E92\u4F5C\u7528\u68C0\u67E5",
        // Lab Cases
        ordered: "\u5DF2\u4E0B\u5355",
        sentToLab: "\u5DF2\u9001\u5B9E\u9A8C\u5BA4",
        inFabrication: "\u5236\u4F5C\u4E2D",
        shipped: "\u5DF2\u53D1\u8D27",
        received: "\u5DF2\u6536\u5230",
        labVendors: "\u5B9E\u9A8C\u5BA4\u4F9B\u5E94\u5546",
        // Referrals
        allDirections: "\u5168\u90E8",
        inbound: "\u8F6C\u5165",
        outbound: "\u8F6C\u51FA",
        generateLetter: "\u751F\u6210\u51FD\u4EF6",
        // Reports
        production: "\u4EA7\u51FA",
        collections: "\u6536\u6B3E",
        schedulingReport: "\u6392\u73ED",
        treatmentAcceptance: "\u6CBB\u7597\u63A5\u53D7\u7387",
        recall: "\u590D\u53EC",
        grossProduction: "\u6BDB\u4EA7\u51FA",
        netProduction: "\u51C0\u4EA7\u51FA",
        collectionRate: "\u6536\u6B3E\u7387",
        plansPresented: "\u5DF2\u5C55\u793A\u8BA1\u5212",
        accepted: "\u5DF2\u63A5\u53D7",
        acceptanceRate: "\u63A5\u53D7\u7387",
        dueThisMonth: "\u672C\u6708\u5230\u671F",
        scheduled: "\u5DF2\u5B89\u6392",
        completed: "\u5DF2\u5B8C\u6210",
        overdue: "\u903E\u671F",
        reactivationRate: "\u91CD\u65B0\u6FC0\u6D3B\u7387",
        // Medical History
        timeline: "\u65F6\u95F4\u7EBF",
        conditions: "\u75C5\u60C5",
        medications: "\u836F\u7269",
        allergies: "\u8FC7\u654F",
        labResults: "\u5316\u9A8C\u7ED3\u679C",
        vitals: "\u751F\u547D\u4F53\u5F81",
        immunizations: "\u514D\u75AB\u63A5\u79CD",
        familyHistory: "\u5BB6\u65CF\u53F2",
        imaging: "\u5F71\u50CF",
        documents: "\u6587\u4EF6",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u5BA1\u8BA1\u65E5\u5FD7",
        compliance: "\u5408\u89C4",
        multiTenancy: "\u591A\u79DF\u6237",
        sso: "SSO\u4E0E\u5B89\u5168",
        featureFlags: "\u529F\u80FD\u6807\u5FD7",
        apiManagement: "API\u7BA1\u7406",
        dataManagement: "\u6570\u636E\u7BA1\u7406",
        // Integrations
        ehr: "\u7535\u5B50\u75C5\u5386",
        labs: "\u5B9E\u9A8C\u5BA4",
        telehealth: "\u8FDC\u7A0B\u533B\u7597",
        aiMl: 'AI/ML',
        wearables: "\u53EF\u7A7F\u6234\u8BBE\u5907",
        connected: "\u5DF2\u8FDE\u63A5",
        disconnected: "\u5DF2\u65AD\u5F00",
        available: "\u53EF\u7528",
        // Components
        status: "\u72B6\u6001",
        healthy: "\u5065\u5EB7",
        caries: "\u9F8B\u9F7F",
        restored: "\u5DF2\u4FEE\u590D",
        missing: "\u7F3A\u5931",
        implant: "\u79CD\u690D\u4F53",
        crownStatus: "\u7259\u51A0",
        bridge: "\u6865\u4F53",
        veneer: "\u8D34\u9762",
        surfaces: "\u9762",
        procedureHistory: "\u64CD\u4F5C\u5386\u53F2",
        addProcedure: "\u6DFB\u52A0\u64CD\u4F5C",
        totalCharged: "\u603B\u6536\u8D39",
        insurancePayment: "\u4FDD\u9669\u652F\u4ED8",
        patientResponsibility: "\u60A3\u8005\u81EA\u4ED8",
        expand: "\u5C55\u5F00",
        policyNumber: "\u4FDD\u5355\u53F7",
        planType: "\u8BA1\u5212\u7C7B\u578B",
        annualMax: "\u5E74\u5EA6\u4E0A\u9650",
        used: "\u5DF2\u7528",
        remaining: "\u5269\u4F59",
        coverageByCategory: "\u6309\u7C7B\u522B\u8986\u76D6",
        preventive: "\u9884\u9632",
        basic: "\u57FA\u7840",
        major: "\u91CD\u5927",
        ortho: "\u6B63\u7578",
        current: "\u5F53\u524D",
        thirtyDay: "30\u5929",
        sixtyDay: "60\u5929",
        ninetyPlus: "90+\u5929",
        totalBalance: "\u603B\u4F59\u989D",
        monthlyPayment: "\u6708\u4F9B",
        paymentsRemaining: "\u5269\u4F59\u671F\u6570",
        nextPayment: "\u4E0B\u6B21\u4ED8\u6B3E",
        paymentProgress: "\u4ED8\u6B3E\u8FDB\u5EA6",
        choosePlan: "\u9009\u62E9\u8BA1\u5212",
        aiInsight: "AI\u6D1E\u5BDF",
        confidence: "\u7F6E\u4FE1\u5EA6",
        revoke: "\u64A4\u9500",
        exams: "\u68C0\u67E5",
        phaseTotal: "\u9636\u6BB5\u5408\u8BA1",
        mon: "\u4E00",
        tue: "\u4E8C",
        wed: "\u4E09",
        thu: "\u56DB",
        fri: "\u4E94",
        sat: "\u516D",
        sun: "\u65E5",
        thinking: "\u601D\u8003\u4E2D...",
        followUpPlaceholder: "\u63D0\u51FA\u540E\u7EED\u95EE\u9898...",
        priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
        patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
        tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
        chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
        english: 'English',
        patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
        xrayAnalysis2: 'X-ray Analysis',
        uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment2: 'Perio Assessment',
        automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe2: 'Clinical Scribe',
        generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling2: 'Risk Profiling',
        analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing2: 'Treatment Sequencing',
        aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientCommunication2: 'Patient Communication',
        generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        insurance2: 'INSURANCE',
        automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
        payments2: 'PAYMENTS',
        onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
        messaging2: 'MESSAGING',
        appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
        ehrLabs2: 'EHR & LABS',
        interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
        clinicsInDatabase: 'Clinics in Database',
        platformModules2: 'Platform Modules',
        integrations2: 'Integrations',
        home2: 'Home',
        features2: 'Features',
        pricing2: 'Pricing',
        dashboard2: 'Dashboard',
        u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
        openFullPeriodontalChart: "Open Full Periodontal Chart \u2192",
        openFullTreatmentPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes2: "Open Clinical Notes \u2192",
        backToAllClinics: "\u2190 Back to all clinics",
        priceRange2: 'Price range:',
        bookAnAppointment: 'Book an Appointment',
        selectDate2: 'Select date',
        selectTime2: 'Select time',
        confirmBooking2: "Confirm Booking \u2192",
        clinics: 'Clinics',
        forBusiness2: 'For Business',
        u00a92026Mcai: '\u00A9 2026 MCAI',
        clinicalNotes: 'Clinical Notes',
        newNote: '+ New Note',
        template: 'Template:',
        crownPrep: 'Crown Prep',
        aiScribe: 'AI Scribe',
        recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
        startRecording: 'Start Recording',
        generateNote: 'Generate Note',
        general: 'General',
        prosthetics: 'Prosthetics',
        typeToSearch: 'Type to search dental terms...',
        revenueToday: 'Revenue Today',
        noshows: 'No-shows',
        confirmed: 'Confirmed',
        time: 'TIME',
        patient: 'PATIENT',
        service: 'SERVICE',
        doctor: 'DOCTOR',
        status2: 'STATUS',
        addPatient: '+ Add Patient',
        mondayMarch19: 'Monday, March 19',
        gBeridzeCheckup: "G. Beridze \u2014 Checkup",
        nKapanadzeWhitening: "N. Kapanadze \u2014 Whitening",
        dGelashviliImplantPhase: "D. Gelashvili \u2014 Implant Phase 2",
        lunchBreak: "\u2014 Lunch Break \u2014",
        mTsiklauriOrthodontics: "M. Tsiklauri \u2014 Orthodontics",
        aJavakhishviliRootCanal: "A. Javakhishvili \u2014 Root Canal",
        lMchedlishviliExtraction: "L. Mchedlishvili \u2014 Extraction",
        tLomidzeCheckup: "T. Lomidze \u2014 Checkup",
        clinicName: 'Clinic Name',
        phone: 'Phone',
        address: 'Address',
        acceptedInsurance: 'Accepted Insurance',
        unison: 'Unison',
        saveSettings: 'Save Settings',
        aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
        openTheFullAi: "Open the full AI Assistant \u2192",
        enterprise: 'Enterprise',
        rolebasedAccessControl: 'Role-Based Access Control',
        permissionMatrix: 'Permission Matrix',
        module: 'Module',
        admin: 'Admin',
        doctor2: 'Doctor',
        hygienist: 'Hygienist',
        reception: 'Reception',
        lab: 'Lab',
        patient2: 'Patient',
        patients: 'Patients',
        full: 'Full',
        read: 'Read',
        none: 'None',
        own: 'Own',
        billing: 'Billing',
        scheduling: 'Scheduling',
        reports: 'Reports',
        settings: 'Settings',
        labOrders: 'Lab Orders',
        auditLog2: 'Audit Log',
        allTypes: 'All Types',
        last7Days: 'Last 7 days',
        complianceDashboard: 'Compliance Dashboard',
        complianceChecklist: 'Compliance Checklist',
        pass: 'PASS',
        dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
        dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
        mfaEnabledForAll: 'MFA enabled for all admin accounts',
        warn: 'WARN',
        dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
        auditLoggingActiveOn: 'Audit logging active on all modules',
        multitenancyManagement: 'Multi-Tenancy Management',
        singleSignonSso: 'Single Sign-On (SSO)',
        saml20: 'SAML 2.0',
        enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
        configured: 'Configured',
        openidConnect: 'OpenID Connect',
        oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
        available2: 'Available',
        signInWithGoogle: 'Sign in with Google organization accounts',
        connected2: 'Connected',
        azureAd: 'Azure AD',
        microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
        featureFlags2: 'Feature Flags',
        aixrayanalysis: 'ai_xray_analysis',
        aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
        voiceperio: 'voice_perio',
        voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
        patientportalv2: 'patient_portal_v2',
        nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
        whatsappreminders: 'whatsapp_reminders',
        multilanguage: 'multi_language',
        multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
        apiManagement2: 'API Management',
        requests24h: 'Requests (24h)',
        avgLatency: 'Avg Latency',
        uptime: 'Uptime',
        apiKeys: 'API Keys',
        dataManagement2: 'Data Management',
        storageUsed: 'Storage Used',
        of100Gb: 'of 100 GB',
        totalRecords: 'Total Records',
        lastBackup: 'Last Backup',
        nextIn4h: 'Next: in 4h',
        dataOperations: 'Data Operations',
        exportAllData: 'Export All Data',
        downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
        export: 'Export',
        purgeOldRecords: 'Purge Old Records',
        removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
        purge: 'Purge',
        dataMigration: 'Data Migration',
        importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
        import: 'Import',
        finance: 'Finance',
        revenueInvoicesPayments: 'Revenue, invoices & payments',
        exportReport: 'Export Report',
        monthlyRevenue: 'Monthly Revenue',
        u20be12400: '\u20BE12,400',
        pending: 'Pending',
        u20be2100: '\u20BE2,100',
        str208: '-5%',
        thisWeek: 'This Week',
        u20be3800: '\u20BE3,800',
        weeklyRevenue: 'Weekly Revenue',
        mon2: 'Mon',
        tue2: 'Tue',
        wed2: 'Wed',
        thu2: 'Thu',
        fri2: 'Fri',
        sat2: 'Sat',
        invoice: 'INVOICE',
        amount: 'AMOUNT',
        inv001: 'INV-001',
        giorgiBeridze: 'Giorgi Beridze',
        checkupXray: 'Checkup + X-ray',
        u20be80: '\u20BE80',
        inv002: 'INV-002',
        ninoKapanadze: 'Nino Kapanadze',
        whitening: 'Whitening',
        u20be120: '\u20BE120',
        inv003: 'INV-003',
        davitGelashvili: 'Davit Gelashvili',
        implantPhase1: 'Implant Phase 1',
        u20be300: '\u20BE300+',
        inv004: 'INV-004',
        anaJavakhishvili: 'Ana Javakhishvili',
        rootCanal: 'Root Canal',
        u20be149: '\u20BE149',
        u2715: '\u2715',
        configuration: 'Configuration',
        apiKey: 'API Key',
        endpointUrl: 'Endpoint URL',
        protocol: 'Protocol',
        syncSettings: 'Sync Settings',
        syncFrequency: 'Sync Frequency',
        every5Minutes: 'Every 5 minutes',
        every15Minutes: 'Every 15 minutes',
        everyHour: 'Every hour',
        manualOnly: 'Manual only',
        autosyncOnChanges: 'Auto-sync on changes',
        lastSynced: 'Last synced',
        disconnect: 'Disconnect',
        testConnection: 'Test Connection',
        labCasePipeline: 'Lab Case Pipeline',
        labVendors2: 'Lab Vendors',
        tbilisidentLab: 'TbilisiDent Lab',
        turnaround710Days: 'Turnaround: 7-10 days',
        rating485: 'Rating: 4.8/5',
        activeCases4: 'Active Cases: 4',
        caucasusDentalLab: 'Caucasus Dental Lab',
        turnaround57Days: 'Turnaround: 5-7 days',
        rating465: 'Rating: 4.6/5',
        activeCases2: 'Active Cases: 2',
        euroDentalGeorgia: 'Euro Dental Georgia',
        turnaround1014Days: 'Turnaround: 10-14 days',
        rating445: 'Rating: 4.4/5',
        enterSpaceForClinics: "Enter space for clinics \u2192",
        book: 'Book',
        followupConsultation: 'Follow-up Consultation',
        postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
        rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
        completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
        periapicalXray: 'Periapical X-ray',
        workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
        medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
        prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
        diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
        patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
        compositeFillingTooth21: 'Composite Filling - Tooth #21',
        classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
        labResultsCbcPanel: 'Lab Results: CBC Panel',
        completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
        fullmouthRadiographs: 'Full-mouth Radiographs',
        panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
        comprehensiveExamination: 'Comprehensive Examination',
        initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
        medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
        patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
        patientRegistration: 'Patient Registration',
        newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
        activeConditions: 'Active Conditions',
        chronicPeriodontitis: 'Chronic Periodontitis',
        active: 'Active',
        generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
        onsetJan2026: 'Onset: Jan 2026',
        dentalCaries: 'Dental Caries',
        resolved: 'Resolved',
        cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
        resolvedFeb2026: 'Resolved: Feb 2026',
        bruxism: 'Bruxism',
        nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
        activeMedications: 'Active Medications',
        lisinopril10mg: 'Lisinopril 10mg',
        onceDailyOral: 'Once daily, oral',
        hypertensionManagement: 'Hypertension management',
        chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
        twiceDailyOralRinse: 'Twice daily, oral rinse',
        periodontalMaintenance: 'Periodontal maintenance',
        ibuprofen400mg: 'Ibuprofen 400mg',
        asNeededForPain: 'As needed for pain, max 3x daily',
        postprocedurePainManagement: 'Post-procedure pain management',
        pastMedications: 'Past Medications',
        amoxicillin500mg: 'Amoxicillin 500mg',
        periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
        completed2: 'Completed',
        metronidazole250mg: 'Metronidazole 250mg',
        adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
        paracetamol500mg: 'Paracetamol 500mg',
        asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
        postfillingSensitivity: 'Post-filling sensitivity',
        diclofenac50mg: 'Diclofenac 50mg',
        twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
        postexamSoreness: 'Post-exam soreness',
        documentedAllergies: 'Documented Allergies',
        penicillin: 'Penicillin',
        severe: 'SEVERE',
        reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
        crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
        documentedJan102026: 'Documented: Jan 10, 2026',
        latex: 'Latex',
        moderate: 'MODERATE',
        reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
        useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
        lidocaine: 'Lidocaine',
        mild: 'MILD',
        reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
        useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
        latestVitalsMar15: "Latest Vitals \u2014 Mar 15, 2026",
        labResults2: 'Lab Results',
        test: 'TEST',
        result: 'RESULT',
        reference: 'REFERENCE',
        date: 'DATE',
        hemoglobin: 'Hemoglobin',
        platelets: 'Platelets',
        glucoseFasting: 'Glucose (fasting)',
        immunizationRecords: 'Immunization Records',
        hepatitisB: 'Hepatitis B',
        completed3doseSeries2019: 'Completed: 3-dose series, 2019',
        upToDate: 'Up to date',
        tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
        lastBooster2022: 'Last booster: 2022',
        covid19: 'COVID-19',
        lastDoseSep2024: 'Last dose: Sep 2024',
        dueForBooster: 'Due for booster',
        familyMedicalHistory: 'Family Medical History',
        father: 'Father',
        hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
        mother: 'Mother',
        osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
        sibling: 'Sibling',
        bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
        imagingRecords: 'Imaging Records',
        panoramicOpg: 'Panoramic OPG',
        periapical14: 'Periapical #14',
        bitewingRl: 'Bitewing R+L',
        patientDocuments: 'Patient Documents',
        consentFormRootCanal: 'Consent Form - Root Canal',
        treatmentPlanAgreement: 'Treatment Plan Agreement',
        medicalHistoryQuestionnaire: 'Medical History Questionnaire',
        insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
        insuranceInformation: 'Insurance Information',
        provider: 'Provider:',
        policy: 'Policy #:',
        group: 'Group:',
        corporatePlanPremium: 'Corporate Plan - Premium',
        coverage: 'Coverage:',
        deductible: 'Deductible:',
        annualMax2: 'Annual Max:',
        valid: 'Valid:',
        age34: 'Age: 34',
        lastVisitMar10: 'Last visit: Mar 10',
        nextMar19: 'Next: Mar 19',
        overview: 'Overview',
        dentalChart: 'Dental Chart',
        treatmentPlan: 'Treatment Plan',
        history: 'History',
        documents2: 'Documents',
        allergies2: 'Allergies',
        medicalNotes: 'Medical Notes',
        insurance3: 'Insurance',
        upperArch: 'Upper Arch',
        lowerArch: 'Lower Arch',
        tooth: 'TOOTH',
        procedure2: 'PROCEDURE',
        price: 'PRICE',
        rootCanalTreatment: 'Root Canal Treatment',
        ceramicCrown: 'Ceramic Crown',
        compositeFilling: 'Composite Filling',
        implantPlacement: 'Implant Placement',
        total: 'Total',
        addProcedure2: '+ Add Procedure',
        march102026: 'March 10, 2026',
        periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
        february152026: 'February 15, 2026',
        compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
        january202026: 'January 20, 2026',
        comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
        bitewingRight: 'Bitewing Right',
        bitewingLeft: 'Bitewing Left',
        uploadDocument: '+ Upload Document',
        all: 'All',
        new: 'New',
        phone2: 'PHONE',
        lastVisit: 'LAST VISIT',
        nextAppt: 'NEXT APPT',
        balance: 'BALANCE',
        pt001: 'PT-001',
        pt002: 'PT-002',
        pt003: 'PT-003',
        mariamTsiklauri: 'Mariam Tsiklauri',
        pt004: 'PT-004',
        pt005: 'PT-005',
        lukaMchedlishvili: 'Luka Mchedlishvili',
        pt006: 'PT-006',
        tamtaLomidze: 'Tamta Lomidze',
        pt007: 'PT-007',
        periodontalChart: 'Periodontal Chart',
        newExam2: '+ New Exam',
        voiceEntry2: 'Voice Entry',
        dcai: 'DCAI',
        dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
        theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
        manage: 'Manage',
        grow: 'Grow',
        marketSize: 'Market Size',
        dentalClinicsInGeorgia: 'dental clinics in Georgia',
        inTbilisiAlone: 'in Tbilisi alone',
        unifiedBookingOrOps: 'unified booking or ops platforms',
        dentosgeIsTheOnly: "\u26A0\uFE0F  dentos.ge is the only partial incumbent \u2014 no full ops layer",
        theProblem2: 'The Problem',
        str511: "\uD83D\uDCCB",
        clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
        noStructuredWorkflowConstant: 'No structured workflow, constant human error',
        str514: "\uD83D\uDCC9",
        noshowsCost1525Of: "No-shows cost 15\u201325% of revenue",
        noAutomatedRemindersOr: 'No automated reminders or confirmation system',
        str517: "\uD83C\uDFE6",
        insuranceBillingIsManual: 'Insurance billing is manual and painful',
        str519: "\uD83D\uDCF5",
        dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
        theSolution: 'The Solution',
        str523: "\uD83D\uDCC5",
        onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
        patientsBook247From: 'Patients book 24/7 from any device',
        str526: "\uD83E\uDDB7",
        patientRecordsTreatmentManagem: 'Patient records & treatment management',
        fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
        str529: "\uD83C\uDFE5",
        insuranceIntegrations: 'Insurance integrations',
        str531: "\uD83D\uDCAC",
        smsWhatsappReminders: 'SMS / WhatsApp reminders',
        cutNoshowsByUp: 'Cut no-shows by up to 40%',
        str534: "\uD83D\uDCCA",
        financialReportingDashboard: 'Financial reporting dashboard',
        revenueSalariesExpensesRealtim: "Revenue, salaries, expenses \u2014 realtime",
        willingnessToPay: 'Willingness to Pay',
        free: 'Free',
        month: '/month',
        listingBookingWidget: 'Listing + booking widget',
        growth: 'Growth',
        calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
        pro: 'Pro',
        fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
        multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
        wtp0515OfMonthly: "\uD83D\uDCA1 WTP: 0.5\u20131.5% of monthly revenue \u2014 clinics earning \u20BE15K\u201350K/mo pay \u20BE100\u2013350/mo comfortably",
        marketOpportunity: 'Market Opportunity',
        addressableClinicsAtLaunch: 'addressable clinics at launch',
        mrrAtFullPenetration: "MRR at full penetration (\u20BE49 avg)",
        home: "\u9996\u9875",
        features: "\u529F\u80FD",
        pricing: "\u4EF7\u683C",
        clinicsNav: "\u8BCA\u6240",
        aiAssistant: "AI\u52A9\u624B",
        forBusiness: "\u4F01\u4E1A\u7248",
        dashboard: "\u4EEA\u8868\u677F",
        getStarted: "\u5F00\u59CB",
        tryDemo: "\u8BD5\u7528\u6F14\u793A",
        viewPitch: "\u67E5\u770B\u6F14\u793A",
        heroTagline: "\u683C\u9C81\u5409\u4E9A\u7259\u79D1\u5E73\u53F0",
        heroTitle: "\u6240\u6709\u7259\u79D1\u8BCA\u6240\u4E2D\u5FC3",
        heroSubtitle: "\u60A8\u7684AI\u52A9\u624B\uFF0C\u5E2E\u60A8\u627E\u5230\u683C\u9C81\u5409\u4E9A\u6700\u597D\u7684\u7259\u79D1\u62A4\u7406",
        searchPlaceholder: "\u641C\u7D22\u8BCA\u6240\u3001\u670D\u52A1\u6216\u63D0\u95EE...",
        chipImplant: "\u7B2C\u6BD4\u5229\u65AF\u6700\u4F73\u79CD\u690D\u7259\u8BCA\u6240",
        chipWhitening: "\u9644\u8FD1\u7684\u7259\u9F7F\u7F8E\u767D",
        chipEmergency: "\u7D27\u6025\u7259\u79D1\u62A4\u7406",
        chipOrtho: "\u6210\u4EBA\u6B63\u7578",
        scrollExplore: "\u6EDA\u52A8\u6D4F\u89C8",
        topRated: "\u7B2C\u6BD4\u5229\u65AF\u8BC4\u5206\u6700\u9AD8\u7684\u7259\u79D1\u8BCA\u6240",
        viewAllClinics: "\u67E5\u770B\u6240\u6709\u8BCA\u6240",
        shareLocation: "\u5206\u4EAB\u4F4D\u7F6E\u67E5\u627E\u9644\u8FD1\u8BCA\u6240",
        locationShared: "\u4F4D\u7F6E\u5DF2\u5206\u4EAB",
        statClinics: "\u8BCA\u6240",
        statNoShows: "\u51CF\u5C11\u7F3A\u5E2D",
        statBooking: "\u5728\u7EBF\u9884\u7EA6",
        statDentists: "\u7259\u533B",
        statRating: "\u5E73\u5747\u8BC4\u5206",
        statPatients: "\u60A3\u8005",
        findClinics: "\u67E5\u627E\u6700\u4F73\u8BCA\u6240",
        clinicsTitle: "\u683C\u9C81\u5409\u4E9A\u7259\u79D1\u8BCA\u6240",
        verifiedClinics: "\u5DF2\u9A8C\u8BC1\u8BCA\u6240",
        searchByName: "\u6309\u540D\u79F0\u3001\u533A\u57DF\u6216\u670D\u52A1\u641C\u7D22...",
        reviews: "\u8BC4\u4EF7",
        loadingMore: "\u52A0\u8F7D\u4E2D...",
        callClinic: "\u62E8\u6253\u7535\u8BDD",
        bookAppointment: "\u9884\u7EA6",
        services: "\u670D\u52A1",
        workingHours: "\u8425\u4E1A\u65F6\u95F4",
        priceRange: "\u4EF7\u683C\u8303\u56F4",
        location: "\u4F4D\u7F6E",
        bookingTitle: "\u9884\u7EA6",
        step: "\u6B65\u9AA4",
        selectClinic: "\u9009\u62E9\u8BCA\u6240",
        selectService: "\u9009\u62E9\u670D\u52A1",
        selectDate: "\u9009\u62E9\u65E5\u671F",
        selectTime: "\u9009\u62E9\u65F6\u95F4",
        confirm: "\u786E\u8BA4",
        next: "\u4E0B\u4E00\u6B65",
        back: "\u8FD4\u56DE",
        forBusinessBtn: "\u4F01\u4E1A\u7248",
        ownClinic: "\u60A8\u62E5\u6709\u4E00\u5BB6\u7259\u79D1\u8BCA\u6240\u5417\uFF1F",
        claimText: "\u5728\u6211\u4EEC\u7684\u6570\u636E\u5E93\u4E2D\u6CE8\u518C\u6216\u6DFB\u52A0\u60A8\u7684\u8BCA\u6240\u3002",
        getListed: "\u7ACB\u5373\u6CE8\u518C \u2192",
        hideMap: "\u9690\u85CF\u5730\u56FE",
        showMap: "\u5730\u56FE",
        nearMe: "\u9644\u8FD1",
        clinicsMatch: "\u8BCA\u6240\u5339\u914D",
        visitWebsite: "\u8BBF\u95EE\u7F51\u7AD9",
        clinicsAvailable: "\u8BCA\u6240\u53EF\u7528",
        clinicsFound: "\u8BCA\u6240\u627E\u5230",
        confirmBooking: "\u786E\u8BA4\u9884\u7EA6",
        bookingConfirmed: "\u60A8\u7684\u9884\u7EA6\u5DF2\u786E\u8BA4\uFF01",
        patientName: "\u60A3\u8005\u59D3\u540D",
        phoneNumber: "\u7535\u8BDD\u53F7\u7801",
        email: "\u7535\u5B50\u90AE\u7BB1",
        notes: "\u5907\u6CE8\uFF08\u53EF\u9009\uFF09",
        businessHeroBadge: "15+ \u6A21\u5757  \xb7  212+ \u8BCA\u6240  \xb7  Gemini AI",
        businessHeroTitle: "\u7259\u79D1\u8BCA\u6240\u64CD\u4F5C\u7CFB\u7EDF",
        businessHeroSubtitle: "\u4E34\u5E8A\u5236\u56FE\u3001\u7259\u5468\u5206\u6790\u3001\u6CBB\u7597\u8BA1\u5212\u3001\u6392\u73ED\u3001\u8BA1\u8D39\u3001\u7535\u5B50\u5904\u65B9\u3001\u5B9E\u9A8C\u5BA4\u7BA1\u7406\u548CAI\u8BCA\u65AD\u2014\u2014\u4E13\u4E3A\u683C\u9C81\u5409\u4E9A\u6253\u9020\u7684\u4E00\u7AD9\u5F0F\u5E73\u53F0\u3002",
        theProblem: "\u95EE\u9898",
        problemSubtitle: "\u683C\u9C81\u5409\u4E9A\u7259\u79D1\u8BCA\u6240\u56E0\u5DE5\u5177\u788E\u7247\u5316\u6BCF\u5929\u635F\u5931\u6536\u5165",
        excelChaos: "Excel\u548CWhatsApp\u6DF7\u4E71",
        excelChaosDetail: "\u8BCA\u6240\u901A\u8FC7\u7535\u5B50\u8868\u683C\u548C\u804A\u5929\u7FA4\u7BA1\u7406\u9884\u7EA6\u3002\u96F6\u81EA\u52A8\u5316\uFF0C\u6301\u7EED\u51FA\u9519\u3002",
        noShowRate: "25%\u723D\u7EA6\u7387",
        noShowDetail: "\u6CA1\u6709\u81EA\u52A8\u63D0\u9192\uFF0C\u60A3\u8005\u5FD8\u8BB0\u9884\u7EA6\u3002\u7A7A\u6905\u5B50\u610F\u5473\u7740\u6BCF\u5929\u20BE500+\u7684\u6536\u5165\u635F\u5931\u3002",
        paperCharts: "2026\u5E74\u4ECD\u7528\u7EB8\u8D28\u75C5\u5386",
        paperChartsDetail: "\u624B\u5199\u4E34\u5E8A\u7B14\u8BB0\uFF0C\u6CA1\u6709\u6570\u5B57\u7259\u4F4D\u56FE\u3002\u5173\u952E\u6570\u636E\u9501\u5728\u6587\u4EF6\u67DC\u4E2D\u3002",
        insuranceBlackHole: "\u4FDD\u9669\u9ED1\u6D1E",
        insuranceDetail: "\u5411Aldagi\u3001GPI\u3001Imedi L\u63D0\u4EA4\u4EBA\u5DE5\u7406\u8D54\u9700\u6570\u5C0F\u65F6\u3002\u88AB\u62D2\u7406\u8D54\u4E0D\u65AD\u79EF\u538B\u3002",
        oneplatform: "\u4E00\u4E2A\u5E73\u53F0\uFF0C\u6240\u6709\u6A21\u5757",
        platformSubtitle: "15\u4E2A\u4E3A\u7259\u79D1\u5B9E\u8DF5\u91CF\u8EAB\u5B9A\u5236\u7684\u96C6\u6210\u6A21\u5757",
        clinical: "\u4E34\u5E8A",
        operations: "\u8FD0\u8425",
        analyticsEnterprise: "\u5206\u6790\u4E0E\u4F01\u4E1A",
        digitalOdontogram: "\u6570\u5B57\u7259\u4F4D\u56FE",
        digitalOdontogramDetail: "FDI 32\u9F7F\u56FE\uFF0C5\u9762\u8FFD\u8E2A\u3002",
        perioCharting: "\u7259\u5468\u5236\u56FE",
        perioChartingDetail: "192\u4F4D\u70B9\u7259\u5468\u7F51\u683C\u30026\u70B9\u63A2\u8BCA\u3001BOP\u3001CAL\u3002",
        treatmentPlanning: "\u6CBB\u7597\u8BA1\u5212",
        treatmentPlanningDetail: "\u5E26CDT\u4EE3\u7801\u7684\u5206\u671F\u8BA1\u5212\uFF0C\u4FDD\u9669\u4F30\u7B97\u3002AI\u6392\u5E8F\u3002",
        soapNotes: "SOAP\u7B14\u8BB0 + AI\u4E66\u5199\u5458",
        soapNotesDetail: "\u5E26\u6A21\u677F\u7684\u7ED3\u6784\u5316\u4E34\u5E8A\u6587\u6863\u3002Gemini\u4ECE\u8BED\u97F3\u751F\u6210\u7B14\u8BB0\u3002",
        multiChairScheduling: "\u591A\u6905\u4F4D\u6392\u73ED",
        multiChairDetail: "\u591A\u64CD\u4F5C\u95F4\u5468\u89C6\u56FE\u3002\u533B\u751F\u989C\u8272\u7F16\u7801\u3002",
        billingInsurance: "\u8BA1\u8D39\u4E0E\u4FDD\u9669",
        billingDetail: "Aldagi\u3001GPI\u3001Imedi L\u7406\u8D54\u8FFD\u8E2A\u3002\u60A3\u8005\u53F0\u8D26\u3001\u4ED8\u6B3E\u8BA1\u5212\u3002",
        ePrescribing: "\u7535\u5B50\u5904\u65B9",
        ePrescribingDetail: "\u5E26\u6A21\u677F\u7684\u6570\u5B57\u5904\u65B9\u3002Gemini\u836F\u7269\u76F8\u4E92\u4F5C\u7528\u68C0\u67E5\u3002",
        labTracking: "\u5B9E\u9A8C\u5BA4\u8FFD\u8E2A",
        labTrackingDetail: "\u770B\u677F\uFF1A\u5DF2\u4E0B\u5355 \u2192 \u5236\u4F5C\u4E2D \u2192 \u5DF2\u53D1\u8D27 \u2192 \u5DF2\u6536\u5230\u3002",
        productionReports: "\u4EA7\u51FA\u62A5\u544A",
        productionReportsDetail: "\u6BDB/\u51C0\u4EA7\u51FA\u3001\u6536\u6B3E\u7387\u3001\u6CBB\u7597\u63A5\u53D7\u7387\u3002",
        referralMgmt: "\u8F6C\u8BCA\u7BA1\u7406",
        referralMgmtDetail: "\u5411\u4E13\u79D1\u533B\u751F\u7684\u8F6C\u5165/\u8F6C\u51FA\u8F6C\u8BCA\u3002AI\u751F\u6210\u7684\u8F6C\u8BCA\u51FD\u3002",
        medicalHistory: "\u75C5\u53F2",
        medicalHistoryDetail: "11\u89C6\u56FE\u60A3\u8005\u8BB0\u5F55\uFF1A\u65F6\u95F4\u7EBF\u3001\u75C5\u60C5\u3001\u836F\u7269\u3001\u8FC7\u654F\u3002",
        enterpriseAdmin: "\u4F01\u4E1A\u7BA1\u7406",
        enterpriseAdminDetail: "RBAC\u3001\u5BA1\u8BA1\u65E5\u5FD7\u3001\u5408\u89C4\u3001\u591A\u79DF\u6237\u3001SSO\u3001API\u7BA1\u7406\u3002",
        geminiBuiltIn: "\u5185\u7F6EGemini AI",
        geminiSubtitle: "\u6BCF\u4E2A\u6A21\u5757\u7531Google Gemini 3.1\u9A71\u52A8",
        xrayAnalysis: "X\u5149\u5206\u6790",
        xrayDetail: "\u4E0A\u4F20\u7259\u79D1X\u5149\u7247\u8FDB\u884CAI\u9F8B\u9F7F\u68C0\u6D4B\u3002",
        perioAssessment: "\u7259\u5468\u8BC4\u4F30",
        perioAssessmentDetail: "\u6839\u636E\u63A2\u8BCA\u6570\u636E\u81EA\u52A8AAP\u5206\u671F/\u5206\u7EA7\u3002",
        clinicalScribe: "\u4E34\u5E8A\u4E66\u5199\u5458",
        clinicalScribeDetail: "\u4ECE\u8BED\u97F3\u5F55\u97F3\u6216\u75C5\u5386\u6570\u636E\u751F\u6210SOAP\u7B14\u8BB0\u3002",
        riskProfiling: "\u98CE\u9669\u8BC4\u4F30",
        riskProfilingDetail: "\u5206\u6790\u75C5\u60C5\u3001\u5BB6\u65CF\u53F2\u4EE5\u521B\u5EFA\u7259\u79D1\u98CE\u9669\u6863\u6848\u3002",
        treatmentSequencing: "\u6CBB\u7597\u6392\u5E8F",
        treatmentSequencingDetail: "AI\u4F18\u5316\u7684\u6CBB\u7597\u5206\u671F\uFF0C\u8003\u8651\u6108\u5408\u671F\u548C\u4FDD\u9669\u3002",
        patientComm: "\u60A3\u8005\u6C9F\u901A",
        patientCommDetail: "\u751F\u6210\u683C\u9C81\u5409\u4E9A\u8BED\u7684\u60A3\u8005\u53CB\u597D\u578B\u89E3\u91CA\u3002",
        georgianEcosystem: "\u683C\u9C81\u5409\u4E9A\u751F\u6001\u7CFB\u7EDF\u5C31\u7EEA",
        integrationsSubtitle: "\u4E0E\u5F53\u5730\u4FDD\u9669\u3001\u652F\u4ED8\u548C\u901A\u8BAF\u7684\u9884\u5EFA\u96C6\u6210",
        insurance: "\u4FDD\u9669",
        payments: "\u652F\u4ED8",
        messaging: "\u901A\u8BAF",
        ehrLabs: "\u7535\u5B50\u75C5\u5386\u4E0E\u5B9E\u9A8C\u5BA4",
        clinicsInDb: "\u6570\u636E\u5E93\u4E2D\u7684\u8BCA\u6240",
        platformModules: "\u5E73\u53F0\u6A21\u5757",
        aiTools: "AI\u5DE5\u5177\uFF08Gemini\uFF09",
        integrations: "\u96C6\u6210",
        pricingTitle: "\u4EF7\u683C",
        pricingSubtitle: "\u514D\u8D39\u5F00\u59CB\uFF0C\u968F\u9700\u6269\u5C55",
        trustedBy: "\u8BCA\u6240\u4FE1\u8D56",
        readyModernize: "\u51C6\u5907\u597D\u73B0\u4EE3\u5316\u4E86\u5417\uFF1F",
        joinCount: "\u52A0\u5165\u683C\u9C81\u5409\u4E9A212+\u5BB6\u8BCA\u6240\u3002",
        startTrial: "\u514D\u8D39\u8BD5\u7528",
        contactSales: "\u8054\u7CFB\u9500\u552E",
        noCreditCard: "\u65E0\u9700\u4FE1\u7528\u5361  \xb7  \u514D\u8D39\u8BA1\u5212  \xb7  5\u5206\u949F\u8BBE\u7F6E",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u4EEA\u8868\u677F",
        navPatients: "\u60A3\u8005",
        navChart: "\u75C5\u5386",
        navPerio: "\u7259\u5468",
        navTreatmentPlans: "\u6CBB\u7597\u8BA1\u5212",
        navNotes: "\u7B14\u8BB0",
        navScheduling: "\u6392\u73ED",
        navBilling: "\u8D26\u5355",
        navPrescriptions: "\u5904\u65B9",
        navLabCases: "\u5B9E\u9A8C\u5BA4\u75C5\u4F8B",
        navReferrals: "\u8F6C\u8BCA",
        navReports: "\u62A5\u544A",
        navMedHistory: "\u75C5\u53F2",
        navIntegrations: "\u96C6\u6210",
        navEnterprise: "\u4F01\u4E1A",
        sectionClinical: "\u4E34\u5E8A",
        sectionOperations: "\u8FD0\u8425",
        sectionAnalytics: "\u5206\u6790",
        sectionAiTools: "AI\u5DE5\u5177",
        sectionAdmin: "\u7BA1\u7406",
        // Booking Page
        chooseClinic: "\u9009\u62E9\u8BCA\u6240",
        selectAService: "\u9009\u62E9\u670D\u52A1",
        pickADate: "\u9009\u62E9\u65E5\u671F",
        pickATime: "\u9009\u62E9\u65F6\u95F4",
        confirmYourBooking: "\u786E\u8BA4\u60A8\u7684\u9884\u7EA6",
        clinicLabel: "\u8BCA\u6240\uFF1A",
        serviceLabel: "\u670D\u52A1\uFF1A",
        dateLabel: "\u65E5\u671F\uFF1A",
        timeLabel: "\u65F6\u95F4\uFF1A",
        // AI Page
        send: "\u53D1\u9001",
        procedure: "\u624B\u672F",
        observations: "\u89C2\u5BDF",
        aiThinking: "AI\u6B63\u5728\u601D\u8003...",
        summarizeHistory: "\u603B\u7ED3\u60A3\u8005\u75C5\u53F2",
        generateTxPlan: "\u751F\u6210\u6CBB\u7597\u8BA1\u5212",
        checkDrugInteractions: "\u68C0\u67E5\u836F\u7269\u76F8\u4E92\u4F5C\u7528",
        writeClinicalNote: "\u7F16\u5199\u4E34\u5E8A\u7B14\u8BB0",
        askAiAssistant: "\u8BE2\u95EEAI\u52A9\u624B...",
        dropXray: "\u62D6\u653EX\u5149\u7247\u6216\u70B9\u51FB\u4E0A\u4F20",
        supportsFormats: "\u652F\u6301DICOM\u3001PNG\u3001JPG",
        analysisResults: "\u5206\u6790\u7ED3\u679C\uFF08\u6F14\u793A\uFF09",
        aiRecommendation: "AI\u5EFA\u8BAE",
        exportToTxPlan: "\u5BFC\u51FA\u81F3\u6CBB\u7597\u8BA1\u5212",
        generateClinicalNote: "\u751F\u6210\u4E34\u5E8A\u7B14\u8BB0",
        generatedSoap: "\u751F\u6210\u7684\u4E34\u5E8A\u7B14\u8BB0\uFF08SOAP\uFF09",
        subjective: "S \u2014 \u4E3B\u89C2",
        objective: "O \u2014 \u5BA2\u89C2",
        assessment: "A \u2014 \u8BC4\u4F30",
        plan: "P \u2014 \u8BA1\u5212",
        copyToRecord: "\u590D\u5236\u5230\u60A3\u8005\u8BB0\u5F55",
        aiPerioAssessment: "AI\u7259\u5468\u8BC4\u4F30",
        enterProbingData: "\u8F93\u5165\u63A2\u8BCA\u6570\u636E\u4EE5\u83B7\u53D6AAP\u5206\u671F/\u5206\u7EA7\u548C\u6CBB\u7597\u5EFA\u8BAE\u3002",
        analyzeWithGemini: "\u4F7F\u7528Gemini\u5206\u6790",
        aiRiskAssessment: "AI\u98CE\u9669\u8BC4\u4F30",
        enterConditions: "\u8F93\u5165\u60A3\u8005\u72B6\u51B5\u3001\u5BB6\u65CF\u53F2\u548C\u751F\u547D\u4F53\u5F81\u4EE5\u751F\u6210\u98CE\u9669\u6863\u6848\u3002",
        generateRiskProfile: "\u751F\u6210\u98CE\u9669\u6863\u6848",
        patientCommunication: "\u60A3\u8005\u6C9F\u901A",
        generateExplanations: "\u751F\u6210\u683C\u9C81\u5409\u4E9A\u8BED\u6216\u82F1\u8BED\u7684\u60A3\u8005\u53CB\u597D\u578B\u6CBB\u7597\u8BF4\u660E\u3002",
        generateExplanation: "\u751F\u6210\u8BF4\u660E",
        patientFriendly: "\u60A3\u8005\u53CB\u597D\u578B\u8BF4\u660E",
        // Billing Page
        claims: "\u7406\u8D54",
        ledger: "\u53F0\u8D26",
        aging: "\u8D26\u9F84",
        paymentPlans: "\u4ED8\u6B3E\u8BA1\u5212",
        eligibility: "\u8D44\u683C",
        allFilter: "\u5168\u90E8",
        submitted: "\u5DF2\u63D0\u4EA4",
        paid: "\u5DF2\u652F\u4ED8",
        denied: "\u5DF2\u62D2\u7EDD",
        patientLedger: "\u60A3\u8005\u53F0\u8D26",
        agedAccounts: "\u903E\u671F\u8D26\u6237",
        sendStatements: "\u53D1\u9001\u5BF9\u8D26\u5355",
        activePaymentPlans: "\u6D3B\u8DC3\u4ED8\u6B3E\u8BA1\u5212",
        insuranceEligibility: "\u4FDD\u9669\u8D44\u683C",
        // Clinical Charting
        odontogram: "\u7259\u4F4D\u56FE",
        perioTab: "\u7259\u5468",
        treatmentPlanTab: "\u6CBB\u7597\u8BA1\u5212",
        notesTab: "\u7B14\u8BB0",
        progressNotes: "\u8FDB\u5C55\u7B14\u8BB0",
        openFullPerio: "\u6253\u5F00\u5B8C\u6574\u7259\u5468\u56FE \u2192",
        openFullTxPlanner: "\u6253\u5F00\u5B8C\u6574\u6CBB\u7597\u89C4\u5212\u5668 \u2192",
        openClinicalNotes: "\u6253\u5F00\u4E34\u5E8A\u7B14\u8BB0 \u2192",
        newExam: "\u65B0\u68C0\u67E5",
        voiceEntry: "\u8BED\u97F3\u8F93\u5165",
        bleedingIndex: "\u51FA\u8840\u6307\u6570",
        plaqueIndex: "\u83CC\u6591\u6307\u6570",
        sitesAbove4: "\u4F4D\u70B9 \u2265 4mm",
        sitesAbove6: "\u4F4D\u70B9 \u2265 6mm",
        planA: "\u65B9\u6848A\uFF1A\u63A8\u8350",
        planB: "\u65B9\u6848B\uFF1A\u4FDD\u5B88",
        newPlan: "+ \u65B0\u65B9\u6848",
        presentToPatient: "\u5411\u60A3\u8005\u5C55\u793A",
        sendToPortal: "\u53D1\u9001\u81F3\u95E8\u6237",
        totalFee: "\u603B\u8D39\u7528",
        insuranceEst: "\u4FDD\u9669\u4F30\u7B97",
        patientPortion: "\u60A3\u8005\u90E8\u5206",
        chairSideMode: "\u6905\u65C1\u6A21\u5F0F",
        adminMode: "\u7BA1\u7406\u6A21\u5F0F",
        proceduresAcrossPhases: "{1}\u4E2A\u9636\u6BB5\u4E2D\u7684{0}\u4E2A\u7A0B\u5E8F",
        // Scheduling
        day: "\u65E5",
        week: "\u5468",
        today: "\u4ECA\u5929",
        providerFilter: "\u6240\u6709\u533B\u751F",
        productionGoal: "\u4EA7\u51FA\u76EE\u6807",
        waitlist: "\u5019\u8865\u540D\u5355",
        // Prescriptions
        activeRx: "\u6709\u6548",
        pastRx: "\u5386\u53F2",
        templates: "\u6A21\u677F",
        interactionCheck: "\u76F8\u4E92\u4F5C\u7528\u68C0\u67E5",
        // Lab Cases
        ordered: "\u5DF2\u4E0B\u5355",
        sentToLab: "\u5DF2\u9001\u5B9E\u9A8C\u5BA4",
        inFabrication: "\u5236\u4F5C\u4E2D",
        shipped: "\u5DF2\u53D1\u8D27",
        received: "\u5DF2\u6536\u5230",
        labVendors: "\u5B9E\u9A8C\u5BA4\u4F9B\u5E94\u5546",
        // Referrals
        allDirections: "\u5168\u90E8",
        inbound: "\u8F6C\u5165",
        outbound: "\u8F6C\u51FA",
        generateLetter: "\u751F\u6210\u51FD\u4EF6",
        // Reports
        production: "\u4EA7\u51FA",
        collections: "\u6536\u6B3E",
        schedulingReport: "\u6392\u73ED",
        treatmentAcceptance: "\u6CBB\u7597\u63A5\u53D7\u7387",
        recall: "\u590D\u53EC",
        grossProduction: "\u6BDB\u4EA7\u51FA",
        netProduction: "\u51C0\u4EA7\u51FA",
        collectionRate: "\u6536\u6B3E\u7387",
        plansPresented: "\u5DF2\u5C55\u793A\u8BA1\u5212",
        accepted: "\u5DF2\u63A5\u53D7",
        acceptanceRate: "\u63A5\u53D7\u7387",
        dueThisMonth: "\u672C\u6708\u5230\u671F",
        scheduled: "\u5DF2\u5B89\u6392",
        completed: "\u5DF2\u5B8C\u6210",
        overdue: "\u903E\u671F",
        reactivationRate: "\u91CD\u65B0\u6FC0\u6D3B\u7387",
        // Medical History
        timeline: "\u65F6\u95F4\u7EBF",
        conditions: "\u75C5\u60C5",
        medications: "\u836F\u7269",
        allergies: "\u8FC7\u654F",
        labResults: "\u5316\u9A8C\u7ED3\u679C",
        vitals: "\u751F\u547D\u4F53\u5F81",
        immunizations: "\u514D\u75AB\u63A5\u79CD",
        familyHistory: "\u5BB6\u65CF\u53F2",
        imaging: "\u5F71\u50CF",
        documents: "\u6587\u4EF6",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u5BA1\u8BA1\u65E5\u5FD7",
        compliance: "\u5408\u89C4",
        multiTenancy: "\u591A\u79DF\u6237",
        sso: "SSO\u4E0E\u5B89\u5168",
        featureFlags: "\u529F\u80FD\u6807\u5FD7",
        apiManagement: "API\u7BA1\u7406",
        dataManagement: "\u6570\u636E\u7BA1\u7406",
        // Integrations
        ehr: "\u7535\u5B50\u75C5\u5386",
        labs: "\u5B9E\u9A8C\u5BA4",
        telehealth: "\u8FDC\u7A0B\u533B\u7597",
        aiMl: 'AI/ML',
        wearables: "\u53EF\u7A7F\u6234\u8BBE\u5907",
        connected: "\u5DF2\u8FDE\u63A5",
        disconnected: "\u5DF2\u65AD\u5F00",
        available: "\u53EF\u7528",
        // Components
        status: "\u72B6\u6001",
        healthy: "\u5065\u5EB7",
        caries: "\u9F8B\u9F7F",
        restored: "\u5DF2\u4FEE\u590D",
        missing: "\u7F3A\u5931",
        implant: "\u79CD\u690D\u4F53",
        crownStatus: "\u7259\u51A0",
        bridge: "\u6865\u4F53",
        veneer: "\u8D34\u9762",
        surfaces: "\u9762",
        procedureHistory: "\u64CD\u4F5C\u5386\u53F2",
        addProcedure: "\u6DFB\u52A0\u64CD\u4F5C",
        totalCharged: "\u603B\u6536\u8D39",
        insurancePayment: "\u4FDD\u9669\u652F\u4ED8",
        patientResponsibility: "\u60A3\u8005\u81EA\u4ED8",
        expand: "\u5C55\u5F00",
        policyNumber: "\u4FDD\u5355\u53F7",
        planType: "\u8BA1\u5212\u7C7B\u578B",
        annualMax: "\u5E74\u5EA6\u4E0A\u9650",
        used: "\u5DF2\u7528",
        remaining: "\u5269\u4F59",
        coverageByCategory: "\u6309\u7C7B\u522B\u8986\u76D6",
        preventive: "\u9884\u9632",
        basic: "\u57FA\u7840",
        major: "\u91CD\u5927",
        ortho: "\u6B63\u7578",
        current: "\u5F53\u524D",
        thirtyDay: "30\u5929",
        sixtyDay: "60\u5929",
        ninetyPlus: "90+\u5929",
        totalBalance: "\u603B\u4F59\u989D",
        monthlyPayment: "\u6708\u4F9B",
        paymentsRemaining: "\u5269\u4F59\u671F\u6570",
        nextPayment: "\u4E0B\u6B21\u4ED8\u6B3E",
        paymentProgress: "\u4ED8\u6B3E\u8FDB\u5EA6",
        choosePlan: "\u9009\u62E9\u8BA1\u5212",
        aiInsight: "AI\u6D1E\u5BDF",
        confidence: "\u7F6E\u4FE1\u5EA6",
        revoke: "\u64A4\u9500",
        exams: "\u68C0\u67E5",
        phaseTotal: "\u9636\u6BB5\u5408\u8BA1",
        mon: "\u4E00",
        tue: "\u4E8C",
        wed: "\u4E09",
        thu: "\u56DB",
        fri: "\u4E94",
        sat: "\u516D",
        sun: "\u65E5",
        thinking: "\u601D\u8003\u4E2D...",
        followUpPlaceholder: "\u63D0\u51FA\u540E\u7EED\u95EE\u9898...",
        initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
        nextExpansionArmeniaAzerbaijan: "\uD83C\uDF0D  Next expansion: Armenia \u2192 Azerbaijan \u2192 broader Caucasus dental market",
        whyNow: 'Why Now',
        str561: "\u2708\uFE0F",
        dentalTourismBoom: 'Dental tourism boom',
        internationalPatientsNeedEngli: 'International patients need English-language online booking now',
        str564: "\uD83D\uDCF1",
        postcovidDigitizationPressure: 'Post-COVID digitization pressure',
        clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
        str567: "\uD83C\uDFC6",
        noStrongLocalIncumbent: 'No strong local incumbent',
        dentosgeOnlyCoversDiscovery: "dentos.ge only covers discovery \u2014 zero full ops platform exists",
        str570: "\uD83C\uDDEC\uD83C\uDDEA",
        georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
        lowCostHighQuality: "Low cost, high quality \u2014 50\u201370% cheaper than Western Europe",
        joinThePartnerClinic: "Join the Partner Clinic Program \u2014 first 3 months free",
        builtForGeorgianClinics: "\uD83E\uDDB7 Built for Georgian clinics, by people who live here",
        prev: "\u2190 Prev",
        next2: "Next \u2192",
        getInTouch: "\uD83E\uDDB7 Get in Touch",
        activePrescriptions: 'Active Prescriptions',
        pastPrescriptions: 'Past Prescriptions',
        prescriptionTemplates: 'Prescription Templates',
        drugInteractionChecker: 'Drug Interaction Checker',
        referrals: 'Referrals',
        newReferral: '+ New Referral',
        inbound2: 'Inbound',
        outbound2: 'Outbound',
        reportsAnalytics: 'Reports & Analytics',
        productionByProvider: 'Production by Provider',
        productionByCategory: 'Production by Category',
        preventive2: 'Preventive',
        restorative: 'Restorative',
        endodontics: 'Endodontics',
        periodontics: 'Periodontics',
        prosthodontics: 'Prosthodontics',
        surgery: 'Surgery',
        agingReport: 'Aging Report',
        appointmentsByDay: 'Appointments by Day',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        topDeclinedTreatments: 'Top Declined Treatments',
        costConcerns: 'Cost concerns',
        wantsToWait: 'Wants to wait',
        orthodontics: 'Orthodontics',
        insuranceNotCovering: 'Insurance not covering',
        notAPriority: 'Not a priority',
        seekingSecondOpinion: 'Seeking second opinion',
        u2190: '\u2190',
        u2192: '\u2192',
        allProviders: 'All Providers',
        hygienistNino: 'Hygienist Nino',
        mon17: 'MON 17',
        tue18: 'TUE 18',
        wed19: 'WED 19',
        thu20: 'THU 20',
        fri21: 'FRI 21',
        crownPrep14: 'Crown Prep #14',
        tKapanadze: 'T. Kapanadze',
        srpQuad1: 'SRP Quad 1',
        dGelashvili: 'D. Gelashvili',
        examXray: 'Exam + X-ray',
        mTsiklauri: 'M. Tsiklauri',
        unconfirmed: 'Unconfirmed',
        rct36: 'RCT #36',
        gBeridze: 'G. Beridze',
        prophyPolish: 'Prophy + Polish',
        iDiasamidze: 'I. Diasamidze',
        perioMaintenance: 'Perio Maintenance',
        tLomidze: 'T. Lomidze',
        prophy: 'Prophy',
        aJavakhishvili: 'A. Javakhishvili',
        inChair: 'In Chair',
        sealantsX4: 'Sealants x4',
        nKapanadze: 'N. Kapanadze',
        lMchedlishvili: 'L. Mchedlishvili',
        u2014LunchU2014: '\u2014 Lunch \u2014',
        veneerPrep11: 'Veneer Prep #11',
        kGabrichidze: 'K. Gabrichidze',
        composite25: 'Composite #25',
        sMeladze: 'S. Meladze',
        bridgePrep3436: 'Bridge Prep #34-36',
        rKharazishvili: 'R. Kharazishvili',
        composite22: 'Composite #22',
        zDolidze: 'Z. Dolidze',
        noShow: 'No Show',
        extraction48: 'Extraction #48',
        vPapunashvili: 'V. Papunashvili',
        implantConsult: 'Implant Consult',
        eTsereteli: 'E. Tsereteli',
        nGogiberidze: 'N. Gogiberidze',
        crownSeat14: 'Crown Seat #14',
        checkup: 'Checkup',
        bShengelia: 'B. Shengelia',
        fluorideTreatment: 'Fluoride Treatment',
        emergencyWalkin: 'Emergency Walk-in',
        scaling: 'Scaling',
        wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
        assignToSchedule: 'Assign to Schedule',
        autoAssign: 'Auto Assign',
        high: 'High',
        anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
        medium: 'Medium',
        irakliDiasamidze: 'Irakli Diasamidze',
        friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
        low: 'Low',
        planARecommended: 'Plan A: Recommended',
        planBConservative: 'Plan B: Conservative',
        newPlan2: '+ New Plan',
        conservativeApproach: 'Conservative Approach',
        thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
        u00b7: '\u00B7',
        treatmentPlanComparison: 'Treatment Plan Comparison',
        u00b72: '\u00b7',
        exams2: 'Exams:',
        metric: 'Metric',
        pdMm: 'PD (mm)',
        gmMm: 'GM (mm)',
        calMm: 'CAL (mm)',
        suppuration: 'Suppuration',
        furcation: 'Furcation',
        mobility: 'Mobility',
        qty: 'Qty',
        refills: 'Refills',
        goal: 'Goal',
        current2: 'Current',
        totalDue: 'Total Due',
        scheduled2: 'Scheduled',
        overdue2: 'Overdue',
        reactivation: 'Reactivation',
        chiefComplaint: 'Chief Complaint',
        painScale: 'Pain Scale:',
        clinicalFindings: 'Clinical Findings',
        diagnosis: 'Diagnosis',
        prescriptions: 'Prescriptions',
        u201c: '\u201C',
        xray: 'X-Ray',
        cleaning: 'Cleaning',
        amountPaid: 'Amount Paid',
        annotate: 'Annotate',
        anonymousPatient: 'Anonymous Patient',
        autoImport: 'Auto Import',
        away: 'Away',
        bankTransfer: 'Bank Transfer',
        beforeAfter: 'Before After',
        bookPrerequisiteFirst: 'Book Prerequisite First',
        breakdown: 'Breakdown',
        bridgePrep: 'Bridge Prep',
        brightness: 'Brightness',
        cabinet: 'Cabinet',
        cabinet1: 'Cabinet 1',
        cabinet2: 'Cabinet 2',
        cabinetSchedule: 'Cabinet Schedule',
        cabinetScheduleDesc: 'Cabinet Schedule Desc',
        card: 'Card',
        cash: 'Cash',
        cbct: 'Cbct',
        cephalometric: 'Cephalometric',
        channels: 'Channels',
        clinicalQuestion: 'Clinical Question',
        clinicAvgRating: 'Clinic Avg Rating',
        collapse: 'Collapse',
        completedToday: 'Completed Today',
        compositeF: 'Composite F',
        continueToScheduling: 'Continue To Scheduling',
        contrast: 'Contrast',
        ctScans: 'Ct Scans',
        customAmount: 'Custom Amount',
        days: 'Days',
        delivered: 'Delivered',
        directMessages: 'Direct Messages',
        disposables: 'Disposables',
        doctorResponse: 'Doctor Response',
        doctors: 'Doctors',
        documentMgmtSubtitle: 'Document Mgmt Subtitle',
        documentPreview: 'Document Preview',
        download: 'Download',
        endodontic: 'Endodontic',
        enterAmount: 'Enter Amount',
        equipmentDevices: 'Equipment Devices',
        estDelivery: 'Est Delivery',
        examConsult: 'Exam Consult',
        explanationQuality: 'Explanation Quality',
        fluorideTx: 'Fluoride Tx',
        fullMouthView: 'Full Mouth View',
        hasBracesQuestion: 'Has Braces Question',
        hasConsultationQuestion: 'Has Consultation Question',
        hasCtScanQuestion: 'Has Ct Scan Question',
        hasRecentXrayQuestion: 'Has Recent Xray Question',
        helpfulQuestion: 'Helpful Question',
        highest: 'Highest',
        hygiene: 'Hygiene',
        imagingType: 'Imaging Type',
        implantPlace: 'Implant Place',
        important: 'Important',
        importLatest: 'Import Latest',
        inProgress: 'In Progress',
        installment: 'Installment',
        insuranceCoverage: 'Insurance Coverage',
        interpreted: 'Interpreted',
        inUse: 'In Use',
        invoices: 'Invoices',
        lastCleaningQuestion: 'Last Cleaning Question',
        lateralSkullView: 'Lateral Skull View',
        lowest: 'Lowest',
        lowStock: 'Low Stock',
        lowStockAlerts: 'Low Stock Alerts',
        maintenance: 'Maintenance',
        management: 'Management',
        markComplete: 'Mark Complete',
        material: 'Material',
        method: 'Method',
        minOrder: 'Min Order',
        monthlySpend: 'Monthly Spend',
        newPayment: 'New Payment',
        newRadiologyReferral: 'New Radiology Referral',
        nextAppointment: 'Next Appointment',
        noDocumentsFound: 'No Documents Found',
        noNoteSelected: 'No Note Selected',
        normal: 'Normal',
        noteInterpreter: 'Note Interpreter',
        occupied: 'Occupied',
        online: 'Online',
        orderNow: 'Order Now',
        orders: 'Orders',
        original: 'Original',
        outstanding: 'Outstanding',
        painManagement: 'Pain Management',
        panoramic: 'Panoramic',
        patientDue: 'Patient Due',
        paymentHistory: 'Payment History',
        paymentMethod: 'Payment Method',
        pendingOrders: 'Pending Orders',
        periapical: 'Periapical',
        perioMaint: 'Perio Maint',
        photos: 'Photos',
        placeOrder: 'Place Order',
        preCheck: 'Pre Check',
        preCheckPassed: 'Pre Check Passed',
        preCheckSubtitle: 'Pre Check Subtitle',
        preCheckTitle: 'Pre Check Title',
        prerequisiteWarning: 'Prerequisite Warning',
        print: 'Print',
        processing: 'Processing',
        processPayment: 'Process Payment',
        processPaymentBtn: 'Process Payment Btn',
        professionalism: 'Professionalism',
        prophyClean: 'Prophy Clean',
        prosthetic: 'Prosthetic',
        punctuality: 'Punctuality',
        qtyUsed: 'Qty Used',
        quantity: 'Quantity',
        queue: 'Queue',
        receiptPreview: 'Receipt Preview',
        recent: 'Recent',
        recentMaterialUsage: 'Recent Material Usage',
        recentReceipts: 'Recent Receipts',
        reliability: 'Reliability',
        remainingBalance: 'Remaining Balance',
        reorderLevel: 'Reorder Level',
        scanning: 'Scanning',
        sealants: 'Sealants',
        sent: 'Sent',
        singleToothView: 'Single Tooth View',
        slotDetails: 'Slot Details',
        sortBy: 'Sort By',
        srpQuad: 'Srp Quad',
        startImaging: 'Start Imaging',
        stock: 'Stock',
        stockLevel: 'Stock Level',
        submitReferral: 'Submit Referral',
        subtotal: 'Subtotal',
        suppliers: 'Suppliers',
        surgical: 'Surgical',
        targetArea: 'Target Area',
        teamChat: 'Team Chat',
        termsNormalized: 'Terms Normalized',
        threeDImaging: 'Three D Imaging',
        totalItems: 'Total Items',
        totalReceived: 'Total Received',
        typeAMessage: 'Type A Message',
        unavailable: 'Unavailable',
        unit: 'Unit',
        urgency: 'Urgency',
        urgent: 'Urgent',
        usageLog: 'Usage Log',
        veneerPrep: 'Veneer Prep',
        viewOnGoogle: 'View On Google',
        xrays: 'Xrays'
    },
    hi: {
        home: "\u0939\u094B\u092E",
        features: "\u0935\u093F\u0936\u0947\u0937\u0924\u093E\u090F\u0902",
        pricing: "\u092E\u0942\u0932\u094D\u092F",
        clinicsNav: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        aiAssistant: "AI \u0938\u0939\u093E\u092F\u0915",
        forBusiness: "\u0935\u094D\u092F\u093E\u092A\u093E\u0930 \u0915\u0947 \u0932\u093F\u090F",
        dashboard: "\u0921\u0948\u0936\u092C\u094B\u0930\u094D\u0921",
        getStarted: "\u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902",
        tryDemo: "\u0921\u0947\u092E\u094B \u0906\u091C\u093C\u092E\u093E\u090F\u0902",
        heroTagline: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u0915\u0947 \u0932\u093F\u090F \u0921\u0947\u0902\u091F\u0932 \u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E",
        heroTitle: "\u0938\u092D\u0940 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0939\u092C",
        heroSubtitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u092E\u0947\u0902 \u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u0926\u0902\u0924 \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E \u0916\u094B\u091C\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0906\u092A\u0915\u093E AI \u0938\u0939\u093E\u092F\u0915",
        searchPlaceholder: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915, \u0938\u0947\u0935\u093E\u090F\u0902 \u0916\u094B\u091C\u0947\u0902 \u092F\u093E \u0915\u0941\u091B \u092A\u0942\u091B\u0947\u0902...",
        chipImplant: "\u0924\u094D\u092C\u093F\u0932\u093F\u0938\u0940 \u092E\u0947\u0902 \u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u0907\u092E\u094D\u092A\u094D\u0932\u093E\u0902\u091F \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        chipWhitening: "\u092E\u0947\u0930\u0947 \u092A\u093E\u0938 \u0926\u093E\u0902\u0924 \u0938\u092B\u0947\u0926 \u0915\u0930\u0928\u093E",
        chipEmergency: "\u0906\u092A\u093E\u0924\u0915\u093E\u0932\u0940\u0928 \u0926\u0902\u0924 \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E",
        chipOrtho: "\u0935\u092F\u0938\u094D\u0915\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u0911\u0930\u094D\u0925\u094B\u0921\u0949\u0928\u094D\u091F\u093F\u0915\u094D\u0938",
        scrollExplore: "\u0926\u0947\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0915\u094D\u0930\u0949\u0932 \u0915\u0930\u0947\u0902",
        topRated: "\u0924\u094D\u092C\u093F\u0932\u093F\u0938\u0940 \u0915\u0947 \u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        viewAllClinics: "\u0938\u092D\u0940 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0926\u0947\u0916\u0947\u0902",
        statClinics: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        statNoShows: "\u0915\u092E \u0905\u0928\u0941\u092A\u0938\u094D\u0925\u093F\u0924\u093F",
        statBooking: "\u0911\u0928\u0932\u093E\u0907\u0928 \u092C\u0941\u0915\u093F\u0902\u0917",
        statDentists: "\u0926\u0902\u0924 \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u0915",
        statRating: "\u0914\u0938\u0924 \u0930\u0947\u091F\u093F\u0902\u0917",
        statPatients: "\u092E\u0930\u0940\u091C",
        findClinics: "\u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0916\u094B\u091C\u0947\u0902",
        clinicsTitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u092E\u0947\u0902 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        verifiedClinics: "\u0938\u0924\u094D\u092F\u093E\u092A\u093F\u0924 \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        reviews: "\u0938\u092E\u0940\u0915\u094D\u0937\u093E\u090F\u0902",
        callClinic: "\u0915\u0949\u0932 \u0915\u0930\u0947\u0902",
        bookAppointment: "\u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092C\u0941\u0915 \u0915\u0930\u0947\u0902",
        services: "\u0938\u0947\u0935\u093E\u090F\u0902",
        workingHours: "\u0915\u093E\u0930\u094D\u092F \u0938\u092E\u092F",
        priceRange: "\u092E\u0942\u0932\u094D\u092F \u0938\u0940\u092E\u093E",
        location: "\u0938\u094D\u0925\u093E\u0928",
        bookingTitle: "\u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092C\u0941\u0915 \u0915\u0930\u0947\u0902",
        step: "\u091A\u0930\u0923",
        selectClinic: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u091A\u0941\u0928\u0947\u0902",
        selectService: "\u0938\u0947\u0935\u093E \u091A\u0941\u0928\u0947\u0902",
        selectDate: "\u0924\u093E\u0930\u0940\u0916 \u091A\u0941\u0928\u0947\u0902",
        selectTime: "\u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902",
        confirm: "\u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
        next: "\u0905\u0917\u0932\u093E",
        back: "\u092A\u0940\u091B\u0947",
        viewPitch: "\u092A\u094D\u0930\u0938\u094D\u0924\u0941\u0924\u093F \u0926\u0947\u0916\u0947\u0902",
        shareLocation: "\u0928\u091C\u093C\u0926\u0940\u0915\u0940 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0915\u0947 \u0932\u093F\u090F \u0932\u094B\u0915\u0947\u0936\u0928 \u0938\u093E\u091D\u093E \u0915\u0930\u0947\u0902",
        locationShared: "\u0932\u094B\u0915\u0947\u0936\u0928 \u0938\u093E\u091D\u093E \u0939\u0941\u0908 \u2014 \u0928\u091C\u093C\u0926\u0940\u0915\u0940 \u0926\u093F\u0916\u093E \u0930\u0939\u0947 \u0939\u0948\u0902",
        forBusinessBtn: "\u0935\u094D\u092F\u093E\u092A\u093E\u0930 \u0915\u0947 \u0932\u093F\u090F",
        ownClinic: "\u0915\u094D\u092F\u093E \u0906\u092A \u090F\u0915 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0915\u0947 \u092E\u093E\u0932\u093F\u0915 \u0939\u0948\u0902?",
        claimText: "\u0905\u092A\u0928\u0940 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0915\u094B \u0939\u092E\u093E\u0930\u0947 \u0921\u0947\u091F\u093E\u092C\u0947\u0938 \u092E\u0947\u0902 \u0930\u091C\u093F\u0938\u094D\u091F\u0930 \u0915\u0930\u0947\u0902 \u092F\u093E \u091C\u094B\u0921\u093C\u0947\u0902\u0964",
        getListed: "\u0930\u091C\u093F\u0938\u094D\u091F\u0930 \u0915\u0930\u0947\u0902 \u2192",
        searchByName: "\u0928\u093E\u092E, \u091C\u093F\u0932\u0947 \u092F\u093E \u0938\u0947\u0935\u093E \u0938\u0947 \u0916\u094B\u091C\u0947\u0902...",
        hideMap: "\u092E\u093E\u0928\u091A\u093F\u0924\u094D\u0930 \u091B\u0941\u092A\u093E\u090F\u0902",
        showMap: "\u092E\u093E\u0928\u091A\u093F\u0924\u094D\u0930",
        nearMe: "\u092E\u0947\u0930\u0947 \u092A\u093E\u0938",
        clinicsMatch: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u092E\u093F\u0932\u0924\u0940 \u0939\u0948\u0902",
        loadingMore: "\u0932\u094B\u0921 \u0939\u094B \u0930\u0939\u093E \u0939\u0948...",
        visitWebsite: "\u0935\u0947\u092C\u0938\u093E\u0907\u091F \u0926\u0947\u0916\u0947\u0902",
        clinicsAvailable: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0909\u092A\u0932\u092C\u094D\u0927",
        clinicsFound: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u092E\u093F\u0932\u0940\u0902",
        confirmBooking: "\u092C\u0941\u0915\u093F\u0902\u0917 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
        bookingConfirmed: "\u0906\u092A\u0915\u0940 \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092C\u0941\u0915 \u0939\u094B \u0917\u0908!",
        patientName: "\u092E\u0930\u0940\u091C \u0915\u093E \u0928\u093E\u092E",
        phoneNumber: "\u092B\u094B\u0928 \u0928\u0902\u092C\u0930",
        email: "\u0908\u092E\u0947\u0932",
        notes: "\u0928\u094B\u091F\u094D\u0938 (\u0935\u0948\u0915\u0932\u094D\u092A\u093F\u0915)",
        businessHeroBadge: "15+ \u092E\u0949\u0921\u094D\u092F\u0942\u0932  \xb7  212+ \u0915\u094D\u0932\u0940\u0928\u093F\u0915  \xb7  Gemini AI",
        businessHeroTitle: "\u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0911\u092A\u0930\u0947\u091F\u093F\u0902\u0917 \u0938\u093F\u0938\u094D\u091F\u092E",
        businessHeroSubtitle: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u091A\u093E\u0930\u094D\u091F\u093F\u0902\u0917, \u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923, \u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E, \u0936\u0947\u0921\u094D\u092F\u0942\u0932\u093F\u0902\u0917, \u092C\u093F\u0932\u093F\u0902\u0917, \u0908-\u092A\u094D\u0930\u093F\u0938\u094D\u0915\u094D\u0930\u093F\u092A\u094D\u0936\u0928, \u0932\u0948\u092C \u092A\u094D\u0930\u092C\u0902\u0927\u0928 \u0914\u0930 AI \u0921\u093E\u092F\u0917\u094D\u0928\u094B\u0938\u094D\u091F\u093F\u0915\u094D\u0938 \u2014 \u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E\u0964",
        theProblem: "\u0938\u092E\u0938\u094D\u092F\u093E",
        problemSubtitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0916\u0902\u0921\u093F\u0924 \u0909\u092A\u0915\u0930\u0923\u094B\u0902 \u0915\u0947 \u0915\u093E\u0930\u0923 \u0926\u0948\u0928\u093F\u0915 \u0930\u093E\u091C\u0938\u094D\u0935 \u0916\u094B \u0930\u0939\u0940 \u0939\u0948\u0902",
        excelChaos: "Excel \u0914\u0930 WhatsApp \u0905\u0930\u093E\u091C\u0915\u0924\u093E",
        excelChaosDetail: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0938\u094D\u092A\u094D\u0930\u0947\u0921\u0936\u0940\u091F \u0914\u0930 \u091A\u0948\u091F \u0938\u0947 \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092A\u094D\u0930\u092C\u0902\u0927\u093F\u0924 \u0915\u0930\u0924\u0940 \u0939\u0948\u0902\u0964 \u0936\u0942\u0928\u094D\u092F \u0938\u094D\u0935\u091A\u093E\u0932\u0928, \u0928\u093F\u0930\u0902\u0924\u0930 \u0924\u094D\u0930\u0941\u091F\u093F\u092F\u093E\u0902\u0964",
        noShowRate: "25% \u0905\u0928\u0941\u092A\u0938\u094D\u0925\u093F\u0924\u093F \u0926\u0930",
        noShowDetail: "\u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u093F\u092E\u093E\u0907\u0902\u0921\u0930 \u0915\u0947 \u092C\u093F\u0928\u093E \u092E\u0930\u0940\u091C \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092D\u0942\u0932 \u091C\u093E\u0924\u0947 \u0939\u0948\u0902\u0964 \u0916\u093E\u0932\u0940 \u0915\u0941\u0930\u094D\u0938\u093F\u092F\u093E\u0902 = \u20BE500+/\u0926\u093F\u0928 \u0928\u0941\u0915\u0938\u093E\u0928\u0964",
        paperCharts: "2026 \u092E\u0947\u0902 \u0915\u093E\u0917\u091C\u093C\u0940 \u091A\u093E\u0930\u094D\u091F",
        paperChartsDetail: "\u0939\u0938\u094D\u0924\u0932\u093F\u0916\u093F\u0924 \u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F\u094D\u0938, \u0915\u094B\u0908 \u0921\u093F\u091C\u093F\u091F\u0932 \u0913\u0921\u094B\u0928\u094D\u091F\u094B\u0917\u094D\u0930\u093E\u092E \u0928\u0939\u0940\u0902\u0964 \u092E\u0939\u0924\u094D\u0935\u092A\u0942\u0930\u094D\u0923 \u0921\u0947\u091F\u093E \u092B\u093E\u0907\u0932 \u0915\u0948\u092C\u093F\u0928\u0947\u091F \u092E\u0947\u0902 \u092C\u0902\u0926\u0964",
        insuranceBlackHole: "\u092C\u0940\u092E\u093E \u092C\u094D\u0932\u0948\u0915 \u0939\u094B\u0932",
        insuranceDetail: "Aldagi, GPI, Imedi L \u0915\u094B \u092E\u0948\u0928\u0941\u0905\u0932 \u0926\u093E\u0935\u0947 \u0918\u0902\u091F\u094B\u0902 \u0932\u0917\u0924\u0947 \u0939\u0948\u0902\u0964 \u0905\u0938\u094D\u0935\u0940\u0915\u0943\u0924 \u0926\u093E\u0935\u0947 \u091C\u092E\u093E \u0939\u094B\u0924\u0947 \u0930\u0939\u0924\u0947 \u0939\u0948\u0902\u0964",
        oneplatform: "\u090F\u0915 \u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E, \u0938\u092D\u0940 \u092E\u0949\u0921\u094D\u092F\u0942\u0932",
        platformSubtitle: "\u0921\u0947\u0902\u091F\u0932 \u092A\u094D\u0930\u0948\u0915\u094D\u091F\u093F\u0938 \u0915\u0947 \u0932\u093F\u090F 15 \u090F\u0915\u0940\u0915\u0943\u0924 \u092E\u0949\u0921\u094D\u092F\u0942\u0932",
        clinical: "\u0928\u0948\u0926\u093E\u0928\u093F\u0915",
        operations: "\u0938\u0902\u091A\u093E\u0932\u0928",
        analyticsEnterprise: "\u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923 \u0914\u0930 \u090F\u0902\u091F\u0930\u092A\u094D\u0930\u093E\u0907\u091C\u093C",
        digitalOdontogram: "\u0921\u093F\u091C\u093F\u091F\u0932 \u0913\u0921\u094B\u0928\u094D\u091F\u094B\u0917\u094D\u0930\u093E\u092E",
        digitalOdontogramDetail: "FDI 32 \u0926\u093E\u0902\u0924 \u091A\u093E\u0930\u094D\u091F, 5 \u0938\u0924\u0939 \u091F\u094D\u0930\u0948\u0915\u093F\u0902\u0917\u0964",
        perioCharting: "\u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u091A\u093E\u0930\u094D\u091F\u093F\u0902\u0917",
        perioChartingDetail: "192 \u0938\u094D\u0925\u093E\u0928 \u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u0917\u094D\u0930\u093F\u0921\u0964 6 \u092C\u093F\u0902\u0926\u0941 \u092A\u094D\u0930\u094B\u092C\u093F\u0902\u0917, BOP, CAL\u0964",
        treatmentPlanning: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E",
        treatmentPlanningDetail: "CDT \u0915\u094B\u0921 \u0915\u0947 \u0938\u093E\u0925 \u091A\u0930\u0923\u092C\u0926\u094D\u0927 \u092F\u094B\u091C\u0928\u093E\u090F\u0902, \u092C\u0940\u092E\u093E \u0905\u0928\u0941\u092E\u093E\u0928\u0964 AI \u0938\u0940\u0915\u094D\u0935\u0947\u0902\u0938\u093F\u0902\u0917\u0964",
        soapNotes: "SOAP \u0928\u094B\u091F\u094D\u0938 + AI \u0938\u094D\u0915\u094D\u0930\u093E\u0907\u092C",
        soapNotesDetail: "\u091F\u0947\u092E\u094D\u092A\u0932\u0947\u091F \u0915\u0947 \u0938\u093E\u0925 \u0938\u0902\u0930\u091A\u093F\u0924 \u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0921\u0949\u0915\u094D\u092F\u0942\u092E\u0947\u0902\u091F\u0947\u0936\u0928\u0964 Gemini \u0906\u0935\u093E\u091C\u093C \u0938\u0947 \u0928\u094B\u091F\u094D\u0938 \u092C\u0928\u093E\u0924\u093E \u0939\u0948\u0964",
        multiChairScheduling: "\u092C\u0939\u0941-\u0915\u0941\u0930\u094D\u0938\u0940 \u0936\u0947\u0921\u094D\u092F\u0942\u0932\u093F\u0902\u0917",
        multiChairDetail: "\u0915\u0908 \u0911\u092A\u0930\u0947\u091F\u0930\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u092A\u094D\u0924\u093E\u0939\u093F\u0915 \u0926\u0943\u0936\u094D\u092F\u0964 \u0921\u0949\u0915\u094D\u091F\u0930 \u0930\u0902\u0917 \u0915\u094B\u0921\u093F\u0902\u0917\u0964",
        billingInsurance: "\u092C\u093F\u0932\u093F\u0902\u0917 \u0914\u0930 \u092C\u0940\u092E\u093E",
        billingDetail: "Aldagi, GPI, Imedi L \u0926\u093E\u0935\u093E \u091F\u094D\u0930\u0948\u0915\u093F\u0902\u0917\u0964 \u092E\u0930\u0940\u091C \u0916\u093E\u0924\u093E, \u092D\u0941\u0917\u0924\u093E\u0928 \u092F\u094B\u091C\u0928\u093E\u090F\u0902\u0964",
        ePrescribing: "\u0908-\u092A\u094D\u0930\u093F\u0938\u094D\u0915\u094D\u0930\u093F\u092A\u094D\u0936\u0928",
        ePrescribingDetail: "\u091F\u0947\u092E\u094D\u092A\u0932\u0947\u091F \u0915\u0947 \u0938\u093E\u0925 \u0921\u093F\u091C\u093F\u091F\u0932 \u0928\u0941\u0938\u094D\u0916\u0947\u0964 Gemini \u0926\u0935\u093E \u0907\u0902\u091F\u0930\u0948\u0915\u094D\u0936\u0928 \u091C\u093E\u0902\u091A\u0964",
        labTracking: "\u0932\u0948\u092C \u091F\u094D\u0930\u0948\u0915\u093F\u0902\u0917",
        labTrackingDetail: "\u0915\u093E\u0928\u092C\u093E\u0928: \u0911\u0930\u094D\u0921\u0930 \u2192 \u0928\u093F\u0930\u094D\u092E\u093E\u0923 \u2192 \u0936\u093F\u092A\u092E\u0947\u0902\u091F \u2192 \u092A\u094D\u0930\u093E\u092A\u094D\u0924\u0964",
        productionReports: "\u0909\u0924\u094D\u092A\u093E\u0926\u0928 \u0930\u093F\u092A\u094B\u0930\u094D\u091F",
        productionReportsDetail: "\u0938\u0915\u0932/\u0936\u0941\u0926\u094D\u0927 \u0909\u0924\u094D\u092A\u093E\u0926\u0928, \u0938\u0902\u0917\u094D\u0930\u0939 \u0926\u0930, \u0909\u092A\u091A\u093E\u0930 \u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F\u0964",
        referralMgmt: "\u0930\u0947\u092B\u0930\u0932 \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        referralMgmtDetail: "\u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E\u094B\u0902 \u0915\u094B \u0906\u0928\u0947/\u091C\u093E\u0928\u0947 \u0935\u093E\u0932\u0947 \u0930\u0947\u092B\u0930\u0932\u0964 AI \u091C\u0928\u093F\u0924 \u092A\u0924\u094D\u0930\u0964",
        medicalHistory: "\u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E \u0907\u0924\u093F\u0939\u093E\u0938",
        medicalHistoryDetail: "11 \u0926\u0943\u0936\u094D\u092F \u092E\u0930\u0940\u091C \u0930\u093F\u0915\u0949\u0930\u094D\u0921: \u0938\u092E\u092F\u0930\u0947\u0916\u093E, \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0902, \u0926\u0935\u093E\u0907\u092F\u093E\u0902, \u090F\u0932\u0930\u094D\u091C\u0940\u0964",
        enterpriseAdmin: "\u090F\u0902\u091F\u0930\u092A\u094D\u0930\u093E\u0907\u091C\u093C \u090F\u0921\u092E\u093F\u0928",
        enterpriseAdminDetail: "RBAC, \u0911\u0921\u093F\u091F \u0932\u0949\u0917, \u0905\u0928\u0941\u092A\u093E\u0932\u0928, \u092E\u0932\u094D\u091F\u0940-\u091F\u0947\u0928\u0947\u0902\u0938\u0940, SSO, API \u092A\u094D\u0930\u092C\u0902\u0927\u0928\u0964",
        geminiBuiltIn: "\u0905\u0902\u0924\u0930\u094D\u0928\u093F\u0939\u093F\u0924 Gemini AI",
        geminiSubtitle: "\u0939\u0930 \u092E\u0949\u0921\u094D\u092F\u0942\u0932 Google Gemini 3.1 \u0926\u094D\u0935\u093E\u0930\u093E \u0938\u0902\u091A\u093E\u0932\u093F\u0924",
        xrayAnalysis: "\u090F\u0915\u094D\u0938-\u0930\u0947 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923",
        xrayDetail: "AI \u0915\u0948\u0930\u0940\u091C\u093C \u0921\u093F\u091F\u0947\u0915\u094D\u0936\u0928 \u0915\u0947 \u0932\u093F\u090F \u0921\u0947\u0902\u091F\u0932 \u090F\u0915\u094D\u0938-\u0930\u0947 \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964",
        perioAssessment: "\u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928",
        perioAssessmentDetail: "\u092A\u094D\u0930\u094B\u092C\u093F\u0902\u0917 \u0921\u0947\u091F\u093E \u0938\u0947 \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 AAP \u0938\u094D\u091F\u0947\u091C\u093F\u0902\u0917/\u0917\u094D\u0930\u0947\u0921\u093F\u0902\u0917\u0964",
        clinicalScribe: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0938\u094D\u0915\u094D\u0930\u093E\u0907\u092C",
        clinicalScribeDetail: "\u0935\u0949\u0907\u0938 \u0930\u093F\u0915\u0949\u0930\u094D\u0921\u093F\u0902\u0917 \u092F\u093E \u091A\u093E\u0930\u094D\u091F \u0921\u0947\u091F\u093E \u0938\u0947 SOAP \u0928\u094B\u091F\u094D\u0938 \u091C\u0928\u0930\u0947\u0936\u0928\u0964",
        riskProfiling: "\u091C\u094B\u0916\u093F\u092E \u092A\u094D\u0930\u094B\u092B\u093E\u0907\u0932\u093F\u0902\u0917",
        riskProfilingDetail: "\u0921\u0947\u0902\u091F\u0932 \u0930\u093F\u0938\u094D\u0915 \u092A\u094D\u0930\u094B\u092B\u093E\u0907\u0932 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u094B\u0902, \u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u0907\u0924\u093F\u0939\u093E\u0938 \u0915\u093E \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923\u0964",
        treatmentSequencing: "\u0909\u092A\u091A\u093E\u0930 \u0938\u0940\u0915\u094D\u0935\u0947\u0902\u0938\u093F\u0902\u0917",
        treatmentSequencingDetail: "\u0909\u092A\u091A\u093E\u0930 \u0914\u0930 \u092C\u0940\u092E\u093E \u0915\u094B \u0927\u094D\u092F\u093E\u0928 \u092E\u0947\u0902 \u0930\u0916\u0924\u0947 \u0939\u0941\u090F AI \u0905\u0928\u0941\u0915\u0942\u0932\u093F\u0924 \u0909\u092A\u091A\u093E\u0930 \u091A\u0930\u0923\u0964",
        patientComm: "\u092E\u0930\u0940\u091C \u0938\u0902\u0935\u093E\u0926",
        patientCommDetail: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u0928 \u092E\u0947\u0902 \u092E\u0930\u0940\u091C-\u0905\u0928\u0941\u0915\u0942\u0932 \u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923 \u0915\u093E \u0928\u093F\u0930\u094D\u092E\u093E\u0923\u0964",
        georgianEcosystem: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0907\u0915\u094B\u0938\u093F\u0938\u094D\u091F\u092E \u0924\u0948\u092F\u093E\u0930",
        integrationsSubtitle: "\u0938\u094D\u0925\u093E\u0928\u0940\u092F \u092C\u0940\u092E\u093E, \u092D\u0941\u0917\u0924\u093E\u0928 \u0914\u0930 \u092E\u0948\u0938\u0947\u091C\u093F\u0902\u0917 \u0915\u0947 \u0938\u093E\u0925 \u092A\u0942\u0930\u094D\u0935-\u0928\u093F\u0930\u094D\u092E\u093F\u0924 \u090F\u0915\u0940\u0915\u0930\u0923",
        insurance: "\u092C\u0940\u092E\u093E",
        payments: "\u092D\u0941\u0917\u0924\u093E\u0928",
        messaging: "\u092E\u0948\u0938\u0947\u091C\u093F\u0902\u0917",
        ehrLabs: "EHR \u0914\u0930 \u0932\u0948\u092C",
        clinicsInDb: "\u0921\u0947\u091F\u093E\u092C\u0947\u0938 \u092E\u0947\u0902 \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        platformModules: "\u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E \u092E\u0949\u0921\u094D\u092F\u0942\u0932",
        aiTools: "AI \u0909\u092A\u0915\u0930\u0923 (Gemini)",
        integrations: "\u090F\u0915\u0940\u0915\u0930\u0923",
        pricingTitle: "\u092E\u0942\u0932\u094D\u092F",
        pricingSubtitle: "\u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902, \u092C\u0922\u093C\u0928\u0947 \u092A\u0930 \u0938\u094D\u0915\u0947\u0932 \u0915\u0930\u0947\u0902",
        trustedBy: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915\u094B\u0902 \u0915\u093E \u0935\u093F\u0936\u094D\u0935\u093E\u0938",
        readyModernize: "\u0906\u0927\u0941\u0928\u093F\u0915\u0940\u0915\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F \u0924\u0948\u092F\u093E\u0930?",
        joinCount: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u092E\u0947\u0902 212+ \u0915\u094D\u0932\u0940\u0928\u093F\u0915\u094B\u0902 \u0938\u0947 \u091C\u0941\u0921\u093C\u0947\u0902\u0964",
        startTrial: "\u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902",
        contactSales: "\u092C\u093F\u0915\u094D\u0930\u0940 \u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902",
        noCreditCard: "\u0915\u094D\u0930\u0947\u0921\u093F\u091F \u0915\u093E\u0930\u094D\u0921 \u0906\u0935\u0936\u094D\u092F\u0915 \u0928\u0939\u0940\u0902  \xb7  \u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u092F\u094B\u091C\u0928\u093E  \xb7  5 \u092E\u093F\u0928\u091F \u092E\u0947\u0902 \u0938\u0947\u091F\u0905\u092A",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u0921\u0948\u0936\u092C\u094B\u0930\u094D\u0921",
        navPatients: "\u092E\u0930\u0940\u091C",
        navChart: "\u091A\u093E\u0930\u094D\u091F",
        navPerio: "\u092A\u0947\u0930\u093F\u092F\u094B",
        navTreatmentPlans: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E\u090F\u0902",
        navNotes: "\u0928\u094B\u091F\u094D\u0938",
        navScheduling: "\u0936\u0947\u0921\u094D\u092F\u0942\u0932\u093F\u0902\u0917",
        navBilling: "\u092C\u093F\u0932\u093F\u0902\u0917",
        navPrescriptions: "\u0928\u0941\u0938\u094D\u0916\u0947",
        navLabCases: "\u0932\u0948\u092C \u0915\u0947\u0938",
        navReferrals: "\u0930\u0947\u092B\u0930\u0932",
        navReports: "\u0930\u093F\u092A\u094B\u0930\u094D\u091F",
        navMedHistory: "\u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E \u0907\u0924\u093F\u0939\u093E\u0938",
        navIntegrations: "\u090F\u0915\u0940\u0915\u0930\u0923",
        navEnterprise: "\u090F\u0902\u091F\u0930\u092A\u094D\u0930\u093E\u0907\u091C\u093C",
        sectionClinical: "\u0928\u0948\u0926\u093E\u0928\u093F\u0915",
        sectionOperations: "\u0938\u0902\u091A\u093E\u0932\u0928",
        sectionAnalytics: "\u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923",
        sectionAiTools: "AI \u0909\u092A\u0915\u0930\u0923",
        sectionAdmin: "\u092A\u094D\u0930\u0936\u093E\u0938\u0928",
        // Booking Page
        chooseClinic: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u091A\u0941\u0928\u0947\u0902",
        selectAService: "\u0938\u0947\u0935\u093E \u091A\u0941\u0928\u0947\u0902",
        pickADate: "\u0924\u093E\u0930\u0940\u0916 \u091A\u0941\u0928\u0947\u0902",
        pickATime: "\u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902",
        confirmYourBooking: "\u0905\u092A\u0928\u0940 \u092C\u0941\u0915\u093F\u0902\u0917 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
        clinicLabel: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915:",
        serviceLabel: "\u0938\u0947\u0935\u093E:",
        dateLabel: "\u0924\u093E\u0930\u0940\u0916:",
        timeLabel: "\u0938\u092E\u092F:",
        // AI Page
        send: "\u092D\u0947\u091C\u0947\u0902",
        procedure: "\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E",
        observations: "\u0905\u0935\u0932\u094B\u0915\u0928",
        aiThinking: "AI \u0938\u094B\u091A \u0930\u0939\u093E \u0939\u0948...",
        summarizeHistory: "\u092E\u0930\u0940\u091C \u0915\u093E \u0907\u0924\u093F\u0939\u093E\u0938 \u0938\u093E\u0930\u093E\u0902\u0936\u093F\u0924 \u0915\u0930\u0947\u0902",
        generateTxPlan: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E \u092C\u0928\u093E\u090F\u0902",
        checkDrugInteractions: "\u0926\u0935\u093E \u0907\u0902\u091F\u0930\u0948\u0915\u094D\u0936\u0928 \u091C\u093E\u0902\u091A\u0947\u0902",
        writeClinicalNote: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F \u0932\u093F\u0916\u0947\u0902",
        askAiAssistant: "AI \u0938\u0939\u093E\u092F\u0915 \u0938\u0947 \u092A\u0942\u091B\u0947\u0902...",
        dropXray: "\u090F\u0915\u094D\u0938-\u0930\u0947 \u091B\u0935\u093F \u0921\u093E\u0932\u0947\u0902 \u092F\u093E \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902",
        supportsFormats: "DICOM, PNG, JPG \u0938\u092E\u0930\u094D\u0925\u093F\u0924",
        analysisResults: "\u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923 \u092A\u0930\u093F\u0923\u093E\u092E (\u0921\u0947\u092E\u094B)",
        aiRecommendation: "AI \u0938\u093F\u092B\u093E\u0930\u093F\u0936",
        exportToTxPlan: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E \u092E\u0947\u0902 \u0928\u093F\u0930\u094D\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        generateClinicalNote: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F \u092C\u0928\u093E\u090F\u0902",
        generatedSoap: "\u091C\u0928\u0930\u0947\u091F \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F (SOAP)",
        subjective: "S \u2014 \u0935\u094D\u092F\u0915\u094D\u0924\u093F\u092A\u0930\u0915",
        objective: "O \u2014 \u0935\u0938\u094D\u0924\u0941\u0928\u093F\u0937\u094D\u0920",
        assessment: "A \u2014 \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928",
        plan: "P \u2014 \u092F\u094B\u091C\u0928\u093E",
        copyToRecord: "\u092E\u0930\u0940\u091C \u0915\u0947 \u0930\u093F\u0915\u0949\u0930\u094D\u0921 \u092E\u0947\u0902 \u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902",
        aiPerioAssessment: "AI \u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928",
        enterProbingData: "AAP \u0938\u094D\u091F\u0947\u091C\u093F\u0902\u0917/\u0917\u094D\u0930\u0947\u0921\u093F\u0902\u0917 \u0914\u0930 \u0909\u092A\u091A\u093E\u0930 \u0938\u093F\u092B\u093E\u0930\u093F\u0936\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u094B\u092C\u093F\u0902\u0917 \u0921\u0947\u091F\u093E \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964",
        analyzeWithGemini: "Gemini \u0938\u0947 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923 \u0915\u0930\u0947\u0902",
        aiRiskAssessment: "AI \u091C\u094B\u0916\u093F\u092E \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928",
        enterConditions: "\u091C\u094B\u0916\u093F\u092E \u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932 \u092C\u0928\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092E\u0930\u0940\u091C \u0915\u0940 \u0938\u094D\u0925\u093F\u0924\u093F, \u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u0907\u0924\u093F\u0939\u093E\u0938 \u0914\u0930 \u0935\u093E\u0907\u091F\u0932 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964",
        generateRiskProfile: "\u091C\u094B\u0916\u093F\u092E \u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932 \u092C\u0928\u093E\u090F\u0902",
        patientCommunication: "\u092E\u0930\u0940\u091C \u0938\u0902\u0935\u093E\u0926",
        generateExplanations: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u0928 \u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092E\u0930\u0940\u091C-\u0905\u0928\u0941\u0915\u0942\u0932 \u0909\u092A\u091A\u093E\u0930 \u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923 \u092C\u0928\u093E\u090F\u0902\u0964",
        generateExplanation: "\u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923 \u092C\u0928\u093E\u090F\u0902",
        patientFriendly: "\u092E\u0930\u0940\u091C-\u0905\u0928\u0941\u0915\u0942\u0932 \u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923",
        // Billing Page
        claims: "\u0926\u093E\u0935\u0947",
        ledger: "\u0916\u093E\u0924\u093E \u092C\u0939\u0940",
        aging: "\u090F\u091C\u093F\u0902\u0917",
        paymentPlans: "\u092D\u0941\u0917\u0924\u093E\u0928 \u092F\u094B\u091C\u0928\u093E\u090F\u0902",
        eligibility: "\u092A\u093E\u0924\u094D\u0930\u0924\u093E",
        allFilter: "\u0938\u092D\u0940",
        submitted: "\u092A\u094D\u0930\u0938\u094D\u0924\u0941\u0924",
        paid: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0939\u0941\u0906",
        denied: "\u0905\u0938\u094D\u0935\u0940\u0915\u0943\u0924",
        patientLedger: "\u092E\u0930\u0940\u091C \u0916\u093E\u0924\u093E \u092C\u0939\u0940",
        agedAccounts: "\u0905\u0924\u093F\u0926\u0947\u092F \u0916\u093E\u0924\u0947",
        sendStatements: "\u0935\u093F\u0935\u0930\u0923 \u092D\u0947\u091C\u0947\u0902",
        activePaymentPlans: "\u0938\u0915\u094D\u0930\u093F\u092F \u092D\u0941\u0917\u0924\u093E\u0928 \u092F\u094B\u091C\u0928\u093E\u090F\u0902",
        insuranceEligibility: "\u092C\u0940\u092E\u093E \u092A\u093E\u0924\u094D\u0930\u0924\u093E",
        // Clinical Charting
        odontogram: "\u0913\u0921\u094B\u0928\u094D\u091F\u094B\u0917\u094D\u0930\u093E\u092E",
        perioTab: "\u092A\u0947\u0930\u093F\u092F\u094B",
        treatmentPlanTab: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E",
        notesTab: "\u0928\u094B\u091F\u094D\u0938",
        progressNotes: "\u092A\u094D\u0930\u0917\u0924\u093F \u0928\u094B\u091F\u094D\u0938",
        openFullPerio: "\u092A\u0942\u0930\u094D\u0923 \u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u091A\u093E\u0930\u094D\u091F \u0916\u094B\u0932\u0947\u0902 \u2192",
        openFullTxPlanner: "\u092A\u0942\u0930\u094D\u0923 \u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E\u0915\u093E\u0930 \u0916\u094B\u0932\u0947\u0902 \u2192",
        openClinicalNotes: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F\u094D\u0938 \u0916\u094B\u0932\u0947\u0902 \u2192",
        newExam: "\u0928\u0908 \u092A\u0930\u0940\u0915\u094D\u0937\u093E",
        voiceEntry: "\u0935\u0949\u0907\u0938 \u090F\u0902\u091F\u094D\u0930\u0940",
        bleedingIndex: "\u0930\u0915\u094D\u0924\u0938\u094D\u0930\u093E\u0935 \u0938\u0942\u091A\u0915\u093E\u0902\u0915",
        plaqueIndex: "\u092A\u094D\u0932\u093E\u0915 \u0938\u0942\u091A\u0915\u093E\u0902\u0915",
        sitesAbove4: "\u0938\u094D\u0925\u093E\u0928 \u2265 4\u092E\u093F\u092E\u0940",
        sitesAbove6: "\u0938\u094D\u0925\u093E\u0928 \u2265 6\u092E\u093F\u092E\u0940",
        planA: "\u092F\u094B\u091C\u0928\u093E A: \u0905\u0928\u0941\u0936\u0902\u0938\u093F\u0924",
        planB: "\u092F\u094B\u091C\u0928\u093E B: \u0930\u0942\u0922\u093C\u093F\u0935\u093E\u0926\u0940",
        newPlan: "+ \u0928\u0908 \u092F\u094B\u091C\u0928\u093E",
        presentToPatient: "\u092E\u0930\u0940\u091C \u0915\u094B \u092A\u094D\u0930\u0938\u094D\u0924\u0941\u0924 \u0915\u0930\u0947\u0902",
        sendToPortal: "\u092A\u094B\u0930\u094D\u091F\u0932 \u092A\u0930 \u092D\u0947\u091C\u0947\u0902",
        totalFee: "\u0915\u0941\u0932 \u0936\u0941\u0932\u094D\u0915",
        insuranceEst: "\u092C\u0940\u092E\u093E \u0905\u0928\u0941\u092E\u093E\u0928",
        patientPortion: "\u092E\u0930\u0940\u091C \u0915\u093E \u0939\u093F\u0938\u094D\u0938\u093E",
        chairSideMode: "\u091A\u0947\u092F\u0930-\u0938\u093E\u0907\u0921 \u092E\u094B\u0921",
        adminMode: "\u090F\u0921\u092E\u093F\u0928 \u092E\u094B\u0921",
        proceduresAcrossPhases: "{1} \u091A\u0930\u0923\u094B\u0902 \u092E\u0947\u0902 {0} \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E\u090F\u0902",
        // Scheduling
        day: "\u0926\u093F\u0928",
        week: "\u0938\u092A\u094D\u0924\u093E\u0939",
        today: "\u0906\u091C",
        providerFilter: "\u0938\u092D\u0940 \u092A\u094D\u0930\u0926\u093E\u0924\u093E",
        productionGoal: "\u0909\u0924\u094D\u092A\u093E\u0926\u0928 \u0932\u0915\u094D\u0937\u094D\u092F",
        waitlist: "\u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u0938\u0942\u091A\u0940",
        // Prescriptions
        activeRx: "\u0938\u0915\u094D\u0930\u093F\u092F",
        pastRx: "\u092A\u093F\u091B\u0932\u0947",
        templates: "\u091F\u0947\u092E\u094D\u092A\u0932\u0947\u091F",
        interactionCheck: "\u0907\u0902\u091F\u0930\u0948\u0915\u094D\u0936\u0928 \u091C\u093E\u0902\u091A",
        // Lab Cases
        ordered: "\u0911\u0930\u094D\u0921\u0930 \u0915\u093F\u092F\u093E",
        sentToLab: "\u0932\u0948\u092C \u0915\u094B \u092D\u0947\u091C\u093E",
        inFabrication: "\u0928\u093F\u0930\u094D\u092E\u093E\u0923 \u092E\u0947\u0902",
        shipped: "\u092D\u0947\u091C \u0926\u093F\u092F\u093E",
        received: "\u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0939\u0941\u0906",
        labVendors: "\u0932\u0948\u092C \u0935\u093F\u0915\u094D\u0930\u0947\u0924\u093E",
        // Referrals
        allDirections: "\u0938\u092D\u0940",
        inbound: "\u0906\u0928\u0947 \u0935\u093E\u0932\u0947",
        outbound: "\u091C\u093E\u0928\u0947 \u0935\u093E\u0932\u0947",
        generateLetter: "\u092A\u0924\u094D\u0930 \u092C\u0928\u093E\u090F\u0902",
        // Reports
        production: "\u0909\u0924\u094D\u092A\u093E\u0926\u0928",
        collections: "\u0938\u0902\u0917\u094D\u0930\u0939",
        schedulingReport: "\u0936\u0947\u0921\u094D\u092F\u0942\u0932\u093F\u0902\u0917",
        treatmentAcceptance: "\u0909\u092A\u091A\u093E\u0930 \u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F",
        recall: "\u0930\u093F\u0915\u0949\u0932",
        grossProduction: "\u0938\u0915\u0932 \u0909\u0924\u094D\u092A\u093E\u0926\u0928",
        netProduction: "\u0936\u0941\u0926\u094D\u0927 \u0909\u0924\u094D\u092A\u093E\u0926\u0928",
        collectionRate: "\u0938\u0902\u0917\u094D\u0930\u0939 \u0926\u0930",
        plansPresented: "\u092A\u094D\u0930\u0938\u094D\u0924\u0941\u0924 \u092F\u094B\u091C\u0928\u093E\u090F\u0902",
        accepted: "\u0938\u094D\u0935\u0940\u0915\u0943\u0924",
        acceptanceRate: "\u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F \u0926\u0930",
        dueThisMonth: "\u0907\u0938 \u092E\u0939\u0940\u0928\u0947 \u0926\u0947\u092F",
        scheduled: "\u0928\u093F\u0930\u094D\u0927\u093E\u0930\u093F\u0924",
        completed: "\u092A\u0942\u0930\u094D\u0923",
        overdue: "\u0905\u0924\u093F\u0926\u0947\u092F",
        reactivationRate: "\u092A\u0941\u0928\u0930\u094D\u0938\u0915\u094D\u0930\u093F\u092F\u0923 \u0926\u0930",
        // Medical History
        timeline: "\u0938\u092E\u092F\u0930\u0947\u0916\u093E",
        conditions: "\u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0902",
        medications: "\u0926\u0935\u093E\u0907\u092F\u093E\u0902",
        allergies: "\u090F\u0932\u0930\u094D\u091C\u0940",
        labResults: "\u0932\u0948\u092C \u092A\u0930\u093F\u0923\u093E\u092E",
        vitals: "\u0935\u093E\u0907\u091F\u0932\u094D\u0938",
        immunizations: "\u091F\u0940\u0915\u093E\u0915\u0930\u0923",
        familyHistory: "\u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u0907\u0924\u093F\u0939\u093E\u0938",
        imaging: "\u0907\u092E\u0947\u091C\u093F\u0902\u0917",
        documents: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u0911\u0921\u093F\u091F \u0932\u0949\u0917",
        compliance: "\u0905\u0928\u0941\u092A\u093E\u0932\u0928",
        multiTenancy: "\u092E\u0932\u094D\u091F\u0940-\u091F\u0947\u0928\u0947\u0902\u0938\u0940",
        sso: "SSO \u0914\u0930 \u0938\u0941\u0930\u0915\u094D\u0937\u093E",
        featureFlags: "\u092B\u093C\u0940\u091A\u0930 \u092B\u093C\u094D\u0932\u0948\u0917",
        apiManagement: "API \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        dataManagement: "\u0921\u0947\u091F\u093E \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        // Integrations
        ehr: 'EHR',
        labs: "\u0932\u0948\u092C",
        telehealth: "\u091F\u0947\u0932\u0940\u0939\u0947\u0932\u094D\u0925",
        aiMl: 'AI/ML',
        wearables: "\u092A\u0939\u0928\u0928\u0947 \u092F\u094B\u0917\u094D\u092F",
        connected: "\u091C\u0941\u0921\u093C\u093E \u0939\u0941\u0906",
        disconnected: "\u0921\u093F\u0938\u094D\u0915\u0928\u0947\u0915\u094D\u091F",
        available: "\u0909\u092A\u0932\u092C\u094D\u0927",
        // Components
        status: "\u0938\u094D\u0925\u093F\u0924\u093F",
        healthy: "\u0938\u094D\u0935\u0938\u094D\u0925",
        caries: "\u0915\u0948\u0930\u0940\u091C\u093C",
        restored: "\u092A\u0941\u0928\u0930\u094D\u0938\u094D\u0925\u093E\u092A\u093F\u0924",
        missing: "\u0905\u0928\u0941\u092A\u0938\u094D\u0925\u093F\u0924",
        implant: "\u0907\u092E\u094D\u092A\u094D\u0932\u093E\u0902\u091F",
        crownStatus: "\u0915\u094D\u0930\u093E\u0909\u0928",
        bridge: "\u092C\u094D\u0930\u093F\u091C",
        veneer: "\u0935\u0940\u0928\u093F\u092F\u0930",
        surfaces: "\u0938\u0924\u0939\u0947\u0902",
        procedureHistory: "\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0907\u0924\u093F\u0939\u093E\u0938",
        addProcedure: "\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u091C\u094B\u0921\u093C\u0947\u0902",
        totalCharged: "\u0915\u0941\u0932 \u091A\u093E\u0930\u094D\u091C",
        insurancePayment: "\u092C\u0940\u092E\u093E \u092D\u0941\u0917\u0924\u093E\u0928",
        patientResponsibility: "\u092E\u0930\u0940\u091C \u0915\u0940 \u091C\u093F\u092E\u094D\u092E\u0947\u0926\u093E\u0930\u0940",
        expand: "\u0935\u093F\u0938\u094D\u0924\u093E\u0930 \u0915\u0930\u0947\u0902",
        policyNumber: "\u092A\u0949\u0932\u093F\u0938\u0940 #",
        planType: "\u092F\u094B\u091C\u0928\u093E \u092A\u094D\u0930\u0915\u093E\u0930",
        annualMax: "\u0935\u093E\u0930\u094D\u0937\u093F\u0915 \u0905\u0927\u093F\u0915\u0924\u092E",
        used: "\u0909\u092A\u092F\u094B\u0917 \u0915\u093F\u092F\u093E",
        remaining: "\u0936\u0947\u0937",
        coverageByCategory: "\u0936\u094D\u0930\u0947\u0923\u0940 \u0915\u0947 \u0905\u0928\u0941\u0938\u093E\u0930 \u0915\u0935\u0930\u0947\u091C",
        preventive: "\u0928\u093F\u0935\u093E\u0930\u0915",
        basic: "\u092C\u0941\u0928\u093F\u092F\u093E\u0926\u0940",
        major: "\u092A\u094D\u0930\u092E\u0941\u0916",
        ortho: "\u0911\u0930\u094D\u0925\u094B",
        current: "\u0935\u0930\u094D\u0924\u092E\u093E\u0928",
        thirtyDay: "30 \u0926\u093F\u0928",
        sixtyDay: "60 \u0926\u093F\u0928",
        ninetyPlus: "90+ \u0926\u093F\u0928",
        totalBalance: "\u0915\u0941\u0932 \u0936\u0947\u0937",
        monthlyPayment: "\u092E\u093E\u0938\u093F\u0915 \u092D\u0941\u0917\u0924\u093E\u0928",
        paymentsRemaining: "\u0936\u0947\u0937 \u092D\u0941\u0917\u0924\u093E\u0928",
        nextPayment: "\u0905\u0917\u0932\u093E \u092D\u0941\u0917\u0924\u093E\u0928",
        paymentProgress: "\u092D\u0941\u0917\u0924\u093E\u0928 \u092A\u094D\u0930\u0917\u0924\u093F",
        choosePlan: "\u092F\u094B\u091C\u0928\u093E \u091A\u0941\u0928\u0947\u0902",
        aiInsight: "AI \u0905\u0902\u0924\u0930\u094D\u0926\u0943\u0937\u094D\u091F\u093F",
        confidence: "\u0935\u093F\u0936\u094D\u0935\u093E\u0938",
        revoke: "\u0930\u0926\u094D\u0926 \u0915\u0930\u0947\u0902",
        exams: "\u092A\u0930\u0940\u0915\u094D\u0937\u093E\u090F\u0902",
        phaseTotal: "\u091A\u0930\u0923 \u0915\u0941\u0932",
        mon: "\u0938\u094B\u092E",
        tue: "\u092E\u0902\u0917\u0932",
        wed: "\u092C\u0941\u0927",
        thu: "\u0917\u0941\u0930\u0941",
        fri: "\u0936\u0941\u0915\u094D\u0930",
        sat: "\u0936\u0928\u093F",
        sun: "\u0930\u0935\u093F",
        thinking: "\u0938\u094B\u091A \u0930\u0939\u093E \u0939\u0948...",
        followUpPlaceholder: "\u0905\u0928\u0941\u0935\u0930\u094D\u0924\u0940 \u092A\u094D\u0930\u0936\u094D\u0928 \u092A\u0942\u091B\u0947\u0902...",
        priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
        patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
        tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
        chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
        english: 'English',
        patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
        xrayAnalysis2: 'X-ray Analysis',
        uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment2: 'Perio Assessment',
        automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe2: 'Clinical Scribe',
        generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling2: 'Risk Profiling',
        analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing2: 'Treatment Sequencing',
        aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientCommunication2: 'Patient Communication',
        generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        insurance2: 'INSURANCE',
        automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
        payments2: 'PAYMENTS',
        onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
        messaging2: 'MESSAGING',
        appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
        ehrLabs2: 'EHR & LABS',
        interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
        clinicsInDatabase: 'Clinics in Database',
        platformModules2: 'Platform Modules',
        integrations2: 'Integrations',
        home2: 'Home',
        features2: 'Features',
        pricing2: 'Pricing',
        dashboard2: 'Dashboard',
        u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
        openFullPeriodontalChart: "Open Full Periodontal Chart \u2192",
        openFullTreatmentPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes2: "Open Clinical Notes \u2192",
        backToAllClinics: "\u2190 Back to all clinics",
        priceRange2: 'Price range:',
        bookAnAppointment: 'Book an Appointment',
        selectDate2: 'Select date',
        selectTime2: 'Select time',
        confirmBooking2: "Confirm Booking \u2192",
        clinics: 'Clinics',
        forBusiness2: 'For Business',
        u00a92026Mcai: '\u00A9 2026 MCAI',
        clinicalNotes: 'Clinical Notes',
        newNote: '+ New Note',
        template: 'Template:',
        crownPrep: 'Crown Prep',
        aiScribe: 'AI Scribe',
        recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
        startRecording: 'Start Recording',
        generateNote: 'Generate Note',
        general: 'General',
        prosthetics: 'Prosthetics',
        typeToSearch: 'Type to search dental terms...',
        revenueToday: 'Revenue Today',
        noshows: 'No-shows',
        confirmed: 'Confirmed',
        time: 'TIME',
        patient: 'PATIENT',
        service: 'SERVICE',
        doctor: 'DOCTOR',
        status2: 'STATUS',
        addPatient: '+ Add Patient',
        mondayMarch19: 'Monday, March 19',
        gBeridzeCheckup: "G. Beridze \u2014 Checkup",
        nKapanadzeWhitening: "N. Kapanadze \u2014 Whitening",
        dGelashviliImplantPhase: "D. Gelashvili \u2014 Implant Phase 2",
        lunchBreak: "\u2014 Lunch Break \u2014",
        mTsiklauriOrthodontics: "M. Tsiklauri \u2014 Orthodontics",
        aJavakhishviliRootCanal: "A. Javakhishvili \u2014 Root Canal",
        lMchedlishviliExtraction: "L. Mchedlishvili \u2014 Extraction",
        tLomidzeCheckup: "T. Lomidze \u2014 Checkup",
        clinicName: 'Clinic Name',
        phone: 'Phone',
        address: 'Address',
        acceptedInsurance: 'Accepted Insurance',
        unison: 'Unison',
        saveSettings: 'Save Settings',
        aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
        openTheFullAi: "Open the full AI Assistant \u2192",
        enterprise: 'Enterprise',
        rolebasedAccessControl: 'Role-Based Access Control',
        permissionMatrix: 'Permission Matrix',
        module: 'Module',
        admin: 'Admin',
        doctor2: 'Doctor',
        hygienist: 'Hygienist',
        reception: 'Reception',
        lab: 'Lab',
        patient2: 'Patient',
        patients: 'Patients',
        full: 'Full',
        read: 'Read',
        none: 'None',
        own: 'Own',
        billing: 'Billing',
        scheduling: 'Scheduling',
        reports: 'Reports',
        settings: 'Settings',
        labOrders: 'Lab Orders',
        auditLog2: 'Audit Log',
        allTypes: 'All Types',
        last7Days: 'Last 7 days',
        complianceDashboard: 'Compliance Dashboard',
        complianceChecklist: 'Compliance Checklist',
        pass: 'PASS',
        dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
        dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
        mfaEnabledForAll: 'MFA enabled for all admin accounts',
        warn: 'WARN',
        dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
        auditLoggingActiveOn: 'Audit logging active on all modules',
        multitenancyManagement: 'Multi-Tenancy Management',
        singleSignonSso: 'Single Sign-On (SSO)',
        saml20: 'SAML 2.0',
        enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
        configured: 'Configured',
        openidConnect: 'OpenID Connect',
        oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
        available2: 'Available',
        signInWithGoogle: 'Sign in with Google organization accounts',
        connected2: 'Connected',
        azureAd: 'Azure AD',
        microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
        featureFlags2: 'Feature Flags',
        aixrayanalysis: 'ai_xray_analysis',
        aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
        voiceperio: 'voice_perio',
        voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
        patientportalv2: 'patient_portal_v2',
        nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
        whatsappreminders: 'whatsapp_reminders',
        multilanguage: 'multi_language',
        multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
        apiManagement2: 'API Management',
        requests24h: 'Requests (24h)',
        avgLatency: 'Avg Latency',
        uptime: 'Uptime',
        apiKeys: 'API Keys',
        dataManagement2: 'Data Management',
        storageUsed: 'Storage Used',
        of100Gb: 'of 100 GB',
        totalRecords: 'Total Records',
        lastBackup: 'Last Backup',
        nextIn4h: 'Next: in 4h',
        dataOperations: 'Data Operations',
        exportAllData: 'Export All Data',
        downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
        export: 'Export',
        purgeOldRecords: 'Purge Old Records',
        removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
        purge: 'Purge',
        dataMigration: 'Data Migration',
        importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
        import: 'Import',
        finance: 'Finance',
        revenueInvoicesPayments: 'Revenue, invoices & payments',
        exportReport: 'Export Report',
        monthlyRevenue: 'Monthly Revenue',
        u20be12400: '\u20BE12,400',
        pending: 'Pending',
        u20be2100: '\u20BE2,100',
        str208: '-5%',
        thisWeek: 'This Week',
        u20be3800: '\u20BE3,800',
        weeklyRevenue: 'Weekly Revenue',
        mon2: 'Mon',
        tue2: 'Tue',
        wed2: 'Wed',
        thu2: 'Thu',
        fri2: 'Fri',
        sat2: 'Sat',
        invoice: 'INVOICE',
        amount: 'AMOUNT',
        inv001: 'INV-001',
        giorgiBeridze: 'Giorgi Beridze',
        checkupXray: 'Checkup + X-ray',
        u20be80: '\u20BE80',
        inv002: 'INV-002',
        ninoKapanadze: 'Nino Kapanadze',
        whitening: 'Whitening',
        u20be120: '\u20BE120',
        inv003: 'INV-003',
        davitGelashvili: 'Davit Gelashvili',
        implantPhase1: 'Implant Phase 1',
        u20be300: '\u20BE300+',
        inv004: 'INV-004',
        anaJavakhishvili: 'Ana Javakhishvili',
        rootCanal: 'Root Canal',
        u20be149: '\u20BE149',
        u2715: '\u2715',
        configuration: 'Configuration',
        apiKey: 'API Key',
        endpointUrl: 'Endpoint URL',
        protocol: 'Protocol',
        syncSettings: 'Sync Settings',
        syncFrequency: 'Sync Frequency',
        every5Minutes: 'Every 5 minutes',
        every15Minutes: 'Every 15 minutes',
        everyHour: 'Every hour',
        manualOnly: 'Manual only',
        autosyncOnChanges: 'Auto-sync on changes',
        lastSynced: 'Last synced',
        disconnect: 'Disconnect',
        testConnection: 'Test Connection',
        labCasePipeline: 'Lab Case Pipeline',
        labVendors2: 'Lab Vendors',
        tbilisidentLab: 'TbilisiDent Lab',
        turnaround710Days: 'Turnaround: 7-10 days',
        rating485: 'Rating: 4.8/5',
        activeCases4: 'Active Cases: 4',
        caucasusDentalLab: 'Caucasus Dental Lab',
        turnaround57Days: 'Turnaround: 5-7 days',
        rating465: 'Rating: 4.6/5',
        activeCases2: 'Active Cases: 2',
        euroDentalGeorgia: 'Euro Dental Georgia',
        turnaround1014Days: 'Turnaround: 10-14 days',
        rating445: 'Rating: 4.4/5',
        enterSpaceForClinics: "Enter space for clinics \u2192",
        book: 'Book',
        followupConsultation: 'Follow-up Consultation',
        postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
        rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
        completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
        periapicalXray: 'Periapical X-ray',
        workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
        medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
        prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
        diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
        patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
        compositeFillingTooth21: 'Composite Filling - Tooth #21',
        classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
        labResultsCbcPanel: 'Lab Results: CBC Panel',
        completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
        fullmouthRadiographs: 'Full-mouth Radiographs',
        panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
        comprehensiveExamination: 'Comprehensive Examination',
        initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
        medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
        patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
        patientRegistration: 'Patient Registration',
        newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
        activeConditions: 'Active Conditions',
        chronicPeriodontitis: 'Chronic Periodontitis',
        active: 'Active',
        generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
        onsetJan2026: 'Onset: Jan 2026',
        dentalCaries: 'Dental Caries',
        resolved: 'Resolved',
        cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
        resolvedFeb2026: 'Resolved: Feb 2026',
        bruxism: 'Bruxism',
        nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
        activeMedications: 'Active Medications',
        lisinopril10mg: 'Lisinopril 10mg',
        onceDailyOral: 'Once daily, oral',
        hypertensionManagement: 'Hypertension management',
        chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
        twiceDailyOralRinse: 'Twice daily, oral rinse',
        periodontalMaintenance: 'Periodontal maintenance',
        ibuprofen400mg: 'Ibuprofen 400mg',
        asNeededForPain: 'As needed for pain, max 3x daily',
        postprocedurePainManagement: 'Post-procedure pain management',
        pastMedications: 'Past Medications',
        amoxicillin500mg: 'Amoxicillin 500mg',
        periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
        completed2: 'Completed',
        metronidazole250mg: 'Metronidazole 250mg',
        adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
        paracetamol500mg: 'Paracetamol 500mg',
        asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
        postfillingSensitivity: 'Post-filling sensitivity',
        diclofenac50mg: 'Diclofenac 50mg',
        twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
        postexamSoreness: 'Post-exam soreness',
        documentedAllergies: 'Documented Allergies',
        penicillin: 'Penicillin',
        severe: 'SEVERE',
        reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
        crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
        documentedJan102026: 'Documented: Jan 10, 2026',
        latex: 'Latex',
        moderate: 'MODERATE',
        reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
        useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
        lidocaine: 'Lidocaine',
        mild: 'MILD',
        reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
        useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
        latestVitalsMar15: "Latest Vitals \u2014 Mar 15, 2026",
        labResults2: 'Lab Results',
        test: 'TEST',
        result: 'RESULT',
        reference: 'REFERENCE',
        date: 'DATE',
        hemoglobin: 'Hemoglobin',
        platelets: 'Platelets',
        glucoseFasting: 'Glucose (fasting)',
        immunizationRecords: 'Immunization Records',
        hepatitisB: 'Hepatitis B',
        completed3doseSeries2019: 'Completed: 3-dose series, 2019',
        upToDate: 'Up to date',
        tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
        lastBooster2022: 'Last booster: 2022',
        covid19: 'COVID-19',
        lastDoseSep2024: 'Last dose: Sep 2024',
        dueForBooster: 'Due for booster',
        familyMedicalHistory: 'Family Medical History',
        father: 'Father',
        hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
        mother: 'Mother',
        osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
        sibling: 'Sibling',
        bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
        imagingRecords: 'Imaging Records',
        panoramicOpg: 'Panoramic OPG',
        periapical14: 'Periapical #14',
        bitewingRl: 'Bitewing R+L',
        patientDocuments: 'Patient Documents',
        consentFormRootCanal: 'Consent Form - Root Canal',
        treatmentPlanAgreement: 'Treatment Plan Agreement',
        medicalHistoryQuestionnaire: 'Medical History Questionnaire',
        insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
        insuranceInformation: 'Insurance Information',
        provider: 'Provider:',
        policy: 'Policy #:',
        group: 'Group:',
        corporatePlanPremium: 'Corporate Plan - Premium',
        coverage: 'Coverage:',
        deductible: 'Deductible:',
        annualMax2: 'Annual Max:',
        valid: 'Valid:',
        age34: 'Age: 34',
        lastVisitMar10: 'Last visit: Mar 10',
        nextMar19: 'Next: Mar 19',
        overview: 'Overview',
        dentalChart: 'Dental Chart',
        treatmentPlan: 'Treatment Plan',
        history: 'History',
        documents2: 'Documents',
        allergies2: 'Allergies',
        medicalNotes: 'Medical Notes',
        insurance3: 'Insurance',
        upperArch: 'Upper Arch',
        lowerArch: 'Lower Arch',
        tooth: 'TOOTH',
        procedure2: 'PROCEDURE',
        price: 'PRICE',
        rootCanalTreatment: 'Root Canal Treatment',
        ceramicCrown: 'Ceramic Crown',
        compositeFilling: 'Composite Filling',
        implantPlacement: 'Implant Placement',
        total: 'Total',
        addProcedure2: '+ Add Procedure',
        march102026: 'March 10, 2026',
        periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
        february152026: 'February 15, 2026',
        compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
        january202026: 'January 20, 2026',
        comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
        bitewingRight: 'Bitewing Right',
        bitewingLeft: 'Bitewing Left',
        uploadDocument: '+ Upload Document',
        all: 'All',
        new: 'New',
        phone2: 'PHONE',
        lastVisit: 'LAST VISIT',
        nextAppt: 'NEXT APPT',
        balance: 'BALANCE',
        pt001: 'PT-001',
        pt002: 'PT-002',
        pt003: 'PT-003',
        mariamTsiklauri: 'Mariam Tsiklauri',
        pt004: 'PT-004',
        pt005: 'PT-005',
        lukaMchedlishvili: 'Luka Mchedlishvili',
        pt006: 'PT-006',
        tamtaLomidze: 'Tamta Lomidze',
        pt007: 'PT-007',
        periodontalChart: 'Periodontal Chart',
        newExam2: '+ New Exam',
        voiceEntry2: 'Voice Entry',
        dcai: 'DCAI',
        dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
        theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
        manage: 'Manage',
        grow: 'Grow',
        marketSize: 'Market Size',
        dentalClinicsInGeorgia: 'dental clinics in Georgia',
        inTbilisiAlone: 'in Tbilisi alone',
        unifiedBookingOrOps: 'unified booking or ops platforms',
        dentosgeIsTheOnly: "\u26A0\uFE0F  dentos.ge is the only partial incumbent \u2014 no full ops layer",
        theProblem2: 'The Problem',
        str511: "\uD83D\uDCCB",
        clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
        noStructuredWorkflowConstant: 'No structured workflow, constant human error',
        str514: "\uD83D\uDCC9",
        noshowsCost1525Of: "No-shows cost 15\u201325% of revenue",
        noAutomatedRemindersOr: 'No automated reminders or confirmation system',
        str517: "\uD83C\uDFE6",
        insuranceBillingIsManual: 'Insurance billing is manual and painful',
        str519: "\uD83D\uDCF5",
        dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
        theSolution: 'The Solution',
        str523: "\uD83D\uDCC5",
        onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
        patientsBook247From: 'Patients book 24/7 from any device',
        str526: "\uD83E\uDDB7",
        patientRecordsTreatmentManagem: 'Patient records & treatment management',
        fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
        str529: "\uD83C\uDFE5",
        insuranceIntegrations: 'Insurance integrations',
        str531: "\uD83D\uDCAC",
        smsWhatsappReminders: 'SMS / WhatsApp reminders',
        cutNoshowsByUp: 'Cut no-shows by up to 40%',
        str534: "\uD83D\uDCCA",
        financialReportingDashboard: 'Financial reporting dashboard',
        revenueSalariesExpensesRealtim: "Revenue, salaries, expenses \u2014 realtime",
        willingnessToPay: 'Willingness to Pay',
        free: 'Free',
        month: '/month',
        listingBookingWidget: 'Listing + booking widget',
        growth: 'Growth',
        calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
        pro: 'Pro',
        fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
        multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
        wtp0515OfMonthly: "\uD83D\uDCA1 WTP: 0.5\u20131.5% of monthly revenue \u2014 clinics earning \u20BE15K\u201350K/mo pay \u20BE100\u2013350/mo comfortably",
        marketOpportunity: 'Market Opportunity',
        addressableClinicsAtLaunch: 'addressable clinics at launch',
        mrrAtFullPenetration: "MRR at full penetration (\u20BE49 avg)",
        home: "\u0939\u094B\u092E",
        features: "\u0935\u093F\u0936\u0947\u0937\u0924\u093E\u090F\u0902",
        pricing: "\u092E\u0942\u0932\u094D\u092F",
        clinicsNav: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        aiAssistant: "AI \u0938\u0939\u093E\u092F\u0915",
        forBusiness: "\u0935\u094D\u092F\u093E\u092A\u093E\u0930 \u0915\u0947 \u0932\u093F\u090F",
        dashboard: "\u0921\u0948\u0936\u092C\u094B\u0930\u094D\u0921",
        getStarted: "\u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902",
        tryDemo: "\u0921\u0947\u092E\u094B \u0906\u091C\u093C\u092E\u093E\u090F\u0902",
        heroTagline: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u0915\u0947 \u0932\u093F\u090F \u0921\u0947\u0902\u091F\u0932 \u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E",
        heroTitle: "\u0938\u092D\u0940 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0939\u092C",
        heroSubtitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u092E\u0947\u0902 \u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u0926\u0902\u0924 \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E \u0916\u094B\u091C\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0906\u092A\u0915\u093E AI \u0938\u0939\u093E\u092F\u0915",
        searchPlaceholder: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915, \u0938\u0947\u0935\u093E\u090F\u0902 \u0916\u094B\u091C\u0947\u0902 \u092F\u093E \u0915\u0941\u091B \u092A\u0942\u091B\u0947\u0902...",
        chipImplant: "\u0924\u094D\u092C\u093F\u0932\u093F\u0938\u0940 \u092E\u0947\u0902 \u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u0907\u092E\u094D\u092A\u094D\u0932\u093E\u0902\u091F \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        chipWhitening: "\u092E\u0947\u0930\u0947 \u092A\u093E\u0938 \u0926\u093E\u0902\u0924 \u0938\u092B\u0947\u0926 \u0915\u0930\u0928\u093E",
        chipEmergency: "\u0906\u092A\u093E\u0924\u0915\u093E\u0932\u0940\u0928 \u0926\u0902\u0924 \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E",
        chipOrtho: "\u0935\u092F\u0938\u094D\u0915\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u0911\u0930\u094D\u0925\u094B\u0921\u0949\u0928\u094D\u091F\u093F\u0915\u094D\u0938",
        scrollExplore: "\u0926\u0947\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0915\u094D\u0930\u0949\u0932 \u0915\u0930\u0947\u0902",
        topRated: "\u0924\u094D\u092C\u093F\u0932\u093F\u0938\u0940 \u0915\u0947 \u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        viewAllClinics: "\u0938\u092D\u0940 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0926\u0947\u0916\u0947\u0902",
        statClinics: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        statNoShows: "\u0915\u092E \u0905\u0928\u0941\u092A\u0938\u094D\u0925\u093F\u0924\u093F",
        statBooking: "\u0911\u0928\u0932\u093E\u0907\u0928 \u092C\u0941\u0915\u093F\u0902\u0917",
        statDentists: "\u0926\u0902\u0924 \u091A\u093F\u0915\u093F\u0924\u094D\u0938\u0915",
        statRating: "\u0914\u0938\u0924 \u0930\u0947\u091F\u093F\u0902\u0917",
        statPatients: "\u092E\u0930\u0940\u091C",
        findClinics: "\u0938\u0930\u094D\u0935\u0936\u094D\u0930\u0947\u0937\u094D\u0920 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0916\u094B\u091C\u0947\u0902",
        clinicsTitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u092E\u0947\u0902 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        verifiedClinics: "\u0938\u0924\u094D\u092F\u093E\u092A\u093F\u0924 \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        reviews: "\u0938\u092E\u0940\u0915\u094D\u0937\u093E\u090F\u0902",
        callClinic: "\u0915\u0949\u0932 \u0915\u0930\u0947\u0902",
        bookAppointment: "\u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092C\u0941\u0915 \u0915\u0930\u0947\u0902",
        services: "\u0938\u0947\u0935\u093E\u090F\u0902",
        workingHours: "\u0915\u093E\u0930\u094D\u092F \u0938\u092E\u092F",
        priceRange: "\u092E\u0942\u0932\u094D\u092F \u0938\u0940\u092E\u093E",
        location: "\u0938\u094D\u0925\u093E\u0928",
        bookingTitle: "\u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092C\u0941\u0915 \u0915\u0930\u0947\u0902",
        step: "\u091A\u0930\u0923",
        selectClinic: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u091A\u0941\u0928\u0947\u0902",
        selectService: "\u0938\u0947\u0935\u093E \u091A\u0941\u0928\u0947\u0902",
        selectDate: "\u0924\u093E\u0930\u0940\u0916 \u091A\u0941\u0928\u0947\u0902",
        selectTime: "\u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902",
        confirm: "\u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
        next: "\u0905\u0917\u0932\u093E",
        back: "\u092A\u0940\u091B\u0947",
        viewPitch: "\u092A\u094D\u0930\u0938\u094D\u0924\u0941\u0924\u093F \u0926\u0947\u0916\u0947\u0902",
        shareLocation: "\u0928\u091C\u093C\u0926\u0940\u0915\u0940 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0915\u0947 \u0932\u093F\u090F \u0932\u094B\u0915\u0947\u0936\u0928 \u0938\u093E\u091D\u093E \u0915\u0930\u0947\u0902",
        locationShared: "\u0932\u094B\u0915\u0947\u0936\u0928 \u0938\u093E\u091D\u093E \u0939\u0941\u0908 \u2014 \u0928\u091C\u093C\u0926\u0940\u0915\u0940 \u0926\u093F\u0916\u093E \u0930\u0939\u0947 \u0939\u0948\u0902",
        forBusinessBtn: "\u0935\u094D\u092F\u093E\u092A\u093E\u0930 \u0915\u0947 \u0932\u093F\u090F",
        ownClinic: "\u0915\u094D\u092F\u093E \u0906\u092A \u090F\u0915 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0915\u0947 \u092E\u093E\u0932\u093F\u0915 \u0939\u0948\u0902?",
        claimText: "\u0905\u092A\u0928\u0940 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0915\u094B \u0939\u092E\u093E\u0930\u0947 \u0921\u0947\u091F\u093E\u092C\u0947\u0938 \u092E\u0947\u0902 \u0930\u091C\u093F\u0938\u094D\u091F\u0930 \u0915\u0930\u0947\u0902 \u092F\u093E \u091C\u094B\u0921\u093C\u0947\u0902\u0964",
        getListed: "\u0930\u091C\u093F\u0938\u094D\u091F\u0930 \u0915\u0930\u0947\u0902 \u2192",
        searchByName: "\u0928\u093E\u092E, \u091C\u093F\u0932\u0947 \u092F\u093E \u0938\u0947\u0935\u093E \u0938\u0947 \u0916\u094B\u091C\u0947\u0902...",
        hideMap: "\u092E\u093E\u0928\u091A\u093F\u0924\u094D\u0930 \u091B\u0941\u092A\u093E\u090F\u0902",
        showMap: "\u092E\u093E\u0928\u091A\u093F\u0924\u094D\u0930",
        nearMe: "\u092E\u0947\u0930\u0947 \u092A\u093E\u0938",
        clinicsMatch: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u092E\u093F\u0932\u0924\u0940 \u0939\u0948\u0902",
        loadingMore: "\u0932\u094B\u0921 \u0939\u094B \u0930\u0939\u093E \u0939\u0948...",
        visitWebsite: "\u0935\u0947\u092C\u0938\u093E\u0907\u091F \u0926\u0947\u0916\u0947\u0902",
        clinicsAvailable: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0909\u092A\u0932\u092C\u094D\u0927",
        clinicsFound: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u092E\u093F\u0932\u0940\u0902",
        confirmBooking: "\u092C\u0941\u0915\u093F\u0902\u0917 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
        bookingConfirmed: "\u0906\u092A\u0915\u0940 \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092C\u0941\u0915 \u0939\u094B \u0917\u0908!",
        patientName: "\u092E\u0930\u0940\u091C \u0915\u093E \u0928\u093E\u092E",
        phoneNumber: "\u092B\u094B\u0928 \u0928\u0902\u092C\u0930",
        email: "\u0908\u092E\u0947\u0932",
        notes: "\u0928\u094B\u091F\u094D\u0938 (\u0935\u0948\u0915\u0932\u094D\u092A\u093F\u0915)",
        businessHeroBadge: "15+ \u092E\u0949\u0921\u094D\u092F\u0942\u0932  \xb7  212+ \u0915\u094D\u0932\u0940\u0928\u093F\u0915  \xb7  Gemini AI",
        businessHeroTitle: "\u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0911\u092A\u0930\u0947\u091F\u093F\u0902\u0917 \u0938\u093F\u0938\u094D\u091F\u092E",
        businessHeroSubtitle: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u091A\u093E\u0930\u094D\u091F\u093F\u0902\u0917, \u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923, \u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E, \u0936\u0947\u0921\u094D\u092F\u0942\u0932\u093F\u0902\u0917, \u092C\u093F\u0932\u093F\u0902\u0917, \u0908-\u092A\u094D\u0930\u093F\u0938\u094D\u0915\u094D\u0930\u093F\u092A\u094D\u0936\u0928, \u0932\u0948\u092C \u092A\u094D\u0930\u092C\u0902\u0927\u0928 \u0914\u0930 AI \u0921\u093E\u092F\u0917\u094D\u0928\u094B\u0938\u094D\u091F\u093F\u0915\u094D\u0938 \u2014 \u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E\u0964",
        theProblem: "\u0938\u092E\u0938\u094D\u092F\u093E",
        problemSubtitle: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0921\u0947\u0902\u091F\u0932 \u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0916\u0902\u0921\u093F\u0924 \u0909\u092A\u0915\u0930\u0923\u094B\u0902 \u0915\u0947 \u0915\u093E\u0930\u0923 \u0926\u0948\u0928\u093F\u0915 \u0930\u093E\u091C\u0938\u094D\u0935 \u0916\u094B \u0930\u0939\u0940 \u0939\u0948\u0902",
        excelChaos: "Excel \u0914\u0930 WhatsApp \u0905\u0930\u093E\u091C\u0915\u0924\u093E",
        excelChaosDetail: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u0938\u094D\u092A\u094D\u0930\u0947\u0921\u0936\u0940\u091F \u0914\u0930 \u091A\u0948\u091F \u0938\u0947 \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092A\u094D\u0930\u092C\u0902\u0927\u093F\u0924 \u0915\u0930\u0924\u0940 \u0939\u0948\u0902\u0964 \u0936\u0942\u0928\u094D\u092F \u0938\u094D\u0935\u091A\u093E\u0932\u0928, \u0928\u093F\u0930\u0902\u0924\u0930 \u0924\u094D\u0930\u0941\u091F\u093F\u092F\u093E\u0902\u0964",
        noShowRate: "25% \u0905\u0928\u0941\u092A\u0938\u094D\u0925\u093F\u0924\u093F \u0926\u0930",
        noShowDetail: "\u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u093F\u092E\u093E\u0907\u0902\u0921\u0930 \u0915\u0947 \u092C\u093F\u0928\u093E \u092E\u0930\u0940\u091C \u0905\u092A\u0949\u0907\u0902\u091F\u092E\u0947\u0902\u091F \u092D\u0942\u0932 \u091C\u093E\u0924\u0947 \u0939\u0948\u0902\u0964 \u0916\u093E\u0932\u0940 \u0915\u0941\u0930\u094D\u0938\u093F\u092F\u093E\u0902 = \u20BE500+/\u0926\u093F\u0928 \u0928\u0941\u0915\u0938\u093E\u0928\u0964",
        paperCharts: "2026 \u092E\u0947\u0902 \u0915\u093E\u0917\u091C\u093C\u0940 \u091A\u093E\u0930\u094D\u091F",
        paperChartsDetail: "\u0939\u0938\u094D\u0924\u0932\u093F\u0916\u093F\u0924 \u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F\u094D\u0938, \u0915\u094B\u0908 \u0921\u093F\u091C\u093F\u091F\u0932 \u0913\u0921\u094B\u0928\u094D\u091F\u094B\u0917\u094D\u0930\u093E\u092E \u0928\u0939\u0940\u0902\u0964 \u092E\u0939\u0924\u094D\u0935\u092A\u0942\u0930\u094D\u0923 \u0921\u0947\u091F\u093E \u092B\u093E\u0907\u0932 \u0915\u0948\u092C\u093F\u0928\u0947\u091F \u092E\u0947\u0902 \u092C\u0902\u0926\u0964",
        insuranceBlackHole: "\u092C\u0940\u092E\u093E \u092C\u094D\u0932\u0948\u0915 \u0939\u094B\u0932",
        insuranceDetail: "Aldagi, GPI, Imedi L \u0915\u094B \u092E\u0948\u0928\u0941\u0905\u0932 \u0926\u093E\u0935\u0947 \u0918\u0902\u091F\u094B\u0902 \u0932\u0917\u0924\u0947 \u0939\u0948\u0902\u0964 \u0905\u0938\u094D\u0935\u0940\u0915\u0943\u0924 \u0926\u093E\u0935\u0947 \u091C\u092E\u093E \u0939\u094B\u0924\u0947 \u0930\u0939\u0924\u0947 \u0939\u0948\u0902\u0964",
        oneplatform: "\u090F\u0915 \u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E, \u0938\u092D\u0940 \u092E\u0949\u0921\u094D\u092F\u0942\u0932",
        platformSubtitle: "\u0921\u0947\u0902\u091F\u0932 \u092A\u094D\u0930\u0948\u0915\u094D\u091F\u093F\u0938 \u0915\u0947 \u0932\u093F\u090F 15 \u090F\u0915\u0940\u0915\u0943\u0924 \u092E\u0949\u0921\u094D\u092F\u0942\u0932",
        clinical: "\u0928\u0948\u0926\u093E\u0928\u093F\u0915",
        operations: "\u0938\u0902\u091A\u093E\u0932\u0928",
        analyticsEnterprise: "\u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923 \u0914\u0930 \u090F\u0902\u091F\u0930\u092A\u094D\u0930\u093E\u0907\u091C\u093C",
        digitalOdontogram: "\u0921\u093F\u091C\u093F\u091F\u0932 \u0913\u0921\u094B\u0928\u094D\u091F\u094B\u0917\u094D\u0930\u093E\u092E",
        digitalOdontogramDetail: "FDI 32 \u0926\u093E\u0902\u0924 \u091A\u093E\u0930\u094D\u091F, 5 \u0938\u0924\u0939 \u091F\u094D\u0930\u0948\u0915\u093F\u0902\u0917\u0964",
        perioCharting: "\u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u091A\u093E\u0930\u094D\u091F\u093F\u0902\u0917",
        perioChartingDetail: "192 \u0938\u094D\u0925\u093E\u0928 \u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u0917\u094D\u0930\u093F\u0921\u0964 6 \u092C\u093F\u0902\u0926\u0941 \u092A\u094D\u0930\u094B\u092C\u093F\u0902\u0917, BOP, CAL\u0964",
        treatmentPlanning: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E",
        treatmentPlanningDetail: "CDT \u0915\u094B\u0921 \u0915\u0947 \u0938\u093E\u0925 \u091A\u0930\u0923\u092C\u0926\u094D\u0927 \u092F\u094B\u091C\u0928\u093E\u090F\u0902, \u092C\u0940\u092E\u093E \u0905\u0928\u0941\u092E\u093E\u0928\u0964 AI \u0938\u0940\u0915\u094D\u0935\u0947\u0902\u0938\u093F\u0902\u0917\u0964",
        soapNotes: "SOAP \u0928\u094B\u091F\u094D\u0938 + AI \u0938\u094D\u0915\u094D\u0930\u093E\u0907\u092C",
        soapNotesDetail: "\u091F\u0947\u092E\u094D\u092A\u0932\u0947\u091F \u0915\u0947 \u0938\u093E\u0925 \u0938\u0902\u0930\u091A\u093F\u0924 \u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0921\u0949\u0915\u094D\u092F\u0942\u092E\u0947\u0902\u091F\u0947\u0936\u0928\u0964 Gemini \u0906\u0935\u093E\u091C\u093C \u0938\u0947 \u0928\u094B\u091F\u094D\u0938 \u092C\u0928\u093E\u0924\u093E \u0939\u0948\u0964",
        multiChairScheduling: "\u092C\u0939\u0941-\u0915\u0941\u0930\u094D\u0938\u0940 \u0936\u0947\u0921\u094D\u092F\u0942\u0932\u093F\u0902\u0917",
        multiChairDetail: "\u0915\u0908 \u0911\u092A\u0930\u0947\u091F\u0930\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u092A\u094D\u0924\u093E\u0939\u093F\u0915 \u0926\u0943\u0936\u094D\u092F\u0964 \u0921\u0949\u0915\u094D\u091F\u0930 \u0930\u0902\u0917 \u0915\u094B\u0921\u093F\u0902\u0917\u0964",
        billingInsurance: "\u092C\u093F\u0932\u093F\u0902\u0917 \u0914\u0930 \u092C\u0940\u092E\u093E",
        billingDetail: "Aldagi, GPI, Imedi L \u0926\u093E\u0935\u093E \u091F\u094D\u0930\u0948\u0915\u093F\u0902\u0917\u0964 \u092E\u0930\u0940\u091C \u0916\u093E\u0924\u093E, \u092D\u0941\u0917\u0924\u093E\u0928 \u092F\u094B\u091C\u0928\u093E\u090F\u0902\u0964",
        ePrescribing: "\u0908-\u092A\u094D\u0930\u093F\u0938\u094D\u0915\u094D\u0930\u093F\u092A\u094D\u0936\u0928",
        ePrescribingDetail: "\u091F\u0947\u092E\u094D\u092A\u0932\u0947\u091F \u0915\u0947 \u0938\u093E\u0925 \u0921\u093F\u091C\u093F\u091F\u0932 \u0928\u0941\u0938\u094D\u0916\u0947\u0964 Gemini \u0926\u0935\u093E \u0907\u0902\u091F\u0930\u0948\u0915\u094D\u0936\u0928 \u091C\u093E\u0902\u091A\u0964",
        labTracking: "\u0932\u0948\u092C \u091F\u094D\u0930\u0948\u0915\u093F\u0902\u0917",
        labTrackingDetail: "\u0915\u093E\u0928\u092C\u093E\u0928: \u0911\u0930\u094D\u0921\u0930 \u2192 \u0928\u093F\u0930\u094D\u092E\u093E\u0923 \u2192 \u0936\u093F\u092A\u092E\u0947\u0902\u091F \u2192 \u092A\u094D\u0930\u093E\u092A\u094D\u0924\u0964",
        productionReports: "\u0909\u0924\u094D\u092A\u093E\u0926\u0928 \u0930\u093F\u092A\u094B\u0930\u094D\u091F",
        productionReportsDetail: "\u0938\u0915\u0932/\u0936\u0941\u0926\u094D\u0927 \u0909\u0924\u094D\u092A\u093E\u0926\u0928, \u0938\u0902\u0917\u094D\u0930\u0939 \u0926\u0930, \u0909\u092A\u091A\u093E\u0930 \u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F\u0964",
        referralMgmt: "\u0930\u0947\u092B\u0930\u0932 \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        referralMgmtDetail: "\u0935\u093F\u0936\u0947\u0937\u091C\u094D\u091E\u094B\u0902 \u0915\u094B \u0906\u0928\u0947/\u091C\u093E\u0928\u0947 \u0935\u093E\u0932\u0947 \u0930\u0947\u092B\u0930\u0932\u0964 AI \u091C\u0928\u093F\u0924 \u092A\u0924\u094D\u0930\u0964",
        medicalHistory: "\u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E \u0907\u0924\u093F\u0939\u093E\u0938",
        medicalHistoryDetail: "11 \u0926\u0943\u0936\u094D\u092F \u092E\u0930\u0940\u091C \u0930\u093F\u0915\u0949\u0930\u094D\u0921: \u0938\u092E\u092F\u0930\u0947\u0916\u093E, \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0902, \u0926\u0935\u093E\u0907\u092F\u093E\u0902, \u090F\u0932\u0930\u094D\u091C\u0940\u0964",
        enterpriseAdmin: "\u090F\u0902\u091F\u0930\u092A\u094D\u0930\u093E\u0907\u091C\u093C \u090F\u0921\u092E\u093F\u0928",
        enterpriseAdminDetail: "RBAC, \u0911\u0921\u093F\u091F \u0932\u0949\u0917, \u0905\u0928\u0941\u092A\u093E\u0932\u0928, \u092E\u0932\u094D\u091F\u0940-\u091F\u0947\u0928\u0947\u0902\u0938\u0940, SSO, API \u092A\u094D\u0930\u092C\u0902\u0927\u0928\u0964",
        geminiBuiltIn: "\u0905\u0902\u0924\u0930\u094D\u0928\u093F\u0939\u093F\u0924 Gemini AI",
        geminiSubtitle: "\u0939\u0930 \u092E\u0949\u0921\u094D\u092F\u0942\u0932 Google Gemini 3.1 \u0926\u094D\u0935\u093E\u0930\u093E \u0938\u0902\u091A\u093E\u0932\u093F\u0924",
        xrayAnalysis: "\u090F\u0915\u094D\u0938-\u0930\u0947 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923",
        xrayDetail: "AI \u0915\u0948\u0930\u0940\u091C\u093C \u0921\u093F\u091F\u0947\u0915\u094D\u0936\u0928 \u0915\u0947 \u0932\u093F\u090F \u0921\u0947\u0902\u091F\u0932 \u090F\u0915\u094D\u0938-\u0930\u0947 \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964",
        perioAssessment: "\u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928",
        perioAssessmentDetail: "\u092A\u094D\u0930\u094B\u092C\u093F\u0902\u0917 \u0921\u0947\u091F\u093E \u0938\u0947 \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 AAP \u0938\u094D\u091F\u0947\u091C\u093F\u0902\u0917/\u0917\u094D\u0930\u0947\u0921\u093F\u0902\u0917\u0964",
        clinicalScribe: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0938\u094D\u0915\u094D\u0930\u093E\u0907\u092C",
        clinicalScribeDetail: "\u0935\u0949\u0907\u0938 \u0930\u093F\u0915\u0949\u0930\u094D\u0921\u093F\u0902\u0917 \u092F\u093E \u091A\u093E\u0930\u094D\u091F \u0921\u0947\u091F\u093E \u0938\u0947 SOAP \u0928\u094B\u091F\u094D\u0938 \u091C\u0928\u0930\u0947\u0936\u0928\u0964",
        riskProfiling: "\u091C\u094B\u0916\u093F\u092E \u092A\u094D\u0930\u094B\u092B\u093E\u0907\u0932\u093F\u0902\u0917",
        riskProfilingDetail: "\u0921\u0947\u0902\u091F\u0932 \u0930\u093F\u0938\u094D\u0915 \u092A\u094D\u0930\u094B\u092B\u093E\u0907\u0932 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u094B\u0902, \u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u0907\u0924\u093F\u0939\u093E\u0938 \u0915\u093E \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923\u0964",
        treatmentSequencing: "\u0909\u092A\u091A\u093E\u0930 \u0938\u0940\u0915\u094D\u0935\u0947\u0902\u0938\u093F\u0902\u0917",
        treatmentSequencingDetail: "\u0909\u092A\u091A\u093E\u0930 \u0914\u0930 \u092C\u0940\u092E\u093E \u0915\u094B \u0927\u094D\u092F\u093E\u0928 \u092E\u0947\u0902 \u0930\u0916\u0924\u0947 \u0939\u0941\u090F AI \u0905\u0928\u0941\u0915\u0942\u0932\u093F\u0924 \u0909\u092A\u091A\u093E\u0930 \u091A\u0930\u0923\u0964",
        patientComm: "\u092E\u0930\u0940\u091C \u0938\u0902\u0935\u093E\u0926",
        patientCommDetail: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u0928 \u092E\u0947\u0902 \u092E\u0930\u0940\u091C-\u0905\u0928\u0941\u0915\u0942\u0932 \u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923 \u0915\u093E \u0928\u093F\u0930\u094D\u092E\u093E\u0923\u0964",
        georgianEcosystem: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E\u0908 \u0907\u0915\u094B\u0938\u093F\u0938\u094D\u091F\u092E \u0924\u0948\u092F\u093E\u0930",
        integrationsSubtitle: "\u0938\u094D\u0925\u093E\u0928\u0940\u092F \u092C\u0940\u092E\u093E, \u092D\u0941\u0917\u0924\u093E\u0928 \u0914\u0930 \u092E\u0948\u0938\u0947\u091C\u093F\u0902\u0917 \u0915\u0947 \u0938\u093E\u0925 \u092A\u0942\u0930\u094D\u0935-\u0928\u093F\u0930\u094D\u092E\u093F\u0924 \u090F\u0915\u0940\u0915\u0930\u0923",
        insurance: "\u092C\u0940\u092E\u093E",
        payments: "\u092D\u0941\u0917\u0924\u093E\u0928",
        messaging: "\u092E\u0948\u0938\u0947\u091C\u093F\u0902\u0917",
        ehrLabs: "EHR \u0914\u0930 \u0932\u0948\u092C",
        clinicsInDb: "\u0921\u0947\u091F\u093E\u092C\u0947\u0938 \u092E\u0947\u0902 \u0915\u094D\u0932\u0940\u0928\u093F\u0915",
        platformModules: "\u092A\u094D\u0932\u0947\u091F\u092B\u0949\u0930\u094D\u092E \u092E\u0949\u0921\u094D\u092F\u0942\u0932",
        aiTools: "AI \u0909\u092A\u0915\u0930\u0923 (Gemini)",
        integrations: "\u090F\u0915\u0940\u0915\u0930\u0923",
        pricingTitle: "\u092E\u0942\u0932\u094D\u092F",
        pricingSubtitle: "\u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902, \u092C\u0922\u093C\u0928\u0947 \u092A\u0930 \u0938\u094D\u0915\u0947\u0932 \u0915\u0930\u0947\u0902",
        trustedBy: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915\u094B\u0902 \u0915\u093E \u0935\u093F\u0936\u094D\u0935\u093E\u0938",
        readyModernize: "\u0906\u0927\u0941\u0928\u093F\u0915\u0940\u0915\u0930\u0923 \u0915\u0947 \u0932\u093F\u090F \u0924\u0948\u092F\u093E\u0930?",
        joinCount: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u093E \u092E\u0947\u0902 212+ \u0915\u094D\u0932\u0940\u0928\u093F\u0915\u094B\u0902 \u0938\u0947 \u091C\u0941\u0921\u093C\u0947\u0902\u0964",
        startTrial: "\u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902",
        contactSales: "\u092C\u093F\u0915\u094D\u0930\u0940 \u0938\u0947 \u0938\u0902\u092A\u0930\u094D\u0915 \u0915\u0930\u0947\u0902",
        noCreditCard: "\u0915\u094D\u0930\u0947\u0921\u093F\u091F \u0915\u093E\u0930\u094D\u0921 \u0906\u0935\u0936\u094D\u092F\u0915 \u0928\u0939\u0940\u0902  \xb7  \u0928\u093F\u0903\u0936\u0941\u0932\u094D\u0915 \u092F\u094B\u091C\u0928\u093E  \xb7  5 \u092E\u093F\u0928\u091F \u092E\u0947\u0902 \u0938\u0947\u091F\u0905\u092A",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u0921\u0948\u0936\u092C\u094B\u0930\u094D\u0921",
        navPatients: "\u092E\u0930\u0940\u091C",
        navChart: "\u091A\u093E\u0930\u094D\u091F",
        navPerio: "\u092A\u0947\u0930\u093F\u092F\u094B",
        navTreatmentPlans: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E\u090F\u0902",
        navNotes: "\u0928\u094B\u091F\u094D\u0938",
        navScheduling: "\u0936\u0947\u0921\u094D\u092F\u0942\u0932\u093F\u0902\u0917",
        navBilling: "\u092C\u093F\u0932\u093F\u0902\u0917",
        navPrescriptions: "\u0928\u0941\u0938\u094D\u0916\u0947",
        navLabCases: "\u0932\u0948\u092C \u0915\u0947\u0938",
        navReferrals: "\u0930\u0947\u092B\u0930\u0932",
        navReports: "\u0930\u093F\u092A\u094B\u0930\u094D\u091F",
        navMedHistory: "\u091A\u093F\u0915\u093F\u0924\u094D\u0938\u093E \u0907\u0924\u093F\u0939\u093E\u0938",
        navIntegrations: "\u090F\u0915\u0940\u0915\u0930\u0923",
        navEnterprise: "\u090F\u0902\u091F\u0930\u092A\u094D\u0930\u093E\u0907\u091C\u093C",
        sectionClinical: "\u0928\u0948\u0926\u093E\u0928\u093F\u0915",
        sectionOperations: "\u0938\u0902\u091A\u093E\u0932\u0928",
        sectionAnalytics: "\u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923",
        sectionAiTools: "AI \u0909\u092A\u0915\u0930\u0923",
        sectionAdmin: "\u092A\u094D\u0930\u0936\u093E\u0938\u0928",
        // Booking Page
        chooseClinic: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915 \u091A\u0941\u0928\u0947\u0902",
        selectAService: "\u0938\u0947\u0935\u093E \u091A\u0941\u0928\u0947\u0902",
        pickADate: "\u0924\u093E\u0930\u0940\u0916 \u091A\u0941\u0928\u0947\u0902",
        pickATime: "\u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902",
        confirmYourBooking: "\u0905\u092A\u0928\u0940 \u092C\u0941\u0915\u093F\u0902\u0917 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
        clinicLabel: "\u0915\u094D\u0932\u0940\u0928\u093F\u0915:",
        serviceLabel: "\u0938\u0947\u0935\u093E:",
        dateLabel: "\u0924\u093E\u0930\u0940\u0916:",
        timeLabel: "\u0938\u092E\u092F:",
        // AI Page
        send: "\u092D\u0947\u091C\u0947\u0902",
        procedure: "\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E",
        observations: "\u0905\u0935\u0932\u094B\u0915\u0928",
        aiThinking: "AI \u0938\u094B\u091A \u0930\u0939\u093E \u0939\u0948...",
        summarizeHistory: "\u092E\u0930\u0940\u091C \u0915\u093E \u0907\u0924\u093F\u0939\u093E\u0938 \u0938\u093E\u0930\u093E\u0902\u0936\u093F\u0924 \u0915\u0930\u0947\u0902",
        generateTxPlan: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E \u092C\u0928\u093E\u090F\u0902",
        checkDrugInteractions: "\u0926\u0935\u093E \u0907\u0902\u091F\u0930\u0948\u0915\u094D\u0936\u0928 \u091C\u093E\u0902\u091A\u0947\u0902",
        writeClinicalNote: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F \u0932\u093F\u0916\u0947\u0902",
        askAiAssistant: "AI \u0938\u0939\u093E\u092F\u0915 \u0938\u0947 \u092A\u0942\u091B\u0947\u0902...",
        dropXray: "\u090F\u0915\u094D\u0938-\u0930\u0947 \u091B\u0935\u093F \u0921\u093E\u0932\u0947\u0902 \u092F\u093E \u0905\u092A\u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902",
        supportsFormats: "DICOM, PNG, JPG \u0938\u092E\u0930\u094D\u0925\u093F\u0924",
        analysisResults: "\u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923 \u092A\u0930\u093F\u0923\u093E\u092E (\u0921\u0947\u092E\u094B)",
        aiRecommendation: "AI \u0938\u093F\u092B\u093E\u0930\u093F\u0936",
        exportToTxPlan: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E \u092E\u0947\u0902 \u0928\u093F\u0930\u094D\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        generateClinicalNote: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F \u092C\u0928\u093E\u090F\u0902",
        generatedSoap: "\u091C\u0928\u0930\u0947\u091F \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F (SOAP)",
        subjective: "S \u2014 \u0935\u094D\u092F\u0915\u094D\u0924\u093F\u092A\u0930\u0915",
        objective: "O \u2014 \u0935\u0938\u094D\u0924\u0941\u0928\u093F\u0937\u094D\u0920",
        assessment: "A \u2014 \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928",
        plan: "P \u2014 \u092F\u094B\u091C\u0928\u093E",
        copyToRecord: "\u092E\u0930\u0940\u091C \u0915\u0947 \u0930\u093F\u0915\u0949\u0930\u094D\u0921 \u092E\u0947\u0902 \u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902",
        aiPerioAssessment: "AI \u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928",
        enterProbingData: "AAP \u0938\u094D\u091F\u0947\u091C\u093F\u0902\u0917/\u0917\u094D\u0930\u0947\u0921\u093F\u0902\u0917 \u0914\u0930 \u0909\u092A\u091A\u093E\u0930 \u0938\u093F\u092B\u093E\u0930\u093F\u0936\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u094B\u092C\u093F\u0902\u0917 \u0921\u0947\u091F\u093E \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964",
        analyzeWithGemini: "Gemini \u0938\u0947 \u0935\u093F\u0936\u094D\u0932\u0947\u0937\u0923 \u0915\u0930\u0947\u0902",
        aiRiskAssessment: "AI \u091C\u094B\u0916\u093F\u092E \u092E\u0942\u0932\u094D\u092F\u093E\u0902\u0915\u0928",
        enterConditions: "\u091C\u094B\u0916\u093F\u092E \u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932 \u092C\u0928\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092E\u0930\u0940\u091C \u0915\u0940 \u0938\u094D\u0925\u093F\u0924\u093F, \u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u0907\u0924\u093F\u0939\u093E\u0938 \u0914\u0930 \u0935\u093E\u0907\u091F\u0932 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964",
        generateRiskProfile: "\u091C\u094B\u0916\u093F\u092E \u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932 \u092C\u0928\u093E\u090F\u0902",
        patientCommunication: "\u092E\u0930\u0940\u091C \u0938\u0902\u0935\u093E\u0926",
        generateExplanations: "\u091C\u0949\u0930\u094D\u091C\u093F\u092F\u0928 \u092F\u093E \u0905\u0902\u0917\u094D\u0930\u0947\u091C\u093C\u0940 \u092E\u0947\u0902 \u092E\u0930\u0940\u091C-\u0905\u0928\u0941\u0915\u0942\u0932 \u0909\u092A\u091A\u093E\u0930 \u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923 \u092C\u0928\u093E\u090F\u0902\u0964",
        generateExplanation: "\u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923 \u092C\u0928\u093E\u090F\u0902",
        patientFriendly: "\u092E\u0930\u0940\u091C-\u0905\u0928\u0941\u0915\u0942\u0932 \u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923",
        // Billing Page
        claims: "\u0926\u093E\u0935\u0947",
        ledger: "\u0916\u093E\u0924\u093E \u092C\u0939\u0940",
        aging: "\u090F\u091C\u093F\u0902\u0917",
        paymentPlans: "\u092D\u0941\u0917\u0924\u093E\u0928 \u092F\u094B\u091C\u0928\u093E\u090F\u0902",
        eligibility: "\u092A\u093E\u0924\u094D\u0930\u0924\u093E",
        allFilter: "\u0938\u092D\u0940",
        submitted: "\u092A\u094D\u0930\u0938\u094D\u0924\u0941\u0924",
        paid: "\u092D\u0941\u0917\u0924\u093E\u0928 \u0939\u0941\u0906",
        denied: "\u0905\u0938\u094D\u0935\u0940\u0915\u0943\u0924",
        patientLedger: "\u092E\u0930\u0940\u091C \u0916\u093E\u0924\u093E \u092C\u0939\u0940",
        agedAccounts: "\u0905\u0924\u093F\u0926\u0947\u092F \u0916\u093E\u0924\u0947",
        sendStatements: "\u0935\u093F\u0935\u0930\u0923 \u092D\u0947\u091C\u0947\u0902",
        activePaymentPlans: "\u0938\u0915\u094D\u0930\u093F\u092F \u092D\u0941\u0917\u0924\u093E\u0928 \u092F\u094B\u091C\u0928\u093E\u090F\u0902",
        insuranceEligibility: "\u092C\u0940\u092E\u093E \u092A\u093E\u0924\u094D\u0930\u0924\u093E",
        // Clinical Charting
        odontogram: "\u0913\u0921\u094B\u0928\u094D\u091F\u094B\u0917\u094D\u0930\u093E\u092E",
        perioTab: "\u092A\u0947\u0930\u093F\u092F\u094B",
        treatmentPlanTab: "\u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E",
        notesTab: "\u0928\u094B\u091F\u094D\u0938",
        progressNotes: "\u092A\u094D\u0930\u0917\u0924\u093F \u0928\u094B\u091F\u094D\u0938",
        openFullPerio: "\u092A\u0942\u0930\u094D\u0923 \u092A\u0947\u0930\u093F\u092F\u094B\u0921\u0949\u0928\u094D\u091F\u0932 \u091A\u093E\u0930\u094D\u091F \u0916\u094B\u0932\u0947\u0902 \u2192",
        openFullTxPlanner: "\u092A\u0942\u0930\u094D\u0923 \u0909\u092A\u091A\u093E\u0930 \u092F\u094B\u091C\u0928\u093E\u0915\u093E\u0930 \u0916\u094B\u0932\u0947\u0902 \u2192",
        openClinicalNotes: "\u0915\u094D\u0932\u093F\u0928\u093F\u0915\u0932 \u0928\u094B\u091F\u094D\u0938 \u0916\u094B\u0932\u0947\u0902 \u2192",
        newExam: "\u0928\u0908 \u092A\u0930\u0940\u0915\u094D\u0937\u093E",
        voiceEntry: "\u0935\u0949\u0907\u0938 \u090F\u0902\u091F\u094D\u0930\u0940",
        bleedingIndex: "\u0930\u0915\u094D\u0924\u0938\u094D\u0930\u093E\u0935 \u0938\u0942\u091A\u0915\u093E\u0902\u0915",
        plaqueIndex: "\u092A\u094D\u0932\u093E\u0915 \u0938\u0942\u091A\u0915\u093E\u0902\u0915",
        sitesAbove4: "\u0938\u094D\u0925\u093E\u0928 \u2265 4\u092E\u093F\u092E\u0940",
        sitesAbove6: "\u0938\u094D\u0925\u093E\u0928 \u2265 6\u092E\u093F\u092E\u0940",
        planA: "\u092F\u094B\u091C\u0928\u093E A: \u0905\u0928\u0941\u0936\u0902\u0938\u093F\u0924",
        planB: "\u092F\u094B\u091C\u0928\u093E B: \u0930\u0942\u0922\u093C\u093F\u0935\u093E\u0926\u0940",
        newPlan: "+ \u0928\u0908 \u092F\u094B\u091C\u0928\u093E",
        presentToPatient: "\u092E\u0930\u0940\u091C \u0915\u094B \u092A\u094D\u0930\u0938\u094D\u0924\u0941\u0924 \u0915\u0930\u0947\u0902",
        sendToPortal: "\u092A\u094B\u0930\u094D\u091F\u0932 \u092A\u0930 \u092D\u0947\u091C\u0947\u0902",
        totalFee: "\u0915\u0941\u0932 \u0936\u0941\u0932\u094D\u0915",
        insuranceEst: "\u092C\u0940\u092E\u093E \u0905\u0928\u0941\u092E\u093E\u0928",
        patientPortion: "\u092E\u0930\u0940\u091C \u0915\u093E \u0939\u093F\u0938\u094D\u0938\u093E",
        chairSideMode: "\u091A\u0947\u092F\u0930-\u0938\u093E\u0907\u0921 \u092E\u094B\u0921",
        adminMode: "\u090F\u0921\u092E\u093F\u0928 \u092E\u094B\u0921",
        proceduresAcrossPhases: "{1} \u091A\u0930\u0923\u094B\u0902 \u092E\u0947\u0902 {0} \u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E\u090F\u0902",
        // Scheduling
        day: "\u0926\u093F\u0928",
        week: "\u0938\u092A\u094D\u0924\u093E\u0939",
        today: "\u0906\u091C",
        providerFilter: "\u0938\u092D\u0940 \u092A\u094D\u0930\u0926\u093E\u0924\u093E",
        productionGoal: "\u0909\u0924\u094D\u092A\u093E\u0926\u0928 \u0932\u0915\u094D\u0937\u094D\u092F",
        waitlist: "\u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u0938\u0942\u091A\u0940",
        // Prescriptions
        activeRx: "\u0938\u0915\u094D\u0930\u093F\u092F",
        pastRx: "\u092A\u093F\u091B\u0932\u0947",
        templates: "\u091F\u0947\u092E\u094D\u092A\u0932\u0947\u091F",
        interactionCheck: "\u0907\u0902\u091F\u0930\u0948\u0915\u094D\u0936\u0928 \u091C\u093E\u0902\u091A",
        // Lab Cases
        ordered: "\u0911\u0930\u094D\u0921\u0930 \u0915\u093F\u092F\u093E",
        sentToLab: "\u0932\u0948\u092C \u0915\u094B \u092D\u0947\u091C\u093E",
        inFabrication: "\u0928\u093F\u0930\u094D\u092E\u093E\u0923 \u092E\u0947\u0902",
        shipped: "\u092D\u0947\u091C \u0926\u093F\u092F\u093E",
        received: "\u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0939\u0941\u0906",
        labVendors: "\u0932\u0948\u092C \u0935\u093F\u0915\u094D\u0930\u0947\u0924\u093E",
        // Referrals
        allDirections: "\u0938\u092D\u0940",
        inbound: "\u0906\u0928\u0947 \u0935\u093E\u0932\u0947",
        outbound: "\u091C\u093E\u0928\u0947 \u0935\u093E\u0932\u0947",
        generateLetter: "\u092A\u0924\u094D\u0930 \u092C\u0928\u093E\u090F\u0902",
        // Reports
        production: "\u0909\u0924\u094D\u092A\u093E\u0926\u0928",
        collections: "\u0938\u0902\u0917\u094D\u0930\u0939",
        schedulingReport: "\u0936\u0947\u0921\u094D\u092F\u0942\u0932\u093F\u0902\u0917",
        treatmentAcceptance: "\u0909\u092A\u091A\u093E\u0930 \u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F",
        recall: "\u0930\u093F\u0915\u0949\u0932",
        grossProduction: "\u0938\u0915\u0932 \u0909\u0924\u094D\u092A\u093E\u0926\u0928",
        netProduction: "\u0936\u0941\u0926\u094D\u0927 \u0909\u0924\u094D\u092A\u093E\u0926\u0928",
        collectionRate: "\u0938\u0902\u0917\u094D\u0930\u0939 \u0926\u0930",
        plansPresented: "\u092A\u094D\u0930\u0938\u094D\u0924\u0941\u0924 \u092F\u094B\u091C\u0928\u093E\u090F\u0902",
        accepted: "\u0938\u094D\u0935\u0940\u0915\u0943\u0924",
        acceptanceRate: "\u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F \u0926\u0930",
        dueThisMonth: "\u0907\u0938 \u092E\u0939\u0940\u0928\u0947 \u0926\u0947\u092F",
        scheduled: "\u0928\u093F\u0930\u094D\u0927\u093E\u0930\u093F\u0924",
        completed: "\u092A\u0942\u0930\u094D\u0923",
        overdue: "\u0905\u0924\u093F\u0926\u0947\u092F",
        reactivationRate: "\u092A\u0941\u0928\u0930\u094D\u0938\u0915\u094D\u0930\u093F\u092F\u0923 \u0926\u0930",
        // Medical History
        timeline: "\u0938\u092E\u092F\u0930\u0947\u0916\u093E",
        conditions: "\u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0902",
        medications: "\u0926\u0935\u093E\u0907\u092F\u093E\u0902",
        allergies: "\u090F\u0932\u0930\u094D\u091C\u0940",
        labResults: "\u0932\u0948\u092C \u092A\u0930\u093F\u0923\u093E\u092E",
        vitals: "\u0935\u093E\u0907\u091F\u0932\u094D\u0938",
        immunizations: "\u091F\u0940\u0915\u093E\u0915\u0930\u0923",
        familyHistory: "\u092A\u093E\u0930\u093F\u0935\u093E\u0930\u093F\u0915 \u0907\u0924\u093F\u0939\u093E\u0938",
        imaging: "\u0907\u092E\u0947\u091C\u093F\u0902\u0917",
        documents: "\u0926\u0938\u094D\u0924\u093E\u0935\u0947\u091C\u093C",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u0911\u0921\u093F\u091F \u0932\u0949\u0917",
        compliance: "\u0905\u0928\u0941\u092A\u093E\u0932\u0928",
        multiTenancy: "\u092E\u0932\u094D\u091F\u0940-\u091F\u0947\u0928\u0947\u0902\u0938\u0940",
        sso: "SSO \u0914\u0930 \u0938\u0941\u0930\u0915\u094D\u0937\u093E",
        featureFlags: "\u092B\u093C\u0940\u091A\u0930 \u092B\u093C\u094D\u0932\u0948\u0917",
        apiManagement: "API \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        dataManagement: "\u0921\u0947\u091F\u093E \u092A\u094D\u0930\u092C\u0902\u0927\u0928",
        // Integrations
        ehr: 'EHR',
        labs: "\u0932\u0948\u092C",
        telehealth: "\u091F\u0947\u0932\u0940\u0939\u0947\u0932\u094D\u0925",
        aiMl: 'AI/ML',
        wearables: "\u092A\u0939\u0928\u0928\u0947 \u092F\u094B\u0917\u094D\u092F",
        connected: "\u091C\u0941\u0921\u093C\u093E \u0939\u0941\u0906",
        disconnected: "\u0921\u093F\u0938\u094D\u0915\u0928\u0947\u0915\u094D\u091F",
        available: "\u0909\u092A\u0932\u092C\u094D\u0927",
        // Components
        status: "\u0938\u094D\u0925\u093F\u0924\u093F",
        healthy: "\u0938\u094D\u0935\u0938\u094D\u0925",
        caries: "\u0915\u0948\u0930\u0940\u091C\u093C",
        restored: "\u092A\u0941\u0928\u0930\u094D\u0938\u094D\u0925\u093E\u092A\u093F\u0924",
        missing: "\u0905\u0928\u0941\u092A\u0938\u094D\u0925\u093F\u0924",
        implant: "\u0907\u092E\u094D\u092A\u094D\u0932\u093E\u0902\u091F",
        crownStatus: "\u0915\u094D\u0930\u093E\u0909\u0928",
        bridge: "\u092C\u094D\u0930\u093F\u091C",
        veneer: "\u0935\u0940\u0928\u093F\u092F\u0930",
        surfaces: "\u0938\u0924\u0939\u0947\u0902",
        procedureHistory: "\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u0907\u0924\u093F\u0939\u093E\u0938",
        addProcedure: "\u092A\u094D\u0930\u0915\u094D\u0930\u093F\u092F\u093E \u091C\u094B\u0921\u093C\u0947\u0902",
        totalCharged: "\u0915\u0941\u0932 \u091A\u093E\u0930\u094D\u091C",
        insurancePayment: "\u092C\u0940\u092E\u093E \u092D\u0941\u0917\u0924\u093E\u0928",
        patientResponsibility: "\u092E\u0930\u0940\u091C \u0915\u0940 \u091C\u093F\u092E\u094D\u092E\u0947\u0926\u093E\u0930\u0940",
        expand: "\u0935\u093F\u0938\u094D\u0924\u093E\u0930 \u0915\u0930\u0947\u0902",
        policyNumber: "\u092A\u0949\u0932\u093F\u0938\u0940 #",
        planType: "\u092F\u094B\u091C\u0928\u093E \u092A\u094D\u0930\u0915\u093E\u0930",
        annualMax: "\u0935\u093E\u0930\u094D\u0937\u093F\u0915 \u0905\u0927\u093F\u0915\u0924\u092E",
        used: "\u0909\u092A\u092F\u094B\u0917 \u0915\u093F\u092F\u093E",
        remaining: "\u0936\u0947\u0937",
        coverageByCategory: "\u0936\u094D\u0930\u0947\u0923\u0940 \u0915\u0947 \u0905\u0928\u0941\u0938\u093E\u0930 \u0915\u0935\u0930\u0947\u091C",
        preventive: "\u0928\u093F\u0935\u093E\u0930\u0915",
        basic: "\u092C\u0941\u0928\u093F\u092F\u093E\u0926\u0940",
        major: "\u092A\u094D\u0930\u092E\u0941\u0916",
        ortho: "\u0911\u0930\u094D\u0925\u094B",
        current: "\u0935\u0930\u094D\u0924\u092E\u093E\u0928",
        thirtyDay: "30 \u0926\u093F\u0928",
        sixtyDay: "60 \u0926\u093F\u0928",
        ninetyPlus: "90+ \u0926\u093F\u0928",
        totalBalance: "\u0915\u0941\u0932 \u0936\u0947\u0937",
        monthlyPayment: "\u092E\u093E\u0938\u093F\u0915 \u092D\u0941\u0917\u0924\u093E\u0928",
        paymentsRemaining: "\u0936\u0947\u0937 \u092D\u0941\u0917\u0924\u093E\u0928",
        nextPayment: "\u0905\u0917\u0932\u093E \u092D\u0941\u0917\u0924\u093E\u0928",
        paymentProgress: "\u092D\u0941\u0917\u0924\u093E\u0928 \u092A\u094D\u0930\u0917\u0924\u093F",
        choosePlan: "\u092F\u094B\u091C\u0928\u093E \u091A\u0941\u0928\u0947\u0902",
        aiInsight: "AI \u0905\u0902\u0924\u0930\u094D\u0926\u0943\u0937\u094D\u091F\u093F",
        confidence: "\u0935\u093F\u0936\u094D\u0935\u093E\u0938",
        revoke: "\u0930\u0926\u094D\u0926 \u0915\u0930\u0947\u0902",
        exams: "\u092A\u0930\u0940\u0915\u094D\u0937\u093E\u090F\u0902",
        phaseTotal: "\u091A\u0930\u0923 \u0915\u0941\u0932",
        mon: "\u0938\u094B\u092E",
        tue: "\u092E\u0902\u0917\u0932",
        wed: "\u092C\u0941\u0927",
        thu: "\u0917\u0941\u0930\u0941",
        fri: "\u0936\u0941\u0915\u094D\u0930",
        sat: "\u0936\u0928\u093F",
        sun: "\u0930\u0935\u093F",
        thinking: "\u0938\u094B\u091A \u0930\u0939\u093E \u0939\u0948...",
        followUpPlaceholder: "\u0905\u0928\u0941\u0935\u0930\u094D\u0924\u0940 \u092A\u094D\u0930\u0936\u094D\u0928 \u092A\u0942\u091B\u0947\u0902...",
        initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
        nextExpansionArmeniaAzerbaijan: "\uD83C\uDF0D  Next expansion: Armenia \u2192 Azerbaijan \u2192 broader Caucasus dental market",
        whyNow: 'Why Now',
        str561: "\u2708\uFE0F",
        dentalTourismBoom: 'Dental tourism boom',
        internationalPatientsNeedEngli: 'International patients need English-language online booking now',
        str564: "\uD83D\uDCF1",
        postcovidDigitizationPressure: 'Post-COVID digitization pressure',
        clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
        str567: "\uD83C\uDFC6",
        noStrongLocalIncumbent: 'No strong local incumbent',
        dentosgeOnlyCoversDiscovery: "dentos.ge only covers discovery \u2014 zero full ops platform exists",
        str570: "\uD83C\uDDEC\uD83C\uDDEA",
        georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
        lowCostHighQuality: "Low cost, high quality \u2014 50\u201370% cheaper than Western Europe",
        joinThePartnerClinic: "Join the Partner Clinic Program \u2014 first 3 months free",
        builtForGeorgianClinics: "\uD83E\uDDB7 Built for Georgian clinics, by people who live here",
        prev: "\u2190 Prev",
        next2: "Next \u2192",
        getInTouch: "\uD83E\uDDB7 Get in Touch",
        activePrescriptions: 'Active Prescriptions',
        pastPrescriptions: 'Past Prescriptions',
        prescriptionTemplates: 'Prescription Templates',
        drugInteractionChecker: 'Drug Interaction Checker',
        referrals: 'Referrals',
        newReferral: '+ New Referral',
        inbound2: 'Inbound',
        outbound2: 'Outbound',
        reportsAnalytics: 'Reports & Analytics',
        productionByProvider: 'Production by Provider',
        productionByCategory: 'Production by Category',
        preventive2: 'Preventive',
        restorative: 'Restorative',
        endodontics: 'Endodontics',
        periodontics: 'Periodontics',
        prosthodontics: 'Prosthodontics',
        surgery: 'Surgery',
        agingReport: 'Aging Report',
        appointmentsByDay: 'Appointments by Day',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        topDeclinedTreatments: 'Top Declined Treatments',
        costConcerns: 'Cost concerns',
        wantsToWait: 'Wants to wait',
        orthodontics: 'Orthodontics',
        insuranceNotCovering: 'Insurance not covering',
        notAPriority: 'Not a priority',
        seekingSecondOpinion: 'Seeking second opinion',
        u2190: '\u2190',
        u2192: '\u2192',
        allProviders: 'All Providers',
        hygienistNino: 'Hygienist Nino',
        mon17: 'MON 17',
        tue18: 'TUE 18',
        wed19: 'WED 19',
        thu20: 'THU 20',
        fri21: 'FRI 21',
        crownPrep14: 'Crown Prep #14',
        tKapanadze: 'T. Kapanadze',
        srpQuad1: 'SRP Quad 1',
        dGelashvili: 'D. Gelashvili',
        examXray: 'Exam + X-ray',
        mTsiklauri: 'M. Tsiklauri',
        unconfirmed: 'Unconfirmed',
        rct36: 'RCT #36',
        gBeridze: 'G. Beridze',
        prophyPolish: 'Prophy + Polish',
        iDiasamidze: 'I. Diasamidze',
        perioMaintenance: 'Perio Maintenance',
        tLomidze: 'T. Lomidze',
        prophy: 'Prophy',
        aJavakhishvili: 'A. Javakhishvili',
        inChair: 'In Chair',
        sealantsX4: 'Sealants x4',
        nKapanadze: 'N. Kapanadze',
        lMchedlishvili: 'L. Mchedlishvili',
        u2014LunchU2014: '\u2014 Lunch \u2014',
        veneerPrep11: 'Veneer Prep #11',
        kGabrichidze: 'K. Gabrichidze',
        composite25: 'Composite #25',
        sMeladze: 'S. Meladze',
        bridgePrep3436: 'Bridge Prep #34-36',
        rKharazishvili: 'R. Kharazishvili',
        composite22: 'Composite #22',
        zDolidze: 'Z. Dolidze',
        noShow: 'No Show',
        extraction48: 'Extraction #48',
        vPapunashvili: 'V. Papunashvili',
        implantConsult: 'Implant Consult',
        eTsereteli: 'E. Tsereteli',
        nGogiberidze: 'N. Gogiberidze',
        crownSeat14: 'Crown Seat #14',
        checkup: 'Checkup',
        bShengelia: 'B. Shengelia',
        fluorideTreatment: 'Fluoride Treatment',
        emergencyWalkin: 'Emergency Walk-in',
        scaling: 'Scaling',
        wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
        assignToSchedule: 'Assign to Schedule',
        autoAssign: 'Auto Assign',
        high: 'High',
        anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
        medium: 'Medium',
        irakliDiasamidze: 'Irakli Diasamidze',
        friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
        low: 'Low',
        planARecommended: 'Plan A: Recommended',
        planBConservative: 'Plan B: Conservative',
        newPlan2: '+ New Plan',
        conservativeApproach: 'Conservative Approach',
        thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
        u00b7: '\u00B7',
        treatmentPlanComparison: 'Treatment Plan Comparison',
        u00b72: '\u00b7',
        exams2: 'Exams:',
        metric: 'Metric',
        pdMm: 'PD (mm)',
        gmMm: 'GM (mm)',
        calMm: 'CAL (mm)',
        suppuration: 'Suppuration',
        furcation: 'Furcation',
        mobility: 'Mobility',
        qty: 'Qty',
        refills: 'Refills',
        goal: 'Goal',
        current2: 'Current',
        totalDue: 'Total Due',
        scheduled2: 'Scheduled',
        overdue2: 'Overdue',
        reactivation: 'Reactivation',
        chiefComplaint: 'Chief Complaint',
        painScale: 'Pain Scale:',
        clinicalFindings: 'Clinical Findings',
        diagnosis: 'Diagnosis',
        prescriptions: 'Prescriptions',
        u201c: '\u201C',
        xray: 'X-Ray',
        cleaning: 'Cleaning',
        amountPaid: 'Amount Paid',
        annotate: 'Annotate',
        anonymousPatient: 'Anonymous Patient',
        autoImport: 'Auto Import',
        away: 'Away',
        bankTransfer: 'Bank Transfer',
        beforeAfter: 'Before After',
        bookPrerequisiteFirst: 'Book Prerequisite First',
        breakdown: 'Breakdown',
        bridgePrep: 'Bridge Prep',
        brightness: 'Brightness',
        cabinet: 'Cabinet',
        cabinet1: 'Cabinet 1',
        cabinet2: 'Cabinet 2',
        cabinetSchedule: 'Cabinet Schedule',
        cabinetScheduleDesc: 'Cabinet Schedule Desc',
        card: 'Card',
        cash: 'Cash',
        cbct: 'Cbct',
        cephalometric: 'Cephalometric',
        channels: 'Channels',
        clinicalQuestion: 'Clinical Question',
        clinicAvgRating: 'Clinic Avg Rating',
        collapse: 'Collapse',
        completedToday: 'Completed Today',
        compositeF: 'Composite F',
        continueToScheduling: 'Continue To Scheduling',
        contrast: 'Contrast',
        ctScans: 'Ct Scans',
        customAmount: 'Custom Amount',
        days: 'Days',
        delivered: 'Delivered',
        directMessages: 'Direct Messages',
        disposables: 'Disposables',
        doctorResponse: 'Doctor Response',
        doctors: 'Doctors',
        documentMgmtSubtitle: 'Document Mgmt Subtitle',
        documentPreview: 'Document Preview',
        download: 'Download',
        endodontic: 'Endodontic',
        enterAmount: 'Enter Amount',
        equipmentDevices: 'Equipment Devices',
        estDelivery: 'Est Delivery',
        examConsult: 'Exam Consult',
        explanationQuality: 'Explanation Quality',
        fluorideTx: 'Fluoride Tx',
        fullMouthView: 'Full Mouth View',
        hasBracesQuestion: 'Has Braces Question',
        hasConsultationQuestion: 'Has Consultation Question',
        hasCtScanQuestion: 'Has Ct Scan Question',
        hasRecentXrayQuestion: 'Has Recent Xray Question',
        helpfulQuestion: 'Helpful Question',
        highest: 'Highest',
        hygiene: 'Hygiene',
        imagingType: 'Imaging Type',
        implantPlace: 'Implant Place',
        important: 'Important',
        importLatest: 'Import Latest',
        inProgress: 'In Progress',
        installment: 'Installment',
        insuranceCoverage: 'Insurance Coverage',
        interpreted: 'Interpreted',
        inUse: 'In Use',
        invoices: 'Invoices',
        lastCleaningQuestion: 'Last Cleaning Question',
        lateralSkullView: 'Lateral Skull View',
        lowest: 'Lowest',
        lowStock: 'Low Stock',
        lowStockAlerts: 'Low Stock Alerts',
        maintenance: 'Maintenance',
        management: 'Management',
        markComplete: 'Mark Complete',
        material: 'Material',
        method: 'Method',
        minOrder: 'Min Order',
        monthlySpend: 'Monthly Spend',
        newPayment: 'New Payment',
        newRadiologyReferral: 'New Radiology Referral',
        nextAppointment: 'Next Appointment',
        noDocumentsFound: 'No Documents Found',
        noNoteSelected: 'No Note Selected',
        normal: 'Normal',
        noteInterpreter: 'Note Interpreter',
        occupied: 'Occupied',
        online: 'Online',
        orderNow: 'Order Now',
        orders: 'Orders',
        original: 'Original',
        outstanding: 'Outstanding',
        painManagement: 'Pain Management',
        panoramic: 'Panoramic',
        patientDue: 'Patient Due',
        paymentHistory: 'Payment History',
        paymentMethod: 'Payment Method',
        pendingOrders: 'Pending Orders',
        periapical: 'Periapical',
        perioMaint: 'Perio Maint',
        photos: 'Photos',
        placeOrder: 'Place Order',
        preCheck: 'Pre Check',
        preCheckPassed: 'Pre Check Passed',
        preCheckSubtitle: 'Pre Check Subtitle',
        preCheckTitle: 'Pre Check Title',
        prerequisiteWarning: 'Prerequisite Warning',
        print: 'Print',
        processing: 'Processing',
        processPayment: 'Process Payment',
        processPaymentBtn: 'Process Payment Btn',
        professionalism: 'Professionalism',
        prophyClean: 'Prophy Clean',
        prosthetic: 'Prosthetic',
        punctuality: 'Punctuality',
        qtyUsed: 'Qty Used',
        quantity: 'Quantity',
        queue: 'Queue',
        receiptPreview: 'Receipt Preview',
        recent: 'Recent',
        recentMaterialUsage: 'Recent Material Usage',
        recentReceipts: 'Recent Receipts',
        reliability: 'Reliability',
        remainingBalance: 'Remaining Balance',
        reorderLevel: 'Reorder Level',
        scanning: 'Scanning',
        sealants: 'Sealants',
        sent: 'Sent',
        singleToothView: 'Single Tooth View',
        slotDetails: 'Slot Details',
        sortBy: 'Sort By',
        srpQuad: 'Srp Quad',
        startImaging: 'Start Imaging',
        stock: 'Stock',
        stockLevel: 'Stock Level',
        submitReferral: 'Submit Referral',
        subtotal: 'Subtotal',
        suppliers: 'Suppliers',
        surgical: 'Surgical',
        targetArea: 'Target Area',
        teamChat: 'Team Chat',
        termsNormalized: 'Terms Normalized',
        threeDImaging: 'Three D Imaging',
        totalItems: 'Total Items',
        totalReceived: 'Total Received',
        typeAMessage: 'Type A Message',
        unavailable: 'Unavailable',
        unit: 'Unit',
        urgency: 'Urgency',
        urgent: 'Urgent',
        usageLog: 'Usage Log',
        veneerPrep: 'Veneer Prep',
        viewOnGoogle: 'View On Google',
        xrays: 'Xrays'
    },
    msa: {
        home: "\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
        features: "\u0627\u0644\u0645\u064A\u0632\u0627\u062A",
        pricing: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
        clinicsNav: "\u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        aiAssistant: "\u0645\u0633\u0627\u0639\u062F AI",
        forBusiness: "\u0644\u0644\u0623\u0639\u0645\u0627\u0644",
        dashboard: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
        getStarted: "\u0627\u0628\u062F\u0623",
        tryDemo: "\u062C\u0631\u0628 \u0627\u0644\u0639\u0631\u0636",
        heroTagline: "\u0645\u0646\u0635\u0629 \u0637\u0628 \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0644\u062C\u0648\u0631\u062C\u064A\u0627",
        heroTitle: "\u0645\u0631\u0643\u0632 \u062C\u0645\u064A\u0639 \u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646",
        heroSubtitle: "\u0645\u0633\u0627\u0639\u062F\u0643 AI \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u0641\u0636\u0644 \u0631\u0639\u0627\u064A\u0629 \u0623\u0633\u0646\u0627\u0646 \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627",
        searchPlaceholder: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0639\u064A\u0627\u062F\u0627\u062A \u0623\u0648 \u062E\u062F\u0645\u0627\u062A...",
        chipImplant: "\u0623\u0641\u0636\u0644 \u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0632\u0631\u0627\u0639\u0629 \u0641\u064A \u062A\u0628\u0644\u064A\u0633\u064A",
        chipWhitening: "\u062A\u0628\u064A\u064A\u0636 \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0628\u0627\u0644\u0642\u0631\u0628 \u0645\u0646\u064A",
        chipEmergency: "\u0631\u0639\u0627\u064A\u0629 \u0623\u0633\u0646\u0627\u0646 \u0637\u0627\u0631\u0626\u0629",
        chipOrtho: "\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0644\u0644\u0628\u0627\u0644\u063A\u064A\u0646",
        scrollExplore: "\u0645\u0631\u0631 \u0644\u0644\u0627\u0633\u062A\u0643\u0634\u0627\u0641",
        topRated: "\u0623\u0641\u0636\u0644 \u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0641\u064A \u062A\u0628\u0644\u064A\u0633\u064A",
        viewAllClinics: "\u0639\u0631\u0636 \u062C\u0645\u064A\u0639 \u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        statClinics: "\u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        statNoShows: "\u063A\u064A\u0627\u0628 \u0623\u0642\u0644",
        statBooking: "\u062D\u062C\u0632 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
        statDentists: "\u0623\u0637\u0628\u0627\u0621 \u0623\u0633\u0646\u0627\u0646",
        statRating: "\u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u062A\u0642\u064A\u064A\u0645",
        statPatients: "\u0627\u0644\u0645\u0631\u0636\u0649",
        findClinics: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0623\u0641\u0636\u0644 \u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        clinicsTitle: "\u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627",
        verifiedClinics: "\u0639\u064A\u0627\u062F\u0627\u062A \u0645\u0648\u062B\u0642\u0629",
        reviews: "\u062A\u0642\u064A\u064A\u0645\u0627\u062A",
        callClinic: "\u0627\u062A\u0635\u0644",
        bookAppointment: "\u0627\u062D\u062C\u0632 \u0645\u0648\u0639\u062F",
        services: "\u0627\u0644\u062E\u062F\u0645\u0627\u062A",
        workingHours: "\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
        priceRange: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0623\u0633\u0639\u0627\u0631",
        location: "\u0627\u0644\u0645\u0648\u0642\u0639",
        bookingTitle: "\u0627\u062D\u062C\u0632 \u0645\u0648\u0639\u062F",
        step: "\u062E\u0637\u0648\u0629",
        selectClinic: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0639\u064A\u0627\u062F\u0629",
        selectService: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062E\u062F\u0645\u0629",
        selectDate: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
        selectTime: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0648\u0642\u062A",
        confirm: "\u062A\u0623\u0643\u064A\u062F",
        next: "\u0627\u0644\u062A\u0627\u0644\u064A",
        back: "\u0631\u062C\u0648\u0639",
        viewPitch: "\u0639\u0631\u0636 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u062A\u0642\u062F\u064A\u0645\u064A",
        shareLocation: "\u0634\u0627\u0631\u0643 \u0645\u0648\u0642\u0639\u0643 \u0644\u0644\u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0642\u0631\u064A\u0628\u0629",
        locationShared: "\u062A\u0645 \u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0645\u0648\u0642\u0639 \u2014 \u0639\u0631\u0636 \u0627\u0644\u0642\u0631\u064A\u0628\u0629",
        forBusinessBtn: "\u0644\u0644\u0623\u0639\u0645\u0627\u0644",
        ownClinic: "\u0647\u0644 \u062A\u0645\u0644\u0643 \u0639\u064A\u0627\u062F\u0629 \u0623\u0633\u0646\u0627\u0646\u061F",
        claimText: "\u0633\u062C\u0651\u0644 \u0639\u064A\u0627\u062F\u062A\u0643 \u0623\u0648 \u0623\u0636\u0641\u0647\u0627 \u0625\u0644\u0649 \u0642\u0627\u0639\u062F\u0629 \u0628\u064A\u0627\u0646\u0627\u062A\u0646\u0627.",
        getListed: "\u0633\u062C\u0651\u0644 \u0627\u0644\u0622\u0646 \u2192",
        searchByName: "\u0628\u062D\u062B \u0628\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0623\u0648 \u0627\u0644\u062E\u062F\u0645\u0629...",
        hideMap: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u062E\u0631\u064A\u0637\u0629",
        showMap: "\u0627\u0644\u062E\u0631\u064A\u0637\u0629",
        nearMe: "\u0628\u0627\u0644\u0642\u0631\u0628 \u0645\u0646\u064A",
        clinicsMatch: "\u0639\u064A\u0627\u062F\u0627\u062A \u0645\u0637\u0627\u0628\u0642\u0629",
        loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
        visitWebsite: "\u0632\u064A\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0642\u0639",
        clinicsAvailable: "\u0639\u064A\u0627\u062F\u0627\u062A \u0645\u062A\u0627\u062D\u0629",
        clinicsFound: "\u0639\u064A\u0627\u062F\u0627\u062A \u0648\u064F\u062C\u062F\u062A",
        confirmBooking: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062D\u062C\u0632",
        bookingConfirmed: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0645\u0648\u0639\u062F\u0643!",
        patientName: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u064A\u0636",
        phoneNumber: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641",
        email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        notes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
        businessHeroBadge: "15+ \u0648\u062D\u062F\u0629  \xb7  212+ \u0639\u064A\u0627\u062F\u0629  \xb7  Gemini AI",
        businessHeroTitle: "\u0646\u0638\u0627\u0645 \u062A\u0634\u063A\u064A\u0644 \u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646",
        businessHeroSubtitle: "\u0627\u0644\u0631\u0633\u0645 \u0627\u0644\u0633\u0631\u064A\u0631\u064A\u060C \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0644\u062B\u0629\u060C \u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u0639\u0644\u0627\u062C\u060C \u0627\u0644\u062C\u062F\u0648\u0644\u0629\u060C \u0627\u0644\u0641\u0648\u062A\u0631\u0629\u060C \u0627\u0644\u0648\u0635\u0641\u0627\u062A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629\u060C \u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u062E\u062A\u0628\u0631 \u0648\u062A\u0634\u062E\u064A\u0635 AI \u2014 \u0643\u0644\u0647\u0627 \u0641\u064A \u0645\u0646\u0635\u0629 \u0648\u0627\u062D\u062F\u0629 \u0644\u062C\u0648\u0631\u062C\u064A\u0627.",
        theProblem: "\u0627\u0644\u0645\u0634\u0643\u0644\u0629",
        problemSubtitle: "\u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629 \u062A\u062E\u0633\u0631 \u0625\u064A\u0631\u0627\u062F\u0627\u062A \u064A\u0648\u0645\u064A\u0627\u064B \u0628\u0633\u0628\u0628 \u0627\u0644\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0645\u062C\u0632\u0623\u0629",
        excelChaos: "\u0641\u0648\u0636\u0649 Excel \u0648WhatsApp",
        excelChaosDetail: "\u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A \u062A\u062F\u064A\u0631 \u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0639\u0628\u0631 \u0627\u0644\u062C\u062F\u0627\u0648\u0644 \u0648\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u062F\u0631\u062F\u0634\u0629. \u0635\u0641\u0631 \u0623\u062A\u0645\u062A\u0629\u060C \u0623\u062E\u0637\u0627\u0621 \u0645\u0633\u062A\u0645\u0631\u0629.",
        noShowRate: "\u0645\u0639\u062F\u0644 \u063A\u064A\u0627\u0628 25%",
        noShowDetail: "\u0628\u062F\u0648\u0646 \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629\u060C \u064A\u0646\u0633\u0649 \u0627\u0644\u0645\u0631\u0636\u0649 \u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F. \u0627\u0644\u0643\u0631\u0627\u0633\u064A \u0627\u0644\u0641\u0627\u0631\u063A\u0629 \u062A\u0639\u0646\u064A \u062E\u0633\u0627\u0631\u0629 \u20BE500+/\u064A\u0648\u0645.",
        paperCharts: "\u0633\u062C\u0644\u0627\u062A \u0648\u0631\u0642\u064A\u0629 \u0641\u064A 2026",
        paperChartsDetail: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0633\u0631\u064A\u0631\u064A\u0629 \u0645\u0643\u062A\u0648\u0628\u0629 \u0628\u062E\u0637 \u0627\u0644\u064A\u062F\u060C \u0628\u062F\u0648\u0646 \u0645\u062E\u0637\u0637 \u0623\u0633\u0646\u0627\u0646 \u0631\u0642\u0645\u064A. \u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0631\u062C\u0629 \u0645\u062D\u0628\u0648\u0633\u0629 \u0641\u064A \u0627\u0644\u062E\u0632\u0627\u0626\u0646.",
        insuranceBlackHole: "\u0627\u0644\u062B\u0642\u0628 \u0627\u0644\u0623\u0633\u0648\u062F \u0644\u0644\u062A\u0623\u0645\u064A\u0646",
        insuranceDetail: "\u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062A \u0627\u0644\u064A\u062F\u0648\u064A\u0629 \u0625\u0644\u0649 Aldagi \u0648GPI \u0648Imedi L \u062A\u0633\u062A\u063A\u0631\u0642 \u0633\u0627\u0639\u0627\u062A. \u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0648\u0636\u0629 \u062A\u062A\u0631\u0627\u0643\u0645.",
        oneplatform: "\u0645\u0646\u0635\u0629 \u0648\u0627\u062D\u062F\u0629\u060C \u0643\u0644 \u0627\u0644\u0648\u062D\u062F\u0627\u062A",
        platformSubtitle: "15 \u0648\u062D\u062F\u0629 \u0645\u062A\u0643\u0627\u0645\u0644\u0629 \u0645\u0635\u0645\u0645\u0629 \u0644\u0645\u0645\u0627\u0631\u0633\u0627\u062A \u0637\u0628 \u0627\u0644\u0623\u0633\u0646\u0627\u0646",
        clinical: "\u0633\u0631\u064A\u0631\u064A",
        operations: "\u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A",
        analyticsEnterprise: "\u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        digitalOdontogram: "\u0645\u062E\u0637\u0637 \u0623\u0633\u0646\u0627\u0646 \u0631\u0642\u0645\u064A",
        digitalOdontogramDetail: "\u0645\u062E\u0637\u0637 FDI 32 \u0633\u0646 \u0645\u0639 \u062A\u062A\u0628\u0639 5 \u0623\u0633\u0637\u062D.",
        perioCharting: "\u0631\u0633\u0645 \u0627\u0644\u0644\u062B\u0629",
        perioChartingDetail: "\u0634\u0628\u0643\u0629 \u0644\u062B\u0648\u064A\u0629 192 \u0646\u0642\u0637\u0629. \u0633\u0628\u0631 6 \u0646\u0642\u0627\u0637\u060C BOP\u060C CAL.",
        treatmentPlanning: "\u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u0639\u0644\u0627\u062C",
        treatmentPlanningDetail: "\u062E\u0637\u0637 \u0645\u0631\u062D\u0644\u064A\u0629 \u0645\u0639 \u0623\u0643\u0648\u0627\u062F CDT\u060C \u062A\u0642\u062F\u064A\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0645\u064A\u0646. \u062A\u0633\u0644\u0633\u0644 AI.",
        soapNotes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A SOAP + \u0643\u0627\u062A\u0628 AI",
        soapNotesDetail: "\u062A\u0648\u062B\u064A\u0642 \u0633\u0631\u064A\u0631\u064A \u0645\u0646\u0638\u0645 \u0628\u0642\u0648\u0627\u0644\u0628. Gemini \u064A\u0648\u0644\u062F \u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0645\u0646 \u0627\u0644\u0635\u0648\u062A.",
        multiChairScheduling: "\u062C\u062F\u0648\u0644\u0629 \u0645\u062A\u0639\u062F\u062F\u0629 \u0627\u0644\u0643\u0631\u0627\u0633\u064A",
        multiChairDetail: "\u0639\u0631\u0636 \u0623\u0633\u0628\u0648\u0639\u064A \u0645\u0639 \u0639\u062F\u0629 \u063A\u0631\u0641 \u0639\u0645\u0644\u064A\u0627\u062A. \u062A\u0631\u0645\u064A\u0632 \u0644\u0648\u0646\u064A \u0644\u0644\u0623\u0637\u0628\u0627\u0621.",
        billingInsurance: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        billingDetail: "\u062A\u062A\u0628\u0639 \u0645\u0637\u0627\u0644\u0628\u0627\u062A Aldagi \u0648GPI \u0648Imedi L. \u062F\u0641\u062A\u0631 \u0627\u0644\u0645\u0631\u064A\u0636\u060C \u062E\u0637\u0637 \u0627\u0644\u062F\u0641\u0639.",
        ePrescribing: "\u0627\u0644\u0648\u0635\u0641\u0627\u062A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
        ePrescribingDetail: "\u0648\u0635\u0641\u0627\u062A \u0631\u0642\u0645\u064A\u0629 \u0628\u0642\u0648\u0627\u0644\u0628. \u0641\u062D\u0635 \u062A\u0641\u0627\u0639\u0644\u0627\u062A \u0627\u0644\u0623\u062F\u0648\u064A\u0629 \u0639\u0628\u0631 Gemini.",
        labTracking: "\u062A\u062A\u0628\u0639 \u0627\u0644\u0645\u062E\u062A\u0628\u0631",
        labTrackingDetail: "\u0643\u0627\u0646\u0628\u0627\u0646: \u062A\u0645 \u0627\u0644\u0637\u0644\u0628 \u2192 \u0627\u0644\u062A\u0635\u0646\u064A\u0639 \u2192 \u0627\u0644\u0634\u062D\u0646 \u2192 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
        productionReports: "\u062A\u0642\u0627\u0631\u064A\u0631 \u0627\u0644\u0625\u0646\u062A\u0627\u062C",
        productionReportsDetail: "\u0627\u0644\u0625\u0646\u062A\u0627\u062C \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A/\u0627\u0644\u0635\u0627\u0641\u064A\u060C \u0645\u0639\u062F\u0644 \u0627\u0644\u062A\u062D\u0635\u064A\u0644\u060C \u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0644\u0627\u062C.",
        referralMgmt: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A",
        referralMgmtDetail: "\u0625\u062D\u0627\u0644\u0627\u062A \u0648\u0627\u0631\u062F\u0629/\u0635\u0627\u062F\u0631\u0629 \u0644\u0644\u0645\u062A\u062E\u0635\u0635\u064A\u0646. \u062E\u0637\u0627\u0628\u0627\u062A \u0645\u0648\u0644\u062F\u0629 \u0628\u0627\u0644\u0640 AI.",
        medicalHistory: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0628\u064A",
        medicalHistoryDetail: "\u0633\u062C\u0644 \u0645\u0631\u064A\u0636 11 \u0639\u0631\u0636: \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A\u060C \u0627\u0644\u062D\u0627\u0644\u0627\u062A\u060C \u0627\u0644\u0623\u062F\u0648\u064A\u0629\u060C \u0627\u0644\u062D\u0633\u0627\u0633\u064A\u0627\u062A.",
        enterpriseAdmin: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        enterpriseAdminDetail: "RBAC\u060C \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642\u060C \u0627\u0644\u0627\u0645\u062A\u062B\u0627\u0644\u060C \u062A\u0639\u062F\u062F \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631\u064A\u0646\u060C SSO\u060C \u0625\u062F\u0627\u0631\u0629 API.",
        geminiBuiltIn: "Gemini AI \u0645\u062F\u0645\u062C",
        geminiSubtitle: "\u0643\u0644 \u0648\u062D\u062F\u0629 \u0645\u062F\u0639\u0648\u0645\u0629 \u0628\u0640 Google Gemini 3.1",
        xrayAnalysis: "\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0623\u0634\u0639\u0629 \u0627\u0644\u0633\u064A\u0646\u064A\u0629",
        xrayDetail: "\u0627\u0631\u0641\u0639 \u0635\u0648\u0631 \u0627\u0644\u0623\u0634\u0639\u0629 \u0627\u0644\u0633\u064A\u0646\u064A\u0629 \u0644\u0644\u0623\u0633\u0646\u0627\u0646 \u0644\u0644\u0643\u0634\u0641 \u0639\u0646 \u0627\u0644\u062A\u0633\u0648\u0633 \u0628\u0627\u0644\u0640 AI.",
        perioAssessment: "\u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0644\u062B\u0629",
        perioAssessmentDetail: "\u062A\u0635\u0646\u064A\u0641/\u062A\u062F\u0631\u064A\u062C AAP \u062A\u0644\u0642\u0627\u0626\u064A \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0633\u0628\u0631.",
        clinicalScribe: "\u0627\u0644\u0643\u0627\u062A\u0628 \u0627\u0644\u0633\u0631\u064A\u0631\u064A",
        clinicalScribeDetail: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0627\u062D\u0638\u0627\u062A SOAP \u0645\u0646 \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u0635\u0648\u062A\u064A\u0629 \u0623\u0648 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0633\u062C\u0644.",
        riskProfiling: "\u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0645\u062E\u0627\u0637\u0631",
        riskProfilingDetail: "\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0639\u0627\u0626\u0644\u064A \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0641 \u0645\u062E\u0627\u0637\u0631 \u0627\u0644\u0623\u0633\u0646\u0627\u0646.",
        treatmentSequencing: "\u062A\u0633\u0644\u0633\u0644 \u0627\u0644\u0639\u0644\u0627\u062C",
        treatmentSequencingDetail: "\u062A\u0633\u0644\u0633\u0644 \u0639\u0644\u0627\u062C \u0645\u062D\u0633\u0651\u0646 \u0628\u0627\u0644\u0640 AI \u0645\u0639 \u0645\u0631\u0627\u0639\u0627\u0629 \u0627\u0644\u0634\u0641\u0627\u0621 \u0648\u0627\u0644\u062A\u0623\u0645\u064A\u0646.",
        patientComm: "\u062A\u0648\u0627\u0635\u0644 \u0627\u0644\u0645\u0631\u064A\u0636",
        patientCommDetail: "\u0625\u0646\u0634\u0627\u0621 \u0634\u0631\u0648\u062D\u0627\u062A \u0645\u0641\u0647\u0648\u0645\u0629 \u0644\u0644\u0645\u0631\u064A\u0636 \u0628\u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629.",
        georgianEcosystem: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0628\u064A\u0626\u064A \u0627\u0644\u062C\u0648\u0631\u062C\u064A \u062C\u0627\u0647\u0632",
        integrationsSubtitle: "\u062A\u0643\u0627\u0645\u0644\u0627\u062A \u0645\u0633\u0628\u0642\u0629 \u0645\u0639 \u0627\u0644\u062A\u0623\u0645\u064A\u0646 \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u0645\u0631\u0627\u0633\u0644\u0627\u062A \u0627\u0644\u0645\u062D\u0644\u064A\u0629",
        insurance: "\u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        payments: "\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
        messaging: "\u0627\u0644\u0645\u0631\u0627\u0633\u0644\u0627\u062A",
        ehrLabs: "\u0627\u0644\u0633\u062C\u0644 \u0627\u0644\u0635\u062D\u064A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u0645\u062E\u062A\u0628\u0631\u0627\u062A",
        clinicsInDb: "\u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A \u0641\u064A \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
        platformModules: "\u0648\u062D\u062F\u0627\u062A \u0627\u0644\u0645\u0646\u0635\u0629",
        aiTools: "\u0623\u062F\u0648\u0627\u062A AI (Gemini)",
        integrations: "\u0627\u0644\u062A\u0643\u0627\u0645\u0644\u0627\u062A",
        pricingTitle: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
        pricingSubtitle: "\u0627\u0628\u062F\u0623 \u0645\u062C\u0627\u0646\u0627\u064B\u060C \u062A\u0648\u0633\u0639 \u0645\u0639 \u0627\u0644\u0646\u0645\u0648",
        trustedBy: "\u062B\u0642\u0629 \u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        readyModernize: "\u0645\u0633\u062A\u0639\u062F \u0644\u0644\u062A\u062D\u062F\u064A\u062B\u061F",
        joinCount: "\u0627\u0646\u0636\u0645 \u0625\u0644\u0649 212+ \u0639\u064A\u0627\u062F\u0629 \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627.",
        startTrial: "\u0627\u0628\u062F\u0623 \u0645\u062C\u0627\u0646\u0627\u064B",
        contactSales: "\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A",
        noCreditCard: "\u0644\u0627 \u062D\u0627\u062C\u0629 \u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0626\u062A\u0645\u0627\u0646  \xb7  \u062E\u0637\u0629 \u0645\u062C\u0627\u0646\u064A\u0629  \xb7  \u0625\u0639\u062F\u0627\u062F \u0641\u064A 5 \u062F\u0642\u0627\u0626\u0642",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
        navPatients: "\u0627\u0644\u0645\u0631\u0636\u0649",
        navChart: "\u0627\u0644\u0633\u062C\u0644",
        navPerio: "\u0627\u0644\u0644\u062B\u0629",
        navTreatmentPlans: "\u062E\u0637\u0637 \u0627\u0644\u0639\u0644\u0627\u062C",
        navNotes: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        navScheduling: "\u0627\u0644\u062C\u062F\u0648\u0644\u0629",
        navBilling: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629",
        navPrescriptions: "\u0627\u0644\u0648\u0635\u0641\u0627\u062A",
        navLabCases: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0628\u0631",
        navReferrals: "\u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A",
        navReports: "\u0627\u0644\u062A\u0642\u0627\u0631\u064A\u0631",
        navMedHistory: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0628\u064A",
        navIntegrations: "\u0627\u0644\u062A\u0643\u0627\u0645\u0644\u0627\u062A",
        navEnterprise: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        sectionClinical: "\u0633\u0631\u064A\u0631\u064A",
        sectionOperations: "\u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A",
        sectionAnalytics: "\u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A",
        sectionAiTools: "\u0623\u062F\u0648\u0627\u062A AI",
        sectionAdmin: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
        // Booking Page
        chooseClinic: "\u0627\u062E\u062A\u0631 \u0639\u064A\u0627\u062F\u0629",
        selectAService: "\u0627\u062E\u062A\u0631 \u062E\u062F\u0645\u0629",
        pickADate: "\u0627\u062E\u062A\u0631 \u062A\u0627\u0631\u064A\u062E\u0627\u064B",
        pickATime: "\u0627\u062E\u062A\u0631 \u0648\u0642\u062A\u0627\u064B",
        confirmYourBooking: "\u0623\u0643\u062F \u062D\u062C\u0632\u0643",
        clinicLabel: "\u0627\u0644\u0639\u064A\u0627\u062F\u0629:",
        serviceLabel: "\u0627\u0644\u062E\u062F\u0645\u0629:",
        dateLabel: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E:",
        timeLabel: "\u0627\u0644\u0648\u0642\u062A:",
        // AI Page
        send: "\u0625\u0631\u0633\u0627\u0644",
        procedure: "\u0625\u062C\u0631\u0627\u0621",
        observations: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        aiThinking: "AI \u064A\u0641\u0643\u0631...",
        summarizeHistory: "\u062A\u0644\u062E\u064A\u0635 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0631\u064A\u0636",
        generateTxPlan: "\u0625\u0646\u0634\u0627\u0621 \u062E\u0637\u0629 \u0639\u0644\u0627\u062C",
        checkDrugInteractions: "\u0641\u062D\u0635 \u062A\u0641\u0627\u0639\u0644\u0627\u062A \u0627\u0644\u0623\u062F\u0648\u064A\u0629",
        writeClinicalNote: "\u0643\u062A\u0627\u0628\u0629 \u0645\u0644\u0627\u062D\u0638\u0629 \u0633\u0631\u064A\u0631\u064A\u0629",
        askAiAssistant: "\u0627\u0633\u0623\u0644 \u0645\u0633\u0627\u0639\u062F AI...",
        dropXray: "\u0623\u0633\u0642\u0637 \u0635\u0648\u0631\u0629 \u0627\u0644\u0623\u0634\u0639\u0629 \u0623\u0648 \u0627\u0646\u0642\u0631 \u0644\u0644\u0631\u0641\u0639",
        supportsFormats: "\u064A\u062F\u0639\u0645 DICOM\u060C PNG\u060C JPG",
        analysisResults: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u062A\u062D\u0644\u064A\u0644 (\u0639\u0631\u0636)",
        aiRecommendation: "\u062A\u0648\u0635\u064A\u0629 AI",
        exportToTxPlan: "\u062A\u0635\u062F\u064A\u0631 \u0625\u0644\u0649 \u062E\u0637\u0629 \u0627\u0644\u0639\u0644\u0627\u062C",
        generateClinicalNote: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0627\u062D\u0638\u0629 \u0633\u0631\u064A\u0631\u064A\u0629",
        generatedSoap: "\u0645\u0644\u0627\u062D\u0638\u0629 \u0633\u0631\u064A\u0631\u064A\u0629 \u0645\u064F\u0646\u0634\u0623\u0629 (SOAP)",
        subjective: "S \u2014 \u0630\u0627\u062A\u064A",
        objective: "O \u2014 \u0645\u0648\u0636\u0648\u0639\u064A",
        assessment: "A \u2014 \u0627\u0644\u062A\u0642\u064A\u064A\u0645",
        plan: "P \u2014 \u0627\u0644\u062E\u0637\u0629",
        copyToRecord: "\u0646\u0633\u062E \u0625\u0644\u0649 \u0633\u062C\u0644 \u0627\u0644\u0645\u0631\u064A\u0636",
        aiPerioAssessment: "\u062A\u0642\u064A\u064A\u0645 AI \u0644\u0623\u0645\u0631\u0627\u0636 \u0627\u0644\u0644\u062B\u0629",
        enterProbingData: "\u0623\u062F\u062E\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0633\u0628\u0631 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u0635\u0646\u064A\u0641 AAP \u0648\u062A\u0648\u0635\u064A\u0627\u062A \u0627\u0644\u0639\u0644\u0627\u062C.",
        analyzeWithGemini: "\u062A\u062D\u0644\u064A\u0644 \u0645\u0639 Gemini",
        aiRiskAssessment: "\u062A\u0642\u064A\u064A\u0645 AI \u0644\u0644\u0645\u062E\u0627\u0637\u0631",
        enterConditions: "\u0623\u062F\u062E\u0644 \u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u0631\u064A\u0636 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0639\u0627\u0626\u0644\u064A \u0648\u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062D\u064A\u0648\u064A\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0641 \u0627\u0644\u0645\u062E\u0627\u0637\u0631.",
        generateRiskProfile: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0641 \u0627\u0644\u0645\u062E\u0627\u0637\u0631",
        patientCommunication: "\u062A\u0648\u0627\u0635\u0644 \u0627\u0644\u0645\u0631\u064A\u0636",
        generateExplanations: "\u0625\u0646\u0634\u0627\u0621 \u0634\u0631\u0648\u062D\u0627\u062A \u0639\u0644\u0627\u062C\u064A\u0629 \u0645\u0641\u0647\u0648\u0645\u0629 \u0644\u0644\u0645\u0631\u064A\u0636 \u0628\u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629 \u0623\u0648 \u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629.",
        generateExplanation: "\u0625\u0646\u0634\u0627\u0621 \u0634\u0631\u062D",
        patientFriendly: "\u0634\u0631\u062D \u0645\u0641\u0647\u0648\u0645 \u0644\u0644\u0645\u0631\u064A\u0636",
        // Billing Page
        claims: "\u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062A",
        ledger: "\u062F\u0641\u062A\u0631 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A",
        aging: "\u062A\u0642\u0627\u062F\u0645 \u0627\u0644\u062F\u064A\u0648\u0646",
        paymentPlans: "\u062E\u0637\u0637 \u0627\u0644\u062F\u0641\u0639",
        eligibility: "\u0627\u0644\u0623\u0647\u0644\u064A\u0629",
        allFilter: "\u0627\u0644\u0643\u0644",
        submitted: "\u0645\u0642\u062F\u0645",
        paid: "\u0645\u062F\u0641\u0648\u0639",
        denied: "\u0645\u0631\u0641\u0648\u0636",
        patientLedger: "\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0631\u064A\u0636",
        agedAccounts: "\u062D\u0633\u0627\u0628\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629",
        sendStatements: "\u0625\u0631\u0633\u0627\u0644 \u0643\u0634\u0648\u0641\u0627\u062A",
        activePaymentPlans: "\u062E\u0637\u0637 \u062F\u0641\u0639 \u0646\u0634\u0637\u0629",
        insuranceEligibility: "\u0623\u0647\u0644\u064A\u0629 \u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        // Clinical Charting
        odontogram: "\u0645\u062E\u0637\u0637 \u0627\u0644\u0623\u0633\u0646\u0627\u0646",
        perioTab: "\u0627\u0644\u0644\u062B\u0629",
        treatmentPlanTab: "\u062E\u0637\u0629 \u0627\u0644\u0639\u0644\u0627\u062C",
        notesTab: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        progressNotes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0627\u0644\u062A\u0642\u062F\u0645",
        openFullPerio: "\u0641\u062A\u062D \u0645\u062E\u0637\u0637 \u0627\u0644\u0644\u062B\u0629 \u0627\u0644\u0643\u0627\u0645\u0644 \u2192",
        openFullTxPlanner: "\u0641\u062A\u062D \u0645\u062E\u0637\u0637 \u0627\u0644\u0639\u0644\u0627\u062C \u0627\u0644\u0643\u0627\u0645\u0644 \u2192",
        openClinicalNotes: "\u0641\u062A\u062D \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0631\u064A\u0629 \u2192",
        newExam: "\u0641\u062D\u0635 \u062C\u062F\u064A\u062F",
        voiceEntry: "\u0625\u062F\u062E\u0627\u0644 \u0635\u0648\u062A\u064A",
        bleedingIndex: "\u0645\u0624\u0634\u0631 \u0627\u0644\u0646\u0632\u064A\u0641",
        plaqueIndex: "\u0645\u0624\u0634\u0631 \u0627\u0644\u0644\u0648\u064A\u062D\u0629",
        sitesAbove4: "\u0645\u0648\u0627\u0642\u0639 \u2265 4\u0645\u0645",
        sitesAbove6: "\u0645\u0648\u0627\u0642\u0639 \u2265 6\u0645\u0645",
        planA: "\u0627\u0644\u062E\u0637\u0629 \u0623: \u0627\u0644\u0645\u0648\u0635\u0649 \u0628\u0647\u0627",
        planB: "\u0627\u0644\u062E\u0637\u0629 \u0628: \u0627\u0644\u062A\u062D\u0641\u0638\u064A\u0629",
        newPlan: "+ \u062E\u0637\u0629 \u062C\u062F\u064A\u062F\u0629",
        presentToPatient: "\u062A\u0642\u062F\u064A\u0645 \u0644\u0644\u0645\u0631\u064A\u0636",
        sendToPortal: "\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0628\u0648\u0627\u0628\u0629",
        totalFee: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0631\u0633\u0648\u0645",
        insuranceEst: "\u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        patientPortion: "\u062D\u0635\u0629 \u0627\u0644\u0645\u0631\u064A\u0636",
        chairSideMode: "\u0648\u0636\u0639 \u062C\u0627\u0646\u0628 \u0627\u0644\u0643\u0631\u0633\u064A",
        adminMode: "\u0648\u0636\u0639 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
        proceduresAcrossPhases: "{0} \u0625\u062C\u0631\u0627\u0621 \u0639\u0628\u0631 {1} \u0645\u0631\u0627\u062D\u0644",
        // Scheduling
        day: "\u064A\u0648\u0645",
        week: "\u0623\u0633\u0628\u0648\u0639",
        today: "\u0627\u0644\u064A\u0648\u0645",
        providerFilter: "\u062C\u0645\u064A\u0639 \u0645\u0642\u062F\u0645\u064A \u0627\u0644\u062E\u062F\u0645\u0629",
        productionGoal: "\u0647\u062F\u0641 \u0627\u0644\u0625\u0646\u062A\u0627\u062C",
        waitlist: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
        // Prescriptions
        activeRx: "\u0646\u0634\u0637\u0629",
        pastRx: "\u0633\u0627\u0628\u0642\u0629",
        templates: "\u0642\u0648\u0627\u0644\u0628",
        interactionCheck: "\u0641\u062D\u0635 \u0627\u0644\u062A\u0641\u0627\u0639\u0644\u0627\u062A",
        // Lab Cases
        ordered: "\u062A\u0645 \u0627\u0644\u0637\u0644\u0628",
        sentToLab: "\u0623\u064F\u0631\u0633\u0644 \u0644\u0644\u0645\u062E\u062A\u0628\u0631",
        inFabrication: "\u0642\u064A\u062F \u0627\u0644\u062A\u0635\u0646\u064A\u0639",
        shipped: "\u062A\u0645 \u0627\u0644\u0634\u062D\u0646",
        received: "\u062A\u0645 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
        labVendors: "\u0645\u0648\u0631\u062F\u0648 \u0627\u0644\u0645\u062E\u062A\u0628\u0631\u0627\u062A",
        // Referrals
        allDirections: "\u0627\u0644\u0643\u0644",
        inbound: "\u0648\u0627\u0631\u062F\u0629",
        outbound: "\u0635\u0627\u062F\u0631\u0629",
        generateLetter: "\u0625\u0646\u0634\u0627\u0621 \u062E\u0637\u0627\u0628",
        // Reports
        production: "\u0627\u0644\u0625\u0646\u062A\u0627\u062C",
        collections: "\u0627\u0644\u062A\u062D\u0635\u064A\u0644\u0627\u062A",
        schedulingReport: "\u0627\u0644\u062C\u062F\u0648\u0644\u0629",
        treatmentAcceptance: "\u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0644\u0627\u062C",
        recall: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u0633\u062A\u062F\u0639\u0627\u0621",
        grossProduction: "\u0627\u0644\u0625\u0646\u062A\u0627\u062C \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A",
        netProduction: "\u0627\u0644\u0625\u0646\u062A\u0627\u062C \u0627\u0644\u0635\u0627\u0641\u064A",
        collectionRate: "\u0645\u0639\u062F\u0644 \u0627\u0644\u062A\u062D\u0635\u064A\u0644",
        plansPresented: "\u0627\u0644\u062E\u0637\u0637 \u0627\u0644\u0645\u0642\u062F\u0645\u0629",
        accepted: "\u0645\u0642\u0628\u0648\u0644",
        acceptanceRate: "\u0645\u0639\u062F\u0644 \u0627\u0644\u0642\u0628\u0648\u0644",
        dueThisMonth: "\u0645\u0633\u062A\u062D\u0642 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
        scheduled: "\u0645\u062C\u062F\u0648\u0644",
        completed: "\u0645\u0643\u062A\u0645\u0644",
        overdue: "\u0645\u062A\u0623\u062E\u0631",
        reactivationRate: "\u0645\u0639\u062F\u0644 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0646\u0634\u064A\u0637",
        // Medical History
        timeline: "\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A",
        conditions: "\u0627\u0644\u062D\u0627\u0644\u0627\u062A",
        medications: "\u0627\u0644\u0623\u062F\u0648\u064A\u0629",
        allergies: "\u0627\u0644\u062D\u0633\u0627\u0633\u064A\u0627\u062A",
        labResults: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0645\u062E\u062A\u0628\u0631",
        vitals: "\u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062D\u064A\u0648\u064A\u0629",
        immunizations: "\u0627\u0644\u062A\u0637\u0639\u064A\u0645\u0627\u062A",
        familyHistory: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0639\u0627\u0626\u0644\u064A",
        imaging: "\u0627\u0644\u062A\u0635\u0648\u064A\u0631",
        documents: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
        compliance: "\u0627\u0644\u0627\u0645\u062A\u062B\u0627\u0644",
        multiTenancy: "\u062A\u0639\u062F\u062F \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631\u064A\u0646",
        sso: "SSO \u0648\u0627\u0644\u0623\u0645\u0627\u0646",
        featureFlags: "\u0623\u0639\u0644\u0627\u0645 \u0627\u0644\u0645\u064A\u0632\u0627\u062A",
        apiManagement: "\u0625\u062F\u0627\u0631\u0629 API",
        dataManagement: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
        // Integrations
        ehr: "\u0627\u0644\u0633\u062C\u0644 \u0627\u0644\u0635\u062D\u064A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        labs: "\u0627\u0644\u0645\u062E\u062A\u0628\u0631\u0627\u062A",
        telehealth: "\u0627\u0644\u0637\u0628 \u0639\u0646 \u0628\u064F\u0639\u062F",
        aiMl: 'AI/ML',
        wearables: "\u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0627\u0631\u062A\u062F\u0627\u0621",
        connected: "\u0645\u062A\u0635\u0644",
        disconnected: "\u063A\u064A\u0631 \u0645\u062A\u0635\u0644",
        available: "\u0645\u062A\u0627\u062D",
        // Components
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        healthy: "\u0633\u0644\u064A\u0645",
        caries: "\u062A\u0633\u0648\u0633",
        restored: "\u0645\u0631\u0645\u0645",
        missing: "\u0645\u0641\u0642\u0648\u062F",
        implant: "\u0632\u0631\u0639\u0629",
        crownStatus: "\u062A\u0627\u062C",
        bridge: "\u062C\u0633\u0631",
        veneer: "\u0642\u0634\u0631\u0629",
        surfaces: "\u0627\u0644\u0623\u0633\u0637\u062D",
        procedureHistory: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
        addProcedure: "\u0625\u0636\u0627\u0641\u0629 \u0625\u062C\u0631\u0627\u0621",
        totalCharged: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u062D\u0645\u0651\u0644",
        insurancePayment: "\u062F\u0641\u0639\u0629 \u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        patientResponsibility: "\u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0631\u064A\u0636",
        expand: "\u062A\u0648\u0633\u064A\u0639",
        policyNumber: "\u0631\u0642\u0645 \u0627\u0644\u0628\u0648\u0644\u064A\u0635\u0629",
        planType: "\u0646\u0648\u0639 \u0627\u0644\u062E\u0637\u0629",
        annualMax: "\u0627\u0644\u062D\u062F \u0627\u0644\u0633\u0646\u0648\u064A \u0627\u0644\u0623\u0642\u0635\u0649",
        used: "\u0645\u0633\u062A\u062E\u062F\u0645",
        remaining: "\u0645\u062A\u0628\u0642\u064A",
        coverageByCategory: "\u0627\u0644\u062A\u063A\u0637\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0641\u0626\u0629",
        preventive: "\u0648\u0642\u0627\u0626\u064A",
        basic: "\u0623\u0633\u0627\u0633\u064A",
        major: "\u0631\u0626\u064A\u0633\u064A",
        ortho: "\u062A\u0642\u0648\u064A\u0645",
        current: "\u062D\u0627\u0644\u064A",
        thirtyDay: "30 \u064A\u0648\u0645",
        sixtyDay: "60 \u064A\u0648\u0645",
        ninetyPlus: "90+ \u064A\u0648\u0645",
        totalBalance: "\u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A",
        monthlyPayment: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0634\u0647\u0631\u064A\u0629",
        paymentsRemaining: "\u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u062A\u0628\u0642\u064A\u0629",
        nextPayment: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
        paymentProgress: "\u062A\u0642\u062F\u0645 \u0627\u0644\u062F\u0641\u0639",
        choosePlan: "\u0627\u062E\u062A\u0631 \u062E\u0637\u0629",
        aiInsight: "\u0631\u0624\u064A\u0629 AI",
        confidence: "\u0627\u0644\u062B\u0642\u0629",
        revoke: "\u0625\u0644\u063A\u0627\u0621",
        exams: "\u0627\u0644\u0641\u062D\u0648\u0635\u0627\u062A",
        phaseTotal: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        mon: "\u0627\u062B\u0646",
        tue: "\u062B\u0644\u0627",
        wed: "\u0623\u0631\u0628",
        thu: "\u062E\u0645\u064A",
        fri: "\u062C\u0645\u0639",
        sat: "\u0633\u0628\u062A",
        sun: "\u0623\u062D\u062F",
        thinking: "\u064A\u0641\u0643\u0631...",
        followUpPlaceholder: "\u0627\u0637\u0631\u062D \u0633\u0624\u0627\u0644 \u0645\u062A\u0627\u0628\u0639\u0629...",
        priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
        patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
        tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
        chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
        english: 'English',
        patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
        xrayAnalysis2: 'X-ray Analysis',
        uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
        perioAssessment2: 'Perio Assessment',
        automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
        clinicalScribe2: 'Clinical Scribe',
        generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
        riskProfiling2: 'Risk Profiling',
        analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
        treatmentSequencing2: 'Treatment Sequencing',
        aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
        patientCommunication2: 'Patient Communication',
        generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
        insurance2: 'INSURANCE',
        automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
        payments2: 'PAYMENTS',
        onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
        messaging2: 'MESSAGING',
        appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
        ehrLabs2: 'EHR & LABS',
        interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
        clinicsInDatabase: 'Clinics in Database',
        platformModules2: 'Platform Modules',
        integrations2: 'Integrations',
        home2: 'Home',
        features2: 'Features',
        pricing2: 'Pricing',
        dashboard2: 'Dashboard',
        u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
        openFullPeriodontalChart: "Open Full Periodontal Chart \u2192",
        openFullTreatmentPlanner: "Open Full Treatment Planner \u2192",
        openClinicalNotes2: "Open Clinical Notes \u2192",
        backToAllClinics: "\u2190 Back to all clinics",
        priceRange2: 'Price range:',
        bookAnAppointment: 'Book an Appointment',
        selectDate2: 'Select date',
        selectTime2: 'Select time',
        confirmBooking2: "Confirm Booking \u2192",
        clinics: 'Clinics',
        forBusiness2: 'For Business',
        u00a92026Mcai: '\u00A9 2026 MCAI',
        clinicalNotes: 'Clinical Notes',
        newNote: '+ New Note',
        template: 'Template:',
        crownPrep: 'Crown Prep',
        aiScribe: 'AI Scribe',
        recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
        startRecording: 'Start Recording',
        generateNote: 'Generate Note',
        general: 'General',
        prosthetics: 'Prosthetics',
        typeToSearch: 'Type to search dental terms...',
        revenueToday: 'Revenue Today',
        noshows: 'No-shows',
        confirmed: 'Confirmed',
        time: 'TIME',
        patient: 'PATIENT',
        service: 'SERVICE',
        doctor: 'DOCTOR',
        status2: 'STATUS',
        addPatient: '+ Add Patient',
        mondayMarch19: 'Monday, March 19',
        gBeridzeCheckup: "G. Beridze \u2014 Checkup",
        nKapanadzeWhitening: "N. Kapanadze \u2014 Whitening",
        dGelashviliImplantPhase: "D. Gelashvili \u2014 Implant Phase 2",
        lunchBreak: "\u2014 Lunch Break \u2014",
        mTsiklauriOrthodontics: "M. Tsiklauri \u2014 Orthodontics",
        aJavakhishviliRootCanal: "A. Javakhishvili \u2014 Root Canal",
        lMchedlishviliExtraction: "L. Mchedlishvili \u2014 Extraction",
        tLomidzeCheckup: "T. Lomidze \u2014 Checkup",
        clinicName: 'Clinic Name',
        phone: 'Phone',
        address: 'Address',
        acceptedInsurance: 'Accepted Insurance',
        unison: 'Unison',
        saveSettings: 'Save Settings',
        aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
        openTheFullAi: "Open the full AI Assistant \u2192",
        enterprise: 'Enterprise',
        rolebasedAccessControl: 'Role-Based Access Control',
        permissionMatrix: 'Permission Matrix',
        module: 'Module',
        admin: 'Admin',
        doctor2: 'Doctor',
        hygienist: 'Hygienist',
        reception: 'Reception',
        lab: 'Lab',
        patient2: 'Patient',
        patients: 'Patients',
        full: 'Full',
        read: 'Read',
        none: 'None',
        own: 'Own',
        billing: 'Billing',
        scheduling: 'Scheduling',
        reports: 'Reports',
        settings: 'Settings',
        labOrders: 'Lab Orders',
        auditLog2: 'Audit Log',
        allTypes: 'All Types',
        last7Days: 'Last 7 days',
        complianceDashboard: 'Compliance Dashboard',
        complianceChecklist: 'Compliance Checklist',
        pass: 'PASS',
        dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
        dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
        mfaEnabledForAll: 'MFA enabled for all admin accounts',
        warn: 'WARN',
        dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
        auditLoggingActiveOn: 'Audit logging active on all modules',
        multitenancyManagement: 'Multi-Tenancy Management',
        singleSignonSso: 'Single Sign-On (SSO)',
        saml20: 'SAML 2.0',
        enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
        configured: 'Configured',
        openidConnect: 'OpenID Connect',
        oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
        available2: 'Available',
        signInWithGoogle: 'Sign in with Google organization accounts',
        connected2: 'Connected',
        azureAd: 'Azure AD',
        microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
        featureFlags2: 'Feature Flags',
        aixrayanalysis: 'ai_xray_analysis',
        aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
        voiceperio: 'voice_perio',
        voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
        patientportalv2: 'patient_portal_v2',
        nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
        whatsappreminders: 'whatsapp_reminders',
        multilanguage: 'multi_language',
        multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
        apiManagement2: 'API Management',
        requests24h: 'Requests (24h)',
        avgLatency: 'Avg Latency',
        uptime: 'Uptime',
        apiKeys: 'API Keys',
        dataManagement2: 'Data Management',
        storageUsed: 'Storage Used',
        of100Gb: 'of 100 GB',
        totalRecords: 'Total Records',
        lastBackup: 'Last Backup',
        nextIn4h: 'Next: in 4h',
        dataOperations: 'Data Operations',
        exportAllData: 'Export All Data',
        downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
        export: 'Export',
        purgeOldRecords: 'Purge Old Records',
        removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
        purge: 'Purge',
        dataMigration: 'Data Migration',
        importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
        import: 'Import',
        finance: 'Finance',
        revenueInvoicesPayments: 'Revenue, invoices & payments',
        exportReport: 'Export Report',
        monthlyRevenue: 'Monthly Revenue',
        u20be12400: '\u20BE12,400',
        pending: 'Pending',
        u20be2100: '\u20BE2,100',
        str208: '-5%',
        thisWeek: 'This Week',
        u20be3800: '\u20BE3,800',
        weeklyRevenue: 'Weekly Revenue',
        mon2: 'Mon',
        tue2: 'Tue',
        wed2: 'Wed',
        thu2: 'Thu',
        fri2: 'Fri',
        sat2: 'Sat',
        invoice: 'INVOICE',
        amount: 'AMOUNT',
        inv001: 'INV-001',
        giorgiBeridze: 'Giorgi Beridze',
        checkupXray: 'Checkup + X-ray',
        u20be80: '\u20BE80',
        inv002: 'INV-002',
        ninoKapanadze: 'Nino Kapanadze',
        whitening: 'Whitening',
        u20be120: '\u20BE120',
        inv003: 'INV-003',
        davitGelashvili: 'Davit Gelashvili',
        implantPhase1: 'Implant Phase 1',
        u20be300: '\u20BE300+',
        inv004: 'INV-004',
        anaJavakhishvili: 'Ana Javakhishvili',
        rootCanal: 'Root Canal',
        u20be149: '\u20BE149',
        u2715: '\u2715',
        configuration: 'Configuration',
        apiKey: 'API Key',
        endpointUrl: 'Endpoint URL',
        protocol: 'Protocol',
        syncSettings: 'Sync Settings',
        syncFrequency: 'Sync Frequency',
        every5Minutes: 'Every 5 minutes',
        every15Minutes: 'Every 15 minutes',
        everyHour: 'Every hour',
        manualOnly: 'Manual only',
        autosyncOnChanges: 'Auto-sync on changes',
        lastSynced: 'Last synced',
        disconnect: 'Disconnect',
        testConnection: 'Test Connection',
        labCasePipeline: 'Lab Case Pipeline',
        labVendors2: 'Lab Vendors',
        tbilisidentLab: 'TbilisiDent Lab',
        turnaround710Days: 'Turnaround: 7-10 days',
        rating485: 'Rating: 4.8/5',
        activeCases4: 'Active Cases: 4',
        caucasusDentalLab: 'Caucasus Dental Lab',
        turnaround57Days: 'Turnaround: 5-7 days',
        rating465: 'Rating: 4.6/5',
        activeCases2: 'Active Cases: 2',
        euroDentalGeorgia: 'Euro Dental Georgia',
        turnaround1014Days: 'Turnaround: 10-14 days',
        rating445: 'Rating: 4.4/5',
        enterSpaceForClinics: "Enter space for clinics \u2192",
        book: 'Book',
        followupConsultation: 'Follow-up Consultation',
        postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
        rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
        completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
        periapicalXray: 'Periapical X-ray',
        workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
        medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
        prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
        diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
        patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
        compositeFillingTooth21: 'Composite Filling - Tooth #21',
        classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
        labResultsCbcPanel: 'Lab Results: CBC Panel',
        completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
        fullmouthRadiographs: 'Full-mouth Radiographs',
        panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
        comprehensiveExamination: 'Comprehensive Examination',
        initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
        medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
        patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
        patientRegistration: 'Patient Registration',
        newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
        activeConditions: 'Active Conditions',
        chronicPeriodontitis: 'Chronic Periodontitis',
        active: 'Active',
        generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
        onsetJan2026: 'Onset: Jan 2026',
        dentalCaries: 'Dental Caries',
        resolved: 'Resolved',
        cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
        resolvedFeb2026: 'Resolved: Feb 2026',
        bruxism: 'Bruxism',
        nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
        activeMedications: 'Active Medications',
        lisinopril10mg: 'Lisinopril 10mg',
        onceDailyOral: 'Once daily, oral',
        hypertensionManagement: 'Hypertension management',
        chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
        twiceDailyOralRinse: 'Twice daily, oral rinse',
        periodontalMaintenance: 'Periodontal maintenance',
        ibuprofen400mg: 'Ibuprofen 400mg',
        asNeededForPain: 'As needed for pain, max 3x daily',
        postprocedurePainManagement: 'Post-procedure pain management',
        pastMedications: 'Past Medications',
        amoxicillin500mg: 'Amoxicillin 500mg',
        periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
        completed2: 'Completed',
        metronidazole250mg: 'Metronidazole 250mg',
        adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
        paracetamol500mg: 'Paracetamol 500mg',
        asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
        postfillingSensitivity: 'Post-filling sensitivity',
        diclofenac50mg: 'Diclofenac 50mg',
        twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
        postexamSoreness: 'Post-exam soreness',
        documentedAllergies: 'Documented Allergies',
        penicillin: 'Penicillin',
        severe: 'SEVERE',
        reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
        crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
        documentedJan102026: 'Documented: Jan 10, 2026',
        latex: 'Latex',
        moderate: 'MODERATE',
        reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
        useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
        lidocaine: 'Lidocaine',
        mild: 'MILD',
        reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
        useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
        latestVitalsMar15: "Latest Vitals \u2014 Mar 15, 2026",
        labResults2: 'Lab Results',
        test: 'TEST',
        result: 'RESULT',
        reference: 'REFERENCE',
        date: 'DATE',
        hemoglobin: 'Hemoglobin',
        platelets: 'Platelets',
        glucoseFasting: 'Glucose (fasting)',
        immunizationRecords: 'Immunization Records',
        hepatitisB: 'Hepatitis B',
        completed3doseSeries2019: 'Completed: 3-dose series, 2019',
        upToDate: 'Up to date',
        tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
        lastBooster2022: 'Last booster: 2022',
        covid19: 'COVID-19',
        lastDoseSep2024: 'Last dose: Sep 2024',
        dueForBooster: 'Due for booster',
        familyMedicalHistory: 'Family Medical History',
        father: 'Father',
        hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
        mother: 'Mother',
        osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
        sibling: 'Sibling',
        bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
        imagingRecords: 'Imaging Records',
        panoramicOpg: 'Panoramic OPG',
        periapical14: 'Periapical #14',
        bitewingRl: 'Bitewing R+L',
        patientDocuments: 'Patient Documents',
        consentFormRootCanal: 'Consent Form - Root Canal',
        treatmentPlanAgreement: 'Treatment Plan Agreement',
        medicalHistoryQuestionnaire: 'Medical History Questionnaire',
        insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
        insuranceInformation: 'Insurance Information',
        provider: 'Provider:',
        policy: 'Policy #:',
        group: 'Group:',
        corporatePlanPremium: 'Corporate Plan - Premium',
        coverage: 'Coverage:',
        deductible: 'Deductible:',
        annualMax2: 'Annual Max:',
        valid: 'Valid:',
        age34: 'Age: 34',
        lastVisitMar10: 'Last visit: Mar 10',
        nextMar19: 'Next: Mar 19',
        overview: 'Overview',
        dentalChart: 'Dental Chart',
        treatmentPlan: 'Treatment Plan',
        history: 'History',
        documents2: 'Documents',
        allergies2: 'Allergies',
        medicalNotes: 'Medical Notes',
        insurance3: 'Insurance',
        upperArch: 'Upper Arch',
        lowerArch: 'Lower Arch',
        tooth: 'TOOTH',
        procedure2: 'PROCEDURE',
        price: 'PRICE',
        rootCanalTreatment: 'Root Canal Treatment',
        ceramicCrown: 'Ceramic Crown',
        compositeFilling: 'Composite Filling',
        implantPlacement: 'Implant Placement',
        total: 'Total',
        addProcedure2: '+ Add Procedure',
        march102026: 'March 10, 2026',
        periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
        february152026: 'February 15, 2026',
        compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
        january202026: 'January 20, 2026',
        comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
        bitewingRight: 'Bitewing Right',
        bitewingLeft: 'Bitewing Left',
        uploadDocument: '+ Upload Document',
        all: 'All',
        new: 'New',
        phone2: 'PHONE',
        lastVisit: 'LAST VISIT',
        nextAppt: 'NEXT APPT',
        balance: 'BALANCE',
        pt001: 'PT-001',
        pt002: 'PT-002',
        pt003: 'PT-003',
        mariamTsiklauri: 'Mariam Tsiklauri',
        pt004: 'PT-004',
        pt005: 'PT-005',
        lukaMchedlishvili: 'Luka Mchedlishvili',
        pt006: 'PT-006',
        tamtaLomidze: 'Tamta Lomidze',
        pt007: 'PT-007',
        periodontalChart: 'Periodontal Chart',
        newExam2: '+ New Exam',
        voiceEntry2: 'Voice Entry',
        dcai: 'DCAI',
        dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
        theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
        manage: 'Manage',
        grow: 'Grow',
        marketSize: 'Market Size',
        dentalClinicsInGeorgia: 'dental clinics in Georgia',
        inTbilisiAlone: 'in Tbilisi alone',
        unifiedBookingOrOps: 'unified booking or ops platforms',
        dentosgeIsTheOnly: "\u26A0\uFE0F  dentos.ge is the only partial incumbent \u2014 no full ops layer",
        theProblem2: 'The Problem',
        str511: "\uD83D\uDCCB",
        clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
        noStructuredWorkflowConstant: 'No structured workflow, constant human error',
        str514: "\uD83D\uDCC9",
        noshowsCost1525Of: "No-shows cost 15\u201325% of revenue",
        noAutomatedRemindersOr: 'No automated reminders or confirmation system',
        str517: "\uD83C\uDFE6",
        insuranceBillingIsManual: 'Insurance billing is manual and painful',
        str519: "\uD83D\uDCF5",
        dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
        theSolution: 'The Solution',
        str523: "\uD83D\uDCC5",
        onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
        patientsBook247From: 'Patients book 24/7 from any device',
        str526: "\uD83E\uDDB7",
        patientRecordsTreatmentManagem: 'Patient records & treatment management',
        fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
        str529: "\uD83C\uDFE5",
        insuranceIntegrations: 'Insurance integrations',
        str531: "\uD83D\uDCAC",
        smsWhatsappReminders: 'SMS / WhatsApp reminders',
        cutNoshowsByUp: 'Cut no-shows by up to 40%',
        str534: "\uD83D\uDCCA",
        financialReportingDashboard: 'Financial reporting dashboard',
        revenueSalariesExpensesRealtim: "Revenue, salaries, expenses \u2014 realtime",
        willingnessToPay: 'Willingness to Pay',
        free: 'Free',
        month: '/month',
        listingBookingWidget: 'Listing + booking widget',
        growth: 'Growth',
        calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
        pro: 'Pro',
        fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
        multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
        wtp0515OfMonthly: "\uD83D\uDCA1 WTP: 0.5\u20131.5% of monthly revenue \u2014 clinics earning \u20BE15K\u201350K/mo pay \u20BE100\u2013350/mo comfortably",
        marketOpportunity: 'Market Opportunity',
        addressableClinicsAtLaunch: 'addressable clinics at launch',
        mrrAtFullPenetration: "MRR at full penetration (\u20BE49 avg)",
        home: "\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
        features: "\u0627\u0644\u0645\u064A\u0632\u0627\u062A",
        pricing: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
        clinicsNav: "\u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        aiAssistant: "\u0645\u0633\u0627\u0639\u062F AI",
        forBusiness: "\u0644\u0644\u0623\u0639\u0645\u0627\u0644",
        dashboard: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
        getStarted: "\u0627\u0628\u062F\u0623",
        tryDemo: "\u062C\u0631\u0628 \u0627\u0644\u0639\u0631\u0636",
        heroTagline: "\u0645\u0646\u0635\u0629 \u0637\u0628 \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0644\u062C\u0648\u0631\u062C\u064A\u0627",
        heroTitle: "\u0645\u0631\u0643\u0632 \u062C\u0645\u064A\u0639 \u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646",
        heroSubtitle: "\u0645\u0633\u0627\u0639\u062F\u0643 AI \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u0641\u0636\u0644 \u0631\u0639\u0627\u064A\u0629 \u0623\u0633\u0646\u0627\u0646 \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627",
        searchPlaceholder: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0639\u064A\u0627\u062F\u0627\u062A \u0623\u0648 \u062E\u062F\u0645\u0627\u062A...",
        chipImplant: "\u0623\u0641\u0636\u0644 \u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0632\u0631\u0627\u0639\u0629 \u0641\u064A \u062A\u0628\u0644\u064A\u0633\u064A",
        chipWhitening: "\u062A\u0628\u064A\u064A\u0636 \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0628\u0627\u0644\u0642\u0631\u0628 \u0645\u0646\u064A",
        chipEmergency: "\u0631\u0639\u0627\u064A\u0629 \u0623\u0633\u0646\u0627\u0646 \u0637\u0627\u0631\u0626\u0629",
        chipOrtho: "\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0644\u0644\u0628\u0627\u0644\u063A\u064A\u0646",
        scrollExplore: "\u0645\u0631\u0631 \u0644\u0644\u0627\u0633\u062A\u0643\u0634\u0627\u0641",
        topRated: "\u0623\u0641\u0636\u0644 \u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0641\u064A \u062A\u0628\u0644\u064A\u0633\u064A",
        viewAllClinics: "\u0639\u0631\u0636 \u062C\u0645\u064A\u0639 \u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        statClinics: "\u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        statNoShows: "\u063A\u064A\u0627\u0628 \u0623\u0642\u0644",
        statBooking: "\u062D\u062C\u0632 \u0639\u0628\u0631 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A",
        statDentists: "\u0623\u0637\u0628\u0627\u0621 \u0623\u0633\u0646\u0627\u0646",
        statRating: "\u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u062A\u0642\u064A\u064A\u0645",
        statPatients: "\u0627\u0644\u0645\u0631\u0636\u0649",
        findClinics: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0623\u0641\u0636\u0644 \u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        clinicsTitle: "\u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627",
        verifiedClinics: "\u0639\u064A\u0627\u062F\u0627\u062A \u0645\u0648\u062B\u0642\u0629",
        reviews: "\u062A\u0642\u064A\u064A\u0645\u0627\u062A",
        callClinic: "\u0627\u062A\u0635\u0644",
        bookAppointment: "\u0627\u062D\u062C\u0632 \u0645\u0648\u0639\u062F",
        services: "\u0627\u0644\u062E\u062F\u0645\u0627\u062A",
        workingHours: "\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644",
        priceRange: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0623\u0633\u0639\u0627\u0631",
        location: "\u0627\u0644\u0645\u0648\u0642\u0639",
        bookingTitle: "\u0627\u062D\u062C\u0632 \u0645\u0648\u0639\u062F",
        step: "\u062E\u0637\u0648\u0629",
        selectClinic: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0639\u064A\u0627\u062F\u0629",
        selectService: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062E\u062F\u0645\u0629",
        selectDate: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
        selectTime: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0648\u0642\u062A",
        confirm: "\u062A\u0623\u0643\u064A\u062F",
        next: "\u0627\u0644\u062A\u0627\u0644\u064A",
        back: "\u0631\u062C\u0648\u0639",
        viewPitch: "\u0639\u0631\u0636 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u062A\u0642\u062F\u064A\u0645\u064A",
        shareLocation: "\u0634\u0627\u0631\u0643 \u0645\u0648\u0642\u0639\u0643 \u0644\u0644\u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0642\u0631\u064A\u0628\u0629",
        locationShared: "\u062A\u0645 \u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0645\u0648\u0642\u0639 \u2014 \u0639\u0631\u0636 \u0627\u0644\u0642\u0631\u064A\u0628\u0629",
        forBusinessBtn: "\u0644\u0644\u0623\u0639\u0645\u0627\u0644",
        ownClinic: "\u0647\u0644 \u062A\u0645\u0644\u0643 \u0639\u064A\u0627\u062F\u0629 \u0623\u0633\u0646\u0627\u0646\u061F",
        claimText: "\u0633\u062C\u0651\u0644 \u0639\u064A\u0627\u062F\u062A\u0643 \u0623\u0648 \u0623\u0636\u0641\u0647\u0627 \u0625\u0644\u0649 \u0642\u0627\u0639\u062F\u0629 \u0628\u064A\u0627\u0646\u0627\u062A\u0646\u0627.",
        getListed: "\u0633\u062C\u0651\u0644 \u0627\u0644\u0622\u0646 \u2192",
        searchByName: "\u0628\u062D\u062B \u0628\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0623\u0648 \u0627\u0644\u062E\u062F\u0645\u0629...",
        hideMap: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u062E\u0631\u064A\u0637\u0629",
        showMap: "\u0627\u0644\u062E\u0631\u064A\u0637\u0629",
        nearMe: "\u0628\u0627\u0644\u0642\u0631\u0628 \u0645\u0646\u064A",
        clinicsMatch: "\u0639\u064A\u0627\u062F\u0627\u062A \u0645\u0637\u0627\u0628\u0642\u0629",
        loadingMore: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
        visitWebsite: "\u0632\u064A\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0642\u0639",
        clinicsAvailable: "\u0639\u064A\u0627\u062F\u0627\u062A \u0645\u062A\u0627\u062D\u0629",
        clinicsFound: "\u0639\u064A\u0627\u062F\u0627\u062A \u0648\u064F\u062C\u062F\u062A",
        confirmBooking: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062D\u062C\u0632",
        bookingConfirmed: "\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0645\u0648\u0639\u062F\u0643!",
        patientName: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u064A\u0636",
        phoneNumber: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641",
        email: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        notes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)",
        businessHeroBadge: "15+ \u0648\u062D\u062F\u0629  \xb7  212+ \u0639\u064A\u0627\u062F\u0629  \xb7  Gemini AI",
        businessHeroTitle: "\u0646\u0638\u0627\u0645 \u062A\u0634\u063A\u064A\u0644 \u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646",
        businessHeroSubtitle: "\u0627\u0644\u0631\u0633\u0645 \u0627\u0644\u0633\u0631\u064A\u0631\u064A\u060C \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0644\u062B\u0629\u060C \u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u0639\u0644\u0627\u062C\u060C \u0627\u0644\u062C\u062F\u0648\u0644\u0629\u060C \u0627\u0644\u0641\u0648\u062A\u0631\u0629\u060C \u0627\u0644\u0648\u0635\u0641\u0627\u062A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629\u060C \u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u062E\u062A\u0628\u0631 \u0648\u062A\u0634\u062E\u064A\u0635 AI \u2014 \u0643\u0644\u0647\u0627 \u0641\u064A \u0645\u0646\u0635\u0629 \u0648\u0627\u062D\u062F\u0629 \u0644\u062C\u0648\u0631\u062C\u064A\u0627.",
        theProblem: "\u0627\u0644\u0645\u0634\u0643\u0644\u0629",
        problemSubtitle: "\u0639\u064A\u0627\u062F\u0627\u062A \u0627\u0644\u0623\u0633\u0646\u0627\u0646 \u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629 \u062A\u062E\u0633\u0631 \u0625\u064A\u0631\u0627\u062F\u0627\u062A \u064A\u0648\u0645\u064A\u0627\u064B \u0628\u0633\u0628\u0628 \u0627\u0644\u0623\u062F\u0648\u0627\u062A \u0627\u0644\u0645\u062C\u0632\u0623\u0629",
        excelChaos: "\u0641\u0648\u0636\u0649 Excel \u0648WhatsApp",
        excelChaosDetail: "\u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A \u062A\u062F\u064A\u0631 \u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F \u0639\u0628\u0631 \u0627\u0644\u062C\u062F\u0627\u0648\u0644 \u0648\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u062F\u0631\u062F\u0634\u0629. \u0635\u0641\u0631 \u0623\u062A\u0645\u062A\u0629\u060C \u0623\u062E\u0637\u0627\u0621 \u0645\u0633\u062A\u0645\u0631\u0629.",
        noShowRate: "\u0645\u0639\u062F\u0644 \u063A\u064A\u0627\u0628 25%",
        noShowDetail: "\u0628\u062F\u0648\u0646 \u062A\u0630\u0643\u064A\u0631\u0627\u062A \u062A\u0644\u0642\u0627\u0626\u064A\u0629\u060C \u064A\u0646\u0633\u0649 \u0627\u0644\u0645\u0631\u0636\u0649 \u0627\u0644\u0645\u0648\u0627\u0639\u064A\u062F. \u0627\u0644\u0643\u0631\u0627\u0633\u064A \u0627\u0644\u0641\u0627\u0631\u063A\u0629 \u062A\u0639\u0646\u064A \u062E\u0633\u0627\u0631\u0629 \u20BE500+/\u064A\u0648\u0645.",
        paperCharts: "\u0633\u062C\u0644\u0627\u062A \u0648\u0631\u0642\u064A\u0629 \u0641\u064A 2026",
        paperChartsDetail: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0633\u0631\u064A\u0631\u064A\u0629 \u0645\u0643\u062A\u0648\u0628\u0629 \u0628\u062E\u0637 \u0627\u0644\u064A\u062F\u060C \u0628\u062F\u0648\u0646 \u0645\u062E\u0637\u0637 \u0623\u0633\u0646\u0627\u0646 \u0631\u0642\u0645\u064A. \u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0631\u062C\u0629 \u0645\u062D\u0628\u0648\u0633\u0629 \u0641\u064A \u0627\u0644\u062E\u0632\u0627\u0626\u0646.",
        insuranceBlackHole: "\u0627\u0644\u062B\u0642\u0628 \u0627\u0644\u0623\u0633\u0648\u062F \u0644\u0644\u062A\u0623\u0645\u064A\u0646",
        insuranceDetail: "\u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062A \u0627\u0644\u064A\u062F\u0648\u064A\u0629 \u0625\u0644\u0649 Aldagi \u0648GPI \u0648Imedi L \u062A\u0633\u062A\u063A\u0631\u0642 \u0633\u0627\u0639\u0627\u062A. \u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0648\u0636\u0629 \u062A\u062A\u0631\u0627\u0643\u0645.",
        oneplatform: "\u0645\u0646\u0635\u0629 \u0648\u0627\u062D\u062F\u0629\u060C \u0643\u0644 \u0627\u0644\u0648\u062D\u062F\u0627\u062A",
        platformSubtitle: "15 \u0648\u062D\u062F\u0629 \u0645\u062A\u0643\u0627\u0645\u0644\u0629 \u0645\u0635\u0645\u0645\u0629 \u0644\u0645\u0645\u0627\u0631\u0633\u0627\u062A \u0637\u0628 \u0627\u0644\u0623\u0633\u0646\u0627\u0646",
        clinical: "\u0633\u0631\u064A\u0631\u064A",
        operations: "\u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A",
        analyticsEnterprise: "\u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0648\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        digitalOdontogram: "\u0645\u062E\u0637\u0637 \u0623\u0633\u0646\u0627\u0646 \u0631\u0642\u0645\u064A",
        digitalOdontogramDetail: "\u0645\u062E\u0637\u0637 FDI 32 \u0633\u0646 \u0645\u0639 \u062A\u062A\u0628\u0639 5 \u0623\u0633\u0637\u062D.",
        perioCharting: "\u0631\u0633\u0645 \u0627\u0644\u0644\u062B\u0629",
        perioChartingDetail: "\u0634\u0628\u0643\u0629 \u0644\u062B\u0648\u064A\u0629 192 \u0646\u0642\u0637\u0629. \u0633\u0628\u0631 6 \u0646\u0642\u0627\u0637\u060C BOP\u060C CAL.",
        treatmentPlanning: "\u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u0639\u0644\u0627\u062C",
        treatmentPlanningDetail: "\u062E\u0637\u0637 \u0645\u0631\u062D\u0644\u064A\u0629 \u0645\u0639 \u0623\u0643\u0648\u0627\u062F CDT\u060C \u062A\u0642\u062F\u064A\u0631\u0627\u062A \u0627\u0644\u062A\u0623\u0645\u064A\u0646. \u062A\u0633\u0644\u0633\u0644 AI.",
        soapNotes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A SOAP + \u0643\u0627\u062A\u0628 AI",
        soapNotesDetail: "\u062A\u0648\u062B\u064A\u0642 \u0633\u0631\u064A\u0631\u064A \u0645\u0646\u0638\u0645 \u0628\u0642\u0648\u0627\u0644\u0628. Gemini \u064A\u0648\u0644\u062F \u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0645\u0646 \u0627\u0644\u0635\u0648\u062A.",
        multiChairScheduling: "\u062C\u062F\u0648\u0644\u0629 \u0645\u062A\u0639\u062F\u062F\u0629 \u0627\u0644\u0643\u0631\u0627\u0633\u064A",
        multiChairDetail: "\u0639\u0631\u0636 \u0623\u0633\u0628\u0648\u0639\u064A \u0645\u0639 \u0639\u062F\u0629 \u063A\u0631\u0641 \u0639\u0645\u0644\u064A\u0627\u062A. \u062A\u0631\u0645\u064A\u0632 \u0644\u0648\u0646\u064A \u0644\u0644\u0623\u0637\u0628\u0627\u0621.",
        billingInsurance: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629 \u0648\u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        billingDetail: "\u062A\u062A\u0628\u0639 \u0645\u0637\u0627\u0644\u0628\u0627\u062A Aldagi \u0648GPI \u0648Imedi L. \u062F\u0641\u062A\u0631 \u0627\u0644\u0645\u0631\u064A\u0636\u060C \u062E\u0637\u0637 \u0627\u0644\u062F\u0641\u0639.",
        ePrescribing: "\u0627\u0644\u0648\u0635\u0641\u0627\u062A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629",
        ePrescribingDetail: "\u0648\u0635\u0641\u0627\u062A \u0631\u0642\u0645\u064A\u0629 \u0628\u0642\u0648\u0627\u0644\u0628. \u0641\u062D\u0635 \u062A\u0641\u0627\u0639\u0644\u0627\u062A \u0627\u0644\u0623\u062F\u0648\u064A\u0629 \u0639\u0628\u0631 Gemini.",
        labTracking: "\u062A\u062A\u0628\u0639 \u0627\u0644\u0645\u062E\u062A\u0628\u0631",
        labTrackingDetail: "\u0643\u0627\u0646\u0628\u0627\u0646: \u062A\u0645 \u0627\u0644\u0637\u0644\u0628 \u2192 \u0627\u0644\u062A\u0635\u0646\u064A\u0639 \u2192 \u0627\u0644\u0634\u062D\u0646 \u2192 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645.",
        productionReports: "\u062A\u0642\u0627\u0631\u064A\u0631 \u0627\u0644\u0625\u0646\u062A\u0627\u062C",
        productionReportsDetail: "\u0627\u0644\u0625\u0646\u062A\u0627\u062C \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A/\u0627\u0644\u0635\u0627\u0641\u064A\u060C \u0645\u0639\u062F\u0644 \u0627\u0644\u062A\u062D\u0635\u064A\u0644\u060C \u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0644\u0627\u062C.",
        referralMgmt: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A",
        referralMgmtDetail: "\u0625\u062D\u0627\u0644\u0627\u062A \u0648\u0627\u0631\u062F\u0629/\u0635\u0627\u062F\u0631\u0629 \u0644\u0644\u0645\u062A\u062E\u0635\u0635\u064A\u0646. \u062E\u0637\u0627\u0628\u0627\u062A \u0645\u0648\u0644\u062F\u0629 \u0628\u0627\u0644\u0640 AI.",
        medicalHistory: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0628\u064A",
        medicalHistoryDetail: "\u0633\u062C\u0644 \u0645\u0631\u064A\u0636 11 \u0639\u0631\u0636: \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A\u060C \u0627\u0644\u062D\u0627\u0644\u0627\u062A\u060C \u0627\u0644\u0623\u062F\u0648\u064A\u0629\u060C \u0627\u0644\u062D\u0633\u0627\u0633\u064A\u0627\u062A.",
        enterpriseAdmin: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        enterpriseAdminDetail: "RBAC\u060C \u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642\u060C \u0627\u0644\u0627\u0645\u062A\u062B\u0627\u0644\u060C \u062A\u0639\u062F\u062F \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631\u064A\u0646\u060C SSO\u060C \u0625\u062F\u0627\u0631\u0629 API.",
        geminiBuiltIn: "Gemini AI \u0645\u062F\u0645\u062C",
        geminiSubtitle: "\u0643\u0644 \u0648\u062D\u062F\u0629 \u0645\u062F\u0639\u0648\u0645\u0629 \u0628\u0640 Google Gemini 3.1",
        xrayAnalysis: "\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0623\u0634\u0639\u0629 \u0627\u0644\u0633\u064A\u0646\u064A\u0629",
        xrayDetail: "\u0627\u0631\u0641\u0639 \u0635\u0648\u0631 \u0627\u0644\u0623\u0634\u0639\u0629 \u0627\u0644\u0633\u064A\u0646\u064A\u0629 \u0644\u0644\u0623\u0633\u0646\u0627\u0646 \u0644\u0644\u0643\u0634\u0641 \u0639\u0646 \u0627\u0644\u062A\u0633\u0648\u0633 \u0628\u0627\u0644\u0640 AI.",
        perioAssessment: "\u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0644\u062B\u0629",
        perioAssessmentDetail: "\u062A\u0635\u0646\u064A\u0641/\u062A\u062F\u0631\u064A\u062C AAP \u062A\u0644\u0642\u0627\u0626\u064A \u0645\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0633\u0628\u0631.",
        clinicalScribe: "\u0627\u0644\u0643\u0627\u062A\u0628 \u0627\u0644\u0633\u0631\u064A\u0631\u064A",
        clinicalScribeDetail: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0627\u062D\u0638\u0627\u062A SOAP \u0645\u0646 \u0627\u0644\u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u0635\u0648\u062A\u064A\u0629 \u0623\u0648 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0633\u062C\u0644.",
        riskProfiling: "\u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0645\u062E\u0627\u0637\u0631",
        riskProfilingDetail: "\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u062D\u0627\u0644\u0627\u062A \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0639\u0627\u0626\u0644\u064A \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0641 \u0645\u062E\u0627\u0637\u0631 \u0627\u0644\u0623\u0633\u0646\u0627\u0646.",
        treatmentSequencing: "\u062A\u0633\u0644\u0633\u0644 \u0627\u0644\u0639\u0644\u0627\u062C",
        treatmentSequencingDetail: "\u062A\u0633\u0644\u0633\u0644 \u0639\u0644\u0627\u062C \u0645\u062D\u0633\u0651\u0646 \u0628\u0627\u0644\u0640 AI \u0645\u0639 \u0645\u0631\u0627\u0639\u0627\u0629 \u0627\u0644\u0634\u0641\u0627\u0621 \u0648\u0627\u0644\u062A\u0623\u0645\u064A\u0646.",
        patientComm: "\u062A\u0648\u0627\u0635\u0644 \u0627\u0644\u0645\u0631\u064A\u0636",
        patientCommDetail: "\u0625\u0646\u0634\u0627\u0621 \u0634\u0631\u0648\u062D\u0627\u062A \u0645\u0641\u0647\u0648\u0645\u0629 \u0644\u0644\u0645\u0631\u064A\u0636 \u0628\u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629.",
        georgianEcosystem: "\u0627\u0644\u0646\u0638\u0627\u0645 \u0627\u0644\u0628\u064A\u0626\u064A \u0627\u0644\u062C\u0648\u0631\u062C\u064A \u062C\u0627\u0647\u0632",
        integrationsSubtitle: "\u062A\u0643\u0627\u0645\u0644\u0627\u062A \u0645\u0633\u0628\u0642\u0629 \u0645\u0639 \u0627\u0644\u062A\u0623\u0645\u064A\u0646 \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u0645\u0631\u0627\u0633\u0644\u0627\u062A \u0627\u0644\u0645\u062D\u0644\u064A\u0629",
        insurance: "\u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        payments: "\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
        messaging: "\u0627\u0644\u0645\u0631\u0627\u0633\u0644\u0627\u062A",
        ehrLabs: "\u0627\u0644\u0633\u062C\u0644 \u0627\u0644\u0635\u062D\u064A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0627\u0644\u0645\u062E\u062A\u0628\u0631\u0627\u062A",
        clinicsInDb: "\u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A \u0641\u064A \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
        platformModules: "\u0648\u062D\u062F\u0627\u062A \u0627\u0644\u0645\u0646\u0635\u0629",
        aiTools: "\u0623\u062F\u0648\u0627\u062A AI (Gemini)",
        integrations: "\u0627\u0644\u062A\u0643\u0627\u0645\u0644\u0627\u062A",
        pricingTitle: "\u0627\u0644\u0623\u0633\u0639\u0627\u0631",
        pricingSubtitle: "\u0627\u0628\u062F\u0623 \u0645\u062C\u0627\u0646\u0627\u064B\u060C \u062A\u0648\u0633\u0639 \u0645\u0639 \u0627\u0644\u0646\u0645\u0648",
        trustedBy: "\u062B\u0642\u0629 \u0627\u0644\u0639\u064A\u0627\u062F\u0627\u062A",
        readyModernize: "\u0645\u0633\u062A\u0639\u062F \u0644\u0644\u062A\u062D\u062F\u064A\u062B\u061F",
        joinCount: "\u0627\u0646\u0636\u0645 \u0625\u0644\u0649 212+ \u0639\u064A\u0627\u062F\u0629 \u0641\u064A \u062C\u0648\u0631\u062C\u064A\u0627.",
        startTrial: "\u0627\u0628\u062F\u0623 \u0645\u062C\u0627\u0646\u0627\u064B",
        contactSales: "\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A",
        noCreditCard: "\u0644\u0627 \u062D\u0627\u062C\u0629 \u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0626\u062A\u0645\u0627\u0646  \xb7  \u062E\u0637\u0629 \u0645\u062C\u0627\u0646\u064A\u0629  \xb7  \u0625\u0639\u062F\u0627\u062F \u0641\u064A 5 \u062F\u0642\u0627\u0626\u0642",
        copyright: "\xa9 2026 MCAI",
        // ─── NEW KEYS ────────────────────────────────────────
        // Navigation & Layout
        navDashboard: "\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645",
        navPatients: "\u0627\u0644\u0645\u0631\u0636\u0649",
        navChart: "\u0627\u0644\u0633\u062C\u0644",
        navPerio: "\u0627\u0644\u0644\u062B\u0629",
        navTreatmentPlans: "\u062E\u0637\u0637 \u0627\u0644\u0639\u0644\u0627\u062C",
        navNotes: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        navScheduling: "\u0627\u0644\u062C\u062F\u0648\u0644\u0629",
        navBilling: "\u0627\u0644\u0641\u0648\u062A\u0631\u0629",
        navPrescriptions: "\u0627\u0644\u0648\u0635\u0641\u0627\u062A",
        navLabCases: "\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u062E\u062A\u0628\u0631",
        navReferrals: "\u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A",
        navReports: "\u0627\u0644\u062A\u0642\u0627\u0631\u064A\u0631",
        navMedHistory: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0637\u0628\u064A",
        navIntegrations: "\u0627\u0644\u062A\u0643\u0627\u0645\u0644\u0627\u062A",
        navEnterprise: "\u0627\u0644\u0645\u0624\u0633\u0633\u0629",
        sectionClinical: "\u0633\u0631\u064A\u0631\u064A",
        sectionOperations: "\u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A",
        sectionAnalytics: "\u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A",
        sectionAiTools: "\u0623\u062F\u0648\u0627\u062A AI",
        sectionAdmin: "\u0627\u0644\u0625\u062F\u0627\u0631\u0629",
        // Booking Page
        chooseClinic: "\u0627\u062E\u062A\u0631 \u0639\u064A\u0627\u062F\u0629",
        selectAService: "\u0627\u062E\u062A\u0631 \u062E\u062F\u0645\u0629",
        pickADate: "\u0627\u062E\u062A\u0631 \u062A\u0627\u0631\u064A\u062E\u0627\u064B",
        pickATime: "\u0627\u062E\u062A\u0631 \u0648\u0642\u062A\u0627\u064B",
        confirmYourBooking: "\u0623\u0643\u062F \u062D\u062C\u0632\u0643",
        clinicLabel: "\u0627\u0644\u0639\u064A\u0627\u062F\u0629:",
        serviceLabel: "\u0627\u0644\u062E\u062F\u0645\u0629:",
        dateLabel: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E:",
        timeLabel: "\u0627\u0644\u0648\u0642\u062A:",
        // AI Page
        send: "\u0625\u0631\u0633\u0627\u0644",
        procedure: "\u0625\u062C\u0631\u0627\u0621",
        observations: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        aiThinking: "AI \u064A\u0641\u0643\u0631...",
        summarizeHistory: "\u062A\u0644\u062E\u064A\u0635 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0631\u064A\u0636",
        generateTxPlan: "\u0625\u0646\u0634\u0627\u0621 \u062E\u0637\u0629 \u0639\u0644\u0627\u062C",
        checkDrugInteractions: "\u0641\u062D\u0635 \u062A\u0641\u0627\u0639\u0644\u0627\u062A \u0627\u0644\u0623\u062F\u0648\u064A\u0629",
        writeClinicalNote: "\u0643\u062A\u0627\u0628\u0629 \u0645\u0644\u0627\u062D\u0638\u0629 \u0633\u0631\u064A\u0631\u064A\u0629",
        askAiAssistant: "\u0627\u0633\u0623\u0644 \u0645\u0633\u0627\u0639\u062F AI...",
        dropXray: "\u0623\u0633\u0642\u0637 \u0635\u0648\u0631\u0629 \u0627\u0644\u0623\u0634\u0639\u0629 \u0623\u0648 \u0627\u0646\u0642\u0631 \u0644\u0644\u0631\u0641\u0639",
        supportsFormats: "\u064A\u062F\u0639\u0645 DICOM\u060C PNG\u060C JPG",
        analysisResults: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u062A\u062D\u0644\u064A\u0644 (\u0639\u0631\u0636)",
        aiRecommendation: "\u062A\u0648\u0635\u064A\u0629 AI",
        exportToTxPlan: "\u062A\u0635\u062F\u064A\u0631 \u0625\u0644\u0649 \u062E\u0637\u0629 \u0627\u0644\u0639\u0644\u0627\u062C",
        generateClinicalNote: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0627\u062D\u0638\u0629 \u0633\u0631\u064A\u0631\u064A\u0629",
        generatedSoap: "\u0645\u0644\u0627\u062D\u0638\u0629 \u0633\u0631\u064A\u0631\u064A\u0629 \u0645\u064F\u0646\u0634\u0623\u0629 (SOAP)",
        subjective: "S \u2014 \u0630\u0627\u062A\u064A",
        objective: "O \u2014 \u0645\u0648\u0636\u0648\u0639\u064A",
        assessment: "A \u2014 \u0627\u0644\u062A\u0642\u064A\u064A\u0645",
        plan: "P \u2014 \u0627\u0644\u062E\u0637\u0629",
        copyToRecord: "\u0646\u0633\u062E \u0625\u0644\u0649 \u0633\u062C\u0644 \u0627\u0644\u0645\u0631\u064A\u0636",
        aiPerioAssessment: "\u062A\u0642\u064A\u064A\u0645 AI \u0644\u0623\u0645\u0631\u0627\u0636 \u0627\u0644\u0644\u062B\u0629",
        enterProbingData: "\u0623\u062F\u062E\u0644 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0633\u0628\u0631 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u0635\u0646\u064A\u0641 AAP \u0648\u062A\u0648\u0635\u064A\u0627\u062A \u0627\u0644\u0639\u0644\u0627\u062C.",
        analyzeWithGemini: "\u062A\u062D\u0644\u064A\u0644 \u0645\u0639 Gemini",
        aiRiskAssessment: "\u062A\u0642\u064A\u064A\u0645 AI \u0644\u0644\u0645\u062E\u0627\u0637\u0631",
        enterConditions: "\u0623\u062F\u062E\u0644 \u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0645\u0631\u064A\u0636 \u0648\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0639\u0627\u0626\u0644\u064A \u0648\u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062D\u064A\u0648\u064A\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0641 \u0627\u0644\u0645\u062E\u0627\u0637\u0631.",
        generateRiskProfile: "\u0625\u0646\u0634\u0627\u0621 \u0645\u0644\u0641 \u0627\u0644\u0645\u062E\u0627\u0637\u0631",
        patientCommunication: "\u062A\u0648\u0627\u0635\u0644 \u0627\u0644\u0645\u0631\u064A\u0636",
        generateExplanations: "\u0625\u0646\u0634\u0627\u0621 \u0634\u0631\u0648\u062D\u0627\u062A \u0639\u0644\u0627\u062C\u064A\u0629 \u0645\u0641\u0647\u0648\u0645\u0629 \u0644\u0644\u0645\u0631\u064A\u0636 \u0628\u0627\u0644\u062C\u0648\u0631\u062C\u064A\u0629 \u0623\u0648 \u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629.",
        generateExplanation: "\u0625\u0646\u0634\u0627\u0621 \u0634\u0631\u062D",
        patientFriendly: "\u0634\u0631\u062D \u0645\u0641\u0647\u0648\u0645 \u0644\u0644\u0645\u0631\u064A\u0636",
        // Billing Page
        claims: "\u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062A",
        ledger: "\u062F\u0641\u062A\u0631 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A",
        aging: "\u062A\u0642\u0627\u062F\u0645 \u0627\u0644\u062F\u064A\u0648\u0646",
        paymentPlans: "\u062E\u0637\u0637 \u0627\u0644\u062F\u0641\u0639",
        eligibility: "\u0627\u0644\u0623\u0647\u0644\u064A\u0629",
        allFilter: "\u0627\u0644\u0643\u0644",
        submitted: "\u0645\u0642\u062F\u0645",
        paid: "\u0645\u062F\u0641\u0648\u0639",
        denied: "\u0645\u0631\u0641\u0648\u0636",
        patientLedger: "\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0631\u064A\u0636",
        agedAccounts: "\u062D\u0633\u0627\u0628\u0627\u062A \u0645\u062A\u0623\u062E\u0631\u0629",
        sendStatements: "\u0625\u0631\u0633\u0627\u0644 \u0643\u0634\u0648\u0641\u0627\u062A",
        activePaymentPlans: "\u062E\u0637\u0637 \u062F\u0641\u0639 \u0646\u0634\u0637\u0629",
        insuranceEligibility: "\u0623\u0647\u0644\u064A\u0629 \u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        // Clinical Charting
        odontogram: "\u0645\u062E\u0637\u0637 \u0627\u0644\u0623\u0633\u0646\u0627\u0646",
        perioTab: "\u0627\u0644\u0644\u062B\u0629",
        treatmentPlanTab: "\u062E\u0637\u0629 \u0627\u0644\u0639\u0644\u0627\u062C",
        notesTab: "\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
        progressNotes: "\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0627\u0644\u062A\u0642\u062F\u0645",
        openFullPerio: "\u0641\u062A\u062D \u0645\u062E\u0637\u0637 \u0627\u0644\u0644\u062B\u0629 \u0627\u0644\u0643\u0627\u0645\u0644 \u2192",
        openFullTxPlanner: "\u0641\u062A\u062D \u0645\u062E\u0637\u0637 \u0627\u0644\u0639\u0644\u0627\u062C \u0627\u0644\u0643\u0627\u0645\u0644 \u2192",
        openClinicalNotes: "\u0641\u062A\u062D \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0627\u0644\u0633\u0631\u064A\u0631\u064A\u0629 \u2192",
        newExam: "\u0641\u062D\u0635 \u062C\u062F\u064A\u062F",
        voiceEntry: "\u0625\u062F\u062E\u0627\u0644 \u0635\u0648\u062A\u064A",
        bleedingIndex: "\u0645\u0624\u0634\u0631 \u0627\u0644\u0646\u0632\u064A\u0641",
        plaqueIndex: "\u0645\u0624\u0634\u0631 \u0627\u0644\u0644\u0648\u064A\u062D\u0629",
        sitesAbove4: "\u0645\u0648\u0627\u0642\u0639 \u2265 4\u0645\u0645",
        sitesAbove6: "\u0645\u0648\u0627\u0642\u0639 \u2265 6\u0645\u0645",
        planA: "\u0627\u0644\u062E\u0637\u0629 \u0623: \u0627\u0644\u0645\u0648\u0635\u0649 \u0628\u0647\u0627",
        planB: "\u0627\u0644\u062E\u0637\u0629 \u0628: \u0627\u0644\u062A\u062D\u0641\u0638\u064A\u0629",
        newPlan: "+ \u062E\u0637\u0629 \u062C\u062F\u064A\u062F\u0629",
        presentToPatient: "\u062A\u0642\u062F\u064A\u0645 \u0644\u0644\u0645\u0631\u064A\u0636",
        sendToPortal: "\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u0628\u0648\u0627\u0628\u0629",
        totalFee: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0631\u0633\u0648\u0645",
        insuranceEst: "\u062A\u0642\u062F\u064A\u0631 \u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        patientPortion: "\u062D\u0635\u0629 \u0627\u0644\u0645\u0631\u064A\u0636",
        chairSideMode: "\u0648\u0636\u0639 \u062C\u0627\u0646\u0628 \u0627\u0644\u0643\u0631\u0633\u064A",
        adminMode: "\u0648\u0636\u0639 \u0627\u0644\u0645\u0633\u0624\u0648\u0644",
        proceduresAcrossPhases: "{0} \u0625\u062C\u0631\u0627\u0621 \u0639\u0628\u0631 {1} \u0645\u0631\u0627\u062D\u0644",
        // Scheduling
        day: "\u064A\u0648\u0645",
        week: "\u0623\u0633\u0628\u0648\u0639",
        today: "\u0627\u0644\u064A\u0648\u0645",
        providerFilter: "\u062C\u0645\u064A\u0639 \u0645\u0642\u062F\u0645\u064A \u0627\u0644\u062E\u062F\u0645\u0629",
        productionGoal: "\u0647\u062F\u0641 \u0627\u0644\u0625\u0646\u062A\u0627\u062C",
        waitlist: "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
        // Prescriptions
        activeRx: "\u0646\u0634\u0637\u0629",
        pastRx: "\u0633\u0627\u0628\u0642\u0629",
        templates: "\u0642\u0648\u0627\u0644\u0628",
        interactionCheck: "\u0641\u062D\u0635 \u0627\u0644\u062A\u0641\u0627\u0639\u0644\u0627\u062A",
        // Lab Cases
        ordered: "\u062A\u0645 \u0627\u0644\u0637\u0644\u0628",
        sentToLab: "\u0623\u064F\u0631\u0633\u0644 \u0644\u0644\u0645\u062E\u062A\u0628\u0631",
        inFabrication: "\u0642\u064A\u062F \u0627\u0644\u062A\u0635\u0646\u064A\u0639",
        shipped: "\u062A\u0645 \u0627\u0644\u0634\u062D\u0646",
        received: "\u062A\u0645 \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645",
        labVendors: "\u0645\u0648\u0631\u062F\u0648 \u0627\u0644\u0645\u062E\u062A\u0628\u0631\u0627\u062A",
        // Referrals
        allDirections: "\u0627\u0644\u0643\u0644",
        inbound: "\u0648\u0627\u0631\u062F\u0629",
        outbound: "\u0635\u0627\u062F\u0631\u0629",
        generateLetter: "\u0625\u0646\u0634\u0627\u0621 \u062E\u0637\u0627\u0628",
        // Reports
        production: "\u0627\u0644\u0625\u0646\u062A\u0627\u062C",
        collections: "\u0627\u0644\u062A\u062D\u0635\u064A\u0644\u0627\u062A",
        schedulingReport: "\u0627\u0644\u062C\u062F\u0648\u0644\u0629",
        treatmentAcceptance: "\u0642\u0628\u0648\u0644 \u0627\u0644\u0639\u0644\u0627\u062C",
        recall: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u0633\u062A\u062F\u0639\u0627\u0621",
        grossProduction: "\u0627\u0644\u0625\u0646\u062A\u0627\u062C \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A",
        netProduction: "\u0627\u0644\u0625\u0646\u062A\u0627\u062C \u0627\u0644\u0635\u0627\u0641\u064A",
        collectionRate: "\u0645\u0639\u062F\u0644 \u0627\u0644\u062A\u062D\u0635\u064A\u0644",
        plansPresented: "\u0627\u0644\u062E\u0637\u0637 \u0627\u0644\u0645\u0642\u062F\u0645\u0629",
        accepted: "\u0645\u0642\u0628\u0648\u0644",
        acceptanceRate: "\u0645\u0639\u062F\u0644 \u0627\u0644\u0642\u0628\u0648\u0644",
        dueThisMonth: "\u0645\u0633\u062A\u062D\u0642 \u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
        scheduled: "\u0645\u062C\u062F\u0648\u0644",
        completed: "\u0645\u0643\u062A\u0645\u0644",
        overdue: "\u0645\u062A\u0623\u062E\u0631",
        reactivationRate: "\u0645\u0639\u062F\u0644 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0646\u0634\u064A\u0637",
        // Medical History
        timeline: "\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A",
        conditions: "\u0627\u0644\u062D\u0627\u0644\u0627\u062A",
        medications: "\u0627\u0644\u0623\u062F\u0648\u064A\u0629",
        allergies: "\u0627\u0644\u062D\u0633\u0627\u0633\u064A\u0627\u062A",
        labResults: "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0645\u062E\u062A\u0628\u0631",
        vitals: "\u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062D\u064A\u0648\u064A\u0629",
        immunizations: "\u0627\u0644\u062A\u0637\u0639\u064A\u0645\u0627\u062A",
        familyHistory: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0639\u0627\u0626\u0644\u064A",
        imaging: "\u0627\u0644\u062A\u0635\u0648\u064A\u0631",
        documents: "\u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A",
        // Enterprise
        rbac: 'RBAC',
        auditLog: "\u0633\u062C\u0644 \u0627\u0644\u062A\u062F\u0642\u064A\u0642",
        compliance: "\u0627\u0644\u0627\u0645\u062A\u062B\u0627\u0644",
        multiTenancy: "\u062A\u0639\u062F\u062F \u0627\u0644\u0645\u0633\u062A\u0623\u062C\u0631\u064A\u0646",
        sso: "SSO \u0648\u0627\u0644\u0623\u0645\u0627\u0646",
        featureFlags: "\u0623\u0639\u0644\u0627\u0645 \u0627\u0644\u0645\u064A\u0632\u0627\u062A",
        apiManagement: "\u0625\u062F\u0627\u0631\u0629 API",
        dataManagement: "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
        // Integrations
        ehr: "\u0627\u0644\u0633\u062C\u0644 \u0627\u0644\u0635\u062D\u064A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        labs: "\u0627\u0644\u0645\u062E\u062A\u0628\u0631\u0627\u062A",
        telehealth: "\u0627\u0644\u0637\u0628 \u0639\u0646 \u0628\u064F\u0639\u062F",
        aiMl: 'AI/ML',
        wearables: "\u0627\u0644\u0623\u062C\u0647\u0632\u0629 \u0627\u0644\u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0627\u0631\u062A\u062F\u0627\u0621",
        connected: "\u0645\u062A\u0635\u0644",
        disconnected: "\u063A\u064A\u0631 \u0645\u062A\u0635\u0644",
        available: "\u0645\u062A\u0627\u062D",
        // Components
        status: "\u0627\u0644\u062D\u0627\u0644\u0629",
        healthy: "\u0633\u0644\u064A\u0645",
        caries: "\u062A\u0633\u0648\u0633",
        restored: "\u0645\u0631\u0645\u0645",
        missing: "\u0645\u0641\u0642\u0648\u062F",
        implant: "\u0632\u0631\u0639\u0629",
        crownStatus: "\u062A\u0627\u062C",
        bridge: "\u062C\u0633\u0631",
        veneer: "\u0642\u0634\u0631\u0629",
        surfaces: "\u0627\u0644\u0623\u0633\u0637\u062D",
        procedureHistory: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
        addProcedure: "\u0625\u0636\u0627\u0641\u0629 \u0625\u062C\u0631\u0627\u0621",
        totalCharged: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u062D\u0645\u0651\u0644",
        insurancePayment: "\u062F\u0641\u0639\u0629 \u0627\u0644\u062A\u0623\u0645\u064A\u0646",
        patientResponsibility: "\u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0627\u0644\u0645\u0631\u064A\u0636",
        expand: "\u062A\u0648\u0633\u064A\u0639",
        policyNumber: "\u0631\u0642\u0645 \u0627\u0644\u0628\u0648\u0644\u064A\u0635\u0629",
        planType: "\u0646\u0648\u0639 \u0627\u0644\u062E\u0637\u0629",
        annualMax: "\u0627\u0644\u062D\u062F \u0627\u0644\u0633\u0646\u0648\u064A \u0627\u0644\u0623\u0642\u0635\u0649",
        used: "\u0645\u0633\u062A\u062E\u062F\u0645",
        remaining: "\u0645\u062A\u0628\u0642\u064A",
        coverageByCategory: "\u0627\u0644\u062A\u063A\u0637\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0641\u0626\u0629",
        preventive: "\u0648\u0642\u0627\u0626\u064A",
        basic: "\u0623\u0633\u0627\u0633\u064A",
        major: "\u0631\u0626\u064A\u0633\u064A",
        ortho: "\u062A\u0642\u0648\u064A\u0645",
        current: "\u062D\u0627\u0644\u064A",
        thirtyDay: "30 \u064A\u0648\u0645",
        sixtyDay: "60 \u064A\u0648\u0645",
        ninetyPlus: "90+ \u064A\u0648\u0645",
        totalBalance: "\u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A",
        monthlyPayment: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0634\u0647\u0631\u064A\u0629",
        paymentsRemaining: "\u0627\u0644\u062F\u0641\u0639\u0627\u062A \u0627\u0644\u0645\u062A\u0628\u0642\u064A\u0629",
        nextPayment: "\u0627\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
        paymentProgress: "\u062A\u0642\u062F\u0645 \u0627\u0644\u062F\u0641\u0639",
        choosePlan: "\u0627\u062E\u062A\u0631 \u062E\u0637\u0629",
        aiInsight: "\u0631\u0624\u064A\u0629 AI",
        confidence: "\u0627\u0644\u062B\u0642\u0629",
        revoke: "\u0625\u0644\u063A\u0627\u0621",
        exams: "\u0627\u0644\u0641\u062D\u0648\u0635\u0627\u062A",
        phaseTotal: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u0631\u062D\u0644\u0629",
        mon: "\u0627\u062B\u0646",
        tue: "\u062B\u0644\u0627",
        wed: "\u0623\u0631\u0628",
        thu: "\u062E\u0645\u064A",
        fri: "\u062C\u0645\u0639",
        sat: "\u0633\u0628\u062A",
        sun: "\u0623\u062D\u062F",
        thinking: "\u064A\u0641\u0643\u0631...",
        followUpPlaceholder: "\u0627\u0637\u0631\u062D \u0633\u0624\u0627\u0644 \u0645\u062A\u0627\u0628\u0639\u0629...",
        initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
        nextExpansionArmeniaAzerbaijan: "\uD83C\uDF0D  Next expansion: Armenia \u2192 Azerbaijan \u2192 broader Caucasus dental market",
        whyNow: 'Why Now',
        str561: "\u2708\uFE0F",
        dentalTourismBoom: 'Dental tourism boom',
        internationalPatientsNeedEngli: 'International patients need English-language online booking now',
        str564: "\uD83D\uDCF1",
        postcovidDigitizationPressure: 'Post-COVID digitization pressure',
        clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
        str567: "\uD83C\uDFC6",
        noStrongLocalIncumbent: 'No strong local incumbent',
        dentosgeOnlyCoversDiscovery: "dentos.ge only covers discovery \u2014 zero full ops platform exists",
        str570: "\uD83C\uDDEC\uD83C\uDDEA",
        georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
        lowCostHighQuality: "Low cost, high quality \u2014 50\u201370% cheaper than Western Europe",
        joinThePartnerClinic: "Join the Partner Clinic Program \u2014 first 3 months free",
        builtForGeorgianClinics: "\uD83E\uDDB7 Built for Georgian clinics, by people who live here",
        prev: "\u2190 Prev",
        next2: "Next \u2192",
        getInTouch: "\uD83E\uDDB7 Get in Touch",
        activePrescriptions: 'Active Prescriptions',
        pastPrescriptions: 'Past Prescriptions',
        prescriptionTemplates: 'Prescription Templates',
        drugInteractionChecker: 'Drug Interaction Checker',
        referrals: 'Referrals',
        newReferral: '+ New Referral',
        inbound2: 'Inbound',
        outbound2: 'Outbound',
        reportsAnalytics: 'Reports & Analytics',
        productionByProvider: 'Production by Provider',
        productionByCategory: 'Production by Category',
        preventive2: 'Preventive',
        restorative: 'Restorative',
        endodontics: 'Endodontics',
        periodontics: 'Periodontics',
        prosthodontics: 'Prosthodontics',
        surgery: 'Surgery',
        agingReport: 'Aging Report',
        appointmentsByDay: 'Appointments by Day',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        topDeclinedTreatments: 'Top Declined Treatments',
        costConcerns: 'Cost concerns',
        wantsToWait: 'Wants to wait',
        orthodontics: 'Orthodontics',
        insuranceNotCovering: 'Insurance not covering',
        notAPriority: 'Not a priority',
        seekingSecondOpinion: 'Seeking second opinion',
        u2190: '\u2190',
        u2192: '\u2192',
        allProviders: 'All Providers',
        hygienistNino: 'Hygienist Nino',
        mon17: 'MON 17',
        tue18: 'TUE 18',
        wed19: 'WED 19',
        thu20: 'THU 20',
        fri21: 'FRI 21',
        crownPrep14: 'Crown Prep #14',
        tKapanadze: 'T. Kapanadze',
        srpQuad1: 'SRP Quad 1',
        dGelashvili: 'D. Gelashvili',
        examXray: 'Exam + X-ray',
        mTsiklauri: 'M. Tsiklauri',
        unconfirmed: 'Unconfirmed',
        rct36: 'RCT #36',
        gBeridze: 'G. Beridze',
        prophyPolish: 'Prophy + Polish',
        iDiasamidze: 'I. Diasamidze',
        perioMaintenance: 'Perio Maintenance',
        tLomidze: 'T. Lomidze',
        prophy: 'Prophy',
        aJavakhishvili: 'A. Javakhishvili',
        inChair: 'In Chair',
        sealantsX4: 'Sealants x4',
        nKapanadze: 'N. Kapanadze',
        lMchedlishvili: 'L. Mchedlishvili',
        u2014LunchU2014: '\u2014 Lunch \u2014',
        veneerPrep11: 'Veneer Prep #11',
        kGabrichidze: 'K. Gabrichidze',
        composite25: 'Composite #25',
        sMeladze: 'S. Meladze',
        bridgePrep3436: 'Bridge Prep #34-36',
        rKharazishvili: 'R. Kharazishvili',
        composite22: 'Composite #22',
        zDolidze: 'Z. Dolidze',
        noShow: 'No Show',
        extraction48: 'Extraction #48',
        vPapunashvili: 'V. Papunashvili',
        implantConsult: 'Implant Consult',
        eTsereteli: 'E. Tsereteli',
        nGogiberidze: 'N. Gogiberidze',
        crownSeat14: 'Crown Seat #14',
        checkup: 'Checkup',
        bShengelia: 'B. Shengelia',
        fluorideTreatment: 'Fluoride Treatment',
        emergencyWalkin: 'Emergency Walk-in',
        scaling: 'Scaling',
        wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
        assignToSchedule: 'Assign to Schedule',
        autoAssign: 'Auto Assign',
        high: 'High',
        anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
        medium: 'Medium',
        irakliDiasamidze: 'Irakli Diasamidze',
        friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
        low: 'Low',
        planARecommended: 'Plan A: Recommended',
        planBConservative: 'Plan B: Conservative',
        newPlan2: '+ New Plan',
        conservativeApproach: 'Conservative Approach',
        thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
        u00b7: '\u00B7',
        treatmentPlanComparison: 'Treatment Plan Comparison',
        u00b72: '\u00b7',
        exams2: 'Exams:',
        metric: 'Metric',
        pdMm: 'PD (mm)',
        gmMm: 'GM (mm)',
        calMm: 'CAL (mm)',
        suppuration: 'Suppuration',
        furcation: 'Furcation',
        mobility: 'Mobility',
        qty: 'Qty',
        refills: 'Refills',
        goal: 'Goal',
        current2: 'Current',
        totalDue: 'Total Due',
        scheduled2: 'Scheduled',
        overdue2: 'Overdue',
        reactivation: 'Reactivation',
        chiefComplaint: 'Chief Complaint',
        painScale: 'Pain Scale:',
        clinicalFindings: 'Clinical Findings',
        diagnosis: 'Diagnosis',
        prescriptions: 'Prescriptions',
        u201c: '\u201C',
        xray: 'X-Ray',
        cleaning: 'Cleaning',
        amountPaid: 'Amount Paid',
        annotate: 'Annotate',
        anonymousPatient: 'Anonymous Patient',
        autoImport: 'Auto Import',
        away: 'Away',
        bankTransfer: 'Bank Transfer',
        beforeAfter: 'Before After',
        bookPrerequisiteFirst: 'Book Prerequisite First',
        breakdown: 'Breakdown',
        bridgePrep: 'Bridge Prep',
        brightness: 'Brightness',
        cabinet: 'Cabinet',
        cabinet1: 'Cabinet 1',
        cabinet2: 'Cabinet 2',
        cabinetSchedule: 'Cabinet Schedule',
        cabinetScheduleDesc: 'Cabinet Schedule Desc',
        card: 'Card',
        cash: 'Cash',
        cbct: 'Cbct',
        cephalometric: 'Cephalometric',
        channels: 'Channels',
        clinicalQuestion: 'Clinical Question',
        clinicAvgRating: 'Clinic Avg Rating',
        collapse: 'Collapse',
        completedToday: 'Completed Today',
        compositeF: 'Composite F',
        continueToScheduling: 'Continue To Scheduling',
        contrast: 'Contrast',
        ctScans: 'Ct Scans',
        customAmount: 'Custom Amount',
        days: 'Days',
        delivered: 'Delivered',
        directMessages: 'Direct Messages',
        disposables: 'Disposables',
        doctorResponse: 'Doctor Response',
        doctors: 'Doctors',
        documentMgmtSubtitle: 'Document Mgmt Subtitle',
        documentPreview: 'Document Preview',
        download: 'Download',
        endodontic: 'Endodontic',
        enterAmount: 'Enter Amount',
        equipmentDevices: 'Equipment Devices',
        estDelivery: 'Est Delivery',
        examConsult: 'Exam Consult',
        explanationQuality: 'Explanation Quality',
        fluorideTx: 'Fluoride Tx',
        fullMouthView: 'Full Mouth View',
        hasBracesQuestion: 'Has Braces Question',
        hasConsultationQuestion: 'Has Consultation Question',
        hasCtScanQuestion: 'Has Ct Scan Question',
        hasRecentXrayQuestion: 'Has Recent Xray Question',
        helpfulQuestion: 'Helpful Question',
        highest: 'Highest',
        hygiene: 'Hygiene',
        imagingType: 'Imaging Type',
        implantPlace: 'Implant Place',
        important: 'Important',
        importLatest: 'Import Latest',
        inProgress: 'In Progress',
        installment: 'Installment',
        insuranceCoverage: 'Insurance Coverage',
        interpreted: 'Interpreted',
        inUse: 'In Use',
        invoices: 'Invoices',
        lastCleaningQuestion: 'Last Cleaning Question',
        lateralSkullView: 'Lateral Skull View',
        lowest: 'Lowest',
        lowStock: 'Low Stock',
        lowStockAlerts: 'Low Stock Alerts',
        maintenance: 'Maintenance',
        management: 'Management',
        markComplete: 'Mark Complete',
        material: 'Material',
        method: 'Method',
        minOrder: 'Min Order',
        monthlySpend: 'Monthly Spend',
        newPayment: 'New Payment',
        newRadiologyReferral: 'New Radiology Referral',
        nextAppointment: 'Next Appointment',
        noDocumentsFound: 'No Documents Found',
        noNoteSelected: 'No Note Selected',
        normal: 'Normal',
        noteInterpreter: 'Note Interpreter',
        occupied: 'Occupied',
        online: 'Online',
        orderNow: 'Order Now',
        orders: 'Orders',
        original: 'Original',
        outstanding: 'Outstanding',
        painManagement: 'Pain Management',
        panoramic: 'Panoramic',
        patientDue: 'Patient Due',
        paymentHistory: 'Payment History',
        paymentMethod: 'Payment Method',
        pendingOrders: 'Pending Orders',
        periapical: 'Periapical',
        perioMaint: 'Perio Maint',
        photos: 'Photos',
        placeOrder: 'Place Order',
        preCheck: 'Pre Check',
        preCheckPassed: 'Pre Check Passed',
        preCheckSubtitle: 'Pre Check Subtitle',
        preCheckTitle: 'Pre Check Title',
        prerequisiteWarning: 'Prerequisite Warning',
        print: 'Print',
        processing: 'Processing',
        processPayment: 'Process Payment',
        processPaymentBtn: 'Process Payment Btn',
        professionalism: 'Professionalism',
        prophyClean: 'Prophy Clean',
        prosthetic: 'Prosthetic',
        punctuality: 'Punctuality',
        qtyUsed: 'Qty Used',
        quantity: 'Quantity',
        queue: 'Queue',
        receiptPreview: 'Receipt Preview',
        recent: 'Recent',
        recentMaterialUsage: 'Recent Material Usage',
        recentReceipts: 'Recent Receipts',
        reliability: 'Reliability',
        remainingBalance: 'Remaining Balance',
        reorderLevel: 'Reorder Level',
        scanning: 'Scanning',
        sealants: 'Sealants',
        sent: 'Sent',
        singleToothView: 'Single Tooth View',
        slotDetails: 'Slot Details',
        sortBy: 'Sort By',
        srpQuad: 'Srp Quad',
        startImaging: 'Start Imaging',
        stock: 'Stock',
        stockLevel: 'Stock Level',
        submitReferral: 'Submit Referral',
        subtotal: 'Subtotal',
        suppliers: 'Suppliers',
        surgical: 'Surgical',
        targetArea: 'Target Area',
        teamChat: 'Team Chat',
        termsNormalized: 'Terms Normalized',
        threeDImaging: 'Three D Imaging',
        totalItems: 'Total Items',
        totalReceived: 'Total Received',
        typeAMessage: 'Type A Message',
        unavailable: 'Unavailable',
        unit: 'Unit',
        urgency: 'Urgency',
        urgent: 'Urgent',
        usageLog: 'Usage Log',
        veneerPrep: 'Veneer Prep',
        viewOnGoogle: 'View On Google',
        xrays: 'Xrays'
    }
};


var $70676ed063e69c3c$export$2e2bcd8739ae039 = {
    ...(0, $3e7bb68d55e4c07c$export$2e2bcd8739ae039),
    polyglot: {
        ...(0, $3e7bb68d55e4c07c$export$2e2bcd8739ae039).polyglot,
        translations: $bc1454a6c0cf0628$export$2e2bcd8739ae039
    },
    state: $583e5c65243bf299$export$2e2bcd8739ae039,
    dependencies: $ffee29e35474451f$export$2e2bcd8739ae039,
    components: $b940b823876787d8$exports,
    snippets: $5006d5ef181f83de$exports,
    pages: $45001c780dea3812$export$2e2bcd8739ae039,
    functions: $b42a2ac40ecd9203$exports,
    methods: $3bda623ffab03480$exports,
    designSystem: $1a9a2097450ea0af$export$2e2bcd8739ae039,
    files: $f00b8cc44c2f4180$export$2e2bcd8739ae039
};


(0, $iTneE.create)((0, $85274e1cff99deb2$export$2e2bcd8739ae039), (0, $70676ed063e69c3c$export$2e2bcd8739ae039));


//# sourceMappingURL=symbols.411d2669.js.map
